// AUTO-GENERATED FILE. Do not edit by hand.
// Generated from games-feed.json via scripts/buildGmGamesData.js.

const games = [
  {
    "id": "76164",
    "slug": "goal-the-answer",
    "title": "Goal the Answer",
    "description": "Use your brain and your aim! Solve tricky math problems and kick the ball into the goal with the correct answer. Learn, play, and score big! how to play ? Click on the right soccer net.",
    "instructions": "Mouse Tap",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math"
    ],
    "thumbnail": "https://img.gamemonetize.com/1o7aanfq4da5z7l7ltuzwsf25or5ixge/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1o7aanfq4da5z7l7ltuzwsf25or5ixge/",
    "sourceUrl": "https://html5.gamemonetize.com/1o7aanfq4da5z7l7ltuzwsf25or5ixge/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "76176",
    "slug": "word-search-universe-2",
    "title": "Word Search Universe 2",
    "description": "Word Search Universe 2 is a fun and relaxing puzzle game where you find hidden words across many themed levels. Explore categories like science, history, food, nature, and more while sharpening your focus and vocabulary. Simply swipe letters to form words, complete challenges, and unlock new chapters. With clean visuals, smooth controls, and hundreds of words to discover.",
    "instructions": "Use a mouse or touchpad to swipe or drag across letters to form hidden words in the grid Find all required words to complete the level and unlock new chapters",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "Hidden",
      "Skill",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/wp3pvfjmcocaga4ci6axw6q3udzz5oy8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wp3pvfjmcocaga4ci6axw6q3udzz5oy8/",
    "sourceUrl": "https://html5.gamemonetize.com/wp3pvfjmcocaga4ci6axw6q3udzz5oy8/",
    "width": 540,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75916",
    "slug": "velocity-breaker",
    "title": "Velocity Breaker",
    "description": "Velocity Breaker is a high-speed reflex game where survival depends on precision and timing. Control a fast-moving energy shard as it races through a constantly scrolling neon tunnel filled with deadly obstacles. The game moves forward automatically &mdash; your job is to dodge, dash, and react in milliseconds. Choose between Easy, Medium, and Hard modes, each increasing speed and challenge. Master the dash mechanic, survive intense obstacle patterns, and push your reflexes to the limit while chasing the highest distance-based score.",
    "instructions": "Move left and right to dodge obstacles while speeding forward automatically Use dash carefully to escape tight situations The faster you survive the higher your score climbs",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Action",
      "Arcade",
      "Casual",
      "Crazy",
      "dash",
      "Fun",
      "Funny",
      "Geometry",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/qg0hdiska40ne7qbe1lv67mb9ycq6jfm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qg0hdiska40ne7qbe1lv67mb9ycq6jfm/",
    "sourceUrl": "https://html5.gamemonetize.com/qg0hdiska40ne7qbe1lv67mb9ycq6jfm/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "76078",
    "slug": "shadow-combat",
    "title": "Shadow Combat",
    "description": "BECOME THE SHADOW FIGHT HERO IN A NEW MULTIPLAYER FIGHTING GAME! Fight against other players in a free online 3D fighting game. Compete in 2 player PVP combats or brawl for fun with friends or play offline against smart bots. Welcome to the ninja realm! Best Mobile Game of 2020 (DevGAMM Awards): Shadow Fight Combat, Immersive 3D graphics The games realistic 3D graphics and animations immerse you right into the epic combat action. Control your hero like in the best classical fighting games and get a console-level battle experience on your mobile device. PvE story mode Fight against AI opponents in a story mode.",
    "instructions": "Move WASD Fight Attacks Y U I G H J K T similar to Tekken-style combos",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Adventure",
      "Fight",
      "Fighting",
      "Level",
      "Multiplayer",
      "Ninja",
      "Skill",
      "Stealth"
    ],
    "thumbnail": "https://img.gamemonetize.com/nvflw22b9ghqp6uo5m4hulg3dksbws62/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nvflw22b9ghqp6uo5m4hulg3dksbws62/",
    "sourceUrl": "https://html5.gamemonetize.com/nvflw22b9ghqp6uo5m4hulg3dksbws62/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75852",
    "slug": "danger-road-game",
    "title": "Danger Road Game",
    "description": "Danger Road is an exciting mobile driving game where you test your skills on a dangerous road. Drive your car at high speed and avoid challenging obstacles to survive as long as possible. Stay focused, react quickly, and beat your high score. The longer you survive, the higher your score!",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Car",
      "crash",
      "drifting",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/mkr85b4bfkirx7sa41rfs00d0263pe12/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mkr85b4bfkirx7sa41rfs00d0263pe12/",
    "sourceUrl": "https://html5.gamemonetize.com/mkr85b4bfkirx7sa41rfs00d0263pe12/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76214",
    "slug": "sonic-speed-run",
    "title": "Sonic Speed Run",
    "description": "Experience lightning-fast action as Sonic in this retro-style pixel endless runner! Grab as many Rings as you can, dodge hazards, and push your limits in an endless race for the highest score. How long can you survive the ultimate speed challenge?",
    "instructions": "Spacebar Jump Double Spacebar DOUBLE JUMP",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Avoid",
      "Collecting",
      "endless",
      "Highscore",
      "jump",
      "Pixel",
      "Retro",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/r09woub5zb1k3b101w7k0zkb98bog5md/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r09woub5zb1k3b101w7k0zkb98bog5md/",
    "sourceUrl": "https://html5.gamemonetize.com/r09woub5zb1k3b101w7k0zkb98bog5md/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "75673",
    "slug": "space-arena",
    "title": "Space Arena",
    "description": "Blast off into a high-stakes galactic conflict in Space Arena! As a pilot in the deep reaches of space, you must navigate through treacherous enemy formations and survive increasingly difficult waves of scouts, fighters, and heavy transporters. Protect your ship while engaging in intense dogfights across multiple challenging levels. Collect powerful upgrades to boost your fire rate, add multi-shot capabilities, and activate defensive shields. Featuring a premium futuristic design with Orbitron typography, smooth particle effects, and high-octane gameplay, Space Arena is fully optimized for a seamless experience on both desktop and mobile.",
    "instructions": "Desktop Arrow Keys Up Down or Mouse Position your ship Spacebar or Left-Click Fire weapons P Pause game Mobile Drag finger Move your ship smoothly on the screen Tap screen Unleash lasers at your enemies Menu Buttons Use the high-visibility",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Mobile",
      "Shooter",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/sgwtu1r9t46y60yn970vj24bivhn62tj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sgwtu1r9t46y60yn970vj24bivhn62tj/",
    "sourceUrl": "https://html5.gamemonetize.com/sgwtu1r9t46y60yn970vj24bivhn62tj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76085",
    "slug": "zombie-defense-last-stand",
    "title": "Zombie Defense: Last Stand",
    "description": "Hold the line. Build deadly defenses. Survive the zombie rush. In this fast-paced tower defense game, waves of zombies never stop coming&mdash;and they get smarter, tougher, and faster every round. Place and upgrade your towers, combine different damage types, and adapt your layout to counter brute tanks, sprinting runners, and armored horrors. Earn resources from every victory, unlock new towers and power-ups, and create the ultimate kill zone with slows, splash damage, and high DPS combos. One wrong placement can break your defense&hellip; but a perfect strategy turns the battlefield into a zombie grinder.",
    "instructions": "Mouse click or tap to play",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Battle",
      "Defense",
      "Fight",
      "Gun",
      "Strategy",
      "Tower Defense",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/zjyt0g4rnl8v44qxt0gw4umcyzyqoxjv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zjyt0g4rnl8v44qxt0gw4umcyzyqoxjv/",
    "sourceUrl": "https://html5.gamemonetize.com/zjyt0g4rnl8v44qxt0gw4umcyzyqoxjv/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "76213",
    "slug": "bottle-storm-elite-beach",
    "title": "Bottle Storm: Elite Beach",
    "description": "Step into the ultimate tactical shooting range in Bottle Storm: Elite Beach! Aim carefully, break bottles, and avoid dangerous red bottles as you climb levels. Unlock new weapons, improve your reflexes, and master the beach arena. Can you reach the highest score without missing too many targets? Test your skill in this fast-paced, addictive arcade shooter!",
    "instructions": "Desktop Mouse Aim and shoot bottles Left Click Shoot Mobile Touch Tap Touch Shoot at bottles Drag finger Move crosshair optional auto-follow",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/slfq5wm1etragwl0400yld5cccha3om1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/slfq5wm1etragwl0400yld5cccha3om1/",
    "sourceUrl": "https://html5.gamemonetize.com/slfq5wm1etragwl0400yld5cccha3om1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76125",
    "slug": "total-sweep",
    "title": "Total sweep",
    "description": "Total sweep is a calming tactical game where you guide drifting balls to break through numbered blocks that shift direction or erupt in explosive bursts. You adapt to unpredictable patterns, clear chaotic clusters, and push toward restoring balance. As you collect crystals, you strengthen your growing squad, giving you more ways to overcome each cleverly arranged challenge.",
    "instructions": "Aim with your touch and shoot the balls at the blocks with numbers Each touch takes 1 away from the number in the block When it is reset to zero it disappears Crystals obtained for destruction can be spent on a one-time increase in balls by 100 or on",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Ball",
      "Best",
      "Best Games",
      "Block",
      "Bricks",
      "Casual",
      "destroying",
      "Geometry"
    ],
    "thumbnail": "https://img.gamemonetize.com/zwxg6lvbf1hcfhasr5ax2s7s9qjsit0n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zwxg6lvbf1hcfhasr5ax2s7s9qjsit0n/",
    "sourceUrl": "https://html5.gamemonetize.com/zwxg6lvbf1hcfhasr5ax2s7s9qjsit0n/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76055",
    "slug": "wrestling-revolution-arena",
    "title": "Wrestling Revolution Arena",
    "description": "The heavyweight champion of wrestling. The Wrestling Revolution Arena 3D rumbles into the 3rd dimension, where it now features BOTH aspects of the business in ONE epic universe. A wrestling career challenges you to take shots in the ring, whereas a booking career allows you to call the shots backstage - promoting entertaining matches every week for ratings. Seeing each side of the curtain gives you an even better appreciation for the other, and ensures youll never grow bored of wrestling again! Both modes are available to play for free, with the option to upgrade to enjoy the Pro experience with no ads or limitations.",
    "instructions": "WASD Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Arena",
      "Battle",
      "Best Games",
      "Fighting",
      "Game",
      "Multiplayer",
      "PvP",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/0iari3p1lujlum3cuo4foos186pwdw8t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0iari3p1lujlum3cuo4foos186pwdw8t/",
    "sourceUrl": "https://html5.gamemonetize.com/0iari3p1lujlum3cuo4foos186pwdw8t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76019",
    "slug": "police-chase-car-simulator",
    "title": "Police Chase Car Simulator",
    "description": "Step into the role of a powerful cop car chase police simulator officer and experience an action-filled police simulator. This game offers many different missions that are easy to understand and fun to play. Enjoy fast speed car chase missions where you follow and stop criminals on busy roads. Take part in parking lane fine missions by checking vehicles and managing traffic rules. Perform border checking missions where you inspect cars and help maintain security. Feel the responsibility during President car escort missions by guiding the convoy safely through the city. Complete terrorist arrest missions and help restore peace.",
    "instructions": "WASD for move tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2 Player",
      "2026 games",
      "3D Games",
      "Best Games",
      "Car",
      "city",
      "Driving",
      "Game",
      "Hypercasual",
      "Police",
      "Simulation",
      "Traffic"
    ],
    "thumbnail": "https://img.gamemonetize.com/1hf3m6hqeubtwjyibxy2p5qvlr0rk955/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1hf3m6hqeubtwjyibxy2p5qvlr0rk955/",
    "sourceUrl": "https://html5.gamemonetize.com/1hf3m6hqeubtwjyibxy2p5qvlr0rk955/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76194",
    "slug": "rotate-ring-game",
    "title": "Rotate Ring Game",
    "description": "Welcome to Off The Ring Game, an exciting and addictive arcade challenge where your timing, focus, and precision skills are put to the test. Your goal is simple: guide the moving object safely through the ring path without touching the edges. Sounds easy &mdash; but mastering the timing requires skill and concentration. This fast-paced arcade game offers smooth gameplay, satisfying mechanics, and progressively challenging levels that keep players engaged. Whether you enjoy reaction-based games or relaxing skill challenges, Off The Ring Game delivers endless fun.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Casual",
      "Fun",
      "Pinball"
    ],
    "thumbnail": "https://img.gamemonetize.com/iau5yh64pq69lpvp2nhgm4jshulheqkk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iau5yh64pq69lpvp2nhgm4jshulheqkk/",
    "sourceUrl": "https://html5.gamemonetize.com/iau5yh64pq69lpvp2nhgm4jshulheqkk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76067",
    "slug": "poly-jumper",
    "title": "Poly Jumper",
    "description": "Poly Jumper is a fast-paced arcade platformer where timing is everything. Jump across vibrant polygon worlds filled with moving platforms, tricky gaps, and unexpected obstacles. Each level challenges your reflexes with increasing speed and precision, pushing you to master perfect jumps and smooth landings. Web Dev <a href='https://www.coolcrazygames.com/'>https://www.coolcrazygames.com/</a>",
    "instructions": "Use left and right arrow keys to move lanes and Up arrow key to jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Jumping",
      "Platform",
      "running",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/rw2fbe3vxawknq6hdwh4teg1sbw26cbg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rw2fbe3vxawknq6hdwh4teg1sbw26cbg/",
    "sourceUrl": "https://html5.gamemonetize.com/rw2fbe3vxawknq6hdwh4teg1sbw26cbg/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75568",
    "slug": "cat-doctor-save-my-cat",
    "title": "Cat Doctor Save my Cat",
    "description": "Become the world&rsquo;s cutest cat doctor Welcome to your pet hospital full of adorable kitties who need your help. Treat illnesses, perform surgery, and unlock new levels! Core Features &bull; Diagnose &amp; treat: fever, ear infections, cuts, broken bones",
    "instructions": "use mouse controls to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cartoon",
      "Cat",
      "Doctor",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/zsb38vr10fvkgi2bj9tdmdxyyhaardr8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zsb38vr10fvkgi2bj9tdmdxyyhaardr8/",
    "sourceUrl": "https://html5.gamemonetize.com/zsb38vr10fvkgi2bj9tdmdxyyhaardr8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75906",
    "slug": "talkback-cat",
    "title": "TalkBack Cat",
    "description": "TalkBack Cat, players interact with a charming and expressive ginger-and-white feline who lives in a cozy, vibrant room. This friendly character is known for its large, curious eyes and a playful smirk that hints at its mischievous personality. Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Cat",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/3p97zr3zvlumo67wmtfat68c3ceiqusx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3p97zr3zvlumo67wmtfat68c3ceiqusx/",
    "sourceUrl": "https://html5.gamemonetize.com/3p97zr3zvlumo67wmtfat68c3ceiqusx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75907",
    "slug": "idlle-cat-merge",
    "title": "Idlle Cat Merge",
    "description": "In Idle Cat Merge, players combine adorable feline companions to discover new, unique breeds and build the ultimate cat sanctuary. This addictive game blends casual idle mechanics with satisfying merge puzzles, allowing you to earn currency even while youre away from the screen. Web Dev <a href='https://www.kizi10.org/'>https://www.kizi10.org/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Cat",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/jshs45gujjr8c4lbes250d5ngv9vi7cq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jshs45gujjr8c4lbes250d5ngv9vi7cq/",
    "sourceUrl": "https://html5.gamemonetize.com/jshs45gujjr8c4lbes250d5ngv9vi7cq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75967",
    "slug": "abyss-sweeper",
    "title": "Abyss Sweeper",
    "description": "Abyss Sweeper reinvents the classic Minesweeper formula into an intense, infinite descent into the unknown. You are the pilot of a specialized drilling craft, tasked with navigating a treacherous, never-ending grid of rock and volatile energy. Unlike traditional puzzle games, you cannot simply avoid the mines&mdash;you must hunt them. Your fuel is constantly draining, and the only way to replenish it is to HARVEST the very mines that threaten to destroy you. How to Play: DIG (Tap): Clear safe tiles to reveal numerical clues. HARVEST (Long Press / Button): Identify a mine location and harvest it to regain critical Fuel. SURVIVE: Watch your Hull",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Avoid",
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/trwkld706r6jrz7pruxovsb20s063pqp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/trwkld706r6jrz7pruxovsb20s063pqp/",
    "sourceUrl": "https://html5.gamemonetize.com/trwkld706r6jrz7pruxovsb20s063pqp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76168",
    "slug": "skibidi-in-backroom-hunter-2d",
    "title": "Skibidi in Backroom Hunter 2D",
    "description": "Skibidi Backroom Hunter is a fast-paced cartoony horror shooter set inside the creepy endless backrooms. Hunt strange Skibidi creatures, survive the maze, and rack up the highest score before they catch you. Quick reflexes and sharp aim are your only way out!",
    "instructions": "Mouse cursor",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Casual",
      "Fun",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/hbsma0cb2pozma7cvd1tsrnwi9uo1o9r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hbsma0cb2pozma7cvd1tsrnwi9uo1o9r/",
    "sourceUrl": "https://html5.gamemonetize.com/hbsma0cb2pozma7cvd1tsrnwi9uo1o9r/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "76183",
    "slug": "3d-mini-curling",
    "title": "3D Mini Curling",
    "description": "Experience the classic winter sport in a smooth and satisfying 3D simulation. Aim carefully, adjust your power, and release the stone with precision to outscore your opponent.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "3D",
      "Ice",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/bxciimfxqlxjyw9vvm7fm7qcz0uqamix/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bxciimfxqlxjyw9vvm7fm7qcz0uqamix/",
    "sourceUrl": "https://html5.gamemonetize.com/bxciimfxqlxjyw9vvm7fm7qcz0uqamix/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "76182",
    "slug": "tastyfarm",
    "title": "TastyFarm",
    "description": "Tasty Farm is a fun and addictive sorting puzzle! Organize your fresh harvest in two exciting modes: match juicy fruits and vegetables by color, or categorize them by type. Drag and drop items into the correct baskets, earn stars for every success, and build your own unique collection of farm cards in the Shop. With smooth animations, relaxing sounds, and increasing difficulty, Tasty Farm is perfect for a quick brain workout! Game Features: -Fun and simple sorting gameplay. -Two modes: Sort by Color or Type. -Unlockable farm card collection. -Beautiful graphics and satisfying effects.",
    "instructions": "Use Mouse or Touch to drag fruits and vegetables into the correct baskets Fill the progress bar to complete the level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Color",
      "Educational",
      "Farm",
      "Fruits",
      "Hypercasual",
      "Kids",
      "Matching",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/f8mlwxqxhqabcxdu858r19lhcvsq8a4f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f8mlwxqxhqabcxdu858r19lhcvsq8a4f/",
    "sourceUrl": "https://html5.gamemonetize.com/f8mlwxqxhqabcxdu858r19lhcvsq8a4f/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "76023",
    "slug": "bank-robbery-sneak-master",
    "title": "Bank Robbery Sneak Master",
    "description": "Bank Robbery Sneak Master is a fun, humor-packed stealth adventure where you play as a sneaky burglar with a good heart. Take on final jobs before leaving the criminal life behind! Sneak past security guards, residents, and sleeping dogs using ninja skills and puzzle solving tactics. Explore luxurious villas, Downtown streets, secret labs, and challenging maps filled with loot. Steal secret documents, TV remotes, and hidden treasures without getting detected. Enjoy hilarious animations, a twisting storyline, and rewarding puzzles.",
    "instructions": "WASD ndash Move Shift ndash Sprint F ndash Shoot Z ndash Zoom",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Avoid",
      "Escape",
      "Hypercasual",
      "run",
      "Shooting",
      "Skill",
      "sneak",
      "Stealth",
      "Strategy",
      "Thief"
    ],
    "thumbnail": "https://img.gamemonetize.com/5vvmlf18g39d0ukqod1inayzg03154hl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5vvmlf18g39d0ukqod1inayzg03154hl/",
    "sourceUrl": "https://html5.gamemonetize.com/5vvmlf18g39d0ukqod1inayzg03154hl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67217",
    "slug": "royal-king-croos-avatar-run",
    "title": "Royal King: Croos  Avatar Run",
    "description": "Royal King: Croos- Avatar Run is a fast and fun royal adventure where you control your life_run_avatar through a puzzle_kingdom of quick decisions and perfect timing! Gameplay Tap to grow the stick and cross between platforms. Hit the perfect timing for bonus rewards. Speed increases, platforms get tougher&mdash;stay alive and beat your best score! Highlights Glorious challenges that keep getting harder Castles design with a true kingdom vibe A Charming story atmosphere Beautiful graphics and smooth gameplay Easy to play, hard to master Download now and prove you&rsquo;re the king of the run!",
    "instructions": "Tap to grow the stick and cross between platforms Hit the perfect timing for bonus rewards Speed increases platforms get tougher mdash stay alive and beat your best score",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "2D",
      "Baby Games",
      "Barbie",
      "beauty",
      "Dress Up",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/28ktdsst1s1kdhqlm38ajj63wjllib7a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/28ktdsst1s1kdhqlm38ajj63wjllib7a/",
    "sourceUrl": "https://html5.gamemonetize.com/28ktdsst1s1kdhqlm38ajj63wjllib7a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75870",
    "slug": "neon-void-galactic-war",
    "title": "Neon Void: Galactic War",
    "description": "Experience Neon Void: Galactic War, an epic neon-infused space shooter that combines classic arcade action with modern gameplay mechanics. As a pilot in the galactic war, you must defend the galaxy from an unrelenting alien invasion through a revolutionary wave-based combat system. - Epic Boss Battles: Face off against 6 devastating boss types, including the heavy-hitting Devastator, the teleporting Void Destroyer, and the ultimate challenge: the Omega Sentinel. - Powerful Upgrades: Collect 6 game-changing power-ups like Energy Shields, Rapid Fire, Tri-Shot, and Time Slow to turn the tide of battle.",
    "instructions": "Desktop Move Arrow Keys or WASD Shoot SPACE Bar or Right-Click Alternative Fire Mobile Move Left and Right on-screen buttons Shoot Dedicated on-screen FIRE button",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Alien",
      "Arcade",
      "attack",
      "crazygamesunblocked",
      "Shooter",
      "Space",
      "Spaceship",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/7smryet7endxpjl4ssgcdk7ywjy1ikgh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7smryet7endxpjl4ssgcdk7ywjy1ikgh/",
    "sourceUrl": "https://html5.gamemonetize.com/7smryet7endxpjl4ssgcdk7ywjy1ikgh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76112",
    "slug": "italian-brainrot-drag-merge-puzzle",
    "title": "Italian Brainrot Drag Merge Puzzle",
    "description": "A Revolutionary Jigsaw Experience. Each level, one image is randomly selected and split into 3&times;3, 4&times;4, 5&times;5, or 6&times;6 pieces, then completely shuffled. Your goal is simple: restore the picture by placing every piece in its correct position. But this is no ordinary jigsaw. When two neighboring pieces are placed correctly next to each other, they merge into a single movable cluster. Instead of slow, one-by-one placement, you can drag any piece or merged group onto another to instantly swap positions.",
    "instructions": "Drag pieces to swap positions pieces that belong next to each other will merge into a cluster clusters move together allowing you to position multiple pieces at once You can upload your images to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "HTML5",
      "Italian Brainrot",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/clpvf0sr3ckhol0fn48758ilg2zu898z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/clpvf0sr3ckhol0fn48758ilg2zu898z/",
    "sourceUrl": "https://html5.gamemonetize.com/clpvf0sr3ckhol0fn48758ilg2zu898z/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "76079",
    "slug": "offroad-truck-driving-simulator",
    "title": "Offroad Truck Driving Simulator",
    "description": "Offroad Truck Driving Simulator is the ultimate off-road mud truck driving game and realistic car racing simulator! Experience stunning graphics, real driving physics, and a huge selection of 4x4 trucks with unique characteristics. Customize and tune your vehicles endlessly, conquer extreme obstacles, and complete dozens of offroad racing challenges, time trials, and dirt races. Enjoy real truck sounds, a simple in-game map, and epic open-road adventures. Fans of Snow Runner, Mud Runner, 4x4 Mania, and Offroad Outlaws will love this ultimate off-roading diesel truck simulator!",
    "instructions": "W A S D Or Arrow Keys rarr Move Truck H rarr Horn R rarr Reverse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2026 games",
      "3D",
      "3D Games",
      "cargo",
      "Driving",
      "offroad",
      "Simulator",
      "transport",
      "Truck",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/bwrunfiqbjfxprp91bq5v0xhtqzmukno/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bwrunfiqbjfxprp91bq5v0xhtqzmukno/",
    "sourceUrl": "https://html5.gamemonetize.com/bwrunfiqbjfxprp91bq5v0xhtqzmukno/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75977",
    "slug": "tractor-farming-simulation-3d",
    "title": "Tractor Farming Simulation 3D",
    "description": "Experience the most realistic Indian vehicles game ever in Tractor Farming Simulation 3D! Drive and customize Indian tractors, cars, bikes, buses, trucks, cranes, harvesters, and DJ vehicles. Explore farming maps, city maps, offroad deserts, jungles, mountains, villages, airports, and beautiful terrains. Enjoy character modification, animal riding, buggies, roaming NPCs, flying birds, and a dynamic weather system including rain, snow, fog, storms, and sandstorms. Customize vehicle colors, tires, number plates, and engage in tochan, Diwali crackers, farming mods, and mud effects.",
    "instructions": "Move vehicles WASD Arrow Keys left mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Best Games",
      "Driving",
      "Farm",
      "Kids",
      "realistic",
      "Simulator",
      "tractor",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/flg92g45dpnnbg2w4rc8kfj1ub6ntlak/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/flg92g45dpnnbg2w4rc8kfj1ub6ntlak/",
    "sourceUrl": "https://html5.gamemonetize.com/flg92g45dpnnbg2w4rc8kfj1ub6ntlak/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75908",
    "slug": "little-cat-doctor-2026",
    "title": "Little Cat Doctor 2026",
    "description": "In Little Cat Doctor, players take on the role of a caring veterinarian tasked with nursing a sick, wide-eyed orange kitten back to health. This interactive medical simulation features colorful, kid-friendly graphics where you must use tools like thermometers and medicine to treat your adorable patient. Web Dev <a href='https://www.y8.org.es/'>https://www.y8.org.es/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2D",
      "Cat",
      "Click",
      "Doctor",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/kosn37blfqkwxxb9nwodvkmiki0wemik/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kosn37blfqkwxxb9nwodvkmiki0wemik/",
    "sourceUrl": "https://html5.gamemonetize.com/kosn37blfqkwxxb9nwodvkmiki0wemik/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75697",
    "slug": "monster-rampage-city",
    "title": "Monster Rampage City",
    "description": "Get ready for monster dinosaur rampage city games where jurrasic park builders in dinosaur city allows godzilla 2014 man eater wild gorilla vs dinosaur games for dinosaur rampage attack in king kong games. Dinosaur games for free with godzilla game in the dino strike that allows you to show monster evolution destruction with dinossauro rex in monster island. Being a monsters destroyer in king kong vs godzilla games 2021 of the giant world - king kong games fighting to show some power of free dinosaur games. Welcome to the deadly dinosaur evolution &amp; monster rampage legends for ultimate dino strike of giant monster games of godzilla vs kong.",
    "instructions": "WASD Arrow Keys ndash Move Mouse Left Click ndash Attack",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Adventure",
      "Arcade",
      "building",
      "city",
      "destruction",
      "Fun",
      "Monster",
      "smash"
    ],
    "thumbnail": "https://img.gamemonetize.com/rzgapruo2id2qpprzx7a3jy61frz4z29/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rzgapruo2id2qpprzx7a3jy61frz4z29/",
    "sourceUrl": "https://html5.gamemonetize.com/rzgapruo2id2qpprzx7a3jy61frz4z29/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73921",
    "slug": "quicksolve",
    "title": "QuickSolve",
    "description": "QuickSolve is a fast-paced timed math challenge designed to sharpen your mind under pressure. Each round presents a new math question&mdash;simple, clear, and quick to read&mdash;but you only get a few seconds to pick the correct answer before the timer runs out. As you progress, the pace increases and the questions become trickier, testing your ability to think fast and stay calm. One mistake costs you a life, and running out means starting over. With clean visuals, instant feedback, and smooth gameplay, QuickSolve turns mental math into an exciting reflex-based puzzle.",
    "instructions": "Choose the CORRECT option",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Math",
      "Puzzle",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/sr7dzzay7mmg37ll2dqyud0re1nnnbqg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sr7dzzay7mmg37ll2dqyud0re1nnnbqg/",
    "sourceUrl": "https://html5.gamemonetize.com/sr7dzzay7mmg37ll2dqyud0re1nnnbqg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74344",
    "slug": "color-circle",
    "title": "Color Circle",
    "description": "Color Circle is a fun skill game that tests your reflexes and concentration. In the game, you control a multi-colored rotating circle and watch the clock hand spin continuously. Your task is to click at the right moment when the hand points to the matching color. Just a slight delay or a wrong color, and youll have to start over. With increasing speed and constantly changing colors, Color Circle offers a simple yet highly addictive experience!",
    "instructions": "Use mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Click",
      "Color",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/4n72iv4dyenus2zfa5oj734hf03w2ohc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4n72iv4dyenus2zfa5oj734hf03w2ohc/",
    "sourceUrl": "https://html5.gamemonetize.com/4n72iv4dyenus2zfa5oj734hf03w2ohc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74994",
    "slug": "sonic-runner-game",
    "title": "Sonic Runner Game",
    "description": "Sonic Runner Game is a fast-paced endless running adventure where speed, timing, and reflexes are the key to survival. Dash through exciting levels filled with obstacles, enemies, and power-ups as you race to achieve the highest score possible. Jump, slide, and dodge your way through dynamic environments while collecting rewards and unlocking new challenges. With smooth controls, vibrant visuals, and addictive gameplay, Sonic Runner Game delivers nonstop action for players of all ages. Test your reflexes, beat your personal best, and experience the thrill of speed in this exciting arcade runner game.",
    "instructions": "Mouse click or tap to play Space Up Arrow X Key Jump Start Game Down Arrow Duck Slide Left Mouse Click Jump Enter Restart Game after Game Over",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "dino",
      "Dinosaur",
      "running",
      "unblocked games",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/say26x9f5nwav93tjhbsqzsl5qslbeyc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/say26x9f5nwav93tjhbsqzsl5qslbeyc/",
    "sourceUrl": "https://html5.gamemonetize.com/say26x9f5nwav93tjhbsqzsl5qslbeyc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75576",
    "slug": "tile-2-match",
    "title": "Tile 2 Match",
    "description": "Discover a bright, addictive puzzle adventure where you match identical fruit tiles to clear each board and earn satisfying points. Every level introduces fresh patterns, fast? paced decisions, and a thrilling timer that keeps gameplay exciting and challenging. With smooth, eye? catching visuals and relaxed controls, this casual matching game delivers stress? free fun for anyone craving a smart, simple, and rewarding brain teaser. Perfect for fans of match?3 puzzles, casual gamers, and anyone looking for a quick, satisfying play session on mobile or tablet. Play more game on crazycubix.com",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Adventure",
      "Best Games",
      "Candy",
      "Match 3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/35iyifc2eb14gwgp7new225pvl44amym/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/35iyifc2eb14gwgp7new225pvl44amym/",
    "sourceUrl": "https://html5.gamemonetize.com/35iyifc2eb14gwgp7new225pvl44amym/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75621",
    "slug": "ice-cream-asmr-diy-games",
    "title": "Ice Cream ASMR DIY Games",
    "description": "Ice cream lovers you&rsquo;ll like this ice cream simulator, make the ice cream of your dreams, mix flavors, add toppings and serve customers in food simulator ice cream games. So many delicious flavors to get and mix together, create the best combinations in an ice cream simulator! The most popular being classic Vanilla, dark chocolate, fruity mango and juicy strawberry with added toppings in ice cream simulator food games. Mix ice cream, a frozen dessert made from cream, milk, sugar, and many different flavorings in ice cream simulator. There are many different types like soft serve cone, ice cream roll, Frozen yogurt, Gelato and Dondurma. Become an expert ice cream maker!",
    "instructions": "use mouse controls",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Casual",
      "Food",
      "Hypercasual",
      "Ice"
    ],
    "thumbnail": "https://img.gamemonetize.com/jj2zm5ccn8uyv4lt9hjvpq7tms74qcb2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jj2zm5ccn8uyv4lt9hjvpq7tms74qcb2/",
    "sourceUrl": "https://html5.gamemonetize.com/jj2zm5ccn8uyv4lt9hjvpq7tms74qcb2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75900",
    "slug": "spot-differences-bird-adventure",
    "title": "Spot Differences Bird Adventure",
    "description": "Spot Differences: Bird Adventure is a fun and relaxing puzzle game where you find differences between two bird pictures. Look carefully, tap the changes, and complete each level before time runs out. Enjoy colorful birds, beautiful scenes, and simple controls. Perfect for all ages who love easy and brain-teasing games.",
    "instructions": "Use a mouse or touchpad to click or tap on the differences between the two images",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bird",
      "Difference",
      "Forest",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/bw9fgck0405p5x99rv2q740mvmfxsc1c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bw9fgck0405p5x99rv2q740mvmfxsc1c/",
    "sourceUrl": "https://html5.gamemonetize.com/bw9fgck0405p5x99rv2q740mvmfxsc1c/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "76000",
    "slug": "cartoon-cat-scary",
    "title": "Cartoon Cat Scary",
    "description": "Discover two thrilling game modes in this unique puzzle experience! Test your logic by filling animal shapes with silver balls in the main puzzle mode shown in the image. Then, access special features from the menu buttons. Tap Sounds to hear a scary cats chilling cry. Press CONTACT to call the mysterious feline directly. Web Dev <a href='https://www.kizi.com.es/'>https://www.kizi.com.es/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2D",
      "Cartoon",
      "Click",
      "Mentolatux",
      "unity"
    ],
    "thumbnail": "https://img.gamemonetize.com/n3j84n1zke94adfa4x8h3moeaf7px0hl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n3j84n1zke94adfa4x8h3moeaf7px0hl/",
    "sourceUrl": "https://html5.gamemonetize.com/n3j84n1zke94adfa4x8h3moeaf7px0hl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76101",
    "slug": "i-show-running-2d",
    "title": "I Show Running 2D",
    "description": "Run. Dodge. Go full speed. Welcome to IShow Running 2D, a fast-paced endless runner where reaction time is everything. Sprint down a high-energy running track, dodge insane obstacles, jump hurdles, slide under barriers, and keep moving as the speed keeps rising.",
    "instructions": "Tap click or SPACE on Keyboard",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Adventure",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/mkw9z8qtebcmr2s5casktrd4gsodhqmg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mkw9z8qtebcmr2s5casktrd4gsodhqmg/",
    "sourceUrl": "https://html5.gamemonetize.com/mkw9z8qtebcmr2s5casktrd4gsodhqmg/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "76062",
    "slug": "guys-stumble-heroes",
    "title": "Guys Stumble Heroes",
    "description": "Guys Stumble Heroes is a fast-paced multiplayer party game where chaotic physics and hilarious obstacles collide! Compete against dozens of players in wild knockout arenas filled with spinning hammers, moving platforms, tricky jumps, and unpredictable traps. Web Dev <a href='https://www.vitalitygames.com/'>https://www.vitalitygames.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Fall Boys",
      "Fall Guys",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/nc0hg87enhki30tajayreyjl34zi4qrh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nc0hg87enhki30tajayreyjl34zi4qrh/",
    "sourceUrl": "https://html5.gamemonetize.com/nc0hg87enhki30tajayreyjl34zi4qrh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76094",
    "slug": "package-deliver-game",
    "title": "Package Deliver Game",
    "description": "Welcome to Package Deliver Game, an exciting and engaging delivery simulation game where you take the role of a professional delivery driver. In this fun and realistic delivery driver game, your mission is to pick up packages and deliver them safely to their destinations across different locations. This package delivery simulator offers smooth controls, interactive gameplay, and challenging missions that test your driving skills and time management abilities. Whether you are delivering small parcels or large packages, every task requires focus, careful driving, and smart route planning.",
    "instructions": "- To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Bike",
      "Fun",
      "Road"
    ],
    "thumbnail": "https://img.gamemonetize.com/zvkxmsf5vg68uvryhnxz0ynak03k7sh3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zvkxmsf5vg68uvryhnxz0ynak03k7sh3/",
    "sourceUrl": "https://html5.gamemonetize.com/zvkxmsf5vg68uvryhnxz0ynak03k7sh3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71991",
    "slug": "dunkeon-dino",
    "title": "Dunkeon dino",
    "description": "Find Your Way &ndash; 2D Navigation Adventure Game Welcome to Find Your Way, a captivating 2D navigation and maze game that challenges your mind, reflexes, and sense of direction. In this unique browser-based experience, your goal is simple: guide your character through intricate mazes, avoid dead ends, and reach the exit as quickly as possible. But don&rsquo;t be fooled by its simplicity&mdash;each level is designed to test your problem-solving skills, patience, and strategic thinking. The world of Find Your Way is full of twists, turns, and surprises. As you progress through each level, the mazes become more complex, introducing new challenges and obstacle",
    "instructions": "Step into the chaotic world of Boozy Berserker a fast-paced 2D action game controlled entirely with mouse clicks Click to swing your weapon dodge enemies and unleash powerful attacks as you survive through challenging arenas Simple controls make it e",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "2025 games",
      "Action",
      "Adventure",
      "amazing",
      "Arcade",
      "free html5 games for your website",
      "Road"
    ],
    "thumbnail": "https://img.gamemonetize.com/xyffohy7n188i89n7bnyso9jluc14hc1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xyffohy7n188i89n7bnyso9jluc14hc1/",
    "sourceUrl": "https://html5.gamemonetize.com/xyffohy7n188i89n7bnyso9jluc14hc1/",
    "width": 180,
    "height": 320,
    "lastUpdated": ""
  },
  {
    "id": "76063",
    "slug": "train-puzzle",
    "title": "Train Puzzle",
    "description": "All aboard for a brain-teasing adventure! In Train Puzzle, your goal is to become the ultimate railway engineer. Slide, rotate, and connect the tracks to create a perfect path for your train to travel safely across the grid. With charming 3D graphics and intuitive controls, you must use logic to avoid dead ends and guide your wagons to the finish line. Web Dev <a href='https://www.crazygames.com.es/'>https://www.crazygames.com.es/</a> Can you solve the route before the train leaves the station?",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Mentolatux",
      "Skill",
      "Train",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/aefgds3hj4dhx8loletpo7mas4fk248c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aefgds3hj4dhx8loletpo7mas4fk248c/",
    "sourceUrl": "https://html5.gamemonetize.com/aefgds3hj4dhx8loletpo7mas4fk248c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75203",
    "slug": "camp-arrange",
    "title": "Camp Arrange",
    "description": "Camp Arrange is a lighthearted yet challenging puzzle game where you need to arrange colorful blocks in their designated positions. Each level presents a different layout, requiring players to observe, calculate, and move strategically to complete the objective. The increasing difficulty helps train logical thinking and provides an enjoyable sense of accomplishment with each level.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Point And Click",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/xpmgjj5a3ayue4x637cx5rscn565tggg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xpmgjj5a3ayue4x637cx5rscn565tggg/",
    "sourceUrl": "https://html5.gamemonetize.com/xpmgjj5a3ayue4x637cx5rscn565tggg/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "33388",
    "slug": "car-eats-car-underwater-adventure",
    "title": "Car Eats Car: Underwater Adventure",
    "description": "Up for a fight against rivals in a dynamic race on the highway? Overtake enemies and create your own car in the incubator in Car Eats Car: Underwater Adventure! Your friends are put to prison - do everything you can to free evil cars! Good driving skills and turbo speed come in handy in this crazy driving simulator and a police chase game. Become a car tycoon, upgrade cars, and play for monster cars against the cops! Fight the boss to survive in these ultimate crazy races!",
    "instructions": "Space - Bombs X - Turbo W - Gas S - Brake A D - Balancing Arrow keys - Gas Brake Balancing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Action",
      "Car",
      "Cars",
      "Cartoon",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/bieldl49kbvg52gjrcruztap5nmvhynm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bieldl49kbvg52gjrcruztap5nmvhynm/",
    "sourceUrl": "https://html5.gamemonetize.com/bieldl49kbvg52gjrcruztap5nmvhynm/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "1655",
    "slug": "car-eats-car-sea-adventure",
    "title": "Car Eats Car: Sea Adventure",
    "description": "Up for a fight against rivals in a dynamic race on the highway? Overtake enemies and create your own car in the incubator in Car Eats Car: Sea Adventure! Your friends are put to prison - do everything you can to free evil cars! Good driving skills and turbo speed come in handy in this crazy driving simulator and a police chase game. Become a car tycoon, upgrade cars, and play for monster cars against the cops! Fight the boss to survive in these ultimate crazy races!",
    "instructions": "Space - Bombs X - Turbo W - Gas S - Brake A D - Balancing Arrow keys - Gas Brake Balancing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Action",
      "Car",
      "Cars",
      "Cartoon",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/eio98g4rp8ec0nj0fpi2n78hhrbun3l1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eio98g4rp8ec0nj0fpi2n78hhrbun3l1/",
    "sourceUrl": "https://html5.gamemonetize.com/eio98g4rp8ec0nj0fpi2n78hhrbun3l1/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "33389",
    "slug": "car-eats-car-arctic-adventure",
    "title": "Car Eats Car: Arctic Adventure",
    "description": "Up for a fight against rivals in a dynamic race on the highway? Overtake enemies and create your own car in the incubator in Car Eats Car: Sea Adventure! Your friends are put to prison - do everything you can to free evil cars! Good driving skills and turbo speed come in handy in this crazy driving simulator and a police chase game. Become a car tycoon, upgrade cars, and play for monster cars against the cops! Fight the boss to survive in these ultimate crazy races!",
    "instructions": "Space - Bombs X - Turbo W - Gas S - Brake A D - Balancing Arrow keys - Gas Brake Balancing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Action",
      "Car",
      "Cars",
      "Cartoon",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/tjfsfsiwef7r77fwey3g68cujt80yg6l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tjfsfsiwef7r77fwey3g68cujt80yg6l/",
    "sourceUrl": "https://html5.gamemonetize.com/tjfsfsiwef7r77fwey3g68cujt80yg6l/",
    "width": 960,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "73915",
    "slug": "germaway",
    "title": "GermAway",
    "description": "GermAway is a fast, simple, and highly reactive survival game where your only mission is crystal clear: stay away from every germ on the screen. You control a tiny character moving through an environment filled with roaming, bouncing, and unpredictable contagious germs. They slide, swirl, chase, or drift across the arena&mdash;one touch is all it takes for the infection to spread and the game to end.",
    "instructions": "Move so that player does not toouch germs",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Casual",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/e6gu9cii7xqbhw8aghfguo2zga72hwsb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e6gu9cii7xqbhw8aghfguo2zga72hwsb/",
    "sourceUrl": "https://html5.gamemonetize.com/e6gu9cii7xqbhw8aghfguo2zga72hwsb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75905",
    "slug": "spin-color",
    "title": "Spin Color",
    "description": "Test your reflexes in this hyper-addictive color matching game! Watch the ball bounce and time your tap to spin the color wheel perfectly. Match the balls color with the wheels slice to score points and advance. One wrong match and its game over! Simple, fast-paced, and endlessly replayable&mdash;can you beat your high score?",
    "instructions": "Tap to spin the color wheel Match colors to score",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Cartoon",
      "Classic",
      "Color",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/hruy5jfueqyt2t9gcgx9j5wz2f7bj10p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hruy5jfueqyt2t9gcgx9j5wz2f7bj10p/",
    "sourceUrl": "https://html5.gamemonetize.com/hruy5jfueqyt2t9gcgx9j5wz2f7bj10p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75899",
    "slug": "birdy-mad-throw",
    "title": "Birdy Mad Throw",
    "description": "Birdy Mad Throw is a chaotic arcade game where an angry little bird is launched across crazy levels using pure throwing power. Aim, charge, and release to smash obstacles, hit targets, and cause maximum mayhem. Each throw demands timing and precision as physics send Birdy bouncing, spinning, and crashing through the environment. Unlock new stages, face tricky layouts, and chase high scores while mastering the art of the perfect mad throw. Fast, silly, and endlessly replayable fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "angrybirds",
      "Arcade",
      "Fun",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/utpewj7h7kka3mpnkn09x064799q569i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/utpewj7h7kka3mpnkn09x064799q569i/",
    "sourceUrl": "https://html5.gamemonetize.com/utpewj7h7kka3mpnkn09x064799q569i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75835",
    "slug": "knife-hit-challenege-game",
    "title": "Knife Hit Challenege Game",
    "description": "Welcome to Knife Hit Challenge Game, an exciting and addictive arcade game that tests your timing, focus, and precision. Get ready to throw knives at rotating targets, break obstacles, and prove your skills in this fast-paced knife throwing challenge. In Knife Hit Challenge Game, your goal is simple but challenging: throw knives accurately at the spinning target without hitting other knives. Each level increases in difficulty with faster rotations, tricky movements, and limited chances. One wrong move and the level is over.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Casual",
      "Fun",
      "Knight"
    ],
    "thumbnail": "https://img.gamemonetize.com/ksp4ter93afx3rqnureytkbtlkir4lcm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ksp4ter93afx3rqnureytkbtlkir4lcm/",
    "sourceUrl": "https://html5.gamemonetize.com/ksp4ter93afx3rqnureytkbtlkir4lcm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75837",
    "slug": "fall-ball-idle",
    "title": "Fall Ball Idle",
    "description": "dle Fall Balls is an addictive idle simulation game where balls of all kinds &mdash; football, tennis, golf, pool, volleyball, rugby and more &mdash; fall through colorful obstacles in satisfying physics-based action. Tap or click near the balls to nudge them and guide their fall through barriers while earning coins and upgrades. Upgrade balls, improve traits, and watch your idle income grow even when you&rsquo;re away. With simple touch controls, casual gameplay, and hyper-casual fun, this HTML5 browser game delivers endless challenge and replayability for players of all ages.",
    "instructions": "Mouse Left click and drag the mouse or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Ball",
      "Bounce",
      "Casual",
      "Clicker",
      "idle",
      "Physics",
      "Relaxation",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/bdd2sl8whgdpwuliwnspyxh2321wzb99/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bdd2sl8whgdpwuliwnspyxh2321wzb99/",
    "sourceUrl": "https://html5.gamemonetize.com/bdd2sl8whgdpwuliwnspyxh2321wzb99/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76052",
    "slug": "mountain-run",
    "title": "Mountain Run",
    "description": "Master the snowy peaks in Mountain Run! Sprint down an endless mountain, dodging trees and rocks while collecting coins. Unlock stylish outfits, experience dynamic seasons from Winter to Summer, and use power-ups like Magnets to boost your score. Features immersive 3D graphics, realistic running audio, and smooth controls. How far can you go in this high-speed adventure ?",
    "instructions": "Desktop - A Left Arrow Move Left - D Right Arrow Move Right - Space Up Arrow Jump Mobile - Tap Left Side Move Left - Tap Right Side Move Right - Tap with Two Fingers Jump",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Avoid",
      "Best",
      "Best Games",
      "Highscore",
      "Ice",
      "Platform",
      "run",
      "running",
      "Skateboard",
      "Skating",
      "Sport",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/releabfjx2tfx6owemnc1nb9cshzkjwg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/releabfjx2tfx6owemnc1nb9cshzkjwg/",
    "sourceUrl": "https://html5.gamemonetize.com/releabfjx2tfx6owemnc1nb9cshzkjwg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76061",
    "slug": "unity-mini-games-hub-relax",
    "title": "Unity Mini Games Hub Relax",
    "description": "Dive into the ultimate relaxation collection with Unity Mini Games Hub Relax! Enjoy a huge variety of satisfying mini-games designed to relieve stress and kill time. From slicing fruits and carving Dalgona candy to defusing bombs and solving block puzzles, there is a challenge for every mood. Web Dev <a href='https://www.brightygames.com/'>https://www.brightygames.com/</a> With colorful graphics and simple controls, it&rsquo;s the perfect way to unwind and have fun instantly!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Fun",
      "Kids",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/fqmm3gf3rd9wdlmknghas2r4vpycpzbz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fqmm3gf3rd9wdlmknghas2r4vpycpzbz/",
    "sourceUrl": "https://html5.gamemonetize.com/fqmm3gf3rd9wdlmknghas2r4vpycpzbz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75920",
    "slug": "last-train-escape",
    "title": "Last Train Escape",
    "description": "Last Train Escape is a fast-paced action survival game where every second matters. Run, jump and slide on top of a speeding train while avoiding obstacles and deadly gaps. Choose your difficulty, react fast and survive as long as possible in this intense arcade experience. No story, no distractions &mdash; only speed, danger and skill-based gameplay designed for quick and addictive sessions.",
    "instructions": "Run on a moving train jump over gaps and slide under obstacles Choose your difficulty and survive as long as you can in nonstop action",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Casual",
      "endless",
      "Escape",
      "Fun",
      "Funny",
      "Hypercasual",
      "Platform",
      "Train"
    ],
    "thumbnail": "https://img.gamemonetize.com/394l69zq5i3mhgqbzul176beyfx4lx5a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/394l69zq5i3mhgqbzul176beyfx4lx5a/",
    "sourceUrl": "https://html5.gamemonetize.com/394l69zq5i3mhgqbzul176beyfx4lx5a/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75947",
    "slug": "momentum",
    "title": "MOMENTUM",
    "description": "MOMENTUM is a high-speed endless runner that challenges your reflexes! Control a unique doodle character dashing through evolving worlds&mdash;from the Animal Kingdom to futuristic Alien Realms. Features: - Dynamic Worlds: Unlock new environments as you speed up (Animal, Human, Alien). - Custom Art Style: Cool doodle aesthetics with smooth animations. - Global Leaderboard: Compete for the top rank and earn titles like Reflex King or God. - Day/Night Cycle: Experience the game in different atmospheric modes. Dodge obstacles, collect crowns, and survive the increasing speed. How far can you run before the void consumes you?",
    "instructions": "Desktop - Left Right Arrow or A D Move Lanes - Up Arrow or Space Jump - Down Arrow Slide Mobile - Use the On-Screen Buttons to move - Swipe support enabled for smooth navigation",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "amazing",
      "Arcade",
      "Best",
      "Best Games",
      "Boys",
      "Brainrot",
      "endless",
      "Girls",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/71kap8r3c2kj9n5rl4xt89khiwf2kowt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/71kap8r3c2kj9n5rl4xt89khiwf2kowt/",
    "sourceUrl": "https://html5.gamemonetize.com/71kap8r3c2kj9n5rl4xt89khiwf2kowt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75563",
    "slug": "neon-space-defender",
    "title": "NEON SPACE DEFENDER",
    "description": "Space Defender is a fast-paced arcade space shooter where you fight endless waves of enemy asteroids. Choose your spaceship, upgrade weapons and armor, use bombs strategically, and survive as long as possible. Featuring smooth controls, radar system, upgrades, and mobile-friendly gameplay, this game delivers an intense sci-fi action experience.",
    "instructions": "PC W A S D ndash Move Mouse Click ndash Shoot Space ndash Bomb Wipeout Mobile Virtual Joystick ndash Move FIRE Button ndash Shoot On-screen buttons ndash Controls",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Alien",
      "Arcade",
      "Mobile",
      "Shooter",
      "Space",
      "Spaceship",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/owu4ajfvxrnt4ottx1jygnsd3n04mou9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/owu4ajfvxrnt4ottx1jygnsd3n04mou9/",
    "sourceUrl": "https://html5.gamemonetize.com/owu4ajfvxrnt4ottx1jygnsd3n04mou9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75583",
    "slug": "arrows-puzzle-escape",
    "title": "Arrows Puzzle Escape",
    "description": "Welcome to Arrows &ndash; Puzzle Escape, a minimalist puzzle game that challenges your logic, planning, and spatial thinking. Your goal is simple: extract each arrow without causing a collision. Features: - Challenging logic puzzles that test your planning skills - Thousands of handcrafted levels with increasing complexity - Clean, minimalist design that lets you focus on the puzzle - Relaxing, no-pressure gameplay &ndash; no timers, just your brain - Hint system to help when youre stuck Whether you have a few minutes or want a longer challenge, Arrows &ndash; Puzzle Escape is the perfect blend of strategy and calm. Can you clear the grid without losing",
    "instructions": "use mouse controls to escape the arrows",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "arrows",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/4b0aobrab7irntvltocbrcux0w0gaqhz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4b0aobrab7irntvltocbrcux0w0gaqhz/",
    "sourceUrl": "https://html5.gamemonetize.com/4b0aobrab7irntvltocbrcux0w0gaqhz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75758",
    "slug": "idle-chop-miner",
    "title": "Idle Chop Miner",
    "description": "Chop wood, gather resources, and grow your lumber empire in Idle Chop Miner! Start with simple tools, collect logs, and watch your production grow even while offline. Expand your operation by upgrading buildings, unlocking new areas, and hiring workers to automate progress. Customize your world with tree skins, character skins, and explore multiple maps. Combining idle and tycoon gameplay, this game lets you manage resources, improve facilities, and build a thriving operation at your own pace. Chop, upgrade, and expand your mining empire today!",
    "instructions": "Mouse Swap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2026 games",
      "Best Games",
      "Casual",
      "Clicker",
      "Gold",
      "idle",
      "Mine",
      "Miner",
      "Relaxation",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/a2z9ezpa0q579b66zi76b1nuq9bxfd5e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a2z9ezpa0q579b66zi76b1nuq9bxfd5e/",
    "sourceUrl": "https://html5.gamemonetize.com/a2z9ezpa0q579b66zi76b1nuq9bxfd5e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75932",
    "slug": "cute-animals-memory",
    "title": "cute Animals Memory",
    "description": "Cute Animals Memory is a fun and relaxing matching puzzle game designed for kids and casual players of all ages. Flip the cards, remember their positions, and match pairs of adorable animal icons. Each level challenges your memory, concentration, and attention in a simple and enjoyable way. The game features cute and colorful animal designs, smooth animations, and easy-to-understand gameplay with no complicated rules. Whether you want a quick brain exercise or a calm and entertaining experience, Cute Animals Memory is perfect for short play sessions. Improve your memory skills, train your brain, and have fun matching cute animals in this ch",
    "instructions": "Mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Memory",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/5znyg5x9ktbmky8darxhnvdnc7yqkp4l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5znyg5x9ktbmky8darxhnvdnc7yqkp4l/",
    "sourceUrl": "https://html5.gamemonetize.com/5znyg5x9ktbmky8darxhnvdnc7yqkp4l/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "76016",
    "slug": "escape-tsunami-for-brainrots",
    "title": "Escape Tsunami for Brainrots",
    "description": "Run fast and collect Brainrots! Run from the tsunamis when they appear! Survive and collect as many Brainrots as possible! Upgrade your Brainrots! Upgrade your base!",
    "instructions": "Run forward to get Brainrots Grab a Brainrot bring it back to your base in time and don rsquo t get caught by the tsunami",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "roblox",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/bar5fayxivsh0l9rgri3sysz8jd0445w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bar5fayxivsh0l9rgri3sysz8jd0445w/",
    "sourceUrl": "https://html5.gamemonetize.com/bar5fayxivsh0l9rgri3sysz8jd0445w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76040",
    "slug": "reckless-getaway-2-car-chase",
    "title": "Reckless Getaway 2: Car Chase",
    "description": "Ready for the ultimate adrenaline rush? Step into the drivers seat in Reckless Getaway 2: Ultimate Police Escape, the most intense action racing game on mobile! Immerse yourself in a thrilling chase as you navigate through city streets and off-road terrain, outrunning cop cars, SUVs, SWAT teams, helicopters, and even tanks!",
    "instructions": "use keyboard arrow keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Car",
      "Casual",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/48c7qqccwj4ac6z4tmrp9wybea1ek7o1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/48c7qqccwj4ac6z4tmrp9wybea1ek7o1/",
    "sourceUrl": "https://html5.gamemonetize.com/48c7qqccwj4ac6z4tmrp9wybea1ek7o1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76035",
    "slug": "dinosaur-city-hunting-destroy",
    "title": "Dinosaur City Hunting Destroy",
    "description": "Unleash your inner beast in Dinosaur City Hunting Destroy! Control a massive, realistic dinosaur and go on a rampage through a modern metropolis. Smash buildings, crush cars, and hunt down specific targets to complete your missions. With stunning 3D graphics and an open-world environment, you are the ultimate predator. Web Dev <a href='https://www.newcrazygames.com/'>https://www.newcrazygames.com/</a> Cause total chaos, survive the city forces, and dominate the streets in this thrilling simulation game!",
    "instructions": "Mouse click or tap to play wasd control the dinosaur",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Action",
      "destroy",
      "destroying",
      "dino",
      "Dinosaur",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/s5pt5t35wuln49vilycw1j81w5ypdm50/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s5pt5t35wuln49vilycw1j81w5ypdm50/",
    "sourceUrl": "https://html5.gamemonetize.com/s5pt5t35wuln49vilycw1j81w5ypdm50/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76034",
    "slug": "extreme-ball-balancer-3d",
    "title": "Extreme Ball Balancer 3D",
    "description": "Test your reflexes and precision in this ultimate balancing challenge! Navigate a rolling ball across treacherous wooden bridges, narrow rails, and shifting traps surrounded by deep blue water. With realistic physics and intense 3D graphics, one wrong move sends you plunging into the depths. Web Dev <a href='https://www.brightestgames.com/'>https://www.brightestgames.com/</a> Master the controls, keep your balance, and overcome every obstacle to reach the finish line. Do you have the steady hand to survive the extreme path?",
    "instructions": "WASD to controll the ball use mouse to change camera from left and right on the screen",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Balance",
      "Ball",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/8b9vp8opunp1ainfejmtmlpaha2yuzy7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8b9vp8opunp1ainfejmtmlpaha2yuzy7/",
    "sourceUrl": "https://html5.gamemonetize.com/8b9vp8opunp1ainfejmtmlpaha2yuzy7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75473",
    "slug": "pinball-block-shooter",
    "title": "PinBall Block Shooter",
    "description": "You know the rules! Use your flippers to launch the ball and smash as many blocks as possible in PinBall Block Shooter. Your goal is to keep the ball in play and rack up points while aiming for high scores. With a simple, classic design, intuitive two-button controls, and straightforward gameplay, this game is easy to pick up but hard to master. Perfect as a fun time killer, test your reflexes, stay in the game as long as possible, and enjoy the nostalgia of classic pinball action anytime!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Ball",
      "Block",
      "Bricks",
      "Casual",
      "Fun",
      "Game",
      "Physics",
      "Pinball",
      "Shooter",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/85637cazntg4sawr5hb10rd70b7skmer/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/85637cazntg4sawr5hb10rd70b7skmer/",
    "sourceUrl": "https://html5.gamemonetize.com/85637cazntg4sawr5hb10rd70b7skmer/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75912",
    "slug": "hexa-tiles-puzzle-game",
    "title": "Hexa Tiles Puzzle Game",
    "description": "Dive into a smart, satisfying hexagon puzzle that&rsquo;s easy to learn and tricky to master! Drag and place hex-shaped pieces onto the board, fitting them perfectly without overlap. Clear full lines and clever hex patterns to rack up points. Every move matters, so think ahead and keep the board open. When no piece fits, it&rsquo;s game over. How long can you keep the hexes clicking?",
    "instructions": "How to Play The board is made of hexagon tiles Choose a hex-shaped piece Drag or tap to place it on the board Pieces must fit and cannot overlap Complete full lines or patterns to clear them and score points Clear multiple lines at once for bonus po",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "amazing",
      "Best Games",
      "Brain",
      "free games for your site",
      "free games for your website",
      "Fun",
      "Hypercasual",
      "Interactive",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/ac6st88emp3rs0j2x8pskkpjykq3hle1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ac6st88emp3rs0j2x8pskkpjykq3hle1/",
    "sourceUrl": "https://html5.gamemonetize.com/ac6st88emp3rs0j2x8pskkpjykq3hle1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75964",
    "slug": "dark-sector",
    "title": "Dark Sector",
    "description": "Dark Sector is an intense alien-raid action game set deep inside a hostile, claustrophobic tunnel. Waves of deadly extraterrestrials pour in from the shadows, and survival depends on your firepower and reflexes. Armed with futuristic weapons, you fight your way through relentless attacks as bullets light up the darkness. The rule is simple: the more guns you carry, the easier it becomes to wipe out the alien threat. Stack your arsenal, upgrade your firepower, and turn the tunnel into a storm of shots and explosions.",
    "instructions": "Make more warriors its easy",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Battle",
      "War",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/s2au51pc8d006ubbfalod6jalw4sa2ih/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s2au51pc8d006ubbfalod6jalw4sa2ih/",
    "sourceUrl": "https://html5.gamemonetize.com/s2au51pc8d006ubbfalod6jalw4sa2ih/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75982",
    "slug": "picture-and-word-match",
    "title": "Picture and Word Match",
    "description": "Hi! Are you ready to match words with pictures? Each letter is a different level! Match each English word with the correct picture, learn the words along with their pronunciations, and move on to the next level! You must finish this educational game, and if you enjoyed it, please rate the game!",
    "instructions": "Match the correct word with the correct picture",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Matching",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/wkdswnm9uw2hak8pzlhkmxlv0sum8jbs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wkdswnm9uw2hak8pzlhkmxlv0sum8jbs/",
    "sourceUrl": "https://html5.gamemonetize.com/wkdswnm9uw2hak8pzlhkmxlv0sum8jbs/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "76024",
    "slug": "color-path-game",
    "title": "Color Path Game",
    "description": "Welcome to Color Path Game, a relaxing yet challenging puzzle adventure where colors, paths, and smart thinking come together. Get ready to connect paths, match colors, and complete exciting levels that test your logic and creativity. In Color Path Game, your mission is to draw the correct color paths without crossing or overlapping. Each level presents a new puzzle with multiple colors and tricky layouts that require careful planning and strategic moves. As you progress, puzzles become more complex and rewarding.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Casual",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/agyoyny2gq110l073a17xfzckaatnzgh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/agyoyny2gq110l073a17xfzckaatnzgh/",
    "sourceUrl": "https://html5.gamemonetize.com/agyoyny2gq110l073a17xfzckaatnzgh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75999",
    "slug": "block-master-polygonal-puzzle",
    "title": "Block Master: Polygonal Puzzle",
    "description": "A game about collecting blocks. But not the usual ones. Instead of the familiar squares, you get a bunch of polygons that you have to fit across the entire playing field to win. This fascinating online puzzle game will not let you get bored, complete all the levels in the game, divided into categories from the easiest to the most difficult to think about! Compete with other players on the leaderboard as you complete the levels!",
    "instructions": "Your goal is to beat as many stages as you can Theyre grouped by how easy they are so start with whatever feels right for you Once you pick a stage just fill the whole board with the shapes they give you Put the shapes next to each other so it makes",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Brain",
      "Casual",
      "construction",
      "Logic",
      "Logical",
      "Match 3",
      "Matching",
      "Mobile",
      "Puzzle",
      "puzzleblock",
      "Relaxation",
      "Skill",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/26hi7kw8year9zgch1e3mu5uz50rbbxc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/26hi7kw8year9zgch1e3mu5uz50rbbxc/",
    "sourceUrl": "https://html5.gamemonetize.com/26hi7kw8year9zgch1e3mu5uz50rbbxc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75496",
    "slug": "auric-core",
    "title": "Auric Core",
    "description": "Unearth the treasures of the underground in Auric Core, a fast-paced mining strategy game where every second counts. Deep within the planet&rsquo;s shifting crust, streams of Carbon and Gold flow through mechanical conveyance belts &mdash; and it&rsquo;s up to you to catch, collect, and refine them before they vanish into the depths. As the Miner Commander, you&rsquo;ll balance speed, timing, and precision to extract maximum value. Upgrade your mining rigs, automate your catchers, and refine your resources to unlock advanced technologies buried in the planet&rsquo;s core.",
    "instructions": "Aim for Gold",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Mind",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/7uv6wzttfusue05iz1z74vj7ucce2ffi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7uv6wzttfusue05iz1z74vj7ucce2ffi/",
    "sourceUrl": "https://html5.gamemonetize.com/7uv6wzttfusue05iz1z74vj7ucce2ffi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75495",
    "slug": "atomlinker",
    "title": "AtomLinker",
    "description": "AtomLinker is a fast-paced, chemistry-themed chain-matching puzzle game where your goal is to link three or more identical chemical elements to trigger powerful reactions. Slide, connect, and strategize as you form longer chains to unlock combo boosts, element power-ups, and explosive molecular effects. Each level challenges you with unique objectives&mdash;collect specific atoms, break frozen tiles, trigger chain reactions, or race against time. As you progress, you&rsquo;ll encounter elements from across the periodic table, each bringing new gameplay twists and special abilities that keep every round exciting.",
    "instructions": "Connect More than 3",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Educational",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/ls7tbr0hsvt095gnw4k4oiuahasjclkg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ls7tbr0hsvt095gnw4k4oiuahasjclkg/",
    "sourceUrl": "https://html5.gamemonetize.com/ls7tbr0hsvt095gnw4k4oiuahasjclkg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75903",
    "slug": "dummy-speed-bridger",
    "title": "Dummy Speed Bridger",
    "description": "Dummy Speed Bridge is a fast-paced reflex game where timing is everything. Dash forward as bridges snap into place beneath your feet, then vanish just as quickly. One wrong step and it&rsquo;s a long fall down. Test your reaction speed, memory, and nerves as the pace ramps up with every level. Simple controls, brutal momentum, and zero mercy&mdash;only the quickest dummies make it across.",
    "instructions": "Mouse click or tap to play",
    "category": ".IO",
    "genres": [
      ".IO"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Platform",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/w7zjm9hffe0ylqkc4jj7w896mj8u66sf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w7zjm9hffe0ylqkc4jj7w896mj8u66sf/",
    "sourceUrl": "https://html5.gamemonetize.com/w7zjm9hffe0ylqkc4jj7w896mj8u66sf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76032",
    "slug": "combo-color-unlocker",
    "title": "Combo Color Unlocker",
    "description": "Combo Color Unlocker is a fast-paced puzzle game where timing and color mastery are everything. Match, chain, and combine vibrant colors to unlock new shades and powerful combos. The longer your streak, the bigger the rewards&mdash;but one wrong move breaks the flow. Unlock special color abilities, beat challenging levels, and chase high scores as the difficulty ramps up. Web Dev <a href='https://www.crazygamesfree.com/'>https://www.crazygamesfree.com/</a> Simple to learn yet hard to master, Combo Color Unlocker delivers satisfying visual effects, smooth gameplay, and addictive combo-based challenges for quick sessions or long play streaks.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Color",
      "Mouse"
    ],
    "thumbnail": "https://img.gamemonetize.com/dxmwy9qzrpkdex7tzkh9qt9f69l74bxk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dxmwy9qzrpkdex7tzkh9qt9f69l74bxk/",
    "sourceUrl": "https://html5.gamemonetize.com/dxmwy9qzrpkdex7tzkh9qt9f69l74bxk/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75840",
    "slug": "quiz-runner-io",
    "title": "Quiz Runner.io",
    "description": "Quiz Runner.io &ndash; Trivia &amp; Multiplayer Quiz Battle Think fast, play smart, and rule the leaderboard in Quiz Runner.io, the ultimate online quiz game! Enjoy solo quiz mode to improve knowledge, custom quizzes to test your favorite topics, or upload your notes and PDFs to play interactive learning games. Join real-time multiplayer quiz battles, friend duels, and tournaments to compete globally. Track progress with levels, achievements, and power-ups. With daily quiz challenges, fast-paced timed games, smooth addictive gameplay, and support for 12+ languages, Quiz Runner.io is perfect for students, teachers, and trivia lovers worldwide!",
    "instructions": "W rarr Move Forward A rarr Move Left D rarr Move Right Double Left-Click Mouse rarr Move left or right",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      ".io Games",
      "2026 games",
      "Arcade",
      "Brain",
      "Educational",
      "Fun",
      "html5 games",
      "Multiplayer",
      "Online",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/o265mdiouhnx82t87q3p0t5jgspwsdoy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o265mdiouhnx82t87q3p0t5jgspwsdoy/",
    "sourceUrl": "https://html5.gamemonetize.com/o265mdiouhnx82t87q3p0t5jgspwsdoy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75910",
    "slug": "zombie-survival-last-stand",
    "title": "Zombie Survival : Last Stand",
    "description": "Survive a zombie-infested city in this fast-paced first-person shooter. Armed with modern weapons, you must fight off waves of aggressive zombies that chase you through narrow streets and abandoned areas. Aim carefully, manage your ammo, and react fast &mdash; the undead won&rsquo;t give you time to breathe. Each level tests your reflexes and accuracy as zombies become more dangerous the longer you survive. Keep moving, line up headshots, and eliminate as many enemies as possible to increase your kill count. Simple controls and intense close-combat encounters make every moment action-packed. How long can you survive against the horde? Features First-pers",
    "instructions": "WASD rarr Move Left Mouse Click rarr Shoot Right Mouse Click rarr Scope R rarr Reload Z rarr Lock cursor Middle Mouse rarr Switch Weapon ESC rarr Unlock cursor",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "fps",
      "Horror",
      "Shooter",
      "survival",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/o6w1t7bn7a9nw6jv4sny1sag7jsutbfu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o6w1t7bn7a9nw6jv4sny1sag7jsutbfu/",
    "sourceUrl": "https://html5.gamemonetize.com/o6w1t7bn7a9nw6jv4sny1sag7jsutbfu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76001",
    "slug": "catch-the-roober",
    "title": "Catch the roober",
    "description": "Put on your badge and clean up the streets in Catch the Robber! In this fast-paced action game, you play as a fearless sheriff chasing down a gang of red-masked thieves. Watch out&mdash;they are armed with giant loot bottles and ready to run! Use stealth and strategy to corner them, knock them out, and protect the town. Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a> With vibrant 3D graphics and addictive gameplay, justice is in your hands!",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "catch",
      "Mentolatux",
      "roober",
      "Skill",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/r8pd241qeg18dgd4kr136nnxdavcv67p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r8pd241qeg18dgd4kr136nnxdavcv67p/",
    "sourceUrl": "https://html5.gamemonetize.com/r8pd241qeg18dgd4kr136nnxdavcv67p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75998",
    "slug": "turret-defend-apocalypse",
    "title": "Turret Defend Apocalypse",
    "description": "Turret Defend Apocalypse is a fast-paced defense game set in a world overrun by chaos. Place, merge, and upgrade powerful turrets to stop endless waves of enemies before they break through your last line of defense. Web Dev <a href='https://www.loogames.com/'>https://www.loogames.com/</a> Combining identical turrets creates stronger, deadlier versions with unique effects and increased firepower. As the apocalypse intensifies, enemies grow faster and tougher, pushing your strategy to the limit. Simple controls, satisfying merges, and nonstop action make every run intense",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Arcade",
      "Shoot 'Em Up",
      "Tower Defense",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/wf7x9s6gngkfgo06rihu0od5p1kw48rx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wf7x9s6gngkfgo06rihu0od5p1kw48rx/",
    "sourceUrl": "https://html5.gamemonetize.com/wf7x9s6gngkfgo06rihu0od5p1kw48rx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "76002",
    "slug": "missile-dude-rpg",
    "title": "Missile Dude RPG",
    "description": "Dive into the explosive world of Missile Dude RPG! In this quirky cartoon action RPG, you play as a bazooka-wielding hero defending against waves of quirky monsters emerging from portals. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a> Launch powerful missiles, collect resources, and upgrade your arsenal to build the ultimate defense. Recruit unique allies and dominate the battlefield in this addictive and strategic mobile adventure. Can you blast them all?",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Mentolatux",
      "Monster",
      "Shooting",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/qftg5cqexp60d49vcz6oroi0ei31nn65/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qftg5cqexp60d49vcz6oroi0ei31nn65/",
    "sourceUrl": "https://html5.gamemonetize.com/qftg5cqexp60d49vcz6oroi0ei31nn65/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75966",
    "slug": "driftsea",
    "title": "DriftSea",
    "description": "DriftSea is a calm yet challenging sea-themed glide puzzle game where strategy meets smooth movement. In each level, you slide floating bars across the ocean grid, carefully planning every move to reach specific goals. The mechanics are simple to learn, but mastering the puzzles requires logical thinking, foresight, and precision. As you progress, levels introduce new layouts and increasing complexity, encouraging you to think ahead and optimize each glide. The soothing ocean atmosphere and clean visuals create a relaxing experience, while the puzzles keep your mind engaged.",
    "instructions": "Make the line full",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bricks",
      "Casual",
      "Puzzle",
      "waterslide"
    ],
    "thumbnail": "https://img.gamemonetize.com/3wj5a4gyag4a4ni5jm1f6ali83lpcnx9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3wj5a4gyag4a4ni5jm1f6ali83lpcnx9/",
    "sourceUrl": "https://html5.gamemonetize.com/3wj5a4gyag4a4ni5jm1f6ali83lpcnx9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75971",
    "slug": "gravesky",
    "title": "GraveSky",
    "description": "GraveSky is a fast-paced arcade flier where survival hangs between narrow gaps in a dark, unforgiving sky. Control a vulture in constant flight and guide it through tight spaces between towering bars&mdash;one wrong move and the run ends. Each tap keeps the vulture airborne, demanding perfect rhythm and sharp focus as obstacles close in. The pace steadily increases, testing your reflexes and control with every passing moment. Staying alive means mastering timing, patience, and precision.",
    "instructions": "Keep the bird between poles",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Bird",
      "Casual",
      "flappybird"
    ],
    "thumbnail": "https://img.gamemonetize.com/rwmmesd1vqbkr3jh7qod4dyjfgkxxrd7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rwmmesd1vqbkr3jh7qod4dyjfgkxxrd7/",
    "sourceUrl": "https://html5.gamemonetize.com/rwmmesd1vqbkr3jh7qod4dyjfgkxxrd7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75981",
    "slug": "mindmatch",
    "title": "MindMatch",
    "description": "MindMatch is an immersive and stylish memory-matching game designed to challenge your brain and sharpen your focus. Set against a beautiful, glassmorphism-inspired interface, players must uncover pairs of hidden emojis across various board sizes ranging from a beginner-friendly 4x4 to a challenging 8x8 grid.Customize your experience with multiple vibrant themes like Ocean, Midnight, and Candy, and choose from diverse emoji categories including Animals, Food, Nature, and Vehicles. With three difficulty levels that control card visibility and a built-in scoring system that rewards speed and precision",
    "instructions": "Mouse Click Tap Interact with menus and flip cards UI Buttons Reset Restart the current game session Menu Return to the main navigation screen Back Return to the previous setup screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Arcade",
      "Brain",
      "Logical",
      "Memory",
      "Pokemon",
      "Puzzle",
      "Skills",
      "unblocked",
      "unblocked games",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/igi0ieohonhbopdsg2kwmyz661ffkh84/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/igi0ieohonhbopdsg2kwmyz661ffkh84/",
    "sourceUrl": "https://html5.gamemonetize.com/igi0ieohonhbopdsg2kwmyz661ffkh84/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75628",
    "slug": "tiny-dolls-dream-world",
    "title": "Tiny Dolls Dream World",
    "description": "Welcome to Tiny Dolls: Dream World, a magical and adorable fantasy universe where creativity and fun come together. If you love design, enjoy creating your own avatar, adore cute cats, and want relaxing, casual gameplay, this game is made just for you!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby",
      "Cat",
      "Design",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/7uxmajpn6g689a71w34hbbviu6tlw45s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7uxmajpn6g689a71w34hbbviu6tlw45s/",
    "sourceUrl": "https://html5.gamemonetize.com/7uxmajpn6g689a71w34hbbviu6tlw45s/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "76010",
    "slug": "hammer-strike-destruction-zone",
    "title": "Hammer Strike: Destruction Zone",
    "description": "Hammer Strike: Destruction Zone is an adrenaline-fueled destruction game offering constant battle against time. You must crush concrete, steel, and reinforced metal blocks raining endlessly from the sky with a massive industrial hammer. Drag the hammer anywhere on screen, charge power, and release to smash! Each destroyed block subtracts precious seconds from the time bar. But beware &mdash; the time bar constantly fills up and when its full, game over. Easy, Normal, and Hard modes offer different time speeds and block durabilities for every skill level. Precise timing, quick reflexes, and strategic hammer placement are keys to success.",
    "instructions": "Drag hammer tap to charge power and release to SMASH Destroy constantly falling blocks Each crushed block reduces time but the bar keeps filling Maximize destruction before time runs out Speed power survival",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Casual",
      "destroy",
      "destroying",
      "destruction",
      "Fun",
      "Funny",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/is991jsmyjk7m5vc5a1jmiir1p7986x5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/is991jsmyjk7m5vc5a1jmiir1p7986x5/",
    "sourceUrl": "https://html5.gamemonetize.com/is991jsmyjk7m5vc5a1jmiir1p7986x5/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "76005",
    "slug": "never-fall",
    "title": "Never Fall",
    "description": "Jump higher and climb forever in Never Fall! Leap from platform to platform, time your jumps perfectly, and rise through endless skies. One mistake sends you falling, so stay sharp and keep moving up. Easy to play but hard to master, Never Fall challenges your reflexes and focus with nonstop action and increasing difficulty. How far can you go before gravity wins?",
    "instructions": "How to Play Tap the screen to make your character jump Land on platforms to keep climbing Avoid falling off or hitting obstacles Make sure to collect coins along the way Climb as high as you can to beat your score",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "amazing",
      "Best Games",
      "Bridge",
      "endless",
      "Highscore",
      "Hypercasual",
      "sky",
      "Superhero",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/val4nbdh5nl16md5ll43al6aj5keq2v0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/val4nbdh5nl16md5ll43al6aj5keq2v0/",
    "sourceUrl": "https://html5.gamemonetize.com/val4nbdh5nl16md5ll43al6aj5keq2v0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75992",
    "slug": "car-modified-master",
    "title": "Car Modified Master",
    "description": "Welcome to Car Modified Master, a powerful and exciting car modification game made for players who love cars, customization, and creative design. Get ready to transform simple cars into stunning modified machines using your skills, imagination, and style. In Car Modified Master, your mission is to customize cars step by step. Change car colors, upgrade wheels, add spoilers, improve body kits, and modify every detail to create your dream car. Each modification makes your vehicle more stylish, unique, and powerful.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Car",
      "Cars",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/yonomgcy7ra0upnrzzh3n30n3cdx17qn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yonomgcy7ra0upnrzzh3n30n3cdx17qn/",
    "sourceUrl": "https://html5.gamemonetize.com/yonomgcy7ra0upnrzzh3n30n3cdx17qn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75268",
    "slug": "sliding-puzzle",
    "title": "Sliding Puzzle",
    "description": "Experience the classic 15-puzzle re-imagined in this premium Mastermind Edition. Sliding Puzzle features a sleek dark user interface, vibrant procedural Gemstone tile colors, and a dynamic audio engine that generates satisfying sound effects in real-time. Challenge yourself across three difficulty levels (3x3, 4x4, and 5x5 grids). Stuck on a hard level? Use the Watch &amp; Solve feature to unlock a smart AI assistant that automatically solves the puzzle for you. Fully optimized for smooth gameplay on both mobile devices and desktops",
    "instructions": "Desktop Click on any tile adjacent to the empty space to slide it Mobile Tap or swipe a tile to move it into the empty space Menu Use the on-screen buttons to pause toggle sound or access settings",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Puzzle",
      "sliding",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/063ygrd7r2kgqf1wqxifmyyrirhsqjt9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/063ygrd7r2kgqf1wqxifmyyrirhsqjt9/",
    "sourceUrl": "https://html5.gamemonetize.com/063ygrd7r2kgqf1wqxifmyyrirhsqjt9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75515",
    "slug": "air-combat-jet-fighter",
    "title": "Air Combat: Jet Fighter",
    "description": "Get ready for adrenaline-pumping aerial battles in Air Combat: Jet Fighter. Take control of advanced jets and dominate the skies in thrilling dogfights and air strike missions. Test your flying skills across multiple combat modes, unlock powerful aircraft, and unleash missiles on enemies. With stunning 3D graphics, smooth controls, cinematic effects, and intense sky battles, experience the ultimate modern air combat. Lead your squadron, crush enemy forces, and become the ace of the skies!",
    "instructions": "Mouse control and WASD to move and L OR Shift to fire",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2026 games",
      "3D",
      "Air",
      "Aircraft",
      "Fight",
      "firefighters",
      "Flight",
      "jet",
      "military",
      "Shooting",
      "Simulation",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/4rwb2vg5k4ax3xi3j3esvq7n9opgoo6q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4rwb2vg5k4ax3xi3j3esvq7n9opgoo6q/",
    "sourceUrl": "https://html5.gamemonetize.com/4rwb2vg5k4ax3xi3j3esvq7n9opgoo6q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75944",
    "slug": "desert-rover-survival",
    "title": "Desert Rover Survival",
    "description": "Desert Rover Survival is an idle survival adventure set in a harsh desert world. Begin with a simple setup and slowly build your own desert rover, upgrading parts and improving technology to push farther into the wasteland.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "building",
      "Casual",
      "Crafting",
      "idle",
      "Simulation",
      "survival",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/x0g1mmje0rtpklbaujt0wx6ntylwcmme/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x0g1mmje0rtpklbaujt0wx6ntylwcmme/",
    "sourceUrl": "https://html5.gamemonetize.com/x0g1mmje0rtpklbaujt0wx6ntylwcmme/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75874",
    "slug": "jump-masters",
    "title": "Jump Masters",
    "description": "Reach for the stars in **Jump Master - Sky High**, an addictive and visually stunning vertical platformer! Guide your character through 50 increasingly difficult levels, mastering the art of the jump to climb higher and higher. Experience a world that evolves as you ascend&mdash;starting from a sunny Spring meadow, rising through the heat of Summer, drifting into Autumns falling leaves, and finally conquering the icy challenges of Winter at the highest peaks. ## Key Features - **Dynamic Seasons**: Watch the world change around you! The background, sky, and weather effects transition seamlessly from Spring to Winter as you climb higher. - **50 Challenging Levels**: Face a variety of platforms including Moving, Disappearing, and Red Danger zones that test your reflexes. - **Realistic Character**: Play as a fully animated character with realistic jute shoes, dynamic clothing colors, and expressive face reactions. - **Global Leaderboard**: Compete with players worldwide! Can you make it to t",
    "instructions": "- PC Use Left Right Arrow Keys or A D to move - Mobile Tap the Left or Right side of the screen to guide your character - Objective Jump on platforms to climb up Avoid falling off the screen or touching the Red Danger pla",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "amazing",
      "Avoid",
      "Best",
      "Best Games",
      "Crazy",
      "jump",
      "Jumping",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/oc96sbhgq8x99xtl3ghoqk3nf85i72bs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oc96sbhgq8x99xtl3ghoqk3nf85i72bs/",
    "sourceUrl": "https://html5.gamemonetize.com/oc96sbhgq8x99xtl3ghoqk3nf85i72bs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75945",
    "slug": "bowmasters2",
    "title": "Bowmasters2",
    "description": "Bowmasters is a fun and action-packed game that combines creative physics with exciting Archery gameplay. Use different types of bows and weapons.",
    "instructions": "Click and drag to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Draw",
      "Drawing",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/iim6rs9x8hnorti436tu66jww9dz2yrg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iim6rs9x8hnorti436tu66jww9dz2yrg/",
    "sourceUrl": "https://html5.gamemonetize.com/iim6rs9x8hnorti436tu66jww9dz2yrg/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "75909",
    "slug": "blocky-leap",
    "title": "Blocky Leap",
    "description": "In Blocky Leap, players take control of an expressive, square-headed character navigating a treacherous path of green-topped pylons. By mastering the click and release mechanic, you must launch your hero across wide gaps with perfect timing and precision. Web Dev <a href='https://www.kizi10.org/'>https://www.kizi10.org/</a> Set against a vibrant jungle backdrop, this arcade-style challenge tests your focus as you aim for the highest score while leaping from pillar to pillar.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Cat",
      "jump",
      "Mentolatux",
      "Skill",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/d3m1umywcoi48t45rpxtu9en66rd9s78/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d3m1umywcoi48t45rpxtu9en66rd9s78/",
    "sourceUrl": "https://html5.gamemonetize.com/d3m1umywcoi48t45rpxtu9en66rd9s78/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75917",
    "slug": "rich-choice-run",
    "title": "Rich Choice Run",
    "description": "Rich Choice Run is a fun swipe runner where every decision shapes your final lifestyle. Slide left and right to pick the best &ldquo;boyfriend&rdquo; choices and grab expensive items along the way. Your choices build your value and status&mdash;choose wisely, because one bad pick can ruin your chance.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Avoid",
      "Collecting",
      "Dating",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/yfdk9i5vhmeyfuo01emtikcft1lz9ocz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yfdk9i5vhmeyfuo01emtikcft1lz9ocz/",
    "sourceUrl": "https://html5.gamemonetize.com/yfdk9i5vhmeyfuo01emtikcft1lz9ocz/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75928",
    "slug": "mr-bean-3d-jigsaw",
    "title": "Mr. Bean 3D Jigsaw",
    "description": "In the game Mr.Bean 3D Jigsaw you will find a cute set of puzzles. All the pictures are dedicated to the popular character Mr.Bean and the set has its own peculiarity. You will be presented with scattered volumetric fragments at each level. Move and move them to connect them. If the fragments fit together, their connection will become unbreakable. The end result will be a whole picture that will appear before you as soon as the last fragment is connected. Gradually, the number of pieces will increase and reach a maximum number of 96.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Android",
      "Best",
      "Cartoon",
      "Fun",
      "Funny",
      "Jigsaw",
      "Kids",
      "Mobile",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/ildo8xjr8mymzcsuotmow174qgqjtgwt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ildo8xjr8mymzcsuotmow174qgqjtgwt/",
    "sourceUrl": "https://html5.gamemonetize.com/ildo8xjr8mymzcsuotmow174qgqjtgwt/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75930",
    "slug": "saw-pop-master",
    "title": "Saw Pop Master",
    "description": "Saw Pop Master is an intense arcade skill game where precision and timing are everything. Pop targets by launching them through spinning saws, moving traps, and deadly obstacles without getting shredded. Each level ramps up the challenge with faster blades, tighter gaps, and clever patterns that test your reflexes. Master perfect throws, earn high scores, and unlock new visuals as you survive the chaos. Easy to pick up but brutally addictive, Saw Pop Master keeps your nerves sharp and your timing sharper.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Basketball"
    ],
    "thumbnail": "https://img.gamemonetize.com/80yhkshj0dqz050yl38ee3sxl79xdvr7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/80yhkshj0dqz050yl38ee3sxl79xdvr7/",
    "sourceUrl": "https://html5.gamemonetize.com/80yhkshj0dqz050yl38ee3sxl79xdvr7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75931",
    "slug": "blocker-fit-guy",
    "title": "Blocker Fit Guy",
    "description": "Blocker Fit Guy is a fun and challenging puzzle-action game where you guide a flexible hero through tight spaces and tricky block formations. Rotate, stretch, and fit your character into the correct shapes to pass each obstacle without getting stuck. As levels progress, layouts become more complex, testing your logic, timing, and spatial awareness. With simple controls, smooth animations, and satisfying solutions, Blocker Fit Guy delivers quick brain-teasing fun that&rsquo;s easy to start and hard to put down.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Platform",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/9qbwwvruexy6qydheqv52tv4f7cgr1tw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9qbwwvruexy6qydheqv52tv4f7cgr1tw/",
    "sourceUrl": "https://html5.gamemonetize.com/9qbwwvruexy6qydheqv52tv4f7cgr1tw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75946",
    "slug": "cuesoccer",
    "title": "CueSoccer",
    "description": "CueSoccer is a game that blends billiards precision with football rules. Aim carefully, control the angles and outplay your opponent. Simple mechanics, surprisingly intense matches.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "Billiard",
      "Football",
      "Pool",
      "Soccer",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/o4xj53t9nzems5znjdyawv3k4d8al21t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o4xj53t9nzems5znjdyawv3k4d8al21t/",
    "sourceUrl": "https://html5.gamemonetize.com/o4xj53t9nzems5znjdyawv3k4d8al21t/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75940",
    "slug": "surprise-blume-doll-unbox",
    "title": "Surprise Blume Doll Unbox",
    "description": "Surprise Blume Doll Unbox is a relaxing and delightful casual game where the joy begins the moment you open the box. Each unboxing reveals a cute doll, turning every play session into an exciting surprise!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Collecting",
      "Dress Up",
      "ragdoll",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/tfc5z6kvwx4vffxr4qklcr0ghb43qq8e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tfc5z6kvwx4vffxr4qklcr0ghb43qq8e/",
    "sourceUrl": "https://html5.gamemonetize.com/tfc5z6kvwx4vffxr4qklcr0ghb43qq8e/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "75948",
    "slug": "harbor-breakout",
    "title": "Harbor Breakout",
    "description": "Harbor Breakout is a fast-paced top-down action escape game where every second counts. Control a speed boat and navigate through a closing harbor filled with enemy patrols, floating mines and tight passages. Choose your difficulty and react fast as obstacles become denser and enemies more aggressive over time. One mistake ends the run. No story, no distractions &mdash; just pure movement, pressure and skill-based arcade action designed for quick and replayable sessions.",
    "instructions": "Steer your speed boat through a dangerous harbor avoid mines and escape enemy patrols Choose your difficulty and survive as long as possible in nonstop action",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Casual",
      "Fun",
      "Funny",
      "Hypercasual",
      "ship"
    ],
    "thumbnail": "https://img.gamemonetize.com/nysfrfcioynodqlvcwye5af07vxg4map/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nysfrfcioynodqlvcwye5af07vxg4map/",
    "sourceUrl": "https://html5.gamemonetize.com/nysfrfcioynodqlvcwye5af07vxg4map/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75689",
    "slug": "stickman-stack-race",
    "title": "Stickman Stack Race",
    "description": "Lead your stickman crowd, crush obstacles, and dominate the streets in Stickman Stack Race! Choose the right gates, gather warriors, and multiply your team to beat rival crowds. Collect coins, upgrade your stickmen, and race through crowded city streets toward the ultimate battle. Face the King-stickman in the final clash and claim the castle! With bright 3D graphics, simple controls, and addictive stacking action, Stickman Stack Race offers endless fun, strategy, and thrills. Become the ultimate crowd master and rule the race!",
    "instructions": "Swipe the mouse to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2026 games",
      "endless",
      "Game",
      "Hypercasual",
      "Kids",
      "Obstacle",
      "Race",
      "running",
      "Stack",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/vbwc7vu6fyrkmcy143eanyv618vh75q6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vbwc7vu6fyrkmcy143eanyv618vh75q6/",
    "sourceUrl": "https://html5.gamemonetize.com/vbwc7vu6fyrkmcy143eanyv618vh75q6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75972",
    "slug": "halo-run",
    "title": "Halo Run",
    "description": "Halo Run is a fast-paced reflex game set on an endless circular track where survival depends on perfect timing. Run endlessly around the halo and leap over incoming obstacles before they collide with you&mdash;one mistake and the run is over. The challenge intensifies as speed increases and obstacles appear closer together, pushing your reaction time to the limit. Every jump must be precise, every move calculated. Simple controls make it easy to play, but mastering the rhythm takes skill and focus.",
    "instructions": "Make the bar jump at the right time",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Jumping",
      "Puzzle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/xvbuyjy16im5sqe4trtlxqfehzaj7w26/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xvbuyjy16im5sqe4trtlxqfehzaj7w26/",
    "sourceUrl": "https://html5.gamemonetize.com/xvbuyjy16im5sqe4trtlxqfehzaj7w26/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75975",
    "slug": "spectral-seek",
    "title": "Spectral Seek",
    "description": "Spectral Seek is a mysterious object-finding game set inside a haunted mansion filled with secrets, shadows, and whispers from the past. Explore eerie rooms and forgotten halls as you search for hidden objects scattered throughout the mansion. Each level challenges your observation skills, blending spooky atmosphere with clever hiding spots. The deeper you venture, the trickier the finds become, testing your focus and attention to detail. Every discovered object brings you closer to uncovering the mansion&rsquo;s secrets.",
    "instructions": "Find the hidden objects",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Hidden"
    ],
    "thumbnail": "https://img.gamemonetize.com/1pwu6s4q04jksombuvu9qzd8g0go4ja4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1pwu6s4q04jksombuvu9qzd8g0go4ja4/",
    "sourceUrl": "https://html5.gamemonetize.com/1pwu6s4q04jksombuvu9qzd8g0go4ja4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75973",
    "slug": "stack-ball-run-3d",
    "title": "Stack Ball Run 3D",
    "description": "Stack Ball Run 3D is a fast-paced arcade runner game. Drag left and right to collect balls and build the tallest stack. Avoid obstacles, survive as long as possible, and beat your high score!",
    "instructions": "Mouse Touch Drag left and right to move Keyboard Arrow Left Arrow Right or A D keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Ball",
      "Casual",
      "endless",
      "Hypercasual",
      "Obstacle",
      "running",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/lf58ps52phzp9ve677ywyq229jjg63gb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lf58ps52phzp9ve677ywyq229jjg63gb/",
    "sourceUrl": "https://html5.gamemonetize.com/lf58ps52phzp9ve677ywyq229jjg63gb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75471",
    "slug": "find-n-match",
    "title": "Find n Match",
    "description": "Find &amp; Match is an addictive pyramid puzzle game that tests your observation skills and quick thinking! Dive into beautifully stacked layers of colorful items - fruits, flowers, animals, foods, and more. Only surface items can be clicked, so plan your moves wisely. Collect three matching items to clear them from your basket. Race against the clock through 6 unique themed levels: Meadow, Garden, Farm, Ocean, Market, and Festival. Each level unlocks after completing the previous one. Can you conquer all pyramids?",
    "instructions": "Tap surface items to collect Match 3 identical items to clear Empty the pyramid before time runs out",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/20isw2akjl2dyo0x7i9jlhqdtjyx6met/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/20isw2akjl2dyo0x7i9jlhqdtjyx6met/",
    "sourceUrl": "https://html5.gamemonetize.com/20isw2akjl2dyo0x7i9jlhqdtjyx6met/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75596",
    "slug": "bounce-ball-ring-challenge",
    "title": "Bounce Ball Ring Challenge",
    "description": "Bounce Ball Ring Challenge is a fast-paced arcade game where precision and timing are everything. Aim carefully and launch the ball to bounce through glowing rings while avoiding tricky obstacles in your path. Each successful ring pass boosts your momentum and helps you reach higher scores. Miss your shot or hit an obstacle, and the challenge gets tougher! Control the angle, master the bounce, and keep the ball in motion. The smoother your aim, the more rings you clear. Simple to play, hard to master&mdash;can you beat your best score?",
    "instructions": "Space Bar or D to jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Ball",
      "Bounce",
      "endless",
      "Fun",
      "Level",
      "Obstacle",
      "onetouch",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/j4737md1z96104ib14j3pdnklirrd2ii/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j4737md1z96104ib14j3pdnklirrd2ii/",
    "sourceUrl": "https://html5.gamemonetize.com/j4737md1z96104ib14j3pdnklirrd2ii/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75867",
    "slug": "flick-shot-soccer",
    "title": "Flick Shot Soccer",
    "description": "Flick Shot Soccer is a fun and addictive soccer shooting game where every goal is all about precision. Simply drag to aim and position your shot, then release to kick and send the ball flying into the net. Easy controls make it perfect for anyone to pick up and play, while smart angles and timing are needed to score consistently.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/t6skn3ximxeitrfklq4g7myypwvhllk2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t6skn3ximxeitrfklq4g7myypwvhllk2/",
    "sourceUrl": "https://html5.gamemonetize.com/t6skn3ximxeitrfklq4g7myypwvhllk2/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75889",
    "slug": "draw-bridge-puzzle-2",
    "title": "Draw Bridge Puzzle 2",
    "description": "Draw Bridge Puzzle is a creative and exciting puzzle game that combines drawing and rescue gameplay into one addictive experience. You become a bridge designer, using your finger to draw safe paths and complete thrilling rescue missions. Enter the car mode, draw a strong bridge to help a motor cross gaps, broken roads, and dangerous obstacles to reach the goal. Or enter the save mode, draw a protective shield to shield the stick figure from danger. As you progress, the levels introduce more complex. You must think carefully and use smart designs to save ink while keeping the bridge stable",
    "instructions": "Tap Drag to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Draw",
      "Drawing"
    ],
    "thumbnail": "https://img.gamemonetize.com/lpkk3oshakph2lsljw07cthymwkxk0vc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lpkk3oshakph2lsljw07cthymwkxk0vc/",
    "sourceUrl": "https://html5.gamemonetize.com/lpkk3oshakph2lsljw07cthymwkxk0vc/",
    "width": 1680,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75878",
    "slug": "ball-throw-goalie",
    "title": "Ball Throw Goalie",
    "description": "Ball Throw Goalie is a fast, skill-based arcade game where precision and timing decide the score. Aim, adjust your power, and throw the ball past an active goalie who reacts to every move. Each level increases the challenge with smarter goalkeepers, moving targets, and tighter angles. Web Dev <a href='https://www.crazygamesx.com/'>https://www.crazygamesx.com/</a> Master curved throws, fake shots, and perfect timing to outplay the goalie, rack up points, and prove you have the accuracy of a true goal scorer.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Ball",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/kq8urvufxkqrwjnzydj996ug2vaa4xss/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kq8urvufxkqrwjnzydj996ug2vaa4xss/",
    "sourceUrl": "https://html5.gamemonetize.com/kq8urvufxkqrwjnzydj996ug2vaa4xss/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75877",
    "slug": "ball-dispensor-puzzle",
    "title": "Ball Dispensor Puzzle",
    "description": "Ball Dispenser Puzzle is a clever physics-based challenge where every move counts. Rotate, slide, and activate dispensers to release balls in the right order and guide them through obstacles, switches, and traps. Timing and logic are key as levels grow more complex, introducing new mechanics and tricky layouts. Web Dev <a href='https://www.crazygames.com.es/'>https://www.crazygames.com.es/</a> One wrong move can jam the system, so plan ahead, experiment, and master each puzzle to deliver every ball to its goal.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Brain",
      "Clicker",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/8de82h54djx2684jfkywpium641xux8h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8de82h54djx2684jfkywpium641xux8h/",
    "sourceUrl": "https://html5.gamemonetize.com/8de82h54djx2684jfkywpium641xux8h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75876",
    "slug": "cat-girl-skater",
    "title": "Cat Girl Skater",
    "description": "Meet this vibrant cat-girl skater, a feline force of energy gliding through a sun-drenched park. Sporting a bold yellow tee, blue shorts, and protective knee pads, she balances effortlessly on her blue skateboard with bright red wheels. Her striking red-streaked hair is held back by a green headband, matching the whimsical outdoor scenery. Web Dev h<a href='https://www.poki.com.es/'>https://www.poki.com.es/</a> With arms outstretched for balance and a confident smile, she embodies the playful spirit of adventure.",
    "instructions": "use arrow and space to control",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Cat",
      "Girl",
      "Mentolatux",
      "Skateboard",
      "Skating",
      "Skill",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/g12vushibrsgqv3tovkii9i2dhb81h29/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g12vushibrsgqv3tovkii9i2dhb81h29/",
    "sourceUrl": "https://html5.gamemonetize.com/g12vushibrsgqv3tovkii9i2dhb81h29/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75873",
    "slug": "cat-escape-2026",
    "title": "Cat Escape 2026",
    "description": "Ready for a purr-fect adventure? Help your cute cat escape from the guards in Cat Escape 2026! Tiptoe through exciting levels, hide in boxes, and avoid getting caught. Collect coins to unlock funny costumes and enjoy hours of relaxing yet challenging gameplay. It&rsquo;s simple, fun, and impossible to put down. Web Dev <a href='https://www.kizi.com.es/'>https://www.kizi.com.es/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Cat",
      "Escape",
      "Mentolatux",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/7gmxgh39vsovluqidxplhotykykaflpd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7gmxgh39vsovluqidxplhotykykaflpd/",
    "sourceUrl": "https://html5.gamemonetize.com/7gmxgh39vsovluqidxplhotykykaflpd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75765",
    "slug": "crossy-zombie-game",
    "title": "Crossy Zombie Game",
    "description": "Welcome to Crossy Zombie Game, a fast-paced and thrilling survival adventure where danger waits at every step! Enter a world overrun by zombies and test your reflexes, timing, and survival skills as you cross deadly roads, rivers, and zombie-filled zones. In this exciting zombie crossing survival game, your mission is simple but challenging: move forward, avoid obstacles, escape zombies, and survive as long as possible. But be careful &mdash; one wrong move can end your run. Zombies attack from all sides, vehicles rush past at high speed, and the environment becomes more dangerous as you progress.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Casual",
      "Puzzle",
      "running",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/iqabe735601dz3yxmbqwjtvt4137846f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iqabe735601dz3yxmbqwjtvt4137846f/",
    "sourceUrl": "https://html5.gamemonetize.com/iqabe735601dz3yxmbqwjtvt4137846f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75805",
    "slug": "challenge-the-basketball",
    "title": "Challenge the Basketball",
    "description": "Welcome to Challenge the Basketball, an exciting and addictive basketball challenge game designed for players who love sports, quick reflexes, and skill-based gameplay. Get ready to test your shooting accuracy, timing, and focus in this fun and engaging basketball experience. In Challenge the Basketball, your goal is simple but challenging: aim carefully, throw the basketball at the right time, and score as many points as possible. As you progress, the difficulty increases with faster movement, tricky angles, and new obstacles that push your basketball skills to the limit.",
    "instructions": "- To click any button use mouse",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Basketball",
      "Football",
      "Fun",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/7v6fe7ejbu9sb7ujjwglt0rg81ze6hdl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7v6fe7ejbu9sb7ujjwglt0rg81ze6hdl/",
    "sourceUrl": "https://html5.gamemonetize.com/7v6fe7ejbu9sb7ujjwglt0rg81ze6hdl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75830",
    "slug": "circuit-tetris",
    "title": "Circuit Tetris",
    "description": "Energize your brain with Circuit Tetris! In this innovative puzzle arcade game, blocks arent just shapes&mdash;they are vital components of a massive circuit board. As pieces descend, you must rotate and strategically place them to create a continuous path of electricity. How to Play: Connect: Build a path from the glowing power strip on the left to the terminal on the right. Power Up: Pieces automatically glow with neon green light when they are successfully connected to the power source. Clear &amp; Score: Completing a circuit clears all powered blocks, rewarding you with points and making room for more components. Combo: Use gravity to your a",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/s17uidalc58vk7yt4locd8khvfd6mzeq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s17uidalc58vk7yt4locd8khvfd6mzeq/",
    "sourceUrl": "https://html5.gamemonetize.com/s17uidalc58vk7yt4locd8khvfd6mzeq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75790",
    "slug": "airplane-battle9",
    "title": "Airplane Battle9",
    "description": "Game Description: Airplane Battle - Epic Aerial Combat Adventure Title: Airplane Battle Description: Prepare for an adrenaline-fueled aerial combat experience in Airplane Battle! Take control of a powerful fighter jet and embark on an intense mission to survive waves of enemy aircraft, defeat massive bosses, and climb the global leaderboard. With stunning visuals, explosive action, and strategic gameplay, this is the ultimate arcade shooter experience! Key Features: Dual Game Modes: Play solo or team up with a friend in exciting two-player mode Precision Controls: Responsive keyboard controls for expert maneuvering and targeting Dynamic Combat System: Multiple weapon types with unique firing patterns Progressive Challenge: Increasing difficulty levels with smarter enemy AI Power-Up System: Collect energy orbs to restore health and gain advantages Epic Boss Battles: Face gigantic boss enemies with multiple attack phases Comprehensive Stats: Track scores, e",
    "instructions": "anonymous2026",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "2D",
      "blocky",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/az33r2vbdm7bi4ky7g6uihbs1qq2a2u7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/az33r2vbdm7bi4ky7g6uihbs1qq2a2u7/",
    "sourceUrl": "https://html5.gamemonetize.com/az33r2vbdm7bi4ky7g6uihbs1qq2a2u7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75735",
    "slug": "lil-cowboy-treasure-hunt",
    "title": "Lil Cowboy:Treasure Hunt",
    "description": "Welcome to Lil Cowboy: Treasure Hunt! A fun and addictive gem matching puzzle game set in the wild west. Embark on an epic adventure as a brave cowboy in search of hidden treasures, rare gems, and gold! Explore beautiful wild west landscapes Collect valuable gems and golden treasures Complete challenging puzzle quests Match 3 or more gems to score points Compete for high scores and achievements Get ready for an exciting journey full of fun, puzzles, and western adventure!",
    "instructions": "Desktop Mouse click Mobile Touch down",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Bomb",
      "Click",
      "Match 3",
      "Top Down"
    ],
    "thumbnail": "https://img.gamemonetize.com/55ad86ncj3wmgtjalsmm61a2r4myf5lx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/55ad86ncj3wmgtjalsmm61a2r4myf5lx/",
    "sourceUrl": "https://html5.gamemonetize.com/55ad86ncj3wmgtjalsmm61a2r4myf5lx/",
    "width": 640,
    "height": 1136,
    "lastUpdated": ""
  },
  {
    "id": "75730",
    "slug": "1line-one-line-with-only-one-touch",
    "title": "1LINE One Line with Only One Touch",
    "description": "One Line with One Touch is a simple way to get some brain training exercise everyday. This is a great mind challenging game with simple rules. Just try to connect all the dots with only one touch. In this tricky mind game you will find a lot of good brain puzzle packs and a daily challenge. Just a couple of minutes a day with this mind game will help you activate your brain. Enjoy this brain training game at home or at work, at a park or in a bus, in other words everywhere! This One Line with One Touch game doesn&rsquo;t occupy a lot of space on your device and it doesn&rsquo;t drain your battery!",
    "instructions": "use mouse click and slide to play the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Casual",
      "Logic"
    ],
    "thumbnail": "https://img.gamemonetize.com/wan5hiatgeu671k4i4sdqyxp2e2m33pl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wan5hiatgeu671k4i4sdqyxp2e2m33pl/",
    "sourceUrl": "https://html5.gamemonetize.com/wan5hiatgeu671k4i4sdqyxp2e2m33pl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75708",
    "slug": "chain-n-gain",
    "title": "Chain n Gain",
    "description": "Try this cute casual puzzle game. Connect matching items in chains for explosive combos! Every move shifts the board: cleared chains make blocks fall, and the bottom row vanishes, keeping gameplay fast and dynamic. Unleash power-ups like bombs, rockets, rainbows, and more! They trigger automatically when adjacent to your chain, sparking dazzling chain reactions. But watch out for obstacles &mdash; plan moves ahead! Chain them up and gain points &mdash; good luck!",
    "instructions": "Tap and drag nbsp across matching items to form a chain mdash horizontally vertically or even diagonally This earns you points and helps complete the level goals collect the required number of specific items",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Casual",
      "Collecting",
      "Highscore",
      "Kid",
      "Kids",
      "Level",
      "Levels",
      "Logic",
      "Matching",
      "Mobile",
      "Puzzle",
      "Relaxation",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/v2vzj8edjgg1fqh9mumdtbpjsokhsh8y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v2vzj8edjgg1fqh9mumdtbpjsokhsh8y/",
    "sourceUrl": "https://html5.gamemonetize.com/v2vzj8edjgg1fqh9mumdtbpjsokhsh8y/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75641",
    "slug": "click-to-control-chaos",
    "title": "Click to Control Chaos",
    "description": "Click to Control Chaos is a fast-paced casual game where disorder is your greatest enemy. Colorful objects move wildly across the screen, and every click you make temporarily restores balance&mdash;at a cost. While calming one area, chaos spreads elsewhere, forcing you to think fast and react even faster. With dynamic visuals, smooth animations, and constantly escalating intensity, the game delivers a unique challenge where control is never permanent. Simple to play but hard to survive, Click to Control Chaos tests your reflexes, focus, and ability to manage growing disorder. How long can you keep chaos under control?",
    "instructions": "Click moving objects to calm them down but each action increases chaos elsewhere Keep the chaos meter under control react quickly and survive as long as possible in this fast-paced challenge",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "Arcade",
      "Casual",
      "Crazy",
      "Fun",
      "Funny",
      "Geometry",
      "Hypercasual",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/eeyrgjj9waju3avx74x7catauqa2ddkv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eeyrgjj9waju3avx74x7catauqa2ddkv/",
    "sourceUrl": "https://html5.gamemonetize.com/eeyrgjj9waju3avx74x7catauqa2ddkv/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75565",
    "slug": "hamada-yed7ak",
    "title": "Hamada Yed7ak",
    "description": "Hamada Yed7ak is a humorous parody trivia game! Test your knowledge of pop culture icons by matching the correct smile to the famous face. This hyper-casual challenge features 15 levels of celebrity caricatures and funny moments. Can you recognize them all?",
    "instructions": "Use your mouse PC or tap the screen Mobile to select the correct option",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Funny",
      "HTML5",
      "html5 games",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/lchmf6hrx6xqxwv03mr3f8sqwypus9ds/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lchmf6hrx6xqxwv03mr3f8sqwypus9ds/",
    "sourceUrl": "https://html5.gamemonetize.com/lchmf6hrx6xqxwv03mr3f8sqwypus9ds/",
    "width": 600,
    "height": 900,
    "lastUpdated": ""
  },
  {
    "id": "75465",
    "slug": "color-ball-rush",
    "title": "Color Ball Rush",
    "description": "Color Ball Rush is a fun and addictive arcade ball game where you merge numbered balls to grow bigger and reach the ultimate goal of 2048. Swipe and control the ball with smooth one-touch controls, combine balls of the same number, and watch them increase in value while changing vibrant colors. Avoid obstacles, stay on the track, and test your reflex and timing skills in this fast-paced endless rush. Easy to play for kids, yet challenging to master, Color Ball Rush rewards skill, speed, and smart merges. Can you create the rainbow 2048 ball?",
    "instructions": "Mouse click or hold the left button or swap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Avoid",
      "Ball",
      "Casual",
      "Collecting",
      "Color",
      "endless",
      "Football",
      "Obstacle",
      "run",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/u5b9ap487uwgrlgx6nep6ky8xlsl4z5n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u5b9ap487uwgrlgx6nep6ky8xlsl4z5n/",
    "sourceUrl": "https://html5.gamemonetize.com/u5b9ap487uwgrlgx6nep6ky8xlsl4z5n/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75866",
    "slug": "stardom-alt-girls-fashion-duel",
    "title": "Stardom Alt Girls Fashion Duel",
    "description": "Welcome to the world of daring alternative glamour! Meet two star heroines - Sydney and Sabrina. Help them go beyond the usual and try on the most daring alternative images: from a gentle soft-grunge princess to a gloomy rock diva. In the game, you can make bright makeup with arrows and sparkles; create unusual hairstyles; collect memorable outfits from tops, corsets, mini skirts and oversized jackets. Create your own collection of stunning Alt-girl looks!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girl",
      "Hair",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/qpmfzipxdely2cbmw6hl3p70udmj9ug4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qpmfzipxdely2cbmw6hl3p70udmj9ug4/",
    "sourceUrl": "https://html5.gamemonetize.com/qpmfzipxdely2cbmw6hl3p70udmj9ug4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75860",
    "slug": "hunting-master",
    "title": "Hunting Master",
    "description": "A strategic hunting game where power decides victory! Choose your wolf targets and compare your attack power with them&mdash;defeat enemies with higher strength and recruit them into your hunting team instantly! Gather powerful wolves, upgrade your total attack, and challenge stronger prey step by step. Easy to play, strategic to win, build your ultimate hunting pack and become the true master of the wild!",
    "instructions": "Tap to select prey and check attack power Tap to confirm and start the battle Defeated prey join your team automatically Tap to upgrade your team rsquo s total attack power Swipe to switch hunting areas for more targets",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Battle",
      "Brain",
      "Jumping",
      "Logic",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/xrhpm0aosdupn3p29z65gtripmcj6p9u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xrhpm0aosdupn3p29z65gtripmcj6p9u/",
    "sourceUrl": "https://html5.gamemonetize.com/xrhpm0aosdupn3p29z65gtripmcj6p9u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75857",
    "slug": "ant-food-guider",
    "title": "Ant food guider",
    "description": "In Ant Food Guider, lead your colony to survival and growth by finding the best food sources in a dynamic, miniature world. Navigate tricky terrain, avoid predators, and collect various food types to strengthen your ants. Strategically manage your colony, assigning workers to different tasks while expanding tunnels and gathering resources. Each decision impacts your colony&rsquo;s success. With colorful environments, challenging obstacles, and addictive gameplay, Ant Food Guider offers a tiny world full of strategy, adventure, and relentless ant action.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Food"
    ],
    "thumbnail": "https://img.gamemonetize.com/kb8ijkr5bzhr0f0goy9n2me9g2xxy0vy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kb8ijkr5bzhr0f0goy9n2me9g2xxy0vy/",
    "sourceUrl": "https://html5.gamemonetize.com/kb8ijkr5bzhr0f0goy9n2me9g2xxy0vy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75851",
    "slug": "among-crowds",
    "title": "Among Crowds",
    "description": "Players start as small crewmates in a crowded space station. The goal is to collect items scattered across the map to grow in size and strength. As your crewmates grow, you can consume smaller crewmates and absorb their crewmates, becoming even larger and more powerful. Strategic growth and hiding are key&mdash;avoid larger crewmates while planning to eat weaker ones.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      "3D",
      "Arcade",
      "Impostor"
    ],
    "thumbnail": "https://img.gamemonetize.com/pucl6gicgb64omchz44vge9297ug5hkt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pucl6gicgb64omchz44vge9297ug5hkt/",
    "sourceUrl": "https://html5.gamemonetize.com/pucl6gicgb64omchz44vge9297ug5hkt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75732",
    "slug": "sudoku-for-bro",
    "title": "Sudoku for bro",
    "description": "Sudoku Puzzle Game Sudoku is a classic logic-based puzzle game designed to challenge your brain and improve your concentration. The goal is simple: fill the 9&times;9 grid so that every row, column, and 3&times;3 sub-grid contains all numbers from 1 to 9 without repetition. This game features multiple difficulty levels, making it perfect for both beginners and experienced Sudoku players. Use hints when you get stuck, check your progress for mistakes, or solve the puzzle instantly if you want to learn the solution. The game is fully responsive and works smoothly on desktop and mobile devices. Advertisements are seamlessly integrated and automatically p",
    "instructions": "Mouse Touch Click or tap on any empty cell to select it Keyboard 1 ndash 9 Type a number from 1 to 9 to fill the selected cell Backspace Delete Remove the number from the selected cell Hint Button Watch an advertisement to receive a correct h",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2026 games",
      "2D",
      "Punch",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/g7lmh7ajnq66in7fpkya8rfha02lj9rk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g7lmh7ajnq66in7fpkya8rfha02lj9rk/",
    "sourceUrl": "https://html5.gamemonetize.com/g7lmh7ajnq66in7fpkya8rfha02lj9rk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75745",
    "slug": "coookie-clicker",
    "title": "Coookie Clicker",
    "description": "Cookie Clicker is an addictive idle clicker game where you bake delicious cookies! Click the giant cookie to earn cookies, then use them to buy upgrades that automatically produce more cookies for you. Unlock powerful upgrades like Cursors, Grandmas, Farms, Factories, Mines, Shipments, Alchemy Labs, Portals, and Time Machines. Each upgrade increases your cookie production, allowing you to earn cookies even when youre not clicking. Watch ads to earn bonus cookies and boost your progress. How many cookies can you bake? Compete with friends and see who can become the ultimate cookie baker!",
    "instructions": "Click Tap on the cookie to bake cookies Click Tap on upgrades to purchase them Click Tap Watch Ad for 100 Cookies button for bonus cookies Click Tap Reset button to restart the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io",
      "1 Player",
      "2025 games",
      "2026 games",
      "Android",
      "Click",
      "Clicker",
      "Cool",
      "HTML",
      "html5 games",
      "Hypercasual",
      "iPad",
      "Relaxation",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/8bc4oqlcyjxtpked5i52imxap3k7dizq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8bc4oqlcyjxtpked5i52imxap3k7dizq/",
    "sourceUrl": "https://html5.gamemonetize.com/8bc4oqlcyjxtpked5i52imxap3k7dizq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75727",
    "slug": "coloring-games-color-paint",
    "title": "Coloring Games: Color Paint",
    "description": "Kids love fun coloring games, and this Coloring Game is one of the best free coloring book and painting apps for children! Coloring Games is filled with fun, colorful, and creative drawing and painting tools that help kids of all ages enjoy creating art on your mobile device. There are multiple modes the whole family can enjoy, including paint by numbers, color by numbers, doodling modes, and free coloring books of all types. Whether your kid is a toddler or a preschooler, theyre bound to have fun with this free coloring game! Coloring Games was built specifically for children. It has an easy to understand interface kids as young as one ye",
    "instructions": "Mouse click to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Coloring",
      "Drawing",
      "Educational"
    ],
    "thumbnail": "https://img.gamemonetize.com/c6zmltfn7ojlpubizxkt3c4vul7e38p7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c6zmltfn7ojlpubizxkt3c4vul7e38p7/",
    "sourceUrl": "https://html5.gamemonetize.com/c6zmltfn7ojlpubizxkt3c4vul7e38p7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75059",
    "slug": "chill-tic-tac-toe",
    "title": "Chill Tic Tac Toe",
    "description": "Chill Tic Tac Toe is a relaxing version of the classic tic-tac-toe game, designed to be played solo or with friends. Simple, fast, and pressure-free, it&rsquo;s perfect for passing the time, training your logic, or enjoying casual matches anytime.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2 Player",
      "2D",
      "Arcade",
      "Casual",
      "HTML5",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/b8gqu4gigikglll72mvaizxi2elbucg1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b8gqu4gigikglll72mvaizxi2elbucg1/",
    "sourceUrl": "https://html5.gamemonetize.com/b8gqu4gigikglll72mvaizxi2elbucg1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75811",
    "slug": "bubble-shooter-crystal-hunt",
    "title": "Bubble Shooter Crystal Hunt",
    "description": "Bubble Shooter Crystal Hunt is an exciting endless bubble-shooting puzzle game where players must collect specific target bubbles along with rare magical crystals that appear among the bubbles. Aim carefully and match three or more bubbles of the same color to clear space while the bubble wall slowly moves toward the border line, increasing tension with every shot. Crystals are hidden within bubble clusters and must also be collected to progress and boost scores.",
    "instructions": "Using a mouse or touchpad aim the bubble launcher and match three same-color bubbles to pop them while collecting hidden crystals for extra score Stop the rising bubble wall with smart shots and boosters to survive longer",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Bubble",
      "Bubble Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/6euixp28beis8nvccl5orcr8od27eo15/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6euixp28beis8nvccl5orcr8od27eo15/",
    "sourceUrl": "https://html5.gamemonetize.com/6euixp28beis8nvccl5orcr8od27eo15/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "75380",
    "slug": "president-2048",
    "title": "President 2048",
    "description": "President 2048 is a fun puzzle game featuring U.S. presidents. Merge tiles from Biden (#46) back to Washington (#1). A perfect blend of classic 2048 gameplay and American history. Can you reach the founding father?",
    "instructions": "Swipe or use arrow keys to move tiles Merge same presidents to go back in history Reach Washington to win",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/fvj6cqgeutu1o8t5lbjd7c4dkrtpuzag/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fvj6cqgeutu1o8t5lbjd7c4dkrtpuzag/",
    "sourceUrl": "https://html5.gamemonetize.com/fvj6cqgeutu1o8t5lbjd7c4dkrtpuzag/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75115",
    "slug": "gravity-dunk",
    "title": "Gravity Dunk",
    "description": "Experience a modern, 3D twist on a classic arcade challenge in Flappy Dunk! Take control of a basketball and navigate through a series of increasingly difficult hoops. The game features a variety of power-ups to help you climb the leaderboard, including Shields to protect against collisions, Speed Boosts (Slow Motion) to navigate tight spots, and Stars for double points. Customize your experience with multiple ball skins, from classic orange to shimmering gold. Precision is key: guide the ball through the center of the hoopto score, but be careful:hitting the ring or missing a hoop will end your run. Track your progress with a detailed stats",
    "instructions": "Jump PC Press SPACE Up Arrow uarr or X Jump Mobile Touch Tap the screen Pause Press ESC or tap the on-screen Pause button Menu Navigation Use your mouse or touch to select buttons and skins",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Adventure",
      "crazygamesunblocked",
      "endless",
      "flappybird",
      "fly",
      "Sport",
      "unblocked games",
      "unblockedgames66",
      "unblockedgamesatschool"
    ],
    "thumbnail": "https://img.gamemonetize.com/ugcxyptqcduillvqeijgcfsx9i9hx2z4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ugcxyptqcduillvqeijgcfsx9i9hx2z4/",
    "sourceUrl": "https://html5.gamemonetize.com/ugcxyptqcduillvqeijgcfsx9i9hx2z4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75390",
    "slug": "makeup-run-challenge",
    "title": "Makeup Run Challenge",
    "description": "Run, collect, and style in the Makeup Run Challenge! Help girls complete their makeover by picking up makeup items, accessories, and fashion upgrades while racing through fun obstacle tracks. Test your speed, reflexes, and fashion sense as you dodge obstacles and finish the run with a perfect look. Play this exciting princess, fashion, dress-up, makeup, makeover, running, fun, girls&rsquo; game, and enjoy colorful levels filled with surprises. Become the ultimate fashion star by completing the makeover and crossing the finish line in style!",
    "instructions": "Tap Left Mouse Click or Swipe amp Hold",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Best Games",
      "Collecting",
      "Dress Up",
      "Fashion",
      "Girls",
      "Kids",
      "Makeover",
      "Obstacle",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/01m0k1f0lxiqr4jm937k05p5vij81tzc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/01m0k1f0lxiqr4jm937k05p5vij81tzc/",
    "sourceUrl": "https://html5.gamemonetize.com/01m0k1f0lxiqr4jm937k05p5vij81tzc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75491",
    "slug": "skyatoms",
    "title": "SkyAtoms",
    "description": "SkyAtoms is a light, educational, and fast-climbing arcade game where science meets the sky. Each cloud drifting upward carries an atomic symbol from the periodic table&mdash;H, O, Na, Cl, and many more. Your mission is to jump from one cloud to the next, climbing higher and higher while recognizing and reacting to the elements that appear. Timing is everything. Tap to leap, land safely, and choose the right cloud before it floats away. Some clouds move, some fade, and some drop quickly, turning each jump into a race against gravity. As you rise, new element symbols appear, helping players learn and familiarize themselves with the periodic table i",
    "instructions": "Tap to begin",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Science",
      "Skill",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/9zem99d2z2j0ymj028dlx7qt0i53b9qi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9zem99d2z2j0ymj028dlx7qt0i53b9qi/",
    "sourceUrl": "https://html5.gamemonetize.com/9zem99d2z2j0ymj028dlx7qt0i53b9qi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75817",
    "slug": "street-mayhem-driver",
    "title": "Street Mayhem Driver",
    "description": "Street Mayhem Driver is a fast-paced arcade driving survival game where chaos rules the streets. Choose your difficulty and race through endless neon-lit city roads filled with traffic, hazards and relentless police chases. The longer you survive, the faster and more dangerous the streets become. One mistake ends the run. No story, no limits &mdash; just pure speed, reflex and nonstop action designed for quick, addictive gameplay sessions.",
    "instructions": "Steer your car through busy city streets avoid traffic and escape the police Choose your difficulty and survive as long as possible in nonstop arcade action Move A D Or Arrow Keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Car",
      "Cars",
      "Casual",
      "Driving",
      "Fun",
      "Funny",
      "Hypercasual",
      "Race",
      "Racing",
      "Road",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/3vet59sqg87hj5mhbwzy711v06ywtkvg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3vet59sqg87hj5mhbwzy711v06ywtkvg/",
    "sourceUrl": "https://html5.gamemonetize.com/3vet59sqg87hj5mhbwzy711v06ywtkvg/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75816",
    "slug": "professional-archerist",
    "title": "Professional Archerist",
    "description": "Professional Archerist is a fast-paced skill game where precision meets momentum. You never stand still: run, slide, jump, and pivot while lining up perfect shots. Targets appear at different heights, angles, and speeds, forcing you to adapt on the move. Timing, focus, and smooth movement matter more than raw power. Chain hits, keep your rhythm, and master control under pressure as arenas push your mobility and accuracy to the limit. Perfect runs demand awareness, consistency, and nerves of steel always.",
    "instructions": "click to interact",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Shoot",
      "Shoot 'Em Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/1gmlwex83wbif4eup1dzztmh1b6bqb4y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1gmlwex83wbif4eup1dzztmh1b6bqb4y/",
    "sourceUrl": "https://html5.gamemonetize.com/1gmlwex83wbif4eup1dzztmh1b6bqb4y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75694",
    "slug": "luggage-collect-game",
    "title": "Luggage Collect Game",
    "description": "Luggage Collect is an exciting and fast-paced arcade game that tests your focus, speed, and decision-making skills. Your mission is simple but challenging: collect the correct luggage at the right time and avoid mistakes. As the game progresses, the speed increases, making each level more intense and fun. Stay alert, react quickly, and prove your skills as you move through increasingly difficult stages. With smooth controls and engaging gameplay, Luggage Collect keeps players hooked for hours.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "airplane",
      "amazing",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/s405yfxbykcwuzt0ehk8201p61txwosp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s405yfxbykcwuzt0ehk8201p61txwosp/",
    "sourceUrl": "https://html5.gamemonetize.com/s405yfxbykcwuzt0ehk8201p61txwosp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75500",
    "slug": "roll-dice-mob-control",
    "title": "Roll Dice Mob Control",
    "description": "Roll Dice Mob Control is an action-packed tower defense experience where every dice roll grows your mob and boosts your power. Aim, roll, and multiply your crowd as you pass through gates, overcome obstacles, and overpower enemy bases. Deploy powerful units, control massive mobs, and make smart choices to conquer each level. With fast-paced battles, satisfying crowd growth, and rewarding progression, this hyper-casual game challenges your timing, strategy, and control skills. Lead your army, dominate the battlefield, and rise to victory!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Army",
      "Battle",
      "Battlegrounds",
      "Casual",
      "Fight",
      "Hypercasual",
      "Multiplayer",
      "Stickman",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/srd7e29jfjc8yqa211dk9j8dqwbc0tl1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/srd7e29jfjc8yqa211dk9j8dqwbc0tl1/",
    "sourceUrl": "https://html5.gamemonetize.com/srd7e29jfjc8yqa211dk9j8dqwbc0tl1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75202",
    "slug": "epic-robot-combat-simulator",
    "title": "Epic Robot Combat Simulator",
    "description": "Hop onto your Combat Suit, prepare your weaponry, and hunt down all your enemies all over space! Are you skilled enough as a Mech Pilot? Find out now!",
    "instructions": "Desktop WASD Move around Number keys Change weapon Shift Dash Mouse Aim and Shoot Mobile Left Joystick Move around Right Joystick Aim and Shoot Use the buttons on the bottom right to switch weapons or dash",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Anime",
      "Avoid",
      "Flight",
      "Robot",
      "Skill",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/drwtgu2s2y4q3n4ehbmcswtdk2hove1h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/drwtgu2s2y4q3n4ehbmcswtdk2hove1h/",
    "sourceUrl": "https://html5.gamemonetize.com/drwtgu2s2y4q3n4ehbmcswtdk2hove1h/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75808",
    "slug": "starforge-boss-rush",
    "title": "STARFORGE BOSS RUSH",
    "description": "STARFORGE BOSS RUSH is an epic sci-fi boss rush shooter where you control a fast spaceship and battle massive bosses, one per level. Fire with click/touch, dodge intense projectile patterns, and survive multi-phase fights. The game features smooth transitions, cinematic visual effects, responsive controls, and a thrilling space atmosphere with action-packed battles. Developer web: poki76.com",
    "instructions": "Control the ship with mouse touch hold click touch to shoot",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Ai Games",
      "amazing",
      "Arcade",
      "Shooting",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/9got0qzcuj1mrt3l4ij658gacib1mujs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9got0qzcuj1mrt3l4ij658gacib1mujs/",
    "sourceUrl": "https://html5.gamemonetize.com/9got0qzcuj1mrt3l4ij658gacib1mujs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75812",
    "slug": "lifebuoy-planing",
    "title": "Lifebuoy Planing",
    "description": "Lifebuoy Planing is an arcade-style action game where you become a flying lifebuoy. You slide through fast, twisting slides, build speed, and launch into open water at the end. Momentum, angles, and timing decide how far and how well you fly across the waves. Perform daring launches, avoid obstacles, and master each slide&rsquo;s layout. Simple controls meet skill-based physics, creating satisfying runs that reward precision, speed, and perfect launches every time. Push limits, chase distance records, and refine every run.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "Fun",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/2pknxcw969p6jbs0ui0jm42dgr5mtd6x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2pknxcw969p6jbs0ui0jm42dgr5mtd6x/",
    "sourceUrl": "https://html5.gamemonetize.com/2pknxcw969p6jbs0ui0jm42dgr5mtd6x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75815",
    "slug": "trishift",
    "title": "Trishift",
    "description": "About the Game Shiftrix is a fast-paced action survival game where players switch between different shapes to survive enemy waves. Each shape has a unique ability, and choosing the right shape at the right time is the key to winning. The game focuses on reflexes, decision-making, and timing, making every fight intense and rewarding. Characters / Shapes You control one character that can shift into three forms: Circle (Speed Form) Square (Defense Form) Triangle (Damage Form) Game Modes Survival Mode &ndash; Endless waves with increasing difficulty Escape Mode &ndash; High-speed survival with time pressure and special abilities",
    "instructions": "Controls Keyboard PC W A S D Arrow Keys ndash Move Q ndash Circle Speed E ndash Square Defense R ndash Triangle Damage Space ndash Ultimate Ability Shift ndash Dash if unlocked Q ndash Shield if unlocked E Hold ndash Slow",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Action",
      "attack",
      "Battle"
    ],
    "thumbnail": "https://img.gamemonetize.com/pki5oeqfqj1sjufc9l2zz1rrwzlmwvve/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pki5oeqfqj1sjufc9l2zz1rrwzlmwvve/",
    "sourceUrl": "https://html5.gamemonetize.com/pki5oeqfqj1sjufc9l2zz1rrwzlmwvve/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75800",
    "slug": "iron-smash",
    "title": "IRON SMASH",
    "description": "Swing a massive iron flail to crush waves of enemies in this chaotic physics-based survival game! IRON SMASH is an intense physics-based arcade game where you wield a heavy iron ball attached to a dynamic chain. Use your mouse to build momentum and swing your weapon to smash through relentless waves of geometric enemies. Every enemy you destroy drops XP, letting you level up and choose from powerful random upgrades&mdash;make your ball massive, extend your chains reach, or turn into a speed demon. Master the physics of the flail to trigger explosive combos and survive as long as possible!",
    "instructions": "pc mouse and mobile finger",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Action",
      "Arcade",
      "Ball",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/wf42ep9hw8py43cv4h4vgorep74ylimk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wf42ep9hw8py43cv4h4vgorep74ylimk/",
    "sourceUrl": "https://html5.gamemonetize.com/wf42ep9hw8py43cv4h4vgorep74ylimk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75609",
    "slug": "stack-ball-run",
    "title": "Stack Ball Run",
    "description": "Stack Ball Run is a fast-paced arcade runner game. Drag left and right to collect coins and build your ball stack. Avoid dangerous obstacles that reduce your stack. The game speed increases over time, making it more challenging. Try to survive as long as possible and achieve the highest score.",
    "instructions": "Mouse Touch Drag left and right to move Keyboard Arrow Left Arrow Right or A D keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Ball",
      "Casual",
      "endless",
      "running",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/yjosrj4strdm6y5ksyo4b5k3cx5nvl7q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yjosrj4strdm6y5ksyo4b5k3cx5nvl7q/",
    "sourceUrl": "https://html5.gamemonetize.com/yjosrj4strdm6y5ksyo4b5k3cx5nvl7q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75335",
    "slug": "kpop-hunter-coloring",
    "title": "kpop hunter coloring",
    "description": "Try our kpop coloring game for hunter demon and enjoy it with your friends Kpop Hunter Coloring Demon game is an educational drawing and coloring dash book and one of the best coloring game for Zoey, Mira, and Rumi characters. A collection of cool, K-Pop-inspired characters to color for Boys and Girls to paint pictures correctly using the right colors. This free Kpop Hunter coloring books game let you provide enjoyable time and relax stress of day. Also coloring pages sneaky Saja Boys and enjoy Rumis fierce battles to Jinus rival vibes.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Coloring"
    ],
    "thumbnail": "https://img.gamemonetize.com/skvcbifszj2pg45k2dnlps9o6y7q96ho/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/skvcbifszj2pg45k2dnlps9o6y7q96ho/",
    "sourceUrl": "https://html5.gamemonetize.com/skvcbifszj2pg45k2dnlps9o6y7q96ho/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75318",
    "slug": "math-speedrunner",
    "title": "Math Speedrunner",
    "description": "Are you a Math genius? Your math skills include high speed?? Math Speedrunner is the game for you!!! Developed in 2025 by FLGames",
    "instructions": "click on the right answer",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/2vi3lvdqlpjamctznn58kidaqiz8u2c1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2vi3lvdqlpjamctznn58kidaqiz8u2c1/",
    "sourceUrl": "https://html5.gamemonetize.com/2vi3lvdqlpjamctznn58kidaqiz8u2c1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74961",
    "slug": "pop-the-fruits",
    "title": "Pop the Fruits",
    "description": "Dive into the juicy world of fruity fun! In this exciting game, youll be shooting vibrant bubbles that are actually... fruits! Lush oranges, sweet strawberries, juicy watermelons, and other delicious treats await you. Shoot fruits, create combos, and savor the sweet taste of victory! Who knew playing with food could be this thrilling?",
    "instructions": "Hold on the screen to aim your fruits direction Release your mouse or finger to launch the fruit Match 3 or more identical fruits to clear them from the board Earn score boosts by chaining multiple combos in a row Don rsquo t let the fruits reach",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Best Games",
      "Bubble",
      "Bubble Shooter",
      "Casual",
      "Classic",
      "free html5 games for your website",
      "Fruit",
      "Fruits",
      "Highscore",
      "Hypercasual",
      "Mobile",
      "Relaxation",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/qei772c5h953fgjo7qgtpbms1jfvwhem/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qei772c5h953fgjo7qgtpbms1jfvwhem/",
    "sourceUrl": "https://html5.gamemonetize.com/qei772c5h953fgjo7qgtpbms1jfvwhem/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74586",
    "slug": "best-2048",
    "title": "best 2048",
    "description": "2048 is a simple yet incredibly addictive puzzle game that challenges your logic, planning, and reflexes. The goal is straightforward: slide numbered tiles across a 4&times;4 grid to combine matching numbers and create increasingly larger values. When two tiles with the same number collide, they merge into a new tile with double the value &mdash; 2 becomes 4, 4 becomes 8, 8 becomes 16, and so on. Your ultimate mission is to reach the legendary 2048 tile, but the real challenge is keeping the board from filling up before you get there. Every move shifts all tiles in the chosen direction, creating new opportunities but also new obstacles. A single swipe",
    "instructions": "How to Play 2048 ndash Controls Arrow Keys on keyboard or Swipe Gestures on mobile Up Slide all tiles upward Down Slide all tiles downward Left Slide all tiles to the left Right Slide all tiles to the right Each move pushes all tiles in that d",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2 Player",
      "2025 games",
      "2048",
      "2D",
      "Air",
      "Dragon Ball Z"
    ],
    "thumbnail": "https://img.gamemonetize.com/4c2cjjktqgb26m295uggrcf7htlaaqdz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4c2cjjktqgb26m295uggrcf7htlaaqdz/",
    "sourceUrl": "https://html5.gamemonetize.com/4c2cjjktqgb26m295uggrcf7htlaaqdz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73924",
    "slug": "jingle-drop-challenge",
    "title": "Jingle Drop Challenge",
    "description": "Jingle Drop Challenge &ndash; Game Description In Jingle Drop Challenge, Santa needs your quick reflexes to save Christmas! Gifts are tumbling from the sky, and it&rsquo;s up to you to tap each falling present before it hits the ground. Every successful tap helps Santa collect the gift and boosts your score, but miss too many and the holiday magic begins to fade! As the game speeds up, the drops get faster, the pressure rises, and only the sharpest players can keep up with the festive frenzy. With cheerful sound effects, snowy visuals, and nonstop action, Jingle Drop Challenge delivers a joyful, fast-paced holiday experience for all ages.",
    "instructions": "Click over to collect gift",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Christmas",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/hnid8dscyy94b6ziyg9krdroabne6hfg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hnid8dscyy94b6ziyg9krdroabne6hfg/",
    "sourceUrl": "https://html5.gamemonetize.com/hnid8dscyy94b6ziyg9krdroabne6hfg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75687",
    "slug": "domino-smashfall",
    "title": "Domino Smashfall",
    "description": "Welcome to Domino Smashfall, a colorful and calming domino game where matching tiles brings pure satisfaction. Enjoy relaxing domino puzzles filled with smooth gameplay, smart challenges, and rewarding progress. Match falling domino tiles, plan your moves carefully, and complete creative board layouts to earn coins and unlock new levels. Each level offers a fresh puzzle that blends strategy with relaxation, making it perfect for quick breaks or long play sessions. With soothing visuals, satisfying tile effects, and endless domino challenges, Domino Smashfall is the ultimate arcade-style board game to unwind, focus, and enjoy stress-free fun.",
    "instructions": "Hold Left Mouse Click to aim",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Action",
      "Arcade",
      "Ball",
      "Casual",
      "Color",
      "Fun",
      "Physics",
      "Skill",
      "smash",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/89rxw3b3omgfq1ley4myrvjwqup7bkkg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/89rxw3b3omgfq1ley4myrvjwqup7bkkg/",
    "sourceUrl": "https://html5.gamemonetize.com/89rxw3b3omgfq1ley4myrvjwqup7bkkg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75692",
    "slug": "challenge-the-zombies",
    "title": "Challenge the zombies",
    "description": "Challenge The Zombies ek action packed aur thrilling zombie shooting game hai jisme aapko dangerous zombies ke against fight karna hota hai. Is game me aap ek brave survivor ban kar apni weapons skills use karte hain aur zombie apocalypse se duniya ko save karte hain. Har level me zombies aur zyada powerful hote jate hain, aur aapko apni strategy aur fast shooting reflexes se survive karna hota hai. Ye game intense missions, exciting gameplay aur nonstop action se bhara hua hai. Agar aapko zombie survival games, shooting action games, aur offline zombie attack games pasand hain to Challenge The Zombies aapke liye best choice hai.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "amazing",
      "Funny",
      "Shooting",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/8xsm75r8jqigepm8fpihn8326rlgpxw5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8xsm75r8jqigepm8fpihn8326rlgpxw5/",
    "sourceUrl": "https://html5.gamemonetize.com/8xsm75r8jqigepm8fpihn8326rlgpxw5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75078",
    "slug": "bubbla-boing",
    "title": "Bubbla Boing",
    "description": "Classic breakout gameplay Multiple levels Power-ups and bonuses Smooth paddle control Progressive difficulty Destroy all bubbles by bouncing the ball off your paddle. Dont let the ball fall off the screen! Clear all levels to achieve the highest score!",
    "instructions": "Space Bar - Shoot Ball Arrow Keys - Move paddle left right",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Arkanoid",
      "Bricks",
      "Bubble",
      "Classic"
    ],
    "thumbnail": "https://img.gamemonetize.com/fjcrggqqgf94v2afh0pilf495c357j78/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fjcrggqqgf94v2afh0pilf495c357j78/",
    "sourceUrl": "https://html5.gamemonetize.com/fjcrggqqgf94v2afh0pilf495c357j78/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "75282",
    "slug": "slime-run",
    "title": "Slime Run",
    "description": "Sime Run is a fun action game where you control a Slime sliding quickly across the arena to color your territory. Competing directly with other Slimes, you need to move skillfully and occupy as much colored space as possible to win. Fast-paced, simple yet dramatic rules, Sime Run offers exciting and entertaining competitions.",
    "instructions": "Use arrow button to move",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Color",
      "Fun",
      "Monster",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/xev0z6srg4q342zrorz0hhwoxn0evfyg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xev0z6srg4q342zrorz0hhwoxn0evfyg/",
    "sourceUrl": "https://html5.gamemonetize.com/xev0z6srg4q342zrorz0hhwoxn0evfyg/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75649",
    "slug": "pentablocks",
    "title": "Pentablocks",
    "description": "Pentablocks is an intense bullet-hell dodging game channeling Slopes infamous red blocks and Undertale-style battle evasion. Maneuver your dot with precise WASD controls through endless barrages of sharp pentagonal red obstacles in a neon void. Survive escalating patterns, chain perfect dodges, unlock modes, and hunt high scores in this pure skill-based, addictive browser reflex tester&mdash;no shooting, just survival.",
    "instructions": "WASD Arrow Keys - Dodge Move in all directions R - Restart level",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2025 games",
      "2D",
      "Arcade",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/9aogv3knwvcc9cm6xs6lk9prepwi1det/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9aogv3knwvcc9cm6xs6lk9prepwi1det/",
    "sourceUrl": "https://html5.gamemonetize.com/9aogv3knwvcc9cm6xs6lk9prepwi1det/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75631",
    "slug": "rainbow-monster-hideout-3d",
    "title": "Rainbow Monster Hideout 3D",
    "description": "Rainbow Monster Hideout 3D is a thrilling survival horror adventure where you must hide, explore, and escape from terrifying rainbow monsters. Trapped inside a creepy hideout, your mission is to survive each night by finding hidden items, completing tasks, and avoiding deadly monsters. Use smart movement, hide in boxes, and cooperate with teammates to finish missions before time runs out. With immersive 3D graphics, spooky sound effects, and intense gameplay, Rainbow Monster Hideout 3D delivers nonstop suspense and fun for horror game lovers.",
    "instructions": "WASD keys or Mouse Swipe to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Adventure",
      "Escape",
      "Hidden",
      "Horror",
      "Kids",
      "Monster",
      "Puzzle",
      "Stealth",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/d74ig27cax8icgtf76iywsqbbv0t3p7f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d74ig27cax8icgtf76iywsqbbv0t3p7f/",
    "sourceUrl": "https://html5.gamemonetize.com/d74ig27cax8icgtf76iywsqbbv0t3p7f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75684",
    "slug": "dandys-world-memory",
    "title": "Dandys World Memory",
    "description": "Test your recall with the colorful crew from Dandy&rsquo;s World! This memory game features 15 progressively challenging levels. Start with a small grid and fewer character pairs. As you advance, face more cards, intricate layouts, and a faster pace. Find all matching pairs of Dandy&rsquo;s iconic characters to clear each level and unlock the next. Perfect your concentration, beat the clock, and prove you&rsquo;ve got the memory to master Dandys universe!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Casual",
      "Hypercasual",
      "Memory",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/pr5nwfnvggs5shod03bntsbju8pay0p5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pr5nwfnvggs5shod03bntsbju8pay0p5/",
    "sourceUrl": "https://html5.gamemonetize.com/pr5nwfnvggs5shod03bntsbju8pay0p5/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73923",
    "slug": "rabbit-portal",
    "title": "Rabbit Portal",
    "description": "Rabbit Portal is a fast-paced space-timing puzzle game where precision is everything. In the vastness of outer space, a mysterious swirling portal&mdash;nicknamed the Rabbit Portal&mdash;opens and closes unpredictably. Your mission: guide incoming spaceships safely into the portal at exactly the right moment. Ships arrive from different directions, speeds, and patterns. Tap or drag to control their path, avoid collisions, and time their entry perfectly.",
    "instructions": "Press the CORRECT button",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Rabbit",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/u8pn0jz3ig013s8aqo8tormoktr2pda4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u8pn0jz3ig013s8aqo8tormoktr2pda4/",
    "sourceUrl": "https://html5.gamemonetize.com/u8pn0jz3ig013s8aqo8tormoktr2pda4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75759",
    "slug": "star-runner-cosmic-escape",
    "title": "Star Runner: Cosmic Escape",
    "description": "Star Runner: Cosmic Escape is an epic space arcade runner where you steer a sleek ship through a glowing starfield. Collect golden stars to complete each level while dodging dangerous asteroids. Activate Shield and Magnet power-ups to survive longer and grab rewards faster. Face a massive boss asteroid and chase high scores. Developer web: freecrazygames.io",
    "instructions": "Move with mouse or touch use A D or arrows press M",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "ship",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/nc0juh3zxt131xwr578abnq4au7w2nus/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nc0juh3zxt131xwr578abnq4au7w2nus/",
    "sourceUrl": "https://html5.gamemonetize.com/nc0juh3zxt131xwr578abnq4au7w2nus/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75760",
    "slug": "smart-basketball",
    "title": "Smart Basketball",
    "description": "Improve your math skills while playing this basketball brain game! Smart Basketball lets you improve your math while playing basketball! Have fun and learn! Try to get the highest score and educate yourself! If you liked the game, please dont forget to rate it!",
    "instructions": "Shoot a basket at the correct answer",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "Basketball",
      "Math"
    ],
    "thumbnail": "https://img.gamemonetize.com/wb8pk4x05bbysrd1vz7b913mv2kv2xx8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wb8pk4x05bbysrd1vz7b913mv2kv2xx8/",
    "sourceUrl": "https://html5.gamemonetize.com/wb8pk4x05bbysrd1vz7b913mv2kv2xx8/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75700",
    "slug": "neon-abyss-defender",
    "title": "Neon Abyss Defender",
    "description": "War Space Defender is a fast-paced arcade space shooter where you pilot a futuristic starfighter through intense enemy waves. Dodge bullets, survive deadly bombs, and defeat powerful bosses across multiple levels. Earn points, gain extra lives, and chase high scores in a stunning galaxy battlefield with smooth controls and nonstop action. Web Dev <a href='https://www.freecrazygames.io/'>https://www.freecrazygames.io/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Ai Games",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/5hjlk8t2n9g21spgmg3drb5ueyf6situ/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5hjlk8t2n9g21spgmg3drb5ueyf6situ/",
    "sourceUrl": "https://html5.gamemonetize.com/5hjlk8t2n9g21spgmg3drb5ueyf6situ/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75693",
    "slug": "bubble-pet-game",
    "title": "Bubble Pet Game",
    "description": "Welcome to Bubble Pet Game, a colorful and super fun bubble shooting adventure where cute pets need your help! Get ready to enjoy an exciting puzzle journey filled with bright bubbles, adorable animals, and relaxing gameplay. In this addictive bubble shooter puzzle game, your mission is to match and pop bubbles by aiming carefully and clearing the board. Each level brings new challenges, fun obstacles, and rewarding surprises that will keep you entertained for hours. Whether you love casual games, brain puzzles, or pet-themed adventures, Bubble Pet Game is the perfect choice for everyone.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Animal",
      "Bubble Shooter",
      "Fun",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/g4gvh81z7v2ne8bziuh6xrwa43bb8sxd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g4gvh81z7v2ne8bziuh6xrwa43bb8sxd/",
    "sourceUrl": "https://html5.gamemonetize.com/g4gvh81z7v2ne8bziuh6xrwa43bb8sxd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75774",
    "slug": "easy-coloring-spongy-adventure",
    "title": "Easy Coloring Spongy Adventure",
    "description": "Easy Coloring Spongy Adventure is a fun and relaxing HTML5 coloring game made for kids and anyone who loves creative play. Join Spongy on a cheerful adventure filled with cute scenes and simple drawings waiting to be brought to life with color. There&rsquo;s no time limit and no pressure&mdash;just pick your favorite colors, tap to paint, and enjoy a calm, playful coloring experience directly in your browser.",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cartoon",
      "Coloring",
      "Drawing",
      "Fun",
      "Hypercasual",
      "Kids",
      "Spongebob"
    ],
    "thumbnail": "https://img.gamemonetize.com/seszyytvpgq3sg0q47eovcclad4pqdtn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/seszyytvpgq3sg0q47eovcclad4pqdtn/",
    "sourceUrl": "https://html5.gamemonetize.com/seszyytvpgq3sg0q47eovcclad4pqdtn/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "75779",
    "slug": "horrorland-defense",
    "title": "HorrorLand Defense",
    "description": "HorrorLand Defense is a twisted tower-defense game where cute visuals collide with pure nightmare fuel. You must protect your last safe zone by placing strange, living defenders against relentless waves of grotesque monsters emerging from the darkness. Enemies behave unpredictably, triggering sudden scares and eerie moments. Colorful environments mask a disturbing atmosphere beneath. Web Dev <a href='https://www.coolcrazygames.com/'>https://www.coolcrazygames.com/</a> Careful strategy, smart resource management, and fast reactions are essential, because one mistake can let the horror overwhelm everything you&rsquo;re trying to save.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "apocalypse",
      "plants",
      "Shoot 'Em Up",
      "Shooting",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/4b8f0p7mywv18wyele8ovnx5r5fblmm0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4b8f0p7mywv18wyele8ovnx5r5fblmm0/",
    "sourceUrl": "https://html5.gamemonetize.com/4b8f0p7mywv18wyele8ovnx5r5fblmm0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75777",
    "slug": "bull-time-shooter",
    "title": "Bull Time Shooter",
    "description": "A fast-paced action shooter where bulls are the enemy and survival depends on quick reflexes and precise aim. Waves of enraged bulls charge relentlessly, forcing players to shoot, dodge, and reposition constantly. Each encounter escalates in intensity, testing awareness, timing, and accuracy. Web Dev <a href='https://www.crazygamesfree.com/'>https://www.crazygamesfree.com/</a> With simple controls and nonstop pressure, the game delivers pure arcade chaos, rewarding skillful movement and smart target prioritization as the battlefield fills with charging horns and thunderous momentum.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Animal",
      "Bullet",
      "fps",
      "Shooter",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/0htjtxvdh0uzihy64uht28qewz5wfvva/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0htjtxvdh0uzihy64uht28qewz5wfvva/",
    "sourceUrl": "https://html5.gamemonetize.com/0htjtxvdh0uzihy64uht28qewz5wfvva/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75155",
    "slug": "bubble-shooter-pro-2026",
    "title": "Bubble Shooter Pro 2026",
    "description": "Discover the ultimate arcade thrill with Bubble Shooter Pro 2026! Aim, match, and pop colorful bubbles in this addictive puzzle adventure. With dynamic random levels, realistic bouncing physics, and satisfying explosions, every shot counts. Strategy is key&mdash;clear the board before running out of ammo! Featuring vibrant graphics and immersive audio, it is perfect for all ages. Can you reach the top of the leaderboard? Web Dev <a href='https://www.y8.org.es/'>https://www.y8.org.es/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Ai Games",
      "Bubble",
      "Bubble Shooter",
      "Games Ai",
      "Mentolatux",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/zsg33l2d4at66476w4yav19dpxanj4k3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zsg33l2d4at66476w4yav19dpxanj4k3/",
    "sourceUrl": "https://html5.gamemonetize.com/zsg33l2d4at66476w4yav19dpxanj4k3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73964",
    "slug": "bubble-war",
    "title": "Bubble War",
    "description": "Bubble War &ndash; The Ultimate Bubble Shooting Battle! Get ready for an exhilarating bubble-popping experience in Bubble War, the ultimate multiplayer and single-player bubble shooting game! Whether you&rsquo;re looking to challenge yourself in solo mode or compete against players worldwide in real-time battles, Bubble War delivers non-stop action, strategy, and fun! Two Exciting Game Modes: Single-Player Mode: Embark on an adventure through hundreds of challenging levels, each designed to test your accuracy and strategy. Match three or more bubbles of the same color to clear the board and earn powerful boosters. As you progress, you&rsquo;ll encoun",
    "instructions": "Press hold and drag to aim and release to shoot",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player"
    ],
    "thumbnail": "https://img.gamemonetize.com/a2cban0dnfg08ohvnecav8gvxy192zpd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a2cban0dnfg08ohvnecav8gvxy192zpd/",
    "sourceUrl": "https://html5.gamemonetize.com/a2cban0dnfg08ohvnecav8gvxy192zpd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75645",
    "slug": "pixel-flow",
    "title": "Pixel Flow",
    "description": "A fast-paced game about reaction and the right order of actions. Cannons fire at pixel blocks of their matching color, breaking them and clearing the board piece by piece. To beat a level, you&rsquo;ll need to manage the flow of shots, avoid overloading the conveyor, and build combos. Simple to learn, but highly addictive: tap &rarr; flow &rarr; pixels fly.",
    "instructions": "Tap to send a cannon onto the conveyor The cannon fires at pixels of its matching color After a full cycle it moves into a spare slot Slots are limited mdash watch the order Shoot in the right sequence to clear the board",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Logic",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/odrui2f4o5fnjszd4idpd0fudxu41e9w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/odrui2f4o5fnjszd4idpd0fudxu41e9w/",
    "sourceUrl": "https://html5.gamemonetize.com/odrui2f4o5fnjszd4idpd0fudxu41e9w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75702",
    "slug": "hurdle-hero",
    "title": "Hurdle Hero",
    "description": "Hurdle Hero is a fast-paced skill game where you must leap over endless hurdles with perfect timing as one mistake ends the run instantly. It&rsquo;s a simple yet addictive challenge designed for quick reflexes and precision jumps. One wrong move and its game over! Have fun playing this obstacle jumping game only here at crazycubix.com",
    "instructions": "Tap on screen",
    "category": "",
    "genres": [],
    "tags": [],
    "thumbnail": "https://img.gamemonetize.com/s4xgelykf8f1l6vnul84v66aglgg39vc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s4xgelykf8f1l6vnul84v66aglgg39vc/",
    "sourceUrl": "https://html5.gamemonetize.com/s4xgelykf8f1l6vnul84v66aglgg39vc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75703",
    "slug": "online-taxi-simulator",
    "title": "Online Taxi Simulator",
    "description": "Experience the life of a taxi driver in our latest taxi simulator game. Complete different types of driving missions as a taxi or private taxi driver and pick your favorite car from a selection of over 30 amazing vehicles, with more new cars being added weekly. Navigate around huge cities like New York, Miami, Rome or Los Angeles and adjust your driving style to different types of clients - some are in a hurry and don&rsquo;t care if you run a red light, while others are terrified of dangerous driving. We take taxi simulation games to a new level with VIP clients, undecided clients and various types of daily and lifetime milestones. Start your t",
    "instructions": "use arrows key for movement",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "carparking",
      "Simulation",
      "Taxi"
    ],
    "thumbnail": "https://img.gamemonetize.com/dxx6hd8bgffy3onznooyb7ikugv5ilmy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dxx6hd8bgffy3onznooyb7ikugv5ilmy/",
    "sourceUrl": "https://html5.gamemonetize.com/dxx6hd8bgffy3onznooyb7ikugv5ilmy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75509",
    "slug": "bendy-circle",
    "title": "Bendy Circle",
    "description": "Bendy Circle is a light yet challenging puzzle game where you need to untangle all the rubber bands intertwined with each other. Every move requires careful observation and calculation, as just one mistake can make things more complicated. The gameplay is simple and intuitive, but increasingly difficult as you progress. Bendy Circle offers a relaxing yet mentally stimulating experience, making it suitable for entertainment anytime and anywhere.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/vomxfryage0o2ydbt36lks3pzuhvhz7l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vomxfryage0o2ydbt36lks3pzuhvhz7l/",
    "sourceUrl": "https://html5.gamemonetize.com/vomxfryage0o2ydbt36lks3pzuhvhz7l/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74682",
    "slug": "epicshooter3d",
    "title": "epicshooter3d",
    "description": "EpicShooter3D is built with one simple goal: to be fast, smooth, simple, and fun &mdash; no installs, no logins, no waiting. Just open the game and start shooting. This game will always be free. No downloads. No accounts. Just pure browser FPS action. Even though I created this game, its not just my game anymore. A lot of the features you see today came directly from player feedback, and I genuinely value every suggestion. I promise to keep listening and improving the game with the community in mind. At its heart, EpicShooter3D is meant to be a stress-buster &mdash; but also a place where friends and total strangers can compete, climb the leaderboard.",
    "instructions": "PC Controls W A S D - Move your character Mouse - Aim Look around Left Click Shoot Space Jump ESC Pause Game Release Cursor Mobile Controls The game automatically detects mobile devices and enables touch controls Left Joystick Drag to move your char",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "amazing",
      "Army",
      "assasin",
      "Battlegrounds",
      "Bullet",
      "First Person Shooter",
      "fps",
      "Games Ai",
      "Multiplayer",
      "Shooting",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/n4h4snqc89f5a7r0bsqn1g8y4f2ob311/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n4h4snqc89f5a7r0bsqn1g8y4f2ob311/",
    "sourceUrl": "https://html5.gamemonetize.com/n4h4snqc89f5a7r0bsqn1g8y4f2ob311/",
    "width": 1728,
    "height": 1084,
    "lastUpdated": ""
  },
  {
    "id": "75670",
    "slug": "crazy-fall-rush-3d",
    "title": "Crazy Fall Rush 3D",
    "description": "Crazy Fall Rush 3D is an intense survival arcade game where quick thinking is the key to victory. Stand on unstable falling blocks and try to stay alive while other stickman players struggle around you. Every move matters as the platform keeps collapsing beneath your feet. You can choose to carefully walk, jump, or push rivals into danger to gain an advantage. Outsmart opponents, keep your balance, and survive till the end of each level. Only the smartest and fastest player can become the last one standing in this thrilling 3D fall rush challenge.",
    "instructions": "Use the A and D keys or the Left and Right Arrow keys to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D",
      "Action",
      "Arcade",
      "Casual",
      "Color",
      "Crazy",
      "endless",
      "Fall Guys",
      "jump",
      "Multiplayer",
      "Physics",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/b0z2gi8ndzs5s6xzy12ozs8l366unqzr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b0z2gi8ndzs5s6xzy12ozs8l366unqzr/",
    "sourceUrl": "https://html5.gamemonetize.com/b0z2gi8ndzs5s6xzy12ozs8l366unqzr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75704",
    "slug": "nightfall-horde",
    "title": "Nightfall Horde",
    "description": "Zombie Horde Survival is a fast-paced horror shooter where you fight endless waves of zombies attacking from the top and both sides. Move with your mouse, aim and shoot to survive the outbreak. Collect shotgun power-ups, defeat mutant bosses, and clear levels with increasing difficulty. Stay alive, score high, and become the last survivor.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "New",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/4p5be8g3fa9hl7o3tnxubjasui3gihpt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4p5be8g3fa9hl7o3tnxubjasui3gihpt/",
    "sourceUrl": "https://html5.gamemonetize.com/4p5be8g3fa9hl7o3tnxubjasui3gihpt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75722",
    "slug": "k-pop-hunters-valentine-style",
    "title": "K Pop Hunters Valentine Style",
    "description": "K-Pop Hunters Valentine Style brings romance, fashion, and K-pop glamour together in one stylish dress-up experience. Help your favorite K-pop hunters transform their looks for Valentine&rsquo;s Day with stunning outfits, flawless makeup, and charming accessories.",
    "instructions": "Left mouse button Click or Tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girls",
      "valentine",
      "valentine day"
    ],
    "thumbnail": "https://img.gamemonetize.com/hfujxbwsqlobd25ic3qkoo9gajc4q7b2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hfujxbwsqlobd25ic3qkoo9gajc4q7b2/",
    "sourceUrl": "https://html5.gamemonetize.com/hfujxbwsqlobd25ic3qkoo9gajc4q7b2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75744",
    "slug": "night-loot-run",
    "title": "Night Loot Run",
    "description": "This is a fast-paced coin collecting arcade game set under a starry night sky. Control a moving hand to grab golden coins while avoiding dangerous red coins. A giant aggressive red coin constantly chases you, increasing the tension. Complete each level by collecting enough coins, survive the hazards, and reach the final victory screen. Developer web: freecrazygames.io",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "Ai Games",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/ofogtc6oriyl247yrhv2runxb20vn9io/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ofogtc6oriyl247yrhv2runxb20vn9io/",
    "sourceUrl": "https://html5.gamemonetize.com/ofogtc6oriyl247yrhv2runxb20vn9io/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75742",
    "slug": "brainrot-evolution-arena",
    "title": "Brainrot Evolution Arena",
    "description": "Play an addictive evolution game where you control an Italian Brainrot creature in a fast-paced arena. Walk around, eat food to gain experience, and grow bigger with every level. As you evolve, your creature becomes stronger, faster, and more chaotic. Eat weaker Brainrot creatures instantly, avoid stronger enemies, and survive as long as possible. There are no complex attacks &mdash; victory depends on movement, positioning, and level advantage. Short sessions, simple mechanics, and constant action make this eat-and-grow Brainrot game highly replayable and perfect for quick fun.",
    "instructions": "PC WSAD MOVE MOBILE JOYSTICK MOVE",
    "category": "3D",
    "genres": [
      "3D"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2025 games",
      "2026 games",
      "3D",
      "3D Games",
      "Action",
      "Arena",
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "Level"
    ],
    "thumbnail": "https://img.gamemonetize.com/cumcmfbhvmb3yvzxrwygcayr5pjy0b52/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cumcmfbhvmb3yvzxrwygcayr5pjy0b52/",
    "sourceUrl": "https://html5.gamemonetize.com/cumcmfbhvmb3yvzxrwygcayr5pjy0b52/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75747",
    "slug": "star-breakout",
    "title": "Star Breakout",
    "description": "Star Breakout is a fast-paced arcade brick breaker set in a beautiful starry space background. Control the paddle, launch the ball, and destroy colorful bricks to clear each level. Bomb bricks explode and smash nearby blocks, while combo streaks unlock x2, x3, and x4 score multipliers. Collect +Paddle power-ups and survive all levels. Web Dev <a href='https://www.freecrazygames.io/'>https://www.freecrazygames.io/</a>",
    "instructions": "Move the paddle with your mouse or finger touch Click or tap to launch the ball Use Pause Resume buttons to stop or continue the game",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Adventure",
      "Ai Games",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/pl8gzye5iug5shfc8jx6a4x3gzt6gran/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pl8gzye5iug5shfc8jx6a4x3gzt6gran/",
    "sourceUrl": "https://html5.gamemonetize.com/pl8gzye5iug5shfc8jx6a4x3gzt6gran/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75490",
    "slug": "sapotago",
    "title": "SapotaGo",
    "description": "SapotaGo is a fast-paced reflex arcade game built around a playful twist: a bouncing object trapped inside the curved world of a giant sapota! Your goal is simple&mdash;keep the object in motion and prevent it from escaping. The sapota&rsquo;s circular edges send the object ricocheting forward from one side to the other. At the circumference, a movable paddle awaits&mdash;your only defense. Slide it in any direction to catch, reflect, and control the direction of the bouncing object. Miss once, and the run ends. As the pace increases, every rebound becomes a test of timing, precision, and quick decision-making.",
    "instructions": "Tap to move the ricochet",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Ball",
      "Casual",
      "Food"
    ],
    "thumbnail": "https://img.gamemonetize.com/3x03o9ydru7g6ajdjz00m9v5vmtb0e2o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3x03o9ydru7g6ajdjz00m9v5vmtb0e2o/",
    "sourceUrl": "https://html5.gamemonetize.com/3x03o9ydru7g6ajdjz00m9v5vmtb0e2o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75492",
    "slug": "hoop-pair",
    "title": "Hoop Pair",
    "description": "Hoop Pair is a clean, skill-based basketball puzzler where you guide two balls at once into a single hoop. Instead of flicking or shooting, you draw a path&mdash;a simple guiding line&mdash;that both balls follow as they drop toward the basket. Each level challenges your timing, accuracy, and planning as obstacles, curves, and moving platforms come into play. Draw the right curve, angle, or bounce pattern to make sure both balls reach the hoop together. One perfect line can solve the entire puzzle&hellip; or send everything off course.",
    "instructions": "Put the ball fall in the basket",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Basketball",
      "Skills",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/plvmdjjiehkku5tjjpqpmvom1qa5cd79/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/plvmdjjiehkku5tjjpqpmvom1qa5cd79/",
    "sourceUrl": "https://html5.gamemonetize.com/plvmdjjiehkku5tjjpqpmvom1qa5cd79/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75493",
    "slug": "last-quiver",
    "title": "Last Quiver",
    "description": "Last Quiver is a fast-paced survival defense game where skill, timing, and precision decide how long you live. You play as a lone archer standing your ground against relentless waves of enemies and zombies. With only your bow, limited arrows, and quick reflexes, you must fend off incoming hordes before they overwhelm you. Every shot matters&mdash;miss too often, and you may find yourself facing the end with an empty quiver. As waves progress, enemies grow faster, tougher, and more unpredictable. Aim carefully, prioritize targets, and make split-second decisions to survive longer and score higher. Power-ups, combo hits, and more!",
    "instructions": "Click to send an arrow",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "arrows",
      "Shoot",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/0m5dkfc9ntne6i0dggr6ve1s44wp88cv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0m5dkfc9ntne6i0dggr6ve1s44wp88cv/",
    "sourceUrl": "https://html5.gamemonetize.com/0m5dkfc9ntne6i0dggr6ve1s44wp88cv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72337",
    "slug": "racing-portal",
    "title": "racing portal",
    "description": "Experience the ultimate adrenaline rush with Turbo Street Racers &mdash; the most thrilling car racing game ever! Race through stunning cityscapes, deserts, and mountain roads while customizing your dream car with powerful upgrades and unique paint jobs. Compete against real players in online multiplayer mode or challenge yourself in the single-player career to become the King of the Road! Features: Realistic driving physics and smooth controls Dynamic weather and day/night cycles Dozens of cars to unlock, upgrade, and customize Global leaderboards and daily rewards Exciting missions and time-limited events Monetization: Unlock",
    "instructions": "Master your car and dominate every race with simple intuitive controls Accelerate Press and hold the Right Arrow rarr or the Gas Pedal button Brake Reverse Press the Left Arrow larr or the Brake button Steer Left Right Use the Arrow Keys",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D Games",
      "Action",
      "Adventure",
      "Ai Games",
      "free games for your website",
      "html games for your website",
      "Interactive",
      "Race",
      "Racing",
      "Super",
      "Supercars",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/zuo8mjoeayuv57mfsueh21iatxrolwbx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zuo8mjoeayuv57mfsueh21iatxrolwbx/",
    "sourceUrl": "https://html5.gamemonetize.com/zuo8mjoeayuv57mfsueh21iatxrolwbx/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "72408",
    "slug": "space-io",
    "title": "space io",
    "description": "In the year 3049, humanity has conquered the stars but not without consequence. The once-united Galactic Union has fractured into countless factions, each commanding swarms of AI-driven ships. In the outer reaches of space, an uncharted region known only as The Void has become the ultimate battleground a digital warzone where pilots fight for dominance, glory, and survival. You are one of these pilots a lone commander plugged into the networked consciousness known as Space.io. Every move you make, every ship you destroy, and every star you claim sends ripples through the data-galaxy. The more you grow, the more your fleet expands. But beware",
    "instructions": "Command your ship through deep space destroy enemies and become the largest fleet in the arena Desktop Web Version Mouse Move Direct your ship rsquo s flight path your ship follows your cursor Left Click Spacebar Fire your primary weapon Righ",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2025 games",
      "Action",
      "Adventure",
      "Aircraft",
      "attack",
      "catch",
      "free games for your site",
      "jump",
      "running",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/4jt7drizukk3heomy00elax4tukm0p19/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4jt7drizukk3heomy00elax4tukm0p19/",
    "sourceUrl": "https://html5.gamemonetize.com/4jt7drizukk3heomy00elax4tukm0p19/",
    "width": 1536,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72022",
    "slug": "edge-of-survival",
    "title": "Edge of Survival",
    "description": "Find Your Way &ndash; 2D Navigation Adventure Game Welcome to Find Your Way, a captivating 2D navigation and maze game that challenges your mind, reflexes, and sense of direction. In this unique browser-based experience, your goal is simple: guide your character through intricate mazes, avoid dead ends, and reach the exit as quickly as possible. But don&rsquo;t be fooled by its simplicity&mdash;each level is designed to test your problem-solving skills, patience, and strategic thinking. The world of Find Your Way is full of twists, turns, and surprises. As you progress through each level, the mazes become more complex, introducing new challenges and obstacle",
    "instructions": "Experience survival in Edge of Survival a simple 2D game you can play entirely with mouse clicks Your goal is to stay alive as long as possible while navigating a small but dangerous world filled with obstacles enemies and hidden items No complicated",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2 Player Games",
      "2025 games",
      "2048",
      "Arkanoid",
      "Ball",
      "Ben 10",
      "Coloring",
      "Hypercasual",
      "Skateboard",
      "Slither",
      "Word",
      "Yoga"
    ],
    "thumbnail": "https://img.gamemonetize.com/2z0ymsbp3xsg3at9l1asiwiq0odj71gb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2z0ymsbp3xsg3at9l1asiwiq0odj71gb/",
    "sourceUrl": "https://html5.gamemonetize.com/2z0ymsbp3xsg3at9l1asiwiq0odj71gb/",
    "width": 512,
    "height": 288,
    "lastUpdated": ""
  },
  {
    "id": "72391",
    "slug": "splashy-sub",
    "title": "Splashy Sub",
    "description": "Dive deep into the ocean in Splashy Sub, a fun and challenging underwater adventure! Control your tiny yellow submarine and navigate through dangerous underwater caves filled with obstacles, mines, and sea creatures. Tap or press the right keys to stay afloat &mdash; every move counts! Avoid crashing, collect coins, and survive as long as you can beneath the waves. Easy to play but hard to master, Splashy Sub combines simple controls with addictive arcade action. How far can you go before the ocean swallows you whole? Features: Flappy-style underwater gameplay Simple one-touch or keyboard control",
    "instructions": "Tap Click to move the submarine upward",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Action",
      "Adventure",
      "Car",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "Race",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/ylxfj0lw3ytgg2zbi9aukv04mp926btc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ylxfj0lw3ytgg2zbi9aukv04mp926btc/",
    "sourceUrl": "https://html5.gamemonetize.com/ylxfj0lw3ytgg2zbi9aukv04mp926btc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "72003",
    "slug": "color-sort-puzzle-game",
    "title": "Color Sort Puzzle Game",
    "description": "Color Sort Water Sort Puzzle gives you mental challenge. Liquid Sort Puzzle Games Offline are designed to test your brain. Improve your mental health and logical reasoning with Color Sort Puzzle Water Game. If you like to take challenges in real time then you must try Color water sort game. You have to sort Color water sort puzzle offline after predicting every move. No doubt it is addictive but water sort puzzle game 3d is interesting and exciting as you are unaware with upcoming water colors.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "3D Games",
      "Adventure",
      "Arcade",
      "Best Games",
      "bottle",
      "Color",
      "Kids",
      "sorting",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/ve2vans9coefrwvnw0uz9893zaz3zwi3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ve2vans9coefrwvnw0uz9893zaz3zwi3/",
    "sourceUrl": "https://html5.gamemonetize.com/ve2vans9coefrwvnw0uz9893zaz3zwi3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75382",
    "slug": "mahjong-puzzle-game",
    "title": "Mahjong Puzzle Game",
    "description": "Mahjong Puzzle Game is a classic and relaxing tile-matching puzzle game designed for players who enjoy calm, thoughtful, and strategic gameplay. This traditional mahjong-style experience challenges players to match identical tiles and clear the board while planning each move carefully. The game combines timeless puzzle mechanics with a clean and modern mobile-friendly design.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qdbiptd77iwsz69u5zqexeursu53ieqz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qdbiptd77iwsz69u5zqexeursu53ieqz/",
    "sourceUrl": "https://html5.gamemonetize.com/qdbiptd77iwsz69u5zqexeursu53ieqz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75322",
    "slug": "bridge-race-3d",
    "title": "Bridge Race 3D",
    "description": "Bridge Race 3D is a fun and competitive casual game where you race to the finish by building your own path. Collect floating wooden planks in your color, stack them up, and use them to create bridges across the water.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Bridge",
      "Collecting",
      "Color",
      "Race",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/bb647sahcn5cvtzlvfhydbubm5lsdvtu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bb647sahcn5cvtzlvfhydbubm5lsdvtu/",
    "sourceUrl": "https://html5.gamemonetize.com/bb647sahcn5cvtzlvfhydbubm5lsdvtu/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74784",
    "slug": "color-sort-impostor-edition",
    "title": "Color Sort Impostor Edition",
    "description": "Color Sort Impostor Edition is a fun and relaxing puzzle game that challenges your logic and focus. Sort the colorful characters into the correct tubes so that each tube contains only one color. The rules are simple, but the puzzles quickly become more challenging as new colors and obstacles appear. Plan your moves carefully, avoid mistakes, and enjoy a smooth, satisfying sorting experience designed for players of all ages.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Impostor",
      "Puzzle",
      "sort",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/bsf4wr41vt498k3e254fziqhs9330qdk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bsf4wr41vt498k3e254fziqhs9330qdk/",
    "sourceUrl": "https://html5.gamemonetize.com/bsf4wr41vt498k3e254fziqhs9330qdk/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72834",
    "slug": "tile-connect-pair-match-puzzle",
    "title": "Tile Connect Pair Match Puzzle",
    "description": "Match &amp; connect tiles of same color &amp; be the master of pair matching puzzle game. In this you have to find and match the same objects. There are different objects.",
    "instructions": "Match The things to complete the game Click on same objects to match them",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Candy",
      "crash",
      "Match-3",
      "Matching",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/t0o4lkpj4iehz9nu4r7bhx41y4mjq1d8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t0o4lkpj4iehz9nu4r7bhx41y4mjq1d8/",
    "sourceUrl": "https://html5.gamemonetize.com/t0o4lkpj4iehz9nu4r7bhx41y4mjq1d8/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75062",
    "slug": "block-21",
    "title": "Block 21",
    "description": "Tap/click on a group of three or more blocks with the same color. Get block 21. Have fun!",
    "instructions": "Tap the screen or click the mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Brain",
      "HTML5",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7y7eipr5axagurxl3zy7urjidst7c413/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7y7eipr5axagurxl3zy7urjidst7c413/",
    "sourceUrl": "https://html5.gamemonetize.com/7y7eipr5axagurxl3zy7urjidst7c413/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75321",
    "slug": "candy-tap-world",
    "title": "candy tap world",
    "description": "Tap the colorful candies as they fly up from the bottom! You must tap them before they reach the top to earn score. Test your speed and your reflexes.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2026 games",
      "2D",
      "Air",
      "amazing",
      "Best Games",
      "Candy",
      "Girls",
      "sky",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/nnk8pcs8cglrd59wycux2mmjvwjdna6h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nnk8pcs8cglrd59wycux2mmjvwjdna6h/",
    "sourceUrl": "https://html5.gamemonetize.com/nnk8pcs8cglrd59wycux2mmjvwjdna6h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74693",
    "slug": "brain-test-iq-challenge",
    "title": "Brain Test: IQ Challenge",
    "description": "Brain Training: Logic &amp; Puzzle Games Educational puzzle game for all ages! Improve logical thinking with pattern recognition, odd-one-out challenges, sequence puzzles. Fun learning !",
    "instructions": "Mouse click and move or tap the screen on mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Casual",
      "Puzzle",
      "puzzleblock",
      "quests",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/893dmia83svuj6rwn19tx03ubpe32a9o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/893dmia83svuj6rwn19tx03ubpe32a9o/",
    "sourceUrl": "https://html5.gamemonetize.com/893dmia83svuj6rwn19tx03ubpe32a9o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74213",
    "slug": "happy-bucket-challenge",
    "title": "Happy Bucket Challenge",
    "description": "The bucket is sad because its empty. Your job is to draw a line to make the glass filled up with liquid and smile again! Try to find the best way to complete each level. You can come up with your own solution so be creative and dont be afraid to think out of the box! Some levels might look easy but lets see if you can actually get the 3 stars. This new draw lines game is good for players of all ages kids and adults to make their mind sharp and enhance their mind power by playing this physics based game and solve crazy physics puzzles of one of the best line draw and glass games. Dynamic mechanism. Draw lines freely to complete levels!",
    "instructions": "Click and hold the left mouse button to draw a line",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "3D Games",
      "Brain",
      "Casual",
      "Drawing",
      "Family",
      "Physics",
      "Puzzle",
      "Relaxation",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/opqmxeneqo44wwzk0yw353ln4rrbxi01/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/opqmxeneqo44wwzk0yw353ln4rrbxi01/",
    "sourceUrl": "https://html5.gamemonetize.com/opqmxeneqo44wwzk0yw353ln4rrbxi01/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75317",
    "slug": "crazy-table-tennis",
    "title": "Crazy Table Tennis",
    "description": "Do you like Ping Pong? prove your abilities in Crazy Table Tennis, a Pong inspired game when you play against unbeatables AI to win the match Developed in 2025 by FLGames",
    "instructions": "WASD to move",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/thohtjto3vc4it861rc4h0j4lvzfqyqh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/thohtjto3vc4it861rc4h0j4lvzfqyqh/",
    "sourceUrl": "https://html5.gamemonetize.com/thohtjto3vc4it861rc4h0j4lvzfqyqh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75501",
    "slug": "blocky-hill-tower-game",
    "title": "Blocky Hill Tower Game",
    "description": "Blocky Hill Tower Game is a fun and challenging block-style game where your goal is to build and balance a tower on a hill environment. In this game, you carefully place blocky pieces one by one to create the tallest and strongest tower possible. Every move matters, because one wrong placement can cause the tower to fall. The game features simple controls and smooth gameplay, making it easy to play for all age groups. As you progress, the difficulty increases, requiring better timing, balance, and focus. The blocky graphics and hill environment give the game a unique and enjoyable look that keeps players engaged.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/m0p5y6f1zoc4ht4j8enb7jketok4krd5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m0p5y6f1zoc4ht4j8enb7jketok4krd5/",
    "sourceUrl": "https://html5.gamemonetize.com/m0p5y6f1zoc4ht4j8enb7jketok4krd5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75636",
    "slug": "my-supermarket-simulator-3d",
    "title": "My Supermarket Simulator 3D",
    "description": "My Supermarket Simulator 3D Game: Master the Art of Retail Management! Welcome to My Supermarket Simulator 3D Game, the ultimate shop simulator game where you will experience grocery store management and get to know that how to manage your supermarket. Take charge of every detail, from stocking shelves to managing staff and transform your modest grocery store into the towns favorite supermart in this supermarket cashier simulator game.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Best Games",
      "Puzzle",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/3tut3wguw5tprf6j3dl6cvtiydgj99nr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3tut3wguw5tprf6j3dl6cvtiydgj99nr/",
    "sourceUrl": "https://html5.gamemonetize.com/3tut3wguw5tprf6j3dl6cvtiydgj99nr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75680",
    "slug": "war-space-defender",
    "title": "War Space Defender",
    "description": "War Space Defender is a fast-paced arcade space shooter where you pilot a sleek starfighter through intense enemy waves. Destroy aggressive alien ships, dodge deadly projectiles, and survive powerful boss battles across multiple levels. Earn points, gain extra lives, and push for a new high score in a stunning galaxy battlefield. Developer site: freecrazygames.io",
    "instructions": "Controls are simple and responsive move your ship by moving the mouse within the lower zone of the screen aim naturally with the cursor and fire by clicking or holding the mouse button Use the on-screen buttons to Start Resume or Pause the game",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Shooter",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/zpvbbddwvqh1oljm9lgc156fb1kqohzy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zpvbbddwvqh1oljm9lgc156fb1kqohzy/",
    "sourceUrl": "https://html5.gamemonetize.com/zpvbbddwvqh1oljm9lgc156fb1kqohzy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75625",
    "slug": "car-crossey-bridge-game",
    "title": "Car Crossey Bridge Game",
    "description": "Car Crossy Bridge ek exciting aur addictive casual driving game hai jisme aapko apni car ko dangerous bridges par safely cross karna hota hai. Har bridge ek new challenge lekar aata hai jahan aapko perfect timing, sharp driving skills aur fast decision making ki zaroorat hoti hai. Is thrilling bridge crossing game me aapko narrow roads, moving platforms aur tricky obstacles ka samna karna hoga. Jitna zyada aap survive karenge utna high score achieve karenge. Agar aapko crossy road games, bridge driving challenges, aur casual car racing adventures pasand hain to Car Crossy Bridge aapke liye best game hai.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Brain",
      "Bridge",
      "Car",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/of0pqpxg8z7qnf8uvnvanq89uvr6q5ny/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/of0pqpxg8z7qnf8uvnvanq89uvr6q5ny/",
    "sourceUrl": "https://html5.gamemonetize.com/of0pqpxg8z7qnf8uvnvanq89uvr6q5ny/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75505",
    "slug": "merge-monster-fight",
    "title": "Merge Monster Fight",
    "description": "Merge Monster Fight &ndash; Fun Merge &amp; Strategy Battles! Step into Merge Monster Fight, a thrilling merge and strategy adventure! Combine and evolve adorable monsters to build unstoppable armies. Outsmart powerful bosses with clever tactics and enjoy exciting 3D battles full of surprises. Every merge, upgrade, and battle decision matters &mdash; plan smartly and watch your monster army grow stronger. Relax, strategize, and experience the joy of merging, battling, and conquering in this casual monster strategy game!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "Battle",
      "Casual",
      "Color",
      "Fight",
      "Fighting",
      "idle",
      "Monster",
      "Skills",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/5tfp26ycgn6c83g0ouf27vynhi128yd8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5tfp26ycgn6c83g0ouf27vynhi128yd8/",
    "sourceUrl": "https://html5.gamemonetize.com/5tfp26ycgn6c83g0ouf27vynhi128yd8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74012",
    "slug": "neon-viper",
    "title": "Neon Viper",
    "description": "Experience the Ultimate IO Battle Thrill! In Neon Viper, consume glowing dots to grow and use tactical maneuvers to cut off enemies, forcing them to crash into you! Dual Modes: Tackle the strategic Campaign or push your limits in Endless Mode. Tactical Shop: Earn coins to unlock powerful items like Shields and Mega Starts. Second Chance: Made a mistake? Watch an ad to Revive and keep your high score streak alive! Smooth Controls: Fully supports PC Keyboard and Mobile Touch Joystick.",
    "instructions": "This game supports two operation methods PC and mobile devices phones tablets 1 PC control keyboard Movement direction Use the arrow keys uarr darr larr rarr Or WASD keys W up S down A left D right Acceleration sprint Hold down",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Boy",
      "H5"
    ],
    "thumbnail": "https://img.gamemonetize.com/ghq2nimyd24h4g7ddejvf7acibdw1dxp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ghq2nimyd24h4g7ddejvf7acibdw1dxp/",
    "sourceUrl": "https://html5.gamemonetize.com/ghq2nimyd24h4g7ddejvf7acibdw1dxp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74585",
    "slug": "stickman-dismounting-2026",
    "title": "Stickman Dismounting 2026",
    "description": "Get ready for the ultimate ragdoll physics experience with Stickman Ragdoll Wreckfest! Control a stickman as you launch him from various vehicles and contraptions, sending him tumbling, crashing, and flailing through intricately designed levels. The goal? To cause as much spectacular damage and create the most creative dismounts possible! Web Dev <a href='https://www.coolcrazygames.com/'>https://www.coolcrazygames.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Dismounting",
      "Mentolatux",
      "ragdoll",
      "Stickman",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/3ge66kqdb05b6jorhx47qug2er6ukm8t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3ge66kqdb05b6jorhx47qug2er6ukm8t/",
    "sourceUrl": "https://html5.gamemonetize.com/3ge66kqdb05b6jorhx47qug2er6ukm8t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75604",
    "slug": "car-wash-simulator-game",
    "title": "Car Wash Simulator Game",
    "description": "Car Wash Simulator ek fun aur satisfying game hai jismein aap dirty cars ko wash, repair aur shine karte ho. Is game mein aapko real car washing experience milta hai jahan aap soap, water, brush aur tools use karke cars ko bilkul new jaisa bana dete ho. Game ke colorful graphics aur smooth controls isay har age ke players ke liye enjoyable banate hain. Har level ke sath new cars aur challenges unlock hote hain jo game ko aur zyada exciting bana dete hain.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2026 games",
      "Action",
      "amazing",
      "Car",
      "Cars",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/3rm3foz4mhkw3a4d6ki22dh9sn4xnrbs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3rm3foz4mhkw3a4d6ki22dh9sn4xnrbs/",
    "sourceUrl": "https://html5.gamemonetize.com/3rm3foz4mhkw3a4d6ki22dh9sn4xnrbs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69318",
    "slug": "funny-crazy-watermelon",
    "title": "Funny Crazy Watermelon",
    "description": "Funny Crazy Watermelon &mdash; a platformer with physics. Play as a funny creature, which is a watermelon with a funny face. Jump over spikes, jump on platforms, push boxes &mdash; all in the classic platformer style. The game has more than 25 levels. The game also has 11 skins.",
    "instructions": "Controls arrows larr rarr uarr or WAD The game has a double jump The goal of the game is to get to the star",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Arcade",
      "Ball",
      "Best",
      "Casual",
      "Crazy",
      "Mobile",
      "New",
      "Platform",
      "watermelon"
    ],
    "thumbnail": "https://img.gamemonetize.com/wlaqwtp1ov17j97sihvjzl7ndv4vlzat/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wlaqwtp1ov17j97sihvjzl7ndv4vlzat/",
    "sourceUrl": "https://html5.gamemonetize.com/wlaqwtp1ov17j97sihvjzl7ndv4vlzat/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75511",
    "slug": "yummy-churros-ice-cream-2",
    "title": "Yummy Churros Ice Cream 2",
    "description": "Create your own Churros Ice Cream! Go through every step in the tasklist to make your delicious ice cream. Pick your favorite flavour and finish it with a combination of syrups and toppings. Complete your tasklist and unlock achievements!",
    "instructions": "Use MOUSE to play the game",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cook",
      "Cooking",
      "Dress Up",
      "Kids",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/tpjvm666wlqde5lkr3w8pyagcmyk767k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tpjvm666wlqde5lkr3w8pyagcmyk767k/",
    "sourceUrl": "https://html5.gamemonetize.com/tpjvm666wlqde5lkr3w8pyagcmyk767k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75416",
    "slug": "italian-brainrot-quiz-and-mdash-meme-mastery",
    "title": "Italian Brainrot Quiz &mdash; Meme Mastery",
    "description": "Test your knowledge of the wildest Italian brainrot memes! Guess the correct answers, recognize absurd characters, and survive the timer. Can you master the chaos and become the ultimate Brainrot Quiz champion?",
    "instructions": "LEFT MOUSE BUTTON INTERACT",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Fun",
      "Funny",
      "Italian Brainrot",
      "Quiz",
      "Sahur",
      "Tralalero Tralala",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/m59916zelz3sgf09lcmemaw1n7d9q4fp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m59916zelz3sgf09lcmemaw1n7d9q4fp/",
    "sourceUrl": "https://html5.gamemonetize.com/m59916zelz3sgf09lcmemaw1n7d9q4fp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75572",
    "slug": "logic-pro-and-ndash-neon-edition",
    "title": "Logic Pro &ndash; Neon Edition",
    "description": "Logic Pro &ndash; Neon Edition is an addictive online puzzle game that challenges your brain with classic lights-out logic gameplay. Turn all the lights OFF by tapping tiles that also toggle their neighbors. Plan carefully, think ahead, and solve each level using the fewest moves possible. Enjoy increasing difficulty, smooth neon visuals, best-score tracking, and mobile-friendly controls. Perfect for fans of brain games, logic puzzles, and casual thinking games. Play free online and train your mind to become a true logic master!",
    "instructions": "Click or tap on a tile to toggle it ON or OFF Tapping a tile also toggles its neighboring tiles Use your mouse on desktop or touch on mobile devices Use help section for more",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brain",
      "Casual",
      "Logic",
      "Logical",
      "Mind",
      "Puzzle",
      "Skill",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/60e54qsjgxyhcdskaega5l14a690441w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/60e54qsjgxyhcdskaega5l14a690441w/",
    "sourceUrl": "https://html5.gamemonetize.com/60e54qsjgxyhcdskaega5l14a690441w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75574",
    "slug": "haunted-inn",
    "title": "Haunted Inn",
    "description": "Ghost Inn is a survival horror game set in ancient China. Defend your inn from vengeful spirits, upgrade defenses, and survive the night! Can you outsmart the ghosts and keep your inn running?",
    "instructions": "bull Tap to build upgrade defenses bull Swipe to navigate bull Tap talismans items to fend off ghosts bull Manage resources for survival",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Arena",
      "Defense",
      "Escape",
      "Horror",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/h3b7e0kkad5vxun35ev7dq1fy79glf8l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h3b7e0kkad5vxun35ev7dq1fy79glf8l/",
    "sourceUrl": "https://html5.gamemonetize.com/h3b7e0kkad5vxun35ev7dq1fy79glf8l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75502",
    "slug": "breakfast-cooking-game",
    "title": "BreakFast Cooking Game",
    "description": "Breakfast Cooking Game is a fun and exciting cooking game where you can prepare delicious breakfast meals in your own virtual kitchen. In this game, you become a chef and cook tasty breakfast items step by step. Follow simple instructions, use kitchen tools, and serve fresh meals to your customers. This cooking game is easy to play and perfect for players of all ages. With smooth controls and colorful graphics, the game offers an enjoyable cooking experience. As you progress, you unlock new breakfast recipes and face new cooking challenges that make the gameplay more interesting and addictive.",
    "instructions": "- To click any button use mouse",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Cook",
      "Cooking",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/wjet3cr91fosr9rdmkmh2q6daozshdxd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wjet3cr91fosr9rdmkmh2q6daozshdxd/",
    "sourceUrl": "https://html5.gamemonetize.com/wjet3cr91fosr9rdmkmh2q6daozshdxd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75503",
    "slug": "branches-game",
    "title": "Branches Game",
    "description": "Branches Game is a fun and addictive casual game that tests your timing, focus, and reflex skills. In this game, your goal is to move forward while avoiding dangerous branches in your path. One wrong move can end the game, so you must stay alert and react quickly. The gameplay is simple and easy to understand, making it perfect for players of all ages. With smooth controls and clean visuals, Branches Game offers a relaxing yet challenging experience. As you progress, the speed increases, making the game more exciting and challenging.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "amazing",
      "Punch"
    ],
    "thumbnail": "https://img.gamemonetize.com/nrwcda3dplh8o67d3pm3nfsqo9720ug5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nrwcda3dplh8o67d3pm3nfsqo9720ug5/",
    "sourceUrl": "https://html5.gamemonetize.com/nrwcda3dplh8o67d3pm3nfsqo9720ug5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75262",
    "slug": "alien-memory",
    "title": "Alien Memory",
    "description": "Test your memory in an otherworldly challenge. Match pairs of cards featuring aliens, spaceships, and cosmic symbols using only focus and logic. A simple, fun, and engaging game for all ages, with progressive difficulty that puts your memory to the test. Invite your friends, play together, and see who has the sharpest memory in the galaxy.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2 Player",
      "Casual",
      "Hypercasual",
      "Memory"
    ],
    "thumbnail": "https://img.gamemonetize.com/d0bwdqm1axda2pp4ckstfzy7logog15t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d0bwdqm1axda2pp4ckstfzy7logog15t/",
    "sourceUrl": "https://html5.gamemonetize.com/d0bwdqm1axda2pp4ckstfzy7logog15t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75617",
    "slug": "fashion-show-makeup",
    "title": "Fashion Show: Makeup",
    "description": "Fashion Princess: Dress Up Time! Who is ready for a fashion adventure? Are you addicted to dress up game up and fashion designer game? Are you ready for style challenge? Let&rsquo;s play this dress up game up right now! Ready to wow fashion show with your unique styles. Start designing looks for superstars, supermodels, brides and more. Create looks that will take you all the way to the top of the style challenges with tons of gorgeous outfits, accessories and bridal make up. This is the most beautiful dress up games in 2025. When you play this dress up game, you have your own fashion show and you can dress up your superstars, superm",
    "instructions": "use mouse controls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Best Games",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/wmcuo9f1seigupqi9sj5kna7t6yzj4oe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wmcuo9f1seigupqi9sj5kna7t6yzj4oe/",
    "sourceUrl": "https://html5.gamemonetize.com/wmcuo9f1seigupqi9sj5kna7t6yzj4oe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75647",
    "slug": "olympic-runner-game",
    "title": "Olympic Runner Game",
    "description": "Experience the ultimate icy adrenaline rush in Olimpic Runner: Olympic Gold! Dash through the frozen tundra and compete in the most prestigious winter sporting event in the Antarctic. As a plucky man athlete, your goal is simple: Run, slide, and jump your way to the podium while navigating treacherous glacial landscapes. Whether youre sliding solo or aiming for the gold, the thrill of the chill is just a tap away. Precision and timing are everything: one slip could mean the difference between a medal and a wipeout!",
    "instructions": "Mouse click or tap to play Space Up Arrow X Key Jump Start Game Down Arrow Duck Slide Left Mouse Click Jump Enter Restart Game after Game Over",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Arcade",
      "crazygamesunblocked",
      "endless",
      "run",
      "running",
      "unblocked",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/pn1xxpv7bw1720i7nfnxe5mz7uwxlrx6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pn1xxpv7bw1720i7nfnxe5mz7uwxlrx6/",
    "sourceUrl": "https://html5.gamemonetize.com/pn1xxpv7bw1720i7nfnxe5mz7uwxlrx6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75654",
    "slug": "guess-the-fruit-world-quiz",
    "title": "Guess The Fruit World Quiz",
    "description": "Welcome to Guess The Fruit World Quiz, the vibrant and juicy picture trivia game that challenges you to identify fruits from all corners of the globe. From common grocery staples to rare tropical delights, how many can you name? A World of Fruits Awaits! Explore hundreds of beautifully crisp, high-definition images of fruits sourced from local markets and exotic farms worldwide. Our diverse gallery ensures youll always discover something new.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fruit",
      "Fruits",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/abc6vmk525r1zqey236jcl4mdjcbpc3l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/abc6vmk525r1zqey236jcl4mdjcbpc3l/",
    "sourceUrl": "https://html5.gamemonetize.com/abc6vmk525r1zqey236jcl4mdjcbpc3l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75657",
    "slug": "void-drop-3d",
    "title": "Void Drop 3D",
    "description": "Void Drop 3D is a fast-paced 3D action game where you fall endlessly into the unknown. Control a falling object, dodge rotating platforms, pass through tight gaps, and survive as the speed increases with every second. The deeper you fall, the harder it becomes. Obstacles appear faster, movement demands precision, and one small mistake ends the run. Simple controls combined with smooth 3D visuals create an addictive experience that&rsquo;s easy to learn but challenging to master. Designed for web play, Void Drop 3D delivers fluid performance, immersive depth, and intense reflex-based gameplay.",
    "instructions": "Move left or right to avoid obstacles while falling through an endless 3D void The speed increases over time mdash survive as long as possible and beat your high score",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "Arcade",
      "Casual",
      "Fun",
      "Funny",
      "Geometry",
      "Hypercasual",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/6ggenlqm3uwxopghx0a52jijse5g7m2u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6ggenlqm3uwxopghx0a52jijse5g7m2u/",
    "sourceUrl": "https://html5.gamemonetize.com/6ggenlqm3uwxopghx0a52jijse5g7m2u/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "33387",
    "slug": "car-eats-car-volcanic-adventure",
    "title": "Car Eats Car: Volcanic Adventure",
    "description": "Up for a fight against rivals in a dynamic race on the highway? Overtake enemies and create your own car in the incubator in Car Eats Car: Volcanic Adventure! Your friends are put to prison - do everything you can to free evil cars! Good driving skills and turbo speed come in handy in this crazy driving simulator and a police chase game. Become a car tycoon, upgrade cars, and play for monster cars against the cops! Fight the boss to survive in these ultimate crazy races!",
    "instructions": "Space - Bombs X - Turbo W - Gas S - Brake A D - Balancing Arrow keys - Gas Brake Balancing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Action",
      "Car",
      "Cars",
      "Cartoon",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/s482azgnri3397pp3919i5xx4f8kfvyi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s482azgnri3397pp3919i5xx4f8kfvyi/",
    "sourceUrl": "https://html5.gamemonetize.com/s482azgnri3397pp3919i5xx4f8kfvyi/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75553",
    "slug": "truckers-offroad-cargo-transport",
    "title": "Truckers: Offroad Cargo Transport",
    "description": "Become a true off-road master in a game where your main goal is to deliver valuable cargo through the harshest conditions! Get behind the wheel of legendary trucks such as ZIL, KamAZ, KrAZ, and UAZ, and set off on an unforgettable off-road journey. What makes the game unique? This game offers an exciting simulation of extreme cargo transportation, where every route is a real challenge. Who is this game for? The game is perfect for fans of trucks, simulators, and extreme driving. It&rsquo;s a challenge for both newcomers and experienced players alike. Key Features: &bull; Legendary trucks: ZIL, KamAZ, KrAZ, UAZ &mdash; choose your favorite! &bull; Advanced ph",
    "instructions": "Mobile Controls On mobile devices you can choose between different control modes Use the accelerate and brake buttons and switch between forward and reverse gears All controls are displayed directly on the screen PC Controls bull W mdash acceler",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Brainrot Italian",
      "Car",
      "cargo",
      "Crafting",
      "drifting",
      "Driving",
      "Minecraft",
      "monstertruck",
      "roblox",
      "transport",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/clih40fq7inyuaejg5yu0txd1cc8gzs0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/clih40fq7inyuaejg5yu0txd1cc8gzs0/",
    "sourceUrl": "https://html5.gamemonetize.com/clih40fq7inyuaejg5yu0txd1cc8gzs0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75514",
    "slug": "rainbow-monster-survival",
    "title": "Rainbow Monster Survival",
    "description": "Rainbow Monster Survival is a thrilling horror survival game where you must escape from terrifying Rainbow Monsters inside a creepy playground. Trapped alone, your mission is to search for hidden blocks while avoiding deadly monsters roaming the map. Each level challenges your stealth, timing, and survival skills. Hide in boxes, stay quiet, and listen carefully to monster footsteps to survive. Simple controls, intense gameplay, and scary encounters make this rainbow horror game exciting and fun. Can you find all the blocks and survive the nightmare?",
    "instructions": "Swipe the mouse on the joystick and also press WASD for movement",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Adventure",
      "Casual",
      "Escape",
      "Game",
      "Horror",
      "Monster",
      "Stealth",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/t7axexhfovxwlns2xcqf1vu2zbjwpm35/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t7axexhfovxwlns2xcqf1vu2zbjwpm35/",
    "sourceUrl": "https://html5.gamemonetize.com/t7axexhfovxwlns2xcqf1vu2zbjwpm35/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74584",
    "slug": "hospital-doctor-emergency",
    "title": "Hospital Doctor Emergency",
    "description": "In a bustling hospital, doctors act as the front line of human resilience. When an emergency strikes, the atmosphere shifts into a high-stakes race against time. Surgeons, nurses, and specialists coordinate with surgical precision, balancing clinical expertise with quiet empathy. Every siren marks a new challenge, requiring rapid diagnosis and decisive action. Web Dev <a href='https://www.crazygames.org.es/'>https://www.crazygames.org.es/</a> Amidst the sterile corridors and rhythmic beeping of monitors, these medical professionals work tirelessly to stabilize patients and save lives.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "emergency",
      "health",
      "hospital",
      "Mentolatux",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/wax5v41r9xmhxliyw1pnlwafhjg9upl4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wax5v41r9xmhxliyw1pnlwafhjg9upl4/",
    "sourceUrl": "https://html5.gamemonetize.com/wax5v41r9xmhxliyw1pnlwafhjg9upl4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75520",
    "slug": "penguin-runner-game",
    "title": "Penguin Runner Game",
    "description": "Get ready for the ultimate arctic adrenaline rush in Penguin Runner Game! Take control of a plucky, caped penguin hero on a high-speed dash across the frozen tundra. This isnt just a stroll through the snow, it&rsquo;s a race against time, physics, and a flurry of frosty obstacles! The ice is thin, the pace is hot, and the adventure is endless. Whether youre dodging obstacles or chasing a new high score, every run is a fresh challenge.",
    "instructions": "Mouse click or tap to play Space Up Arrow X Key Jump Start Game Down Arrow Duck Slide Left Mouse Click Jump Enter Restart Game after Game Over",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "endless",
      "run",
      "running",
      "unblocked",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/78tpxdgf7kga71ju6xxwlo5j4rlj1i6r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/78tpxdgf7kga71ju6xxwlo5j4rlj1i6r/",
    "sourceUrl": "https://html5.gamemonetize.com/78tpxdgf7kga71ju6xxwlo5j4rlj1i6r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75426",
    "slug": "crazy-drone-pizza-delivery",
    "title": "Crazy Drone Pizza Delivery",
    "description": "Crazy Drone Pizza Delivery is a fast-paced casual delivery game where you control a pizza drone racing through busy city skies. Fly carefully, avoid buildings, wires, and moving obstacles while delivering hot pizzas on time. Enjoy smooth one-hand controls, quick missions, and endless arcade fun. Upgrade your drone&rsquo;s speed, stability, and cargo capacity to handle tougher routes. Complete daily challenges, earn rewards, unlock new drone skins, and compete on leaderboards. Easy to play, exciting to master&mdash;perfect for short breaks or long play sessions.",
    "instructions": "Use WASD keys to control the Drone",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D",
      "3D Games",
      "Arcade",
      "Best Games",
      "Casual",
      "fly",
      "Fun",
      "Obstacle",
      "pizza",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/aukn9nz779c75rmacfesutqv65m2568g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aukn9nz779c75rmacfesutqv65m2568g/",
    "sourceUrl": "https://html5.gamemonetize.com/aukn9nz779c75rmacfesutqv65m2568g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75637",
    "slug": "run-pet-surfer",
    "title": "Run Pet Surfer",
    "description": "Pet Runner is an endless running mobile game. Building to unlock more pet characters. Run and jump with your pet to avoid obstacles in the road. Collect various items such as coins, score, elastic shoes, jetpacks, magnets and booster packs. By swapping rapidly as speed increases, more coins and score can be acquired. A variety of costumes can be unlocked via in-game and players can collect specific items.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Cartoon",
      "Casual",
      "Hypercasual",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/eyimeq93m1pi4j2calk8n0k04f7xlo2l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eyimeq93m1pi4j2calk8n0k04f7xlo2l/",
    "sourceUrl": "https://html5.gamemonetize.com/eyimeq93m1pi4j2calk8n0k04f7xlo2l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75079",
    "slug": "drag-n-drop-games-color-match",
    "title": "Drag n Drop Games Color Match",
    "description": "Welcome to Color Match!, the ultimate interactive learning experience for children! This game is designed to help young learners identify and distinguish colors in a fun, engaging way. The goal is simple: Look at the black-and-white objects in the targets and find the matching colored card from the source box. Drag the red card to the apple, the blue card to the whale, and watch the objects come to life with color!",
    "instructions": "Desktop Use your Mouse to click and drag the colored cards Release the mouse button over the matching object to color it Mobile Tablet Tap and hold the colored cards with your finger Drag and drop them onto the matching object icons",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Educational",
      "HTML5",
      "Kids",
      "Matching",
      "Mobile",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/yqivnpieqw33nru9a3274iaqp11d1q0r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yqivnpieqw33nru9a3274iaqp11d1q0r/",
    "sourceUrl": "https://html5.gamemonetize.com/yqivnpieqw33nru9a3274iaqp11d1q0r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75274",
    "slug": "minesweeper-find-bombs",
    "title": "Minesweeper: Find Bombs",
    "description": "Minesweeper - Find Bombs is a classic puzzle experience that challenges your logic and attention to detail. Carefully analyze the grid, reveal hidden clues, and locate every bomb without making a mistake. Clear all bombs to pass the level and master this timeless brain teaser. Made with GODOT 4.5",
    "instructions": "HOW TO PLAY Left Click Open the cells Long Press Plant remove a flag Goal Clear the field without hitting a mine",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bomb",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/gqr5252tlvkb64cla5ku8td29k0uc23a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gqr5252tlvkb64cla5ku8td29k0uc23a/",
    "sourceUrl": "https://html5.gamemonetize.com/gqr5252tlvkb64cla5ku8td29k0uc23a/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75287",
    "slug": "combo-crush",
    "title": "Combo Crush",
    "description": "Combo Crush is a fast-paced, addictive puzzle game where strategy meets satisfaction. Your goal is simple: find groups of two or more matching blocks and blast them away to reach the target score. But dont be fooled&mdash;as the levels progress, youll need sharp logic and clever moves to master the grid! How to Play: - Tap groups of matching colored blocks to remove them. - Reach the target score before the board gets stuck. - Earn points to buy helpful items in the Shop. - Complete levels to unlock bigger grids and new color challenges",
    "instructions": "Use Mouse To Play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Brain",
      "endless",
      "HTML5",
      "Puzzle",
      "puzzleblock",
      "Skill",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/sjrfvn10lojsxqjjir7fmxwzvutfwj2l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sjrfvn10lojsxqjjir7fmxwzvutfwj2l/",
    "sourceUrl": "https://html5.gamemonetize.com/sjrfvn10lojsxqjjir7fmxwzvutfwj2l/",
    "width": 720,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75326",
    "slug": "the-hardest-game-in-world-and-ever",
    "title": "The Hardest Game in World and Ever",
    "description": "Hardcore arcade game: Survive 30 levels with orcs! Collect keys, unlock doors and fight through obstacles. Retro-style action game with challenging gameplay! Test your skills in this hardcore arcade action game where every second counts. 30 intense levels are packed with relentless orcs, deadly traps, and environmental puzzles that will challenge your wit. The core loop is addictive yet demanding: find hidden keys scattered throughout each maze-like stage to unlock doors and progress further. Every level introduces new challenges, ramping up the difficulty and requiring quick reflexes, strategic planning, and sheer determination.",
    "instructions": "HOW TO PLAY WASD - Movement Controls Arrows larr rarr uarr darr - Movement Controls Touchpad - Movement Controls",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2026 games",
      "2D",
      "Collecting",
      "Mobile",
      "Timing",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/v3eus367y2qs0plh3r5s74j67432kqxf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v3eus367y2qs0plh3r5s74j67432kqxf/",
    "sourceUrl": "https://html5.gamemonetize.com/v3eus367y2qs0plh3r5s74j67432kqxf/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75396",
    "slug": "escape-the-police",
    "title": "Escape the Police",
    "description": "Youre a wanted man mr.X!!! Dont let the police near you and have fun!!! Escape the Police is a simple html game developed in 2025 by FLGames",
    "instructions": "WASD or arrows to move",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Police"
    ],
    "thumbnail": "https://img.gamemonetize.com/2lzr44fn0gin4uqxgjfqcbqt1ul43r6h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2lzr44fn0gin4uqxgjfqcbqt1ul43r6h/",
    "sourceUrl": "https://html5.gamemonetize.com/2lzr44fn0gin4uqxgjfqcbqt1ul43r6h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75399",
    "slug": "niche-shift",
    "title": "Niche Shift",
    "description": "Dive into the Deep Blue! Niche Shift is a deceptively simple strategy puzzle that challenges you to build a thriving ocean ecosystem. It starts with a simple swipe: merge Plankton to create Krill, merge Krill to create Fish, and evolve your way up the food chain to the legendary Leviathan. But the ocean is a dangerous place. Unlike standard merging games, your creatures have needs. The Twist: Hunger &amp; Balance High-level predators (Level 3+) arent just tiles&mdash;they are living creatures. Every time you move, they get hungrier. You must merge them to feed them, or they will starve and turn into Bones&mdash;useless obstacles that clog your re",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io",
      "2048",
      "Hypercasual",
      "Puzzle",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/2nyi42eoickamix42wswu2vm27vxwbsl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2nyi42eoickamix42wswu2vm27vxwbsl/",
    "sourceUrl": "https://html5.gamemonetize.com/2nyi42eoickamix42wswu2vm27vxwbsl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75431",
    "slug": "tung-sahur-tycoon-obby",
    "title": "Tung Sahur Tycoon + Obby",
    "description": "Run, jump, and build your empire in Tung Sahur Obby, a colorful 3D parkour game where fast-paced obby challenges meet addictive tycoon progression. Complete obstacle courses, earn rewards, spin the wheel, collect playtime bonuses, and upgrade your tycoon to grow stronger with every run.",
    "instructions": "MOVE WASD JUMP SPACE",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io",
      "1 Player",
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Fun",
      "jump",
      "roblox",
      "Sahur",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/1nczdtzx4skiljsoch95spcd7hdpyq6h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1nczdtzx4skiljsoch95spcd7hdpyq6h/",
    "sourceUrl": "https://html5.gamemonetize.com/1nczdtzx4skiljsoch95spcd7hdpyq6h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75444",
    "slug": "color-switch-dash",
    "title": "Color Switch Dash",
    "description": "Color Switch Dash is a fast-paced hyper-casual arcade game that challenges your reflexes and timing. Control a constantly moving shape and switch its color to match incoming obstacles. Only the correct color lets you pass, and one mistake ends the run. The longer you survive, the faster and more intense the game becomes. With smooth controls, bright neon visuals, and endless gameplay, Color Switch Dash is easy to learn but hard to master. Compete against your own best score, react quickly, and test your focus in this addictive color-matching challenge designed for quick and satisfying play sessions.",
    "instructions": "Tap or click to change your color and match incoming obstacles Pass through the correct colors to survive while the game speeds up Score increases over time One wrong color ends the game",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Ball",
      "Color",
      "Coloring",
      "endless"
    ],
    "thumbnail": "https://img.gamemonetize.com/amnpg3qf18rjprac8lygop6syizmtlvu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/amnpg3qf18rjprac8lygop6syizmtlvu/",
    "sourceUrl": "https://html5.gamemonetize.com/amnpg3qf18rjprac8lygop6syizmtlvu/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73293",
    "slug": "aqua-logics-puzzle-new",
    "title": "Aqua   Logics puzzle new",
    "description": "Water Sorting Puzzle is a relaxing and addictive brain-training game. Your goal is simple &mdash; sort the colored water into the correct bottles until each tube contains only one color. It starts easy but becomes more challenging with every level! Plan your moves carefully, use logic, and experience the ultimate satisfaction when every bottle is perfectly sorted. Perfect for puzzle lovers of all ages! Features 100+ mind-refreshing levels Calming gameplay and smooth animations No timer &mdash; play at your own pace Undo option for smarter play Increasing difficulty to boost brain IQ Try now and train your mind while having fun!",
    "instructions": "Game Controls Desktop PC Click on a bottle to pick it up Click on another bottle to pour the water Mobile Touch Tap on a bottle to select Tap on another bottle to pour You can pour only if The target bottle has space The water on top is the sam",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Puzzle",
      "Relaxation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/1jra3of7hdmts3copvj012iw2ygtd0ut/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1jra3of7hdmts3copvj012iw2ygtd0ut/",
    "sourceUrl": "https://html5.gamemonetize.com/1jra3of7hdmts3copvj012iw2ygtd0ut/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75627",
    "slug": "circle-rush-trolley-run",
    "title": "Circle Rush Trolley Run",
    "description": "Circle Rush Trolley Run is a super addictive arcade racing and running game that will hook you from the very first second. Dash through a futuristic world made of spinning circle tracks. Speed, timing, and quick reactions are everything. Seize the moment to collect blocks, assemble them into a circle to unleash your invincible skill.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Block",
      "Obstacle",
      "running",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/i56dhqt93jgj8vle7de50y3k7nhgboba/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i56dhqt93jgj8vle7de50y3k7nhgboba/",
    "sourceUrl": "https://html5.gamemonetize.com/i56dhqt93jgj8vle7de50y3k7nhgboba/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "75513",
    "slug": "parking-master-license-exam",
    "title": "Parking Master: License Exam",
    "description": "Varied difficulty levels: start with simple parking spots in open areas and gradually move on to more challenging scenarios, such as parallel parking on narrow streets or parking under time pressure. From city streets to busy supermarket parking lots, each location requires a different approach. Avoid obstacles like other cars, poles, or even construction materials to reach your parking spot. Realistic physics and controls: feel the weight and inertia of your car in every maneuver. Control the steering, acceleration, and brakes with realistic controls to achieve perfect parking.",
    "instructions": "PC bull W mdash accelerate bull S mdash brake bull A mdash steer left bull D mdash steer right Smartphone Tablet bull Tap hold the right pedal mdash accelerate bull Tap hold the left pedal mdash brake bull Swipe left or r",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "2026 games",
      "Best Games",
      "Brainrot Italian",
      "Car",
      "carparking",
      "Cars",
      "Cartoon",
      "crash",
      "Crazy",
      "Driving",
      "Parking",
      "Supercars",
      "trial car"
    ],
    "thumbnail": "https://img.gamemonetize.com/eluo7qyi771dcbatizylr0moyn88eima/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eluo7qyi771dcbatizylr0moyn88eima/",
    "sourceUrl": "https://html5.gamemonetize.com/eluo7qyi771dcbatizylr0moyn88eima/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75616",
    "slug": "deep-digger-tycoon",
    "title": "Deep Digger Tycoon",
    "description": "Deep Digger Tycoon is a satisfying digging and upgrade tycoon where every scoop can turn into profit. Dig into the ground to uncover treasures and valuable rewards, sell them for coins, and reinvest your earnings to become a stronger, faster, richer digger.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "idle",
      "Management",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/a7b298qmcww2351ciephg64i24o67ulq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a7b298qmcww2351ciephg64i24o67ulq/",
    "sourceUrl": "https://html5.gamemonetize.com/a7b298qmcww2351ciephg64i24o67ulq/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75591",
    "slug": "slimeadventure",
    "title": "SlimeAdventure",
    "description": "Slime Adventure is a fun action game where you control a green slime venturing into challenging levels. Your mission is to skillfully move, avoid dangers, and eliminate red slimes to clear the level. Each level has its own layout and difficulty, requiring quick reflexes and strategic thinking. With fast-paced gameplay and vibrant visuals, Slime Adventure offers exciting and thrilling entertainment.",
    "instructions": "- A D or left and right arrows to move - Space to jump - Use the mouse to shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Fight",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/itrfkwlr4oqbyryljnm3epb57se9inuo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/itrfkwlr4oqbyryljnm3epb57se9inuo/",
    "sourceUrl": "https://html5.gamemonetize.com/itrfkwlr4oqbyryljnm3epb57se9inuo/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74084",
    "slug": "2048-shoot-merge-number-3d",
    "title": "2048 Shoot Merge Number 3D",
    "description": "A fresh 3D take on classic 2048! Aim, shoot and merge numbered blocks (2&rarr;4&rarr;8&rarr;&hellip;&rarr;2048) for satisfying upgrades. Match numbers to merge, boost your score and clear space. Intuitive one-touch controls make it easy to learn, but strategize to avoid filling the board! Enjoy crisp 3D visuals and smooth animations as you chase 2048 (and beyond) in endless mode. Play offline anytime, train your brain, beat your high score&mdash;perfect for casual breaks and logic fans!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2048",
      "3D",
      "blocky",
      "Geometry",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/a5n46az8ma9tlaqre5wzz0yn0rqv354l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a5n46az8ma9tlaqre5wzz0yn0rqv354l/",
    "sourceUrl": "https://html5.gamemonetize.com/a5n46az8ma9tlaqre5wzz0yn0rqv354l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75270",
    "slug": "music-sword-beat",
    "title": "Music Sword Beat",
    "description": "Step into the world of Music Sword Beat, the ultimate 3D rhythm action game! Play piano-style beats while dashing forward with a glowing music sword. Slice enemies, dodge obstacles, and race through neon worlds synced perfectly to epic music. Enjoy hip-hop vibes, Y2K tracks, pop hits, and classical beats all in one game. Inspired by rhythm mods, you play as a brave Boyfriend protecting his Girlfriend from indie enemies. Tap, slash, and run to the beat in this thrilling music race gameplay.",
    "instructions": "Mouse swipe to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Action",
      "Arcade",
      "Best Games",
      "Casino",
      "Casual",
      "Music",
      "Rhythm",
      "Sword",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/2hir0b99mewrlpwr0dikzsz0ebp15kte/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2hir0b99mewrlpwr0dikzsz0ebp15kte/",
    "sourceUrl": "https://html5.gamemonetize.com/2hir0b99mewrlpwr0dikzsz0ebp15kte/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75551",
    "slug": "vampires-edge",
    "title": "Vampires Edge",
    "description": "Vampires on Limit is an incredibly addictive arcade hit where simple rules yield hours of gripping chaos. Your goal is clear from the very first second: survive as long as possible against endless hordes of night undead.",
    "instructions": "In this game your character attacks automatically You dont need to press the shoot button-instead your entire focus is on survival tactics Dodge hordes of monsters collect experience from defeated enemies and make the most important choice",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "amazing",
      "Android",
      "Battle",
      "Casual",
      "Hypercasual",
      "Mobile",
      "survival",
      "unity",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/5m09h3om0f88t8yt498darkhwc5t10f3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5m09h3om0f88t8yt498darkhwc5t10f3/",
    "sourceUrl": "https://html5.gamemonetize.com/5m09h3om0f88t8yt498darkhwc5t10f3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75588",
    "slug": "horror-eye",
    "title": "Horror Eye",
    "description": "Horror Eyes is a horror 3D game where you wake up in a house, and it is dark in this house, and there is a dangerous monster in this house from which you have to escape and get out of the house, and there are some items with the help of which you have to escape from this monster",
    "instructions": "Tap on screen and use keyboard",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "Action",
      "Adventure",
      "Casual",
      "Game",
      "Horror",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/2dzkz4ddpprxjcpwfs1akerpw2b2wfjv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2dzkz4ddpprxjcpwfs1akerpw2b2wfjv/",
    "sourceUrl": "https://html5.gamemonetize.com/2dzkz4ddpprxjcpwfs1akerpw2b2wfjv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75313",
    "slug": "time-fracture",
    "title": "Time Fracture",
    "description": "Time Fracture is a fast-paced sci-fi arcade game where time itself becomes your weapon and your enemy. Run through unstable zones, slow time using energy control, survive gravity failures, ghost anomalies, and time jammers. Each day brings a unique daily protocol with new modifiers, making every run different. Test your reflexes, timing, and skill as difficulty increases the longer you survive. Can you stay synchronized, or will the system collapse? Play daily, master the anomalies, and achieve the highest sync score.",
    "instructions": "Click Tap Space ndash Jump Hold ndash Slow Time Release ndash Resume Time",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Arcade",
      "endless",
      "HTML5",
      "Hypercasual",
      "onetouch",
      "running",
      "Skill",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/qp2o7dtau87qwwunwdpgzjjk551jhs2r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qp2o7dtau87qwwunwdpgzjjk551jhs2r/",
    "sourceUrl": "https://html5.gamemonetize.com/qp2o7dtau87qwwunwdpgzjjk551jhs2r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73632",
    "slug": "shape-shift-survival",
    "title": "Shape Shift Survival",
    "description": "Shape Shift Survival is a fast-paced reflex arcade game where players must instantly switch shapes to survive incoming obstacles. Test your reaction speed, focus, and timing as the game gradually becomes faster and more challenging. Every correct move increases your score, while a single mistake ends the run. With smooth controls, responsive gameplay, and clean visuals, Shape Shift Survival is easy to play but hard to master. Perfect for quick sessions on both mobile and desktop devices.",
    "instructions": "Desktop press 1 2 and 3 Mobile bull Tap Buttons",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Click",
      "endless",
      "HTML5",
      "Mobile",
      "Skill",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/87g2ud84ogwty2tam636h507juf5g2ws/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/87g2ud84ogwty2tam636h507juf5g2ws/",
    "sourceUrl": "https://html5.gamemonetize.com/87g2ud84ogwty2tam636h507juf5g2ws/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73168",
    "slug": "laser-dodge-arena",
    "title": "Laser Dodge Arena",
    "description": "Enter the neon danger zone in Laser Dodge Arena! Your goal is simple: survive as long as possible. Dodge the deadly red lasers that appear randomly and move faster the longer you survive. Collect blue Shield Orbs to protect yourself and earn Coins based on your survival time. Visit the Shop to unlock cool new skins and gradient effects for your character. Can you top the leaderboard and become the ultimate survivor?",
    "instructions": "PC - Arrow Keys WASD to move Mobile - Touch and drag to move the player Objective - Avoid lasers and survive as long as possible",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Avoid",
      "Casual",
      "endless",
      "Skills",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/rww5qwbfee8ozz61ixqlyzwa915t9ebo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rww5qwbfee8ozz61ixqlyzwa915t9ebo/",
    "sourceUrl": "https://html5.gamemonetize.com/rww5qwbfee8ozz61ixqlyzwa915t9ebo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75599",
    "slug": "sea-port-controller",
    "title": "Sea Port: Controller",
    "description": "Play Seaport, a ship management and strategy simulation game! Take control of your ships in a city or island port and become a shipping tycoon! Ensure ships avoid collisions in the port and send ships that have finished their work in the port back on their voyages. Start now and strive to be the best in this game! If you enjoyed the game, please rate it!",
    "instructions": "Use the mouse or touch to draw a path for the ships to go to the port",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "Boat",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/zl3m33542jw0z8zlfr9yq1wz7g7pekv1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zl3m33542jw0z8zlfr9yq1wz7g7pekv1/",
    "sourceUrl": "https://html5.gamemonetize.com/zl3m33542jw0z8zlfr9yq1wz7g7pekv1/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75607",
    "slug": "labubu-platform-challenge",
    "title": "Labubu Platform Challenge",
    "description": "Labubu Platform Challenge is an incredibly entertaining online game designed for children. Remain on the platform for as long as you can and gather food to increase your score. The platform will evolve over time, making it harder to maintain balance. Have fun!",
    "instructions": "Mouse or arrow keys to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Collecting",
      "Jumping",
      "Kids",
      "Labubu",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/649lq46cbaiyun0yeadn05rpyp2v2ayn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/649lq46cbaiyun0yeadn05rpyp2v2ayn/",
    "sourceUrl": "https://html5.gamemonetize.com/649lq46cbaiyun0yeadn05rpyp2v2ayn/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "75598",
    "slug": "fruit-sort-logic",
    "title": "Fruit Sort Logic",
    "description": "Fruit Sort Logic is a fun and relaxing puzzle game where you sort colorful fruit juices on shelves. Move the juices around and match three of the same kind to clear a shelf. Space is limited, so each move matters. Clear all shelves to finish the level and unlock new ones. With smooth controls, bright visuals, and endless levels, the game is easy to play and satisfying to master. Perfect for a calm but clever puzzle experience.",
    "instructions": "Move fruit juice items between shelves and match three identical juices to clear a shelf Plan each move carefully because space is limited Clear all shelves to complete the level and continue unlocking new sorting challenges",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Logic",
      "Puzzle",
      "sort",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/xc9peayspssscylbjy2sy1xoylwpz1zn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xc9peayspssscylbjy2sy1xoylwpz1zn/",
    "sourceUrl": "https://html5.gamemonetize.com/xc9peayspssscylbjy2sy1xoylwpz1zn/",
    "width": 450,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "75510",
    "slug": "yummy-toast-2",
    "title": "Yummy Toast 2",
    "description": "Yummy Toast is the funnest cooking game ever! Your goal is to make delicious toast by tapping the correct materials and ingredients u needed. Make the tastiest toast and serve to ur customers. Be the best toast master and to unlock all the achievements!",
    "instructions": "Use MOUSE to play the game",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cook",
      "Cooking",
      "Dress Up",
      "Kids",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/mkaluzh9227iu9t3phutqs8vyld5pz5d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mkaluzh9227iu9t3phutqs8vyld5pz5d/",
    "sourceUrl": "https://html5.gamemonetize.com/mkaluzh9227iu9t3phutqs8vyld5pz5d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75561",
    "slug": "fish-super-io-eating",
    "title": "Fish Super IO Eating",
    "description": "Welcome to an exciting underwater world! In this 2D game, you begin your journey as a small fish, exploring the depths of the ocean and feeding on smaller fish to grow. With each level, your fish becomes bigger, unlocking new opportunities &mdash; hunt larger prey and dominate the underwater world. Enjoy unique levels, dynamic gameplay, and engaging mechanics. Play, grow, and become the true king of the ocean!",
    "instructions": "PC Controls The fish moves relative to the mouse position from the center of the screen bull Space or Left Mouse Button LMB mdash boost speed up Mobile Controls The fish is controlled using a standard virtual joystick bull Tap the lightning i",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2026 games",
      "Action",
      "Best",
      "Best Games",
      "Brain",
      "Brainrot",
      "Fish",
      "Fishing",
      "roblox",
      "Shark",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/boeaw04eduubp8cjsl4umvc3yw4omaro/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/boeaw04eduubp8cjsl4umvc3yw4omaro/",
    "sourceUrl": "https://html5.gamemonetize.com/boeaw04eduubp8cjsl4umvc3yw4omaro/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75564",
    "slug": "taylor-dress-studio-preppy-wild-west",
    "title": "Taylor Dress Studio Preppy Wild West",
    "description": "Welcome to the dress-up game, in which the pop diva tries on three completely different fashionable looks: a youthful preppy bow, a cowboy outfit and a glamorous stage look. In addition, you can experiment with hairstyles and change the makeup of the heroine. Complete the images with accessories: glasses, hats and jewelry. Choose clothes and combine elements from different sets to create delicate, daring or superstar bows. Turn Taylor into an icon of any style!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Hair",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/ddnz8cfibheh21ir6qziwazysr37a2lv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ddnz8cfibheh21ir6qziwazysr37a2lv/",
    "sourceUrl": "https://html5.gamemonetize.com/ddnz8cfibheh21ir6qziwazysr37a2lv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75577",
    "slug": "furniture-master-and-ndash-build-your-furniture-stor",
    "title": "Furniture Master &ndash; Build Your Furniture Stor",
    "description": "Welcome to an exciting world where every player becomes the architect of their own crafting empire. Explore rich resource zones and embark on a rewarding journey of furniture creation &mdash; from the very first design steps to fully finished masterpieces. Your task is not only to gather and process resources, but also to build beautiful interiors. Here, your crafting skills are the key to creating unique furniture items that can decorate the homes of other players. Grow your abilities and become a true design legend. Hire employees and upgrade your production by automating processes and increasing efficiency. Forge your path to success, overcome",
    "instructions": "Controls Use the W-A-S-D keys to control the character on PC or a virtual joystick on mobile devices Purchases To buy workers factories or display stands step into the marked squares with a banknote icon When you enter the square the required cur",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Arcade",
      "Balance",
      "Best",
      "Best Games",
      "Brainrot",
      "Casual",
      "gta",
      "idle",
      "Mario",
      "Minecraft",
      "Miner",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/butmcsxmnd2oq7njl840dl93foobn68q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/butmcsxmnd2oq7njl840dl93foobn68q/",
    "sourceUrl": "https://html5.gamemonetize.com/butmcsxmnd2oq7njl840dl93foobn68q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74579",
    "slug": "blocky-combat-swat-original-2026",
    "title": "Blocky Combat Swat Original 2026",
    "description": "Dive into the pixelated chaos of Blocky Combat Swat Original 2026, the ultimate evolution of the classic voxel shooter. Engage in high-stakes tactical warfare across diverse, destructible environments. Whether youre storming strongholds in single-player missions or dominating the leaderboard in fast-paced multiplayer arenas, the 2026 edition delivers refined mechanics, a massive arsenal of blocky weaponry, and vibrant, low-poly graphics. Web Dev <a href='https://www.coolcrazygames.com/'>https://www.coolcrazygames.com/</a> Grab your gear and lead your squad to victory!",
    "instructions": "Tab in game menu WASD walk Mouse to shoot aim scroll weapons",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "blocky",
      "Mentolatux",
      "Multiplayer",
      "Shooting",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/kuryjdyq83t9camx2htr964na2j4eev0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kuryjdyq83t9camx2htr964na2j4eev0/",
    "sourceUrl": "https://html5.gamemonetize.com/kuryjdyq83t9camx2htr964na2j4eev0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75579",
    "slug": "samuroof",
    "title": "Samuroof",
    "description": "In this game, the ninja has to run across buildings, defeat the enemies that appear in front, and collect coins. Each level becomes more difficult than the last, and the game is really fun to play. play more game on crazycubix.com",
    "instructions": "Tap on screen",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Adventure",
      "amazing",
      "attack",
      "Best Games",
      "Jumping",
      "Puzzle",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ssz71vvwsjg2f6r388lpevzjbkkyjsf5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ssz71vvwsjg2f6r388lpevzjbkkyjsf5/",
    "sourceUrl": "https://html5.gamemonetize.com/ssz71vvwsjg2f6r388lpevzjbkkyjsf5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75578",
    "slug": "fruit-slicings",
    "title": "Fruit Slicings",
    "description": "Endless game that puts your ninja skills to the test as you slice through a cascade of juicy fruits while skillfully avoiding deadly bombs! As a master ninja, your objective is clear: slice as many fruits as you can, but beware of the bombs that threaten to end your slicing spree. play more game on crazycubix.com",
    "instructions": "Tap on screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "amazing",
      "Arcade",
      "Best Games",
      "Fruit",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/v5nbuh25d5noyvcwtuf4smvn5sggn91u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v5nbuh25d5noyvcwtuf4smvn5sggn91u/",
    "sourceUrl": "https://html5.gamemonetize.com/v5nbuh25d5noyvcwtuf4smvn5sggn91u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75575",
    "slug": "dead-rails",
    "title": "Dead Rails",
    "description": "The world of the Wild West has collapsed under the onslaught of an unknown virus that turns people into zombie freaks . The only salvation is your armored train, hurtling through the ruins in search of survivors and hope. Infiltrate abandoned cities , clear buildings, mine resources and find rare gear . Upgrade weapons and stock up on fuel to overcome the dangerous path to the last station where the cure may be hiding. Each new kilometer is a deadly challenge . Fight mutants, repel zombie raids, upgrade the train Will you be able to survive and bring the expedition to the end?",
    "instructions": "PC W A S D - movement E - pick up a specific item G - discard an item LKM - drag or shoot Mobile device Left joystick - movement Right side of the screen - camera rotation and buttons Train control W - forward S - stop Space - get off the train Mobile",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "3D Games",
      "Action",
      "Adventure",
      "amazing",
      "First Person Shooter",
      "roblox",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/r9iyyfr6vf2bi7eau07elxfbpp85oaoh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r9iyyfr6vf2bi7eau07elxfbpp85oaoh/",
    "sourceUrl": "https://html5.gamemonetize.com/r9iyyfr6vf2bi7eau07elxfbpp85oaoh/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75477",
    "slug": "idle-defense-grid",
    "title": "Idle Defense Grid",
    "description": "Idle Defense Grid is a minimalist strategy game that combines classic tower defense mechanics with idle progression. Place towers on a small grid, defend your base from incoming enemy waves, and earn resources over time to strengthen your defenses. Every decision matters, as limited space forces you to think carefully about positioning and upgrades. With clean visuals, smooth gameplay, and gradually increasing difficulty, Idle Defense Grid offers a relaxed yet strategic experience. Easy to understand but challenging to master, the game rewards smart planning and long-term thinking.",
    "instructions": "Place towers on the grid to stop incoming enemies Towers attack automatically while you earn resources over time Upgrade your defenses survive increasingly difficult waves and protect your base as long as possible",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Arcade",
      "attack",
      "Ball",
      "Battle",
      "battleship",
      "Casual",
      "Defense",
      "destroying",
      "Hypercasual",
      "Strategy",
      "Tower Defense",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/c9k0gi1qlic81de068mj5c09rvfdobek/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c9k0gi1qlic81de068mj5c09rvfdobek/",
    "sourceUrl": "https://html5.gamemonetize.com/c9k0gi1qlic81de068mj5c09rvfdobek/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75472",
    "slug": "muscle-master-quest",
    "title": "Muscle Master Quest",
    "description": "Muscle Master Quest &ndash; Smash Running is an action-packed runner game where strength is your greatest weapon. Run through exciting obstacle courses, smash barriers, defeat enemies, and collect power-ups to grow stronger with every step. Time your moves carefully as each obstacle tests your muscle power and strategy. Upgrade your strength, unlock fun character skins, and face powerful boss challenges that push your limits. With fast-paced gameplay, satisfying smashing mechanics, and endless running action, Muscle Rush delivers a thrilling experience where only the strongest runners reach the finish line.",
    "instructions": "Tap mouse click and drag move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Action",
      "builder",
      "Casual",
      "Fight",
      "Game",
      "quest",
      "Race",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/sqcs64vvvbk3qimwnv4xqmyus9dcbk1j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sqcs64vvvbk3qimwnv4xqmyus9dcbk1j/",
    "sourceUrl": "https://html5.gamemonetize.com/sqcs64vvvbk3qimwnv4xqmyus9dcbk1j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75389",
    "slug": "dinosaur-merge-quest",
    "title": "Dinosaur Merge Quest",
    "description": "Can you think fast enough to merge dinosaurs and warriors to create the ultimate dino squad? Your mission is simple: combine your troops, form powerful fusions, and fight off waves of enemies! In Dinosaur Merge Quest, strategy is key. Merge dinosaurs, dragons, and mighty warriors in real-time to build unstoppable teams. Use quick thinking and clever tactics to dominate the battlefield in this epic dinosaur and monster battle simulator! React, merge, and fight your way to victory in the coolest dinosaur fusion game.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "Casual",
      "dino",
      "Dinosaur",
      "Fun",
      "idle",
      "Monster",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/u4zk80262v3hqvuvvwbu18y45m7t4a3t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u4zk80262v3hqvuvvwbu18y45m7t4a3t/",
    "sourceUrl": "https://html5.gamemonetize.com/u4zk80262v3hqvuvvwbu18y45m7t4a3t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75567",
    "slug": "hill-climb-racing-adventure",
    "title": "Hill Climb Racing Adventure",
    "description": "Play the original classic Hill Climb Racing! Race your way uphill in this physics based driving game, playable offline! Meet Bill, the young aspiring uphill racer. He is about to embark on a journey through Climb Canyon that takes him to where no ride has ever been before. With little respect to the laws of physics, Bill will not rest until he has conquered the highest hills up on the moon!",
    "instructions": "use forward and backward arrow keys",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2026 games",
      "Car",
      "Driving",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/4gytlbqiojhlxt2r5vc4sbma091103b5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4gytlbqiojhlxt2r5vc4sbma091103b5/",
    "sourceUrl": "https://html5.gamemonetize.com/4gytlbqiojhlxt2r5vc4sbma091103b5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75445",
    "slug": "tower-war",
    "title": "Tower War",
    "description": "Tower War is a fast and exciting strategy game where you compete to take over enemy towers. The rules are simple, but winning takes skill: drag from your base to an enemy tower to send your troops and capture it. Connect towers smartly and act quickly to outplay your opponent and take control. Every level is unique, with different tower arrangements and challenges that test your timing and strategy. You&rsquo;ll need to think fast, plan your moves, and react to the enemy before they strike back. With over 30 fun and challenging levels, each stage brings a new puzzle to solve and more action to enjoy.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Best",
      "Best Games",
      "Enemies",
      "Enemy",
      "Fighting",
      "Fun",
      "Puzzle",
      "Skill",
      "Strategy",
      "Tower Defense",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/hanpmswo083n98n78adtiocwyg635x1d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hanpmswo083n98n78adtiocwyg635x1d/",
    "sourceUrl": "https://html5.gamemonetize.com/hanpmswo083n98n78adtiocwyg635x1d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75522",
    "slug": "keep-her-alive",
    "title": "Keep Her Alive",
    "description": "Keep Her Alive is a precision puzzle game where you don&rsquo;t fight enemies &mdash; you turn them against each other. Rotate the world, line up the angles, and let their own bullets do the work. One wrong degree and the girl dies. There are no second chances. Think slowly. Aim carefully. Keep Her Alive.",
    "instructions": "Rotate objects using A and D or the Left and Right Arrow keys Shoot using the Left Mouse Button or the Space Bar",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Boys",
      "Funny",
      "Girl",
      "Gun",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/g5639hr3p3avxhnt8bv9guohjeh5efk2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g5639hr3p3avxhnt8bv9guohjeh5efk2/",
    "sourceUrl": "https://html5.gamemonetize.com/g5639hr3p3avxhnt8bv9guohjeh5efk2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75536",
    "slug": "noob-survival-battle-royale",
    "title": "Noob Survival: Battle Royale",
    "description": "Players fight against each other on a vast map, aiming to be the last one standing. The game starts with players dropping from a plane onto the battlefield, then battling opponents while trying to survive inside a constantly shrinking safe zone. Key Features Huge Map: Explore diverse locations, including cities, forests, mountains, and bodies of water. Immersive Graphics: Enjoy impressive visuals and detailed environments. Tactical Gameplay: Use strategy and smart positioning to defeat enemies and stay alive. Game Mechanics Drop-In Start: Begin each match by jumping from a plane and choosing the best landing spot.",
    "instructions": "PC Controls bull WASD mdash move bull Shift mdash sprint bull P mdash remove parachute bull 1 2 3 4 5 6 mdash switch weapons Mobile Controls bull Use the on-screen buttons bull Move and aim with the standard virtual joysticks",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "attack",
      "Avoid",
      "Best Games",
      "Bow",
      "Brainrot Italian",
      "Cartoon",
      "Gun",
      "Minecraft",
      "roblox",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/9b58615hck0sv5v8pzt0o2icj059g09r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9b58615hck0sv5v8pzt0o2icj059g09r/",
    "sourceUrl": "https://html5.gamemonetize.com/9b58615hck0sv5v8pzt0o2icj059g09r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75508",
    "slug": "funny-pet-haircut-2",
    "title": "Funny Pet Haircut 2",
    "description": "Take your messy pets, alpaca and cat to the hair salon. Wash and dry your pets before giving them a brand new look by changing their colors and giving them pattern look. Dress up too. And turn them into a stylish beauty!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Doctor",
      "Dress Up",
      "Fashion",
      "Hair"
    ],
    "thumbnail": "https://img.gamemonetize.com/cdz2oen9lmt5h1pg4hurtp4jg008cjng/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cdz2oen9lmt5h1pg4hurtp4jg008cjng/",
    "sourceUrl": "https://html5.gamemonetize.com/cdz2oen9lmt5h1pg4hurtp4jg008cjng/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75498",
    "slug": "dinosaur-evolution-io",
    "title": "Dinosaur Evolution IO",
    "description": "Grow your dragon and take it to the peak of evolution! Eat fruits, defeat other players, and become the most powerful creature in this world. Choose your playstyle &mdash; will you be a fast and aggressive hunter, or a careful strategist who defends their territory? Dive into an exciting growth and evolution journey, upgrade your dragon&rsquo;s abilities, and adapt to a constantly changing world. Explore new areas and become a true legend among dragons! Features: &bull; Eat, fight, and survive in fast-paced battles &bull; Evolve and reach new stages of evolution &bull; Unlock and explore new territories &bull; Become the strongest dragon in the game!",
    "instructions": "On PC bull WASD mdash movement control On mobile bull Swipe on the screen mdash movement",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2026 games",
      "Arcade",
      "beauty",
      "Bounce",
      "Brainrot Italian",
      "dino",
      "Dinosaur",
      "Dragon",
      "eating",
      "Minecraft",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/ykl7foe8q8olus573dq1zubicm5rbbz2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ykl7foe8q8olus573dq1zubicm5rbbz2/",
    "sourceUrl": "https://html5.gamemonetize.com/ykl7foe8q8olus573dq1zubicm5rbbz2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75507",
    "slug": "yummy-hotdog-2",
    "title": "Yummy Hotdog 2",
    "description": "Make your own yummy hotdog from the scratch. Get the materials and ingredients you needed. Start mixing them and getting your batter ready. Control everything, garnishing with sauce and add toppings to make ur hotdog even tastier. Finish your perfect hotdog and unlock all the achievements of the game!",
    "instructions": "Use MOUSE to play the game",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cooking",
      "Dress Up",
      "Girls",
      "HTML5",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/tq5hqw0gvvdifelc7k0htqvcjgozgr8r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tq5hqw0gvvdifelc7k0htqvcjgozgr8r/",
    "sourceUrl": "https://html5.gamemonetize.com/tq5hqw0gvvdifelc7k0htqvcjgozgr8r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75480",
    "slug": "labubu-wheelie-challenge",
    "title": "Labubu Wheelie Challenge",
    "description": "Join us on a thrilling ride with Labubu Wheelie Challenge, where balance and precision are your best friends. This free online game demands skillful maneuvering as you strive to perform the perfect wheelie. Available on both phone and computer, this game promises an engaging experience for all enthusiasts of vehicular stunts. Challenge yourself to maintain balance while navigating through a series of obstacles and collecting coins to boost your score. Can you conquer the levels and become the ultimate wheelie champion?",
    "instructions": "The left and right buttons are your primary tools for balancing the jeep Accelerate cautiously to maintain a wheelie and use these buttons to prevent the vehicle from flipping over during challenging sections",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Avoid",
      "Balance",
      "Car",
      "Collecting",
      "Driving",
      "jeep",
      "Labubu",
      "Mouse"
    ],
    "thumbnail": "https://img.gamemonetize.com/3d9ytpsyjynmfm0lgrmoux9bfcuv8xuc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3d9ytpsyjynmfm0lgrmoux9bfcuv8xuc/",
    "sourceUrl": "https://html5.gamemonetize.com/3d9ytpsyjynmfm0lgrmoux9bfcuv8xuc/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "75401",
    "slug": "my-cat-restaurant",
    "title": "My Cat Restaurant",
    "description": "Welcome to My Cat Restaurant, a casual kids cooking simulator game that you can play for free. Act as a chef and restaurant manager. Take orders, cook food, serve customers, and collect money. Plan your moves and workload in advance, and figure out an efficient routine.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Animal",
      "Collecting",
      "Restaurant"
    ],
    "thumbnail": "https://img.gamemonetize.com/zro5d0oom4aubos4mlka610s5mla0zt3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zro5d0oom4aubos4mlka610s5mla0zt3/",
    "sourceUrl": "https://html5.gamemonetize.com/zro5d0oom4aubos4mlka610s5mla0zt3/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75398",
    "slug": "fun-mini-games-for-kids",
    "title": "Fun Mini Games For Kids",
    "description": "Welcome to Fun Mini Games For Kids, a casual minigame collection for kids on H5games4u. Are you a game lover? Want to enjoy diverse types of relaxing minigames all in one? Join H5games4us best kids games. Play doctor simulation games, match shapes in avatar-making games, dress up Brainrot memes, or design room settings.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Kids",
      "Relaxation",
      "Simulation",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/i2q8vghjgrthrslxwfixl7zl4k932rbn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i2q8vghjgrthrslxwfixl7zl4k932rbn/",
    "sourceUrl": "https://html5.gamemonetize.com/i2q8vghjgrthrslxwfixl7zl4k932rbn/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "75148",
    "slug": "spill-the-wine",
    "title": "Spill the wine",
    "description": "Spill It! is an addictive physics-based puzzle game where you drop balls to knock over glasses and spill everything. Enjoy fun casual arcade gameplay, simple controls, and challenging levels. Perfect for quick play sessions and offline puzzle game lovers.",
    "instructions": "use mouse control to spill the ball",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "Color",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/isgdnfg7nrb5l8fw66063hynp2arj05t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/isgdnfg7nrb5l8fw66063hynp2arj05t/",
    "sourceUrl": "https://html5.gamemonetize.com/isgdnfg7nrb5l8fw66063hynp2arj05t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73896",
    "slug": "sudoku-9x9",
    "title": "Sudoku 9x9",
    "description": "In this game, you need to fill a 9&times;9 grid with numbers so that each column, row, and small square contains digits from 1 to 9. You can use hints during the game. There are three difficulty levels available: easy, medium, and hard.",
    "instructions": "The main rule of Sudoku is that numbers must not repeat in rows columns or small squares There are three difficulty levels available easy medium and hard The higher the difficulty the fewer numbers are filled in at the start You can use hints to",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "free html5 games for your website",
      "Puzzle",
      "Sudoku"
    ],
    "thumbnail": "https://img.gamemonetize.com/fao1vekxb0636oat1c083l9n6kcjasaw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fao1vekxb0636oat1c083l9n6kcjasaw/",
    "sourceUrl": "https://html5.gamemonetize.com/fao1vekxb0636oat1c083l9n6kcjasaw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75152",
    "slug": "line-color-puzzle-game",
    "title": "Line Color Puzzle Game",
    "description": "Slide and paint your way through a world of line color in Line Color 3D, the exciting color adventure game. With just a tap and hold, make your cube runner glide along the path, watching it masterfully draw the color line. This isnt just a game; its a vibrant color 3D journey! Seeking a peaceful escape after a long day? Line Color 3D is your go-to stress buster. This line color game is an ideal way to relax and let go. Download this color adventure and immerse yourself in a world where the only task is to color lines and enjoy the tranquility.",
    "instructions": "Mouse click and hold to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Action",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/m4o7lueza84sd0qy0wrn991ups3x1l64/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m4o7lueza84sd0qy0wrn991ups3x1l64/",
    "sourceUrl": "https://html5.gamemonetize.com/m4o7lueza84sd0qy0wrn991ups3x1l64/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75160",
    "slug": "memory-emoji",
    "title": "Memory Emoji",
    "description": "Try a fun new spin of the classic memory game with Memory Emoji!! Find all the couples of emojis to win in this wonderful game developed by FLGames in 2025",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Memory"
    ],
    "thumbnail": "https://img.gamemonetize.com/3s56bhfz1vc2njsrlqzgnfs9m2r9eabf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3s56bhfz1vc2njsrlqzgnfs9m2r9eabf/",
    "sourceUrl": "https://html5.gamemonetize.com/3s56bhfz1vc2njsrlqzgnfs9m2r9eabf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75439",
    "slug": "neon-directive",
    "title": "Neon Directive",
    "description": "Neon Directive revives the classic arcade thrill with a futuristic twist! Master the bounce, shatter bricks, and unlock spectacular powers like Multi-Ball and the mysterious Ghost Ball across 30 unique, progressively challenging levels. Experience silky-smooth paddle controls for pixel-perfect saves. Simple to learn, tough to master, plan your shots andunleash chaos, Ready to top the high score?",
    "instructions": "Space Bar - Shoot Ball Arrow Keys - Move paddle left right",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Arkanoid",
      "Bricks",
      "Casual",
      "destroy",
      "Highscore",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/uld6tyf7inegdrqfnx6w34vj3jqdtzv2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uld6tyf7inegdrqfnx6w34vj3jqdtzv2/",
    "sourceUrl": "https://html5.gamemonetize.com/uld6tyf7inegdrqfnx6w34vj3jqdtzv2/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "75470",
    "slug": "hatchling-heroes-arena",
    "title": "Hatchling Heroes Arena",
    "description": "Hatchling Heroes Arena is a fast and fun arena battle game where your fighters are born from eggs&mdash;and powered up through merging. On the home screen, collect and merge egg heroes to unlock stronger characters. Each hero comes with a unique skill, different stats, and its own playstyle.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "Arena",
      "Battle",
      "Casual",
      "egg",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/1n46w168ijo5mtlbbeo8rcqm2r7hhrw0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1n46w168ijo5mtlbbeo8rcqm2r7hhrw0/",
    "sourceUrl": "https://html5.gamemonetize.com/1n46w168ijo5mtlbbeo8rcqm2r7hhrw0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75429",
    "slug": "starry-bridge-physics-puzzle",
    "title": "Starry Bridge Physics Puzzle",
    "description": "Starry Bridge: Physics Puzzle is a captivating and brain-challenging game that tests your problem-solving skills like never before. Navigate through a series of levels filled with gravity-defying obstacles, interactive objects, and clever physics-based challenges. Use your creativity and understanding of physics to build bridges, trigger chain reactions, and find innovative solutions to reach your goals. With intuitive controls and engaging gameplay, Starry Bridge: Physics Puzzle promises hours of fun and mental stimulation for players of all ages. Get ready to construct, experiment, and master the laws of physics to conquer every level!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Brain",
      "construction",
      "Fun",
      "Game",
      "Kids",
      "Physics",
      "Puzzle",
      "Space",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/ili7ddydq63jj8ox6cb5r81iqiwhjoe8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ili7ddydq63jj8ox6cb5r81iqiwhjoe8/",
    "sourceUrl": "https://html5.gamemonetize.com/ili7ddydq63jj8ox6cb5r81iqiwhjoe8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75494",
    "slug": "pixel-amphibian",
    "title": "Pixel Amphibian",
    "description": "Pixel Amphibian is a fast-paced endless runner where quick reflexes and perfect timing keep a pixelated toad hopping forward. Guide your toad through a vibrant pixel world filled with ever-changing obstacles. Jump, dodge, and react in split seconds as the speed steadily increases and the path becomes more unpredictable. One mistimed hop can end the run, so staying focused is the key to survival. As you last longer, the challenge ramps up with tighter gaps, faster obstacles, and trickier patterns. Simple controls make it easy to start, but mastering the rhythm of movement and timing every leap takes skill and practice.",
    "instructions": "Dont fall Click to jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Jumping",
      "Platform",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/tyg5373vfjlvuhp3yb3napfxk1i0pmmh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tyg5373vfjlvuhp3yb3napfxk1i0pmmh/",
    "sourceUrl": "https://html5.gamemonetize.com/tyg5373vfjlvuhp3yb3napfxk1i0pmmh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75466",
    "slug": "bouncy-ball-jump",
    "title": "Bouncy Ball Jump",
    "description": "Jump your ball upward and survive as long as you can in this fast-paced arcade game! Control a bouncy ball and help it jump higher while avoiding sharp spikes and dangerous obstacles. Perfect timing and quick reflexes are the key to success. Each jump becomes more challenging as the speed increases, testing your skills and focus. With simple one-tap controls and endless vertical gameplay, this casual hyper-arcade game is easy to play but hard to master. How high can you jump without hitting the spikes?",
    "instructions": "Left mouse click or tap to jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Avoid",
      "Ball",
      "Bounce",
      "endless",
      "Hypercasual",
      "Jumping",
      "Obstacle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/hfqstkxwa6jxhsoecei533a6gdacr94q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hfqstkxwa6jxhsoecei533a6gdacr94q/",
    "sourceUrl": "https://html5.gamemonetize.com/hfqstkxwa6jxhsoecei533a6gdacr94q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73874",
    "slug": "bubble-shooter-relaxing-puzzle",
    "title": "Bubble Shooter Relaxing Puzzle",
    "description": "Welcome to the Bubble Shooter Relaxing Puzzle shooting game world! Play the classic and the most popular free bubble shooter game! Bubble Shooter is the best relaxing bubble shooter free games. You can play Bubble Shooter on Android phones or on a PC. No time limit, no life limit, you can play this bubble pop game anywhere, it is a really relaxing shoot bubbles game. Aim, match, and blast all the balls in this relaxing color-matching adventure. This is an endless bubble pop game that is simple and easy to learn, perfect for families to enjoy.",
    "instructions": "Mouse operated - Tap the left mouse button to shoot",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "3D Games",
      "Brain",
      "Bubble",
      "Bubble Shooter",
      "Color",
      "Matching",
      "Puzzle",
      "Relaxation",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/tv66qo5zdz26osoqx597umvqyuaov0cs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tv66qo5zdz26osoqx597umvqyuaov0cs/",
    "sourceUrl": "https://html5.gamemonetize.com/tv66qo5zdz26osoqx597umvqyuaov0cs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75461",
    "slug": "parking-expert-driving-exam",
    "title": "Parking Expert: Driving Exam",
    "description": "Welcome to a game that will test your driving skills and turn you into a true parking master! You will face a variety of challenges &mdash; from parking in tight city spaces to maneuvering in complex conditions. Control your car, avoid obstacles, follow the rules, and prove that you deserve the title of the best driver! Game Features: &bull; Realistic car physics for an immersive driving experience. &bull; A wide variety of levels. &bull; Engaging tasks inspired by real driving school exams. &bull; Easy and intuitive controls suitable for both beginners and experienced players. Test your focus, precision, and agility in parking challenges. Every level is a new test",
    "instructions": "PC W mdash Accelerate S mdash Brake Reverse A mdash Steer left D mdash Steer right Smartphone Tablet Tap and hold the right pedal mdash Accelerate Tap and hold the left pedal mdash Brake Reverse Use your finger to turn the steering whee",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Adult",
      "Best",
      "Best Games",
      "Brainrot",
      "Car",
      "car tuning",
      "carparking",
      "Cartoon",
      "CSGO",
      "Minecraft",
      "Parking",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/3efo9ee8ez14ljclx20uake4khgruzf9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3efo9ee8ez14ljclx20uake4khgruzf9/",
    "sourceUrl": "https://html5.gamemonetize.com/3efo9ee8ez14ljclx20uake4khgruzf9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75467",
    "slug": "rainbow-friends-hide-and-seek",
    "title": "Rainbow Friends Hide And Seek",
    "description": "Rainbow Friends Hide And Seek is an exciting and fast-paced hide-and-seek adventure game set in a colorful yet dangerous rainbow world. Step into this thrilling role-playing experience, choose your role, and get ready for an unforgettable adventure.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Escape",
      "Hidden",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/43laukn7qonx96t8mqc4glbubfmfi5w3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/43laukn7qonx96t8mqc4glbubfmfi5w3/",
    "sourceUrl": "https://html5.gamemonetize.com/43laukn7qonx96t8mqc4glbubfmfi5w3/",
    "width": 1336,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "75460",
    "slug": "prison-master-escape-journey",
    "title": "Prison Master: Escape Journey",
    "description": "Prison Master Escape Journey is a thrilling prison escape simulator that challenges your brain and strategic thinking! Trapped inside a high-security prison, you must plan every move carefully and begin an intense adventure toward freedom.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Brain",
      "Escape",
      "Prison",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/payn1ec80jcovst0n8taikjzn6xteqd2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/payn1ec80jcovst0n8taikjzn6xteqd2/",
    "sourceUrl": "https://html5.gamemonetize.com/payn1ec80jcovst0n8taikjzn6xteqd2/",
    "width": 1440,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75428",
    "slug": "hunter-underwater-spearfishing",
    "title": "Hunter Underwater Spearfishing",
    "description": "Hunter Underwater Spearfishing is an immersive simulator hunting game that takes you deep beneath the ocean for an exciting underwater adventure. Grab your spearfishing arrow, dive in, and experience the thrill of becoming a true underwater hunter!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Fishing",
      "Hunting",
      "Simulator",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/xtca88xonz94nvjb5uf54a6h8m3nmsqo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xtca88xonz94nvjb5uf54a6h8m3nmsqo/",
    "sourceUrl": "https://html5.gamemonetize.com/xtca88xonz94nvjb5uf54a6h8m3nmsqo/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "75440",
    "slug": "stick-arena-stickmen",
    "title": "Stick Arena: Stickmen",
    "description": "Welcome to the world of epic battles! This game delivers physics-based combat where your agility, reaction speed, and strategic thinking are put to the test. Control a stick fighter, unleash powerful strikes, and perform acrobatic moves to defeat your opponents. Game Modes: &bull; Single Player: Fight against enemies and improve your skills. &bull; Two Players: Battle your friends on the same device and prove who the ultimate warrior is. &bull; Survival: An endless mode where you must survive as long as possible against nonstop waves of enemies. Game Features: &bull; Realistic stickman physics. &bull; Unique attack animations and combo moves. &bull; Exciting arenas wi",
    "instructions": "bull On mobile devices Move your character using the virtual joystick located on the right side of the screen Attacks are performed automatically in the direction the character is moving bull On PC Use the arrow keys to control your character amp",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2026 games",
      "2D",
      "Adventure",
      "Arena",
      "Balance",
      "Battle",
      "battleship",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "roblox",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/2o839x3puukucr9eseld3go95wlb3yyf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2o839x3puukucr9eseld3go95wlb3yyf/",
    "sourceUrl": "https://html5.gamemonetize.com/2o839x3puukucr9eseld3go95wlb3yyf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75432",
    "slug": "obby-climb-up-and-slide-down-on-minecarts",
    "title": "Obby: Climb Up and Slide Down on Minecarts",
    "description": "Welcome to an exciting game where you climb upward on carts, collect money, and upgrade your ride! Make your way through various levels and push your progress higher and higher. Each run earns you money that can be spent on a brand-new cart. The higher you climb, the more challenging the track becomes&mdash;but the rewards grow as well. Unlock new zones, explore diverse locations, and get stronger with every attempt. Adorable pets will accompany you on your journey. Collect a wide variety of pets, level them up, and use their unique abilities to complete levels faster and more efficiently. Compete with friends for the best score, improve your sk",
    "instructions": "On PC WASD ndash Move Mouse ndash Camera control On Mobile Use the on-screen controls Drag anywhere on the screen ndash Camera control",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Android",
      "cannon",
      "Cars",
      "Cartoon",
      "Cartoon Network",
      "Craft",
      "CSGO",
      "destroy",
      "eggames",
      "Fishing",
      "Hypercasual",
      "Penguin",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/0uwm8whz3pn4yq9nz4a62ya7ztns9typ/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0uwm8whz3pn4yq9nz4a62ya7ztns9typ/",
    "sourceUrl": "https://html5.gamemonetize.com/0uwm8whz3pn4yq9nz4a62ya7ztns9typ/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75435",
    "slug": "snake-2048-cube-merge",
    "title": "Snake 2048: Cube Merge",
    "description": "This game is an exciting combination of the classic Snake mechanics and the popular 2048 puzzle. Your goal is to control the snake and absorb cubes with a smaller or equal value. Each absorbed cube increases your mass, making the snake longer and stronger. But be careful &mdash; colliding with a larger cube will result in defeat. The game offers a unique gameplay experience that blends fast-paced action with strategic thinking. You must plan your path carefully, avoid dangerous cubes, survive as long as possible, and score the highest number of points. The controls are simple and intuitive: on PC, the snake follows your cursor, while on mobile de",
    "instructions": "Absorb cubes that are smaller than or equal to your current mass Colliding with a larger cube will result in defeat For PC The snake moves by following your mouse cursor For mobile devices Control the snake rsquo s direction using a virtual joystick",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      ".io",
      ".io Games",
      "2 Player Games",
      "2048",
      "Action",
      "attack",
      "battleship",
      "Brainrot Italian",
      "Cartoon",
      "Cartoon Network",
      "destroy",
      "Minecraft",
      "roblox",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/nkjtibnj0tezzvci3owaf2dtff3hvfvq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nkjtibnj0tezzvci3owaf2dtff3hvfvq/",
    "sourceUrl": "https://html5.gamemonetize.com/nkjtibnj0tezzvci3owaf2dtff3hvfvq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75430",
    "slug": "tunnel-drift",
    "title": "Tunnel Drift",
    "description": "Tunnel Drift is an intense endless arcade racer where precision is key. Key Features: Heavy Duty Drifting: Experience unique handling as you drift a heavy truck through a 360-degree rotating tunnel. Endless Challenge: The further you go, the faster it gets. Procedurally generated levels mean no two runs are the same! High Score Hunt: Collect Rings to maximize your points and challenge players worldwide on the Global Leaderboard. Instant Action: Simple controls, hard to master gameplay. Just tap to drift and survive!",
    "instructions": "Controls Keyboard Left Arrow or A Rotate Tunnel Left Right Arrow or D Rotate Tunnel Right Mouse Touch Click Tap Left Side of Screen Rotate Left Click Tap Right Side of Screen Rotate Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Race",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ox8d1qc9bwgge7gxfj7pw1hj9cgfz3t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ox8d1qc9bwgge7gxfj7pw1hj9cgfz3t/",
    "sourceUrl": "https://html5.gamemonetize.com/4ox8d1qc9bwgge7gxfj7pw1hj9cgfz3t/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75345",
    "slug": "sniper-rush-target-blitz",
    "title": "Sniper Rush: Target Blitz",
    "description": "A fast-paced casual sniper game! Take aim, fire, and clear levels by eliminating targets&mdash;ninjas, soldiers, boxers, and more. Use explosive barrels for quick takedowns, manage limited ammo, and conquer evolving city/desert scenes. With low-poly cartoon style and straightforward controls, it&rsquo;s perfect for quick, satisfying shooting fun. Race through levels, hit every mark, and master the trigger!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "attack",
      "Bullet",
      "Shoot",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/nufdzq6id9i0p4a923uh9y1lurrhja32/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nufdzq6id9i0p4a923uh9y1lurrhja32/",
    "sourceUrl": "https://html5.gamemonetize.com/nufdzq6id9i0p4a923uh9y1lurrhja32/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75446",
    "slug": "shape-merge-run",
    "title": "Shape Merge Run",
    "description": "Shape Merge Run is a fast and satisfying hyper-casual arcade game that combines endless running with merge mechanics. Control a moving shape, collect identical shapes, and merge them into bigger and more powerful forms. Each merge increases your score but also makes the game more challenging as movement becomes harder. Avoid obstacles, choose the right paths, and decide when to grow bigger or stay small. With smooth controls, clean neon visuals, and endless gameplay, Shape Merge Run is easy to learn yet difficult to master. Test your reflexes, plan your merges, and aim for the highest score in this addictive merge-runner experience.",
    "instructions": "Move left or right to collect matching shapes and merge them into bigger ones Bigger shapes give more score but are harder to control Avoid obstacles and survive as long as possible in this endless merge runner",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Ball",
      "Casual",
      "Color",
      "Coloring",
      "endless",
      "Geometry",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ebqrdphibx8wi5amsf9p1xhjfy92rke/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ebqrdphibx8wi5amsf9p1xhjfy92rke/",
    "sourceUrl": "https://html5.gamemonetize.com/4ebqrdphibx8wi5amsf9p1xhjfy92rke/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75341",
    "slug": "precision-car-parking-3d",
    "title": "Precision Car Parking 3D",
    "description": "Test your driving skills in Precision Parking 3D, a realistic and challenging parking simulation game where accuracy matters more than speed! Navigate through tight spaces, avoid obstacles, and park your vehicle perfectly in a variety of carefully designed levels. Each stage pushes your control, patience, and precision to the limit.",
    "instructions": "W To Forward A D For Left Right S to Reverse amp Space To Brake",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "Car",
      "Race",
      "Racing",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/7borf8z2jzentis77i6zz882h7lrvxwo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7borf8z2jzentis77i6zz882h7lrvxwo/",
    "sourceUrl": "https://html5.gamemonetize.com/7borf8z2jzentis77i6zz882h7lrvxwo/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75424",
    "slug": "obby-tsunami-1-speed",
    "title": "Obby: Tsunami +1 speed",
    "description": "The city is on the brink of destruction&mdash;a giant tsunami is gaining speed and sweeping away everything in its path. Only you can survive and save the inhabitants! In this dynamic running game, youll need to increase your speed, improve your heros abilities, and reach the finish line faster than the destructive wave catches up with you. The higher your speed, the more chances you have to break ahead and win. Explore different worlds, from modern city streets to fantastical locations. Each world brings new challenges, obstacles, and visual effects. Collect pets that give you unique bonuses: acceleration, extra speed, auto-boosts, and wave pro",
    "instructions": "On PC WASD ndash Move Mouse ndash Camera control Space ndash Jump On Mobile Use the game interface Drag anywhere on the screen ndash Camera control",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Brainrot",
      "Family",
      "hex",
      "Italian Brainrot",
      "jump",
      "Minecraft",
      "Mobile",
      "Multiplayer",
      "Pixel",
      "Pokemon",
      "roblox",
      "Robot",
      "Skibidi",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/1uz0abnrl91gljfhg0okss7rs7q3olva/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1uz0abnrl91gljfhg0okss7rs7q3olva/",
    "sourceUrl": "https://html5.gamemonetize.com/1uz0abnrl91gljfhg0okss7rs7q3olva/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75242",
    "slug": "obby-raft",
    "title": "Obby: Raft",
    "description": "Welcome to Obby: Raft! In this game you have to fish to gain points and unlock new levels and abilities. Develop, win, collect unique pets and get stronger with each world! Practice - increase your knowledge for new achievements. Fish - develop and improve your skills. Pet - unlock allies for extra help. New Locations - explore unique worlds.",
    "instructions": "PC W A S D - move PCM - rotate camera LKM - lick Mobile device Left Joystick - move Right side of the screen - rotate camera",
    "category": "",
    "genres": [],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "Clicker",
      "roblox",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/sqqor4xp50y8dlxhiy224hre9gzwsr1g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sqqor4xp50y8dlxhiy224hre9gzwsr1g/",
    "sourceUrl": "https://html5.gamemonetize.com/sqqor4xp50y8dlxhiy224hre9gzwsr1g/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75464",
    "slug": "super-cat-free-fire",
    "title": "Super Cat Free Fire",
    "description": "Super Cat Free Fire is a wild and exciting action shooting simulator where a powerful cat becomes the ultimate battlefield hero. Grab your gun, jump into intense free fire combat, and experience nonstop shooting action in fast-paced arenas.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Battle",
      "Cat",
      "Shooting",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/gm4ye0kewhpvic63ik6c4spycq2y94qc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gm4ye0kewhpvic63ik6c4spycq2y94qc/",
    "sourceUrl": "https://html5.gamemonetize.com/gm4ye0kewhpvic63ik6c4spycq2y94qc/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "75427",
    "slug": "funny-haircut-2",
    "title": "Funny Haircut 2",
    "description": "Daisy wants to change her hairstyle, so she went to your salon to get a makeover. Lets give her the best hair makeover she can get!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Funny",
      "Hair",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/j971kh41lyq20yxtl2qy19qjvucb3ucg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j971kh41lyq20yxtl2qy19qjvucb3ucg/",
    "sourceUrl": "https://html5.gamemonetize.com/j971kh41lyq20yxtl2qy19qjvucb3ucg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75419",
    "slug": "stick-hero-battle",
    "title": "Stick Hero Battle",
    "description": "Stick Hero Battle is a fast-paced and explosive action fighting game that throws you straight into intense battle arenas. The game features easy-to-learn controls with deep combat mechanics. Control a fearless stick hero and fight your way through waves of enemies using powerful attacks, smart movement, and perfect timing.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "attack",
      "Battle",
      "Stickman",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/5knd8zfdys2tpheteor7jtjnlo6hj2ng/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5knd8zfdys2tpheteor7jtjnlo6hj2ng/",
    "sourceUrl": "https://html5.gamemonetize.com/5knd8zfdys2tpheteor7jtjnlo6hj2ng/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75422",
    "slug": "brainrot-world-hole-io",
    "title": "Brainrot World Hole io",
    "description": "Brainrot World Hole.io is a hilarious casual hole game packed with chaotic brainrot energy and funny Italian meme vibes. Control a growing hole and dive into a crazy world where swallowing everything in sight is the key to victory. Move around the map and collect objects smaller than your hole.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Brainrot",
      "Enemies",
      "Fight",
      "Funny"
    ],
    "thumbnail": "https://img.gamemonetize.com/qbsw3x9auxgjncitdcgnat16aptkq4ns/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qbsw3x9auxgjncitdcgnat16aptkq4ns/",
    "sourceUrl": "https://html5.gamemonetize.com/qbsw3x9auxgjncitdcgnat16aptkq4ns/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "75379",
    "slug": "color-wood-animal-jam",
    "title": "Color Wood Animal Jam",
    "description": "Begin a charming logic puzzle match game in Color Wood Animal Jam. Drag the colorful wooden animal pieces into their correct spots. Complete each delightful jam puzzle. One wrong move can make the color block jam even trickier.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Block",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/aiq299yp6g7oyyqmlmsuemyl8ud8jds9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aiq299yp6g7oyyqmlmsuemyl8ud8jds9/",
    "sourceUrl": "https://html5.gamemonetize.com/aiq299yp6g7oyyqmlmsuemyl8ud8jds9/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75413",
    "slug": "obby-iq-escape-from-the-laboratory",
    "title": "Obby: IQ Escape from the Laboratory",
    "description": "Welcome to &ldquo;Obby: IQ Escape from the Laboratory&rdquo; - a unique 3D game where each level tests not only your dexterity, but also your intelligence! You find yourself in a mysterious laboratory full of puzzles, traps and unusual challenges. To get out, youll have to do more than just jump - youll have to think! What awaits you: IQ-tests - non-standard tasks that require logic, attention and wit. Fun mechanics - push, build, jump and destroy: each level offers a new approach to the solution. Humor and surprises - unexpected traps and funny situations are waiting around every corner. Parkour with brain - its not just an obby, its",
    "instructions": "Control on your phone - Move - virtual joystick on the left hand side - Jump - button on the right - Interaction if needed - additional button",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Adult",
      "Ballon",
      "Best",
      "Cartoon",
      "Craft",
      "Escape",
      "Jumping",
      "Logic",
      "Minecraft",
      "roblox",
      "Robot",
      "Sandbox",
      "voxel"
    ],
    "thumbnail": "https://img.gamemonetize.com/9bo3b0dd43bfdu66e24xv0wauholkx20/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9bo3b0dd43bfdu66e24xv0wauholkx20/",
    "sourceUrl": "https://html5.gamemonetize.com/9bo3b0dd43bfdu66e24xv0wauholkx20/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75324",
    "slug": "subway-walker",
    "title": "subway walker",
    "description": "Subway Runner 3D is a high-speed, adrenaline-pumping endless runner set in a vibrant cyberpunk city. Take control of a daring city surfer as you dodge oncoming trains, leap over barriers, and slide under high-voltage signals. Your mission: outrun the chasing police officer and set the ultimate high score! As you dash through the neon-lit tracks, collect golden coins to spend in the shop. Upgrade your Power-ups like the Coin Magnet, Jetpack, and Super Sneakers to gain an edge, or buy a Headstart to blast through the beginning of your run. Unlock various colorful outfits to customize your character and use the Hoverboard to gain a second life w",
    "instructions": "Keyboard Arrow Keys WASD Move Left Right Jump Up and Roll Down P Esc Pause Resume game Space Jump Touch Mobile Swipe Left Right Change lanes Swipe Up Jump Swipe Down Roll Slide Double Tap Activate Hoverboard",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Arcade",
      "Casual",
      "HTML5",
      "running",
      "Subway Surfers",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/tv85e5g8lq74gbe8iwt4on6ybx17v591/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tv85e5g8lq74gbe8iwt4on6ybx17v591/",
    "sourceUrl": "https://html5.gamemonetize.com/tv85e5g8lq74gbe8iwt4on6ybx17v591/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75266",
    "slug": "alphabet-count-rush",
    "title": "Alphabet Count Rush",
    "description": "Choose the best gate, pass through it, and bring alphabet stickman warriors together to clash with the opposing crowd. In Alphabet Count Rush, you start alone but quickly grow your letter crowd by choosing the right paths and counting smartly. Become the crowd master and lead your alphabet army through the crowded city till the end of this epic race. Crash obstacles, avoid traps, and beat rival letter groups on your way. Collect coins, unlock upgrades, and increase your power. Defeat the final alphabet boss in an intense battle and take control of the arena. Looking for fun, thrill, and fast-paced action? This 3D running game is just for you.",
    "instructions": "Swipe the mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Brain",
      "Educational",
      "Fun",
      "Game",
      "Kids",
      "Letters",
      "Number",
      "Puzzle",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/hbvt6ecfxfrtu62sm0km7c1gs23be5c2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hbvt6ecfxfrtu62sm0km7c1gs23be5c2/",
    "sourceUrl": "https://html5.gamemonetize.com/hbvt6ecfxfrtu62sm0km7c1gs23be5c2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75402",
    "slug": "super-poker",
    "title": "Super Poker",
    "description": "SuperPoker is a puzzle game with a casino style, where you match combinations such as pairs, triplets, or special groups to achieve the highest score. Each level features different arrangements, requiring quick observation and strategic calculation to create valuable combo chains. The engaging gameplay, lively effects, and the thrill of conquering high scores make SuperPoker an exciting intellectual entertainment choice.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Casino",
      "Casual",
      "Click",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/f5mv3cltk9bjta0h3t54c1isiqwlxgf3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f5mv3cltk9bjta0h3t54c1isiqwlxgf3/",
    "sourceUrl": "https://html5.gamemonetize.com/f5mv3cltk9bjta0h3t54c1isiqwlxgf3/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75342",
    "slug": "minecraft-card-matching-puzzle",
    "title": "Minecraft Card Matching Puzzle",
    "description": "Minecraft Card Matching Puzzle is a fun and relaxing card matching game that tests your memory and attention. Tap on cards to reveal them and match two identical cards to make them disappear. If the cards do not match, they flip back over. Each level contains 16 cards. Once all cards are matched, a new set of 16 cards drops from the top and the challenge continues. The level number indicates how many card sets must be completed. When all sets are successfully matched, the level is completed. With simple controls and Minecraft-style visuals, the game offers an enjoyable experience for players of all ages.",
    "instructions": "The player taps on cards to reveal two at a time Matching cards disappear while non-matching cards flip back When all 16 cards are matched new cards drop from above Completing all card sets wins the level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Card",
      "Classic",
      "Fun",
      "Funny",
      "Matching",
      "Minecraft",
      "Pixel",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/0k3sevkud3u577u39a45bjll6ts7zwuo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0k3sevkud3u577u39a45bjll6ts7zwuo/",
    "sourceUrl": "https://html5.gamemonetize.com/0k3sevkud3u577u39a45bjll6ts7zwuo/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75272",
    "slug": "gear-shift-race",
    "title": "Gear Shift Race",
    "description": "Gear Shift Race is an adrenaline-fueled drag racing game that puts you in control of fully manual cars with realistic gear shifting and clutch timing. Set in a sprawling city ruled by rival street gangs and their powerful leaders, every race is a fight for speed, skill, and reputation. Rise through the underground ranks by defeating gang kings in intense drag battles. Earn cash and reputation to upgrade engine power, tuning, paint, and skins. Master precise gear shifts and perfect clutch control to unleash maximum acceleration. In Gear Shift Race, split-second decisions decide victory or defeat.",
    "instructions": "Tap or mouse click on the gear",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2026 games",
      "3D",
      "Arcade",
      "Best Games",
      "Car",
      "Casual",
      "endless",
      "Racing",
      "Sport",
      "Traffic",
      "wheel"
    ],
    "thumbnail": "https://img.gamemonetize.com/bwxvpns0l9v0vxqcsj2v5uw6ummx54zr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bwxvpns0l9v0vxqcsj2v5uw6ummx54zr/",
    "sourceUrl": "https://html5.gamemonetize.com/bwxvpns0l9v0vxqcsj2v5uw6ummx54zr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75364",
    "slug": "obby-fish-training",
    "title": "Obby: Fish training",
    "description": "- Control the fish and unlock more and more powerful underwater creatures! - Collect energy currents to unlock new fish and explore the depths. - Unique &ldquo;water footprints&rdquo; with visual effects - leave your style in the ocean! - Rebirth system - unlock new underwater eras and become stronger. - Tournaments and leaderboards - become the fastest swimmer in the underwater world!",
    "instructions": "PC Controls bull Movement W A S D bull Jump Spacebar bull Camera Rotation Right Mouse Button bull Camera Zoom Mouse Scroll Wheel Mobile Controls bull Movement On-screen virtual joystick bull Jump amp Actions Button with the cor",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Bike",
      "Brainrot",
      "Cartoon",
      "Cute",
      "Fish",
      "Fishing",
      "Jewel",
      "Minecraft",
      "Road",
      "roblox",
      "trial car",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/pimxsd9m3sizr84geh189wa4fhlgcrmg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pimxsd9m3sizr84geh189wa4fhlgcrmg/",
    "sourceUrl": "https://html5.gamemonetize.com/pimxsd9m3sizr84geh189wa4fhlgcrmg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75299",
    "slug": "sweet-triple-mahjong",
    "title": "Sweet Triple Mahjong",
    "description": "Sweet Triple Mahjong is a relaxing yet challenging tile-matching puzzle game with a delicious candy theme. Match three identical tiles that are free on the left or right to collect them and clear the board. Each level introduces new tile layouts that test your observation and strategy skills. Easy to learn but hard to master, Sweet Triple Mahjong offers smooth gameplay, colorful visuals, and satisfying progression across multiple levels. Perfect for quick play sessions or long puzzle-solving fun.",
    "instructions": "Tap tiles that are free on the left or right and match three identical tiles to remove them from the board Plan your moves carefully to avoid getting stuck and clear all tiles to finish the level and move to the next one",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cake",
      "Candy",
      "Mahjong",
      "Match-3",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qzm35edmdtwxhxzbwbftmmo3zxqn5vn0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qzm35edmdtwxhxzbwbftmmo3zxqn5vn0/",
    "sourceUrl": "https://html5.gamemonetize.com/qzm35edmdtwxhxzbwbftmmo3zxqn5vn0/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "75288",
    "slug": "room-chaos",
    "title": "Room Chaos",
    "description": "Welcome to Room Chaos, an addictive and fun game where you get to clean up the most incredibly cluttered rooms! If you like games like Find the Item and Time Management, then Room Chaos will definitely appeal to you, but with a unique twist on cleaning.",
    "instructions": "Room cleaning In each room there are many scattered objects and garbage Your goal is to clean up all these items using the appropriate tools and basket Using tools Each tool is designed to clean a specific type of item",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "amazing",
      "Android",
      "Boys",
      "Casual",
      "endless",
      "Girls",
      "Mobile",
      "Puzzle",
      "unity",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ypw3yglcce50zbvhnkl6nbrhq1xfb7l1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ypw3yglcce50zbvhnkl6nbrhq1xfb7l1/",
    "sourceUrl": "https://html5.gamemonetize.com/ypw3yglcce50zbvhnkl6nbrhq1xfb7l1/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75319",
    "slug": "rock-paper-scissors-adventure",
    "title": "Rock Paper Scissors Adventure",
    "description": "Rock Paper Scissors Adventure is a battle game inspired by the classic rock paper scissors game and from html games classics like Agar.io developed in 2025 by FLGames Take the role of one of the three symbols, be strategic and win!!",
    "instructions": "WASD to move",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Arena"
    ],
    "thumbnail": "https://img.gamemonetize.com/josjif5rysmcx2wap9iluipssoinetbc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/josjif5rysmcx2wap9iluipssoinetbc/",
    "sourceUrl": "https://html5.gamemonetize.com/josjif5rysmcx2wap9iluipssoinetbc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "1650",
    "slug": "car-eats-car-dungeon-adventure",
    "title": "Car Eats Car: Dungeon Adventure",
    "description": "Up for a fight against rivals in a dynamic race on the highway? Overtake enemies and create your own car in the incubator in Car Eats Car: Dungeon Adventure! Your friends are put to prison - do everything you can to free evil cars! Good driving skills and turbo speed come in handy in this crazy driving simulator and a police chase game. Become a car tycoon, upgrade cars, and play for monster cars against the cops! Fight the boss to survive in these ultimate crazy races!",
    "instructions": "Space - Bombs X - Turbo W - Gas S - Brake A D - Balancing Arrow keys - Gas Brake Balancing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Action",
      "Car",
      "Cars",
      "Family",
      "Race",
      "Racing",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ysdz38kvh0t5zfu64oew4wzbbginajp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ysdz38kvh0t5zfu64oew4wzbbginajp/",
    "sourceUrl": "https://html5.gamemonetize.com/2ysdz38kvh0t5zfu64oew4wzbbginajp/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "75400",
    "slug": "funny-eye-surgery-2",
    "title": "Funny Eye Surgery 2",
    "description": "Luke and Lora have been neglected their eyes by watching tablet all day, watch TV in dark, and never get their eyes proper rest. That cause problems to the eyes, and now they must go to eye doctor. Lets fix these kids eyes so they can see better!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Doctor",
      "Fun",
      "Kids",
      "Simulation",
      "Surgery"
    ],
    "thumbnail": "https://img.gamemonetize.com/3dbpctrkr6qv804au3sl0dnfrzms698c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3dbpctrkr6qv804au3sl0dnfrzms698c/",
    "sourceUrl": "https://html5.gamemonetize.com/3dbpctrkr6qv804au3sl0dnfrzms698c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75405",
    "slug": "obby-dragon-training",
    "title": "Obby: Dragon Training",
    "description": "Welcome to the world of dragon adventure! Here youll have to fly as far as you can while taming mighty dragons, unlocking magic trails and collecting energy! Become the best dragon rider! Tame legendary dragons, collect energy and pets that will give you powerful bonuses! Explore amazing locations, but remember - youll need rebirth points to unlock them! Game Features: - Ride the dragon and unlock new winged creatures! - Farm flight points to tame new dragons and unlock magic trails. - A variety of trails with unique effects, leave your mark in the sky! - Rebirth system - open new worlds and become stronger. - Leade",
    "instructions": "PC bull Movement ndash W A S D bull Jump ndash Spacebar Mobile Device bull Movement ndash Virtual joystick Enjoy Collect speed take flights and earn victories",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Brainrot sahuuur",
      "Cartoon",
      "Cute",
      "Dragon",
      "Dragon Ball Z",
      "Driving",
      "Dungeon",
      "egg",
      "eggs",
      "Games",
      "Italian Brainrot",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/a6782t42mr6qdxn6v32mmwlzep6or530/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a6782t42mr6qdxn6v32mmwlzep6or530/",
    "sourceUrl": "https://html5.gamemonetize.com/a6782t42mr6qdxn6v32mmwlzep6or530/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73880",
    "slug": "zombie-shooter-sniper-game",
    "title": "Zombie Shooter Sniper Game",
    "description": "Zombie Shooter Sniper Game is an engaging combination of thrilling and realistic FPS shooting game with massive sniper and multiplayer PvP modes in new 3D zombie themes. Get ready for fun and non-stop action in the free Sniper Zombie 3D gun shooting game and become the top zombie shooter in the sniper assassin arena. Experience one of the most engaging online &amp; offline FPS shooting and sniper zombie 3D games on mobiles. What makes this offline sniper zombie 3D game of shooting more attractive is to push yourself into a fun adventure of a sniper through incredible zombie concepts.",
    "instructions": "Move---W Back---S left---A Right---D Fire---Left Mouse click Scope --- Right Mouse Click",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2026 games",
      "Action",
      "Game",
      "Gun",
      "Shooter",
      "Shooting",
      "Skill",
      "Sniper",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/46v9r8xh83md97ez29sdqhowxjvn79ks/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/46v9r8xh83md97ez29sdqhowxjvn79ks/",
    "sourceUrl": "https://html5.gamemonetize.com/46v9r8xh83md97ez29sdqhowxjvn79ks/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75397",
    "slug": "funny-tattoo-shop-2",
    "title": "Funny Tattoo Shop 2",
    "description": "Choose whats your favorite things and make it a tattoo on your arm or leg. Feel free to modify and color them as you wish!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "beauty",
      "Coloring",
      "Dress Up",
      "Fashion",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/thbai26ng09fewuptgo2w3xdnmr9zfg7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/thbai26ng09fewuptgo2w3xdnmr9zfg7/",
    "sourceUrl": "https://html5.gamemonetize.com/thbai26ng09fewuptgo2w3xdnmr9zfg7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75339",
    "slug": "snake-fusion-arena",
    "title": "Snake Fusion Arena",
    "description": "Snake Fusion Arena is a fun arcade snake game with a unique fusion twist. Before you enter the arena, visit the home screen to buy new snakes, merge them, and choose between different game modes like Normal, Survival, and Dino Mode.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      "Arcade",
      "Arena",
      "dino",
      "Slither",
      "Snake",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/orj7l5d1ddgyh8oqkzqqzu7q6pan4kqo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/orj7l5d1ddgyh8oqkzqqzu7q6pan4kqo/",
    "sourceUrl": "https://html5.gamemonetize.com/orj7l5d1ddgyh8oqkzqqzu7q6pan4kqo/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "75393",
    "slug": "fruit-jam-master",
    "title": "Fruit Jam Master",
    "description": "Enter the juiciest and most addictive puzzle adventure ever. Enjoy a fun logic puzzle game in Fruit Jam Master. You need to help all the animals leave the grassland to win. Pay attention to the color of the food. Animals can only pass through when the food matches their own color.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Fruits",
      "Logic",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/utagaibvfznnd8uv6mia0spy81mlubxy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/utagaibvfznnd8uv6mia0spy81mlubxy/",
    "sourceUrl": "https://html5.gamemonetize.com/utagaibvfznnd8uv6mia0spy81mlubxy/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75374",
    "slug": "paw-patrol-marshall-skye-ryder-everest",
    "title": "Paw Patrol Marshall Skye Ryder  Everest",
    "description": "An exciting runner inspired by Paw Patrol. Players choose their favorite patrol characters and dive into a thrilling adventure. The game&rsquo;s storyline is closely connected to the animated series, adding depth to the overall experience. Each character&rsquo;s unique abilities provide strategic flexibility. A variety of levels filled with creative obstacles keeps the gameplay dynamic and engaging. Bright, colorful graphics capture the atmosphere of the cartoon, while detailed animations bring the characters and game world to life. Numerous bonuses and power-ups add variety to the gameplay. Players run through levels, collect coins, and rescue citizen",
    "instructions": "You need to tap the screen on mobile devices or press the Space key on PC to jump Collect coins and use jumps or double jumps to avoid traps You can also collect coins to unlock and buy new Paw Patrol pups",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Cartoon",
      "Cat",
      "Color",
      "Crazy",
      "Creation",
      "Cute",
      "Disney",
      "Fall Boys",
      "Funny",
      "Game",
      "jump",
      "Kids",
      "Minecraft",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/th6r6dcoio6do4r6lnk6ceav865h24bq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/th6r6dcoio6do4r6lnk6ceav865h24bq/",
    "sourceUrl": "https://html5.gamemonetize.com/th6r6dcoio6do4r6lnk6ceav865h24bq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75388",
    "slug": "obby-swimming-competition",
    "title": "Obby: Swimming competition",
    "description": "Welcome to the world of Obby: The Swimming Competition! Here its up to you to swim as far away as possible by buying boats and ships, unlocking new air trails and collecting energy! Buy cool swimming aids, collect energy and pets that will give you bonuses! Explore different locations, but remember - you need rebirth points to open them! Game Features: - Manage boats and buy new models! - Farm swim points to buy new watercraft and air trails. - A variety of air trails with unique effects. - Rebirth system - unlock new locations and become stronger. - Leaderboards and competitions - compete with other swimmers and bec",
    "instructions": "PC bull Movement ndash W A S D bull Jump ndash Spacebar Mobile Device bull Movement ndash Virtual joystick Enjoy Collect speed take water transport and earn victories",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "cargo",
      "Cartoon",
      "Craft",
      "Cute",
      "Fun",
      "Minecraft",
      "roblox",
      "ship",
      "ships",
      "Top Down"
    ],
    "thumbnail": "https://img.gamemonetize.com/vmc273vczy6iwsv6v650nv39wc2yxpvk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vmc273vczy6iwsv6v650nv39wc2yxpvk/",
    "sourceUrl": "https://html5.gamemonetize.com/vmc273vczy6iwsv6v650nv39wc2yxpvk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75296",
    "slug": "curve-master-football",
    "title": "Curve Master Football",
    "description": "Become the ultimate football legend in Curve Master Football! This isnt just about kicking the ball; its about mastering the art of the swerve. Use your finger to draw the perfect curved path, guiding the ball around walls, tricky defenders, and the goalkeeper to score spectacular goals. Experience the satisfaction of a Perfect Shot with slow-motion effects as you hit the top corner. Progress through 300+ increasingly difficult levels, collect coins to unlock 30+ unique ball skins, and claim your Daily Rewards. Aim for the Bullseye targets for extra points and climb the Global Leaderboard. Can you master the arc and become the world champ",
    "instructions": "Mobile Touch Touch and drag on the screen to draw a path for the ball Release to shoot Desktop Click and hold the Left Mouse Button to draw the path Release to shoot",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "3D",
      "Ball",
      "Boys",
      "Draw",
      "Drawing",
      "Football",
      "HTML5",
      "Hypercasual",
      "Mobile",
      "Physics",
      "Skills",
      "Soccer",
      "Sports",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/8zw1gm6pbpq0n4ubhgqjs9hyr6ii54z9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8zw1gm6pbpq0n4ubhgqjs9hyr6ii54z9/",
    "sourceUrl": "https://html5.gamemonetize.com/8zw1gm6pbpq0n4ubhgqjs9hyr6ii54z9/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "65795",
    "slug": "fantastic-cubic-dash",
    "title": "Fantastic Cubic Dash",
    "description": "Fantastic Cubic Dash is an addictive, endless runner that challenges players to master timing and quick reflexes as they guide a vibrant cube through an obstacle course. Every jump contributes to a soaring score that fuels your competitive spirit&mdash;and propels you toward unlocking a rich collection of dazzling cube skins. From the first tap or spacebar press, you&rsquo;ll find yourself immersed in synchronized, eye-catching visuals. Obstacles range from simple spikes, ensuring no two runs feel the same. As you rack up points, your progression bar fills, granting access to rare and legendary skins that reflect your skill and dedication.",
    "instructions": "Mobile Tap anywhere on the screen to make the cube jump PC Press Space to jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Android",
      "Arcade",
      "Geometry"
    ],
    "thumbnail": "https://img.gamemonetize.com/f18l8mpi2u2attd3nqs4zy4mznjadjjm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f18l8mpi2u2attd3nqs4zy4mznjadjjm/",
    "sourceUrl": "https://html5.gamemonetize.com/f18l8mpi2u2attd3nqs4zy4mznjadjjm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66421",
    "slug": "ham",
    "title": "HAM",
    "description": "Hungry guy is hungry because of you are not played it but he wants to eat stones, and he need your help. If you trust your reflexes, you can drag him towards the stones and make him eat them, thus increasing your score to the highest levels.",
    "instructions": "Drag him to stones for eating with mouse or touch",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "eating",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/yt3u8bf8yru07np1i0c6846c7kij2tw3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yt3u8bf8yru07np1i0c6846c7kij2tw3/",
    "sourceUrl": "https://html5.gamemonetize.com/yt3u8bf8yru07np1i0c6846c7kij2tw3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74924",
    "slug": "car-parkour-challenge",
    "title": "Car Parkour Challenge",
    "description": "Stunt Car Parkour challenge is the ultimate stunt and trial car skill racing game with both entertaining and awe-inspiring tracks. The main tracks are designed for casual play, but the bonus tracks offer more extreme challenge! The bonus tracks have high risks but also high rewards. Levels include hard trial levels, easy speed levels, and casual and fun jump ramp levels. You get more challenges as you progress in the levels. The game has a daily challenge mode, in which you try to win real players drives. In the cups mode, you race against three drivers in three race tracks in a roll.",
    "instructions": "Move Forward - - Up Arrow Back - - Down Arrow Left - - Left Arrow Right - - Right Arrow",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      ".io Games",
      "2026 games",
      "3D Games",
      "Arcade",
      "Best Games",
      "Car",
      "Driving",
      "Racing",
      "Skill",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/ym2qhm2n7ceu7xmckpqtzocnxfewxgm9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ym2qhm2n7ceu7xmckpqtzocnxfewxgm9/",
    "sourceUrl": "https://html5.gamemonetize.com/ym2qhm2n7ceu7xmckpqtzocnxfewxgm9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75024",
    "slug": "crush-the-blocks",
    "title": "Crush the blocks",
    "description": "Crush the blocks is a puzzle game with slider movement as its core, integrating classic mechanisms and innovative gameplay, combining fun and intellectual training value.",
    "instructions": "Tap or use the left mouse button to twist bolts and use in-game buttons",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Casual",
      "Logic",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/7eozs07k1zpfvt945rsochrsixh74nu0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7eozs07k1zpfvt945rsochrsixh74nu0/",
    "sourceUrl": "https://html5.gamemonetize.com/7eozs07k1zpfvt945rsochrsixh74nu0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75208",
    "slug": "draw-a-perfect-circle",
    "title": "Draw a Perfect Circle",
    "description": "Draw a Perfect Circle is a minimalist and challenging game that tests your precision, focus, and control. The idea is simple: draw a perfect circle. But be careful, every attempt shows how hard perfection is to achieve. Have fun, challenge yourself, and invite your friends to see who can get closest to the perfect circle!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Draw",
      "Drawing",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/m4scm9dora4j56myxv3gxx16vi2drpw9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m4scm9dora4j56myxv3gxx16vi2drpw9/",
    "sourceUrl": "https://html5.gamemonetize.com/m4scm9dora4j56myxv3gxx16vi2drpw9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75267",
    "slug": "destroy-godzillas-3d-shooter",
    "title": "Destroy Godzillas: 3D Shooter",
    "description": "Destroy the Robot Godzillas &ndash; 3D Space Shooter Game is an action-packed 3D space shooter that challenges your reflexes and focus. You control a spaceship and must destroy giant robot Godzillas rushing toward you at high speed. The game starts with only 1 life, and every enemy that passes your spaceship without being destroyed costs you a life. When your life reaches zero, the game ends.",
    "instructions": "The player controls a spaceship and shoots robot Godzillas advancing toward them Every enemy that is not destroyed reduces the player rsquo s life by one When life reaches zero the game ends Destroyed enemies provide currency that can be used to upgra",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "3D Games",
      "Action",
      "Fun",
      "Funny",
      "Shoot",
      "Shooter",
      "Shooting",
      "Space",
      "Spaceship",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/acr77onayq8v642n5x7z6xki1q6o837d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/acr77onayq8v642n5x7z6xki1q6o837d/",
    "sourceUrl": "https://html5.gamemonetize.com/acr77onayq8v642n5x7z6xki1q6o837d/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75329",
    "slug": "tralalero-tralala-tycoon-obby",
    "title": "tralalero tralala Tycoon + Obby",
    "description": "Run, jump, and build your empire in Tralalero Tycoon Obby, a colorful 3D parkour game where fast-paced obby challenges meet addictive tycoon progression. Complete obstacle courses, earn rewards, spin the wheel, collect playtime bonuses, and upgrade your tycoon to grow stronger with every run.",
    "instructions": "MOVE WASD JUMP SPACE",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2026 games",
      "3D",
      "amazing",
      "Balance",
      "Brainrot",
      "Brainrot Italian",
      "Casual",
      "Fun",
      "Funny",
      "Obstacle",
      "roblox",
      "Tralalero Tralala"
    ],
    "thumbnail": "https://img.gamemonetize.com/qqofegg2n6coarlzox230tse8ijqfv4l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qqofegg2n6coarlzox230tse8ijqfv4l/",
    "sourceUrl": "https://html5.gamemonetize.com/qqofegg2n6coarlzox230tse8ijqfv4l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75190",
    "slug": "mecha-allstars-battle-royale",
    "title": "Mecha Allstars Battle Royale",
    "description": "Get ready to enter the ultimate battlefield of steel and fire. Mecha Allstars Battle Royale is a high-energy action fighting game that throws you into explosive team-based combat. Select equipment to upgrade your mech.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Battle",
      "Fighting",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/o3keyvg8k8ye86o55epwo9uw7j8e89bee/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o3keyvg8k8ye86o55epwo9uw7j8e89bee/",
    "sourceUrl": "https://html5.gamemonetize.com/o3keyvg8k8ye86o55epwo9uw7j8e89bee/",
    "width": 1387,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "75271",
    "slug": "fnf-music-clash",
    "title": "FNF Music Clash",
    "description": "Gear Shift Race throws you into a high-octane challenge where timing is everything. Just when you want a smooth drive, nasty rivals and ruthless bosses push your skills to the limit. Shift gears in perfect rhythm, hit boosts on beat, and race through intense story-driven battles or crash out hard. Face twisted opponents, dominate every stage, and prove you belong on the road. Enjoy a bangin&rsquo; soundtrack that keeps your adrenaline pumping as you master every gear change. With stylish visuals, unique tracks, powerful rivals, and fast-paced gameplay, Gear Shift Race delivers interactive racing excellence where precision, music, and speed collide.",
    "instructions": "Mouse tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Battle",
      "Clash",
      "Dancing",
      "Fashion",
      "Fun",
      "Game",
      "Music",
      "Rhythm",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/0xudc3upbt8y0lxqut6cvrva9h0yze4s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0xudc3upbt8y0lxqut6cvrva9h0yze4s/",
    "sourceUrl": "https://html5.gamemonetize.com/0xudc3upbt8y0lxqut6cvrva9h0yze4s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75355",
    "slug": "obby-extreme-cart-ride",
    "title": "Obby: Extreme Cart Ride",
    "description": "Jumps, speed, and nonstop forward momentum &mdash; there&rsquo;s no time to slow down! Get ready for a wild ride across challenging tracks where every section demands precision and quick reactions. Accelerate, overcome dangerous segments, dodge traps, and try not to fly off the track. Every mistake can cost you the victory &mdash; and that&rsquo;s exactly what makes each run so exciting. As you progress, the tracks become more difficult and the obstacles more unpredictable. Test your control skills, learn to feel the speed, and prove that you can reach the finish line even in the most extreme conditions. What awaits you: &bull; Unique tracks with unexpected turn",
    "instructions": "PC Controls bull W A S D mdash Move character bull Space mdash Jump bull Right mouse button mouse movement mdash Camera control Mobile Controls bull Left joystick mdash Move character bull On-screen button mdash Jump amp",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "Action",
      "Best Games",
      "blocky",
      "Brainrot",
      "Cars",
      "Cartoon",
      "Casual",
      "Driving",
      "eggs",
      "Minecraft",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/liu390xbuce2gxzdh8c65ob14vi8o6ez/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/liu390xbuce2gxzdh8c65ob14vi8o6ez/",
    "sourceUrl": "https://html5.gamemonetize.com/liu390xbuce2gxzdh8c65ob14vi8o6ez/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75367",
    "slug": "funny-hair-salons",
    "title": "Funny Hair Salons",
    "description": "Georges hair is in a no bueno situation. His scalp is full of mites and pimps. The only way to fix his hair is going to the salon. Lets cure his scalp and plant new hair to his head, so he can show his true outter beauty!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Funny",
      "Hair",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/kv087b0a2ovri16fv2432q3uc0q1axi1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kv087b0a2ovri16fv2432q3uc0q1axi1/",
    "sourceUrl": "https://html5.gamemonetize.com/kv087b0a2ovri16fv2432q3uc0q1axi1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75363",
    "slug": "2-player-games-kids-kitchen",
    "title": "2 Player Games Kids Kitchen",
    "description": "Do you want to run your own restaurant? Want to experience the blend of collaboration and cooking fun? Join H5games4us best restaurant tycoon game and enjoy cooking fun. You will engage in different gaming modes. The best part is that you can work together with your friends in the virtual restaurant!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cooking",
      "Fun",
      "Restaurant",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/n3j5e4bfy466hcs72p2y73fxly75zdle/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n3j5e4bfy466hcs72p2y73fxly75zdle/",
    "sourceUrl": "https://html5.gamemonetize.com/n3j5e4bfy466hcs72p2y73fxly75zdle/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75357",
    "slug": "zero-g-wind-escape",
    "title": "Zero G Wind Escape",
    "description": "Along the way, you&rsquo;ll need to collect useful items like keys and briefcases to unlock routes and complete objectives. Each level brings new layouts and tighter spaces, turning simple drifting into a satisfying physics challenge. Easy controls, smart puzzles, and bite-size levels make Zero-G Wind Escape perfect for quick brain workouts anytime.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Escape",
      "Hypercasual",
      "Physics",
      "Puzzle",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/g72u3xfspheum9zp1w0tg0z3wzrtscrx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g72u3xfspheum9zp1w0tg0z3wzrtscrx/",
    "sourceUrl": "https://html5.gamemonetize.com/g72u3xfspheum9zp1w0tg0z3wzrtscrx/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75368",
    "slug": "noob-parkour-2d",
    "title": "Noob: Parkour 2D",
    "description": "Welcome to Noob: Parkour 2D! Noob: Parkour 2D is a parkour game set in a Minecraft-style world where you must overcome obstacles. Game features: Conquer challenging parkour courses, defeat enemies, collect keys, and move on to the next course! Remember, you are a great player and you must win! If you enjoyed the game, please rate it!",
    "instructions": "W A S D or Arrow Keys Double jump activated",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "Block",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/kodqn6kynwbn57dskzi8g6vvexsng2he/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kodqn6kynwbn57dskzi8g6vvexsng2he/",
    "sourceUrl": "https://html5.gamemonetize.com/kodqn6kynwbn57dskzi8g6vvexsng2he/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "75316",
    "slug": "magic-15-puzzle",
    "title": "Magic 15 Puzzle",
    "description": "The classic 15 puzzle game now available on all your devices Order correctly the numbers from 1 to 15 and leave empty the last tile Developed by FLGames in 2025",
    "instructions": "click on a tile to move it",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/xuseqfayanszx97p09h6pocckqyd3m4k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xuseqfayanszx97p09h6pocckqyd3m4k/",
    "sourceUrl": "https://html5.gamemonetize.com/xuseqfayanszx97p09h6pocckqyd3m4k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75348",
    "slug": "mind-math",
    "title": "Mind Math",
    "description": "Math Sprint is a fast-paced arithmetic game that challenges your speed, accuracy, and focus. Solve math problems before time runs out, level up, earn high scores, and achieve top grades. Whether you&rsquo;re a casual player or a math master, Math Sprint keeps your brain active and engaged! Each level gives you 4 math questions with a limited time to answer. The faster and more accurate you are, the higher your score and grade. Progress through increasing difficulty, unlock new modes.",
    "instructions": "Left Mouse Button ndash Select Choose Number",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Android",
      "Brain",
      "Logic",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/vle0fcvaud52czaxp79311wdb0jrko32/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vle0fcvaud52czaxp79311wdb0jrko32/",
    "sourceUrl": "https://html5.gamemonetize.com/vle0fcvaud52czaxp79311wdb0jrko32/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75349",
    "slug": "ultimate-block-puzzle",
    "title": "Ultimate Block Puzzle",
    "description": "An interesting and exciting puzzle awaits you in the new online game Ultimate Block Puzzle. Today you will create various objects. In front of you on the screen you will see a playing field in the upper part of which an object of a certain shape will be drawn. Below it, blocks of different shapes will appear on the panel in turn. You can use the mouse to move them up and place them inside the object. By making moves in this way, your task is to completely fill the internal field of the object. As soon as you do this, you will be given points in the Ultimate Block Puzzle game.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Android",
      "Best",
      "Best Games",
      "Block",
      "Brain",
      "Fun",
      "iPhone",
      "Logic",
      "Mobile",
      "puzzleblock",
      "Skill",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/q557xpxkn86b20teewhu3qekroxopdh2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q557xpxkn86b20teewhu3qekroxopdh2/",
    "sourceUrl": "https://html5.gamemonetize.com/q557xpxkn86b20teewhu3qekroxopdh2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75361",
    "slug": "math-advanced",
    "title": "Math Advanced",
    "description": "Math Advanced is an intellectual game that tests your calculation skills and quick reflexes. The players task is to accurately solve the continuously appearing math problems within a limited time. The faster and more correct your answers, the higher your score, and the more difficult the challenges become. The game is suitable for both entertainment and daily training to improve thinking, concentration, and mathematical skills.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Click",
      "Math",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/j4ege3ipyq3ts3zmtpowl8tpc6i25x91/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j4ege3ipyq3ts3zmtpowl8tpc6i25x91/",
    "sourceUrl": "https://html5.gamemonetize.com/j4ege3ipyq3ts3zmtpowl8tpc6i25x91/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74098",
    "slug": "ocean-catcher-fun",
    "title": "Ocean Catcher fun",
    "description": "Ocean Catcher Fun is a fast-paced arcade hyper-casual game set in a vibrant underwater world where players test their reflexes and timing. Dive into the ocean, catch a variety of fish, avoid dangerous sea creatures, and score as high as possible. Each run is quick, skill-based, and easy to learn but challenging to master. Gameplay &bull; Tap or click to cast your net &bull; Catch safe fish to earn points and combos &bull; Avoid dangerous creatures like sharks and jellyfish &bull; Manage your energy and build high-score streaks Progress &amp; Challenges &bull; Level-based progression with increasing difficulty &bull; Daily missions and objectives &bull; Combo system that reward",
    "instructions": "Game Controls Mouse Touch Click or Tap anywhere to cast your net Net Selector Switch between Small Low Cost Medium and Large High Cost nets depending on the situation",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2025 games",
      "2D",
      "amazing",
      "Best Games",
      "Casual",
      "Classic",
      "endless",
      "Fish",
      "Fishing"
    ],
    "thumbnail": "https://img.gamemonetize.com/45krpb29q3e11xey9vzktjpbe9b5p8xr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/45krpb29q3e11xey9vzktjpbe9b5p8xr/",
    "sourceUrl": "https://html5.gamemonetize.com/45krpb29q3e11xey9vzktjpbe9b5p8xr/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75140",
    "slug": "build-a-tower",
    "title": "Build a tower",
    "description": "Tap to build your dream skyscraper! Every click adds a new floor. Challenge friends on the global leaderboard and unlock unique designs to customize your tower. How high can you go? Simple, addictive, and endlessly fun. Start building your empire in the sky now!",
    "instructions": "Tap to stack floors and compete for the highest tower",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "build",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/almujssv4w7v7lhnc2jjrd37os40dh75/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/almujssv4w7v7lhnc2jjrd37os40dh75/",
    "sourceUrl": "https://html5.gamemonetize.com/almujssv4w7v7lhnc2jjrd37os40dh75/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75284",
    "slug": "gas-station-survival",
    "title": "Gas station survival",
    "description": "Gas Station Survival is a thrilling tower defense game where you must protect your station from relentless waves of enemies. Upgrade your tower, unlock new defenses, and strategically fend off attackers to survive as long as possible. Every upgrade makes your fortress stronger, but the enemies grow tougher too&mdash;only sharp tactics and quick decisions will keep your gas station standing.",
    "instructions": "Use the mouse to upgrade your tower and manage defenses with simple clicks Enemies approach automatically in waves so your focus is on upgrading positioning and timing your actions to keep the gas station safe",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Arcade",
      "survival",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ipjvicr96utfgfafqoyk2ox7wjkj5ct/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ipjvicr96utfgfafqoyk2ox7wjkj5ct/",
    "sourceUrl": "https://html5.gamemonetize.com/4ipjvicr96utfgfafqoyk2ox7wjkj5ct/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75290",
    "slug": "aqua-fish-rush",
    "title": "Aqua Fish Rush",
    "description": "Aqua Fish Rush is an energetic endless 2D underwater runner game in which the player is required to navigate through the water with their fish while dodging other fishes that are not friendly. As the game goes on, the speed raises, making it harder to defeat the enemies. The game offers good controls, nice graphics depicting ocean environments, and easy gameplay that is quite easy to learn but takes time to master. Attempt to survive for as long as possible and try to defeat your highest record in this exciting aquatic adventure.",
    "instructions": "Controls PC Keyboard amp Mouse W ndash Swim Up Up Arrow uarr ndash Swim Up Space Bar ndash Swim Up Right Mouse Click ndash Swim Up Pause Button UI ndash Pause Resume the game Mobile Touch Tap anywhere on the screen ndash Swim",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Defense",
      "Fishing",
      "Fun",
      "Game",
      "survival",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/s4fcgpadzw8nfgqiede354iy6gys1p9m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s4fcgpadzw8nfgqiede354iy6gys1p9m/",
    "sourceUrl": "https://html5.gamemonetize.com/s4fcgpadzw8nfgqiede354iy6gys1p9m/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "996",
    "slug": "monsters-wheels-special",
    "title": "Monsters' Wheels Special",
    "description": "Drive your huge and powerful car on various trucks. Go over hills, precipices and jump over different obstacles. Participate in races against strong opponents and very powerful cars. Ram your opponents and crush them because in demolition derby you need to win by whatever means necessary. Earn money, unlock new cars and upgrade you engine power, durability, nitro and so on. Get behind the wheel, step on the juice and enjoy these dynamic racing game!",
    "instructions": "Arrow up - gas Arrow down - brake Arrow left - balance left Arrow right - balance right Space X - nitro",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Car",
      "Cars",
      "jump",
      "Racing",
      "Truck",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/mde2rzu4y35gw7d96xo2wrjojaz1nx99/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mde2rzu4y35gw7d96xo2wrjojaz1nx99/",
    "sourceUrl": "https://html5.gamemonetize.com/mde2rzu4y35gw7d96xo2wrjojaz1nx99/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "995",
    "slug": "mad-day-2-special",
    "title": "Mad Day 2 Special",
    "description": "Ride, shoot, jump and smash your way to victory in this addictive runner. Team up with ex-Marine Bob to battle evil aliens who have invaded the planet. To make things even worse, they’ve kidnapped his beloved pet octopus. Needless to say that Bob is on a mission to make this an encounter that the aliens won’t soon forget!",
    "instructions": "space - jump double space - double jump x arrow up - rockets",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Action",
      "Alien",
      "Car",
      "Cars",
      "Cartoon",
      "Driving",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/pl0ny22eyt8lt0zseofcxkc7th9gtlej/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pl0ny22eyt8lt0zseofcxkc7th9gtlej/",
    "sourceUrl": "https://html5.gamemonetize.com/pl0ny22eyt8lt0zseofcxkc7th9gtlej/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "966",
    "slug": "mad-truck-challenge-special",
    "title": "Mad Truck Challenge Special",
    "description": "Gear up for roaring, action-packed race battles against the meanest Monster Trucks you’ve ever seen! They’re waiting for you at the Mad Truck Challenge starting line. Strap up for a relentless racing simulator that will have your adrenaline pumping. Select your truck, armed with rockets, and race against the toughest off-road drivers on the planet. Crush and blast your way to victory while you perform extreme stunts and make your opponents bite the dust to earn the coveted MTC trophy.",
    "instructions": "Arrow left right - balancing Space bar - nitro X - rockets",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Action",
      "Car",
      "Cars",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/mlg18x7fbslpg4i3yoxbykpgq90lisr4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mlg18x7fbslpg4i3yoxbykpgq90lisr4/",
    "sourceUrl": "https://html5.gamemonetize.com/mlg18x7fbslpg4i3yoxbykpgq90lisr4/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "75292",
    "slug": "cooking-korean-lessons",
    "title": "Cooking Korean Lessons",
    "description": "Do you know how to make kimchi? Do you know how to make bibimbap? Lets play together and serve the best kimchi and bibimbap you can make!",
    "instructions": "Use MOUSE to play the game",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cook",
      "Cooking",
      "Dress Up",
      "HTML5",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/7nwavo9azy74s1zf1p5s16sz1ege95h6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7nwavo9azy74s1zf1p5s16sz1ege95h6/",
    "sourceUrl": "https://html5.gamemonetize.com/7nwavo9azy74s1zf1p5s16sz1ege95h6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74179",
    "slug": "3d-maze-control",
    "title": "3D Maze Control",
    "description": "3D Maze Control is a casual and fun puzzle physics game. Your goal is to rotate the board to let the ball reach its goal. The ball always falls down due to gravity and beware of scary aliens on the way.",
    "instructions": "Use your mouse or tap the screen to rotate the board",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D Games",
      "Alien",
      "Ball",
      "Casual",
      "Fun",
      "Funny",
      "Hypercasual",
      "Kids",
      "Maze",
      "Physics",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/2dt5i17at52tsqt6jec4urf41ct7q4rm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2dt5i17at52tsqt6jec4urf41ct7q4rm/",
    "sourceUrl": "https://html5.gamemonetize.com/2dt5i17at52tsqt6jec4urf41ct7q4rm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75293",
    "slug": "escape-maze",
    "title": "Escape Maze",
    "description": "Escape Maze is a sleek and immersive 2D maze puzzle game that challenges your logic, focus, and sense of direction. Guide a glowing white cube through beautifully designed top-down mazes, navigating tight paths, misleading routes, and clever dead ends to reach the hidden exit. With smooth touch and mouse controls, the game is optimised for both mobile and desktop play, offering a seamless experience across all devices. Each level features a fresh background color, subtle flying particle effects, and progressively harder maze layouts that keep the game play unpredictable and engaging.There&rsquo;s no timer success depends purely on precision.......",
    "instructions": "Tap the arrow on the cube to choose a direction The cube will automatically move until it hits a wall or reaches a new junction Works on both mobile and desktop",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Android",
      "Casual",
      "Maze",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/dbtfo7n2j64ac27jv7276k5jjgq2qplk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dbtfo7n2j64ac27jv7276k5jjgq2qplk/",
    "sourceUrl": "https://html5.gamemonetize.com/dbtfo7n2j64ac27jv7276k5jjgq2qplk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75193",
    "slug": "wars-island-commander",
    "title": "Wars Island Commander",
    "description": "A global zombie infestation has converted many into zombies. As a survivor, your primary goal is to retain your humanity and survive. Begin your journey with an intense survival challenge. Dodge and combat waves of zombies. Its not just about survival; its about quick reflexes and strategic thinking, as each lane presents unique obstacles and zombies! - Create Your Zombie-Free Shelter Customize your base and expand your army - you are the light in this shelter, leading people towards a glimmer of hope.",
    "instructions": "Use a mouse click to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2026 games",
      "Army",
      "Battle",
      "Battlegrounds",
      "Collecting",
      "Island",
      "military",
      "Shoot",
      "Strategy",
      "survival",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/k5hyx81jyfp1tbbxs7nipu01qrk1bkhm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k5hyx81jyfp1tbbxs7nipu01qrk1bkhm/",
    "sourceUrl": "https://html5.gamemonetize.com/k5hyx81jyfp1tbbxs7nipu01qrk1bkhm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75092",
    "slug": "doodle-car-race",
    "title": "Doodle Car Race",
    "description": "Doodle Car Race is a fun and creative racing game where your car starts with your own drawing. At the beginning of each match, sketch a car shape and watch it instantly come to life. Then race against opponents in fast battles and fight your way to the top to become the champion.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Battle",
      "Car",
      "Design",
      "Drawing",
      "Physics",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/51aqkc4jms89fx9patymyowjoqmgb016/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/51aqkc4jms89fx9patymyowjoqmgb016/",
    "sourceUrl": "https://html5.gamemonetize.com/51aqkc4jms89fx9patymyowjoqmgb016/",
    "width": 640,
    "height": 1136,
    "lastUpdated": ""
  },
  {
    "id": "73014",
    "slug": "snakey-hunters-arena",
    "title": "Snakey: Hunters Arena",
    "description": "Advanced snake game with power-ups, abilities, hunters, and progressive levels. Collect food, avoid obstacles, and survive as long as you can! LEVEL PROGRESSION Level 0-4: Basic gameplay, increasing speed Level 5+: Obstacles appear (rocks, spikes, portals) Level 10+: Armed hunters start appearing and shooting bullets Every 30 seconds: Level increases, more obstacles and hunters spawn",
    "instructions": "Desktop Arrow Keys - Move snake uarr darr larr rarr Hold Arrow Keys - Speed boost 60 faster Mobile Touch Swipe - Move snake in desired direction Hold Swipe - Speed boost",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Casual",
      "Hypercasual",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/qjusux5oqqbsva2z8x2fu24h3afnpsst/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qjusux5oqqbsva2z8x2fu24h3afnpsst/",
    "sourceUrl": "https://html5.gamemonetize.com/qjusux5oqqbsva2z8x2fu24h3afnpsst/",
    "width": 800,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "74828",
    "slug": "sandwich-runner-game",
    "title": "Sandwich Runner Game",
    "description": "Make extraordinary sandwich by towering it with sandwich ingredients. Sandwich runner game is a sandwich maker running game in which sandwich stack acts like a sandwich maker. Your job is to make sandwich stack while picking the sandwich maker ingredients in one of the unique sandwich runner games. Just swipe left and right to make your sandwich spicy or normal in sandwich stack - sandwich runner game.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "amazing",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/xellcmcuj2zc8q0w6wvucipgpxoa74s0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xellcmcuj2zc8q0w6wvucipgpxoa74s0/",
    "sourceUrl": "https://html5.gamemonetize.com/xellcmcuj2zc8q0w6wvucipgpxoa74s0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74765",
    "slug": "flappy-birds-smash",
    "title": "Flappy Birds Smash",
    "description": "It&rsquo;s a fun arcade game, and it is not as easy as it looks. It has a simple but not rough pixel picture, a little bird. Gameplay You need to constantly control the frequency of clicking on the screen to adjust the flying height and landing speed of the bird, so that the bird can smoothly pass through the pipe gap on the right side of the screen. Prepare for a thrilling twist on the classic bird-shooting game with Angry Flappy Birds.",
    "instructions": "Left Mouse click",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "angrybirds",
      "Arcade",
      "Best Games",
      "Bird",
      "Casual",
      "flappybird",
      "Game",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/024t3d4llydo3nkvpkxqae30dtiddena/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/024t3d4llydo3nkvpkxqae30dtiddena/",
    "sourceUrl": "https://html5.gamemonetize.com/024t3d4llydo3nkvpkxqae30dtiddena/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75280",
    "slug": "road-racer-2",
    "title": "Road Racer 2",
    "description": "Experience the thrill of the neon highway in Road Racer 2! Drive at high speeds, dodge heavy traffic, and survive the realistic day-night cycle with dynamic street lighting. Features smooth physics-based steering, stunning visual effects, and intense endless gameplay. How far can you go without crashing?",
    "instructions": "Desktop Use Left and Right Arrow keys to steer Mobile Tap the Left or Right side of the screen to move",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "Driving",
      "endless",
      "Racing",
      "spin-wheel"
    ],
    "thumbnail": "https://img.gamemonetize.com/zru2a1xcmbfoa11pq8nqlce2dzfes58a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zru2a1xcmbfoa11pq8nqlce2dzfes58a/",
    "sourceUrl": "https://html5.gamemonetize.com/zru2a1xcmbfoa11pq8nqlce2dzfes58a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75283",
    "slug": "flappy-minecraft",
    "title": "Flappy Minecraft",
    "description": "Flappy Minecraft is a fast-paced arcade game that combines classic Flappy Bird gameplay with a familiar Minecraft-inspired visual style. Players control a flying character and must stay airborne while passing through obstacles with precise timing and quick reflexes. Unlike traditional Flappy-style games, the green block obstacles appear suddenly and randomly, forcing players to react instantly instead of memorizing patterns. This unexpected obstacle system makes every run unique and significantly more challenging. Simple controls, increasing difficulty, and unpredictable block placement create a highly addictive experience focused on reflexes",
    "instructions": "Tap to keep the character flying and avoid crashing into green blocks Obstacles appear randomly and without warning requiring fast reactions and perfect timing Each successful pass increases your score pushing you to survive longer and beat your best",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "Arcade",
      "flappybird",
      "Fun",
      "Funny",
      "jump",
      "Jumping",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/mev9bpmqryqha1mwkju35tie5n262d91/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mev9bpmqryqha1mwkju35tie5n262d91/",
    "sourceUrl": "https://html5.gamemonetize.com/mev9bpmqryqha1mwkju35tie5n262d91/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73185",
    "slug": "flappy-bacchan",
    "title": "Flappy bacchan",
    "description": "Flappy Bacchan is a hilarious action-arcade game where you guide the legendary &lsquo;Bacchan&rsquo; through crazy obstacles! Tap to fly, dodge pipes, beat high scores, and unlock epic stick-figure styles. With funny animations, catchy sound effects, and endless challenge, this game brings pure entertainment. Simple to play, hard to master &mdash; how far can you make Bacchan fly? Play, laugh, and compete with friends!",
    "instructions": "Desktop use mouse click Tap anywhere to jump Goal Fly through gaps avoid pipes and score points",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Funny"
    ],
    "thumbnail": "https://img.gamemonetize.com/r276cvpzjp8ehtfbbw6sivefvir90imc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r276cvpzjp8ehtfbbw6sivefvir90imc/",
    "sourceUrl": "https://html5.gamemonetize.com/r276cvpzjp8ehtfbbw6sivefvir90imc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75298",
    "slug": "bee-and-flower",
    "title": "Bee and Flower",
    "description": "Bee and Flower is a light and relaxing skill game where you control a small bee flying around the garden to collect vibrant flowers. Skillful control, avoiding obstacles, and choosing the right flight path to gather as many flowers as possible. The simple gameplay and cheerful atmosphere provide a pleasant entertainment experience suitable for all ages.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Casual",
      "Collecting",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/4q455laryczf3114nqvs1h513b5a1xjl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4q455laryczf3114nqvs1h513b5a1xjl/",
    "sourceUrl": "https://html5.gamemonetize.com/4q455laryczf3114nqvs1h513b5a1xjl/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74577",
    "slug": "prime-sudoku",
    "title": "Prime Sudoku",
    "description": "Sudoku is a relaxing yet challenging number puzzle game made for Jio feature phones. Fill the 9&times;9 grid with numbers 1 to 9 without repeating any in a row, column, or 3&times;3 box. Choose from different difficulty levels and test your logic skills.",
    "instructions": "Start Sudoku by selecting a difficulty level Fill each row column and 3x3 grid with numbers from 1 to 9 without repeating any number Tap a cell to select it then choose a number to fill in Use the erase button to clear mistakes The game ends when a",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "digital circus",
      "Number",
      "Puzzle",
      "Sudoku"
    ],
    "thumbnail": "https://img.gamemonetize.com/emtp8idjxf95f5b37mhsn1p7muehu9v8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/emtp8idjxf95f5b37mhsn1p7muehu9v8/",
    "sourceUrl": "https://html5.gamemonetize.com/emtp8idjxf95f5b37mhsn1p7muehu9v8/",
    "width": 360,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "75146",
    "slug": "colosseum-battle",
    "title": "Colosseum Battle",
    "description": "Youre the man in the Arena!!! Survive the tigers in the old Colosseum in Rome, show the world that youre worthy!! Developed by FLGames in 2025",
    "instructions": "WASD or arrows to move Click or Tap to use the sword",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Animal",
      "Arena",
      "Battle",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/7rw9ll8efbvho5y5ga9zhcv92s95od0j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7rw9ll8efbvho5y5ga9zhcv92s95od0j/",
    "sourceUrl": "https://html5.gamemonetize.com/7rw9ll8efbvho5y5ga9zhcv92s95od0j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75275",
    "slug": "color-auction-studio",
    "title": "Color Auction Studio",
    "description": "Color Auction Studio is a relaxing art simulation where you turn blank items into valuable masterpieces. Start by coloring and painting, then refine your work until it&rsquo;s ready to show off and sell at auction. The better you finish, the more coins you earn.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Makeover",
      "Mobile",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/7vwmyewmslhds7a1obijxykxvcwyx5ec/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7vwmyewmslhds7a1obijxykxvcwyx5ec/",
    "sourceUrl": "https://html5.gamemonetize.com/7vwmyewmslhds7a1obijxykxvcwyx5ec/",
    "width": 576,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "75273",
    "slug": "hipsters-vs-rockers",
    "title": "Hipsters vs Rockers",
    "description": "Gaia, Ero and Ai are best friends forever. They like to try the latest fashion and compare with one another that suits them. This time they tried the style of rockers and hipsters. Wonder which fashion is suitable for them?",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girls",
      "Kids",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/yo8fxgxdgxczxv7im59lx219pddctzjh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yo8fxgxdgxczxv7im59lx219pddctzjh/",
    "sourceUrl": "https://html5.gamemonetize.com/yo8fxgxdgxczxv7im59lx219pddctzjh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75258",
    "slug": "warplane",
    "title": "WarPlane",
    "description": "War Plane is an exciting action game where you control a warship and plunge into fierce battles with the enemy. Dodge fire, attack precisely, and destroy waves of enemies to gain control of the skies. The game is fast-paced, easy to play, yet full of drama, suitable for those who love the feeling of continuous combat and challenging reflexes.",
    "instructions": "Use arrow button to move R to Dash Space to Shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "airplane",
      "attack",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/wgywmblcy2ez27hdgl6a2g2ao9hfwjaj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wgywmblcy2ez27hdgl6a2g2ao9hfwjaj/",
    "sourceUrl": "https://html5.gamemonetize.com/wgywmblcy2ez27hdgl6a2g2ao9hfwjaj/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75191",
    "slug": "head-basketball-arena",
    "title": "Head Basketball Arena",
    "description": "Head basketball sports which are a simplified of basketball game. Before each game, you can choose your character and then customize its appearance and other features of the game like playground, weather, AI difficulty, match duration and etc. The rest is simple! You have four buttons to control your character and earn scores against your opponent. Two keys are for moving, one is for jumping and the other one is for kicking the ball with your foot or head.",
    "instructions": "- To click any button use mouse",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Adventure",
      "Basketball",
      "Battlegrounds",
      "Sport",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/9xqde35qpwv69d32wksqifnnltqf6sid/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9xqde35qpwv69d32wksqifnnltqf6sid/",
    "sourceUrl": "https://html5.gamemonetize.com/9xqde35qpwv69d32wksqifnnltqf6sid/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75192",
    "slug": "head-volleyball-sport-game",
    "title": "Head Volleyball Sport Game",
    "description": "Head volleyball sports which are a simplified of volleyball game. Before each game, you can choose your character and then customize its appearance and other features of the game like playground, weather, AI difficulty, match duration and etc. The rest is simple! You have four buttons to control your character and earn scores against your opponent. Two keys are for moving, one is for jumping and the other one is for kicking the ball with your foot or head.",
    "instructions": "- To click any button use mouse",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2 Player Games",
      "2026 games",
      "Adventure",
      "Battlegrounds",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/jz8w9k3nxk7qs6axk3b24frb1u89mm1y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jz8w9k3nxk7qs6axk3b24frb1u89mm1y/",
    "sourceUrl": "https://html5.gamemonetize.com/jz8w9k3nxk7qs6axk3b24frb1u89mm1y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75163",
    "slug": "run-snowball-run",
    "title": "Run Snowball Run",
    "description": "An endless runner adventure through pixelated landscapes Features Infinite procedural levels Multiple obstacle types Flying enemies Score tracking Retro pixel art Tips Time your jumps carefully Watch for flying enemies Slide under obstacles Practice makes perfect!",
    "instructions": "X - Jump Z - Slide",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "endless",
      "Family",
      "Highscore",
      "Hypercasual",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/1jqyeyaf9lwbuuruhjej5jeq2s06f56b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1jqyeyaf9lwbuuruhjej5jeq2s06f56b/",
    "sourceUrl": "https://html5.gamemonetize.com/1jqyeyaf9lwbuuruhjej5jeq2s06f56b/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "75250",
    "slug": "stickman-gun-runner",
    "title": "Stickman Gun Runner",
    "description": "Stickman Gun Runner is an action-packed RPG runner shooter game that combines fast-paced gun shooting, intense stickman fighting, and nonstop adventure. Step into a dark and dangerous world where you control a fearless stickman warrior running forward while shooting zombies, monsters, and powerful enemies. Upgrade your weapons, unlock new guns, master special skills, and customize your stickman with cool skins as you progress through challenging levels. Each run tests your reflexes, aiming accuracy, and combat strategy. Face deadly bosses, dodge obstacles, and survive waves of enemies in this thrilling action shooter game.",
    "instructions": "Use Mouse Click to Play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2026 games",
      "Action",
      "Arcade",
      "Best Games",
      "Casual",
      "firefighters",
      "Gun",
      "running",
      "Shooter",
      "Stickman",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/0h5o76e5mwy6dhmu5zqall1ys6hrm0jn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0h5o76e5mwy6dhmu5zqall1ys6hrm0jn/",
    "sourceUrl": "https://html5.gamemonetize.com/0h5o76e5mwy6dhmu5zqall1ys6hrm0jn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75168",
    "slug": "neon-predator",
    "title": "Neon Predator",
    "description": "Step into the digital void in Neon Predator - Cyber Survival, a high-octane minimalist arcade experience where only the fastest survive. You are a pulsing core of energy in a world of predatory geometric shadows. Your objective is simple but lethal: consume the smaller neon spheres to increase your mass and dominance. But stay alert:you arent the only predator in the grid. Larger, more aggressive entities roam the darkness, waiting for you to misstep. One collision with a superior force means instant deletion. As you grow, the Neon Fever sets in. The grid becomes more crowded, the enemies move with more intelligence, the speed intensifies",
    "instructions": "Desktop Mouse Movement Simply move your cursor to guide your Predator The circle follows your pointer with physics-based momentum Esc P Toggle the Pause menu Mobile Touch Touch amp Drag Tap anywhere on the screen and drag to move your Predator",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Arena",
      "crazygamesunblocked",
      "endless",
      "Science",
      "survival",
      "unblocked",
      "unblocked games"
    ],
    "thumbnail": "https://img.gamemonetize.com/jyggk88tasujz96fhhnyz3q71acakc1x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jyggk88tasujz96fhhnyz3q71acakc1x/",
    "sourceUrl": "https://html5.gamemonetize.com/jyggk88tasujz96fhhnyz3q71acakc1x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75100",
    "slug": "jewel-match-puzzle",
    "title": "Jewel Match Puzzle",
    "description": "Explore a World of Jewels and Adventure Step into a sparkling journey through deserts, glaciers, and beyond. Jewel Match puzzle offers classic match-3 gameplay with colorful visuals, smooth controls, and hundreds of unique levels. Swap jewels, trigger powerful combos, and collect sparkling treasures as you unlock new stages. Whether you have a minute or an hour, this game offers the perfect puzzle break. Match jewel cubes, solve puzzles, train your brain, and beat boredom! Tap matching colors to enjoy thousands of fun and challenging matching-color puzzles!",
    "instructions": "Mouse click to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Best Games",
      "Brain",
      "Educational",
      "Jewel",
      "Logic",
      "Matching",
      "Math",
      "Puzzle",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/8qgyaqb59yxy6s5qvf6abbn5rhmgboew/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8qgyaqb59yxy6s5qvf6abbn5rhmgboew/",
    "sourceUrl": "https://html5.gamemonetize.com/8qgyaqb59yxy6s5qvf6abbn5rhmgboew/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75016",
    "slug": "the-mazes-of-infinity",
    "title": "The Mazes of Infinity",
    "description": "The Mazes of Infinity is an exciting game that offers a unique adventure for all lovers of maze passing. Discover an exciting world full of mysteries and riddles, and immerse yourself in an endless number of procedurally created mazes of varying complexity. The game offers a wide range of modes that can be unlocked as you earn score. The variety of modes adds variety and challenge to the gameplay, allowing you to constantly find something new and exciting.",
    "instructions": "Movement WASD Arrow Buttons To complete the maze stand on a square with a blue circle exit Score and coins are given for passing Their amount depends on the mode and difficulty level You can unlock new modes and difficulty levels for coins",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Adult",
      "Best Games",
      "Brain",
      "Casual",
      "Educational",
      "endless",
      "Escape",
      "html games for your website",
      "Logic",
      "Logical",
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/6up9c6fsxdcn3vt5eo3vz6upvn99r7rh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6up9c6fsxdcn3vt5eo3vz6upvn99r7rh/",
    "sourceUrl": "https://html5.gamemonetize.com/6up9c6fsxdcn3vt5eo3vz6upvn99r7rh/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75009",
    "slug": "math-is-easy",
    "title": "Math is easy!",
    "description": "Math is Easy! is an exciting and challenging game for anyone who wants to practice math! Test your skills by combining examples with correct answers, and calculate a wide variety of expressions. - Many mathematical operations: addition, subtraction, multiplication, division, fractions, roots, degrees, etc. - Difficulty levels: Start with simple examples and gradually move on to complex calculations. - Compete: Compare your scores with other players in the global high score table. - Develop your skills: Hone your mathematical intuition and expand your knowledge.",
    "instructions": "Connect examples red text left column and answers green text right column by pressing the cursor or finger When all the blocks on the screen are paired you can test yourself Explanations 1 log X Y is the logarithm of Y based on X 2 sqrt is th",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Brain",
      "Educational",
      "endless",
      "free html5 games for your website",
      "Hypercasual",
      "Math",
      "Number",
      "Puzzle",
      "Quiz",
      "School",
      "Super",
      "Train"
    ],
    "thumbnail": "https://img.gamemonetize.com/js4jmc9kvc0gqwipc2t3sbyvgayd42yg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/js4jmc9kvc0gqwipc2t3sbyvgayd42yg/",
    "sourceUrl": "https://html5.gamemonetize.com/js4jmc9kvc0gqwipc2t3sbyvgayd42yg/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "74965",
    "slug": "lumina-weaver",
    "title": "Lumina Weaver",
    "description": "Master the neon void in Lumina Weaver! Collect orbs, dodge spikes, and survive as long as you can. Fully optimized for mobile devices.",
    "instructions": "Desktop Move your mouse to guide the ribbon Mobile Touch and drag on the screen to steer",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Avoid",
      "Collecting"
    ],
    "thumbnail": "https://img.gamemonetize.com/5hx8h33uw4w8kp0i9a2b9myle17sfowu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5hx8h33uw4w8kp0i9a2b9myle17sfowu/",
    "sourceUrl": "https://html5.gamemonetize.com/5hx8h33uw4w8kp0i9a2b9myle17sfowu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71618",
    "slug": "cut-it",
    "title": "Cut It",
    "description": "Cut It is a fun and satisfying puzzle game where precision matters. Slice objects at the perfect angle to complete each level and unlock new challenges. Easy to play, hard to master!",
    "instructions": "Mouse click and slide to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "cut",
      "Relaxation",
      "Slicing"
    ],
    "thumbnail": "https://img.gamemonetize.com/0n2nwj22igmzntq12jq6eoj3cv2stweh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0n2nwj22igmzntq12jq6eoj3cv2stweh/",
    "sourceUrl": "https://html5.gamemonetize.com/0n2nwj22igmzntq12jq6eoj3cv2stweh/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "74009",
    "slug": "restaurant-tycoon",
    "title": "Restaurant Tycoon",
    "description": "In the Restaurant Tycoon game, your main goal is to become a tycoon, successfully developing your business and increasing the profits of your restaurant empire. The game offers the perfect combination of gameplay and strategic decisions. Relax, enjoy the game and watch your empire flourish. Hire managers who will manage your establishment and earn coins in idle mode. Unlock new levels floors. Constantly improve the levels of managers to reach the top of management. Raise the level of your kitchen for faster and more efficient cooking, as well as invest in modern elevators to meet the needs of your clientele.",
    "instructions": "The game is controlled by the mouse cursor tap on the screen Hire managers Improve the levels of the elevator the kitchen and the restaurant itself Earn coins Open new floors Going into the game after some time you will get a big reward for i",
    "category": "Cooking",
    "genres": [
      "Cooking"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Restaurant"
    ],
    "thumbnail": "https://img.gamemonetize.com/e95zrrqgy2byky91pydr21z02za2q9ql/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e95zrrqgy2byky91pydr21z02za2q9ql/",
    "sourceUrl": "https://html5.gamemonetize.com/e95zrrqgy2byky91pydr21z02za2q9ql/",
    "width": 1200,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73637",
    "slug": "the-number-puzzle",
    "title": "THE NUMBER PUZZLE",
    "description": "Test your brain with the ultimate Sudoku challenge! Enjoy hours of number puzzle fun with this classic Sudoku game, designed for players of all skill levels. Fill the 9&times;9 grid with numbers 1 through 9 so that every row, column, and 3&times;3 box contains each number exactly once. Whether you&rsquo;re a beginner or a Sudoku master, this game sharpens your mind and improves logic skills. Features include: Multiple difficulty levels &ndash; Easy, Medium, Hard, and Expert. Intuitive controls and smooth gameplay. Timer to challenge your speed and accuracy. Undo &amp; hint system to help you solve tricky puzzles.",
    "instructions": "Mouse Touch Click or tap on a cell to select it then click tap a number to fill it Keyboard Use number keys 1 ndash 9 to fill the selected cell Undo Hint Use on-screen buttons to undo moves or get hints",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Brainrot",
      "Game",
      "Geometry",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/dpq6e4s4f3ieccpufdsmq2c6xiams70t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dpq6e4s4f3ieccpufdsmq2c6xiams70t/",
    "sourceUrl": "https://html5.gamemonetize.com/dpq6e4s4f3ieccpufdsmq2c6xiams70t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73396",
    "slug": "magical-tic-tac-toe",
    "title": "magical tic tac toe",
    "description": "Magical Tic Tac Toe is a fresh and modern version of the classic game! Play against a smart computer with multiple difficulty levels or challenge a friend on the same device. Earn coins, unlock beautiful gradient themes, and enjoy smooth animations with a clean premium UI. Perfect for all ages &mdash; simple to play, fun to master, and fully responsive on mobile &amp; desktop. Can you outsmart the computer?",
    "instructions": "Mouse Touch Controls bull Tap or click on any square to place X or O bull Use Pause to stop the game anytime bull Press Home to return to the main menu bull Select themes and difficulties using on-screen buttons bull Earn coins automatically",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "Boy",
      "Girl",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/etd4mypbj2bl7uhstqki1zuq62ln3evu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/etd4mypbj2bl7uhstqki1zuq62ln3evu/",
    "sourceUrl": "https://html5.gamemonetize.com/etd4mypbj2bl7uhstqki1zuq62ln3evu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75254",
    "slug": "baby-race-galaxy-2",
    "title": "Baby Race Galaxy 2",
    "description": "Get ready for a funny race baby in Baby Race Galaxy! Race and upgrade your race car to the maximum speed. Buy accessories to accompany you in this long race. Explore different galaxies and become the best baby racer in the universe. Have fun!",
    "instructions": "Use WASD ARROW SPACE to play the game",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Baby",
      "Car",
      "Fun",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/e1vfnq3syvvgu1uag8qzf8s45ckw3hnt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e1vfnq3syvvgu1uag8qzf8s45ckw3hnt/",
    "sourceUrl": "https://html5.gamemonetize.com/e1vfnq3syvvgu1uag8qzf8s45ckw3hnt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75240",
    "slug": "dinosaur-rampage",
    "title": "Dinosaur Rampage",
    "description": "When the rampage ends, you&rsquo;ll compete against other dinosaurs in the same arena and get ranked based on your destruction performance. Unlock many different dinosaur types, collect cool skins in the shop, and prove you&rsquo;re the ultimate king of chaos. Fast, satisfying, and perfect for stress relief&mdash;just stomp, smash, and climb the leaderboard!",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "Action",
      "Casual",
      "city",
      "destruction",
      "dino",
      "Dinosaur",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/fkc3rct9vk7ac6rtv94i24tw2vtpxcti/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fkc3rct9vk7ac6rtv94i24tw2vtpxcti/",
    "sourceUrl": "https://html5.gamemonetize.com/fkc3rct9vk7ac6rtv94i24tw2vtpxcti/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75197",
    "slug": "trail-rider",
    "title": "Trail Rider",
    "description": "Trail Rider is a fun and addictive drawing game where your imagination drives the jeep! Draw a line to build the trail, guide your jeep to the finish line, and avoid dangerous obstacles along the way. Think one step ahead, plan your path carefully, and ride your way to success!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Car",
      "Draw",
      "Drawing",
      "Driving",
      "Hypercasual",
      "jeep",
      "Kids",
      "Obstacle",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/mostmenk0hogv1kkcrdwoi4xdqfxcr4n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mostmenk0hogv1kkcrdwoi4xdqfxcr4n/",
    "sourceUrl": "https://html5.gamemonetize.com/mostmenk0hogv1kkcrdwoi4xdqfxcr4n/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75251",
    "slug": "christmas-bridge-runner",
    "title": "Christmas Bridge Runner",
    "description": "Choose your route, grab enough socks, and build faster than your rivals. The more you collect, the easier it is to climb&mdash;but wait too long and someone else may reach the top first. Quick matches, satisfying bridge-building, and a cozy Christmas vibe make this the perfect holiday race. Can you be the first to reach the highest platform?",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Bridge",
      "Christmas",
      "Holiday",
      "running",
      "Stack",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/bjoap0vw6oi1y5xvqfwjjuvte90d4p1i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bjoap0vw6oi1y5xvqfwjjuvte90d4p1i/",
    "sourceUrl": "https://html5.gamemonetize.com/bjoap0vw6oi1y5xvqfwjjuvte90d4p1i/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "75158",
    "slug": "zombie-street-fighter",
    "title": "Zombie Street Fighter",
    "description": "Street Fighter IV: Champion Edition perfects the winning gameplay formula by offering the most exciting fighting game on mobile. Long time Street Fighter fans can jump into the action and have an instant familiarity with the controls. For more casual players Street Fighter IV features numerous settings and tutorials that put you on the path to victory.",
    "instructions": "use key board arrow keys and keys z x c for fight",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "assasin",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/27v4xw60npqnujfp8gjpx3qaeeh5pzm9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/27v4xw60npqnujfp8gjpx3qaeeh5pzm9/",
    "sourceUrl": "https://html5.gamemonetize.com/27v4xw60npqnujfp8gjpx3qaeeh5pzm9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75175",
    "slug": "retro-x-racer",
    "title": "Retro x Racer",
    "description": "Pilot a high-speed jet in Retro X Racer! Dodge infinite towers, collect credits, and grab power-ups to survive as long as you can. Use A/D or Arrow Keys to steer and set the highest score.",
    "instructions": "Controls A or Left Arrow Key Move Left D or Right Arrow Key Move Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Racing",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/n6uz0z9jcww93cq7k5nn8guh2244qc1j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n6uz0z9jcww93cq7k5nn8guh2244qc1j/",
    "sourceUrl": "https://html5.gamemonetize.com/n6uz0z9jcww93cq7k5nn8guh2244qc1j/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75241",
    "slug": "brick-challenge",
    "title": "Brick Challenge",
    "description": "Brick Challenge is a fun puzzle game where you need to arrange bricks of the same color next to each other to score points. Observe quickly, choose your moves wisely, and create large combinations to achieve the highest score. Each level presents a new challenge, helping to train your thinking skills and providing engaging entertainment.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Color",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/u0f4wlhmsvqlp7yiqpr9d9bch7pypdfc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u0f4wlhmsvqlp7yiqpr9d9bch7pypdfc/",
    "sourceUrl": "https://html5.gamemonetize.com/u0f4wlhmsvqlp7yiqpr9d9bch7pypdfc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75195",
    "slug": "queen-bee-run",
    "title": "Queen Bee Run",
    "description": "Step into the world of glamour and style with Queen Bee Run! The ultimate fashion game where you can become a doll maker and create your dream queen! Become a virtual fashion designer and let your creativity shine! Choose your model and dive into a project makeover. Design everything: from stunning hairstyles and flawless makeup to the hottest outfits and fabulous accessories! This is your chance to build a sweet doll with your unique style. Showcase your looks on the catwalk and compete in thrilling fashion battles! Will you make the right choices to win and become the ultimate Fashion Queen? Play Queen Bee and use combinations of makeovers",
    "instructions": "Use a mouse click to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Arcade",
      "beauty",
      "Casual",
      "Collecting",
      "Dress Up",
      "Fashion",
      "Girls",
      "Makeover",
      "Obstacle",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/mly9r03mguwtebz742huj4vd52f9ttpg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mly9r03mguwtebz742huj4vd52f9ttpg/",
    "sourceUrl": "https://html5.gamemonetize.com/mly9r03mguwtebz742huj4vd52f9ttpg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75223",
    "slug": "dentist-doctor-game",
    "title": "Dentist Doctor Game",
    "description": "Become a dentist and help our friends to have a healthy mouth. Brian, Katie, Frank and Peter have come to the dental clinic for you to help them clean their teeth, put fillings or fix broken teeth. Your children may perform dental treatments and play as experts dentists. Help your kid become a dentist, its educational and fun. Enjoy our amazing dentists game.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2026 games",
      "Adventure",
      "amazing",
      "Doctor"
    ],
    "thumbnail": "https://img.gamemonetize.com/a2y3nwkemv1qiq6f0xj423o3rwsu7e80/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a2y3nwkemv1qiq6f0xj423o3rwsu7e80/",
    "sourceUrl": "https://html5.gamemonetize.com/a2y3nwkemv1qiq6f0xj423o3rwsu7e80/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74817",
    "slug": "swap-and-solve",
    "title": "Swap And Solve",
    "description": "Swap tiles, race the clock, and reveal stunning fantasy images. Relax into a smooth puzzle flow where smart swaps and quick thinking bring every picture together.",
    "instructions": "1 Scrambled tile image 2 Adjacent tile swapping 3 Picture completion goal 4 Countdown timer pressure 5 Visual pattern recognition 6 Mouse Touch",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fantasy",
      "Jigsaw",
      "Kids",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ruect5vdmg6uar178515cuz5ztc15ap5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ruect5vdmg6uar178515cuz5ztc15ap5/",
    "sourceUrl": "https://html5.gamemonetize.com/ruect5vdmg6uar178515cuz5ztc15ap5/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "75253",
    "slug": "mr-been-puzzle-time",
    "title": "Mr Been Puzzle Time",
    "description": "Mr. Bean Puzzle Time is a fun online jigsaw game for kids! Solve colorful puzzles featuring everyone&rsquo;s favorite funny character, Mr. Bean. Drag and drop the pieces to complete each picture, unlock new levels, and enjoy hours of playful brain-teasing fun. Perfect for developing problem-solving skills while having a laugh!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boy",
      "Brain",
      "Cartoon",
      "Girl",
      "Jigsaw",
      "Kids",
      "Logic",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/z2jndbsgxh587pvrbaznwp1sco9ong7p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z2jndbsgxh587pvrbaznwp1sco9ong7p/",
    "sourceUrl": "https://html5.gamemonetize.com/z2jndbsgxh587pvrbaznwp1sco9ong7p/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "74934",
    "slug": "jelly-runner-platform",
    "title": "Jelly runner platform",
    "description": "Jelly Runner Platform is a fun and colorful platform runner where you guide a bouncy jelly through exciting levels full of obstacles, coins, and surprises. Jump, dodge, and run your way across vibrant platform while enjoying smooth controls and cheerful visuals. Easy to play, hard to master&mdash;perfect for quick fun anytime! Mobile Players: Please rotate your phone for the best gaming experience and enjoy the full colorful adventure!",
    "instructions": "Game Controls PC Press Space or Left Mouse Click to Jump Mobile Tap anywhere on the screen to Jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Android",
      "Arcade",
      "Best Games",
      "Jelly",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/u4mf9621e9skpp79vz8n5gzew8re8ur0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u4mf9621e9skpp79vz8n5gzew8re8ur0/",
    "sourceUrl": "https://html5.gamemonetize.com/u4mf9621e9skpp79vz8n5gzew8re8ur0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75074",
    "slug": "dino-runner-birthday",
    "title": "Dino Runner Birthday",
    "description": "Celebrate in high-speed style with Dino Runner Birthday! In this neon-soaked endless runner, you take control of a cyber-enhanced dinosaur sprinting through a futuristic landscape. The game combines classic jump and duck mechanics with a vibrant synthwave aesthetic and increasing difficulty that challenges your reflexes. Navigate past hazardous energy blocks and low-flying obstacles while the world speeds up around you. Whether you are dodging red spikes or sliding under blue barriers, your goal is to survive as long as possible to reach a new high score. Perfect for quick gaming sessions, Dino Runner Birthday features smooth controls.",
    "instructions": "Desktop Keyboard Spacebar Up Arrow Jump Avoid ground obstacles Down Arrow Hold Slide Dodge high obstacles Mobile Touch Tap Screen Jump Swipe Down Slide While holding your finger on the screen",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Adventure",
      "Arcade",
      "Arena",
      "Best Games",
      "crazygamesunblocked",
      "jump",
      "Jumping",
      "run",
      "running",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/ir2clqc9nzxcq064jh0ksy8lmfas45uw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ir2clqc9nzxcq064jh0ksy8lmfas45uw/",
    "sourceUrl": "https://html5.gamemonetize.com/ir2clqc9nzxcq064jh0ksy8lmfas45uw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74715",
    "slug": "idle-restaurant-game",
    "title": "Idle Restaurant Game",
    "description": "Do you want to be a food tycoon? Get into this restaurant management sim game now, start as a street food bar, recruit staff, and upgrade to earn more money, then open a bigger restaurant! What do our cute customers want to have today? Meet the mini cute staff at our restaurants! Lovely and interesting food market tycoon restaurants! Welcome to our Idle Restaurant Tycoon Feature: - Simple and easy to start, tap for fun - Strategically upgrade your restaurants to maximize revenue - Various restaurants and food are waiting for you to unlock",
    "instructions": "Use the mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "Best Games",
      "Casual",
      "Food",
      "Fun",
      "idle",
      "Management",
      "Relaxation",
      "Restaurant",
      "Simulation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/gp3mvm4ln5y233y9wmp6hm12nwumguyc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gp3mvm4ln5y233y9wmp6hm12nwumguyc/",
    "sourceUrl": "https://html5.gamemonetize.com/gp3mvm4ln5y233y9wmp6hm12nwumguyc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74537",
    "slug": "neon-saga-tic-tac-toe-69-level-war",
    "title": "Neon Saga Tic Tac Toe: 69 Level War",
    "description": "Are you ready to redefine everything you know about the classic game of X&rsquo;s and O&rsquo;s? Welcome to Neon Saga Tic Tac Toe: 69 Level War, the most visually stunning and strategically deep board game experience on the web. This isn&rsquo;t just a simple puzzle game; it is an intergalactic war of wits, set against a rotating space nebula and drenched in cyberpunk neon aesthetics. In this HTML5 strategy masterpiece, you don&rsquo;t just play a match&mdash;you embark on a saga. You are the challenger, stepping into the digital arena to face off against 69 unique AI opponents, each with their own personality, icon, and difficulty level. From the rusty gears of the lower levels to the god-like intelligence of The Eternal at level 69, this is the definitive Tic Tac Toe experience for casual players and logic masters alike. Gameplay: Classic Logic, Modern Warfare At its core, Neon Saga Tic Tac Toe honors the timeless rules of Noughts and Crosses (Xs and Os). The goal is simple: align three of your marks in a hor",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Board",
      "Brain",
      "free html5 games for your website",
      "Fun",
      "Funny",
      "HTML5",
      "html5 games",
      "Puzzle",
      "puzzleblock",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/1al34xfehjfvkgvhac01ce484w8k5zas/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1al34xfehjfvkgvhac01ce484w8k5zas/",
    "sourceUrl": "https://html5.gamemonetize.com/1al34xfehjfvkgvhac01ce484w8k5zas/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75219",
    "slug": "forest-survivor-rougelike",
    "title": "Forest Survivor Rougelike",
    "description": "Forest Survivor Roguelike is an addictive simulator adventure game that throws you into a dangerous forest. Only the strongest survivor can survive. From the very first moment, you must fight, explore, and adapt to stay alive in this intense roguelike world. Every step in the forest is a new challenge.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Fight",
      "Simulator",
      "Skills",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/e8h0pc2klcszfgw7gnrx1z03u9qj9knm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e8h0pc2klcszfgw7gnrx1z03u9qj9knm/",
    "sourceUrl": "https://html5.gamemonetize.com/e8h0pc2klcszfgw7gnrx1z03u9qj9knm/",
    "width": 1624,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74006",
    "slug": "super-world-adventure",
    "title": "Super World Adventure",
    "description": "Super World Adventure is a Platform &ndash; Adventure game where you will help the little hero rescue the princess in a fantasy world. Travel through many levels, collect coins, use power-ups, and defeat enemies to reach every castle. Enjoy this fantastic adventure, overcome obstacles, and become a hero.",
    "instructions": "Desktop and Mobile Support",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/ps7uumcvrewu1rxv2it1n0dc8klr2ju3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ps7uumcvrewu1rxv2it1n0dc8klr2ju3/",
    "sourceUrl": "https://html5.gamemonetize.com/ps7uumcvrewu1rxv2it1n0dc8klr2ju3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75090",
    "slug": "space-diamond-miner",
    "title": "Space Diamond Miner",
    "description": "Space Diamond Miner is a casual arcade game inspired by classic Gold Miner&ndash;style mechanics, set in a colorful space diamond mining universe. Players control an astronaut and use a hook to collect valuable diamonds hidden underground on alien planets. Each level has a time limit, encouraging precise timing and smart target selection. Collected diamonds can be spent on upgrades such as hook speed, hook size, extra time, and diamond value, creating a simple yet rewarding progression system.",
    "instructions": "Players launch a hook to grab underground diamonds and earn as much as possible before time runs out Timing target selection and upgrade choices are key to success Diamonds collected can be used to improve hook speed size time bonuses and diamond v",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Classic",
      "Fun",
      "Funny",
      "Mine",
      "Miner",
      "Puzzle",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/euu197dacdczi1124zadza2tbgkk7khf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/euu197dacdczi1124zadza2tbgkk7khf/",
    "sourceUrl": "https://html5.gamemonetize.com/euu197dacdczi1124zadza2tbgkk7khf/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73917",
    "slug": "plumber-world-pipe-puzzle",
    "title": "Plumber World Pipe Puzzle",
    "description": "In a fantasy world, you are the master of the plumbers, and every lands call you in order to build their water system. Connect the pipes, fix the leaks, and start to flow water in the pipes to plug this crazy network. Play PLUMBER WORLD, a great puzzle game to have fun and kill time. This plumber game is fun and will require you to be really smart to finish all levels. The gameplay is super simple.",
    "instructions": "Mouse Click to rotate",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Best Games",
      "Fun",
      "Games",
      "Logic",
      "Pipe",
      "Play",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/kcf1vebqutbqmzh5siudvqbp3rqikwbf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kcf1vebqutbqmzh5siudvqbp3rqikwbf/",
    "sourceUrl": "https://html5.gamemonetize.com/kcf1vebqutbqmzh5siudvqbp3rqikwbf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73593",
    "slug": "brainrot-sudoku",
    "title": "Brainrot Sudoku",
    "description": "Brainrot Sudoku is a hilarious twist on the classic number puzzle! Instead of filling grids with numbers, youll solve puzzles using brainrot-themed elements and memes. Challenge your logic skills while enjoying the chaotic fun of internet culture. Perfect for puzzle lovers who want something fresh, funny, and addictive!",
    "instructions": "Just click and play sudoku",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brainrot",
      "Brainrot Italian",
      "Casual",
      "Puzzle",
      "Sudoku"
    ],
    "thumbnail": "https://img.gamemonetize.com/lfc6qibeu2mqgn8zzjyee01ldhfpo0qu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lfc6qibeu2mqgn8zzjyee01ldhfpo0qu/",
    "sourceUrl": "https://html5.gamemonetize.com/lfc6qibeu2mqgn8zzjyee01ldhfpo0qu/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "75023",
    "slug": "bone-doctor-shoulder-case",
    "title": "Bone Doctor Shoulder Case",
    "description": "Oouch, our cheerleader took a tumble and hurt her shoulder. Help fix her up with a quick shoulder surgery by following the right steps to ensure she recovers fully. Once she healed, give her a make over with some stylish outfits and accessories from our collection, so she can return to the squad looking better than ever!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Doctor",
      "Dress Up",
      "Simulation",
      "Surgery"
    ],
    "thumbnail": "https://img.gamemonetize.com/8l230gjfwqu2g6zkil1avidugb9wc5sq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8l230gjfwqu2g6zkil1avidugb9wc5sq/",
    "sourceUrl": "https://html5.gamemonetize.com/8l230gjfwqu2g6zkil1avidugb9wc5sq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73916",
    "slug": "dual-control-racing-stunt-3d",
    "title": "Dual Control Racing Stunt 3D",
    "description": "Ever wish to be a furious car driver in extreme driving games and drive awesome cars in the mountain? So enjoy the best car games that you have never play before. Car driving simulator games are one of the most played car games in the play store. Adrenaline will rush through your bone in these casual driving games. The car game include many 3d cars to keep you in this car master game. Stunning features are also included in this car games simulator to fulfill your desire to be the gt car master. Some obstacle will help you in the race car game 3d to find out your car love. Your main goal in car games is to win the racing championship.",
    "instructions": "Left amp Right Mouse Buttons",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Car",
      "Crazy",
      "Driving",
      "jump",
      "Racing",
      "Simulator",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/j8uoj1uqfpg3y9mng1jgds80ko8bov3c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j8uoj1uqfpg3y9mng1jgds80ko8bov3c/",
    "sourceUrl": "https://html5.gamemonetize.com/j8uoj1uqfpg3y9mng1jgds80ko8bov3c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73661",
    "slug": "neon-overdrive",
    "title": "NEON OVERDRIVE",
    "description": "Neon Overdrive: Doom Chasers is a fast-paced cyberpunk parkour platformer where reflexes decide survival. Dash, double-jump, and sprint across procedurally generated neon platforms while a deadly laser chases you relentlessly. Collect stars, unlock new levels, earn coins, and customize your runner with stylish neon skins. Featuring smooth controls, dynamic difficulty, particle effects, and a futuristic synth soundscape, Neon Overdrive delivers an intense arcade experience on both desktop and mobile. How far can you run before the system overloads?",
    "instructions": "PC A D or larr rarr Move Space W uarr Jump Shift Dash P Esc Pause Mobile On-screen buttons Move Tap screen Jump Button Dash",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "dash",
      "Jumping",
      "Platform",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/auytzokmwmkk3lfwd4qh4mtpom1k7nm6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/auytzokmwmkk3lfwd4qh4mtpom1k7nm6/",
    "sourceUrl": "https://html5.gamemonetize.com/auytzokmwmkk3lfwd4qh4mtpom1k7nm6/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75210",
    "slug": "wrodscapes",
    "title": "Wrodscapes",
    "description": "Playing Wordscapes 10 mins a day sharpens your mind and prepares you for your daily life and challenges! This text twist of a word game is tremendous brain challenging fun. Enjoy modern word puzzles with word searching, anagrams, and crosswords! Immerse yourself into the beautiful scenery backgrounds to relax and ease your mind.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Brain",
      "free games for your website",
      "free html5 games for your website",
      "html games for your website",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/s3opy3pfvz7h7pfmpgbiyp8ab8ij5dwm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s3opy3pfvz7h7pfmpgbiyp8ab8ij5dwm/",
    "sourceUrl": "https://html5.gamemonetize.com/s3opy3pfvz7h7pfmpgbiyp8ab8ij5dwm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75085",
    "slug": "flappy-witch-fly",
    "title": "Flappy Witch Fly",
    "description": "Flappy Witch Fly is a fun and challenging arcade game inspired by the classic Flappy Bird style, where you control a little witch flying on her magic broomstick. Tap or click the screen to keep her airborne and dodge obstacles as you fly through an enchanted world filled with trees and mountains. The pace is fast, the controls are simple, and every game tests your reflexes and precision. Perfect for short but addictive sessions, Flappy Witch Fly combines colorful graphics, smooth animations, and progressive difficulty that will have you trying again and again to beat your high score.",
    "instructions": "Tap the screen to jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Bird",
      "Brain",
      "Casual",
      "flappybird",
      "Hot",
      "Mario",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/06nfr1994zfoeu76fmoy2th2sifk1qf8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/06nfr1994zfoeu76fmoy2th2sifk1qf8/",
    "sourceUrl": "https://html5.gamemonetize.com/06nfr1994zfoeu76fmoy2th2sifk1qf8/",
    "width": 460,
    "height": 270,
    "lastUpdated": ""
  },
  {
    "id": "70814",
    "slug": "adventure-park-master",
    "title": "Adventure Park Master",
    "description": "Park Master is a fun and addictive puzzle game where players draw paths to park cars safely in their correct spots. Use logic and timing to avoid collisions, navigate obstacles, and complete each level with precision. Simple controls, smooth gameplay, and challenging levels make it perfect for quick play sessions.",
    "instructions": "use mouse swipe to reach destination",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "carparking",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/oa4wk88gldaubifxoh2vpd4ngtm5y95r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oa4wk88gldaubifxoh2vpd4ngtm5y95r/",
    "sourceUrl": "https://html5.gamemonetize.com/oa4wk88gldaubifxoh2vpd4ngtm5y95r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73450",
    "slug": "gift-puzzle-saga",
    "title": "Gift Puzzle Saga",
    "description": "Join Santa&rsquo;s team and tidy up the workshop! In this festive puzzle game, your goal is to clear the board by dropping gifts into lanes and stacking three of a kind. Plan your moves carefully&mdash;if the stacks get too high, the warehouse will overflow! Enjoy 16 challenging levels at your own pace with no time limits. Click on a horizontal column to move the bottom gift to the staging area. Try to move three of the same type gifts to remove it from the warehouse. If no match is made, the stack of three gifts moves back to the warehouse. If no room is available for the stack the level ends.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Christmas",
      "Match 3",
      "Match3",
      "Puzzle",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/usayll6womy0vbbwmfchnee9dto8vwcl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/usayll6womy0vbbwmfchnee9dto8vwcl/",
    "sourceUrl": "https://html5.gamemonetize.com/usayll6womy0vbbwmfchnee9dto8vwcl/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73977",
    "slug": "car-climb-mountain",
    "title": "Car Climb Mountain",
    "description": "Complete fun, enthusiasm, and exploit - these are various of the words that perfectly describe Car Climb Mountain. It is an adventure-filled game with excellent graphics and exciting sound effects. Get ready for the most amazing hill car climb mountain hill racing game on the market today. The challenging environment makes for a tough Hill Adventure time for you the driver as you face this unique challenging hill car climb simulator game with dangerous unwelcomed mountains. Swinging bridges and the other crazy Hill car climb hurdles which makes the drive difficult and fun all at the same time.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Cars",
      "Cartoon",
      "drift"
    ],
    "thumbnail": "https://img.gamemonetize.com/899s3080d4it19lz5a6frfaj6ik8z0mp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/899s3080d4it19lz5a6frfaj6ik8z0mp/",
    "sourceUrl": "https://html5.gamemonetize.com/899s3080d4it19lz5a6frfaj6ik8z0mp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74835",
    "slug": "endless-cube-runner",
    "title": "Endless Cube Runner",
    "description": "Endless Cube Runner is a fast-paced arcade game where you dodge obstacles and race forward on an endless path of cubes. Test your reflexes, beat your high score, and see how far you can survive!",
    "instructions": "Use mouse click and swipe to move the character",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "endless",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/r0uubquynzvxrw29ro38xdf9cqi8accz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r0uubquynzvxrw29ro38xdf9cqi8accz/",
    "sourceUrl": "https://html5.gamemonetize.com/r0uubquynzvxrw29ro38xdf9cqi8accz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74851",
    "slug": "reality-of-cosmos",
    "title": "Reality of Cosmos",
    "description": "Pilot the Starship Lumina through dangerous cosmic sectors. Dodge asteroids, collect health spheres, and battle alien guardians as you warp between endless space worlds.",
    "instructions": "Desktop W uarr ndash Move Up S darr ndash Move Down Space ndash Fire Laser Esc ndash Pause Mobile ndash Move Up amp Down LASER ndash Fire ndash Pause",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2026 games",
      "3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/fjlur1zl27gi0mrx4j9ygxltq5fnzdnn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fjlur1zl27gi0mrx4j9ygxltq5fnzdnn/",
    "sourceUrl": "https://html5.gamemonetize.com/fjlur1zl27gi0mrx4j9ygxltq5fnzdnn/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75099",
    "slug": "snowball-platformer",
    "title": "SnowBall: Platformer",
    "description": "SnowBall: Platformer is a joyful physics-based platformer made for the holidays! You play as SnowBall &mdash; a lively snowball on a mission to collect every gift and make New Year&rsquo;s Eve happen! Roll, bounce, and roll again through 25 cleverly designed levels, each ending with a special finish-line gift. Without it&hellip; there&rsquo;s no New Year! The game starts easy, but don&rsquo;t be fooled &mdash; challenges grow with every level! Master momentum, timing, and realistic physics to succeed. Help SnowBall gather all the gifts before midnight strikes&hellip; or the holiday will vanish!",
    "instructions": "On PC use the arrow keys or WAD to control the game and press E to exit the level On mobile use the on-screen buttons",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Arcade",
      "Best",
      "Christmas",
      "HTML5",
      "html5 games",
      "Mobile",
      "New",
      "Physics",
      "Platform",
      "Snow"
    ],
    "thumbnail": "https://img.gamemonetize.com/ri8c7y73o96ngsawgzdthajbu9xmajfz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ri8c7y73o96ngsawgzdthajbu9xmajfz/",
    "sourceUrl": "https://html5.gamemonetize.com/ri8c7y73o96ngsawgzdthajbu9xmajfz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75161",
    "slug": "dragon-fly",
    "title": "Dragon Fly",
    "description": "As a newly hatched dragon pup you still have too tiny wings to fly. That however is not going to stop you from embarking on your very first adventure. The realms are full of curvy hills. Slide along them and time your touches with precision to build momentum and take off into the sky. Be quick though! Dragon mum is anxious about your whereabouts and has headed out to end your journey and bring you back to the nest.",
    "instructions": "use mouse controls",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "Action",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/dxkjhu3yz4hflh9wrwgushsqub50w9ya/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dxkjhu3yz4hflh9wrwgushsqub50w9ya/",
    "sourceUrl": "https://html5.gamemonetize.com/dxkjhu3yz4hflh9wrwgushsqub50w9ya/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75154",
    "slug": "tap-out-gallery",
    "title": "Tap Out Gallery",
    "description": "Dive into a clever arrow-block puzzle where every tile points the way. Click blocks to remove them, but plan ahead: each removal changes the route through the stack, opening new options or trapping you in dead ends. Web Dev <a href='https://www.kizi10.org/'>https://www.kizi10.org/</a> Clear the board by creating smooth directional chains, using green starters and orange movers to guide your progress.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/qtniwco62z5nnhql0vs9nl6wqvkd056r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qtniwco62z5nnhql0vs9nl6wqvkd056r/",
    "sourceUrl": "https://html5.gamemonetize.com/qtniwco62z5nnhql0vs9nl6wqvkd056r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75138",
    "slug": "mountain-truck-simulator-3d",
    "title": "Mountain Truck Simulator 3D",
    "description": "Mountain Truck Simulator 3D is a realistic 3D truck driving game where you deliver cargo across dangerous mountain roads. Earn rewards from successful deliveries, expand your collection in the shop, and manage your fleet in the garage. With challenging routes, tight time limits, and satisfying truck handling, this is the perfect driving simulator for players who love skill-based transportation challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Driving",
      "mountain",
      "Simulation",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/5sn9eczj7lz3fuu73zx164xff5p5zd6c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5sn9eczj7lz3fuu73zx164xff5p5zd6c/",
    "sourceUrl": "https://html5.gamemonetize.com/5sn9eczj7lz3fuu73zx164xff5p5zd6c/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75037",
    "slug": "crazy-math-quick-test",
    "title": "Crazy Math Quick Test",
    "description": "Crazy Math Quik Games - Tricky Riddles is an addictive free puzzle &amp; math game with a series of tricky riddles and teasers for training the brain. Interesting riddles and tricky tests will improve your mind. Train your memory and improve cognitive abilities with our fun and challenging mobile game. With personalized progress tracking, youll see your memory skills improve over time. Free multiplication games suitable for every age group, from school kids to adults and even seniors. Practice different mental skills and get smarter with our logic apps, and add games for your mind.",
    "instructions": "Mouse click to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Best Games",
      "Brain",
      "Educational",
      "Logic",
      "Logical",
      "Math",
      "Number",
      "Puzzle",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/vb6mga32bkenrvu7wmk749e4kzgczbcj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vb6mga32bkenrvu7wmk749e4kzgczbcj/",
    "sourceUrl": "https://html5.gamemonetize.com/vb6mga32bkenrvu7wmk749e4kzgczbcj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75086",
    "slug": "draw-happy-glass",
    "title": "Draw Happy Glass",
    "description": "The glass is sad because its empty. Your job is to draw a line to make the glass filled up with liquid and smile again! Try to find the best way to complete each level. You can come up with your own solution so be creative and dont be afraid to think out of the box! Some levels might look easy but lets see if you can actually get the 3 stars.",
    "instructions": "mouse left click and draw ilne to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Best Games",
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/u942um6zwx62yzh7l6issb4g9pv8luk7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u942um6zwx62yzh7l6issb4g9pv8luk7/",
    "sourceUrl": "https://html5.gamemonetize.com/u942um6zwx62yzh7l6issb4g9pv8luk7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74540",
    "slug": "digit-hunter",
    "title": "Digit Hunter",
    "description": "Digit Hunter is a fast-paced reflex and logic game where quick thinking meets speed. Tap and hunt the correct digits before the timer runs out, but be careful&mdash;every wrong tap costs you points. With simple one-touch controls, the game is easy to learn and perfect for mobile and feature-phone players. Enjoy endless levels with increasing speed and difficulty that constantly challenge your focus and reflexes. Smooth animations, engaging sound effects, and a lightweight design ensure smooth performance even offline. Train your brain, improve your reaction time, and chase high scores in this addictive number-hunting challenge.",
    "instructions": "Tap Start to begin the game Numbers will appear on the screen and your goal is to destroy the target digits before time runs out Be careful not to tap the wrong digits as that will reduce your score As you progress through the levels the speed increase",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Arcade",
      "Bomb",
      "Match 3",
      "Number"
    ],
    "thumbnail": "https://img.gamemonetize.com/pfq6zfqjtfe2ghlllurdbdm3618ke3t9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pfq6zfqjtfe2ghlllurdbdm3618ke3t9/",
    "sourceUrl": "https://html5.gamemonetize.com/pfq6zfqjtfe2ghlllurdbdm3618ke3t9/",
    "width": 360,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "74852",
    "slug": "boom-duello",
    "title": "Boom Duello",
    "description": "Boom Duello is a fast-paced 2-player TNT battle game where only one can survive. Face off against your friend on two unique maps, plan your moves, place your TNT wisely, and blow your opponent away to claim victory.",
    "instructions": "Mobile controls are available Player 1 Controls Move W A S D Throw Bomb R ---------------------------------------- Player 2 Controls Move Arrow Keys uarr darr larr rarr Throw Bomb P",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "Action",
      "Casual",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/e95xsaozqcbnadabaokflgrw9l9vzdz6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e95xsaozqcbnadabaokflgrw9l9vzdz6/",
    "sourceUrl": "https://html5.gamemonetize.com/e95xsaozqcbnadabaokflgrw9l9vzdz6/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "75008",
    "slug": "drive-and-park-puzzle-game",
    "title": "Drive and Park Puzzle Game",
    "description": "Navigate through busy city streets and master perfect turns in this fast-paced arcade driving game. Control your vehicle, avoid traffic, collect rewards, and test your reflexes as the road gets more challenging. Simple controls, smooth gameplay, and endless fun make this game perfect for quick play",
    "instructions": "use mouse swipe to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/39jgkj1qrnrleg6brbkdn683i45mvihy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/39jgkj1qrnrleg6brbkdn683i45mvihy/",
    "sourceUrl": "https://html5.gamemonetize.com/39jgkj1qrnrleg6brbkdn683i45mvihy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75046",
    "slug": "2048-neon-game",
    "title": "2048 neon game",
    "description": "Dive into the most addictive number puzzle experience with 2048 Clean. Slide the tiles to merge matching numbers: 2+2 becomes 4, 4+4 becomes 8, and so on. Your goal is to reach the legendary 2048 tile without running out of moves! Key Features: - Brain Training: Improve your logic and math skills. - Mobile Optimized: Smooth gameplay on all devices (Android, iOS, PC). - Fast &amp; Clean: Minimalist design for zero distractions. - High Score: Challenge your friends and beat your best score. Whether you are a fan of classic math puzzles or looking for a relaxing brain teaser, 2048 Clean is the perfect choice. Play now for free!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io",
      "1 Player",
      "2026 games",
      "2048",
      "Board",
      "Classic",
      "HTML5",
      "html5 games",
      "Math",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/u215wd09xavp4bb40yhdokmqgrmrr92w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u215wd09xavp4bb40yhdokmqgrmrr92w/",
    "sourceUrl": "https://html5.gamemonetize.com/u215wd09xavp4bb40yhdokmqgrmrr92w/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75116",
    "slug": "vice-city-mad-driving",
    "title": "Vice City Mad Driving",
    "description": "Vice City Mad Driving is an open city driving game where chaos meets freedom. Explore a neon city inspired by classic vice streets, drive fast cars, perform crazy stunts, smash through traffic, and cause mayhem with no rules holding you back. Jump into free roam driving, test your skills, and enjoy pure arcade madness directly in your browser.",
    "instructions": "WASD - Drive Space - Brake R - Restart Mouse - Rotate view TAB - Pause",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Car",
      "Cars",
      "Driving",
      "gta",
      "Race",
      "Racing",
      "Supercars",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/sjq4qrvuzt2vrxwh89cxxc02hhb9arst/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sjq4qrvuzt2vrxwh89cxxc02hhb9arst/",
    "sourceUrl": "https://html5.gamemonetize.com/sjq4qrvuzt2vrxwh89cxxc02hhb9arst/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75151",
    "slug": "winter-fairytale-jigsaw-puzzles",
    "title": "Winter Fairytale: Jigsaw Puzzles",
    "description": "&ldquo;Winter Fairytale: Jigsaw Puzzles&rdquo; is a cozy winter jigsaw game with magical illustrations: snowy forests, Santa-like characters, fairy-tale heroes, animals, and festive scenes. Pick a picture, choose the number of pieces, then drag and place the pieces until the image is complete. Win puzzles to earn stars and unlock new artworks &mdash; harder puzzles give bigger rewards. Relaxing music, a clean UI, and confetti after completion make it perfect for a calm break.",
    "instructions": "Mouse Touch drag and drop puzzle pieces into place Click a picture to select an image Choose the number of pieces before starting Sound button mdash toggle music on off Exit X button mdash return to selection screen Fullscreen button mdash",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Christmas",
      "HTML5",
      "Kids",
      "Logic",
      "Puzzle",
      "Snow",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/dn3ayyfdxhdum8l6dygmnbj1t2ip90wb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dn3ayyfdxhdum8l6dygmnbj1t2ip90wb/",
    "sourceUrl": "https://html5.gamemonetize.com/dn3ayyfdxhdum8l6dygmnbj1t2ip90wb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75171",
    "slug": "hexagon-block-puzzle-game",
    "title": "Hexagon Block Puzzle Game",
    "description": "Hexagon Block: Puzzle Game is a brain storming puzzle game.Stretch your mind and train your brain with this addictive block puzzle game. Colorful and easy user interface of puzzle&bull; Combine the blocks to make the pattern.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "Block",
      "Casino",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/vnfx9yvw41rrmyehhsyw4uo5ss9jh9c0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vnfx9yvw41rrmyehhsyw4uo5ss9jh9c0/",
    "sourceUrl": "https://html5.gamemonetize.com/vnfx9yvw41rrmyehhsyw4uo5ss9jh9c0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74702",
    "slug": "tall-man-run-3d",
    "title": "Tall Man Run 3D",
    "description": "In this tall man run game, Run on the track and pass through the different gates to become taller, thicker, thinner, and shorter. Avoid obstacles to completing the levels. If you are thick and tall, you can beat the boss at the end of each level. Get as tall and wide as you can to take out bots and beat the level! If you getting bored of daily routines then the tall man run game has great fun for you. Here we represent the Tall Man Runner Game, a brand new Tall man run 3d recreation for you. Welcome to tall man runner is running alongside a bridge, an epic race 3d, and a fun run with the aid of doing extraordinary activities in tall run game.",
    "instructions": "Use the mouse to move the player left or right",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "Adventure",
      "Best Games",
      "endless",
      "jump",
      "Obstacle",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/s31bg8zbno7jx2eu2reak4rmesyafzqq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s31bg8zbno7jx2eu2reak4rmesyafzqq/",
    "sourceUrl": "https://html5.gamemonetize.com/s31bg8zbno7jx2eu2reak4rmesyafzqq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75189",
    "slug": "head-football-game",
    "title": "Head Football Game",
    "description": "Head Soccer is the ultimate football games where skill, speed, and strategy decide who wins the match. Jump onto the pitch for fast-paced soccer battles, score epic goals, and compete to become the champion!",
    "instructions": "Mouse click or tap to play",
    "category": "Soccer",
    "genres": [
      "Soccer"
    ],
    "tags": [
      "2025 games",
      "3D",
      "Adventure",
      "Battlegrounds",
      "Football",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/08dvlr1ksytrmsn4pd1s9t1t2ob8egql/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/08dvlr1ksytrmsn4pd1s9t1t2ob8egql/",
    "sourceUrl": "https://html5.gamemonetize.com/08dvlr1ksytrmsn4pd1s9t1t2ob8egql/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "964",
    "slug": "mad-day-special",
    "title": "Mad Day Special",
    "description": "Battle the oncoming Alien Invasion of Earth in this epic racer to rescue your beloved pet Octopus Fluffy and escape. Mad Day is a combination of an awesome racing and alien shooting game. Upgrade your Car, Guns, Armor, Clothing and more to beat the bad guys. Take on the aliens lasers and blasters with your own trucks rocket launcher as you climb hills and smash through walls. Then start running on foot with your shotgun, killing and smashing aliens.",
    "instructions": "Space - Jump X Arrow Key Up - Rockets",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Action",
      "Alien",
      "Battle",
      "Car",
      "Cars",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/x1pcf3eqnaqhacegno3gkgidfsbz7us4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x1pcf3eqnaqhacegno3gkgidfsbz7us4/",
    "sourceUrl": "https://html5.gamemonetize.com/x1pcf3eqnaqhacegno3gkgidfsbz7us4/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "73879",
    "slug": "speed-car-race-madness",
    "title": "Speed Car Race Madness",
    "description": "Rule the street racing Underground as you race in the Speed made just for mobile! Conquer the asphalt of Blackridge city, engage your nitro, and tune your cars. Ever wish to be a furious car driver in extreme driving games and drive awesome cars in the mountain? So enjoy the best car games that you have never play before. Car driving simulator games are one of the most played car games in the play store. Adrenaline will rush through your bone in these casual driving games. The car game include many 3d cars to keep you in this car master game.",
    "instructions": "Drive ------------Right Arrow Back -------------Left Arrow Front Flip ----------X Back Flip -------------z",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Adventure",
      "Car",
      "drifting",
      "Driving",
      "Race",
      "Racing",
      "Road",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/9hibl9blop3ss2jxycuxpzoflnl2n16w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9hibl9blop3ss2jxycuxpzoflnl2n16w/",
    "sourceUrl": "https://html5.gamemonetize.com/9hibl9blop3ss2jxycuxpzoflnl2n16w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74922",
    "slug": "run-rich-path-3d",
    "title": "Run Rich Path 3D",
    "description": "Are you looking for a fun run race 3D game to relieve stress? What do you think about the game with the money theme? Money Run Rich Path 3D is inspired by the reality of monetizing. The path in this free game simulates the road to the success of a millionaire or billionaire. This game is definitely one of the best run 3D games that you cannot miss. First, you will play as a homeless person without a rich dad, but a poor dad. Your mission is to monetize, study, and work to become rich. Pay attention to stay away and overcome obstacles like party, game, or even girl. These things can make you go bankrupt. Saving your money!",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2026 games",
      "Arcade",
      "Avoid",
      "Best Games",
      "Casual",
      "Collecting",
      "endless",
      "Hypercasual",
      "Obstacle",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/vo12n6no6emyjp54whvniujy73gvoulg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vo12n6no6emyjp54whvniujy73gvoulg/",
    "sourceUrl": "https://html5.gamemonetize.com/vo12n6no6emyjp54whvniujy73gvoulg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74763",
    "slug": "bounce-and-pop-puzzle",
    "title": "Bounce and Pop Puzzle",
    "description": "Thorn and Balloons is a very interesting casual bounce ballon game. In the game, you need to control the strength and angle to launch the thorn ball. The thorn ball will bounce when it hits the wall, and all the balloons will be broken by rebounding to win. Shoot Balloon: Spike Bounce is an exhilarating and fast-paced arcade game that combines precision with rapid reflexes. In this game, players are challenged to pop as many balloons as possible using a set of bouncing spikes. The objective is simple yet addictive: aim and launch the spikes in such a way that they hit and burst the balloons scattered across the screen.",
    "instructions": "Hold the left mouse button and drag",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Ballon",
      "Best Games",
      "Bounce",
      "Brain",
      "Casual",
      "Color",
      "Poppy Playtime",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/6wx12ufz9dvbxjb8vorna8x9c2q096lq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6wx12ufz9dvbxjb8vorna8x9c2q096lq/",
    "sourceUrl": "https://html5.gamemonetize.com/6wx12ufz9dvbxjb8vorna8x9c2q096lq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74831",
    "slug": "breakout-neon-drift",
    "title": "Breakout: Neon Drift",
    "description": "Breakout: Neon Drift is a retro arcade brick-breaker with stunning neon visuals and CRT effects. Smash through 10 unique levels, collect power-ups like lasers, multiball, and shields, and chase the high score! Features smooth controls, combo scoring, and an electrifying synthwave soundtrack.",
    "instructions": "Mouse Touch Move paddle left and right Click Tap Launch ball shoot lasers",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Block"
    ],
    "thumbnail": "https://img.gamemonetize.com/sgblzji7vv1ziw0pm64e3m23wr8vlt5j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sgblzji7vv1ziw0pm64e3m23wr8vlt5j/",
    "sourceUrl": "https://html5.gamemonetize.com/sgblzji7vv1ziw0pm64e3m23wr8vlt5j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74821",
    "slug": "2048-cube-runner-ultimate",
    "title": "2048 Cube Runner ultimate",
    "description": "Cube Runner is a fast-paced endless runner game where players control a cube racing through a dynamic track full of obstacles. The goal is to dodge barriers, react quickly, and survive as long as possible while the speed gradually increases.",
    "instructions": "Mouse pad click and swipe left and right to move cube",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2048",
      "2D",
      "Arcade",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/lrjjbrw3q06ypjecioyavretjgv3luku/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lrjjbrw3q06ypjecioyavretjgv3luku/",
    "sourceUrl": "https://html5.gamemonetize.com/lrjjbrw3q06ypjecioyavretjgv3luku/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74712",
    "slug": "word-cooking-puzzle",
    "title": "Word Cooking Puzzle",
    "description": "Welcome to Word Cooking Puzzle! Dive into the ultimate word puzzle game and satisfy your craving for fun and challenge with Word Cooking Puzzle! Whether youre a fan of word connect games or enjoy word search games, our game offers a delightful mix of puzzles designed to sharpen your mind and expand your vocabulary. Download now and start your word adventure! Use your puzzle solving and vocabulary knowledge to serve up some tasty dishes in the hottest kitchen in town. Great for stress relief and brain training and if you do run into some trouble our hint system is there to help.",
    "instructions": "Use Mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Best Games",
      "Brain",
      "Casual",
      "Cook",
      "Cooking",
      "Educational",
      "Letters",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/m4v93ivuc6mqm509elql01q8nbqd7qo8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m4v93ivuc6mqm509elql01q8nbqd7qo8/",
    "sourceUrl": "https://html5.gamemonetize.com/m4v93ivuc6mqm509elql01q8nbqd7qo8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74606",
    "slug": "fruit-goals-match",
    "title": "Fruit Goals Match",
    "description": "Fruit Goals Match is a fun and strategic fruit-matching puzzle game where you collect specific fruits to complete each mission within a limited number of moves. Every level introduces new goals that reward smart planning and careful decisions. New missions unlock continuously, keeping the gameplay engaging and endless. Optional reward ads let you earn extra moves and see how far you can progress.",
    "instructions": "Swap adjacent fruits using mouse or touch controls Match three or more identical fruits to collect them Complete level goals within the limited number of moves New missions unlock as you progress",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Collecting",
      "Fruits",
      "Match 3",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/5txbd96gtcx2qig7ianog91ktnfaduqf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5txbd96gtcx2qig7ianog91ktnfaduqf/",
    "sourceUrl": "https://html5.gamemonetize.com/5txbd96gtcx2qig7ianog91ktnfaduqf/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "74845",
    "slug": "arrows-escape",
    "title": "Arrows  Escape",
    "description": "Step into Arrows Puzzle Escape, a minimalist puzzle experience designed to challenge your logic, planning, and spatial awareness. The objective is simple&mdash;but mastering it isn&rsquo;t: guide each arrow out of the grid without causing a single collision.",
    "instructions": "click to move",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "catch",
      "Math",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/42hehm7fh1gph6uc9lkwlcfyaf8xctdo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/42hehm7fh1gph6uc9lkwlcfyaf8xctdo/",
    "sourceUrl": "https://html5.gamemonetize.com/42hehm7fh1gph6uc9lkwlcfyaf8xctdo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74769",
    "slug": "attractive",
    "title": "Attractive",
    "description": "Pull the ball into your attracting device and then launch it towards the open mechanical trap. Hit all the balls into the trap to win. Win the game and have fun!",
    "instructions": "Left Right Arrow Controls Hold Z Suction Release Z Blow",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/52r5o13q586xapqfkofvculcmv23te84/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/52r5o13q586xapqfkofvculcmv23te84/",
    "sourceUrl": "https://html5.gamemonetize.com/52r5o13q586xapqfkofvculcmv23te84/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74997",
    "slug": "dwarf-treasures",
    "title": "Dwarf Treasures",
    "description": "Dwarf Treasures is a deep and captivating puzzle game that transports you to the heart of mysterious mountain caves. Your task is to navigate hundreds of unique levels, clearing the path to treasure by smashing ice blocks and overcoming other treacherous obstacles hidden deep within the earth. But simply matching stones and gems isnt enough! Discover new locations, uncover the secrets of the dwarven clan, and amass untold treasures in this epic adventure puzzle game, where strategy, luck, and fun combine perfectly!",
    "instructions": "Welcome to the dwarven mines Your goal is to complete all levels by fulfilling objectives collecting treasures destroying obstacles and reaching target scores Move the crystals to form lines of 3 or more to get as far as possible",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Match 3",
      "Match-3",
      "Match3"
    ],
    "thumbnail": "https://img.gamemonetize.com/rkkb9zcmnp5w7lg752pv4r8hlkvohuoh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rkkb9zcmnp5w7lg752pv4r8hlkvohuoh/",
    "sourceUrl": "https://html5.gamemonetize.com/rkkb9zcmnp5w7lg752pv4r8hlkvohuoh/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75044",
    "slug": "fly-2048",
    "title": "Fly 2048",
    "description": "Fly 2048 is a unique and challenging fusion of two legendary arcade mechanics: the mathematical logic of 2048 and the intense, skill-based navigation of Flappy Bird. In this game, you dont just slide tiles on a grid; you control a flying tile that must navigate through narrow gaps between block barriers. Each successful pass through a gate increases your score and transforms your tile into the next power of two. As your score climbs, the games speed increases, demanding faster reflexes and tighter control. Watch your number grow from 2 to 2048 and beyond while trying to beat your personal best score. How far can you fly before hitting an",
    "instructions": "Desktop Press any key on your keyboard or Click the left mouse button to jump and gain altitude Mobile Tablet Tap anywhere on the screen to flap your wings and fly upward Goal Maintain the correct height to pass through the openings in the barriers",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2048",
      "Action",
      "angrybirds",
      "Arcade",
      "Balance",
      "crazygamesunblocked",
      "endless",
      "flappybird",
      "fly",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/cvejhwrjd65k00r262dtlpyinbg2fd1c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cvejhwrjd65k00r262dtlpyinbg2fd1c/",
    "sourceUrl": "https://html5.gamemonetize.com/cvejhwrjd65k00r262dtlpyinbg2fd1c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74826",
    "slug": "nail-run-bridge-game",
    "title": "Nail Run Bridge Game",
    "description": "Get ready to embark into the beauty nail stack art makeover and nail salon fashion games that put your wit, strategy, and fashion sense to the test. The nail art makeover fashion girl game requires nail stack art fashion skills and creative thoughts. The Nail Long Stack Rush is a fun and addictive nail art fashion salon and nails fashion makeover game perfectly designed for girls who love beauty and fashion. The objective of the nail long stack rush:",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "amazing",
      "Bridge",
      "Girls",
      "Nails",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/yb6exqwgv67wbraaupahqxjgunwnmlbo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yb6exqwgv67wbraaupahqxjgunwnmlbo/",
    "sourceUrl": "https://html5.gamemonetize.com/yb6exqwgv67wbraaupahqxjgunwnmlbo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75034",
    "slug": "money-run-fest",
    "title": "Money Run Fest",
    "description": "Are you looking for a fun run race 3D game to relieve stress? What do you think about the game with the money theme? Money Run Fest 3D is inspired by the reality of monetizing. The path in this free game simulates the road to the success of a millionaire or billionaire. This game is definitely one of the best money race 3D games that you cannot miss. Your mission is to monetize, study and work to become rich. Pay attention to stay away and overcome obstacles. These things can make you go bankrupt. Saving your money!!",
    "instructions": "Mouse Left click and hold to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Adventure",
      "Best Games",
      "Casual",
      "Collecting",
      "Collection",
      "endless",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/62kwj49mooe64ti7qzab1nhzw2gfn85x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/62kwj49mooe64ti7qzab1nhzw2gfn85x/",
    "sourceUrl": "https://html5.gamemonetize.com/62kwj49mooe64ti7qzab1nhzw2gfn85x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75081",
    "slug": "slide-battle",
    "title": "Slide Battle",
    "description": "Slide Battle is a thrilling action arena game where you control warriors in intense battles. Using agile sliding controls, you move your character, dodge attacks, and strike to defeat enemies in the arena. Each battle requires quick reflexes and sound strategy to win. Master your warrior and be the last survivor!",
    "instructions": "Use mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Action",
      "Arena",
      "Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/k18z8grwfe3h29rrzcm5m2t3v5u1y220/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k18z8grwfe3h29rrzcm5m2t3v5u1y220/",
    "sourceUrl": "https://html5.gamemonetize.com/k18z8grwfe3h29rrzcm5m2t3v5u1y220/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74912",
    "slug": "girl-mini-games-relaxing-fun",
    "title": "Girl Mini Games Relaxing Fun",
    "description": "Are you a lover of toys and games? Want to unlock more fun minigames all at once? Join our best girl game and enjoy upgraded fun. Play Squid Game candy picking with Brainrot themes, dress up Ballerina Cappuccina in charming dresses, interact in the Mukbang livestream, and more.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Candy",
      "Collection",
      "Girls",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/14gcy0koaagf9lhzmghxqt2gc6we8r2j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/14gcy0koaagf9lhzmghxqt2gc6we8r2j/",
    "sourceUrl": "https://html5.gamemonetize.com/14gcy0koaagf9lhzmghxqt2gc6we8r2j/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "75030",
    "slug": "99-nights-in-the-forest",
    "title": "99 Nights In The Forest",
    "description": "This is a game about real survival, where every night becomes more dangerous. You will have to gather resources, build shelters, build campfires, and defend yourself from wild animals and enemies. During the day, you can explore the forest, search for food and materials, and at night, prepare for a real test &mdash; enemies become stronger, and only your skills will help you survive. Can you endure all 99 nights and prove that you are a true survivor?",
    "instructions": "PC W A S D - movement E - pick up item F - put in bag G - drop item from inventory bag LMB - drag or shoot Mobile device Left joystick - movement Right side of the screen - camera rotation and buttons",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "3D Games",
      "Adventure",
      "Android",
      "building",
      "Forest",
      "Fun",
      "Horror",
      "roblox",
      "survival",
      "tree"
    ],
    "thumbnail": "https://img.gamemonetize.com/mlyhcvwb0q50d73of2tz554whe6khzna/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mlyhcvwb0q50d73of2tz554whe6khzna/",
    "sourceUrl": "https://html5.gamemonetize.com/mlyhcvwb0q50d73of2tz554whe6khzna/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75042",
    "slug": "change-brick",
    "title": "Change Brick",
    "description": "Change Brick is an engaging puzzle game where you need to move and arrange colorful blocks to their designated positions. Each level presents a strategic challenge, requiring you to calculate the best path, avoid getting stuck, and utilize space intelligently. The difficulty increases progressively with many new and unique layouts, offering a thrilling sense of accomplishment. Change Brick is suitable for training your logic skills and providing lighthearted entertainment every day.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Click",
      "Color",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/8o8w3md9f2qfg1jfmq1r5mvu3hzheea8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8o8w3md9f2qfg1jfmq1r5mvu3hzheea8/",
    "sourceUrl": "https://html5.gamemonetize.com/8o8w3md9f2qfg1jfmq1r5mvu3hzheea8/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75027",
    "slug": "2048-flappy",
    "title": "2048 Flappy",
    "description": "Get ready for the ultimate mashup of two legendary hits! Flappy 2048 combines the addictive, flapping mechanics of the bird genre with the brain-teasing math of the 2048 puzzle. In this game, you dont just fly through pipes, you fly through numbers! Tap to flap your tile and navigate through the gaps. To increase your value, you must pass through the walls with numbers that match your own. Watch your tile evolve from 2 to 4, 8, 16, and eventually all the way to 2048 and other! It&rsquo;s a test of both reflexes and quick thinking. One wrong move or a mistimed flap and it&rsquo;s game over. How far can you fly, and can you reach the ultimate 2048 tile",
    "instructions": "Mouse click or tap to play Desktop Left-Click or Spacebar to flap and fly upwards Mobile Tap the screen to flap and fly upwards Objective Fly through the matching number gates to merge and increase your score Avoid hitting the edges of the gates",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2048",
      "Air",
      "Arcade",
      "crazygamesunblocked",
      "endless",
      "flappybird",
      "HTML5",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/qet6afsr54te1zpfpg2jp0mv25v0zh0p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qet6afsr54te1zpfpg2jp0mv25v0zh0p/",
    "sourceUrl": "https://html5.gamemonetize.com/qet6afsr54te1zpfpg2jp0mv25v0zh0p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74707",
    "slug": "beat-shooter-3d",
    "title": "Beat Shooter 3D",
    "description": "Try great time killer game now! Beat Shooter 3D game combines one-finger control gameplay with beautiful music and gun sounds, help you relaxing and feeling comfortable. About this game A special game in different genres of piano games with wonderful gameplay! Beat Fire creates a music feast suitable for YOU. Totally innovative with feel-good gun sounds. Play it at home to release stress! Try this great time killer now. Let Beat Fire make your day!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "Action",
      "Arcade",
      "Best Games",
      "Music",
      "Rhythm",
      "Shoot",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/g53ydn3nvgouudb6xfbim7l6saeqgz32/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g53ydn3nvgouudb6xfbim7l6saeqgz32/",
    "sourceUrl": "https://html5.gamemonetize.com/g53ydn3nvgouudb6xfbim7l6saeqgz32/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74962",
    "slug": "underdogs-puzzle-odyssey",
    "title": "Underdogs Puzzle Odyssey",
    "description": "Underdogs Puzzle Odyssey is a casual puzzle game that perfectly blends clever brain teaser challenges and a charming story-driven adventure. Join a small underdog hero and help them overcome obstacles through creative puzzle-solving.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Hypercasual",
      "Obstacle"
    ],
    "thumbnail": "https://img.gamemonetize.com/mw7249mepwi1jpny297pe42u7pbli9l0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mw7249mepwi1jpny297pe42u7pbli9l0/",
    "sourceUrl": "https://html5.gamemonetize.com/mw7249mepwi1jpny297pe42u7pbli9l0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71330",
    "slug": "celebrity-lol-funny-face",
    "title": "Celebrity LOL Funny Face",
    "description": "Celebrity LOL Funny Face is a hilarious and free online game for kids. Have fun creating silly and goofy faces of famous celebrities and enjoy endless laughs!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Arcade",
      "Celebrity",
      "Drawing",
      "Fun",
      "Funny",
      "HTML5",
      "Hypercasual",
      "Kids",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/nbu0rgdj5kmuju5jqma66vkkss5nb776/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nbu0rgdj5kmuju5jqma66vkkss5nb776/",
    "sourceUrl": "https://html5.gamemonetize.com/nbu0rgdj5kmuju5jqma66vkkss5nb776/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "74838",
    "slug": "christmas-ornaments-jigsaw-puzzles",
    "title": "Christmas Ornaments Jigsaw Puzzles",
    "description": "Christmas Ornaments Jigsaw Puzzles is a cozy holiday jigsaw game where you pick a picture and assemble it piece by piece. Choose the difficulty (16, 36, or 64 pieces), drag and drop puzzle parts onto the board, and watch the image come together. Use the hint option if you get stuck, and track your time and moves while you play. The game includes gentle looped background music with a simple sound on/off button, so you can play comfortably. Perfect for relaxing in a winter mood and enjoying classic jigsaw gameplay for kids and adults.",
    "instructions": "Mouse Touch drag and drop puzzle pieces Buttons Music ON OFF Shuffle Hint ON OFF Exit Fullscreen if available",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Christmas",
      "Holiday",
      "Jigsaw",
      "Kids",
      "Logic",
      "Puzzle",
      "Snow",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/azcopqbquvo19bl2wcht4kq3tpxx3136/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/azcopqbquvo19bl2wcht4kq3tpxx3136/",
    "sourceUrl": "https://html5.gamemonetize.com/azcopqbquvo19bl2wcht4kq3tpxx3136/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74837",
    "slug": "bubble-pop-fairyland",
    "title": "Bubble Pop Fairyland",
    "description": "Bubble Pop Fairyland is an exciting bubble shooter game that&rsquo;s very highly addictive! Aim, shoot &amp; pop all the color bubbles using epic blasters to clear the board and win coins! Bubble Pop Fairyland is a fun and relaxing puzzle game designed to keep your mind sharp at any age. It also is a perfect brain training and fast solution making game You will have hours of fun shooting &amp; matching the same colored bubbles! With thousands of challenging &amp; addictive unique levels, you simply won&rsquo;t put it down!",
    "instructions": "Aim Move your mouse or swipe on mobile to point the shooter in the direction you want to fire Shoot Click or tap to launch the bubble When your bubble hits a group of at least three bubbles of the same color they pop and disappear",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Ballon",
      "Bricks",
      "Bubble",
      "Bubble Shooter",
      "dino",
      "Dinosaur",
      "egg",
      "free games for your site",
      "free html5 games for your website",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/ahwsuq0u20qmw742m7x61ewn282lnlxk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ahwsuq0u20qmw742m7x61ewn282lnlxk/",
    "sourceUrl": "https://html5.gamemonetize.com/ahwsuq0u20qmw742m7x61ewn282lnlxk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75045",
    "slug": "going-balls-3d",
    "title": "Going Balls 3D",
    "description": "Going Balls 3D is a relaxing 3D rolling game where smooth control and calm focus are the key to winning. Swipe to steer the wooden platform and guide the ball forward&mdash;no need to rush, just keep it steady and reach the finish line without falling.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Ball",
      "Obstacle",
      "Platform",
      "Side Scrolling"
    ],
    "thumbnail": "https://img.gamemonetize.com/np5tu1klmoqljxnjm9ae657nl7tjtgcc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/np5tu1klmoqljxnjm9ae657nl7tjtgcc/",
    "sourceUrl": "https://html5.gamemonetize.com/np5tu1klmoqljxnjm9ae657nl7tjtgcc/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "75039",
    "slug": "hotline-miami",
    "title": "Hotline Miami",
    "description": "Hotline Miami is an exciting 2D top-down shooter. Players are immersed in a vibrant, retro world with fast-paced, intense combat where every mistake can be fatal. Youll encounter a variety of levels with enemies that require a strategic approach, a wide range of weapons, and high stakes where every second counts. Pixel graphics and an 80s-inspired neon atmosphere create a unique aesthetic, while intense firefights and epic soundtracks immerse you in an atmosphere of danger and adrenaline.",
    "instructions": "For PC WASD - to move LMB left mouse button - to shoot R - to reload 1 2 3 - to change weapons For mobile devices Left joystick - to move Right joystick - to shoot Tap on the weapon slot to select it",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "Action",
      "amazing",
      "Gun",
      "Hot",
      "Kill",
      "Music",
      "Shooter",
      "sound",
      "Top Down"
    ],
    "thumbnail": "https://img.gamemonetize.com/9hox58eqiu1ghoxfy80v691ijtd2ou92/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9hox58eqiu1ghoxfy80v691ijtd2ou92/",
    "sourceUrl": "https://html5.gamemonetize.com/9hox58eqiu1ghoxfy80v691ijtd2ou92/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "75051",
    "slug": "tenkyu",
    "title": "TENKYU",
    "description": "Roll the ball through a 3D world to reach the goal! Carefully maneuver through stages, or meet your doom! Swipe your finger and tilt the stage and roll the ball. Be careful not to tilt too much! Game over if the ball falls!",
    "instructions": "use mouse controls to play the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "2D",
      "amazing",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/gho9jzdi8savyfsgdqv7306161nzx6x8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gho9jzdi8savyfsgdqv7306161nzx6x8/",
    "sourceUrl": "https://html5.gamemonetize.com/gho9jzdi8savyfsgdqv7306161nzx6x8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75036",
    "slug": "weapon-merge-run",
    "title": "Weapon Merge Run",
    "description": "Dive into a world filled with action and guns with Weapon Merge Gun Games seamlessly blend the adrenaline-pumping experience of a gun run shooter with the strategic depth of weapon crafting and evolution. Merge gun pieces into firearms, prepare for a race of gun games, clash with the enemy in thrilling, rapid-fire gunplay, and start shooting! Action games have never looked this good before. Get your gun and start running! Exciting Gun Game Gameplay: Clear and shoot obstacles in this gun game to unlock an arsenal of powerful weapons. Test your aiming accuracy by shooting down targets and enemies.",
    "instructions": "Mouse Left click and hold to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Casual",
      "Collecting",
      "Hypercasual",
      "Obstacle",
      "run",
      "running",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/smdgwqhuue8pc8d7k6c1ixkmlsvz3921/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/smdgwqhuue8pc8d7k6c1ixkmlsvz3921/",
    "sourceUrl": "https://html5.gamemonetize.com/smdgwqhuue8pc8d7k6c1ixkmlsvz3921/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75026",
    "slug": "fire-boy-run-adventure",
    "title": "Fire Boy Run Adventure",
    "description": "Fire Boy Run Adventure is an exciting side-scrolling action game that blends adventure and running into one thrilling experience. As the fearless fireboy and dash forward through dangerous levels full of traps and obstacles!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "jump",
      "Obstacle",
      "running",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/2oso175x1i32s7fiiw7xga6bu39imz18/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2oso175x1i32s7fiiw7xga6bu39imz18/",
    "sourceUrl": "https://html5.gamemonetize.com/2oso175x1i32s7fiiw7xga6bu39imz18/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74960",
    "slug": "sausage-man-shooting-adventure",
    "title": "Sausage Man Shooting Adventure",
    "description": "Sausage Man Shooting Adventure is a fast-paced side-scrolling shooting game where you control a crazy, energetic sausage hero and blast through waves of enemies. Run forward, dodge traps, jump platforms, and shoot enemies with nonstop excitement! Collect airdrops to increase your damage.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Crazy",
      "Enemies",
      "Shoot",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/ext7f26qsuyww8lbfgzrpymdxndofs8b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ext7f26qsuyww8lbfgzrpymdxndofs8b/",
    "sourceUrl": "https://html5.gamemonetize.com/ext7f26qsuyww8lbfgzrpymdxndofs8b/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74797",
    "slug": "police-car-simulator-game",
    "title": "Police Car Simulator Game",
    "description": "Step into the world of law enforcement with the Police Game. The Ultimate Cop Simulator, the ultimate combination of police parking, racing, open-world exploration, and crime-fighting missions. Experience the life of a real officer from learning in the police training academy to chasing down dangerous criminals in the streets. This is not just a police simulator, it&rsquo;s a full city experience that gives you freedom, control, and thrill in every mode.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "drifting",
      "Driving",
      "Parking",
      "Police",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/bl55rgkxrmizqvgrtwuic4vukctuegq2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bl55rgkxrmizqvgrtwuic4vukctuegq2/",
    "sourceUrl": "https://html5.gamemonetize.com/bl55rgkxrmizqvgrtwuic4vukctuegq2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74793",
    "slug": "snake-remix",
    "title": "Snake: Remix",
    "description": "Snake Remix - 3 Games in 1! Experience the classic snake game like never before! Snake Remix brings you three unique modes in one epic package: Neo Synthwave - Navigate neon-lit levels with glowing walls, combos, and pulsing beats. Can you master all 10 challenging stages? Nokia 3310 - Pure retro nostalgia! The authentic LCD look and feel from the legendary phone. Simple, addictive, endless. 16-Bit Arcade - Chain colorful fruits for massive combos! Strategic gameplay with wraparound edges and fever mode. Beautiful visuals, pumping synthwave music, and smooth controls on both desktop and mobile. One game, three ways to play!",
    "instructions": "Desktop Arrow keys or WASD to move P or ESC to pause Mobile Swipe to change direction Tap icons to pause or toggle sound Gamepad D-pad to move A to confirm",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Classic",
      "Highscore",
      "Puzzle",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/ip9pseepln2g3gv02ys3mkmzs3gegy8o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ip9pseepln2g3gv02ys3mkmzs3gegy8o/",
    "sourceUrl": "https://html5.gamemonetize.com/ip9pseepln2g3gv02ys3mkmzs3gegy8o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74874",
    "slug": "spacebattle",
    "title": "SpaceBattle",
    "description": "Catch Insect is a captivating puzzle game where you must carefully plan your moves to eliminate all the monsters from a distant planet. Your mission is to control and arrange missiles so that their colors match the target monsters, as only missiles of the same color can destroy them. Each level is designed with a clever layout, requiring players to think logically, choose the right attack order, and make the most of their limited turns. The game offers an exciting intellectual challenge that bec",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Puzzle",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/i3095eapbni2eng0us4g3gdrmrtocidt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i3095eapbni2eng0us4g3gdrmrtocidt/",
    "sourceUrl": "https://html5.gamemonetize.com/i3095eapbni2eng0us4g3gdrmrtocidt/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74964",
    "slug": "avatar-world-secrets",
    "title": "Avatar World Secrets",
    "description": "Dive into various cute items, design the room setting, dress up your avatar family, and make up a life story as you like.Enjoy the fun interaction with items and characters online. From cooking food to watering flowers, and from playing video games to designing clothes, we offer you endless options to choose from.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cooking",
      "Cute",
      "Dress Up",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/212mzzx7wqekyew8yslxg92fk51c6uw6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/212mzzx7wqekyew8yslxg92fk51c6uw6/",
    "sourceUrl": "https://html5.gamemonetize.com/212mzzx7wqekyew8yslxg92fk51c6uw6/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74984",
    "slug": "dark-dino-runner",
    "title": "Dark Dino Runner",
    "description": "Get ready for an adrenaline-pumping adventure in Dark Dino Runner: Night Mode! Jump, duck, and dash through a thrilling night-time landscape filled with obstacles, dangers, and surprises. Play as the fearless dino and test your reflexes in this endless runner challenge. Collect points, unlock achievements, and see how far you can survive in the dark! Perfect for quick gaming sessions and high-score chasers. Are you fast enough to conquer the night?",
    "instructions": "Mouse click or tap to play Space Up Arrow X Key Jump Start Game Down Arrow Duck Slide Left Mouse Click Jump Enter Restart Game after Game Over",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "crazygamesunblocked",
      "dino",
      "Dinosaur",
      "endless",
      "run",
      "running",
      "unblocked games",
      "unblockedgames66",
      "unblockedgames76",
      "unblockedgamesatschool"
    ],
    "thumbnail": "https://img.gamemonetize.com/4wl72xvug9efb7huuw3ydpyvr9ljdwbs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4wl72xvug9efb7huuw3ydpyvr9ljdwbs/",
    "sourceUrl": "https://html5.gamemonetize.com/4wl72xvug9efb7huuw3ydpyvr9ljdwbs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "75002",
    "slug": "classic-falling-ball-game",
    "title": "Classic Falling Ball Game",
    "description": "Your Job Is To Make A Way For The Balls To Put Them In One Truck, And Every Level You Finished It You Will Go To a Harder Level Until You Complete the Hole Levels At The Game.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "3D",
      "Ball",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tz6w334axfeqgscm9bl38ivrlmxs8t1y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tz6w334axfeqgscm9bl38ivrlmxs8t1y/",
    "sourceUrl": "https://html5.gamemonetize.com/tz6w334axfeqgscm9bl38ivrlmxs8t1y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74980",
    "slug": "infinite-line-runner-game",
    "title": "Infinite Line Runner Game",
    "description": "Infinite Line Runner Game is a fast-paced and addictive runner game that challenges your reflexes, focus, and timing. In this game, players control a character running endlessly along a line-based path filled with obstacles, turns, and increasing speed. The goal is simple: keep running as long as possible, avoid obstacles, and achieve the highest score.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "amazing",
      "Brain",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ewxqm0cao31kb3y0m7fpca0psheswxs1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ewxqm0cao31kb3y0m7fpca0psheswxs1/",
    "sourceUrl": "https://html5.gamemonetize.com/ewxqm0cao31kb3y0m7fpca0psheswxs1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74210",
    "slug": "flying-spider",
    "title": "Flying Spider",
    "description": "Welcome to our new Flying Spider Games in the crime city. Come and play Flying Spider Games, in the crime city battle, and enjoy the gangster fight in the Miami city of crime, with smooth animations as all superheroes swing freely through the gangster crime city like never before. The rope spider hero game has an amazing 3D open world Superhero Fight is a new superhero fighting game with a flying spider vs spider fighter.",
    "instructions": "Movement A S W D Punch P Kick K Jump Space Fly E",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "Arcade",
      "fly",
      "Games",
      "Skill",
      "Spiderman",
      "Superhero",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/6ynfkrz65r4p23h9glqbrb5mejbjl5sh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6ynfkrz65r4p23h9glqbrb5mejbjl5sh/",
    "sourceUrl": "https://html5.gamemonetize.com/6ynfkrz65r4p23h9glqbrb5mejbjl5sh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74759",
    "slug": "survivor-io-battle",
    "title": "Survivor.io Battle",
    "description": "Dangerous zombies have overrun the city, pushing humanity to the brink of extinction! The streets are in chaos, and survival is the only option left. Awakened by fate, you step forward as a lone warrior with unlimited potential. In Survivor.io Battle, one player must face endless waves of ruthless zombies and fight for survival. Armed with powerful weapons, you must move smartly, attack strategically, and avoid being surrounded by the overwhelming horde. Collect mystery boxes scattered across the city to unlock upgrades, boost your abilities, and gain powerful weapons that turn the tide of battle.",
    "instructions": "Up - - UP Arow Down - - Down Arrow Left - - Left Arrow Right - - Right Arrow",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      ".io Games",
      "2026 games",
      "Arcade",
      "Battle",
      "Best Games",
      "Enemy",
      "Shooting",
      "Skill",
      "Superhero",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/g2yx03az6bsx6sekkut63069587y5ads/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g2yx03az6bsx6sekkut63069587y5ads/",
    "sourceUrl": "https://html5.gamemonetize.com/g2yx03az6bsx6sekkut63069587y5ads/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74761",
    "slug": "parent-run-game",
    "title": "Parent Run Game",
    "description": "Parent Run Game is a fun and entertaining runner game where you experience the exciting journey of parenthood in a unique way. Run through colorful levels, avoid obstacles, and make smart choices that shape your parenting path. Collect helpful items, dodge challenges, and guide your character safely to the finish line while building a happy family.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "3D Games",
      "Action",
      "Best Games",
      "Casual",
      "endless",
      "Hypercasual",
      "running",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/h2ykyukz2ee36cxdsuday6t988qr5ppy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h2ykyukz2ee36cxdsuday6t988qr5ppy/",
    "sourceUrl": "https://html5.gamemonetize.com/h2ykyukz2ee36cxdsuday6t988qr5ppy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74139",
    "slug": "racing-master-3d",
    "title": "Racing Master 3D",
    "description": "Racing Master 3D is a 3D racing driving simulation game thatll get your adrenaline pumping in seconds! Here, youll drive ultra-cool cars at full throttle. Race through the fully immersive 3D tracks. Enjoy the realistic car driving simulation. Hit the nitro button and blast past every rival in seconds.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "Driving",
      "realistic",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/0zvdndep52fquu58jwu2lej6g1zsk8m2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0zvdndep52fquu58jwu2lej6g1zsk8m2/",
    "sourceUrl": "https://html5.gamemonetize.com/0zvdndep52fquu58jwu2lej6g1zsk8m2/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74123",
    "slug": "wonder-coloring",
    "title": "Wonder Coloring",
    "description": "Hey, artist! In Wonder Coloring, you can create vibrant drawings and enjoy magical sounds! Its easy &mdash; just draw, color, and relax. Each picture is a new opportunity for your creativity! Share your works with friends!",
    "instructions": "Choose the picture you like Click on the parts of the picture to color them Turn on the sound and enjoy the soothing ASMR drawing sounds Your works are automatically saved Draw more to have fun all day long",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boy",
      "Boys",
      "Candy",
      "Cartoon",
      "Color",
      "Coloring",
      "Cool",
      "Girl",
      "Girls",
      "Kid",
      "Kids",
      "paint",
      "painting",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/nvisfpubp05bn2s084d1corq7qiohqgt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nvisfpubp05bn2s084d1corq7qiohqgt/",
    "sourceUrl": "https://html5.gamemonetize.com/nvisfpubp05bn2s084d1corq7qiohqgt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74705",
    "slug": "stickman-escape-out",
    "title": "Stickman Escape Out",
    "description": "Stickman Escape Out is a tunnel-digging game centered on helping criminals escape from prison. Drag your mouse to dig through the ground, collect keys and gold along the way, and reach the vehicle waiting for you at the end of the route that will take you to a better life. Dig the right exit and enjoy your freedom.",
    "instructions": "Use the mouse or touch to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Escape",
      "free html5 games for your website",
      "kiz10",
      "Prison",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/ev3gwfoeax6rglg74t4a5569ci33zqeq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ev3gwfoeax6rglg74t4a5569ci33zqeq/",
    "sourceUrl": "https://html5.gamemonetize.com/ev3gwfoeax6rglg74t4a5569ci33zqeq/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "74998",
    "slug": "anipo",
    "title": "Anipo",
    "description": "Anipo is a light yet challenging puzzle game where you control a character with a unique color to move across land pieces on the map. Each step leaves a color on the land tile you pass through, and your task is to calculate a logical route to color the entire area and complete the level. The levels are designed with variety, requiring logical thinking and dexterity in every move. Anipo offers a relaxing experience suitable for all ages.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Brain",
      "Casual",
      "Logic",
      "Puzzle",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/ictw1wtbs7i8oqykqeatkjh316w0t9k2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ictw1wtbs7i8oqykqeatkjh316w0t9k2/",
    "sourceUrl": "https://html5.gamemonetize.com/ictw1wtbs7i8oqykqeatkjh316w0t9k2/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74978",
    "slug": "destroy-the-ragdoll-sandbox",
    "title": "Destroy the Ragdoll Sandbox",
    "description": "Ready to destroy and earn? In this sandbox clicker, its simple: choose your weapon, attack characters, and get paid for the damage you deal. The stronger your attacks, the bigger the reward! Use different tactics, unlock new gear, and upgrade your firepower. The further you go, the more powerful the weapons and the greater the possibilities. Ready to become the strongest fighter? Then tap, destroy, and earn!",
    "instructions": "Tap anywhere on the screen to attack Choose weapons backgrounds and characters in the menu Earn money and level up to unlock new types of weapons",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "2D",
      "attack",
      "Clicker",
      "destroy",
      "destroying",
      "endless",
      "Fun",
      "Gun",
      "Kill",
      "Killing",
      "Sandbox",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/8bfx1odbmkrk05bjthltlx5tius6prmi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8bfx1odbmkrk05bjthltlx5tius6prmi/",
    "sourceUrl": "https://html5.gamemonetize.com/8bfx1odbmkrk05bjthltlx5tius6prmi/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74853",
    "slug": "fruity-shoot-gift-frenzy",
    "title": "Fruity Shoot: Gift Frenzy",
    "description": "Get ready for a juicy blast in Fruity Shoot! Test your precision and reflexes in this vibrant, fast-paced arcade shooter. Your mission is simple: aim and shoot a lot of fruits with your gun to create satisfying splashes. But be careful&mdash;if you miss too many fruits, your game will be over! To help you stay in the action, special gifts are awarded during gameplay to help you survive longer and reach higher scores. How long can you keep the fruit frenzy going?#Arcade #Fruit #Shooting #Hypercasual",
    "instructions": "Game Controls For Mobile Users Aim amp Shoot Just Tap anywhere on the screen to fire your gun at the fruits Precision Use quick taps to catch the fast-moving fruits before they fall For PC Users Aim Move your Mouse cursor to track the fruits",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Arcade",
      "Best Games",
      "free html5 games for your website",
      "Shooting",
      "watermelon"
    ],
    "thumbnail": "https://img.gamemonetize.com/cwgkvn5i0as7gj8to12cw2akgyj5s06e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cwgkvn5i0as7gj8to12cw2akgyj5s06e/",
    "sourceUrl": "https://html5.gamemonetize.com/cwgkvn5i0as7gj8to12cw2akgyj5s06e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73933",
    "slug": "merrykins-coloring",
    "title": "MerryKins Coloring",
    "description": "Merrykins Coloring pages is a warm and cozy winter coloring game for kids and adults alike! Immerse yourself in New Year magic with cheerful festive music. Pick favorite colors, paint charming seasonal illustrations, or try the fun random fill mode. Use a wide range of tools: pencil, fill, eyedropper, eraser, multiple brushes, copy &amp; paste, and undo. Discover 30 delightful winter scenes: childrens, snowmen, kittens, puppies and bear cubs, Christmas tree, Santa Claus and the Snow Maiden, snowy adventures, and more. Each picture tells a small story you can make truly your own. Save your pictures as JPG and share them with friends! Have fun!",
    "instructions": "mdash Use left mouse button or touch to pick tools and color mdash Zoom with mouse wheel or pinch gesture mdash Tap the question mark for tool tips mdash Save progress with the floppy disk icon mdash Save finished picture to device amp sha",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cat",
      "Christmas",
      "Color",
      "Coloring",
      "Cute",
      "Draw",
      "Drawing",
      "Educational",
      "Girls",
      "Santa",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/6mdzc0s2rt6hd1qb534tohd6c06kroyf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6mdzc0s2rt6hd1qb534tohd6c06kroyf/",
    "sourceUrl": "https://html5.gamemonetize.com/6mdzc0s2rt6hd1qb534tohd6c06kroyf/",
    "width": 1244,
    "height": 700,
    "lastUpdated": ""
  },
  {
    "id": "74605",
    "slug": "easy-coloring-sprunki-time",
    "title": "Easy Coloring Sprunki Time",
    "description": "Click the left mouse button to play and bring our adorable Sprunki character to life with vibrant colors! Let your creativity shine as you choose from a wide palette of bright shades, fun patterns, and magical combinations. There&rsquo;s no time limit and no rush &mdash; just pure coloring fun! Paint Sprunki any way you like, explore your artistic side, and watch the character transform into your own colorful masterpiece. Perfect for kids and anyone who loves relaxing, creative games!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Arcade",
      "Boys",
      "Cartoon",
      "Coloring",
      "Educational",
      "Kids",
      "painting",
      "Puzzle",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/omcneftg3kdg2t7fh36e2452dgkqk99v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/omcneftg3kdg2t7fh36e2452dgkqk99v/",
    "sourceUrl": "https://html5.gamemonetize.com/omcneftg3kdg2t7fh36e2452dgkqk99v/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "74176",
    "slug": "sugar-blast-snowy-pop",
    "title": "Sugar Blast: Snowy Pop",
    "description": "Sugar Blast: Welcome to Snowy Pop! Join 125 thrilling levels filled with colorful candies, plan your moves, and put your skills to the test. But be careful! Some candies hide bombs that can cost you your life. Every move counts! Level up your abilities: boost your tapping power, increase your starting lives, and unleash powerful candy bombs to clear the screen in a single strike! Each level gets tougher, keeping the fun fresh and intense. Unlock 9 mysterious achievements, grow stronger, and prove your mastery!",
    "instructions": "Tap on matching groups of candies horizontal vertical or diagonal to blast them away Earn points with every blast but watch out some candies hide bombs that cost you 1 life If your lives drop to zero it rsquo s game over mdash so think strate",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Pirate",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/h6lgjs8937zrpdh9rpn6djj6557jmz8b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h6lgjs8937zrpdh9rpn6djj6557jmz8b/",
    "sourceUrl": "https://html5.gamemonetize.com/h6lgjs8937zrpdh9rpn6djj6557jmz8b/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74206",
    "slug": "space-bike",
    "title": "Space Bike",
    "description": "Space Flash is a racing casual game on a platform. Race on a long ways to get the best score. Try to get more teabubble to increase you fuel for biker. In Space Flash, you control a bike that can defy gravity and jump over platforms road. But be careful, the space is full of surprises. You never know what you&rsquo;ll find in the next ways. Space Flash is a fun and addictive game that will keep you entertained for hours. You can customize your bike, unlock new levels and achievements, and compete with your friends online. Don&rsquo;t miss this opportunity to experience the thrill of space biking.",
    "instructions": "Using Up Down arrow keyboard to move biker forward backward Left Right arrow keyboard to control bike turbo support by touch screen control",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Fun",
      "Race",
      "Racing",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/cehwgcoqlllp9jgmciqz443abg7k3f8b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cehwgcoqlllp9jgmciqz443abg7k3f8b/",
    "sourceUrl": "https://html5.gamemonetize.com/cehwgcoqlllp9jgmciqz443abg7k3f8b/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74316",
    "slug": "bubble-shooter-aura",
    "title": "Bubble Shooter Aura",
    "description": "Bubble Shooter Aura is a modern and calming take on the classic bubble shooter game. Featuring soft colors, smooth animations, and subtle glowing aura effects, the game creates a relaxing yet addictive experience. With intuitive controls and satisfying gameplay, it&rsquo;s easy to pick up and enjoyable for both casual players and longtime bubble shooter fans.",
    "instructions": "How to Play Aim the shooter and match 3 or more bubbles of the same color Clear bubbles from the board to complete each level rsquo s objective Bounce shots off the walls to reach difficult angles and create combos Trigger chain reactions to activate g",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bubble",
      "Bubble Shooter",
      "Casual",
      "Game",
      "Games",
      "Puzzle",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/3zbf11ewrb4irlyyydqc2je6dgvlzjqv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3zbf11ewrb4irlyyydqc2je6dgvlzjqv/",
    "sourceUrl": "https://html5.gamemonetize.com/3zbf11ewrb4irlyyydqc2je6dgvlzjqv/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74220",
    "slug": "gunship-shooting-attack-game-3d",
    "title": "GunShip Shooting Attack Game 3D",
    "description": "Gunship Shooting Attack Game 3D is the most immersive and realistic 3D helicopter battle action game available on Google Play. Launch the attack on the most dangerous terrorists now! Gunship Strike puts you in the gunner seat of the most powerful combat helicopters. Strategically fire your powerful machines guns and devastating missiles to slay hordes of enemies across the world. Guide with precision your combat helicopter and demolish the enemy military bases in the world&rsquo;s greatest combat experience! The Gunship Helicopter shooting is the best unique tool to train your mind, that how to battle against the strongest enemy.",
    "instructions": "Left Mouse Click",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      ".io Games",
      "2025 games",
      "3D Games",
      "Action",
      "Arcade",
      "attack",
      "Bullet",
      "Enemy",
      "Gun",
      "Shooting",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/vxpxovxs5r64zrvrrjfz60mgxauv8ou1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vxpxovxs5r64zrvrrjfz60mgxauv8ou1/",
    "sourceUrl": "https://html5.gamemonetize.com/vxpxovxs5r64zrvrrjfz60mgxauv8ou1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74624",
    "slug": "new-year-puzzles",
    "title": "New Year Puzzles",
    "description": "New Year Puzzles is a cozy jigsaw game with festive winter artwork. Choose a picture, select the difficulty, and assemble the image piece by piece. Drag fragments onto the board, rotate them when needed, and connect the details until the scene is complete. Use the hint option if you get stuck, or challenge yourself to finish faster with fewer moves. Simple controls, relaxing gameplay, and holiday phere make it perfect for quick breaks for both kids and adults.",
    "instructions": "Mouse Touch drag and drop pieces Rotate use the rotate button if available Hint toggle the hint button Sound speaker icon Restart restart button",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Christmas",
      "HTML5",
      "Kids",
      "Logic",
      "Puzzle",
      "Snow",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/tyrkeqjz7vbu5b36u4jsov6jei0qaf12/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tyrkeqjz7vbu5b36u4jsov6jei0qaf12/",
    "sourceUrl": "https://html5.gamemonetize.com/tyrkeqjz7vbu5b36u4jsov6jei0qaf12/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74919",
    "slug": "human-leap-evolution",
    "title": "Human Leap Evolution",
    "description": "Want a wild evolution adventure from caveman to futuristic super warrior? Human Leap: Evolution is a high-energy action evolution puzzle game where every jump you make shapes your destiny. Choose wisely, evolve rapidly, and battle your enemies with unstoppable power!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Enemies",
      "Puzzle",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/7xkt616oba0xrzx2jfnntq5calom3gm0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7xkt616oba0xrzx2jfnntq5calom3gm0/",
    "sourceUrl": "https://html5.gamemonetize.com/7xkt616oba0xrzx2jfnntq5calom3gm0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74897",
    "slug": "rolly-vortex-puzzle-game",
    "title": "Rolly Vortex Puzzle Game",
    "description": "Set on an exhilarating journey through twisting, turning mazes in the heart-pounding world of Vortex 3D - Ball Run 2024 Maze! This Vortex runner game is not for the faint of heart - its a rollercoaster ride for your fingertips, where youll guide a relentless ball through an ever-changing labyrinth of obstacles. Are you ready to take on the ball control challenge? Try Vortex 3D &ndash; Ball Run 2026 Maze Today!",
    "instructions": "use mouse click and swipe",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/jx6p10zm0ndt2snum3ddz2fbvh1ufx0x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jx6p10zm0ndt2snum3ddz2fbvh1ufx0x/",
    "sourceUrl": "https://html5.gamemonetize.com/jx6p10zm0ndt2snum3ddz2fbvh1ufx0x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74894",
    "slug": "mario-wheelie",
    "title": "Mario Wheelie",
    "description": "Experience high octane motorcycle action as you master daring wheelies and nail tight stunts on every level. Keep tapping the screen to sustain the wheelie, avoid crashing the front wheel, and race toward the finish line while racking up coins for extra challenges. Perfect balance and quick reflexes are essential for this fast?paced bike?riding adventure that blends classic platform thrills with modern mobile gameplay. Play now and prove you&rsquo;ve got the skill to dominate the ultimate wheelie challenge!",
    "instructions": "Mouse to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Balance",
      "Bike",
      "Boy",
      "Hypercasual",
      "Mario",
      "Motorcycle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/drwag9fi0mf3u6a313pjn6ls0exdqpun/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/drwag9fi0mf3u6a313pjn6ls0exdqpun/",
    "sourceUrl": "https://html5.gamemonetize.com/drwag9fi0mf3u6a313pjn6ls0exdqpun/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "74706",
    "slug": "blocky-champions",
    "title": "blocky champions",
    "description": "Blocky Champions is a fast-paced HTML5 arcade platform runner game designed primarily for desktop users. Players control a rolling football that moves forward automatically and must jump across platforms, avoid traps, and survive as long as possible. The game is best experienced on a keyboard, where precise timing and quick reactions are required to dodge obstacles and reach longer distances. With its colorful blocky environment and simple yet challenging gameplay, Blocky Champions delivers a fun arcade experience for PC players.",
    "instructions": "Controls Keyboard Left Arrow Right Arrow ndash Move Space ndash Jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2026 games",
      "2D",
      "Arcade",
      "Ball",
      "Best Games",
      "blocky",
      "free html5 games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/2g0xkdovc638taq3637xr5qmqomrr88q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2g0xkdovc638taq3637xr5qmqomrr88q/",
    "sourceUrl": "https://html5.gamemonetize.com/2g0xkdovc638taq3637xr5qmqomrr88q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74849",
    "slug": "paint-pop-3d-2026",
    "title": "Paint Pop 3D 2026",
    "description": "Paint Pop 3D is an one-tap hyper casual shooting game that will keep you hooked for hours! Tap to paint. Hold for more fun! Stay away from obstacles and paint all slices on the ring. Features: - More than 1000+ levels to experience game play. - A lot challenging missions. - Various characters &amp; themes. - Beautiful graphic.",
    "instructions": "- Tap to paint - Paint all slices on the ring to complete a level - Be careful to the obstacles Game is over if hit an obstacle",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "3D",
      "Ball",
      "Bubble Shooter",
      "Levels",
      "paint",
      "paintball",
      "Shoot 'Em Up",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/ih9o47r2mzomdg0gefgy17z5z64mq6wt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ih9o47r2mzomdg0gefgy17z5z64mq6wt/",
    "sourceUrl": "https://html5.gamemonetize.com/ih9o47r2mzomdg0gefgy17z5z64mq6wt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74836",
    "slug": "catch-insect",
    "title": "Catch Insect",
    "description": "Catch Insect is a fun skill-based puzzle game where you must use your thinking and reflexes to catch cunning insects. Each level presents a different challenge, requiring you to observe the terrain, calculate your path, and choose the precise moment to strike. Just one wrong move, and the prey can escape. With its simple yet strategic gameplay, Catch Insect offers a relaxing yet stimulating experience, suitable for all ages.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Casual",
      "Fun",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/bkdt1ei1lf2fipzez0gd0i4aizns3qwc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bkdt1ei1lf2fipzez0gd0i4aizns3qwc/",
    "sourceUrl": "https://html5.gamemonetize.com/bkdt1ei1lf2fipzez0gd0i4aizns3qwc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74816",
    "slug": "crush-bird",
    "title": "Crush Bird",
    "description": "Crush Bird - Destruction Edition is a fast-paced arcade game where you smash through obstacles, collect power-ups, and cause maximum destruction. Unlike traditional bird games, your goal is to destroy obstacles using Crush Power rather than just avoiding them. You can build up your meter to activate a Mega Crush that wipes the screen, maintain combos for higher scores, and navigate through different game modes like Mayhem, Rampage, Apocalypse, and Survival. Watch out for indestructible red obstacles unless you have a shield active!",
    "instructions": "Tap Click Jump upward and perform a Crush attack Spacebar Alternative control to perform a Crush attack Mega Crush Automatically triggers when you tap click while the Crush Power meter is at 100",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2026 games",
      "Action",
      "Bird",
      "HTML5",
      "sky",
      "unblockedgames66",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/2f9nm4n14gvzfjv6klu7vxx4zyf15zwy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2f9nm4n14gvzfjv6klu7vxx4zyf15zwy/",
    "sourceUrl": "https://html5.gamemonetize.com/2f9nm4n14gvzfjv6klu7vxx4zyf15zwy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74848",
    "slug": "crazy-flappy-bat",
    "title": "Crazy Flappy Bat",
    "description": "Flappy Bat is a fast-paced and addictive arcade game that puts a fresh twist on the classic flappy style. Instead of simple pipes, randomly generated spikes appear from the top and bottom, each with different sizes, making every run unpredictable and challenging. Trust your reflexes and aim for the highest score!",
    "instructions": "The gameplay is the same as Flappy Bird Tap the screen to make the bat fly upward Avoid the random spikes and survive as long as possible to get the best score",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "flappybird",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/xledkxrz9v3rm9mwmkooz3nlpcdqdhjy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xledkxrz9v3rm9mwmkooz3nlpcdqdhjy/",
    "sourceUrl": "https://html5.gamemonetize.com/xledkxrz9v3rm9mwmkooz3nlpcdqdhjy/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74885",
    "slug": "head-ball-challenge",
    "title": "Head Ball Challenge",
    "description": "Head Ball Challenge puts you right into the heart of football competition. Step onto the field, show your reflexes, set your strategy, and dominate every match. Whether you challenge a friend in local multiplayer or advance through the long-term progression of Career Mode, the game delivers nonstop excitement. Two players can compete head-to-head on the same device. Challenge your friend and prove who the real champion is.",
    "instructions": "Move with W A D or Arrow Keys shoot with Space or K Mobile On-screen touch controls appear automatically Use the virtual D-pad to move and tap the action button to shoot",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2 Player Games",
      "2D",
      "Best",
      "Boys",
      "Football",
      "Fun",
      "Funny",
      "Skill",
      "Soccer",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/dzms91rzyryq1yrnxf8chzlr2q9lbzwj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dzms91rzyryq1yrnxf8chzlr2q9lbzwj/",
    "sourceUrl": "https://html5.gamemonetize.com/dzms91rzyryq1yrnxf8chzlr2q9lbzwj/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74893",
    "slug": "capybara-winter-curse",
    "title": "Capybara Winter Curse",
    "description": "During the winter months, the entire capybara folk fell ill and was cursed. Hit all the zombie capybaras with your snowball gun and neutralize them. Remember, the giant capybara zombie is extremely powerful; you must be very fast and strong to defeat it. The fate of the entire capybara world is in your hands. Grab your weapon and start firing!",
    "instructions": "Click the mouse to fire or tap the fire button on mobile Use the WASD keys to move Mobile touch controls available Playable on both mobile and PC",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Arcade",
      "First Person Shooter",
      "Shoot",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/o6k4qcnp882pkffi00f1hi2b6cqs2y97/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o6k4qcnp882pkffi00f1hi2b6cqs2y97/",
    "sourceUrl": "https://html5.gamemonetize.com/o6k4qcnp882pkffi00f1hi2b6cqs2y97/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74770",
    "slug": "stack-maze-challenge",
    "title": "Stack Maze Challenge",
    "description": "This game will AMAZE you! Collect the blocks in the maze and build a bridge to reach the end. The more blocks you collect, the more rewards you will get. Get ready to be amazed! To fill in puzzles, fill each square to unlock more addictive AMAZE maze paint puzzles. Watch out! AMAZE gets harder as you play, color, and paint the maze, and fill in crossy road puzzles! Each level is a canvas",
    "instructions": "Tap the left mouse button amp Swipe",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Best Games",
      "build",
      "Game",
      "Levels",
      "Logic",
      "Maze",
      "Obstacle",
      "Road",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/ckmb6wrjxud03res23yifa4fckqtfd5a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ckmb6wrjxud03res23yifa4fckqtfd5a/",
    "sourceUrl": "https://html5.gamemonetize.com/ckmb6wrjxud03res23yifa4fckqtfd5a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73194",
    "slug": "traffic-jam-car-puzzle-game",
    "title": "Traffic Jam Car Puzzle Game",
    "description": "Welcome to Traffic Road Jam, the ultimate traffic jam puzzle game where your logic and strategy skills are put to the test! Dive into a world of gridlocked cars, each moving in a fixed direction. Your mission? Tap the cars in the right sequence to clear the jam without any crashes. Can you master the chaos and restore order. This traffic jam puzzle game gives you simple controls where you slide cars and trucks to make a free path on the road. In this traffic car game, your goal is to remove all blocks and help the main car escape the jam.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Car",
      "Puzzle",
      "Strategy",
      "Traffic"
    ],
    "thumbnail": "https://img.gamemonetize.com/ovf6uuc81zc1p3pezhvj4hzckwybipgi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ovf6uuc81zc1p3pezhvj4hzckwybipgi/",
    "sourceUrl": "https://html5.gamemonetize.com/ovf6uuc81zc1p3pezhvj4hzckwybipgi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74813",
    "slug": "block-magic-puzzle-game",
    "title": "Block Magic Puzzle Game",
    "description": "Puzzle Game is a most addictive puzzle games collection, With beautiful graphics and interesting levels. Puzzle Game brings many classic fun puzzle games togetherlike Block Puzzle, Bubble Shooter and Onet Puzzle. These puzzle games are classic and funand they are easy to learn. From now on, as a puzzle game lover, you dont have to search a lot of games, you can play these classic games here.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "2026 games",
      "Block",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/3nin4ln4pjt0ae72rcoxq07kekbedyn7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3nin4ln4pjt0ae72rcoxq07kekbedyn7/",
    "sourceUrl": "https://html5.gamemonetize.com/3nin4ln4pjt0ae72rcoxq07kekbedyn7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74825",
    "slug": "endless-ball-ride-game",
    "title": "Endless Ball Ride Game",
    "description": "Endless Ball: Downhill Ride Bring your skills to the next level by exploring and extending this complete 3D endless runner game! Endless Ball: Downhill Ride is a simple but challeging endless runner game, ready to be extended by you! The game comes with a complete and animated UI, an endless game experience with increasing level of difficulty, as well as an integrated score and highscore system.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "amazing",
      "Ball",
      "Casual",
      "Hypercasual",
      "Top Down"
    ],
    "thumbnail": "https://img.gamemonetize.com/wnfswonlbf082z66f9keryvrl35gkng2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wnfswonlbf082z66f9keryvrl35gkng2/",
    "sourceUrl": "https://html5.gamemonetize.com/wnfswonlbf082z66f9keryvrl35gkng2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74827",
    "slug": "two-dot-connect-game",
    "title": "Two Dot Connect Game",
    "description": "Swipe from dot to dot and let the colors flow freely as you link the dots together, crafting a bigger ball connection. Go beyond merely connecting two dots or three dots; embrace the limitless possibilities of dot link connections. This dots game is full of surprises and endless fun. Solve dot link puzzles and relax after stressful studying and working hours. Sharpen your mind with many different color connect levels that little by little increase puzzle difficulty.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2026 games",
      "3D",
      "amazing",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/022kxdryikh9larmv0udgkebl2g9gpxo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/022kxdryikh9larmv0udgkebl2g9gpxo/",
    "sourceUrl": "https://html5.gamemonetize.com/022kxdryikh9larmv0udgkebl2g9gpxo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73891",
    "slug": "aquasort-2-color-puzzle",
    "title": "AquaSort 2: Color Puzzle",
    "description": "AquaSort 2: Color Puzzle is an engaging and relaxing water-sorting puzzle game designed to challenge your mind and provide hours of satisfying gameplay. Your goal is simple: sort all the colored liquids into their respective bottles until each bottle contains only one color. With hundreds of levels, the complexity increases as you advance, introducing more colors and bottles to manage. The game features adjustable difficulty settings (Easy, Normal, Hard) that dynamically change the level generation to offer a smoother or much tougher challenge, including an increased number of empty bottles on the Hard setting.",
    "instructions": "Select Bottle Tap Click the bottle you wish to pour from Pour Liquid Tap Click the destination bottle after selecting the source bottle Deselect Bottle Tap Click the currently selected bottle again Undo Move Tap Click the Undo button Reset Level Ta",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "HTML5",
      "Logic",
      "Logical",
      "unblocked",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/f6bmqv5n3ys6ugmds34q2jf7g0hc1525/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f6bmqv5n3ys6ugmds34q2jf7g0hc1525/",
    "sourceUrl": "https://html5.gamemonetize.com/f6bmqv5n3ys6ugmds34q2jf7g0hc1525/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73307",
    "slug": "merge-game-puzzle-fusion",
    "title": "MERGE GAME: Puzzle Fusion",
    "description": "Become a Merge Master in the most addictive puzzle fusion game! Combine adorable animals, magical creatures, and mysterious objects to discover incredible new characters. With simple tap-to-merge gameplay and stunning visual effects, every combination brings exciting surprises. - STRATEGIC PUZZLE GAMEPLAY: Plan your moves wisely to create powerful chain reactions - HUNDREDS OF UNIQUE CHARACTERS: Collect and evolve your fantasy creature collection - VIBRANT WORLDS: Explore beautifully designed environments with captivating graphics - SATISFYING PROGRESSION: Experience incredibly juicy merge effects and animations",
    "instructions": "Mouse click or tap to play",
    "category": "",
    "genres": [],
    "tags": [],
    "thumbnail": "https://img.gamemonetize.com/dct28y0h5hz5e5vu7ji6l5h1wuqlirr5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dct28y0h5hz5e5vu7ji6l5h1wuqlirr5/",
    "sourceUrl": "https://html5.gamemonetize.com/dct28y0h5hz5e5vu7ji6l5h1wuqlirr5/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74373",
    "slug": "kids-mahjong-connect",
    "title": "Kids Mahjong Connect",
    "description": "An easy mahjong connect game build for kids with cute emojis.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Mahjong"
    ],
    "thumbnail": "https://img.gamemonetize.com/7iv1ztz3hx9xnzq19f8kadpp4eptrkrv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7iv1ztz3hx9xnzq19f8kadpp4eptrkrv/",
    "sourceUrl": "https://html5.gamemonetize.com/7iv1ztz3hx9xnzq19f8kadpp4eptrkrv/",
    "width": 700,
    "height": 650,
    "lastUpdated": ""
  },
  {
    "id": "74480",
    "slug": "match-pairs-memory-card",
    "title": "Match Pairs Memory Card",
    "description": "Match Pair: Memory Card Game takes the classic concentration game to the next level. Embark on an epic journey across 19 unique worlds&mdash;from the depths of the Ocean to the far reaches of Space. Adventure Mode: Conquer 100+ levels with unique objectives and 3-star rankings. Boss Battles: duel against an AI opponent that fights back! Power-Ups: Use Flash Vision, Time Freeze, and Guardian Shields to save your streak. Collection System: Unlock dozens of premium card skins and complete your Sticker Book. Daily Rewards: Log in every day to earn gems and boosters.",
    "instructions": "Mouse Left-click to flip cards and interact with buttons Touch Tap the screen to play on mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Brain",
      "Card",
      "Matching",
      "Memory",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/t1qzb3es71gl68xvqq6iwm9vltl0uctg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t1qzb3es71gl68xvqq6iwm9vltl0uctg/",
    "sourceUrl": "https://html5.gamemonetize.com/t1qzb3es71gl68xvqq6iwm9vltl0uctg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74599",
    "slug": "woody-cross",
    "title": "Woody Cross",
    "description": "Woody Cross is an excellent way to loosen up and relax your mind. Find as many hidden words as you can and improve your vocabulary everyday! Woody Cross combines classic crossword with a modern twist, offering hours of fun and brain-boosting challenges. Features: 6000+ challenging levels. Well designed grass &amp; wooden theme. Dictionary: Expand your vocabulary! Hint and other boosters: magnifying glasses, firecrackers. No time limit, no pressure.",
    "instructions": "Swipe to connect letters in any direction to make words Find the hidden words and fill in the crossword grid to win levels Complete levels to earn bonus rewards",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Brain",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/bhs9ves88nta7s59d4ms7o9bhc49dss2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bhs9ves88nta7s59d4ms7o9bhc49dss2/",
    "sourceUrl": "https://html5.gamemonetize.com/bhs9ves88nta7s59d4ms7o9bhc49dss2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74559",
    "slug": "galaxy-2048",
    "title": "Galaxy 2048",
    "description": "Galaxy 2048 is a fun and addictive puzzle game inspired by the classic 2048 gameplay. Swipe the tiles to combine numbers and create higher values as you aim to reach the ultimate 2048 tile. With a clean galaxy-themed design and smooth controls, the game is easy to learn but challenging to master. Perfect for relaxing your mind while training your logic and concentration skills. Play anytime on desktop or mobile devices and enjoy endless number-merging fun!",
    "instructions": "Controls - Swipe Up Down Left Right to move the tiles - Tiles with the same number merge into one - Reach 2048 to win the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Block",
      "Brain",
      "Casual",
      "Classic",
      "HTML5",
      "Logic",
      "Math",
      "Mobile",
      "Number"
    ],
    "thumbnail": "https://img.gamemonetize.com/wqrjoibnw3f6kjr8gjcy6pdypydad9h8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wqrjoibnw3f6kjr8gjcy6pdypydad9h8/",
    "sourceUrl": "https://html5.gamemonetize.com/wqrjoibnw3f6kjr8gjcy6pdypydad9h8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74814",
    "slug": "holiday-tile-swap",
    "title": "Holiday Tile Swap",
    "description": "Swap tiles fast to restore festive holiday scenes before time runs out. Enjoy smooth, interactive puzzle action with cozy visuals and quick challenges.",
    "instructions": "1 Adjacent tile swapping 2 20-tile picture grid 3 Timed puzzle challenge 4 Festive holiday artwork 5 Mouse Touch",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Christmas",
      "Holiday",
      "Jigsaw",
      "Puzzle",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/9fas20fr13hsw5tyx95oe7uq6npza0lt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9fas20fr13hsw5tyx95oe7uq6npza0lt/",
    "sourceUrl": "https://html5.gamemonetize.com/9fas20fr13hsw5tyx95oe7uq6npza0lt/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "74774",
    "slug": "couple-wedding-race-game",
    "title": "Couple Wedding Race Game",
    "description": "Plan your perfect wedding from head to toe in this fun dress-up and makeover game! Help the bride and groom find their dream looks, from stunning dresses and dashing suits to delicious cake and beautiful decorations.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2 Player",
      "3D",
      "amazing",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7lo7ba1h1mlmc379empw2qaubnpmrtl9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7lo7ba1h1mlmc379empw2qaubnpmrtl9/",
    "sourceUrl": "https://html5.gamemonetize.com/7lo7ba1h1mlmc379empw2qaubnpmrtl9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74794",
    "slug": "mini-art-puzzle-game",
    "title": "Mini Art Puzzle Game",
    "description": "Welcome to Art Puzzle Game, a relaxing and fun puzzle game where art and creativity come together. Enjoy peaceful gameplay as you solve beautiful art puzzles filled with color, shapes, and calm music. If you love art games, painting puzzles, or relaxing games, this one is made for you.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Castle",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/up6wvk9fkctxyigx4lu3w6393p0b3qjd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/up6wvk9fkctxyigx4lu3w6393p0b3qjd/",
    "sourceUrl": "https://html5.gamemonetize.com/up6wvk9fkctxyigx4lu3w6393p0b3qjd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74791",
    "slug": "house-build-puzzle-game",
    "title": "House Build Puzzle Game",
    "description": "Build House Mini Puzzle Game is a fun and relaxing puzzle game that challenges players to build houses by solving smart and engaging mini puzzles. This game is designed for players who enjoy construction games, logic challenges, and creative problem-solving. Each level presents a new building task where players must carefully place parts and complete the house structure step by step.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Casual",
      "House",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7mmei5us3xl7bq7g3ryiiprptaq73vbq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7mmei5us3xl7bq7g3ryiiprptaq73vbq/",
    "sourceUrl": "https://html5.gamemonetize.com/7mmei5us3xl7bq7g3ryiiprptaq73vbq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74445",
    "slug": "merge-miners-3d-puzzle",
    "title": "Merge Miners 3D Puzzle",
    "description": "Classic merge game with a twist. Easy to pick up and play! Become rich by buying tools, upgrading them, and letting physics do the rest. Start your mining empire today! Merge and Miner is an addictive merging game where you begin with a single miner tool and must dig deep by breaking pixel blocks to make a mining empire. In each level, you can purchase a new miner tool and merge it with your existing mining tool to upgrade it into a more powerful and advanced miner tool.",
    "instructions": "Left Mouse Click - Drag and merge shovels to unlock the Ice Breaker Shovel",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Arcade",
      "Brain",
      "Cartoon",
      "Casual",
      "Game",
      "idle",
      "Puzzle",
      "Relaxation",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/e1etc88ybuxetnm7ygqvyv2ndqyyt3st/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e1etc88ybuxetnm7ygqvyv2ndqyyt3st/",
    "sourceUrl": "https://html5.gamemonetize.com/e1etc88ybuxetnm7ygqvyv2ndqyyt3st/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74163",
    "slug": "new-years-eve-makeup",
    "title": "New Years Eve Makeup",
    "description": "Create stunning New Years Eve looks in the New Years Eve Makeup game! Help three BFFs get party-ready with dazzling themes: Ellie&rsquo;s cinnamon roll glam, Regina&rsquo;s golden glow, and Kali&rsquo;s icy gem look. Customize each girls makeup with eyeshadows, mascaras, lipsticks, and accessories, then complete their style with elegant dresses and chic hairstyles. Perfect for makeup and fashion enthusiasts, this game brings the ultimate NYE makeover experience. Celebrate in style and sparkle all night!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "beauty",
      "Christmas",
      "Dress Up",
      "Fashion",
      "Girl",
      "Girls",
      "Holiday",
      "Makeover",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/hq69725hm23c4why11d389bh2vxl6vvc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hq69725hm23c4why11d389bh2vxl6vvc/",
    "sourceUrl": "https://html5.gamemonetize.com/hq69725hm23c4why11d389bh2vxl6vvc/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72882",
    "slug": "escape-maze-rush",
    "title": "Escape Maze Rush",
    "description": "Escape Maze Rush is a fast-paced and addictive HTML5 puzzle-action game! Help a brave bunny navigate through tricky mazes filled with fruits, enemies, spikes, and hidden surprises. Your mission: collect all the fruits, grab the key, defeat enemies, and reach the glowing portal to escape each level! Featuring 20 challenging stages and 10+ unlockable character skins available from the start, every run is packed with action and excitement. Can you beat all the mazes and become the ultimate escape master?",
    "instructions": "Mobile Swipe on the screen to move the bunny Up Down Left Right Desktop Use the arrow keys to control the bunny",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Cute",
      "Kids",
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/zyxc23mt9r9xxujgkxw76rpvp2odve9p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zyxc23mt9r9xxujgkxw76rpvp2odve9p/",
    "sourceUrl": "https://html5.gamemonetize.com/zyxc23mt9r9xxujgkxw76rpvp2odve9p/",
    "width": 504,
    "height": 896,
    "lastUpdated": ""
  },
  {
    "id": "74126",
    "slug": "dead-frequency",
    "title": "Dead Frequency",
    "description": "Dead Frequency is a unique tower defense game where survival depends on a single central tower. Waves of relentless enemies close in from all directions, and your lone tower must hold the line. Upgrade its abilities, unleash powerful attacks, and adapt your strategy to withstand the growing chaos. With only one tower to rely on, every decision counts &mdash; can you endure the frequency of death?",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Monster",
      "Strategy",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/bs0yhsqsqhzg7qjj0dh3tgsstxmt6wit/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bs0yhsqsqhzg7qjj0dh3tgsstxmt6wit/",
    "sourceUrl": "https://html5.gamemonetize.com/bs0yhsqsqhzg7qjj0dh3tgsstxmt6wit/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "74230",
    "slug": "santa-matching-game",
    "title": "Santa Matching Game",
    "description": "Xmas Matching is a delightful, holiday-themed memory puzzle game designed for friends and family to enjoy together. Set against a snowy winter night, players take turns flipping cards to find matching pairs of iconic Christmas symbols, including Santa Claus, warm cocoa, festive candles, and gingerbread cookies. Challenge your brain across multiple levels of increasing difficulty. Whether you are playing solo to beat your best score or competing in the Battle Mode with up to 4 players, the goal remains the same: remember the positions, find the matches, and clear the board to become the ultimate Holiday Match Master!",
    "instructions": "Xmas Matching Select Flip Left-Click or Tap Navigate Left-Click or Tap buttons to start or progress levels Input Use Keyboard to type player names during setup",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "amazing",
      "Brain",
      "Christmas",
      "Fun",
      "Matching",
      "Memory",
      "Mind",
      "Multiplayer",
      "Santa",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/7zwgvkvq609jq0jk7tpfe10bncofyj5o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7zwgvkvq609jq0jk7tpfe10bncofyj5o/",
    "sourceUrl": "https://html5.gamemonetize.com/7zwgvkvq609jq0jk7tpfe10bncofyj5o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74360",
    "slug": "knee-case-simulator",
    "title": "Knee Case Simulator",
    "description": "Oops, Tiara fell and hurt her knee! Dont worry, youre here to save the day! Jump in as a doctor and fix her up with some quick knee surgery. Follow the right steps to ensure shes back on her feet in no time. Once shes healed, its time for some fun! Check out some cute outfits and accessories in our collection and give her a fresh, stunning look!",
    "instructions": "Use MOUSE to play the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Doctor",
      "Dress Up",
      "Simulation",
      "Surgery"
    ],
    "thumbnail": "https://img.gamemonetize.com/34bokq1kfeghn5db0gklnun2xhfszzn8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/34bokq1kfeghn5db0gklnun2xhfszzn8/",
    "sourceUrl": "https://html5.gamemonetize.com/34bokq1kfeghn5db0gklnun2xhfszzn8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74490",
    "slug": "draw-half-game",
    "title": "Draw Half Game",
    "description": "Welcome to the Half Draw Missing Puzzle Game, Do you like drawing games? Have you ever wanted a drawing puzzle game to challenge your brain and your talent for drawing? Let&rsquo;s try Draw One Part to experience this drawing puzzle. Playing is simple, use your finger to draw and outline the shapes of the parts that the level needs, and then watch the color auto-fill in the rest to complete the mission and take you on to the next challenge. Have you ever wanted a game to challenge your brain and your talent for drawing? Solve puzzles by using your powers of logic.",
    "instructions": "Tap amp Hold to draw Left Mouse Button",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Best Games",
      "Brain",
      "Casual",
      "Draw",
      "Drawing",
      "free games for your site",
      "Logic",
      "Relaxation",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/7uo06teaeenernuaaty9xth5olc1j4od/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7uo06teaeenernuaaty9xth5olc1j4od/",
    "sourceUrl": "https://html5.gamemonetize.com/7uo06teaeenernuaaty9xth5olc1j4od/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74753",
    "slug": "mafia-sniper-crime-shooting",
    "title": "Mafia Sniper Crime Shooting",
    "description": "Ready to become the coldest, deadliest sniper in the entire city? Mafia Sniper Crime Shooting is a FPS action shooting simulator where you complete high-risk missions. Use powerful guns to eliminate dangerous mafia targets.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Gun",
      "Shoot",
      "Simulator",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/3j2rhgd5dukodiw4wqrmoiuezoppxru0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3j2rhgd5dukodiw4wqrmoiuezoppxru0/",
    "sourceUrl": "https://html5.gamemonetize.com/3j2rhgd5dukodiw4wqrmoiuezoppxru0/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74493",
    "slug": "magic-action-gun-game",
    "title": "Magic Action Gun Game",
    "description": "Dive into the world filled with action and guns with Weapon Master and Magic Action Gun Games - Gun Games seamlessly blend the adrenaline-pumping experience of a gun run shooter with the strategic depth of weapon crafting and evolution. Merge gun pieces into firearms, prepare for a race of gun games, clash with the enemy in thrilling, rapid-fire gunplay, and start shooting! Action games never looked this good before. Get your gun and start running! Exciting Gun Game Gameplay: Clear and shoot obstacles in this gun game to unlock an arsenal of powerful weapons. Test your aiming accuracy by shooting down targets and enemies.",
    "instructions": "Left Mouse Click",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adventure",
      "Fantasy",
      "Game",
      "Games",
      "Gun",
      "Magic",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/zvml4zjgzkh5xq1pgb1egqtjskoxazyu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zvml4zjgzkh5xq1pgb1egqtjskoxazyu/",
    "sourceUrl": "https://html5.gamemonetize.com/zvml4zjgzkh5xq1pgb1egqtjskoxazyu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74539",
    "slug": "long-hair-rush-challenge",
    "title": "Long Hair Rush Challenge",
    "description": "Are you ready for a massive long Hair Challenge? This is an adventure in which you have a super long majestic hair! This popular hair runner game is perfect for you! Do you hate getting a bad hair cut? So do we! Especially in this super fun Hair Challenge game! Pick up weaves of any hair colors as you walk the runway. Watch out for the scissors, blades, and all other sharp obstacles to keep your gorgeous hair from getting cut! Did you not like your hair color? Or need a makeover? No problem, because this is a hair salon runway. Put your high heels on, pick yourself up a colorful hair dye, and start running on the roof!",
    "instructions": "Forward - Up Arrow Backward - Down Arrow Left - Left Arrow Right - Right Arrow",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Best Games",
      "Casual",
      "Color",
      "endless",
      "Fun",
      "Games",
      "Hair",
      "HTML5",
      "Obstacle",
      "run",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/h4v0ysri6hupa388nkw45nwatwiekpzf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h4v0ysri6hupa388nkw45nwatwiekpzf/",
    "sourceUrl": "https://html5.gamemonetize.com/h4v0ysri6hupa388nkw45nwatwiekpzf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74231",
    "slug": "dress-to-impress-new-years-party",
    "title": "Dress To Impress: New Years Party",
    "description": "Dress To Impress: New Year&rsquo;s Party is a glamorous dress-up game where you style four best friends for the biggest night of the year. Create sparkling gold glam, celestial blue looks, bold black elegance, and playful pink showgirl outfits. Mix dresses, tops, shoes, hairstyles, and accessories to match each girl&rsquo;s vibe and welcome the New Year in unforgettable style.",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Christmas",
      "Dress Up",
      "Fashion",
      "Girl",
      "Girls",
      "Holiday"
    ],
    "thumbnail": "https://img.gamemonetize.com/hnepturtmdnnfy99tq90kqev1uesmg9p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hnepturtmdnnfy99tq90kqev1uesmg9p/",
    "sourceUrl": "https://html5.gamemonetize.com/hnepturtmdnnfy99tq90kqev1uesmg9p/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "74055",
    "slug": "transition",
    "title": "Transition",
    "description": "Find the right color of being and help him to find his purpose in life. Little creature is sad, because he does not know the meaning of his life. But one day, the magic come. You must help him to get to the platform in the same color. But you must pay attention to the time and the black platforms, because the game will end. ----- The game was created on Bratislava Game Jam 2016 and game won in category Attendee Choice. The theme of this event was the transition same as name of game.",
    "instructions": "click tap on right half of screen - go to right click tap on left half of screen - go to left",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best Games",
      "Casual",
      "Christmas",
      "Classic",
      "Clicker",
      "Color",
      "Fantasy",
      "Jumping",
      "Magic",
      "Maze",
      "Puzzle",
      "Snow"
    ],
    "thumbnail": "https://img.gamemonetize.com/fmhunbb9t16sybhv5ca08c53idaqb77g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fmhunbb9t16sybhv5ca08c53idaqb77g/",
    "sourceUrl": "https://html5.gamemonetize.com/fmhunbb9t16sybhv5ca08c53idaqb77g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74253",
    "slug": "hide-and-seek-game",
    "title": "Hide and Seek Game",
    "description": "Presenting you with the best classic hide and seek, stylishly. Play this strategy game either as a hider or a seeker. Use shelters from phone booths or office desks, hide while swimming in the water, in the hay pile, in the cradle, behind walls, or anywhere you feel safe. Hide and seek is one of the most enjoyable games for kids and families, both in old and modern times. We provide the best hide-and-seek game to have fun anywhere, anytime.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/f8fx8of4s4j1n3ibmtcw1npzc5l1le7g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f8fx8of4s4j1n3ibmtcw1npzc5l1le7g/",
    "sourceUrl": "https://html5.gamemonetize.com/f8fx8of4s4j1n3ibmtcw1npzc5l1le7g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73212",
    "slug": "snow-battel-arena",
    "title": "Snow Battel Arena",
    "description": "Snowball Battle Arena 3D is an action-packed first-person shooter set in a frozen battlefield. Armed with unlimited snowballs, players must survive wave after wave of hostile snowmen that grow stronger over time. Use quick movement, jumping, and dash abilities to stay alive while defending yourself in a beautifully animated winter arena. How many waves can you survive?",
    "instructions": "Keyboard amp Mouse Controls W A S D ndash Move Mouse ndash Aim Left Click ndash Throw Snowball Space ndash Jump E ndash Dash ESC ndash Pause Game",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D Games",
      "First Person Shooter",
      "Shooter",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/6blezhm8cqxbz394788vid1pjle1qxse/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6blezhm8cqxbz394788vid1pjle1qxse/",
    "sourceUrl": "https://html5.gamemonetize.com/6blezhm8cqxbz394788vid1pjle1qxse/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74608",
    "slug": "almond-connection-link-win",
    "title": "Almond Connection Link Win",
    "description": "This game is a bright and satisfying puzzle game where your goal is to connect matching dots and fill the entire board with paths. Each line forms a tiny connection, and every level brings a fresh challenge for your logic and attention.",
    "instructions": "Connect matching dots Find pairs of the same color and draw a line between them Avoid crossing paths Lines cannot overlap or block each other Fill the whole board Use every cell to complete the level Difficulty increases",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur"
    ],
    "thumbnail": "https://img.gamemonetize.com/qwzdad6rm2i86iklcn6m3yobkj5zz7sn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qwzdad6rm2i86iklcn6m3yobkj5zz7sn/",
    "sourceUrl": "https://html5.gamemonetize.com/qwzdad6rm2i86iklcn6m3yobkj5zz7sn/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "74698",
    "slug": "idle-factory-game-tycoon",
    "title": "Idle Factory Game Tycoon",
    "description": "Factory Game : Idle Tycoon - Industrial Empire Simulator Experience the industrial revolution and build your factory empire. Factory Game Idle Tycoon combines idle clicker, business simulator, tycoon strategy and factory management mechanics into a comprehensive industrial game experience. Metal Production and Automation Produce metal with every click, convert to cash and grow your economic power. Works with click income, metal production, auto robot and passive income system. Earn idle earnings with simple auto robot, regional robot program and national robot fleet. Offline earnings continue even when the game is closed.",
    "instructions": "Game Controls Mouse Controls Left Click Click on the metal gear to produce metal Left Click Press buttons to open panels Click Upgrades Decorations Factories Investment Casino Left Click Convert metal to money in Click panel Left Click",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Balance",
      "Click",
      "Clicker",
      "Fun",
      "Funny",
      "Point And Click",
      "spin-wheel"
    ],
    "thumbnail": "https://img.gamemonetize.com/b2mu0m7nkeipo8oc38tdybm4qeudbo0g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b2mu0m7nkeipo8oc38tdybm4qeudbo0g/",
    "sourceUrl": "https://html5.gamemonetize.com/b2mu0m7nkeipo8oc38tdybm4qeudbo0g/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74491",
    "slug": "deadly-hunters-run",
    "title": "Deadly Hunters Run",
    "description": "Run away from the hungry lion with little Hunter! An addictive endless runner that can be played offline whenever you want! Race through endless gorgeous locations, dodge obstacles, jump over chasms on a rope, and pick delicious strawberries! Explore breathtaking landscapes, track elusive animals, and hone your shooting skills in this action-packed game. Whether you&rsquo;re a seasoned hunter or a novice, this game offers a realistic and immersive hunting adventure that will keep you on the edge of your seat. Enjoy seamless hunting with no breaks in the action, all in portrait mode. Progress through the game by winning events, unlocking new tours.",
    "instructions": "Forword --- Up Arrow Or W Back --- Down Arrow Or S Left --- Left Arrow Or A Right --- Right Arrow OR D",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adventure",
      "Casual",
      "endless",
      "Game",
      "Games",
      "html5 games for your site",
      "hunter",
      "Obstacle",
      "run",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/b413soatjrbi9igc9d22pi22ugt7r7bs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b413soatjrbi9igc9d22pi22ugt7r7bs/",
    "sourceUrl": "https://html5.gamemonetize.com/b413soatjrbi9igc9d22pi22ugt7r7bs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74374",
    "slug": "bricksbreaker",
    "title": "BricksBreaker",
    "description": "Bricks Breaker is a fast-paced arcade game where you aim, shoot, and smash colorful bricks to clear each level. Enjoy simple controls, satisfying ball physics, and progressively challenging stages",
    "instructions": "use mouse controls and slide left and right",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Arena",
      "Bricks"
    ],
    "thumbnail": "https://img.gamemonetize.com/tgf0q3ux6b5uhpr03a55pw4kkl7un5nv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tgf0q3ux6b5uhpr03a55pw4kkl7un5nv/",
    "sourceUrl": "https://html5.gamemonetize.com/tgf0q3ux6b5uhpr03a55pw4kkl7un5nv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74709",
    "slug": "draw-to-smash-zombie",
    "title": "Draw To Smash Zombie",
    "description": "Draw To Smash Zombie is an exciting drawing logic puzzle game where your creativity becomes the ultimate weapon against waves of silly zombies. The gameplay is simple, addictive, and super fun. You just draw shapes, lines, ramps, or anything you want. Roll the bomb to blast the zombies.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Draw",
      "Fun",
      "smash",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/rw198uk8lylevqyln8jpyfea1zf9zp9d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rw198uk8lylevqyln8jpyfea1zf9zp9d/",
    "sourceUrl": "https://html5.gamemonetize.com/rw198uk8lylevqyln8jpyfea1zf9zp9d/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "73908",
    "slug": "wolf-simulator-forest-hunt-3d",
    "title": "Wolf Simulator Forest Hunt 3D",
    "description": "Explore nature as a wild animal and raise a family in the wilderness in Wildcraft, a new RPG adventure set in a huge 3D landscape! Start your adventure as a wolf, fox, lynx and more, and take your family on a new adventure. Play with friends in multiplayer games and form animal families to protect your cubs from enemies. Unlock new animal breeds as your family legacy grows in Wildcraft! Online Multiplayer Simulator Compete with players from all around the World! The wilderness is never empty. Meet other wolves in real time and conquer the forest!",
    "instructions": "use mouse LMB hit WASD E eat F drink P pick Space Jump ESC pause menu TAB Objective",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "Animal",
      "Arcade",
      "Forest",
      "Game",
      "Hunting",
      "Simulator",
      "Wolf"
    ],
    "thumbnail": "https://img.gamemonetize.com/obte6bemd7au25zgt9xva9wlnzerhzm2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/obte6bemd7au25zgt9xva9wlnzerhzm2/",
    "sourceUrl": "https://html5.gamemonetize.com/obte6bemd7au25zgt9xva9wlnzerhzm2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74221",
    "slug": "real-car-parking-game",
    "title": "Real Car Parking Game",
    "description": "Welcome to the Vehicle Master Parking Games! It is an exhilarating street car driving game 2024. Street car parking is full of challenges of parking and driving. Step into the vehicles driver seat and show your car driving skills in street car park game. Car racing and vehicle driving master is the ultimate vehicle driving and car parking game that offers an entertaining experience for fans of car driving games, car simulators, and vehicle simulators",
    "instructions": "- To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Car",
      "carparking",
      "Cars",
      "Driving",
      "Parking"
    ],
    "thumbnail": "https://img.gamemonetize.com/htg34efhl5vzddci66p144nwumk49mto/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/htg34efhl5vzddci66p144nwumk49mto/",
    "sourceUrl": "https://html5.gamemonetize.com/htg34efhl5vzddci66p144nwumk49mto/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74108",
    "slug": "prom-run",
    "title": "Prom Run",
    "description": "Prom Run is a fast-paced fashion runner where every outfit can change your fate. Swipe to guide your girl through the runway streets, &ldquo;eating&rdquo; clothes, shoes, accessories and beauty items to boost her charm score. Grab the good stuff, dodge the bad choices, and try to reach the club door with enough charm to get inside&mdash;or impress the boy waiting at the end of the run.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "beauty",
      "Casual",
      "Dress Up",
      "Fashion",
      "Girls",
      "Makeover",
      "Mobile",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/dbepm3ipf3b8rgtyv3wb8ucthllcpqn6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dbepm3ipf3b8rgtyv3wb8ucthllcpqn6/",
    "sourceUrl": "https://html5.gamemonetize.com/dbepm3ipf3b8rgtyv3wb8ucthllcpqn6/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "74137",
    "slug": "doll-doll",
    "title": "Doll Doll",
    "description": "Doll Doll is a fun fighting game combined with collection elements, where you roam the map to gather adorable Doll rabbits. Each time you collect 3 rabbits of the same color, you score points and create interesting combo chains. The map is full of challenges with many unexpected situations, requiring you to move skillfully and choose the right path to collect all the rabbits. Simple and easy to play but equally engaging, Doll Doll offers a light and colorful entertainment experience!",
    "instructions": "Use mouse play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Brain",
      "Click",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qgrkhk9dgtmc5vfjl82jzl0sdj4i22mj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qgrkhk9dgtmc5vfjl82jzl0sdj4i22mj/",
    "sourceUrl": "https://html5.gamemonetize.com/qgrkhk9dgtmc5vfjl82jzl0sdj4i22mj/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74174",
    "slug": "brainrot-clicker",
    "title": "Brainrot Clicker",
    "description": "Play the best brainrot clicker! Your favorite characters and a variety of cool worlds await you. Level up your clicks, respawn, and listen to your favorite brainrot music!",
    "instructions": "1 Tap the screen to collect coins The faster you click the more coins you get 2 Reborn ndash discover new worlds Accumulate enough coins to be reborn and unlock unique locations with cool bloggers 3 Purchase upgrades Each upgrade will give you",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Brainrot",
      "Cartoon",
      "Casual",
      "Crazy",
      "Game",
      "HTML5",
      "Italian Brainrot",
      "Stunts",
      "Tralalero Tralala",
      "Tung Tung Tung Sahur",
      "WebGL",
      "World"
    ],
    "thumbnail": "https://img.gamemonetize.com/d5znapsqor09pu1la49pjm0jc0m2d94r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d5znapsqor09pu1la49pjm0jc0m2d94r/",
    "sourceUrl": "https://html5.gamemonetize.com/d5znapsqor09pu1la49pjm0jc0m2d94r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73918",
    "slug": "prison-escape-puzzle-master",
    "title": "Prison Escape Puzzle Master",
    "description": "Think prison life is boring? Think again! Prison Master: Escape Journey 3D turns everyday life into a thrilling strategy adventure. Explore hidden corners, collect valuable tools, and find clever ways to outsmart the guard. Your mission is to find a way out, no matter the risk. Stay sharp, move wisely, and build your route to freedom in this thrilling 3D adventure. Every decision matters in Prison Escape Puzzle Master: Escape Journey. Whether you&rsquo;re planning or making deals, each move takes you one step closer to freedom - or total failure.",
    "instructions": "Mouse Controlled Hold the left mouse button and drag to draw a path Tap the player to start moving along the drawn track Avoid searchlights laser beams and hurdles to escape safely",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Adventure",
      "Brain",
      "Casual",
      "Escape",
      "Fun",
      "Levels",
      "Logic",
      "Prison"
    ],
    "thumbnail": "https://img.gamemonetize.com/mha46qn18vus7r51xk5tupuye600smef/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mha46qn18vus7r51xk5tupuye600smef/",
    "sourceUrl": "https://html5.gamemonetize.com/mha46qn18vus7r51xk5tupuye600smef/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73922",
    "slug": "fall-guy-stick-column-runner",
    "title": "Fall Guy Stick Column Runner",
    "description": "Its a game that you will have fun playing. Pass the traps and go to the next level. There are other lurks waiting for you. Fall Guy is a unique game where players control a charming character who falls between two columns. You must focus and press at the right time to stick the stick between your hands to the columns to avoid obstacles and reach the finish line. The goal of the game is to reach the bottom finish line in each level. Tap the screen at the right time to stick the stick to the columns. As you progress in the game, the levels will become more challenging. You will encounter various obstacles. Collect stars along the way",
    "instructions": "Mouse Controlled - Left button click",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Arcade",
      "Balance",
      "Casual",
      "endless",
      "Fall Guys",
      "Game",
      "Obstacle",
      "running",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/h0ns1q2u6umb13nq1y620jnt15tz1dnl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h0ns1q2u6umb13nq1y620jnt15tz1dnl/",
    "sourceUrl": "https://html5.gamemonetize.com/h0ns1q2u6umb13nq1y620jnt15tz1dnl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74598",
    "slug": "counting-for-kids",
    "title": "Counting For Kids",
    "description": "Counting Game for Kids is a set of unique educational kids counting games aimed at helping children learn counting numbers from one to nine. This game has 10 levels with 10 different themes: animals, planet, fruits, vegetables, flowers, learning tools, etc&hellip; In particular, with each level, the kids will learn how to write and pronounce the words of each picture that the kids counts. Teaching numbers in a way that engages fun and creativity, the kids will simply love playing the counting games.",
    "instructions": "Tap Screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Coloring",
      "Educational",
      "Kids",
      "Math",
      "Puzzle",
      "puzzleblock",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/6vgagh1gaq7i4007brxrq206j7t45tn3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6vgagh1gaq7i4007brxrq206j7t45tn3/",
    "sourceUrl": "https://html5.gamemonetize.com/6vgagh1gaq7i4007brxrq206j7t45tn3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74535",
    "slug": "dungeon-fighter-3d",
    "title": "Dungeon Fighter 3D",
    "description": "Thrilling Gameloft ARPG Sequel! Unite, fearless Bounty Hunters, and embrace Dungeon Hunter fighter 3D - a unique and enthralling hack-and-slash odyssey that continues the cherished Dungeon Hunter saga. As a seasoned dungeon crawler, enter uncharted dungeon territories, reunite with iconic Dungeon Hunter characters, and experience a new level of excitement in this extraordinary action-packed MMORPG installment! Return to Valenthias dungeons 200 years after the brave sacrifice of the Dungeon Hunter and experience brand new thrilling Dungeon quests, in a scale never seen before in a Dungeon Hunter game.",
    "instructions": "use mouse WASD Arrow keys for movement z punch x kick c defend Space Jump ESC pause menu TAB Objective LMB hit",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D",
      "3D Games",
      "Action",
      "Adventure",
      "Dungeon",
      "Fight",
      "Monster",
      "RPG",
      "Superhero",
      "Sword"
    ],
    "thumbnail": "https://img.gamemonetize.com/91v6to68exgcl8f6lecc9znohnfjp0d1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/91v6to68exgcl8f6lecc9znohnfjp0d1/",
    "sourceUrl": "https://html5.gamemonetize.com/91v6to68exgcl8f6lecc9znohnfjp0d1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74272",
    "slug": "idle-tomato-clicker",
    "title": "Idle Tomato Clicker",
    "description": "Tomato Clicker - Idle Simulator is a fun and addictive clicker game where players grow their wealth by collecting tomatoes. Players tap the big tomato button to gather tomatoes, convert these tomatoes into money , and invest in upgrades to build their farming empire. The game offers a growth journey starting from a tiny tomato all the way to a massive agricultural and real estate fortune.",
    "instructions": "Tomato Harvesting At the heart of the game is a giant tomato button Every time you tap you earn tomatoes These tomatoes become your main source of income Tomatoes rarr Money You keep the game rsquo s economy running by converting the tomatoes",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Casual",
      "Click",
      "Clicker",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/v54l0afl1irg98zufy8x57rghqum03ih/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v54l0afl1irg98zufy8x57rghqum03ih/",
    "sourceUrl": "https://html5.gamemonetize.com/v54l0afl1irg98zufy8x57rghqum03ih/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74082",
    "slug": "winter-tetrix-trails",
    "title": "Winter Tetrix Trails",
    "description": "Winter Tetrix Trails is a relaxing shape-filling puzzle game set in a snowy world. Drag and place colorful Tetris-style blocks to complete each unique silhouette &mdash; think carefully, fit perfectly, and enjoy the magic of winter puzzles!",
    "instructions": "Click drag and place the blocks with your mouse or touchpad mdash fill the silhouette to finish the level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Christmas",
      "Jigsaw",
      "Tetris",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/q830yihrtp9gvpbekcxeoazfxqyjkkia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q830yihrtp9gvpbekcxeoazfxqyjkkia/",
    "sourceUrl": "https://html5.gamemonetize.com/q830yihrtp9gvpbekcxeoazfxqyjkkia/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "74315",
    "slug": "real-estate-tycoon",
    "title": "Real Estate Tycoon",
    "description": "Climb step by step to the top of the real estate world! Buy and sell properties with strategy and skill, grow your fortune and leave your rivals behind. Every move brings you closer to achieving massive success as the ultimate realtor. Building your real estate empire has never been this fun!",
    "instructions": "- Buy and Sell Houses Snag cheap houses sell them at higher prices and maximize your profit Every transaction requires strategic thinking the right moves lead to wealth - Mystery Achievements Unlock a total of 18 mysterious achievements Disco",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Business",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/bhvaljoobtkiazbqp182ns9yl7ui9jba/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bhvaljoobtkiazbqp182ns9yl7ui9jba/",
    "sourceUrl": "https://html5.gamemonetize.com/bhvaljoobtkiazbqp182ns9yl7ui9jba/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74600",
    "slug": "trap-cursor",
    "title": "TRAP CURSOR",
    "description": "Trap Cursor: Ultimate Reflex Challenge! Test your speed and precision in this high-stakes survival game! Navigate your cursor through a maze of deadly traps and shifting obstacles. Stay sharp&mdash;one mistake is all it takes to get caught. How long can you survive the trap? Fast &amp; Addictive: Quick rounds for non-stop action. Neon Aesthetics: Sleek, high-contrast orange visuals. Challenge Your Limits: Perfect your timing and beat the high score! #TrapCursor #ReflexGame #Arcade #IndieGame #FastPaced #SkillGame #NeonGaming #HighScorer #CursorGame #ReactionTest",
    "instructions": "Game Controls For Desktop Spacebar Press the Space button to control your movement and stay safe",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "arrow",
      "arrows",
      "Best",
      "Boys",
      "Brain",
      "Classic",
      "Clicker",
      "HTML5"
    ],
    "thumbnail": "https://img.gamemonetize.com/vx8bws60g7pzct7o0r0izxb76ay4yogm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vx8bws60g7pzct7o0r0izxb76ay4yogm/",
    "sourceUrl": "https://html5.gamemonetize.com/vx8bws60g7pzct7o0r0izxb76ay4yogm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74685",
    "slug": "forest-archer",
    "title": "Forest Archer",
    "description": "Master the bow in this epic Action challenge! Aim, time your shots, and battle shifting winds in the ultimate Archery experience. Each level gets tougher&mdash;test your Hunting skills and become the legend of the forest",
    "instructions": "How to Play PC Mouse Aim amp Power Click and drag the mouse back to aim and set power Shoot Release the left mouse button to fire the arrow Mobile Touch Aim amp Power Touch and drag your finger on the screen to aim Shoot Lift your finger",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Action",
      "Adventure",
      "Bird",
      "Brain",
      "Hunting",
      "Shooting",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/hzap7ij8k021garzem76ikki7d5eg8qk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hzap7ij8k021garzem76ikki7d5eg8qk/",
    "sourceUrl": "https://html5.gamemonetize.com/hzap7ij8k021garzem76ikki7d5eg8qk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74575",
    "slug": "football-kick-3d",
    "title": "Football Kick 3D",
    "description": "Football Kick 3D is a fast-paced 3D soccer action game where you don&rsquo;t just dribble &mdash; you smash through defenders to claim the ball and score. Charge forward, knock enemies away with powerful tackles, steal possession, and push through the field toward the goal.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "3D",
      "Casual",
      "Football",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/faldmlyi3o26ppqc18vmuvsd9dqierk2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/faldmlyi3o26ppqc18vmuvsd9dqierk2/",
    "sourceUrl": "https://html5.gamemonetize.com/faldmlyi3o26ppqc18vmuvsd9dqierk2/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74681",
    "slug": "kick-the-santa-christmas-buddy",
    "title": "Kick The Santa Christmas Buddy",
    "description": "Want the most hilarious, chaotic, and stress-relieving Christmas action experience ever? Kick The Santa: Christmas Buddy is a casual and funny Christmas game where your Christmas Buddy becomes your ultimate stress-buster.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Christmas",
      "Funny",
      "smash",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/goiftww0fg5u5vpjutkvctdtp14sjc9k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/goiftww0fg5u5vpjutkvctdtp14sjc9k/",
    "sourceUrl": "https://html5.gamemonetize.com/goiftww0fg5u5vpjutkvctdtp14sjc9k/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74677",
    "slug": "animal-racing-idle-park",
    "title": "Animal Racing Idle Park",
    "description": "Animal Racing: Idle Park is an addictive racing animal transform game that will keep you playing for hours. In this game, you&rsquo;ll train multiple animal racers such as lions, eagles, orangutans, dolphins, and more!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Multiplayer",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/cqyx3s8p63ybn0nfpix9jszqrmx7anj8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cqyx3s8p63ybn0nfpix9jszqrmx7anj8/",
    "sourceUrl": "https://html5.gamemonetize.com/cqyx3s8p63ybn0nfpix9jszqrmx7anj8/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74680",
    "slug": "gold-miner-classic",
    "title": "Gold Miner Classic",
    "description": "Jump into the most classic gold mining adventure ever! Gold Miner Classic brings you all the excitement of being a real gold miner. Feel into the perfect casual relaxation experience. Your mission is simple but incredibly satisfying.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Classic",
      "Gold",
      "Miner",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/pavs6ax35zqbk58pkp91enhexhikaomf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pavs6ax35zqbk58pkp91enhexhikaomf/",
    "sourceUrl": "https://html5.gamemonetize.com/pavs6ax35zqbk58pkp91enhexhikaomf/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74602",
    "slug": "hop-masters",
    "title": "Hop Masters",
    "description": "In Hop Masters, you must tap left or right to reach the next platform before it moves, breaks, or even disappears! Along the way, you&rsquo;ll find chests and pi&ntilde;atas packed with tons of adorable costumes to dress up your character and amazing items to decorate your home.",
    "instructions": "Use the touch or mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "endless",
      "free html5 games for your website",
      "Jumping",
      "kiz10",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/cvc9k9xogv4c3l5zujs0zf4ttzvuvgsl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cvc9k9xogv4c3l5zujs0zf4ttzvuvgsl/",
    "sourceUrl": "https://html5.gamemonetize.com/cvc9k9xogv4c3l5zujs0zf4ttzvuvgsl/",
    "width": 768,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "74547",
    "slug": "hot-and-cold-winter-style",
    "title": "Hot And Cold Winter Style",
    "description": "Princesses Eliza and Milana are going on winter vacation, but for each of the girls, winter vacation will be special. Eliza lives in snowy regions and loves fluffy fur coats, warm scarves and winter dresses. Milana celebrates her holidays under palm trees and chooses swimsuits, light capes and bright accessories. Players will have to create stylish images, combining the cold shine of snow and the warm glow of the tropics. Help Eliza and Milana become the most fashionable princesses of winter!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Christmas",
      "Dress Up",
      "Elsa",
      "Fashion",
      "Holiday",
      "Princess",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/5nvq381ebrokq6sgw2to2em4cn5sfnmr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5nvq381ebrokq6sgw2to2em4cn5sfnmr/",
    "sourceUrl": "https://html5.gamemonetize.com/5nvq381ebrokq6sgw2to2em4cn5sfnmr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74596",
    "slug": "skate-xmas",
    "title": "Skate Xmas",
    "description": "Have you ever skateboarded across the rooftops of buildings at Christmas? Skate on the rooftops and be very careful&mdash;if you fall from a great height, you lose. You must be very careful to avoid falling from high places. Pass over the buildings and reach the finish line by jumping over the objects in the sky.",
    "instructions": "You can move using the WASD keys and jump with the lsquo W rsquo key Playable on both mobile and PC Mobile touch controls available",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/2qga0wdl7kge0x6121to74g8knjdvqwj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2qga0wdl7kge0x6121to74g8knjdvqwj/",
    "sourceUrl": "https://html5.gamemonetize.com/2qga0wdl7kge0x6121to74g8knjdvqwj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73877",
    "slug": "fish-tank-aquarium-game",
    "title": "Fish tank Aquarium Game",
    "description": "The fish aquarium game is taking care of your own pet fish and building an aquarium for your precious fish. It sounds like fun, doesn&rsquo;t it? Well, now you can be a proud owner of your own fish tank, take care of fish, and even become a fish doctor! All you need to do is download **Fish Aquarium Game Decorate free, and your aquarium adventure can start! Fish Aquarium is the latest advance in fish simulations. Enjoy plenty of freshwater and saltwater fish, including seahorses, whales, dolphins, sharks, starfish, jellyfish, rays, and turtles.",
    "instructions": "Mouse operated - Tap on the food container to drop fish food and click on the fish to hunt",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Arcade",
      "Ball",
      "Best Games",
      "Fish",
      "Fishing",
      "Fun",
      "Relaxation",
      "Tank"
    ],
    "thumbnail": "https://img.gamemonetize.com/v1slhk8r5gjzp3eeqdf7gk6n0l0ltcqq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v1slhk8r5gjzp3eeqdf7gk6n0l0ltcqq/",
    "sourceUrl": "https://html5.gamemonetize.com/v1slhk8r5gjzp3eeqdf7gk6n0l0ltcqq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74212",
    "slug": "foot-doctor-simulator",
    "title": "Foot Doctor Simulator",
    "description": "Step into the soothing world of Foot Doctor Simulator, the ultimate relaxation simulation game that combines the comforting sensation of ASMR with the fulfilling role of a foot specialist. Immerse yourself in a calming and stress-relieving environment where you can pamper virtual patients feet, providing them with the utmost care and comfort. Try to cure nail and foot injuries of your patients by using realistic surgical tools in this game. If you like medical simulation games, then this game is surely for you!",
    "instructions": "Mouse Click Left",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Baby Games",
      "Casual",
      "Doctor",
      "Game",
      "Kids",
      "Makeover",
      "Simulator",
      "Surgery"
    ],
    "thumbnail": "https://img.gamemonetize.com/1bg3rrhjqnu8bbnn3lhu1d6hn31r5k5w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1bg3rrhjqnu8bbnn3lhu1d6hn31r5k5w/",
    "sourceUrl": "https://html5.gamemonetize.com/1bg3rrhjqnu8bbnn3lhu1d6hn31r5k5w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74254",
    "slug": "clash-master-running-game",
    "title": "Clash Master Running Game",
    "description": "Clash Master Game is a thrilling mobile game that puts you in control of an unstoppable hero on a quest for supremacy. As you navigate through dynamic levels filled with obstacles, your goal is to gather points and recruit more fighters to your army. But watch out for the rebel king who stands in your way - use your skills to outmaneuver him and push him down while mastering the art of the clash. With fast-paced action and addictive gameplay, Clash Master Game will keep you entertained for hours on end. Download now and become the ultimate champion!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tg1zz96zk73ebwd647fp1tkcclxvruia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tg1zz96zk73ebwd647fp1tkcclxvruia/",
    "sourceUrl": "https://html5.gamemonetize.com/tg1zz96zk73ebwd647fp1tkcclxvruia/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74558",
    "slug": "city-bus-passenger-picking-game",
    "title": "City Bus Passenger Picking Game",
    "description": "Welcome to the idle bus traffic empire tycoon simulator game to build and manage your big human transportation business. Start development with an empty building and develop it by investing in various rooms and buying buses. Supermarket, restaurant, waiting room, toilet - these are just some of the departments of your future business. Will you be the richest millionaire tycoon in this idle simulator game? Develop your station, buy counters with goods, upgrade the level of staff, hire managers, automate and get more money from visitor service.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D",
      "amazing",
      "bus",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/zxwkge8heuts5hye8yvgybd4qaexnw8b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zxwkge8heuts5hye8yvgybd4qaexnw8b/",
    "sourceUrl": "https://html5.gamemonetize.com/zxwkge8heuts5hye8yvgybd4qaexnw8b/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74580",
    "slug": "merge-bullet-army-game",
    "title": "Merge Bullet Army Game",
    "description": "Run and Stack the bullets shoot them all , new Bullet and Gun Experience with stack. Throughout each level, players encounter various hurdles and adversaries that stand in their path. Utilize your stocked bullets wisely to overcome these obstacles, shooting barrels, and collecting more ammunition to replenish your magazines. As the level progresses, the challenge intensifies, requiring quick reflexes and precise aim to succeed. Use your weapons and guns strategically, saving bullets for crucial moments and unleashing them with precision to defeat enemies and clear the path to victory.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Gun",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/d5y2dcsgmttfsmt146e796g16nnpcdpu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d5y2dcsgmttfsmt146e796g16nnpcdpu/",
    "sourceUrl": "https://html5.gamemonetize.com/d5y2dcsgmttfsmt146e796g16nnpcdpu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74447",
    "slug": "crazy-revolution-police-runner-hyper-casual",
    "title": "Crazy Revolution   Police Runner : Hyper Casual",
    "description": "Crazy Revolution - Police Runner - Hyper Casual is a hyper-casual , fast-paced, addictive runner game! &zwj; Choose your side at the start: Police &zwj; or Revolutionary &zwj;? Each path gives a unique gameplay experience &mdash; your enemies depend on your side!",
    "instructions": "At the start of the game you choose your side zwj zwj mdash ldquo Police rdquo or ldquo Revolutionary rdquo Your choice determines your enemies mdash if you choose police the revolutionaries become your foes and vice versa",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Crazy",
      "Level",
      "Levels",
      "Police",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/cahl3ywbi3nx38fbmjqwfyko4p6sexrk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cahl3ywbi3nx38fbmjqwfyko4p6sexrk/",
    "sourceUrl": "https://html5.gamemonetize.com/cahl3ywbi3nx38fbmjqwfyko4p6sexrk/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74159",
    "slug": "mega-sweet-fruits-popper",
    "title": "Mega Sweet Fruits   Popper",
    "description": "Welcome to Mega Sweet Fruits - Popper! Take on 125 exciting levels filled with colorful fruits, plan your moves, and test your skills. But be careful! Some fruits hide bombs that can cost you a life. Every move matters! Upgrade your abilities: increase your tap power, boost your starting lives, and use powerful pomegranates to clear the screen in one strike! Each level gets more challenging, keeping the fun fresh and intense. Unlock 9 mysterious achievements, grow stronger, and prove your mastery! With 8 supported languages (English, Russian, French, Turkish, Spanish, German, Italian, Portuguese)",
    "instructions": "Tap on groups of matching fruits horizontal vertical or diagonal to pop them Earn points with every pop but watch out some fruits hide bombs that cost you 1 life If your lives drop to zero it rsquo s game over mdash so think strategically",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Fruit",
      "Fruits",
      "Poppy Playtime"
    ],
    "thumbnail": "https://img.gamemonetize.com/bzlbckwgoew0dwj7nenqq840dj9mtcen/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bzlbckwgoew0dwj7nenqq840dj9mtcen/",
    "sourceUrl": "https://html5.gamemonetize.com/bzlbckwgoew0dwj7nenqq840dj9mtcen/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74256",
    "slug": "sky-invader-impossible-track-game",
    "title": "Sky Invader Impossible Track Game",
    "description": "Get ready for the ultimate thrill with Mega Ramp Car Stunt, the most exciting car stunt game of 2024! Dive into a world of extreme car stunts and conquer impossible tracks as you perform jaw-dropping maneuvers on sky-high ramps. Whether youre a racing enthusiast or a fan of crazy stunts, this game delivers high-speed action and adrenaline-pumping fun.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left Pressing the Esc key will pause the game Pressing Esc again will resume gameplay If the player wants to restart in the middle of the game they can press Es",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Car",
      "crash",
      "Driving",
      "Race",
      "Racing",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/supvzi8uj1bw42robdjoiof720h0ekkr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/supvzi8uj1bw42robdjoiof720h0ekkr/",
    "sourceUrl": "https://html5.gamemonetize.com/supvzi8uj1bw42robdjoiof720h0ekkr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74597",
    "slug": "and-again",
    "title": "and Again",
    "description": "Together with the main character of the new online game And Again, you will go on a journey through the painted world in search of treasures and adventures. The location in which your hero will be will be visible on the screen in front of you. By controlling his actions you will have to move around the area. Overcoming various obstacles and traps, you will have to help the hero find special magic pins. With their help, he will be able to activate the portal leading to the next level.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Best",
      "Fun",
      "Logic",
      "Logical",
      "Mobile",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/r222w4gt6l2rszwx3rj788jfj10ba2ob/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r222w4gt6l2rszwx3rj788jfj10ba2ob/",
    "sourceUrl": "https://html5.gamemonetize.com/r222w4gt6l2rszwx3rj788jfj10ba2ob/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74570",
    "slug": "survival-on-raft-multiplayer",
    "title": "Survival On Raft Multiplayer",
    "description": "Begin an exciting survival adventure in Survival On Raft: Multiplayer. Have an addictive survival-adventure simulation on an island. Here, youll be gathering various foods, stones, and other items. Collect ocean resources like wood, leaves and rare items.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Food",
      "Multiplayer",
      "Simulation",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/mx9w5vmo8udrlwtrvrzu9dzjme1pz4re/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mx9w5vmo8udrlwtrvrzu9dzjme1pz4re/",
    "sourceUrl": "https://html5.gamemonetize.com/mx9w5vmo8udrlwtrvrzu9dzjme1pz4re/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74089",
    "slug": "prince-of-demons-dark-flame",
    "title": "Prince Of Demons : Dark Flame",
    "description": "Wield hellfire, conquer darkness, and rise as the Prince of Demons in this epic RPG to break free from your cursed half-demon fate. Features: 1. Explosive Hack &amp; Slash Combat &ndash; Fast-paced action with dark magic and brutal powers. 2. Epic Boss Battles &ndash; Face monstrous demons and corrupted kings",
    "instructions": "Arrow Keys rarr Move Z rarr Attack X rarr Fire Attack Space Bar rarr Jump Mouse Movement rarr Rotate Camera",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Battle",
      "Horror",
      "Magic",
      "RPG",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/p5862ilgm4xspokrfzokc5s9ybarivkq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p5862ilgm4xspokrfzokc5s9ybarivkq/",
    "sourceUrl": "https://html5.gamemonetize.com/p5862ilgm4xspokrfzokc5s9ybarivkq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68852",
    "slug": "smashmetal-car-wrek-wars",
    "title": "SmashMetal: Car Wrek Wars",
    "description": "Get ready for the most intense car wreck action! Smash Metal Car Wrek Wars Ultimate Car Crash Battle! is a high-speed addicted car battle game where destruction means highest point achieve. Drift, crash, and wreck your way to dominance in this epic car destruction simulator with fun way. Realistic crash physics Epic metal-on-metal battles Multiple arenas with increasing chaos Can you survive the war of wrecks? Try now and prove your driving rage! Game Features: Full of fun Earn Coin and Loss Coin! Stunning wrecked car models Game like catch me if you can! 2 minutes wrecking arena gameplay Addictive funny car smashing battle",
    "instructions": "Keyboard Left amp Right Key Mobile Left amp Right Screen Touch",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Car",
      "Cars",
      "Race",
      "Racing",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/ubj2rnab93quq2cj7gpq7mshgvf8azm6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ubj2rnab93quq2cj7gpq7mshgvf8azm6/",
    "sourceUrl": "https://html5.gamemonetize.com/ubj2rnab93quq2cj7gpq7mshgvf8azm6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74536",
    "slug": "tractor-farming-3d",
    "title": "Tractor Farming 3D",
    "description": "Welcome to Tractor Farming Game 3D, the most realistic and exciting farming &amp; tractor simulation game! Experience real village life, enjoy tochan battles, and grow crops in beautiful 3D environments. From powerful tractors to cinematic missions, every mode gives you a new farming adventure! Indian Tractor Farming 3D Driving Game 2024 is specially designed for tractor game 2022 3d lovers. If you want to drive a real tractor trail game in a farming tractor simulator game. So this tractor driving game is a good option. Are you ready to grow your farming game with the tractor game 2021 game 3d in farming?",
    "instructions": "Tap amp Hold the left mouse button and drag",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D Games",
      "Casual",
      "cut",
      "Driving",
      "Farm",
      "Games",
      "html5 games",
      "Hypercasual",
      "Kids",
      "Simulation",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/dfymk5qt8qib3qr4fkf0omgkeftny6tt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dfymk5qt8qib3qr4fkf0omgkeftny6tt/",
    "sourceUrl": "https://html5.gamemonetize.com/dfymk5qt8qib3qr4fkf0omgkeftny6tt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74543",
    "slug": "merge-weapon-run",
    "title": "Merge Weapon Run",
    "description": "Merge Weapon Run is a satisfying merge runner that turns into a tactical tower defense battle at the finish line. Run forward and collect numbered weapons like 2, 4, 6, 8&hellip; then merge them 2048-style: two matching weapons combine into a stronger one (2+2=4, 4+4=8, and so on). Build the biggest, strongest weapon chain you can before reaching the end.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2048",
      "3D",
      "Casual",
      "Strategy",
      "Tower Defense",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/tdxecpw2tgr54phiy9udf1sbwkjwm3xu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tdxecpw2tgr54phiy9udf1sbwkjwm3xu/",
    "sourceUrl": "https://html5.gamemonetize.com/tdxecpw2tgr54phiy9udf1sbwkjwm3xu/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74255",
    "slug": "bubble-man-running-game",
    "title": "Bubble Man Running Game",
    "description": "Bubble Man Running Gameis a thrilling mobile game that puts you in control of an unstoppable hero on a quest for supremacy. As you navigate through dynamic levels filled with obstacles, your goal is to gather points and recruit more fighters to your army. But watch out for the rebel king who stands in your way - use your skills to outmaneuver him and push him down while mastering the art of the clash. With fast-paced action and addictive gameplay, Bubble Man Running Gamee will keep you entertained for hours on end. Download now and become the ultimate champion!",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ih38502mhtn929xtnxkz362u32dooqkl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ih38502mhtn929xtnxkz362u32dooqkl/",
    "sourceUrl": "https://html5.gamemonetize.com/ih38502mhtn929xtnxkz362u32dooqkl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74259",
    "slug": "color-number-shooter-game",
    "title": "Color Number Shooter Game",
    "description": "Step into the world of color shooter challenge games. The ultimate reflex and precision-based arcade game that will keep you glued to your screen for hours! In this addictive and fast-paced game, your mission is simple yet thrilling &mdash; shoot the rotating circle, reduce its number to zero, and conquer every level in the number shooter game. But don&rsquo;t be fooled by its minimalistic design &mdash; each level brings new twists, faster rotations, and mind-bending challenges that test your focus, speed, and accuracy. Whether you&rsquo;re a casual gamer looking for a fun way to pass the time or a competitive player aiming for high scores.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Ball",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/2xox2kcz8hr62mztd8iprtwh1b2wwfot/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2xox2kcz8hr62mztd8iprtwh1b2wwfot/",
    "sourceUrl": "https://html5.gamemonetize.com/2xox2kcz8hr62mztd8iprtwh1b2wwfot/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74215",
    "slug": "crazy-snow-skier-platformer",
    "title": "Crazy Snow Skier: Platformer",
    "description": "Slide through icy slopes, collect coins , upgrade your speed and buy hearts ! Face 10 increasingly difficult levels . Avoid crushing metal blocks and bats &mdash;they&rsquo;ll cost you a heart! Out of hearts? Game over. Your goal: reach the finish flag &mdash;but no signs, no hints! Explore &amp; survive on your own.",
    "instructions": "Desktop Gameplay To Play the Game - To Go Right -- gt A - To Go Left -- gt D - To Jump -- gt W",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Platform",
      "Ski",
      "Snow"
    ],
    "thumbnail": "https://img.gamemonetize.com/kslcgc9gpy8bq2ys9z6yio1ttumubduv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kslcgc9gpy8bq2ys9z6yio1ttumubduv/",
    "sourceUrl": "https://html5.gamemonetize.com/kslcgc9gpy8bq2ys9z6yio1ttumubduv/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74552",
    "slug": "grenade-simulator",
    "title": "Grenade Simulator",
    "description": "Begin the most explosive simulator experience ever. Grenade Simulator is an adrenaline-pumping explosion simulator where you can freely throw grenades, drop mines, and trigger massive blasts. This isn&rsquo;t just a casual game. This is a full-power explosion playground! You can experience how to use various bombs.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Bomb",
      "Fun",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/v4d4jevlefo9eletrcs2vb9asdnh0d2n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v4d4jevlefo9eletrcs2vb9asdnh0d2n/",
    "sourceUrl": "https://html5.gamemonetize.com/v4d4jevlefo9eletrcs2vb9asdnh0d2n/",
    "width": 1600,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74554",
    "slug": "block-jam-match-game",
    "title": "Block Jam Match Game",
    "description": "Embark on a thrilling adventure that combines strategic block matching, a heart-pounding bus mini-game, an explosive Bomb Bridge Competition, and a brand-new challenge: the Baloon Rise Challenge! Elevate your gaming experience with strategic moves and test your skills in a puzzle-packed journey.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D",
      "amazing",
      "Block",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/4otjsjz31jgy4a3yr2p0bv98wiygri1u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4otjsjz31jgy4a3yr2p0bv98wiygri1u/",
    "sourceUrl": "https://html5.gamemonetize.com/4otjsjz31jgy4a3yr2p0bv98wiygri1u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74572",
    "slug": "goods-triple-match-3d",
    "title": "Goods Triple Match 3D",
    "description": "Begin a super satisfying match 3 puzzle challenge. Goods Triple Match 3D is a colorful and addictive casual logic game where all items appear in beautiful and realistic 3D. Your table is filled with tons of cute 3D drinks.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cute",
      "Food",
      "Match 3",
      "realistic"
    ],
    "thumbnail": "https://img.gamemonetize.com/xhywxdf6g4miazad5puvp5dknu1s0nxs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xhywxdf6g4miazad5puvp5dknu1s0nxs/",
    "sourceUrl": "https://html5.gamemonetize.com/xhywxdf6g4miazad5puvp5dknu1s0nxs/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74553",
    "slug": "poly-rush",
    "title": "Poly Rush",
    "description": "PolyRush is a fast-paced flight game set in a stunning low-poly universe. Pilot your aircraft through challenging obstacles, master the art of the charged jump, and unleash powerful dashes to break through barriers. Collect coins to unlock unique planes and custom trails in the Hangar. Featuring customizable pilots, daily missions, and a global leaderboard. How far can you go?",
    "instructions": "Desktop Space Left Click Jump Hold Space Mouse Charge Jump Fly Higher P Pause Game Swipe Mouse Dash Break Obstacles Mobile Tap Jump Hold Charge Jump Swipe Dash",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D Games",
      "Arcade",
      "Highscore",
      "Platform",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ye45xjgk7ul14kfrjmvtejealw62zzm8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ye45xjgk7ul14kfrjmvtejealw62zzm8/",
    "sourceUrl": "https://html5.gamemonetize.com/ye45xjgk7ul14kfrjmvtejealw62zzm8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73883",
    "slug": "suika-game-2",
    "title": "Suika Game 2",
    "description": "Suika Game 2 is an engaging and meditative puzzle game where your goal is to merge as many identical fruits as possible to create bigger ones. Starting with small cherries, you progress toward the giant watermelon! Choose the perfect moment to drop each fruit to prevent the game field from overflowing above the Danger Limit. Test your strategy and reaction speed as you compete for the highest score. This is the classic fruit merge mechanic powered by a dynamic physics engine, fully adapted for mobile devices and PC. Challenge yourself and beat your own highscore!",
    "instructions": "Mouse Touch Move the aiming reticle translucent fruit left right Click Tap Drop the fruit Keyboard Arrow Keys larr rarr or A D for fine aim adjustment Spacebar Drop the fruit Esc Pause the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Bubble",
      "Clicker",
      "Coloring",
      "Cute",
      "HTML5"
    ],
    "thumbnail": "https://img.gamemonetize.com/utcobvmr6c5qjr8p93yr0ba78l4fewtm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/utcobvmr6c5qjr8p93yr0ba78l4fewtm/",
    "sourceUrl": "https://html5.gamemonetize.com/utcobvmr6c5qjr8p93yr0ba78l4fewtm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74532",
    "slug": "anomaly-content-record",
    "title": "Anomaly Content Record",
    "description": "Welcome to Anomaly Content Record, a terrifying horror adventure where your only goal is to escape and survive. You&rsquo;re a field investigator sent to explore a restricted research facility that went silent overnight.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Escape",
      "Horror",
      "Room",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/af3f43ib3e6hxb8sodugn3c8ijh9kavm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/af3f43ib3e6hxb8sodugn3c8ijh9kavm/",
    "sourceUrl": "https://html5.gamemonetize.com/af3f43ib3e6hxb8sodugn3c8ijh9kavm/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74273",
    "slug": "city-auto-rickshaw-game",
    "title": "City Auto Rickshaw Game",
    "description": "Welcome to the world of the city tuk tuk rickshaw game. Get ready to drive your favorite auto rickshaw in tuk tuk rickshaw driving game, the ultimate rickshaw driving game featuring thrilling pick and drop missions in a beautifully designed open city environment. Choose from 10 unique tuk tuk rickshaws, each with realistic controls and detailed interiors. From city auto rickshaw rides to thrilling tuk tuk games challenges, this sim brings you endless fun with smooth gameplay and detailed 3D graphics. The environments in our tuk tuk simulator game are visually stunning, providing an immersive experience for gamers.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "Driving",
      "Racing",
      "TukTuk"
    ],
    "thumbnail": "https://img.gamemonetize.com/qz5lpk820ga1ganvfby8m9c04y2noado/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qz5lpk820ga1ganvfby8m9c04y2noado/",
    "sourceUrl": "https://html5.gamemonetize.com/qz5lpk820ga1ganvfby8m9c04y2noado/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74533",
    "slug": "dance-on-hotsteps-mobile",
    "title": "Dance On Hotsteps Mobile",
    "description": "Dress up your superstar in beautiful suits and dresses, follow the beats of the music, make perfect dance moves, and surprise the crowd in the dancing show! If you are a dance lover or a makeover master, do not miss this chance to show your creativity and talents in fashion in the best dance games for girls online.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Makeover",
      "Music"
    ],
    "thumbnail": "https://img.gamemonetize.com/a0ibw0qf0g13fu1l2rcxxrx8kkvb2ukn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a0ibw0qf0g13fu1l2rcxxrx8kkvb2ukn/",
    "sourceUrl": "https://html5.gamemonetize.com/a0ibw0qf0g13fu1l2rcxxrx8kkvb2ukn/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "74498",
    "slug": "zig-zag-color",
    "title": "Zig Zag Color",
    "description": "Welcome to Zig Zag Colors fun game! tap the screen to change the direction, Collect the stars and Try not to collide with anything! Challenge your friends at school and try to get the highest score! Enjoy Zig Zag.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [],
    "thumbnail": "https://img.gamemonetize.com/jt5k4vhyfbpke8fdv1dpcivdwm4id0uo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jt5k4vhyfbpke8fdv1dpcivdwm4id0uo/",
    "sourceUrl": "https://html5.gamemonetize.com/jt5k4vhyfbpke8fdv1dpcivdwm4id0uo/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74442",
    "slug": "balloon-buddies-flat-edition",
    "title": "Balloon Buddies    Flat Edition",
    "description": "Balloon Buddies: Flat Edition is a fun, colorful and kids-friendly HTML5 arcade game. Players tap or click on balloons to pop them before they escape the screen. The game starts simple, but balloon speed and frequency increase over time, creating an endless progression challenge. Cute balloon characters appear with different moods such as happy, naughty, angry and laughing, adding fun and variety. The game features a clean flat 2D art style, smooth animations, and bright visuals. It supports both mobile touch and desktop mouse controls and is safe, family-friendly, and suitable for all ages.",
    "instructions": "PC Mouse click to pop balloons Mobile Tap on balloons to pop",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2025 games",
      "amazing",
      "Ballon",
      "Best Games",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/oi2wl66w5hi6xf77dfkfebjx1qn62p78/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oi2wl66w5hi6xf77dfkfebjx1qn62p78/",
    "sourceUrl": "https://html5.gamemonetize.com/oi2wl66w5hi6xf77dfkfebjx1qn62p78/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74522",
    "slug": "virtual-neko-kitty-collector",
    "title": "Virtual Neko Kitty Collector",
    "description": "Welcome to Virtual Neko: Kitty Collector, a casual cat game that you can play for free. Dive into a super cute world with cute kittens. Buy items, feed them, and earn red hearts to upgrade your cats yard. Have fun with endless minigames: dice merge, cat clicker game, fun match, and more. Take care of your pets and play with these cute creatures.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Cute",
      "endless",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/r2blix2t3re3dwey4t51rw60upegcp4d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r2blix2t3re3dwey4t51rw60upegcp4d/",
    "sourceUrl": "https://html5.gamemonetize.com/r2blix2t3re3dwey4t51rw60upegcp4d/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74497",
    "slug": "cash-climb-rush",
    "title": "Cash Climb Rush",
    "description": "Cash Climb Rush is a fast and satisfying click runner where money becomes your power. Collect cash along the track, then tap at the right moment to release and rise higher, crossing obstacles and climbing to new heights.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Click",
      "Levels",
      "Obstacle",
      "running",
      "Stack",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/10w2fm2oj92ercxirn3ugi5eofz47z57/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/10w2fm2oj92ercxirn3ugi5eofz47z57/",
    "sourceUrl": "https://html5.gamemonetize.com/10w2fm2oj92ercxirn3ugi5eofz47z57/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74487",
    "slug": "birds-sort-color-match-puzzle",
    "title": "Birds Sort Color Match Puzzle",
    "description": "Welcome to the gentle world of Bird Sort Color, where the gentle embrace of nature meets the joy of relaxation! Say goodbye to ordinary puzzles and get ready for an exciting experience with lively avian characters and delightful asmr melodies. Bird Sort Color is the perfect blend of fun and relaxation. Birds need to be with their flocks to fly around the world. Bird migration season is coming. Sort bird flocks, let them fly. For all those who love the Bird Sort puzzle game, big news is here with Bird Sort color match new sorting rule, more challenging, more fun. There are many super-hard levels that youve never found in the first Bird Sort.",
    "instructions": "Left mouse click to select the bird and the branches",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Bird",
      "Brain",
      "Casual",
      "Color",
      "Cute",
      "Game",
      "html5 games for your site",
      "Logic",
      "Matching",
      "Puzzle",
      "sort"
    ],
    "thumbnail": "https://img.gamemonetize.com/i7b34e3h3odt7n6qawle56nlyypm0h2r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i7b34e3h3odt7n6qawle56nlyypm0h2r/",
    "sourceUrl": "https://html5.gamemonetize.com/i7b34e3h3odt7n6qawle56nlyypm0h2r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74450",
    "slug": "boss-office-life-simulator",
    "title": "Boss Office Life Simulator",
    "description": "Welcome to our game and your first super cool day as a boss! Sometimes, work life is boring. But in our game, it is not! Because here, you are the only boss. Go to the office and enjoy life! There are multiple levels you can experience. Hire/Fire an employee, throw papers to your colleagues to wake them up, or investigate The company your father built is going bankrupt. As a boss, you have a chance to go back in time to save your company. Manage your office with an iron fist or let your employees slack off without consequence. How you manage your office will determine your companys success.",
    "instructions": "Left mouse click to accept and refuse requests",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Arcade",
      "Best Games",
      "Business",
      "Cartoon Network",
      "Casual",
      "Fun",
      "HTML5",
      "idle",
      "Management",
      "Relaxation",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/931otwnbdhvoa4yojtp3y5g3ypfryfu2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/931otwnbdhvoa4yojtp3y5g3ypfryfu2/",
    "sourceUrl": "https://html5.gamemonetize.com/931otwnbdhvoa4yojtp3y5g3ypfryfu2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74488",
    "slug": "lift-brake-simulator",
    "title": "Lift Brake Simulator",
    "description": "The player takes on the role of a secret agent for an unspecified organization or government. Starting from the rooftop of a 30-story building, the agent must navigate down to the basement while collecting secret documents hidden behind blue doors. To move between floors, the agent utilizes the buildings elevator and escalator systems while avoiding or eliminating enemy agents attempting to stop the mission. Once all documents are secured, the agent can escape to the basement and drive away in a waiting car, completing the level. Fast-paced 2D action gameplay with smooth controls.",
    "instructions": "Tap amp Hold the left mouse button to survive",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Brain",
      "Casual",
      "html games for your website",
      "HTML5",
      "Physics",
      "realistic",
      "Simulation",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/9ztbepa9p5v61akvt935e78cj3iszy72/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9ztbepa9p5v61akvt935e78cj3iszy72/",
    "sourceUrl": "https://html5.gamemonetize.com/9ztbepa9p5v61akvt935e78cj3iszy72/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74494",
    "slug": "arrow-escape-puzzle-game",
    "title": "Arrow Escape Puzzle Game",
    "description": "Arrow Out is a clever arrow puzzle that tests your logic and strategy in every move. Plan each slide carefully, unlock tricky routes, and watch every arrow find its perfect way out. Early stages are calm and simple - but as you progress, each arrow escape becomes more challenging, pushing your logic to new limits.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "arrows",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/e465er9wtcqxeuiaikb122ak32yxs7fh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e465er9wtcqxeuiaikb122ak32yxs7fh/",
    "sourceUrl": "https://html5.gamemonetize.com/e465er9wtcqxeuiaikb122ak32yxs7fh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74514",
    "slug": "word-puzzle-master-game",
    "title": "Word Puzzle Master Game",
    "description": "Play the amazing word game Word Galaxy for 10 min a day to sharpen your mind and boost your energy! Start connecting the letters! Solve word puzzles with stunning backgrounds while improving your vocabulary. Brain puzzle games such as word cross games are wonderful for your brain. Now you can prove your word puzzle skills!",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "amazing",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/67333bivrq0zjb1borizb0k4zs80dv4l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/67333bivrq0zjb1borizb0k4zs80dv4l/",
    "sourceUrl": "https://html5.gamemonetize.com/67333bivrq0zjb1borizb0k4zs80dv4l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74329",
    "slug": "fragments-of-wonder",
    "title": "Fragments of Wonder",
    "description": "Dive into a colorful puzzle adventure! Match three or more tiles to solve clever puzzles, unlock exciting levels, and enjoy a relaxing yet challenging gameplay experience. Easy to learn, hard to master &mdash; perfect for quick breaks or long play sessions.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Jigsaw",
      "Match 3",
      "Match-3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/id9pzqw3x5y5akv44lzvv23gseg63cm9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/id9pzqw3x5y5akv44lzvv23gseg63cm9/",
    "sourceUrl": "https://html5.gamemonetize.com/id9pzqw3x5y5akv44lzvv23gseg63cm9/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74479",
    "slug": "last-z-survival-shooter",
    "title": "Last Z Survival Shooter",
    "description": "Ready for an all-out apocalypse escape? Last Z: Survival Shooter throws you straight into a world overrun by zombies. Zombies attack from every direction. Keep moving, dodge smartly, and never stop running. Shoot the digital doors to gain more helpers or boost your attack speed, etc. Use your strategy to choose which digital door to go through.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "attack",
      "Battle",
      "Shoot",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/xmm7ejt17ncqbkbfjcwtswrfu6rgdbg2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xmm7ejt17ncqbkbfjcwtswrfu6rgdbg2/",
    "sourceUrl": "https://html5.gamemonetize.com/xmm7ejt17ncqbkbfjcwtswrfu6rgdbg2/",
    "width": 1280,
    "height": 760,
    "lastUpdated": ""
  },
  {
    "id": "74485",
    "slug": "christmas-bubble-shooter-game",
    "title": "Christmas Bubble Shooter Game",
    "description": "Welcome to the Christmas Bubble Shooter Game! Get ready for a scary adventure filled with endless bubble-popping fun! Dive into the haunted world of this thrilling offline game, perfect for when you need a break or want to enjoy some Christmas excitement anytime, anywhere! With hundreds of scary levels to conquer, your skills will be put to the test as you pop, match, and blast bubbles in a series of nightmare-inducing Christmas challenges.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Bubble Shooter",
      "Casual",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/aumacmqvzwt6w1r2whz2ukrlhfosxwss/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aumacmqvzwt6w1r2whz2ukrlhfosxwss/",
    "sourceUrl": "https://html5.gamemonetize.com/aumacmqvzwt6w1r2whz2ukrlhfosxwss/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74434",
    "slug": "crazy-three-puzzle",
    "title": "Crazy Three Puzzle",
    "description": "3D Crazy puzzle! Triple Tap Enjoy the ultimate 3D match 3 experience &ndash; Crazy Match Triple Tap! Looking for fun, relaxing, and addictive matching games? Crazy Match brings you a vibrant 3D triple match puzzle that blends offline sorting, organizing, and triple matching into one of the most satisfying match 3 games. Play hundreds of colorful levels designed for fans of offline games, triple tile challenges, and goods sorting mechanics. Whether you&rsquo;re looking for easy, relaxing gameplay or intense, brain teasing levels, Crazy Match has something for every puzzle lover.",
    "instructions": "Tap amp Hold left mouse button",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Arcade",
      "arrow",
      "Brain",
      "Draw",
      "Fun",
      "Online",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/ui0itlim8wbenxdcgc3o00ogl2fndzrs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ui0itlim8wbenxdcgc3o00ogl2fndzrs/",
    "sourceUrl": "https://html5.gamemonetize.com/ui0itlim8wbenxdcgc3o00ogl2fndzrs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74366",
    "slug": "air-fighter-3d",
    "title": "Air Fighter 3D",
    "description": "Climb into the cockpit of your favorite fighter aircraft, get ready to take-off, and soar into the skies brimming with visceral dogfights! Fly solo as a lone wolf or command a fleet of acrobatic aircraft to establish air superiority over the battlefield. Perform dizzying acrobatic maneuvers, get the enemy in your sights, and hit the trigger to shoot them down. Become the supreme lord of the skies in Air Fighters 3D now! Play modern air fighter 3d in the air fighter jet fighter combat game to become sky warriors of fighter jet games with missions 3d offline to fly jet dogfight games of modern warplanes pvp warfare jet fighter planes flying",
    "instructions": "Tap and Hold left mouse button drag to the left right to change position",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "Air",
      "Arcade",
      "Fight",
      "Game",
      "jet",
      "Simulation",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/0jrr2jg4sbbumx8hpoxo8bn3qvwdnjp7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0jrr2jg4sbbumx8hpoxo8bn3qvwdnjp7/",
    "sourceUrl": "https://html5.gamemonetize.com/0jrr2jg4sbbumx8hpoxo8bn3qvwdnjp7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74452",
    "slug": "gun-upgrade-rush",
    "title": "Gun Upgrade Rush",
    "description": "Gun Upgrade Rush is a fast and satisfying swipe runner where you control a gun racing through action-packed levels. Slide left and right to collect upgrade pickups that boost your fire rate, unlock shotgun blasts, and evolve into stronger weapon types as you run.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Bullet",
      "Gun",
      "Hypercasual",
      "Obstacle",
      "running",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/ibdi5nxvuhzxk5ltd72ktnc5clcm7ho8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ibdi5nxvuhzxk5ltd72ktnc5clcm7ho8/",
    "sourceUrl": "https://html5.gamemonetize.com/ibdi5nxvuhzxk5ltd72ktnc5clcm7ho8/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74251",
    "slug": "farm-land-farming-life-game",
    "title": "Farm Land   Farming life game",
    "description": "Farm Land &ndash; Farming Life Game is a relaxing farming simulator where you build your own cozy farm from the ground up. Plant seeds, water your crops, and watch them grow until they&rsquo;re ready to harvest. Sell your fresh produce to earn coins, then use your profits to expand into new land and grow an even bigger farm.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Farm",
      "grow",
      "Island",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/lfqfciu8cezjl1atn5hpycz0l1rnw3p8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lfqfciu8cezjl1atn5hpycz0l1rnw3p8/",
    "sourceUrl": "https://html5.gamemonetize.com/lfqfciu8cezjl1atn5hpycz0l1rnw3p8/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74312",
    "slug": "marnyl-silence-the-haters",
    "title": "MARNYL Silence The Haters",
    "description": "MARNYL - Silence The Haters! Intense top-down music shooter! Play as YBORG and fight endless waves of haters, critics, and failed musicians. GAMEPLAY: - Survive endless enemy waves - Collect XP to level up - 10+ music weapons: Vinyl discs, Microphone, Guitar, Drums, Saxophone, AMP - Epic boss battles FEATURES: - 6 unique maps (Arena, Studio, Festival, Rooftop, Club, Concert Hall) - 30+ enemy types - Dynamic upgrades - Original YBORG music - Mobile controls - 60 FPS ITEMS: Health, XP magnets, Bombs, Freeze Survive the chaos and become the ultimate musician!",
    "instructions": "WASD Arrow keys to move auto-shooting mouse to aim",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Arena",
      "Battle",
      "Best Games",
      "endless",
      "Enemy",
      "Killing",
      "Level",
      "Music",
      "Shooting",
      "survival",
      "Top Down",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/qsvp3xbk2zk4diq7d5v87ri8vl72sd8t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qsvp3xbk2zk4diq7d5v87ri8vl72sd8t/",
    "sourceUrl": "https://html5.gamemonetize.com/qsvp3xbk2zk4diq7d5v87ri8vl72sd8t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74363",
    "slug": "dino-t-rex-3d-run",
    "title": "Dino T Rex 3D Run",
    "description": "Just enjoy the remake of the popular offline and endless game, that you know from the Google Chrome browser in a new 3D dimension! In the Dino T-Rex 3D Run, you can find cool features like: 3D Dino T-Rex 3D obstacles alternating day and night increasing speed black and white mode or color mode 3D or 2D mode playful music funny sounds cool effects during the run simple controls ----- Please note, that the first version of the game was released 12.7.2019 for the other platforms.",
    "instructions": "Up Arrow - jump Down Arrrow - duck or use UI buttons",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Action",
      "Best Games",
      "Classic",
      "dino",
      "Dinosaur",
      "endless",
      "Hypercasual",
      "Jumping",
      "Platform",
      "Retro",
      "running",
      "Skill",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/0uq5hmbx1pi8xx5ivrnkyfphfurxkxlq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0uq5hmbx1pi8xx5ivrnkyfphfurxkxlq/",
    "sourceUrl": "https://html5.gamemonetize.com/0uq5hmbx1pi8xx5ivrnkyfphfurxkxlq/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74420",
    "slug": "word-match-3d",
    "title": "Word Match 3D",
    "description": "Play Word Match 3D online for free! This is an addictive word puzzle game that tests your vocabulary and observation skills. In this 3D brain teaser, your goal is to find specific 3D letters hidden in a messy pile to complete the target word. You must be fast to clear the level before the time runs out! Features: Word Matching: Search and collect letters to spell words. Shuffle Booster: Stuck? Use the Shuffle button to mix up the pile and reveal hidden letters. Brain Training: Improve your focus and spelling speed in a fun 3D world.",
    "instructions": "Use the mouse to interact - Left Click Select and collect 3D letters - Shuffle Button Click to rearrange the items if you get stuck",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Brain",
      "Educational",
      "Letters",
      "Logic",
      "Management",
      "Matching",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/m27uyguq2k1men8en9f2hckdoytglv9g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m27uyguq2k1men8en9f2hckdoytglv9g/",
    "sourceUrl": "https://html5.gamemonetize.com/m27uyguq2k1men8en9f2hckdoytglv9g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74446",
    "slug": "stair-ball-hyper-casual",
    "title": "Stair Ball: Hyper Casual",
    "description": "Step into endless fun and test your reflexes with Stair Ball: Hyper Casual! Conquer 75 exciting levels, each step getting tougher and requiring more focus Unlock 28 mysterious achievements, discover surprises, and boost your gameplay! Gain the upper hand with 3 powerful upgrades: Coin Gain, Starting Time, and Starting Heart",
    "instructions": "The ball moves quickly left and right on its own harr and your only job is to tap to make it jump Each tap takes the ball one step higher but beware mdash hitting red spikes will cost you hearts Race against time collect as many coins as possi",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Ball",
      "jump",
      "Jumping",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/tgj2thd219rytx6czy5jr411hfiy6j34/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tgj2thd219rytx6czy5jr411hfiy6j34/",
    "sourceUrl": "https://html5.gamemonetize.com/tgj2thd219rytx6czy5jr411hfiy6j34/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74441",
    "slug": "k-pop-demon-hunters-nail-studio",
    "title": "K Pop Demon Hunters Nail Studio",
    "description": "You run a nail salon that employs real K-pop idols &mdash; they make perfect nails during the day and fight demons at night. Create fashionable designs, choose colors, decorations and effects to enhance the powers of the hunters and defeat the darkness.",
    "instructions": "Desktop Mouse Click Choose nail Color Drag Mouse Paint nails Click Apply design Mobile Tap Choose nail Color Swipe Paint nails Tap Apply design Hint Create stylish manicures to power up K-Pop hunters and defeat demons Unlock new designs",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Fashion"
    ],
    "thumbnail": "https://img.gamemonetize.com/qx1i9urbjg9rcbcjm4b18lurjnvc2gx7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qx1i9urbjg9rcbcjm4b18lurjnvc2gx7/",
    "sourceUrl": "https://html5.gamemonetize.com/qx1i9urbjg9rcbcjm4b18lurjnvc2gx7/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "74483",
    "slug": "wood-block-brain-puzzle",
    "title": "Wood Block Brain Puzzle",
    "description": "Wood Block Brain Puzzle Looking for a fun and addictive puzzle game that will keep you entertained for hours on end? Look no further than Wood Block Brain Games, the ultimate wood block game for you! With its simple and intuitive gameplay, Wood Block is perfect for puzzle lovers of all ages and skill levels. Simply drag and drop the wooden blocks to fill up the board and complete each level. With increasing levels of difficulty, youll never run out of challenges to tackle! Join millions of players who love Block Puzzle Wood Blast, the addictive puzzle game that sharpens your mind and relieves stress. Play anytime.",
    "instructions": "Mouse Operated - Press amp Hold left mouse button to pick and place blocks",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Best Games",
      "Block",
      "Brain",
      "Classic",
      "free games for your site",
      "Logic",
      "mineblock",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/9o7pp1cj2kgu8onu66xjp545xpywi2ze/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9o7pp1cj2kgu8onu66xjp545xpywi2ze/",
    "sourceUrl": "https://html5.gamemonetize.com/9o7pp1cj2kgu8onu66xjp545xpywi2ze/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74257",
    "slug": "nut-bolt-puzzle-game",
    "title": "Nut Bolt Puzzle Game",
    "description": "Become a pro at unscrewing nuts and bolts while enjoying the exciting journey ahead. Embark on an exhilarating adventure where bolts, nuts, and wooden puzzles intertwine to create a mind-boggling challenge. Plunge into a world teeming with enigmas, where each move uncovers a new twist in the game. Wood Screw, Nuts &amp; Bolts Puzzle game, a place where the intrigue of screw puzzles and the excitement of fastening elements merge! Test your puzzle-solving abilities and advance to expert levels as you navigate through this attractive adventure.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qf25ickz6rnca426qr18uwsneubpx6rj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qf25ickz6rnca426qr18uwsneubpx6rj/",
    "sourceUrl": "https://html5.gamemonetize.com/qf25ickz6rnca426qr18uwsneubpx6rj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74260",
    "slug": "rolling-color-ball-game",
    "title": "Rolling Color Ball Game",
    "description": "Welcome to the world of color match games. Get ready for a thrilling and addictive arcade experience with color match! Guide your ball through a colorful 3D world filled with obstacles and surprises. Your only rule? Dont touch the wrong colors! Get ready to journey down an exhilarating track as a vibrant little ball, always pushing forward, always ready for the next big thrill. The gameplay is simple but hard to master. Just one simple rule, dont touch the other colors in the match game.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/gbsfn2uts49a1j53nfqqrikznu08oaek/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gbsfn2uts49a1j53nfqqrikznu08oaek/",
    "sourceUrl": "https://html5.gamemonetize.com/gbsfn2uts49a1j53nfqqrikznu08oaek/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73361",
    "slug": "farm-house-crash-match-game",
    "title": "Farm House Crash Match Game",
    "description": "Welcome to Farm House Crash &amp; Match! The most addictive puzzle adventure on the farm! Swap and match cute fruits and veggies to complete fun levels. Solve challenging puzzles, unlock boosters, and help friendly animals rebuild their dream farm. Enjoy vibrant graphics and brain-teasing fun for all ages. Download now!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Farm",
      "Match 3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/2mlw18zjwhj5gk57wjhmz7bgwpe5h7db/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2mlw18zjwhj5gk57wjhmz7bgwpe5h7db/",
    "sourceUrl": "https://html5.gamemonetize.com/2mlw18zjwhj5gk57wjhmz7bgwpe5h7db/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74207",
    "slug": "survive-the-night",
    "title": "Survive The Night",
    "description": "Are you ready for the most terrifying night of your life? Survive The Night is an intense horror survival game where you&rsquo;re trapped in a dark, creepy room with something lurking in the shadows. Choose between Normal Mode or Horror Mode to challenge yourself. In Normal Mode, youll receive more hints, fewer rooms, and standard monsters.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Escape",
      "Horror",
      "Room",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/2pjzp1topm9l3t6teqmnk2ym27iporsp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2pjzp1topm9l3t6teqmnk2ym27iporsp/",
    "sourceUrl": "https://html5.gamemonetize.com/2pjzp1topm9l3t6teqmnk2ym27iporsp/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74347",
    "slug": "brainrot-bridge-race-3d",
    "title": "Brainrot Bridge Race 3D",
    "description": "This is not just a simple running and racing game. It&rsquo;s a brainrot-style 3D battle where speed and strategy collide! Your goal is to collect as many bananas as possible while sprinting through hilarious obstacle courses. Collect more bananas to evolve your form.",
    "instructions": "Mouse click or tap to play",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "Battle",
      "Brainrot",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/e27ezlhh5edki5wv0aad96d8w3g1l1bf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e27ezlhh5edki5wv0aad96d8w3g1l1bf/",
    "sourceUrl": "https://html5.gamemonetize.com/e27ezlhh5edki5wv0aad96d8w3g1l1bf/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73909",
    "slug": "moto-bike-extreme-hill-stunts",
    "title": "Moto Bike Extreme Hill Stunts",
    "description": "Get ready for a heart-pounding motocross adventure in Stunt Bike Extreme &ndash; the ultimate physics-based bike racing game! Ride powerful stunt bikes through insane obstacle courses, master tricky terrain, and perform jaw-dropping flips, jumps, and tricks. Skill-Based Racing: Precision and timing matter! Only the best riders will conquer all stages. Extreme Tracks: Race across mountains, factories, and floating platforms. Insane Stunts: Defy gravity with backflips, air time, and near-impossible landings.",
    "instructions": "Right Arrow Drive Left Arrow Break Front Flip Up Arrow Back Flip Down Arrow 360 Jump Space bar",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Best Games",
      "Bike",
      "Driving",
      "hills",
      "jump",
      "Race",
      "Simulation",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/obew7eabe9gst3mfz3uoj444bqaa6o0x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/obew7eabe9gst3mfz3uoj444bqaa6o0x/",
    "sourceUrl": "https://html5.gamemonetize.com/obew7eabe9gst3mfz3uoj444bqaa6o0x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74351",
    "slug": "capybara-mukbang-asmr",
    "title": "Capybara Mukbang ASMR",
    "description": "Dive into a delicious world where you cook hamburger, pizza, and ice cream recipes. Dress up and taste your dishes one by one. Share your food with the audience by eating and drinking in the Mukbang livestream, and see how many likes you can receive.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cook",
      "Dress Up",
      "Food",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/8iaa1egaoj6mkjmjcvam9klnuqr9g8bt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8iaa1egaoj6mkjmjcvam9klnuqr9g8bt/",
    "sourceUrl": "https://html5.gamemonetize.com/8iaa1egaoj6mkjmjcvam9klnuqr9g8bt/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74162",
    "slug": "santa-claus-xmas-run",
    "title": "Santa Claus Xmas Run",
    "description": "Santa Claus Xmas Run is a fun and free online game for kids! Help Santa collect as many gifts as possible while staying on the rolling snowball. Be careful&mdash;don&rsquo;t touch the top or bottom lines! Enjoy the festive challenge and have fun!",
    "instructions": "WAD or arrow keys to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Avoid",
      "Christmas",
      "Collecting",
      "html5 games",
      "jump",
      "Platform",
      "Santa",
      "Santa Claus",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/88vl3rdrsq1lrzhnq33q3ck9dngyg4el/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/88vl3rdrsq1lrzhnq33q3ck9dngyg4el/",
    "sourceUrl": "https://html5.gamemonetize.com/88vl3rdrsq1lrzhnq33q3ck9dngyg4el/",
    "width": 8480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "74111",
    "slug": "mathmates-3d-brain-quest",
    "title": "MathMates 3D: Brain Quest",
    "description": "A fun 3D math adventure! Choose your skill level, solve smart puzzles, and play with animated number characters. With smooth animations, clean visuals, and satisfying interactions, MathMates 3D: Brain Quest turns brain training into a playful experience for all ages.",
    "instructions": "Mouse click and for answer keyboard and tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Best Games",
      "Brain",
      "Educational",
      "Kids",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/an1qn67onw104whrxlc1tro20zajqytj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/an1qn67onw104whrxlc1tro20zajqytj/",
    "sourceUrl": "https://html5.gamemonetize.com/an1qn67onw104whrxlc1tro20zajqytj/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74233",
    "slug": "axe-champ-simulator",
    "title": "Axe Champ Simulator",
    "description": "Axe Champ is a fast-paced arcade game where timing is everything. Throw your axe with precision, hit the targets, and prove you have what it takes to become the ultimate axe champion",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "attack",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/uvr40dbo9klj89pnj133jy6jnfnevm91/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uvr40dbo9klj89pnj133jy6jnfnevm91/",
    "sourceUrl": "https://html5.gamemonetize.com/uvr40dbo9klj89pnj133jy6jnfnevm91/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "74313",
    "slug": "color-box-ship",
    "title": "Color Box Ship",
    "description": "Welcome to Color Box Ship! Catch the colorful boxes before they hit the water! A simple yet addictive arcade-style game awaits you. The goal is simple: Box touches water = Game over! Trust your reflexes, collect points, and unlock upgrades! Use your score to enhance your ship: Earnings Boost &ndash; Get more points per box! New Colors &ndash; Unlock vibrant box types! Ship Health &ndash; Survive small mistakes! Box Gravity &ndash; Slow down their fall! With colorful visuals, easy controls, and fun gameplay for all ages! Available in 7 languages: Captain, get ready to set sail and start collecting!",
    "instructions": "Move your mouse left and right to control the ship Catch the falling boxes If a box touches the water Game over How long can you survive Earn points unlock upgrades and improve your reflexes",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Color",
      "Coloring",
      "Fun",
      "Funny",
      "ship"
    ],
    "thumbnail": "https://img.gamemonetize.com/fj1qbt440zwgptaddzu0yyenn68o1tti/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fj1qbt440zwgptaddzu0yyenn68o1tti/",
    "sourceUrl": "https://html5.gamemonetize.com/fj1qbt440zwgptaddzu0yyenn68o1tti/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73855",
    "slug": "paper-dolls-diy-diary",
    "title": "Paper Dolls DIY Diary",
    "description": "Welcome to Paper Dolls DIY Diary, a casual girl makeover game that you can play for free. Choose your paper doll avatar, open the wardrobe book, and slide to explore a variety of clothing, makeup, hairstyles, and accessories.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/0qh5mn3joqd4wzlq09bak2qjvphob3c1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0qh5mn3joqd4wzlq09bak2qjvphob3c1/",
    "sourceUrl": "https://html5.gamemonetize.com/0qh5mn3joqd4wzlq09bak2qjvphob3c1/",
    "width": 1600,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74370",
    "slug": "tuntun-sahur-super-runner-game",
    "title": "TunTun Sahur: Super Runner Game",
    "description": "TunTun Sahur: Super Runner Game &ndash; Ready to have fun running with TunTun Sahur? In this hyper-casual runner, race down an endless highway &zwj; with a single goal: reach the finish line alive! Endless Random Challenges Police &zwj; and cash appear completely at random every run. No two levels are ever the same&mdash;every step brings a new surprise! Powerful Upgrades Collect coins to enhance three core upgrades: Coin Earnings, Starting Health Points, and the +Health Multiplier Gate. Become stronger and faster with every run!",
    "instructions": "Survive to Reach the Finish Line If your health drops below 1 0 it rsquo s game over Dodge enemy attacks or take them out by colliding when necessary and make it to the finish line in one piece",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ru184msxoyuxepcbwbgl62wo0un74jqd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ru184msxoyuxepcbwbgl62wo0un74jqd/",
    "sourceUrl": "https://html5.gamemonetize.com/ru184msxoyuxepcbwbgl62wo0un74jqd/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74354",
    "slug": "black-hole-io-3d-game",
    "title": "Black Hole io 3D Game",
    "description": "Black Hole io 3D Game - Swallow Everything &amp; Dominate the City! Enter the ultimate black hole battle and compete to become the biggest hole in town! Move your hungry black hole, swallow buildings, cars, and even opponents to grow bigger before time runs out. The more you absorb, the stronger you become. Can you outsize the competition and take over the arena? This immersive, addictive mobile gaming experience places you in the role of the Hoard Master, controlling a powerful black hole capable of swallowing whole cities. As the Hole Master, you are tasked with a battle against the clock.",
    "instructions": "Tap and hold left mouse button Hold the left mouse button and drag to collect items",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Brain",
      "Candy",
      "Casual",
      "Color",
      "Games",
      "Jelly",
      "Kids",
      "Match 3",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/4wnjcp7cea8z1qza1cyw6aj2nmp90q9c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4wnjcp7cea8z1qza1cyw6aj2nmp90q9c/",
    "sourceUrl": "https://html5.gamemonetize.com/4wnjcp7cea8z1qza1cyw6aj2nmp90q9c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74334",
    "slug": "ambulance-rescue-hospital-game",
    "title": "Ambulance Rescue Hospital Game",
    "description": "Start your career as an rescue ambulance simulator driver, cars rescue and doing a wonderful job to rescue them to the hospitals un this emergency simulator. You might have played many rescue helicopter ambulance 3d, emergency racing, ambulance games before but this heli ambulance rescue 911 Emergency rescue ambulance game is best from all the previous emergency ambulance simulator 2024: ambulance games 3d due to its smooth controls. The best thing in this emergency rescue ambulance driving simulator is its environment so you have an opportunity to drive the city rescue in city ambulance games simulator:",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "ambulance",
      "carparking",
      "Driving",
      "Parking"
    ],
    "thumbnail": "https://img.gamemonetize.com/ye7mb9a2adqnli65z3i06h2gikcaaru7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ye7mb9a2adqnli65z3i06h2gikcaaru7/",
    "sourceUrl": "https://html5.gamemonetize.com/ye7mb9a2adqnli65z3i06h2gikcaaru7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73569",
    "slug": "sniper-shooting-offline-games",
    "title": "Sniper Shooting Offline Games",
    "description": "Get ready to unleash the ultimate sniper 3d experience with the most thrilling and action-packed shooting game of all time! Sniper 3d is the definitive free-to-play gun game that puts you in the shoes of a deadly assassin. Immerse yourself in high-intensity offline missions and show off your shooting skills in this adrenaline-pumping sniper adventure. Are you the ultimate shooter? Prove it in Sniper 3d!",
    "instructions": "Left Click Shoot Mouse Wheel Zoom in or zoom out Right Click Toggle zoom",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "amazing",
      "Enemy",
      "Game",
      "Shooter",
      "Shooting",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/ndmuxgujjnz4m51i9ylggukct53rhd8q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ndmuxgujjnz4m51i9ylggukct53rhd8q/",
    "sourceUrl": "https://html5.gamemonetize.com/ndmuxgujjnz4m51i9ylggukct53rhd8q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74308",
    "slug": "mission-santa-deliver-the-gifts",
    "title": "Mission Santa: Deliver the Gifts",
    "description": "Santa must deliver gifts to children in time! There are many kids and only one Santa, so everything has to be done on the fly! Fly in a sleigh on Christmas night and throw gifts down chimneys to make children happy. The game helps you feel the atmosphere of the approaching holiday and prepare for the most magical time of the year!",
    "instructions": "PC Press the Left Mouse Button or Spacebar to drop a gift Mobile phone tablet touch controls Tap anywhere on the screen to drop a gift Hit the chimneys The harder it is to land a gift in a chimney the more points you earn Set new records and un",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Casual",
      "Christmas",
      "Classic",
      "endless",
      "Flight",
      "Hypercasual",
      "Mobile",
      "Santa",
      "Santa Claus",
      "unity"
    ],
    "thumbnail": "https://img.gamemonetize.com/o055ppwfelpahjhwjjpbnvncc7l5j2g0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o055ppwfelpahjhwjjpbnvncc7l5j2g0/",
    "sourceUrl": "https://html5.gamemonetize.com/o055ppwfelpahjhwjjpbnvncc7l5j2g0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74288",
    "slug": "cosmos-404",
    "title": "COSMOS 404",
    "description": "Explore the galaxy in Cosmos 404! Run across procedurally generated tiny planets, collect coins, and dodge hostile aliens. Use power-ups like Speed Boost and Magnet to survive longer. How far can you go in this addictive low-poly space adventure?",
    "instructions": "Desktop Use Arrow Keys WASD or Mouse to move Mobile Use the on-screen Joystick to run",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual",
      "Collecting",
      "Hypercasual",
      "running",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/il8hi4r9ts9l9r8qu29kg3bz2zprd2vu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/il8hi4r9ts9l9r8qu29kg3bz2zprd2vu/",
    "sourceUrl": "https://html5.gamemonetize.com/il8hi4r9ts9l9r8qu29kg3bz2zprd2vu/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74232",
    "slug": "urban-sniper-2",
    "title": "Urban Sniper 2",
    "description": "Urban Sniper 2 is an intense first person sniper game where you step into the role of an elite marksman whose mission is to liberate Vice City from invading enemy soldiers. The city is under threat, streets are filled with hostile forces, and only your precision, patience, and deadly accuracy can restore peace. Carefully scout rooftops, balconies, and hidden corners to locate targets, eliminate dangerous enemies, and complete a wide range of tactical missions across the city.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "CSGO",
      "First Person Shooter",
      "Gun",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Sniper",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/nkiklh747mm8bjel7kfxh0eazcy2ka41/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nkiklh747mm8bjel7kfxh0eazcy2ka41/",
    "sourceUrl": "https://html5.gamemonetize.com/nkiklh747mm8bjel7kfxh0eazcy2ka41/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72164",
    "slug": "arcanoid-side-guns",
    "title": "Arcanoid Side Guns",
    "description": "Blast your way through the galaxy! Pilot your ship in this explosive Arcanoid-style game, but this time, youre armed. Destroy the overhead brick barriers with precise ball bounces and unleash your side guns to obliterate enemy spaceships and grab power-ups. Web Dev <a href='https://www.crazygames.org.es/'>https://www.crazygames.org.es/</a> Can you clear the screen and survive the cosmic onslaught?",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Ai Games",
      "Arcade",
      "Arkanoid",
      "Gun",
      "HTML5",
      "Mentolatux"
    ],
    "thumbnail": "https://img.gamemonetize.com/ocq7vi913jlqifdczchb81cybsvhnqph/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ocq7vi913jlqifdczchb81cybsvhnqph/",
    "sourceUrl": "https://html5.gamemonetize.com/ocq7vi913jlqifdczchb81cybsvhnqph/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74314",
    "slug": "fashion-battle-queen",
    "title": "Fashion Battle Queen",
    "description": "Fashion Battle Queen is a stylish swipe runner where your choices decide who becomes the beauty champion. Guide your girl through colorful runways and pick the best outfit at every crossroads&mdash;dress, hairstyle, accessories, and more. One wrong turn can ruin the look, but perfect choices create a stunning combo.",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Battle",
      "beauty",
      "Casual",
      "Dress Up",
      "Fashion",
      "Girl",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/l1maz5r36o17yfhyvl7ffbdvm85k5b4d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l1maz5r36o17yfhyvl7ffbdvm85k5b4d/",
    "sourceUrl": "https://html5.gamemonetize.com/l1maz5r36o17yfhyvl7ffbdvm85k5b4d/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74335",
    "slug": "runner-tomato-hyper-casual",
    "title": "Runner Tomato: Hyper Casual",
    "description": "Runner Tomato: Hyper Casual &ndash; Are you ready to have fun running with a tomato? In this hyper-casual runner game, dash along an endless highway with a single goal &zwj;: reach the finish line alive! Endless Random Challenges Knives and cash appear completely at random in every run. No two levels are ever the same &mdash; every step brings a brand-new surprise!",
    "instructions": "Runner Tomato Hyper Casual ndash The Ultimate Running Game Sprint on a single straight track zwj At every level knives and coins appear completely at random mdash no memorization needed every run is a brand-new challenge Survive to Reach the F",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "Adventure",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/w1anzed55xbbm11n1fdkrc8j1rb9qp4n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w1anzed55xbbm11n1fdkrc8j1rb9qp4n/",
    "sourceUrl": "https://html5.gamemonetize.com/w1anzed55xbbm11n1fdkrc8j1rb9qp4n/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74164",
    "slug": "christmas-girls-dress-up",
    "title": "Christmas Girls Dress Up",
    "description": "Celebrate the holidays in Christmas Girls Dress Up, a festive fashion game where you style four friends for a magical Christmas celebration! Each girl has a unique theme: gingerbread cutie, Nutcracker elegance, Santa sweetheart, and Grinch-inspired glam. Mix and match tops, dresses, hairstyles, shoes, and accessories to create cozy, cheerful outfits. Create unique Christmas outfits for our girls, express your creativity, and enjoy the ultimate Christmas dress-up fun filled with sparkle, style, and holiday vibes!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Christmas",
      "Dress Up",
      "Fashion",
      "Girl"
    ],
    "thumbnail": "https://img.gamemonetize.com/caf2pcmqktbsq5pko8z361puirtynic5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/caf2pcmqktbsq5pko8z361puirtynic5/",
    "sourceUrl": "https://html5.gamemonetize.com/caf2pcmqktbsq5pko8z361puirtynic5/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "74350",
    "slug": "fashion-stylist-salon-makeover",
    "title": "Fashion Stylist Salon Makeover",
    "description": "Do you want to create your own fashion styles? Join our best hair salon simulator game and enjoy the utmost fun. You will act as a fashion stylist who does haircuts, hairstyling, and skin care. Welcome customers with different requirements and use your hairstyling skills to make them satisfied and happy!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fashion",
      "Fun",
      "Makeover",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/6xk3hmal6tg86n9uw4rd1le61uht4gzn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6xk3hmal6tg86n9uw4rd1le61uht4gzn/",
    "sourceUrl": "https://html5.gamemonetize.com/6xk3hmal6tg86n9uw4rd1le61uht4gzn/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74352",
    "slug": "kpop-studio-music-beats",
    "title": "Kpop Studio Music Beats",
    "description": "Are you a music lover? Do you want to unlock a new mode of Sprunki Music Beats game? Do not hesitate to join our best Sprunki music game on Kpop themes. Choose your favorite style and click to start! Play music, create melodies, and interact with Kpop Sprunki characters.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fun",
      "Kids",
      "Music",
      "Rhythm"
    ],
    "thumbnail": "https://img.gamemonetize.com/x3n9xerobkb4hcsn16vo54vzf3mhunpk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x3n9xerobkb4hcsn16vo54vzf3mhunpk/",
    "sourceUrl": "https://html5.gamemonetize.com/x3n9xerobkb4hcsn16vo54vzf3mhunpk/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74367",
    "slug": "labubu-memory-challenge",
    "title": "Labubu Memory Challenge",
    "description": "The Labubu Memory Challenge is a fun and engaging game designed to test and improve your memory skills. It&rsquo;s simple to learn but becomes progressively challenging as the levels advance, making it a great exercise for both children and adults.",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Kids",
      "Labubu",
      "Memory",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/ujddtcm8dnx4ry5qvtwqntf89kfzfi4i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ujddtcm8dnx4ry5qvtwqntf89kfzfi4i/",
    "sourceUrl": "https://html5.gamemonetize.com/ujddtcm8dnx4ry5qvtwqntf89kfzfi4i/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "73564",
    "slug": "chill-waves-mini-games",
    "title": "Chill Waves Mini Games",
    "description": "Do you want to play some relaxing games? We are offering the best anxiety relief games in this application to help you get calm and achieve mindfulness! There are many satisfying games included in this app. Examples include mucus simulators, hydraulic presses, firearms simulators, X-ray simulators, and so on. Open the anti-stress app when youre bored and choose one of dozens of toys to play with!",
    "instructions": "Left Mouse Click",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "amazing",
      "Arcade",
      "Brain",
      "Brainrot",
      "Relaxation",
      "Super",
      "surprize"
    ],
    "thumbnail": "https://img.gamemonetize.com/zw602ze7mimrlu4y6ok48uhh297971zn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zw602ze7mimrlu4y6ok48uhh297971zn/",
    "sourceUrl": "https://html5.gamemonetize.com/zw602ze7mimrlu4y6ok48uhh297971zn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73743",
    "slug": "connect-dots-puzzle-game",
    "title": "Connect Dots Puzzle Game",
    "description": "Embark on a captivating journey of mind-bending puzzles with Connect Dots! Engage your strategic thinking and visual perception as you navigate through a multitude of challenging levels. In this addictive and immersive puzzle game, your objective is simple yet deceptively challenging: connect the dots to complete intricate patterns and shapes. With each level presenting a unique arrangement of dots and obstacles, youll need to employ clever tactics and foresight to conquer the increasingly complex challenges.",
    "instructions": "Left Mouse Click",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "amazing",
      "Brain",
      "Brainrot",
      "Fun",
      "Game",
      "Puzzle",
      "puzzleblock",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/sdzab1fve8n864qjvyt8uilelg4heyd6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sdzab1fve8n864qjvyt8uilelg4heyd6/",
    "sourceUrl": "https://html5.gamemonetize.com/sdzab1fve8n864qjvyt8uilelg4heyd6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74268",
    "slug": "ear-doctor-care-game",
    "title": "Ear Doctor Care Game",
    "description": "Ear doctor game is a simulation game to treat ear in the emergency doctor room. Ear Doctor Game to treat all sorts of wounds and have tons of fun playing hospital games! Use modern medical tools as a professional surgeon in a doctor game. Doctor games are the best way to start practicing if you&rsquo;re dreaming of becoming a surgeon and save lives when you grow up! Use foot surgery medical tools as a professional doctor in a hospital game.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Doctor",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/n3i3rbf2wsitkfibi62vhntgc9rm73r9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n3i3rbf2wsitkfibi62vhntgc9rm73r9/",
    "sourceUrl": "https://html5.gamemonetize.com/n3i3rbf2wsitkfibi62vhntgc9rm73r9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74085",
    "slug": "cosmic-glider",
    "title": "Cosmic Glider",
    "description": "Strap into the cockpit of advanced starships in this high-velocity infinite runner. In Cosmic Glider, you pilot a sleek spacecraft through a treacherous neon tunnel of geometric gates at breakneck speeds. The universe accelerates around you&mdash;how long can you survive the void?",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Arcade",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/1ordv729xxzwe1slwg6mfglcxqvpdv0s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1ordv729xxzwe1slwg6mfglcxqvpdv0s/",
    "sourceUrl": "https://html5.gamemonetize.com/1ordv729xxzwe1slwg6mfglcxqvpdv0s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74217",
    "slug": "slash-blitz-master",
    "title": "Slash Blitz Master",
    "description": "A hyper-addictive casual action game: Grab your blade, aim, and slash wacky rubber foes! Dodge their weapons, fling your knife to take them down, and unlock deadlier blades. Race through vibrant stages&mdash;tropical beaches, crate docks&mdash;with a looming helicopter (reward or threat?). Level up to become the Slash Master: collect upgrades, crush tough enemies, and savor one-hit thrills. Simple taps, nonstop chaos, quick, satisfying fun. Can you blitz every wave and claim the title?",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "attack",
      "Battlegrounds",
      "Casual",
      "Launch"
    ],
    "thumbnail": "https://img.gamemonetize.com/n0sqg09g8in6vjz54cdnkm05r5qar47o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n0sqg09g8in6vjz54cdnkm05r5qar47o/",
    "sourceUrl": "https://html5.gamemonetize.com/n0sqg09g8in6vjz54cdnkm05r5qar47o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74208",
    "slug": "connect-hero",
    "title": "Connect Hero",
    "description": "Connect Hero is a fun puzzle game where you control a cannon to shoot bullets and push superhero symbol gems back to their correct positions. Each level is an interesting challenge that requires you to aim carefully, calculate the force, and cleverly utilize the terrain. Just one wrong shot can cause the gems to deviate from their trajectory. With simple yet challenging gameplay, Connect Hero offers a light and highly engaging entertainment experience!",
    "instructions": "Use mouse to plays",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Puzzle",
      "Shoot",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/eub830b0mgebekb5aidmy5rvpc2crurz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eub830b0mgebekb5aidmy5rvpc2crurz/",
    "sourceUrl": "https://html5.gamemonetize.com/eub830b0mgebekb5aidmy5rvpc2crurz/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74165",
    "slug": "drive-pro-3d",
    "title": "Drive Pro 3D",
    "description": "Drive Pro 3D is a simple but intense one-touch driving game about perfect timing and clean dodges. Press and hold to accelerate your car, release to brake instantly. Weave through traffic, swing past obstacles, and thread the needle between moving hazards to reach the finish line. Every completed level rewards you with coins, which you can spend in the car shop to unlock new vehicles with different looks and vibes.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Car",
      "Hypercasual",
      "Obstacle",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/jqwz9v6dty5x1y6ug4cpb7xyjoimawu8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jqwz9v6dty5x1y6ug4cpb7xyjoimawu8/",
    "sourceUrl": "https://html5.gamemonetize.com/jqwz9v6dty5x1y6ug4cpb7xyjoimawu8/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "74125",
    "slug": "blocky-zombie-shooting",
    "title": "Blocky Zombie Shooting",
    "description": "Blocky Zombie Shooting drops you into a voxel warzone where waves of undead swarm every lane. Grab quirky guns, craft quick barricades, and kite hordes through tight corners to survive. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a> Upgrade ammo, unlock skins, and chase headshot combos in arcade or survival modes. Fast runs, crunchy sound, and satisfying ragdolls make each round dangerously replayable. Aim sharp, reload faster.",
    "instructions": "wasd - to walk and drive mouse - look around aim shootin",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Driving",
      "Mentolatux",
      "Racing",
      "Shooting",
      "vehicle",
      "WebGL",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/10ldsmty6x2gwdw3kgxpjbfqoxshqupm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/10ldsmty6x2gwdw3kgxpjbfqoxshqupm/",
    "sourceUrl": "https://html5.gamemonetize.com/10ldsmty6x2gwdw3kgxpjbfqoxshqupm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73940",
    "slug": "castle-island-clicker-game",
    "title": "Castle Island Clicker Game",
    "description": "Fling dice and generate woodcutters based on the results! Chop wood and be the first to complete your cannon. Shoot the enemys tower to win the game!",
    "instructions": "- To click any button use mouse",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Castle",
      "Number",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/08zz54721tnmudem371f33fvgc17w6e0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/08zz54721tnmudem371f33fvgc17w6e0/",
    "sourceUrl": "https://html5.gamemonetize.com/08zz54721tnmudem371f33fvgc17w6e0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73323",
    "slug": "master-archer-2025",
    "title": "Master Archer 2025",
    "description": "Master Archer 2025 is a fast-paced archery game that tests precision, timing, and focus. Aim carefully, release at the perfect moment, and hit challenging targets across dynamic levels. Improve your skills, master powerful bows, and prove you have what it takes to become a true master archer. Web Dev <a href='https://www.freecrazygames.io/'>https://www.freecrazygames.io/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "arrows",
      "Enemies"
    ],
    "thumbnail": "https://img.gamemonetize.com/69b1fcb4p2ce5ty7aaoexe1yfm7wte2t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/69b1fcb4p2ce5ty7aaoexe1yfm7wte2t/",
    "sourceUrl": "https://html5.gamemonetize.com/69b1fcb4p2ce5ty7aaoexe1yfm7wte2t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74178",
    "slug": "escape-from-dictatorship-runner-game",
    "title": "Escape from Dictatorship: Runner Game",
    "description": "Escape from Dictatorship: Runner Game: Are you ready for a life-or-death sprint to freedom? In this hyper-casual runner, you&rsquo;ll race down an endless crimson highway &zwj; with just one goal&mdash;reach the finish line alive! Endless Random Challenges: Soldiers and red coins appear in completely random patterns every round. No two levels are ever the same&mdash;each step brings a fresh surprise! Powerful Upgrades: Collect red coins to boost three core upgrades&mdash;Red Coin Earnings, Starting Health Points, and the +Health Multiplier Gate&mdash;so every run gets stronger and faster!",
    "instructions": "Linear Path to Freedom Sprint along a single straight route zwj But in every level the soldiers and coins on the road spawn completely at random mdash no memorization every run is a brand-new challenge Reach the Finish Alive If your health drops",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "Escape",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/nbh1x1rbv0baw88ta8gxc3m7q4azmpjt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nbh1x1rbv0baw88ta8gxc3m7q4azmpjt/",
    "sourceUrl": "https://html5.gamemonetize.com/nbh1x1rbv0baw88ta8gxc3m7q4azmpjt/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74140",
    "slug": "scratch-to-win-game",
    "title": "Scratch To Win Game",
    "description": "Scratch To Win is a fun and exciting app designed to give users an entertaining scratch card experience on their device. This app brings the thrill of scratching cards and revealing surprises in a simple, colorful, and easy-to-use format. Just scratch the card, reveal the hidden symbols, and enjoy the excitement every time you play.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/2gdn0qw5g7sar6shz0nsnvfh0ack7i8l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2gdn0qw5g7sar6shz0nsnvfh0ack7i8l/",
    "sourceUrl": "https://html5.gamemonetize.com/2gdn0qw5g7sar6shz0nsnvfh0ack7i8l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74157",
    "slug": "annoying-uncle-punch-the-meme",
    "title": "Annoying Uncle   Punch the Meme",
    "description": "Annoying Uncle Punch The Meme Game Get ready for a fun and chaotic meme-style experience! Annoying uncles pop up from different sides, and your job is to punch them before they irritate you with their silly expressions. React fast, score high, and enjoy the simple, funny, and addictive gameplay. The game includes a settings option to manage sound, a level selection screen, and a score display to track your best punches.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Casual",
      "Crazy",
      "Punch"
    ],
    "thumbnail": "https://img.gamemonetize.com/dmbzuklinvm2zf8p1cumrsoujm6iir9p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dmbzuklinvm2zf8p1cumrsoujm6iir9p/",
    "sourceUrl": "https://html5.gamemonetize.com/dmbzuklinvm2zf8p1cumrsoujm6iir9p/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "73398",
    "slug": "double-klondike-solitaire-card",
    "title": "double klondike solitaire Card",
    "description": "Ready for the ultimate solitaire test? Try Double Klondike Solitaire! This exciting and strategic twist on the classic game uses TWO decks, doubling the fun and the challenge. Can you clear all the cards and build up the foundations? Perfect for seasoned solitaire players looking for their next obsession!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Casino",
      "Poker",
      "Puzzle",
      "Slot Machine",
      "Solitaire"
    ],
    "thumbnail": "https://img.gamemonetize.com/kbac8c4u2b42ezncjx0049awdderpzxm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kbac8c4u2b42ezncjx0049awdderpzxm/",
    "sourceUrl": "https://html5.gamemonetize.com/kbac8c4u2b42ezncjx0049awdderpzxm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74146",
    "slug": "pixel-destroyer",
    "title": "Pixel Destroyer",
    "description": "Pixel Blast is an exciting physics-based arcade puzzle game where your goal is to destroy colorful pixel shapes using bouncing balls. Dive into a world of pixel destruction! In this game, you&rsquo;ll need to use your wits and precision. Each level features a unique shape made of pixel blocks. Your objective is to destroy them all using a limited number of shots. The balls follow the laws of physics, bouncing off walls and obstacles, allowing you to reach even the most hard-to-access blocks.",
    "instructions": "Destroy all pixel blocks on the screen to complete the level Touch the screen and drag to aim Release your finger or the mouse button to fire a burst of balls Use the walls for ricochets to reach protected areas You have a limited number of moves for",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arkanoid",
      "Ball",
      "Christmas",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/kk2f1i1jbnfvg87cu5d6pso2jj0mb7t7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kk2f1i1jbnfvg87cu5d6pso2jj0mb7t7/",
    "sourceUrl": "https://html5.gamemonetize.com/kk2f1i1jbnfvg87cu5d6pso2jj0mb7t7/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73640",
    "slug": "diy-ugly-christmas-sweater",
    "title": "DIY Ugly Christmas Sweater",
    "description": "Get ready to deck the halls with festive creativity in DIY Ugly Christmas Sweater! Join three BFFs as they design their unique ugly Christmas sweaters for an epic holiday party. Choose sweater colors and decorate them with Christmas trees, reindeer, snowmen, globes, lights, bows, and more! Complete their holiday looks with new hairstyles and festive accessories. Show off your holiday spirit and create the ultimate cozy, ugly sweater masterpiece in this fun and festive game!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Christmas",
      "Creation",
      "Design",
      "Dress Up",
      "Fashion",
      "Girl",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/8c3sjuae8vo7epvhr6gsk025gulyuecd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8c3sjuae8vo7epvhr6gsk025gulyuecd/",
    "sourceUrl": "https://html5.gamemonetize.com/8c3sjuae8vo7epvhr6gsk025gulyuecd/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "74144",
    "slug": "pro-builder-3d",
    "title": "Pro Builder 3D",
    "description": "Pro Builder 3D is a satisfying build-and-sell simulation about turning raw wood into dream houses and big profit. Move your character around the 3D construction site, transport logs, drop them at the work area, and hire workers to help you build faster. Watch the house rise step by step, then put it up for auction, choose the best offer, and use the money to expand your building empire.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "builder",
      "construction",
      "House",
      "idle",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/jy1zy8wwj3fksi9mgqw44v1b43xzqohn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jy1zy8wwj3fksi9mgqw44v1b43xzqohn/",
    "sourceUrl": "https://html5.gamemonetize.com/jy1zy8wwj3fksi9mgqw44v1b43xzqohn/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73211",
    "slug": "memory-lane",
    "title": "Memory Lane",
    "description": "Your goal in each level is to reach the Goal Platform without falling or touching enemies. Levels are played in two phases. A. Reveal Phase: Duration: Short preview at the start of each level &bull; All platforms become visible. &bull; You cannot move. &bull; Study the layout, paths, traps, and pickups. Your task: Remember what you see. ________________________________________ B. Action Phase: &bull; All memory phase platforms become invisible unless they are marked to stay visible. &bull; Touching platforms reveals them permanently. Your task: Reach the goal using your memory and reflexes.",
    "instructions": "Movement bull Left Right A D or Left Right Arrow keys bull Jump Tap space once to jump bull Hold space for a higher jump arc bull Double Jump available only when powered up Mobile Controls Touch buttons appear automatically on mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Jumping",
      "Memory",
      "Pixel",
      "Platform",
      "Puzzle",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/8ww1qvuf37fo6hnmscv4m3hja4f096he/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8ww1qvuf37fo6hnmscv4m3hja4f096he/",
    "sourceUrl": "https://html5.gamemonetize.com/8ww1qvuf37fo6hnmscv4m3hja4f096he/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73998",
    "slug": "ping-pong-ball-game",
    "title": "Ping Pong Ball Game",
    "description": "Ping Pong is one of the most practiced sports in the world. Not only in China, where it has been declared the national sport, but in all countries around the world people play Ping Pong for fun or on a competitive level.",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Adventure",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/b1uqdtule8d5duwapga2ju5983obn4e6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b1uqdtule8d5duwapga2ju5983obn4e6/",
    "sourceUrl": "https://html5.gamemonetize.com/b1uqdtule8d5duwapga2ju5983obn4e6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74004",
    "slug": "coffee-tycoon",
    "title": "Coffee Tycoon",
    "description": "Run your own small coffee restaurant where every cup counts! Prepare delicious coffee and croissants, help customers quickly, upgrade machines, and hire staff to keep things running smoothly. Expand your caf&eacute; step by step and watch it grow into a busy, happy tycoon world.",
    "instructions": "Use WASD arrow keys drag the Mouse to move around the restaurant and complete tasks",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Food",
      "Management",
      "Restaurant",
      "Simulation",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/t5mo61zy3exqj175p281jbjxiwi3s1v6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t5mo61zy3exqj175p281jbjxiwi3s1v6/",
    "sourceUrl": "https://html5.gamemonetize.com/t5mo61zy3exqj175p281jbjxiwi3s1v6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74155",
    "slug": "garden-war",
    "title": "Garden War",
    "description": "Garden War is a fun combat game set in a colorful garden, where you must move skillfully and face mischievous insects. Each level offers lively battles that require you to dodge, counterattack, and use skills wisely to defeat enemies. With fast-paced gameplay, vivid effects, and simple yet engaging mechanics, Garden War provides moments of lighthearted entertainment filled with excitement right in the familiar garden!",
    "instructions": "- Use W A S D or the arrow keys to move",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Battle",
      "Farm",
      "Fun",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/acsafdbxzfco30c0iv3pn9t22x9ezel7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/acsafdbxzfco30c0iv3pn9t22x9ezel7/",
    "sourceUrl": "https://html5.gamemonetize.com/acsafdbxzfco30c0iv3pn9t22x9ezel7/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73892",
    "slug": "gravity-pulse",
    "title": "Gravity Pulse",
    "description": "Gravity Pulse is a minimalist arcade survival game where the player navigates a small arena, balancing risk and reward. The game is built around Attractor Fields &mdash; invisible forces that guide player behavior, creating flow, tension, and emergent mastery. Core Fun: Discover invariants in a chaotic system while being subtly guided by invisible attractor fields. Player Goal: Survive as long as possible and collect points.",
    "instructions": "Move WASD Arrows Mouse Touch Dash Space L-Click Button Pause ESC Button",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "Action",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ou77fx68xo237ynuy4ct3djbzbnywxe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ou77fx68xo237ynuy4ct3djbzbnywxe/",
    "sourceUrl": "https://html5.gamemonetize.com/4ou77fx68xo237ynuy4ct3djbzbnywxe/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "74015",
    "slug": "flag-merging-puzzle-game",
    "title": "Flag Merging   Puzzle Game",
    "description": "Are you ready to discover the flags of the world? With 8 language options (English, Russian, French, Turkish, Spanish, German, Italian, and Portuguese), 75 challenging levels await you. Beat the clock by grabbing and dropping the flags that appear , then merge two identical flags to clear the target ones! As each level gets harder, you can unlock 12 mysterious achievements &zwj; and power up with two upgrades: increase your coin rewards and gain extra starting time . Show your strategy, speed, and reflexes to become the ultimate flag master!",
    "instructions": "New flags will drop from above Drag and drop them anywhere with your finger Merge two identical flags to clear them and earn coins Complete the required flag goals before time runs out to advance to the next level Spend your coins wisely on upg",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Bubble",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/6jjp0jsq0vvvt1yep2h8lp2i1oxmdtm5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6jjp0jsq0vvvt1yep2h8lp2i1oxmdtm5/",
    "sourceUrl": "https://html5.gamemonetize.com/6jjp0jsq0vvvt1yep2h8lp2i1oxmdtm5/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74016",
    "slug": "escape-from-hell-crazy-runner-game",
    "title": "Escape from Hell: Crazy Runner Game",
    "description": "Ready for a deadly sprint through the flames of hell? In this hyper-casual runner, you race down a scorching straight path &zwj; with just one goal: reach the finish line alive! On every level, the devils and shimmering coins on the track appear completely at random. No two runs are ever the same&mdash;every step brings a new surprise! Collect coins to upgrade three powerful boosts&mdash;Fire Coin Earnings, Starting Health Points, and + Health Multiplier Gate&mdash;and push your run even further! Unlock a total of 18 mysterious achievements : 9 earned by slaying devils and 9 by collecting huge point totals .",
    "instructions": "Straight Hell Run Dash along a single blazing road zwj where devils and coins spawn randomly each level No memorizing mdash every attempt is a fresh challenge Survive to the Finish If your health drops below 1 0 it rsquo s game over Dodge devil",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D Games",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/e91ouncy54s94hw42d6142hsf4iti5vg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e91ouncy54s94hw42d6142hsf4iti5vg/",
    "sourceUrl": "https://html5.gamemonetize.com/e91ouncy54s94hw42d6142hsf4iti5vg/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69748",
    "slug": "ice-dash",
    "title": "ICE DASH",
    "description": "Ice Dash is a fun and frosty adventure where you draw icy lines to guide Santa through exciting levels. Help him slide across your custom paths, avoid icy traps, ride moving platforms, and collect yummy cookies along the way! Watch out for obstacles and keep your balance &ndash; the challenge gets harder as you go. Can you get every cookie and make Santa dash to victory?",
    "instructions": "Controls Draw Ice Line Tap and drag Mobile Click and drag PC Move Santa Santa slides automatically on the lines you draw Pause Game Tap the pause button",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Android",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/k77rpabre5am7bilq0zsjld6fv8zussk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k77rpabre5am7bilq0zsjld6fv8zussk/",
    "sourceUrl": "https://html5.gamemonetize.com/k77rpabre5am7bilq0zsjld6fv8zussk/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "74138",
    "slug": "perfect-tidy",
    "title": "Perfect Tidy",
    "description": "Welcome to Perfect Tidy, a simple and relaxing cleaning simulator game that you can play for free. Are you good at cleaning work? Searching for something that is stress-relieving? Join Perfect Tidy, where you can dive into multiple cleaning tasks: Car washing, skin care, teeth fixing, pet care, and more.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Car",
      "Casual",
      "Cleaning",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/xqw51wy0b0p332po2zia9w8sadpz7fgp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xqw51wy0b0p332po2zia9w8sadpz7fgp/",
    "sourceUrl": "https://html5.gamemonetize.com/xqw51wy0b0p332po2zia9w8sadpz7fgp/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "74102",
    "slug": "adventure-rush",
    "title": "Adventure Rush",
    "description": "Adventure Rush is an online platform game full of action and challenges. Run through paths packed with traps, jump at the right moment, and avoid dangers that appear at high speed. Learn from every attempt, sharpen your reflexes, and progress level by level by overcoming increasingly difficult obstacles.",
    "instructions": "Use the keyboard or touch buttons to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Ball",
      "free html5 games for your website",
      "Geometry",
      "Jumping",
      "kiz10",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/3rv2agmrwyrr60xqtrbj4zm4wvzmel3h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3rv2agmrwyrr60xqtrbj4zm4wvzmel3h/",
    "sourceUrl": "https://html5.gamemonetize.com/3rv2agmrwyrr60xqtrbj4zm4wvzmel3h/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "73344",
    "slug": "m2-blocks-2048",
    "title": "M2 BLOCKS 2048",
    "description": "M2 Blocks is an addictive and strategic puzzle game that challenges your logic, planning skills, and reflexes. Your goal is simple but engaging: merge matching numbered blocks to create higher values and score as many points as possible. Each move matters &mdash; one wrong decision can quickly fill the board, so think ahead and play smart. With clean visuals, smooth controls, and fast gameplay, M2 Blocks is perfect for quick sessions or long puzzle-solving marathons. Whether you are a casual player or a puzzle expert, the game offers a satisfying challenge that keeps you coming back for more.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Block",
      "Brain",
      "mapi games",
      "Number",
      "Puzzle",
      "puzzleblock",
      "Tetris"
    ],
    "thumbnail": "https://img.gamemonetize.com/kspqjp4u64fwgdnq0v025uri509teye1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kspqjp4u64fwgdnq0v025uri509teye1/",
    "sourceUrl": "https://html5.gamemonetize.com/kspqjp4u64fwgdnq0v025uri509teye1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68079",
    "slug": "crazy-christmas-fun-2",
    "title": "Crazy Christmas Fun 2",
    "description": "This Christmas eve and all the presents have fallen out of his sleigh. In this holiday Christmas adventure game, many balloons have invaded the North Pole, and Santa must run to catch the gifts. But Santa changed his sleigh, and he is now fast and furious! He and his reindeer need your help! Your task is to fly through the sky dodging obstacles and collecting gifts. Once you reach the Christmas tree you will level up! Have Fun! The Version 2 (Crazy Christmas Fun 2) game has easier and well-managed levels which make the game more involving and Funnier!",
    "instructions": "Click to rise alongwith kart",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Christmas",
      "Kart",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/kf4zckp8q2ls38dy3xx6bgsfv50gsnaw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kf4zckp8q2ls38dy3xx6bgsfv50gsnaw/",
    "sourceUrl": "https://html5.gamemonetize.com/kf4zckp8q2ls38dy3xx6bgsfv50gsnaw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65116",
    "slug": "santas-snowy-sprint",
    "title": "Santas Snowy Sprint",
    "description": "Santas Snowy Sprint is a festive adventure packed with holiday cheer and nonstop action! Help Santa dash across snowy rooftops, leap over chimneys, dodge icy obstacles, and collect gifts scattered along the way. Race against time to deliver presents and save Christmas, all while navigating beautifully decorated winter wonderlands. With cheerful music, charming graphics, and exciting power-ups like magic sleds and flying reindeer, every sprint is full of surprises. Unlock festive outfits, beat your high scores, and experience the magic of the holidays. Get ready for a jolly race like no other in Santas Snowy Sprint!",
    "instructions": "Use keyboards arrow key to play game",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Best Games",
      "Cartoon",
      "Casual",
      "Christmas",
      "Crazy",
      "Planet",
      "Race",
      "Santa",
      "Santa Claus",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/v4rl3sdyui8v4xrk4ahgccdlpwan5au8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v4rl3sdyui8v4xrk4ahgccdlpwan5au8/",
    "sourceUrl": "https://html5.gamemonetize.com/v4rl3sdyui8v4xrk4ahgccdlpwan5au8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72430",
    "slug": "santa-collecting-gifts",
    "title": "Santa  Collecting gifts",
    "description": "Get ready for the ultimate Christmas adventure in Santa Collecting gifts, a fast-paced holiday arcade game where your mission is to help Santa collect as many gifts as possible &mdash; while avoiding explosive surprises! The snowy skies are full of falling presents and dangerous bombs. Use your keyboard arrows or WASD keys to guide Santa across the frosty night sky in his sleigh. Catch colorful gift boxes to earn points and spread the holiday cheer &mdash; but watch out for the bombs! One wrong move, and you&rsquo;ll lose a life. Enjoy beautiful winter visuals, real jingle bell background music, and a snowfall animation that brings Christmas magic to life. As you progress, the falling speed of gifts and bombs gradually increases, making every second more exciting and challenging. Lose all three lives, and it&rsquo;s game over &mdash; but don&rsquo;t worry! You can restart anytime and try to beat your best score. With smooth controls, relaxing festive music, and joyful gameplay, Santa Gift Rush is the perfect",
    "instructions": "Move Santa Arrow Keys or WASD",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Christmas",
      "Holiday",
      "New",
      "Santa",
      "Santa Claus",
      "Skill",
      "Snow"
    ],
    "thumbnail": "https://img.gamemonetize.com/9l3npfpud13rxnfixu6dx9yoojgw1tng/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9l3npfpud13rxnfixu6dx9yoojgw1tng/",
    "sourceUrl": "https://html5.gamemonetize.com/9l3npfpud13rxnfixu6dx9yoojgw1tng/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73539",
    "slug": "santa-gift-collect-game",
    "title": "Santa Gift Collect Game",
    "description": "Santa Gift Collect Game is a fun holiday game where you help Santa collect gifts. Your goal is to guide Santa through the path and gather as many gifts as possible. The game has easy controls so players of all ages can enjoy it Beautiful Christmas graphics make the game feel magical and joyful. Each level becomes more exciting as more gifts appear on the path.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Boxing",
      "Collecting",
      "Santa",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/vfrlkliuah2j0wzrg405r58i9ytilf8f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vfrlkliuah2j0wzrg405r58i9ytilf8f/",
    "sourceUrl": "https://html5.gamemonetize.com/vfrlkliuah2j0wzrg405r58i9ytilf8f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73668",
    "slug": "santa-on-fire",
    "title": "Santa on Fire",
    "description": "Santa is TRAPPED! Pull him out of the chimney before it&rsquo;s too late! Get ready for the challenging Christmas Game where every tap counts. A little boy made the fire too hot, and Santa Claus is stuck in a dangerous, fiery trap! Santa on Fire is the perfect jumping game for quick breaks. Youll need quick reflexes and perfect timing to Save Christmas! ----- Music: Kevin MacLeod (incompetech.com)",
    "instructions": "Christmas Day is in jeopardy and Santa Claus urgently needs your help Enjoy this addictive arcade game with simple controls - First Tap LAUNCH Santa upwards Jump - Second Tap CATCH Santa before he falls Watch out for Dangerous Obstacles You must",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "amazing",
      "Arcade",
      "Best Games",
      "Boy",
      "Cartoon",
      "Cat",
      "Christmas",
      "Clicker",
      "Cute",
      "endless",
      "Fun",
      "Santa",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/734cmz6mrjj4vwxeyaxhw6mepp7msdhr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/734cmz6mrjj4vwxeyaxhw6mepp7msdhr/",
    "sourceUrl": "https://html5.gamemonetize.com/734cmz6mrjj4vwxeyaxhw6mepp7msdhr/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73856",
    "slug": "christmas-onet-connect",
    "title": "Christmas Onet Connect",
    "description": "Christmas Onet Connect is a fun and relaxing cute mahjong connect game. Your task is to find pairs and remove all tiles from the board. The path between two tiles cant have more than three lines or two 90 degree angles though. You can use Hint or Shuffle to help. Play strategically because some levels the tiles can move. If you have no shuffle left, the game is over! How many score can you beat?",
    "instructions": "Use mouse or tap to play this mahjong connect games",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Christmas",
      "HTML5",
      "html5 games",
      "Mahjong",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/d9nv7htz1ahz633c0vcjiv25qutmwyf2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d9nv7htz1ahz633c0vcjiv25qutmwyf2/",
    "sourceUrl": "https://html5.gamemonetize.com/d9nv7htz1ahz633c0vcjiv25qutmwyf2/",
    "width": 720,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73982",
    "slug": "nutsforwinter",
    "title": "NutsForWinter",
    "description": "Nuts For Winter is an adorable and high-quality physics-based game that offers hours of fun and challenge. With its charming visuals and engaging mechanics, it provides a delightful experience for players of all ages. The game automatically scales to fit your devices screen, ensuring a seamless and immersive experience on any device. Perfect for anyone looking to enjoy a playful yet challenging adventure!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/myw0pwlknsc217kcq47bwf988w79g70x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/myw0pwlknsc217kcq47bwf988w79g70x/",
    "sourceUrl": "https://html5.gamemonetize.com/myw0pwlknsc217kcq47bwf988w79g70x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74077",
    "slug": "winter-hexa-stack",
    "title": "Winter Hexa Stack",
    "description": "Winter Hexa Stack is a cozy and addictive winter-themed puzzle game where you clear the board by stacking three matching hex tiles. Tap a tile to place it in an empty spot or on top of a similar tile. When you match three identical tiles, they disappear and free up valuable space. Be careful&mdash;if your holding slots fill up or the timer runs out, the level ends. Plan your moves, stay organized, and enjoy a relaxing winter atmosphere as you solve each puzzle. Perfect for puzzle fans who want a calm, satisfying challenge.",
    "instructions": "Use a mouse or touchpad to place tiles and stack three identical ones to clear them Plan wisely to keep the board from filling up",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Christmas",
      "hexa",
      "sort",
      "sorting",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/hibeqes1lf3e0eb1hofflskm5cysjrok/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hibeqes1lf3e0eb1hofflskm5cysjrok/",
    "sourceUrl": "https://html5.gamemonetize.com/hibeqes1lf3e0eb1hofflskm5cysjrok/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "73750",
    "slug": "jingle-juggle-merge",
    "title": "Jingle Juggle Merge",
    "description": "Drop and merge identical ornaments on the gameboard by simply clicking your desired spot. The challenge is to combine them without crossing the Max line. Keep playing until you successfully create the ultimate prize: Santa Claus! Take your time and enjoy this festive, hyper-casual game.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Christmas",
      "Holiday",
      "Santa",
      "Santa Claus"
    ],
    "thumbnail": "https://img.gamemonetize.com/s5qaj4t9xc5i923apf39ahhnvy8ezv60/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s5qaj4t9xc5i923apf39ahhnvy8ezv60/",
    "sourceUrl": "https://html5.gamemonetize.com/s5qaj4t9xc5i923apf39ahhnvy8ezv60/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "73812",
    "slug": "the-horde",
    "title": "The Horde",
    "description": "**The Horde** is an intense action-survival game where you must defend against endless hordes of enemies. Upgrade your weapons, build defenses, and survive as long as possible!",
    "instructions": "- Move WASD Arrow Keys Virtual Joystick Point and click - Shoot Auto-shoot - Build In the build editor",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Action",
      "Multiplayer"
    ],
    "thumbnail": "https://img.gamemonetize.com/439zdrtozj8ankic3t7ebh6ghjy1kqpe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/439zdrtozj8ankic3t7ebh6ghjy1kqpe/",
    "sourceUrl": "https://html5.gamemonetize.com/439zdrtozj8ankic3t7ebh6ghjy1kqpe/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74094",
    "slug": "balanceduel",
    "title": "BalanceDuel",
    "description": "Balance Duel is a fun fighting game based on the element of balance, where you wield weapons and directly confront opponents in laughter-filled battles. Your task is not only to attack but also to maintain your balance, timing your strikes wisely to knock down your opponent before you lose your own footing. Every collision is unpredictable, creating matches that are both tense and humorous. The player who maintains better balance will be the winner!",
    "instructions": "- Use A or the left arrow to go back - Use D or the right arrow to move forward",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "1 Player",
      "Fight",
      "firefighters",
      "Knight",
      "Monster"
    ],
    "thumbnail": "https://img.gamemonetize.com/x3qzkzg6n6bflmzh2y18xeinpm8f59np/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x3qzkzg6n6bflmzh2y18xeinpm8f59np/",
    "sourceUrl": "https://html5.gamemonetize.com/x3qzkzg6n6bflmzh2y18xeinpm8f59np/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "74081",
    "slug": "jungle-mart-idle-game",
    "title": "Jungle Mart idle game",
    "description": "Jungle Mart is a casual idle farming and market management game where youep workers awake to maintain smooth production. Hire helpers, upgrade efficiency, and expand your jungle market step by step. Easy to play yet strategic, Jungle Mart delivers a relaxing idle experience with constant progression and satisfying management gameplay.",
    "instructions": "Mobile Use the on-screen joystick to move and interact PC Use W A S D keys to move around the jungle mart",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2D",
      "Adventure",
      "Farm",
      "Food",
      "idle",
      "Kids",
      "Monkey"
    ],
    "thumbnail": "https://img.gamemonetize.com/e8eah86fzgbb5rpni7i2zqk2huqks6nm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e8eah86fzgbb5rpni7i2zqk2huqks6nm/",
    "sourceUrl": "https://html5.gamemonetize.com/e8eah86fzgbb5rpni7i2zqk2huqks6nm/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73971",
    "slug": "idle-cave-story",
    "title": "Idle Cave Story",
    "description": "Idle Cave Story is an idle simulation and strategy game set in a primitive caveman village. Build and expand your settlement, assign workers, and manage your resources as your tribe grows stronger. Hire new villagers with different roles, upgrade your buildings, and unlock new areas to explore. Send your warriors into battle to clear dangerous caves, defeat enemies, and bring back valuable loot for the village. Balance your economy and army to keep your tribe safe and thriving. Whether you&rsquo;re actively managing every click or letting your village progress on its own, Idle Cave Story offers a relaxing yet strategic idle experience.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Battle",
      "building",
      "Casual",
      "idle",
      "Management",
      "Simulation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/7t6ygohziy6t8xn7x5ksxlnqcyeeajox/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7t6ygohziy6t8xn7x5ksxlnqcyeeajox/",
    "sourceUrl": "https://html5.gamemonetize.com/7t6ygohziy6t8xn7x5ksxlnqcyeeajox/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73939",
    "slug": "vehicle-driving-master-game",
    "title": "Vehicle Driving Master Game",
    "description": "Gear up for an exciting driving adventure in vehicle master driving 3d! This vehicle master car game isnt just about racing to the finish line; its about driving and parking the multiple vehicles on their designated spots with full care. From sports cars to heavy trucks, each vehicle feels unique with its own handling and challenges. Customize your city rides to match your style and become the real vehicle master 3d driver. Vehicle master 3d game is full of challenges of car parking and driving master. Jump into the vehicles driver seat and show your vehicle driving skills in city driver game.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Car",
      "Parking",
      "Truck",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qarvyvvg2opieitmizdgb8aoik63t0jm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qarvyvvg2opieitmizdgb8aoik63t0jm/",
    "sourceUrl": "https://html5.gamemonetize.com/qarvyvvg2opieitmizdgb8aoik63t0jm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73567",
    "slug": "smooth-mood-mini-games",
    "title": "Smooth Mood Mini Games",
    "description": "Stressed out to the max? Pop, squish &amp; squeeze your worries like never before with AntiStress Fidget Toys set:a virtual pocket-sized arsenal of 100+ stress-busting satisfying toys satisfying pops of colorful Pop Its &amp; simple dimples, squishy delights of stress balls to the mesmerizing melodies of Pop Tubes and the ASMR magic of soap cutting, AntiStress Fidget. Unique Squeeze, stretch, and squish stress balls, squishy toys, having different animations and slimes of every texture and color for tactile gratification.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Best Games",
      "Brainrot",
      "Brainrot Italian",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/jh6u3d8bkely91iztkzk69896odl6qum/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jh6u3d8bkely91iztkzk69896odl6qum/",
    "sourceUrl": "https://html5.gamemonetize.com/jh6u3d8bkely91iztkzk69896odl6qum/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72746",
    "slug": "prism-match-3d",
    "title": "Prism Match 3D",
    "description": "Prism Match 3D: A Multi-Dimensional Puzzle Adventure Enter a dazzling 3D world of colorful prism cubes and test your mind like never before. Prism Match 3D blends Mahjong-style strategy with the excitement of modern match-3 gameplay. Immersive 3D Graphics &ndash; Rotate, zoom, and explore beautifully crafted levels full of hidden tiles. Addictive &amp; Relaxing &ndash; Easy to learn, hard to master. Balance logic, timing, and focus to win. Endless Challenges &ndash; Progress through creative stages that keep the fun fresh and engaging. Think &amp; Unwind &ndash; Relax your mind while sharpening memory, observation, and problem-solving skills.",
    "instructions": "Clear all tiles to win Rotate the 3D board to spot free tiles Tap to collect them in your 7-slot tray Match 3 identical tiles to clear space and keep going Be strategic if the tray fills up it rsquo s game over Use Undo Retr or Shuffle",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Best Games",
      "free html5 games for your website",
      "HTML5",
      "html5 games",
      "Match 3",
      "Match-3",
      "Matching",
      "Mobile",
      "Puzzle",
      "puzzleblock",
      "touch",
      "touchscreen"
    ],
    "thumbnail": "https://img.gamemonetize.com/t98bbzmv3a9g4fwg2lph0374wdhuvoln/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t98bbzmv3a9g4fwg2lph0374wdhuvoln/",
    "sourceUrl": "https://html5.gamemonetize.com/t98bbzmv3a9g4fwg2lph0374wdhuvoln/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73093",
    "slug": "metastack",
    "title": "MetaStack",
    "description": "Experience an addictive one-player stacking challenge where precision and timing are the keys to reaching new heights. Build your tower block by block, aim for the perfect drop, and push your limits to achieve the highest score. Enjoy a variety of exciting power-ups designed to boost your gameplay and keep the action engaging. Simple to play yet endlessly fun&mdash;this stacking game delivers a smooth, competitive, and rewarding experience every time you play.",
    "instructions": "Tap Click Drop the moving block Timing is key Release the block when it aligns with the stack Perfect Drops Achieve perfect alignment to boost your score and stabilize the tower Use Power-Ups Activate special boosts to help you reach higher levels",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Android",
      "blocky"
    ],
    "thumbnail": "https://img.gamemonetize.com/dlnb4987u5ap9i4p8phnryzhuqulufa5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dlnb4987u5ap9i4p8phnryzhuqulufa5/",
    "sourceUrl": "https://html5.gamemonetize.com/dlnb4987u5ap9i4p8phnryzhuqulufa5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73233",
    "slug": "drivex-city",
    "title": "DriveX City",
    "description": "Experience the ultimate 3D driving adventure in DriveX City! Explore a massive open world with stunning graphics and dynamic gameplay across 16 unique themes and 15 exciting game modes.",
    "instructions": "KEYBOARD Desktop W Arrow Up - Accelerate Drive Forward S Arrow Down - Brake Reverse A Arrow Left - Turn Left D Arrow Right - Turn Right SHIFT - Nitro Boost when available SPACE - Jump Double-click Title - Toggle Sound ON OFF MOBILE TOUC",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2048",
      "2D",
      "Ai Games",
      "amazing"
    ],
    "thumbnail": "https://img.gamemonetize.com/rt3n9tqlyil0j3io7atk39vtqz9nr5cr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rt3n9tqlyil0j3io7atk39vtqz9nr5cr/",
    "sourceUrl": "https://html5.gamemonetize.com/rt3n9tqlyil0j3io7atk39vtqz9nr5cr/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73331",
    "slug": "water-sort-master",
    "title": "Water Sort Master",
    "description": "Water Sort Master is the ultimate liquid puzzle game! Test your brain with 6 unique game modes, including Classic, Time Trial, and Mystery. Sort the colored liquids until each flask contains only one color. Featuring thousands of levels, unlockable themes, and helpful power-ups like Undo and Extra Flasks. Features: 6 Game Modes: Classic, Time Trial, Limited Moves, Sequence, Mystery, and Fusion. Over 1000 unique levels. Unlockable themes and bottle styles. Smooth animations and relaxing sound effects. Play on Mobile or Desktop.",
    "instructions": "Use the mouse or touch to play Tap a flask to pick up the top liquid Tap another flask to pour it Rule You can only pour liquid onto the same color or into an empty flask",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Brain",
      "Casual",
      "Color",
      "HTML5",
      "html5 games",
      "Logic",
      "Mobile",
      "Puzzle",
      "Relaxation",
      "sort",
      "Strategy",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/ka46hy72vwpoy3pppugopn6ppwm7rkwd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ka46hy72vwpoy3pppugopn6ppwm7rkwd/",
    "sourceUrl": "https://html5.gamemonetize.com/ka46hy72vwpoy3pppugopn6ppwm7rkwd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73425",
    "slug": "qblock-puzzle",
    "title": "QBlock Puzzle",
    "description": "QBlock Puzzle - Addictive block game for fans of puzzles, jigsaw, and classic wooden block. Play QBlock Puzzle 10 minutes a day keep your mind sharp! Drag &amp; drop the block to create full horizontal or vertical lines of block. Keep the board clean and beat your high score in QBlock Puzzle! It would easily help lower your stress, anxiety, and aid you to focus on anything else. QBlock Puzzle features: - 4 FREE beautiful themes: Wood, Cartoon, Day &amp; Night. - Easy and simple, no pressure and no time limit. - Block rotation is available.",
    "instructions": "Drag and drop a block onto the board Fill an entire row or column to clear it Clearing lines gives you points and more space to keep playing If a block doesn rsquo t fit anywhere on the board the game ends",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Bejeweled",
      "Block",
      "Board",
      "Brain",
      "Casual",
      "Classic",
      "free games for your site",
      "HTML5",
      "Logic",
      "Mind",
      "puzzleblock",
      "Tetris",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/t9xqzh1133o06x3soxt2kmek6mgmt778/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t9xqzh1133o06x3soxt2kmek6mgmt778/",
    "sourceUrl": "https://html5.gamemonetize.com/t9xqzh1133o06x3soxt2kmek6mgmt778/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73625",
    "slug": "cube-play",
    "title": "Cube Play",
    "description": "Cube Play is a 3D color-matching puzzle game. Swipe to move cubes, merge matching colors to upgrade them, and break ice blocks by merging adjacent cubes. Clear all ice to complete each level.",
    "instructions": "Use the arrow keys on screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Collecting",
      "Color",
      "endless",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/vswya9xt28yiwqzj513ktobl52irix5i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vswya9xt28yiwqzj513ktobl52irix5i/",
    "sourceUrl": "https://html5.gamemonetize.com/vswya9xt28yiwqzj513ktobl52irix5i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73801",
    "slug": "sticky-planet",
    "title": "Sticky Planet",
    "description": "Launch, Stick, and Survive! Welcome to Sticky Planet, the addictive hyper-casual arcade game where gravity is your best friend&mdash;and your worst enemy. How to Play: &bull; Tap anywhere to launch your ship from its current planet. &bull; Time your shots perfectly to land on the next planet. &bull; Master the orbital physics and changing gravity. &bull; Avoid the void and dont miss! Chain successful landings to build your Combo Multiplier and rack up massive high scores. Featuring vibrant visuals, satisfying physics, and instant-restart gameplay for that just one more try feeling. Can you conquer the galaxy?",
    "instructions": "Controls - Tap Click anywhere to launch from the planet - Time your jumps to orbit around planets - Collect stars for points - Dont drift into space",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Brain",
      "Casual",
      "HTML5"
    ],
    "thumbnail": "https://img.gamemonetize.com/5it2ku5rbtw1gwqdl0woc9wmqo47e4q6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5it2ku5rbtw1gwqdl0woc9wmqo47e4q6/",
    "sourceUrl": "https://html5.gamemonetize.com/5it2ku5rbtw1gwqdl0woc9wmqo47e4q6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73747",
    "slug": "gothic-knife",
    "title": "Gothic Knife",
    "description": "Test your reflexes and precision in this addictive knife throwing game! Your goal is simple: throw knives into the rotating logs to break them. Be careful not to hit the knives youve already thrown! Key Features: &bull; Challenge yourself with endless levels. &bull; Battle unique Bosses every 3 stages! &bull; Explore 3 stunning themes: Cyberpunk, Gothic, and Village. &bull; Collect bonuses to earn extra knives. &bull; Master the Combo system for massive high scores!",
    "instructions": "Tap the screen or click the mouse to throw a knife",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Mobile",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/eug6wzijzbk3ykimgaogrpbt4d05rnt8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eug6wzijzbk3ykimgaogrpbt4d05rnt8/",
    "sourceUrl": "https://html5.gamemonetize.com/eug6wzijzbk3ykimgaogrpbt4d05rnt8/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "73914",
    "slug": "gasspark",
    "title": "GasSpark",
    "description": "Welcome to GasSpark, the high-pressure arcade reaction game where every barrel is a ticking time-bomb of volatile gas! Your mission is simple &mdash; tap every barrel before it overheats and explodes. But be warned: the sparks fly faster than you think. Barrels ignite, pressure rises, flames flare, and one missed tap can start a chain reaction that engulfs the whole board. Only the quickest players can tame the spark!",
    "instructions": "Tap to break the barrels before blast",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "Educational",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/g4fnv1ugi01r781ilpjqflasuh2clp9y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g4fnv1ugi01r781ilpjqflasuh2clp9y/",
    "sourceUrl": "https://html5.gamemonetize.com/g4fnv1ugi01r781ilpjqflasuh2clp9y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74075",
    "slug": "santa-vs-zomby",
    "title": "Santa Vs Zomby",
    "description": "Just before Christmas night, zombies invade Santa&rsquo;s base and steal all the gifts! Guide Santa, launch him at the zombies, use physics to knock them down, clear every level and save Christmas! Full description A group of zombies attacks Santa&rsquo;s base and steals the presents meant for children. The elves are in shock &mdash; now it&rsquo;s up to you! Launch Santa Claus at the zombies, use physics to make them fall or crash, destroy all enemies and complete every level. Simple rules, fun physics, and a clear goal: recover the gifts and save Christmas! &zwj;",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "angrybirds",
      "mapi games",
      "Santa",
      "Santa Claus",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/ssyulsswaf3fi5ycarggemnrmysrv3gd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ssyulsswaf3fi5ycarggemnrmysrv3gd/",
    "sourceUrl": "https://html5.gamemonetize.com/ssyulsswaf3fi5ycarggemnrmysrv3gd/",
    "width": 1024,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73553",
    "slug": "the-zombie-house",
    "title": "The Zombie House",
    "description": "Protect your home from endless waves of zombies! Defeat zombies to collect coins and ability drops. Use coins to upgrade both your player and your house. Each level makes the zombies stronger. How long can you survive?",
    "instructions": "PC Move with WASD and click on zombies to shoot in that direction Mobile Use the left joystick to move and the right joystick to aim amp shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Horror",
      "Shoot",
      "survival",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/kqrdzycb73wfohom35hrnae8ttuz9b1u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kqrdzycb73wfohom35hrnae8ttuz9b1u/",
    "sourceUrl": "https://html5.gamemonetize.com/kqrdzycb73wfohom35hrnae8ttuz9b1u/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73574",
    "slug": "oil-tanker-truck-parking-game",
    "title": "Oil Tanker Truck Parking Game",
    "description": "Do you like heavy duty oil cargo truck driving simulator games 2021? Then Oil Tanker Transporter Truck Simulator gives you a realistic truck driving experience. Driving big oil tanker and cargo trailer is not a simple task as you have to know all the driving school rules to drive big offroad trucks.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2025 games",
      "Car",
      "monstertruck",
      "Parking",
      "Tank",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/40i95l7qrakoextsh18h4bi0s3uq3vcy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/40i95l7qrakoextsh18h4bi0s3uq3vcy/",
    "sourceUrl": "https://html5.gamemonetize.com/40i95l7qrakoextsh18h4bi0s3uq3vcy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73807",
    "slug": "brainrot-shooter",
    "title": "Brainrot Shooter",
    "description": "Play the hurricane-pounding Brainrot Shooter! Its tons of fun, tons of guns, and features your favorite Brainrots. Come on in and prove youre the best!",
    "instructions": "Desktop 1 Walk - WASD 2 Switch weapons - Q or E 3 Look - use the mouse Mobile 1 Use on-screen controls",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Army",
      "attack",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "First Person Shooter",
      "fps",
      "Italian Brainrot",
      "Shooter",
      "Shooting",
      "Tralalero Tralala",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/l8xgrcjf37q82eol0yfzm5bc78sexlw5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l8xgrcjf37q82eol0yfzm5bc78sexlw5/",
    "sourceUrl": "https://html5.gamemonetize.com/l8xgrcjf37q82eol0yfzm5bc78sexlw5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73965",
    "slug": "us-coach-bus-simulator-game",
    "title": "US Coach Bus Simulator Game",
    "description": "Welcome to drive new bus simulator games. Race opponents with advanced super bus driving game controls. Get ready for endless bus missions of picking passengers from one city to drop passengers in other city. Move bus on city highways with amazing bus controls. Be an expert bus driver just by playing new bus driving simulator game 2024 for free. Drive new story based bus parking &amp; simulation.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "bus",
      "Car",
      "Driving",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/55cyt96a5u85bj0e3gfrd1qkn33bibos/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/55cyt96a5u85bj0e3gfrd1qkn33bibos/",
    "sourceUrl": "https://html5.gamemonetize.com/55cyt96a5u85bj0e3gfrd1qkn33bibos/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "74018",
    "slug": "christmas-hexa-puzzle",
    "title": "Christmas Hexa Puzzle",
    "description": "Christmas Hexa Puzzle is a relaxing holiday-themed jigsaw game where you arrange vibrant hexagonal tiles to complete festive pictures. Choose between 14-piece and 22-piece puzzle modes, perfect for both quick plays and more challenging sessions. Drag and fit each hexa piece into its correct spot, watch the Christmas scene come to life, and enjoy a cozy, soothing puzzle experience for all ages.",
    "instructions": "Use your mouse or touchpad to move and fix the hexagonal tiles to complete the picture",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Christmas",
      "Jigsaw",
      "Puzzle",
      "Skill",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/r5yewhqbovg8et5g93jg55kmpsopj75a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r5yewhqbovg8et5g93jg55kmpsopj75a/",
    "sourceUrl": "https://html5.gamemonetize.com/r5yewhqbovg8et5g93jg55kmpsopj75a/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "74017",
    "slug": "christmas-puzzle-with-santa",
    "title": "Christmas Puzzle With Santa",
    "description": "Christmas Puzzle With Santa is a cheerful jigsaw game full of holiday magic! Join Santa Claus and enjoy relaxing puzzle fun with adorable Christmas artwork. Perfect for kids and puzzle lovers, this game will warm your heart and get you into the festive spirit. Have fun piecing together Christmas joy!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Christmas",
      "Hypercasual",
      "Jigsaw",
      "Kids",
      "Puzzle",
      "Santa",
      "Santa Claus",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/s80ixkrfmqkfbbm9wpgfhusidlad6j9o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s80ixkrfmqkfbbm9wpgfhusidlad6j9o/",
    "sourceUrl": "https://html5.gamemonetize.com/s80ixkrfmqkfbbm9wpgfhusidlad6j9o/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "74069",
    "slug": "juice-machine",
    "title": "Juice Machine",
    "description": "Juice Machine is a relaxing casual game where you operate a colorful blender. Fruits continuously appear, and your task is to wait for the blades to blend them into delicious juice. You can click directly on the fruits to speed up the blending process and earn extra resources. Use the rewards to upgrade the blender to the maximum level, increasing speed and efficiency. Simple, fun, and extremely addictive!",
    "instructions": "Use mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Fruits",
      "idle",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/5ce4gmwhbhjzvogzq0ncr7tk22cd6456/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5ce4gmwhbhjzvogzq0ncr7tk22cd6456/",
    "sourceUrl": "https://html5.gamemonetize.com/5ce4gmwhbhjzvogzq0ncr7tk22cd6456/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73837",
    "slug": "neon-hockey-2",
    "title": "Neon Hockey 2",
    "description": "Neon Hockey 2: Championship Edition is a fast-paced arcade air hockey game styled in a neon retro aesthetic. Enjoy smooth, physics-based gameplay with vibrant visual effects. The game offers two modes: 1 Player vs AI (featuring significantly improved Artificial Intelligence with three difficulty levels) and 2 Players (local multiplayer on a single device). Customize mallet size and maximum puck speed in the settings. Compete in a Best of 3 Periods format, needing 7 goals to win a period. Perfect for quick, competitive fun!",
    "instructions": "PLAYER 1 Left Mouse Touch left half of screen WASD Keyboard PLAYER 2 Right Touch right half of screen Arrows uarr darr larr rarr Keyboard PAUSE ESC or P",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Click",
      "Color",
      "endless",
      "hockey",
      "Physics",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/gswoqzyqz7pbsqvzv8lvjbmspmsxnunp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gswoqzyqz7pbsqvzv8lvjbmspmsxnunp/",
    "sourceUrl": "https://html5.gamemonetize.com/gswoqzyqz7pbsqvzv8lvjbmspmsxnunp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73929",
    "slug": "parking-jam-2025",
    "title": "Parking Jam 2025",
    "description": "Step into a charming miniature world where parking is more than a task&mdash;its a skill to be perfected! In Tiny Wheels: Parking Hero, you control a tiny toy car navigating through playful, stylized parking lots filled with obstacles, tight turns, and clever layouts. Designed with a clean top-down look and smooth controls, every level challenges your accuracy, timing, and strategy. Park without crashing, avoid traffic, and complete each challenge to become the ultimate Parking Hero!",
    "instructions": "Mouse Swipe",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Car",
      "carparking",
      "Casual",
      "Parking",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/95snwzd0xk6s5gro5jhlh0wrx7ez7gzr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/95snwzd0xk6s5gro5jhlh0wrx7ez7gzr/",
    "sourceUrl": "https://html5.gamemonetize.com/95snwzd0xk6s5gro5jhlh0wrx7ez7gzr/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73960",
    "slug": "street-war",
    "title": "Street War",
    "description": "StreetWar is a street action game where you choose a character with unique skills and enter intense battles. Each warrior has different strengths and weaknesses, requiring you to utilize timing and strategy to win. Prove your courage and become the strongest on the street!",
    "instructions": "- Use the W A D keys to move - Press J to punch - Press K to kick",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "Boy",
      "Fight",
      "Skill",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/6v1ijm03umzkj73s57p6cjag80axbwum/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6v1ijm03umzkj73s57p6cjag80axbwum/",
    "sourceUrl": "https://html5.gamemonetize.com/6v1ijm03umzkj73s57p6cjag80axbwum/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73935",
    "slug": "runaway-fish-runner-game",
    "title": "Runaway Fish Runner Game",
    "description": "Welcome to the world of the fish runner game. A fast-paced underwater endless runner adventure that plunges you into the mesmerizing world beneath the water. With beautiful underwater visuals, smooth controls, endless levels, and addictive gameplay. Fish runner game is the perfect choice for fans of endless runner games and aquatic adventures alike.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Fish",
      "running",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/urdizd6vpkhaob5hvnjn90tnywq8ggvb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/urdizd6vpkhaob5hvnjn90tnywq8ggvb/",
    "sourceUrl": "https://html5.gamemonetize.com/urdizd6vpkhaob5hvnjn90tnywq8ggvb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73372",
    "slug": "drift-x-driving-car-game",
    "title": "Drift X Driving Car Game",
    "description": "Welcome to the world of car drift and driving games. Get ready to ignite your engines, push the pedal to the metal, and drift like a pro in the most thrilling car drift and driving game ever. This is not just a driving simulator game, its an adrenaline-pumping, tire-squealing, smoke-flying experience that takes your car control skills to the next level. Whether you are into precision driving, freestyle drifting, or open world cruising, this game has something for every car enthusiast.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Action",
      "Car",
      "drift",
      "Driving",
      "Parking",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/1mf5gvj912ik2r7i0nkbfobb4ow3ax1t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1mf5gvj912ik2r7i0nkbfobb4ow3ax1t/",
    "sourceUrl": "https://html5.gamemonetize.com/1mf5gvj912ik2r7i0nkbfobb4ow3ax1t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73913",
    "slug": "ants-io",
    "title": "Ants io",
    "description": "Ants io is a fast-paced .io-style arena game where you control a battle-hardened ant fighting for the top spot in the jungle. Move around the map, hunt enemies, and use your unique special ability to outplay other ants. Each ant type comes with its own special skill and playstyle, and you can unlock many more in the in-game shop. Choose from four different game modes to test your skills, and pick from three random skills during the run to build powerful combos. Survive, grow stronger, and be the last ant standing to claim first place on the leaderboard.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      ".io",
      ".io Games",
      "3D Games",
      "Action",
      "Arena",
      "Battle",
      "Skills",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/padkimfk900lo640e7v8dm70zuqacvpv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/padkimfk900lo640e7v8dm70zuqacvpv/",
    "sourceUrl": "https://html5.gamemonetize.com/padkimfk900lo640e7v8dm70zuqacvpv/",
    "width": 1600,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73905",
    "slug": "piano-kids-music-and-songs",
    "title": "Piano Kids Music And Songs",
    "description": "You will experience a fun and realistic music feast. Tap on your keyboard or screen to make melodious songs and share your music with all your friends and family. This educational game is also perfect for kids to develop hands-on ability, the sense of music and colors at an early age. Turn your keyboard into a fun musical instrument and play music freely anytime, anywhere.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Kids",
      "Music",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/k3qebemq0hr192ojfx686k0id4xqu8td/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k3qebemq0hr192ojfx686k0id4xqu8td/",
    "sourceUrl": "https://html5.gamemonetize.com/k3qebemq0hr192ojfx686k0id4xqu8td/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73897",
    "slug": "cyber-smash",
    "title": "Cyber Smash",
    "description": "Cyber Smash is a retro-inspired, neon-soaked Breakout game where quick reflexes and strategic power-up usage are key to victory. Smash through multi-layered cyber bricks using your glowing paddle and ball. Watch out for power-ups like Multi-ball and Fire Mode (Laser Guns) to unleash massive destruction and rack up huge combo scores. Complete all levels and become the ultimate Cyber Smasher! Features: Dynamic level generation, multiple power-up types, a challenging combo system, and persistent high scores.",
    "instructions": "bull Mouse Touch Drag the paddle horizontally bull Keyboard PC Left Arrow A to move left Right Arrow D to move right Launch Ball Fire Laser bull Mouse Touch Click or tap the screen bull Keyboard PC Spacebar Up Arrow W",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Coloring",
      "HTML5",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/ukcr870zdtvp729gljb1aqq10jwvy0v5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ukcr870zdtvp729gljb1aqq10jwvy0v5/",
    "sourceUrl": "https://html5.gamemonetize.com/ukcr870zdtvp729gljb1aqq10jwvy0v5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73566",
    "slug": "mini-games-fun-therapy",
    "title": "Mini Games Fun Therapy",
    "description": "A very interesting collection of super relaxing games. Do you want to play some relaxing games? We offer a wide range of fun anxiety relief games to help you calm down and relax! This application contains many satisfying games. If you are looking for a game to relieve stress and anxiety, then this relaxing mini game will be perfect for you!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "3D Games",
      "amazing",
      "Arcade",
      "Baby Games",
      "Brain",
      "Brainrot",
      "Crazy"
    ],
    "thumbnail": "https://img.gamemonetize.com/0l63e7y0zqkpwjovwfwcsa0a88z6anbw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0l63e7y0zqkpwjovwfwcsa0a88z6anbw/",
    "sourceUrl": "https://html5.gamemonetize.com/0l63e7y0zqkpwjovwfwcsa0a88z6anbw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73887",
    "slug": "float-boat",
    "title": "Float Boat",
    "description": "Float Boat is a fun and relaxing browser game where you guide a small boat across floating platforms and obstacles. With simple controls and smooth movement, players must stay balanced, avoid falling, and travel as far as possible. It&rsquo;s easy to play, enjoyable for all ages, and great for quick gaming sessions.",
    "instructions": "Up Arrow and Down Arrow",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Boat",
      "crazygamesunblocked",
      "Escape",
      "free html5 games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/89ffw0r03as995swxpcm5kazry2dot18/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/89ffw0r03as995swxpcm5kazry2dot18/",
    "sourceUrl": "https://html5.gamemonetize.com/89ffw0r03as995swxpcm5kazry2dot18/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73685",
    "slug": "celebrities-get-ready-for-christmas",
    "title": "Celebrities Get Ready For Christmas",
    "description": "Step into the world of &lsquo;Celebrities Get Ready for Christmas&rsquo;! Join your favorite stars as they prepare for the festive season. Explore dazzling holiday outfits, glamorous decorations, and witness the magic of Christmas through the eyes of celebrities. Get ready for a star-studded holiday celebration! Play and have fun!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Christmas",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/1ppyg0qwhtdvfhcvfobnhym4j123ytux/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1ppyg0qwhtdvfhcvfobnhym4j123ytux/",
    "sourceUrl": "https://html5.gamemonetize.com/1ppyg0qwhtdvfhcvfobnhym4j123ytux/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73928",
    "slug": "trump-winter-adventure",
    "title": "Trump Winter Adventure",
    "description": "Trump Winter Adventure is a fun and free online game for kids! Help the cheerful Trump save Christmas by collecting as many gifts as possible while racing to the finish line. Enjoy the holiday adventure and have fun!",
    "instructions": "Mouse to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Avoid",
      "Celebrity",
      "Christmas",
      "Collecting",
      "Fun",
      "Hypercasual",
      "jump",
      "Jumping",
      "run",
      "running",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/sbe7ep8jinyyd0vylm65mqq1j7aeorvg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sbe7ep8jinyyd0vylm65mqq1j7aeorvg/",
    "sourceUrl": "https://html5.gamemonetize.com/sbe7ep8jinyyd0vylm65mqq1j7aeorvg/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "73904",
    "slug": "1945-air-force-space-shooter",
    "title": "1945 Air Force Space Shooter",
    "description": "Prepare for nonstop action in 1945 Air Force: Space Shooter! Inspired by the classic shooter era, this game combines vintage visuals with thrilling bulletstorm gameplay that will test your reflexes and precision. Fly through endless waves of enemy aircraft. Avoid storms of bullets and unleash devastating firepower from your Force fighter.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "airplane",
      "firefighters",
      "Shoot",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/wtdy3b6e8v505vj1ayn2c14kjkoy2k2e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wtdy3b6e8v505vj1ayn2c14kjkoy2k2e/",
    "sourceUrl": "https://html5.gamemonetize.com/wtdy3b6e8v505vj1ayn2c14kjkoy2k2e/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "51878",
    "slug": "mr-dude-king-of-the-hill",
    "title": "Mr. Dude: King of the Hill",
    "description": "The famous criminal Mister Dude found himself on the top of a mountain, where residents were waiting for him, ready to hand him over to the police. Help him avoid getting caught, defeat all enemies and conquer the mountain! Game Features: Interactive Ragdoll Characters: Your goal is to knock out, drag and throw your opponents using physics and fun ragdoll effects. The game has a huge number of different objects that you can manipulate and throw at your opponents. The variety of options and tactics ensures exciting gameplay. The game has various enemies, levels and modes.",
    "instructions": "Control computer WASD - movement Space - jump F - pick up an item G - eat food E - ledge grab Left mouse button - hit throw shot Right mouse button - aim 1 2 3 - switching items",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "amazing",
      "Android",
      "Arcade",
      "Best Games",
      "Fun",
      "Funny",
      "Game",
      "iPhone",
      "Physics",
      "unity games",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/hp4wgaxp9qnpjbjr6lqx65h56fn9rl8h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hp4wgaxp9qnpjbjr6lqx65h56fn9rl8h/",
    "sourceUrl": "https://html5.gamemonetize.com/hp4wgaxp9qnpjbjr6lqx65h56fn9rl8h/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73853",
    "slug": "k-wedding-dream",
    "title": "K Wedding Dream",
    "description": "Immerse yourself in the atmosphere of Korean love with the heroes of this dress-up game. Become a part of a magical story where bright K-Pop stars are preparing for the most important day of their lives - their Wedding day! Combine tradition and modern fashion by creating wedding looks for lovers. Choose the perfect makeup, hairstyle and jewelry to highlight their unique style and charm. Let each of your choices reflect the emotions and dreams of the characters, turning this day into a real fairy tale!",
    "instructions": "Help the couple create a Korean-style wedding look The most interesting images can be saved as a screenshot in PNG format Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Anime",
      "Dress Up",
      "Fashion",
      "Hair",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/hkph41kd0ddzg00y7zxgwh29sed97omn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hkph41kd0ddzg00y7zxgwh29sed97omn/",
    "sourceUrl": "https://html5.gamemonetize.com/hkph41kd0ddzg00y7zxgwh29sed97omn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73872",
    "slug": "quad-bike-racing-game",
    "title": "Quad Bike Racing Game",
    "description": "ATV Quad Bike 3D Racing Games plus shooting game ensures to fulfill the ultimate traffic shooting extreme atv games in real quad drive ahead games. This is a complete and full featured ATV quad simulator, which gives you dual experience of ATV Quad Bike 3D Racing Games and best bike shooting games. Quad bike racing simulator will give you a taste of extreme quad racing city bike driving games and bike racing that offers no less than the real fun of atv kart racing games, real quad games &amp; quad bike games.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Bike",
      "Driving",
      "Parking",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/e7vwr30va5gq2lqvwa51grgufbtrejcn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e7vwr30va5gq2lqvwa51grgufbtrejcn/",
    "sourceUrl": "https://html5.gamemonetize.com/e7vwr30va5gq2lqvwa51grgufbtrejcn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73875",
    "slug": "career-run-ramp-game",
    "title": "Career Run Ramp Game",
    "description": "Experience high-speed action and extreme car stunt driving in Car Racing Games. Get ready for impossible track challenges, gravity-defying jumps, and sky-high ramp car racing that will test your stunt driving skills in this epic ramp car simulator. Ramp game delivers intense car stunt gameplay with 3D racing tracks, twisted roads, and extreme ramp car missions. Perform dangerous flips, mid-air stunts, and insane jumps over mega ramps",
    "instructions": "Mouse Operated - Press and hold the left button then move the mouse left or right to control movement",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Game",
      "Puzzle",
      "Race",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/n27xhtefi2jsta88usj0kdsphs1s4bui/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n27xhtefi2jsta88usj0kdsphs1s4bui/",
    "sourceUrl": "https://html5.gamemonetize.com/n27xhtefi2jsta88usj0kdsphs1s4bui/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73912",
    "slug": "aimistry",
    "title": "Aimistry",
    "description": "Aimistry &ndash; Learn Chemistry Through Precision and Play! Get ready to test your aim and your knowledge of the periodic table! Aimistry is an exciting fusion of science and skill, where every throw counts &mdash; literally. Based on the chemical elements, Aimistry brings chemistry to life with an innovative twist: instead of numbers, you&rsquo;ll aim using chemical element symbols up to Calcium (Atomic Number 20).",
    "instructions": "No two sticks to collide",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Educational",
      "Math",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/l937mpytwf6eig6mkezalqs0bd814eri/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l937mpytwf6eig6mkezalqs0bd814eri/",
    "sourceUrl": "https://html5.gamemonetize.com/l937mpytwf6eig6mkezalqs0bd814eri/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73829",
    "slug": "nuts-bolts-screw-puzzle",
    "title": "Nuts Bolts Screw Puzzle",
    "description": "Welcome to Screw, Nuts and Bolts Puzzle, a fun and relaxing wood puzzle game where your goal is to solve puzzles and free birds trapped in wooden structures. Each level challenges you to remove nuts, bolts, and screws in the correct order to break apart the wood. As you solve each puzzle, watch the wooden blocks fall and the birds fly away, giving you a sense of achievement. This wooden puzzle game is suitable for players of all ages, with puzzles that start off easy and get harder as you go. Use your brain to figure out the right order to remove the screws, all while enjoying the calming visuals of the game.",
    "instructions": "Mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Ai Games",
      "Arcade",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/bmene1v8w9vlbu0fesbiym9wa9tvtqd8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bmene1v8w9vlbu0fesbiym9wa9tvtqd8/",
    "sourceUrl": "https://html5.gamemonetize.com/bmene1v8w9vlbu0fesbiym9wa9tvtqd8/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73216",
    "slug": "winter-battle",
    "title": "Winter Battle",
    "description": "The perfect winter season has arrived. Join the battle between Santa Claus and the Grinch under the snow. Collect all the gift boxes falling from the sky, but remember, some gift boxes are very dangerous. As you collect gift boxes, your size increases; naturally, if you collect the wrong box, your size will shrink. Collect the highest score before time runs out to win the game.",
    "instructions": "You can move with WASD and Arrow Keys Players can push each other using the Down Arrow key or the S key The player with the highest score at the end of the duration wins",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Christmas",
      "Santa Claus",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/dncor1an3qhktld28weh6bqzd56iw14s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dncor1an3qhktld28weh6bqzd56iw14s/",
    "sourceUrl": "https://html5.gamemonetize.com/dncor1an3qhktld28weh6bqzd56iw14s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73226",
    "slug": "duo-family-santa",
    "title": "Duo Family Santa",
    "description": "Steve and Alex need to race against each other. The one who holds the Lucky Block wins the game. Hold onto the Lucky Block until the time runs out to win the game. You can earn money by collecting socks and you can also earn money by defeating your friend. You must be very careful; steal the Lucky Block from your friend and keep it until the time is up.",
    "instructions": "Use the WASD and Arrow keys to move The player holding the Lucky Block when the time runs out wins the game Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade",
      "Christmas",
      "mineblock",
      "Minecraft",
      "Platform",
      "Santa",
      "Santa Claus",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/qn4ri5pm4ohq9mk391wpd6ka1fojxjk5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qn4ri5pm4ohq9mk391wpd6ka1fojxjk5/",
    "sourceUrl": "https://html5.gamemonetize.com/qn4ri5pm4ohq9mk391wpd6ka1fojxjk5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73857",
    "slug": "fruit-shotter",
    "title": "Fruit Shotter",
    "description": "Fruit Shooter is a fun casual game where you control a cannon to shoot and destroy various fruits. The more accurate your shots, the higher your score! But be careful, if you hit obstacles, you will fail. Observe the trajectory, aim precisely, and choose the right moment to eliminate all the fruits in each level.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Click",
      "Fruit",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/rd1t71grt2bw50p7hilqyr122vwam8i9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rd1t71grt2bw50p7hilqyr122vwam8i9/",
    "sourceUrl": "https://html5.gamemonetize.com/rd1t71grt2bw50p7hilqyr122vwam8i9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73871",
    "slug": "prime-ball-adventure-game",
    "title": "Prime Ball Adventure Game",
    "description": "Welcome to the world of prime ball games. Are you ready to embark on a thrilling journey filled with brain-teasing challenges and strategic gameplay? Get ready to challenge your brain with prime balls game. Pull the pin ball game where mind meets fun and logic creates beauty. This prime ball game is the perfect combination of challenging brain teasers, rewarding gameplay, and soothing antistress vibes. Its not just a prime ball game it&rsquo;s a test of skill, a workout for your mind, and a vibrant, rewarding journey.",
    "instructions": "- To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D",
      "Adventure",
      "Ball",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/uvzynzup76nhfiyyxph4kh1vjd7ixfy6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uvzynzup76nhfiyyxph4kh1vjd7ixfy6/",
    "sourceUrl": "https://html5.gamemonetize.com/uvzynzup76nhfiyyxph4kh1vjd7ixfy6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73859",
    "slug": "fnaf-secret-of-the-mimic",
    "title": "Fnaf Secret Of The Mimic",
    "description": "Step back into the terrifying world of Five Nights at Freddy&rsquo;s in FNAF: Secret of The Mimic! It&rsquo;s a chilling mix of logic, escape, and horror adventure that will test your nerves and your wits! You&rsquo;re trapped inside a dark, abandoned pizzeria where something far worse than Freddy lurks in the shadows - The Mimic.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Escape",
      "Horror",
      "Puzzle",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/slbqlihkv3nnqt3h91ddy10c8chi4ou0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/slbqlihkv3nnqt3h91ddy10c8chi4ou0/",
    "sourceUrl": "https://html5.gamemonetize.com/slbqlihkv3nnqt3h91ddy10c8chi4ou0/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73555",
    "slug": "real-car-highway-racing-game",
    "title": "Real Car Highway Racing Game",
    "description": "Gear up for the ultimate racing adventure! Real Car Highway Racing Offline Game combines high-speed action, intense car racing, and real highway challenges in an immersive driving experience. Dodge traffic, drift with precision, and dominate in this thrilling car game. Race iconic cars like the Rover MX 12, Lamborghini Cardo, Chevrolet Camaro, and Bugatti Veyron through car traffic while tackling high-speed racing and exciting challenges in this free street racing simulator.",
    "instructions": "Mobile controls available and for keyboard W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Best Games",
      "Car",
      "Race",
      "Racing",
      "Supercars"
    ],
    "thumbnail": "https://img.gamemonetize.com/vgx4unz2tl0ybefewcwzhhypzxsoydnk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vgx4unz2tl0ybefewcwzhhypzxsoydnk/",
    "sourceUrl": "https://html5.gamemonetize.com/vgx4unz2tl0ybefewcwzhhypzxsoydnk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73324",
    "slug": "antistress-relaxing-game",
    "title": "Antistress Relaxing Game",
    "description": "Antistress Game: Mini Fan Games is your perfect place to relax, calm your mind, and enjoy a collection of Fun Mini Games designed for pure peace. This Antistress game helps you unwind from your busy day and release tension through satisfying, interactive experiences. If you&rsquo;re looking for the best Anti stress games that bring instant calmness and joy, this is exactly what you need.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Adventure",
      "Arcade",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/gnx894mbhc7271np4gvgo3w2efqcmwcp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gnx894mbhc7271np4gvgo3w2efqcmwcp/",
    "sourceUrl": "https://html5.gamemonetize.com/gnx894mbhc7271np4gvgo3w2efqcmwcp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73831",
    "slug": "hand-or-money",
    "title": "Hand Or Money",
    "description": "Hand Or Money is a fast reaction and timing game about pure risk and reward. Wait for the right moment, then click to stretch your hand out and grab the cash hiding behind a dangerous guillotine. Mistime it and you lose your hand &mdash; time it perfectly to snatch the money and build up big combos for extra rewards. Between rounds, choose one of three random buffs to power up your run, stack crazy effects, and see how far your luck and reflexes can take you.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Click",
      "endless",
      "onetouch",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/4sq7lw5if1rq337i7wkq4c9ww11ox940/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4sq7lw5if1rq337i7wkq4c9ww11ox940/",
    "sourceUrl": "https://html5.gamemonetize.com/4sq7lw5if1rq337i7wkq4c9ww11ox940/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72225",
    "slug": "word-search-2025",
    "title": "Word Search 2025",
    "description": "&laquo;Word Search: Puzzle Game&raquo; is designed for fans of word puzzles. Letters are placed on the board, and your goal is to form words from them. Fill the grid, unlock new levels, complete tasks, and increase your rating. Compete with players from around the world for the title of the most attentive and knowledgeable.",
    "instructions": "With mouse click and hold the left button drag over the letters to select a word release to confirm On touch device tap and hold drag over the letters lift your finger to confirm",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/ppnf5uy8xk2zjtqzqbrkvtc0yuitwp5o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ppnf5uy8xk2zjtqzqbrkvtc0yuitwp5o/",
    "sourceUrl": "https://html5.gamemonetize.com/ppnf5uy8xk2zjtqzqbrkvtc0yuitwp5o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73186",
    "slug": "an-origami-dolphin",
    "title": "an origami dolphin",
    "description": "An Origami Dolphin is a relaxing skill game inspired by the art of origami. Guide a folded paper dolphin through textured blue origami tubes, collecting points as you pass through. Bubbles float gently by. With simple controls (tap or click to jump), minimalist graphics, and smooth visual effects, it offers accessible, stress-free fun. Ideal for all ages. Beat your high score in style!",
    "instructions": "mause",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/s7002s0hrcmu05ctum972pkfe5eli68b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s7002s0hrcmu05ctum972pkfe5eli68b/",
    "sourceUrl": "https://html5.gamemonetize.com/s7002s0hrcmu05ctum972pkfe5eli68b/",
    "width": 360,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "73641",
    "slug": "fruit-block-tetra-puzzle",
    "title": "Fruit Block Tetra Puzzle",
    "description": "Fruit Block Tetra Puzzle is a fast and fun block puzzle game where you place fruit-shaped blocks to clear lines and collect target fruits before time runs out. Complete each fruit goal to level up and unlock new challenges. Easy to play, satisfying to master, and perfect for quick, brain-boosting fun!",
    "instructions": "Use your mouse or touchpad to drag fruit blocks into the grid place them strategically and clear lines to collect target fruits",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Collecting",
      "Fruit",
      "Puzzle",
      "Skill",
      "Tetris"
    ],
    "thumbnail": "https://img.gamemonetize.com/j6megw9uguvx0ar4mom5cl0137zjo5d9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j6megw9uguvx0ar4mom5cl0137zjo5d9/",
    "sourceUrl": "https://html5.gamemonetize.com/j6megw9uguvx0ar4mom5cl0137zjo5d9/",
    "width": 450,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73534",
    "slug": "flappy-blitz-intercept",
    "title": "Flappy Blitz: Intercept",
    "description": "Get ready for an adrenaline-pumping twist on the classic flapping frenzy! In Flappy Blitz: Intercept, youre not just avoiding obstacles; youre a nimble, pixel-art jet tasked with a critical mission: Intercept the enemy missiles! Navigate a relentless barrage of incoming pipes and guided enemy rockets. Tap to flap your wings and maintain altitude. Time your taps perfectly to slip through the gaps, but keep a keen eye out for the fast-moving missiles&mdash;theyll track you! Score points by passing through the pipes and by strategically leading the enemy missiles into them for a satisfying Blitz bonus!",
    "instructions": "Mobile Touch Screen Tap anywhere on the screen to flap the jets wings and gain altitude Release to descend PC Keyboard Press the Spacebar or up arrow key to flap the jets wings and gain altitude Release to descend",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Action",
      "Arcade",
      "flappybird",
      "Flight",
      "unblockedgames76"
    ],
    "thumbnail": "https://img.gamemonetize.com/t4oj8lz7bkon6p6evtftnahw8mlt4wj2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t4oj8lz7bkon6p6evtftnahw8mlt4wj2/",
    "sourceUrl": "https://html5.gamemonetize.com/t4oj8lz7bkon6p6evtftnahw8mlt4wj2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73670",
    "slug": "dead-survival-zombie-shooter",
    "title": "Dead Survival: Zombie Shooter",
    "description": "Dive into Dead Survival: Zombie Shooter, the ultimate offline zombie shooting game designed for intense action and survival horror fans. Battle through a post-apocalyptic world overrun by the undead. With stunning graphics, powerful weapons, and smart zombie AI, every second is a fight for survival.",
    "instructions": "WASD rarr Move Left Mouse Click rarr Shoot Right Mouse Click rarr Scope Middle Mouse rarr Switch Weapon R rarr Reload Z rarr Lock cursor ESC rarr Unlock cursor",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Shooting",
      "survival",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/dyxwy4707q834y994kunt3e4ea94e12m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dyxwy4707q834y994kunt3e4ea94e12m/",
    "sourceUrl": "https://html5.gamemonetize.com/dyxwy4707q834y994kunt3e4ea94e12m/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73815",
    "slug": "go-golf",
    "title": "Go Golf",
    "description": "GoGolf is a fun sports game where you have to hit the golf ball into the hole with a limited number of strokes. Each level features different terrains, requiring you to observe carefully and aim precisely. Just a slight misdirection or overhit, and youll lose a valuable turn. Think carefully, score perfectly, and conquer every challenge!",
    "instructions": "Use mouse to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Casual",
      "Click",
      "Golf",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/vyoai08811vqppdfilocq5k1f7emjsxg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vyoai08811vqppdfilocq5k1f7emjsxg/",
    "sourceUrl": "https://html5.gamemonetize.com/vyoai08811vqppdfilocq5k1f7emjsxg/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73659",
    "slug": "makeover-run-3d",
    "title": "Makeover Run 3D",
    "description": "Makeover Run 3D is a casual dress-up parkour game. Just slide to control the girls to choose different styles of clothes. By making choices along the way, see if your matching can win the favor of the prince!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Casual",
      "Dress Up",
      "Logic",
      "running",
      "slider"
    ],
    "thumbnail": "https://img.gamemonetize.com/93gho8zm44tyfplow05psa1w59wtima7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/93gho8zm44tyfplow05psa1w59wtima7/",
    "sourceUrl": "https://html5.gamemonetize.com/93gho8zm44tyfplow05psa1w59wtima7/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73149",
    "slug": "stair-rush",
    "title": "Stair Rush",
    "description": "Stair Rush is a fast-paced hyper-casual runner where your character automatically runs forward on a narrow track filled with obstacles, blocks, and platforms. Your goal is to collect tiles, build stairs, avoid obstacles, and reach the finish line. The more tiles you collect, the further you can climb, and the higher your score will be. Each level increases difficulty with tighter paths, moving obstacles, and bigger challenges. Players must react quickly, time their moves, and keep their balance to survive the course and complete the level.",
    "instructions": "Mobile Touch - Tap amp Hold rarr Start running forward - Drag Left Right rarr Move your character sideways on the track - Release rarr Sometimes can stop building stairs or control movement PC - Left Arrow A rarr Move Left - Right Arrow",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Collection",
      "Hypercasual",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/qdz9rleg7bpgb74ho1pzumfof61g4kta/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qdz9rleg7bpgb74ho1pzumfof61g4kta/",
    "sourceUrl": "https://html5.gamemonetize.com/qdz9rleg7bpgb74ho1pzumfof61g4kta/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "70800",
    "slug": "jumping-birds",
    "title": "Jumping Birds",
    "description": "Jumping Birds is a game of skill and reflexes where players take on the roles of adventurous birds embarking on an endless ascent above the clouds. The game world blends colorful environments, dynamic platforming, and a fast pace that demands precision, anticipation, and speed. Each bird has its own unique movement style, but they all share a common goal: to climb ever higher by jumping from platform to platform, avoiding obstacles, and taking advantage of power-ups scattered throughout the environment. The core gameplay revolves around a reactive jumping system that rewards players who master their timing.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Cartoon",
      "jump",
      "Jumping"
    ],
    "thumbnail": "https://img.gamemonetize.com/knkznkotvxga9vqrltcjq25nt10vejzy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/knkznkotvxga9vqrltcjq25nt10vejzy/",
    "sourceUrl": "https://html5.gamemonetize.com/knkznkotvxga9vqrltcjq25nt10vejzy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73085",
    "slug": "shiny-dodge",
    "title": "Shiny Dodge",
    "description": "Shiny Dodge is a fast, addictive arcade dodging game where you control a glowing energy orb and survive as long as possible! Move left and right to avoid falling red spikes while collecting coins and rare golden stars to increase your score. Pick up powerful abilities like Shield, Magnet, and Slow Motion to stay alive longer and push your high score even higher. The game starts simple but quickly becomes challenging as falling objects speed up over time. Each run is unique thanks to randomized spawns and smooth controls. Play with keyboard arrows or use simple touch controls on mobile.",
    "instructions": "Desktop Left Arrow - Move Left Right Arrow - Move Right Mobile Touch and Drag on screen to move the player left right tap pause button to pause game tap sound button to toggle audio",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Casual",
      "Collection",
      "Escape"
    ],
    "thumbnail": "https://img.gamemonetize.com/6wrigosarx8psz95dcfcrcsaus91jgk5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6wrigosarx8psz95dcfcrcsaus91jgk5/",
    "sourceUrl": "https://html5.gamemonetize.com/6wrigosarx8psz95dcfcrcsaus91jgk5/",
    "width": 400,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73150",
    "slug": "counterflow",
    "title": "COUNTERFLOW",
    "description": "COUNTERFLOW is a fast-paced lane-switching driving game. Avoid oncoming cars, survive as long as you can, and break your best record. Simple controls, clean visuals, and increasing speed make every run intense and addictive.",
    "instructions": "Desktop Left Right Arrow ndash Move between lanes A D ndash Move between lanes Space ndash Pause Resume Mobile Tap left right side of the screen ndash Move between lanes Tap top area of the screen ndash Pause",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "Avoid",
      "Car",
      "Driving"
    ],
    "thumbnail": "https://img.gamemonetize.com/5qvdrkrue8qnbn4gstx4xygxbio0ul6g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5qvdrkrue8qnbn4gstx4xygxbio0ul6g/",
    "sourceUrl": "https://html5.gamemonetize.com/5qvdrkrue8qnbn4gstx4xygxbio0ul6g/",
    "width": 540,
    "height": 1440,
    "lastUpdated": ""
  },
  {
    "id": "73188",
    "slug": "ole-bunny",
    "title": "Ole Bunny",
    "description": "Ole Bunny plunges you into a crazy arena where a cute bunny finds himself because of his love for roses ! Now you must show courage and skill to escape the wild bulls and collect as many fragrant roses as possible. Can you become the best bunny matador of all time?",
    "instructions": "How to play bull Ole Bunny moves only in an O shape bull Each click changes the direction of movement bull The compass shows you the way to the roses bull Eat carrots to gain special abilities ----- Music Kevin MacLeod incompetech com Lic",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "amazing",
      "Animal",
      "Arcade",
      "Arena",
      "Best",
      "Best Games",
      "Cartoon",
      "Cute",
      "Hypercasual",
      "Rabbit",
      "run",
      "touch",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/6uelofb3wuyay5oy6qkspegpnngxu0m4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6uelofb3wuyay5oy6qkspegpnngxu0m4/",
    "sourceUrl": "https://html5.gamemonetize.com/6uelofb3wuyay5oy6qkspegpnngxu0m4/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73352",
    "slug": "dots-and-boxes-2",
    "title": "Dots and Boxes 2",
    "description": "Dots and Boxes 2.0 is a modern, feature-rich version of the classic pen-and-paper strategy game where players take turns connecting dots to form squares (boxes). The player who completes the most boxes wins! This version offers multiple ways to play:vs AI Bot: Challenge yourself against three difficulty levels: Normal, Hard, and Expert.Two Players: Enjoy local multiplayer with a friend.The game features a customizable board size up to 20x20, color settings for both players, and a Quick Game option to start with 40% of the lines already filled. The game also includes statistics tracking and is designed with resp",
    "instructions": "Mouse Touch Click or tap on an empty space between two dots to draw a line",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player Games",
      "2025 games",
      "arrow",
      "Board",
      "HTML5"
    ],
    "thumbnail": "https://img.gamemonetize.com/njg32276zi9zg95bn3uc185d107hraix/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/njg32276zi9zg95bn3uc185d107hraix/",
    "sourceUrl": "https://html5.gamemonetize.com/njg32276zi9zg95bn3uc185d107hraix/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73475",
    "slug": "doodle-jump-4",
    "title": "Doodle Jump 4",
    "description": "Doodle Jump v4 - Ultra Edition is a highly optimized and feature-rich arcade platformer. The goal is to jump on platforms and climb as high as possible without falling. This version introduces key mobile features, including a dedicated Pause button in the header, Touch Controls (left/right buttons) for movement, and Mobile Tilt Controls (off by default) for a classic experience. It features an expanded Settings menu with controls for Graphics Quality, an FPS Counter, and a Map overlay for height tracking. Players can also choose from an expanded roster of characters, including Santa and Ninja Doodles, in addition to the classics. Jump on plat",
    "instructions": "Keyboard Arrow Keys or A D for movement Mobile Tilt Enabled in Settings tilt the device left right to move Mobile Touch Left and Right directional buttons at the bottom of the screen",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2025 games",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/ufndae85yssn1i6ddmyxsvluxg590wvh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ufndae85yssn1i6ddmyxsvluxg590wvh/",
    "sourceUrl": "https://html5.gamemonetize.com/ufndae85yssn1i6ddmyxsvluxg590wvh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73687",
    "slug": "obby-99-nights-escape-1-speed",
    "title": "Obby: 99 Nights Escape +1 Speed",
    "description": "This is a thrilling adventure survival game where each night brings new dangers. Upgrade your hero&rsquo;s speed and energy to overcome harder and harder levels and try to make it through all 99 nights. You will face various challenges: &mdash; escaping from raging deer, &mdash; running across disappearing bridges, &mdash; navigating confusing labyrinths, &mdash; avoiding traps, obstacles, and forest surprises. Collect power-ups, train at special stations, boost your stats, and unlock new areas. Each night becomes more difficult as enemies grow faster and smarter. Survive all 99 nights and prove you can escape this dangerous forest!",
    "instructions": "PC Controls WASD mdash Movement Mouse mdash Camera control Space mdash Jump Mobile Controls Use on-screen buttons Drag anywhere mdash Camera control",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Animal",
      "Anime",
      "Arcade",
      "Casual",
      "egg",
      "eggames",
      "eggs",
      "Horror",
      "Kids",
      "Minecraft",
      "OnlyUp",
      "roblox",
      "Sport",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/k1eahl1b9wxc6vqzxloqtvfzh5ai9csw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k1eahl1b9wxc6vqzxloqtvfzh5ai9csw/",
    "sourceUrl": "https://html5.gamemonetize.com/k1eahl1b9wxc6vqzxloqtvfzh5ai9csw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72844",
    "slug": "harvest-glam",
    "title": "Harvest Glam",
    "description": "Glam is the ultimate fall-themed makeup and dress-up game where cozy vibes meet high fashion! Create stunning autumn looks using warm palettes, golden highlights, and stylish seasonal outfits. Mix earthy tones, layered hairstyles, and rustic accessories to craft the perfect fall aesthetic. Celebrate sweater weather with endless glam possibilities in this cozy-chic makeover adventure!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "beauty",
      "Dress Up",
      "Fashion",
      "Girl",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/dzrrj6ge0x1m20bc5bo0iqx4g1pklmsr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dzrrj6ge0x1m20bc5bo0iqx4g1pklmsr/",
    "sourceUrl": "https://html5.gamemonetize.com/dzrrj6ge0x1m20bc5bo0iqx4g1pklmsr/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "73777",
    "slug": "car-racing-3d-extreme-dodge",
    "title": "Car Racing 3D: Extreme Dodge",
    "description": "Car Racing 3D: Extreme Dodge is a fast-paced racing game where your only goal is to survive at high speeds. Steer left and right to avoid traffic, obstacles and road hazards. Use boosters at the perfect moment to break through tense situations and chase higher scores. Unlock new cars from the store, upgrade their stats, and push your driving skills to the limit in non-stop 3D racing challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Avoid",
      "Car",
      "Casual",
      "Driving",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/jpvsnofjw5cqhov1a2sjeu3521tn1tc2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jpvsnofjw5cqhov1a2sjeu3521tn1tc2/",
    "sourceUrl": "https://html5.gamemonetize.com/jpvsnofjw5cqhov1a2sjeu3521tn1tc2/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73313",
    "slug": "pipe-connect-puzzle-game",
    "title": "Pipe Connect Puzzle Game",
    "description": "Pipe Connect - Plumbing Puzzle Challenge immerses you in the captivating world of plumbing puzzles and brain-teasing challenges designed to enhance your problem-solving abilities. Your objective is to strategically connect pipes to create an unbroken pipeline, all while overcoming various obstacles. Each level presents a unique and intriguing plumbing puzzle that awaits your solution. To succeed, youll need to apply critical thinking, planning, and precise pipe connections to ensure a smooth flow and prevent any leaks.",
    "instructions": "Use Mouse To Play Game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/b6inwt2c5d2hkk39omcv6e7e1m4he3y9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b6inwt2c5d2hkk39omcv6e7e1m4he3y9/",
    "sourceUrl": "https://html5.gamemonetize.com/b6inwt2c5d2hkk39omcv6e7e1m4he3y9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73353",
    "slug": "marshmallow-rush",
    "title": "Marshmallow Rush",
    "description": "Marshmallow Rush is a one-button runner where you tap at the right moment to stack fluffy marshmallows, weave through cute obstacles, and dash to the finish. Build the tallest, sweetest tower you can, snag boosters for extra points, and master the timing to clear tricky layouts. Simple to play, satisfying to perfect&mdash;how far can your marshmallow tower go?",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Casual",
      "Clicker",
      "onetouch",
      "run",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/qo6b7wd58bvy8is0umvi9ymripyxbmk3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qo6b7wd58bvy8is0umvi9ymripyxbmk3/",
    "sourceUrl": "https://html5.gamemonetize.com/qo6b7wd58bvy8is0umvi9ymripyxbmk3/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73657",
    "slug": "whack-a-mole-pixel-version",
    "title": "Whack a Mole   Pixel Version",
    "description": "-&gt; Whack a Mole &ndash; Pixel Version is a fast-paced arcade game in a retro pixel style where your goal is to hit as many moles as you can before they disappear. Test your reaction speed, focus, and tapping skills! -&gt; Gameplay: Moles appear randomly on the screen &mdash; your task is to tap them before they hide again. Each successful hit earns you points, while bombs take away them! -&gt; Goal: Get as many points as possible in a limited time and beat your own record!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Arcade",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/xwfmok1iu5miopfeyqwzpt4flna2na6d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xwfmok1iu5miopfeyqwzpt4flna2na6d/",
    "sourceUrl": "https://html5.gamemonetize.com/xwfmok1iu5miopfeyqwzpt4flna2na6d/",
    "width": 960,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "73328",
    "slug": "mini-asmr-relaxing-games",
    "title": "Mini ASMR Relaxing Games",
    "description": "People forget to take a break from their regular tasks because they are concerned with them. We are here to serve you in de-stressing with antistress calming games &amp; relaxing toys slime simulator provides you with anxiety relief games &amp; Antistress Relaxing toy Games. These antistress puzzle toys game and satisfying fidget games are an excellent way to release your stress and are best for a peaceful mind. Best ASMR games offer the most pleasant sensory toys in the AntiStress games, providing you a a delightful fulfilling experience to focus, relax, and control your anxiety. You can relax and overcome anxiety by listening to soothing music.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/5blz73jojw0zw9fgoy0dkvfsgv4xo862/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5blz73jojw0zw9fgoy0dkvfsgv4xo862/",
    "sourceUrl": "https://html5.gamemonetize.com/5blz73jojw0zw9fgoy0dkvfsgv4xo862/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73608",
    "slug": "shape-puzzle",
    "title": "Shape Puzzle",
    "description": "Shape Puzzle is a simple yet captivating puzzle game where you adjust pieces of different shapes and place them in the correct positions on the board. Each level presents a new layout, requiring you to observe carefully, rotate, and arrange each piece precisely to complete the picture. As you progress, the difficulty increases with more complex shapes, forcing you to think carefully and arrange them skillfully. With intuitive gameplay, sharp graphics, and a highly satisfying sense of completion, Shape Puzzle offers a relaxing yet challenging experience for all players.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Click",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/dpbl07ksovtacdqlan1u5fp52gf43hia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dpbl07ksovtacdqlan1u5fp52gf43hia/",
    "sourceUrl": "https://html5.gamemonetize.com/dpbl07ksovtacdqlan1u5fp52gf43hia/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73688",
    "slug": "fashionista-christmas-eve-party",
    "title": "Fashionista Christmas Eve Party",
    "description": "Indulge in the Fashionista Christmas Eve Party extravaganza! Discover glamorous holiday ensembles, festive accessories, and the perfect blend of chic for a stylish celebration. Join the fashion-forward festivities and elevate your Christmas Eve style to new heights. Unwrap the magic of the season with Fashionista, where every outfit is a statement and every moment is a fashion triumph. Let the glamour of Christmas Eve unfold.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Christmas",
      "Dress Up",
      "Fashion",
      "Holiday",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/5atjh0rucpsr1fsh0pkgzkj15r4xjkia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5atjh0rucpsr1fsh0pkgzkj15r4xjkia/",
    "sourceUrl": "https://html5.gamemonetize.com/5atjh0rucpsr1fsh0pkgzkj15r4xjkia/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73511",
    "slug": "carrom-pro",
    "title": "carrom pro",
    "description": "Experience the ultimate digital adaptation of the classic Carrom board game! Carrom Pro blends realistic physics with modern arcade aesthetics for a smooth, competitive experience. Game Modes: Classic Carrom: Traditional rules with the Queen. Disc Pool: Fast-paced action, clear your pucks first. Freestyle: Point-based arcade scoring. Features: Global Arenas: Progress from Dhaka to NYC. Realistic Physics: Smooth controls and collisions. Pass &amp; Play: Offline local multiplayer. Daily Rewards: Lucky spins and quests. Leaderboards: Climb the ranks! Download Carrom Pro now and become the King of the Board!",
    "instructions": "How to Play Aiming Drag your finger anywhere on the screen or the striker baseline to position your Striker Shooting Pull back on the Striker to set power and direction Release to shoot Objective Carrom Disc Pool Pot all your colored pieces Whit",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "2 Player",
      "Board",
      "Multiplayer"
    ],
    "thumbnail": "https://img.gamemonetize.com/ts6iu4xqkctvpkau5yk4hwdkr3nwbsn7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ts6iu4xqkctvpkau5yk4hwdkr3nwbsn7/",
    "sourceUrl": "https://html5.gamemonetize.com/ts6iu4xqkctvpkau5yk4hwdkr3nwbsn7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73504",
    "slug": "tower-breaker",
    "title": "Tower Breaker",
    "description": "Tower Breaker is a physics-based destruction game where you throw different types of projectiles, collapse towers, break structures, and experiment with realistic physics. Pull the rope, aim, and release &mdash; each ball has unique properties and opens new ways to bring the entire city down.Spectacular destruction, falling debris, explosions, and endless chaos. Every level is different &mdash; sturdy towers, fragile constructions, ultra-tall buildings, bonus structures, and even randomly generated cities.",
    "instructions": "Hold amp amp Drag ndash pull the ropeRelease ndash shoot the ballMove Cursor ndash aimClick Buttons ndash select ball type and use the menu",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "crash",
      "destroy",
      "Mouse",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/vzlf957tf696fqliepaa9gkcgd2omtx9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vzlf957tf696fqliepaa9gkcgd2omtx9/",
    "sourceUrl": "https://html5.gamemonetize.com/vzlf957tf696fqliepaa9gkcgd2omtx9/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73656",
    "slug": "flower-fairy-adventure-story",
    "title": "Flower Fairy Adventure Story",
    "description": "Welcome to Flower Fairy Adventure Story, a casual puzzle game that you can play for free. Flower Fairy lost her wings! Embark on an adventure where you solve each tiny jigsaw, dress up your girl in pretty clothes, and pave the way for the Flower Fairy.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Dress Up",
      "Girls",
      "Jigsaw",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/5ou6u5a1fbiqfwzd3dnraxbcwg7d28sf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5ou6u5a1fbiqfwzd3dnraxbcwg7d28sf/",
    "sourceUrl": "https://html5.gamemonetize.com/5ou6u5a1fbiqfwzd3dnraxbcwg7d28sf/",
    "width": 1600,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "71541",
    "slug": "fall-aesthetics",
    "title": "Fall Aesthetics",
    "description": "Get ready to conquer the fashion world with Fall Aesthetics! Travel the globe alongside our stylish crew and unlock your inner fashionista. Mix and match outfits inspired by the vibrant streets of New York, the golden sunsets of Tuscany, the mesmerizing festivals, the traditional beauty of Japan, and the enchanting charm of Scotland. With endless options for dressing up and a touch of wit and fun, Fall Aesthetics will keep you entertained for hours. Play now and let your fashion sense shine like never before!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/w2plop8mnxgcdps57l4ks5yx9lzzkuzv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w2plop8mnxgcdps57l4ks5yx9lzzkuzv/",
    "sourceUrl": "https://html5.gamemonetize.com/w2plop8mnxgcdps57l4ks5yx9lzzkuzv/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72863",
    "slug": "monster-escape-logic-puzzle-adventure",
    "title": "Monster Escape: Logic Puzzle Adventure",
    "description": "Monster Escape is a thrilling logic puzzle game where every move counts! Rotate the world, dodge deadly traps, and guide your monster to the key in order to escape the dungeon. With 60 challenging levels, brain-teasing mechanics, and fast reflex gameplay, this adventure will test your strategy skills and puzzle-solving abilities. Avoid falling boxes, sharp thorns, and tricky obstacles as you explore mysterious dungeon worlds. Each level becomes harder, pushing you to think smarter, move quicker, and master the physics-based rotation system. Perfect for fans of escape games, monster adventure games, brain puzzles, and skill-based platformers.",
    "instructions": "Use the onscreen buttons to rotate the monster rsquo s world Tap left or right of the monster to walk without rotating the level Reach the key avoid traps and escape the dungeon",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/iswcg23g2usoz6y1uj4kjb92um44r24i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iswcg23g2usoz6y1uj4kjb92um44r24i/",
    "sourceUrl": "https://html5.gamemonetize.com/iswcg23g2usoz6y1uj4kjb92um44r24i/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "73392",
    "slug": "jewelry-match-puzzle-game",
    "title": "Jewelry Match Puzzle Game",
    "description": "Dive into the enchanting world of Jewelry Match Puzzle Game, beloved by millions of players worldwide! This captivating match-3 puzzle game is perfect for puzzle enthusiasts of all ages, offering thousands of unique levels filled with challenges and obstacle",
    "instructions": "Mouse click to play Game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/spacg9g3ocw5proj2m7p2bxe8fmet3dy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/spacg9g3ocw5proj2m7p2bxe8fmet3dy/",
    "sourceUrl": "https://html5.gamemonetize.com/spacg9g3ocw5proj2m7p2bxe8fmet3dy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73325",
    "slug": "mini-pocket-game-2025",
    "title": "Mini Pocket Game 2025",
    "description": "This relaxing toy game includes dozens of satisfying objects to touch, tap, and play with &mdash; giving you a real sense of calm and mindfulness. Each update adds new relaxing experiences to keep your journey fresh and enjoyable. With realistic haptics, ASMR-inspired sounds, and vibrant visuals, every session in this Antistress Relaxing Game and Antistress - Relaxing Mini Game feels like therapy.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Best Games",
      "Brainrot",
      "Color"
    ],
    "thumbnail": "https://img.gamemonetize.com/affiobu9gimfnfg27qqj1hiikr41zmdl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/affiobu9gimfnfg27qqj1hiikr41zmdl/",
    "sourceUrl": "https://html5.gamemonetize.com/affiobu9gimfnfg27qqj1hiikr41zmdl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73638",
    "slug": "push-gold",
    "title": "Push Gold",
    "description": "PushGold is a puzzle game where you take on the role of a clever miner tasked with pushing gold blocks to their designated positions. Every move requires careful calculation because the narrow terrain can cause you to get stuck. As you progress through levels, the difficulty gradually increases with more obstacles and tight tunnels, forcing you to observe, plan, and choose the correct pushing direction. Conquer the mine and collect gold in the most skillful way!",
    "instructions": "Use arrow buttons to move",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Block",
      "Brain",
      "Logic"
    ],
    "thumbnail": "https://img.gamemonetize.com/dv7mvugfv11ml7sih07edfvus2fziyfk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dv7mvugfv11ml7sih07edfvus2fziyfk/",
    "sourceUrl": "https://html5.gamemonetize.com/dv7mvugfv11ml7sih07edfvus2fziyfk/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73348",
    "slug": "easy-coloring-labubu-time",
    "title": "Easy Coloring Labubu Time",
    "description": "Easy Coloring Labubu Time is super fun and free to play online coloring game for kids. Choose one of the images and make a master piece! Have fun!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Arcade",
      "Coloring",
      "Educational",
      "Fun",
      "Hypercasual",
      "Kids",
      "Labubu",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/ssspxwzt95e93vzbhabrl3rbomuzzyc5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ssspxwzt95e93vzbhabrl3rbomuzzyc5/",
    "sourceUrl": "https://html5.gamemonetize.com/ssspxwzt95e93vzbhabrl3rbomuzzyc5/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73544",
    "slug": "neon-ping-pong",
    "title": "Neon Ping Pong",
    "description": "Dive into the futuristic, fast-paced action of Neon Ping Pong 2.0, The Championship Edition! This modern take on classic Pong features stunning neon graphics, intense gameplay, and multiple modes. Challenge the increasingly difficult AI in 1-Player mode, or face off against a friend in 2-Player local mode. V2.0 Updates: Customize your game experience with the new Settings Menu, allowing you to adjust paddle size and set a maximum ball speed limit for controlled chaos.",
    "instructions": "Player 1 Left Paddle Keyboard Use the W key to move the paddle up and the S key to move the paddle down Mouse Touch Move the mouse or drag your finger on the left half of the screen to control the paddle position Player 2 Right Paddle - 2-Player M",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Action",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/r4v95rc6m6gypa5pgwwdune2jngh6i4p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r4v95rc6m6gypa5pgwwdune2jngh6i4p/",
    "sourceUrl": "https://html5.gamemonetize.com/r4v95rc6m6gypa5pgwwdune2jngh6i4p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73590",
    "slug": "cosmic-defender",
    "title": "Cosmic Defender",
    "description": "Cosmic Defender 2.1 is a fast-paced, retro-styled vertical arcade shooter (Shmup) set against a cyberpunk sci-fi backdrop. Pilot the powerful Cosmic Defender starship to fend off a galaxy-wide invasion. Battle through multiple levels, destroying formations of diverse enemy types - from Interceptors to Juggernauts - that descend upon you. Clear the enemy ranks to engage and defeat a unique, powerful Boss at the end of each protocol level. Survive all challenges to face the ultimate Final Boss encounter. Earn high scores and track your lifetime statistics as you defend the cosmos.",
    "instructions": "Move Ship Move Mouse Cursor Touch Drag on mobile or use Keyboard keys A Left Arrow and D Right Arrow Fire Weapon Hold Mouse Click Hold Touch or Hold SPACEBAR Pause Menu Press Escape or the P key",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Action",
      "Fight",
      "Retro",
      "Science",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/hpps4rzujsi2jzxw7thbkypm3sb4mq0q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hpps4rzujsi2jzxw7thbkypm3sb4mq0q/",
    "sourceUrl": "https://html5.gamemonetize.com/hpps4rzujsi2jzxw7thbkypm3sb4mq0q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73631",
    "slug": "monster-egg",
    "title": "Monster Egg",
    "description": "Begin the wildest evolution adventure ever in Monster Egg! This is not just a simple running game. It&rsquo;s a fast-paced action platform full of monsters, DNA collecting, and epic battles. You start as a small egg on the track. Run and collect DNA orbs. Your monster evolves into stronger and crazier forms!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "eggs",
      "Monster",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/a6mlyusljrtcoyhetis4m6u4rxbdymda/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a6mlyusljrtcoyhetis4m6u4rxbdymda/",
    "sourceUrl": "https://html5.gamemonetize.com/a6mlyusljrtcoyhetis4m6u4rxbdymda/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73514",
    "slug": "shark-boy",
    "title": "Shark Boy",
    "description": "Shark Boy is a colorful underwater puzzle game where you will accompany the boy and his friendly whale on a quest to find precious golden shells. Skillfully utilize anchors to pull, swing, or create momentum to move the two main characters precisely to each position. Each level presents a new challenge with unique terrain, different obstacle arrangements, and numerous dangers lurking in the deep water. Just one miscalculation can cause you to fall into a trap or collide with dangerous creatures. Observe carefully, plan your path logically, and collect all the golden shells to complete the mission. With gameplay that is both rel",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Click",
      "Logic"
    ],
    "thumbnail": "https://img.gamemonetize.com/wsyqf99n87edjqqnatiyhiqb8qv5aaim/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wsyqf99n87edjqqnatiyhiqb8qv5aaim/",
    "sourceUrl": "https://html5.gamemonetize.com/wsyqf99n87edjqqnatiyhiqb8qv5aaim/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73405",
    "slug": "monster-boom-boom",
    "title": "Monster Boom Boom",
    "description": "Monster Boom Boom is a fun and challenging puzzle game where you use special vials created from green monsters to eliminate all the monsters on the arena. Each move is precious because the number of actions is limited. You need to carefully calculate the position, shooting direction, and timing to create an optimal chain explosion, clearing all enemies in just a few steps. With exciting explosion effects, the gameplay is both simple and strategic, offering thrilling and satisfying puzzle experiences.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Alien",
      "Brain",
      "Click",
      "Monster",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/762jwzjxrf7he4af39rywycw6xpzib4d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/762jwzjxrf7he4af39rywycw6xpzib4d/",
    "sourceUrl": "https://html5.gamemonetize.com/762jwzjxrf7he4af39rywycw6xpzib4d/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73572",
    "slug": "red-up-survival-offline-game",
    "title": "Red Up Survival Offline Game",
    "description": "Red up is an amazing platformer game, where you can control fireboy on his stick adventure to rescue watergirl. They are also the main characters of Red And Blue Stickman Animation, so this classic fire and water game will be so exciting. Escape from the castle full of tricks and mysterious puzzles. This escape room game will challenge your ability to solve puzzles! The Terrible Villain grabbed the Princess and set traps on the way to her rescue. A brave knight can save the girl hidden in the tricky tower of the crossy castle! Hurry up, the trap adventures are waiting!",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D",
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/uvzrxu8peda71uin0gxeqdinrly6kwob/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uvzrxu8peda71uin0gxeqdinrly6kwob/",
    "sourceUrl": "https://html5.gamemonetize.com/uvzrxu8peda71uin0gxeqdinrly6kwob/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73413",
    "slug": "mini-no-wifi-games-2024",
    "title": "Mini No Wifi Games 2024",
    "description": "But relaxation isnt just about what you do &ndash; its also about how you feel. Thats why weve included exercises to help you chill out and de-stress. We also have exercises to help you relax, like taking deep breaths. Our anti-stress mobile game is always at your fingertips, ready to provide you with a moment of relaxation whenever you need it most. These quick and easy relaxing games are perfect for anyone, anytime. Find satisfaction in our stress relief games as you engage in calming activities that melt away tension and leave you feeling refreshed.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2D",
      "3D Games",
      "Adventure",
      "Baby Games",
      "Casual",
      "free games for your site",
      "free games for your website",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/0bxsnepcupr0twu3umvmdxnso7kzwwr3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0bxsnepcupr0twu3umvmdxnso7kzwwr3/",
    "sourceUrl": "https://html5.gamemonetize.com/0bxsnepcupr0twu3umvmdxnso7kzwwr3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73404",
    "slug": "cozy-pizzeria",
    "title": "Cozy Pizzeria",
    "description": "Run a cozy pizza shop that grows into a city-wide chain. Hire and manage staff, upgrade ovens and counters, buy new land, balance morale to prevent strikes, and keep the dough&mdash;and cash&mdash;rolling.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Casual",
      "Management",
      "pizza",
      "Restaurant",
      "Simulation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/la3akmhdsim4g3vztf22xdk3recbrkec/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/la3akmhdsim4g3vztf22xdk3recbrkec/",
    "sourceUrl": "https://html5.gamemonetize.com/la3akmhdsim4g3vztf22xdk3recbrkec/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73369",
    "slug": "found-it-hidden-object-game",
    "title": "Found It! Hidden Object Game",
    "description": "The addictive &amp; FREE hidden objects puzzle game for you to train your brain and kill boredom! Take the challenge and relax with super fun hidden object puzzles and casual finding games. Spot, seek and FIND IT now! Feeling stressed from a day of work? Are you searching for the perfect hidden objects game to kill your time? You will definitely be addicted to this free Find It puzzle and new finding game. Be a super spy&zwj;, relax your mind, and solve countless hidden objects puzzles as quickly as you can!",
    "instructions": "Mouse click to play Game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/rpque3q0zlm0z2jiecj7wmokvr4wzai8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rpque3q0zlm0z2jiecj7wmokvr4wzai8/",
    "sourceUrl": "https://html5.gamemonetize.com/rpque3q0zlm0z2jiecj7wmokvr4wzai8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73294",
    "slug": "number-merger",
    "title": "number merger",
    "description": "Dive into the ultimate idle puzzle experience with Number Merger Infinite! Drag and merge blocks to reach impossible numbers like 99,999 and beyond. Manage your economy, upgrade your fabricators, and harness the power of Time Flux to speed up the universe. When you hit a wall, Ascend to earn prestige Crowns and unlock permanent, game-changing boosts. With infinite scaling and deep strategy, how high can you go? Play now and build your number empire!",
    "instructions": "drag and click or touch drag and touch",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Click",
      "Clicker",
      "free html5 games for your website",
      "HTML",
      "html games for your website",
      "HTML5",
      "html5 games",
      "html5 games for your site",
      "idle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ylbicwd30vva0awbilt3x3ryxjkg5v59/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ylbicwd30vva0awbilt3x3ryxjkg5v59/",
    "sourceUrl": "https://html5.gamemonetize.com/ylbicwd30vva0awbilt3x3ryxjkg5v59/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73343",
    "slug": "draw-dot-picture-game",
    "title": "Draw Dot Picture Game",
    "description": "Welcome to Draw One Miss Part Brain Games, the addictive puzzle game where logic, drawing, and brain games come together! Think you&rsquo;re good at spotting details? Test your skills by identifying the missing part in each scene, and use your finger to draw it back in. Sounds simple? These brain puzzles are trickier than you think!",
    "instructions": "Mouse click to play Game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Draw",
      "Drawing",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/nj974v2hmarol6ij7nr8op8qt1cq5x33/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nj974v2hmarol6ij7nr8op8qt1cq5x33/",
    "sourceUrl": "https://html5.gamemonetize.com/nj974v2hmarol6ij7nr8op8qt1cq5x33/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71969",
    "slug": "snake-battle",
    "title": "Snake Battle",
    "description": "Experience the Ultimate IO Battle Thrill! In Snake Battle, consume glowing dots to grow and use tactical maneuvers to cut off enemies, forcing them to crash into you! Dual Modes: Tackle the strategic Campaign or push your limits in Endless Mode. Tactical Shop: Earn coins to unlock powerful items like Shields and Mega Starts. Second Chance: Made a mistake? Watch an ad to Revive and keep your high score streak alive! Smooth Controls: Fully supports PC Keyboard and Mobile Touch Joystick.",
    "instructions": "This game supports two operation methods PC and mobile devices phones tablets 1 PC control keyboard Movement direction Use the arrow keys uarr darr larr rarr Or WASD keys W up S down A left D right Acceleration sprint Hold down",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Boy",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/69an8dj2qbecd9ek1dca4e9rmq6g3d6e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/69an8dj2qbecd9ek1dca4e9rmq6g3d6e/",
    "sourceUrl": "https://html5.gamemonetize.com/69an8dj2qbecd9ek1dca4e9rmq6g3d6e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73383",
    "slug": "food-game-grill-sort",
    "title": "Food Game Grill Sort",
    "description": "Welcome to Food Game - Grill Sort, the sizzling casual puzzle simulation game that will make your taste buds tingle. Become a master grill chef as you carefully sort and match delicious skewers on the barbecue! Your goal is simple yet addictively fun. Clear food to earn coins according to customers needs.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Food",
      "Matching",
      "Simulation",
      "sort"
    ],
    "thumbnail": "https://img.gamemonetize.com/x18szni3pe1a4863gcud2kqig4rhrgfg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x18szni3pe1a4863gcud2kqig4rhrgfg/",
    "sourceUrl": "https://html5.gamemonetize.com/x18szni3pe1a4863gcud2kqig4rhrgfg/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73371",
    "slug": "real-grand-truck-simulator-game",
    "title": "Real Grand Truck Simulator Game",
    "description": "Welcome to the legendary truck parking game. The most realistic and thrilling truck parking simulation game. Are you ready to prove your driving and parking skills with powerful trucks? Get ready for an unforgettable experience where you take control of gigantic trucks and park them in challenging scenarios. Whether you are a parking game enthusiast or a professional truck driver, this game offers something for everyone. Featuring stunning graphics, realistic controls, and immersive sound effects. Legend truck parking will keep you hooked for hours!",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Parking",
      "Simulation",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/li3mjjfsponfzv0lrbdraonb6qqf9g4i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/li3mjjfsponfzv0lrbdraonb6qqf9g4i/",
    "sourceUrl": "https://html5.gamemonetize.com/li3mjjfsponfzv0lrbdraonb6qqf9g4i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71985",
    "slug": "highway-car-racing-game",
    "title": "Highway Car Racing Game",
    "description": "Enjoy the cutting edge 3D graphics with realistically created environments and amazingly detailed cars. Race at high speeds, drive against traffic and overtake cars! Dont push your luck in sticky situations, slow time for easier manoeuvres. Take a ride in Village, Desert, City, or have a snowy one in Winter. Feel the Fever in One Way and Two Way, rush a quick game in Time Attack or drive calmly in Free Ride. Race through traffic with Top or Back camera, or just dive into the action with Hood camera. Each camera angle offers a unique driving experience.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Car",
      "Cars",
      "Driving",
      "Race",
      "Racing",
      "Road"
    ],
    "thumbnail": "https://img.gamemonetize.com/qbqv80h4e5r9avum225uy3hxqdxu5793/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qbqv80h4e5r9avum225uy3hxqdxu5793/",
    "sourceUrl": "https://html5.gamemonetize.com/qbqv80h4e5r9avum225uy3hxqdxu5793/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71834",
    "slug": "city-car-pick-and-drop-game",
    "title": "City Car Pick And Drop Game",
    "description": "Welcome to the car pick and drop game. Get ready to experience the most realistic, thrilling, and immersive car driving adventure game. In this game you are not just driving, you are providing an essential service to virtual passengers who rely on your exceptional driving skills to reach their destinations safely. From the bustling city streets every journey tells a story, and every passenger adds a new layer of excitement and challenge to your day as a professional driver. In the car pick and drop game you play as a dedicated and skilled driver working for a modern, high-tech ride service.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "Action",
      "Adventure",
      "building",
      "Car",
      "Cars",
      "city"
    ],
    "thumbnail": "https://img.gamemonetize.com/874bx7nponra853hk8751z6ui4ssa07q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/874bx7nponra853hk8751z6ui4ssa07q/",
    "sourceUrl": "https://html5.gamemonetize.com/874bx7nponra853hk8751z6ui4ssa07q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72659",
    "slug": "fruit-catchere",
    "title": "Fruit Catchere",
    "description": "Get ready to experience the juicy fun of Fruit Catcher, a simple yet addictive game that will test your reflexes, timing, and hand-eye coordination! Step into the colorful world of fruits, where your only goal is to catch as many falling fruits as possible before they hit the ground. Sounds easy? Think again &mdash; with every level, the speed increases, and the challenge gets even more exciting! Use your mouse (or finger on mobile) to move the basket. Catch fresh fruits like apples, oranges, bananas, and more. Avoid bad fruits or bombs that can ruin your streak.",
    "instructions": "easy controls just click in basket and move to catcher fruit",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Baby Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/18vy36scythopw8n2oibpaltoj3wvjwp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/18vy36scythopw8n2oibpaltoj3wvjwp/",
    "sourceUrl": "https://html5.gamemonetize.com/18vy36scythopw8n2oibpaltoj3wvjwp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73547",
    "slug": "neon-pulse-arena",
    "title": "Neon Pulse Arena",
    "description": "Neon Pulse Arena is a fast-reaction survival arcade game where you dodge incoming shapes and push your limits for as long as possible. Every second you survive, the arena becomes more intense. Simple controls, clean neon visuals, and pure skill-based gameplay &mdash; no luck, just reflex. How long can you stay alive?",
    "instructions": "Mouse Touch to move Avoid shapes Survive as long as possible",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Arena",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/54o8e31n5pikjwkpbotk09ffg09eluy1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/54o8e31n5pikjwkpbotk09ffg09eluy1/",
    "sourceUrl": "https://html5.gamemonetize.com/54o8e31n5pikjwkpbotk09ffg09eluy1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73576",
    "slug": "labubu-find-the-differences",
    "title": "Labubu Find the Differences",
    "description": "Labubu Find the Differences is an amazing and free to play online game for kids. The aim of the game is to fin all 5 differences on each level to enter a new one. Labubu theme and a lot of fun is waiting for you!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boy",
      "Brain",
      "Difference",
      "Fun",
      "Girl",
      "Hypercasual",
      "Kids",
      "Labubu",
      "Logic",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/o1770rkhfl4qeja9s68btv7flae5ooe7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o1770rkhfl4qeja9s68btv7flae5ooe7/",
    "sourceUrl": "https://html5.gamemonetize.com/o1770rkhfl4qeja9s68btv7flae5ooe7/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "73347",
    "slug": "easy-picture-colouring-game",
    "title": "Easy Picture Colouring Game",
    "description": "Looking for coloring games for kids? Try our fun coloring for kids &mdash; a perfect blend of creativity, learning, and kids coloring gameplay! Simply tap a picture from our coloring book for kids and choose how you want to color it: by numbers, by letters, or by solving simple math problems! Its an easy way for little boys and girls to be creative and learn while playing an engaging kids game.",
    "instructions": "Use Mouse To Play Game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Color",
      "Coloring",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/85n63q0psxqw26ojixem9459svfp46ld/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/85n63q0psxqw26ojixem9459svfp46ld/",
    "sourceUrl": "https://html5.gamemonetize.com/85n63q0psxqw26ojixem9459svfp46ld/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73411",
    "slug": "asmr-mini-puzzle-games-2024",
    "title": "ASMR Mini Puzzle Games 2024",
    "description": "Need a quick stress release? Weve got you covered with a variety of virtual popping games. Pop bubble wrap that never runs out, fidget with popping buttons that click oh-so-satisfyingly, and explore a world of colorful fidget toys that fit right in your pocket. Weve got a ton of cool antistress 3d fidget toys to pop and play with, plus awesome ASMR sounds for extra calming vibes. We even have balloon popping games for some extra fun. Its the perfect way to relax and de-stress.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Arcade",
      "Best Games",
      "Fun",
      "Relaxation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/i376ctj4firbz34cju00yyepssrvxco9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i376ctj4firbz34cju00yyepssrvxco9/",
    "sourceUrl": "https://html5.gamemonetize.com/i376ctj4firbz34cju00yyepssrvxco9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73453",
    "slug": "emotional-support-duck",
    "title": "Emotional Support Duck",
    "description": "Emotional Support Duck is a cozy life-management game where you balance your Emotional Energy and your duck&rsquo;s Support Capacity. Face 100+ random events, enjoy soothing visuals and ambient audio, and track progress with autosaves and high scores on any device.",
    "instructions": "N for Next Event B for Challenge Boss M for Toggle Mute ESC for Exit Fullscreen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "Animal",
      "Battle"
    ],
    "thumbnail": "https://img.gamemonetize.com/8j1yrpb0xpmufhojds2rloowa334q7ts/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8j1yrpb0xpmufhojds2rloowa334q7ts/",
    "sourceUrl": "https://html5.gamemonetize.com/8j1yrpb0xpmufhojds2rloowa334q7ts/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73559",
    "slug": "dinosaur-games-for-toddlers",
    "title": "Dinosaur Games For Toddlers",
    "description": "Welcome to Dinosaur Games For Toddlers, a casual collection of minigames on dinosaur themes. Paint a vivid dinosaur in coloring book games, click to see how an egg transforms into chicks, and join a fun car racing game. You can choose chicken types, colors of paintbrushes, or different illustrations freely.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Collection",
      "Dinosaur",
      "eggs",
      "Funny"
    ],
    "thumbnail": "https://img.gamemonetize.com/okteqriu3kq21tj9s55swx4u4o4zg732/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/okteqriu3kq21tj9s55swx4u4o4zg732/",
    "sourceUrl": "https://html5.gamemonetize.com/okteqriu3kq21tj9s55swx4u4o4zg732/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73543",
    "slug": "frank-in-geometry-maps",
    "title": "Frank In Geometry Maps",
    "description": "Frank in Geometry Maps is a fast-paced platformer where you control a cube through six intricate mazes. The game throws obstacles like spikes and moving platforms at you while your character speeds along, testing your reflexes. Time your jumps carefully&mdash;use the yellow boosters to reach higher ground and avoid instant-death traps.",
    "instructions": "Touch for jump mouse cllick fo jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Avoid",
      "Geometry",
      "jump"
    ],
    "thumbnail": "https://img.gamemonetize.com/8ansls0hjssmsr3rk8ry4clfmwbqq8qn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8ansls0hjssmsr3rk8ry4clfmwbqq8qn/",
    "sourceUrl": "https://html5.gamemonetize.com/8ansls0hjssmsr3rk8ry4clfmwbqq8qn/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73533",
    "slug": "timely-delivery",
    "title": "Timely Delivery",
    "description": "Timely Delivery is a fast and casual delivery runner. Press and hold to move, release to stop - simple controls, tight time constraints. Make your way through crowds and traffic, complete delivery quotas, and collect fees to unlock new skins. With dozens of hand-crafted levels and escalating dangers, every second counts on your way to becoming a delivery star.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Avoid",
      "Casual",
      "Obstacle",
      "onetouch",
      "running",
      "Traffic"
    ],
    "thumbnail": "https://img.gamemonetize.com/cfr12fabbug90fu9aqqqpatan4adauwy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cfr12fabbug90fu9aqqqpatan4adauwy/",
    "sourceUrl": "https://html5.gamemonetize.com/cfr12fabbug90fu9aqqqpatan4adauwy/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73521",
    "slug": "monster-truck-zombies-and-nbsp-game",
    "title": "Monster Truck Zombies&nbsp;Game",
    "description": "Monster Truck Games Kids: Ignite your child&rsquo;s passion for high-octane fun with colossal bigfoot trucks and thrilling monster truck collisions! Watch little racers zoom through dazzling arenas, collect quirky power-ups, and celebrate every smashing victory.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "",
    "genres": [],
    "tags": [
      "2 Player Games",
      "Adventure",
      "Monster",
      "Race",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/vx9c332rtjn79s9qjidasv804co4lbwd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vx9c332rtjn79s9qjidasv804co4lbwd/",
    "sourceUrl": "https://html5.gamemonetize.com/vx9c332rtjn79s9qjidasv804co4lbwd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73538",
    "slug": "go-mafalda",
    "title": "Go Mafalda!",
    "description": "Run as Mafalda in this pixelated endless runner! Collect apples to boost your score and dodge slimy slimes to stay alive as long as possible!",
    "instructions": "Spacebar Jump Double Spacebar DOUBLE JUMP",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Cute",
      "endless",
      "Highscore",
      "jump",
      "Pixel",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/1hsabrp99x1yy9f9vs267k2gt0fvlv0i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1hsabrp99x1yy9f9vs267k2gt0fvlv0i/",
    "sourceUrl": "https://html5.gamemonetize.com/1hsabrp99x1yy9f9vs267k2gt0fvlv0i/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "73452",
    "slug": "3d-kid-sliding-puzzle",
    "title": "3D Kid Sliding Puzzle",
    "description": "Solve a variety of 3&times;3 and 3&times;4 slide puzzles featuring cute animal drawings by moving one piece at a time into the open space on the puzzle. When all pieces are in the correct position the bottom right corner will be empty and the computer will then fill in that space for you.",
    "instructions": "Use the mouse or tap the screen to solve the puzzle",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Fun",
      "Funny",
      "Kids",
      "Skill",
      "sliding"
    ],
    "thumbnail": "https://img.gamemonetize.com/r9j8tc1hmo3v4q59qbap0e7jhv3m9smc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r9j8tc1hmo3v4q59qbap0e7jhv3m9smc/",
    "sourceUrl": "https://html5.gamemonetize.com/r9j8tc1hmo3v4q59qbap0e7jhv3m9smc/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73370",
    "slug": "power-boat-racing-game",
    "title": "Power Boat Racing Game",
    "description": "Welcome to the world of power boat games. Get ready for high-speed thrills on the water with PowerBoat Racing, the most realistic and action-packed powerboat simulator game. Take a break from the hustle and dive into the relaxing world of PowerBoat Adventure. Come and enjoy the ocean and realistic cargo motions. The best boat driving simulator comes with the best driving physics!",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Boat",
      "Race",
      "Racing",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/m7neml8mldms64runb0a6bhaaro21hhh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m7neml8mldms64runb0a6bhaaro21hhh/",
    "sourceUrl": "https://html5.gamemonetize.com/m7neml8mldms64runb0a6bhaaro21hhh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72930",
    "slug": "solitaire-card-sorting",
    "title": "Solitaire: Card Sorting",
    "description": "An intellectual card puzzle that combines the mechanics of classic solitaire with the logic of thematic sorting. At each level, you need to organize cards into categories: plants, jewelry, toys, tools, flowers, and many more. Use observation and strategy to clear the field and complete the level within a limited number of moves.",
    "instructions": "Each round starts with a partially filled table Draw one card from the deck and place it in the correct category To start building place a category card first then add related cards Sort carefully mdash if the layout is wrong you rsquo ll run out",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Casual",
      "Puzzle",
      "Solitaire"
    ],
    "thumbnail": "https://img.gamemonetize.com/8g0f47j2ywc7mtqftraxeu45z13qw3hg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8g0f47j2ywc7mtqftraxeu45z13qw3hg/",
    "sourceUrl": "https://html5.gamemonetize.com/8g0f47j2ywc7mtqftraxeu45z13qw3hg/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72693",
    "slug": "jigsolitaire-deluxe",
    "title": "Jigsolitaire Deluxe",
    "description": "Jigsolitaire Deluxe is a refined card-based puzzle where every level turns into the creation of a masterpiece. Move picture cards around the board to connect them into a seamless image &mdash; from famous paintings like Mona Lisa to serene landscapes and still lifes. As the fragments start to align and the image comes to life, you&rsquo;ll feel that satisfying moment of completion. Simple controls, smooth gameplay, and visually stunning artworks make this game both relaxing and rewarding.",
    "instructions": "Swipe to move cards around the board When two matching pieces align they connect automatically Move connected pieces as a single group Complete all fragments to reveal the full masterpiece The faster you complete the image the higher your score Enj",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Card",
      "Relaxation",
      "Solitaire"
    ],
    "thumbnail": "https://img.gamemonetize.com/23sgyhikibl5jvylyk2uub6wksiq8tfo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/23sgyhikibl5jvylyk2uub6wksiq8tfo/",
    "sourceUrl": "https://html5.gamemonetize.com/23sgyhikibl5jvylyk2uub6wksiq8tfo/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "73535",
    "slug": "hen-bubble-go-up-game",
    "title": "Hen Bubble Go Up Game",
    "description": "Hen Bubble Go Up Game is a fun and simple game where a cute hen flies upward inside a bubble. Your main goal is to help the hen rise safely while avoiding different obstacles. The game is designed with easy controls so every player can enjoy smooth gameplay. Just tap the screen and make the bubble go higher in the sky.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Arcade",
      "Bubble"
    ],
    "thumbnail": "https://img.gamemonetize.com/zlzf1kffk3viwxaxuw6uhecozdcb85u2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zlzf1kffk3viwxaxuw6uhecozdcb85u2/",
    "sourceUrl": "https://html5.gamemonetize.com/zlzf1kffk3viwxaxuw6uhecozdcb85u2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73171",
    "slug": "aqualogics-puzzles-game",
    "title": "Aqualogics Puzzles Game",
    "description": "Aqualogics is a challenging and fast-paced water sorting puzzle game designed for sharp minds! Sort all colored liquids into separate tubes using logic, planning, and limited moves. Features: 100 Procedural Levels Clean UI &amp; smooth animations Smart move system Undo, Shuffle &amp; Skip Powers Earn coins and unlock harder levels Mobile-friendly, lightweight HTML5 Are you smart enough to complete all levels? Test your brain now!",
    "instructions": "Tap Click Select a tube Tap another tube to pour Drag Drag from one tube to another to pour mobile amp desktop Undo power Spend coins to undo last move Shuffle power Shuffle liquids when stuck Skip power Skip level costly",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logical",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/myfre67i1rsz9gav2l0in0rfqct6mrjy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/myfre67i1rsz9gav2l0in0rfqct6mrjy/",
    "sourceUrl": "https://html5.gamemonetize.com/myfre67i1rsz9gav2l0in0rfqct6mrjy/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73418",
    "slug": "men-vs-gorillas",
    "title": "Men Vs Gorillas",
    "description": "Men vs Gorilla &ndash; The Ultimate Evolution Battle! Step into the wild showdown of Man vs Gorilla! Upgrade your human&rsquo;s strength, damage, and health to survive the rising fury of the jungle&rsquo;s strongest beast. ? Each level brings a tougher gorilla, smarter attacks, and intense battles but also bigger rewards! Use your earnings to level up your power, evolve your fighter, and dominate every fight!",
    "instructions": "Use the left mouse button to upgrade and deploy humans",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "Action",
      "Fight",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/g04edxyis63ewbo539y721f4qpa3n1nt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g04edxyis63ewbo539y721f4qpa3n1nt/",
    "sourceUrl": "https://html5.gamemonetize.com/g04edxyis63ewbo539y721f4qpa3n1nt/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73560",
    "slug": "phone-case-diy-kpop-fans",
    "title": "Phone Case Diy Kpop Fans",
    "description": "Welcome to Phone Case DIY Kpop Fans, a casual fashion design game that you can play for free. You will act as a phone case designer and create cool and latest phone cases for your Kpop girls! Use spray paints or brushes to craft a charming and trendy pattern.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cool",
      "Design",
      "Fashion",
      "iPhone"
    ],
    "thumbnail": "https://img.gamemonetize.com/sk9x91sn2cabxx0s7wksvwqsa923iccw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sk9x91sn2cabxx0s7wksvwqsa923iccw/",
    "sourceUrl": "https://html5.gamemonetize.com/sk9x91sn2cabxx0s7wksvwqsa923iccw/",
    "width": 504,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73433",
    "slug": "spider-match",
    "title": "Spider Match",
    "description": "Unleash your inner hero and become the legend you were destined to be. Prepare for an epic adventure in a Spiderman world where only the strongest heroes thrive. Collect powerful superheroes, build your legendary team, and venture across vast fantasy worlds in a hero crafted for those who seek glory.",
    "instructions": "Use the mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "free html5 games for your website",
      "Kiz 10",
      "Match 3",
      "Puzzle",
      "Spiderman",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/sjghavwkh9bpg0i06sgsnve9uxomk6x2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sjghavwkh9bpg0i06sgsnve9uxomk6x2/",
    "sourceUrl": "https://html5.gamemonetize.com/sjghavwkh9bpg0i06sgsnve9uxomk6x2/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73447",
    "slug": "gang-blast",
    "title": "Gang Blast",
    "description": "Gang Blast is a cover-based escort shooter. Escape from out-of-control dinosaur hordes, protect your evacuation, and clear your way to freedom. Use cash to unlock powerful weapons and perks, and plan every escape route to outwit the guards. One mistake could jeopardize the entire rescue - can you escort everyone to safety?",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Dinosaur",
      "Shooter",
      "Stealth",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/48v0gscii4bf868ymoyqf6oyo0tsd2ou/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/48v0gscii4bf868ymoyqf6oyo0tsd2ou/",
    "sourceUrl": "https://html5.gamemonetize.com/48v0gscii4bf868ymoyqf6oyo0tsd2ou/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73440",
    "slug": "legend-dream-football-game",
    "title": "Legend Dream Football Game",
    "description": "Get ready to dive into the electrifying world of football. Step into the thrilling world of football with the football champions game. Ultimate soccer game, the ultimate sports experience for fans of the beautiful football game. Whether you&rsquo;re a casual gamer or a hardcore football enthusiast, this game delivers realistic gameplay, immersive graphics, and strategic challenges that will keep you hooked for hours. Choose your favorite team and compete in intense matches where every pass, dribble, and goal matters in a football game.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse Pass F Key Shoot Left Shift for power shots Tackle Left Ctrl for defensive nbsp actions",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Ball",
      "Food",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/bom17v0dxydcmce4incq85b80hxccsqx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bom17v0dxydcmce4incq85b80hxccsqx/",
    "sourceUrl": "https://html5.gamemonetize.com/bom17v0dxydcmce4incq85b80hxccsqx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73377",
    "slug": "toy-rumble-3d",
    "title": "Toy Rumble 3D",
    "description": "Begin an explosive toy adventure in Toy Rumble 3D. A 3D running and racing arcade game packed with action, speed, and strategy. Move your tank through chaotic obstacle courses, collect parts, assemble your cannon, and shoot your way to victory.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Racing",
      "running",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/0a9w8rhj93oivc5ax2ag9khog6k9klar/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0a9w8rhj93oivc5ax2ag9khog6k9klar/",
    "sourceUrl": "https://html5.gamemonetize.com/0a9w8rhj93oivc5ax2ag9khog6k9klar/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73329",
    "slug": "obby-universe-mini-games-online",
    "title": "Obby Universe: Mini Games Online",
    "description": "Obby Universe: Mini Games Online A world of incredible adventures! Play: Escape lava waves and outsmart evil traps in unique mini-games. Explore: Find secrets and enjoy parachute jumps or water slides. Build: Construct your own city and even design your personal house to earn bonuses. Customize: Choose from 150+ items for your character and adopt a cool pet. Join the fun now!",
    "instructions": "On PC 1 WASD - move 2 Hold right mouse button - control camera 3 Spacebar - jump On phone 1 Left joystick - walk 2 Press and drag finger on right part of screen - control camera 3 Jump button on right - jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D Games",
      "Adventure",
      "Arcade",
      "Baby Games",
      "Best",
      "Best Games",
      "Brainrot",
      "Cartoon",
      "Casual",
      "House",
      "Kids",
      "Minecraft",
      "roblox",
      "World"
    ],
    "thumbnail": "https://img.gamemonetize.com/rigii51flinmiis7djlyliiwf3ggc9r1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rigii51flinmiis7djlyliiwf3ggc9r1/",
    "sourceUrl": "https://html5.gamemonetize.com/rigii51flinmiis7djlyliiwf3ggc9r1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73357",
    "slug": "puzzle-legends-game-of-heroes",
    "title": "Puzzle Legends: Game of Heroes",
    "description": "Dive into the colorful world of Puzzle Legends, the ultimate match-3 puzzle game where strategy, skill, and quick thinking collide! Swap, match, and crush gems to solve challenging puzzles while unlocking legendary heroes, powerful boosts, and epic rewards. Join millions of players worldwide in this addictive puzzle adventure. Complete levels filled with tricky obstacles, special gems, and unique power-ups that make every match exciting. Whether you&rsquo;re a casual gamer or a puzzle master, Puzzle Legends offers endless fun with hundreds of levels, daily challenges, and exciting events.",
    "instructions": "Get ready to become a hero in the colorful world of Puzzle Legends the ultimate match-3 puzzle game Follow these simple steps to master the game and climb the leaderboard",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Match 3",
      "Match-3",
      "Match3"
    ],
    "thumbnail": "https://img.gamemonetize.com/m8n8ghtemiogm3qr1wu4x7udws58b84n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m8n8ghtemiogm3qr1wu4x7udws58b84n/",
    "sourceUrl": "https://html5.gamemonetize.com/m8n8ghtemiogm3qr1wu4x7udws58b84n/",
    "width": 430,
    "height": 878,
    "lastUpdated": ""
  },
  {
    "id": "73327",
    "slug": "asmr-relaxing-puzzle-games",
    "title": "ASMR Relaxing Puzzle Games",
    "description": "Relax with Antistress relaxing toy games by playing A fidget toys 3D Spinner, or just Smash Some Phones to relieve stress, or you can also pop bubbles with a bubble wrap to relax Your mind with antistress puzzle toys game offline &amp; stress relief games for anxiety relief games. We have provided you with antistress relaxing toy games.These games also includepop it fidget antistress gamestress relief games and help you to clean up stress. Take pleasure in enjoying Antistress puzzle toys gamewith tons of fidget games that you can hold, squeeze, crush, or do whatever you want with slime games, it is one of the Pop it Fidget.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Adventure",
      "Arcade",
      "Best Games",
      "Brainrot"
    ],
    "thumbnail": "https://img.gamemonetize.com/x8n96yantm6dnnqq98nud7qlvhu180dz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x8n96yantm6dnnqq98nud7qlvhu180dz/",
    "sourceUrl": "https://html5.gamemonetize.com/x8n96yantm6dnnqq98nud7qlvhu180dz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73416",
    "slug": "health-protection",
    "title": "Health Protection",
    "description": "Health Protection is a survival journey inside the body, where you play the role of a brave beneficial bacteria warrior, standing up to protect health from harmful bacteria waves invading. Initially, you are weak and can only eliminate small bacteria to accumulate energy and grow. Over time, your strength increases, allowing you to confront larger and more dangerous bacteria. Each battle is a challenge of observation and target selection, because attacking the wrong opponent can cause you to be overwhelmed immediately. Develop in the right direction, choose the right timing, and clear all threats to protect the body. With engaging growth g",
    "instructions": "Use ASWD to move",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Fight",
      "Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/j5ksbudef7eir5mwrj6mdric2lq1h7c7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j5ksbudef7eir5mwrj6mdric2lq1h7c7/",
    "sourceUrl": "https://html5.gamemonetize.com/j5ksbudef7eir5mwrj6mdric2lq1h7c7/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73513",
    "slug": "animal-bus-traffic-jam",
    "title": "Animal Bus Traffic Jam",
    "description": "All aboard for the cutest puzzle ride ever in Animal Bus Traffic Jam. This clever match-3 sort puzzle and casual logic game challenges you to help adorable animal passengers find their correct buses. Each level is a traffic jam of colorful buses filled with cats, dogs, pandas, and more.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "bus",
      "Hypercasual",
      "Match 3",
      "Traffic"
    ],
    "thumbnail": "https://img.gamemonetize.com/srinp50qip55glw9w2efsi4phsioa5qu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/srinp50qip55glw9w2efsi4phsioa5qu/",
    "sourceUrl": "https://html5.gamemonetize.com/srinp50qip55glw9w2efsi4phsioa5qu/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73474",
    "slug": "dino-idle-park",
    "title": "Dino Idle Park",
    "description": "Dino Idle Park is a relaxing leisure real estate tycoon where you create and develop a dinosaur amusement park. Expand plots, release and display dinosaurs, optimize queues and parks, hire staff, and upgrade investments to increase funds and income. Balance safety, visitor happiness, and research to keep the park thriving even when youre away.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Dinosaur",
      "idle",
      "Island",
      "Management",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/gurifvt11u531slx3g2euizginnvaag0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gurifvt11u531slx3g2euizginnvaag0/",
    "sourceUrl": "https://html5.gamemonetize.com/gurifvt11u531slx3g2euizginnvaag0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73479",
    "slug": "labubu-antistress-game",
    "title": "Labubu Antistress Game",
    "description": "Labubu Antistress Game is an amazing and free to play online game for kids. play around with our lovely Labubu doll and have fun!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fun",
      "HTML5",
      "Hypercasual",
      "Kids",
      "Labubu",
      "Mobile",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/ko1brbmzswyng2twamjyngif346vfm18/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ko1brbmzswyng2twamjyngif346vfm18/",
    "sourceUrl": "https://html5.gamemonetize.com/ko1brbmzswyng2twamjyngif346vfm18/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "73512",
    "slug": "brainrot-cleaning",
    "title": "Brainrot Cleaning",
    "description": "Welcome to Brainrot Cleaning, the weirdly satisfying cleaning simulation that turns chaos into calm. In this fun and quirky casual game, your job is to scrub away the mess caused by the wild world of brainrot characters and their hilarious antics! In the Cleaning Italian Brainrot or the Underwater mode, you will finish various cleaning tasks.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Brainrot",
      "Cleaning",
      "Fun",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/977eerotjsnb1mdc4vl4oek1g1ilp9bq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/977eerotjsnb1mdc4vl4oek1g1ilp9bq/",
    "sourceUrl": "https://html5.gamemonetize.com/977eerotjsnb1mdc4vl4oek1g1ilp9bq/",
    "width": 1560,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73421",
    "slug": "angry-zombies-war-game",
    "title": "Angry Zombies War Game",
    "description": "Angry Zombies You have to eliminate zombies with the skull You throw the skull at the zombie by dragging it back. There are two modes in the game: Easy and Hard mode. Hard mode doesnt have an aim sight Each level in ANGRY ZOMBIES is packed full of destructible objects and crazy zombie enemies. Simply shoot, pull back and start shooting! Use precariously stacked crates and other environmental hazards to take out every zombie on the screen. If things get tough, ANGRY ZOMBIES provides the scariest environment but Nothing scares a zombie more than a destructive stone towards him.",
    "instructions": "- To click any button use mouse",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "War",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/qmiqy19ao70stllycsh79urhk93mk086/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qmiqy19ao70stllycsh79urhk93mk086/",
    "sourceUrl": "https://html5.gamemonetize.com/qmiqy19ao70stllycsh79urhk93mk086/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73376",
    "slug": "block-puzzle-legend",
    "title": "Block puzzle legend",
    "description": "Challenge your brain in Block Puzzle Legend. Enjoy the ultimate classic puzzle game. Slide, match, and blast blocks to clear the board and reach new high scores. This casual game is perfect for quick fun or long strategy sessions. It combines satisfying block-clearing action with a colorful, relaxing interface.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Classic",
      "Hypercasual",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/n383lwm9rj72iqfto0xgve8yp69v0svq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n383lwm9rj72iqfto0xgve8yp69v0svq/",
    "sourceUrl": "https://html5.gamemonetize.com/n383lwm9rj72iqfto0xgve8yp69v0svq/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73145",
    "slug": "ultimate-bike-stunt-racing",
    "title": "Ultimate Bike Stunt Racing",
    "description": "Get ready for a thrilling gameplay experience in this emerging tricky bike stunt game. With a wide variety of bikes to choose from, youll embark on a stimulating journey through challenging tracks and exhilarating bike race. Show off your skills &amp; master the art of bike stunts in action-packed racing stunt games. While most levels are easy, it can be very hard to master the level and beat the top time. Whether you prefer the speed of a motorcycle or the agility of a stunt bike, this game has it all.",
    "instructions": "Mouse click or tap to play Drive Right Arrow Break Left Arrow Front Flip Up Arrow Back Flip Down Arrow Jump Space Bar",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Bike",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/80zq2crg7nc0mo1awq1oxdbirtg10hlx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/80zq2crg7nc0mo1awq1oxdbirtg10hlx/",
    "sourceUrl": "https://html5.gamemonetize.com/80zq2crg7nc0mo1awq1oxdbirtg10hlx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72192",
    "slug": "3d-sniper-shooting-game",
    "title": "3D Sniper Shooting Game",
    "description": "The best sniper 3d ultimate game 2025. There are gangsters in the town, terrorists, thieves, criminals, and robbers who destroy the peace of the city. Everyone is terrifying in the city Sniper Game 2025 Offline top gun game. The city looks like a warzone, other side, criminals ran out of prison by breaking the jail your mission is to kill them with your fps shooting strike skills. Hold your new Sniper shooting Gun, sniper Game 2025 Offline with sniper shooting skills and perform your police sniper shooter duty as an fps commando shooter. Having Sniper 3d Game 2025 Offline shooter skills. shot as a sniper assassin!",
    "instructions": "Mouse click or tap to play Mouse Gun Movement Right Button Scope On amp Off Left Button Fire",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "First Person Shooter",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/5aa8se9unw7t2wqnsqey9i6ddgc67jp3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5aa8se9unw7t2wqnsqey9i6ddgc67jp3/",
    "sourceUrl": "https://html5.gamemonetize.com/5aa8se9unw7t2wqnsqey9i6ddgc67jp3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73391",
    "slug": "super-zombie-shooter-2",
    "title": "Super Zombie Shooter 2",
    "description": "Super Zombie Shooter 2 throws you into a dangerous research facility packed with zombie hordes. Explore dark labs, abandoned corridors, and hidden rooms while fighting to survive. Each level challenges you to find the exit and move deeper into the complex. Unlock new weapons ranging from pistols to powerful rifles and experimental guns. Search for ammo and supplies, defeat tougher enemies, and uncover the mystery behind the outbreak as you fight your way to safety.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "First Person Shooter",
      "Gun",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Unity3D",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/fu9e3j7jqq5pwejo86w0gyxiv050eaz2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fu9e3j7jqq5pwejo86w0gyxiv050eaz2/",
    "sourceUrl": "https://html5.gamemonetize.com/fu9e3j7jqq5pwejo86w0gyxiv050eaz2/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73417",
    "slug": "road-of-fury-4",
    "title": "Road Of Fury 4",
    "description": "Road Of Fury 4 is an explosive scroller shooter game set in a world of post-apocalypse. Team-up with other nomads, upgrade cars, guns and super-powers and use your skills to fight through 30 levels and 3 bosses. You&rsquo;ll face waves of enemies, battle three powerful bosses, and gear up with six unique cars. With a massive arsenal at your disposal, you must upgrade, adapt, and fight your way through relentless chaos to prove your survival skills.",
    "instructions": "Use mouse finger to aim the guns 1 2 3 to activate super-powers",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "apocalypse",
      "Car",
      "Gun",
      "Physics",
      "Shoot 'Em Up",
      "Shooter",
      "Side Scrolling"
    ],
    "thumbnail": "https://img.gamemonetize.com/178lcz542682rtzlmgxullzpbbhjh3ad/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/178lcz542682rtzlmgxullzpbbhjh3ad/",
    "sourceUrl": "https://html5.gamemonetize.com/178lcz542682rtzlmgxullzpbbhjh3ad/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73415",
    "slug": "skytap-dash",
    "title": "SkyTap Dash",
    "description": "SkyTap Dash is a fast-paced tap-to-fly arcade game with smooth controls, medals, 3 difficulty modes, and addictive gameplay. Easy to learn, hard to master, and perfectly optimized for mobile browsers.",
    "instructions": "Tap Click Space to fly upward Avoid obstacles and survive as long as possible",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Bird",
      "Bounce",
      "endless",
      "flappybird",
      "fly",
      "Hypercasual",
      "Jumping",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/yy8s2tp0hje8zae0h1rtt0yd4a8fmlsm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yy8s2tp0hje8zae0h1rtt0yd4a8fmlsm/",
    "sourceUrl": "https://html5.gamemonetize.com/yy8s2tp0hje8zae0h1rtt0yd4a8fmlsm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73395",
    "slug": "strike-the-can-game",
    "title": "Strike The Can Game",
    "description": "Can you smash hit all the cans and make them fall down? The can knockdown game is fun and interesting to play and can test your aiming skills. Its an aiming and physics-based game where you have to strategically aim so that all can knock down when you shoot the ball",
    "instructions": "Mouse click to play Game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Ball",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ju5z5sfiqnq494twgl9ngxp6jr7raus/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ju5z5sfiqnq494twgl9ngxp6jr7raus/",
    "sourceUrl": "https://html5.gamemonetize.com/2ju5z5sfiqnq494twgl9ngxp6jr7raus/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73393",
    "slug": "miami-city-crime-simulator-game",
    "title": "Miami City Crime Simulator Game",
    "description": "Miami Crime Simulator sets the stage for non-stop action as you travel through a city filled with challenges and gangsters. Engage in street races through Miami&rsquo;s neighborhoods, dodging police chases and taking down thugs as you go. Use your skills to drive through traffic, escape chases, and maintain control of your territory.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "city",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/xprw37zlon1jvygprtro5gdoobefune4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xprw37zlon1jvygprtro5gdoobefune4/",
    "sourceUrl": "https://html5.gamemonetize.com/xprw37zlon1jvygprtro5gdoobefune4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73380",
    "slug": "brainrot-mob-clash-3d",
    "title": "Brainrot Mob Clash 3D",
    "description": "Welcome to the wild and chaotic world of Brainrot Mob Clash 3D. It&rsquo;s a full-blown racing and fighting adventure. Dash through 3D obstacle courses, avoid deadly traps like spikes and spinning saws. Match and merge your stickman army. Crush enemy mobs in exciting action-packed battles. As you run, collect brainrot characters to increase your numbers and merge them to form powerful units.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Fighting",
      "Obstacle",
      "Racing",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/zuyfbfbzgk33arr72z3n89o33iaqtwfj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zuyfbfbzgk33arr72z3n89o33iaqtwfj/",
    "sourceUrl": "https://html5.gamemonetize.com/zuyfbfbzgk33arr72z3n89o33iaqtwfj/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73326",
    "slug": "no-wifi-mini-games-2025",
    "title": "No Wifi Mini Games 2025",
    "description": "When you need relaxation, diversion or just a moment of distraction enjoy this collection of toys: hear the sound of a bamboo chime, play with wooden boxes, swipe gently your finger in the water, tap buttons, draw with chalks and so on! Are you waiting for something and you need a diversion? Open Antistress app and start playing with a Newtons cradle! Are you furious with someone? Have some relaxation with the never-old fifteen game! Do you need distraction from study? Open Antistress app and choose one among dozens of toys to play!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "3D Games",
      "Adventure",
      "amazing",
      "Arcade",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/roo2t4sin2amtiqi682gbl3y0tf5y5t2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/roo2t4sin2amtiqi682gbl3y0tf5y5t2/",
    "sourceUrl": "https://html5.gamemonetize.com/roo2t4sin2amtiqi682gbl3y0tf5y5t2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73287",
    "slug": "dunkchallenge",
    "title": "DunkChallenge",
    "description": "Dunk Challenge is a skill game where you control a basketball, trying to get it into the hoop in the most skillful way possible. But its not that simple &mdash; unexpected obstacles always appear along the way, hindering your perfect shot. Adjust your direction, time your throws perfectly, and overcome all obstacles to score as many points as possible. Each basket scored is an exhilarating feeling, but each level presents a new challenge that requires finesse and quick reflexes.",
    "instructions": "Use mouse to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Basketball",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/fgf2u6fqdr4nwodcpxe0ur2py8vh3kuu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fgf2u6fqdr4nwodcpxe0ur2py8vh3kuu/",
    "sourceUrl": "https://html5.gamemonetize.com/fgf2u6fqdr4nwodcpxe0ur2py8vh3kuu/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73300",
    "slug": "big-supermarket-simulator",
    "title": "Big Supermarket Simulator",
    "description": "Big Supermarket Simulator is a light business simulation game: start from a small supermarket, restock, cashier, clean, and add new products. Every gold coin you earn can be invested in upgrades. As the scale expands, you can open coffee shops and flower shops to create a multi-business commercial street. Hire employees, unlock automated production lines, optimize movement lines and warehousing, and improve customer satisfaction and unit price. Even if you take a break, offline income will continue to accumulate - step by step, turn your store into the most lively shopping landmark in the city!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Casual",
      "idle",
      "Management",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/wpt61nuoce4aib4x6uq1qz4yl001u2td/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wpt61nuoce4aib4x6uq1qz4yl001u2td/",
    "sourceUrl": "https://html5.gamemonetize.com/wpt61nuoce4aib4x6uq1qz4yl001u2td/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73375",
    "slug": "cut-the-rope-unblocked",
    "title": "Cut The Rope Unblocked",
    "description": "Begin a brain-teasing adventure with Cut The Rope Unblocked. This addictive puzzle game is packed with clever logic puzzles and clear levels. It will challenge your mind and reflexes. By cutting the rope and applying physics techniques, you perfectly guide balls of different colors into their corresponding colored water.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "cut",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/ako88227j1m9mbizistu27ad51e97klr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ako88227j1m9mbizistu27ad51e97klr/",
    "sourceUrl": "https://html5.gamemonetize.com/ako88227j1m9mbizistu27ad51e97klr/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "73374",
    "slug": "zombie-waves-2",
    "title": "Zombie Waves 2",
    "description": "Face endless chaos in Zombie Waves, an intense action and strategy game. Waves of terrifying zombies are invading your territory, and only you can guard the last defense line. Drag your character to shoot zombies. Shoot equipment to boost your guns speed, upgrade your character, increase your bullet count, and more. Shoot zombies to build strong plants for defense, and fight through thrilling shooting battles to stay alive.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Defense",
      "Fighting",
      "Strategy",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/fr8ljaub5ph4cwxo3fzit82t2mtkzib3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fr8ljaub5ph4cwxo3fzit82t2mtkzib3/",
    "sourceUrl": "https://html5.gamemonetize.com/fr8ljaub5ph4cwxo3fzit82t2mtkzib3/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73378",
    "slug": "stick-war-saga",
    "title": "Stick War Saga",
    "description": "Prepare for an epic clash in Stick War: Saga, an exciting blend of fighting, action, strategy, and tower defense. Take command of your stickman army and lead them through nervous war campaigns. Mine resources, build your army, and unleash your strategic power to conquer enemy lands.",
    "instructions": "Mouse click or tap to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Defense",
      "Enemy",
      "Strategy",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/va5qos76kvktyfmxfc5pwr52djpfwvmt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/va5qos76kvktyfmxfc5pwr52djpfwvmt/",
    "sourceUrl": "https://html5.gamemonetize.com/va5qos76kvktyfmxfc5pwr52djpfwvmt/",
    "width": 1600,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73382",
    "slug": "cave-crusade",
    "title": "Cave Crusade",
    "description": "Cave Crusade takes you on a dangerous journey as a knight in shining armor, venturing into a cursed castle filled with traps and monsters. Your mission is to carefully plan each move, avoid deadly traps, fight against creatures guarding the darkness, and find a safe escape. Each level presents a new challenge that requires skill, observation, and precise strategy to survive. With intense gameplay, a dark setting, and thrilling battles, Cave Crusade offers an exciting adventure experience where courage is the key to overcoming danger.",
    "instructions": "Use mouse to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Escape",
      "Fight",
      "Knight",
      "Monster"
    ],
    "thumbnail": "https://img.gamemonetize.com/i1rtpeo3qo7zryifwmr83hxtmouv2z9v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i1rtpeo3qo7zryifwmr83hxtmouv2z9v/",
    "sourceUrl": "https://html5.gamemonetize.com/i1rtpeo3qo7zryifwmr83hxtmouv2z9v/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68426",
    "slug": "army-playground-3d",
    "title": "Army Playground 3D",
    "description": "Test your tactical skills on the battlefield. You have a large arsenal of combat units and equipment at your disposal. Upgrade your units, earn diamonds and buy more and more advanced weapons that will help you win!",
    "instructions": "Select combat units and place them on the battlefield Consider the characteristics of units to win",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "3D",
      "Aircraft",
      "Battle",
      "Battlegrounds",
      "cannon",
      "Defense",
      "destroy",
      "military",
      "Simulation",
      "Tank",
      "vehicle",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/4hqykjny6c6fa490so5o2sds4zghv7wx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4hqykjny6c6fa490so5o2sds4zghv7wx/",
    "sourceUrl": "https://html5.gamemonetize.com/4hqykjny6c6fa490so5o2sds4zghv7wx/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73387",
    "slug": "fruit-helix-jump",
    "title": "Fruit Helix Jump",
    "description": "Face a juicy twist on the classic helix adventure in Fruit Helix Jump. Drop your colorful ball down the spiral helix tower and smash through layers of fruit in this exciting 3D arcade experience! Keep falling through the gaps to break juicy fruit slices and score big combos!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Classic",
      "Fruits",
      "Helix",
      "jump"
    ],
    "thumbnail": "https://img.gamemonetize.com/v6fb51qjfbf7oo9hyfwr81diygoko9d0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v6fb51qjfbf7oo9hyfwr81diygoko9d0/",
    "sourceUrl": "https://html5.gamemonetize.com/v6fb51qjfbf7oo9hyfwr81diygoko9d0/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73354",
    "slug": "run-cat-run",
    "title": "Run Cat Run",
    "description": "An endless runner adventure through pixelated landscapes Features Infinite procedural levels Multiple obstacle types Flying enemies Score tracking Retro pixel art Tips Time your jumps carefully Watch for flying enemies Slide under obstacles Practice makes perfect!",
    "instructions": "X - Jump Z - Slide",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "endless",
      "Family",
      "Highscore",
      "Hypercasual",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/sauiu1emtzmwlyt8ib6rc88t7wetq8ap/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sauiu1emtzmwlyt8ib6rc88t7wetq8ap/",
    "sourceUrl": "https://html5.gamemonetize.com/sauiu1emtzmwlyt8ib6rc88t7wetq8ap/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "73368",
    "slug": "hunter-and-survivor",
    "title": "Hunter and Survivor",
    "description": "Hunter and Survivor is an intense hide-and-seek game where you play as either the Hunter or the Survivor with completely opposite objectives. If you become the Hunter, you must track down and catch all the Survivors before they collect enough keys on the map. Every second that passes is either an opportunity or a failure. When playing as a Survivor, you need to move skillfully, hide intelligently, and quickly gather all the keys to open a safe escape route before being caught by the Hunter. With suspenseful gameplay, tense chases, and many unexpected situations, Hunter and Survivor offers an exciting modern hide-and-seek experience in ever",
    "instructions": "Use WASD or Arrow Button to move Use J Button to Attack",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Avoid",
      "Hidden",
      "Hunting",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/mni7hjcp2h32k0ozwgkiw9rg72vlnv63/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mni7hjcp2h32k0ozwgkiw9rg72vlnv63/",
    "sourceUrl": "https://html5.gamemonetize.com/mni7hjcp2h32k0ozwgkiw9rg72vlnv63/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73351",
    "slug": "highway-car-racer-game",
    "title": "Highway Car Racer Game",
    "description": "Enjoy the cutting edge 3D graphics with realistically created environments and amazingly detailed cars. Race at high speeds, drive against traffic and overtake cars! Dont push your luck in sticky situations, slow time for easier manoeuvres. Take a ride in Village, Desert, City, or have a snowy one in Winter. Feel the Fever in One Way and Two Way, rush a quick game in Time Attack or drive calmly in Free Ride. Race through traffic with Top or Back camera, or just dive into the action with Hood camera. Each camera angle offers a unique driving experience.",
    "instructions": "A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Car",
      "Cars",
      "Road",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/lkyqug7dh8worsk3z1hakch6nzkjlsf5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lkyqug7dh8worsk3z1hakch6nzkjlsf5/",
    "sourceUrl": "https://html5.gamemonetize.com/lkyqug7dh8worsk3z1hakch6nzkjlsf5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73390",
    "slug": "sort-game-toy-sort",
    "title": "Sort Game Toy Sort",
    "description": "Enjoy some adorable sorting fun in Sort Game: Toy Sort. This delightful match 3 puzzle and casual sort game challenges you to organize colorful dolls and toys. Match and eliminate all dolls within the limited time. When you encounter difficulties, use items to help you quickly clear the level.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cute",
      "Fun",
      "Match 3",
      "sort"
    ],
    "thumbnail": "https://img.gamemonetize.com/fd5lnyb9yzs3b30o5t1w11m5z1ggl6ho/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fd5lnyb9yzs3b30o5t1w11m5z1ggl6ho/",
    "sourceUrl": "https://html5.gamemonetize.com/fd5lnyb9yzs3b30o5t1w11m5z1ggl6ho/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73289",
    "slug": "world-soccer-game-championship",
    "title": "World Soccer Game Championship",
    "description": "Be a greatest player in the world of soccer with our new Football game, Soccer Championship of Worldcup 2025, In this Extreme Football Games! Start building your own career as a professional in worlds leaderboard. Play the extra ordinary of our new soccer game with which you can become the next best player in history. Unlock defenses then curl in that perfect shot to score and celebrate the Win! Trophies your progress through your career and earn great prizes and be a best soccer team of the world. Take on hundreds of matches of engaging gameplay challenges for your Team to conquer the opponents.",
    "instructions": "Movement Up Down Left Right Fast Run Arrows K Pass N High Hit M Throw Long Shot Space Bar",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Football",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/tcmwqk752btbdxuthwtk5ilatulu5ioj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tcmwqk752btbdxuthwtk5ilatulu5ioj/",
    "sourceUrl": "https://html5.gamemonetize.com/tcmwqk752btbdxuthwtk5ilatulu5ioj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73334",
    "slug": "movebox3d",
    "title": "MoveBox3D",
    "description": "MoveBox3D is a spatial puzzle game where you control pushing machines to move boxes into the correct designated positions. Each level is a strategic problem that requires you to observe the layout, calculate the appropriate pushing directions, and arrange the sequence of actions intelligently. The boxes can only be moved according to certain rules, so a single mistake can force you to start over. With a visually intuitive 3D environment, logical gameplay mechanics, and increasing difficulty with each level, MoveBox3D offers an experience that is both challenging and satisfying as you find the perfect solution.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Click",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/d2eiuneiapb2r72e0ahd4k4kofp5v7aa/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d2eiuneiapb2r72e0ahd4k4kofp5v7aa/",
    "sourceUrl": "https://html5.gamemonetize.com/d2eiuneiapb2r72e0ahd4k4kofp5v7aa/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73303",
    "slug": "black-friday-dress-up-selfie",
    "title": "Black Friday Dress Up Selfie",
    "description": "Shop the best looks in Black Friday Dress Up Selfie! Help your fashionista choose outfits from her wishlist, cozy fall fits, warm winter layers, sparkly holiday glam, and dark-academia vibes. Mix tops, bottoms, dresses, shoes, and accessories to create the perfect selfie-ready style. A fun, fast way to solve every &ldquo;What should I wear?&rdquo; moment!",
    "instructions": "Use your mouse to play on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Holiday",
      "Mobile",
      "Shopping"
    ],
    "thumbnail": "https://img.gamemonetize.com/318d59n5ygif9axk7fohg48p3kq3ywti/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/318d59n5ygif9axk7fohg48p3kq3ywti/",
    "sourceUrl": "https://html5.gamemonetize.com/318d59n5ygif9axk7fohg48p3kq3ywti/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72194",
    "slug": "modern-bus-simulator-games",
    "title": "Modern Bus Simulator Games",
    "description": "Bus Game 3d 2021 is a Free Games that will teach you to drive a bus simulator ultimate 2022 across different platforms. Play the amazing bus game simulator indonesia bus games 2021, where you can test your bus driving game skills. Complete given challenging missions and upgrade your bus game simulator ultimate for a better real bus driver. Drive a city bus driving game 2022 to take passengers from one city to another, show them amazing places and enjoy the realistic public transporter bus driver environment. We know Image quality is more important in public transport bus simulator offline bus games.",
    "instructions": "Mobile controls available and for keyboard W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Best Games",
      "bus"
    ],
    "thumbnail": "https://img.gamemonetize.com/idt2d0oae69evjj8kxkgtuud886hoxm1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/idt2d0oae69evjj8kxkgtuud886hoxm1/",
    "sourceUrl": "https://html5.gamemonetize.com/idt2d0oae69evjj8kxkgtuud886hoxm1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73288",
    "slug": "save-the-girl-pin-pull",
    "title": "Save the Girl: Pin Pull",
    "description": "When you pull the pin to save girl in a pin lock game, pick up the treasure, there will be scary monsters wondering around, you have to be careful, calculate carefully before pulling the pin to avoid the ugly monsters. Feel the joy of solving interesting obstacles along the way and saving the hero from crisis Solve puzzles, Unique levels, and rescue the hero, collect all the treasures, kill monsters, and save the princess. Solve puzzles and take the treasures by removing the pin in the right way. Rescue the princess and escape from monsters. Pull the pin to destroy your enemies by pulling lava and poisonous gas into their puzzle units.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Adventure",
      "amazing"
    ],
    "thumbnail": "https://img.gamemonetize.com/ou8mqrlep6me679hiz21lxfcjfhuz5cu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ou8mqrlep6me679hiz21lxfcjfhuz5cu/",
    "sourceUrl": "https://html5.gamemonetize.com/ou8mqrlep6me679hiz21lxfcjfhuz5cu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73317",
    "slug": "board-score-master-game",
    "title": "Board Score Master Game",
    "description": "Play the classic board table game with smooth controls, realistic physics, and addictive gameplay. Whether you call it board, pool, or disc pool, this fun board game brings the excitement of pool table games right to your fingertips.",
    "instructions": "To Play Game Use Mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Board",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/dm7paj6okr54lp77yh3godjn3y3oq5ek/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dm7paj6okr54lp77yh3godjn3y3oq5ek/",
    "sourceUrl": "https://html5.gamemonetize.com/dm7paj6okr54lp77yh3godjn3y3oq5ek/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73318",
    "slug": "find-word-puzzle-game",
    "title": "Find Word Puzzle Game",
    "description": "Uncover hidden words in Word Search - Find Word Puzzle! Challenge yourself with thousands of word search puzzles, word scramble challenges, and letter grids. Perfect for word game enthusiasts, puzzle lovers, and anyone looking for a fun, relaxing, and brain-boosting adventure. This game combines the core elements of word search, crossword puzzles, word scrambles, and hidden word challenges, offering endless hours of engaging gameplay.",
    "instructions": "Mouse click to play Game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/4j31h2w1ktjm12odyiqckc149iapav3j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4j31h2w1ktjm12odyiqckc149iapav3j/",
    "sourceUrl": "https://html5.gamemonetize.com/4j31h2w1ktjm12odyiqckc149iapav3j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73284",
    "slug": "freecell-classic",
    "title": "Freecell Classic",
    "description": "Play Freecell Classic, the ultimate free online card games experience! This addictive Freecell Solitaire challenges your mind with pure strategy. Unlike other solitaire games, every Freecell card game is winnable with skill. Play Freecell online and master this brain teaser game that combines logic with classic solitaire gameplay. Use four free cells wisely, move cards strategically, and build foundation piles from Ace to King. This patience game offers endless entertainment for beginners and experts alike. No downloads required&mdash;enjoy Freecell online instantly in your browser. Start your Freecell Classic adventure now!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brain",
      "Card",
      "Classic",
      "Puzzle",
      "Solitaire",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/aec4x89o56eu8w7tf6bh9sje5gcrdy1l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aec4x89o56eu8w7tf6bh9sje5gcrdy1l/",
    "sourceUrl": "https://html5.gamemonetize.com/aec4x89o56eu8w7tf6bh9sje5gcrdy1l/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71988",
    "slug": "whot-the-ultimate-nigerian-card-game",
    "title": "WHOT The Ultimate Nigerian Card Game",
    "description": "Experience the classic African card game WHOT! Play solo against AI or challenge friends in real-time multiplayer. Features stunning neon graphics, background music, and smooth gameplay. Free to play! GAMEPLAY: 1. On your turn, play a card that matches either: - The SHAPE of the top card (circle, triangle, cross, square, star) - The NUMBER of the top card 2. If you cant play, draw one card from the pile - If the drawn card is playable, you may play it - Otherwise, click SKIP TURN 3. WHOT cards (20) are wild - play them anytime and choose any shape",
    "instructions": "HOW TO PLAY WHOT OBJECTIVE Be the first player to play all your cards from your hand GAME SETUP bull Each player starts with 6 cards bull One card is placed face-up as the starting card bull Remaining cards form the draw pile CONTROLS bull C",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "1 Player",
      "2 Player Games",
      "2025 games"
    ],
    "thumbnail": "https://img.gamemonetize.com/at7gjto5axuv0mv7m4ain5pll3qmutcz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/at7gjto5axuv0mv7m4ain5pll3qmutcz/",
    "sourceUrl": "https://html5.gamemonetize.com/at7gjto5axuv0mv7m4ain5pll3qmutcz/",
    "width": 800,
    "height": 650,
    "lastUpdated": ""
  },
  {
    "id": "73206",
    "slug": "offroad-4x4-jeep-game",
    "title": "OffRoad 4X4 Jeep Game",
    "description": "Have you ever tried jeep driving games? If not, then this offroad jeep game is one of the driving simulator game 2025 experiences you will find. Offroad Jeep Driving Game Sims stands apart from any other jeep 4x4 offroad game 2025 because it comes with multiple exciting modes in jeep games offline. You can race in extreme racing offroad jeeps, explore an open world, and enjoy a thrilling adventure in the car offroad jeep games. Be careful while driving in the offroad simulator, and don&rsquo;t panic about jeep driving race challenges.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Car",
      "Driving",
      "jeep",
      "offroad",
      "Race",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/ugkhhsz92qor1i1r1unl1c14uq4utj38/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ugkhhsz92qor1i1r1unl1c14uq4utj38/",
    "sourceUrl": "https://html5.gamemonetize.com/ugkhhsz92qor1i1r1unl1c14uq4utj38/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73299",
    "slug": "penguin-run-adventure-game",
    "title": "Penguin Run Adventure Game",
    "description": "Penguin run game is adventure and help a little cute Penguin against the alien monsters. Penguin run adventure is specifically designed for people who want to enjoy and play with the coolest and cutest Penguins in the world! Simple gameplay, nice graphic, funny monsters and sound, very funny and very interesting, you can help him slide, jump, fire or even fly with a cannon or rocket.",
    "instructions": "Arrow Up rarr Move jump - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Penguin",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/120mbnbz66p5h9gpuztotqaxbbz77id2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/120mbnbz66p5h9gpuztotqaxbbz77id2/",
    "sourceUrl": "https://html5.gamemonetize.com/120mbnbz66p5h9gpuztotqaxbbz77id2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73204",
    "slug": "real-bull-fighting-game",
    "title": "Real Bull Fighting Game",
    "description": "Welcome come back on our latest bull fighting game in which bull attack on city passenger. Before to the bullfight, the bull is held in a tiny, dark isolation cell. He is not given food or water. Confused and anxious, the bull misses the company of his herd. Just before entering the bullring, he is harpooned, causing him to bleed, then released into the bright light of the arena.Animal Fighting Games which top free action game where you play as crazy bull and attack torero matador for bull fighting against city passenger.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Fight",
      "Game",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/yr5extwzdezxpn3tcl6lubl2hk8js3tt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yr5extwzdezxpn3tcl6lubl2hk8js3tt/",
    "sourceUrl": "https://html5.gamemonetize.com/yr5extwzdezxpn3tcl6lubl2hk8js3tt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71992",
    "slug": "moto-bike-highway-racing-game",
    "title": "Moto Bike Highway Racing Game",
    "description": "Bike Racing Games 2025 can be played with our free offline bike games. Racing motorbikes give you a real feeling of motorcycle riding and performing freestyle motorbike rides in motorcycle racing games. Be a pro-traffic motorbike rider in the town. Join the largest circle of highway traffic bike riders. Race up with a crazy bike rider in the offline bike racing game 2025. Motorcycle game focus on the idea of sports bike racing games. It gives users an extreme motorbike ride fun experience in offline games 3D.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Bike",
      "Driving",
      "Race",
      "Racing",
      "Road"
    ],
    "thumbnail": "https://img.gamemonetize.com/ip4xo3alng5cmvlc7b2vizs4tgykuwmd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ip4xo3alng5cmvlc7b2vizs4tgykuwmd/",
    "sourceUrl": "https://html5.gamemonetize.com/ip4xo3alng5cmvlc7b2vizs4tgykuwmd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67963",
    "slug": "arcade-breakout",
    "title": "Arcade Breakout",
    "description": "Dive into the neon-infused world of Arcade Breakout, a modern take on the timeless brick-breaking classic! Control your high-tech paddle, launch the blazing ball, and shatter vibrant rows of bricks across increasingly challenging levels. Feel the adrenaline as the ball gains speed with every hit, pushing your reflexes to the limit. Conquer denser, 2x bigger brick layouts in each new stage, striving for the ultimate high score. Master the physics, earn extra lives by skillfully hitting multiple bricks, and prove youre the ultimate Breakout champion!",
    "instructions": "Controls Mouse Move Paddle Drag your mouse horizontally across the screen to control the paddles movement Touch Phones Tablets Move Paddle Swipe or drag your finger horizontally across the screen to control the paddles movement Keyboard Move Pad",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Classic"
    ],
    "thumbnail": "https://img.gamemonetize.com/exk5zftpns3wcr41el1buf3jtsbn1cug/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/exk5zftpns3wcr41el1buf3jtsbn1cug/",
    "sourceUrl": "https://html5.gamemonetize.com/exk5zftpns3wcr41el1buf3jtsbn1cug/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68116",
    "slug": "magic-princess",
    "title": "Magic Princess",
    "description": "Magic Princess is a fashionable ultra-casual simulation girl game with a strong anime chibi style, suitable for all unique girls to play. Game Features Avatar Creator &amp; Memoji Maker Make up your own versions of international star girls or gothic charming dolls! More than 1000+ dress up items, skin tones and hairdressing! High quality animation in some clothes and items, you will definitely love it! Create more gorgeous photos, fabulous videos about your dolls Give your friends your painted, lovely doll girl. Keep track of every innovative designs",
    "instructions": "Click to makeover with your finger Put on suitable cosmetics Dress up in a variety of clothing and items Arrange the scenario Create an unique photographic memory",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Magic",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/5szgywdnkc6zixm78fzw1qs0hqodkoat/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5szgywdnkc6zixm78fzw1qs0hqodkoat/",
    "sourceUrl": "https://html5.gamemonetize.com/5szgywdnkc6zixm78fzw1qs0hqodkoat/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71301",
    "slug": "beaten-barry-prison-face-lol",
    "title": "Beaten Barry Prison Face LOL",
    "description": "Get ready to laugh out loud in Beaten Barry Prison Face LOL &ndash; the wacky face-deformation game where you can poke, drag, and squash Barry Prison&rsquo;s face into hilarious shapes! Stretch, bruise, and twist the photo in real time with slime-like effects, or tap and drag to add funny bumpy marks. Every interaction creates ridiculous results that you can screenshot and share with friends. Whether you want to mash, warp, or just make a goofy face, this game guarantees endless comedy moments!",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2D",
      "Draw",
      "Tung Tung"
    ],
    "thumbnail": "https://img.gamemonetize.com/260vz9cqhbz7hkf1mm180tq41xlsguym/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/260vz9cqhbz7hkf1mm180tq41xlsguym/",
    "sourceUrl": "https://html5.gamemonetize.com/260vz9cqhbz7hkf1mm180tq41xlsguym/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72828",
    "slug": "drop-ball",
    "title": "Drop Ball",
    "description": "Drop Ball is an exciting physics puzzle game where your task is to skillfully drop the ball to fill all the empty spaces on the board. It may sound simple, but things get more challenging with the appearance of obstacles, sloped surfaces, and special terrains that make the balls path unpredictable. Each drop is a test of your observation, calculation, and reflexes!",
    "instructions": "Use the mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Ball",
      "Hypercasual",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/gcxz8h3yk56b5kmhlhanzpe2g910f5gx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gcxz8h3yk56b5kmhlhanzpe2g910f5gx/",
    "sourceUrl": "https://html5.gamemonetize.com/gcxz8h3yk56b5kmhlhanzpe2g910f5gx/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73309",
    "slug": "rescue",
    "title": "Rescue",
    "description": "Rescue is a thrilling puzzle game where you connect wires to help citizens swing across dangerous areas and reach safety. Each level presents a new challenge with complex terrain, unexpected traps, and obstacles that can threaten lives at any moment.",
    "instructions": "Use mouse to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Avoid",
      "Casual",
      "Click",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/kkbc7m7ukszyk8u2e6d2uknp5at6gvxp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kkbc7m7ukszyk8u2e6d2uknp5at6gvxp/",
    "sourceUrl": "https://html5.gamemonetize.com/kkbc7m7ukszyk8u2e6d2uknp5at6gvxp/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73169",
    "slug": "stickman-archer-kick",
    "title": "Stickman Archer Kick",
    "description": "Take the bow and arrows to kick the stickmans and save their lifes, with a ragdoll style, and awesome game physics. Complete all levels to save the stickmans and collect stars to unlock new character.",
    "instructions": "Use the mouse or touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "free html5 games for your website",
      "kiz10",
      "Levels",
      "Puzzle",
      "Shooter",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/ztlovnynr83cl5osxdm27wwr0v16owsn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ztlovnynr83cl5osxdm27wwr0v16owsn/",
    "sourceUrl": "https://html5.gamemonetize.com/ztlovnynr83cl5osxdm27wwr0v16owsn/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73234",
    "slug": "rescue-sharp-turn",
    "title": "Rescue Sharp Turn",
    "description": "Rescue Puzzle 3D is a lightweight 3D fun puzzle game. You need to click on the correct objects in the small three-dimensional scene to trigger mechanisms, remove obstacles or form a chain reaction to meet the level conditions and rescue the injured character. The levels are short but full of ingenuity: turn off the power switch, move rocks, release water to extinguish fire, synthesize props... If you make a wrong move, everyone will lose, but if you make a mistake, everyone will cheer. It supports mouse and touch, and you can fix it and go even if you have fragmented time.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Casual",
      "Logic",
      "Obstacle",
      "Physics",
      "trap"
    ],
    "thumbnail": "https://img.gamemonetize.com/euad95y8syzf9ry1qac2ob63op70x4vl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/euad95y8syzf9ry1qac2ob63op70x4vl/",
    "sourceUrl": "https://html5.gamemonetize.com/euad95y8syzf9ry1qac2ob63op70x4vl/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "73137",
    "slug": "mega-ramps-bike-stunt-game",
    "title": "Mega Ramps Bike Stunt Game",
    "description": "Mega Ramp Bike Stunt Games 3D, you are invited to a brand-new level of excitement and adventure with Impossible Bike Stunt Game Offline 3D 2023. With our new Bike racing games 3D offline 2023, you may see the ultimate experience in Mega Ramp impossible tracks stunt bike rider. With Mega Ramp Bike Stunt Games 3D, driving on the sky road to perform the Mega Ramp impossible bike stunt. Be a Mega Ramp bike stunt master and get the best driving experience on an impossible track by performing stunts on difficult ramps and enjoy the ultimate bike racing 3D experience in the moto bike stunt games extreme racing.",
    "instructions": "Mobile controls available and for keyboard W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Bike",
      "BMX Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/f23ia3pc72ia1xj03rdavhqpligxlq7j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f23ia3pc72ia1xj03rdavhqpligxlq7j/",
    "sourceUrl": "https://html5.gamemonetize.com/f23ia3pc72ia1xj03rdavhqpligxlq7j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72604",
    "slug": "knife-madness",
    "title": "Knife Madness",
    "description": "Aim, throw and survive! Watch out &mdash; avoid hitting other blades. The spinning wheel gets faster, the stakes get higher and only your quick reflexes will keep you in the game. Can you defeat the boss levels and unlock epic knife skins? The challenge is on!",
    "instructions": "The goal of the game is to throw knives onto a spinning wheel avoiding those already placed Aim carefully and use your precision to hit empty spots Each level brings more knives faster speeds and increased difficulty",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Interactive",
      "Knight",
      "Skill",
      "Skills",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/0npammu9ftwyu3a4p4b7dpluj6sq368e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0npammu9ftwyu3a4p4b7dpluj6sq368e/",
    "sourceUrl": "https://html5.gamemonetize.com/0npammu9ftwyu3a4p4b7dpluj6sq368e/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73223",
    "slug": "viking-war",
    "title": "Viking War",
    "description": "Viking War is an action game where you embody a fierce Viking warrior, charging into brutal battles to prove your strength. Each level presents a new challenge, with dangerous enemies waiting for you ahead. Use your weapons, skills, and agility to defeat all opponents, survive the fights, and assert your status as a true Viking warrior. Only those who are resilient, strong, and decisive can claim ultimate victory on the stormy battlefield.",
    "instructions": "- Press the W key or the up arrow to jump - Press Space to attack",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arena",
      "Fight",
      "Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/o7ihd51xk07z7dgqaau8q6vkxzxga6v9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o7ihd51xk07z7dgqaau8q6vkxzxga6v9/",
    "sourceUrl": "https://html5.gamemonetize.com/o7ihd51xk07z7dgqaau8q6vkxzxga6v9/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73269",
    "slug": "labubu-puzzle-challenge",
    "title": "Labubu Puzzle Challenge",
    "description": "Labubu Puzzle Challenge is a fun, exciting, and completely free online jigsaw puzzle game designed especially for kids! In this adorable brain-teasing adventure, players must connect all the small puzzle pieces to recreate a cute Labubu picture. Each puzzle tests attention, memory, and problem-solving skills while keeping the gameplay simple, relaxing, and enjoyable for all ages. Kids can take their time, drag and drop the pieces, and watch the full image come together step by step. Whether you want a quick challenge or a calming puzzle session, Labubu Puzzle Challenge is the perfect pick. Have fun matching the pieces and completing the picture!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Baby",
      "Boys",
      "Girls",
      "Hypercasual",
      "Jigsaw",
      "Kids",
      "Labubu",
      "Mobile",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/dhcbsntirf6yd10394v2bp6n38pwy3f7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dhcbsntirf6yd10394v2bp6n38pwy3f7/",
    "sourceUrl": "https://html5.gamemonetize.com/dhcbsntirf6yd10394v2bp6n38pwy3f7/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72591",
    "slug": "hop-music-ball-game",
    "title": "Hop Music Ball Game",
    "description": "Music Ballz Hop is going to revolutionize your experience with music games. It perfectly blends the thrill of ball games with the rhythm of song games, this game will have you hopping to the beat in no time. Indulge into a world of colorful music tiles, bouncing balls, and entrancing pop music, while enjoying the mesmerizing color switch cube effects that make every moment unforgettable.",
    "instructions": "How to Play In Hop Music Ball the ball moves forward automatically Your only job is to control the ball left and right to keep it landing on the moving blocks How it works Move the ball left or right using the mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ball",
      "Casual",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/c7iy1hpq002mdakbqara3lfmna3oj1qz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c7iy1hpq002mdakbqara3lfmna3oj1qz/",
    "sourceUrl": "https://html5.gamemonetize.com/c7iy1hpq002mdakbqara3lfmna3oj1qz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73229",
    "slug": "school-bus-driving-game",
    "title": "School Bus Driving Game",
    "description": "Are you ready to perform your driver duty as a 4x4 bus driver? If yes then this city high school bus is for you, where you can pick up and drop students at their school on time. The students are waiting for their school bus, pick them up, and drop them at the school. As a preschool bus driver, perform your summer camp school transportation service safely. In free school bus games, follow the traffic rules while driving high school coaches because it takes into consideration the lives of students and teachers. After school pickup service, you have to need drop students at their homes carefully.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "bus",
      "Driving",
      "Race",
      "School",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/7zmhlham22sb3ndn5f69fqks9pnu9xv4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7zmhlham22sb3ndn5f69fqks9pnu9xv4/",
    "sourceUrl": "https://html5.gamemonetize.com/7zmhlham22sb3ndn5f69fqks9pnu9xv4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73183",
    "slug": "dress-up-match-3",
    "title": "Dress Up Match 3",
    "description": "Dress Up Match 3 is the ultimate fashion puzzle game where you match tiles to get outfits! This cute match 3 game for girls and women combines style and match gameplay - solve puzzles to unlock gorgeous clothes, accessories, and makeup. Build your dream wardrobe by completing challenging match 3 levels. The more you play this match 3 dress up game, the more trendy outfits you collect! Dress up your model with hundreds of fashionable items. Best fashion games free to play with no limits! Every puzzle solved adds new pieces to your outfit collection. Perfect style match 3 game for fashion lovers who enjoy puzzle challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Collection",
      "Dress Up",
      "Fashion",
      "free games for your site",
      "Match 3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/17om6g8azok4uvmfa8824ax5lu3ha9ri/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/17om6g8azok4uvmfa8824ax5lu3ha9ri/",
    "sourceUrl": "https://html5.gamemonetize.com/17om6g8azok4uvmfa8824ax5lu3ha9ri/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72862",
    "slug": "maze-escape-challenge",
    "title": "Maze Escape Challenge",
    "description": "Maze Escape Challenge is a fast-paced maze game where your goal is to reach the exit as quickly as possible. Each level features a unique labyrinth with increasing difficulty and new surprises. Some mazes include Dark Mode, where visibility is reduced and you must navigate carefully using only the small light around your player. To progress to higher levels, you need to collect a required number of stars. Stars are earned by completing mazes fast &mdash; the quicker you finish, the more stars you receive (1 to 3 stars). Unlock new levels, improve your best times, and try to perfect every maze. Can you master all labyrinths and collect every star?",
    "instructions": "PC Web W A S D ndash Move Arrow Keys ndash Move Mouse ndash Navigate UI Mobile Touch amp Drag ndash Move the player Tap ndash Buttons and UI",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Escape",
      "Logic",
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/36yncw0seninikhbxzkamsnahoi8n3b1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/36yncw0seninikhbxzkamsnahoi8n3b1/",
    "sourceUrl": "https://html5.gamemonetize.com/36yncw0seninikhbxzkamsnahoi8n3b1/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73175",
    "slug": "labubu-auto-adventure",
    "title": "Labubu Auto Adventure",
    "description": "Labubu Auto Adventure is a super fun and free online driving game for kids! You play as Labubu, cruising through snowy roads in a cool jeep while collecting delicious pancakes for your girl. Gather as many pancakes as possible and make it safely to the finish line. Enjoy the adventure and have fun!",
    "instructions": "Mouse to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Boy",
      "Car",
      "Collecting",
      "Driving",
      "Girl",
      "Hypercasual",
      "jeep",
      "Kid",
      "Labubu",
      "Racing",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/ruobz36yp9vi68oj2s6xj1efn2sjds1r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ruobz36yp9vi68oj2s6xj1efn2sjds1r/",
    "sourceUrl": "https://html5.gamemonetize.com/ruobz36yp9vi68oj2s6xj1efn2sjds1r/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "73193",
    "slug": "link-me-to-the-factory",
    "title": "Link Me To The Factory",
    "description": "Link Me To The Factory is a creative puzzle game where your task is to connect the square blocks according to the rules to complete the system and activate the factory. Each level presents a new structure with the square block positions arranged in a challenging way. You need to observe carefully, calculate a reasonable connection path, and arrange the blocks so that they are all fully connected. If you make just one mistake, the entire system will break, and you will have to start over!",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Block",
      "Brain",
      "Coloring"
    ],
    "thumbnail": "https://img.gamemonetize.com/g7xq8egkbdbvq6mhp8zb7zr4py0jh0x8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g7xq8egkbdbvq6mhp8zb7zr4py0jh0x8/",
    "sourceUrl": "https://html5.gamemonetize.com/g7xq8egkbdbvq6mhp8zb7zr4py0jh0x8/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73203",
    "slug": "resuce-escape",
    "title": "Resuce Escape",
    "description": "Rescue Escape is an action puzzle game where you control stick figures trying to escape from a prison filled with traps. Your mission: guide all the characters past dangerous obstacles and gather them safely at the escape point to open the way out. Each level presents a new challenge&mdash;spike traps, moving obstacles, narrow paths, and countless other dangers force you to move skillfully and calculate each step. If just one stick figure gets stuck, the whole group wont be able to escape!",
    "instructions": "Use mouse to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Casual",
      "Escape",
      "Puzzle",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ld0n9qnfpx6nins5x9zo8esyr6qiiax4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ld0n9qnfpx6nins5x9zo8esyr6qiiax4/",
    "sourceUrl": "https://html5.gamemonetize.com/ld0n9qnfpx6nins5x9zo8esyr6qiiax4/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73197",
    "slug": "slap-man",
    "title": "Slap Man",
    "description": "Slap Man is a hyper-casual parkour game that involves sliding left and right. You sprint through the streets, dodging roadblocks and traps, while sending passing NPCs staggering with well-timed slaps. Its easy to play, brainless and refreshing. If you want to get high scores, you have to be accurate, fast and bad enough. Suitable for playing in fragmented time, supports mouse/touch operation, and is an easy-to-learn little spoof of parkour!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Action",
      "endless",
      "Funny",
      "running",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/i525ff5nendf17hw0exvh7bqyczc25hc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i525ff5nendf17hw0exvh7bqyczc25hc/",
    "sourceUrl": "https://html5.gamemonetize.com/i525ff5nendf17hw0exvh7bqyczc25hc/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72603",
    "slug": "moto-race-city",
    "title": "Moto Race City",
    "description": "Time is key. The longer you ride, the more money you earn to unlock faster, stronger bikes. Feel the speed, upgrade your ride and become unstoppable. Every map is a new challenge &mdash; faster, harder and more dangerous.",
    "instructions": "Ride as fast and as far as you can without crashing Overtake vehicles to earn money unlock new bikes with unique speed handling and braking stats Explore different roads and push your limits on increasingly challenging routes",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Bike",
      "Card",
      "Driving",
      "Moto",
      "Motocross",
      "Motorcycle",
      "Race",
      "Racing",
      "Road",
      "wheel",
      "wheels"
    ],
    "thumbnail": "https://img.gamemonetize.com/q0bv0dhbsdkv726khzvwkk72liyyilgp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q0bv0dhbsdkv726khzvwkk72liyyilgp/",
    "sourceUrl": "https://html5.gamemonetize.com/q0bv0dhbsdkv726khzvwkk72liyyilgp/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "73147",
    "slug": "defense-tower-2025",
    "title": "Defense Tower 2025",
    "description": "Defense Tower 2025 delivers fast-paced futuristic tower-defense action, challenging players to strategize, upgrade high-tech weapons, and withstand escalating waves of robotic enemies. With sleek visuals, dynamic maps, and relentless pressure, the game rewards smart placement, quick decisions, and adaptive tactics as you defend humanity&rsquo;s last stronghold in an intense sci-fi battlefield.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Action",
      "Adventure",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/cmf9r0la5swe9ku3t754dbu3y723nvwf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cmf9r0la5swe9ku3t754dbu3y723nvwf/",
    "sourceUrl": "https://html5.gamemonetize.com/cmf9r0la5swe9ku3t754dbu3y723nvwf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73177",
    "slug": "fast-fruit-juice",
    "title": "Fast Fruit Juice",
    "description": "Fast Fruit Juice is a lively arcade-style game where you slice, mix, and serve colorful fruits at high speed. Precision matters as you combine ingredients, avoid obstacles, and fulfill orders before time runs out. With vibrant visuals and fast-paced challenges, it rewards quick reactions, smooth combos, and satisfying juice-making mastery.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Fruit",
      "Fruits",
      "Funny",
      "Logic"
    ],
    "thumbnail": "https://img.gamemonetize.com/y7slbqpvz04dac94kf770a7lpy76oz03/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/y7slbqpvz04dac94kf770a7lpy76oz03/",
    "sourceUrl": "https://html5.gamemonetize.com/y7slbqpvz04dac94kf770a7lpy76oz03/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72302",
    "slug": "english-checkers",
    "title": "English Checkers",
    "description": "Immerse yourself in the exciting world of Checkers English, where every game is a test of your tactics and foresight! Also this game is known by name Draughts Here, you dont just play - you build a career as a draughts strategist: - The rating system allows you to track your progress and compete for a place in the leaderboard. - Your personal profile stores complete statistics of your games, including the number of wins and losses, the percentage of successful captures, and the average rating of your opponents. Analyze the dynamics and set new goals - Search for opponents via the built-in chat - find like-minded people, discuss strategy",
    "instructions": "Mouse for desktop touch for mobile Click on checker and then clik on target cell on the board",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2 Player",
      "Board",
      "Brain",
      "HTML5",
      "Logic",
      "Mobile",
      "Multiplayer",
      "Online",
      "Puzzle",
      "PvP",
      "Relaxation",
      "Strategy",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/pir55cwoygvsus9az7d5zyxd6gra48dh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pir55cwoygvsus9az7d5zyxd6gra48dh/",
    "sourceUrl": "https://html5.gamemonetize.com/pir55cwoygvsus9az7d5zyxd6gra48dh/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73153",
    "slug": "ninjas-blade",
    "title": "Ninjas Blade",
    "description": "Immerse yourself in the dark world of ninja action! As Ryu, the last warrior of his clan, you&rsquo;ll fight through hordes of enemies to reach the main antagonist - Tengu. Dynamic battles, spectacular combos, deadly traps, and epic boss fights await you. Test your speed, precision, and the power of the Dragon in this hardcore game.",
    "instructions": "Desktop A - left D - right W - jump G - sword attack H - shuriken Esc - pause Mobile Use the on-screen controls",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "assasin",
      "Fighting",
      "Jumping",
      "Killing",
      "Ninja",
      "Stealth",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/4zan7z32l5z63lmeo68xg3t3b7jvzmb0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4zan7z32l5z63lmeo68xg3t3b7jvzmb0/",
    "sourceUrl": "https://html5.gamemonetize.com/4zan7z32l5z63lmeo68xg3t3b7jvzmb0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72833",
    "slug": "mega-escape-car-parking-puzzle",
    "title": "Mega Escape Car Parking Puzzle",
    "description": "A fun and compelling puzzle board game called Parking Jam. Its more than just parking; its an enjoyable driving adventure that will advance you. Parking lot traffic jams, difficult parking conditions, irate seniors, and more. Play one of the best parking board games, earn rewards and unlock skins, solve harder and harder puzzles, decide which car to move to find smooth departs without hitting anybody or anything, characteristics.",
    "instructions": "Move the objects to solve the puzzle",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Car",
      "Match-3",
      "Maze",
      "Parking"
    ],
    "thumbnail": "https://img.gamemonetize.com/249wl1gt32c8pf51yveq11sxc61ob5ub/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/249wl1gt32c8pf51yveq11sxc61ob5ub/",
    "sourceUrl": "https://html5.gamemonetize.com/249wl1gt32c8pf51yveq11sxc61ob5ub/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72195",
    "slug": "drop-stack-ball-game",
    "title": "Drop Stack Ball Game",
    "description": "Welcome to the ultimate stack ball adventure game. A thrilling, addictive, and action-packed hyper-casual game that will keep you hooked for hours! If you love smashing, bouncing, and breaking through colorful platforms with incredible speed and precision, then this stack ball 3d game is made just for you. Get ready to experience the most exciting ball drop challenge where your goal is simple, smash through all the rotating platforms and reach the very bottom of the tower without hitting the deadly black obstacles.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Ball",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/15rsgtn42eictvskflz0sy0vt5zyf5ae/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/15rsgtn42eictvskflz0sy0vt5zyf5ae/",
    "sourceUrl": "https://html5.gamemonetize.com/15rsgtn42eictvskflz0sy0vt5zyf5ae/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72220",
    "slug": "rocket-car-chase-game",
    "title": "Rocket Car Chase Game",
    "description": "Run!! Rocket cars are chasing you! Hold your steering strong and evade them away. Make your way through power-ups, speed-ups, bombs, and coins. Level up and speed up your vehicle, do not get busted. Ready to take the challenge? Run faster choosing your best car! Evade rocket cars and collect coins to stay upgrade to play with new cars in new levels. Bombs, Speed ups and other power ups to make the game play more interesting. Rocket cars are faster than you so stay calm, drive safe &amp; find out the best way to evade those all. Boom those personal cars!!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Battle",
      "Car",
      "Cars",
      "Driving",
      "Rocket"
    ],
    "thumbnail": "https://img.gamemonetize.com/p87qt8y9dwqj57vgahavbg5c5m69nx55/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p87qt8y9dwqj57vgahavbg5c5m69nx55/",
    "sourceUrl": "https://html5.gamemonetize.com/p87qt8y9dwqj57vgahavbg5c5m69nx55/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73037",
    "slug": "cloudy-cleaning",
    "title": "cloudy cleaning",
    "description": "The world of Aqualune had always been a place where water and life danced together. Its floating islands drifted lazily across seas of shimmering blue, connected by streams that glowed like ropes of liquid starlight. Children played beside crystal ponds, and elders fished from silver rivers that sparkled even at midnight. Water was not just a resource in Aqualune it was the heartbeat of the entire world. But the heartbeat began to falter. No one noticed it at first. A few strange bubbles rising from the deep lakes. A patch of murky water near the docks. A fountain that sputtered instead of singing. The elders shrugged it off, believing natu",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2D",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/s2fkdsg73zkoxekkks70i3ac8vjxv29a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s2fkdsg73zkoxekkks70i3ac8vjxv29a/",
    "sourceUrl": "https://html5.gamemonetize.com/s2fkdsg73zkoxekkks70i3ac8vjxv29a/",
    "width": 768,
    "height": 1366,
    "lastUpdated": ""
  },
  {
    "id": "73166",
    "slug": "pushball",
    "title": "PushBall",
    "description": "Push Ball is an intelligent puzzle game where you control a red ball to push purple balls according to the unique movement rules of each type. Your goal: to get all the balls to their designated positions on the map. Each level is designed like a complex problem&mdash;just pushing in the wrong direction can mess up the entire layout and force you to start over. Therefore, observe carefully, calculate each step, and find the most reasonable way to complete the challenge.",
    "instructions": "Use mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ball",
      "Brain",
      "Classic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/plazocnynvxnd11synrxzlblc7hspydb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/plazocnynvxnd11synrxzlblc7hspydb/",
    "sourceUrl": "https://html5.gamemonetize.com/plazocnynvxnd11synrxzlblc7hspydb/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73165",
    "slug": "street-car-race-3d",
    "title": "Street Car Race 3D",
    "description": "This is a simulation racing game. There are many modes in it. There are also nitrogen acceleration and various functions. Real simulation, don&rsquo;t crash.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Car",
      "Casual",
      "Driving",
      "Racing",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/6kjj8zr4e5yro9o6dfifg2lj1b0cg3qo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6kjj8zr4e5yro9o6dfifg2lj1b0cg3qo/",
    "sourceUrl": "https://html5.gamemonetize.com/6kjj8zr4e5yro9o6dfifg2lj1b0cg3qo/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "73128",
    "slug": "slime-escape",
    "title": "Slime Escape",
    "description": "Slime Escape is a puzzle-adventure game where you control a flexible Slime sliding through challenging mazes to find the escape key. Skillfully navigate the Slime through turns, narrow corridors, and unexpected paths; each maze offers a different layout that requires you to observe carefully and calculate the most efficient route. Only by collecting the key can you open the gate and escape!",
    "instructions": "- Use the buttons on the screen to control - Use the Up Down Left and Right keys to move",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Cartoon",
      "Classic",
      "Puzzle",
      "sliding"
    ],
    "thumbnail": "https://img.gamemonetize.com/4vbsf6ut2afctd6e466eansgmyjogoam/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4vbsf6ut2afctd6e466eansgmyjogoam/",
    "sourceUrl": "https://html5.gamemonetize.com/4vbsf6ut2afctd6e466eansgmyjogoam/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73102",
    "slug": "space-brawlers-tds",
    "title": "Space Brawlers TDS!",
    "description": "Space Brawlers is a Non-Stop Action Packed Sci-fi Top-Down Shooter! Choose from 4 unique classes, each with tactical counters, health, speed, and 3 cooldown skills. Play as the Mercenary Gunner, a precision fighter who harasses enemies from range, perfect for beginners thanks to his aim-bot ability. The Blitz Scout thrives on lightning speed and supportive powers, but demands accuracy to shred foes. Prefer durability? WHIP out the Stalwart Tank, sacrificing speed for defense and smashing through enemy positions. Or pick Salvus Tech, repairing allies, holding ground with turrets, and breaking stalemates with Hypercharge.",
    "instructions": "Capture control defend points before time runs out or your team scores 1 000 points How to Play Use Q E and F abilities to gain advantage WASD to move left click to fire SPACE to jump pads and acitvate secret abilities",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Brawl",
      "Cartoon",
      "Shoot",
      "Shooter",
      "Shooting",
      "Tanks",
      "Top Down",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/lb0odw8lkqrwu7kzs5qte8ynyq5e03e4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lb0odw8lkqrwu7kzs5qte8ynyq5e03e4/",
    "sourceUrl": "https://html5.gamemonetize.com/lb0odw8lkqrwu7kzs5qte8ynyq5e03e4/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "73146",
    "slug": "stickjump",
    "title": "StickJump",
    "description": "StickJump is a high-speed reflex game where you control a stick figure running around an endless circle. But dont be complacent&mdash;obstacles appear continuously and completely unexpectedly, always trying to block your path! Your task is very simple: jump at the right moment, dodge accurately, and try to run for as long as possible. The longer you survive, the faster the speed increases and the challenges become harder, creating a thrilling experience in every moment.",
    "instructions": "- Use W up arrow to change direction - Hold S down arrow to dash",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Casual",
      "Jumping",
      "running",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/y495cxabjpk43d833bsm8acoay0l4n5a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/y495cxabjpk43d833bsm8acoay0l4n5a/",
    "sourceUrl": "https://html5.gamemonetize.com/y495cxabjpk43d833bsm8acoay0l4n5a/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73112",
    "slug": "pixelparkour",
    "title": "PixelParkour",
    "description": "PixelParkour is a pixel-style action game where you take on the role of a professional thief in a black outfit with exceptional parkour skills.Your mission: overcome obstacles, avoid dangerous traps, collect gold, and find your way to the finish line safely. Each level is full of surprises, requiring you to be quick and precise with every jump!",
    "instructions": "- Hold the mouse to jump - Release the mouse to fall",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Avoid",
      "Cartoon",
      "Jumping",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/27foeoin58lzi2aaa7ppjgnr63c8uzas/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/27foeoin58lzi2aaa7ppjgnr63c8uzas/",
    "sourceUrl": "https://html5.gamemonetize.com/27foeoin58lzi2aaa7ppjgnr63c8uzas/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "73139",
    "slug": "raccoon-clicker",
    "title": "Raccoon Clicker",
    "description": "Raccoon Clicker is a cute and relaxing idle game where you build your own raccoon world, one tap at a time! Start by clicking your little raccoon to earn your first coins, then unlock helpers like mama raccoons, parks, trash planes, and even space upgrades. The more you tap, the faster your raccoon family grows. Collect adorable raccoon characters, upgrade your world, and follow funny news headlines about strange raccoon activity in the human world. Each upgrade makes your raccoon empire bigger, from simple trash collecter friends to cosmic raccoon explorers. Build, tap, upgrade, and discover what the raccoons are really planning!",
    "instructions": "Tap or click the big raccoon to earn coins Tap upgrade buttons to buy helpers and boost your income Swipe or drag the shop list to scroll through upgrades Tap the icons on the right side to open settings and other menus",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Click",
      "Clicker",
      "free games for your site",
      "idle",
      "Kids",
      "NoViolence"
    ],
    "thumbnail": "https://img.gamemonetize.com/ek2mqvg6azeayh1l3bwjkfdbzc2myesz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ek2mqvg6azeayh1l3bwjkfdbzc2myesz/",
    "sourceUrl": "https://html5.gamemonetize.com/ek2mqvg6azeayh1l3bwjkfdbzc2myesz/",
    "width": 1600,
    "height": 1200,
    "lastUpdated": ""
  },
  {
    "id": "71866",
    "slug": "clonium",
    "title": "Clonium",
    "description": "Capture your opponents cells, think through every move, and use strategy to be the last one standing. The more explosions, the more spectacular the game! Simple rules, but an endless number of combinations and tactics make Clonium incredibly addictive.",
    "instructions": "The board is divided into cells each capable of holding multiple pieces - Players take turns filling their cell - When a cell is full it explodes scattering the pieces into adjacent cells - If the pieces land in your opponents cells they become you",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2D",
      "Ai Games",
      "Android",
      "Arcade",
      "Best Games",
      "Clash",
      "free html5 games for your website",
      "Skills",
      "unity games for your site",
      "unity games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/cx9ykv4xl6wlfq6vd9odkn68e6zenz7s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cx9ykv4xl6wlfq6vd9odkn68e6zenz7s/",
    "sourceUrl": "https://html5.gamemonetize.com/cx9ykv4xl6wlfq6vd9odkn68e6zenz7s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72471",
    "slug": "magic-mahjong",
    "title": "Magic mahjong",
    "description": "Dive into the world of &ldquo;Magic Mahjong,&rdquo; where classic mechanics meet the mystique of runes. Each level brings unique layouts and increasing difficulty. The core mahjong rule: to select a pair, a rune must be open &mdash; it must have no neighbor on its right or left. Find rune pairs, clear the board, and earn points for streaks of matches.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "HTML5",
      "Mahjong",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ziw120fv4kopsa9yvvyo5r0vxlxl07vz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ziw120fv4kopsa9yvvyo5r0vxlxl07vz/",
    "sourceUrl": "https://html5.gamemonetize.com/ziw120fv4kopsa9yvvyo5r0vxlxl07vz/",
    "width": 840,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "72045",
    "slug": "fly-to-star",
    "title": "Fly To Star",
    "description": "Fly to Stars is a fast-paced, skill-based flying arcade game that challenges your reflexes, precision, and focus. Take control of a sleek starship soaring through dazzling cosmic skies filled with obstacles, glowing stars, and endless adventure. Every move counts &mdash; one wrong tap, and it&rsquo;s game over! Feel the thrill of dodging meteor trails and glowing barriers as you rise higher and higher into the vast unknown. boost your score and prove your mastery in this addictively simple yet endlessly challenging experience. Whether you&rsquo;re playing on desktop or mobile, Fly to Stars delivers smooth, responsive controls and a clean, vibrant design that keeps you hooked from the very first flight.",
    "instructions": "Mouse Touch",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io",
      "1 Player",
      "2 Player",
      "2025 games",
      "2D",
      "Action",
      "Anime",
      "Arcade",
      "Avoid",
      "endless",
      "fly",
      "Obstacle",
      "sky",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/9jqpga0tv9qvy7f749e039673zdq3np8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9jqpga0tv9qvy7f749e039673zdq3np8/",
    "sourceUrl": "https://html5.gamemonetize.com/9jqpga0tv9qvy7f749e039673zdq3np8/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "72643",
    "slug": "fps-shooting-game-3d-gun-game",
    "title": "FPS Shooting Game: 3D Gun Game",
    "description": "Are you ready to play the best Action shooter game ever, complete with realistic modes and weapons? Join a worldwide community of millions of players in an offline Shooting game. The goal is to survive and compete against your opponents. Enemy snipers and soldiers are ready to retaliate and counter your maneuvers. This is a survival fps shooting game in which you must use strategy and skill to finish the missions. As a member of our C Ops team, you will play as a hardcore commando. In this war game 3d, Your objective is to enter enemy territory and assassinate high-profile targets in gun games 3d.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Enemies",
      "Shoot",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/brlo27b6436ff8upmd5e8awfzxpikovi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/brlo27b6436ff8upmd5e8awfzxpikovi/",
    "sourceUrl": "https://html5.gamemonetize.com/brlo27b6436ff8upmd5e8awfzxpikovi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72155",
    "slug": "mahjong-connect-spooky",
    "title": "Mahjong Connect: Spooky",
    "description": "Click a tile to select it. Click another tile to make a move. A move can only be made if there are 2 or fewer bends in the line. There are 10 levels in the game.",
    "instructions": "Use the mouse to click tiles",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/38mhcpt34xh8j6hguzws8jcoo42e9dta/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/38mhcpt34xh8j6hguzws8jcoo42e9dta/",
    "sourceUrl": "https://html5.gamemonetize.com/38mhcpt34xh8j6hguzws8jcoo42e9dta/",
    "width": 760,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "72197",
    "slug": "real-mountain-climber-game",
    "title": "Real Mountain Climber Game",
    "description": "Welcome to the world of real mountain climber games. Get ready to climb the challenging mountain peaks and become the King of the mountain! This immersive mountain climbing simulator takes you on an adventure of a lifetime, where you climb to the peak of each mountain and collect coins. Climbing the mountain game offers a diverse and exciting gameplay experience in mountain climber. Get ready to push your limits in real climber game, the ultimate mountain climbing adventure that will test your skills, focus, and determination!",
    "instructions": "To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Cartoon",
      "Click",
      "Helicopter",
      "mountain"
    ],
    "thumbnail": "https://img.gamemonetize.com/fj98q32pmgh1r7a3wo2lrdc3xhx1dnmj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fj98q32pmgh1r7a3wo2lrdc3xhx1dnmj/",
    "sourceUrl": "https://html5.gamemonetize.com/fj98q32pmgh1r7a3wo2lrdc3xhx1dnmj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72914",
    "slug": "highway-traffic-racerr",
    "title": "Highway Traffic Racerr",
    "description": "Are you bored from previous playing Car race game and new car games 2025? Car racing fun - Car Games 3D 2025 might be the racing car speed game you are looking for. Welcome to the real car racing games and new offline car racing games 2025. Car driving games will bring you the most compelling and enjoyable highway traffic racing games experience. Compete with other players while driving through a speed car racing 3d games offline tour. Enjoy the power of extreme car driving &amp; racing in your hands. Car games master 3d and offline car games simulator have a lot of stunning cars to choose from such as endless racing cars and sports cars.",
    "instructions": "Mobile controls available and for keyboard W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Best Games",
      "Car",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/kkjxnb8lwk9cwznz46u2sw9devjkzql8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kkjxnb8lwk9cwznz46u2sw9devjkzql8/",
    "sourceUrl": "https://html5.gamemonetize.com/kkjxnb8lwk9cwznz46u2sw9devjkzql8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72521",
    "slug": "black-friday-mystery-sale",
    "title": "Black Friday Mystery Sale",
    "description": "Dive into the excitement of Black Friday shopping with a twist! In the Black Friday Mystery Sale dress up game, fashion surprises await, and its up to you to style the princesses with fabulous outfits hidden inside the mystery boxes. Ready for a shopping spree you&rsquo;ll never forget? Start playing now!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Girl",
      "Princess",
      "Shopping"
    ],
    "thumbnail": "https://img.gamemonetize.com/kxoov2brmemdeblj1fjm0uwt52yw3kr0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kxoov2brmemdeblj1fjm0uwt52yw3kr0/",
    "sourceUrl": "https://html5.gamemonetize.com/kxoov2brmemdeblj1fjm0uwt52yw3kr0/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72619",
    "slug": "tokyo-treats",
    "title": "Tokyo Treats",
    "description": "In this engaging puzzle game, youre tasked with matching a variety of colorful fruit hues to clear the board and earn sweet rewards. As you progress through increasingly challenging levels, the colors and combinations become more complex, requiring strategic thinking and quick reflexes to succeed. With each new level, the excitement builds and the thrill of the match grows, challenging you to rise to the challenge and become a master of fruit-matching. Can you master the art of matching and claim victory?",
    "instructions": "Click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Candy",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/mp8r029cl7fae9fgu4oiitgftwhs646y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mp8r029cl7fae9fgu4oiitgftwhs646y/",
    "sourceUrl": "https://html5.gamemonetize.com/mp8r029cl7fae9fgu4oiitgftwhs646y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73032",
    "slug": "bloom-crush",
    "title": "Bloom Crush",
    "description": "Bloom Crush is a classic match-3 puzzle game filled with fun challenges. Swap items to make lines of three or more matching pieces, horizontally or vertically. Keep matching to clear tiles and move through each stage. Use power-ups like bombs, arrows, magnets, and more to finish levels faster. Beat all 75 levels to win the game!",
    "instructions": "Use a mouse or touchpad to swap flowers to make a match of three or more",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Match-3",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/vkh0651zwog47f9g2lxbjlphz9q5lll9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vkh0651zwog47f9g2lxbjlphz9q5lll9/",
    "sourceUrl": "https://html5.gamemonetize.com/vkh0651zwog47f9g2lxbjlphz9q5lll9/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "72325",
    "slug": "stickman-sky-3d",
    "title": "stickman sky 3D",
    "description": "Stickman Sky 3D is a fast-paced action game where you control a stickman running through floating sky platforms, dodging obstacles, jumping between gaps, and collecting rewards. The game challenges your reflexes with increasing speed, dynamic traps, and thrilling sky-high environments designed to test precision, timing, and quick decision-making.",
    "instructions": "WSAD to control and Space to jump",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "Fun",
      "Jumping",
      "unity games for your site",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ss13q0odm4vofj1co2daj2cq4mmd8dbv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ss13q0odm4vofj1co2daj2cq4mmd8dbv/",
    "sourceUrl": "https://html5.gamemonetize.com/ss13q0odm4vofj1co2daj2cq4mmd8dbv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "73098",
    "slug": "alien-forest-jump",
    "title": "Alien Forest Jump",
    "description": "Alien Forest Jump is an action-packed platformer where a brave alien navigates a mysterious forest filled with traps, unstable platforms, and dangerous creatures. Players must execute precise jumps, avoid obstacles, and collect power-ups to advance as far as possible in this fast-paced intergalactic adventure. Web Dev <a href='https://www.unblockedgamestop.com/'>https://www.unblockedgamestop.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Alien",
      "Animal",
      "Arcade",
      "Jumping"
    ],
    "thumbnail": "https://img.gamemonetize.com/0r2lzld37cqojc1jar4mh6cke028425q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0r2lzld37cqojc1jar4mh6cke028425q/",
    "sourceUrl": "https://html5.gamemonetize.com/0r2lzld37cqojc1jar4mh6cke028425q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72366",
    "slug": "apex-rush",
    "title": "Apex Rush",
    "description": "Welcome to Ultimate Car Race, the ultimate test of speed, reflex, and precision driving! Get behind the wheel of your high-performance race car and take on thrilling tracks, heart-pounding rivals, and intense challenges that push your skills to the limit. Whether you&rsquo;re a casual gamer looking for fast fun or a die-hard racing fan hungry for competition, Ultimate Car Race delivers nonstop excitement, gorgeous 2D visuals, and addictive gameplay designed for everyone. The roar of the engines, the screech of the tires, the smell of burning rubber it&rsquo;s all here. Your mission? Race through vibrant cities, scorching deserts, and twisting mountain",
    "instructions": "Keyboard Controls - Home ndash Move Left - End ndash Move Right - Page Up ndash Move Up - Page Down ndash Move Down",
    "category": "3D",
    "genres": [
      "3D"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Bricks",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/ramp6ibpxwm777g2hmdsvbnx9rdisd6i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ramp6ibpxwm777g2hmdsvbnx9rdisd6i/",
    "sourceUrl": "https://html5.gamemonetize.com/ramp6ibpxwm777g2hmdsvbnx9rdisd6i/",
    "width": 20000,
    "height": 20000,
    "lastUpdated": ""
  },
  {
    "id": "72876",
    "slug": "marble-maze-game",
    "title": "Marble Maze Game",
    "description": "Players rotate a circular maze packed with small moving balls, guiding a single ball toward the center. The goal is to carefully tilt and rotate the maze so the main ball drops perfectly into the vertical cylinder in the middle. Each level increases difficulty with tighter paths, faster movement, and more obstacles to avoid. With smooth controls, clean visuals, and satisfying physics, this rotation maze challenge offers a fun mix of skill, timing, and strategy. Ideal for fans of puzzle, balance.",
    "instructions": "PC Mouse Click and hold on the left or right side of the maze to rotate it Mobile Tap or hold on the left or right side of the screen to rotate the maze",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/zr3pn302pn7b4a6kb4cohh799a2eu7uh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zr3pn302pn7b4a6kb4cohh799a2eu7uh/",
    "sourceUrl": "https://html5.gamemonetize.com/zr3pn302pn7b4a6kb4cohh799a2eu7uh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72917",
    "slug": "aircraft-space-turret",
    "title": "Aircraft Space Turret",
    "description": "This is a 3D game that simulates a real fighter jet from a first-person perspective. Enjoy strafing while avoiding enemy bombings in the game!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "airplane",
      "attack",
      "Driving",
      "Shoot 'Em Up",
      "Shooter",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/1ocmj7di2lg6bytceakrfvik6hwuimrz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1ocmj7di2lg6bytceakrfvik6hwuimrz/",
    "sourceUrl": "https://html5.gamemonetize.com/1ocmj7di2lg6bytceakrfvik6hwuimrz/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "70195",
    "slug": "autumn-glam-gala",
    "title": "Autumn Glam Gala",
    "description": "Get ready for the ultimate fall beauty adventure at the Autumn Glam Gala! Help three BFFs create stunning makeup looks for the most anticipated gala of the season. From soft, natural tones to bold, sparkling colors, you&rsquo;ll have endless fun choosing makeup, hairstyles, and glamorous outfits. Experiment with fall-inspired looks and fashion trends to ensure each friend shines at the gala. Are you ready to showcase your makeup artist skills? Play Autumn Glam Gala now and let the glam begin!",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/k3htkr72jyxvq9gk997848f4oawi2bhj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k3htkr72jyxvq9gk997848f4oawi2bhj/",
    "sourceUrl": "https://html5.gamemonetize.com/k3htkr72jyxvq9gk997848f4oawi2bhj/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72329",
    "slug": "race-traffic-crazy",
    "title": "Race Traffic Crazy",
    "description": "Race Traffic Crazy throws you into high speed lanes packed with reckless drivers, tight corners, and nonstop near misses. Dodge cars, thread impossible gaps, and chase new records while your heart pounds. Web Dev h<a href='https://www.poki.com.es/'>https://www.poki.com.es/</a> One tiny mistake and it is game over, so stay sharp and floor it, every single terrifying run.",
    "instructions": "wasd to drive",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Car",
      "Driving",
      "Mentolatux",
      "Race",
      "Supercars",
      "Traffic",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/81p68gvtqdfhc0g4pjz672alvu5mrurv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/81p68gvtqdfhc0g4pjz672alvu5mrurv/",
    "sourceUrl": "https://html5.gamemonetize.com/81p68gvtqdfhc0g4pjz672alvu5mrurv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72610",
    "slug": "dog-racing-master-game",
    "title": "Dog Racing Master  Game",
    "description": "Ultimate dog racing tournament is being started in mighty stadium with huge crowd in Dog Race Game: Dog Racing 3D. Enjoy this dog racing simulator game and become a crazy dog racer. Dog racing is an interesting dog race championship with many racing dog breeds and this is more fun than a dog chase race. Have you played dog chase racing games before this dog racing simulator and dog race games?",
    "instructions": "Mouse click or tap to play Press W to Run Dog Press Shift For Boost",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Race",
      "Racing",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/hc4opz2pjsgyxtdsbnshnz5meju8ipap/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hc4opz2pjsgyxtdsbnshnz5meju8ipap/",
    "sourceUrl": "https://html5.gamemonetize.com/hc4opz2pjsgyxtdsbnshnz5meju8ipap/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72946",
    "slug": "mashup-hero",
    "title": "Mashup Hero",
    "description": "Mashup Hero is a fast-paced mecha parkour game where you assemble a robot while sprinting to the finish line. Swipe to avoid traps, then unleash a massive shockwave to crush your opponents in the final arena. Earn cores to upgrade speed, armor, and strength, unlock new skins, and complete increasingly tricky courses. Simple one-finger control, bite-sized stage, massive hits.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Action",
      "Fighting",
      "Hypercasual",
      "Levels",
      "Robot",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/tdv27vpdpio4ybapsixwrd3nc0qq81ge/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tdv27vpdpio4ybapsixwrd3nc0qq81ge/",
    "sourceUrl": "https://html5.gamemonetize.com/tdv27vpdpio4ybapsixwrd3nc0qq81ge/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72919",
    "slug": "winter-tile-connect",
    "title": "Winter Tile Connect",
    "description": "Winter Tile Connect is a fun and relaxing puzzle game where you match two identical winter tiles. Draw a line to connect them using three or fewer straight segments. The path may turn no more than two times and cannot cross other tiles. Clear all tiles to finish the level. The game has many levels and each one becomes a little harder. Play, relax, and enjoy the calm winter mood while you train your brain.",
    "instructions": "Use your mouse or a touchpad to connect tiles",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Christmas",
      "html5 games",
      "Matching",
      "Mobile",
      "Puzzle",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/c7c9w53rs28jcb1fmeqgloxtfb8ze916/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c7c9w53rs28jcb1fmeqgloxtfb8ze916/",
    "sourceUrl": "https://html5.gamemonetize.com/c7c9w53rs28jcb1fmeqgloxtfb8ze916/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "72612",
    "slug": "pop-the-lock-game",
    "title": "Pop The Lock Game",
    "description": "Unlock your target by hitting it accurately. Develop your skills in levels filled with rotating bars, accelerating rotation speeds, and more. This simple yet addictive game is ready to challenge and entertain you at every level! Tap on the left or right side of the screen. Align the lock with the correct target. Release the touch to unlock. The combination of strategy and speed ensures Pop the Lock delivers an indispensable experience. Enjoy the game and share your best scores with friends!",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Funny",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/lsdr4urdlf5b0588dquwcpiy10yk47w7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lsdr4urdlf5b0588dquwcpiy10yk47w7/",
    "sourceUrl": "https://html5.gamemonetize.com/lsdr4urdlf5b0588dquwcpiy10yk47w7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72916",
    "slug": "winter-labubu-pacman-adventure",
    "title": "Winter Labubu Pacman Adventure",
    "description": "Winter Labubu Pacman Adventure is a super fun online game inspired by classic Pac-Man gameplay. Navigate the icy maze, avoid enemies, collect items, and survive as long as possible. Stay sharp, keep moving, and most importantly&mdash;have fun!",
    "instructions": "Arrow keys to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Escape",
      "Hypercasual",
      "Kids",
      "Labubu",
      "Logic",
      "Maze",
      "Mobile",
      "PacMan",
      "Puzzle",
      "Skill",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/0ychz5yzi2xhlndeypmlq5svnh2hwx08/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0ychz5yzi2xhlndeypmlq5svnh2hwx08/",
    "sourceUrl": "https://html5.gamemonetize.com/0ychz5yzi2xhlndeypmlq5svnh2hwx08/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "72874",
    "slug": "furry-wedding-proposal",
    "title": "Furry Wedding Proposal",
    "description": "Hi, young stylist! You will find a very unusual couple in love - a brutal fox and a feminine bunny - who are preparing for their future wedding. They dream of looking stunning on this holiday and you will become their main assistant in this exciting adventure! You have to dress the characters in beautiful wedding dresses, choose stylish hairstyles for them and apply light makeup. Are you ready to become a part of this wonderful story and help the characters become the most beautiful couple? Create, fantasize and create a fairy tale with them!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Animal",
      "Cartoon",
      "Cute",
      "Dress Up",
      "Hair",
      "Love",
      "Rabbit",
      "valentine day"
    ],
    "thumbnail": "https://img.gamemonetize.com/6deaaf6we5wdex6n9x6da8qlg2vwht3u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6deaaf6we5wdex6n9x6da8qlg2vwht3u/",
    "sourceUrl": "https://html5.gamemonetize.com/6deaaf6we5wdex6n9x6da8qlg2vwht3u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72810",
    "slug": "black-friday-store-manager",
    "title": "Black Friday Store Manager",
    "description": "Build your dream clothing store in the Black Friday Store Manager game! Buy new clothes, place them on the shelves and attract customers looking for the latest fashion. Earn coins from every sale and invest them wisely to expand your store, upgrade your staff and unlock new areas. Move your character around the store, replenish empty shelves and keep customers happy with fast service. Will you focus on cheap fast fashion or higher-margin premium designer products?",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "3D",
      "Business",
      "Casual",
      "Girls",
      "HTML5",
      "Management",
      "Shopping",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/tib6wak2cd3ux9mj8di0eeezdvxtra07/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tib6wak2cd3ux9mj8di0eeezdvxtra07/",
    "sourceUrl": "https://html5.gamemonetize.com/tib6wak2cd3ux9mj8di0eeezdvxtra07/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72249",
    "slug": "fruit-drop-puzzle-game",
    "title": "Fruit Drop Puzzle Game",
    "description": "Welcome to Furitrot Merge &ndash; a uniquely chaotic Italian merge puzzle game where strategy meets satisfaction. In Furitrot Merge, your goal is to combine viral Furitrot characters to fulfill customer orders and progress through endlessly fun levels. Whether youre playing for a quick break or a longer session, the fast-paced gameplay and unexpected character drops will keep you engaged. Each character brings its own unique personality and chaos. Can you unlock them all?",
    "instructions": "- To click any button use mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2025 games",
      "Animal",
      "Casual",
      "Fruits",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/iyqprq93bhwn2j53egheo3za2aemqpq8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iyqprq93bhwn2j53egheo3za2aemqpq8/",
    "sourceUrl": "https://html5.gamemonetize.com/iyqprq93bhwn2j53egheo3za2aemqpq8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72640",
    "slug": "bubble-man-runner-game",
    "title": "Bubble Man Runner Game",
    "description": "Welcome to Bubble Runner Game, a fun and exciting running game full of colorful bubbles, jumping action, and endless adventure. In this bubble running game, you control a cute bubble that rolls, jumps, and runs across amazing tracks. Enjoy smooth controls, bright colors, and simple fun in this bubble game made for all ages.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Bridge",
      "Bubble",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/za55ayaekb6v4popocbptsxzpsvj47bu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/za55ayaekb6v4popocbptsxzpsvj47bu/",
    "sourceUrl": "https://html5.gamemonetize.com/za55ayaekb6v4popocbptsxzpsvj47bu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72836",
    "slug": "railways-train-simulator-game",
    "title": "Railways Train Simulator Game",
    "description": "Welcome to Train Parking Game, the most fun and realistic train driving game where you park trains carefully and complete amazing missions. Enjoy the real experience of train parking, driving, and transporting passengers in beautiful 3D environments. In Train Parking Game, you become a real train driver who controls powerful engines on different tracks. Your goal is to park trains safely at the right spot without crashing. The easy controls and smooth gameplay make this train simulator game perfect for all players.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Driving",
      "mountain",
      "Parking",
      "Train"
    ],
    "thumbnail": "https://img.gamemonetize.com/hg2zzusjodkrau8lpbt50zouac81n91t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hg2zzusjodkrau8lpbt50zouac81n91t/",
    "sourceUrl": "https://html5.gamemonetize.com/hg2zzusjodkrau8lpbt50zouac81n91t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72847",
    "slug": "celebrity-thanksgiving-prep",
    "title": "Celebrity Thanksgiving Prep",
    "description": "It&rsquo;s Thanksgiving, and the celebrities are getting ready for the big day! In Celebrity Thanksgiving Prep, you&rsquo;ll help your favorite stars get glammed up for the holiday dinner. Start by creating stunning makeup looks, styling hair, and choosing the perfect fall outfit. Then, join them in the kitchen for some festive cooking fun! From cozy sweaters to chic party dresses, show off your fashion taste and creativity in this delightful seasonal makeover game.",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Cute",
      "Dress Up",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/2o0fsrcn9yiwcyei20dyz1tjl7ujvrrl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2o0fsrcn9yiwcyei20dyz1tjl7ujvrrl/",
    "sourceUrl": "https://html5.gamemonetize.com/2o0fsrcn9yiwcyei20dyz1tjl7ujvrrl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71468",
    "slug": "horde-zombie-war",
    "title": "Horde Zombie War",
    "description": "Horde Zombie War is an intense top-down shooter where you battle endless waves of zombies across multiple levels and face powerful bosses. Upgrade your reflexes, dodge attacks, and survive the undead assault using quick aim and precision fire. Web Dev <a href='https://www.unblockedgamest.com/'>https://www.unblockedgamest.com/</a>",
    "instructions": "Hold mouse to fire the machine gun Move the crosshair to aim bull Press Space to pause resume bull M to mute You lose one life each time you get hit",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Ai Games",
      "battleship",
      "Best Games",
      "Click",
      "Shooter",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/rtvrw32wvt6cfmuynn0dy5dqwzd69q94/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rtvrw32wvt6cfmuynn0dy5dqwzd69q94/",
    "sourceUrl": "https://html5.gamemonetize.com/rtvrw32wvt6cfmuynn0dy5dqwzd69q94/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72627",
    "slug": "hexa-merge-2048-puzzle",
    "title": "Hexa Merge 2048: Puzzle",
    "description": "Dive into Hexa Merge 2048, the exciting puzzle game that mixes numbers and fun! Merge colorful, smiling hexagon tiles on a magical adventure. Combine numbers like 2, 4, and 8 to create 2048 in this brain-teasing challenge. With its cute, kid-friendly design and simple tap-to-merge gameplay, its the perfect educational game for children. Enjoy vibrant graphics, relaxing music, and endless puzzle fun. Download the best free number game and start your merging journey today",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Casual",
      "Educational",
      "Family",
      "hexagon",
      "Hypercasual",
      "Kids",
      "Number",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/5r7akvnmm0t25uang36jgu02fek7qqr5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5r7akvnmm0t25uang36jgu02fek7qqr5/",
    "sourceUrl": "https://html5.gamemonetize.com/5r7akvnmm0t25uang36jgu02fek7qqr5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64131",
    "slug": "roll-away-3d",
    "title": "Roll Away 3D",
    "description": "This Ball rolling gameplay mechanics of ZenRoll are elegantly simple yet deeply engaging, centering on the intuitive control of the balls movement through subtle keyboard inputs. As players gracefully navigate through the meticulously crafted levels, they will encounter an array of obstacles and challenges strategically positioned to test their skill and patience. However, fear not, for the difficulty curve is delicately balanced, ensuring a stress-free experience that fosters a sense of exploration and discovery at every turn.",
    "instructions": "Left Right Up Down arrow key - Movement spacebar - Jump",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "3D Games",
      "Adventure",
      "amazing",
      "Arcade",
      "Ball",
      "unity",
      "unity games",
      "unity games for your site",
      "unity games for your website",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/nhgld41ueub48pma1jjtum04qgt2jzp3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nhgld41ueub48pma1jjtum04qgt2jzp3/",
    "sourceUrl": "https://html5.gamemonetize.com/nhgld41ueub48pma1jjtum04qgt2jzp3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72835",
    "slug": "police-car-parking-game",
    "title": "Police Car Parking Game",
    "description": "Welcome to Police Parking Game, the best police car driving game where you can test your parking skills and experience real cop car driving in 3D environments. Enjoy smooth controls, realistic missions, and fun challenges in this exciting police parking simulator. In this Police Parking Game, you play as a real police officer who drives and parks patrol cars with skill and precision. The goal is simple &mdash; park the car safely without hitting obstacles. This parking simulator is perfect for beginners and experts who love driving games.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Car",
      "carparking",
      "Driving",
      "Parking",
      "Police"
    ],
    "thumbnail": "https://img.gamemonetize.com/578b5br8b4p9vnh8mzu2t9gk88blkvz3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/578b5br8b4p9vnh8mzu2t9gk88blkvz3/",
    "sourceUrl": "https://html5.gamemonetize.com/578b5br8b4p9vnh8mzu2t9gk88blkvz3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72638",
    "slug": "tractor-parking-and-driving-game",
    "title": "Tractor Parking And Driving Game",
    "description": "Welcome to the tractor parking driving game, the ultimate tractor driving and parking simulator made for everyone who loves realistic parking challenges. This game gives you the fun of parking powerful tractors on a beautiful highway environment with smooth roads and open spaces. It&rsquo;s simple, relaxing, and full of interesting levels that test your patience, timing, and driving skills. This tractor game gives you a full real tractor driving and parking experience. You&rsquo;ll learn how to control your vehicle properly in tight spaces, reverse park, and handle turns on smooth roads.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "city",
      "Driving",
      "Parking",
      "Simulation",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/15b7hdc6yr0f8mk95jgbx9b03q4q6c14/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/15b7hdc6yr0f8mk95jgbx9b03q4q6c14/",
    "sourceUrl": "https://html5.gamemonetize.com/15b7hdc6yr0f8mk95jgbx9b03q4q6c14/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72848",
    "slug": "tic-tac-toe-sprunki",
    "title": "Tic Tac Toe Sprunki",
    "description": "Tic Tac Toe Sprunki is a fun and interactive version of the classic game you know and love! Challenge opponent and test your strategy skills.The goal is simple &mdash; line up three of your Sprunki heads before your opponent does! Have fun playing.entertainment with friends online.",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Boy",
      "Brain",
      "Fun",
      "Girl",
      "Hypercasual",
      "Kids",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/cejcp4vy4nc1lkflrx8jrpfcixw7e37b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cejcp4vy4nc1lkflrx8jrpfcixw7e37b/",
    "sourceUrl": "https://html5.gamemonetize.com/cejcp4vy4nc1lkflrx8jrpfcixw7e37b/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "72868",
    "slug": "rocket-fest",
    "title": "Rocket Fest",
    "description": "Control the rocket to collect energy or other useful props along the way, and bomb the target at the end! This is a casual stress relief game.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Casual",
      "destroy",
      "Rocket",
      "run",
      "Shoot",
      "slide"
    ],
    "thumbnail": "https://img.gamemonetize.com/q5b8pfuo0rhucj7un9t3pzr94vh5oc8x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q5b8pfuo0rhucj7un9t3pzr94vh5oc8x/",
    "sourceUrl": "https://html5.gamemonetize.com/q5b8pfuo0rhucj7un9t3pzr94vh5oc8x/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "70390",
    "slug": "goldrush",
    "title": "GoldRush",
    "description": "GoldRush &mdash; a thrilling 2D endless runner where you play as a grumpy little dwarf miner on the hunt for gold! Leap across shaky platforms, grab shiny nuggets, and dodge falling rocks before they crush you flat. Beware of sneaky traps, deadly spikes, and bottomless pits &mdash; the cave is out to get you! The deeper you go, the faster the pace. How long can you keep up the rush and prove you&rsquo;re the toughest miner underground?",
    "instructions": "Controls PC Keyboard A D mdash move left and right Spacebar mdash jump Android Touch Lower left part of the screen mdash built-in dynamic joystick for moving left and right Right side of the screen mdash jump button",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Gold",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/qezo7d10nv4d2pblyf8i7idbqji1bsog/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qezo7d10nv4d2pblyf8i7idbqji1bsog/",
    "sourceUrl": "https://html5.gamemonetize.com/qezo7d10nv4d2pblyf8i7idbqji1bsog/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66969",
    "slug": "jewel-blaster",
    "title": "Jewel Blaster",
    "description": "Dive into the sparkling world of Jewel Blaster, a fun and addictive HTML5 puzzle game where strategy meets excitement! Your mission is to match three or more dazzling jewels of the same color to blast them from the board, earn points, and unlock new challenges. With every move, players must think carefully to create powerful combos, trigger chain reactions, and achieve the highest score possible. The game offers smooth controls, bright graphics, and satisfying sound effects that keep players engaged for hours. Each level brings new obstacles and objectives, making gameplay fresh and challenging. Whether it&rsquo;s clearing a set number of gems",
    "instructions": "Desktop Use your mouse to click and interact with the game Mobile Tablet Use your finger tap gestures to select and move items Simple drag amp drop or tap to swap mechanics depending on gameplay Pause Restart buttons available in the in-game menu",
    "category": "",
    "genres": [],
    "tags": [
      "Adventure",
      "amazing",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/5cpk92w126p8iu19sohpil125cqrcwar/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5cpk92w126p8iu19sohpil125cqrcwar/",
    "sourceUrl": "https://html5.gamemonetize.com/5cpk92w126p8iu19sohpil125cqrcwar/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65692",
    "slug": "fuji-leapers",
    "title": "Fuji Leapers",
    "description": "In Fuji Leaper, step into the world of a nimble frog navigating a perilous jungle. Your task? To vanquish swarming bees while racking up points. As you glide through the lush landscape, anticipate increasingly swift and treacherous adversaries. Leap with precision to overcome these obstacles and advance to the next level. But beware, as new threats await&mdash;venomous spiders and clouds of poison loom ahead. Hone your reflexes, sharpen your instincts, and discover how far your leaping prowess can take you in this thrilling, action-packed journey!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "amazing"
    ],
    "thumbnail": "https://img.gamemonetize.com/ugfvau20g5koj55czd4e63rqyhbovib1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ugfvau20g5koj55czd4e63rqyhbovib1/",
    "sourceUrl": "https://html5.gamemonetize.com/ugfvau20g5koj55czd4e63rqyhbovib1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70458",
    "slug": "dragon-warrior-tower-defense",
    "title": "Dragon Warrior Tower Defense",
    "description": "This is a tower - defense game where players need to protect their territory from a giant, winding snake - like enemy. The snake is segmented, each with a certain amount of health points displayed on it. Players must strategically place and use towers to attack the snake and prevent it from causing damage.",
    "instructions": "Tower Placement Players can position towers at suitable locations on the map Tower Activation Targeting Towers automatically attack the snake segments and players can also manually adjust the targeting priority if needed though in basic operations a",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Action",
      "Battle",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/7qbr7gz5bgvnyhsr3k7hy9k6fef9byw1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7qbr7gz5bgvnyhsr3k7hy9k6fef9byw1/",
    "sourceUrl": "https://html5.gamemonetize.com/7qbr7gz5bgvnyhsr3k7hy9k6fef9byw1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68539",
    "slug": "pusha-pusha",
    "title": "Pusha Pusha",
    "description": "Pusha Pusha is a puzzle game where you must push boxes into the target area in order to pass the level. One wrong move can lose the game. Are you ready to push the blocks?",
    "instructions": "Use Keyboard",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/9x331e2ydjh0nf845jc7tk1ftuapj6xc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9x331e2ydjh0nf845jc7tk1ftuapj6xc/",
    "sourceUrl": "https://html5.gamemonetize.com/9x331e2ydjh0nf845jc7tk1ftuapj6xc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72243",
    "slug": "my-talking-labubu",
    "title": "My Talking Labubu",
    "description": "Welcome to the magical world of Labubu &mdash; adorable and funny little creatures you just want to cuddle! Play, collect, take care of them, and have fun with your very own Labubu! -Open surprise Labubu boxes &mdash; collect them all and find the secret Labubu! -Dress up your Labubu in cool outfits and change their style -Paint them in any colors you like -Talk to them &mdash; Labubu can say hundreds of silly and fun phrases! -Take care of them: bathe, feed, and tuck them into bed -Play mini-games and complete fun tasks -Decorate their house and make it cozy -Compose music on the piano",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Boys",
      "Casual",
      "Girls",
      "Hypercasual",
      "Kids",
      "Labubu",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/gmhdqc6xhj8ewhpx3dfbo1l9tegdy946/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gmhdqc6xhj8ewhpx3dfbo1l9tegdy946/",
    "sourceUrl": "https://html5.gamemonetize.com/gmhdqc6xhj8ewhpx3dfbo1l9tegdy946/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72794",
    "slug": "neon-mini-golf",
    "title": "Neon Mini Golf",
    "description": "Neon Mini Golf is a stylish HTML5 arcade mini-golf game featuring glowing neon graphics, realistic physics, and 39 handcrafted levels! Drag, aim, and release to shoot the ball toward the hole &mdash; but watch out for bumpers, walls, and teleporters that will challenge your aim and timing. Earn stars, unlock all levels, and experience a dazzling synthwave neon world full of color and precision. Features: - 39 unique and challenging levels - Realistic ball physics and smooth controls - Beautiful neon glow design - Works perfectly on desktop and mobile - Instant play, no download required",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Clicker",
      "Golf",
      "HTML5",
      "mapi games",
      "Mobile",
      "Physics",
      "Retro",
      "Skill",
      "Space",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/jjbc1jhdydn8azhcmbnpo3tvzbkyhy76/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jjbc1jhdydn8azhcmbnpo3tvzbkyhy76/",
    "sourceUrl": "https://html5.gamemonetize.com/jjbc1jhdydn8azhcmbnpo3tvzbkyhy76/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72807",
    "slug": "car-line-rider",
    "title": "Car Line Rider",
    "description": "You control a neon car that leaves a bright, glowing trail behind it. Avoid crashing into your own trail or your opponents&rsquo; paths. Stay sharp, outmaneuver everyone, and aim to be the last one standing!",
    "instructions": "Left and Right arrow to drive",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Avoid",
      "Car",
      "Driving",
      "Hypercasual",
      "Kids",
      "Killing",
      "Racing",
      "Skill",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/7awyv0ytowhmcvd83lyhr7p9acvtd3kn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7awyv0ytowhmcvd83lyhr7p9acvtd3kn/",
    "sourceUrl": "https://html5.gamemonetize.com/7awyv0ytowhmcvd83lyhr7p9acvtd3kn/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69958",
    "slug": "swim-good",
    "title": "Swim Good",
    "description": "Chomp your way through a swirling feast of worms while dodging deadly spiky firing urchins! Stay alive, keep circling, and see how long you can last.",
    "instructions": "Left-click Tap on the on-screen button or use A D or Arrow keys to move left or right",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Avoid",
      "Fish",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/0b9opyq403zw97yoccuntar25ookv8e9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0b9opyq403zw97yoccuntar25ookv8e9/",
    "sourceUrl": "https://html5.gamemonetize.com/0b9opyq403zw97yoccuntar25ookv8e9/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "68536",
    "slug": "eventide",
    "title": "Eventide",
    "description": "in this gameyou have player and big ground and protect from enimies every 30 second game make difficult share with your friend and enjoy the game",
    "instructions": "Use Keyboard",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "8 Ball Pool"
    ],
    "thumbnail": "https://img.gamemonetize.com/k672dx870llm55o3aqtsg2umisl3u9iq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k672dx870llm55o3aqtsg2umisl3u9iq/",
    "sourceUrl": "https://html5.gamemonetize.com/k672dx870llm55o3aqtsg2umisl3u9iq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70297",
    "slug": "bear-ball-master-honey-king",
    "title": "Bear Ball Master : Honey King",
    "description": "Embark on an epic puzzle journey in Bear Ball Master: Honey King. Join a lovable bear on a mission to save the Honey Kingdom by popping Balls, solving puzzles, and mastering challenging levels. With over 190 handcrafted levels, stunning visuals, and engaging gameplay, this Ball shooter game offers hours of addictive fun for all ages. Game Features: Charming Characters: Follow Bear on his journey to become the Honey King Classic Bubble Shooter Gameplay: Aim, match, and pop to clear the board Over 150 Exciting Levels: Unique layouts and challenges keep things fresh Power-Ups and Combos: Use honey bombs, rainbow bubbles, and more Vibrant G",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Ball",
      "Ballon",
      "Bubble Shooter",
      "Kids",
      "Match 3",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/aur96p0aeocgnl7bo82mjy6pvmw3fbuo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aur96p0aeocgnl7bo82mjy6pvmw3fbuo/",
    "sourceUrl": "https://html5.gamemonetize.com/aur96p0aeocgnl7bo82mjy6pvmw3fbuo/",
    "width": 600,
    "height": 900,
    "lastUpdated": ""
  },
  {
    "id": "71656",
    "slug": "coin-flick-soccer",
    "title": "Coin Flick Soccer",
    "description": "Finger Flick (a.k.a. Dedoball, Peg Game, or &ldquo;Peteleco&rdquo;) is a fast-paced physics game where you use your finger to flick a coin across the board, bounce off nails, and aim for goals. Known by many names around the world, this classic playground challenge now has a digital twist &mdash; smooth physics, satisfying collisions, and endless chances to test your skill!",
    "instructions": "You must click before the coin and flick to direction",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2D",
      "Arcade",
      "Soccer",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/k4orfszy5grobv16zcyfg6fie450ivi2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k4orfszy5grobv16zcyfg6fie450ivi2/",
    "sourceUrl": "https://html5.gamemonetize.com/k4orfszy5grobv16zcyfg6fie450ivi2/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72795",
    "slug": "sokoban-push-the-box",
    "title": "Sokoban Push The Box",
    "description": "Challenge your brain in Sokoban - Push The Box. This is a timeless classic puzzle game. Enter a clever maze full of crates, tight corners, and tricky layouts. Your task is simple but challenging. Push every box to the correct spot. Each level will test your logic, patience, and planning skills. One wrong move could block your path, so think carefully before every push. But keep an eye on your move count.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Brain",
      "Classic",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/1my1qdjwu871fk0992pvyobmnlu40t7n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1my1qdjwu871fk0992pvyobmnlu40t7n/",
    "sourceUrl": "https://html5.gamemonetize.com/1my1qdjwu871fk0992pvyobmnlu40t7n/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72747",
    "slug": "crowd-battle-gun-rush",
    "title": "Crowd Battle Gun Rush",
    "description": "This is a game that combines parkour and shooting. In the game, you need to avoid bad props and remember to upgrade your weapons. Finally destroy the incoming enemies!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Action",
      "attack",
      "Obstacle",
      "running",
      "Shoot",
      "slide"
    ],
    "thumbnail": "https://img.gamemonetize.com/zgyi4uc3u2rbu9euvx144c5hwv8mq5ap/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zgyi4uc3u2rbu9euvx144c5hwv8mq5ap/",
    "sourceUrl": "https://html5.gamemonetize.com/zgyi4uc3u2rbu9euvx144c5hwv8mq5ap/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72224",
    "slug": "hero-rescue-survival-game",
    "title": "Hero Rescue Survival Game",
    "description": "You want to have your own pets and protect them? You want to travel around the world with your pet? Don&rsquo;t wait, play Save the Girl - Pull The Pin now. Save the Girl - Pull The Pin is the game leading the trend of puzzle games. Solve the puzzles and unlock maps to travel to around the world. The gameplay in Save the Girl - Pull The Pin is super simple but extremely attractive The hero begins his journey for treasure and to save the princess, but the puzzles in front of the hunter trap him. You need to pull the pins correctly so the hero can take the hidden treasure and save the princess safely from the dragons, wolves, and monsters.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "onetouch",
      "Pinball",
      "Rescue",
      "Spiderman"
    ],
    "thumbnail": "https://img.gamemonetize.com/i3dpnomkm9lcphbjz7qe2v7t3bmxqnb1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i3dpnomkm9lcphbjz7qe2v7t3bmxqnb1/",
    "sourceUrl": "https://html5.gamemonetize.com/i3dpnomkm9lcphbjz7qe2v7t3bmxqnb1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72592",
    "slug": "fashion-makeup-and-dress-up-game",
    "title": "Fashion Makeup And Dress Up Game",
    "description": "Are you addicted to dress up game up and fashion designer game? Are you ready for style challenge? Let&rsquo;s play this dress up game up right now! Ready to wow fashion show with your unique styles. Start designing looks for superstars, supermodels, brides and more. Create looks that will take you all the way to the top of the style challenges with tons of gorgeous outfits, accessories and bridal make up.",
    "instructions": "To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Fashion",
      "Girl",
      "Girls",
      "Hypercasual",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/6b40mq9bu1rda8ptf37o615nirp2kocz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6b40mq9bu1rda8ptf37o615nirp2kocz/",
    "sourceUrl": "https://html5.gamemonetize.com/6b40mq9bu1rda8ptf37o615nirp2kocz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72508",
    "slug": "funny-sounds",
    "title": "Funny sounds",
    "description": "Funny sounds. A fun game in which you make funny sounds. Surprise your colleagues at work by unobtrusively making one of the funny sounds.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "Funny",
      "sound"
    ],
    "thumbnail": "https://img.gamemonetize.com/tr8vmrucaanecpllp3ja0dl1omj1wjv6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tr8vmrucaanecpllp3ja0dl1omj1wjv6/",
    "sourceUrl": "https://html5.gamemonetize.com/tr8vmrucaanecpllp3ja0dl1omj1wjv6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72285",
    "slug": "flag-paint-puzzle-game",
    "title": "Flag Paint Puzzle Game",
    "description": "Get ready to embark on a vibrant journey with World Flags: Color Puzzle, the ultimate game for flag enthusiasts and puzzle lovers alike! If you have a passion for national flags and a flair for colors, this hyper-casual game is tailor-made for you. Welcome to the Colorful World of World Flags: Color Puzzle! In the World Flags: Color Puzzle, your mission is to paint the national flags of the world with the right colors. This isnt just about painting; its about testing your knowledge and memory of different national flags.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Color",
      "Coloring",
      "Hypercasual",
      "paint",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7uij88omrdew9cnvt1oux8eg0tdm7qj8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7uij88omrdew9cnvt1oux8eg0tdm7qj8/",
    "sourceUrl": "https://html5.gamemonetize.com/7uij88omrdew9cnvt1oux8eg0tdm7qj8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72673",
    "slug": "nine-cards-of-winter",
    "title": "Nine Cards Of Winter",
    "description": "Get into the holiday spirit with Nine Cards of Winter, a fun and relaxing tile-matching game! Pick up to 9 Christmas tiles and match 3 of the same to clear them. Watch out &mdash; if your stack fills up, the game is over! Use smart moves to uncover hidden tiles, solve tricky puzzles, and enjoy cute holiday designs.It&rsquo;s easy to play, relaxing to enjoy, and full of winter charm!",
    "instructions": "Use your mouse or touchpad to tap tiles and match three of the same to clear them",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Christmas",
      "html5 games",
      "Match-3",
      "Matching",
      "Mobile",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/f3r5sex50ro1fwrmks41k5najty3mhll/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f3r5sex50ro1fwrmks41k5najty3mhll/",
    "sourceUrl": "https://html5.gamemonetize.com/f3r5sex50ro1fwrmks41k5najty3mhll/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "68540",
    "slug": "rat-purrsuit",
    "title": "Rat Purrsuit",
    "description": "in this game you have cat and catch the rat and complete the level every level diffcult and share with your friend enjoy the game on game monetize",
    "instructions": "Use Keyboard",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/086re3fo35f43d8ovg6ls8q87gonl31f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/086re3fo35f43d8ovg6ls8q87gonl31f/",
    "sourceUrl": "https://html5.gamemonetize.com/086re3fo35f43d8ovg6ls8q87gonl31f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68544",
    "slug": "tower-defence-1",
    "title": "Tower Defence 1",
    "description": "Prepare for relentless waves of creepy crawlers in this action-packed strategy game! In Tower Defence, your base is under siege by swarms of invading insects&mdash;and its up to you to stop them. Build and upgrade 4 unique tower types, each with powerful abilities and customizable upgrades, to create the ultimate defense. Face off against a variety of insect enemies, each with their own strengths and strategies. How long can you survive the endless onslaught?",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action"
    ],
    "thumbnail": "https://img.gamemonetize.com/9v6hqnas31f02nlu9bntd1rz4pm3ff90/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9v6hqnas31f02nlu9bntd1rz4pm3ff90/",
    "sourceUrl": "https://html5.gamemonetize.com/9v6hqnas31f02nlu9bntd1rz4pm3ff90/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72341",
    "slug": "abyssal-echoes",
    "title": "Abyssal Echoes",
    "description": "Excellent choice. &ldquo;Abyssal Echoes&rdquo; is a powerful, poetic, and haunting name perfect for a deep-sea psychological horror game. Below is a complete long-form game description written specifically for Abyssal Echoes, with professional tone and cinematic flow ideal for Steam, PlayStation, or App Store listings Abyssal Echoes Official Game Description The Deep Remembers What Humanity Forgot You are Dr. Elias Ward, a deep-sea researcher descending into the ruins of Station Erebus, an underwater facility lost decades ago in the Mariana Trench. A mission meant for science becomes a nightmare of memory, pressure, and time.",
    "instructions": "Game Controls ndash Abyssal Echoes Mastering the controls is your only chance to survive the descent Every move consumes oxygen every light flicker hides danger mdash precision and timing are key beneath the pressure PC Controls Action Key Descri",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      ".io Games",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2048",
      "Action",
      "Adventure",
      "Anime",
      "Arcade",
      "Avoid"
    ],
    "thumbnail": "https://img.gamemonetize.com/p2yoio4lbhdhw0e57040u82k19fyi2pv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p2yoio4lbhdhw0e57040u82k19fyi2pv/",
    "sourceUrl": "https://html5.gamemonetize.com/p2yoio4lbhdhw0e57040u82k19fyi2pv/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72340",
    "slug": "d-race-x",
    "title": "D Race X",
    "description": "Get ready for the ultimate racing experience in Deadly Race: Ultimate Speed &mdash; a high-octane, skill-based car racing game built for true speed lovers! No pay-to-win, no ads, no in-app purchases &mdash; just pure racing excitement and real challenge. Every victory is earned through your driving skills, precision, and timing. Real Racing Action Feel the rush as you race through city streets, deserts, and mountain roads at incredible speeds. Each track is carefully designed with dynamic weather, realistic physics, and day/night cycles that make every race feel alive. Push your limits and prove you&rsquo;re the fastest driver on the road!",
    "instructions": "Take full control of your car and master every race with precise responsive handling The controls are designed to feel natural smooth and intuitive perfect for both beginners and pro racers Keyboard PC Controls",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2 Player Games",
      "2025 games",
      "2048",
      "Action",
      "Adventure",
      "Fantasy",
      "free html5 games for your website",
      "html games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/603mzpfpq50loewnua433w5u7lf0j3tz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/603mzpfpq50loewnua433w5u7lf0j3tz/",
    "sourceUrl": "https://html5.gamemonetize.com/603mzpfpq50loewnua433w5u7lf0j3tz/",
    "width": 1536,
    "height": 1984,
    "lastUpdated": ""
  },
  {
    "id": "72266",
    "slug": "lumbering-at-sea",
    "title": "Lumbering At Sea",
    "description": "You can experience an adventure different from the Grand Line. You need to collect materials to build your own ship, and then compete with others here. Of course there are rich rewards after winning.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "Arcade",
      "attack",
      "build"
    ],
    "thumbnail": "https://img.gamemonetize.com/t28x1cf2kqtnitkhi4xhhz6l69rar4pn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t28x1cf2kqtnitkhi4xhhz6l69rar4pn/",
    "sourceUrl": "https://html5.gamemonetize.com/t28x1cf2kqtnitkhi4xhhz6l69rar4pn/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72723",
    "slug": "city-defense",
    "title": "City Defense",
    "description": "This is a real-time strategy tower defense game. You need to deploy your troops and obstacles to defend against enemies, and also upgrade them strategically to eliminate each wave of enemies!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Action",
      "Defense",
      "Strategy",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/jm6h40wvlisy01h8gmt9z3fd0h2h4yov/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jm6h40wvlisy01h8gmt9z3fd0h2h4yov/",
    "sourceUrl": "https://html5.gamemonetize.com/jm6h40wvlisy01h8gmt9z3fd0h2h4yov/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72611",
    "slug": "alien-space-shooter-game",
    "title": "Alien Space Shooter Game",
    "description": "Space Invaders and alien swarms Airattack are approaching, and it is your mission to protect the entire Galaxy at this moment. In order to protect the Galaxy from being attacked by Space Invaders, you must save the universe from vicious Space Invaders like an Alien Shooter in Space Flight Simulator. If you are a big fan of arcade shooting game with the new modern combat, and want to bring the freedom in the galaxy games, so Space shooter:",
    "instructions": "Move Mouse To Play Game",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Adventure",
      "Casual",
      "Hypercasual",
      "Shooter",
      "Shooting",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/ywh6vr73jrwgm5bpy50y6ra8y2vn1z1u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ywh6vr73jrwgm5bpy50y6ra8y2vn1z1u/",
    "sourceUrl": "https://html5.gamemonetize.com/ywh6vr73jrwgm5bpy50y6ra8y2vn1z1u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72481",
    "slug": "cargo-truck-transport-game",
    "title": "Cargo Truck Transport Game",
    "description": "Welcome to the world of truck cargo transport games. Real cargo truck driving,uphill mountain cargo truck drive simulator game. Breath taking cargo truck games with dangerous mountains with day terrain and city roads will make this new cargo truck game modern cargo simulator intriguing and pleasurable. Cargo truck driver simulator game has the thrill of driving logging cargo trucks in an offroad and hill environment. After playing with a real cargo truck driver, you will get an idea about the offroad adventure and hill side environment.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "cargo",
      "city",
      "Driving",
      "mountain",
      "offroad",
      "Truck",
      "trucks",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/4w8oinja7h4ednfqu9nn75f086ijklkz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4w8oinja7h4ednfqu9nn75f086ijklkz/",
    "sourceUrl": "https://html5.gamemonetize.com/4w8oinja7h4ednfqu9nn75f086ijklkz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72464",
    "slug": "drag-it-puzzle-shapes",
    "title": "Drag it Puzzle Shapes",
    "description": "Get ready to dive into this captivating puzzle adventure that will truly engage your mind! In Drag it Puzzle Shapes, you&rsquo;ll connect virtual pieces just like in real life to form stunning images and follow creative patterns. Each level becomes more challenging, testing your logic and sharpening your problem-solving skills. Arrange a variety of items and emoji puzzles to complete beautiful pictures right on your mobile screen. Improve your thinking and logic abilities while enjoying endless fun &mdash; you&rsquo;ll never get tired of playing this addictive Connect Master game!",
    "instructions": "Tap or mouse click to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Draw",
      "huggy",
      "Poppy Playtime"
    ],
    "thumbnail": "https://img.gamemonetize.com/zhqtaj1wchcrjrteoikrzimn26666gaf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zhqtaj1wchcrjrteoikrzimn26666gaf/",
    "sourceUrl": "https://html5.gamemonetize.com/zhqtaj1wchcrjrteoikrzimn26666gaf/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72697",
    "slug": "cat-with-a-gun-clicker-evolution",
    "title": "Cat with a Gun Clicker Evolution",
    "description": "This isn&rsquo;t just a cat &mdash; it&rsquo;s a cat with a gun! Your mission is simple: tap, earn coins, and watch your kitty evolve into new, stronger, and totally ridiculous forms! Each evolution brings a new gun, a new look, and tons of explosive chaos!",
    "instructions": "Tap the cat to shoot and earn coins Upgrade your firepower and shooting speed Unlock new cats with unique weapons Reach ultimate forms and become the Mega Cat How many clicks can you handle before your cat blasts off into space",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Click",
      "Clicker",
      "Gun"
    ],
    "thumbnail": "https://img.gamemonetize.com/p9om649472ct8dvj4mbc9rnp68np7m2n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p9om649472ct8dvj4mbc9rnp68np7m2n/",
    "sourceUrl": "https://html5.gamemonetize.com/p9om649472ct8dvj4mbc9rnp68np7m2n/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68541",
    "slug": "find-ball",
    "title": "Find Ball",
    "description": "Three Cups is a mind-bending puzzle game that challenges players to test their focus, memory, and strategic thinking. In each level, three cups are shuffled rapidly, hiding a small object underneath one of them. Players must track the cup concealing the object and choose wisely, as the cups move quicker and the stakes rise higher with each round. Play the Three Cups game at Game Monetize now and have fun.",
    "instructions": "Tap on screen",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action"
    ],
    "thumbnail": "https://img.gamemonetize.com/p5rxs26j1s3nw5rnugp4mqja8cc5q33u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p5rxs26j1s3nw5rnugp4mqja8cc5q33u/",
    "sourceUrl": "https://html5.gamemonetize.com/p5rxs26j1s3nw5rnugp4mqja8cc5q33u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69757",
    "slug": "smart-dots-reloaded",
    "title": "Smart Dots Reloaded",
    "description": "Smart Dots Reloaded is a fresh remake of the classic Dots and Boxes puzzle from Windows 3.1. Players take turns drawing lines between dots. Completing a square earns a point, and the game ends when the board is full. Featuring modern visuals, smooth animations, and both AI and two-player modes, this is a strategy game that&rsquo;s easy to learn but hard to master.",
    "instructions": "Click in lines and try to make squares to earn points",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2D",
      "Casual",
      "Draw",
      "html5 games",
      "Puzzle",
      "Strategy",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/f5l8chws2l7exii1362h6ifzt5jal195/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f5l8chws2l7exii1362h6ifzt5jal195/",
    "sourceUrl": "https://html5.gamemonetize.com/f5l8chws2l7exii1362h6ifzt5jal195/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72348",
    "slug": "ocean-drift",
    "title": "Ocean Drift",
    "description": "Get ready to race across the waves in Boat Rush! Take control of your high-speed powerboat and navigate through challenging waters filled with obstacles, waves, and surprises. Collect coins, avoid crashes, and see how far you can go before the tide catches you! Smooth controls, colorful 2D graphics, and endless action make Boat Rush the ultimate water racing challenge. Can you beat your own record and become the fastest racer on the sea? Features: Fast-paced 2D boat racing gameplay Endless scrolling water environment Collect coins and score points Avoid rocks, buoys, and other obstacles Fun sound effects and smooth anima",
    "instructions": "Controls - Press LEFT RIGHT arrow keys to steer your boat - Hold UP arrow to speed up - Avoid obstacles and collect coins to increase your score",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2 Player",
      "2025 games",
      "Action",
      "Adventure",
      "Arcade",
      "attack",
      "free games for your site",
      "free html5 games for your website",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/udotd1qgzo8n65v43606opsfcz48j1fp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/udotd1qgzo8n65v43606opsfcz48j1fp/",
    "sourceUrl": "https://html5.gamemonetize.com/udotd1qgzo8n65v43606opsfcz48j1fp/",
    "width": 4864,
    "height": 9568,
    "lastUpdated": ""
  },
  {
    "id": "72586",
    "slug": "nivra",
    "title": "Nivra",
    "description": "In a world shattered by endless wars, the land has turned into a barren wasteland ruled by powerful tank factions. Cities have fallen, resources are scarce, and survival depends on the strength of your armor and the precision of your aim. The few who remain fight not for glory but for control of the last fuel and metal that keep their machines alive. You are a lone survivor who stumbles upon an abandoned war factory buried under the sands. Inside, you find an old but powerful tank, forgotten by time. With nothing left to lose, you repair it piece by piece and prepare to face the dangers that lie beyond the ruins.",
    "instructions": "Controls A ndash Move Left D ndash Move Right W ndash Move Up Forward",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2025 games",
      "Action",
      "Adventure",
      "Arcade",
      "Arena",
      "attack",
      "free html5 games for your website",
      "games for your website",
      "Tank",
      "Tanks"
    ],
    "thumbnail": "https://img.gamemonetize.com/nq90wfutco4i0htj0ikdvgp70a5o0q66/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nq90wfutco4i0htj0ikdvgp70a5o0q66/",
    "sourceUrl": "https://html5.gamemonetize.com/nq90wfutco4i0htj0ikdvgp70a5o0q66/",
    "width": 1152,
    "height": 1456,
    "lastUpdated": ""
  },
  {
    "id": "72062",
    "slug": "farm-simulator-township-game",
    "title": "Farm Simulator Township Game",
    "description": "Welcome to the most immersive and relaxing farming game experience ever created. Ultimate farming simulation game! Live the life of a modern farmer as you step into a vibrant, dynamic world full of fertile land, advanced equipment, and a community that thrives on hard work, dedication, and strategy. Whether you&rsquo;re managing an entire farming empire in career mode or focusing on the fine art of cultivating high-quality cotton in cotton mode, this game offers an unmatched level of depth, realism, and fun. Start your journey as a beginner farmer with limited resources. Begin with a small patch of land, a basic tractor, and a handful of tools.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Driving",
      "Farm",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/iojkoe68zyjra4dxu5itysdy88dzqxt6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iojkoe68zyjra4dxu5itysdy88dzqxt6/",
    "sourceUrl": "https://html5.gamemonetize.com/iojkoe68zyjra4dxu5itysdy88dzqxt6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72219",
    "slug": "mud-offroad-jeep-game",
    "title": "Mud Offroad Jeep Game",
    "description": "Welcome to the off road jeep driving game. Get ready to embark on the ultimate off road journey in an off road jeep adventure game where powerful jeeps, rugged terrains, and extreme challenges await. Take control of powerful jeeps and navigate through steep hills, muddy roads and rocky paths. With realistic vehicle physics and breathtaking environments, every mission will test your driving skills to the limit. Can you handle the toughest terrains and become the ultimate off road champion? It&rsquo;s time to find out. Drive a collection of monster trucks, and powerful jeeps. Unlock advanced vehicles with better traction, suspension, and horsepower.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Car",
      "Driving",
      "jeep",
      "mountain",
      "offroad"
    ],
    "thumbnail": "https://img.gamemonetize.com/93d6h8i0rbebzr6pcjrc98ui9bhtdn7q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/93d6h8i0rbebzr6pcjrc98ui9bhtdn7q/",
    "sourceUrl": "https://html5.gamemonetize.com/93d6h8i0rbebzr6pcjrc98ui9bhtdn7q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72526",
    "slug": "airplane-simulator-game",
    "title": "Airplane Simulator Game",
    "description": "Get ready for an amazing flight adventure with the Airplane Simulator Game. The most exciting airplane flying game where you take off from one airport and land safely at another. Feel like a real pilot as you control powerful airplanes, fly through clouds, and explore stunning skies. This flight simulator game brings you a real flying experience with easy controls and a beautiful environment. In this flight simulator, you take the seat of a real pilot, control your airplane, and complete missions to reach your destination. The world is open, the sky is yours, and every flight brings a new adventure.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Aircraft",
      "airplane",
      "fly",
      "Helicopter"
    ],
    "thumbnail": "https://img.gamemonetize.com/etxaaflofm9eluf5v74343nlwnpgkynx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/etxaaflofm9eluf5v74343nlwnpgkynx/",
    "sourceUrl": "https://html5.gamemonetize.com/etxaaflofm9eluf5v74343nlwnpgkynx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72637",
    "slug": "hoard-master-online",
    "title": "Hoard Master Online",
    "description": "This is a black hole game. You only need a mouse slide or a finger to control the black hole to swallow everything you want. A quick decompression game. Hope you all like it.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Best Games",
      "Funny",
      "Hypercasual",
      "Physics",
      "slide"
    ],
    "thumbnail": "https://img.gamemonetize.com/vgfnd5q6s2gzx282e3r58unifb97maxt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vgfnd5q6s2gzx282e3r58unifb97maxt/",
    "sourceUrl": "https://html5.gamemonetize.com/vgfnd5q6s2gzx282e3r58unifb97maxt/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72601",
    "slug": "my-tiny-market",
    "title": "My Tiny Market",
    "description": "In My Tiny Market, youre the boss of your very own supermarket. Manage your time and resources well to find the perfect balance between all your tasks: restock shelves, serve customers and keep everything running at full speed!",
    "instructions": "Start with a small supermarket and grow it step by step Take care of everything from simple tasks like picking tomatoes or feeding chickens to restocking shelves and serving customers at the checkout Hire employees to speed things up and expand your st",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Action",
      "Adventure",
      "amazing",
      "idle",
      "Shopping"
    ],
    "thumbnail": "https://img.gamemonetize.com/if0vl0cck4st4pxcxjppbsny1h6tzutn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/if0vl0cck4st4pxcxjppbsny1h6tzutn/",
    "sourceUrl": "https://html5.gamemonetize.com/if0vl0cck4st4pxcxjppbsny1h6tzutn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72162",
    "slug": "arcanoid-shooter-defence",
    "title": "Arcanoid Shooter Defence",
    "description": "Step into an intergalactic arcade adventure! This game blends classic Arkanoid brick-breaking action with a futuristic twist. Pilot your spaceship, bounce the ball, and strategically destroy rows of vibrant green blocks. Unleash power-ups and master precision to clear the board and conquer the cosmic challenge. Web Dev <a href='https://www.poki.com.es/'>https://www.poki.com.es/</a> . Get ready to zap those bricks into stardust!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Ai Games",
      "Arcade",
      "Arkanoid",
      "Games Ai",
      "HTML5",
      "Mentolatux",
      "Shooting",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/qx9xhqoqs5ll86irzxh9pxm073ctssev/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qx9xhqoqs5ll86irzxh9pxm073ctssev/",
    "sourceUrl": "https://html5.gamemonetize.com/qx9xhqoqs5ll86irzxh9pxm073ctssev/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72553",
    "slug": "animal-world",
    "title": "Animal World",
    "description": "An open-world sandbox where you can catch and tame Brainrots, Palmons, and cute pets! Build your home, gather resources, and survive against night monsters. Explore a vast world with a day-night cycle, craft weapons, armor, and medicine, and find loot in chests or from enemies. Tame creatures to help you gather resources and embark on endless adventures!",
    "instructions": "WASD mdash movement Q mdash Rolling dodge the punches Left mouse button mdash attack Right mouse button mdash aim Average mouse volume mdash zoom Space mdash jump Shift mdash running E mdash action for example pick up an item 1 2 3 a",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Battle",
      "build",
      "builder",
      "building",
      "hunter",
      "Hunting",
      "Monster",
      "survival",
      "Sword",
      "World"
    ],
    "thumbnail": "https://img.gamemonetize.com/tausm4cqqzkv5z6955gfrdbhq9kztztc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tausm4cqqzkv5z6955gfrdbhq9kztztc/",
    "sourceUrl": "https://html5.gamemonetize.com/tausm4cqqzkv5z6955gfrdbhq9kztztc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71153",
    "slug": "feed-all-the-monsters-in-the-mineblock",
    "title": "Feed all the MONSTERS in the Mineblock",
    "description": "Feed all the monsters in the Mineblock World right now! Immerse yourself in the amazing world of monsters and feed them all to the limit. You will have a wide variety of different types of food, some of which have unique properties.",
    "instructions": "In the game your task is to feed the monsters until they burst Test all the monsters and feed them to the limit Select the object you want to place on the play area and click on it to place it in the location indicated by the arrow",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Classic",
      "Crazy",
      "Fighting",
      "Food",
      "Horror",
      "html5 games",
      "Minecraft",
      "Monster",
      "Play",
      "Sandbox",
      "unity games",
      "unity games for your site",
      "unity games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/fc1sslk92fdsse6hiswcx33bvv9lhth7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fc1sslk92fdsse6hiswcx33bvv9lhth7/",
    "sourceUrl": "https://html5.gamemonetize.com/fc1sslk92fdsse6hiswcx33bvv9lhth7/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "72608",
    "slug": "cargo-bike-and-car-game",
    "title": "Cargo Bike And Car Game",
    "description": "This cargo truck bike and car game gives you three driving experiences in one. Drive heavy cargo trucks on long roads, ride fast delivery bikes in the city, and drive cool cars for special transport missions. Enjoy easy gameplay in this truck bike car simulator. Enjoy heavy-duty driving in this cargo truck simulator. Carry wood, boxes, fuel, and other items across highways and mountains. Drive slow on sharp turns in this truck driving game to keep the cargo safe.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Bike",
      "cargo",
      "Driving",
      "Racing",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/85hiue0w37zlpaollwf1oid4ibbak3tn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/85hiue0w37zlpaollwf1oid4ibbak3tn/",
    "sourceUrl": "https://html5.gamemonetize.com/85hiue0w37zlpaollwf1oid4ibbak3tn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72517",
    "slug": "planet-hero",
    "title": "Planet Hero",
    "description": "Planet Hero is a top-down 3D action game where you defend planets from waves of alien monsters! Battle endless enemies, rescue your world, and become the ultimate guardian of the galaxy. Each wave brings tougher challenges but also new power-ups, allies, and upgrades. Recruit unique heroes with special abilities to fight beside you. Collect coins, unlock boosters, and evolve your team to face even stronger intergalactic threats. Save the universe and become the Planet Hero",
    "instructions": "Keyboard Use WASD or Arrow Keys to move your hero Mouse Move with the onscreen joystick and aim freely Touch Devices Use the joystick to control movement Shooting happens automatically",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Action",
      "Shoot 'Em Up",
      "Shooter",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/icwwnsv25zjvr9d9tghebsqi42uwmsfq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/icwwnsv25zjvr9d9tghebsqi42uwmsfq/",
    "sourceUrl": "https://html5.gamemonetize.com/icwwnsv25zjvr9d9tghebsqi42uwmsfq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72636",
    "slug": "animal-runner-safari-game",
    "title": "Animal Runner Safari Game",
    "description": "Become the best in this awesome endless runner game. Surf through the city with loads of exciting characters who can use powerups like jetpacks and hoverboards. An amazing looking city to run and surf through for free. Play with your friends! Perform Fun knockout challenges in offline animal running games. Be the best HERO and Run into action to beat all the levels in the endless animal runner games 2023!",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Animal",
      "Horse",
      "Kart",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/k6bun6vwzcb9tnhgogtvbzu33kxyixft/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k6bun6vwzcb9tnhgogtvbzu33kxyixft/",
    "sourceUrl": "https://html5.gamemonetize.com/k6bun6vwzcb9tnhgogtvbzu33kxyixft/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72407",
    "slug": "ghost-shift",
    "title": "Ghost Shift",
    "description": "GHOST SHIFT - Master Two Worlds in One Game! Switch between HUMAN and GHOST modes to survive in this addictive endless runner! HOW TO PLAY: - Click/Tap to JUMP - Press Switch button to toggle between Human and Ghost modes - Avoid obstacles based on your current mode: - HUMAN MODE: Red blocks are deadly! Blue barriers are safe to pass through - GHOST MODE: Blue barriers will kill you! Red blocks are safe to phase through - Collect coins to unlock awesome skins - Grab shields for temporary protection",
    "instructions": "Controls DESKTOP - SPACE or UP ARROW - Jump - S or DOWN ARROW - Switch Mode - MOUSE CLICK on canvas - Jump MOBILE - TAP screen - Jump - TAP Switch button - Switch Mode PAUSE - Click Pause button during gameplay",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "endless",
      "Ghost",
      "HTML",
      "jump",
      "Mobile",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/exfdtiqpclhki6mvuiq1f6628eln6383/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/exfdtiqpclhki6mvuiq1f6628eln6383/",
    "sourceUrl": "https://html5.gamemonetize.com/exfdtiqpclhki6mvuiq1f6628eln6383/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72599",
    "slug": "bulletman-3d",
    "title": "BulletMan 3D",
    "description": "Bulletman 3D is here &mdash; faster, sharper, and more explosive than ever! Dive into a world of action-packed missions, stunning 3D visuals, and epic slow-motion shots. Outsmart enemies, master every bullet, and prove you&rsquo;re the ultimate agent! Are you ready to become a legend?",
    "instructions": "Use the mouse or touch to aim and shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Action",
      "free html5 games for your website",
      "kiz10",
      "Puzzle",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/tjsii5r6qlrfyf34b076syz13lzeq0x1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tjsii5r6qlrfyf34b076syz13lzeq0x1/",
    "sourceUrl": "https://html5.gamemonetize.com/tjsii5r6qlrfyf34b076syz13lzeq0x1/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "72470",
    "slug": "rescue-casual-pin-puzzle",
    "title": "Rescue Casual Pin Puzzle",
    "description": "Welcome to Rescue Casual Pin Puzzle, the brain-teasing adventure filled with love, strategy, and excitement. In this addictive puzzle and pin puzzle game, your mission is to rescue the couple from tricky traps and dangerous enemies. Every level tells a small love story. To save the couple, you must pull the pins in the correct order!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Enemies",
      "Love",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/lr8dul0s0ws9ujbpsip0387xen307y4j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lr8dul0s0ws9ujbpsip0387xen307y4j/",
    "sourceUrl": "https://html5.gamemonetize.com/lr8dul0s0ws9ujbpsip0387xen307y4j/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "72290",
    "slug": "ace-drift-3d",
    "title": "Ace Drift 3D",
    "description": "This is a racing game. Accurate control is required to reach the finish line. There is also no reversing system. Although it is a casual game, it also has rich content.",
    "instructions": "Mouse click or tap to play Keyboard WASD",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Car",
      "Cars",
      "Driving",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/vlqkcszim3vwzsx0k50xo9lymachkj6s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vlqkcszim3vwzsx0k50xo9lymachkj6s/",
    "sourceUrl": "https://html5.gamemonetize.com/vlqkcszim3vwzsx0k50xo9lymachkj6s/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72147",
    "slug": "obby-prison-escape-speed",
    "title": "Obby Prison Escape Speed",
    "description": "Get ready for a crazy challenge! In this game you&rsquo;ll face a whole series of bright and thrilling obby levels. Run away from guards, escape the wave of bubbles, jump across disappearing floors and don&rsquo;t let the sharks catch you! Each new stage gets harder, testing your speed, reflexes and wit. Show your skills in speed and agility: train your reaction, improve your movement and beat increasingly tricky challenges. Compete with friends or chase your personal record &mdash; only the fastest and most attentive players can make it to the end. Can you overcome all the traps and prove that you are the true obby master?",
    "instructions": "- On PC WASD ndash Move Mouse ndash Camera control Space ndash Jump - On Mobile Use the game interface Drag anywhere on the screen ndash Camera control",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Animal",
      "Anime",
      "Arcade",
      "Escape",
      "Fun",
      "Funny",
      "grow",
      "Prison",
      "roblox",
      "Simulation",
      "Simulator",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/5v60c88pl81kvr27x3xp89qhpelm6va2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5v60c88pl81kvr27x3xp89qhpelm6va2/",
    "sourceUrl": "https://html5.gamemonetize.com/5v60c88pl81kvr27x3xp89qhpelm6va2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72525",
    "slug": "horse-kart-runner-game",
    "title": "Horse Kart Runner Game",
    "description": "Welcome to the world of horse cart runner games. Get ready for a wild galloping thrill! Dive into the exciting world of horse cart runner Game, a unique combination of traditional cart racing with level runner gameplay. Steer your horse-drawn cart across countless challenging levels filled with obstacles, coins, power-ups, and intense action. Whether you are a fan of racing games, endless runners, horse simulators, or just love the thrill of adventure, horse cart runner game is your perfect gaming destination.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Forest",
      "Horse",
      "Kart",
      "Race",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/8s4lk3741uxenrmsxuyj3c3iwnn1eq0f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8s4lk3741uxenrmsxuyj3c3iwnn1eq0f/",
    "sourceUrl": "https://html5.gamemonetize.com/8s4lk3741uxenrmsxuyj3c3iwnn1eq0f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72607",
    "slug": "tank-wrestle",
    "title": "Tank Wrestle",
    "description": "Welcome to the world of tank battles, where you can control tanks to fight with other enemies on different maps. There are also a wealth of tanks for you to choose from!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Collection",
      "Mobile",
      "Obstacle",
      "running",
      "touch",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ojv8zoj9ko1zoil5cpv4ewj46b1k8lya/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ojv8zoj9ko1zoil5cpv4ewj46b1k8lya/",
    "sourceUrl": "https://html5.gamemonetize.com/ojv8zoj9ko1zoil5cpv4ewj46b1k8lya/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "72425",
    "slug": "seafloor-racing-3d",
    "title": "Seafloor Racing 3D",
    "description": "Seafloor Racing 3D is a racing game compatible with mobile and PC. You need to be alert for sudden obstacles, sometimes whales. The game also has a rich shopping mall system to match your racing car.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "Car",
      "Driving",
      "Racing",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/ufcvtjet12akdnq7ivr1empmhug0swsd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ufcvtjet12akdnq7ivr1empmhug0swsd/",
    "sourceUrl": "https://html5.gamemonetize.com/ufcvtjet12akdnq7ivr1empmhug0swsd/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "72412",
    "slug": "bubble-shooter-clash-blast-online",
    "title": "Bubble Shooter Clash Blast Online",
    "description": "Bubble Shooter Cash Blast Online is a fun, fast-paced, and addictive bubble shooter game where every pop can lead to big rewards! Aim, shoot, and match colorful bubbles to clear the board, unlock bonuses, and climb the leaderboard. Experience thrilling cash blast effects, shining coins, and satisfying combo explosions &mdash; all wrapped in stunning HD visuals and smooth gameplay. Whether youre a casual gamer or a competitive shooter, Bubble Shooter Cash Blast Online delivers endless entertainment and excitement. Challenge your precision and reflexes in this vibrant arcade adventure!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Bubble",
      "Bubble Shooter",
      "Casual",
      "Color",
      "Hypercasual",
      "Match-3",
      "Matching",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/nbb1ozf3q5s064utarnohqghn16l6ohi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nbb1ozf3q5s064utarnohqghn16l6ohi/",
    "sourceUrl": "https://html5.gamemonetize.com/nbb1ozf3q5s064utarnohqghn16l6ohi/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72246",
    "slug": "ultimate-flying-eagle-game",
    "title": "Ultimate Flying Eagle Game",
    "description": "Eagle Empire is a game created for those who love arcade games and overcoming obstacles and adversities. It is also a great game for nature and animal lovers. Birds and eagles in particular, since its super main character is a real eagle. Flappy Eagle is an arcade game. The goal is to get the higher score possible. If you like strong emotions and to surpass yourself, you will love this animal game. It will help you develop your mental reflexes and physical coordination as you will have to overcome obstacles and advance as far as possible.",
    "instructions": "- To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "fly",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/7j0h669xt7sa6x492awk7htjib9lwqz3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7j0h669xt7sa6x492awk7htjib9lwqz3/",
    "sourceUrl": "https://html5.gamemonetize.com/7j0h669xt7sa6x492awk7htjib9lwqz3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72507",
    "slug": "magic-beauty-makeup",
    "title": "Magic Beauty Makeup",
    "description": "Welcome to Magic Beauty Makeup, a casual and relaxing girl makeover game on H5games4u. The girl is in trouble with her appearance. Help her return to her original beauty with skin care and makeup methods. You will act as a makeover artist who does skin care, applies facial makeup, and designs a perfect look in the virtual fashion salon.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "beauty",
      "Dress Up",
      "Makeover",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/wvwfdzfjv7jj4ikopq3fkpq1lwi6as3o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wvwfdzfjv7jj4ikopq3fkpq1lwi6as3o/",
    "sourceUrl": "https://html5.gamemonetize.com/wvwfdzfjv7jj4ikopq3fkpq1lwi6as3o/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "72347",
    "slug": "overlook-tank-war",
    "title": "Overlook Tank War",
    "description": "Overlook Tank War is an exciting top-down tank shooter where players control a powerful tank on a mission to clear out enemy forces. With automatic shooting, players can focus on strategic movements and positioning while battling waves of enemies. Take advantage of the battlefield terrain, outmaneuver opponents, and dominate the arena! Automatic Shooting: Let your tank fire automatically, so you can concentrate on movement and tactics. Strategic Gameplay: Plan your moves carefully, avoid enemy fire, and be the last tank standing. Top-Down View: Experience the game from a tactical bird&rsquo;s-eye view, perfect for controlling your tank&rsquo;s movem",
    "instructions": "keyboard WASD move and tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Adventure",
      "attack",
      "Battle",
      "Shooter",
      "Tank",
      "Tanks",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/qszsjvbbog34bpge30jspq1j73p6cfj8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qszsjvbbog34bpge30jspq1j73p6cfj8/",
    "sourceUrl": "https://html5.gamemonetize.com/qszsjvbbog34bpge30jspq1j73p6cfj8/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72327",
    "slug": "bus-park-3d",
    "title": "Bus Park 3D",
    "description": "Bus Park 3D is a realistic truck-parking challenge with tight corners, narrow docks, cones, and moving traffic. Master precise steering, trailer swing, and momentum as you park without hitting obstacles. Unlock new yards and trucks, switch camera views, Perfect for fans of driving sims and skill-based challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "3D Games",
      "bus",
      "Car",
      "Driving",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/44fm06aqx7dz3mq1u9oyowc93ns21n3p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/44fm06aqx7dz3mq1u9oyowc93ns21n3p/",
    "sourceUrl": "https://html5.gamemonetize.com/44fm06aqx7dz3mq1u9oyowc93ns21n3p/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "72222",
    "slug": "animal-helicopter-rescue-game",
    "title": "Animal Helicopter Rescue Game",
    "description": "Welcome to an exciting helicopter rescue game where you are the pilot, and your mission is to save the lives of animals. In this helicopter rescue game, your job is to complete different rescue missions and become a true pilot. In helicopter simulator games every level brings an interesting challenge. Fly carefully and complete the mission. Fly smart, stay calm, and become the real pilot in this helicopter game simulator which everyone needs. This is your chance to save lives as well as sharpen your helicopter flying expertise. Play the helicopter game and enjoy the helicopter flying in the helicopter rescue mission game. In",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back An arrow appears above the helicopter showing the delivery direction and a dot also appears on the map At the destination there is another animated arrow making it easy for the player to",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "airplane",
      "Animal",
      "Forest",
      "Helicopter",
      "Rescue",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/lfcfbk6qfhprm2gs5yah70sxbiugs80a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lfcfbk6qfhprm2gs5yah70sxbiugs80a/",
    "sourceUrl": "https://html5.gamemonetize.com/lfcfbk6qfhprm2gs5yah70sxbiugs80a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72500",
    "slug": "wednesday-halloween-cave",
    "title": "Wednesday Halloween Cave",
    "description": "Gothic girls need to escape from the mine. The girls who study at the wizard school enter a very dangerous cave in search of the magic book they&rsquo;ve been looking for. Inside the cave, they encounter a zombie they&rsquo;ve never seen before. Together with your friends, help the girls get the magic book and make sure they retrieve it safely. Be careful&mdash;there are dangerous spiders and a giant zombie in the cave. Run away from the giant zombie, and don&rsquo;t let it catch you!",
    "instructions": "When the game starts the characters move automatically Press the Up Arrow or W key to jump Mobile touch controls are available for playing on mobile devices Escape from the giant zombie and reach the magic book safely at the end of the level",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arcade",
      "free games for your website",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/erkxhnpvttp3mlh88fphd3u90qsl2tb9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/erkxhnpvttp3mlh88fphd3u90qsl2tb9/",
    "sourceUrl": "https://html5.gamemonetize.com/erkxhnpvttp3mlh88fphd3u90qsl2tb9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72496",
    "slug": "crazy-rocket-man",
    "title": "Crazy Rocket Man",
    "description": "Crazy Rocket Man is an exciting and entertaining online game made especially for kids who love action and creativity! The main goal is simple yet super fun &mdash; match the puppet&rsquo;s pose on the left side of the screen with the one on the right. Every time you successfully copy the pose, you&rsquo;ll earn a rocket part as your reward. Keep matching and collecting until you&rsquo;ve built your entire rocket! Once all the parts are assembled, your rocket will be ready to blast off into space. It&rsquo;s a thrilling mix of memory, coordination, and imagination &mdash; perfect for players who love interactive challenges and playful adventures. Get ready to pose, match, and launch in Crazy Rocket Man!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Celebrity",
      "Fun",
      "Funny",
      "Hypercasual",
      "Logic",
      "Puzzle",
      "Skill",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/fjtiq9g04drsb52wl3tl7b9lx0klo9e6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fjtiq9g04drsb52wl3tl7b9lx0klo9e6/",
    "sourceUrl": "https://html5.gamemonetize.com/fjtiq9g04drsb52wl3tl7b9lx0klo9e6/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72501",
    "slug": "tanks-of-war-halloween",
    "title": "Tanks of War Halloween",
    "description": "Are you ready for a tank battle? Team up with your friend and fight together. The fastest player wins the game. Don&rsquo;t forget to get the special Halloween skin for your tank! Join the red or blue team and destroy the enemy tank in front of you. Collect the power-ups scattered around the map &mdash; they&rsquo;ll make your tank invincible or boost your firepower. Be quick and shoot at the right moment to win the battle!",
    "instructions": "Use the WASD and Arrow Keys to move Use the Q and P keys to fire the tank A never-ending tank battle game 4 different maps",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade",
      "Halloween",
      "Tank",
      "Tanks"
    ],
    "thumbnail": "https://img.gamemonetize.com/1lbhtq5p27z7p6w5xkah2vcrlijm9fec/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1lbhtq5p27z7p6w5xkah2vcrlijm9fec/",
    "sourceUrl": "https://html5.gamemonetize.com/1lbhtq5p27z7p6w5xkah2vcrlijm9fec/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71549",
    "slug": "gem-runner",
    "title": "Gem Runner",
    "description": "Coin Runner &ndash; 3D Endless Adventure! Get ready for Coin Runner, a thrilling 3D endless running game that will test your reflexes, speed, and focus! Dodge obstacles, collect shiny coins and rare diamonds, and race your way through a stunning 3D road filled with challenges and surprises. You&rsquo;re the hero of the track &mdash; quick on your feet and hungry for treasures! But be careful &mdash; one wrong move and it&rsquo;s game over. Luckily, you&rsquo;ve got extra lives to keep the adventure going. The further you go, the faster it gets &mdash; can you handle the rush? Features Smooth and responsive 3D gameplay using advanced WebGL graphics. Collect coins and diamonds to increase your score. Dynamic camera follow system for immersive action. Crash sound effects and reward sounds for a realistic experience. 3 extra lives to give you a second chance at glory. Auto mute/pause system for ads (integrated with GameMonetize SDK). Mobile-friendly design &mdash; play on any device, anytime! Restar",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Collecting",
      "endless",
      "Road",
      "running",
      "Skill",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/oqb0sn6kv4qfmcqzqo5hjzpy2w9vplxu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oqb0sn6kv4qfmcqzqo5hjzpy2w9vplxu/",
    "sourceUrl": "https://html5.gamemonetize.com/oqb0sn6kv4qfmcqzqo5hjzpy2w9vplxu/",
    "width": 100,
    "height": 100,
    "lastUpdated": ""
  },
  {
    "id": "71788",
    "slug": "tap-react-plus",
    "title": "Tap React Plus",
    "description": "Tap &amp; React Plus is a fast-paced reaction game where every tap counts. Keep the red square alive by tapping it quickly before it shrinks away. Hit yellow squares for bonus points, and avoid the blue ones&mdash;they end your run instantly! Stay focused, react fast, and climb to the top score in this addictive reflex challenge!",
    "instructions": "Mouse PC amp Touch controls Mobile",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Shooting",
      "Skill",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/7zsk6ioaig2tn26ocf6z1kv3daxtv2xm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7zsk6ioaig2tn26ocf6z1kv3daxtv2xm/",
    "sourceUrl": "https://html5.gamemonetize.com/7zsk6ioaig2tn26ocf6z1kv3daxtv2xm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72089",
    "slug": "epic-runner-parkour-game",
    "title": "Epic Runner Parkour Game",
    "description": "Begin your journey with an intense survival challenge. Dodge and combat waves of enemies. Its not just about survival; its about quick reflexes and strategic thinking, as each lane presents unique obstacles and enemies! In the challenging world of enemies, survival is a team effort. Partner with players from all over the globe to battle the enemies. Stay alert &ndash; alliances are complex, and not every survivor you encounter is friendly. Assemble your ultimate team by recruiting heroes. With a choice of three military branches, each hero comes with their own unique skills. Combine different heroes to easily achieve victory against the enemies.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Fighting",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/qn8id2vh04sszh1968dgt3lp5u0hi7pl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qn8id2vh04sszh1968dgt3lp5u0hi7pl/",
    "sourceUrl": "https://html5.gamemonetize.com/qn8id2vh04sszh1968dgt3lp5u0hi7pl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72144",
    "slug": "monster-city",
    "title": "Monster City",
    "description": "Play as the Godzilla monster who saves...the city from destruction and allows the destruction of the city while destroying the enemies to protect the city. To protect is to accuse, to destroy is to be obligated.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "city",
      "destroy",
      "Monster",
      "Simulation",
      "WebGL",
      "World"
    ],
    "thumbnail": "https://img.gamemonetize.com/qwyxt4jx6byoc7gnl0gf01e82cab94jf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qwyxt4jx6byoc7gnl0gf01e82cab94jf/",
    "sourceUrl": "https://html5.gamemonetize.com/qwyxt4jx6byoc7gnl0gf01e82cab94jf/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "70396",
    "slug": "jigsawadventure",
    "title": "JigsawAdventure",
    "description": "Jigsaw Adventure is a jigsaw puzzle game full of retro adventure atmosphere. Players will piece together various mysterious patterns in a scene like yellowed parchment, from castle silhouettes to fantasy treasures. Each successful is like unlocking an adventure anecdote, and while training their observation skills, they start a different jigsaw puzzle adventure journey.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/r7b62izwob9hznoi8z75ldl8pt8bbddz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r7b62izwob9hznoi8z75ldl8pt8bbddz/",
    "sourceUrl": "https://html5.gamemonetize.com/r7b62izwob9hznoi8z75ldl8pt8bbddz/",
    "width": 1152,
    "height": 648,
    "lastUpdated": ""
  },
  {
    "id": "71848",
    "slug": "confusionsinmath-5-8",
    "title": "ConfusionsInMath 5 8",
    "description": "Many a times student use numbers in Std. 5-8 and have common confusions over their multiplications resulting in numbers 1-100. These are basic building blocks for all Quant so kids at this levels should make sure, they solve it always right.",
    "instructions": "Choose the correct options",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math",
      "Quiz",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/piw2np8o1kkmua3lqq8yth6v5uzzdw8l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/piw2np8o1kkmua3lqq8yth6v5uzzdw8l/",
    "sourceUrl": "https://html5.gamemonetize.com/piw2np8o1kkmua3lqq8yth6v5uzzdw8l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72071",
    "slug": "easiest-maths",
    "title": "Easiest Maths",
    "description": "Learn. Play. Win! Easiest Maths is a bright and playful math quiz game made especially for kids up to 10 years old. It helps children build strong basics in addition, subtraction, multiplication, and number patterns through quick, easy, and colorful challenges.",
    "instructions": "Choose correct option",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math",
      "Puzzle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ibqkoa8tga71wluasvc3b7r3kthngz8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ibqkoa8tga71wluasvc3b7r3kthngz8/",
    "sourceUrl": "https://html5.gamemonetize.com/2ibqkoa8tga71wluasvc3b7r3kthngz8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71720",
    "slug": "color-jam-3d",
    "title": "Color Jam 3D",
    "description": "Color Jam 3D is a fun and relaxing match-and-merge puzzle game! Combine crayons of the same colors to fill the picture and bring stunning images to life with vibrant colors. With engaging gameplay and satisfying color-filling mechanics, Color Jam 3D offers a unique blend of puzzle-solving and artistic expression.",
    "instructions": "Tap a crayon to send it into a slot Some crayons are blocked mdash clear blocking pieces to free them Match three crayons of the same color to color the picture",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Hypercasual",
      "Match 3"
    ],
    "thumbnail": "https://img.gamemonetize.com/jwsdzxshoezui2jlv4sd1gf5x5jkrx57/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jwsdzxshoezui2jlv4sd1gf5x5jkrx57/",
    "sourceUrl": "https://html5.gamemonetize.com/jwsdzxshoezui2jlv4sd1gf5x5jkrx57/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71809",
    "slug": "pipe-connect-puzzle",
    "title": "Pipe Connect Puzzle",
    "description": "Pipe Connect: Games Puzzle is a brilliant puzzle solver with an acute attention to detail and a sharp mind. Their function is to join dispersed pipe segments on a grid to provide a continuous water flow path from beginning to end. They must rotate and position pipes of different shapes, such as straight lines, elbows, and T-junctions, within a set amount of time or space as the puzzles get harder. Obstacles such as various sources, restricted routes, or challenging layouts are specific to each level. The character uses reasoning to see the finished process before acting, and he lives on strategy and planning.",
    "instructions": "Mouse click or swipe to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Brain",
      "Color",
      "Mind",
      "Pipe",
      "Puzzle",
      "Strategy",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/yjp4brcxapqbz5bsjcblsh4btx3kl4ey/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yjp4brcxapqbz5bsjcblsh4btx3kl4ey/",
    "sourceUrl": "https://html5.gamemonetize.com/yjp4brcxapqbz5bsjcblsh4btx3kl4ey/",
    "width": 800,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "72411",
    "slug": "cellf-defense",
    "title": "Cellf Defense",
    "description": "Cellf Defense is a fast-paced action strategy game where you command microscopic defenders inside a living cell. As waves of invading viruses and bacteria attack, you must deploy specialized immune units, upgrade your defenses, and adapt to evolving threats. Master the balance between offense and resource management to keep your cell alive. With vibrant visuals, challenging levels, and relentless enemies, only the sharpest strategist can survive the microscopic battlefield.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/whqzssc4qq9m927vemrnr89i5jkj8kdg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/whqzssc4qq9m927vemrnr89i5jkj8kdg/",
    "sourceUrl": "https://html5.gamemonetize.com/whqzssc4qq9m927vemrnr89i5jkj8kdg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72291",
    "slug": "fish-hunting-frenzy-shooter-game",
    "title": "Fish Hunting Frenzy Shooter Game",
    "description": "Welcome to the dark, thrilling, and action-packed underwater world of fish hunting. This is not just another fish survival game &ndash; this is an extreme predator experience where the tables have turned. For years, humans have dominated the oceans with fishing nets, boats, and harpoons. But now, the ocean has given birth to a monster &ndash; a terrifying mutant fish with sharp teeth, endless hunger, and an unstoppable desire to hunt humans in a fish hunting game. It is a monster fish that eats humans. When you start the fish game, your fish is small but powerful. You swim in the ocean, near the beach, and around the ships.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Fish",
      "hunter",
      "Hunting",
      "Simulation",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/fka0srbhopmu1w4dr232pxga38pk79v8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fka0srbhopmu1w4dr232pxga38pk79v8/",
    "sourceUrl": "https://html5.gamemonetize.com/fka0srbhopmu1w4dr232pxga38pk79v8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72320",
    "slug": "box-magician",
    "title": "Box Magician",
    "description": "Box Magician is a cute Halloween-themed physics puzzle game where you help a little witch collect treasure! Tap and remove crates to alter the structure and guide the chest safely toward her. Some items explode, others roll or tip the balance &mdash; each level is a clever setup waiting to be solved with timing and logic. With charming Halloween visuals, smooth animations, and increasingly complex layouts, Box Magician offers a pleasant yet exciting experience for players who enjoy clever, satisfying physics puzzles.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Fun",
      "Halloween",
      "Logic",
      "Mobile",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/auevh1h61qj97qp28g7m9fs2jb89vplj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/auevh1h61qj97qp28g7m9fs2jb89vplj/",
    "sourceUrl": "https://html5.gamemonetize.com/auevh1h61qj97qp28g7m9fs2jb89vplj/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72252",
    "slug": "two-player-red-hands-game",
    "title": "Two Player Red Hands Game",
    "description": "Welcome to the world of two players of the red hands game. Challenge your friends to play two player hand games and check whos the first one to get hot hands! Ready? Gooo!!! Red hands two player game is based on one of the coolest clapping games. It belongs to funny reaction games, but anyone whos competitive can play this funny game. If you like to play two player games, this is a perfect choice for you! Because it is simple and easy to play, red hands two player games belong to fun games for people of all ages. The game tests your reflexes and speed so if you dont pay attention, you will get red hands!",
    "instructions": "- To click any button use mouse",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Action",
      "attack",
      "Fighting",
      "Red"
    ],
    "thumbnail": "https://img.gamemonetize.com/485gqzfrbzass7ig99juwrcb73d0286z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/485gqzfrbzass7ig99juwrcb73d0286z/",
    "sourceUrl": "https://html5.gamemonetize.com/485gqzfrbzass7ig99juwrcb73d0286z/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69896",
    "slug": "cubic-rush1",
    "title": "Cubic Rush1",
    "description": "Cubic Rush is a fast-paced, minimalist 2D endless runner where rhythm and timing are key! You control a vibrant red cube that automatically slides forward on a sleek green path under a sunny yellow sky. Your goal is simple: tap to make the cube jump over the incoming blue obstacles. Each successful jump boosts your score and releases a satisfying pop sound with white bubble particles. But beware! Hitting a blue cube triggers a loss sound and a YOU LOSE screen. The challenge intensifies as your speed increases with every 5 points scored, pushing your reflexes to the limit. Chase a new high score in this endlessly escalating, visually clean, and addictive arcade challenge!",
    "instructions": "middot Mobile Touchscreen middot Tap anywhere on the screen Makes the Red Cube jump middot Tap the REPLAY button Restarts the game after a loss middot PC Keyboard middot Press SPACEBAR Makes the Red Cube jump middot Press t",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "amazing",
      "Arcade",
      "Avoid",
      "Best",
      "Best Games",
      "Game",
      "HTML",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/a84nnc8v9ds5z1qkgmfgti532to875sl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a84nnc8v9ds5z1qkgmfgti532to875sl/",
    "sourceUrl": "https://html5.gamemonetize.com/a84nnc8v9ds5z1qkgmfgti532to875sl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72082",
    "slug": "maze-boom",
    "title": "MAZE BOOM",
    "description": "Find your way through challenging mazes filled with twists turns and surprises use logic and memory to avoid dead ends solve clever puzzles and reach the exit before time runs out each level brings new obstacles and more excitement making every maze a thrilling adventure",
    "instructions": "pc arrow keys phone swipe on the maze",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "amazing",
      "Avoid",
      "Best Games",
      "Cool",
      "Maze",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/5x895nh10i777j08juyxdq6qpfx0glng/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5x895nh10i777j08juyxdq6qpfx0glng/",
    "sourceUrl": "https://html5.gamemonetize.com/5x895nh10i777j08juyxdq6qpfx0glng/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64002",
    "slug": "link-flow",
    "title": "Link Flow",
    "description": "Enter the mesmerizing world of Link Flow, where logic meets creativity in a captivating puzzle experience! In this minimalist yet visually stunning game, your goal is simple: connect the dots with seamless lines, recreating intricate patterns that test your problem-solving skills. With each level, the complexity increases, requiring you to think ahead and strategize your moves. The clean interface, calming aesthetics, and smooth mechanics make Link Flow both relaxing and challenging at the same time. Whether youre looking for a casual brain teaser or a deep puzzle-solving experience, this game offers endless entertainment.",
    "instructions": "Mouse PC Click and drag to connect dots and create the required pattern Touch Mobile Tablets Tap and swipe to draw lines between the dots Undo Use the back button to remove the last connection if needed Restart Press the reset button to start t",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Color",
      "Drawing",
      "Logic",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/dyz43tu8xyxu9d1o2f2loe20o8vijrki/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dyz43tu8xyxu9d1o2f2loe20o8vijrki/",
    "sourceUrl": "https://html5.gamemonetize.com/dyz43tu8xyxu9d1o2f2loe20o8vijrki/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72163",
    "slug": "the-bunny-vs-the-gardener",
    "title": "The Bunny vs The Gardener",
    "description": "The Bunny vs The Gardener is a fast-paced arcade shooter where a brave bunny defends his peaceful garden from the furious gardener boss. Dodge attacks, blast through waves of seeds and obstacles, and face epic boss battles at 30 and 60 points. Quick reflexes, smooth controls, and colorful visuals make every round exciting and unpredictable. Web Dev <a href='https://www.crazygamesxo.com/'>https://www.crazygamesxo.com/</a>",
    "instructions": "Move Move your mouse left right to steer the bunny Shoot Hold Left Mouse Button to fire Release to stop firing Lives You start with 3 lives You gain 1 life when advancing to the next level",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Adventure",
      "Animal",
      "Arcade",
      "Games Ai",
      "Rabbit",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/0r37g5w6rdj1u9t3hitlddy78afvy429/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0r37g5w6rdj1u9t3hitlddy78afvy429/",
    "sourceUrl": "https://html5.gamemonetize.com/0r37g5w6rdj1u9t3hitlddy78afvy429/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72288",
    "slug": "crowd-runners-3d",
    "title": "Crowd Runners 3D",
    "description": "Choose the best gate, pass through it, and bring stickman warriors together to clash with the opposing crowd. Become the crowd runner and lead your people through the crowded city till the end of this epic race. Crash obstacles and beat everyone on your way, collect coins and upgrade your levels. Defeat the King-stickman in the final battle and take the castle!",
    "instructions": "Use the mouse or touch to control the Stickmans",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Action",
      "Clash",
      "Fighting",
      "Levels",
      "running",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/cb46lvg1na5tbw02mtyngdts930u61f1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cb46lvg1na5tbw02mtyngdts930u61f1/",
    "sourceUrl": "https://html5.gamemonetize.com/cb46lvg1na5tbw02mtyngdts930u61f1/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "72267",
    "slug": "offroad-jeep-driving-game",
    "title": "OffRoad Jeep Driving Game",
    "description": "Welcome to play offroad jeep driving simulator on impossible offroad tracks where you will show your driving skills and enjoy an off-road journey in the mountains area. SUV 4x4 offroad jeep driving simulator offline powerful engine Prado car games offroad drive simulator 2023 with your driving skills reach the target without destroying your mountain climb truck game offroad jeep games stunt racing game and keep your grip on the mountain hill roads and complete the missions that You are assigned as a professional uphill jeep simulator 3d offroad driver, Fast Jeep Wrangler simulator off-road 4x4 jeep driving games.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Action",
      "Car",
      "Driving",
      "jeep",
      "offroad"
    ],
    "thumbnail": "https://img.gamemonetize.com/l73y71zlm4347f4sw6y0key3hm7fepq2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l73y71zlm4347f4sw6y0key3hm7fepq2/",
    "sourceUrl": "https://html5.gamemonetize.com/l73y71zlm4347f4sw6y0key3hm7fepq2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72257",
    "slug": "monster-truck-racing-game",
    "title": "Monster Truck Racing Game",
    "description": "Get ready for the most thrilling adventure in the world of monster truck games! Drive powerful 4x4 monster trucks across extreme tracks, perform impossible stunts, and explore dangerous offroad environments in this action-packed monster truck driving simulator game. If you love offroad racing games, truck stunt games, or realistic driving simulators, then this game is made just for you. Easy steering, realistic physics, and responsive handling for the best driving experience. In this Monster Truck Game, your mission is simple but challenging &ndash; take control of giant monster trucks, race against time, climb steep hills, and crush everything tha",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "city",
      "Driving",
      "Monster",
      "monstertruck",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/1az3dmc5l928uspjpx12zdkb5ppbh4gd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1az3dmc5l928uspjpx12zdkb5ppbh4gd/",
    "sourceUrl": "https://html5.gamemonetize.com/1az3dmc5l928uspjpx12zdkb5ppbh4gd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72251",
    "slug": "halloween-bubble-shooting-game",
    "title": "Halloween Bubble Shooting Game",
    "description": "Welcome to the Halloween Bubble Shooter! Get ready for a scary adventure filled with pumpkins, ghosts, and endless bubble-popping fun! Dive into the haunted world of this thrilling offline game, perfect for when you need a break or want to enjoy some Halloween excitement anytime, anywhere! With hundreds of scary levels to conquer, your skills will be put to the test as you pop, match, and blast bubbles in a series of nightmare-inducing Halloween challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Bubble",
      "Bubble Shooter",
      "onetouch"
    ],
    "thumbnail": "https://img.gamemonetize.com/zm3rceetko64aovtlppp75lb2ykjpvpp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zm3rceetko64aovtlppp75lb2ykjpvpp/",
    "sourceUrl": "https://html5.gamemonetize.com/zm3rceetko64aovtlppp75lb2ykjpvpp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72221",
    "slug": "real-advanced-monster-truck-simulator",
    "title": "Real Advanced Monster Truck Simulator",
    "description": "You have to perform crazy race stunts and cause destruction with derby car. Stunt driver can smash and destroy the realistic 3D environment. Enjoy real damage by the monstrous truck and demolish everything in your way with the reckless monster truck driving. Enjoy cars smashing, hitting and crashing into each other in the most exciting monster truck games.",
    "instructions": "Use W A S D for player movement",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "carparking",
      "Highscore",
      "jump",
      "monstertruck",
      "Parking",
      "Race",
      "Simulator",
      "Stunts",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/3sbwz2loxtmz631j5ide4t1cndniw51r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3sbwz2loxtmz631j5ide4t1cndniw51r/",
    "sourceUrl": "https://html5.gamemonetize.com/3sbwz2loxtmz631j5ide4t1cndniw51r/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72247",
    "slug": "anti-terrorist-shooting-game",
    "title": "Anti Terrorist Shooting Game",
    "description": "Overview Play as an elite commando in a modern war against terrorists. Fight across realistic terrains with AI enemies, complete missions, and experience smooth auto-shoot controls with HD graphics. Game Modes Campaign: Story-based terrorist takedown Survival: Endless enemy waves PVP (Offline): Practice vs AI enemies Zombie Mode: Survive undead attacks Tank Mode: Control tanks and destroy terrorist bases Defuse Mode: Disarm bombs strategically Features Auto-shoot &amp; swipe-to-aim controls Upgradable modern weapons and explosives Realistic HD graphics &amp; immersive sound",
    "instructions": "Mouse click or tap to play W A S D for left right movement and left tap for shooting and right click for aim and R for reload",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Adventure",
      "Best Games",
      "First Person Shooter",
      "fps",
      "PvP",
      "Shooting",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/yppzt3a7q7dn0qpf1rame7d875dbo7s9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yppzt3a7q7dn0qpf1rame7d875dbo7s9/",
    "sourceUrl": "https://html5.gamemonetize.com/yppzt3a7q7dn0qpf1rame7d875dbo7s9/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72263",
    "slug": "candy-match-puzzle-challenge",
    "title": "Candy Match Puzzle Challenge",
    "description": "Candy Match Puzzle is an exciting and free-to-play online match-4 style game designed to bring endless fun and challenge to players of all ages! Your goal is simple but addictive &mdash; match as many colorful candies as possible to achieve the highest score. Connect four or more identical candies to clear them from the board and watch as sweet combos and chain reactions fill your screen with rewarding points.",
    "instructions": "Left and right arrow to move the player Z to grab the candy and X to swap the candies",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bejeweled",
      "Brain",
      "Candy",
      "Collecting",
      "Fun",
      "Highscore",
      "Hypercasual",
      "Logic",
      "Match 3",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/nu3fgrns30jdzq2wysqff6te13emsdlu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nu3fgrns30jdzq2wysqff6te13emsdlu/",
    "sourceUrl": "https://html5.gamemonetize.com/nu3fgrns30jdzq2wysqff6te13emsdlu/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "70388",
    "slug": "flappy-halloween-run",
    "title": "Flappy Halloween Run",
    "description": "Welcome to the Flappy Halloween Run game!!! The player has to save the Halloween ball and fly through gaps between obstacles like flying witch and birds. The game ends when the player touch with the Any obstacles or falls down due to gravity.",
    "instructions": "Simple Control Tap And Jump TAP AND PLAY You Can Tap Mouse To Jump Over the Obstacles",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "3D",
      "Adventure",
      "Alien",
      "Android",
      "Anime",
      "attack",
      "Ghost"
    ],
    "thumbnail": "https://img.gamemonetize.com/eou8jfbte7a7mkm9appdrfheu1v6n3tb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eou8jfbte7a7mkm9appdrfheu1v6n3tb/",
    "sourceUrl": "https://html5.gamemonetize.com/eou8jfbte7a7mkm9appdrfheu1v6n3tb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72100",
    "slug": "halloween-match-trio",
    "title": "Halloween Match Trio",
    "description": "Halloween Match Trio is a classic match-3 puzzle game with fun challenges. Swap items to make a line of three or more matching items, horizontally or vertically. Keep matching to unlock all tiles and reach the final stage. Use power-ups like bombs, arrows, magnets, and more to clear levels faster. Complete all 75 levels to win the game!",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Halloween",
      "Match-3",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/m1jq6f0w2zxpje2avccod87k5yof5ef0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m1jq6f0w2zxpje2avccod87k5yof5ef0/",
    "sourceUrl": "https://html5.gamemonetize.com/m1jq6f0w2zxpje2avccod87k5yof5ef0/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "72239",
    "slug": "firedash-2d",
    "title": "FireDash 2D",
    "description": "FireDash-2D is a fast-paced survival game where you must dodge rising flames and move quickly to stay alive. Test your reflexes, time your dashes, and survive as long as possible. Simple controls, fiery visuals, and nonstop action make it an addictive challenge for players who love speed and precision!",
    "instructions": "Mouse click or tap to play Movement left Right Arrow key",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adventure",
      "amazing",
      "Animal",
      "Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/rkcju0by0l4tphqlipsq1jzhs6boxco0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rkcju0by0l4tphqlipsq1jzhs6boxco0/",
    "sourceUrl": "https://html5.gamemonetize.com/rkcju0by0l4tphqlipsq1jzhs6boxco0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72234",
    "slug": "mojo-emoji",
    "title": "Mojo Emoji",
    "description": "Moji Emoji is a fun and clever word/emoji puzzle game where each level challenges you to guess the hidden word or phrase from a set of expressive emojis. Think fast, connect the clues, and test your emoji decoding skills across hundreds of creative puzzles.",
    "instructions": "Click on the letter to place it the slot",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/ihwy9h4pojf3lu9ngeuuyev6x4nsi1vo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ihwy9h4pojf3lu9ngeuuyev6x4nsi1vo/",
    "sourceUrl": "https://html5.gamemonetize.com/ihwy9h4pojf3lu9ngeuuyev6x4nsi1vo/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "72217",
    "slug": "floof-my-pet-house",
    "title": "Floof My Pet House",
    "description": "Welcome to Floof - My Pet House, a casual pet simulation game for kids online. If you love playing with cats and dogs, or are looking for lovely and relaxing games online, do not hesitate to join H5games4us best animal care game. You will take care of a puppy or a cute cat, feed them, dress them up, and play minigames with them. Earn enough coins to upgrade your pet house and buy more furniture.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Dress Up",
      "Kids",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/kvk00287r982pktzqwkd5h8ca3l338bz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kvk00287r982pktzqwkd5h8ca3l338bz/",
    "sourceUrl": "https://html5.gamemonetize.com/kvk00287r982pktzqwkd5h8ca3l338bz/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71918",
    "slug": "nut-sort-color-puzzle-game",
    "title": "Nut Sort: Color Puzzle Game",
    "description": "Nut Sort: Color Puzzle Game &mdash; a satisfying and addictive logic puzzle that will test your organizational skills! Sort colorful nuts onto matching bolts so that each bolt holds nuts of only one color. Sounds simple? Think again! Each new level introduces more bolts, more colors, and trickier layouts that will truly challenge your brain. How to play: Tap to move nuts between bolts, but plan carefully &mdash; one wrong move can leave you stuck!",
    "instructions": "Left-click Tap mdash select a nut and move it onto another bolt",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Color",
      "Relaxation",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/bqo62nz1cpec68bw0mb8z8deln9yrq5a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bqo62nz1cpec68bw0mb8z8deln9yrq5a/",
    "sourceUrl": "https://html5.gamemonetize.com/bqo62nz1cpec68bw0mb8z8deln9yrq5a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71811",
    "slug": "formula-car-racing-games",
    "title": "Formula Car Racing Games",
    "description": "In Top Speed Formula Car Racing Games, you have access to multiple high-speed cars, all set to race on thrilling tracks. This formula game, renowned among car games, starts in a stadium packed with motorsport enthusiasts. Be cautious on sharp turns, as high-speed racing can be dangerous, leading to slips and crashes. Enjoy the realistic physics and become a legend in the formula racing world, striving to win the top speed racing tournament. Become a top racer in this formula car racing game, designed for fast-paced competition. Drive single-seat, open cockpit, open-wheel cars with powerful engines of racing car games.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Car",
      "Cars",
      "Race",
      "Racing",
      "Road",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/0l23s8wwj9n5xgcc6tyagm5inw1bv60d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0l23s8wwj9n5xgcc6tyagm5inw1bv60d/",
    "sourceUrl": "https://html5.gamemonetize.com/0l23s8wwj9n5xgcc6tyagm5inw1bv60d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71923",
    "slug": "city-cargo-truck-driving-game",
    "title": "City Cargo Truck Driving Game",
    "description": "Welcome to the city truck cargo game. Experience the thrill of driving a truck through a bustling city. Gear up for the ultimate cargo delivery adventure in City Cargo Truck Simulator, where you take the wheel of powerful trucks to transport cars in a bustling city. Navigate through heavy traffic, narrow streets, and tricky turns as you complete challenging delivery missions with precision and speed. Can you handle the pressure and become the top cargo truck driver in the city? Every mission requires skillful driving and precise parking. Feel the weight of your cargo as you drive.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adventure",
      "Racing",
      "Simulation",
      "Simulator",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/2t96bk2qy6gfeqe3wvcorrpkytk33rcf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2t96bk2qy6gfeqe3wvcorrpkytk33rcf/",
    "sourceUrl": "https://html5.gamemonetize.com/2t96bk2qy6gfeqe3wvcorrpkytk33rcf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71823",
    "slug": "emergency-ambulance-driving-game",
    "title": "Emergency Ambulance Driving Game",
    "description": "Welcome to the ambulance rescue simulator game! Are you ready to become a real-life hero? Take a seat and start your job in a fully modeled and realistic ambulance game. Ambulance rescue simulator game offers an exciting and educational experience. Navigate through busy city streets, rush to accident scenes, and transport patients safely to the hospital. Your mission is to drive fast, stay calm, and save lives! Get turn on the sirens, and show your emergency driving skills in this action-packed rescue game! Experience realistic engine sounds, emergency sirens, and heart-pounding rescue music as you race to save lives.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "ambulance",
      "Car",
      "Cars",
      "city",
      "Driving"
    ],
    "thumbnail": "https://img.gamemonetize.com/ex0828f49g2pkh7v0v9ygdxxwwwoq69v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ex0828f49g2pkh7v0v9ygdxxwwwoq69v/",
    "sourceUrl": "https://html5.gamemonetize.com/ex0828f49g2pkh7v0v9ygdxxwwwoq69v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72242",
    "slug": "3d-halloween-jigsaw",
    "title": "3D Halloween Jigsaw",
    "description": "3D Halloween Jigsaw is a 3D remake of the classic jigsaw puzzle with beautiful halloween themes. Can you solve the puzzle with many difficulties from 6 pieces to 96 pieces?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Fun",
      "Funny",
      "Halloween",
      "Jigsaw",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/yqtmz79h77simoqjmg9sj2g1up2vth3o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yqtmz79h77simoqjmg9sj2g1up2vth3o/",
    "sourceUrl": "https://html5.gamemonetize.com/yqtmz79h77simoqjmg9sj2g1up2vth3o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72223",
    "slug": "machine-city-balls",
    "title": "Machine City Balls",
    "description": "Control your ball and drive on irregular roads. Sometimes you may encounter obstacles, but you may also fall into the abyss if you are not careful. However, there will be generous rewards for clearing the level.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Action",
      "Ball",
      "Hypercasual",
      "running",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/83hgteh0eensk1rjj4m3ayqo38b33imw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/83hgteh0eensk1rjj4m3ayqo38b33imw/",
    "sourceUrl": "https://html5.gamemonetize.com/83hgteh0eensk1rjj4m3ayqo38b33imw/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72201",
    "slug": "three-points",
    "title": "Three Points",
    "description": "Three Points is a fast-paced neon reflex arcade game that challenges your precision and timing. Rotate the glowing triangle to match the color of each falling ball before it hits the ring. One mistake ends the game, so stay focused and react fast. How to Play: Tap or click to rotate the triangle by 120 degrees. Match the top color with the falling ball to score points. Collect special bonus orbs with letters inside for temporary power-ups like time extension, shield, or score multiplier.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "mapi games",
      "Matching",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/j26hfzgrv8fjng9pi1deswl9gcoyag8e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j26hfzgrv8fjng9pi1deswl9gcoyag8e/",
    "sourceUrl": "https://html5.gamemonetize.com/j26hfzgrv8fjng9pi1deswl9gcoyag8e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72206",
    "slug": "fnaf-strike-halloween",
    "title": "FNAF Strike Halloween",
    "description": "FNAF Strike Halloween is an intense first-person shooter set in a spooky Halloween-themed world inspired by the legendary Five Nights at Freddy&rsquo;s universe. Your mission is simple but terrifying &mdash; survive each level by blasting through waves of deadly FNAF animatronics and find your way to the exit before they catch you. Every level is packed with chilling decorations, haunted corridors, flickering lights, and eerie sounds that create the ultimate horror-shooter experience. As you advance, new challenges, hidden traps, and stronger animatronic enemies appear, testing your reflexes and accuracy.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "CSGO",
      "First Person Shooter",
      "Gun",
      "Halloween",
      "Horror",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/ku4cdozc5yihzx014dvug9m9ndifnd3x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ku4cdozc5yihzx014dvug9m9ndifnd3x/",
    "sourceUrl": "https://html5.gamemonetize.com/ku4cdozc5yihzx014dvug9m9ndifnd3x/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71833",
    "slug": "nostalgic-playstation1-quiz",
    "title": "Nostalgic Playstation1 Quiz",
    "description": "Step back into the golden age of gaming with Nostalgic Playstation1 Quiz! Test your memory and knowledge of the legendary PS1 era &mdash; from classic characters and epic soundtracks to the unforgettable games that started it all. Can you recognize every retro gem? ???? Features: ???? Hundreds of questions about iconic PS1 games ???? Guess-the-game from images, logos, or trivia clues ???? Relive the 90s nostalgia with every question ???? Challenge friends and prove you&rsquo;re a true PlayStation legend",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Quiz",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/06clf8qhjrfp4dftq78jinoige4u5xow/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/06clf8qhjrfp4dftq78jinoige4u5xow/",
    "sourceUrl": "https://html5.gamemonetize.com/06clf8qhjrfp4dftq78jinoige4u5xow/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70468",
    "slug": "cashier-point",
    "title": "Cashier Point",
    "description": "In this game, you take on the role of a cashier at a store, where the main task is to calculate and return the correct change to the customer. The game is designed to test both your math skills and speed under pressure. Objective: The main goal is to return the correct change as quickly as possible. The game becomes increasingly challenging as the amounts get larger and the time to make the change decreases. The faster you are, the higher your score will be.",
    "instructions": "Mouse click",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Brain",
      "Casino",
      "Logical",
      "Math",
      "Mind"
    ],
    "thumbnail": "https://img.gamemonetize.com/c1j9fdppzk5g4btdemyvue2lifq7dlvv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c1j9fdppzk5g4btdemyvue2lifq7dlvv/",
    "sourceUrl": "https://html5.gamemonetize.com/c1j9fdppzk5g4btdemyvue2lifq7dlvv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71813",
    "slug": "k-pop-hunter-halloween-fashion",
    "title": "K Pop Hunter Halloween Fashion",
    "description": "Step into the glamorous world of K-Pop Hunter Halloween Fashion! In this fun dress-up game, you become the ultimate stylist, creating spooky yet stylish looks for popular K-Pop stars. Mix and match Halloween costumes, trendy hairstyles, and cool accessories to design jaw-dropping outfits for the season&rsquo;s most exciting event.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/yb2a55demhhm058ax3vzzx34babw545i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yb2a55demhhm058ax3vzzx34babw545i/",
    "sourceUrl": "https://html5.gamemonetize.com/yb2a55demhhm058ax3vzzx34babw545i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72218",
    "slug": "lion-family-sim-online",
    "title": "Lion Family Sim Online",
    "description": "Step into the wild and rule the savannah in Lion Family Sim Online. It&rsquo;s a full animal simulation adventure where you live the life of a mighty lion. Build and grow your own lion family, explore vast open landscapes, and face thrilling challenges. Hunt for food to survive, protect your territory, and lead your pride with strength and strategy.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Animal",
      "Food",
      "lion",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/3rpjxnxcc6482ltv1hbfbhsc68ezkg2c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3rpjxnxcc6482ltv1hbfbhsc68ezkg2c/",
    "sourceUrl": "https://html5.gamemonetize.com/3rpjxnxcc6482ltv1hbfbhsc68ezkg2c/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "71309",
    "slug": "fish-royale-io",
    "title": "Fish Royale io",
    "description": "Fish Royale io throws you into a chaotic reef where bite beats might. Start as a scrappy guppy, gobble smaller fish to grow, then bully the food chain with wild power-ups&mdash;laser bursts, drill dashes, toxic wakes, and slick comic-inspired skins. The ocean&rsquo;s packed with predators, so weave through kelp, time your boosts, and snipe unsuspecting snacks. Web Dev h<a href='https://www.poki.com.es/'>https://www.poki.com.es/</a> Level up fast, evolve into a nightmare piranha, and chase the crown on the global leaderboard.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "Arcade",
      "Fish",
      "Fishing",
      "Mentolatux",
      "onlinegames io",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/lmxuoasnk3yi56rki31cim52miapkent/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lmxuoasnk3yi56rki31cim52miapkent/",
    "sourceUrl": "https://html5.gamemonetize.com/lmxuoasnk3yi56rki31cim52miapkent/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72228",
    "slug": "brainrot-mini-challenge",
    "title": "Brainrot Mini Challenge",
    "description": "Want the craziest challenges ever? Brainrot Mini Challenge is a massive collection packed with tons of fun minigames. Each level offers a completely fresh experience. From tricky brain teasers to exciting shooting battles, hilarious stickman moments, and relaxing casual puzzles, there&rsquo;s something here for everyone!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Puzzle",
      "Shoot",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/0vebeu4j60gmlg7lwbnozyelejdxjq84/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0vebeu4j60gmlg7lwbnozyelejdxjq84/",
    "sourceUrl": "https://html5.gamemonetize.com/0vebeu4j60gmlg7lwbnozyelejdxjq84/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "72092",
    "slug": "mermaids-tail-rush",
    "title": "Mermaids Tail Rush",
    "description": "Mermaids are known to eat their tails to increase their length and make them more beautiful. Im kidding. At the end of the game, you will receive rewards based on the length of your tail! Please feel free to lengthen it",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual",
      "Collecting",
      "Hypercasual",
      "Obstacle",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/1j1r48dhcnlj6j1nr2axr6bzbe0z19gm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1j1r48dhcnlj6j1nr2axr6bzbe0z19gm/",
    "sourceUrl": "https://html5.gamemonetize.com/1j1r48dhcnlj6j1nr2axr6bzbe0z19gm/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71925",
    "slug": "dirt-bus-simulation-game",
    "title": "Dirt Bus Simulation Game",
    "description": "Welcome to the off road bus game. This is a fun and exciting game where you drive a big bus on rough and bumpy roads in mud bus game. If you enjoy driving games and want to try something new, this game is just right for you. . Each level is full of fun, adventure, and new challenges. You will drive your bus through hills, dirt roads, and rocky paths. The roads are not smooth, so you need to drive carefully to avoid falling or crashing. You have to be careful and avoid hitting them while driving your bus. This makes the game even more exciting and fun.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "bus",
      "offroad",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/0aznla513smxr263nt7f1ppdkuvz5e8p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0aznla513smxr263nt7f1ppdkuvz5e8p/",
    "sourceUrl": "https://html5.gamemonetize.com/0aznla513smxr263nt7f1ppdkuvz5e8p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71820",
    "slug": "car-cargo-ship-game",
    "title": "Car Cargo Ship Game",
    "description": "Welcome to the car transport ship simulator game. The ultimate cargo transport and driving game where your driving, parking, loading, and ship navigation skills will be tested to the limits. Become a professional car transporter, load cars onto massive cargo ships, sail through deep ocean ports, and deliver vehicles across exotic islands and modern ports. If you have ever dreamed of managing a high-tech transport fleet with jeeps, ships and cars, this game is made for you! Test your parking skills, ship handling, and time management in this action-packed cargo simulator game.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adventure",
      "Car",
      "Cars",
      "Driving",
      "Parking",
      "ship",
      "ships",
      "waterslide"
    ],
    "thumbnail": "https://img.gamemonetize.com/kxh30m2ua6pedi5yfbep1e6ppyyb4yr3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kxh30m2ua6pedi5yfbep1e6ppyyb4yr3/",
    "sourceUrl": "https://html5.gamemonetize.com/kxh30m2ua6pedi5yfbep1e6ppyyb4yr3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71810",
    "slug": "brain-puzzle-tricky-quest",
    "title": "Brain Puzzle: Tricky Quest",
    "description": "Brain Test is an addictive free tricky puzzle game with a series of tricky brain teasers. Different riddles and tricky tests will challenge your mind. This new puzzle game may break common sense and bring your new brain-pushing experience! You can enjoy yourself with your friends with this addictive and funny free IQ game. Brain games, IQ games and mind games can be a great way to enhance your brain. Think out of the box, crack the puzzles and get ready to take the quiz! You will enjoy this funny tricky test. This game is a new game and an offline game. Also one of the best games in the world.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Funny",
      "Kid",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/0xpoap7mxwuwhj89a49njoponru4a0pr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0xpoap7mxwuwhj89a49njoponru4a0pr/",
    "sourceUrl": "https://html5.gamemonetize.com/0xpoap7mxwuwhj89a49njoponru4a0pr/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71821",
    "slug": "car-wash-and-repair-game",
    "title": "Car Wash And Repair Game",
    "description": "Welcome to the car wash simulator game. The ultimate car cleaning and detailing game where you transform dirty, muddy vehicles into sparkling, showroom-ready rides. Experience the thrill of running a car wash business in this realistic simulation game! With realistic graphics and gameplay you will feel like youre really washing cars. Take on the car cleaning challenge and show off your skills. Wash and clean a variety of cars. Each car has its own unique characteristics and cleaning challenges. Each car is unique, giving you a fresh challenge every time in car cleaning games.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Car",
      "car tuning",
      "carparking",
      "Cars",
      "city",
      "Driving",
      "Parking"
    ],
    "thumbnail": "https://img.gamemonetize.com/ym1fq29e2c21ionwkca41aq593csvapm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ym1fq29e2c21ionwkca41aq593csvapm/",
    "sourceUrl": "https://html5.gamemonetize.com/ym1fq29e2c21ionwkca41aq593csvapm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72156",
    "slug": "soccer-guantone-mobile",
    "title": "Soccer Guantone Mobile",
    "description": "Take on Guantone the sassy goalkeeper and the Hungry Giant in this funny, fast-paced soccer adventure! Score penalties, avoid blocks, collect diamonds, and reach 12 goals to win the cup, +7000 points, and an epic celebration with balloons and donuts! A happy, silly, and thrilling game for kids, teens, and anyone who loves big laughs and crazy soccer fun!",
    "instructions": "Controls Mobile Version Essential Touch Controls Ball Movement Tap the Left Right buttons on the screen Shooting and Aim Tap the Shoot Button Your tap doesnt just shoot it locks the Auto Aim at that precise moment Victory is all about timing",
    "category": "Soccer",
    "genres": [
      "Soccer"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Baby Games",
      "Football",
      "Funny",
      "Mobile",
      "Soccer",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/sxamxsrcl1yjh3m2nsbaa96o4mcduxno/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sxamxsrcl1yjh3m2nsbaa96o4mcduxno/",
    "sourceUrl": "https://html5.gamemonetize.com/sxamxsrcl1yjh3m2nsbaa96o4mcduxno/",
    "width": 960,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72138",
    "slug": "passenger-city-taxi-game",
    "title": "Passenger City Taxi Game",
    "description": "Welcome to the city taxi driver simulator game, the ultimate driving experience where you become the most reliable and skilled taxi driver in the city. Navigate busy streets, pick up passengers and drop them off safely at their destinations. Every ride is a new challenge that will test your driving skills and city navigation abilities. Get powerful taxis and complete exciting missions and earn rewards for exceptional service. Ready to hit the road and become the best taxi driver in town. Drive a range of vehicles from classic yellow cabs and modern luxurious taxis. Unlock new taxis as you progress through the taxi game.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "building",
      "Car",
      "city",
      "Driving",
      "Taxi",
      "transport"
    ],
    "thumbnail": "https://img.gamemonetize.com/wbzn75op9wz7mjmjv4s877cwj1s91myf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wbzn75op9wz7mjmjv4s877cwj1s91myf/",
    "sourceUrl": "https://html5.gamemonetize.com/wbzn75op9wz7mjmjv4s877cwj1s91myf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72181",
    "slug": "flipxy-the-bat",
    "title": "Flipxy, the bat",
    "description": "Flipxy is a fast-paced arcade game where you control a bouncing bat that can only flip its direction. Collect coins, dodge monsters, grab bananas to survive, and face spooky bosses in a thrilling Halloween night.",
    "instructions": "Simple two-button flip controls In addition you can use the keyboard or configure a gamepad physical or virtual Keyboard Player 1 Flip X A Flip Y S Player 2 Flip X O Flip Y P",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/0hu0lxuttwm5fjw5mox59cbs8h69py9s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0hu0lxuttwm5fjw5mox59cbs8h69py9s/",
    "sourceUrl": "https://html5.gamemonetize.com/0hu0lxuttwm5fjw5mox59cbs8h69py9s/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71734",
    "slug": "obby-grow-with-every-step",
    "title": "Obby Grow with every step",
    "description": "Obby game inspired by Roblox where your character grows taller with every step! The more you run, the higher you become &mdash; and the harder the challenges you can overcome! Jump over gaps, climb high platforms, avoid traps, and see how far you can go! Test your skills in exciting levels filled with parkour elements, puzzles, and obstacles that become more difficult as your character grows. Improve your agility, speed, and precision to become the tallest and most skilled obby hero! Perfect for fans of Roblox-style adventures, parkour, and reaction-based challenges. Simple controls, bright graphics, and endless growth make it the perfect way to",
    "instructions": "On PC WASD ndash Move Mouse ndash Camera control Space ndash Jump On mobile devices Use the on-screen controls Drag anywhere on the screen ndash Camera control",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Animal",
      "Anime",
      "Cake",
      "Food",
      "grow",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/ka8j21lmya1dzuvvpmbly8tn8sei6w1x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ka8j21lmya1dzuvvpmbly8tn8sei6w1x/",
    "sourceUrl": "https://html5.gamemonetize.com/ka8j21lmya1dzuvvpmbly8tn8sei6w1x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72152",
    "slug": "k-pop-halloween-dress-up",
    "title": "K Pop Halloween Dress Up",
    "description": "Get spooky and stylish with K-Pop Demon Hunters Halloween Dress Up! Dress the Huntrix girls in hauntingly chic outfits like Witch, Pumpkin Queen, Vampire Idol, and more. Mix costumes, accessories, and spooky face paint to create bold Halloween looks for your favorite idols. Show off your fashion skills and celebrate Halloween K-pop style in this fun dress up game!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girl",
      "Halloween",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/w24lmd536cbwi6d750r1n9lu0w81alyk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w24lmd536cbwi6d750r1n9lu0w81alyk/",
    "sourceUrl": "https://html5.gamemonetize.com/w24lmd536cbwi6d750r1n9lu0w81alyk/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "72069",
    "slug": "crowd-evolution-3d",
    "title": "Crowd Evolution 3D",
    "description": "This is a level-breaking game that combines real-time combat and strategy. You can purchase troops or strengthen weapons and equipment, and avoid obstacles while defeating the final boss!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D Games",
      "Action",
      "attack",
      "builder",
      "Mobile",
      "Shoot",
      "slide"
    ],
    "thumbnail": "https://img.gamemonetize.com/oibc1h332sdsky90u7p3qsjtuc1mri20/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oibc1h332sdsky90u7p3qsjtuc1mri20/",
    "sourceUrl": "https://html5.gamemonetize.com/oibc1h332sdsky90u7p3qsjtuc1mri20/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72060",
    "slug": "coffee-business-tycoon-game",
    "title": "Coffee Business Tycoon Game",
    "description": "Welcome to Coffee Shop Idle, the ultimate coffee game for barista life enthusiasts! In this exciting cafe simulator, youll be running your very own coffee shop, serving up perfect coffee stacks to a growing number of customers. As you start out, youll need to master the art of the coffee stack. With each perfect coffee pour, youll earn money to grow your business, upgrade equipment and hire skilled baristas to help you keep up with the coffee rush. Keep practicing and perfecting your coffee stack technique to impress your customers and earn more money to say &ldquo;my cafe is the best!&rdquo;",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Casual",
      "Cooking",
      "eating",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/00f80f5f25tv7kjsr8z0az3ic2drfagu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/00f80f5f25tv7kjsr8z0az3ic2drfagu/",
    "sourceUrl": "https://html5.gamemonetize.com/00f80f5f25tv7kjsr8z0az3ic2drfagu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72033",
    "slug": "car-sale-business-tycoon-game",
    "title": "Car Sale Business Tycoon Game",
    "description": "Get ready for an exciting career as a Used Car Dealer, work as an auto Sales showroom manager and run a used cars dealer business simulator in the used car dealer simulator Dealership tycoon game. Start a new &amp; used cars trade showroom business and become a real car Trade tycoon in Used car Trade Dealer job simulator business game. Buy new and used cars, place them in the Cars for Trades showroom to sell and earn money in car dealer job simulator business game. Grow your used cars trade business game and sell sedan, sports car, super car in car tycoon game.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "bus",
      "Business",
      "Car",
      "city",
      "monstertruck",
      "offroad",
      "Shopping",
      "Simulation",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/sx7gnh62y8r1pa9fj0aedbvykl70jq4h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sx7gnh62y8r1pa9fj0aedbvykl70jq4h/",
    "sourceUrl": "https://html5.gamemonetize.com/sx7gnh62y8r1pa9fj0aedbvykl70jq4h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72011",
    "slug": "matrix-typer",
    "title": "Matrix Typer",
    "description": "Matrix Typer is a fast-paced typing challenge where every word is a battle against time. Type falling codes before they hit the system core &mdash; each correct word boosts your score and accuracy! Unlock new stages, improve your typing speed, and master real keyboard skills through progressive levels that double as a full typing course. Perfect for players who love The Matrix vibe, coding, or simply want to type faster while having fun.",
    "instructions": "On desktop type the falling words using your physical keyboard before they reach the bottom of the screen Keep your rhythm steady to increase speed and accuracy On mobile devices use the on-screen keyboard to type the words in the same way Precision",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Skill",
      "Skills",
      "Typing"
    ],
    "thumbnail": "https://img.gamemonetize.com/vh95ff6wevnozek14953yrill4xufv7c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vh95ff6wevnozek14953yrill4xufv7c/",
    "sourceUrl": "https://html5.gamemonetize.com/vh95ff6wevnozek14953yrill4xufv7c/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72185",
    "slug": "monster-evolution-demon-dna",
    "title": "Monster Evolution Demon DNA",
    "description": "The monster that controls your fusion process must eventually defeat the final boss of the computer fusion after going through a series of obstacles.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Action",
      "Fighting",
      "running",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/h96ivkknuf9cyfdh6d2nzn64d2rfxl82/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h96ivkknuf9cyfdh6d2nzn64d2rfxl82/",
    "sourceUrl": "https://html5.gamemonetize.com/h96ivkknuf9cyfdh6d2nzn64d2rfxl82/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71960",
    "slug": "galaxy-space-defender",
    "title": "Galaxy Space Defender",
    "description": "Galaxy Space Defender is an action-packed space shooter where you battle waves of enemy ships and powerful bosses. Dodge super-bombs, unleash precision shots, and survive through six intense levels. With fast-paced gameplay, explosive effects, and polished visuals, this HTML5 arcade shooter delivers nonstop excitement and skill-based challenges for fans of browser shooting games. Web Dev",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Alien",
      "battleship",
      "Classic",
      "Shooting",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/977j05ebiq1xk4l6yu9xppn7r2ma0pn2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/977j05ebiq1xk4l6yu9xppn7r2ma0pn2/",
    "sourceUrl": "https://html5.gamemonetize.com/977j05ebiq1xk4l6yu9xppn7r2ma0pn2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71865",
    "slug": "brainrotio",
    "title": "BrainrotIO",
    "description": "Welcome to the world where crocodiles turn into airplanes, cows live on Saturn, and cappuccinos dance on stage in ballet tutus. Play as the strangest creatures born from Italian brainrot: Bombardiro Crocodilo Tralalero Tralala Lirili Larila Bobritto Bandito Cappuccino Assassino La Vaca Saturno Saturnita Ballerina Cappuccina Boneca Ambalabu Burbaloni Lulioli Chimpanzini Bananini Every new form is a surprise, a meme, and pure absurdity that makes the game even more fun!",
    "instructions": "Control your snake-plane and collect glossy dots Grow longer cut off opponents and grab their loot Climb the leaderboard and unlock all Italian brainrot skins Enjoy chaos memes and absurd humor",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2025 games",
      "2D",
      "Action",
      "attack",
      "Brainrot",
      "Brainrot Italian"
    ],
    "thumbnail": "https://img.gamemonetize.com/8n1q0ns6lcaebps64s94ash2twh5ehj0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8n1q0ns6lcaebps64s94ash2twh5ehj0/",
    "sourceUrl": "https://html5.gamemonetize.com/8n1q0ns6lcaebps64s94ash2twh5ehj0/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71862",
    "slug": "farmer-squid-game-challenge",
    "title": "Farmer Squid Game Challenge",
    "description": "Your objective is to reach the finish line first. When the traffic lights turn red stop immediately, as the scarecrow will turn around to check for movement. If it sees you move, you&rsquo;re out. While it is watching, keep the slider centered to avoid releasing exhaust smoke, or the scarecrow will spot that too.",
    "instructions": "Arrow keys to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Driving",
      "Escape",
      "Hypercasual",
      "Kids",
      "Racing",
      "Skill",
      "squidgame",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/ibnu8g1u4sv34e7bl8k7sw5snxdhlo6b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ibnu8g1u4sv34e7bl8k7sw5snxdhlo6b/",
    "sourceUrl": "https://html5.gamemonetize.com/ibnu8g1u4sv34e7bl8k7sw5snxdhlo6b/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "72125",
    "slug": "draw-action-freestyle-fight",
    "title": "Draw Action: Freestyle Fight",
    "description": "The arcade battle begins! Just swipe your finger to formulate action battles, Break the old remote sensing operation and experience the novel pick-up operation!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Adventure",
      "attack",
      "Fighting",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/aa9yvwznsns56myjncgle5j1xj09dk63/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aa9yvwznsns56myjncgle5j1xj09dk63/",
    "sourceUrl": "https://html5.gamemonetize.com/aa9yvwznsns56myjncgle5j1xj09dk63/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72091",
    "slug": "city-drift-car-racing-game",
    "title": "City Drift Car Racing Game",
    "description": "Welcome to the world of car drift and driving games. Get ready to ignite your engines, push the pedal to the metal, and drift like a pro in the most thrilling car drift and driving game ever. This is not just a driving simulator game, its an adrenaline-pumping, tire-squealing, smoke-flying experience that takes your car control skills to the next level. Whether you are into precision driving, freestyle drifting, or open world cruising, this game has something for every car enthusiast.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "building",
      "Car",
      "Cars",
      "city",
      "drift",
      "Driving",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/dps8kt2nqvkpkax8fptdzdqhk8sbp5w5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dps8kt2nqvkpkax8fptdzdqhk8sbp5w5/",
    "sourceUrl": "https://html5.gamemonetize.com/dps8kt2nqvkpkax8fptdzdqhk8sbp5w5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72070",
    "slug": "city-tuk-tuk-rickshaw-game",
    "title": "City Tuk Tuk Rickshaw Game",
    "description": "Welcome to the world of the city tuk tuk rickshaw game. Get ready to drive your favorite auto rickshaw in tuk tuk rickshaw driving game, the ultimate rickshaw driving game featuring thrilling pick and drop missions in a beautifully designed open city environment. Choose from 10 unique tuk tuk rickshaws, each with realistic controls and detailed interiors. From city auto rickshaw rides to thrilling tuk tuk games challenges, this sim brings you endless fun with smooth gameplay and detailed 3D graphics. The environments in our tuk tuk simulator game are visually stunning, providing an immersive experience for gamers.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Bike",
      "city",
      "Driving",
      "Motorcycle",
      "Parking",
      "TukTuk"
    ],
    "thumbnail": "https://img.gamemonetize.com/ui2zk9hek22lbsb9nxix534lboex2hx9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ui2zk9hek22lbsb9nxix534lboex2hx9/",
    "sourceUrl": "https://html5.gamemonetize.com/ui2zk9hek22lbsb9nxix534lboex2hx9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72137",
    "slug": "monster-truck-stunt-game",
    "title": "Monster Truck Stunt Game",
    "description": "Welcome to the world of monster track stunt games. Get ready for thrilling monster truck stunts in one of the most exciting truck games! Drive powerful monster truck racing vehicles, perform insane stunt jumps, and conquer mega ramps in this action-packed car game experience. Master racing car game challenges, speed through impossible tracks, and prove your skills in monster truck stunts! Take control of a powerful stunt truck and experience truck stunt racing like never before! Compete in monster truck stunts, execute high-speed stunt jumps, and master the most extreme stunt tracks.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adventure",
      "Car",
      "Monster",
      "monstertruck",
      "Race",
      "Racing",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/xifh6y7i516derrhvzs04nr3vh9sxlk1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xifh6y7i516derrhvzs04nr3vh9sxlk1/",
    "sourceUrl": "https://html5.gamemonetize.com/xifh6y7i516derrhvzs04nr3vh9sxlk1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71506",
    "slug": "solitaire-freecell-frenzy",
    "title": "Solitaire Freecell Frenzy",
    "description": "Freecell Frenzy every round gets trickier! Move all cards to the four foundations from Ace to King in matching suits. Build tableau piles in alternating colors and use Free Cells wisely to plan your moves. Think ahead, stay sharp, and clear the board!",
    "instructions": "Mouse click or tap to play",
    "category": "",
    "genres": [],
    "tags": [
      "Best Games",
      "Card",
      "Casual",
      "Classic",
      "Puzzle",
      "Solitaire",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/bxjrx65nfwczhzrm6t6cl9bl7xic4ufe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bxjrx65nfwczhzrm6t6cl9bl7xic4ufe/",
    "sourceUrl": "https://html5.gamemonetize.com/bxjrx65nfwczhzrm6t6cl9bl7xic4ufe/",
    "width": 940,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71581",
    "slug": "soccer-guantone",
    "title": "Soccer Guantone",
    "description": "Take on Guantone the sassy goalkeeper and the Hungry Giant in this funny, fast-paced soccer adventure! Score penalties, avoid blocks, collect diamonds, and reach 12 goals to win the cup, +7000 points, and an epic celebration with balloons and donuts! A happy, silly, and thrilling game for kids, teens, and anyone who loves big laughs and crazy soccer fun!",
    "instructions": "Stop the aiming reticle in time to shoot click your favorite balls and watch out for Guantone and the Hungry Giant New soccer balls and surprises coming soon mdash more fun with every update",
    "category": "Soccer",
    "genres": [
      "Soccer"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Baby Games",
      "Football",
      "Funny",
      "Soccer",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/77q8zyf5m7jg48wn59hrij59tdr8l2ak/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/77q8zyf5m7jg48wn59hrij59tdr8l2ak/",
    "sourceUrl": "https://html5.gamemonetize.com/77q8zyf5m7jg48wn59hrij59tdr8l2ak/",
    "width": 960,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71843",
    "slug": "get-on-board",
    "title": "Get On Board",
    "description": "How will you face the rush hour during commuting? Please try this casual and stress-relieving crowd-crushing game! Just tap the screen to play. See if you can get off before getting off.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "bus",
      "Click",
      "Hypercasual",
      "Mobile",
      "Physics",
      "Timing",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/p4zntfeujzj7emy0je63mzdnxauudk85/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p4zntfeujzj7emy0je63mzdnxauudk85/",
    "sourceUrl": "https://html5.gamemonetize.com/p4zntfeujzj7emy0je63mzdnxauudk85/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72076",
    "slug": "hidden-horrors",
    "title": "Hidden Horrors",
    "description": "Ready to explore the haunted Halloween world? Play a hidden object game with 30 Halloween levels. Each level has 6 hidden objects. Find all objects before time runs out. If you need help, use a hint. The game is easy to play. Enjoy colorful Halloween scenes and fun gameplay.",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Halloween",
      "Hidden",
      "Horror",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/ccsrinkotsp5bbwxhq11cwarh3fr15zn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ccsrinkotsp5bbwxhq11cwarh3fr15zn/",
    "sourceUrl": "https://html5.gamemonetize.com/ccsrinkotsp5bbwxhq11cwarh3fr15zn/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "72004",
    "slug": "bootiful-princess-match",
    "title": "Bootiful Princess Match",
    "description": "Welcome to an exciting puzzle-game, created in a Halloween atmosphere. There are three princesses in the game and each one is ready for her own eerily beautiful transformation. The player will have to look for paired cards to discover new elements of the girls future image. Each successful match brings you closer to creating a unique costume, makeup or hairstyle. Only the most attentive players will be able to make their princesses truly scary-beautiful!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used for control",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Dress Up",
      "Halloween",
      "Matching",
      "Princess",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/h8m0o4t56kwp34jbp6m3wek0ek0e4spx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h8m0o4t56kwp34jbp6m3wek0ek0e4spx/",
    "sourceUrl": "https://html5.gamemonetize.com/h8m0o4t56kwp34jbp6m3wek0ek0e4spx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71580",
    "slug": "neon-collider",
    "title": "Neon Collider",
    "description": "Neon Collider brings the legendary brick breaker gameplay into a stunning futuristic universe of light and energy. Test your skill across 100 levels of increasing difficulty, featuring dazzling neon colors, pulsing synthwave music, and explosive visual effects. Use your paddle to bounce the energy ball, destroy every glowing brick, and collect power-ups that change the course of the game &mdash; from multiball and slow motion to the ultimate Fire Mode, where you can shoot and obliterate blocks with pure plasma energy! Progress through levels one by one, unlock new stages, and resume your game anytime thanks to automatic save.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Arkanoid",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/4qlzvoyo94nx261mosc65dif1zzearma/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4qlzvoyo94nx261mosc65dif1zzearma/",
    "sourceUrl": "https://html5.gamemonetize.com/4qlzvoyo94nx261mosc65dif1zzearma/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71702",
    "slug": "chainsaw-man-anime",
    "title": "Chainsaw Man Anime",
    "description": "Chainsaw Man Game is a new amazing chainsaw man anime game,and free online anime game ,in this epic anime action game you can battle through amazing funny levels filled with zombies,demons,bosses and devils, use your chainsaw man attacks to kill and slash like devil hunters and demon slayer,experience the best anime game,perfect for anime fans and action lovers, chainsaw man anime game gives you pure action adventure experience and demon slayer vibes,play as denji and slice zombies,devils and demons in this anime game,master your chainsaw powers to explore multiple stages inspired by the anime show,filled with blood,zombies,and high quality.",
    "instructions": "Mouse click or tap to play Chainsaw Man Game is made for Pc and mobile devices that you can play it online on the website for free Use your mouse or your finger to aim with your chainsaw man and attack to slice enemies with your chainsaw powers",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Action",
      "Adult",
      "Adventure",
      "amazing",
      "Anime",
      "assassin",
      "Best Games",
      "Blood",
      "Funny",
      "Game",
      "New",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/o4cf0t4hmkcie0z64vjk5oevjgnlg8gu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o4cf0t4hmkcie0z64vjk5oevjgnlg8gu/",
    "sourceUrl": "https://html5.gamemonetize.com/o4cf0t4hmkcie0z64vjk5oevjgnlg8gu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "72020",
    "slug": "bike-stunt-racing-game",
    "title": "Bike Stunt Racing Game",
    "description": "Welcome to the world of bike stunt games. Get ready to experience the most thrilling and extreme motorcycle stunt game. Enter the world of daring flips, impossible tracks, and heart-pounding challenges. Whether you are a casual gamer or a die-hard stunt rider, this bike stunt game is designed to keep you hooked for hours. Unlock new bikes, improve your skills, and push the limits of what&rsquo;s possible. Experience the thrill of flying through the air, the satisfaction of perfect landings, and the excitement of conquering impossible tracks in a stunt game. Whether you want to race down the mega ramps.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "Bike",
      "Race",
      "Racing",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/eublyenenukaheclo59umogqhsdxig3c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eublyenenukaheclo59umogqhsdxig3c/",
    "sourceUrl": "https://html5.gamemonetize.com/eublyenenukaheclo59umogqhsdxig3c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71989",
    "slug": "balloon-shooter-archery-game",
    "title": "Balloon Shooter Archery Game",
    "description": "Welcome to the ultimate balloon shooting adventure game. Get ready to test your aiming skills, precision, and speed in this fun-filled balloon shooter game. A perfect blend of classic arcade fun and modern shooting mechanics, this balloon game offers an immersive experience for players of all ages. Your goal is simply to use your bow and arrows to pop as many balloons as possible and complete increasingly challenging levels. But beware each level comes with new twists, obstacles, and surprises that will test your reflexes and strategy in a shooting game. Pick up your virtual bow, aim carefully, and shoot arrows at floating balloons.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Ballon",
      "Casual",
      "Hypercasual",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/6o99ls7p9ahkt48lim2fm5gpcb6s6p6r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6o99ls7p9ahkt48lim2fm5gpcb6s6p6r/",
    "sourceUrl": "https://html5.gamemonetize.com/6o99ls7p9ahkt48lim2fm5gpcb6s6p6r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71281",
    "slug": "car-parking-simulator-offline",
    "title": "Car Parking Simulator Offline",
    "description": "Modern Car Parking 3D Game and School Driving Simulator is the latest parking jam 3D simulation game and totally genuine real car parking jam game of 2025. Start with simple parking jam 3D scenarios and work your way up to complex, mind-bending challenges of Modern car parking 3D games. As you progress through traffic jam 3D, youll need to navigate tight spaces in car games 3D, avoid obstacles in the car driving parking master, and even park in adverse weather conditions.",
    "instructions": "Mobile controls available and for keyboard W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D Games",
      "carparking",
      "Cars"
    ],
    "thumbnail": "https://img.gamemonetize.com/t8r807bi7xvmtfkxcua1nvqbk12mfm2g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t8r807bi7xvmtfkxcua1nvqbk12mfm2g/",
    "sourceUrl": "https://html5.gamemonetize.com/t8r807bi7xvmtfkxcua1nvqbk12mfm2g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71356",
    "slug": "image-block-puzzle",
    "title": "Image Block Puzzle",
    "description": "Image Box is an engaging and challenging puzzle game designed to test your spatial awareness and problem-solving skills. The game divides a complete image into a grid, which can be 2x2, 3x3, 4x4, or 5x5 blocks. Each block can be clicked to rotate it 90 degrees counterclockwise. The players goal is to rotate the blocks in such a way that the original image is reconstructed. Image Box is perfect for puzzle enthusiasts looking for a fun and mentally stimulating game. Whether you prefer a solo challenge or competitive play, this game offers something for everyone.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Best Games",
      "Brain",
      "Mind",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/ajg4fahtaw667pg8mwpp26j719v0f4tl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ajg4fahtaw667pg8mwpp26j719v0f4tl/",
    "sourceUrl": "https://html5.gamemonetize.com/ajg4fahtaw667pg8mwpp26j719v0f4tl/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71986",
    "slug": "halloween-tom-math-challenge",
    "title": "Halloween Tom Math Challenge",
    "description": "Halloween Tom Math Challenge is a super fun and completely free math game that lets you test your quick-thinking and basic math skills in a spooky Halloween world! Solve simple math problems and help Tom through thrilling Halloween-themed challenges. Perfect for kids and adults who love brain games with a festive twist &mdash; learn, play, and enjoy the Halloween fun while sharpening your math skills!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boys",
      "Brain",
      "Educational",
      "Girls",
      "Hypercasual",
      "Kids",
      "Logic",
      "Math",
      "School",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/uzus656bcagyrurdzhdsc5pfwq8lfwji/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uzus656bcagyrurdzhdsc5pfwq8lfwji/",
    "sourceUrl": "https://html5.gamemonetize.com/uzus656bcagyrurdzhdsc5pfwq8lfwji/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "72031",
    "slug": "counter-craft-sniper",
    "title": "Counter Craft Sniper",
    "description": "Counter Craft Sniper is a first-person shooter where you step into the boots of an elite sniper sent to protect a city invaded by Minecraft mobs. Creepers, skeletons, and zombies have appeared in the middle of downtown, and only your precision and quick reflexes can stop them before the chaos spreads. Armed with your trusty sniper rifle, you must take position on rooftops and high vantage points to eliminate every hostile target that threatens the civilians below.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "First Person Shooter",
      "Minecraft",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Sniper",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/xrwzvqdm8dhzzqpc97crxfgabb2i6bvd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xrwzvqdm8dhzzqpc97crxfgabb2i6bvd/",
    "sourceUrl": "https://html5.gamemonetize.com/xrwzvqdm8dhzzqpc97crxfgabb2i6bvd/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71916",
    "slug": "maths-quiz-with-negative-numbers",
    "title": "Maths Quiz with Negative Numbers",
    "description": "Sharpen your mind with the challenge of adding and subtracting positive and negative numbers! This fast-paced knockout-style maths quiz is designed for students of Standards 5&ndash;8 to strengthen their understanding of integers and sign rules. You&rsquo;ll face 100 randomly generated questions involving numbers between &minus;100 and +100. Each question must be solved within a 12-second timer &mdash; get one wrong, and the game ends! Keep playing to beat your best score and build longer streaks of correct answers. With its dynamic interface and instant feedback, this game helps learners master tricky negative-number operations through speed and accuracy.",
    "instructions": "Choose the CORRECT choice",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Educational",
      "Math",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/qomy2w6xc1qiu1fr9lq4lt5hd3nwue6l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qomy2w6xc1qiu1fr9lq4lt5hd3nwue6l/",
    "sourceUrl": "https://html5.gamemonetize.com/qomy2w6xc1qiu1fr9lq4lt5hd3nwue6l/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71746",
    "slug": "sand-blast",
    "title": "Sand Blast",
    "description": "Ready to blast some blocks? Welcome to Sand Blast, a super addictive puzzle game. It combines classic Tetris strategy with satisfying block blast fun! In this game, your goal is to move, stack, and match different-shaped blocks to create perfect lines or patterns.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Classic",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/ehpcosrryb6e0q9lbqfbp84npyj3eiup/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ehpcosrryb6e0q9lbqfbp84npyj3eiup/",
    "sourceUrl": "https://html5.gamemonetize.com/ehpcosrryb6e0q9lbqfbp84npyj3eiup/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71762",
    "slug": "blow-king",
    "title": "Blow King",
    "description": "Disease enters through the mouth, so blow hard! There are different delicious foods in each level, but here, remember not to eat them.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Clicker",
      "Funny",
      "Physics",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/9fmzaqn02wmdbvc4vmy8nfbkufkly271/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9fmzaqn02wmdbvc4vmy8nfbkufkly271/",
    "sourceUrl": "https://html5.gamemonetize.com/9fmzaqn02wmdbvc4vmy8nfbkufkly271/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "72023",
    "slug": "car-stunt-racing-3d",
    "title": "Car Stunt Racing 3D",
    "description": "Car Stunt Racing is an exhilarating racing game where speed and skill collide! Take control of powerful race cars and zoom through exciting tracks. Use Nitro boosts to accelerate past your opponents and make sharp drifts around corners to maintain your lead. Avoid obstacles, hit turbo boosts, and stay ahead in this high-speed adventure. With smooth controls and thrilling challenges, Car Stunt Racing promises an adrenaline-packed ride!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Car",
      "Driving",
      "Mobile",
      "Racing",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/w624cstu4ev9qnmuatvjk46l7sbr3ah8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w624cstu4ev9qnmuatvjk46l7sbr3ah8/",
    "sourceUrl": "https://html5.gamemonetize.com/w624cstu4ev9qnmuatvjk46l7sbr3ah8/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "71818",
    "slug": "army-truck-driving-game",
    "title": "Army Truck Driving Game",
    "description": "The new offline games for boys. If youre looking for a top truck simulator army games. Then these are the best army truck driving simulator games. enjoy playing new games. the new game 2021 offline for boys. Drive your free army transport in these military truck games. Driving in the snow will be challenging in our new military truck driving game, which is top army racing game. New Truck simulator in the army is best truck Driving games offline. Play the new truck driving offline games. As an army truck driver in mission games, you have to be very careful as roads are very dangerous to drive but that&rsquo;s what the Army Truck Simulator 2024 game",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Action",
      "Adventure",
      "Car",
      "Simulation",
      "Simulator",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/w73g33vh2xbip5he0p67smokz0m79ewr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w73g33vh2xbip5he0p67smokz0m79ewr/",
    "sourceUrl": "https://html5.gamemonetize.com/w73g33vh2xbip5he0p67smokz0m79ewr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71816",
    "slug": "toco-teens-halloween-party",
    "title": "Toco Teens Halloween Party",
    "description": "Step into the spooky fun world of Toca Teens Halloween Party, a fashionable Halloween dress-up game made just for style lovers! Join the Toca teens as they get ready for the most glamorous Halloween event of the year. Choose from eerie yet elegant outfits, haunting accessories, and bold makeup looks to create the perfect spooky-chic style.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/vejh53g610bzc6g3lho5qm3bpr9yyks2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vejh53g610bzc6g3lho5qm3bpr9yyks2/",
    "sourceUrl": "https://html5.gamemonetize.com/vejh53g610bzc6g3lho5qm3bpr9yyks2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71808",
    "slug": "human-playground",
    "title": "Human Playground",
    "description": "Welcome to Human Playground: Battle Arena! Carefully control your character to strike the right spots on your opponent&rsquo;s body. Attack strategically to destroy and crush your enemies. Earn gold coins to unlock new characters and upgrade your skills. Have fun and dominate the arena!",
    "instructions": "Mouse click or tap to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Battle",
      "Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/amcyo8ti91cj87bxrfdzz82n9b10s9e1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/amcyo8ti91cj87bxrfdzz82n9b10s9e1/",
    "sourceUrl": "https://html5.gamemonetize.com/amcyo8ti91cj87bxrfdzz82n9b10s9e1/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69425",
    "slug": "image-crossword",
    "title": "Image Crossword",
    "description": "Welcome to Image Crossword, an innovative word puzzle game that transcends traditional boundaries! Here, images dont just sit inside a grid &ndash; they transform into letters, creating a dynamic and unique gameplay experience that combines visual cues with word formation. Innovative Gameplay: Get ready for a twist on classic word games! In Image Crossword, each level presents you with a series of images. Watch in amazement as these images turn into letters, challenging you to decipher and spell out the correct words.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Football",
      "jungle",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ryhsbpr53d7igq2z2383dcnok3fmw4g2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ryhsbpr53d7igq2z2383dcnok3fmw4g2/",
    "sourceUrl": "https://html5.gamemonetize.com/ryhsbpr53d7igq2z2383dcnok3fmw4g2/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71760",
    "slug": "amaze-mission",
    "title": "Amaze Mission",
    "description": "Enter the world of Block Blast, a fun and free block puzzle game where every move challenges your brain and strategy, rewarding you with satisfying crush effects as you blast cubes away. Whether youre seeking offline relaxation or looking to enhance your logic skills, Block Blast delivers an engaging puzzle experience. Why Youll Love Block Blast Vibrant Puzzle Adventure: Match colorful blocks on an 8x8 board, solve logic puzzles, and watch the cubes crush in a cascade of color. Strategic Combos &amp; Streaks: Use your brain to clear multiple lines of blocks in one move for powerful combos.",
    "instructions": "How to Play Drag amp Match Strategically place cubes on the 8x8 board Crush amp Score Complete rows or columns to crush blocks away and earn points Chase Combos Plan your moves and trigger massive combos for bonus points Stay Strategic App",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Block",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/9ptuxedz7qew9dmuhxhzzvmsmtv8mvce/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9ptuxedz7qew9dmuhxhzzvmsmtv8mvce/",
    "sourceUrl": "https://html5.gamemonetize.com/9ptuxedz7qew9dmuhxhzzvmsmtv8mvce/",
    "width": 600,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "71236",
    "slug": "corners-classic",
    "title": "Corners Classic",
    "description": "In our corner version, you can improve your analytical skills and strategic thinking while immersing yourself in an atmosphere of calm and coziness. - Computer Play: Battle a virtual opponent whose difficulty ranges from beginner to master. Upgrade your skills and take on new challenges. - Play with a friend: Have fun playing on the same board with a loved one. See who can handle the pieces better!",
    "instructions": "Win Draw Conditions 1 Win by moving all your pieces into the opponent rsquo s house 2 If both players fill the opponent rsquo s house simultaneously rarr draw 3 All pieces must leave your own house within 40 moves 80 total moves 4 After",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2D",
      "Adult",
      "Board",
      "Brain",
      "Casual",
      "Classic",
      "Logic",
      "Logical",
      "Multiplayer",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/18zg842v7hffexi6olfcc1b9aeiumz7w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/18zg842v7hffexi6olfcc1b9aeiumz7w/",
    "sourceUrl": "https://html5.gamemonetize.com/18zg842v7hffexi6olfcc1b9aeiumz7w/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71970",
    "slug": "halloween-sprunki-coloring-book",
    "title": "Halloween Sprunki Coloring Book",
    "description": "Welcome to the game Halloween Sprunki Coloring Book where you will find 12 different pictures to color. They need to be colored and for this you are provided with a set of fifteen felt-tip pens of different bright colors. On the left you will see a set of circles of different diameters. You can also save the colored image. Have fun playing this Sprunki coloring book game!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Color",
      "Coloring",
      "Fun",
      "Halloween",
      "Kids",
      "Mobile",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/cj8gu49uvklchegop2hoo07a5i8eu2ox/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cj8gu49uvklchegop2hoo07a5i8eu2ox/",
    "sourceUrl": "https://html5.gamemonetize.com/cj8gu49uvklchegop2hoo07a5i8eu2ox/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71887",
    "slug": "crazy-kick-ball",
    "title": "Crazy Kick Ball",
    "description": "Dribble the ball past defenders, fake the keeper, and shoot! Dodge tackles, find the gap, and score to beat your high score.There are also many skins to choose from in the game. Come on, football boy.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "3D",
      "Football",
      "Shoot",
      "Soccer",
      "Sports",
      "Timing"
    ],
    "thumbnail": "https://img.gamemonetize.com/b31uzigageic19gw6a7ihijn4p1ni0ro/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b31uzigageic19gw6a7ihijn4p1ni0ro/",
    "sourceUrl": "https://html5.gamemonetize.com/b31uzigageic19gw6a7ihijn4p1ni0ro/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71958",
    "slug": "robots-battle-mech-arena",
    "title": "Robots Battle Mech Arena",
    "description": "Begin an electrifying robot showdown in Robots Battle: Mech Arena. You will enter the ultimate mech battle arena. Control your massive robots in epic action and fighting combat. Unleash your skills and chain combos. Defeat your enemies to claim victory. Upgrade your heros damage or health.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arena",
      "Battle",
      "Fight",
      "Robot"
    ],
    "thumbnail": "https://img.gamemonetize.com/jndn1zi3hz7zn3yasxe4x67en90yabaq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jndn1zi3hz7zn3yasxe4x67en90yabaq/",
    "sourceUrl": "https://html5.gamemonetize.com/jndn1zi3hz7zn3yasxe4x67en90yabaq/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71955",
    "slug": "car-and-truck-parking-game",
    "title": "Car And Truck Parking Game",
    "description": "Welcome to the world of car and truck parking games. Get ready to experience the best of both worlds with a car and truck parking game. Realistic and addictive parking simulator where you can test your skills driving both cars and massive trucks. This game brings you a full driving experience in one powerful package. Precision, patience, and control are the keys to success. Park your vehicle perfectly, avoid obstacles, and complete dozens of increasingly difficult levels.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Car",
      "carparking",
      "Parking",
      "Simulation",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/wv3tyswsags63174ax129hbnfow1afcn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wv3tyswsags63174ax129hbnfow1afcn/",
    "sourceUrl": "https://html5.gamemonetize.com/wv3tyswsags63174ax129hbnfow1afcn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71927",
    "slug": "deer-hunting-jungle-game",
    "title": "Deer Hunting Jungle Game",
    "description": "Welcome to the world of animal hunting game. Step into the wild and experience the ultimate thrill of the hunt with animals hunting game. The most realistic, immersive, and exhilarating hunting simulation game. Realistic environments teeming with wildlife, sharpen your sniping skills, and prove yourself as the ultimate hunter. Whether you are a seasoned sharpshooter or eager to explore the animal. This game offers an unforgettable journey into the heart of nature. Get ready to embark on an unforgettable expedition through lush green forests and dense tropical jungles.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Fighting",
      "jungle",
      "Kill",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/k55zpjvcyx539ujjoeg1cb9paxzesmjj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k55zpjvcyx539ujjoeg1cb9paxzesmjj/",
    "sourceUrl": "https://html5.gamemonetize.com/k55zpjvcyx539ujjoeg1cb9paxzesmjj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71864",
    "slug": "brainrot-attack",
    "title": "Brainrot Attack!",
    "description": "Welcome to a world where crocodiles don&rsquo;t swim &mdash; they fly and shoot! You control a brainrot crocodile plane soaring through waves of enemies, power-ups, and pure chaos. The longer you survive, the more points, madness, and laughter you get. It&rsquo;s not just a shooter &mdash; it&rsquo;s a real test of reflexes, focus, and meme energy!",
    "instructions": "Control your crocodile plane mdash dodge bullets and destroy enemies Collect boosters to become even more chaotic Unlock new crocodile forms and skins Fight bosses and prove your brainrot is the strongest Share your scores and laugh at the mad",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Air",
      "airplane",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/4jweir1ls0u5h2t0hawk3h8u7xhoxhai/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4jweir1ls0u5h2t0hawk3h8u7xhoxhai/",
    "sourceUrl": "https://html5.gamemonetize.com/4jweir1ls0u5h2t0hawk3h8u7xhoxhai/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71846",
    "slug": "dandys-world-marathon",
    "title": "Dandys World Marathon",
    "description": "You play as your favorite characters from the Dandys World and help them collect mysterious black droplets scattered across bizarre levels.",
    "instructions": "Tap on the screen to make the character jump or turn Collect all the droplets to complete the level Avoid obstacles mdash chasms do not slumber Discover new characters",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/iu0jsixmgos58tsr6g2s2lbee9mlexld/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iu0jsixmgos58tsr6g2s2lbee9mlexld/",
    "sourceUrl": "https://html5.gamemonetize.com/iu0jsixmgos58tsr6g2s2lbee9mlexld/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71892",
    "slug": "add-to-half",
    "title": "Add to Half",
    "description": "Sharpen your fraction skills in Add to Half, a fast-paced and brain-teasing math puzzle! In this game, your goal is simple&mdash;but tricky: find two fractions that add up to exactly one-half. Each round presents you with a mix of fraction tiles floating or flipping on the screen. Tap or click the correct pair before time runs out! As you progress, the fractions get more challenging &mdash; from simple ones like &frac14; and &frac14; to trickier combinations like and &sup1;&frasl;. Speed, accuracy, and quick thinking are your keys to climbing the leaderboard.",
    "instructions": "Add two that make 1 2",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math",
      "Puzzle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/5lfr5zmdckpfztyulsov3govcm25y3o1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5lfr5zmdckpfztyulsov3govcm25y3o1/",
    "sourceUrl": "https://html5.gamemonetize.com/5lfr5zmdckpfztyulsov3govcm25y3o1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71926",
    "slug": "plamber-differences",
    "title": "Plamber Differences",
    "description": "Plumber Differences is a super fun and engaging spot-the-differences game inspired by the classic Mario-style theme! Sharpen your eyes and test your observation skills as you explore colorful plumber-themed scenes filled with hidden details and tricky differences to uncover. Each level offers a fresh challenge with vibrant graphics, cheerful music, and nostalgic elements that bring the plumber world to life. Perfect for players of all ages, this game combines the charm of retro platformers with the fun of puzzle-solving. Can you find all the differences before time runs out? Jump in and start spotting!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Collecting",
      "Difference",
      "free html5 games for your website",
      "Fun",
      "Girls",
      "Hypercasual",
      "Mario",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/bjy8uk4u6dkhd0ad3m927zjfb9af1lz4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bjy8uk4u6dkhd0ad3m927zjfb9af1lz4/",
    "sourceUrl": "https://html5.gamemonetize.com/bjy8uk4u6dkhd0ad3m927zjfb9af1lz4/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "71959",
    "slug": "arcade-empire-tycoon",
    "title": "Arcade Empire Tycoon",
    "description": "Start with a tiny arcade and grow it into an empire&mdash;buy cabinets, place them smartly, hire staff, maintain machines, and set prices. Upgrade, research, and automate to boost profits and earn even while offline.",
    "instructions": "PCMouse click drag MobileTap drag",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "build",
      "Management",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/7ce5hyriesc246z20xfta8pmdgb98kix/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7ce5hyriesc246z20xfta8pmdgb98kix/",
    "sourceUrl": "https://html5.gamemonetize.com/7ce5hyriesc246z20xfta8pmdgb98kix/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71611",
    "slug": "hot-highway",
    "title": "Hot Highway",
    "description": "Hot Pursuit is a fast, physics-driven highway racer where you slice through dense traffic, hit top speed, and chase high scores. Unlock sleek rides, upgrade performance, and master multiple camera views as you weave through dynamic, laneswitching traffic. One mistake ends the run &mdash; how far can you go?",
    "instructions": "WASD Arrows to steer accelerate brake Space handbrake Left Shift nitro C change camera",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Action",
      "Avoid",
      "Car",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/1moz5frarmn80sl04hwa11nsegxkpq1d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1moz5frarmn80sl04hwa11nsegxkpq1d/",
    "sourceUrl": "https://html5.gamemonetize.com/1moz5frarmn80sl04hwa11nsegxkpq1d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71008",
    "slug": "car-parking-3d-pro",
    "title": "Car Parking 3D Pro",
    "description": "Enter the Car Parking 3D Pro. It&rsquo;s a realistic car driving simulator 3D experience. Here, youll challenge yourself with driving and parking various vehicles. There are three modes for you to choose from: Arrival, Parking and Truck. Prove your parking skills in tight parking lots. Move your vehicle through various obstacles until you reach your destination. Manage acceleration and braking carefully to avoid collisions, or you will fail.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "Parking",
      "Truck",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tqlffyqpv12974sy52dv2nf4dx5n1wvl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tqlffyqpv12974sy52dv2nf4dx5n1wvl/",
    "sourceUrl": "https://html5.gamemonetize.com/tqlffyqpv12974sy52dv2nf4dx5n1wvl/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "71603",
    "slug": "slime-farm",
    "title": "Slime Farm",
    "description": "Slime Farm! is a relaxing yet addictive game where you drive a suction truck to vacuum up unruly slimes and turn them into cash. Cruise smoothly through gooey fields, slurp with satisfying precision, sell your haul to upgrade your truck and expand your farm into a thriving slime empire.",
    "instructions": "Use WASD arrow keys drag the left mouse button to move around",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Casual",
      "Collecting",
      "Farm"
    ],
    "thumbnail": "https://img.gamemonetize.com/vewezuk2cd0nnr69m37fcl048alebpxo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vewezuk2cd0nnr69m37fcl048alebpxo/",
    "sourceUrl": "https://html5.gamemonetize.com/vewezuk2cd0nnr69m37fcl048alebpxo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71822",
    "slug": "super-football-fever",
    "title": "Super Football Fever",
    "description": "Fast mini matches&mdash;pass, shoot, tackle, and challenge friends in local duels! Are you ready for a hearty football game? Probably maybe maybe... no referee.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "3D",
      "Action",
      "Dragon",
      "Sport",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/zbh22a4mynyf1zv90semlnszn4f9zzmn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zbh22a4mynyf1zv90semlnszn4f9zzmn/",
    "sourceUrl": "https://html5.gamemonetize.com/zbh22a4mynyf1zv90semlnszn4f9zzmn/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71924",
    "slug": "city-police-car-chase-game",
    "title": "City Police Car Chase Game",
    "description": "Welcome to the world of police car simulator games. Get ready to patrol the streets in the ultimate police car driving simulator! Whether you love high-speed pursuits, precision parking, or exploring the city freely, this game has it all. Drive powerful cop cars, chase down criminals, complete missions, park with accuracy, and enjoy an open-world driving experience like never before in a police game. Become the city&rsquo;s top cop in this action-packed police car simulator game. Take command of high-speed police cars, chase down criminals, master expert parking challenges, and freely explore a detailed open-world environment.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "building",
      "Car",
      "Cars",
      "city",
      "Police",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/17efswqo5on8f1w1yy89u45rb9pe6r19/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/17efswqo5on8f1w1yy89u45rb9pe6r19/",
    "sourceUrl": "https://html5.gamemonetize.com/17efswqo5on8f1w1yy89u45rb9pe6r19/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71928",
    "slug": "battery-run-3d",
    "title": "Battery Run 3D",
    "description": "Dash as a tiny battery, avoid hazards, collect energy to charge up, and reach the finish to power the device! Fast lanes and quick reactions are the key.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Collection",
      "Mobile",
      "running",
      "slide",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/vm7x1g0ypqgni8vk1yrw4fwblzkn2pw0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vm7x1g0ypqgni8vk1yrw4fwblzkn2pw0/",
    "sourceUrl": "https://html5.gamemonetize.com/vm7x1g0ypqgni8vk1yrw4fwblzkn2pw0/",
    "width": 750,
    "height": 1670,
    "lastUpdated": ""
  },
  {
    "id": "71838",
    "slug": "tricky-square-roots",
    "title": "Tricky Square Roots",
    "description": "Tricky Square Roots is a fun and brain-teasing number puzzle game designed to sharpen your math skills while keeping things light, colorful, and engaging. Perfect for players of all ages, this game challenges your ability to connect, match, and identify square roots of numbers from 1 to 10 &mdash; all presented on bright, cheerful tiles!",
    "instructions": "Match-3 game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/pfns9ch4ual2rvdw15h0x4ff2a4l6bwp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pfns9ch4ual2rvdw15h0x4ff2a4l6bwp/",
    "sourceUrl": "https://html5.gamemonetize.com/pfns9ch4ual2rvdw15h0x4ff2a4l6bwp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71116",
    "slug": "sudoku-classic-minimalism",
    "title": "Sudoku: Classic Minimalism",
    "description": "Sudoku is a popular number puzzle where the goal is to fill a 9x9 grid with digits. Its a perfect game for training your mind, improving concentration, and logical thinking. Every successfully solved puzzle brings satisfaction and develops your intellect!",
    "instructions": "Goal Fill all empty cells with digits from 1 to 9 Rule 1 Each digit must appear only once in each row Rule 2 Each digit must appear only once in each column Rule 3 Each digit must appear only once in each small 3x3 square there are 9 such squares",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Android",
      "Brain",
      "Classic",
      "endless",
      "Logic",
      "Logical",
      "Mobile",
      "Number",
      "Puzzle",
      "Sudoku",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/rt0ktly03lmlerry8tt573c4elhsibo4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rt0ktly03lmlerry8tt573c4elhsibo4/",
    "sourceUrl": "https://html5.gamemonetize.com/rt0ktly03lmlerry8tt573c4elhsibo4/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71896",
    "slug": "metal-match",
    "title": "Metal Match",
    "description": "Get ready to spark your brain and test your chemistry smarts in Metal Match &mdash; the electrifying match-3 puzzle game built around the elements of the periodic table! In this shining challenge, each tile displays the atomic name of a metal &mdash; like Na, Mg, Al, Cu, Ge. Your mission: match three or more identical metal tiles to clear them from the board and earn points. Chain bigger combos to unleash explosive reactions and climb the leaderboard! As levels progress, the metals mix faster, and the board fills with tricky obstacles &mdash; but with sharp eyes and clever strategy, you can keep your reactions going strong.",
    "instructions": "Match-3 metals of same kind color",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Match 3",
      "Puzzle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/h7h95fnsc7xsr6nqzmt4455lh1kyzm8k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h7h95fnsc7xsr6nqzmt4455lh1kyzm8k/",
    "sourceUrl": "https://html5.gamemonetize.com/h7h95fnsc7xsr6nqzmt4455lh1kyzm8k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71285",
    "slug": "ghost-ninja",
    "title": "Ghost Ninja",
    "description": "Step into the arena and face relentless waves of ninja enemies in this fast-paced survival shooter. Move, dodge, and slash your way through massive hordes while collecting gems to unlock powerful upgrades. Each run is unique, with new weapons and abilities that stack into wild combos. How long can you survive against the endless swarm?",
    "instructions": "Mouse Click and drag to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Arena",
      "assasin",
      "Enemies",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/klqvf5wd7v7ws9ohrkgu3ups19anaj2h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/klqvf5wd7v7ws9ohrkgu3ups19anaj2h/",
    "sourceUrl": "https://html5.gamemonetize.com/klqvf5wd7v7ws9ohrkgu3ups19anaj2h/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70900",
    "slug": "dystopia-rpg",
    "title": "Dystopia RPG",
    "description": "Dystopia RPG is an 8 bit style fantasy RPG where You lost a duel to a governments shaman and ended up trapped and sealed in a Cell Phone application. Explore the Dungeons, Combat monsters, Collect and Trade Items, Glitch the game &amp; break free.",
    "instructions": "Mouse click to attack Up Down Left Right to move Space to Jump",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2D",
      "Action",
      "apocalypse",
      "blockchain",
      "Fighting",
      "quests",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/2s3jqh4cymu086cf9m1kmmm9cm52hdj2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2s3jqh4cymu086cf9m1kmmm9cm52hdj2/",
    "sourceUrl": "https://html5.gamemonetize.com/2s3jqh4cymu086cf9m1kmmm9cm52hdj2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71245",
    "slug": "obby-climb-and-jump",
    "title": "Obby: Climb and Jump",
    "description": "Ready to conquer the tallest towers? In this game its real! Climb higher and higher, using your wings to speed up! The higher you climb, the more coins you can collect! And with cute pets youll earn even more - theyll help you collect coins! Whats in store for you: - Powerful wings for super fast climbing - Funny pet partners - Giant towers and new peaks - Vivid graphics and fun gameplay Conquer the top and become a real champion!",
    "instructions": "On PC WASD - Move Mouse - Camera view Spacebar - Jump On mobile devices Using the game interface",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Arcade",
      "Baby",
      "Clicker",
      "Fighting",
      "fly",
      "jump",
      "Jumping",
      "Mobile",
      "Multiplayer",
      "roblox",
      "Simulation",
      "Simulator",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/05hbr88zoj9rydb7lol4z3x3hlsimg8f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/05hbr88zoj9rydb7lol4z3x3hlsimg8f/",
    "sourceUrl": "https://html5.gamemonetize.com/05hbr88zoj9rydb7lol4z3x3hlsimg8f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71766",
    "slug": "alphabet-survivor",
    "title": "Alphabet Survivor",
    "description": "Join the survival challenge in Blue Monster - Letter Impostor Survivor! In this multiplayer game, players compete to be the last one standing while avoiding impostors disguised as blue monsters. Can you identify the impostors and survive the game? Download now and put your skills to the test! Game Features: - Multiplayer gameplay with players from around the world - A variety of game modes to choose from - The ability to play as an impostor or as a survivor - Exciting and fast-paced gameplay - Regular updates with new features and improvements",
    "instructions": "How to Play - Join a game with other players - Avoid being eliminated by the impostors disguised as blue monsters - Identify and eliminate the impostors - A D W S to move -Mouse Left to hide or attack",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "Action",
      "Minecraft",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/jcgh7g265pgzzlb7e01uqo74kama4ggx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jcgh7g265pgzzlb7e01uqo74kama4ggx/",
    "sourceUrl": "https://html5.gamemonetize.com/jcgh7g265pgzzlb7e01uqo74kama4ggx/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71799",
    "slug": "merge-brainrot",
    "title": "Merge Brainrot",
    "description": "Merge Brainrot is a fast, snackable merge-puzzle where you fuse meme-soaked &ldquo;brainrot&rdquo; bits into higher tiers, rack up combos, and chase absurd score spikes. Quick rounds, juicy upgrades, and constant dopamine perfect for idle grinding between tabs or full-send leaderboard runs. Web Dev h<a href='https://www.poki.com.es/'>https://www.poki.com.es/</a> . Tap, merge, evolve, repeat.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Mentolatux",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/awoagqomglta3ln14o8y60e1trv7x7uf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/awoagqomglta3ln14o8y60e1trv7x7uf/",
    "sourceUrl": "https://html5.gamemonetize.com/awoagqomglta3ln14o8y60e1trv7x7uf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71836",
    "slug": "tricky-easy-squares",
    "title": "Tricky Easy Squares",
    "description": "Tricky Easy Squares is a fun, lighthearted number puzzle game that blends simplicity with a hint of strategy! Centered around the squares of numbers 1 to 5, this game is perfect for players who love quick math challenges, satisfying visuals, and smooth puzzle mechanics that keep your mind engaged.",
    "instructions": "Match 3 same types",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Match 3",
      "Math",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/peo29avw2x70o9bt193e4f3d3qv4hvo3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/peo29avw2x70o9bt193e4f3d3qv4hvo3/",
    "sourceUrl": "https://html5.gamemonetize.com/peo29avw2x70o9bt193e4f3d3qv4hvo3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71246",
    "slug": "iconic-halloween-costumes",
    "title": "Iconic Halloween Costumes",
    "description": "Get ready for a spooky and stylish adventure in Iconic Halloween Costumes! Help three BFFs pick out their perfect Halloween looks, from royal Glinda and Bridgerton-inspired outfits to edgy Beetlejuice vibes and cowgirl-chic styles. Customize their costumes with tops, bottoms, accessories, and makeup to create iconic Halloween outfits. Play now and let the fashion fun begin!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/ht9c3lellccpt62ijmdz8fzf28303gvh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ht9c3lellccpt62ijmdz8fzf28303gvh/",
    "sourceUrl": "https://html5.gamemonetize.com/ht9c3lellccpt62ijmdz8fzf28303gvh/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "71815",
    "slug": "black-pink-halloween-concert",
    "title": "Black Pink Halloween Concert",
    "description": "Step into the spooky spotlight with Black Pink Halloween Concert, a thrilling dress-up game where you style the K-Pop superstars for their haunted Halloween performance. Choose from a wide variety of creepy-cute costumes, bold hairstyles, and festive accessories to make the members shine on stage.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/wjn547giyn85dbo1igcj1jjeob74dk74/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wjn547giyn85dbo1igcj1jjeob74dk74/",
    "sourceUrl": "https://html5.gamemonetize.com/wjn547giyn85dbo1igcj1jjeob74dk74/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71789",
    "slug": "mega-car-stunt-game",
    "title": "Mega Car Stunt Game",
    "description": "Experience the most epic racing game ever by driving your way to the top of the Mega Ramp! Mega Ramp will keep you entertained for hours with its stunning graphics and amazing gameplay. Jump into the most realistic stunt driving game ever made! Test your skills to their limits as you jump from one ramp to the next. With stunning graphics and amazing physics, Mega Ramp is the most epic racing game ever! Some people are bored from Mega Ramp Car Stunt Master, GT Car Stunts 3D Master, Jet Car Stunts and Mega Ramp Car Stunt Races 3d. Mega Ramp Car Stunts Car Race, Car Stunts Offline: Car Games and Ramp Car Games: GT Car Stunts have no fun in it.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Adventure",
      "Car",
      "Cars",
      "Race",
      "Racing",
      "Slacking",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/79c9srzk80gmie8gpez35xcoxn5bta8i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/79c9srzk80gmie8gpez35xcoxn5bta8i/",
    "sourceUrl": "https://html5.gamemonetize.com/79c9srzk80gmie8gpez35xcoxn5bta8i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71783",
    "slug": "modern-bus-driving-game",
    "title": "Modern Bus Driving Game",
    "description": "Welcome to the world of bus simulator games. Get ready to experience the thrill of driving a real modern bus driving simulator game. Drive your bus on bustling city streets, hilly mountain roads, and off road terrain in this realistic and immersive bus simulator game. Drive a variety of modern buses, complete routes, and transport passengers safely to their destinations. Whether you&rsquo;re maneuvering through heavy traffic or cruising on scenic highways, every level delivers a unique and engaging driving experience.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Adventure",
      "Best Games",
      "bus",
      "Racing",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/lomadsoeaa1xnnazl1vti18dul0vo66e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lomadsoeaa1xnnazl1vti18dul0vo66e/",
    "sourceUrl": "https://html5.gamemonetize.com/lomadsoeaa1xnnazl1vti18dul0vo66e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70223",
    "slug": "geography-quiz-countries-flags-capitals",
    "title": "Geography Quiz countries flags capitals",
    "description": "We invite you to embark on an unforgettable adventure around the world with our unique geography quiz. Here you can demonstrate your knowledge of capitals, countries and flags, as well as broaden your horizons and learn a lot about different parts of the planet. A variety of tasks are waiting for you in our game: - guess the country by its flag - guess what the flag of the country is - determine the capital of the country - identify a country by its capital",
    "instructions": "For each question choose one of the possible answers that you think is correct For each correct answer you get one point and for the wrong answer you lose a life You will lose if the lives drop to zero Use boosters to replenish your life or get a h",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "amazing",
      "Brain",
      "Educational",
      "free html5 games for your website",
      "HTML",
      "Level",
      "Puzzle",
      "quest",
      "Quiz",
      "Relaxation",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/dx0y2yxpvm90wot9eac5jsogsg0hw24z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dx0y2yxpvm90wot9eac5jsogsg0hw24z/",
    "sourceUrl": "https://html5.gamemonetize.com/dx0y2yxpvm90wot9eac5jsogsg0hw24z/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71599",
    "slug": "space-traveler",
    "title": "Space Traveler",
    "description": "Run through space in this fun endless runner game! Avoid asteroids and other obstacles, and grab coins and magnet power-ups to unlock new balls. Finish missions to discover new planets. Play Space Traveler on your phone, tablet, or computer!",
    "instructions": "Swipe left or use the left arrow key to move the ball left Swipe right or use the right arrow key to move the ball right Swipe up or use the up arrow key to jump Swipe down or use the down arrow key to move the ball down",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io",
      ".io Games",
      "3D",
      "3D Games",
      "Action",
      "Arcade",
      "Ball",
      "Hypercasual",
      "Race",
      "Racing",
      "running",
      "Space",
      "Subway Surfers",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/q7gdldtfn1k0wgpaevwe26poeh9qbirt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q7gdldtfn1k0wgpaevwe26poeh9qbirt/",
    "sourceUrl": "https://html5.gamemonetize.com/q7gdldtfn1k0wgpaevwe26poeh9qbirt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71908",
    "slug": "primelink",
    "title": "PrimeLink",
    "description": "Enter the world of numbers and logic with PrimeLink &mdash; a brainy and addictive match-3+ puzzle game built entirely around prime numbers! Your goal is simple: link three or more of the same prime numbers in a chain to clear them from the board. The longer the chain, the higher your score &mdash; and the greater your combo bonus! But be quick and strategic &mdash; the board fills fast, and every move counts. With every level, the challenge grows: new primes appear, patterns get trickier, and your number skills are put to the ultimate test.",
    "instructions": "Match-3 of same kind make large chains",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Halloween",
      "Match-3",
      "Math"
    ],
    "thumbnail": "https://img.gamemonetize.com/8f6wmzv4d2cqp0siruzdvu6m3cihz3nu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8f6wmzv4d2cqp0siruzdvu6m3cihz3nu/",
    "sourceUrl": "https://html5.gamemonetize.com/8f6wmzv4d2cqp0siruzdvu6m3cihz3nu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71909",
    "slug": "chemical-flowtint",
    "title": "Chemical FlowTint",
    "description": "Dive into a world where color meets chemistry in FlowTint &mdash; a vibrant puzzle game that challenges both your logic and your learning! Your mission: fill the entire grid by choosing from a set of colors &mdash; but with a twist. Each color represents a chemical element, helping you learn while you play! Strategize each move carefully &mdash; you have only 22 moves to make the colors flow and cover the entire space. As you progress, the puzzles get trickier, colors multiply, and your mastery of both patterns and periodic elements grows stronger. It&rsquo;s a perfect blend of art, logic, and science &mdash; wrapped in one relaxing yet challenging experience.",
    "instructions": "Cover the field in 22 moves",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Math",
      "Puzzle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/461ggg9byuw1anbu9qpsdnbcsgkoz25q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/461ggg9byuw1anbu9qpsdnbcsgkoz25q/",
    "sourceUrl": "https://html5.gamemonetize.com/461ggg9byuw1anbu9qpsdnbcsgkoz25q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71759",
    "slug": "obby-fly-the-farthest-in-an-airplane",
    "title": "Obby: Fly the Farthest in an Airplane",
    "description": "Welcome to the world of Aviation Obby! Your goal is to fly as far as possible by buying new planes, unlocking unique aerial trails, and collecting energy! Get awesome planes, collect energy and pets that give you bonuses! Explore different locations, but remember &ndash; you need rebirth points to unlock new areas! Game Features: &bull; Control your plane and buy new models! &bull; Farm flight points to purchase new planes and aerial trails. &bull; Diverse aerial trails with unique effects. &bull; Rebirth system &ndash; unlock new locations and become stronger. &bull; Leaderboards and competitions &ndash; compete with other pilots and become the champion!",
    "instructions": "PC bull Movement ndash W A S D bull Jump ndash Spacebar Mobile Device bull Movement ndash Virtual joystick Enjoy Collect speed take flights and earn victories",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Air",
      "Aircraft",
      "airplane",
      "amazing",
      "Animal",
      "Anime",
      "Baby",
      "Brainrot",
      "Kid",
      "Kids",
      "roblox",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/ovdr2vq8pjxr02lszsp6vr4mgjm5b4yp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ovdr2vq8pjxr02lszsp6vr4mgjm5b4yp/",
    "sourceUrl": "https://html5.gamemonetize.com/ovdr2vq8pjxr02lszsp6vr4mgjm5b4yp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71765",
    "slug": "obby-training-on-the-train",
    "title": "Obby: Training on the Train",
    "description": "- Drive the train and unlock more and more powerful locomotives! - Collect track energy to unlock trains and build new routes. - Unique track &ldquo;tracks&rdquo; with visual effects - leave your style on the rails! - Rebirth system - unlock new railroad eras and become stronger. - Tournaments and leaderboards - become the fastest train driver in the world! Ready to start the engine and burst into adventure?",
    "instructions": "PC bull Movement ndash W A S D bull Jump ndash Spacebar Mobile Device bull Movement ndash Virtual joystick",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Anime",
      "Arcade",
      "Kid",
      "Kids",
      "Race",
      "Racing",
      "roblox",
      "Simulation",
      "Simulator",
      "Sport",
      "Strategy",
      "Train",
      "transport"
    ],
    "thumbnail": "https://img.gamemonetize.com/7utob7srpu4s5n0nfijxya0lykl5ewb7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7utob7srpu4s5n0nfijxya0lykl5ewb7/",
    "sourceUrl": "https://html5.gamemonetize.com/7utob7srpu4s5n0nfijxya0lykl5ewb7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71473",
    "slug": "hero-transform-run",
    "title": "Hero Transform Run",
    "description": "Superheroes accumulate energy by constantly upgrading themselves, and at the end of the level they must quickly defeat different enemies. This is a casual combat parkour game!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Battle",
      "running",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/4hwrr84zykoqg208ipum1s3yhzaixafz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4hwrr84zykoqg208ipum1s3yhzaixafz/",
    "sourceUrl": "https://html5.gamemonetize.com/4hwrr84zykoqg208ipum1s3yhzaixafz/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71770",
    "slug": "racing-bulldozer",
    "title": "Racing Bulldozer",
    "description": "Bulldozer Race GAME This is one of the most fascinating games! Can you drive a bulldozer? We are looking for craftsmen. This race is the best way we found. You have to collect gravel to make way and make your sandballs bigger than the other players. Earn the title of Bulldozer Master!",
    "instructions": "Joystick to move",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D Games",
      "Car",
      "Crazy",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/ly86n1mv8u0vpuprkgh0sjsn15wars8h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ly86n1mv8u0vpuprkgh0sjsn15wars8h/",
    "sourceUrl": "https://html5.gamemonetize.com/ly86n1mv8u0vpuprkgh0sjsn15wars8h/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69961",
    "slug": "labubu-and-me",
    "title": "Labubu And Me",
    "description": "Play this fun game for girls where you style your own Labubu monster and yourself! Customize Labubu with fur colors, eyes, tops, stickers, and accessories. Then, match your makeup and outfits to create the ultimate twin look. From trendy dresses and cute bags to stylish hairstyles, show off your fashion skills and creativity. Perfect for fans of Labubu games and makeover fun!",
    "instructions": "Use your mouse to play on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Design",
      "Dress Up",
      "Girl",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/59t18wi5337h0uznorx8a940ks97o5ww/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/59t18wi5337h0uznorx8a940ks97o5ww/",
    "sourceUrl": "https://html5.gamemonetize.com/59t18wi5337h0uznorx8a940ks97o5ww/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "71471",
    "slug": "bandits-bane",
    "title": "Bandits Bane",
    "description": "Bandits Bane consists of 5 levels. The city bank has been robbed! Save the city from vicious bandits, shooting only the most dangerous ones and rescuing the hostages! Kill all the bandits to advance to the next level before the end of the game, and youll win glory in the Wild West!",
    "instructions": "Mouse Click - Shoot Attack Mouse Movement - Aim direction",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/121weei0mlhtn5fkft56wqjkov7md493/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/121weei0mlhtn5fkft56wqjkov7md493/",
    "sourceUrl": "https://html5.gamemonetize.com/121weei0mlhtn5fkft56wqjkov7md493/",
    "width": 810,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "70620",
    "slug": "spooky-chains",
    "title": "Spooky Chains",
    "description": "Spooky Chains is a fun Halloween puzzle game. Tap a tile and drag through matching nearby items to make a chain of 3 or more. The items vanish, and the tiles turn golden. New items drop into the empty spots. Your goal is to turn all tiles golden. Early levels are easy, but later ones bring more challenge. Sometimes a Flying Witch glides across the board. Tap her while she flies to watch a reward ad. After the ad, she blasts some tiles into golden. You can also watch a reward ad to remove the timer and play without time pressure.",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "blockchain",
      "Halloween",
      "html5 games",
      "Match3",
      "Matching",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/nkpzi40jb5fnxpvm10sg6oshs7a0m588/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nkpzi40jb5fnxpvm10sg6oshs7a0m588/",
    "sourceUrl": "https://html5.gamemonetize.com/nkpzi40jb5fnxpvm10sg6oshs7a0m588/",
    "width": 768,
    "height": 510,
    "lastUpdated": ""
  },
  {
    "id": "71484",
    "slug": "warroll",
    "title": "WarRoll",
    "description": "Welcome to WarRoll &ndash; The Ultimate Strategic Dice Battle! Step into a thrilling world where every dice roll shapes your destiny! WarRoll takes classic Ludo-style gameplay to a whole new level with tactical twists, intense battles, and smart strategy. Roll your dice, plan your moves, and outthink your opponents to dominate the board. How to Play: Roll your dice and strategically deploy your pieces across the battlefield. Engage in dice-powered clashes with opponents to conquer key zones. Use power-ups, special rules, and clever positioning to outmaneuver rivals.",
    "instructions": "Play wisely see the tutorial",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Best",
      "Casual",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/82icxfnsylw2i2j6cscbquyfodmpx1lr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/82icxfnsylw2i2j6cscbquyfodmpx1lr/",
    "sourceUrl": "https://html5.gamemonetize.com/82icxfnsylw2i2j6cscbquyfodmpx1lr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71475",
    "slug": "big-vowels-fun",
    "title": "Big Vowels Fun",
    "description": "Welcome to Big Vowels Fun &ndash; The Ultimate Vowel Match-3 Challenge! Step into a bright and playful world where vowels take center stage! In Big Vowels Fun, your mission is to match A, E, I, O, and U tiles to rack up points, clear the board, and race against the clock across multiple exciting levels. How to Play: Match 3 or more of the same vowel tiles to score points. Beat the timer by making quick, smart matches. Advance through multiple levels, each with increasing speed and tricky patterns. Chain combos and power-ups to boost your score and keep the game flowing.",
    "instructions": "Match-3 in a row or column and increase your score",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Match 3",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/koyb5hm9g9fh4pvq7m71pk7txd1bc7kn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/koyb5hm9g9fh4pvq7m71pk7txd1bc7kn/",
    "sourceUrl": "https://html5.gamemonetize.com/koyb5hm9g9fh4pvq7m71pk7txd1bc7kn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71782",
    "slug": "kick-the-chicken",
    "title": "Kick the Chicken",
    "description": "This helpless little hen will need your help to get as much momentum as possible to go as far as she can on her journey across the farm. Are you ready to bat with all your might in the game Kick the Chicken? Join now this fun bird launching game and help the chickens fulfill their dream of flying far away!",
    "instructions": "Use the mouse or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Arcade",
      "Chicken",
      "endless",
      "Flight",
      "fly",
      "Highscore",
      "html games for your website",
      "kiz10"
    ],
    "thumbnail": "https://img.gamemonetize.com/gdzxtvcut1b5hsvlr2erofndc7vh3vm9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gdzxtvcut1b5hsvlr2erofndc7vh3vm9/",
    "sourceUrl": "https://html5.gamemonetize.com/gdzxtvcut1b5hsvlr2erofndc7vh3vm9/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "71786",
    "slug": "bottle-rush-3d",
    "title": "Bottle Rush 3D",
    "description": "Game Origin: Russia, maybe. You need to control the matryoshka and match the color to pass the level! Good luck to everyone! Keep your eyes open and move forward",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Action",
      "Adventure",
      "Mobile",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/9wry7tylhcvimxz4gmnlyqxnpy95p94i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9wry7tylhcvimxz4gmnlyqxnpy95p94i/",
    "sourceUrl": "https://html5.gamemonetize.com/9wry7tylhcvimxz4gmnlyqxnpy95p94i/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71764",
    "slug": "craft-monster-hunting",
    "title": "Craft Monster Hunting",
    "description": "Craft Room: Monster Hunting is a 3D action game where you take on the role of a hero who must hunt the evil monster. The game is set in a vast and beautiful craft world that is filled with danger and adventure. You will need to use your gun and shoot the monster and save everyone in the room. The monster will go around in the familiar rythm Dop Dop Dop Yes Yes with skin of monster.",
    "instructions": "Simple yet addictive stimulation - Find and shoot all the monster in every corners of the room - Take the weapon which are plenty of guns to give yourself an edge in battle - Use buttons joysticks to move run and jump",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D Games",
      "Minecraft",
      "Shooter",
      "Skibidi Toilet"
    ],
    "thumbnail": "https://img.gamemonetize.com/iy7dyv9scrhh9q05o75em17b3t5rerfb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iy7dyv9scrhh9q05o75em17b3t5rerfb/",
    "sourceUrl": "https://html5.gamemonetize.com/iy7dyv9scrhh9q05o75em17b3t5rerfb/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71707",
    "slug": "zigzag-animal-road",
    "title": "ZigZag   Animal Road",
    "description": "Guide a cast of cute animals across a busy, endless highway! Master the art of the zigzag to dodge speeding cars and massive trucks. Test your reflexes, set a new high score, and see how long you can survive the asphalt jungle!",
    "instructions": "Desktop Controls Arrow Keys Mouse Mobile Devices Tap amp swipe controls",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/k7zibsp73gcclup0ykknq06xvzy2a9yz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k7zibsp73gcclup0ykknq06xvzy2a9yz/",
    "sourceUrl": "https://html5.gamemonetize.com/k7zibsp73gcclup0ykknq06xvzy2a9yz/",
    "width": 720,
    "height": 1000,
    "lastUpdated": ""
  },
  {
    "id": "71481",
    "slug": "token-strike",
    "title": "Token Strike",
    "description": "Welcome to Token Strike &ndash; Fire Away and Smash the Crypto Targets! Lock, load, and aim your crypto cannon in this explosive arcade-style shooter where precision meets power! In Token Strike, your goal is simple: blast through waves of digital coins and crypto tokens with perfect aim and timing to rack up massive scores. How to Play: Aim your cannon at falling or floating crypto tokens. Tap to fire and smash tokens into bits to score points. Hit combos, chain explosions, and keep the coins from piling up.",
    "instructions": "Achieve the score and go to next level Timeout kills you",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Android",
      "arrows",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/z200cr43ckkn0rlz5a7hppdditsye5vv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z200cr43ckkn0rlz5a7hppdditsye5vv/",
    "sourceUrl": "https://html5.gamemonetize.com/z200cr43ckkn0rlz5a7hppdditsye5vv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71434",
    "slug": "food-jam",
    "title": "Food Jam",
    "description": "Food Jam is a fun and satisfying puzzle game where you sort fruits, veggies, and drinks into the right takeout carts. With over 500 juicy levels, unlock delicious new themes like desserts and juices! Use unique power-ups to clear tricky jams and keep your customers happy.",
    "instructions": "One-touch tap controls perfect for casual play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Match 3"
    ],
    "thumbnail": "https://img.gamemonetize.com/gtnb87wggwo1jk7b2snk4jk2njazmxtj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gtnb87wggwo1jk7b2snk4jk2njazmxtj/",
    "sourceUrl": "https://html5.gamemonetize.com/gtnb87wggwo1jk7b2snk4jk2njazmxtj/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71469",
    "slug": "euro-truck-driving-simulator",
    "title": "Euro Truck Driving Simulator",
    "description": "Welcome to the euro truck driving simulator game. Drive powerful trucks across highways and mountain roads in this realistic truck driving simulator game. Load cargo, follow traffic rules, and complete challenging delivery missions in detailed 3D environments. Hop in and drive your colorful truck through fun levels and easy roads Get ready for a relaxing and exciting ride with a euro truck game. Truck driving simulators made for fun! Drive cool trucks, complete easy cargo missions, and explore colorful roads in this enjoyable and easy-to-learn truck driving experience.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "3D",
      "3D Games",
      "Adventure",
      "Car",
      "city",
      "Games",
      "Racing",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/oukqsx8lias75zxke9657cll9pe1dhly/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oukqsx8lias75zxke9657cll9pe1dhly/",
    "sourceUrl": "https://html5.gamemonetize.com/oukqsx8lias75zxke9657cll9pe1dhly/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71784",
    "slug": "bus-jam",
    "title": "Bus Jam",
    "description": "Bus Jam &ndash; Fun Puzzle Adventure with Colorful Challenges! Get ready for Bus Jam, the ultimate bus game that&rsquo;s all about matching passengers to their buses in this relaxing yet brain-teasing bus mania adventure. Its up to you to solve fun, colorful puzzles and clear the way to send each passenger on their dream vacation! In this exciting puzzle game, youll encounter progressively challenging levels as you advance. Your goal? Strategically match passengers with their correctly colored buses! Game Features: Fun &amp; Relaxing Gameplay: Enjoy hours of relaxing and strategic gameplay as you work through puzzles and organize passengers.",
    "instructions": "Tap on a bus of a certain color to pick up passengers of the same color",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "bus",
      "carparking",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/iuiwdzr6jg4daxiduxbn1bz84fgwdfti/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iuiwdzr6jg4daxiduxbn1bz84fgwdfti/",
    "sourceUrl": "https://html5.gamemonetize.com/iuiwdzr6jg4daxiduxbn1bz84fgwdfti/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "56804",
    "slug": "save-pilot-ryan",
    "title": "Save Pilot Ryan",
    "description": "Can you keep Pilot Ryan flying? In this high-octane action game, youll be dodging a relentless barrage of missiles. Guide Pilot Ryans plane through treacherous skies, maneuvering skillfully to avoid deadly collisions. Sharpen your reflexes and test your focus as the pressure mounts. Can you survive this extremely arbitary battle ?Will you lead Pilot Ryan to safety, or will he succumb to the missile onslaught? Buckle up and prepare for a thrilling flight in Save Pilot Ryan! We wait for your highest score!",
    "instructions": "Click and drag to change the plane direction",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "airplane",
      "Battle",
      "Bomb"
    ],
    "thumbnail": "https://img.gamemonetize.com/g62nrbhov6yeu90qzbl176b7wn92crb7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g62nrbhov6yeu90qzbl176b7wn92crb7/",
    "sourceUrl": "https://html5.gamemonetize.com/g62nrbhov6yeu90qzbl176b7wn92crb7/",
    "width": 2240,
    "height": 1400,
    "lastUpdated": ""
  },
  {
    "id": "71509",
    "slug": "frozen-race-3d",
    "title": "Frozen Race 3D",
    "description": "This is a fan-friendly game where you play as a princess and use specific magic to freeze your enemies or obstacles until you reach the end!",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Disney",
      "Girl",
      "Magic",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/03tc5rchi1y4b1t9ieviywsstoimwohn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/03tc5rchi1y4b1t9ieviywsstoimwohn/",
    "sourceUrl": "https://html5.gamemonetize.com/03tc5rchi1y4b1t9ieviywsstoimwohn/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71730",
    "slug": "pickle-ball-clash",
    "title": "Pickle Ball Clash",
    "description": "Step into the fast-paced world of Pickle Ball Clash &mdash; a thrilling sports game where every match is a battle of skill, speed, and strategy. Customize your character, unlock powerful paddles, and climb the competitive ranks from backyard brawls to pro-level leagues. Whether youre smashing winners or pulling off trick shots, the court is yours to conquer. Are you ready to clash?",
    "instructions": "Swipe longer to hit the ball far Swipe short to hit the ball near",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/fvlpux2ktkxuver104lz94z5huvc9oyb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fvlpux2ktkxuver104lz94z5huvc9oyb/",
    "sourceUrl": "https://html5.gamemonetize.com/fvlpux2ktkxuver104lz94z5huvc9oyb/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "60655",
    "slug": "prado-car-parking-game",
    "title": "Prado Car Parking Game",
    "description": "Welcome to the ultimate prado car parking simulator game. A realistic, thrilling, and precision-based driving experience designed exclusively for fans of luxury cars and master-level parking challenges in car parking games. This car parking game is not just about driving games. It&rsquo;s about technique, timing, and control all while maneuvering your favorite prado models through a wide range of parking challenges.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2025 games",
      "3D",
      "Adventure",
      "Car",
      "carparking",
      "Cars",
      "Crazy",
      "Game",
      "Parking"
    ],
    "thumbnail": "https://img.gamemonetize.com/xdcbce71p7nlxghsu51nly0ussa0li4s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xdcbce71p7nlxghsu51nly0ussa0li4s/",
    "sourceUrl": "https://html5.gamemonetize.com/xdcbce71p7nlxghsu51nly0ussa0li4s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71583",
    "slug": "soda-block-jam",
    "title": "Soda Block Jam",
    "description": "Soda Block Jam is a refreshing twist on classic puzzle games. Navigate through vibrant levels by swiping soda crates in continuous motions, collecting soda bottles, and delivering them to their designated exits.",
    "instructions": "Swipe a soda crate to move it in any direction The crate collects bottles of the same color as it moves Other colors and crates block the way Once full the crate exits through its matching color gate",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Escape"
    ],
    "thumbnail": "https://img.gamemonetize.com/sx9e751be41mwvzz7w9ynub5ejuhxm6d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sx9e751be41mwvzz7w9ynub5ejuhxm6d/",
    "sourceUrl": "https://html5.gamemonetize.com/sx9e751be41mwvzz7w9ynub5ejuhxm6d/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71667",
    "slug": "flappy-bird-2025",
    "title": "Flappy Bird 2025",
    "description": "Fly through endless obstacles in Flappy Bird 2025 &mdash; a fast-paced arcade game inspired by the classic hit! Tap or click to keep your bird flying and avoid the pipes. Each successful pass earns you a point &mdash; how far can you go? Simple to play but hard to master, Flappy Bird 2025 will test your reflexes and patience to the limit. Challenge your friends, beat your high score, and prove you&rsquo;re the ultimate flyer!",
    "instructions": "Mouse Tap Click or tap to make the bird flap and stay in the air Spacebar optional Press to flap",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "angrybirds",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/061ywu0eu49of0pyl2r83jd8pgy44cmj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/061ywu0eu49of0pyl2r83jd8pgy44cmj/",
    "sourceUrl": "https://html5.gamemonetize.com/061ywu0eu49of0pyl2r83jd8pgy44cmj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71480",
    "slug": "slidex",
    "title": "SlideX",
    "description": "Experience precision and speed like never before in SlideX! Glide a sleek cube left and right with perfect timing to slice through dashed lines while dodging solid obstacles. One wrong move, and it&rsquo;s game over. Stay focused, react fast, and keep your rhythm as the pace intensifies with every cut. Simple to play but hard to master &mdash; SlideX is the ultimate test of reflexes and accuracy. Key Features: Minimalistic yet addictive gameplay One-tap controls for quick left-right shifts Perfectly slice through dashed lines to score",
    "instructions": "Cut the ropes never hit solid blocks",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "blockchain",
      "blocky",
      "cut"
    ],
    "thumbnail": "https://img.gamemonetize.com/6n1affx3lh9chbsvl2725nefia8bqwhb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6n1affx3lh9chbsvl2725nefia8bqwhb/",
    "sourceUrl": "https://html5.gamemonetize.com/6n1affx3lh9chbsvl2725nefia8bqwhb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71054",
    "slug": "terraria-playground",
    "title": "Terraria Playground",
    "description": "Immerse yourself in the amazing world of Terraria Playground right now! The game offers a variety of unique items and characters that you can use to conduct crazy experiments and have fun exploring.",
    "instructions": "Select an object from the list and click on it to add it to the game board You can move objects around the game board by simply holding them down Experiment and have fun with this epic game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Arcade",
      "Battle",
      "Classic",
      "Cute",
      "destroy",
      "destruction",
      "free games for your website",
      "free html5 games for your website",
      "Funny",
      "Games",
      "Pixel",
      "Sandbox",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/1b9i7wog8r0dlkhmykjw2eqjszqda2ss/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1b9i7wog8r0dlkhmykjw2eqjszqda2ss/",
    "sourceUrl": "https://html5.gamemonetize.com/1b9i7wog8r0dlkhmykjw2eqjszqda2ss/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71051",
    "slug": "decode-the-movie-quote",
    "title": "Decode the Movie Quote",
    "description": "Welcome to an exciting game where you guess famous movie quotes one letter at a time! Show your wit and prove youre a true movie buff. Discover iconic lines from your favorite films, enjoy fun challenges, and have hours of entertainment. Play solo or compete with friends to see who knows movies best!",
    "instructions": "Keyboard - Dark key mdash all instances of the letter have been used - Yellow key mdash the letter is still in the phrase click on it in the phrase to highlight its positions - Red key mdash the letter is not in the phrase Use a hint if you ge",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Brain",
      "Casual",
      "Educational",
      "Guessing",
      "html5 games",
      "Letters",
      "Logic",
      "Movie",
      "Puzzle",
      "quest",
      "Quiz",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/r762uo77us0kwpsllwnk22hu64l5gqak/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r762uo77us0kwpsllwnk22hu64l5gqak/",
    "sourceUrl": "https://html5.gamemonetize.com/r762uo77us0kwpsllwnk22hu64l5gqak/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71373",
    "slug": "build-a-burger",
    "title": "Build a Burger",
    "description": "Get ready for burger madness in the game Build a Burger! Run forward, collect ingredients according to the recipe, and upgrade your burger, making it bigger and tastier. Fun obstacles await you along the way&mdash;be quick and attentive to make sure you dont miss a single ingredient! Collect ingredients, experiment with recipes, and upgrade your burger to incredible sizes. Each new dish unlocks unique opportunities and bonuses, and finally, the most important thing: feed your giant burger and enjoy the result! Fun, bright, and dynamic, this runner will bring a wave of emotions to both children and adults. Simple controls, engaging levels, fun",
    "instructions": "On phone Gently swipe left or right to confidently collect ingredients and avoid obstacles On computer Move the burger sideways with your mouse Or use the A D or larr rarr keys to control movement",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "amazing",
      "Casual",
      "Cooking",
      "Game",
      "HTML5",
      "Hypercasual",
      "Levels",
      "Mobile",
      "New",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/rr18r2i3d6ovzgkapjgmbkfj2uc0dxbw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rr18r2i3d6ovzgkapjgmbkfj2uc0dxbw/",
    "sourceUrl": "https://html5.gamemonetize.com/rr18r2i3d6ovzgkapjgmbkfj2uc0dxbw/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71697",
    "slug": "tactical-conquest",
    "title": "Tactical Conquest",
    "description": "Use these tactics to take over the enemys position. Try to get ahead of the enemy and take more advantageous positions. Only the strongest will win.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual",
      "Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/989mfa19sukt8g2ea7ey13ferv2btg53/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/989mfa19sukt8g2ea7ey13ferv2btg53/",
    "sourceUrl": "https://html5.gamemonetize.com/989mfa19sukt8g2ea7ey13ferv2btg53/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71684",
    "slug": "cowboy-runners-dash",
    "title": "Cowboy Runners Dash",
    "description": "Dash through subway tunnels and busy city streets! Dodge trains, vault barriers, collect coins, and upgrade power-ups. Simple touch or keyboard controls&mdash;how far can you run this time?",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D Games",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ixske9fiqg8axn0ijggk275lps3temyf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ixske9fiqg8axn0ijggk275lps3temyf/",
    "sourceUrl": "https://html5.gamemonetize.com/ixske9fiqg8axn0ijggk275lps3temyf/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71606",
    "slug": "long-neck",
    "title": "Long neck",
    "description": "Collect rings of the same color as the character himself to make the neck as high as possible. If you collect more rings, you will get a better result.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/l1yxw9b1cyuacnv8nrt83w97vt20xymj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l1yxw9b1cyuacnv8nrt83w97vt20xymj/",
    "sourceUrl": "https://html5.gamemonetize.com/l1yxw9b1cyuacnv8nrt83w97vt20xymj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71543",
    "slug": "truck-delivery-simulator",
    "title": "Truck Delivery Simulator",
    "description": "Overall its a truck simulation, but you have to be careful not to get the cargo outside while racing against time. This shouldnt be difficult for you.",
    "instructions": "Mouse click or tap to play Keyboard wasd to control movement",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D Games",
      "Car",
      "Driving",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/wd3ryipq2wo3il6cv5mug814nqvjjvq0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wd3ryipq2wo3il6cv5mug814nqvjjvq0/",
    "sourceUrl": "https://html5.gamemonetize.com/wd3ryipq2wo3il6cv5mug814nqvjjvq0/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "71479",
    "slug": "potion-path",
    "title": "Potion Path",
    "description": "Welcome to Potion Path &ndash; A Magical Running Adventure! Join a playful young witch on a thrilling journey through enchanted lands filled with danger, mystery, and magical rewards. In Potion Path, your mission is to run, jump, and collect powerful elements and tasty treats, all while dodging deadly enemies lurking on the path! How to Play: Tap to jump over obstacles and evil creatures. Collect magical food and potion ingredients to boost your score. Use skill and timing to survive as long as you can &mdash; lives are limited, so every jump counts!",
    "instructions": "Jump and Slide Jump is left side tap and Slide is right side tap",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "endless",
      "Magic",
      "running",
      "Witch"
    ],
    "thumbnail": "https://img.gamemonetize.com/cf49nnx6v5azxx72i9agpgnppa1eyz6a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cf49nnx6v5azxx72i9agpgnppa1eyz6a/",
    "sourceUrl": "https://html5.gamemonetize.com/cf49nnx6v5azxx72i9agpgnppa1eyz6a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69868",
    "slug": "russian-is-easy",
    "title": "Russian is easy",
    "description": "Russian is easy&rdquo; is an exciting game for those who want to improve their skills in the Russian language. It offers a unique approach to learning new words and phrases, allowing players to simultaneously train their memory and develop their vocabulary. The game is suitable for a wide range of players, from children and teenagers just starting to learn Russian, to adults who want to improve their knowledge and expand their vocabulary. The game will be interesting to anyone who wants to easily understand and speak Russian.",
    "instructions": "Develop your vocabulary Connect Russian green and English red words with your cursor or finger When all the words on the screen are paired you can check yourself Closed items may appear in the game with a small chance To add an item to the collec",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Brain",
      "Educational",
      "HTML",
      "html5 games",
      "Interactive",
      "Logical",
      "Mobile",
      "Super",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/fqmu9opwmryiinpd2vtn0aww8m3so2oe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fqmu9opwmryiinpd2vtn0aww8m3so2oe/",
    "sourceUrl": "https://html5.gamemonetize.com/fqmu9opwmryiinpd2vtn0aww8m3so2oe/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "70065",
    "slug": "pet-doctor-business-tycoon-game",
    "title": "Pet Doctor Business Tycoon Game",
    "description": "Step into the world of animal care with Pet Doctor &ndash; Animal Hospital Simulator! Become a kind and skilled veterinarian as you treat adorable pets including cats, dogs, rabbits, and more. Use realistic medical tools to diagnose, clean wounds, check heartbeats, and perform surgeries. Each level brings new challenges where you must care for sick, injured, or pregnant animals in a friendly hospital environment. Customize your clinic, unlock advanced tools, and make every furry patient happy and healthy. Enjoy bright graphics, smooth animations, and fun mini-games that make learning about pet care exciting for all ages.",
    "instructions": "Farm Land Game Controls W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "amazing",
      "Animal",
      "Baby Games",
      "Cartoon"
    ],
    "thumbnail": "https://img.gamemonetize.com/vj94bb7ch7ys7oe8ojupaez357290zie/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vj94bb7ch7ys7oe8ojupaez357290zie/",
    "sourceUrl": "https://html5.gamemonetize.com/vj94bb7ch7ys7oe8ojupaez357290zie/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71550",
    "slug": "bts-cute-kitty-coloring",
    "title": "BTS Cute Kitty Coloring",
    "description": "BTS Cute Kitty Coloring is a super fun and completely free online coloring game made for kids who love creativity! Let your imagination run wild as you bring adorable kitties to life with bright colors and unique designs. Show off your artistic skills, experiment with shades and styles, and create your very own masterpiece. Relax, color, and have tons of fun in this cute kitty adventure!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Boys",
      "Cat",
      "Coloring",
      "Educational",
      "Fun",
      "Girls",
      "Hypercasual",
      "Mobile",
      "painting",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/42ihnluwaaonop24ayq6uqemk7rstvmg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/42ihnluwaaonop24ayq6uqemk7rstvmg/",
    "sourceUrl": "https://html5.gamemonetize.com/42ihnluwaaonop24ayq6uqemk7rstvmg/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "71544",
    "slug": "thief-stick-puzzle-man-escape",
    "title": "Thief Stick Puzzle: Man Escape",
    "description": "Enjoy a hilarious and brain-twisting adventure in Thief Stick Puzzle: Man Escape. It&rsquo;s a mix of stickman comedy, clever puzzle levels, and funny escape challenges that will keep you hooked for hours! You play as a sneaky thief stickman trying to escape from tricky situations. To survive, you&rsquo;ll need to solve smart brain teaser puzzles. For example, finding the correct path through a maze to obtain treasure, or bypassing a cutting machine to save a puppy.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Escape",
      "Funny",
      "Stickman",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/yebankbv1mje7k4fy64y645emocg0y9m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yebankbv1mje7k4fy64y645emocg0y9m/",
    "sourceUrl": "https://html5.gamemonetize.com/yebankbv1mje7k4fy64y645emocg0y9m/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "71589",
    "slug": "precise-shooting",
    "title": "Precise shooting",
    "description": "Aim well to make accurate shots at the basketball basket. Be careful and try not to make mistakes. In each task, you need to hit each basketball basket, make two mistakes and you will start the level from the beginning.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Basketball",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/klycj2xefepam2ocak1c3mg8nhuledpd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/klycj2xefepam2ocak1c3mg8nhuledpd/",
    "sourceUrl": "https://html5.gamemonetize.com/klycj2xefepam2ocak1c3mg8nhuledpd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71630",
    "slug": "merge-archers-bow-and-arrow",
    "title": "Merge Archers Bow and Arrow",
    "description": "Find the right angle, draw the bow, and release the arrow! Use it with a little strategy to grow your army. But remember to shoot the enemy before they wipe out all your soldiers.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D Games",
      "arrow",
      "attack",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/pcrc4h8jk17a6sxf3dsaxgi8vmq4nywc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pcrc4h8jk17a6sxf3dsaxgi8vmq4nywc/",
    "sourceUrl": "https://html5.gamemonetize.com/pcrc4h8jk17a6sxf3dsaxgi8vmq4nywc/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71602",
    "slug": "slither-escape",
    "title": "Slither Escape",
    "description": "Slither Escape is the perfect snake puzzle for playing online on your mobile or PC. In Slither Escape, guide the colored vipers to their respective exit through complex mazes. Its a fast and addictive HTML5 game. Download or play Slither Escape now!",
    "instructions": "drag to move the snakes",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Puzzle",
      "Slither",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/ha123s3jwobpg4g6qp6eryonco60eprw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ha123s3jwobpg4g6qp6eryonco60eprw/",
    "sourceUrl": "https://html5.gamemonetize.com/ha123s3jwobpg4g6qp6eryonco60eprw/",
    "width": 640,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71563",
    "slug": "spider-bubu",
    "title": "Spider Bubu",
    "description": "Spider-Bubu swings from wall to wall across the city. Halloween has arrived, and you need to collect all the Halloween candies along with Spider-Bubu. Don&rsquo;t forget to grab the giant pumpkin too! You must be very careful in the city &mdash; sharp spinning blades and pointed spikes are everywhere. Collect all the pumpkins and safely reach the portal that appears in the city.",
    "instructions": "To move from wall to wall tap and release on mobile or click and release with the mouse on PC Collect all three pumpkins and safely reach the visible portal Playable on both mobile and PC",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Arcade",
      "Halloween",
      "Hypercasual",
      "Interactive",
      "Spiderman"
    ],
    "thumbnail": "https://img.gamemonetize.com/e0z758qengfhk5xq1fdrnxeldm0z5nbo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e0z758qengfhk5xq1fdrnxeldm0z5nbo/",
    "sourceUrl": "https://html5.gamemonetize.com/e0z758qengfhk5xq1fdrnxeldm0z5nbo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69736",
    "slug": "cities-game",
    "title": "Cities Game",
    "description": "Cities game is a timeless game that puts your knowledge and vocabulary to the test. Your challenge is simple: name cities that start with the last letter of the previously named city. The winner is the last player standing who can name a valid city when others cant. Dont miss your chance to test your knowledge and compete against others! Cities game will immerse you in a world of learning and fun, helping you discover fascinating cities around the globe.",
    "instructions": "The goal of the game is to name a city starting with the last letter of the city suggested by the game - Skip a turn If you dont know the right city skip the turn losing 5 points - Hint light bulb Get help from the game by watching the commercial",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Best",
      "Brain",
      "city",
      "Classic",
      "Educational",
      "free html5 games for your website",
      "Guessing",
      "Hypercasual",
      "Letters",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/0z6ub9z770iru1io7cmgxogjjq05gb8q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0z6ub9z770iru1io7cmgxogjjq05gb8q/",
    "sourceUrl": "https://html5.gamemonetize.com/0z6ub9z770iru1io7cmgxogjjq05gb8q/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71610",
    "slug": "cake-link-master",
    "title": "Cake Link Master",
    "description": "Cake Link Master is a fun puzzle game where you tap two matching cakes to connect them with a line. The line can turn up to two times but cannot go over other tiles. The game has 120 challenging levels, and the difficulty grows as you play. Clear the cakes, solve the puzzles, and enjoy hours of sweet, relaxing fun!",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Cake",
      "Girls",
      "html5 games",
      "Mahjong",
      "Matching",
      "Mobile",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/1q8z9qiuy0tp9mjq7v5ymclf4wgxjdlb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1q8z9qiuy0tp9mjq7v5ymclf4wgxjdlb/",
    "sourceUrl": "https://html5.gamemonetize.com/1q8z9qiuy0tp9mjq7v5ymclf4wgxjdlb/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "71625",
    "slug": "explosive-speed",
    "title": "Explosive speed",
    "description": "The giant is too big, you can beat him with something big. Accelerate the car to maximum speed and deal a crushing blow to the giant.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Car",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/cbjmp7m8raq528lk3dz8padyhjkjbtrn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cbjmp7m8raq528lk3dz8padyhjkjbtrn/",
    "sourceUrl": "https://html5.gamemonetize.com/cbjmp7m8raq528lk3dz8padyhjkjbtrn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71287",
    "slug": "piggy-vs-watermelon",
    "title": "Piggy vs Watermelon",
    "description": "Guide a plucky pig across a lush, nine-parcel garden in this fast, arcade shooter. Move the pig with your mouse and fire upward to pop incoming watermelons before they crash into you. Each hit triggers juicy red explosions and flying rind fragments, adding satisfying feedback without slowing play. Web Dev <a href='https://www.freecrazygames.io/'>https://www.freecrazygames.io/</a>",
    "instructions": "Click Play Move the mouse left right to move the pig Left-click or hold to shoot Dodge and pop the watermelons Click Play again to restart",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Ai Games",
      "Animal",
      "Arcade",
      "Fruits"
    ],
    "thumbnail": "https://img.gamemonetize.com/c3g7q1lmpoax6jtrpv5fkmki4hn3t6r0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c3g7q1lmpoax6jtrpv5fkmki4hn3t6r0/",
    "sourceUrl": "https://html5.gamemonetize.com/c3g7q1lmpoax6jtrpv5fkmki4hn3t6r0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71310",
    "slug": "space-war-symphony",
    "title": "Space War Symphony",
    "description": "Space War Symphony is a fast, rhythm-tuned arcade shooter where your starship dances with the beat. Glide horizontally with the mouse, click to fire, and time shots to the BPM for boosted damage, score, and stylish spread patterns. Web Dev <a href='https://www.unblockedgamest.com/.'>https://www.unblockedgamest.com/.</a> Enemies surge in waves, evolving as your score climbs, while bosses crash the stage with distinct bullet patterns and glowing health bars.",
    "instructions": "Move the ship left ndash right by moving the mouse Left-click to shoot hold to auto-fire Time your clicks to the beat for extra damage score and combo Dodge enemy bullets survive waves and press P to pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Ai Games",
      "battleship",
      "Bullet",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/game0fm682vwc1pxjlyic9f3o6jz883u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/game0fm682vwc1pxjlyic9f3o6jz883u/",
    "sourceUrl": "https://html5.gamemonetize.com/game0fm682vwc1pxjlyic9f3o6jz883u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71257",
    "slug": "space-asteroids-war",
    "title": "space asteroids war",
    "description": "This game is a modern remake of the classic Asteroids, bringing fast-paced arcade action to the browser. Players control a small triangular spaceship navigating through a star-filled sky, tasked with blasting apart drifting asteroids before they collide with the ship. Each destroyed rock splits into smaller fragments, increasing both challenge and excitement. Web Dev <a href='https://www.poki76.com/'>https://www.poki76.com/</a>",
    "instructions": "Use the Arrow Keys to navigate uarr applies thrust and activates the ship rsquo s flame while larr and rarr rotate the ship left or right Press Spacebar or Left Mouse Click to fire bullets directly from the ship rsquo s tip producing a quick am",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Ai Games",
      "attack",
      "Battle",
      "battleship",
      "Click",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/i1raaei18aer6qs260o8xjuwpmgndo6p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i1raaei18aer6qs260o8xjuwpmgndo6p/",
    "sourceUrl": "https://html5.gamemonetize.com/i1raaei18aer6qs260o8xjuwpmgndo6p/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71248",
    "slug": "space-shooter-war",
    "title": "Space Shooter War",
    "description": "Space Shooter is a classic arcade-style game where the player pilots a spaceship and faces endless waves of enemies. The main objective is to destroy as many enemy ships as possible, avoid incoming projectiles, and survive for as long as you can. The spaceship can be controlled with the keyboard or mouse, and every laser shot counts in the battle for survival. As the game progresses, difficulty increases with faster and more aggressive enemies, keeping the adrenaline high and the challenge engaging. Web Dev <a href='https://www.ovigames.com/'>https://www.ovigames.com/</a>",
    "instructions": "Move the mouse on the canvas to move bull Click hold to shoot bull Arrows A D and Space also work bull Touch drag finger horizontally hold to fire",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adventure",
      "Ai Games",
      "HTML5",
      "Shooting",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/mgpc7btrdmktn4x3sr5ljs40vup2hgyg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mgpc7btrdmktn4x3sr5ljs40vup2hgyg/",
    "sourceUrl": "https://html5.gamemonetize.com/mgpc7btrdmktn4x3sr5ljs40vup2hgyg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71513",
    "slug": "rainbow-survivor",
    "title": "Rainbow Survivor",
    "description": "Blue Monster Impostor Survivor - where you will play as a person who has been kidnapped during a school trip to an amusement park. You and other players would have to try to run away from the Blue Monster monster and get safe. HOW TO PLAY - Use the joystick to move around and collect boxes - Use the box to hide and protect yourself from the Blue Monster monster - Cooperate with other players to complete the mission in limited time GAME FEATURES - Beautiful 3D and minecraft theme and relaxing sound effect - Fun and addictive gameplay - Great for those who love Minecraft games. Play the game and enjoy it with your loved ones!",
    "instructions": "WASD to move Right Mouse Button to hide or attack P to pause",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "Minecraft",
      "roblox",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/2011azu5v0v14r8aq3scgy399izfbr9s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2011azu5v0v14r8aq3scgy399izfbr9s/",
    "sourceUrl": "https://html5.gamemonetize.com/2011azu5v0v14r8aq3scgy399izfbr9s/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71579",
    "slug": "passing-master-3d",
    "title": "Passing master 3D",
    "description": "Complete the obstacle course and collect only useful items that will enhance your skills. Each level contains new obstacles, it depends on you whether you can reach the end or not.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Basketball",
      "Casual",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/bqnrihk0tusss89hxxxe2ne0e5mryv2m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bqnrihk0tusss89hxxxe2ne0e5mryv2m/",
    "sourceUrl": "https://html5.gamemonetize.com/bqnrihk0tusss89hxxxe2ne0e5mryv2m/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71423",
    "slug": "geometry-dash-3d",
    "title": "Geometry Dash 3D",
    "description": "- Addictive Gameplay &ndash; Experience fast-paced levels packed with thrilling obstacles that will test your reflexes, precision, and agility. Every second matters as you race toward survival! - Immersive 3D Worlds &ndash; Dive into stunning three-dimensional environments bursting with vibrant colors, dynamic animations, and unique designs that bring each level to life. - Variety of Challenges &ndash; From easy beginner stages to intricate mazes and deadly traps, every level offers new tests for players of all skill levels.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Boys",
      "Casual",
      "dash",
      "Geometry",
      "Girls",
      "Hypercasual",
      "jump",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/sunivbgaw98s2nmvao60lhqyhjh0es3f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sunivbgaw98s2nmvao60lhqyhjh0es3f/",
    "sourceUrl": "https://html5.gamemonetize.com/sunivbgaw98s2nmvao60lhqyhjh0es3f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71512",
    "slug": "3d-bullet-bender",
    "title": "3D Bullet Bender",
    "description": "Experience the world of killer in this game! You play a killer, oh no, its the killers bullet, control it to penetrate the enemy. Remember to shoot your head.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D Games",
      "Bullet",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/5irj7f2fjar5hr2ysd26d1x6ezuc0hro/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5irj7f2fjar5hr2ysd26d1x6ezuc0hro/",
    "sourceUrl": "https://html5.gamemonetize.com/5irj7f2fjar5hr2ysd26d1x6ezuc0hro/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71577",
    "slug": "endless-fall",
    "title": "Endless Fall",
    "description": "Welcome to Endless Fall, the ultimate test of reflex and precision! Your goal is simple &mdash; guide the ball safely as it falls endlessly downward. But the path is filled with tricky obstacles that you must move, rotate, and position just right to clear the way. Each level gets faster and more challenging, demanding perfect timing and smart thinking. How long can you keep falling?",
    "instructions": "Slide and tap on the game screen to move and rotate the objects",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ball",
      "Brain",
      "Logical",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/03uhew8c30nrkkadh1ydqkxrcmh1p0ph/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/03uhew8c30nrkkadh1ydqkxrcmh1p0ph/",
    "sourceUrl": "https://html5.gamemonetize.com/03uhew8c30nrkkadh1ydqkxrcmh1p0ph/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71477",
    "slug": "ghoul-fusion",
    "title": "Ghoul Fusion",
    "description": "Welcome to Ghoul Fusion &ndash; The Spookiest Merge Puzzle Ever! Step into a haunted world where pumpkins rain from the sky! In Ghoul Fusion, your goal is simple yet wickedly fun: merge identical Halloween objects to create larger, creepier, and higher-scoring items. How to Play: Drag and drop spooky objects as they fall. Merge two of the same kind to evolve them into bigger, more powerful Halloween icons. Chain combos and build eerie mega-merges to rack up monstrous scores!",
    "instructions": "Take the dropping poll to any position you like and grow the pumpkins for higher score Pause for not a tiring session",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Christmas",
      "Fruits",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/bemc5mwn09sl1xxicpgf4u5q6lrmub1j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bemc5mwn09sl1xxicpgf4u5q6lrmub1j/",
    "sourceUrl": "https://html5.gamemonetize.com/bemc5mwn09sl1xxicpgf4u5q6lrmub1j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70803",
    "slug": "my-happy-farm-land-simulator",
    "title": "My Happy Farm Land Simulator",
    "description": "Welcome to farm land game &ndash; the ultimate farming adventure that brings the beauty of rural life, the challenge of resource management, and the excitement of running your very own farm straight to your browser. Whether you are a casual player looking to relax or a hardcore strategist seeking to build the most efficient farming empire, this game has something for everyone. The game is not just about clicking and waiting; it&rsquo;s about strategy, timing, and smart decisions. Do you invest in farms first or focus on crops? Should you expand your land or upgrade your equipment? Every choice matters.",
    "instructions": "W Arrow Up rarr Move Front S Arrow Down rarr Move Back A Arrow Left rarr Move Left D Arrow Right rarr Move Right - To click any button use mouse",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Adventure",
      "Animal",
      "Business",
      "Farm"
    ],
    "thumbnail": "https://img.gamemonetize.com/357hlo1zvarptc23w99gx1p7y3i9hu70/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/357hlo1zvarptc23w99gx1p7y3i9hu70/",
    "sourceUrl": "https://html5.gamemonetize.com/357hlo1zvarptc23w99gx1p7y3i9hu70/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71546",
    "slug": "florify",
    "title": "Florify",
    "description": "Florify is a soothing and addictive flower-matching puzzle game. Connect beautiful flower buds of the same kind to make them bloom and earn points! As you play, new flower types appear, making every level more colorful and challenging. The pace quickens with each stage &mdash; so stay sharp and keep your garden blooming!",
    "instructions": "Touch or use your mouse to connect 3 or more matching flowers Longer chains create bigger combos and bonus points",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Arcade",
      "Educational",
      "Fun",
      "Kid",
      "Kids",
      "Match 3",
      "Match-3",
      "Match3",
      "Matching",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/zwib9b94v2k6q9211hzfdxkndxd32xw5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zwib9b94v2k6q9211hzfdxkndxd32xw5/",
    "sourceUrl": "https://html5.gamemonetize.com/zwib9b94v2k6q9211hzfdxkndxd32xw5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71355",
    "slug": "the-rise-of-zombies",
    "title": "The Rise Of Zombies",
    "description": "This is a thrilling real-time survival strategy game where you control a growing horde of zombies against humans. The world is alive with day-night cycles: during the day, humans shoot with higher accuracy, while at night they are weaker and less aggressive. Your goal is to infect humans, expand your army, and destroy survivors before they wipe you out. Meteors occasionally fall&mdash;collect them to unlock mutations that boost zombie speed and strength. Every match is dynamic: humans roam, panic, and fight back intelligently. Zombies infect survivors on close contact, instantly turning them into allies.",
    "instructions": "Click on the map or meteors to set your horde rsquo s waypoint Move the camera by moving the mouse to screen edges Press P or use the buttons to pause or resume Press M or use the button to mute unmute sound",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Action",
      "Horror",
      "Knight",
      "Shooter",
      "Shooting",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/x6ba1la3lfjilaond7eeic2te3p329a7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x6ba1la3lfjilaond7eeic2te3p329a7/",
    "sourceUrl": "https://html5.gamemonetize.com/x6ba1la3lfjilaond7eeic2te3p329a7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71361",
    "slug": "infinity-roll-3d",
    "title": "Infinity Roll 3D",
    "description": "Infinity Rolls 3D is a fast-paced endless rolling adventure that puts your reflexes and focus to the ultimate test! Control a rolling ball racing through futuristic 3D tracks where the speed never stops. Your mission is simple tap or click on time to make perfect turn and collect diamonds, and push your score higher and higher! With smooth controls, dynamic challenges, and neon-style graphics, Infinity Rolls 3D delivers an addictive and immersive experience that keeps you coming back for &ldquo;one more round.&rdquo;",
    "instructions": "The game is simple to play but hard to master ndash just tap mobile or click PC to turn the ball and survive as long as you can Every turn counts and every mistake could be your last",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Ball",
      "Clicker",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/3q0k2f1pvoevwqphm95snp3kyduteejs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3q0k2f1pvoevwqphm95snp3kyduteejs/",
    "sourceUrl": "https://html5.gamemonetize.com/3q0k2f1pvoevwqphm95snp3kyduteejs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71433",
    "slug": "space-shooter-boss",
    "title": "Space Shooter Boss",
    "description": "Space Shooter Boss is a fast-paced arcade game where you pilot a powerful spaceship through waves of enemies and meteor showers. Dodge attacks, collect power-ups, and defeat the mighty final boss to save the galaxy. Web Dev <a href='https://www.freecrazygames.io/'>https://www.freecrazygames.io/</a>",
    "instructions": "Move the mouse left or right to steer the spaceship hold the left mouse button to shoot continuously e click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Ai Games",
      "Alien",
      "battleship",
      "Best Games",
      "Bike",
      "Clicker",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/vfjh5lqrh92fxoxfesnyrvzm099zlymo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vfjh5lqrh92fxoxfesnyrvzm099zlymo/",
    "sourceUrl": "https://html5.gamemonetize.com/vfjh5lqrh92fxoxfesnyrvzm099zlymo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71476",
    "slug": "coral-adventure",
    "title": "Coral Adventure",
    "description": "Welcome to Coral Adventure &ndash; Dive Into a Splashy Challenge! &zwj; Join a cute Barbee fish on an exciting underwater journey filled with obstacles, bubbles, and coral reefs. In Coral Adventure, your mission is to swim through narrow gaps, avoid the dangerous bars ahead, and see how far you can go in this thrilling underwater dash! How to Play: Tap to keep the Barbee fish swimming and afloat. Navigate through a series of coral bars without crashing. Stay focused &mdash; one wrong tap and it&rsquo;s game over!",
    "instructions": "Click to stay afloat release to drop down",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fish",
      "flappybird",
      "Mermaid",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/q7p96cwgdub54jy200mut4hhft4x0hcj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q7p96cwgdub54jy200mut4hhft4x0hcj/",
    "sourceUrl": "https://html5.gamemonetize.com/q7p96cwgdub54jy200mut4hhft4x0hcj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71478",
    "slug": "numeral-crawl",
    "title": "Numeral Crawl",
    "description": "Welcome to Potion Path &ndash; A Magical Running Adventure! Join a playful young witch on a thrilling journey through enchanted lands filled with danger, mystery, and magical rewards. In Potion Path, your mission is to run, jump, and collect powerful elements and tasty treats, all while dodging deadly enemies lurking on the path! How to Play: Tap to jump over obstacles and evil creatures. Collect magical food and potion ingredients to boost your score. Use skill and timing to survive as long as you can &mdash; lives are limited, so every jump counts!",
    "instructions": "Save yourself from blocks try finding a way",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Math",
      "Number",
      "puzzleblock",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/k0whyluqu1exfjllnynqqeyaeaemjstx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k0whyluqu1exfjllnynqqeyaeaemjstx/",
    "sourceUrl": "https://html5.gamemonetize.com/k0whyluqu1exfjllnynqqeyaeaemjstx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71534",
    "slug": "royal-match-tile-family",
    "title": "Royal Match Tile Family",
    "description": "Play an addictive brain challenge in Royal Match Tile Family. This is not just another match puzzle game. It&rsquo;s a thrilling mix of logic, strategy, and quick thinking. Your goal is simple yet exciting: match tiles of the same design to clear the board. Unlock levels and rescue the royal family from tricky traps. Eliminate blocks, balls, and other objects in a limited number of moves. You can also use power-ups to quickly clear blocks or temporarily freeze obstacles.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Cute",
      "Funny",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/mnjub0iklzsmug2xuiq75v5qp8pem646/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mnjub0iklzsmug2xuiq75v5qp8pem646/",
    "sourceUrl": "https://html5.gamemonetize.com/mnjub0iklzsmug2xuiq75v5qp8pem646/",
    "width": 1600,
    "height": 900,
    "lastUpdated": ""
  },
  {
    "id": "71532",
    "slug": "super-zombie-driving",
    "title": "Super Zombie Driving",
    "description": "Super Zombie Driving throws you straight into a post-apocalyptic city overrun by the undead, where your only mission is to survive behind the wheel. In this thrilling action-packed driving game, every street is filled with zombies, wrecked cars, and chaos. Choose your vehicle, start the engine, and get ready to crush your way through hordes of zombies as you complete missions to clean up the streets and earn rewards. Each level challenges you to smash a specific number of zombies before time runs out, pushing your reflexes and driving skills to the limit.",
    "instructions": "WASD - Drive Space - Brake R - Restart Mouse - Rotate view",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Car",
      "Cars",
      "Driving",
      "Race",
      "Racing",
      "Unity3D",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/v90vdwuzah53dm2037cu0wo74xep0dqe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v90vdwuzah53dm2037cu0wo74xep0dqe/",
    "sourceUrl": "https://html5.gamemonetize.com/v90vdwuzah53dm2037cu0wo74xep0dqe/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71533",
    "slug": "many-bricks-breaker",
    "title": "Many Bricks Breaker",
    "description": "Welcome to Many Bricks Breaker, an addictive game where you can choose between two exciting modes: Classic and Many Bricks. Each mode features 100 challenging levels to test your skills. Enjoy breaking bricks, collecting cool boosters, and have fun!",
    "instructions": "Follow the game instructions",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Bricks"
    ],
    "thumbnail": "https://img.gamemonetize.com/rm0b1h5rhe1rwn8lfzsdc3sdsr18g0wf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rm0b1h5rhe1rwn8lfzsdc3sdsr18g0wf/",
    "sourceUrl": "https://html5.gamemonetize.com/rm0b1h5rhe1rwn8lfzsdc3sdsr18g0wf/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71547",
    "slug": "ice-cream-toppings",
    "title": "Ice Cream Toppings",
    "description": "Ice Cream Toppings is a delightful and fast-paced online game made especially for kids who love sweet challenges! At the top of the screen, you&rsquo;ll see a list of yummy ice cream orders waiting to be completed. Your mission is to match each order perfectly by adding the right toppings and flavors. Test your memory, speed, and creativity in this fun ice cream-making adventure!",
    "instructions": "Mouse to play",
    "category": "Cooking",
    "genres": [
      "Cooking"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Cooking",
      "Creation",
      "Funny",
      "Girls",
      "Hypercasual",
      "Matching",
      "Memory",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/b0ykbbsn67tx1enbc6zfm90xcd17qfxc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b0ykbbsn67tx1enbc6zfm90xcd17qfxc/",
    "sourceUrl": "https://html5.gamemonetize.com/b0ykbbsn67tx1enbc6zfm90xcd17qfxc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71470",
    "slug": "transform-battle",
    "title": "Transform Battle",
    "description": "This is an exciting Autobot game! You need to collect parts to upgrade and evolve your Autobots. Then, defeat the boss at each level to complete the game.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Adventure",
      "Battle",
      "Car"
    ],
    "thumbnail": "https://img.gamemonetize.com/fbch6sjalv1x5nxr11y6ca7jf62vovgq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fbch6sjalv1x5nxr11y6ca7jf62vovgq/",
    "sourceUrl": "https://html5.gamemonetize.com/fbch6sjalv1x5nxr11y6ca7jf62vovgq/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "71483",
    "slug": "tropical-tidy",
    "title": "Tropical Tidy",
    "description": "Welcome to Tropical Tidy &ndash; The Juiciest Sorting Puzzle! Escape to a vibrant tropical paradise where fruits are everywhere, and only the sharpest minds can bring order to the juicy chaos! In Tropical Tidy, your mission is to sort, match, and organize colorful fruits into their correct places before the board overflows. How to Play: Tap, drag, and place fruits into their matching containers. Strategize your moves to create perfect sorted stacks. Watch out &mdash; the puzzle gets trickier as more fruits appear! Clear levels, unlock new tropical backgrounds, and aim for high scores.",
    "instructions": "Select the food to move there",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Casual",
      "Food",
      "Fruits"
    ],
    "thumbnail": "https://img.gamemonetize.com/v6zo7dlvw59m77o64amfq2nlbvwahf0j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v6zo7dlvw59m77o64amfq2nlbvwahf0j/",
    "sourceUrl": "https://html5.gamemonetize.com/v6zo7dlvw59m77o64amfq2nlbvwahf0j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "16116",
    "slug": "parking",
    "title": "Parking",
    "description": "Test your logic through a hundred of levels that keep getting harder in this puzzle game. Move cars, bus and trailers and find the way to get your vehicle out of a totally crowded parking. An excellent game for the waiting times… in the rush hours! Parking Panic is an amusing game for the whole family! Only recommended for... everyone!",
    "instructions": "Test your logic through a hundred of levels that keep getting harder in this puzzle game Move cars bus and trailers and find the way to get your vehicle out of a totally crowded parking An excellent game for the waiting times in the rush hours Par",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Baby",
      "Baby Hazel",
      "Boy",
      "Boys",
      "Brain",
      "Car",
      "Cars",
      "Classic",
      "Fun",
      "Funny",
      "Game",
      "Games",
      "Kid",
      "Kids",
      "Puzzle",
      "Supercars"
    ],
    "thumbnail": "https://img.gamemonetize.com/r6wiuzzpu0d8jvb2rfw0gutuxmyfd085/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r6wiuzzpu0d8jvb2rfw0gutuxmyfd085/",
    "sourceUrl": "https://html5.gamemonetize.com/r6wiuzzpu0d8jvb2rfw0gutuxmyfd085/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "62680",
    "slug": "ball-sort-puzzle-free",
    "title": "Ball Sort Puzzle Free",
    "description": "Ball Sort Puzzle is a challenging puzzle game that will keep you entertained for hours! Sort the colored balls in the tubes until all of the same-hued balls are in the same tube. A brain-teasing game that is both tough and relaxing!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "amazing",
      "Ball",
      "Brain",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/sd072z9zvvalrwbem1ha83dl7vep0so0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sd072z9zvvalrwbem1ha83dl7vep0so0/",
    "sourceUrl": "https://html5.gamemonetize.com/sd072z9zvvalrwbem1ha83dl7vep0so0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "64360",
    "slug": "puzzle-minecraft",
    "title": "Puzzle Minecraft",
    "description": "&iexcl;Bienvenido a Minecraft Puzzle Crafter, el juego web definitivo para los amantes de los rompecabezas y el universo c&uacute;bico de Minecraft! Sum&eacute;rgete en una experiencia &uacute;nica donde deber&aacute;s poner a prueba tu l&oacute;gica, memoria visual y paciencia mientras armas rompecabezas creados a partir de impresionantes im&aacute;genes del mundo Minecraft.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Classic",
      "Minecraft",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/nmfrjvpgbf7b6qab1i5pc79zqc67xp7h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nmfrjvpgbf7b6qab1i5pc79zqc67xp7h/",
    "sourceUrl": "https://html5.gamemonetize.com/nmfrjvpgbf7b6qab1i5pc79zqc67xp7h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64077",
    "slug": "ninja-poof",
    "title": "Ninja Poof",
    "description": "Ninja Poof is a fast-paced HTML5 game where you vanish, strike, and dodge enemies like a true stealth master. Quick reflexes and clever tactics will help you complete every level with style. ovechkin, uconn vs ucla, dodgers vs phillies, nuggets vs warriors, pelicans vs lakers, everton vs arsenal, julio jones, dylan grant, texas vs south carolina, yankees vs pirates, fighting oligarchy tour, thunder vs rockets, cavaliers vs spurs, cardinals vs red sox, marlins vs braves, mavericks vs clippers, mariners vs giants, guardians vs angels, quer&eacute;taro - le&oacute;n, dc vs csk, irs stimulus check, suns vs celtics, white sox.",
    "instructions": "use your left mouse button to dodgle the blades",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "amazing",
      "Arcade",
      "Avoid",
      "Best Games",
      "Click",
      "Clicker",
      "dash",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/iv0rr9mpq9q1de8da57me49fslkhtzdy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iv0rr9mpq9q1de8da57me49fslkhtzdy/",
    "sourceUrl": "https://html5.gamemonetize.com/iv0rr9mpq9q1de8da57me49fslkhtzdy/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71505",
    "slug": "idle-space-miner-tycoon",
    "title": "Idle Space Miner Tycoon",
    "description": "Take charge of your own space mining company and establish a global empire! Begin with a single drill and go from automated drills to controlling enormous Stellar Refinery Hubs and obtaining valuable Credits from gas giants and asteroids throughout the galaxy.",
    "instructions": "Use the mouse or touch controls to play Your objective is straightforward enhance your Credits Per Second CPS by implementing strategic upgrades and intelligent automation",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Clicker",
      "idle",
      "Miner",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/okleig3hu0svc45xwhme8vvnxi5bfij5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/okleig3hu0svc45xwhme8vvnxi5bfij5/",
    "sourceUrl": "https://html5.gamemonetize.com/okleig3hu0svc45xwhme8vvnxi5bfij5/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "71432",
    "slug": "fantasy-brothers",
    "title": "Fantasy Brothers",
    "description": "Fantasy Brothers is a game where two young brothers are locked up in a beautiful fantasy world, trying to escape. It&rsquo;s a 2D puzzle game where you will enjoy their adventure full of danger. Be sure to collect as many keys during your adventure, so that you will be later able to unlock the door, allowing the brothers to escape.",
    "instructions": "Use the keyboard and mouse to play Use screen buttons on mobile",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Best Games",
      "Fantasy",
      "free games for your site",
      "html5 games for your site",
      "Kiz 10",
      "Levels",
      "Multiplayer",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/46jiqbgtn5c2q2r0wvvld9uodd63vxur/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/46jiqbgtn5c2q2r0wvvld9uodd63vxur/",
    "sourceUrl": "https://html5.gamemonetize.com/46jiqbgtn5c2q2r0wvvld9uodd63vxur/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "71437",
    "slug": "runaway-the-truck",
    "title": "Runaway The Truck",
    "description": "This is a lightweight but rich truck racing game. You can get a variety of trucks and scenes to experience the exciting racing game!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "Car",
      "Hypercasual",
      "Physics",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/bjlu92617ddcmzv9xdrqp1bi6fd0p36g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bjlu92617ddcmzv9xdrqp1bi6fd0p36g/",
    "sourceUrl": "https://html5.gamemonetize.com/bjlu92617ddcmzv9xdrqp1bi6fd0p36g/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "70798",
    "slug": "mega-car-stunt-ramps-games",
    "title": "Mega Car Stunt Ramps Games",
    "description": "Ramp up your skills in driving games with these meticulously designed stunt games 2025 and Car Games 3d. With car games 3d Ramp up, your skills in the car driving games 3D with these meticulously designed stunt games 2025 . This stunt car driving simulator game offers new challenges on mega ramps as your preferred game to enchant your senses via the car game 3d 2025. Drive through untraversed sky tracks filled with incredible challenges requiring fantastic car stunts in your car game 2025. In these impossible mega ramp car stunt racing games, every stage accompanies exciting news and offers fabulous car stunt driving game.",
    "instructions": "Mouse click or tap to play and keyboard arrow use to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Car",
      "Cars",
      "Race",
      "Racing",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/xfv68lv141kcpoawuqlrv9jh0wxrbxtl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xfv68lv141kcpoawuqlrv9jh0wxrbxtl/",
    "sourceUrl": "https://html5.gamemonetize.com/xfv68lv141kcpoawuqlrv9jh0wxrbxtl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71370",
    "slug": "family-squid-challenge",
    "title": "Family Squid Challenge",
    "description": "Hey Player, bring your friend along and team up in this Squid adventure! There are black and red masked men everywhere, so you must be very careful. Run from them and collect the keys to complete the level. Be cautious &mdash; both of you need to survive!",
    "instructions": "Use the WASD and Arrow keys to move Jump on enemies to defeat them Collect the blue and red keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2D",
      "Action",
      "Arcade",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/iaw5drfuhjevngpoyyfbl3ikj08ab1ld/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iaw5drfuhjevngpoyyfbl3ikj08ab1ld/",
    "sourceUrl": "https://html5.gamemonetize.com/iaw5drfuhjevngpoyyfbl3ikj08ab1ld/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71360",
    "slug": "fireball-dodge",
    "title": "Fireball Dodge",
    "description": "Fireball Dodge &ndash; Endless Survival Arcade Adventure Welcome to Fireball Dodge, an action-packed endless survival game where your reflexes and focus are tested against the fiery wrath of a relentless fireball. Whether you&rsquo;re a casual gamer looking for quick fun or a competitive player aiming to climb the leaderboards, Fireball Dodge promises fast-paced excitement, addictive coin-collecting challenges, and nonstop replay value. In this game, your one and only mission is simple yet thrilling: dodge the fireball and survive for as long as possible while collecting coins to boost your score. The longer you last, the higher your score climbs easy..",
    "instructions": "Mobile Users Swipe left or right using on-screen buttons PC Users Use the Left and Right Arrow Keys to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Action",
      "Ball",
      "Defense",
      "endless"
    ],
    "thumbnail": "https://img.gamemonetize.com/jt4uxh4hwefwyaj99x0w18qakp85nug9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jt4uxh4hwefwyaj99x0w18qakp85nug9/",
    "sourceUrl": "https://html5.gamemonetize.com/jt4uxh4hwefwyaj99x0w18qakp85nug9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71438",
    "slug": "obby-jigsaw",
    "title": "Obby Jigsaw",
    "description": "Obby Jigsaw is a game where you are presented with a total of twelve different, but always interesting colorful pictures, each of which has four sets of fragments. The choice is free. You can choose any picture and any set of fragments according to your level and experience in assembling puzzles. In addition, during the construction you can add or disable the rotation option and the background display. Enjoy the game and get ready.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Best",
      "Best Games",
      "Jigsaw",
      "Kids",
      "Mobile",
      "roblox",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/corjd98b28gf4jaterusht0imrep0gcp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/corjd98b28gf4jaterusht0imrep0gcp/",
    "sourceUrl": "https://html5.gamemonetize.com/corjd98b28gf4jaterusht0imrep0gcp/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71369",
    "slug": "little-bubu-fillz",
    "title": "Little Bubu Fillz",
    "description": "Little Bubu Fillz is a relaxing yet challenging level puzzle game where every move matters! Meet Bubu, the adorable bunny who loves solving puzzles. Your task is simple&mdash;swipe to fill every block on the board. But don&rsquo;t be fooled by the cute looks; as levels progress, puzzles become trickier and require more thinking. You must plan your swipes carefully to cover every tile without missing any. With its colorful design, cheerful sound, and smooth gameplay, Little Bubu Fillz is perfect for all ages. Sharpen your brain and enjoy hours of calm, fun puzzle-solving with Bubu!",
    "instructions": "Desktop Controls Mouse Click Drag Swipe to fill path Mobile Controls Tap Swipe Fill the tiles with Bubu",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ai Games",
      "Arcade",
      "Casual",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "HTML",
      "html games for your website",
      "HTML5",
      "html5 games",
      "html5 games for your site",
      "Hypercasual",
      "Online",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/b3wwfhw4bq2gcdb8q1mg53ojsz1qjiiw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b3wwfhw4bq2gcdb8q1mg53ojsz1qjiiw/",
    "sourceUrl": "https://html5.gamemonetize.com/b3wwfhw4bq2gcdb8q1mg53ojsz1qjiiw/",
    "width": 1280,
    "height": 2560,
    "lastUpdated": ""
  },
  {
    "id": "71089",
    "slug": "pinata-fiesta-slots",
    "title": "Pinata Fiesta Slots",
    "description": "Experience the thrill of a real casino slot machine from the comfort of your home with Pi&ntilde;ata Party Slots! This vibrant, Mexican-fiesta-themed game brings colorful pi&ntilde;atas, exciting bonuses, and the exclusive Respin feature &ndash; where every spin could trigger another chance to win big! [RESPIN GAMES] 6 or more [respin] trigger Respin Game. During Respins Games, any extra [respin] will reset the number of Respins back to 3. If [respin] appearing on the grid can form a larger square, [respin] will become bigger and occupy the larger square. The Respin Games can be instantly triggered from the base game by buying for it for 100x current bet.",
    "instructions": "Click the SPIN button",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Arcade",
      "Casino",
      "Slot Machine"
    ],
    "thumbnail": "https://img.gamemonetize.com/xdyftm223gh5010i1kh0620m39g4oxiy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xdyftm223gh5010i1kh0620m39g4oxiy/",
    "sourceUrl": "https://html5.gamemonetize.com/xdyftm223gh5010i1kh0620m39g4oxiy/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71396",
    "slug": "labuba-halloween-infestation",
    "title": "Labuba Halloween Infestation",
    "description": "Monsters are invading Halloween! You must destroy them all &mdash; the fate of Halloween is in your hands. The game features three different modes, each with tougher and more powerful monsters. Defeat the monsters and reach the end of the level. But it doesn&rsquo;t end there &mdash; at the end of each stage, you&rsquo;ll face the strongest and biggest of them all: the Boss Monster. Defeat it to complete the level!The game is playable on both mobile and PC, so you can hunt monsters anytime, anywhere. You can purchase various costumes to change your appearance. There are also Pumpkin Boosts in the game &mdash; each boost grants different powers and abilities. Buy boost",
    "instructions": "Click the Fire button to shoot or use your mouse to shoot when playing on PC Use the WASD and Arrow keys to move",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Halloween",
      "Labubu",
      "Platform",
      "Shoot",
      "Shooter",
      "Shooting",
      "Side Scrolling"
    ],
    "thumbnail": "https://img.gamemonetize.com/8u5s79o9rln2v42voc0xw80fmdrz8w51/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8u5s79o9rln2v42voc0xw80fmdrz8w51/",
    "sourceUrl": "https://html5.gamemonetize.com/8u5s79o9rln2v42voc0xw80fmdrz8w51/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71397",
    "slug": "wordly",
    "title": "WORDLY",
    "description": "Wordly is a fun and relaxing word puzzle game that trains your mind and vocabulary while keeping you entertained. Your goal is simple: form the target word by tapping the letters in the correct order. Each level brings a new challenge with words of increasing difficulty. Earn 15 coins for every correct answer and lose 15 for mistakes - so think carefully before you tap! You have five attempts per level; fail them all and it&rsquo;s game over. Use a Hint to reveal the first letter of the hidden word or Shuffle the tiles for a fresh perspective. The game is suitable for everyone!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Family",
      "Letters",
      "Logic",
      "mapi games",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/vy809reourjzmnf76c7l3b2sj7k2la96/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vy809reourjzmnf76c7l3b2sj7k2la96/",
    "sourceUrl": "https://html5.gamemonetize.com/vy809reourjzmnf76c7l3b2sj7k2la96/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71313",
    "slug": "magic-farm-clicker",
    "title": "Magic Farm : Clicker",
    "description": "Magic Farm Clicker is a fun and relaxing incremental game where every click helps your enchanted farm grow. Start with a single seed, harvest magical crops, and unlock upgrades to expand your fields. Discover rare plants, automate your harvest, and watch your farm transform into a flourishing magical paradise. How far can you grow your enchanted garden?",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player"
    ],
    "thumbnail": "https://img.gamemonetize.com/aufgnrly23b8jkw7eafbg04b5vxt7bz2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aufgnrly23b8jkw7eafbg04b5vxt7bz2/",
    "sourceUrl": "https://html5.gamemonetize.com/aufgnrly23b8jkw7eafbg04b5vxt7bz2/",
    "width": 407,
    "height": 882,
    "lastUpdated": ""
  },
  {
    "id": "71430",
    "slug": "color-3d-bump-it-up",
    "title": "Color 3D   Bump it Up",
    "description": "The main principle is pretty simple &ndash; you are controlling a small ball that is always moving forward. On your way, there are a few obstacles that you need to get through. There&rsquo;s a small problem however, because you can only touch obstacles that are the same color as your ball. If you touch an obstacle with a different color, the game ends and you need to start from the beginning.",
    "instructions": "Mouse control to swipe",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/4h4wmuul3lx4323pp1ju8cz6vzx37n99/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4h4wmuul3lx4323pp1ju8cz6vzx37n99/",
    "sourceUrl": "https://html5.gamemonetize.com/4h4wmuul3lx4323pp1ju8cz6vzx37n99/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69597",
    "slug": "square-sort-mania",
    "title": "Square Sort Mania",
    "description": "Square Sort Mania is a fresh, addictive hybrid casual puzzle game. Players place layered square blocks, each with four concentric colored layers onto a grid. If the outermost color of the placed block matches the outermost color of any adjacent block, both blocks destroy in a satisfying pop. This can trigger chain reactions, with the next inner color becoming the new outer layer and repeating the destruction sequence. The result is a visually explosive and strategic experience that blends puzzle-solving with match-style satisfaction.",
    "instructions": "Mouse Touch Click amp Drag or Tap amp Drag ndash Pick up a square and move it Release ndash Drop the square in a desired stack or slot Quick Tap ndash Instantly place a square into a highlighted valid position Esc Tab ndash Open the me",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "amazing",
      "Block",
      "Match 3",
      "Matching",
      "sort",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/m0insptnj0ivme8bm25rn8pd4wbwdb0r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m0insptnj0ivme8bm25rn8pd4wbwdb0r/",
    "sourceUrl": "https://html5.gamemonetize.com/m0insptnj0ivme8bm25rn8pd4wbwdb0r/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71315",
    "slug": "fashion-heroes-academy",
    "title": "Fashion Heroes Academy",
    "description": "Welcome to the Academy of Fashion Heroines, a place where style and superpowers go hand in hand! Three brave girls entered the academy in order not only to reveal their abilities, but also to create their own unique image. And you will help them in this. Choose outfits for studying, training and super battles. Experiment with makeup and accessories. Let each schoolgirl become a superhero and a style icon at the same time!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Dress Up",
      "Fashion",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/8gi5sdgybd82plgp6uwif12tdv41tml8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8gi5sdgybd82plgp6uwif12tdv41tml8/",
    "sourceUrl": "https://html5.gamemonetize.com/8gi5sdgybd82plgp6uwif12tdv41tml8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71283",
    "slug": "arcanoid-space-defense",
    "title": "Arcanoid Space Defense",
    "description": "Get ready for an explosive arcade adventure! Arcanoid Space Defense reimagines the classic block-breaker with a cosmic twist. Pilot your defense turret, blast through waves of alien geometric invaders, and protect the galaxy. Web Dev <a href='https://www.bestcrazygames.com/.'>https://www.bestcrazygames.com/.</a> Use powerful upgrades and strategic shots to shatter every hostile block.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Arkanoid",
      "Shooting",
      "Skill",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/907p9cfuaqil6tsntnopimketvhh2ofk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/907p9cfuaqil6tsntnopimketvhh2ofk/",
    "sourceUrl": "https://html5.gamemonetize.com/907p9cfuaqil6tsntnopimketvhh2ofk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71110",
    "slug": "geometry-dash-ultra-mega-mod-playground",
    "title": "Geometry Dash: Ultra Mega MOD Playground!",
    "description": "Immerse yourself in the epic world of Ultra Mega Mod on Geometry Dash Playground right now! The game features a wide variety of characters from the Geometry Dash world, each with their own cool abilities and varying levels of health. Discover them all and conduct the most insane experiments! Additionally, the game includes an automatic machine and a portal gun, making your experiments even more exciting!",
    "instructions": "To place a character weapon or object on the game board simply click on the button with its image and it will appear on the game board You can move objects and characters by simply holding them down Each character has its own health bar and some c",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Classic",
      "crash",
      "Crazy",
      "dash",
      "free games for your website",
      "free html5 games for your website",
      "Fun",
      "Funny",
      "Geometry",
      "Sandbox",
      "unity",
      "unity games",
      "unity games for your website",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/xv5isigf7nugyjabpavjwand3ycapo69/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xv5isigf7nugyjabpavjwand3ycapo69/",
    "sourceUrl": "https://html5.gamemonetize.com/xv5isigf7nugyjabpavjwand3ycapo69/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70681",
    "slug": "the-maze",
    "title": "The Maze",
    "description": "Welcome to THE MAZE! Get ready to dive into a glowing, neon world of classic arcade action! THE MAZE is a fast-paced, retro-style chase game where quick reflexes and sharp turns are your only way to survive. The rules are simple, but the challenge is anything but. Do you have what it takes to outsmart your hunters and escape? The Objective Your goal is to navigate each level of the glowing maze, collect all three Stars, and reach the green Exit Portal before youre caught! How to Play: The Rules Collect Everything: The maze is filled with small pink energy nodes. Collect them all to maximize your score. Find the Stars: Your main objective",
    "instructions": "Of course Here is a description for your website that explains the game rules and controls for THE MAZE written in a simple but explicit style with clear examples Welcome to THE MAZE Get ready to dive into a glowing neon world of classic arcade actio",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Adventure",
      "Animal",
      "Arcade",
      "Best",
      "Best Games",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/4tkaqd30dk3zo7ilbu1bpfsj7ii5wwy9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4tkaqd30dk3zo7ilbu1bpfsj7ii5wwy9/",
    "sourceUrl": "https://html5.gamemonetize.com/4tkaqd30dk3zo7ilbu1bpfsj7ii5wwy9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71012",
    "slug": "koko-loco-block-blast",
    "title": "Koko Loco Block Blast",
    "description": "Think fast, blast smart &mdash; can you beat your best score? Blast blocks, fit shapes, outsmart the grid. Get ready for some block-busting fun with a brainy twist! This fast-paced puzzle game combines colourful block blasting with the challenge of fitting each new set of 3 shapes onto the board. Every move matters &mdash; clear space, chain combos, and keep the grid from filling up! With smooth controls and quick rounds, it&rsquo;s perfect for casual play, but players who love to plan ahead and outsmart the board will find endless ways to challenge their brains. Easy to pick up, hard to put down &mdash; can you climb the high score ladder?",
    "instructions": "- Mouse Click and drag to place shapes - Touch Mobile Tap and drag to place shapes Tips Combo System Overview The combo mechanic rewards players for consistently clearing lines Keeping the Combo Alive After starting a combo you must clear at least",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "blockchain",
      "blocky",
      "Board",
      "Brain",
      "Bricks",
      "Casual",
      "Classic",
      "Cool",
      "Cute",
      "destroy",
      "endless",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/f5g89vmko0f0aezofpkzhhjm0b9arl5f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f5g89vmko0f0aezofpkzhhjm0b9arl5f/",
    "sourceUrl": "https://html5.gamemonetize.com/f5g89vmko0f0aezofpkzhhjm0b9arl5f/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "70501",
    "slug": "ultimate-bottle-flip-game",
    "title": "Ultimate Bottle Flip Game",
    "description": "Offline Master Bottle 3D: Tap, Flip &amp; Jump, the ultimate bottle flipping adventure where excitement meets challenge! Master the art of flipping a water bottle and embark on an exhilarating parkour frenzy. Tap to flip, spin, and jump your bottle to achieve your goals. With endless tricks and challenges, this bottle game is sure to keep you hooked! FEATURES - Stunning Graphics: Immerse yourself in visually striking bottle flipping action. - Diverse Challenges: Tackle a wide range of challenges that test your flipping prowess. - Relax and Play: Unwind with easy tap game controls.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "Adventure",
      "amazing",
      "Brainrot"
    ],
    "thumbnail": "https://img.gamemonetize.com/ralvylg9mlb81zphmf70vo2f3k0u777w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ralvylg9mlb81zphmf70vo2f3k0u777w/",
    "sourceUrl": "https://html5.gamemonetize.com/ralvylg9mlb81zphmf70vo2f3k0u777w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71242",
    "slug": "jumper-jam",
    "title": "Jumper jam",
    "description": "Gameplay is similar to the Doodle Jump game. ABOUT THE GAME Welcome to Jumper jam - an exciting arcade game where simple controls meet adrenaline-packed gameplay! Control a cute character, collect shiny coins, and set new records in this colorful browser-based game.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/vz014sa1b6hbw3jquxwgn98xhzux2uhz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vz014sa1b6hbw3jquxwgn98xhzux2uhz/",
    "sourceUrl": "https://html5.gamemonetize.com/vz014sa1b6hbw3jquxwgn98xhzux2uhz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71282",
    "slug": "space-ark-shooter",
    "title": "Space Ark Shooter",
    "description": "Destroy all blocks and enemy ships to clear the sector. Smash through colorful bricks while alien ships dive to take you out. Use your paddle cannons, control the ball, and face random bosses across unique levels. Web Dev <a href='https://www.kizi10.org/.'>https://www.kizi10.org/.</a> Fast, clean, and punchy&mdash;classic arcade feel with a space-combat twist.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Ai Games",
      "Arcade",
      "Arkanoid",
      "Games Ai",
      "HTML5"
    ],
    "thumbnail": "https://img.gamemonetize.com/52fsj10g947npnukuf2i6tttdom1lhza/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/52fsj10g947npnukuf2i6tttdom1lhza/",
    "sourceUrl": "https://html5.gamemonetize.com/52fsj10g947npnukuf2i6tttdom1lhza/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69284",
    "slug": "wood-cutter-clicker",
    "title": "Wood Cutter Clicker",
    "description": "Wood Cutter Clicker is an addictive idle clicker game where you chop trees, collect wood, and upgrade your axe to become the ultimate lumberjack. With endless levels and progressive challenges, this casual tree-cutting simulator offers nonstop tapping action and resource management. Perfect for fans of clicker, idle, and tycoon games, it blends fast-paced gameplay with satisfying upgrades and wood-cutting mechanics. Build your cutting speed, unlock new tools, and see how far your chopping skills can take you.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Click",
      "Clicker",
      "cut",
      "Hypercasual",
      "Slicing",
      "tree"
    ],
    "thumbnail": "https://img.gamemonetize.com/m8f61epfu8r1owr18qu4sgkwp1pnf7mf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m8f61epfu8r1owr18qu4sgkwp1pnf7mf/",
    "sourceUrl": "https://html5.gamemonetize.com/m8f61epfu8r1owr18qu4sgkwp1pnf7mf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "63277",
    "slug": "drive-and-avoid",
    "title": "Drive and Avoid!",
    "description": "As you drive your way level by level and escape the evil orb from destroying your health with your blue car! Dodge as many car obstacles as you can and prepare for levels raising difficulty! Be alert at all times when driving in this game because youll need to restart your journey if you ever run out of health! Challenge your reflexes, and make sure to put your thinking caps on when dodging with all your might. Introducing 30 levels, where 1st level is the easiest, and the last level can be pretty challenging depending on your skill level! Your character The Blue Car must dodge and avoid other cars, and the evil orbs fired spheres!",
    "instructions": "Using left or right keyboard keys to move or left clicking with mouse the left or right buttons",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Avoid",
      "Ball",
      "Bullet",
      "Car",
      "dash",
      "Enemies",
      "Game",
      "HTML",
      "Level",
      "Levels",
      "Obstacle",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/u86fh1bsoacxgocn89rlxzoqu169s3sk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u86fh1bsoacxgocn89rlxzoqu169s3sk/",
    "sourceUrl": "https://html5.gamemonetize.com/u86fh1bsoacxgocn89rlxzoqu169s3sk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71062",
    "slug": "candy-match-3-kit-2025",
    "title": "CANDY MATCH 3 KIT 2025",
    "description": "Candy Match 3 is a fun and addictive puzzle game that challenges your mind while satisfying your sweet tooth! Match three or more colorful candies in a row to clear the board and unlock exciting power-ups. With each level, the puzzles get trickier, keeping you entertained for hours of gameplay. Features: Bright and vibrant candy-themed graphics Easy to play, hard to master mechanics Special boosters and combos for extra fun Hundreds of challenging levels Relaxing gameplay perfect for all ages Get ready to swap, match, and crush your way through a world full of sugary puzzles. Play Candy Match 3 now and see how far you can go!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Hypercasual",
      "Match 3",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/b4fj2duqnsxijnxvr8r4k4evkxm74zhv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b4fj2duqnsxijnxvr8r4k4evkxm74zhv/",
    "sourceUrl": "https://html5.gamemonetize.com/b4fj2duqnsxijnxvr8r4k4evkxm74zhv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70775",
    "slug": "fit-runner",
    "title": "Fit Runner",
    "description": "Welcome Gamers!! Lets play fun and Fit race and make the body from fat or fit instantly and see the cool and funny body shapes by just collecting different amount of foods and see the impact instantly.!!",
    "instructions": "- Simple Control - Click Mouse Tap to play - Swipe Left and Right",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D Games",
      "Adventure",
      "amazing",
      "Android",
      "Hunting",
      "Race",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/hu9dcb8ca0utzguv6w7sixmipbfur454/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hu9dcb8ca0utzguv6w7sixmipbfur454/",
    "sourceUrl": "https://html5.gamemonetize.com/hu9dcb8ca0utzguv6w7sixmipbfur454/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70869",
    "slug": "celebrity-selen-all-around-the-fashion",
    "title": "Celebrity Selen All Around The Fashion",
    "description": "Welcome to Celebrity Selen All Around The Fashion. Celebrity Selen plans to try different fashion trends. She needs some help to choose the perfect costumes and outfits. Browse her wardrobe and choose the perfect outfits for each fashion trend. Play and have fun with this new game!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/6gm0yj0xl4loiccuoaj7xwf6uljjkrae/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6gm0yj0xl4loiccuoaj7xwf6uljjkrae/",
    "sourceUrl": "https://html5.gamemonetize.com/6gm0yj0xl4loiccuoaj7xwf6uljjkrae/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70655",
    "slug": "pinpoint",
    "title": "PinPoint",
    "description": "PinPoint is a fast-paced precision arcade game where timing is everything. With every turn, you&rsquo;re given a number &mdash; and that&rsquo;s exactly how many arrows you must launch at a rotating circle. The challenge? Each arrow must land cleanly without colliding into the others already in place. As the circle speeds up, slows down, or even changes direction, your reflexes and focus will be put to the test. Every perfect shot pushes your score higher, while a single wrong move ends the round. Key Features: Addictive one-tap gameplay that&rsquo;s easy to learn, hard to master. Dynamic rotating circles with unpredictable patterns.",
    "instructions": "Throw at the right time never hit another stick",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Stickman",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/atfzvgw0dimq43adk5q3n8tyfhgme9bd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/atfzvgw0dimq43adk5q3n8tyfhgme9bd/",
    "sourceUrl": "https://html5.gamemonetize.com/atfzvgw0dimq43adk5q3n8tyfhgme9bd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71260",
    "slug": "sins-and-desires",
    "title": "Sins and Desires",
    "description": "&ldquo;Sins and Desires&rdquo; is a captivating visual novel in the detective genre with romance elements. As detective Felicia, you travel to the village of West-Alben to uncover the mystery of aristocrat William&rsquo;s disappearance. Experience an interactive story with branching choices, a relationship system that affects the ending, and romance routes with Albert, Felix, and Victor. The atmosphere of a dark mansion, a foggy lake, and a village full of secrets keeps you intrigued. Every choice matters - will you uncover the truth or fall into the shadows of West-Alben&rsquo;s sins and desires?",
    "instructions": "In ldquo Sins and Desires rdquo you play as detective Felicia investigating the disappearance of an aristocrat in the village of West-Alben This is a visual novel with a mystery story romance and branching choices",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Best Games",
      "Casual",
      "Detective",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "Games",
      "games for your website",
      "html games for your website",
      "html5 games",
      "html5 games for your site"
    ],
    "thumbnail": "https://img.gamemonetize.com/6nn7f0o949kziyd9skhj87tdiipxmeq2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6nn7f0o949kziyd9skhj87tdiipxmeq2/",
    "sourceUrl": "https://html5.gamemonetize.com/6nn7f0o949kziyd9skhj87tdiipxmeq2/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71237",
    "slug": "truck-simulation",
    "title": "Truck Simulation",
    "description": "Truck Simulation gives you the chance to step into the life of a real trucker! Start your journey as the driver of a modest old truck and climb your way up to becoming the proud owner of a massive trucking company. Experience the thrill of long-haul driving, master realistic controls, and explore a huge open world full of challenges and opportunities.",
    "instructions": "Mouse to view the camera Keys W-A-S-D to control the car Space - handbrake C - change camera view H - horn T - gear up G - gear down Esc - pause",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Boys",
      "Car",
      "Driving",
      "Racing",
      "Simulation",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/ldyyypn720nku1dw3yyq2x4nwzhtid7z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ldyyypn720nku1dw3yyq2x4nwzhtid7z/",
    "sourceUrl": "https://html5.gamemonetize.com/ldyyypn720nku1dw3yyq2x4nwzhtid7z/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71188",
    "slug": "glow-blocks",
    "title": "Glow Blocks",
    "description": "Glow Blocks is a vibrant neon puzzle game inspired by the timeless classic Tetris. Stack glowing blocks in a futuristic grid, clear full lines, and climb through endless levels as the speed increases. With its colorful neon visuals, cyberpunk atmosphere, and smooth gameplay, Glow Blocks is both nostalgic and fresh. Challenge yourself to beat your high score, enjoy the glowing effects, and test your reflexes in this addictive endless puzzle experience!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Block",
      "mapi games",
      "Tetris"
    ],
    "thumbnail": "https://img.gamemonetize.com/6ijb9ae9x9a7c6iodq6pfokdkp4p8hm1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6ijb9ae9x9a7c6iodq6pfokdkp4p8hm1/",
    "sourceUrl": "https://html5.gamemonetize.com/6ijb9ae9x9a7c6iodq6pfokdkp4p8hm1/",
    "width": 300,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71173",
    "slug": "hero-inc",
    "title": "Hero Inc",
    "description": "Step into a thrilling 3D adventure RPG! Control your hero, explore mysterious levels, fight dangerous enemies, and unlock powerful skills. Pass challenging quests, defeat epic bosses, and protect the world. Are you ready for the ultimate action adventure?",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "Action",
      "Adventure",
      "RPG"
    ],
    "thumbnail": "https://img.gamemonetize.com/f622arfy65iwdazrrp916b8etouotp81/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f622arfy65iwdazrrp916b8etouotp81/",
    "sourceUrl": "https://html5.gamemonetize.com/f622arfy65iwdazrrp916b8etouotp81/",
    "width": 720,
    "height": 1600,
    "lastUpdated": ""
  },
  {
    "id": "71156",
    "slug": "four-in-a-row",
    "title": "Four in a Row",
    "description": "Four in a Row is the classic strategy board game you know and love, now in a colorful digital version! Drop your red or yellow discs into the grid and try to be the first to line up four in a row - vertically, horizontally, or diagonally. Play against the computer with increasing difficulty levels or challenge a friend in local 2-player mode. With smooth gameplay, fun sound effects, and a bright cool style, this game is perfect for all ages. Can you outsmart your opponent and claim victory?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Clicker",
      "HTML5",
      "mapi games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/qiqyhqdyht8hiys5n2lhn1jffcxjbvj3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qiqyhqdyht8hiys5n2lhn1jffcxjbvj3/",
    "sourceUrl": "https://html5.gamemonetize.com/qiqyhqdyht8hiys5n2lhn1jffcxjbvj3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71240",
    "slug": "classic-checkers-forest",
    "title": "Classic Checkers: Forest",
    "description": "A captivating board game set in a unique forest-themed atmosphere! Enjoy classic checkers rules surrounded by nature. Sharpen your strategic thinking, challenge friends or AI, and immerse yourself in a relaxing yet exciting experience. Perfect for all ages!",
    "instructions": "Dont forget to customize the game to your liking giveaway mode mandatory captures and other settings are available in the menu Choose your game mode play against the computer or share the board with a friend Move your pieces according to the classic",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2D",
      "Ai Games",
      "Best Games",
      "Board",
      "Brain",
      "Casual",
      "Classic",
      "Logic",
      "Logical",
      "Strategy",
      "two player games"
    ],
    "thumbnail": "https://img.gamemonetize.com/v7ec9hsu8m34cjuetzz8dj7zaasd3fpx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v7ec9hsu8m34cjuetzz8dj7zaasd3fpx/",
    "sourceUrl": "https://html5.gamemonetize.com/v7ec9hsu8m34cjuetzz8dj7zaasd3fpx/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71235",
    "slug": "farm-defense",
    "title": "Farm Defense",
    "description": "Survive against waves of bizarre monsters trying to invade your farm. Collect temporary power-ups like rapid fire, explosive ammo, health packs, and electric fences. At the end of each stage, pick from random upgrades, unlock new weapons, deploy crop duster airstrikes, slow enemies with traps, or grab a magnet to pull power-ups. Progress further to unlock new playable heroes with unique styles.",
    "instructions": "Move with Arrow Keys WASD press Space to turn around",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Best Games",
      "Defense",
      "Farm",
      "Fighting",
      "Fun",
      "Monster",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/ig17s0sns5301kokmitnvl9ml688pw9q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ig17s0sns5301kokmitnvl9ml688pw9q/",
    "sourceUrl": "https://html5.gamemonetize.com/ig17s0sns5301kokmitnvl9ml688pw9q/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71055",
    "slug": "the-mobs-farm-in-mineblock",
    "title": "The Mobs Farm in Mineblock!",
    "description": "The legendary mob farm in Mine is back and ready to introduce you to a lot of new content right now! In the game, your goal is to upgrade your farm so that it can destroy mobs more effectively. You have access to a wide range of epic items that can help you defeat enemies faster and easier. As you defeat mobs, you will earn money that you can use to unlock new mobs, purchase new saws, and increase their damage.",
    "instructions": "Select the item you want to place on the game board and click on it Then select the mob you want to destroy and click on it to place it on the game board Each mob has its own health and mass and some have unique abilities Some of them can even help yo",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "2D",
      "amazing",
      "Android",
      "Best",
      "Best Games",
      "Bomb",
      "Classic",
      "Crazy",
      "free games for your website",
      "Minecraft",
      "Sandbox",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/twjj5hopodmbqfqyyg3x4n4lw0qcs1be/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/twjj5hopodmbqfqyyg3x4n4lw0qcs1be/",
    "sourceUrl": "https://html5.gamemonetize.com/twjj5hopodmbqfqyyg3x4n4lw0qcs1be/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71164",
    "slug": "tung-tung-sahur-funny-face",
    "title": "Tung Tung Sahur Funny Face",
    "description": "Tung Tung Sahur Funny Face brings the legendary sahur drummer into a world of laughter! Stretch, twist, and mash his wooden face into the goofiest expressions ever. From wide-eyed shock to hilarious squishy smiles, every creation is pure comedy gold.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "Ai Games",
      "Android",
      "Animal",
      "attack",
      "Baby",
      "Draw",
      "Drawing",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/3obnes4rseady52wfy5wyxt50o1y2fej/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3obnes4rseady52wfy5wyxt50o1y2fej/",
    "sourceUrl": "https://html5.gamemonetize.com/3obnes4rseady52wfy5wyxt50o1y2fej/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71022",
    "slug": "draw-a-skin-for-mineblock-with-physics",
    "title": "Draw a skin for Mineblock with physics",
    "description": "Immerse yourself in the amazing world of creating skins and destruction in the world of Mineblock and Playground right now! In this game, you can create your own skins from various colorful blocks, and then experiment with them. For example, you can blow up your skin, take it apart, and much more.",
    "instructions": "In the game your task is to create your own skin from various blocks To do this select the color and block you want to draw with and click on the desired pixel to fill it in To replace the blocks you need to activate a special function",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Clicker",
      "Coloring",
      "Craft",
      "Decoration",
      "Design",
      "Drawing",
      "free games for your website",
      "Fun",
      "Funny",
      "Games",
      "Minecraft",
      "unblocked games",
      "unity games",
      "unity games for your site"
    ],
    "thumbnail": "https://img.gamemonetize.com/qv5vz20cx3kt3qivak7hi3hvc5clao8i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qv5vz20cx3kt3qivak7hi3hvc5clao8i/",
    "sourceUrl": "https://html5.gamemonetize.com/qv5vz20cx3kt3qivak7hi3hvc5clao8i/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71027",
    "slug": "kpop-puzzle-hunters",
    "title": "Kpop Puzzle Hunters",
    "description": "K-Pop Puzzle Hunters is a fun and creative puzzle game inspired by the K-Pop Demon Hunters universe where you get to piece together 12 stunning images featuring Huntrix, Saja Boys, and Derpy Tiger. Choose your challenge with 16, 36, 64, or 100 puzzle pieces and use hints when needed. Perfect for K-Pop fans, anime lovers, and puzzle enthusiasts, this free game mixes strategy, logic, and fandom fun. Start solving today and become the ultimate Puzzle Hunter!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Boy",
      "Brain",
      "Girl",
      "Jigsaw",
      "Mind"
    ],
    "thumbnail": "https://img.gamemonetize.com/chsrswt9l4imu4cyb291djt44ivtmu0e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/chsrswt9l4imu4cyb291djt44ivtmu0e/",
    "sourceUrl": "https://html5.gamemonetize.com/chsrswt9l4imu4cyb291djt44ivtmu0e/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "70961",
    "slug": "fall-guys-unblocked-web-multiplayer",
    "title": "Fall Guys Unblocked Web Multiplayer",
    "description": "Fall Guys Unblocked Web Multiplayer drops you into fast, chaotic obstacle courses right in your browser, no installs. Built with WebGL, it runs smoothly on modern devices while you dodge swinging hammers, tilting platforms, and grabby beans. Web Dev <a href='https://www.crazygamesfree.com/.'>https://www.crazygamesfree.com/.</a> Jump in solo or queue with friends, race, survive, and outlast the crowd across bite-size rounds. Quick matches, bright physics, and hilarious wipeouts make it perfect for study breaks, school Chromebooks, or evenings.",
    "instructions": "Mouse click or tap to play WASD TO walk juml on Space",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "2025 games",
      "Fall Boys",
      "Fall Guys",
      "jump",
      "Mentolatux",
      "Multiplayer",
      "Obstacle",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/7o8qtn59e5ejushl2s6bp52nbcgiu44x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7o8qtn59e5ejushl2s6bp52nbcgiu44x/",
    "sourceUrl": "https://html5.gamemonetize.com/7o8qtn59e5ejushl2s6bp52nbcgiu44x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70920",
    "slug": "brainrot-garden-merge-cats",
    "title": "Brainrot Garden. Merge Cats",
    "description": "Welcome to the strangest garden ever, where cats grow instead of vegetables. Your mission is to merge identical cats to create new, even weirder creatures! The further you go, the more chaotic your garden becomes, and the cats keep getting crazier. It&rsquo;s a true brainrot farm full of surprises and meme-worthy combinations.",
    "instructions": "Merge identical cats mdash and see who appears Clear garden plots and collect harvest to move forward Watch the board if it gets full the game is over Experiment and unlock all brainrot cat forms",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Cat",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/jhm2y4ivz33e388lrmoh5csgea2v53zp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jhm2y4ivz33e388lrmoh5csgea2v53zp/",
    "sourceUrl": "https://html5.gamemonetize.com/jhm2y4ivz33e388lrmoh5csgea2v53zp/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71035",
    "slug": "tetris-15go",
    "title": "TETRIS 15Go",
    "description": "Tetris 24 is a classic puzzle game where you must rotate and move falling blocks to create complete horizontal lines. With no time limit, you can enjoy a relaxing yet challenging gameplay experience. Simple, addictive, and timeless, this version of Tetris lets you test your strategy and reflexes at your own pace.",
    "instructions": "Arrow Left larr rarr Move block left Arrow Right rarr rarr Move block right Arrow Up uarr rarr Rotate block Arrow Down darr rarr Move block down faster Spacebar rarr Drop block instantly if supported",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/454kfhhgb5xvblghku49qhsf63tyw37y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/454kfhhgb5xvblghku49qhsf63tyw37y/",
    "sourceUrl": "https://html5.gamemonetize.com/454kfhhgb5xvblghku49qhsf63tyw37y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70917",
    "slug": "lost-things",
    "title": "Lost Things",
    "description": "Embark on an exciting adventure where your powers of observation are your main tool! This is a relaxing hidden object game created for those who appreciate slow-paced gameplay and enjoy exploring detailed worlds. Forget about time pressure! Here you can explore huge, colorful maps filled with hundreds of artfully hidden objects at your own pace. Game Features: &bull; No time limit: Enjoy the search process without feeling cornered by a timer. &bull; Addictive gameplay: Immerse yourself in long and exciting sessions full of discoveries and satisfaction from finding objects. &bull; Visual Enjoyment: Enjoy the vivid and detailed graphics that make searching",
    "instructions": "New sections of the map open when a certain number of items are found When the hint is activated the camera moves to the object so that you can collect it and the object itself is highlighted with small effects The left mouse button is used to collect",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Best Games",
      "Casual",
      "Girls",
      "Hidden",
      "HTML5",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/yhtcdcbrhzud7as5o54t9itsjx193ofk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yhtcdcbrhzud7as5o54t9itsjx193ofk/",
    "sourceUrl": "https://html5.gamemonetize.com/yhtcdcbrhzud7as5o54t9itsjx193ofk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70868",
    "slug": "all-seasons-nail-salon",
    "title": "All Seasons Nail Salon",
    "description": "Welcome to All Seasons Nail Salon. It is manicure madness over here and it&rsquo;s your time to become the greatest Nail Salon of the year! All you need to do is choose the shape, paint, polish, and also help to pick beautiful accessories and tattoos. Play and have fun!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Decoration",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/zj9pksp805yzk9lx7io2ipvbyz0um711/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zj9pksp805yzk9lx7io2ipvbyz0um711/",
    "sourceUrl": "https://html5.gamemonetize.com/zj9pksp805yzk9lx7io2ipvbyz0um711/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71194",
    "slug": "beaten-trump-face-lol",
    "title": "Beaten Trump Face LOL",
    "description": "Get ready to laugh out loud in Beaten Trump Face LOL &ndash; the wacky face-deformation game where you can poke, drag, and squash Trump&rsquo;s face into hilarious shapes! Stretch, bruise, and twist the photo in real time with slime-like effects, or tap and drag to add funny bumpy marks. Every interaction creates ridiculous results that you can screenshot and share with friends. Whether you want to mash, warp, or just make a goofy face, this game guarantees endless comedy moments!",
    "instructions": "mouse only",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Draw",
      "Drawing",
      "Funny"
    ],
    "thumbnail": "https://img.gamemonetize.com/4td2abdcpm6v8bb399tdyevr3gazngo7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4td2abdcpm6v8bb399tdyevr3gazngo7/",
    "sourceUrl": "https://html5.gamemonetize.com/4td2abdcpm6v8bb399tdyevr3gazngo7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71154",
    "slug": "super-tris-tic-tac-toe",
    "title": "Super Tris Tic Tac Toe",
    "description": "Super Tris is a fun and colorful take on the classic Tic-Tac-Toe game! Challenge the computer across three difficulty levels: Easy, Medium, and Hard; and see how far your strategy can take you. With bright graphics, smooth animations, and cheerful sound effects, every match feels exciting. Win games to unlock tougher AI opponents, celebrate victories with confetti, and keep track of your progress on the scoreboard. Whether you&rsquo;re a casual player or a seasoned strategist, Super Tris delivers quick, addictive gameplay perfect for all ages!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "HTML5",
      "mapi games",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/memt6xmgz88enbhyo9rbyj7a58wcee4y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/memt6xmgz88enbhyo9rbyj7a58wcee4y/",
    "sourceUrl": "https://html5.gamemonetize.com/memt6xmgz88enbhyo9rbyj7a58wcee4y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71102",
    "slug": "little-bugs",
    "title": "Little bugs",
    "description": "The beetles approach the two pictures and then there is a choice of which way to go. One picture is safe, you can walk through it, the second is a trapdoor into the abyss and if you misunderstand the hint in the form of a piece of vegetable or animal, you will not be able to reach the finish line.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/neq7li03jfkek5u8sk39l4wbbsy4x3n2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/neq7li03jfkek5u8sk39l4wbbsy4x3n2/",
    "sourceUrl": "https://html5.gamemonetize.com/neq7li03jfkek5u8sk39l4wbbsy4x3n2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71001",
    "slug": "repeat-pixel-arts",
    "title": "Repeat Pixel Arts",
    "description": "Immerse yourself in the amazing world of pixel art right now! In the game, your task is to repeat pixel drawings. Each level offers images that are unique in color and pixel arrangement, and a diverse palette allows you to make the game more exciting! In the game, your task is to reproduce the pixel pattern depicted on the adjacent canvas. Select the desired color and click on the desired pixel located on the game board to change its color. After you completely repeat the drawing from the neighboring",
    "instructions": "In the game your task is to reproduce the pixel pattern depicted on the adjacent canvas Select the desired color and click on the desired pixel located on the game board to change its color After you completely repeat the drawing from the neighboring",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Android",
      "beauty",
      "Best Games",
      "Creation",
      "Design",
      "Drawing",
      "endless",
      "free html5 games for your website",
      "Friv",
      "HTML5",
      "html5 games",
      "Pixel",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/ztsl034dw3uqai8ro1bdg6b4azrieq8o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ztsl034dw3uqai8ro1bdg6b4azrieq8o/",
    "sourceUrl": "https://html5.gamemonetize.com/ztsl034dw3uqai8ro1bdg6b4azrieq8o/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71101",
    "slug": "the-cargo-2",
    "title": "The Cargo 2",
    "description": "The Cargo 2 is a delivery game where the task is to load the cargo using a crane and then deliver it to the destination. Drive accurately and get to the destination without losing the load.",
    "instructions": "Desktop Arrow keys or W A S D to control the crane and drive the truck Spacebar to attach and detach the cargo Mobile Use on-screen buttons to control the crane and drive the truck",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Android",
      "Car",
      "Driving",
      "HTML5",
      "iPhone",
      "Mobile",
      "Obstacle",
      "offroad",
      "Simulation",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/rljbizanw8kgewwza5zbuh5vmkff18ih/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rljbizanw8kgewwza5zbuh5vmkff18ih/",
    "sourceUrl": "https://html5.gamemonetize.com/rljbizanw8kgewwza5zbuh5vmkff18ih/",
    "width": 900,
    "height": 506,
    "lastUpdated": ""
  },
  {
    "id": "70719",
    "slug": "battle-swat-vs-mercenary-zombie-survival",
    "title": "Battle SWAT vs Mercenary Zombie Survival",
    "description": "Battle SWAT vs Mercenary: Zombie Survival throws you into gritty browser firefights where humans and the undead crash the party. Pick SWAT or Mercenary, kit your loadout, and clear tight maps packed with chokepoints and vertical angles. Web Dev <a href='https://www.crazygamesx.com/.'>https://www.crazygamesx.com/.</a> Swap between PvP skirmishes and wave-based zombie survival, earn cash, unlock weapons, and hold the line with smart positioning and burst control. Fast rounds, headshot-clean TTK, and clutch revives keep the chaos sweaty and addictive.",
    "instructions": "Mouse click or tap to shoot aim scroll change gun WASD to walk TAB for menu",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "fps",
      "Gun",
      "Mentolatux",
      "Multiplayer",
      "Shooting",
      "survival",
      "unity",
      "WebGL",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/e64p0zajdjm62wp0gze9gfjdk5agmzcw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e64p0zajdjm62wp0gze9gfjdk5agmzcw/",
    "sourceUrl": "https://html5.gamemonetize.com/e64p0zajdjm62wp0gze9gfjdk5agmzcw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71047",
    "slug": "pixel-snake",
    "title": "Pixel Snake",
    "description": "Pixel Snake is a modern take on the timeless classic Snake game. Guide your glowing pixel snake across the grid, eat the red apples to grow longer, and test your reflexes as the challenge increases. The rules are simple: don&rsquo;t crash into the walls or your own tail, or it&rsquo;s game over! With its retro vibe, neon visuals, and addictive gameplay, Pixel Snake brings back the charm of one of the most iconic arcade experiences ever.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Best Games",
      "mapi games",
      "Pixel",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/ugfuzjjrykoatmr9de6yn37yagw986m8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ugfuzjjrykoatmr9de6yn37yagw986m8/",
    "sourceUrl": "https://html5.gamemonetize.com/ugfuzjjrykoatmr9de6yn37yagw986m8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71059",
    "slug": "catch-the-berry",
    "title": "Catch The Berry",
    "description": "Catch The Berry is a free hypercasual platform adventure game where you run, move, and collect juicy berries to reach the highest score. Avoid tricky obstacles, react fast, and enjoy endless arcade fun with colorful graphics and smooth gameplay. Play online on desktop or mobile, with simple left and right button controls or arrow keys. Each berry adds points, one hit ends your run, and your high score is saved. Easy to play but challenging to master, Catch The Berry is the perfect casual arcade game for kids and adults who love free HTML5 games, online platform challenges, and hypercasual fun.",
    "instructions": "Desktop Arrow Left Right Move Mouse Click on Left Right buttons Move Mobile Tap Left Move Left Tap Right Move Right",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Android",
      "Arcade",
      "Bounce",
      "Classic",
      "Crazy",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "HTML5",
      "Hypercasual",
      "Mobile",
      "NapTech Games",
      "Online",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/e8ed0va85i0wju5xnfisampeabqr55j1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e8ed0va85i0wju5xnfisampeabqr55j1/",
    "sourceUrl": "https://html5.gamemonetize.com/e8ed0va85i0wju5xnfisampeabqr55j1/",
    "width": 2560,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "71018",
    "slug": "trump-the-puppet",
    "title": "Trump the Puppet",
    "description": "Trump the Puppet is a super fun online game for kids! The goal is to match the puppet&rsquo;s pose on the left with the one on the right. Reach above the objective line to unlock a new level. Have fun and enjoy the challenge!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Celebrity",
      "Fun",
      "Funny",
      "Kids",
      "Logic",
      "Matching",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/pveuwd9f92rmu2jmgscoko8jqgsq2f3p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pveuwd9f92rmu2jmgscoko8jqgsq2f3p/",
    "sourceUrl": "https://html5.gamemonetize.com/pveuwd9f92rmu2jmgscoko8jqgsq2f3p/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "71024",
    "slug": "cube-twin",
    "title": "Cube Twin",
    "description": "Cube Twin is a simple and addictive game where the challenge is to align two cubes of the same color, moving vertically while trying not to lose lives. The difficulty increases as you progress, making it challenging. Have fun matching the colored cubes.",
    "instructions": "The challenge is to align two cubes of the same color moving them vertically while trying not to lose lives The difficulty increases as you progress making it even more challenging Have fun combining the colored cubes",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player"
    ],
    "thumbnail": "https://img.gamemonetize.com/e54kj8nxsmtocwbxs8t9u7y6fzs301xx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e54kj8nxsmtocwbxs8t9u7y6fzs301xx/",
    "sourceUrl": "https://html5.gamemonetize.com/e54kj8nxsmtocwbxs8t9u7y6fzs301xx/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "70898",
    "slug": "kim-jong-un-lol-face",
    "title": "Kim Jong Un LOL Face",
    "description": "Kim Jong Un LOL Face puts the power of comedy in your hands! Take a serious portrait and twist it into something hilarious with wacky distortions, stretchy warps, and goofy face edits. Drag, bend, and reshape the photo grid to create the funniest versions you can imagine. It&rsquo;s not about politics&mdash;it&rsquo;s all about laughs! Whether you want a big head, tiny chin, or silly stretched smile, this editor lets you craft endless funny faces.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "Draw",
      "Drawing",
      "paint"
    ],
    "thumbnail": "https://img.gamemonetize.com/cbqwk5qneid6rffhbt1t9514pmcalffe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cbqwk5qneid6rffhbt1t9514pmcalffe/",
    "sourceUrl": "https://html5.gamemonetize.com/cbqwk5qneid6rffhbt1t9514pmcalffe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71114",
    "slug": "parking-driver",
    "title": "Parking driver",
    "description": "The cars are already in the parking lot and are as compact as possible. You have to clear the parking lot so that the cars can go about their business.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Arcade",
      "carparking",
      "Casual",
      "Cat"
    ],
    "thumbnail": "https://img.gamemonetize.com/lpsxm6si2nwt7ybw73vjzuwy8365tdn7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lpsxm6si2nwt7ybw73vjzuwy8365tdn7/",
    "sourceUrl": "https://html5.gamemonetize.com/lpsxm6si2nwt7ybw73vjzuwy8365tdn7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70558",
    "slug": "chicken-banana-pen",
    "title": "Chicken Banana Pen",
    "description": "Enjoy a unique game based on Chicken Banana Internet hit. Put your accuracy to test and shoot pens in order to stab the fruits. Aim for a high score!",
    "instructions": "Use the mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Cartoon",
      "Chicken",
      "free html5 games for your website",
      "Hypercasual",
      "kiz10"
    ],
    "thumbnail": "https://img.gamemonetize.com/atzb6w9wd6ogze8oy6mq6ccrkzodp7r9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/atzb6w9wd6ogze8oy6mq6ccrkzodp7r9/",
    "sourceUrl": "https://html5.gamemonetize.com/atzb6w9wd6ogze8oy6mq6ccrkzodp7r9/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "65344",
    "slug": "the-genius-crow",
    "title": "The Genius Crow",
    "description": "The Genius Crow is a fun and educational puzzle game inspired by the classic fable. Help the smart crow drop stones into the jar to raise the water and complete each level. Enjoy colorful graphics, smooth touch controls, and brain-teasing challenges that sharpen logic and problem-solving skills. Perfect for kids, students, and puzzle lovers, this HTML5 game works on mobile and desktop for hours of engaging fun.",
    "instructions": "Mobile Tap and drag to drop stones into the jar interact with objects and navigate menus Desktop Use the left mouse button to interact with objects and menus",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Educational",
      "HTML5",
      "html5 games",
      "Hypercasual",
      "Kids",
      "Levels",
      "Logic",
      "Mobile",
      "NapTech Games",
      "Online",
      "Physics",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/jux6l5xpjtiw5dfymavtdwx1zjit2r5n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jux6l5xpjtiw5dfymavtdwx1zjit2r5n/",
    "sourceUrl": "https://html5.gamemonetize.com/jux6l5xpjtiw5dfymavtdwx1zjit2r5n/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "71056",
    "slug": "crazy-lemmings-2",
    "title": "Crazy Lemmings 2",
    "description": "Crazy Lemmings 2 is a fast-paced and addictive arcade game where your mission is to save the reckless lemmings as they leap off the cliffs! Take control of the rescue craft, move quickly, and bounce the lemmings to safety before they hit the ground. The more lemmings you save, the higher your score. Test your reflexes, challenge your skills, and see how many crazy lemmings you can rescue!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Animal",
      "Cartoon",
      "Cute",
      "jump",
      "Jumping",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/4mc1komzn0hekwp3y351prxhlfc3ulf7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4mc1komzn0hekwp3y351prxhlfc3ulf7/",
    "sourceUrl": "https://html5.gamemonetize.com/4mc1komzn0hekwp3y351prxhlfc3ulf7/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "70918",
    "slug": "flappy-birds-game-ai",
    "title": "Flappy Birds Game Ai",
    "description": "Flappy Bird is an incredibly simple yet frustratingly addictive mobile game. Players tap the screen to make a small, pixelated bird flap its wings and navigate through a series of green pipes. Web Dev <a href='https://www.crazygamesfree.com/.'>https://www.crazygamesfree.com/.</a> The goal is to get the highest score possible by passing through as many pipes as you can without hitting them or the ground. Its challenging difficulty and retro 8-bit graphics made it an overnight sensation and a cultural phenomenon.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Bird",
      "Click",
      "flappybird",
      "fly",
      "HTML5",
      "jump",
      "Mentolatux"
    ],
    "thumbnail": "https://img.gamemonetize.com/i8l0k7bc01z772gtygbyr3xdwfw224w0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i8l0k7bc01z772gtygbyr3xdwfw224w0/",
    "sourceUrl": "https://html5.gamemonetize.com/i8l0k7bc01z772gtygbyr3xdwfw224w0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71023",
    "slug": "draw-with-pencils-coloring-book",
    "title": "Draw with Pencils Coloring Book!",
    "description": "Draw with Pencils - Coloring Book! is an exciting creativity game. Here you can relax and use your imagination: color ready-made outlines with bright colors or create your own masterpiece from a blank slate. A huge palette of pencils and simple tools will help you create the perfect picture. Create with ease and enjoyment!",
    "instructions": "- Choose a mode start a new drawing on a white canvas or choose a ready-made picture to color - Choose a color click on your favorite pencil in the palette - Start drawing hold down the left mouse button and move the cursor across the canvas",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Baby",
      "Baby Games",
      "Best Games",
      "Boy",
      "Casual",
      "Color",
      "Coloring",
      "Draw",
      "Drawing",
      "Interactive",
      "Kid",
      "Kids",
      "paint",
      "painting"
    ],
    "thumbnail": "https://img.gamemonetize.com/al9whnr4986kmxpu3kaxfi729ukkctw4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/al9whnr4986kmxpu3kaxfi729ukkctw4/",
    "sourceUrl": "https://html5.gamemonetize.com/al9whnr4986kmxpu3kaxfi729ukkctw4/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70806",
    "slug": "wars-of-thrones",
    "title": "Wars of Thrones",
    "description": "Are you ready to survive in a colorful world full of dangers? In this top-down action game, you&rsquo;ll fight alongside your loyal wolf against relentless enemies. Each level brings new challenges! Fall and respawn, change your strategy, and come back stronger. Upgrade your character, unlock powerful abilities, and conquer the stages to achieve victory!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Arena",
      "attack",
      "Battle",
      "Boy"
    ],
    "thumbnail": "https://img.gamemonetize.com/6tn25wojmrf5x28o36axvprip7bzc0u1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6tn25wojmrf5x28o36axvprip7bzc0u1/",
    "sourceUrl": "https://html5.gamemonetize.com/6tn25wojmrf5x28o36axvprip7bzc0u1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71075",
    "slug": "bird-in-danger",
    "title": "Bird in Danger",
    "description": "Bird in Danger is a minimalist, straightforward, addictive, and fun platformer. Help the little bird navigate the columns and overcome each dangerous obstacle. The difficulty increases as you progress, making it challenging.",
    "instructions": "With a simple click on the screen help the little bird navigate the columns and overcome each dangerous obstacle The difficulty increases as you progress making it challenging",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/1myfrain82bj60nsribb3sxl4u4is2pu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1myfrain82bj60nsribb3sxl4u4is2pu/",
    "sourceUrl": "https://html5.gamemonetize.com/1myfrain82bj60nsribb3sxl4u4is2pu/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "71084",
    "slug": "diy-clothing",
    "title": "Diy Clothing",
    "description": "There are clothes in the wardrobe for successful DIY creation, choose a beautiful outfit. Use your imagination to choose the best option.",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "3D",
      "beauty",
      "Design"
    ],
    "thumbnail": "https://img.gamemonetize.com/bzk5s8v5nvc8qy3vk18ztsk3dfoezpn5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bzk5s8v5nvc8qy3vk18ztsk3dfoezpn5/",
    "sourceUrl": "https://html5.gamemonetize.com/bzk5s8v5nvc8qy3vk18ztsk3dfoezpn5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70945",
    "slug": "obby-working-as-a-firefighter",
    "title": "Obby: Working as a Firefighter",
    "description": "Become a firefighter hero! In this exciting adventure you will have to save the city from the fire element. Keep people and buildings safe, because every second counts! Put out fires with water pistols Aim accurately, run through the burning streets and defeat the fire before it destroys everything around you. Difficult levels and challenges With each stage, the fire spreads faster and time is getting shorter. Show the reaction and precision of a real rescuer! Compete and save Set records, share your results with friends and prove that you are the best firefighter in town!",
    "instructions": "On PC - WASD arrows - move the hero forward backward left right - Left mouse button - extinguish fire with water gun - Spacebar - jump On mobile devices - Virtual joystick on the left - hero movement",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "Animal",
      "Best",
      "Best Games",
      "Brawl",
      "mineblock",
      "Minecraft",
      "Multiplayer",
      "Physics",
      "roblox",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/r75ajpg21deomfxjm7sj3nqvlnhxhui8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r75ajpg21deomfxjm7sj3nqvlnhxhui8/",
    "sourceUrl": "https://html5.gamemonetize.com/r75ajpg21deomfxjm7sj3nqvlnhxhui8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70835",
    "slug": "speeding-ball",
    "title": "Speeding ball",
    "description": "There is only one stroke per hole, and you need to roll the ball with one stroke. Its not the easiest task in front of you, you need a good calculation so that the ball falls into the hole on the first attempt.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Golf",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/paag9a0xkq1j6sjber4mtmsisfh4vb0x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/paag9a0xkq1j6sjber4mtmsisfh4vb0x/",
    "sourceUrl": "https://html5.gamemonetize.com/paag9a0xkq1j6sjber4mtmsisfh4vb0x/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70992",
    "slug": "bus-parking-unblocked",
    "title": "Bus Parking Unblocked",
    "description": "Bus Parking is a clean, skill-based driving challenge where you thread a long city bus through tight turns, cones, and zero-margin bays. Feel the weight, plan your swing, and nail precision stops without scraping paint. Web Dev <a href='https://www.crazygamesonline.com/.'>https://www.crazygamesonline.com/.</a> Smooth throttle, crisp camera, and progressive levels keep the loop addictive. Beat timers, earn three stars, and flex pro driver vibes. Mess up? Rewind, learn the line, and park it like a boss. Every time.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "bus",
      "Driving",
      "Mentolatux",
      "Parking",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ycrq598s8r7r88p8j5b3ijzk2o63wtxw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ycrq598s8r7r88p8j5b3ijzk2o63wtxw/",
    "sourceUrl": "https://html5.gamemonetize.com/ycrq598s8r7r88p8j5b3ijzk2o63wtxw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70654",
    "slug": "acorn-flight",
    "title": "Acorn Flight",
    "description": "Take to the skies in Acorn Flight, a fast-paced flying adventure where you guide a daring squirrel through the open air. Your mission? Dodge flocks of birds while collecting shining golden rings to boost your score. Simple to play but tricky to master, every tap keeps your squirrel soaring&mdash;one wrong move and it&rsquo;s game over! The farther you fly and the more rings you collect, the higher your score climbs. With quick action, endless challenges, and addictive gameplay, Acorn Flight is perfect for players who love skill-based fun. Can you flap, glide, and grab your way to the top of the skies?",
    "instructions": "Catch all rings and never hit another bird",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Bird",
      "fly",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/8gkq1jw5de9ezsyoozy0sx3fzudmfjq3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8gkq1jw5de9ezsyoozy0sx3fzudmfjq3/",
    "sourceUrl": "https://html5.gamemonetize.com/8gkq1jw5de9ezsyoozy0sx3fzudmfjq3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70866",
    "slug": "little-lily-halloween-prep",
    "title": "Little Lily Halloween Prep",
    "description": "Welcome to Little Lily Halloween Prep. It&rsquo;s time to celebrate Halloween with Little Lily! Enjoy a memorable Halloween night with Lily and play fun-packed Halloween games and activities. Help the lily to complete her makeover, then help her with Halloween face painting. Browse her wardrobe and pick cute outfits and costumes. Finally, help her with cake decoration. A lot more to enjoy and explore this Halloween season with Little Lily. Happy Halloween!!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls",
      "Halloween"
    ],
    "thumbnail": "https://img.gamemonetize.com/bkmwpswxx62cp7qsoro7xe7fpnkzbd64/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bkmwpswxx62cp7qsoro7xe7fpnkzbd64/",
    "sourceUrl": "https://html5.gamemonetize.com/bkmwpswxx62cp7qsoro7xe7fpnkzbd64/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70982",
    "slug": "screw-bolt-3d",
    "title": "screw bolt 3d",
    "description": "Screw &amp; Bolt 3D Tighten, twist, and unlock the world of mechanics! Screw &amp; Bolt is a fun and brain-teasing 3D puzzle game, where every level challenges your logic and precision. Rotate screws, unscrew bolts, and solve mechanical puzzles to progress through increasingly tricky structures. With realistic 3D physics, smooth controls, and engaging visuals, each challenge feels satisfying to solve. Whether you&rsquo;re loosening a jammed bolt or securing parts into place, strategy and timing are key.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Color",
      "Interactive",
      "Punch"
    ],
    "thumbnail": "https://img.gamemonetize.com/7e5x1pipuzzog3aefxd2ev1ya8zw63jn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7e5x1pipuzzog3aefxd2ev1ya8zw63jn/",
    "sourceUrl": "https://html5.gamemonetize.com/7e5x1pipuzzog3aefxd2ev1ya8zw63jn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "71029",
    "slug": "escape-from-the-prison-in-mineblock-destruction",
    "title": "Escape from the prison in Mineblock! Destruction!",
    "description": "Escape from the epic prison in Mineblock in a variety of ways right now! The game features a variety of items that can help you escape, as well as many prisons, each with its own unique abilities or durability. Try to escape from all the prisons right now! Earn money by destroying the prison blocks and unlock new blocks, as well as upgrade the damage of your items!",
    "instructions": "Select the objects and click on them so that they appear in the position indicated by the arrow You can also choose which blocks the prison will consist of Each block has its own amount of strength For each broken block you get money",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Classic",
      "free games for your site",
      "Fun",
      "Funny",
      "Games",
      "games for your website",
      "html games for your website",
      "html5 games",
      "Mine",
      "mineblock",
      "Minecraft",
      "Miner",
      "Prison",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/mbvqo8k9xm7lyezy1j8qsf7cu4z9qwps/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mbvqo8k9xm7lyezy1j8qsf7cu4z9qwps/",
    "sourceUrl": "https://html5.gamemonetize.com/mbvqo8k9xm7lyezy1j8qsf7cu4z9qwps/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "71036",
    "slug": "soccer-volley",
    "title": "Soccer Volley",
    "description": "Enjoy a fast-paced HTML5 arcade challenge! Test your reflexes, collect rewards, and avoid obstacles as you try to beat your high score. Simple to play but hard to master, this game is perfect for quick fun sessions on both mobile and desktop. Can you set a new record?",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "8 Ball Pool",
      "Clicker",
      "Football",
      "mapi games",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/qm0monm28raplsrs517u47quhag1zqpk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qm0monm28raplsrs517u47quhag1zqpk/",
    "sourceUrl": "https://html5.gamemonetize.com/qm0monm28raplsrs517u47quhag1zqpk/",
    "width": 600,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "70979",
    "slug": "obby-dig-to-the-center-of-the-earth",
    "title": "Obby: Dig to the center of the Earth",
    "description": "Grab your drill and start digging straight down! Unlock the way to the depths of the earth by breaking blocks and going deeper and deeper. Overcome the layers of earth and get to the bottom! Each layer gets stronger and requires powerful upgrades to pass through. Hatch pets to earn more and dig faster! Pets give you loot bonuses and speed up your progress. Upgrade your drill, unlock powerful tools and become a better digger! Collect currency, improve your equipment and get stronger and stronger. Compete with other players and climb the leaderboard! Show who is the fastest and hardest digger!",
    "instructions": "For PC WASD - Character Control Right mouse button - Camera rotation Left mouse button - Gain power and interact with ------------------ For mobile devices Joystick - Character Control Button - Jump Sensor - Camera rotation",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "Action",
      "Animal",
      "Best",
      "Brainrot",
      "Brawl",
      "Cartoon",
      "Clicker",
      "Dragon",
      "gta",
      "Minecraft",
      "roblox",
      "RPG",
      "Skibidi"
    ],
    "thumbnail": "https://img.gamemonetize.com/tqe2zu6lsyq77pth6j9qifmtw1k68dun/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tqe2zu6lsyq77pth6j9qifmtw1k68dun/",
    "sourceUrl": "https://html5.gamemonetize.com/tqe2zu6lsyq77pth6j9qifmtw1k68dun/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70997",
    "slug": "minecraft-rooftop-snipers",
    "title": "Minecraft Rooftop Snipers",
    "description": "Minecraft Rooftop Snipers drops blocky duelists onto sketchy skyscraper ledges for fast, physics-goofy shootouts. Tap to jump, time your shots, and ride recoil to pop helmets without yeeting yourself off the edge. Web Dev <a href='https://www.crazygamesonline.com/.'>https://www.crazygamesonline.com/.</a> Solo versus a cheeky AI or couch two-player chaos, rounds are quick, clutch, and meme-worthy. Simple two-button controls, crunchy hits, windy knockbacks, and random props keep every set fresh. Miss the platform? Respawn, adapt, and steal match point.",
    "instructions": "WAS - Move SPACE - shooting",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2D",
      "Ai Games",
      "Games Ai",
      "Mentolatux",
      "Minecraft",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/zt1aj4qazh57u87jr41yaycsfjwna8j5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zt1aj4qazh57u87jr41yaycsfjwna8j5/",
    "sourceUrl": "https://html5.gamemonetize.com/zt1aj4qazh57u87jr41yaycsfjwna8j5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70943",
    "slug": "noob-vs-pro-but-archers-minecraft",
    "title": "Noob vs Pro But Archers Minecraft",
    "description": "A two-player game where the fastest and most calculating wins! Noob and Pro decided to have a bow duel! Shoot your opponent before they shoot you! A fun two-player game in the style of Minecraft. Theres also a single-player mode. About the Game The game features: Two-player mode Single-player mode 26 levels Surfaces that arrows can ricochet off Falling sand blocks Sharp arrows And much more! The main goal of the game is to try to calculate the arrows flight to hit your opponent before they do! Use your calculation skills!",
    "instructions": "How to Play On PC Pro controls A - rotate bow left D - rotate bow right W - shoot Noob controls Mouse and click to shoot On Mobile Rotate the bow using the joystick To shoot slide your finger to the edge of the joystick",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2048",
      "2D",
      "Arcade",
      "Fun",
      "Funny",
      "Mine",
      "mineblock",
      "Minecraft",
      "Miner",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/6asufor8sv5q6k091rtzrzvxm54qne3r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6asufor8sv5q6k091rtzrzvxm54qne3r/",
    "sourceUrl": "https://html5.gamemonetize.com/6asufor8sv5q6k091rtzrzvxm54qne3r/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70912",
    "slug": "hamster-maze",
    "title": "Hamster Maze",
    "description": "Embark on a fun and fast-paced adventure with a brave little hamster! In this runner game, you will guide the hamster to jump over challenging obstacles, collect tasty food along the way, and reach the goal to clear each level. Timing and quick reflexes are the key &mdash; every move counts as the speed increases. With simple controls, colorful graphics, and addictive gameplay, this hamster run delivers endless excitement for players of all ages. Can you help the hamster overcome every obstacle and become the ultimate food-loving champion?",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Animal"
    ],
    "thumbnail": "https://img.gamemonetize.com/jdqq2dsuxfzt02vp6spq62p655a0rnpb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jdqq2dsuxfzt02vp6spq62p655a0rnpb/",
    "sourceUrl": "https://html5.gamemonetize.com/jdqq2dsuxfzt02vp6spq62p655a0rnpb/",
    "width": 720,
    "height": 1555,
    "lastUpdated": ""
  },
  {
    "id": "70657",
    "slug": "quick-cards",
    "title": "Quick Cards",
    "description": "Keep throwing the cards on your turn, the larger card wins! The winner keeps both the cards. In case of tie, the game is on! The more you play, the more you like the game.",
    "instructions": "Keep throwing cards",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Color",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/8a69iuz39a0yy5eu1467ncyxh68vofs7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8a69iuz39a0yy5eu1467ncyxh68vofs7/",
    "sourceUrl": "https://html5.gamemonetize.com/8a69iuz39a0yy5eu1467ncyxh68vofs7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70870",
    "slug": "arrows-disappear",
    "title": "Arrows disappear",
    "description": "Tap on the blocks to make them fly off the screen. Remove all the blocks to complete the level. Try to handle large amounts of blocks when you have a limit on the number of moves and every mistake will bring you closer to failure.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "Arcade",
      "arrow",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/lkhr9e5ja90yu8wgfwfe7u5btrmv0k3g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lkhr9e5ja90yu8wgfwfe7u5btrmv0k3g/",
    "sourceUrl": "https://html5.gamemonetize.com/lkhr9e5ja90yu8wgfwfe7u5btrmv0k3g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70873",
    "slug": "lol-presidential-face",
    "title": "LOL Presidential Face",
    "description": "LOL Presidential Face is a funny and lighthearted face-editing game where you can mix, stretch, and swap presidential features in hilarious ways. Pick from different presidents, drag and distort their faces, add goofy accessories, and create the funniest combinations you can imagine. Whether you&rsquo;re making them look silly, serious, or just plain ridiculous, the goal is simple: laugh out loud at your presidential masterpiece and share it with friends.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Draw",
      "Drawing",
      "Pixel",
      "surprise",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/25ew10jwvjm3o1jks9xtqt5lltgd6ph4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/25ew10jwvjm3o1jks9xtqt5lltgd6ph4/",
    "sourceUrl": "https://html5.gamemonetize.com/25ew10jwvjm3o1jks9xtqt5lltgd6ph4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70536",
    "slug": "bus-route",
    "title": "Bus Route",
    "description": "The BUS ROUTE is a colourful and fun puzzlesorting game created by gameNply.com In this game: You have a queue of passengers waiting for their bus, each passenger having different colours, Your task is to sort them by colour, match them up in the right way, and organize the flow so that VIP passengers or special ones can board on time, The game features smooth animations, lively backgrounds, and vibrant, bus-themed visuals. As you progress, it gets more challenging: more colours, more passengers, more pressure to sort quickly and efficiently, It&rsquo;s simple to get into but clever in design&mdash; Thanks for Play",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "bus",
      "Clicker",
      "Color",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ylb0bv504njgyezlc86d14c0gax7330v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ylb0bv504njgyezlc86d14c0gax7330v/",
    "sourceUrl": "https://html5.gamemonetize.com/ylb0bv504njgyezlc86d14c0gax7330v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70777",
    "slug": "tracky-tracks",
    "title": "Tracky Tracks",
    "description": "Tracky Tracks (Tricky Tracks) &mdash; fast-paced drifting game of precision and speed! Race through mountains, cities, and lakes, customize your car, and master challenging tracks with smooth, responsive controls.",
    "instructions": "W S FORWARD BACKWARD A D RIGHT LEFT SPACE BRAKE ESC GO TO MAIN MENU P PAUSE R RESTART C CHANGE CAMERA",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Avoid",
      "Car",
      "drift",
      "Driving"
    ],
    "thumbnail": "https://img.gamemonetize.com/j6kqv5c19zklpk0vku3kz8jjfxvpyp21/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j6kqv5c19zklpk0vku3kz8jjfxvpyp21/",
    "sourceUrl": "https://html5.gamemonetize.com/j6kqv5c19zklpk0vku3kz8jjfxvpyp21/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70690",
    "slug": "obby-training-by-car",
    "title": "Obby: Training by Car",
    "description": "Get ready to drive as far as possible, buy new cars, unlock new trails, and collect energy! Buy awesome cars, and collect energy and pets that give you powerful bonuses! Explore different locations. Game Features: &bull; Control your car. &bull; Farm energy to make your car faster. &bull; Unlock unique trails with special effects. &bull; Revive system &ndash; unlock new locations and grow stronger. &bull; Leaderboards &amp; competitions &ndash; race against other players and become the champion! Can you become the best racer?",
    "instructions": "bull Movement ndash W A S D bull Jump ndash Spacebar",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "car tuning",
      "Cars",
      "Casual",
      "Dragon",
      "Interactive",
      "Mobile",
      "Race",
      "Racing",
      "roblox",
      "Simulation",
      "Simulator",
      "Supercars",
      "trial car"
    ],
    "thumbnail": "https://img.gamemonetize.com/on6r436vavy94l6g7lf5y8iyn0v24s1y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/on6r436vavy94l6g7lf5y8iyn0v24s1y/",
    "sourceUrl": "https://html5.gamemonetize.com/on6r436vavy94l6g7lf5y8iyn0v24s1y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70769",
    "slug": "bus-simulator-unblocked-remastered",
    "title": "Bus Simulator Unblocked Remastered",
    "description": "Bus Simulator Unblocked Remastered lets you drive legit routes in your browser&mdash;no installs, no drama. Climb into a first-person cockpit, start the engine, signal, open doors, and keep to the schedule while traffic AI and tight corners test your patience. Web Dev <a href='https://www.crazygamesx.com/.'>https://www.crazygamesx.com/.</a> Smooth WebGL visuals, decent physics, and multiple camera views make runs feel real. Perfect for school Chromebooks or quick breaks. WASD to drive, Q/E for indicators, space to brake&mdash;don&rsquo;t miss those stops.",
    "instructions": "Mouse click or tap to play WASD to drive the bus",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "bus",
      "Driving",
      "Mentolatux",
      "Remastered",
      "Simulation",
      "unblocked",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/42eq7wikn26zuxun0hx0m6fd7bhz8a42/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/42eq7wikn26zuxun0hx0m6fd7bhz8a42/",
    "sourceUrl": "https://html5.gamemonetize.com/42eq7wikn26zuxun0hx0m6fd7bhz8a42/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70957",
    "slug": "pass-the-ball-3d",
    "title": "Pass the ball 3d",
    "description": "The ball must be kicked so that it bounces off various objects and flies exactly into the green container. Watch the behavior of the defenders, they can easily hit the ball.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/7mfd1zm7wm1z1uv4te3rwog0r2is8ncv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7mfd1zm7wm1z1uv4te3rwog0r2is8ncv/",
    "sourceUrl": "https://html5.gamemonetize.com/7mfd1zm7wm1z1uv4te3rwog0r2is8ncv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70807",
    "slug": "brainrot-click-to-hatch",
    "title": "Brainrot Click to Hatch",
    "description": "Enter Brainrot Click to Hatch, the absurd and epic clicker where every tap hatches chaotic BRAINROTS. Unlock characters like Bombardero Cocodrilo, Tralalero Tralala, Lirali Liralira, and Chimpancini Bananini, then push them to their MAX POWER forms with epic transformations. Earn coins, unlock upgrades, and speed your progress. Discover special day/night backgrounds and watch your collection grow stranger and more powerful. From viral classics to impossible evolutions, the challenge is clear: collect them all before losing your mind!",
    "instructions": "Use the left mouse button to play and interact with the in-game UI",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Click",
      "Clicker",
      "idle",
      "Italian Brainrot",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/84pbd1sr3mqpg1q0gwumcd8ebv42jtcv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/84pbd1sr3mqpg1q0gwumcd8ebv42jtcv/",
    "sourceUrl": "https://html5.gamemonetize.com/84pbd1sr3mqpg1q0gwumcd8ebv42jtcv/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70983",
    "slug": "musical-labubu-make-a-melody",
    "title": "Musical Labubu: Make a Melody",
    "description": "Musical Labubu - Make a Melody is a game about creating your own melody in a small 3D world. Here youll see a variety of Labubu, with a variety of animations and sounds. The game features a night mode that can really surprise and scare you. If youre not afraid, youll love it. Come on in and create your favorite melody!",
    "instructions": "Drag the Labubu icons from the bottom of the screen onto the stage Each Labubu plays its own melody so create a variety of melodies and enjoy the game",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "3D",
      "Best Games",
      "Casino",
      "Casual",
      "Click",
      "Clicker",
      "Cool",
      "Dancing",
      "Game",
      "Horror",
      "HTML5",
      "Hypercasual",
      "Labubu",
      "Music"
    ],
    "thumbnail": "https://img.gamemonetize.com/8adxlj3n9i12qxlrs9dl91b3otpjbkhs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8adxlj3n9i12qxlrs9dl91b3otpjbkhs/",
    "sourceUrl": "https://html5.gamemonetize.com/8adxlj3n9i12qxlrs9dl91b3otpjbkhs/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70926",
    "slug": "noob-vs-pro-but-knife-hit-minecraft",
    "title": "Noob vs Pro But Knife Hit Minecraft",
    "description": "A two-player game where the luckiest and most calculating wins! Noob and Pro decided to play a so-called darts game, but with knives. A fun two-player game in the style of Minecraft and Knife Hit. The game features: -Two-player mode -Single-player mode -20+ level variations -20+ single-player level variations -10 bosses -Sharp knives -Logs (just logs) -Workbenches (both spinning and non-spinning, but thats a matter of taste) -Fragile sand blocks -Evil bosses -Strange levels -And much more! The main goal of the game is to throw knives at logs until they run out.",
    "instructions": "Controls on PC 1 player Pro Z key - shoot knife 2 player Noob Up arrow - shoot knife In two-player mode shoot knives in turns In single-player mode shoot by pressing the up arrow Controls on Mobile Tap the screen to shoot a knife",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2025 games",
      "2048",
      "2D",
      "Action",
      "Best Games",
      "Dinosaur",
      "Fun",
      "Funny",
      "Mine",
      "mineblock",
      "Minecraft",
      "Miner"
    ],
    "thumbnail": "https://img.gamemonetize.com/hx8re2tfco2ej8l6xkuxbvlofv4l1fl2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hx8re2tfco2ej8l6xkuxbvlofv4l1fl2/",
    "sourceUrl": "https://html5.gamemonetize.com/hx8re2tfco2ej8l6xkuxbvlofv4l1fl2/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70867",
    "slug": "super-girls-my-rainy-day-outfits",
    "title": "Super Girls My Rainy Day Outfits",
    "description": "Welcome to Super Girls My Rainy Day Outfits. Who said that you can&rsquo;t look perfect on a rainy day? A bit of rain shouldn&rsquo;t stop us from looking fabulous! And don&rsquo;t even worry about the hair, some curls under a hat look absolutely perfect! How would your perfect rainy day outfit look like? Try creating it while helping these princesses dress up in warmer clothes and rain boots. Accessorize their look with a hat, scarf, and a cute umbrella.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/togvdiy9kjgkpux6azmnva19l8zb1y5y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/togvdiy9kjgkpux6azmnva19l8zb1y5y/",
    "sourceUrl": "https://html5.gamemonetize.com/togvdiy9kjgkpux6azmnva19l8zb1y5y/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70546",
    "slug": "road-fighter-and-ndash-endless-car-racing",
    "title": "Road Fighter &ndash; Endless Car Racing",
    "description": "Hit the road in Road Fighter, a fast-paced 3-lane racing game! Dodge traffic, avoid oil spills, and race against time while climbing the leaderboard. Collect points to level up and increase your speed. Can you survive the traffic and become the ultimate road champion? Features: 3 lanes with smooth left/right movement Obstacles: cars and oil spills Increasing speed and levels for extra challenge Real-time scoring and leaderboard support Mobile-friendly with touch controls Sound effects and background music for immersive gameplay",
    "instructions": "Desktop Arrow Left A Move left Arrow Right D Move right Arrow Up W Accelerate Arrow Down S Brake Mobile Touch Left button Move left Right button Move right Accelerate button Increase speed Brake button Slow down",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "Car",
      "Driving",
      "Racing",
      "Road"
    ],
    "thumbnail": "https://img.gamemonetize.com/noym5buhm52w1oqhkng1kno2ift8gtym/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/noym5buhm52w1oqhkng1kno2ift8gtym/",
    "sourceUrl": "https://html5.gamemonetize.com/noym5buhm52w1oqhkng1kno2ift8gtym/",
    "width": 800,
    "height": 1200,
    "lastUpdated": ""
  },
  {
    "id": "69893",
    "slug": "om-nom-run-03",
    "title": "Om Nom Run 03",
    "description": "Om Nom Run is an exciting endless runner where you guide Om Nom through fun and colorful levels, jumping over obstacles and collecting tasty candies. The goal is simple: run as far as you can, score points, and beat your high score! With easy one-button controls, anyone can pick up and play, making it perfect for kids and adults alike. The further you run, the faster the game becomes, testing your reflexes and timing. Avoid dangerous obstacles, grab candies for bonus points, and try to survive as long as possible. Whether you&rsquo;re looking for a quick game to pass the time or a real challenge to push your limits, Om Nom Run delivers fast-paced",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Arcade",
      "Fun",
      "HTML5",
      "Jumping",
      "Kids",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/z8gamat20izb3pw25e3e1ruonuafdd5y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z8gamat20izb3pw25e3e1ruonuafdd5y/",
    "sourceUrl": "https://html5.gamemonetize.com/z8gamat20izb3pw25e3e1ruonuafdd5y/",
    "width": 800,
    "height": 400,
    "lastUpdated": ""
  },
  {
    "id": "70839",
    "slug": "noob-vs-pro-but-floor-is-lava-minecraft",
    "title": "Noob vs Pro But Floor is Lava Minecraft",
    "description": "Noob and Pro decided to relax, but suddenly rising lava ruined their plans! Now they&rsquo;re trying to survive in this lava-filled world! A fun two-player game in a Minecraft style. The game features: -Two-player mode -Single-player mode -12 main levels plus 2 special levels -Hot lava -Jump and speed potions found in chests -Falling sand blocks -Levels with lava lakes -And much more! The main goal is to avoid falling into the lava, which rises higher and higher each round. Occasionally, the lava will lower to give you a brief break. 1 Player mode also available!",
    "instructions": "On PC Pro controls A D to move left and right W to jump Noob controls Left arrow Right arrow to move Up arrow to jump On Mobile Pro controls joystick Noob controls joystick",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2D",
      "Action",
      "Arcade",
      "Funny",
      "jump",
      "Jumping",
      "Mine",
      "mineblock",
      "Minecraft",
      "Miner"
    ],
    "thumbnail": "https://img.gamemonetize.com/7j6xjz5mtmf5j97yyadzc7bnykholqsr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7j6xjz5mtmf5j97yyadzc7bnykholqsr/",
    "sourceUrl": "https://html5.gamemonetize.com/7j6xjz5mtmf5j97yyadzc7bnykholqsr/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70841",
    "slug": "black-and-white-2",
    "title": "Black And White 2",
    "description": "Black and White 2 is a fast-paced arcade game where you control a cube that switches between black and white. Jump over obstacles, adapt to shifting patterns, and survive as long as you can. Each zone you clear restores your 6 lives, but when they run out it&rsquo;s game over. The Game Over screen shows how far you made it before giving you the chance to retry and jump straight back into the action. With its minimalist design, sharp contrast, and addictive gameplay, Black and White delivers a modern arcade experience that&rsquo;s easy to pick up but hard to master.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Block",
      "Casual",
      "endless",
      "Hypercasual",
      "jump",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/gkxj0wqryg0efku1bkdtgjsa2jaaml9b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gkxj0wqryg0efku1bkdtgjsa2jaaml9b/",
    "sourceUrl": "https://html5.gamemonetize.com/gkxj0wqryg0efku1bkdtgjsa2jaaml9b/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69187",
    "slug": "whats-in-my-bag",
    "title": "Whats In My Bag?",
    "description": "Unpack style and surprises in What&rsquo;s In My Bag? &ndash; the ultimate dress-up and makeup game for fashion lovers! Choose cute outfits, glam makeup, and trendy bags, then reveal what&rsquo;s inside each one. From influencer props to girly goodies, every bag tells a story. Get creative, show off your style, and join the viral &ldquo;what&rsquo;s in my bag&rdquo; trend now! Perfect for fans of dress-up games, makeup fun, and aesthetic vibes.",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Decorate",
      "Decoration",
      "Dress Up",
      "Fashion",
      "Girl"
    ],
    "thumbnail": "https://img.gamemonetize.com/8dxx4qmb65d51vv2bm5zenycya9mrmxb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8dxx4qmb65d51vv2bm5zenycya9mrmxb/",
    "sourceUrl": "https://html5.gamemonetize.com/8dxx4qmb65d51vv2bm5zenycya9mrmxb/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "70840",
    "slug": "super-basketball-bluey",
    "title": "Super Basketball Bluey",
    "description": "Super Basketball is a simple yet incredibly addictive game built on realistic physics! Just tap and slide the ball to adjust the angle and power, then shoot it straight into the hoop. With smooth physics and visual effects, every shot looks clear and exciting. It&rsquo;s an endless arcade challenge: score to advance through levels as the difficulty rises with four different random hoop movements. But be careful &mdash; you only have 3 shots to complete each level! HOW TO PLAY: Tap the screen. Drag the ball to adjust power and angle. Release to shoot!",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Basketball",
      "Cartoon",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/k42cjr2na7lc5sgm3hq42yewek26tzib/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k42cjr2na7lc5sgm3hq42yewek26tzib/",
    "sourceUrl": "https://html5.gamemonetize.com/k42cjr2na7lc5sgm3hq42yewek26tzib/",
    "width": 1024,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70846",
    "slug": "noob-vs-pro-but-anvil-rain-minecraft",
    "title": "Noob vs Pro But Anvil Rain Minecraft",
    "description": "Noob and Pro decided to sit down and relax, but a sudden anvil rain ruined their plans! Now they&rsquo;re trying to survive in this world! A fun two-player game in the style of Minecraft. The game features: Two-player mode Single-player mode 12 main levels 3 single-player levels Hot lava Heavy and noisy anvils Falling sand blocks (its a tradition by now) Levels with lava lakes Strange levels? And much more! The main goal is to dodge the falling anvils. The longer you survive, the more anvils will fall every second!",
    "instructions": "On PC Pro controls A D to move left and right W to jump Noob controls Left arrow Right arrow to move Up arrow to jump On Mobile Pro controls joystick Noob controls joystick",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Brain",
      "Brainrot",
      "destroy",
      "Fight",
      "Fun",
      "Funny",
      "Hot",
      "Jumping",
      "Mine",
      "mineblock",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/2fm5dy4usyoe0ze5t6tjxrd6kiluifh8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2fm5dy4usyoe0ze5t6tjxrd6kiluifh8/",
    "sourceUrl": "https://html5.gamemonetize.com/2fm5dy4usyoe0ze5t6tjxrd6kiluifh8/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70861",
    "slug": "people-tower",
    "title": "People tower",
    "description": "We need to get to the finish line, but there are many obstacles ahead that will have to be bypassed. Collect people along the way to form a high pyramid, so you will definitely go all the way.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/o9qyw5t3ziqgjwg7m7akjicg1no56b5q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o9qyw5t3ziqgjwg7m7akjicg1no56b5q/",
    "sourceUrl": "https://html5.gamemonetize.com/o9qyw5t3ziqgjwg7m7akjicg1no56b5q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70649",
    "slug": "slither-mini-kingdom",
    "title": "Slither Mini Kingdom",
    "description": "Control a glowing snake in a competitive arena, eating dots to grow longer while outmaneuvering other players. Avoid colliding with your rivals to survive, and trap them to turn them into food. Your goal is simple: become the longest snake and dominate the leaderboard.",
    "instructions": "Mouse to control amp space button to boost in phone use joystick to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Multiplayer",
      "Slither",
      "Worms"
    ],
    "thumbnail": "https://img.gamemonetize.com/21k6yq7qmr0c2807attftweykcvk8e3m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/21k6yq7qmr0c2807attftweykcvk8e3m/",
    "sourceUrl": "https://html5.gamemonetize.com/21k6yq7qmr0c2807attftweykcvk8e3m/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70704",
    "slug": "obby-climb-and-slide",
    "title": "Obby: Climb and Slide",
    "description": "Ready to conquer the tallest slides? In this game, you can! Climb higher and higher up the ladders, then rush down the thrilling slides! The farther you slide, the more coins you collect! And with cute pets by your side, you&rsquo;ll earn even more &mdash; they&rsquo;ll help you gather coins! What awaits you: &bull; Long ladders and exciting slides for speedy rides &bull; Funny pet companions &bull; Bright levels and new heights &bull; Fun gameplay and colorful graphics Climb up, slide down, and become the ultimate slide champion!",
    "instructions": "On PC WASD ndash Move Mouse ndash Camera control Space ndash Jump On Mobile Use the on-screen controls Drag anywhere on the screen ndash Camera control",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Car",
      "Clicker",
      "roblox",
      "Simulation",
      "Simulator",
      "slide",
      "slider",
      "sliding",
      "waterslide"
    ],
    "thumbnail": "https://img.gamemonetize.com/lr5u64zee68h9nghuu29z8dxce7iecfo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lr5u64zee68h9nghuu29z8dxce7iecfo/",
    "sourceUrl": "https://html5.gamemonetize.com/lr5u64zee68h9nghuu29z8dxce7iecfo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70833",
    "slug": "happy-gunman",
    "title": "Happy Gunman",
    "description": "Your salvation is in your hands, in order to survive, you need to take accurate shots at your pursuers. All forces are thrown in pursuit of you, even using dinosaurs to chase you.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Arcade",
      "attack",
      "Dinosaur",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/ugosyon4e6hxxou6ykzar5ogexl2cly3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ugosyon4e6hxxou6ykzar5ogexl2cly3/",
    "sourceUrl": "https://html5.gamemonetize.com/ugosyon4e6hxxou6ykzar5ogexl2cly3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70338",
    "slug": "bear-block-puzzle",
    "title": "Bear Block Puzzle",
    "description": "Fun Bear Block Puzzle is a classic and engaging block puzzle game that challenges your logic and sharpens your mind. Designed for players of all ages, this game offers a perfect blend of relaxation and brain training, making it an excellent choice for puzzle lovers. With simple drag-and-drop mechanics, your goal is to place blocks on the grid and clear lines to earn points. Whether you are looking for a stress-relieving game, a logic challenge, or just a fun way to pass time, Fun Bear Block Puzzle is the perfect companion. How to Play Drag and drop blocks onto the 8x8 grid. Fill rows or columns completely to clear them and score points.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "amazing",
      "Block",
      "Brainrot",
      "Puzzle",
      "puzzleblock",
      "Strategy",
      "touchscreen"
    ],
    "thumbnail": "https://img.gamemonetize.com/apn0y579tb1ytuvaxmbf6dm80xa7mfy8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/apn0y579tb1ytuvaxmbf6dm80xa7mfy8/",
    "sourceUrl": "https://html5.gamemonetize.com/apn0y579tb1ytuvaxmbf6dm80xa7mfy8/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "63537",
    "slug": "candy-quest",
    "title": "Candy Quest",
    "description": "Candy Quest: A Sweet Puzzle Adventure! Candy Quest is an exciting and addictive logic-based puzzle game that will challenge your thinking while delivering endless fun. With vibrant visuals, engaging gameplay, and strategic challenges, it keeps players entertained for hours. Your mission is simple but requires skill and planning: collect the required number of blocks in each level, ranging from two to four different types. But don&rsquo;t be fooled by its simplicity&mdash;each level comes with a limited number of moves, making every decision crucial. Unlike many puzzle games, Candy Quest gives you unlimited access to powerful boosters, ensuring a thrill",
    "instructions": "PC controls Mouse Touch Control works on all browsers and all mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/w4gggcqnowrr17s49loiqhnili9mu2zd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w4gggcqnowrr17s49loiqhnili9mu2zd/",
    "sourceUrl": "https://html5.gamemonetize.com/w4gggcqnowrr17s49loiqhnili9mu2zd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70504",
    "slug": "journey-of-escape",
    "title": "Journey Of Escape",
    "description": "Escape games have always been a popular genre among puzzle enthusiasts and adventure seekers. They challenge players to think critically, solve intricate puzzles, and uncover hidden secrets while racing against time. Journey of Escape is an immersive collection of escape games designed to test your intelligence",
    "instructions": "Use mouse to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Escape",
      "Hidden",
      "Puzzle",
      "Room"
    ],
    "thumbnail": "https://img.gamemonetize.com/l1rhybtx256rpe52ssv2hjxjx2lb38hk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l1rhybtx256rpe52ssv2hjxjx2lb38hk/",
    "sourceUrl": "https://html5.gamemonetize.com/l1rhybtx256rpe52ssv2hjxjx2lb38hk/",
    "width": 1280,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "70505",
    "slug": "ocean-blast-match-3",
    "title": "Ocean Blast Match 3",
    "description": "Ocean King Match Puzzle is design based on ocean creatures to gives you the taste of ocean. For Match 3 puzzle game lovers to experience the ocean life in Game play. Match 3 items to start the fun and explore the ocean. Blast through multiple items Become the King of Ocean by matching and solving ocean puzzle. Show your matching and solving skills to unlock the depths of the ocean. Thousands of Brain storming puzzle to boost your brain cells. Ocean King Match Puzzle Gives you the chance to explore the hidden treasures of the ocean. Rule the ocean and show your skills to the world. Make your path to the end of bottom.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D Games",
      "Adventure",
      "Bomb",
      "Brain",
      "Match 3",
      "Mind",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/nmftnzx6e4frgw01p965k2aadoiajyto/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nmftnzx6e4frgw01p965k2aadoiajyto/",
    "sourceUrl": "https://html5.gamemonetize.com/nmftnzx6e4frgw01p965k2aadoiajyto/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70659",
    "slug": "shuffle-sage",
    "title": "Shuffle Sage",
    "description": "Shuffle Sage &ndash; A Solitaire Challenge of Wisdom and Strategy Step into the world of Shuffle Sage, a solitaire-inspired card game where patience meets mastery. Your goal is simple yet challenging: arrange the sequence of cards in perfect order, carefully alternating between red and black suits as you build your stacks. Every move counts &mdash; place the wrong card and you&rsquo;ll block your progress, but with the right foresight and planning, you can untangle the toughest layouts. Test your wisdom, sharpen your strategy, and prove yourself worthy of the title Shuffle Sage. Are you ready to conquer the deck and achieve the perfect sequence?",
    "instructions": "Arrange the cards as in Solitaire",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Casual",
      "Solitaire"
    ],
    "thumbnail": "https://img.gamemonetize.com/vwgqt3a0451fmt38zjpxlmr21q9vpxuh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vwgqt3a0451fmt38zjpxlmr21q9vpxuh/",
    "sourceUrl": "https://html5.gamemonetize.com/vwgqt3a0451fmt38zjpxlmr21q9vpxuh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70809",
    "slug": "deep-fuel",
    "title": "Deep Fuel",
    "description": "In Deep Fuel, you dive underground with your drill machine and race against fuel consumption. Collect gold, oil, and gems to boost your score, while avoiding walls and running out of fuel. Compete with AI bots, unlock upgrades, and climb the leaderboard. Simple controls, addictive gameplay, endless digging fun!",
    "instructions": "Arrow Keys A D rarr Move left amp right Down Arrow rarr Drill deeper auto-move down is also active Mouse Touch rarr Tap left or right side of the screen to move on mobile E Key Tap Button rarr Use active power-up",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Action",
      "Battle",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/kz6p3x5tdz7fc43lf424reyq68yd9ixp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kz6p3x5tdz7fc43lf424reyq68yd9ixp/",
    "sourceUrl": "https://html5.gamemonetize.com/kz6p3x5tdz7fc43lf424reyq68yd9ixp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70815",
    "slug": "red-ball-html5",
    "title": "Red Ball Html5",
    "description": "The Red Ball HTML5 game captures players with its straightforward approach. Youll quickly see why its easy rules lead to so much replay value. This classic arcade fun is always ready to go, no matter where you are. It proves that great games dont need fancy graphics to be super entertaining. Its basic design hides a deep sense of fun. You get hooked trying to solve each levels unique puzzles. This game shows how simple ideas can deliver endless hours of fun. Why do people keep coming back for more? Its charm is tough to beat.",
    "instructions": "Use the arrow keys to play For mobile devices use the arrows that appear on the screen of your device",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ball",
      "html5 games",
      "Red"
    ],
    "thumbnail": "https://img.gamemonetize.com/npkz17stxru2fpolezaguktgnxkw2fk8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/npkz17stxru2fpolezaguktgnxkw2fk8/",
    "sourceUrl": "https://html5.gamemonetize.com/npkz17stxru2fpolezaguktgnxkw2fk8/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70783",
    "slug": "fruits-mania",
    "title": "Fruits Mania",
    "description": "Fruit Mania is a colorful match &amp; tap puzzle game for all ages. Your mission is to help the cute little lemming collect the right fruits! On the board, you&rsquo;ll see plenty of smiling fruit blocks (red strawberries, blue blueberries, yellow lemons, green watermelons, and more). The player must tap groups of same-colored fruits to clear them and earn points. The larger the group of fruits you tap, the higher your score and combo bonus! At the bottom right, the game shows the fruit needed (for example, a red strawberry) that you must collect to complete the level&rsquo;s goal.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cartoon",
      "Fruit",
      "Fruits",
      "mapi games",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/714lpb7fb1587g0hknogzq32jzaithkd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/714lpb7fb1587g0hknogzq32jzaithkd/",
    "sourceUrl": "https://html5.gamemonetize.com/714lpb7fb1587g0hknogzq32jzaithkd/",
    "width": 768,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "70667",
    "slug": "running-in-foam",
    "title": "running in foam",
    "description": "In the game, we need to control the girl and use various bathing tools to bathe the girl. When the girl successfully washes up and reaches the end, the game will be won. Come and experience it with me.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/p32lr73p0596mo5r2flvqye8rw8ho34o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p32lr73p0596mo5r2flvqye8rw8ho34o/",
    "sourceUrl": "https://html5.gamemonetize.com/p32lr73p0596mo5r2flvqye8rw8ho34o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67499",
    "slug": "brick-breaker-gala",
    "title": "Brick Breaker Gala",
    "description": "Shatter bricks and shine in Brick Breaker Gala, a thrilling arcade game! Strategically launch balls, unleash powerful power-ups, and demolish colorful brick walls across countless levels. Earn stars with high scores to advance in the dazzling Summer Gala, claiming fantastic rewards! Collect coins to enhance your gameplay through a robust upgrade system, boosting your balls, power-ups, and lives. Conquer challenges with skill and precision in this visually stunning and endlessly addictive brick-breaking adventure!",
    "instructions": "Use mouse or tap to set ball shoot direction and destroy bricks",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Ball",
      "Best Games",
      "Bricks",
      "destroy",
      "destroying",
      "destruction",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/075c3wfmrlnx6tquvca3mv81et2ue5fu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/075c3wfmrlnx6tquvca3mv81et2ue5fu/",
    "sourceUrl": "https://html5.gamemonetize.com/075c3wfmrlnx6tquvca3mv81et2ue5fu/",
    "width": 1116,
    "height": 816,
    "lastUpdated": ""
  },
  {
    "id": "68155",
    "slug": "paper-doll-makeover-dress-up",
    "title": "Paper Doll Makeover Dress Up",
    "description": "Welcome to Paper Doll Makeover &amp; Dress Up, a doll world where the fashion of DIY paper doll and the fun of a doll dress up game come together. Step into this enchanting dress up game and become the stylist of your very own paper princess. With over 1000 fashion items at your fingertips, including trendy clothing, unique accessories, various hairstyles, and ASMR-inspired makeup, you can let your DIY creativity soar through your cute doll.",
    "instructions": "Transform your paper doll into a fashion icon with your styling skills From elegant outfits to stylish accessories design looks that turn your doll princess into a style queen Each choice you make has a significant impact leading your DIY journey in e",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/efbm9g8i0f8euf9hbf7q1sz749s37jfc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/efbm9g8i0f8euf9hbf7q1sz749s37jfc/",
    "sourceUrl": "https://html5.gamemonetize.com/efbm9g8i0f8euf9hbf7q1sz749s37jfc/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70776",
    "slug": "snaily-braver-europe-adventure",
    "title": "Snaily Braver (Europe Adventure)",
    "description": "Join Snaily Braver on a Grand European Adventure! Get ready to embark on a charming journey with the worlds most intrepid snail! Meet Snaily, a small adventurer with a big heart and an even bigger dream: to capture the perfect selfie in Europes most famous cities. He&rsquo;s packed his shell and is ready for an unforgettable trip, but he cant do it without you! Guide our courageous hero through the stunning landscapes of Paris, Amsterdam, and London in this delightful platforming adventure. Leap across rooftops, dodge the grumpy Fog Police, and outsmart mischievous crows as you explore beautifully crafted levels inspired by real-world locations",
    "instructions": "Simple amp Intuitive Controls Mastering Snailys moves is easy and fun whether youre at a desk or on the go On PC Use the Arrow Keys to run left and right and press the Up Arrow to jump Ready to defend yourself Hit the Spacebar to launch a spitball",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Animal",
      "Arcade",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/5vy9blk0bhy14ih2th0sfcco6pf5z3ea/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5vy9blk0bhy14ih2th0sfcco6pf5z3ea/",
    "sourceUrl": "https://html5.gamemonetize.com/5vy9blk0bhy14ih2th0sfcco6pf5z3ea/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70658",
    "slug": "chromatch",
    "title": "Chromatch",
    "description": "Chromatch &ndash; Test Your Reflexes, Match Your Colors! Get ready for Chromatch, the fast-paced color-matching challenge that keeps you on your toes! A spinning wheel divided into four vibrant color sections awaits your precision. Your task is simple: throw the arrow of a given color and hit the matching section. But be careful&mdash;land on the wrong color, and you&rsquo;ll lose one of your three lives. As the wheel speeds up, your reflexes, timing, and focus will be put to the ultimate test. Easy to pick up but hard to master, Chromatch delivers endless fun in short bursts, making it perfect for casual play or high-score chasers.",
    "instructions": "Shoot at the right time to match the color",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "arrow",
      "Color",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/ll1v3omcwn8r7zyd9joxny6ym3mrj8rr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ll1v3omcwn8r7zyd9joxny6ym3mrj8rr/",
    "sourceUrl": "https://html5.gamemonetize.com/ll1v3omcwn8r7zyd9joxny6ym3mrj8rr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70774",
    "slug": "unicorn-coloring-challenge",
    "title": "Unicorn Coloring Challenge",
    "description": "Unicorn Coloring Challenge is a magical and delightful coloring game that will spark creativity in kids and adults alike! Dive into a world of rainbow-colored unicorns, sparkling stars, and enchanted landscapes. Grab your digital crayons, paints, and brushes to bring each adorable unicorn to life. With endless colors to choose from, you can create dazzling designs, mix and match patterns, and let your imagination run wild. Perfect for little artists who love magical creatures, glittery adventures, and fun challenges. Let the unicorn magic begin and see who can make the most fabulous masterpiece!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cartoon",
      "Coloring",
      "Educational",
      "Fun",
      "Girls",
      "Hypercasual",
      "Mobile",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/os0nnbahf0d3dnlf5kmsk8pl19cg3x11/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/os0nnbahf0d3dnlf5kmsk8pl19cg3x11/",
    "sourceUrl": "https://html5.gamemonetize.com/os0nnbahf0d3dnlf5kmsk8pl19cg3x11/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "70773",
    "slug": "rapid-match",
    "title": "Rapid Match",
    "description": "Tap, match, and clear the row! In this fast-paced puzzle game where timing and precision matter, you shoot blocks from the bottom to hit the matching ones above. Match them right and boom &mdash; the whole row is gone! But watch out &mdash; your block changes on its own!",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Block",
      "Clicker",
      "Halloween",
      "Shoot 'Em Up",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/eq9kggnt86xu08stss3m9lt0bnupwn0w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eq9kggnt86xu08stss3m9lt0bnupwn0w/",
    "sourceUrl": "https://html5.gamemonetize.com/eq9kggnt86xu08stss3m9lt0bnupwn0w/",
    "width": 600,
    "height": 1000,
    "lastUpdated": ""
  },
  {
    "id": "70588",
    "slug": "sort-and-style-back-to-school",
    "title": "Sort And Style: Back To School",
    "description": "Step into the world of Sort And Style: Back To School, a fun mix of sorting and dress-up games for girls! Organize messy desks, lockers, wardrobes, and even bento boxes across 9 exciting levels. Then, challenge your creativity in the final dress-up unit where you style your school look with trendy uniforms, shoes, hairstyles, and accessories. Perfect for fans of organizing games, makeover fun, and school fashion challenges!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Cleaning",
      "Dress Up",
      "Fashion",
      "Girl",
      "html5 games",
      "School",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/qykgrmfq439njtlgmw9dau4s7zgksbcr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qykgrmfq439njtlgmw9dau4s7zgksbcr/",
    "sourceUrl": "https://html5.gamemonetize.com/qykgrmfq439njtlgmw9dau4s7zgksbcr/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "70695",
    "slug": "galaxy-blaster",
    "title": "Galaxy Blaster",
    "description": "Galaxy Blaster is an exciting brick-breaking adventure designed for both kids and adults. Smash through waves of glowing bricks as you advance from one level to the next, each more challenging than the last. Collect valuable points along the way and use them to upgrade your paddle, making it stronger and faster. With its cosmic theme and addictive gameplay, Galaxy Blaster guarantees hours of fun among the stars!",
    "instructions": "Arrow keys to move the paddle",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Boys",
      "Bricks",
      "Collecting",
      "Hypercasual",
      "Puzzle",
      "puzzleblock",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/sztozbv85en6n3c47kguipa0bp1q2kw2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sztozbv85en6n3c47kguipa0bp1q2kw2/",
    "sourceUrl": "https://html5.gamemonetize.com/sztozbv85en6n3c47kguipa0bp1q2kw2/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "70669",
    "slug": "battle-swat-vs-mercenary-remaster",
    "title": "Battle SWAT vs Mercenary Remaster",
    "description": "Battle SWAT vs Mercenary throws you into intense first-person shooter action where you pick a side and fight for dominance. Choose to fight as a skilled SWAT soldier or a ruthless mercenary in thrilling multiplayer battles. The game also features a zombie mode, where you can rise from the dead and hunt down your enemies. With fast-paced combat and diverse modes, every match is packed with adrenaline and chaos. Web Dev <a href='https://www.crazygamesx.com/.'>https://www.crazygamesx.com/.</a> Mouse to aim, shooting, change gun, Tab for menu, WASD to walk-run.",
    "instructions": "Mouse to aim shooting change gun Tab for menu WASD to walk-run",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "Mentolatux",
      "Multiplayer",
      "Shooting",
      "unblocked",
      "unblocked games",
      "unity",
      "WebGL",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/np11v2111dvriy3bgljgr99a8qo2l8vi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/np11v2111dvriy3bgljgr99a8qo2l8vi/",
    "sourceUrl": "https://html5.gamemonetize.com/np11v2111dvriy3bgljgr99a8qo2l8vi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70602",
    "slug": "hop-to-rescue",
    "title": "Hop To Rescue",
    "description": "Hop To Rescue is a fun and challenging platformer adventure where you help the hero rescue animals trapped in cages. Jump across platforms, avoid traps, and time your moves to clear each level. Collect coins to boost your score and unlock tougher challenges. With smooth one-tap or key controls, colorful 2D graphics, and addictive gameplay, this arcade-style rescue game is easy to play but hard to master. Perfect for fans of action, adventure, and platform games, Hop To Rescue offers endless fun on both desktop and mobile. Play free online and test your skills today!",
    "instructions": "Desktop Press Space or Up Arrow to Jump Mobile Tap anywhere on the screen to Jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Adventure",
      "Arcade",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "Games",
      "jump",
      "Jumping",
      "NapTech Games",
      "Online",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/rxh15es73gp24lr7xh08s50e5n57521y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rxh15es73gp24lr7xh08s50e5n57521y/",
    "sourceUrl": "https://html5.gamemonetize.com/rxh15es73gp24lr7xh08s50e5n57521y/",
    "width": 2560,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "70382",
    "slug": "cheez-pizza-ready",
    "title": "Cheez Pizza Ready",
    "description": "Cheez Pizza Ready game where you manage and expand your own pizza restaurant, taking orders at the counter and drive-thru, cooking and serving pizzas, managing staff, and growing your business into a chain. The game features a casual, free-to-play experience focused on the business management aspects of running a pizzeria!!",
    "instructions": "Pizza Ready is a simulation game and as such its controlled using touch and tap inputs on your device rather than traditional keyboard or mouse controls Youll simply tap on the screen to interact with your restaurant hire staff manage orders and u",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D Games",
      "Adventure",
      "amazing",
      "Boy",
      "Cooking",
      "pizza",
      "Shopping"
    ],
    "thumbnail": "https://img.gamemonetize.com/nrgqcwl31wbabd43s3hbw1850kbempg3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nrgqcwl31wbabd43s3hbw1850kbempg3/",
    "sourceUrl": "https://html5.gamemonetize.com/nrgqcwl31wbabd43s3hbw1850kbempg3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70679",
    "slug": "cowboy-shooter-2",
    "title": "Cowboy Shooter 2",
    "description": "Step into the Wild West and test your aim in this fast-paced cowboy shooting game! Time is running out, and every shot counts. Break bottles, hit targets, and push yourself to earn the highest score before the clock runs out. With changing weather conditions and an increasingly fast-paced tempo, the excitement rises even higher. With its simple yet addictive gameplay, Cowboy Shooter 2 offers endless fun and a true test of your reflexes. Are you quick enough to become the ultimate sharpshooter?",
    "instructions": "Aim Move the mouse to aim at the targets Shoot Press the Left Mouse Button to fire Mobile Use the on-screen buttons to aim and shoot just like on PC",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Action",
      "Boys",
      "Bullet",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/jc2acrnxxo170e3q4gaovsvhle6dt7wj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jc2acrnxxo170e3q4gaovsvhle6dt7wj/",
    "sourceUrl": "https://html5.gamemonetize.com/jc2acrnxxo170e3q4gaovsvhle6dt7wj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70660",
    "slug": "mosaic-master",
    "title": "Mosaic Master",
    "description": "Unleash your creativity and sharpen your mind in Mosaic Master, a relaxing yet challenging puzzle game where every shape finds its perfect place. How to Play: Fit colorful geometric pieces into beautifully designed patterns. Complete each mosaic to reveal stunning artwork made of soothing colors, flowers, and leaves. Features: Hundreds of Unique Puzzles &ndash; From simple shapes to intricate masterpieces. Relaxing Gameplay &ndash; No timers, just calming music and beautiful visuals. Soothing Aesthetic &ndash; Floral themes and gentle colors for a peaceful experience. Brain Training &ndash; Improve focus, logic, and spatial reasoning.",
    "instructions": "Match the shapes and colors",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Color",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/32huepcj4fmn0h55mpxme5boehkasb8b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/32huepcj4fmn0h55mpxme5boehkasb8b/",
    "sourceUrl": "https://html5.gamemonetize.com/32huepcj4fmn0h55mpxme5boehkasb8b/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70675",
    "slug": "long-nails",
    "title": "Long nails",
    "description": "All we need to do is move the mouse so that the character moves left and right, and then get resources on the field. All we have to do is increase the length of the nails to get to the finish line and get the maximum reward.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Arcade",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/s2yckj9jz9wtna63yxw2vf7wvlwgjd9a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s2yckj9jz9wtna63yxw2vf7wvlwgjd9a/",
    "sourceUrl": "https://html5.gamemonetize.com/s2yckj9jz9wtna63yxw2vf7wvlwgjd9a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70664",
    "slug": "superbrain",
    "title": "Superbrain",
    "description": "Run forward and increase the brain in size, you will need it at the end to launch the monkey to another planet. Try to get the maximum brain size.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D",
      "Arcade",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/s70c6wusr70i4grzeocugji5asw17eo0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s70c6wusr70i4grzeocugji5asw17eo0/",
    "sourceUrl": "https://html5.gamemonetize.com/s70c6wusr70i4grzeocugji5asw17eo0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70634",
    "slug": "labubu-geometry-dash",
    "title": "Labubu Geometry Dash",
    "description": "Labubu Geometry dash is an avoider game. Play as tiny plane, avoid any obstacles, gain power up and enjoy Labubu dancing. Challenge all 40 level of chaotic level!",
    "instructions": "mouse only",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "3D Games",
      "angryplants",
      "Animal",
      "Labubu"
    ],
    "thumbnail": "https://img.gamemonetize.com/qge3r3syyxhvzxjf6cb5oe0rq9bk9uxh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qge3r3syyxhvzxjf6cb5oe0rq9bk9uxh/",
    "sourceUrl": "https://html5.gamemonetize.com/qge3r3syyxhvzxjf6cb5oe0rq9bk9uxh/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70661",
    "slug": "number-nexus",
    "title": "Number Nexus",
    "description": "Enter the Number Nexus, a world where logic and quick thinking collide! Numbered boxes fall from above, and it&rsquo;s your job to place them wisely. When two blocks of the same value meet, they merge into a single higher number, freeing up space and boosting your score. Every move matters: stack carefully, chain your merges, and keep the board clear while chasing ever-larger numbers. The more you combine, the higher your score climbs&mdash;and the closer you get to mastering the nexus of numbers. With endless possibilities and addictive gameplay, Number Nexus is the perfect test of strategy, foresight, and mathematical mastery. Make your mark!",
    "instructions": "Click to drop the number in that lane",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Math",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/xz46f70xu0un63f8l196dtwchzujrtyn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xz46f70xu0un63f8l196dtwchzujrtyn/",
    "sourceUrl": "https://html5.gamemonetize.com/xz46f70xu0un63f8l196dtwchzujrtyn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70662",
    "slug": "whimsy-workshop",
    "title": "Whimsy Workshop",
    "description": "Step inside the Whimsy Workshop, a playful world where every toy follows the rules of physics&mdash;and sometimes breaks them in surprising ways! Stack, topple, bounce, and roll your way through fun challenges as you experiment with blocks, balls, cars, and more. With realistic physics and endless possibilities, no two play sessions are ever the same. Build towering creations, set up chain reactions, or just enjoy the delightful chaos when everything comes crashing down. Perfect for players of all ages, Whimsy Workshop is a sandbox of creativity, curiosity, and toybox fun. Are you ready to play, build, and discover the magic of physics-driven to",
    "instructions": "Use Mouse Touch to place the objects",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Kid",
      "Physics",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/sehje38sm6k4yprnc6w4ciaeciqym2lu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sehje38sm6k4yprnc6w4ciaeciqym2lu/",
    "sourceUrl": "https://html5.gamemonetize.com/sehje38sm6k4yprnc6w4ciaeciqym2lu/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70636",
    "slug": "the-brick",
    "title": "The brick",
    "description": "The Brick Smash bricks, collect power-ups, and beat the clock in this high-pace arcade classic! In The Brick, your task is simple but addictive: launch the ball, bounce it off your paddle and destroy every brick on the screen. Grab falling power-ups and extra lives to turn the tide in your favor. Every level brings a fresh challenge&mdash;faster speeds, tight corners, and clever layouts. Keep the ball in play as long as you can; missed catches will cost you lives. Can you keep your reflexes sharp enough to set the ultimate high score? thanks for playing",
    "instructions": "mouse",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Arcade",
      "Ball",
      "Bricks",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/1b923d8oda3amyye1sir3gytq0929qz4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1b923d8oda3amyye1sir3gytq0929qz4/",
    "sourceUrl": "https://html5.gamemonetize.com/1b923d8oda3amyye1sir3gytq0929qz4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70637",
    "slug": "color-connect-master",
    "title": "Color Connect Master",
    "description": "Color Connect Master Welcome to Color Connect Master, the ultimate puzzle game where colors meet your logic skills! Relax, strategize, and connect your way through dozens of mindteasing levels. Perfect for players of all ages who love a satisfying challenge. How to Play- Connect matching colored dots by drawing continuous lines between them. Ensure that no two lines intersect &mdash; paths must not cross or overlap. Fill the entire grid to complete each level. Features Hundreds of levels with increasing difficulty &mdash; start easy, get challenging! Multiple grid sizes to test your spatial thinking. thanks for playing",
    "instructions": "mouse for pc users",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "construction",
      "Hypercasual",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/l0t60tzlheh3tupvmst1stzql9h68vnp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l0t60tzlheh3tupvmst1stzql9h68vnp/",
    "sourceUrl": "https://html5.gamemonetize.com/l0t60tzlheh3tupvmst1stzql9h68vnp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70639",
    "slug": "hexa-master",
    "title": "hexa master",
    "description": "Hexa Master Dive into the colorful world of Hexa Master, a dazzling hexagonal match-puzzle game that&rsquo;s perfect for your next gaming fix! Rotate clusters of glowing dots, match three or more, and unleash chain reactions to clear each level. Hundreds of Levels &ndash; Every stage brings new challenges and surprises. Vibrant Visuals &ndash; Stunning graphics and smooth animations make the gameplay a treat for the eyes. Easy to Learn, Hard to Master &ndash; Tap or click to rotate the hexagon; plan moves to get higher scores and bonuses. Relax or Compete &ndash; Play to unwind, or sharpen your strategy to beat your high score. thanks for playing",
    "instructions": "mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Action",
      "Casual",
      "Clash",
      "Classic",
      "Color",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/hb61fead4eytu525smtnepg73cjgadt7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hb61fead4eytu525smtnepg73cjgadt7/",
    "sourceUrl": "https://html5.gamemonetize.com/hb61fead4eytu525smtnepg73cjgadt7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70372",
    "slug": "space-stairwell",
    "title": "Space Stairwell",
    "description": "Space Stairwell is a fast-paced survival game. You control a sphere and must jump up an endless series of platforms rising from the bottom of the screen. The goal is to survive as long as possible by completing levels. Every jump consumes energy, so you must collect items to recharge. The game gets harder in higher levels, with platforms that collapse faster and require quicker reflexes. You can unlock new levels by successfully completing the previous ones.",
    "instructions": "Controls The game can be played on both Mobile and PC Mobile Jump Tap directly on the platform you want to jump to PC Jump Click with your mouse on the platform you want to jump to Slide Use the A D or the Left Right Arrow Keys to slide Smart-J",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Action",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/c8d6ujnjwx4npxq1kx1vwoly2lw16j45/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c8d6ujnjwx4npxq1kx1vwoly2lw16j45/",
    "sourceUrl": "https://html5.gamemonetize.com/c8d6ujnjwx4npxq1kx1vwoly2lw16j45/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70292",
    "slug": "scary-baby-pink-horror-game",
    "title": "Scary Baby Pink Horror Game",
    "description": "Welcome to the chilling world of Scary Baby Pink, where babysitting takes on a terrifying twist! Brace yourself for an immersive horror experience unlike any other. Are you ready to face the darkness lurking within Your house. In this spine-tingling game, you play the role of a babysitter tasked with caring for a seemingly innocent baby. However, as night falls, you quickly realize that there is something sinister about the child youre watching over. Your objective? Survive the night and uncover the dark secrets hidden within the babys room while taking care of the baby and keeping her safe from the evil racoon.",
    "instructions": "-Arrow keys WASD to move Hold LMB RMB to move the camera to look around and Mouse click to interact for PC users -Touch Screen for mobile users to move and interact in gameplay",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Baby Games",
      "Ghost",
      "Horror",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/e1hzuywcosqdxcxvawfs22una3vsknto/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e1hzuywcosqdxcxvawfs22una3vsknto/",
    "sourceUrl": "https://html5.gamemonetize.com/e1hzuywcosqdxcxvawfs22una3vsknto/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70597",
    "slug": "rogue-runner",
    "title": "Rogue Runner",
    "description": "Become the most wanted fugitive in a relentless, high-octane Rogue Runner simulator. Outsmart and outdrive an ever-growing police force in a dynamic open world. Your driving skills are the only thing between freedom and capture. Weave through dense urban traffic, execute dangerous maneuvers, and use the environment to your advantage. Every smashed barrier and near-miss intensifies the pursuit. Feel the adrenaline surge as SWAT teams join the hunt, deploying spike strips and tactical units. How long can you survive with the entire citys law enforcement on your tail? Push your vehicle to its limits, master the streets, and defy capture in",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "2025 games",
      "attack",
      "Race",
      "Racing",
      "Sniper"
    ],
    "thumbnail": "https://img.gamemonetize.com/0ofsn4w5u0lzffnmb1ed7d8ra7uj3wpv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0ofsn4w5u0lzffnmb1ed7d8ra7uj3wpv/",
    "sourceUrl": "https://html5.gamemonetize.com/0ofsn4w5u0lzffnmb1ed7d8ra7uj3wpv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70309",
    "slug": "xo-for-bro",
    "title": "xo for bro",
    "description": "Enjoy the timeless strategy game Tic Tac Toe (XO) with a modern design and smooth animations! Challenge your friends in Player vs Player mode or test your skills against a simple bot. Track your wins, losses, and draws with an automatic score system that saves your progress. With eye-catching visuals, glowing effects, and full mobile support, this version of Tic Tac Toe is the perfect mix of classic gameplay and modern style.",
    "instructions": "Click on any empty cell to place your mark X or O Get 3 in a row horizontally vertically or diagonally to win The game will automatically highlight the winning line or show a draw message",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2025 games",
      "2048",
      "2D",
      "Adult",
      "Bubble"
    ],
    "thumbnail": "https://img.gamemonetize.com/am1z1iytli8d5g1y4txjp9mfkxluoq7d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/am1z1iytli8d5g1y4txjp9mfkxluoq7d/",
    "sourceUrl": "https://html5.gamemonetize.com/am1z1iytli8d5g1y4txjp9mfkxluoq7d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70299",
    "slug": "sliding-number-puzzle-and-ndash-classic-brain-teaser",
    "title": "Sliding Number Puzzle &ndash; Classic Brain Teaser",
    "description": "Challenge your mind with Sliding Number Puzzle, a timeless brain teaser built with pure HTML5, ready to run seamlessly on desktop and mobile browsers. Rearrange the numbered tiles to restore the correct order in the least number of moves. Perfect for casual gamers and puzzle enthusiasts alike, this game delivers endless replay value with its clean design and addictive gameplay.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Memory",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/hzm4ilrkbvxv6bbtvycjitkgvqu4qyzk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hzm4ilrkbvxv6bbtvycjitkgvqu4qyzk/",
    "sourceUrl": "https://html5.gamemonetize.com/hzm4ilrkbvxv6bbtvycjitkgvqu4qyzk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70286",
    "slug": "secret-reef-merge",
    "title": "Secret Reef Merge",
    "description": "**Dive into Sea Merge Drop!** Merge adorable sea animals by dropping matching pairs. Watch them evolve into even cuter creatures! Tap to release animals strategically - create chains of merges for higher scores. Dont let the ocean fill up or its game over! Each merge earns points and unlocks new aquatic friends. Reach level targets to progress through the game. How many merges can you create? How high can you score? Can swim all the way through 10 levels? Simple one-tap gameplay with charming visuals. Perfect for quick play sessions or diving deep into merging madness! Ready to make a splash?",
    "instructions": "Click screen to place sea animals Desktop Tap screen to place sea animals mobile",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Bubble",
      "HTML"
    ],
    "thumbnail": "https://img.gamemonetize.com/n8kdjme20jrkue7qiyos81enwg8ncnxa/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n8kdjme20jrkue7qiyos81enwg8ncnxa/",
    "sourceUrl": "https://html5.gamemonetize.com/n8kdjme20jrkue7qiyos81enwg8ncnxa/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70254",
    "slug": "interactive-jigsaw-puzzle-game",
    "title": "Interactive Jigsaw Puzzle Game",
    "description": "Engage your users with a fun and interactive Jigsaw Puzzle Game built with pure HTML5, CSS3, and JavaScript. This fully responsive game allows players to click or tap puzzle pieces, complete puzzles of different sizes, and enjoy a smooth, user-friendly experience. Perfect for websites, educational platforms, or entertainment apps, this game is easy to integrate and customize. Features include multiple puzzle sets, responsive design, timer &amp; move counter, and attractive animations to enhance gameplay.",
    "instructions": "Drag amp drop puzzle pieces",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/duc00bv6i1up4xyinr3uu0ps3gguiyae/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/duc00bv6i1up4xyinr3uu0ps3gguiyae/",
    "sourceUrl": "https://html5.gamemonetize.com/duc00bv6i1up4xyinr3uu0ps3gguiyae/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69377",
    "slug": "quiz-education",
    "title": "Quiz Education",
    "description": "Quiz Education: A Fun and Interactive Way to Learn! Tired of boring textbooks? Transform your study sessions into an exciting adventure with Quiz Education! Dive into a world of knowledge with thousands of engaging quizzes across countless subjects. Whether youre a student, a professional, or a lifelong learner, our interactive platform makes mastering new topics simple and enjoyable. Track your progress, challenge your friends, and unlock achievements as you learn. Download now and discover how fun learning can be!",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Ai Games",
      "amazing",
      "Animal",
      "Baby Games",
      "Balance",
      "Ball",
      "Educational",
      "Logic",
      "Logical",
      "quest",
      "quests",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/zg27rg61nqjy6oaxt5puqpcn78g6q46a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zg27rg61nqjy6oaxt5puqpcn78g6q46a/",
    "sourceUrl": "https://html5.gamemonetize.com/zg27rg61nqjy6oaxt5puqpcn78g6q46a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70373",
    "slug": "fishdo",
    "title": "Fishdo",
    "description": "Dive into the magical world of Fishdo, where endless underwater adventures await! Play through exciting levels filled with puzzles, challenges, and fun surprises. Rescue and collect adorable fish and pets as you explore vibrant aquariums, each more beautiful than the last. Every level brings new obstacles to overcome and new treasures to discover. Unlock unique aquariums, customize them with colorful creatures, and watch your collection grow. Participate in special in-game events, earn rewards, and test your skills in a sea of captivating challenges. With charming graphics, relaxing gameplay, and lovable fish friends, Fishdo is perfect f",
    "instructions": "Use the mouse on kayboard or touch screen phone to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Family",
      "Fantasy",
      "Fishing",
      "Fun",
      "Funny",
      "Kids",
      "Logical",
      "Mind"
    ],
    "thumbnail": "https://img.gamemonetize.com/0z0adb53i13wjkbed88an3lu29nvmfat/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0z0adb53i13wjkbed88an3lu29nvmfat/",
    "sourceUrl": "https://html5.gamemonetize.com/0z0adb53i13wjkbed88an3lu29nvmfat/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70256",
    "slug": "pga-toons",
    "title": "PGA Toons",
    "description": "Lock and load in a vibrant voxel world where every corner is a playground and every jump can win the round. PGA Toons blends classic arena shooting with modern movement and snappy controls. Parkour across rooftops, slide through alleys, bounce off jump pads, and jetpack into mid-air duels. Web Dev <a href='https://www.poki76.com/'>https://www.poki76.com/</a> .Whether you&rsquo;re clutching a round in Team Deathmatch or snatching the flag with a last-second dash, the action stays tight, readable, and gloriously cartoonish.",
    "instructions": "Mouse click to shoot aim change gun Tab to menu",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "fps",
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/gw00mqn2tqrl78k76v4bug5o2ho9qng8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gw00mqn2tqrl78k76v4bug5o2ho9qng8/",
    "sourceUrl": "https://html5.gamemonetize.com/gw00mqn2tqrl78k76v4bug5o2ho9qng8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70586",
    "slug": "tomb-of-the-mask-color-maze",
    "title": "Tomb of the Mask Color Maze",
    "description": "Test your skills and see how many levels you can conquer in this thrilling 25 maze challenge! Your task is to paint the entire maze while avoiding the oncoming obstacles that get in your way. Each level presents new twists, turns, and obstacles, making the mazes progressively harder to complete",
    "instructions": "Use the arrow keys mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Casual",
      "free html5 games for your website",
      "kiz10",
      "Maze",
      "Puzzle",
      "puzzleblock",
      "smash",
      "tomb"
    ],
    "thumbnail": "https://img.gamemonetize.com/01hkwxirzy9ur5zanr1nn38da9ui7fob/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/01hkwxirzy9ur5zanr1nn38da9ui7fob/",
    "sourceUrl": "https://html5.gamemonetize.com/01hkwxirzy9ur5zanr1nn38da9ui7fob/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "70467",
    "slug": "tied-up",
    "title": "Tied Up",
    "description": "Tied Up is an action survival game with a unique twist! Control a small ball connected to a larger ball with a spring joint, and swing around to dodge and attack. Enemies come in challenging waves, each wave bringing new dangers trying to collide and take you down. You have 3 lives per round&mdash;survive as many waves as possible and push your high score higher each run. Easy to play, hard to master&mdash;can you stay alive while being Tied Up?",
    "instructions": "Movement Move your mouse to control the ball -Dodge enemies destroy them with the attached ball and survive each wave -You have 3 lives per round collisions reduce lives",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Action",
      "Arcade",
      "Ball",
      "Best Games",
      "Casual",
      "Highscore",
      "Mouse",
      "Physics",
      "Skills",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/nkck0dijlrvf2di28d70x6gzowufg2kb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nkck0dijlrvf2di28d70x6gzowufg2kb/",
    "sourceUrl": "https://html5.gamemonetize.com/nkck0dijlrvf2di28d70x6gzowufg2kb/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70548",
    "slug": "gloomy-princess-favorite-toy",
    "title": "Gloomy Princess Favorite Toy",
    "description": "Immerse yourself in the mysterious world of the Gloomy Princess and her strange but touching teddy friend. Create unique images for the heroine of the game: choose makeup, outfits and accessories - from witch hats to lace corsets in the Gothic spirit. Add personality to her favorite toy: change the expression of the muzzle, color, add ears, bows, scars, button eyes and other cute or creepy details. Assemble the perfect duo - a princess hiding her feelings behind a flawless image, and her beloved companion reflecting the inner world of the hostess!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Halloween",
      "Labubu"
    ],
    "thumbnail": "https://img.gamemonetize.com/ye86508jhpq8ujkvw2lns1hrdnnjo2s0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ye86508jhpq8ujkvw2lns1hrdnnjo2s0/",
    "sourceUrl": "https://html5.gamemonetize.com/ye86508jhpq8ujkvw2lns1hrdnnjo2s0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70496",
    "slug": "breakit",
    "title": "BreakIt",
    "description": "Control the block to fall down, smash the breakable platforms on each floor, avoid hitting obstacles, and safely reach the bottom.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/x6i89a1q0ivo2odpgwyxvu57vzizgegl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x6i89a1q0ivo2odpgwyxvu57vzizgegl/",
    "sourceUrl": "https://html5.gamemonetize.com/x6i89a1q0ivo2odpgwyxvu57vzizgegl/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70464",
    "slug": "fall-skibidi-toilet",
    "title": "Fall Skibidi Toilet",
    "description": "Dash through chaotic obstacle towers while Skibidi Toilets swarm&mdash;ragdoll physics, quick rounds, last one standing wins. Web Dev <a href='https://www.crazygamesx.com/'>https://www.crazygamesx.com/</a> Arcade party chaos with slippery floors, plungers as power-ups, and trap-filled courses. Solo or squad up online, unlock goofy skins, and yeet rivals off the map before the toilets get you.",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Fall Boys",
      "Fall Guys",
      "Mentolatux",
      "run",
      "Skibidi",
      "Skibidi Toilet",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/lx6oizv0neo53yapewhua4l4lqg0zd1d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lx6oizv0neo53yapewhua4l4lqg0zd1d/",
    "sourceUrl": "https://html5.gamemonetize.com/lx6oizv0neo53yapewhua4l4lqg0zd1d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "16053",
    "slug": "stickman-school-run-3",
    "title": "StickMan School Run-3",
    "description": "happy to show you its brand new game: StickMan School Run. Feel like you went back to school and take the control of a little wire man who’s also trying to run away from his homework and save his girlfriend. Come and test your skills in this obstacle race!",
    "instructions": "happy to show you its brand new game StickMan School Run Feel like you went back to school and take the control of a little wire man who s also trying to run away from his homework and save his girlfriend Come and test your skills in this obstacle race",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      ".io Games",
      "Boy",
      "Boys",
      "Fun",
      "Funny",
      "jump",
      "Jumping",
      "Kid",
      "Kids",
      "run",
      "running",
      "School",
      "Spiderman",
      "Sport",
      "Sports",
      "Stickman",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/h8s3azqnzkq6lllmjcr1xub4nodjd96v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h8s3azqnzkq6lllmjcr1xub4nodjd96v/",
    "sourceUrl": "https://html5.gamemonetize.com/h8s3azqnzkq6lllmjcr1xub4nodjd96v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70552",
    "slug": "fruit-catcher-apple",
    "title": "Fruit catcher apple",
    "description": "Fruit Catcher is a fast-paced, colorful arcade game where your goal is simple &ndash; catch as many falling fruits as you can! Move the basket left and right to grab apples. Every fruit you catch increases your score, but miss too many and it&rsquo;s game over! With cheerful visuals, fun animations, and simple controls, Fruit Catcher is the perfect quick-play game for players of all ages.",
    "instructions": "Keyboard Desktop Move Left rarr Arrow Left Move Right rarr Arrow Right Mouse Desktop move mouse left and right to move the basket Touch Mobile swipe left right to move the basket",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Cartoon",
      "Casual",
      "catcher",
      "Fruit",
      "Fruits",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/oza4bpg2zq2hs4fd5c1s8lq4pg0wvihp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oza4bpg2zq2hs4fd5c1s8lq4pg0wvihp/",
    "sourceUrl": "https://html5.gamemonetize.com/oza4bpg2zq2hs4fd5c1s8lq4pg0wvihp/",
    "width": 400,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "70470",
    "slug": "body-drop",
    "title": "Body Drop",
    "description": "Body Drop is an exciting game with realistic physics and excellent three&mdash;dimensional graphics, in which you have to test the strength of the dummys body by dropping it from various structures!",
    "instructions": "You need to launch the balls at the dummy so as to inflict the greatest amount of damage to it Control is carried out with the mouse Left-click to launch the balls Right mouse button - camera rotation Mouse wheel - zoom in out of the camera",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "destroy",
      "destroying",
      "destruction",
      "Fun",
      "Physics",
      "Simulator",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/ssevmpwntk2cpkny075qgdtpa58ic387/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ssevmpwntk2cpkny075qgdtpa58ic387/",
    "sourceUrl": "https://html5.gamemonetize.com/ssevmpwntk2cpkny075qgdtpa58ic387/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68152",
    "slug": "paper-princess-doll-dress-up",
    "title": "Paper Princess   Doll Dress Up",
    "description": "Welcome to Princess Dream Castle. Create enchanting looks &amp; live a fantasy princess life in Paper Princess - Doll Dress Up. Mix outfits, accessories, and crowns to style your royal character for a magical adventure. Immerse yourself in a fairy tales world where you can enjoy interactive activities with a dose of fun! Create your castle story and explore all the rooms. Experience true princess fairy tale life and explore this kingdom. Paper Princess - Doll Dress Up allows you to step into the world of fantasy and fairy tales, fostering their imagination as they envision and design their ideal princess characters.",
    "instructions": "Various fabulous outfits and items to blow your mind Prepare the princess for various occasions Stunning scenes and engage in interactive activities Choose from elegant gowns to sparkling accessories Customize your princesss appearance",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Castle",
      "Dress Up",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/v8xifgkn3mo6c9c8fd1p5vb0bfzkgt6n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v8xifgkn3mo6c9c8fd1p5vb0bfzkgt6n/",
    "sourceUrl": "https://html5.gamemonetize.com/v8xifgkn3mo6c9c8fd1p5vb0bfzkgt6n/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "70499",
    "slug": "celebrity-e-girl-vibes",
    "title": "Celebrity E Girl Vibes",
    "description": "Step into the world of edgy street style with Celebrity E-Girl Vibes! This game lets you dress up celebrities in the bold, trendy looks that define E-Girl fashion. Experiment with colorful hairstyles, graphic eyeliner, oversized hoodies, crop tops, ripped jeans, plaid skirts, chokers, and statement accessories. Pair each look with vibrant makeup and nail polish to complete the vibe.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/0qggl21qxp8g3zit49kxrm5x60lc69fm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0qggl21qxp8g3zit49kxrm5x60lc69fm/",
    "sourceUrl": "https://html5.gamemonetize.com/0qggl21qxp8g3zit49kxrm5x60lc69fm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70462",
    "slug": "pga3-zombie",
    "title": "PGA3 Zombie",
    "description": "PGA3 Zombie Mode: hold the line or join the horde. Survive endless voxel hordes in solo or 4-player co-op&mdash;board up, upgrade guns, trigger traps, and drop bosses. Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a> Wave-based zombie chaos with fast rounds, cash-for-perks, craftable gear, deadly map traps, and escalating boss fights. How long can you last?",
    "instructions": "Mouse click to shoot aim Tba to menu",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "unity",
      "WebGL",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/tg44gsgkrah9ash957sdnj6jg2oeyn75/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tg44gsgkrah9ash957sdnj6jg2oeyn75/",
    "sourceUrl": "https://html5.gamemonetize.com/tg44gsgkrah9ash957sdnj6jg2oeyn75/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70200",
    "slug": "doroppuboru-13",
    "title": "Doroppuboru 13",
    "description": "Doroppuboru 13 is a casual web-based puzzle game that involves falling objects, often in the form of balls or blocks, which the player needs to manage by positioning them correctly. The objective is typically to prevent the screen from filling up with objects by either clearing them or organizing them in specific patterns, similar to the mechanics of popular falling-block games like Tetris. As the game progresses, the difficulty increases, with faster speeds and more challenging patterns to manage. The game tests players&rsquo; quick thinking, reaction times, and ability to think ahead. With simple controls and an addictive gameplay loop,",
    "instructions": "Keyboard Controls Arrow Keys Left Arrow Move the falling object ball to the left Right Arrow Move the falling object ball to the right Down Arrow Accelerate the falling speed of the object Quick drop Up Arrow Rotate or flip the object if rotati",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "Basketball"
    ],
    "thumbnail": "https://img.gamemonetize.com/ay9z13yl6k30gfe0w3butmorqn2eeyov/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ay9z13yl6k30gfe0w3butmorqn2eeyov/",
    "sourceUrl": "https://html5.gamemonetize.com/ay9z13yl6k30gfe0w3butmorqn2eeyov/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70498",
    "slug": "forest-glade-mysteries",
    "title": "Forest Glade Mysteries",
    "description": "Immerse yourself in the world of Forest Glade Mysteries &mdash; a magical forest where the cutest animals live! Each level introduces you to new fluffy friends and exciting challenges. This forest is full of mysteries, and every step brings you closer to uncovering ancient secrets!",
    "instructions": "Adorable animals each unique and waiting for your help A magical forest with vibrant locations from blooming meadows to shady corners Magical powers of nature to help you tackle even the toughest levels",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Match 3",
      "Match-3",
      "Match3",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/ivzfzj8c6tf51dshplnpzs5u2ermcup3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ivzfzj8c6tf51dshplnpzs5u2ermcup3/",
    "sourceUrl": "https://html5.gamemonetize.com/ivzfzj8c6tf51dshplnpzs5u2ermcup3/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "70385",
    "slug": "dolphin-dress-up",
    "title": "Dolphin Dress Up",
    "description": "Dolphin Dress Up you get to explore a vibrant underwater world where two playful dolphins are ready to get glammed up! This charming dress-up game lets you choose outfits, accessories, and fun props to create a stylish underwater look for both dolphins.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Games",
      "Girls",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/hgbj3m3gz5evq1dkjq4dnzamt0u6xpw2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hgbj3m3gz5evq1dkjq4dnzamt0u6xpw2/",
    "sourceUrl": "https://html5.gamemonetize.com/hgbj3m3gz5evq1dkjq4dnzamt0u6xpw2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70495",
    "slug": "bloons-battles",
    "title": "Bloons Battles",
    "description": "Bloons Battles is a fun game with monkeys and colored balloons. Check your skill in this game and try to pop all the balloons on the level. Play this game and unlock all the levels. Aim well to avoid obstacles and hit the target. Have fun.",
    "instructions": "Use the mouse or touch to aim and shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "arrows",
      "Bubble Shooter",
      "Defense",
      "Fun",
      "html games for your website",
      "Monkey",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/ydihbdfz3qxevtauhuefdttmlgmxxzvo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ydihbdfz3qxevtauhuefdttmlgmxxzvo/",
    "sourceUrl": "https://html5.gamemonetize.com/ydihbdfz3qxevtauhuefdttmlgmxxzvo/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "70465",
    "slug": "motorcycle-stunt-racing-2025",
    "title": "Motorcycle Stunt Racing 2025",
    "description": "Motorcycle Stunt Racing 2025: lean, boost, fly. Arcade-fast bike racing with big air, bigger combos, and traffic-threading chaos across city, canyon, and coast. Web Dev <a href='https://www.crazygamesx.com/'>https://www.crazygamesx.com/</a> Master a trick-first stunt system, chain manuals and flips, and slingshot through dynamic weather and rush-hour traffic. Tackle Career, Trick Attack, Time Trial, and 8-player Online Freestyle, then chase leaderboards with ghosts and weekly events. Tune your ride with performance parts, liveries, and neon trails&mdash;skill wins, style flexes.",
    "instructions": "WASD to drive",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Bike",
      "Mentolatux",
      "Motorcycle",
      "Race",
      "Racing",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/9czjb50eymluumjyxcn0b6o2oixor6iy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9czjb50eymluumjyxcn0b6o2oixor6iy/",
    "sourceUrl": "https://html5.gamemonetize.com/9czjb50eymluumjyxcn0b6o2oixor6iy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70441",
    "slug": "knightbit-far-lands",
    "title": "KnightBit: Far Lands",
    "description": "Welcome to KnightBit: Far Lands, a new chapter of the great confrontation! Discover an updated world where knights face harsh Vikings at the edge of the lands. large-scale battles await you, where each victory brings you closer to glory. Explore a completely redesigned game world - from snowy fjords to the blazing borders of kingdoms. The rank system lets you level up your status from recruit to king! Increase your rank, unlock unique skills and command ever more powerful weapons! Get ready for new challenges, explore uncharted lands, fight for dominance and write your name in the chronicles of KnightBit: Far Lands!",
    "instructions": "Objective of the game Defeat the opposing team by scoring a certain number of points To do this you need to capture flags and destroy enemies Character Controls -Movement WASD -Jump Spacebar -Sprint Shift -Interact with objects or pick up weapons",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "Action",
      "Boys",
      "Castle",
      "Enemies",
      "Fight",
      "Horse",
      "Knight",
      "Levels",
      "RPG",
      "ships",
      "Strategy",
      "Winter"
    ],
    "thumbnail": "https://img.gamemonetize.com/wc8lmi60nfqsuf9eyjn9dd69tmokmo85/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wc8lmi60nfqsuf9eyjn9dd69tmokmo85/",
    "sourceUrl": "https://html5.gamemonetize.com/wc8lmi60nfqsuf9eyjn9dd69tmokmo85/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "16044",
    "slug": "army-of-soldiers",
    "title": "Army of Soldiers",
    "description": "The most epic war game is now available. Play now to : \"Army of Soldiers : Worlds war\". You must defend the earth against invading creatures coming from other worlds. They have started to invade earth and destroy all human being. The last hope...: the new big canon: ALPHA DESTRUCTOR 1. A powerfull weapon that should destroy the invaders, and end that war... But this weapon is not finished yet. You must protect ALPHA DESTRUCTOR 1 from the invaders",
    "instructions": "The most epic war game is now available Play now to Army of Soldiers Worlds war You must defend the earth against invading creatures coming from other worlds They have started to invade earth and destroy all human being The last hope",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Army",
      "Ben 10",
      "Boy",
      "Boys",
      "Fun",
      "Funny",
      "Game",
      "Games",
      "Gun",
      "Kid",
      "Kill",
      "Killing",
      "Skill",
      "Solitaire",
      "Sword",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/kqoavqbhufeqo5fq0v0r9r3juzq28xqs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kqoavqbhufeqo5fq0v0r9r3juzq28xqs/",
    "sourceUrl": "https://html5.gamemonetize.com/kqoavqbhufeqo5fq0v0r9r3juzq28xqs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68119",
    "slug": "sweet-paper-doll-dress-up-diy",
    "title": "Sweet Paper Doll: Dress Up DIY",
    "description": "Have you ever played paper doll dress up game? Now you can play it with Sweet Paper Doll: Dress Up DIY now. In the game you will be able to own your own doll, change clothes every day to suit the new place you will go. Choose your dolls beautiful clothes and make up. This doll makeover challenge allows you to craft your own. You will have a great experience with Sweet Paper Doll: Dress Up DIY. Unlock all items and upgrade your creative skills.",
    "instructions": "Create your own theme Customize the dolls look Give her a makeover",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/8l6gpd8nyrmrb5ttx09rj32btzyx4z2i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8l6gpd8nyrmrb5ttx09rj32btzyx4z2i/",
    "sourceUrl": "https://html5.gamemonetize.com/8l6gpd8nyrmrb5ttx09rj32btzyx4z2i/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "70374",
    "slug": "masterdash",
    "title": "MasterDash",
    "description": "Leap onto city roofs! Dash, jump, dodge obstacles between scattered rooftops, push speed limits with your fingers, and feel the adrenaline of high-altitude parkour!",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Best Games",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/kbb249dizzaamqeysebgkukx0qi012cc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kbb249dizzaamqeysebgkukx0qi012cc/",
    "sourceUrl": "https://html5.gamemonetize.com/kbb249dizzaamqeysebgkukx0qi012cc/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70487",
    "slug": "k-pop-demon-hunter-fashion",
    "title": "K Pop Demon Hunter Fashion",
    "description": "Unleash your creativity in K-Pop Demon Hunter Fashion, a unique dress up game where trendy K-Pop meets gothic demon hunter vibes. Style glamorous idols in bold K-Pop looks while blending them with dark, fantasy-inspired outfits. From leather jackets and spiked boots to neon hair, glowing makeup, and mystical accessories&mdash;you&rsquo;ll create fierce, otherworldly fashion statements.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion"
    ],
    "thumbnail": "https://img.gamemonetize.com/k2r4qscut9l09grrw6qsat9pcfzcgteb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k2r4qscut9l09grrw6qsat9pcfzcgteb/",
    "sourceUrl": "https://html5.gamemonetize.com/k2r4qscut9l09grrw6qsat9pcfzcgteb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70328",
    "slug": "shadowcurse",
    "title": "Shadowcurse",
    "description": "The world is broken&hellip; a hollow shell of what it was. Yet hope lingers still. A lone wanderer steps into the darkness. With blade in hand and courage unbroken, you will face the Shadow. Whether you bring an end to it, or vanish into its depths, the fate of this land now rests with you. Art by: Tiny Worlds,logaboga,Burrito,escape-pixel,Noobk,zLizard,zneeke, AimMaga Music by: Andrew LiVecchi,MakotoHiramatsu",
    "instructions": "WASD To Move And Jump Space To Attack Skill 1 Hold W to jump higher Esc To Open Menu E To Attack Skill 2 Shift To Attack Skill 3",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "apocalypse",
      "Blood",
      "Cute",
      "Fighting",
      "Horror",
      "Pixel",
      "Platform",
      "quests"
    ],
    "thumbnail": "https://img.gamemonetize.com/ypqt70texurvh6h64z4v6n2ub8eh7efr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ypqt70texurvh6h64z4v6n2ub8eh7efr/",
    "sourceUrl": "https://html5.gamemonetize.com/ypqt70texurvh6h64z4v6n2ub8eh7efr/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70202",
    "slug": "blockcraft-together",
    "title": "BlockCraft Together",
    "description": "This game can be played both in pairs and alone. You can get resources, defeat mobs, travel across dimensions, build whatever you want, craft armor, weapons and tools, hunt, cook, and much more. Conquer the vast game world and fight the legendary Warden!",
    "instructions": "For mobile devices control using graphic buttons located on the screen For Desktop Player 1 Controls W and S keys to move A and D keys to rotate Space key to jump F key to attack E key to aim Q key to change item R key to open inven",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "Block",
      "Mine",
      "mineblock",
      "Minecraft",
      "Monster",
      "PvP",
      "Sandbox",
      "survival",
      "two player games",
      "Unity3D",
      "voxel",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/jgegp1b4sbjjaqbj4erwln3bs71z6yge/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jgegp1b4sbjjaqbj4erwln3bs71z6yge/",
    "sourceUrl": "https://html5.gamemonetize.com/jgegp1b4sbjjaqbj4erwln3bs71z6yge/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70366",
    "slug": "minecraft-parkour-trials",
    "title": "Minecraft Parkour Trials",
    "description": "Minecraft Parkour Trials is a super fun and free-to-play parkour game. Your goal is to reach the portal at the finish line by skillfully jumping over obstacles. Have fun and enjoy the challenge!",
    "instructions": "WASD or Arrow keys to walk and right mouse click or space to jump",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "Adventure",
      "Boys",
      "Hypercasual",
      "jump",
      "mineblock",
      "Minecraft",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/ji92yl2ga3pp1ytwgn6zprw6dz23bjj2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ji92yl2ga3pp1ytwgn6zprw6dz23bjj2/",
    "sourceUrl": "https://html5.gamemonetize.com/ji92yl2ga3pp1ytwgn6zprw6dz23bjj2/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69797",
    "slug": "travel-with-me-asmr-edition",
    "title": "Travel With Me: ASMR Edition",
    "description": "Prepare to jet-set across the world with Travel With Me: ASMR Edition! Join Lisa, the stylish vlogger, as she explores stunning destinations, allowing you to dress her up in fabulous outfits that match each location perfectly. From the serene temples of Thailand to the desert adventures in Dubai, and the tropical paradise of Maldives, challenge your fashion skills and create unforgettable looks for every occasion.",
    "instructions": "Use your mouse to play this game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "html5 games"
    ],
    "thumbnail": "https://img.gamemonetize.com/nhqglb7xugf05jp6jeexpj8qzymsog6j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nhqglb7xugf05jp6jeexpj8qzymsog6j/",
    "sourceUrl": "https://html5.gamemonetize.com/nhqglb7xugf05jp6jeexpj8qzymsog6j/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69709",
    "slug": "move-the-tower",
    "title": "Move the Tower",
    "description": "Tower Of Hanoi is an ancient puzzle game that is now available as a game. Try your hand at this classic test of logic and strategy! In the game Move the Tower you will move disks from one rod to another, using the third as a temporary storage. But there is one rule - you can only rearrange one disk at a time, and at the same time you can not put a larger disk on a smaller one. Does it sound simple? But with each new level, the task becomes more complicated, and you will have to use all your wits to overcome it!",
    "instructions": "- Drag and drop discs with your mouse or finger - Only one disc can be rearranged at a time - You cant put a bigger disk on a smaller one - It is necessary to move the tower from the initial rod to any other - In sandbox mode the rules do not apply but",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "amazing",
      "Casual",
      "Games",
      "games for your website",
      "html5 games",
      "Hypercasual",
      "Interactive",
      "Logic",
      "Logical",
      "Physics",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/n55cadwdpiv6f3b9u5gdvznkewhxuauf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n55cadwdpiv6f3b9u5gdvznkewhxuauf/",
    "sourceUrl": "https://html5.gamemonetize.com/n55cadwdpiv6f3b9u5gdvznkewhxuauf/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "70448",
    "slug": "bubble-sorting-infinite-remastered",
    "title": "Bubble Sorting Infinite Remastered",
    "description": "Bubble Sorting Infinite Remastered is a fun and calming puzzle game where you sort colorful bubbles into matching tubes. Just move the bubbles around, stack 3 to 10 of the same color together, and watch them pop away! With endless levels and relaxing gameplay, it&rsquo;s the perfect brain teaser to unwind anytime, anywhere.",
    "instructions": "Play using a mouse or touchpad ndash Tap a tube to pop the top bubble then tap the target tube to move it there",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bubble",
      "Logic",
      "Puzzle",
      "sort",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/ocw34nv8r32gov4k28iufvmnoydpyewx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ocw34nv8r32gov4k28iufvmnoydpyewx/",
    "sourceUrl": "https://html5.gamemonetize.com/ocw34nv8r32gov4k28iufvmnoydpyewx/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "70400",
    "slug": "who-will-win-create-a-battle",
    "title": "Who Will Win Create a Battle",
    "description": "Create a battle and watch who wins! Build your own card or use a ready-made one. There are more than 300 objects in the game! A huge number of characters, vehicles, various weapons and armor in order to create the most spectacular battle!",
    "instructions": "Arrange the objects you like objects of protection or decoration transport characters Equip the characters with weapons and armor if desired Start the fight and watch who wins At the end of the battle a reward will be given for which you can unloc",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Android",
      "Arena",
      "attack",
      "Battle",
      "builder",
      "building",
      "construction",
      "destruction",
      "Enemy",
      "Gun",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/6xtwb99dangq1daggj2a8wa4yz4zbd07/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6xtwb99dangq1daggj2a8wa4yz4zbd07/",
    "sourceUrl": "https://html5.gamemonetize.com/6xtwb99dangq1daggj2a8wa4yz4zbd07/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70168",
    "slug": "the-wizard-green-skibidis-fury",
    "title": "The Wizard Green Skibidis Fury",
    "description": "The green wizard in a parallel universe now escapes from the Skibidi toilet! Quickly! Find the exit! Le sorcier vert dun univers parall&egrave;le s&eacute;chappe des toilettes de Skibidi ! Vite ! Trouvez la sortie ! Il mago verde in un universo parallelo &egrave; scappato dal bagno degli Skibidi! Presto! Trovate luscita!",
    "instructions": "Use AWSD or touch for move",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Android",
      "Escape",
      "HTML5",
      "Mobile",
      "Skibidi",
      "Wizard"
    ],
    "thumbnail": "https://img.gamemonetize.com/x3a7or9an0bw8lg3lt81jhwc3lcp7463/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x3a7or9an0bw8lg3lt81jhwc3lcp7463/",
    "sourceUrl": "https://html5.gamemonetize.com/x3a7or9an0bw8lg3lt81jhwc3lcp7463/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70314",
    "slug": "labubu-world-game",
    "title": "Labubu World Game",
    "description": "Labubu World is a fun and quirky adventure game that brings the mischievous character Labubu to life in a colorful, whimsical world. Players step into a universe full of surprises, where every stage is packed with unique challenges, hidden treasures, and playful creatures. In this game, you guide Labubu through vibrant levels, jumping across platforms, solving puzzles, and avoiding tricky obstacles. Each world has its own theme and personality&mdash;whether it&rsquo;s enchanted forests, mysterious caves, or candy-colored skies. Collect items along the way to unlock new abilities and customize your Labubu with fun outfits.",
    "instructions": "mouse only",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Labubu"
    ],
    "thumbnail": "https://img.gamemonetize.com/iri6qbxw5iyl4teu4u6tqwh9lgtmeiju/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iri6qbxw5iyl4teu4u6tqwh9lgtmeiju/",
    "sourceUrl": "https://html5.gamemonetize.com/iri6qbxw5iyl4teu4u6tqwh9lgtmeiju/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70308",
    "slug": "paws-off-my-clues",
    "title": "Paws Off My Clues!",
    "description": "Explore unique locations filled with hidden objects and unexpected mysteries. From sunny beaches to the ancient ruins of Persia, every corner of this fluffy world comes to life as you hunt for hidden treasures. Watch as the cats go about their lives, adding charm and humor to the atmosphere, while you search through their delightful mess. Solve puzzles, progress through levels, and become the ultimate hidden object master!",
    "instructions": "Choose a level from the vibrant and detailed locations Carefully scan the screen to spot hidden objects Complete the level by finding all listed items and move on to the next exciting scene",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "Cat",
      "Hidden"
    ],
    "thumbnail": "https://img.gamemonetize.com/u1n5ttd87g2a326o5b2pn1wb9ntpx33f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u1n5ttd87g2a326o5b2pn1wb9ntpx33f/",
    "sourceUrl": "https://html5.gamemonetize.com/u1n5ttd87g2a326o5b2pn1wb9ntpx33f/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69874",
    "slug": "card-quest-solitaire",
    "title": "Card Quest: Solitaire",
    "description": "Embark on an epic journey through the world of cards in Card Quest: Solitaire! This is not just another solitaire &ndash; it&rsquo;s a true adventure where every move matters. Master the classic solitaire rules, explore multiple themes, and challenge yourself with unique scoring modes. Whether you&rsquo;re here to relax or to chase the highest score, the quest never ends! With smooth controls, beautiful backgrounds, and unlimited replayability, Card Quest: Solitaire will keep you coming back for just one more game. Are you ready to begin your quest?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Puzzle",
      "Relaxation",
      "Solitaire"
    ],
    "thumbnail": "https://img.gamemonetize.com/v6qpevlp4d7jt4uhznzfg5g8a4ugerl1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v6qpevlp4d7jt4uhznzfg5g8a4ugerl1/",
    "sourceUrl": "https://html5.gamemonetize.com/v6qpevlp4d7jt4uhznzfg5g8a4ugerl1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67152",
    "slug": "dontmove",
    "title": "DontMove",
    "description": "Dont move. There is an npc in the game who turns around. When he stands over and sees you moving, the machine gunner beside him will shoot you dead. Its super exciting. Give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Adventure",
      "Best Games",
      "Hypercasual",
      "squidgame"
    ],
    "thumbnail": "https://img.gamemonetize.com/fnovd6el1om21x49ug7wrn7sgmzmrxgn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fnovd6el1om21x49ug7wrn7sgmzmrxgn/",
    "sourceUrl": "https://html5.gamemonetize.com/fnovd6el1om21x49ug7wrn7sgmzmrxgn/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68320",
    "slug": "pro-sliding-puzzle",
    "title": "Pro Sliding Puzzle",
    "description": "Slide Puzzle is a classic logic game where you must slide numbered tiles on a grid to arrange them in the correct order. Use strategy and planning to solve the puzzle and win!",
    "instructions": "Mouse or Touch",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Hypercasual",
      "Logic",
      "Logical",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/kb4jbjfx5zza8y6rtme06k6bqfbkfdsp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kb4jbjfx5zza8y6rtme06k6bqfbkfdsp/",
    "sourceUrl": "https://html5.gamemonetize.com/kb4jbjfx5zza8y6rtme06k6bqfbkfdsp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69698",
    "slug": "spirit-drops-from-dew",
    "title": "Spirit Drops   From Dew",
    "description": "Catch the falling lights, evolve the spirit, and embrace the magic of the forest. In Spirit Drops, you play as a mystical being catching drops of light falling from the sky. Each drop brings you closer to your next evolution&mdash;from a tiny glowing orb to a majestic spirit of light. But beware! Not all that falls is pure. Dark orbs must be avoided at all costs. You have 60 seconds. Catch light drops to earn points. Watch your spirit evolve with each milestone. Miss a dark orb and face the consequences... Simple controls: Swipe or use Arrow keys to move. How far can your spirit grow?",
    "instructions": "Use the arrow keys or joystick to control the game On PC you can also control the joystick with the mouse On mobile devices control is available via touch",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/oevq0zw0hly0tlfvoz79kq4wr3wvf5ng/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oevq0zw0hly0tlfvoz79kq4wr3wvf5ng/",
    "sourceUrl": "https://html5.gamemonetize.com/oevq0zw0hly0tlfvoz79kq4wr3wvf5ng/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70094",
    "slug": "physics-optics-quiz",
    "title": "Physics   Optics Quiz",
    "description": "This quiz is a quick test of Optics (Physics) concepts. Good for both students and educators. Learn everything and take this test to check your knowledge instantly.",
    "instructions": "Choose the CORRECT options",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Physics",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/jyfikmb02do9u5niahe16vt1641y2c2z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jyfikmb02do9u5niahe16vt1641y2c2z/",
    "sourceUrl": "https://html5.gamemonetize.com/jyfikmb02do9u5niahe16vt1641y2c2z/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68484",
    "slug": "solo-quiz-ing",
    "title": "Solo Quiz ing",
    "description": "Step into the shadowy world of Solo Leveling with this fast-paced anime quiz! Test your knowledge of Sung Jin-Woo&rsquo;s journey, the mysterious leveling system, epic battles, and powerful shadow soldiers. Whether youre a casual fan or a hardcore hunter, these 10 questions will challenge your memory and immerse you in the dark fantasy universe of Solo Leveling.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Anime",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/b30iow7uizs4aeyv9pjz928ph4ylgfiy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b30iow7uizs4aeyv9pjz928ph4ylgfiy/",
    "sourceUrl": "https://html5.gamemonetize.com/b30iow7uizs4aeyv9pjz928ph4ylgfiy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70260",
    "slug": "froggy-hop",
    "title": "Froggy Hop",
    "description": "Get ready to bounce with Froggy Hop! Launch your frog into the air, hop across lily pads, collect coins, and see how far you can go. Watch out for traps, power up your frog with upgrades, and take on fun daily missions. Unlock cool frog skins, each with their own perks. With easy one-tap controls and super fun bounce physics, Froggy Hop is the perfect game to pick up and play anytime!",
    "instructions": "Desktop Left Mouse Button Jump Dive Use the left mouse button to launch and bounce the frog - Avoid obstacles like stone tree log and mud - Dive on lily pads turtles and other elements at the right time to bounce",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Best Games",
      "Bounce",
      "Casual",
      "endless",
      "Jumping",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/ntn28t01dl303rgbklck032jnu4il1d8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ntn28t01dl303rgbklck032jnu4il1d8/",
    "sourceUrl": "https://html5.gamemonetize.com/ntn28t01dl303rgbklck032jnu4il1d8/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67955",
    "slug": "frenzy-demine",
    "title": "Frenzy Demine",
    "description": "Test your reflexes and strategy in this fast-paced bomb disposal game! Identify and defuse the correct mines before time runs out, earning points and bonuses for speed. Each wave ramps up the challenge with more mines and less time, pushing your skills to the limit. Can you survive the explosive chaos and set a new personal best?",
    "instructions": "Left-click Tap on the shapes",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Casual",
      "Retro",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/jjprjr53ojpuxj4nx49ga0kb6puqqp6e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jjprjr53ojpuxj4nx49ga0kb6puqqp6e/",
    "sourceUrl": "https://html5.gamemonetize.com/jjprjr53ojpuxj4nx49ga0kb6puqqp6e/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "70095",
    "slug": "physics-semiconductos-quiz",
    "title": "Physics: Semiconductos Quiz",
    "description": "This quiz on Semiconductors (Physics) gives you a quick review of your knowledge, for basic knowledge. Try it before an exam and you know what have you done till now!",
    "instructions": "Choose CORRECT options",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Physics",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/cdqzdxyib5g7h8tzqvpiiu8uum3f42dl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cdqzdxyib5g7h8tzqvpiiu8uum3f42dl/",
    "sourceUrl": "https://html5.gamemonetize.com/cdqzdxyib5g7h8tzqvpiiu8uum3f42dl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70285",
    "slug": "brainrot-hidden-stars",
    "title": "Brainrot Hidden Stars",
    "description": "Play Brainrot Hidden Stars game online and for free. Find out the hidden stars in the specified images. Each level has 12 hidden stars. There are 12 levels in total. The time is limited so be fast and find all hidden objects before time runs out. Clicking in the wrong place several times reduces the time by an additional 5 seconds. So, if you are ready, start the game and have fun!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Best",
      "Brainrot",
      "Funny",
      "Hidden",
      "Italian Brainrot",
      "Kids",
      "Skill",
      "Tralalero Tralala",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/valc1kedi8vlsu1ffikb9hc5dgw7l7ga/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/valc1kedi8vlsu1ffikb9hc5dgw7l7ga/",
    "sourceUrl": "https://html5.gamemonetize.com/valc1kedi8vlsu1ffikb9hc5dgw7l7ga/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70294",
    "slug": "lastwar-survival",
    "title": "LastWar Survival",
    "description": "A global zombie infestation has converted many into zombies. As a survivor, your primary goal is to retain your humanity and survive. How long can you last in this apocalypse? Join LastWar: Survival Game and embark on a thrilling journey of survival and strategy!",
    "instructions": "Use the mouse or touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Defense",
      "html games for your website",
      "kiz10",
      "Shooter",
      "survival",
      "Tower Defense",
      "War",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/a1uq2ezl0d031hot7ly5xnlhpio62lg0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a1uq2ezl0d031hot7ly5xnlhpio62lg0/",
    "sourceUrl": "https://html5.gamemonetize.com/a1uq2ezl0d031hot7ly5xnlhpio62lg0/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "70155",
    "slug": "dino-rush",
    "title": "Dino Rush",
    "description": "Get ready for an exciting adventure with our cute dino! Dino Rush is a fun and easy-to-play arcade game where you help a light-blue dinosaur run and jump over obstacles. The gameplay is simple but full of challenges, and the more you play, the faster and more thrilling it becomes! Perfect for all ages, featuring smooth cartoon graphics and a retro arcade vibe. Test your skills, aim for the highest score, and challenge your friends!",
    "instructions": "Jump Space or Touch",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "2D",
      "Ai Games",
      "Arcade",
      "dino",
      "Dinosaur",
      "endless",
      "jump",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/uevg2ya1nntvkrzl3w9b5fnzsr80yapc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uevg2ya1nntvkrzl3w9b5fnzsr80yapc/",
    "sourceUrl": "https://html5.gamemonetize.com/uevg2ya1nntvkrzl3w9b5fnzsr80yapc/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70178",
    "slug": "zippy-bird-game",
    "title": "Zippy Bird Game",
    "description": "Help Zippy Bird fly through gaps in pipes! Tap to flap and avoid obstacles in this fast-paced arcade challenge. Easy to learn, hard to master!",
    "instructions": "bull Tap or Click to make the bird flap bull Avoid hitting the pipes to stay alive bull The longer you survive the higher your score",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Air",
      "Best Games",
      "Bird",
      "Click",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/3hh5z81ik1xz5o5epk7mpy6dtjtvwvma/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3hh5z81ik1xz5o5epk7mpy6dtjtvwvma/",
    "sourceUrl": "https://html5.gamemonetize.com/3hh5z81ik1xz5o5epk7mpy6dtjtvwvma/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70242",
    "slug": "neon-ball-slope",
    "title": "Neon Ball Slope",
    "description": "Love slope games? Then Neon Ball Slope is your next addiction! Roll a glowing neon ball down an endless 3D slope in this fast-paced arcade challenge that tests reflexes, precision, and physics-based control. The slope starts simple but quickly becomes steeper and trickier, keeping you on edge every second. Collect coins to unlock upgrades, enhancement packs, and powerful gear. Earn XP to level up, boost drop rates, and unlock special chests filled with unique equipment. Complete missions, climb the daily leaderboards, and prove your skills by chasing the highest score. With endless replayability, glowing neon visuals, and competitive rankings",
    "instructions": "Use arrow keys to move horizontally On mobile press on the left right hand sides to move in that direction",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "3D Games",
      "Arcade",
      "Avoid",
      "Ball",
      "endless",
      "HTML5",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/tvffgv3xt5p39edpb54kiulbaa86ia21/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tvffgv3xt5p39edpb54kiulbaa86ia21/",
    "sourceUrl": "https://html5.gamemonetize.com/tvffgv3xt5p39edpb54kiulbaa86ia21/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70199",
    "slug": "space-surfer",
    "title": "Space Surfer",
    "description": "Welcome to Space Surfer! Get ready for the ultimate hyperspace challenge! Space Surfer is a thrilling 3D arcade game that sends you blasting through a dazzling, high-speed tunnel of light and color. Your mission is simple: survive the cosmic chaos, dodge dangerous obstacles, and grab as many rewards as you can to become a legend of the vortex. Do you have the reflexes to master the tunnel? How to Play: Your Mission Briefing Survive the Rush!",
    "instructions": "Mouse click or tap to play Easy Controls Controlling your ship is incredibly intuitive Just click and drag your mouse or use your finger on a touchscreen to glide around the space tunnel Your ship will follow you instantly",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2025 games",
      "Arcade",
      "Best Games",
      "New",
      "Obstacle",
      "running",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/1hk8ygcmh5jv3y1gallcs6zu36146iw9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1hk8ygcmh5jv3y1gallcs6zu36146iw9/",
    "sourceUrl": "https://html5.gamemonetize.com/1hk8ygcmh5jv3y1gallcs6zu36146iw9/",
    "width": 1080,
    "height": 2424,
    "lastUpdated": ""
  },
  {
    "id": "70246",
    "slug": "xtreme-good-and-bad-boys-2-2025",
    "title": "Xtreme Good And Bad Boys 2 2025",
    "description": "A gripping thriller about two estranged brothers, one a cop and the other a criminal, forced to confront their past as they team up to take down a powerful drug cartel. Get ready for an action-packed ride with heart-stopping stunts and unexpected twists. Web Dev <a href='https://www.crazygamesfree.com/.'>https://www.crazygamesfree.com/.</a> Watch Xtreme Good And Bad Boys 2 now for a thrilling cinematic experience.",
    "instructions": "use WASD to walk and run mouse to fire and aim and change gun tab for menu",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "First Person Shooter",
      "Mentolatux",
      "Multiplayer",
      "Shooting",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/4aska90ahbnx3k1ksah2akohmhd1fd8d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4aska90ahbnx3k1ksah2akohmhd1fd8d/",
    "sourceUrl": "https://html5.gamemonetize.com/4aska90ahbnx3k1ksah2akohmhd1fd8d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67982",
    "slug": "marble-zuma-shooter",
    "title": "Marble Zuma Shooter",
    "description": "Marble Zumar is a thrilling marble shooter game that will keep you hooked for hours! Blast colorful balls into the rolling chain, match three or more of the same color, and clear them before they reach the end of the track. With fast-paced action, beautifully designed levels, and smooth controls, Marble Zumar delivers an addictive puzzle experience for players of all ages. Sharpen your reflexes, plan your shots carefully, and challenge yourself through increasingly difficult stages. Can you stop the marbles in time? Play now and become the ultimate Marble Zumar master!",
    "instructions": "tap to shoot",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Bubble Shooter",
      "Hypercasual",
      "Shoot",
      "Shooter",
      "Zuma"
    ],
    "thumbnail": "https://img.gamemonetize.com/b9i5mkz668iuabs1k2tt01filmfc7qiv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b9i5mkz668iuabs1k2tt01filmfc7qiv/",
    "sourceUrl": "https://html5.gamemonetize.com/b9i5mkz668iuabs1k2tt01filmfc7qiv/",
    "width": 600,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "56710",
    "slug": "aqua-escape",
    "title": "Aqua Escape",
    "description": "Dive deep into the aquatic world of Aqua Escape, an exciting and challenging adventure where you must guide your character through a series of underwater obstacles. With beautiful oceanic environments and engaging gameplay, Aqua Escape tests your reflexes and strategic thinking as you navigate past dangers and collect treasures.",
    "instructions": "Start the Game Tap on the play button to begin your underwater adventure Navigate the Character Use your devices controls to move your character up down left or right to avoid obstacles Avoid Obstacles Stay alert and avoid hitting any underwater o",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2048",
      "2D",
      "Adventure",
      "Android",
      "Arcade",
      "Best",
      "Best Games",
      "Games Ai"
    ],
    "thumbnail": "https://img.gamemonetize.com/kcdkoe0gnw3y1icaw52yfda9k54x342w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kcdkoe0gnw3y1icaw52yfda9k54x342w/",
    "sourceUrl": "https://html5.gamemonetize.com/kcdkoe0gnw3y1icaw52yfda9k54x342w/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "16117",
    "slug": "bridge-builder",
    "title": "Bridge Builder",
    "description": "Stretch the stick in order to reach and walk on the platforms. Watch out! If the stick is not long enough, you will fall down! How far can you go? This game tests your timing skills, can you build the perfect bridge or will you fall to your doom?",
    "instructions": "Stretch the stick in order to reach and walk on the platforms Watch out If the stick is not long enough you will fall down How far can you go This game tests your timing skills can you build the perfect bridge or will you fall to your doom",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boy",
      "Boys",
      "Bridge",
      "Classic",
      "Click",
      "Clicker",
      "Fun",
      "Funny",
      "Kid",
      "Kids",
      "Mobile",
      "Pixel",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/z506enuu51pn1wrijaos3ipfl0dukq5j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z506enuu51pn1wrijaos3ipfl0dukq5j/",
    "sourceUrl": "https://html5.gamemonetize.com/z506enuu51pn1wrijaos3ipfl0dukq5j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70141",
    "slug": "math-box-balance",
    "title": "Math Box Balance",
    "description": "Math Box Balance is a puzzle game with numbers. Early levels have 2 boxes, and as you progress you can reach up to 8 boxes. Each box contains 4 number blocks, and the sum of these numbers is shown inside the box. Your goal is to make the sum of all boxes equal. You can swap number blocks between boxes to achieve the equal sum. It is an endless game where the difficulty increases over time, your score goes up, and the fun grows with it.",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Logic",
      "Math",
      "School",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/p0le8iw7v1sruhqzokqjzrnd1veqjm2x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p0le8iw7v1sruhqzokqjzrnd1veqjm2x/",
    "sourceUrl": "https://html5.gamemonetize.com/p0le8iw7v1sruhqzokqjzrnd1veqjm2x/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "70220",
    "slug": "snake-game-2025",
    "title": "Snake Game 2025",
    "description": "Classic Snake Game &ndash; HTML5 + Responsive + Touch Support Bring back the nostalgia with this modern take on the classic Snake Game, built entirely with HTML5, CSS3, and JavaScript. Lightweight, fast, and fully responsive, this game runs smoothly across all modern browsers and devices.",
    "instructions": "Control the snake using the arrow keys or W A S D keys Eat the food grow longer and avoid crashing into the walls or yourself",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Best Games",
      "Bomb",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/i6y64skipzp3fqog4u2qpbqw4o2bhzar/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i6y64skipzp3fqog4u2qpbqw4o2bhzar/",
    "sourceUrl": "https://html5.gamemonetize.com/i6y64skipzp3fqog4u2qpbqw4o2bhzar/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70217",
    "slug": "fishdom",
    "title": "Fishdom",
    "description": "Dive into the fantastic world of Fishdom! Youre in for an ocean of exciting levels, scores of adorable fish and pets, and a sea of captivating events! Explore incredible underwater adventures! Unlock aquariums and save the fish on every level.",
    "instructions": "Use the mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cute",
      "Fish",
      "Fishing",
      "Fun",
      "html5 games for your site",
      "kiz10",
      "Puzzle",
      "Rescue"
    ],
    "thumbnail": "https://img.gamemonetize.com/55m645alo88yve3z7su5g252gfk9t0p6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/55m645alo88yve3z7su5g252gfk9t0p6/",
    "sourceUrl": "https://html5.gamemonetize.com/55m645alo88yve3z7su5g252gfk9t0p6/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "70211",
    "slug": "terminal-master-bus-tycoon",
    "title": "Terminal Master Bus Tycoon",
    "description": "Play the bus station simulation tycoon game in the Terminal Master - Bus Tycoon. From a small bus station to a global transportation mogul. Keep upgrading stations, buying buses, and recruiting employees. Increase efficiency and revenue. Buy new buses, unlock faster and fancier vehicles. Its easy and stress-free to earn even when youre offline. Keep upgrading until you are the top bus tycoon in the world.",
    "instructions": "Mouse click or tap to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "bus",
      "Simulation",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/cptb46rrt3zu7opt09qswu8ndptftjbl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cptb46rrt3zu7opt09qswu8ndptftjbl/",
    "sourceUrl": "https://html5.gamemonetize.com/cptb46rrt3zu7opt09qswu8ndptftjbl/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70017",
    "slug": "pull-the-pin-fish-rescue",
    "title": "Pull the Pin Fish Rescue",
    "description": "Pull the Pin: Fish Rescue! is a relaxing and addictive puzzle game with lots of interesting puzzles. You will see several niches in it. They will be separated by partitions. In one niche you will see a fish, and in another water. You will need to carefully study everything and pull the pin. Thus, you will open it and water will get to the fish.",
    "instructions": "use mouse or swipe screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fish",
      "Rescue"
    ],
    "thumbnail": "https://img.gamemonetize.com/rhtnddpq95ww5wuo0yak159m7df41kif/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rhtnddpq95ww5wuo0yak159m7df41kif/",
    "sourceUrl": "https://html5.gamemonetize.com/rhtnddpq95ww5wuo0yak159m7df41kif/",
    "width": 1080,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68949",
    "slug": "aha-world-dream-town",
    "title": "Aha World Dream Town",
    "description": "Welcome to Aha World Dream Town, a casual life simulation game online. Whether you are an enthusiast of simulator games or just a casual player looking for relaxation online, do not miss this chance to experience a different world from your real life. Aha World Dream Town offers plenty of scenes, including supermarkets, restaurants, shops, and the game center. Traverse various charming settings and create new characters.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Girls",
      "Relaxation",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/0ered4nljwbbu6gnxbzg04g6etc6r6ou/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0ered4nljwbbu6gnxbzg04g6etc6r6ou/",
    "sourceUrl": "https://html5.gamemonetize.com/0ered4nljwbbu6gnxbzg04g6etc6r6ou/",
    "width": 1600,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70201",
    "slug": "pga1",
    "title": "PGA1",
    "description": "Pixel Gun Apocalypse 1 is a thrilling first-person shooter that combines blocky pixel graphics with fast-paced multiplayer action. In this online game, players can join different servers and battle it out in classic modes like Team Deathmatch or Free for All. Web DeArmed with a variety of weapons&mdash;ranging from pistols and rifles to powerful sniper guns&mdash;you&rsquo;ll need sharp reflexes and smart tactics to survive. The voxel-style world gives it a Minecraft-like look, but the gameplay is all about adrenaline-fueled combat. Whether you fight as a soldier or test your skills against zombies, Pixel Gun Apocalypse 1 delivers endless fun for shooter fans.",
    "instructions": "wasd to walk mouse to shooting and aim tab for menu",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooter",
      "Shooting",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/jrtf5ktgenvegef26udy6gv11g9z2f1g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jrtf5ktgenvegef26udy6gv11g9z2f1g/",
    "sourceUrl": "https://html5.gamemonetize.com/jrtf5ktgenvegef26udy6gv11g9z2f1g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69884",
    "slug": "simple-fruit-memory",
    "title": "Simple Fruit Memory",
    "description": "Simple Memory Game is a fun and engaging memory-matching puzzle where players test their concentration and visual recall across 10 increasingly challenging levels. Each level presents a grid of cards hiding colorful fruit emojis. Players must flip the cards two at a time to uncover matching fruit pairs. The objective is simple: match all the fruit pairs in each level to progress to the next. As levels advance, the number of cards increases, demanding sharper focus and stronger memory skills. Quick recognition and strategic flipping are key to achieving the best possible score.",
    "instructions": "Match the cards for right fruit pairs",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fruit",
      "Memory",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/seqzl58f171fmac9s05qqr5ffhd4dk9g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/seqzl58f171fmac9s05qqr5ffhd4dk9g/",
    "sourceUrl": "https://html5.gamemonetize.com/seqzl58f171fmac9s05qqr5ffhd4dk9g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70144",
    "slug": "enchanted-mahjong-saga",
    "title": "Enchanted Mahjong Saga",
    "description": "Enchanted Mahjong Saga is a fast-paced twist on the classic tile-matching game, with unlimited levels to challenge your mind. Match tiles, beat the clock, and keep your streak alive as each level gets tougher and more exciting. Feeling stuck? Use helpful hints to get back on track and stay in the game.Whether youre playing for a quick break or settling in for a longer session, theres always a new puzzle waiting.",
    "instructions": "Use your mouse or touchpad to select and match tiles",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Board",
      "Fantasy",
      "html5 games",
      "Logic",
      "Mahjong",
      "Matching",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/mtlddkkcybrsq23xuuqe0qv4quyiqmck/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mtlddkkcybrsq23xuuqe0qv4quyiqmck/",
    "sourceUrl": "https://html5.gamemonetize.com/mtlddkkcybrsq23xuuqe0qv4quyiqmck/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "70190",
    "slug": "tic-tac-toe-with-ai-and-multiplayer",
    "title": "Tic tac toe   with AI and multiplayer",
    "description": "Tic Tac Toe is a classic strategy-based HTML5 game built with pure HTML5, CSS3, and JavaScript, designed for desktop and mobile browsers. This lightweight game is responsive, fast-loading, and fully customizable, making it perfect for websites, blogs, and game portals. Players can challenge the computer (AI) or play with a friend in 2-player mode. The game features clean UI, smooth animations, and modern design, ensuring a great user experience across all devices. Whether you&rsquo;re a developer, game publisher, or looking to add engagement to your site, this Tic Tac Toe game is an easy-to-integrate, monetizable, and timeless classic.",
    "instructions": "Mouse click or tap to play",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "2 Player",
      "2D"
    ],
    "thumbnail": "https://img.gamemonetize.com/yek6als54qfbxd4vx2h26nuq55rt7gt8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yek6als54qfbxd4vx2h26nuq55rt7gt8/",
    "sourceUrl": "https://html5.gamemonetize.com/yek6als54qfbxd4vx2h26nuq55rt7gt8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69969",
    "slug": "space-geometry-dash-waves",
    "title": "Space Geometry Dash Waves",
    "description": "Space Geometry Dash Waves is a fast-paced reflex game where precision is everything. Hold the mouse to make your arrow rise, release to glide down&mdash;navigate through a neon-lit maze of moving traps and deceptive geometry. Each of the 40 handcrafted levels introduces a new obstacle mechanic: vanishing ninjas that flicker in and out of sight, hidden barriers that only appear when youre close, and more unpredictable challenges designed to test your timing and focus. From twisting corridors to sudden reveals, every stage pushes your skill to the limit in a hypnotic journey through the horizons of geometry. Can you master the rhythm and reach th",
    "instructions": "mouse only",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Aircraft",
      "amazing",
      "Android",
      "angryplants",
      "Arcade",
      "Baby",
      "Balance"
    ],
    "thumbnail": "https://img.gamemonetize.com/jujmnao4au4zopxglknsszpswitpr1ca/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jujmnao4au4zopxglknsszpswitpr1ca/",
    "sourceUrl": "https://html5.gamemonetize.com/jujmnao4au4zopxglknsszpswitpr1ca/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70160",
    "slug": "maze-evolution",
    "title": "Maze Evolution",
    "description": "Maze Evolution combines puzzle mazes to make the game more exciting. You start with easy mazes, and as you progress, the levels become harder to complete. Also, the game consists of 28 levels to play.on any device.",
    "instructions": "The game is easy to control For the computers you can use your mouse and on mobile devices you can control it with your touch pen or finger To start the level first you need to touch the black star After you touch the player then you can control it",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/ybj69y6czwevdf09m89xkq8r5ay372rz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ybj69y6czwevdf09m89xkq8r5ay372rz/",
    "sourceUrl": "https://html5.gamemonetize.com/ybj69y6czwevdf09m89xkq8r5ay372rz/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69641",
    "slug": "alien-shooting-survival",
    "title": "Alien Shooting Survival",
    "description": "Alien Shooting Survival throws you into an apocalyptic forest and ruined town overrun by alien creatures and soldier invaders. Armed and ready, you must fight off waves of hostile enemies, from terrifying alien animals to armored troops. Web Dev <a href='https://www.crazygames.org.es/'>https://www.crazygames.org.es/</a> . Drive vehicles to navigate deadly zones, reach objectives, and survive relentless battles. Destroy every threat to complete your mission!",
    "instructions": "WASD TO WALK AND DRIVE vehicle and mouse to aim and shooting",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Alien",
      "Driving",
      "Mentolatux",
      "Shooting",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/1l4vxoxw41zgf55rzlnvze60hnywzf01/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1l4vxoxw41zgf55rzlnvze60hnywzf01/",
    "sourceUrl": "https://html5.gamemonetize.com/1l4vxoxw41zgf55rzlnvze60hnywzf01/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70122",
    "slug": "cozy-kitchen-merge",
    "title": "Cozy Kitchen Merge",
    "description": "Cozy Kitchen Merge is a cute cooking puzzle where you place dishes on the tray, watch the queue, and merge 3 or more of the same dish&mdash;sides or corners both count. Each merge makes the next recipe and bumps your score. Every 100 points gives you an Eat Token. Tap the fork button to munch one dish and make space when things get tight. Keep at least one empty spot; no room for the next dish means game over. Climb the recipe ladder (1&rarr;10), unlock sweet achievements, and chase your best score. Soft art, cozy sounds, quick runs&mdash;perfect for a relaxing break. And hey, please dont wreck the game menu. Things may fall.",
    "instructions": "Tap click an empty spot on tray to place the next dish Check the counter the dish on the right goes next Merge 3 or more of the same dish touching each other Every 100 points you get 1 Eat Token In the main menu you can tap and drag the decor",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Boys",
      "Cook",
      "Cooking",
      "Cute",
      "free games for your site",
      "Girls",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/jcezh6c42tp32b6qy5oulakrv44jc5hi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jcezh6c42tp32b6qy5oulakrv44jc5hi/",
    "sourceUrl": "https://html5.gamemonetize.com/jcezh6c42tp32b6qy5oulakrv44jc5hi/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70085",
    "slug": "physics-electro-magnetism-quiz",
    "title": "Physics: Electro Magnetism Quiz",
    "description": "Check out this Physics: Electro-magnetism quiz from Immanitas. This is good for students or educators who just want a quiz test of their basic knowledge of this topic of Physics. Winning-streak is taken account of!",
    "instructions": "Select the CORRECT option",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Physics",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/fi7gbbxtopjxhbm6j2kyufuxc0coam9i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fi7gbbxtopjxhbm6j2kyufuxc0coam9i/",
    "sourceUrl": "https://html5.gamemonetize.com/fi7gbbxtopjxhbm6j2kyufuxc0coam9i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "61256",
    "slug": "foodies-2048",
    "title": "Foodies 2048",
    "description": "Enter the bright and tasty world of &ldquo;2048 Foodies&rdquo; &mdash; a casual 2048-style puzzle with fruits and berries! Merge identical berries and fruits to create new, juicier, and more delicious sweets. Every merge brings you closer to rare and exotic treats. Simple, intuitive controls make this merge game perfect for everyone: just connect matching items and watch new fruits appear. Colorful, vibrant graphics, smooth animations, and a mouth-watering design create an addictive fruity merge experience.",
    "instructions": "ldquo 2048 Foodies rdquo offers 3 control schemes for any device swipe on mobile hold and drag with the right mouse button or use W A S D or arrow keys All controls are quick responsive and intuitive letting you focus on merging fruits unlock",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Casual",
      "Fruits",
      "Hypercasual",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/jcudjznlfifbu3le2mgo5215rpdd1713/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jcudjznlfifbu3le2mgo5215rpdd1713/",
    "sourceUrl": "https://html5.gamemonetize.com/jcudjznlfifbu3le2mgo5215rpdd1713/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "70162",
    "slug": "pic-pie-wonders",
    "title": "Pic Pie Wonders",
    "description": "Pic Pie Wonders&rdquo; is a delightful photo puzzle game where each level presents a round picture broken into pieshaped pieces. Swap two adjacent pieces by swiping with your finger or mouse, and keep rearranging them until the photo is complete.",
    "instructions": "Click and hold or swipe your finger on a pie piece then drag to an adjacent piece to swap them Keep swapping until you complete the round photo",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Board",
      "Jigsaw",
      "Mobile",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/s6ad4dhtrledj3ikfixw2hwx3cge27ht/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s6ad4dhtrledj3ikfixw2hwx3cge27ht/",
    "sourceUrl": "https://html5.gamemonetize.com/s6ad4dhtrledj3ikfixw2hwx3cge27ht/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "70172",
    "slug": "fruit-merge-2048-and-ndash-juicy-puzzle",
    "title": "Fruit Merge 2048 &ndash; Juicy Puzzle",
    "description": "Fruit Merge 2048 is a fun and addictive puzzle game that combines the classic 2048 gameplay with colorful, mouth-watering fruits! Simply swipe to merge identical fruits and watch them evolve into bigger, juicier ones. The more you merge, the closer you get to the ultimate fruit! Featuring bright graphics, smooth animations, and satisfying gameplay, this fruit puzzle is perfect for casual players and puzzle lovers of all ages. Whether you want to challenge your brain, pass the time, or just enjoy some juicy fun, Fruit Merge 2048 is your go-to choice.",
    "instructions": "Use arrow keys or swipe to move tiles Combine matching fruits to create new ones",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Fruits",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/nrae5bijahbi5m5nydila7xqw875n4ut/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nrae5bijahbi5m5nydila7xqw875n4ut/",
    "sourceUrl": "https://html5.gamemonetize.com/nrae5bijahbi5m5nydila7xqw875n4ut/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68862",
    "slug": "something-below-the-sea-hard-version",
    "title": "Something below the Sea Hard version",
    "description": "A team of scientists spotted an area of the planet with an immense amount of garbage, seeing that this threatened marine life, they decided to create drones to remove this garbage, but something else is hidden...",
    "instructions": "Use ASDW for move or Touch and shoot with P ou Touch the square for shoot",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "Bubble",
      "html5 games for your site",
      "Island",
      "ship",
      "Shoot",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/asor6gv8sy44ciqhjuwmp5j2i2fn3ksm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/asor6gv8sy44ciqhjuwmp5j2i2fn3ksm/",
    "sourceUrl": "https://html5.gamemonetize.com/asor6gv8sy44ciqhjuwmp5j2i2fn3ksm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70092",
    "slug": "tralalero-tralala-endless-run",
    "title": "Tralalero Tralala Endless Run",
    "description": "Tralalero Tralala Endless Run is a colorful and exciting online game that kids will love. The challenge is simple but addictive: stay alive for as long as possible while running endlessly through a quirky world full of surprises. Your goal is to jump on jellyfish to keep moving forward and collect as many delicious burgers as you can along the way. The more burgers you gather, the higher your score will climb. But watch out: crashing into the top or bottom of the screen will quickly end your run. This fast-paced adventure is all about quick reflexes, timing, and endless fun. Perfect for kids who enjoy bright graphics, silly characters, and non-stop action. Best of all, it is completely free to play online, so you can jump right into the excitement anytime. So, get ready to guide Tralalero Tralala through this hilarious endless journey, collect those burgers, and see how long you can survive. Can you set a new record? Give it a try and have fun!",
    "instructions": "Left and right arrow keys or mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Avoid",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Collecting",
      "Fun",
      "Hypercasual",
      "jump",
      "Kids",
      "Mobile",
      "Tralalero Tralala"
    ],
    "thumbnail": "https://img.gamemonetize.com/n3us455bf6ehkagzsue2ogjih00ggjzb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n3us455bf6ehkagzsue2ogjih00ggjzb/",
    "sourceUrl": "https://html5.gamemonetize.com/n3us455bf6ehkagzsue2ogjih00ggjzb/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "70033",
    "slug": "fragment",
    "title": "FRAGMENT",
    "description": "You are a weaponized human test subject disguised as a robot. Your test is to shoot through the test, destroying the heart behind your creation. There are ~40 levels you have to finish. Try to finish it as fast as possible.",
    "instructions": "A D Move S Slide Space Jump Skip Intro Exit Time Screen Mouse Aim R Reset if you get stuck Right-click Shoot ESC P Pause",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Battle",
      "Crazy",
      "demolition",
      "destroy",
      "destroying",
      "destruction",
      "Pixel",
      "Robot",
      "Science",
      "unity",
      "unity games",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/bxj43j2b4om02pg3nzf11oqflng06wwu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bxj43j2b4om02pg3nzf11oqflng06wwu/",
    "sourceUrl": "https://html5.gamemonetize.com/bxj43j2b4om02pg3nzf11oqflng06wwu/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "70026",
    "slug": "billiard-diamond-challenge",
    "title": "Billiard Diamond Challenge",
    "description": "Billiard Diamond Challenge is a fun and free online billiard game for both kids and adults. Your goal is to sink all the balls into the pockets except for the white ball. While playing, you can collect blue diamonds that allow you to unlock a brand new cue. The game offers both level mode and time mode, so you can choose the challenge that suits you best. Get ready to test your skills and have fun at the billiard table!",
    "instructions": "Mouse to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "8 Ball Pool",
      "Arcade",
      "Billiard",
      "Board",
      "Brain",
      "Hypercasual",
      "Logic",
      "Physics",
      "Pool",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/bvbz9z2d98h60fav66kp0eabxi1jhrf0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bvbz9z2d98h60fav66kp0eabxi1jhrf0/",
    "sourceUrl": "https://html5.gamemonetize.com/bvbz9z2d98h60fav66kp0eabxi1jhrf0/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69671",
    "slug": "jellymerge",
    "title": "JellyMerge",
    "description": "Slide the screen to merge the jelly blocks of the same color. All of them are combined to complete the level. The game features multiple exquisite levels. Come and challenge your brain.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Best Games",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/jnhinht5g9s2znqarxteta7bwa723c2m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jnhinht5g9s2znqarxteta7bwa723c2m/",
    "sourceUrl": "https://html5.gamemonetize.com/jnhinht5g9s2znqarxteta7bwa723c2m/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68159",
    "slug": "pin-away-puzzle-tap-it-out",
    "title": "Pin Away Puzzle   Tap It Out",
    "description": "**Pin Away Puzzle &mdash; Tap It Out: What&rsquo;s Inside?** Dive into a world of captivating challenges, where every stage is a new test of your logic and problem-solving abilities. With a variety of unique pin arrangements, each level offers a fresh and exciting experience. Engage in effortless tapping action thats both fun and rewarding, as you plan your moves and clear the board with precision. Whether youre seeking a way to relax or looking to boost your mental agility, this game offers the perfect solution.",
    "instructions": "Exercise your mind by tapping on pins of various shapes taking into account each step since some pins might be obstructed by others Brace yourself for a delightful and effortless adventure that blends tactics and calmness",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7ik4e5h1bmydlnwst353wpwwe8aax9a2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7ik4e5h1bmydlnwst353wpwwe8aax9a2/",
    "sourceUrl": "https://html5.gamemonetize.com/7ik4e5h1bmydlnwst353wpwwe8aax9a2/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "60781",
    "slug": "little-princess-dress-up",
    "title": "Little Princess Dress Up",
    "description": "This is a fashion dress-up game for girls. If you like to dress up virtual dolls, we have a game you cant miss. The game offers a wide range of styles of gorgeous outfits and accessories for you to choose from, so you will be overwhelmed.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion"
    ],
    "thumbnail": "https://img.gamemonetize.com/lrqyk0fb308zlzk2gpt95mtqp1yr40au/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lrqyk0fb308zlzk2gpt95mtqp1yr40au/",
    "sourceUrl": "https://html5.gamemonetize.com/lrqyk0fb308zlzk2gpt95mtqp1yr40au/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67019",
    "slug": "dont-tease-me",
    "title": "Dont Tease Me",
    "description": "Don&rsquo;t Tease Me is a survival game where dodging is your only defense. Avoid balls, grab ghost pickups to vanish, and see how long you can stay masked. No fighting back&mdash;just pure evasion!",
    "instructions": "Use WASD Keys or Left Mouse Click or Touch to control the character to avoid the incoming stones",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Avoid"
    ],
    "thumbnail": "https://img.gamemonetize.com/yave8cdl69fawz24yaiy0m45oep54882/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yave8cdl69fawz24yaiy0m45oep54882/",
    "sourceUrl": "https://html5.gamemonetize.com/yave8cdl69fawz24yaiy0m45oep54882/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "70037",
    "slug": "balloon-heroes-run-and-rise",
    "title": "Balloon Heroes Run and Rise",
    "description": "Balloon Heroes: Run &amp; Rise is a fast-paced racing game where you compete in thrilling obstacle courses. Collect balloons to power high jumps, avoid falling into water, and race to the finish line ahead of rivals. Earn coins to unlock skins and customize your hero. With tons of challenging levels, this game offers nonstop action, strategy, and fun as you run, jump, and outsmart opponents to claim victory!",
    "instructions": "Tap or mouse click to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Multiplayer",
      "Race",
      "run",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/vlhloqzu0cvn1apzoyq9vwycgddt3fxn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vlhloqzu0cvn1apzoyq9vwycgddt3fxn/",
    "sourceUrl": "https://html5.gamemonetize.com/vlhloqzu0cvn1apzoyq9vwycgddt3fxn/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70087",
    "slug": "physics-heat-temperatuie-quiz",
    "title": "Physics: Heat Temperatuie Quiz",
    "description": "Try out our new Quiz on Heat and Temperature in Physics. This quiz is designed for a quick checkpoint about your knowledge on this topic. Prepare well and then try :)",
    "instructions": "Click on the CORRECT option",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "Physics",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/q06mhtqhtjgzoulq0zw55vs8uvfm2fkd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q06mhtqhtjgzoulq0zw55vs8uvfm2fkd/",
    "sourceUrl": "https://html5.gamemonetize.com/q06mhtqhtjgzoulq0zw55vs8uvfm2fkd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "57032",
    "slug": "hexamatch",
    "title": "HexaMatch",
    "description": "HexaMatch &ndash; The Ultimate Number Puzzle! Swipe and sort tiles into the empty slot to solve addictive hexa puzzles. With progressive difficulty, unique gameplay, and a fresh twist on classic number games, HexaMatch is perfect for all ages. Train your brain, relax your mind, and enjoy endless fun with this simple yet challenging merge hexa puzzle!",
    "instructions": "You have only one empty slot on the board Slide a tile into the empty slot to move it Tap or swipe the tile you wish to move Keep moving the tiles until all the numbers are in the correct sequence",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Logic",
      "Matching",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/dogv5wgrkwxsq71uh8zuhrt7d0xf3u9s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dogv5wgrkwxsq71uh8zuhrt7d0xf3u9s/",
    "sourceUrl": "https://html5.gamemonetize.com/dogv5wgrkwxsq71uh8zuhrt7d0xf3u9s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70059",
    "slug": "rocket-adventure",
    "title": "Rocket Adventure",
    "description": "Blast off for the stratosphere with Rocket Adventure, the addictive physics rocket game that beat all conquest games. Your mission is to launch your rocket as high into orbit as possible. Simple touches control when you release each stage in your rocket. Earn in-game currency from successful launches and spend it to acquire new parts and styles.",
    "instructions": "Use the mouse or touch to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "Clicker",
      "Flight",
      "html games for your website",
      "kiz10",
      "Rocket",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/882isa4b37an4ap1p7dv7akabupe7awf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/882isa4b37an4ap1p7dv7akabupe7awf/",
    "sourceUrl": "https://html5.gamemonetize.com/882isa4b37an4ap1p7dv7akabupe7awf/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69984",
    "slug": "jam-escape",
    "title": "Jam Escape",
    "description": "Parking Guru is an addictive parkingpuzzle game where you rearrange vehicles to clear a path for the red car to escape the jam. If you&rsquo;re a fan of the classic Rush Hour board game, this puzzle will hook you instantly! Levels for every skill: From simple shuffles to mind-bending brainteasers. Varied vehicle roster: Classic sedans, rugged SUVs, and massive trucks&mdash;all with unique silhouettes. Intuitive controls: Drag cars with your mouse, rotate them, and find your way out of even the most tangled traffic. Time &amp; move tracking: Beat your best time or take it slow&mdash;set a new personal record or simply enjoy the challenge. Vibrant art",
    "instructions": "Play levels in sequence or jump straight to any level you choose Drag cars with your mouse to clear a path for the red car Aim to solve each puzzle with the fewest moves and in the shortest time Click ldquo Reset rdquo to restart the current level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/efg2lhro63ynxm7xu8esecw8sh030iql/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/efg2lhro63ynxm7xu8esecw8sh030iql/",
    "sourceUrl": "https://html5.gamemonetize.com/efg2lhro63ynxm7xu8esecw8sh030iql/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69885",
    "slug": "mysterious-elevator",
    "title": "Mysterious elevator",
    "description": "Immerse yourself in the thrilling adventure of &ldquo;Mysterious Elevator&rdquo;! You are trapped in a skyscraper with 100 floors, ruled by the sarcastic Keeper of Numbers &mdash; a master of mathematical riddles. To escape, solve logical challenges while riding in an old creaky elevator. Swap number and sign blocks, assemble equations, and face extra puzzles along the way. Each floor is a new test: from simple arithmetic to tricky logic traps. One mistake, and the elevator may crash! With every solution you descend closer to freedom. &ldquo;Mysterious Elevator&rdquo; is perfect for fans of math, logic, and atmospheric mysteries. Can you outsmart the Keeper and escape?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "Escape",
      "Logic",
      "Math",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/fovn0q6vntn3c8adm8lsz17gszwguvw4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fovn0q6vntn3c8adm8lsz17gszwguvw4/",
    "sourceUrl": "https://html5.gamemonetize.com/fovn0q6vntn3c8adm8lsz17gszwguvw4/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69981",
    "slug": "maths-for-standard-ii",
    "title": "Maths for Standard II",
    "description": "Add the numbers and choose the correct option. This is simple maths game for giving puzzles to students who are below or in Standard 2nd. This just asks students to choose from 4 options out of which one option is CORRECT!",
    "instructions": "Click to choose an option out of 4 options",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Math",
      "Number",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/9lshvga0hkj67rv1hpxmssq4684ik2kw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9lshvga0hkj67rv1hpxmssq4684ik2kw/",
    "sourceUrl": "https://html5.gamemonetize.com/9lshvga0hkj67rv1hpxmssq4684ik2kw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68456",
    "slug": "cowboy-shooter",
    "title": "Cowboy Shooter",
    "description": "Step into the Wild West and test your aim in this fast-paced cowboy shooting game! Time is running, and every shot counts. Break bottles, hit targets, and challenge yourself to earn the highest score before the clock runs out. With simple yet addictive gameplay, Cowboy Shooter offers endless fun and a true test of your reflexes. Are you quick enough to become the ultimate sharpshooter?",
    "instructions": "Aim Move the mouse to aim at the targets Shoot Press the Left Mouse Button to fire Mobile Use the on-screen buttons to aim and shoot just like on PC",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2025 games",
      "3D",
      "3D Games",
      "Action",
      "Best",
      "Bullet",
      "Decoration",
      "First Person Shooter",
      "free games for your website",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/kkpkruc5ghqfy3xgopo26yy7i44a95of/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kkpkruc5ghqfy3xgopo26yy7i44a95of/",
    "sourceUrl": "https://html5.gamemonetize.com/kkpkruc5ghqfy3xgopo26yy7i44a95of/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69707",
    "slug": "multiplication-master",
    "title": "Multiplication Master",
    "description": "Multiplication Master isn&rsquo;t your average math game &ndash; it&rsquo;s a full-on battle for brainpower. You pick the mode, you set the pace. From steady Normal runs to the nerve-wracking Timed Challenge, the lightning-fast Quick Answers, the relentless Survival, the explosive Bomb Mode, and the ultimate Marathon &ndash; every match will push your limits. Think you&rsquo;ve got the tables from x2 to x12 locked down? Prove it. Mix them up for the real test. Rack up points, keep those streaks alive, and climb the global leaderboard where only the sharpest minds survive.",
    "instructions": "- Keyboard Touchscreen ndash Type your answer using the number keys or on-screen keyboard - Mouse Tap ndash Click or tap the answer buttons in Quick Answers mode - Press Enter or tap Check to submit your answer - Use Menu buttons to change leve",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Math",
      "Number",
      "Puzzle",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/8sud2ncj514ukh808c0pfyrbiht9998z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8sud2ncj514ukh808c0pfyrbiht9998z/",
    "sourceUrl": "https://html5.gamemonetize.com/8sud2ncj514ukh808c0pfyrbiht9998z/",
    "width": 800,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "69403",
    "slug": "frog-adventure",
    "title": "Frog Adventure",
    "description": "Leap, sneak, and strike as a pixel-art ninja frog in a fast-paced platformer adventure! Dive into a stylish retro world where you control a ninja frog with lightning reflexes. Each level is crafted to challenge your timing, precision, and creativity. Jump over traps, dash through enemies, and master the art of pixel-perfect movement. With vibrant visuals and snappy gameplay, this is platforming with attitude.",
    "instructions": "Controls larr A Q Move Left rarr D Move Right uarr W Space Z Jump TAP Pause",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Adventure",
      "Pixel",
      "Platform",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/4rskvzksbpjd52lsalqeazyest2fpqdp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4rskvzksbpjd52lsalqeazyest2fpqdp/",
    "sourceUrl": "https://html5.gamemonetize.com/4rskvzksbpjd52lsalqeazyest2fpqdp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68201",
    "slug": "asmr-makeover-and-amp-makeup-studio",
    "title": "ASMR Makeover &amp; Makeup Studio",
    "description": "Get ready to dive into the world of beauty and creativity! ASMR Makeup &amp; Makeover Studio offers an incredible opportunity to give your virtual model a stunning makeover. This isnt just any makeover game &mdash; its an immersive experience that combines relaxation and excitement through the power of ASMR!",
    "instructions": "Give your toy a fabulous new look with these skin care and makeup options Check out what the game has to offer Pamper your dolls skin and make it shine with various skin care products Choose from an array of makeup styles and colors to create any d",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/oylhmja8edugu708hhwbycfcjtofga6a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oylhmja8edugu708hhwbycfcjtofga6a/",
    "sourceUrl": "https://html5.gamemonetize.com/oylhmja8edugu708hhwbycfcjtofga6a/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69906",
    "slug": "2048-space-mission",
    "title": "2048 Space Mission",
    "description": "2048 Space Mission is an amazing and addictive number puzzle game. Explore tons of challenging levels and try to complete them all! Each level has a different mission. Collect coins to unlock beautiful new game boards or use the hammer to eliminate discs. Have fun!",
    "instructions": "Follow the game instructions",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "3D",
      "Arcade",
      "Math",
      "Number"
    ],
    "thumbnail": "https://img.gamemonetize.com/zn8rb2r0aw0km0r3qqojz9pbfcgecx8w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zn8rb2r0aw0km0r3qqojz9pbfcgecx8w/",
    "sourceUrl": "https://html5.gamemonetize.com/zn8rb2r0aw0km0r3qqojz9pbfcgecx8w/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69954",
    "slug": "minicraft-chef-cake-wars",
    "title": "Minicraft Chef Cake Wars",
    "description": "Hey player, would you like to have a cooking competition with your friend? In this cooking contest, you must beat your friend. Collect all the cooking materials as quickly as possible. We need to gather the cake ingredients floating in balloons in the air. The player who collects the most ingredients the fastest wins the game. To bake the cake, collect everything: salt, flour, and milk. Gather all the ingredients and win the game!",
    "instructions": "The first player to collect 10 cake ingredients wins the game Use the WASD and Arrow keys to move Double Jump available Playable on both mobile and PC Use S and Down Arrow keys to push",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arcade",
      "Arena",
      "Battle",
      "mineblock",
      "Minecraft",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/fjf2rxzypz98j86jzv3mxc0djp5v1hec/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fjf2rxzypz98j86jzv3mxc0djp5v1hec/",
    "sourceUrl": "https://html5.gamemonetize.com/fjf2rxzypz98j86jzv3mxc0djp5v1hec/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69684",
    "slug": "cutepanckake",
    "title": "CutePanckake",
    "description": "Take the cake out of the pan and stack it at the bottom. The more you stack, the easier it is to pour over. Choosing the right position is very crucial. See how much you can stack",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Balance",
      "Best Games",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/nzigd2vu6gapzj57ty5vzkclwaal7op3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nzigd2vu6gapzj57ty5vzkclwaal7op3/",
    "sourceUrl": "https://html5.gamemonetize.com/nzigd2vu6gapzj57ty5vzkclwaal7op3/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69964",
    "slug": "3d-tower-defense",
    "title": "3D Tower Defense",
    "description": "Defend your base in 3D Tower Defense! Explore colorful arenas, test your logic, and enjoy funny yet challenging battles. One of the best games for strategy lovers!",
    "instructions": "Click with interactive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "amazing",
      "Arcade",
      "Arena",
      "arrow",
      "arrows",
      "attack",
      "Battle",
      "Best",
      "Defense",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/14dmjhvrz1a49o8mzkbm7ztup4ocbr2u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/14dmjhvrz1a49o8mzkbm7ztup4ocbr2u/",
    "sourceUrl": "https://html5.gamemonetize.com/14dmjhvrz1a49o8mzkbm7ztup4ocbr2u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "70014",
    "slug": "basic-physics-single-choice",
    "title": "Basic Physics Single Choice",
    "description": "This is a single-choice correct Physics quiz where each question is knockout and timed. Time over, you lose. Single incorrect reply and you lose too! So plan and play! This game is a quick test of your knowledge.",
    "instructions": "Click on the correct answer",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Educational",
      "Physics",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/9i02rpc309q7yj95vpttlhruabr2aag1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9i02rpc309q7yj95vpttlhruabr2aag1/",
    "sourceUrl": "https://html5.gamemonetize.com/9i02rpc309q7yj95vpttlhruabr2aag1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69330",
    "slug": "zippy-bird",
    "title": "Zippy Bird",
    "description": "Help Zippy Bird fly through gaps in pipes! Tap to flap and avoid obstacles in this fast-paced arcade challenge. Easy to learn, hard to master!",
    "instructions": "bull Tap or Click to make the bird flap bull Avoid hitting the pipes to stay alive bull The longer you survive the higher your score",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Air",
      "amazing",
      "Android",
      "Arcade",
      "Best",
      "Best Games",
      "Bird",
      "Click",
      "Clicker",
      "Cool",
      "Crazy",
      "Highscore",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/urgeu3uta5umpjhn02ihyql5ouwc1hfq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/urgeu3uta5umpjhn02ihyql5ouwc1hfq/",
    "sourceUrl": "https://html5.gamemonetize.com/urgeu3uta5umpjhn02ihyql5ouwc1hfq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69855",
    "slug": "vector-parkour",
    "title": "Vector Parkour",
    "description": "Vector is an exciting arcade-style game featuring you as the exceptional free runner who wont be held down by the system. Run, jump and climb using techniques based on the urban-ninja sport of parkour with Big Brother in hot pursuit!",
    "instructions": "Use the keyboard or Mouse to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Action",
      "Escape",
      "free html5 games for your website",
      "Jumping",
      "kiz10",
      "realistic",
      "running",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/gcg6mybdrkv0l5midg3b798bx5h30ltk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gcg6mybdrkv0l5midg3b798bx5h30ltk/",
    "sourceUrl": "https://html5.gamemonetize.com/gcg6mybdrkv0l5midg3b798bx5h30ltk/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69772",
    "slug": "3d-puzzle",
    "title": "3d Puzzle",
    "description": "3D isometric Puzzle Game is a fun and addictive puzzle game with isometric tiles. Find secret path to finish all levels. - move the player to the next isometric block. - Once you leave a yellow block, it will fall to the ground. - To finish a level, all yellow blocks have to be down on the ground and the player has to be on the Purple block, to solve the puzzle",
    "instructions": "Mouse click or tap or swipe to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/omk6vjruzury89ordfkxxohwysej87tb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/omk6vjruzury89ordfkxxohwysej87tb/",
    "sourceUrl": "https://html5.gamemonetize.com/omk6vjruzury89ordfkxxohwysej87tb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69605",
    "slug": "pga4",
    "title": "PGA4",
    "description": "Step into the thrilling world of Pixel Gun Apocalypse 4, where fast-paced shooting meets blocky pixel graphics! Join intense multiplayer battles, choose from powerful weapons, and prove your skills in survival arenas. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a> . Whether you fight as a soldier or a zombie, strategy and precision are the keys to victory. Experience adrenaline-packed action, smooth controls, and endless fun in this epic online FPS adventure.",
    "instructions": "Mouse click or tap to play wasd to walk",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "unity games",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/5bpvxu9qn38i4pgg0aw5kzzskawhkk6n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5bpvxu9qn38i4pgg0aw5kzzskawhkk6n/",
    "sourceUrl": "https://html5.gamemonetize.com/5bpvxu9qn38i4pgg0aw5kzzskawhkk6n/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68549",
    "slug": "cool-girl-aesthetics",
    "title": "Cool Girl Aesthetics",
    "description": "In Cool Girl Aesthetics, join Mia as she creates her ultimate trendy look! Start by customizing her Stanley cup with fun colors, prints, and accessories. Then, style her headphones, giving them a unique vibe. Next, design her manicure with cool colors, rings, and temporary tattoos for a stylish edge. Complete the look with makeup options like face stickers, colorful braces, and more. Dive into this fun, creative dress-up, and makeover game for endless aesthetic options. Make Mia&rsquo;s look unforgettable!",
    "instructions": "Use your mouse to play this game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "beauty",
      "Design",
      "Fashion",
      "Girl",
      "HTML5",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/tu1dlg1h1mt9mi7v71143be6s1qf3ok4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tu1dlg1h1mt9mi7v71143be6s1qf3ok4/",
    "sourceUrl": "https://html5.gamemonetize.com/tu1dlg1h1mt9mi7v71143be6s1qf3ok4/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69963",
    "slug": "minicraft-bedwars",
    "title": "Minicraft Bedwars",
    "description": "How about protecting your bed and destroying your friend&rsquo;s bed in Bedwars mode? Choose either the red or blue team. Collect gold as quickly as possible and use the gold you&rsquo;ve gathered to buy cannonballs for your cannon. Fire cannonballs from your cannon to hit your friend&rsquo;s bed. You can collect both your own gold and your friend&rsquo;s gold. Gather all the gold and purchase cannonballs. Remember, if you miss your shot, you&rsquo;ll run out of cannonballs and lose the game. You must be very careful.",
    "instructions": "The red player moves using the WASD keys The blue player moves using the arrow keys Press the Bottom Arrow key and the S key to fire and buy cannons",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade",
      "Battle",
      "mineblock",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/0nghl3lt3nq5s5c1d3bykttjy4256qzg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0nghl3lt3nq5s5c1d3bykttjy4256qzg/",
    "sourceUrl": "https://html5.gamemonetize.com/0nghl3lt3nq5s5c1d3bykttjy4256qzg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69942",
    "slug": "monster-makeover",
    "title": "Monster MakeOver",
    "description": "Monster Makeover, the ultimate game for monster lovers! Have you ever wanted to create your monster? Yes, you are not mistaken. Now you can! Choose from a variety of cute monsters and get ready to unleash your creativity! You can use them everywhere.",
    "instructions": "use mouse on desktop or your finger in the screen on mobile",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Baby",
      "Baby Games",
      "Baby Hazel",
      "Fun",
      "Funny",
      "Poppy Playtime",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ffjwdvs3xi6qfqiqxbapohbhgplvtmto/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ffjwdvs3xi6qfqiqxbapohbhgplvtmto/",
    "sourceUrl": "https://html5.gamemonetize.com/ffjwdvs3xi6qfqiqxbapohbhgplvtmto/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69985",
    "slug": "basic-economics-multiple-choice",
    "title": "Basic Economics Multiple choice",
    "description": "This is a game which prepares Standard Xth to University students for a fast-paced quiz based knowledge testing on Economics where each question is timed and one incorrect answer leaves you failed. Choose 1 of 4 choices!",
    "instructions": "Click tap on the CORRECT choice",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Management",
      "Math",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/tttzp6eq2dhs0qk33j1uw3pq26fp7xp7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tttzp6eq2dhs0qk33j1uw3pq26fp7xp7/",
    "sourceUrl": "https://html5.gamemonetize.com/tttzp6eq2dhs0qk33j1uw3pq26fp7xp7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69982",
    "slug": "maths-for-standard-v",
    "title": "Maths for Standard V",
    "description": "This is a game designed for school children from Std. 3-5, who should be able to add numbers till 100 and multiply/divide numbers till 10. 4 options per question and 1 is CORRECT, choose that one. Any wrong answers or time over, restarts the game!",
    "instructions": "Click or tap on the CORRECT option",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Educational",
      "Kids",
      "Math"
    ],
    "thumbnail": "https://img.gamemonetize.com/dy7n5ruc8l4whfv0d1dng13uchr2ctce/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dy7n5ruc8l4whfv0d1dng13uchr2ctce/",
    "sourceUrl": "https://html5.gamemonetize.com/dy7n5ruc8l4whfv0d1dng13uchr2ctce/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69909",
    "slug": "hill-racer-2d",
    "title": "Hill Racer 2D",
    "description": "Hill Racer 2D &ndash; Drive through hills, balance your car, and race to the finish without flipping or running out of fuel! Addictive 2D racing fun, challenging tracks, and endless excitement.",
    "instructions": "How to Play PC Use buttons A D or Arrow larr rarr to control the car Mobile Use buttons brakes and gas on the screen",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Air",
      "Arcade",
      "arrow",
      "Baby",
      "Baby Games",
      "Best",
      "Best Games",
      "Car",
      "Cars",
      "Motorcycle",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/9608ky3vismjiwrg1axdutxkoqti9w6d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9608ky3vismjiwrg1axdutxkoqti9w6d/",
    "sourceUrl": "https://html5.gamemonetize.com/9608ky3vismjiwrg1axdutxkoqti9w6d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69883",
    "slug": "feed-monster-game",
    "title": "Feed Monster Game",
    "description": "Wander through an endless maze collecting glowing dots to boost your score while staying ahead of the hungry creatures lurking around. Grab an energizer and turn the tables, chasing monsters for extra points. Feed Monster offers a twist on the classic arcade vibe, keeping every run unpredictable and exciting for players who love a challenge.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Classic",
      "Funny",
      "games for your website",
      "Highscore",
      "Maze",
      "PacMan",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/v2537t64ojk8ia8pa1r0d7xdrhlqq9xt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v2537t64ojk8ia8pa1r0d7xdrhlqq9xt/",
    "sourceUrl": "https://html5.gamemonetize.com/v2537t64ojk8ia8pa1r0d7xdrhlqq9xt/",
    "width": 1280,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69930",
    "slug": "baby-noob-help-steve",
    "title": "Baby Noob Help! Steve",
    "description": "Baby Noob needs to reach home. You must help him, Steve. Steve should help so that Baby Noob arrives home safely. Once Noob makes it home, he must reach the baby stroller. When he reaches the stroller, the level is complete. Be careful, there are green monsters in the forest. You must defeat all the monsters, Steve. Collect all the baby bottles along the way.",
    "instructions": "Press wasd keys to move Press the SPACE key to attack with the sword Double Jump available Mobile Touch Control Kill all the monsters and safely guide them to the barn",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Minecraft",
      "Platform",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/w1ccjotbnts714u46xi817i2n3au243a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w1ccjotbnts714u46xi817i2n3au243a/",
    "sourceUrl": "https://html5.gamemonetize.com/w1ccjotbnts714u46xi817i2n3au243a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69867",
    "slug": "labubu-shooter",
    "title": "Labubu Shooter",
    "description": "Labubu Shooter is a fast paced crossover game that mixes tactical FPS action with quirky humor. You play as a Counter Strike style operative fighting against waves of Labubu creatures in Minecraft inspired levels.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "CSGO",
      "First Person Shooter",
      "Gun",
      "Labubu",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/klzoqsmeofr7ylbhwhbwy9znj3n4ucsw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/klzoqsmeofr7ylbhwhbwy9znj3n4ucsw/",
    "sourceUrl": "https://html5.gamemonetize.com/klzoqsmeofr7ylbhwhbwy9znj3n4ucsw/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69674",
    "slug": "liftbreak",
    "title": "LiftBreak",
    "description": "Seize the opportunity to control the elevator to stop falling, avoid hitting obstacles, and reach the bottom to clear the level. The game features multiple levels. Come and take on the challenge",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "Adventure",
      "Best Games",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/1km05cdq3j7zxyhsmed5jx4mfj8gwq64/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1km05cdq3j7zxyhsmed5jx4mfj8gwq64/",
    "sourceUrl": "https://html5.gamemonetize.com/1km05cdq3j7zxyhsmed5jx4mfj8gwq64/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69889",
    "slug": "simple-flappy-ball",
    "title": "Simple Flappy Ball",
    "description": "Step into the thrilling world of Simple Flappy Ball, where precise timing and quick reflexes are the keys to survival! Control a small, bouncy ball as it maneuvers within a rotating arena filled with dangerous obstacles. The ball must stay in motion, constantly jumping between the inner safe zone and the outer rotating bars. A perfectly timed jump propels the ball outward, while missing a jump causes it to fall toward the center &mdash; and colliding with the inner circle or the spinning outer bars ends the game instantly. Challenge yourself to master the delicate balance of flapping to avoid danger while surviving as long as possible in this endl",
    "instructions": "Click tap to jump away from center avoid collision else you die",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ball",
      "Bird",
      "jump",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/rcha84n0dg1pfi1kq0gibx5ro8s35xf2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rcha84n0dg1pfi1kq0gibx5ro8s35xf2/",
    "sourceUrl": "https://html5.gamemonetize.com/rcha84n0dg1pfi1kq0gibx5ro8s35xf2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69916",
    "slug": "sudoku-vault",
    "title": "Sudoku Vault",
    "description": "Sudoku Vault is a logic-based puzzle game featuring 4x4, 6x6, and 9x9 boards &mdash; each with four difficulty levels: Basic, Normal, Hard, and Expert. Whether youre a beginner or an expert, every grid offers a fresh challenge for your mind. Use smart NOTES to keep track of possibilities, and when you want to check your progress, tap the CHECK button &mdash; it will remove incorrect inputs and lock the correct ones, helping you stay focused on the solution. With clean design and intuitive controls, Sudoku Vault is the perfect blend of relaxation and brain training.",
    "instructions": "Use a mouse or touchpad to select a cell then choose a number from the on-screen number pad to fill it in Use the Note button to toggle pencil marks and tap Check to validate your entries mdash incorrect numbers are removed and correct ones are lock",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "Logic",
      "Puzzle",
      "Skill",
      "Sudoku"
    ],
    "thumbnail": "https://img.gamemonetize.com/nb0q7eulslp9pr3tya11bssnkbwcm1kg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nb0q7eulslp9pr3tya11bssnkbwcm1kg/",
    "sourceUrl": "https://html5.gamemonetize.com/nb0q7eulslp9pr3tya11bssnkbwcm1kg/",
    "width": 450,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68692",
    "slug": "big-catch-fishing",
    "title": "Big Catch Fishing",
    "description": "In Big Catch Fishing, you play as a cute cat on a fishing adventure! Tap the screen to drop your hook into the water. While it sinks, move it left and right to collect as many fish as you can. When the hook comes back up, tap on the fish to shoot them and earn coins. Use those coins to buy upgrades in the shop. You can go deeper, make your line faster, and unlock better weapons like rifles, shotguns, and even a sniper! There are also special tools like lights and electric shocks to help you catch more. The more you upgrade, the more treasure you&rsquo;ll find under the sea.",
    "instructions": "Tap the Screen to begin fishing Hold amp Drag to guide the fishing hook underwater Tap on Fish during the shooting phase to earn coins Use Coins to buy upgrades from the shop -Increase line distance -Boost line speed -Upgrade your weapon -Unlock lamp o",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Cat",
      "catch",
      "Fish",
      "Fishing",
      "Shoot",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/tarwiqehtxcf9u727r5xshj7bk43o6lu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tarwiqehtxcf9u727r5xshj7bk43o6lu/",
    "sourceUrl": "https://html5.gamemonetize.com/tarwiqehtxcf9u727r5xshj7bk43o6lu/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69846",
    "slug": "arrow-survival-15-seconds",
    "title": "Arrow Survival: 15 Seconds",
    "description": "Dodge and shoot to survive 15 seconds! Master 40 levels of arrow chaos in this fast-paced pixel art platformer! Dive into Arrow Survival: 15 Seconds, a thrilling 2D pixel art platformer where every second counts! As a skilled archer, your mission is to survive 15 seconds per level by dodging deadly hazards and strategically firing arrows. Each of the 40 unique levels introduces new challenges, from bouncing platforms that redirect your arrows to treacherous spikes and evolving mechanics that keep you on your toes.",
    "instructions": "Move A D or larr rarr Jump W uarr or Spacebar Shoot Arrows J or X Restart Level R Pause Game P",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "arrow",
      "arrows",
      "Bow",
      "Casual",
      "free games for your site",
      "free games for your website",
      "free html5 games for your website",
      "html games for your website",
      "Hypercasual",
      "Pixel",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/oqyu2giimhs2eegfvn1wd9xo5p862dpz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oqyu2giimhs2eegfvn1wd9xo5p862dpz/",
    "sourceUrl": "https://html5.gamemonetize.com/oqyu2giimhs2eegfvn1wd9xo5p862dpz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69840",
    "slug": "sky-bus-mega-ramp-drive",
    "title": "Sky Bus Mega Ramp Drive",
    "description": "Step into Sky Bus Mega Ramp Drive &ndash; the ultimate bus stunt adventure on towering mega ramps! Get behind the wheel of colossal buses and push them to the limit as you take on impossible sky-high ramps, insane loops, and gravity-defying tracks. Your mission? Master the mega bus and perform jaw-dropping stunts high above the clouds&mdash;leap across gigantic gaps, blast through vertical loops, and dominate some of the wildest ramps ever created.",
    "instructions": "Use the Arrow Keys or WASD to drive the bus mdash Up W accelerates Down S brakes or reverses Left A and Right D steer Press Space Bar to activate Nitro boost for extra speed on big jumps Navigate ramps loops and narrow sky roads while avoiding obs",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "bus",
      "Car",
      "Driving",
      "Race",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/a02km4qyipo77qsylzqktgxlm2sia2tf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a02km4qyipo77qsylzqktgxlm2sia2tf/",
    "sourceUrl": "https://html5.gamemonetize.com/a02km4qyipo77qsylzqktgxlm2sia2tf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69685",
    "slug": "cuteslicesball",
    "title": "CuteSlicesBall",
    "description": "Arrange all the slices of different shapes reasonably into the surrounding circular containers. After all the slices are placed, pass the level. There are multiple different levels, and you need to use your little brain to pass them. Come and take on the challenge",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Best Games",
      "Casual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/6nclv6w89nvzotvfsoc3gziz76bjop1a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6nclv6w89nvzotvfsoc3gziz76bjop1a/",
    "sourceUrl": "https://html5.gamemonetize.com/6nclv6w89nvzotvfsoc3gziz76bjop1a/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69747",
    "slug": "space-adventure-fun-game",
    "title": "Space Adventure Fun Game",
    "description": "This is a fun, casual space game. Collect as much gold as possible and earn points. I wish everyone who plays the game good luck. You can also use the gold you collect to customize your spaceship. I hope you enjoy the game.",
    "instructions": "Mobile Click Rigth Button and go to rigth click left button and go to left Pc mouse left click go to left and mouse rigth click go to rigth",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adult",
      "Adventure",
      "Air",
      "Aircraft",
      "airplane",
      "Alien",
      "Best",
      "Best Games",
      "Casual",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/7j1c4iivzxwn4awbc8jrdhv7uneqlgi7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7j1c4iivzxwn4awbc8jrdhv7uneqlgi7/",
    "sourceUrl": "https://html5.gamemonetize.com/7j1c4iivzxwn4awbc8jrdhv7uneqlgi7/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69835",
    "slug": "krashen",
    "title": "Krashen",
    "description": "Krashen &ndash; Stack, Smash, and Conquer! Think you&rsquo;ve got perfect timing? Krashen will put your reflexes to the ultimate test. Your mission is simple, but dangerously addictive: Tap at the perfect moment to stack falling blocks on top of each other. Miss the alignment, and the overhanging piece gets sliced away. With each mistake, your tower shrinks&hellip; until there&rsquo;s nothing left! The higher you stack, the faster and more intense the challenge becomes. Can you stay calm under pressure and build a skyscraper that scrapes the sky?",
    "instructions": "Click or Tap the screen to place the blocks",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2025 games",
      "Best",
      "Best Games",
      "Casual",
      "Classic",
      "Clicker",
      "Hypercasual",
      "Lego",
      "New",
      "smash",
      "Stack"
    ],
    "thumbnail": "https://img.gamemonetize.com/z3r5ki3ft58tzkpzn2w4qchzho944bz8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z3r5ki3ft58tzkpzn2w4qchzho944bz8/",
    "sourceUrl": "https://html5.gamemonetize.com/z3r5ki3ft58tzkpzn2w4qchzho944bz8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69844",
    "slug": "edge-racing",
    "title": "Edge Racing",
    "description": "Edge Racing is a casual arcade game where every move counts. Guide your car along sharp turns and narrow tracks with a simple tap. The goal is clear &mdash; stay on the edge and try to set the biggest record you can. Easy to pick up, hard to master, and endlessly replayable, this game will test your reflexes and focus. Challenge yourself, chase higher scores, and enjoy the thrill of pushing your limits in Edge Racing!",
    "instructions": "PC Left Mouse Button or Spacebar Mobile Tap anywhere on the screen",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "3D",
      "3D Games",
      "Android",
      "Arcade",
      "Car",
      "Cars",
      "Casual",
      "Highscore",
      "Hypercasual",
      "Mobile",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/8vebs706uygypzgidd73ysnnssdbny0a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8vebs706uygypzgidd73ysnnssdbny0a/",
    "sourceUrl": "https://html5.gamemonetize.com/8vebs706uygypzgidd73ysnnssdbny0a/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69861",
    "slug": "3d-racing-typing-game",
    "title": "3D Racing Typing Game",
    "description": "Experience the thrill of speed in 3D Racing Typing Game! Boost your car by typing fast and accurate, race rivals, unlock levels, and test your skills in this unique fusion of racing and typing fun!",
    "instructions": "Typing",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Best",
      "Best Games",
      "Car",
      "car tuning",
      "Cars",
      "Cartoon",
      "drift",
      "Driving",
      "Supercars",
      "Typing",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/wtmy1hk5nob7j0znq0ypwoz9tricgilg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wtmy1hk5nob7j0znq0ypwoz9tricgilg/",
    "sourceUrl": "https://html5.gamemonetize.com/wtmy1hk5nob7j0znq0ypwoz9tricgilg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69465",
    "slug": "pixel-wings",
    "title": "Pixel Wings",
    "description": "The player controls a spaceship in outer space and shoots down enemies. For each enemy destroyed, the player earns 100 points. If the player collides with an enemy, they lose one life. The game tests the players reflexes and reaction speed.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D"
    ],
    "thumbnail": "https://img.gamemonetize.com/64exbye6je3ruqutnkml53j69649y9o6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/64exbye6je3ruqutnkml53j69649y9o6/",
    "sourceUrl": "https://html5.gamemonetize.com/64exbye6je3ruqutnkml53j69649y9o6/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69786",
    "slug": "match-factory",
    "title": "Match Factory",
    "description": "Welcome to Match Factory - the most relaxing and non-stop casual triple puzzle game. Step into a vibrant factory full of colorful items, and play the role of a master matcher. Match three identical items to clear them from the board, pack them up, and keep the factory running smoothly! Every level is uniquely designed with tricky layouts and challenges. Use power-ups that help you overcome difficult puzzles!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cute",
      "Funny",
      "Matching",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/o6hdnqn9ys9h7n5c4ne2si58xvefz5e4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o6hdnqn9ys9h7n5c4ne2si58xvefz5e4/",
    "sourceUrl": "https://html5.gamemonetize.com/o6hdnqn9ys9h7n5c4ne2si58xvefz5e4/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69651",
    "slug": "connect-em-all",
    "title": "Connect Em All",
    "description": "Play Connect Em All Online and Solve Colorful Dot Puzzles. Connect Em All is an exciting and addictive puzzle game that you can enjoy for free right in your browser. The goal is simple yet surprisingly challenging: connect all the dots of the same color to complete each level. It sounds easy at first, but as the puzzles grow in size and complexity, you will need clever thinking and careful planning to succeed.",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Avoid",
      "Board",
      "Brain",
      "Collecting",
      "Fun",
      "Hypercasual",
      "Kids",
      "Logic",
      "Logical",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/85uns24prhdog42nt71v12wwvdl1lrwu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/85uns24prhdog42nt71v12wwvdl1lrwu/",
    "sourceUrl": "https://html5.gamemonetize.com/85uns24prhdog42nt71v12wwvdl1lrwu/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69502",
    "slug": "italian-brainrot-bomb-2player",
    "title": "Italian Brainrot Bomb   2Player",
    "description": "The dynamite bomb is left in the space hangar. Whoever has it when the time runs out wins the game, because the bomb will explode. Take the bomb from your opponent before the time runs out. When the time ends, the player holding the bomb wins. Grab the bomb to win the game. Be very careful &mdash; take the bomb and run, and never let the other player have it.",
    "instructions": "Use the WASD and Arrow keys to move Be the bomb holder before the time runs out and win the game Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/v8coxcrv90p3b04gvzj6hlt8njrhs6bp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v8coxcrv90p3b04gvzj6hlt8njrhs6bp/",
    "sourceUrl": "https://html5.gamemonetize.com/v8coxcrv90p3b04gvzj6hlt8njrhs6bp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68471",
    "slug": "evolve-numbers",
    "title": "Evolve Numbers",
    "description": "Merge tiles with identical numbers by sliding them across the board. When two tiles with the same number combine, they create a new tile with double the value. The goal is to reach the 2048 tile to win, but you can keep playing for an even higher score. Be careful not to run out of moves!",
    "instructions": "On PC Use the arrow keys Up Down Left Right to move the tiles On mobile devices Swipe your finger in the desired direction Up Down Left Right to move the tiles",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "blockchain",
      "Classic",
      "Forest",
      "Highscore",
      "html5 games",
      "Mobile",
      "Number",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/x3vmst3chfxrcrqp0v3lbkd3azdalyk8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x3vmst3chfxrcrqp0v3lbkd3azdalyk8/",
    "sourceUrl": "https://html5.gamemonetize.com/x3vmst3chfxrcrqp0v3lbkd3azdalyk8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "54064",
    "slug": "guess-words-fast",
    "title": "Guess Words Fast",
    "description": "Guess Words Fast challenges players to swiftly decipher words from clues provided. In this high-paced game, players race against time to identify words accurately, testing their vocabulary and cognitive skills. With each correct guess, players accumulate points, fostering a competitive spirit among participants. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a> The games dynamic nature keeps players engaged, as they strive to beat their own records or compete with friends and family.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boy",
      "Boys",
      "Educational",
      "Kid",
      "Kids",
      "Mentolatux",
      "Puzzle",
      "Unity3D",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/b6p5wiivp65yc37p95p2qafcu4g83c1e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b6p5wiivp65yc37p95p2qafcu4g83c1e/",
    "sourceUrl": "https://html5.gamemonetize.com/b6p5wiivp65yc37p95p2qafcu4g83c1e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69742",
    "slug": "retrohero-the-last-stand",
    "title": "retrohero the last stand",
    "description": "Enter a mythic pixel world where ancient guardians rise to protect their realm from invaders. As the chosen defender, you must face endless waves of aliens, ruthless robots, and demonic creatures seeking to conquer your land. Armed with mystical powers and legendary artifacts, every battle is a test of skill and survival. With vibrant retro pixel art, fast-paced action, and a clash of mythology and sci-fi, this game challenges you to adapt, crush enemies, and prove that the ancient spirit can withstand any external threat. The fate of the world rests in your hands.",
    "instructions": "left up right down a s",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Action",
      "Adventure",
      "Alien",
      "Android",
      "Arcade",
      "attack",
      "Classic",
      "free html5 games for your website",
      "HTML5",
      "Mobile",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/klwrlmp3nmrjn49q7e4lmzwk48bcfum2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/klwrlmp3nmrjn49q7e4lmzwk48bcfum2/",
    "sourceUrl": "https://html5.gamemonetize.com/klwrlmp3nmrjn49q7e4lmzwk48bcfum2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69808",
    "slug": "vowels-vs-consonants",
    "title": "Vowels Vs Consonants",
    "description": "Challenge your brain with Vowel Vs Consonant! This fun educational game helps children and learners practice identifying vowels and consonants in a playful way. Each round presents a random letter, and your job is to make the right choice before time runs out. A great way to boost memory, speed, and confidence in English learning. Use mouse clicks on desktop or tap on mobile devices to answer and enjoy endless learning fun.",
    "instructions": "Desktop Controls Use your mouse to click on ldquo Vowel rdquo or ldquo Consonant rdquo Mobile Controls Tap the correct option on the screen to answer",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Educational",
      "HTML5",
      "html5 games",
      "Kid",
      "Kids",
      "NapTech Games",
      "Online",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/3n9m6mczuvpll6ahppsibqc0d21nlmh7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3n9m6mczuvpll6ahppsibqc0d21nlmh7/",
    "sourceUrl": "https://html5.gamemonetize.com/3n9m6mczuvpll6ahppsibqc0d21nlmh7/",
    "width": 2560,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69552",
    "slug": "minecraft-unblocked-online",
    "title": "Minecraft Unblocked Online",
    "description": "Welcome to Minecraft Unblocked Online - a completely open pixel sandbox world. Here you can build, design and create your own fantasy world to your hearts content! You can explore the endless map, collect resources, dig up cubes, build castles, villages, and even a city in the sky! Youre in charge of all the creativity! This game is easy to play and quick to get started. A perfect combination of casual and arcade style.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "build",
      "Craft",
      "Mine",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/cjuftfessx0di02doxcwbzfsom0dd3v7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cjuftfessx0di02doxcwbzfsom0dd3v7/",
    "sourceUrl": "https://html5.gamemonetize.com/cjuftfessx0di02doxcwbzfsom0dd3v7/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69790",
    "slug": "dr-parking-2",
    "title": "Dr. Parking 2",
    "description": "Ready to test your parking skills? Welcome to Dr. Parking - the super addictive car simulation game designed for all the boys who love a true driving challenge. In the game, you will drive various types of vehicles. Traverse the obstacle-laden parking lot and change corners and park your car precisely in the designated spot. And keep an eye out for keys. Each level is a test of your precision, patience, and driving instinct.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Car",
      "Parking",
      "Simulation",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/5lg1g0z33q4o6mt1shnje9ou4ts17wtl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5lg1g0z33q4o6mt1shnje9ou4ts17wtl/",
    "sourceUrl": "https://html5.gamemonetize.com/5lg1g0z33q4o6mt1shnje9ou4ts17wtl/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "69795",
    "slug": "sausage-flip-free",
    "title": "Sausage Flip Free",
    "description": "In Sausage Flip Free, youre not just any sausage. You&rsquo;re a daring, bouncy hero on a mission to overcome wild levels full of danger, timing, and precision! This action, casual game blends goofy fun with real skill challenges! Tap to launch your sausage with a perfect flip! Launch the sausage on the vine and keep moving to the next pot or shelf, etc. Use your perfect skills to master each tricky obstacle. Cross the finish line to win.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Cute",
      "Funny",
      "jump"
    ],
    "thumbnail": "https://img.gamemonetize.com/7wy770uggn81toy38j8u1mlsl18dsxdv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7wy770uggn81toy38j8u1mlsl18dsxdv/",
    "sourceUrl": "https://html5.gamemonetize.com/7wy770uggn81toy38j8u1mlsl18dsxdv/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69776",
    "slug": "eastern-star-vs-city-style-icon",
    "title": "Eastern Star vs City Style Icon",
    "description": "Welcome to the world of style, where the ancient palaces of the East meet the splendor of a modern metropolis! Two beautiful heroines are waiting for you in the game: an oriental beauty with exquisite outfits in the style of an Ottoman fairy tale and a stylish urban fashionista conquering the catwalks of the metropolis. During the game, you will become a fashion stylist and create unique looks for each of the girls. Choose your side in the cultural dispute and make this choice a reality!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Hair",
      "Makeover",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/g682jdzxjp4xdg2ivpgq8kx69gbgzf9j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g682jdzxjp4xdg2ivpgq8kx69gbgzf9j/",
    "sourceUrl": "https://html5.gamemonetize.com/g682jdzxjp4xdg2ivpgq8kx69gbgzf9j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69767",
    "slug": "mr-hero",
    "title": "Mr Hero",
    "description": "With great power comes great fun! Defeat deadly enemies with the powers of a super hero. Lift, burn, freeze opponents who try to get in your way. No one will stop you from obtaining justice. Your team of heroes are here to save the day.",
    "instructions": "Use the mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Action",
      "amazing",
      "Fighting",
      "free html5 games for your website",
      "Interactive",
      "kiz10",
      "Punch",
      "Puzzle",
      "Stickman",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/f14jllbvqp7oi6z65ky8xwwpheukce0n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f14jllbvqp7oi6z65ky8xwwpheukce0n/",
    "sourceUrl": "https://html5.gamemonetize.com/f14jllbvqp7oi6z65ky8xwwpheukce0n/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68771",
    "slug": "drag-race-x",
    "title": "Drag Race X",
    "description": "Drag Race X is an adrenaline-pumping racing game where you test your skills on high-speed straight tracks. Game Features: Fast-paced 3D drag racing with realistic graphics. Daily challenges and global tournaments. Smooth controls for all types of players. Immersive sound and visual effects for maximum thrill. Do you have what it takes to become the ultimate Drag Race X champion",
    "instructions": "Mouse click or tap to play use vitesse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "Car",
      "monstertruck",
      "Motocross",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/wu16paev51m4jnlhvv7wsvl7tjixwl7t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wu16paev51m4jnlhvv7wsvl7tjixwl7t/",
    "sourceUrl": "https://html5.gamemonetize.com/wu16paev51m4jnlhvv7wsvl7tjixwl7t/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69796",
    "slug": "sprunki-whooo",
    "title": "Sprunki Whooo",
    "description": "Face the funniest card puzzle ever in Sprunki Whooo. Together with the adorable Sprunki characters, youll figure out the right answer in a deck full of surprises! Choose a character as your target. Each round presents a weird or funny question. Constantly ask each other about the characteristics of the target and eliminate all the wrong ones. Finally, identify the target and arrest him. Win rounds to unlock more Sprunki cards and characters!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Card",
      "Funny",
      "Guessing",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/xxkc0bk3njhxvvygmj07qcxip2hj9vco/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xxkc0bk3njhxvvygmj07qcxip2hj9vco/",
    "sourceUrl": "https://html5.gamemonetize.com/xxkc0bk3njhxvvygmj07qcxip2hj9vco/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69758",
    "slug": "duo-adventures-legacy-of-traps",
    "title": "Duo Adventures (Legacy of Traps)",
    "description": "This game was made by me and my friends (Vinh) :&gt; (Design,story and coding...) If you enjoyed it, please leave a comment or support us by donating!!! Your support really motivates me and my friends to keep making games! Thank you so much for playing! ################################################################# About the Game This is a HARDCORE PUZZLE ADVENTURE GAME. Note: The game is designed for 2 players. You can play solo, but it might be pretty challenging!",
    "instructions": "Player 1 WASD Player 2 Arrow Keys Goal Collect enough coins and head to the door to escape",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2025 games",
      "Adventure",
      "Multiplayer",
      "Pixel",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tnnrxj2pgv9mu60upaq4p1dw6s4xoch7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tnnrxj2pgv9mu60upaq4p1dw6s4xoch7/",
    "sourceUrl": "https://html5.gamemonetize.com/tnnrxj2pgv9mu60upaq4p1dw6s4xoch7/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69723",
    "slug": "merge-animals-game",
    "title": "Merge Animals game",
    "description": "Merge Animals is a very simple but addictive game where you have to touch 2 identical objects together to make them explode and go to the next level",
    "instructions": "Click or drag and drop animals anywhere on the screen to drop them on top of the animals of the same type and earn points 2 animals of the same type merge and turn into a bigger fruit in the position where they collide so you can blast the bears the bi",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "amazing",
      "Animal",
      "Kid",
      "Kids",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/8n6gt5cajbz23op0fmac6n7qy686dgvm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8n6gt5cajbz23op0fmac6n7qy686dgvm/",
    "sourceUrl": "https://html5.gamemonetize.com/8n6gt5cajbz23op0fmac6n7qy686dgvm/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68800",
    "slug": "alien-clicker-invaders",
    "title": "Alien Clicker Invaders",
    "description": "Alien Clicker Invaders is a thrilling action and reflex game where you face endless waves of alien invaders! Get ready to click like crazy as you defend Earth against enemy hordes and colossal bosses that will test your skills. Collect powerful power-ups, unlock upgrades, and evolve your attack strength to survive each new wave of destruction! Play alone or share your mission to protect the Earth with a friend playing on a mobile device!",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2 Player",
      "2D",
      "Action",
      "Alien",
      "attack",
      "Clicker",
      "HTML",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/6b7ug211k0d8bv11s05fyb8qhm2hpaei/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6b7ug211k0d8bv11s05fyb8qhm2hpaei/",
    "sourceUrl": "https://html5.gamemonetize.com/6b7ug211k0d8bv11s05fyb8qhm2hpaei/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69601",
    "slug": "back-to-school-uniforms-edition",
    "title": "Back To School: Uniforms Edition",
    "description": "Explore global fashion in Back to School: Uniforms Edition! This fun dress-up game lets you spin the wheel to unlock school uniforms from countries like Japan, the U.S., the U.K., India, France, and South Korea. Customize your character with stylish outfits, accessories, and hairstyles inspired by each culture. Dive into the diversity of school uniforms and become a fashion expert while having fun! Discover all seven uniform styles featured in this online dress-up game for girls and find your favorite. Have a blast!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Princess",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/szj6wq3b07je7xnpqqrjko1no0qftqlf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/szj6wq3b07je7xnpqqrjko1no0qftqlf/",
    "sourceUrl": "https://html5.gamemonetize.com/szj6wq3b07je7xnpqqrjko1no0qftqlf/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69744",
    "slug": "get-off-my-farm",
    "title": "Get Off My Farm!",
    "description": "Protect your farm from relentless waves of mutant pests in this action-packed defense shooter! Your quiet farmland is swarmed by strange and dangerous creatures, and only your guns and quick reflexes can keep them away from your crops. Blast through incoming enemies and pick up temporary power-ups along the way &mdash; rapid-fire shots, explosive ammo, health refills, or extra energy for your electric fence. Survive enough waves and the stage ends, giving you a choice of random upgrades: unlock new weapons, call in a crop duster airstrike, slow down enemy hordes, attract power-ups with a magnet, and more.",
    "instructions": "Mobile Touch Swipe the screen Keyboard Arrows WASD and Space",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Action",
      "Defense",
      "Shoot",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/cwn6tqn4opyneil8sxmp4qbg42l8rlo6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cwn6tqn4opyneil8sxmp4qbg42l8rlo6/",
    "sourceUrl": "https://html5.gamemonetize.com/cwn6tqn4opyneil8sxmp4qbg42l8rlo6/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69688",
    "slug": "sprunki-squid-gaming",
    "title": "Sprunki Squid Gaming",
    "description": "In Squid Gaming, you must survive. Compete with your friend &mdash; first, make it through the Green Light, Red Light game alive, and then beat your friend in the tug-of-war game. Remember, you have to reach the end of the game before time runs out. After that, challenge your friend again in the next game, where the best tug-of-war player wins before time runs out. A short but fun competitive game you can play with your friend. Play in two different modes with your friend and celebrate the winner.",
    "instructions": "Use the A and P keys to move Playable on both mobile and PC 2 different short game modes",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arcade",
      "Platform",
      "squid",
      "squidgame"
    ],
    "thumbnail": "https://img.gamemonetize.com/pc5586s7x4eulp51t056uhh938u7j2f3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pc5586s7x4eulp51t056uhh938u7j2f3/",
    "sourceUrl": "https://html5.gamemonetize.com/pc5586s7x4eulp51t056uhh938u7j2f3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69517",
    "slug": "tapsync-blocks",
    "title": "TapSync Blocks",
    "description": "Get ready to test your timing and reflexes in TapSync Blocks! In this vibrant arcade challenge, your goal is to tap at just the right moment to match the moving color with the central block. Each correct match earns you points, but a single wrong move costs you a life. With only 3 lives per round, precision is key! As the game speeds up, can you keep your cool and maintain perfect sync?",
    "instructions": "Click at the time where matching block is around",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Best Games",
      "Block",
      "blocky"
    ],
    "thumbnail": "https://img.gamemonetize.com/pjwf8fp0lxhw1jhe7fv2sv13dfkw2c48/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pjwf8fp0lxhw1jhe7fv2sv13dfkw2c48/",
    "sourceUrl": "https://html5.gamemonetize.com/pjwf8fp0lxhw1jhe7fv2sv13dfkw2c48/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68557",
    "slug": "veggie-slice",
    "title": "Veggie Slice",
    "description": "Veggie Slice is an arcade slicing game where you slice vegetables with precision and avoid deadly dynamites. Earn high scores by chaining perfect combos. The game features endless mode with progressive difficulty, combo bonuses, and special veggies that boost your score. Miss three veggies, and it&rsquo;s game over! With colorful visuals and smooth mouse or touch controls, its a fun challenge for all ages on both desktop and mobile.",
    "instructions": "Mouse Click and drag Touch Swipe to slice",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Casual",
      "Classic",
      "cut",
      "free games for your site",
      "Games",
      "Highscore",
      "HTML",
      "Slicing",
      "slide",
      "touchscreen",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/4mod1gaaufo1g81rqaccjz3mj3osgbc9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4mod1gaaufo1g81rqaccjz3mj3osgbc9/",
    "sourceUrl": "https://html5.gamemonetize.com/4mod1gaaufo1g81rqaccjz3mj3osgbc9/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "69191",
    "slug": "click-crates",
    "title": "Click_Crates",
    "description": "Step into the action in this fun and fast-paced 3D skill game! Your goal is simple: tap and destroy the crates before they disappear &mdash; but stay sharp, the difficulty increases as you go! Test your reflexes across 3 difficulty levels: Easy, Normal, and Hard Improve your focus and reaction time Compete for the best score &mdash; can you beat your high score? Optimized for desktop and mobile WebGL play Includes dynamic sound effects for better experience Perfect for casual players who love a challenge. Try it now and see how far you can go",
    "instructions": "Mouse Click ndash Destroy crates Menu Navigation ndash Use mouse to select difficulty retry or navigate menus Works on Desktop WebGL",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/sgoboj8o1ufl00addofq88qwakc5hxa7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sgoboj8o1ufl00addofq88qwakc5hxa7/",
    "sourceUrl": "https://html5.gamemonetize.com/sgoboj8o1ufl00addofq88qwakc5hxa7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69233",
    "slug": "water-sort-legend",
    "title": "Water Sort Legend",
    "description": "Water Sort Legend is a brain-teasing puzzle game with a twist of fun, coins, and challenge! Sort colored water into the right tubes &mdash; test your logic, improve your IQ, and unlock new levels as you go! With over 150 handcrafted levels across Easy, Medium, and Hard difficulties, players will never run out of puzzles to solve. Features: Level Unlock System &ndash; Beat a level to unlock the next! IQ Estimator &ndash; Get a smartness score based on your moves! Coins &amp; Currency System &ndash; Earn coins for every win. Upgrade Shop &ndash; Spend coins on helpful boosters: Extra Tube Coin Booster Color Helper Sound FX &ndash; Clean sounds",
    "instructions": "Desktop Click on a tube to select it Click on another tube to pour the water if allowed Use your mouse to play ndash no keyboard needed Mobile Tap on a tube to select Tap on another tube to pour water Fully optimized for touch controls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D"
    ],
    "thumbnail": "https://img.gamemonetize.com/8o2djq26yo34ft65w3ue5teuyavvltfj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8o2djq26yo34ft65w3ue5teuyavvltfj/",
    "sourceUrl": "https://html5.gamemonetize.com/8o2djq26yo34ft65w3ue5teuyavvltfj/",
    "width": 400,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69309",
    "slug": "cosmic-clicker",
    "title": "Cosmic Clicker",
    "description": "Cosmic Clicker is a highly engaging and monetizable idle clicker game set in a vibrant, stylized cosmos. The core loop is simple and addictive: click celestial objects to earn points, spend them on strategic upgrades, and watch your score soar into the trillions. With deep progression systems including missions, achievements, permanent upgrades, and a prestige Rebirth mechanic, the game is built for long-term player retention.",
    "instructions": "Mouse",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Click",
      "Clicker",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/tf0cmqoj5s9s26jxbydpmjm3to76pncz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tf0cmqoj5s9s26jxbydpmjm3to76pncz/",
    "sourceUrl": "https://html5.gamemonetize.com/tf0cmqoj5s9s26jxbydpmjm3to76pncz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69710",
    "slug": "pop-the-bubbles-relaxing",
    "title": "Pop the Bubbles: Relaxing",
    "description": "A simple and captivating game designed to help you unwind and escape the daily hustle. Pop colorful bubbles to soothing music and enjoy beautiful visuals. Perfect for stress relief and relaxation, with endless levels and a calming vibe. Minimal effort, maximum enjoyment &ndash; the ideal way to relax. Launch now and immerse yourself in a world of tranquility and fun!",
    "instructions": "Find groups of bubbles of the same color Press 2 times to pop The more bubbles pop at a time the more points",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "amazing",
      "Best Games",
      "Bubble",
      "Bubble Shooter",
      "Casual",
      "endless",
      "free html5 games for your website",
      "html games for your website",
      "Match-3",
      "Match3",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/s7e6xmuq8kwidnku964f8072hflua90i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s7e6xmuq8kwidnku964f8072hflua90i/",
    "sourceUrl": "https://html5.gamemonetize.com/s7e6xmuq8kwidnku964f8072hflua90i/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69680",
    "slug": "linking-battle",
    "title": "Linking Battle",
    "description": "You are a wizard. You will beat your enemies by linking elements in your brain. When 3 or more elements are linked, you can release your power. Hope you enjoy your trip.",
    "instructions": "Mouse",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "Battle"
    ],
    "thumbnail": "https://img.gamemonetize.com/fcfnevvapkiuo9ymwzi2jtw5ahlez8re/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fcfnevvapkiuo9ymwzi2jtw5ahlez8re/",
    "sourceUrl": "https://html5.gamemonetize.com/fcfnevvapkiuo9ymwzi2jtw5ahlez8re/",
    "width": 360,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "69129",
    "slug": "pretty-sheep-run",
    "title": "Pretty Sheep Run",
    "description": "Play a fun arcade game in Pretty Sheep Run. You guide an adorable little sheep dashing across endless platforms. Keep your sheep running while cleverly avoiding dangerous traps. Control your sheep running to shoot different numbered doors. Change the numbers into positive numbers. Thus increasing the guns DMG, ATK SPD, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Avoid",
      "dash",
      "running",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/npaw28olimvi5tsbxsx49kpov6yldq3f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/npaw28olimvi5tsbxsx49kpov6yldq3f/",
    "sourceUrl": "https://html5.gamemonetize.com/npaw28olimvi5tsbxsx49kpov6yldq3f/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69726",
    "slug": "brainrot-jet-ski-racing",
    "title": "Brainrot Jet Ski Racing",
    "description": "Brainrot Jet Ski Racing is a fast paced, meme fueled racing game where iconic Brainrot characters battle it out on jet skis. Race across a chaotic water track, hit checkpoints, dodge obstacles, and aim for first place while enjoying over-the-top visuals and sound effects. Master the waves, time your boosts, and prove you&rsquo;re the ultimate Brainrot jet ski champion.",
    "instructions": "WASD or Arrow keys to move",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "jetski",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/q1rhn9oouokiujejarumihyal58tpbp0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q1rhn9oouokiujejarumihyal58tpbp0/",
    "sourceUrl": "https://html5.gamemonetize.com/q1rhn9oouokiujejarumihyal58tpbp0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69733",
    "slug": "ultra-realistic-blockcraft",
    "title": "Ultra Realistic BlockCraft",
    "description": "Help Steve in the ultra-realistic block world and make sure he reaches the portal. Remember, this realistic world is extremely challenging and monsters are roaming everywhere. You must collect all the diamonds. While collecting diamonds, don&rsquo;t forget to open the chests you find along the way. Open the chests and crush all the monsters. Reach the portal at the end of the level safely to complete the stage. Remember, you only have one life and if it runs out you will lose everything you&rsquo;ve earned.",
    "instructions": "If your life runs out your progress in the game will be erased so you must play very carefully Use the ldquo WASD rdquo keys to play Jump on top of the monsters to crush them Find all the diamonds and chests and reach the end of the level",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "mineblock",
      "Minecraft",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/6r0a1ijsnmzzj7xtup7fa2y5yg9hgr7k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6r0a1ijsnmzzj7xtup7fa2y5yg9hgr7k/",
    "sourceUrl": "https://html5.gamemonetize.com/6r0a1ijsnmzzj7xtup7fa2y5yg9hgr7k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69727",
    "slug": "mission-kill-italian-brainrot",
    "title": "Mission Kill Italian Brainrot",
    "description": "Hello warrior, help Tung Tung and defeat all the incoming enemies. There are enemies everywhere so you must be very careful. Destroy the enemies and find all the chests. You need to find and open all the chests. Open all the chests and collect the money inside. You must collect all the money dropped by the enemies. Gather the money and complete the level. In each level you will face stronger enemies, so you need to be even more careful. Save up money and buy different weapons.",
    "instructions": "Use the WASD keys to move Use the mouse to shoot Eliminate all enemies and collect all the gold to move to the next level 4 different game modes with 4 different difficulty levels rdquo",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Action",
      "attack",
      "Battle",
      "Brainrot Italian",
      "Italian Brainrot",
      "survival",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/nb0lo74rxsor1etgta1c6md890erfct8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nb0lo74rxsor1etgta1c6md890erfct8/",
    "sourceUrl": "https://html5.gamemonetize.com/nb0lo74rxsor1etgta1c6md890erfct8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68157",
    "slug": "screw-nuts-bolts-wood-solve",
    "title": "Screw Nuts Bolts: Wood Solve",
    "description": "Embark on a Brain-Twisting Journey with Nuts and Bolts Woody Puzzle, an exceptional wood puzzle game about nuts and bolts to test your IQ brain power. For nuts and bolts lovers who likes challenge and innovative gameplay, the right game for you - the ultimate puzzle game - is here.",
    "instructions": "Start by tapping to remove nuts and bolts making the wood plates pinned to the board to cascade The complexity of the nuts and bolts within this puzzle game will test your wit Navigate the nuts and bolts correctly ensuring all wood plates fall This",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/q16vzo4tomyxw5uumsfrh1a7icct2iu0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q16vzo4tomyxw5uumsfrh1a7icct2iu0/",
    "sourceUrl": "https://html5.gamemonetize.com/q16vzo4tomyxw5uumsfrh1a7icct2iu0/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "64277",
    "slug": "burger-rush-restaurant",
    "title": "Burger Rush Restaurant",
    "description": "Welcome to your burger paradise! Dive into the sizzling world of restaurant management where every burger tells a story. Craft mouthwatering creations from a diverse range of ingredients, meeting each customers unique taste buds. Serve fast, combine cleverly, and watch your tiny burger joint grow into the town&rsquo;s favorite spot for delicious burgers. Your burger mastery starts now!",
    "instructions": "Touch Click the ingredients to make a burger and click the customer to serve it",
    "category": "Cooking",
    "genres": [
      "Cooking"
    ],
    "tags": [
      "Arcade",
      "Cook",
      "Cooking",
      "Restaurant"
    ],
    "thumbnail": "https://img.gamemonetize.com/zsn8chm3hmle88thmv96ok6ch9o0eifw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zsn8chm3hmle88thmv96ok6ch9o0eifw/",
    "sourceUrl": "https://html5.gamemonetize.com/zsn8chm3hmle88thmv96ok6ch9o0eifw/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68573",
    "slug": "bubble-popper",
    "title": "Bubble Popper",
    "description": "Pop colorful bubbles to clear each level! Click or tap bubbles to make them disappear - smaller bubbles give more points, so aim carefully. Clear all bubbles to advance to the next level, where youll face more bubbles moving faster. Challenge yourself to achieve the highest score in this addictive arcade game perfect for quick gaming sessions!",
    "instructions": "Click or tap the bubbles to pop them",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/myz6019w82b5q1121jomhtfm0dyhut5r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/myz6019w82b5q1121jomhtfm0dyhut5r/",
    "sourceUrl": "https://html5.gamemonetize.com/myz6019w82b5q1121jomhtfm0dyhut5r/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69519",
    "slug": "sharpshot-trials",
    "title": "Sharpshot Trials",
    "description": "Step into the world of precision and power in Sharpshot Trials! This arrow-throwing challenge puts your aim to the test across a variety of dynamic scenarios. From moving targets to tricky angles, each level demands focus, timing, and a steady hand. With every accurate shot, you climb higher in skill and score &mdash; but miss your mark, and the trial gets tougher. Are you ready to prove your mastery as the ultimate sharpshooter?",
    "instructions": "Aim and shoot",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "arrow",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/406nooocmwif8bd3pm20vqdmn4b8wobj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/406nooocmwif8bd3pm20vqdmn4b8wobj/",
    "sourceUrl": "https://html5.gamemonetize.com/406nooocmwif8bd3pm20vqdmn4b8wobj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69734",
    "slug": "brainrot-a-difference-challenge",
    "title": "Brainrot A Difference Challenge",
    "description": "Put your observation skills to the test in Brainrot &ndash; A Difference Challenge, the ultimate photo puzzle game! Spot subtle differences between two eerily similar Italian brainrot images across a series of mind-bending levels. Each pair of pictures will challenge your focus, attention to detail, and visual memory. Can you find them all before time runs out?",
    "instructions": "Use a mouse or touch pad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brainrot Italian",
      "Difference",
      "html games for your website",
      "Kids",
      "Mobile",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/3rhhry4fhz3xu10bpj2w5drqgbq0c55f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3rhhry4fhz3xu10bpj2w5drqgbq0c55f/",
    "sourceUrl": "https://html5.gamemonetize.com/3rhhry4fhz3xu10bpj2w5drqgbq0c55f/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "69099",
    "slug": "flappy-climate",
    "title": "flappy climate",
    "description": "The game is Flappy weather, you can play the flappy bird liked games , so this game also so fun and especially this game as one new thing is if you can hit the obstacles you can continue the game up to 3 lives . when the score is 10 greater the climate effects also changed. so much fun and addictive game . Thanking you.",
    "instructions": "In windows use mouse left click and android devices touch controls",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/dt780txhz9ncslrwuvqpyrbeit30ei9k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dt780txhz9ncslrwuvqpyrbeit30ei9k/",
    "sourceUrl": "https://html5.gamemonetize.com/dt780txhz9ncslrwuvqpyrbeit30ei9k/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69618",
    "slug": "tung-tung-sahur-in-geometry-dash",
    "title": "Tung Tung Sahur in Geometry Dash",
    "description": "Join Tung Tung Sahur, the wooden drum-carrying dawn caller, as he bounces and flips through a neon cityscape just before sunrise! Dodge spikes, leap over traps, and time your jumps to the beat of his signature &ldquo;tung-tung!&rdquo; calls. In this Geometry Dash&ndash;inspired challenge, the streets are alive with glowing gates, speed pads, and tricky gravity flips. Can you drum your way to the end without missing a beat?",
    "instructions": "mouse only",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Brainrot sahuuur",
      "dash",
      "Geometry",
      "Italian Brainrot",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/xpdem6m773wts2kyi1f3j2wusxe6743o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xpdem6m773wts2kyi1f3j2wusxe6743o/",
    "sourceUrl": "https://html5.gamemonetize.com/xpdem6m773wts2kyi1f3j2wusxe6743o/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69266",
    "slug": "dead-zone15165",
    "title": "Dead Zone15165",
    "description": "Dead Zone is a lightweight 2D zombie shooter designed for instant browser play. Players control a lone survivor in a cartoon-style world, dodging and shooting waves of undead with simple one-button mechanics. Built for fast reflexes and short sessions, Dead Zone runs smoothly even on low-end devices .",
    "instructions": "Controls Move WASD or ZQSD Shoot Left Click Shift run Reload R Pause P Restart I Recover mouse control Tab if the mouse gets stuck",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "survival",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/awku83ardtmr5fs8p5miwb29n518zh4k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/awku83ardtmr5fs8p5miwb29n518zh4k/",
    "sourceUrl": "https://html5.gamemonetize.com/awku83ardtmr5fs8p5miwb29n518zh4k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69422",
    "slug": "goal-io",
    "title": "Goal.io",
    "description": "Goal.io &ndash; Score Big in This Free Football IO Game Online Looking for a fast-paced soccer game you can play right in your browser? Meet Goal.io &mdash; the ultimate free football io game online where reflexes, timing, and sharp shooting decide who rules the leaderboard. No downloads. No sign-ups. Just you, the ball, and 3 minutes to score big.",
    "instructions": "WADS to move",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      ".io Games",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/vjyl8p9lma7kpn58wh0syqkj6ph28clp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vjyl8p9lma7kpn58wh0syqkj6ph28clp/",
    "sourceUrl": "https://html5.gamemonetize.com/vjyl8p9lma7kpn58wh0syqkj6ph28clp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69683",
    "slug": "buddy-kick-archer",
    "title": "Buddy Kick Archer",
    "description": "Buddy Kick Archer is a fun and fast-paced archery challenge where you aim, shoot, and defeat quirky enemies with precision shots. Test your bow skills, unlock powerful arrows, and take down targets in creative ways. Perfect for players who love skill-based action mixed with humor and endless challenges in each level.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "free html5 games for your website",
      "Fun",
      "Funny",
      "Kids",
      "Kill",
      "kiz10",
      "Shooting",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/yhrb03lzm5viyx80fucyw85ppapumvwk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yhrb03lzm5viyx80fucyw85ppapumvwk/",
    "sourceUrl": "https://html5.gamemonetize.com/yhrb03lzm5viyx80fucyw85ppapumvwk/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69363",
    "slug": "rgb-shooter",
    "title": "RGB Shooter",
    "description": "RGB Shooter is a fast-paced 2D action shooting game where color-matching meets arcade chaos! Switch between red, green, and blue bullets to destroy enemies of the same color. Use your reflexes to survive endless waves of colorful attackers. As you level up, the game becomes faster and more challenging. Activate your Ulti ability to fire random-colored bullets and turn the tide of battle when things get intense. Simple controls, vibrant visuals, and addictive gameplay make RGB Shooter a perfect experience for action and arcade fans!",
    "instructions": "A ndash Krmz mermiyle ate et S ndash Yeil mermiyle ate et D ndash Mavi mermiyle ate et W ndash Ultiyi Aktif Et rastgele renkli mermi atar Bu kontroller ekrandaki butonlara tklanarak da kullanlabilir",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arena",
      "Battle",
      "Color"
    ],
    "thumbnail": "https://img.gamemonetize.com/p0ata23ta267p4z5rp8ejs84o7gxklri/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p0ata23ta267p4z5rp8ejs84o7gxklri/",
    "sourceUrl": "https://html5.gamemonetize.com/p0ata23ta267p4z5rp8ejs84o7gxklri/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69518",
    "slug": "bricks-of-wrath",
    "title": "Bricks of Wrath",
    "description": "Unleash chaos in Bricks of Wrath &mdash; a break-brick game with a fierce twist! Fire powerful shots to destroy the advancing wall of bricks, but stay alert &mdash; these aren&rsquo;t ordinary bricks. Once attacked, they strike back! Dodge incoming fire, time your shots, and survive the relentless onslaught. With every level, the challenge intensifies. It&rsquo;s not just about breaking bricks &mdash; it&rsquo;s about outlasting their wrath. How long can you hold your ground?",
    "instructions": "Shoot and avoid getting shot by the enemy",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "blocky",
      "Bullet",
      "Shoot 'Em Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/lad82v5dqpbwy41w28bble9t103wscl5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lad82v5dqpbwy41w28bble9t103wscl5/",
    "sourceUrl": "https://html5.gamemonetize.com/lad82v5dqpbwy41w28bble9t103wscl5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69522",
    "slug": "choco-draw",
    "title": "Choco Draw",
    "description": "Welcome to Choco Draw, the sweetest twist on classic card games! In this candy-themed challenge, each card is marked with delicious treats &mdash; from gummies and lollipops to chocolate bars and bonbons. Match, draw, and strategize your way through sugary showdowns where luck meets logic. Whether youre collecting sets or bluffing your way to victory, every draw is a bite-sized surprise. Ready to outsmart your opponents in this candy-coated card game?",
    "instructions": "Poker Game Enjoy",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Candy",
      "Card",
      "Poker"
    ],
    "thumbnail": "https://img.gamemonetize.com/7wu7my5w4k695l3ypricyoziy5mf6kyp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7wu7my5w4k695l3ypricyoziy5mf6kyp/",
    "sourceUrl": "https://html5.gamemonetize.com/7wu7my5w4k695l3ypricyoziy5mf6kyp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69630",
    "slug": "btc-clicker",
    "title": "BTC clicker",
    "description": "Click the Bitcoin and do upgrades like autoclicker and Bitcoin per click, and you have achievements like getting 100 Bitcoin , so what are you waiting for? Start clicking! :D",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Click",
      "Clicker",
      "idle"
    ],
    "thumbnail": "https://img.gamemonetize.com/aiht7jx9eiy1uvttc053mzub9cx1zzg4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aiht7jx9eiy1uvttc053mzub9cx1zzg4/",
    "sourceUrl": "https://html5.gamemonetize.com/aiht7jx9eiy1uvttc053mzub9cx1zzg4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69631",
    "slug": "ghostrick-the-sacred-war",
    "title": "GhosTrick The Sacred War",
    "description": "Game Overview Players can choose to play against the computer (P1 vs CPU) or against another player (P1 vs P2). The game revolves around capturing each others pieces. However, not all pieces can be captured&mdash;some must not be taken. Additionally, certain pieces have special roles or ranks. The victory conditions are as follows: Force your opponent to capture all of your forbidden-to-capture pieces. Capture a set number of the opponent&rsquo;s valid targets. Successfully guide a specific number of your own pieces to the designated escape points.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/lo04qoqpa8lx8340ezn2ftje86vt74qp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lo04qoqpa8lx8340ezn2ftje86vt74qp/",
    "sourceUrl": "https://html5.gamemonetize.com/lo04qoqpa8lx8340ezn2ftje86vt74qp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69678",
    "slug": "gun-match-screw",
    "title": "Gun Match Screw",
    "description": "Gun Match Screw is a unique level-based puzzle game that combines screw puzzles with exciting gun-themed mechanics. In this game, each level presents you with a board shaped like different guns or gun parts, and your goal is to unlock all the boards by matching colored screws, which are represented as bullets. Gameplay: Each board contains a set of colored screws (bullets) that need to be matched to unlock the panels. The game features two modes where you fill 6-slot bullet magazines. By matching screws of the same color, youll fill the magazine and exchange it for a new empty one. You also have 5 extra bullet slots to store unmatched bu",
    "instructions": "Use left mouse button to play the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Gun",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/w0uhn2ohy7yjt4qm1jqhwrnyhpq4uydx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w0uhn2ohy7yjt4qm1jqhwrnyhpq4uydx/",
    "sourceUrl": "https://html5.gamemonetize.com/w0uhn2ohy7yjt4qm1jqhwrnyhpq4uydx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69649",
    "slug": "minesweeper-infinite",
    "title": "Minesweeper Infinite",
    "description": "&ldquo;Minesweeper Infinite&rdquo; is a classic logic game with the addition of a new endless field mode! Now you have the opportunity to open cages and mine as much as you want. Overcome obstacles, compete with players from all over the world and take high positions on the leaderboard, showing everyone your unsurpassed strategy and ingenuity. Thanks to the simple and intuitive controls, everyone will be able to join this exciting process and test their strength in solving complex puzzles. Enjoy the pleasant design and stunning graphics and become a true professional in the world of &ldquo;Minesweeper Infinite&rdquo;!",
    "instructions": "1 Select the mode Classic Endless 2 To open a cell click on it if there is a mine the game is over To find a mine use hints in the form of numbers of cells around for example if the number 1 is indicated in an open cell this means that one of t",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2025 games",
      "2D",
      "Best",
      "Best Games",
      "Bomb",
      "games for your website",
      "HTML5",
      "Mine",
      "Miner"
    ],
    "thumbnail": "https://img.gamemonetize.com/hy3hr7kh0ck0ty3rw75i4kuwa0dq4xws/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hy3hr7kh0ck0ty3rw75i4kuwa0dq4xws/",
    "sourceUrl": "https://html5.gamemonetize.com/hy3hr7kh0ck0ty3rw75i4kuwa0dq4xws/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69681",
    "slug": "elvis-funny-face",
    "title": "Elvis Funny Face",
    "description": "Elvis Funny Face is super fun and free to play online game for kids. Make the funniest face of our Elvis and have fun!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boys",
      "Celebrity",
      "Fun",
      "Funny",
      "Girls",
      "Hypercasual",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/9oqx32oi2ygzyru8b88na4d069vq9ihv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9oqx32oi2ygzyru8b88na4d069vq9ihv/",
    "sourceUrl": "https://html5.gamemonetize.com/9oqx32oi2ygzyru8b88na4d069vq9ihv/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69648",
    "slug": "apple-worm-2",
    "title": "Apple Worm 2",
    "description": "Play Apple Worm now. This is a classic puzzle game with simple operation. Brain-burning levels make you love it! Control a cute little worm whose goal is to eat the apple and upgrade. Upgrading allows you to unlock more cute skins. You can also earn rewards by completing challenges. Unlock Auto ATK, Summoning, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Brain",
      "Classic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/pnqinh9qlg6fnsvf7qzvten219lj5q1a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pnqinh9qlg6fnsvf7qzvten219lj5q1a/",
    "sourceUrl": "https://html5.gamemonetize.com/pnqinh9qlg6fnsvf7qzvten219lj5q1a/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68968",
    "slug": "wednesday-light-academia",
    "title": "Wednesday Light Academia",
    "description": "Join the trend in Wednesday Light Academia - a fun, immersive makeover game for girls! Today youre becoming a super-talented stylist and your job is to transform Wednesday Addams from a dark e-girl look to a stunning girly-girl fashionista. Explore the fun realms of makeup, hairstyling, and fashion-forward wardrobe choices with this addictive game. Have fun!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "beauty",
      "Casual",
      "Dress Up",
      "Fashion",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/fx8tewjdap559x6osw9t2d9hogs8y7gs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fx8tewjdap559x6osw9t2d9hogs8y7gs/",
    "sourceUrl": "https://html5.gamemonetize.com/fx8tewjdap559x6osw9t2d9hogs8y7gs/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68946",
    "slug": "lafufu-typer",
    "title": "Lafufu Typer",
    "description": "Your goal is to quickly match the correct letters of the colorful and chaotic Lafufus before they reach the barrier and break through your defenses, ending the game and your progress.",
    "instructions": "Use keyboard or touch to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "2D",
      "amazing",
      "Casual",
      "Color",
      "Cute",
      "Fun",
      "Funny",
      "HTML",
      "html5 games for your site",
      "Hypercasual",
      "Kids",
      "Labubu"
    ],
    "thumbnail": "https://img.gamemonetize.com/5mzwe1fglvuzmhbdmdi11mveaitby5p2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5mzwe1fglvuzmhbdmdi11mveaitby5p2/",
    "sourceUrl": "https://html5.gamemonetize.com/5mzwe1fglvuzmhbdmdi11mveaitby5p2/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69228",
    "slug": "cloneup-stack-yourself",
    "title": "CloneUp: Stack Yourself",
    "description": "CloneUp &ndash; Stack Yourself is a 2D pixel-art platformer where your greatest tool is&hellip; yourself! Create clones, stack them, and use them as platforms to dodge spikes, reach new heights, and make your way to the exit door. In CloneUp &ndash; Stack Yourself, you&rsquo;ll use copies of the main character to reach platforms and avoid deadly obstacles. For some unknown reason, you have the power to create clones of yourself and even stack them to form makeshift platforms. Use them to cross dangerous gaps, escape spikes, and climb higher toward the goal. Your mission: reach the exit door on each level, using your reflexes, logic, and clever clone placement.",
    "instructions": "- Move A D or larr rarr - Jump W uarr or Spacebar - Create Clone F Restart Level R Return to Menu P",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Hypercasual",
      "Logic",
      "Pixel",
      "Platform",
      "Side Scrolling"
    ],
    "thumbnail": "https://img.gamemonetize.com/2a16no4zh14v7ifrv6it71409v9hecyv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2a16no4zh14v7ifrv6it71409v9hecyv/",
    "sourceUrl": "https://html5.gamemonetize.com/2a16no4zh14v7ifrv6it71409v9hecyv/",
    "width": 1024,
    "height": 576,
    "lastUpdated": ""
  },
  {
    "id": "69139",
    "slug": "fireegg",
    "title": "FireEgg",
    "description": "Control the chicken to fire bullets, smashing obstacles from all directions. The more obstacles you smash, the more gold coins you will obtain. Gold coins can be used to upgrade the bullet firing frequency furnace, as well as the bullet damage and rotation frequency. Its very fun. Come and give it a try",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Best Games",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/hbw58xnuz792df7gv3ylf43gmn062qfg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hbw58xnuz792df7gv3ylf43gmn062qfg/",
    "sourceUrl": "https://html5.gamemonetize.com/hbw58xnuz792df7gv3ylf43gmn062qfg/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69489",
    "slug": "help-sprunky",
    "title": "Help sprunky",
    "description": "Get ready for an exciting and challenging challenge! This puzzle game will test your wits and attentiveness as you help the characters complete levels with mazes, solve problems and collect important items. Simple controls, high difficulty: Easy to play: Tap and hold the characters head, then pull to move. When you release, the head automatically returns to its starting position, creating a simple but tricky control mechanism. Mazes and traps: Each level has a confusing maze with obstacles and traps through which you need to guide your character to collect the desired item.",
    "instructions": "ap and hold the characters head with your finger on your phone or mouse on your PC Avoid the traps and collect the necessary item to complete the level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2D",
      "Casual",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/lwio2pev5vso9wejhv6tw1trpeo4nqti/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lwio2pev5vso9wejhv6tw1trpeo4nqti/",
    "sourceUrl": "https://html5.gamemonetize.com/lwio2pev5vso9wejhv6tw1trpeo4nqti/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69491",
    "slug": "monster-jeep-coloring",
    "title": "Monster Jeep Coloring",
    "description": "Monster Jeep Coloring is a playful online game made for kids who love creativity. Pick your favorite monster jeep image and bring it to life with your own colors. Once your masterpiece is ready, share it proudly with friends. Let your imagination run wild and enjoy the fun of coloring!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Car",
      "Coloring",
      "Creation",
      "Fun",
      "Hypercasual",
      "jeep",
      "Kids",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/9una69qdetv838um94tm0uttdl2rvj0j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9una69qdetv838um94tm0uttdl2rvj0j/",
    "sourceUrl": "https://html5.gamemonetize.com/9una69qdetv838um94tm0uttdl2rvj0j/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69625",
    "slug": "creep-crushers",
    "title": "Creep Crushers",
    "description": "Step into the spooky showdown of Creep Crusher! Halloween horrors are closing in, and your only defense is your lightning-fast clicking skills. Tap repeatedly to smash ghouls, banish ghosts, and squash creepy creatures before they get too close. Every enemy you crush keeps you safe a little longer, but as the night deepens, the creeps come faster and in greater numbers. Can you survive the haunting onslaught and become the ultimate Halloween hero?",
    "instructions": "Click on the pumpkins",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Clicker",
      "Halloween",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/6x1pqesk0qiiwk7z5k6v8t71v5w9cqo1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6x1pqesk0qiiwk7z5k6v8t71v5w9cqo1/",
    "sourceUrl": "https://html5.gamemonetize.com/6x1pqesk0qiiwk7z5k6v8t71v5w9cqo1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69485",
    "slug": "italian-brainrot-survival-arena",
    "title": "Italian Brainrot Survival Arena",
    "description": "Are you ready for the ultimate showdown between Trallero and Tung Tung Sahur? Yes, in a lava-filled cave &mdash; let&rsquo;s see who will win! The player who falls into the lava the most loses the game. You can push your friend. Push your friend and make them fall into the lava. Be very careful! Avoid falling into the lava at all costs. Remember, it&rsquo;s not just the danger of falling down &mdash; you also have to watch out for rocket missiles falling from the cave ceiling. If one of them hits you, you lose the game.",
    "instructions": "Use the WASD or Arrow keys to move Press S or the Down arrow key to push each other The player who falls into the lava the most or gets hit by a rocket loses the game Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arena",
      "Battle",
      "Brainrot Italian",
      "Italian Brainrot",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/lrvx72nbbm23sedsystwpoo2rwqwh647/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lrvx72nbbm23sedsystwpoo2rwqwh647/",
    "sourceUrl": "https://html5.gamemonetize.com/lrvx72nbbm23sedsystwpoo2rwqwh647/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69609",
    "slug": "end-charge-alpha",
    "title": "End Charge Alpha",
    "description": "A game where you are the last energy bearer in a completely vast and dull world, use your energy and try to save the world from darkness.",
    "instructions": "W - Jump D - Right A - Left Mouse Left - Shoot hook R - Restart",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/e4w8gz1m62kng5w16vlheikap1zh5ytt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e4w8gz1m62kng5w16vlheikap1zh5ytt/",
    "sourceUrl": "https://html5.gamemonetize.com/e4w8gz1m62kng5w16vlheikap1zh5ytt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68629",
    "slug": "whiskers-adventures",
    "title": "Whiskers Adventures",
    "description": "Whiskers Adventures is a fun mobile game offering exciting adventures as players control a clever cat through various levels filled with puzzles, obstacles, and rewards. With engaging gameplay and captivating environments, players explore new worlds and achieve goals while enjoying unique graphics and sound effects.",
    "instructions": "Mouse click or tap to play Q E rotate W A S D move",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Adventure",
      "Block",
      "Casual",
      "Game",
      "Games",
      "Puzzle",
      "puzzleblock",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/bpint3up514tv2bjxf4ve56qcweusk2h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bpint3up514tv2bjxf4ve56qcweusk2h/",
    "sourceUrl": "https://html5.gamemonetize.com/bpint3up514tv2bjxf4ve56qcweusk2h/",
    "width": 400,
    "height": 620,
    "lastUpdated": ""
  },
  {
    "id": "69462",
    "slug": "trallero-tung-tung-chicken",
    "title": "Trallero Tung Tung Chicken",
    "description": "Have you entered the world of farmers? You need to catch the chickens. Catch all the chickens and win the game. The first to collect 10 chickens wins. Choose one of the farmer characters, Trallero or Tung Sahur, and race against your friend to win. You can break wooden crates by jumping on them. Jump three times to break the crate and grab the chicken. Collect all the chickens before your friend. Bring the chickens to the coop as fast as you can.",
    "instructions": "Use the WASD and Arrow keys to move The player who collects 10 chickens and brings them to the coop wins the game Jump 3 times to break the wooden crates and get the chicken Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arcade",
      "Arena",
      "Battle",
      "Brainrot Italian",
      "Italian Brainrot",
      "Tralalero Tralala",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/tuj68izy7ybfqtdj42aeuvm4pmrz5c32/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tuj68izy7ybfqtdj42aeuvm4pmrz5c32/",
    "sourceUrl": "https://html5.gamemonetize.com/tuj68izy7ybfqtdj42aeuvm4pmrz5c32/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69464",
    "slug": "car-simulator-3d",
    "title": "Car Simulator 3D",
    "description": "Play **Car Simulator 3D**, an exciting 3D open-world car simulation game for Android and iOS! Explore the city, take on missions, race, and drive a variety of cool cars with realistic graphics. This game offers an exciting driving experience, from online multiplayer modes, car modifications, to exploring an unlimited free world. **Car Simulator 3D Features:** * Vast open world * Realistic 3D graphics &amp; easy controls",
    "instructions": "Controls W uarr Accelerate S darr Brake A larr Turn Left D rarr Turn Right ESC Pause Space Handbrake",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Baby",
      "Baby Games",
      "Balance",
      "Car",
      "Cars",
      "Cartoon",
      "Color",
      "drift",
      "drifting",
      "Driving",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/brxqmk9ejqx2rgurxhwcoz1s7f4u512r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/brxqmk9ejqx2rgurxhwcoz1s7f4u512r/",
    "sourceUrl": "https://html5.gamemonetize.com/brxqmk9ejqx2rgurxhwcoz1s7f4u512r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69596",
    "slug": "pixel-gun-apocalypse-2025",
    "title": "Pixel Gun Apocalypse 2025",
    "description": "Pixel Gun Apocalypse 2025 delivers intense block-style FPS action with modern weapons, diverse maps, and competitive multiplayer modes. Players can choose between SWAT and mercenaries, engage in fast-paced firefights, and master tactics for victory. Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a> .Updated graphics, smooth gameplay, and new maps make this edition a thrilling online shooting experience.",
    "instructions": "Mouse loog around wasd to walk",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2025 games",
      "Fun",
      "Gun",
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/gm9nnnxkzbwlhdaco2tkavec45pkk7b9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gm9nnnxkzbwlhdaco2tkavec45pkk7b9/",
    "sourceUrl": "https://html5.gamemonetize.com/gm9nnnxkzbwlhdaco2tkavec45pkk7b9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69524",
    "slug": "yolk-patrol",
    "title": "Yolk Patrol",
    "description": "Welcome to Yolk Patrol &mdash; the ultimate egg-saving mission! Eggs are falling fast from both sides, and its your job to catch them before they crack. Stay sharp, move swiftly, and don&rsquo;t let a single shell hit the ground. But be careful &mdash; only a few mistakes are allowed before your patrol ends. Can you keep every egg safe and prove youre the top yolk defender?",
    "instructions": "Click on either side of man to change direction of collecting eggs click 1 or 2 times",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Casual",
      "Chicken",
      "eggames"
    ],
    "thumbnail": "https://img.gamemonetize.com/yvpebzorujsljhc6w8b2mxj9x8xv88sb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yvpebzorujsljhc6w8b2mxj9x8xv88sb/",
    "sourceUrl": "https://html5.gamemonetize.com/yvpebzorujsljhc6w8b2mxj9x8xv88sb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69525",
    "slug": "geo-champs",
    "title": "Geo Champs",
    "description": "Get ready to shape up with Geo Champs! Designed for young learners aged 5 to 8, this fun and educational game helps kids recognize and identify basic geometric shapes in an interactive way. From circles and squares to triangles and more, children will boost their visual learning and shape recognition skills while playing through colorful levels. With cheerful visuals and simple gameplay, every young player can become a true geometry champion!",
    "instructions": "Guess the correct shape and click on the right option",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Educational",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/nnr25yqyuwd3z98628kjs07lmcwshs1n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nnr25yqyuwd3z98628kjs07lmcwshs1n/",
    "sourceUrl": "https://html5.gamemonetize.com/nnr25yqyuwd3z98628kjs07lmcwshs1n/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69562",
    "slug": "fish-merge",
    "title": "Fish Merge",
    "description": "Dive into the ultimate Fish Merge - Under Water! Experience the fun of merging colorful fish in addictive pattern. Enjoy relaxing underwater effects and soothing visuals as you combine similar items to unlock surprises and boost your score. Perfect for casual gamers of all ages, this game blends strategy, fun, and calming ocean vibes.",
    "instructions": "Merge Drag matching fish together to combine them Score Higher-level fish give more points and coins Unlock Keep merging to discover rare fish",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Casual",
      "Fish",
      "Hypercasual",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/3o02ka521te3s4pfsszkfdkdtp741reo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3o02ka521te3s4pfsszkfdkdtp741reo/",
    "sourceUrl": "https://html5.gamemonetize.com/3o02ka521te3s4pfsszkfdkdtp741reo/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69539",
    "slug": "marble-snap-color-puzzle-game",
    "title": "Marble Snap: Color Puzzle Game",
    "description": "Marble Snap is an addictive and relaxing logic puzzle game designed to test your brain and sharpen your thinking skills. Match, place, and arrange marbles on the board to solve each level. With smooth controls, colorful 3D graphics, and satisfying animations, every move feels rewarding. Challenge yourself through hundreds of mind-teasing levels that start easy but grow more complex, keeping you hooked for hours. Perfect for fans of casual puzzle games, match-and-place challenges, and brain-training games. Play at your own pace&mdash;no time pressure, just pure puzzle fun. Whether you want a quick mental workout or a long, relaxing session.",
    "instructions": "Mouse Click and drag to connect matching marble balls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "3D Games",
      "Android",
      "Arcade",
      "Ball",
      "Best Games",
      "Color",
      "crash",
      "crazygamesunblocked",
      "Fun",
      "Hypercasual",
      "Mind",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/yly424o862no7jfaq5hoiz0sjisam2dj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yly424o862no7jfaq5hoiz0sjisam2dj/",
    "sourceUrl": "https://html5.gamemonetize.com/yly424o862no7jfaq5hoiz0sjisam2dj/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69388",
    "slug": "friday-night-funkin-unblocked",
    "title": "Friday Night Funkin Unblocked",
    "description": "Friday Night Funkin Unblocked is a wildly popular casual arcade music game where you can immerse yourself in the crazy beats and supercharged duels. Tap the arrows in sync with the beats to nail every note and stay on rhythm! Face off against all kinds of funky foes. The pace is getting faster and the challenges more exciting! Super original beats and music tracks, let you get addicted to FNFs unique sound tour world!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Funny",
      "Music",
      "Rhythm"
    ],
    "thumbnail": "https://img.gamemonetize.com/8g62o78s1wjhsiu54xlmql32h7pagsek/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8g62o78s1wjhsiu54xlmql32h7pagsek/",
    "sourceUrl": "https://html5.gamemonetize.com/8g62o78s1wjhsiu54xlmql32h7pagsek/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69590",
    "slug": "stickman-slash",
    "title": "Stickman Slash",
    "description": "Experience the world of one of your favorite fighting action games but with stickman as main hero! Advanced physics and immersive graphics have brought this experience to a whole new level for players!",
    "instructions": "Use the mouse or touch to fight",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Arcade",
      "Blood",
      "Fight",
      "free html5 games for your website",
      "Killing",
      "kiz10",
      "Levels",
      "sliding",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/dimgvlqk0miw677p6zv1snl4u3491l3i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dimgvlqk0miw677p6zv1snl4u3491l3i/",
    "sourceUrl": "https://html5.gamemonetize.com/dimgvlqk0miw677p6zv1snl4u3491l3i/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69551",
    "slug": "flowers-vs-zombies",
    "title": "Flowers vs Zombies",
    "description": "&zwnj;Flowers vs Zombies&zwnj; is a strategic plant-placement game where players defend against zombie attacks by placing flowers that automatically shoot bullets. Two flowers can be merged into a more advanced one, with higher-tier flowers having greater attack power. Killing zombies earns points, and the higher the score, the better the ranking.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "garden",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/xn12cq3wtha3qeb9es5281yv7xhbtkvv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xn12cq3wtha3qeb9es5281yv7xhbtkvv/",
    "sourceUrl": "https://html5.gamemonetize.com/xn12cq3wtha3qeb9es5281yv7xhbtkvv/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69392",
    "slug": "macho-man-go",
    "title": "Macho Man Go",
    "description": "Ready to run, jump, punch, and dominate in Macho Man Go. As a muscle-bound hero, race through action platform levels filled with traps, enemies, and high-octane challenges! This game blends racing, fighting and running gameplay. Dash through obstacle courses and avoid deadly traps. Collect gems and power-ups, and unlock epic new skins and abilities! Collect various body parts to increase your strength. Avoid various obstacles like walls, spikes, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Jumping",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/x1gpfvr0wehy1sptr6289mh0wt1ijc88/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x1gpfvr0wehy1sptr6289mh0wt1ijc88/",
    "sourceUrl": "https://html5.gamemonetize.com/x1gpfvr0wehy1sptr6289mh0wt1ijc88/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69381",
    "slug": "vemon-run-3d",
    "title": "Vemon Run 3D",
    "description": "Vemon Run 3D brings a fun arcade running game. Step into a vivid 3D platform world. You become the nimble Vemon, racing forward and avoiding obstacles in a thrilling running adventure. Flexibly move your character to dodge left and right, and sprint at breakneck speeds! Keep collecting more gems to upgrade your character. Pass through positive-numbered doors. Destroy enemies to gain upgrades and transform into a superhero!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Fun",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/r3jhlbh7d5cuihn60hzv7dqw08x7f3kl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r3jhlbh7d5cuihn60hzv7dqw08x7f3kl/",
    "sourceUrl": "https://html5.gamemonetize.com/r3jhlbh7d5cuihn60hzv7dqw08x7f3kl/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "69532",
    "slug": "color-dash-match-the-color",
    "title": "Color Dash Match the Color",
    "description": "Color Dash is a fast-paced endless runner that tests your reflexes and color matching skill! Pilot a speeding rocket and match its color to smash through colored gates. Dodge the wrong colors and react to frantic color changes to keep your run alive. Grab powerful shield and nitro power-ups to blast further and beat your personal best score in this addictive arcade adventure. How high can you score?",
    "instructions": "Desktop Controls Move Left Press the Left Arrow Key or the A key Move Right Press the Right Arrow Key or the D key Mobile amp Tablet Controls Move Swipe Left or Swipe Right on the touch screen",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "Avoid",
      "Casual",
      "Color",
      "endless",
      "Matching",
      "Obstacle",
      "sky",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/apry8igioaarecxbc5wx2be8sdzvcdtt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/apry8igioaarecxbc5wx2be8sdzvcdtt/",
    "sourceUrl": "https://html5.gamemonetize.com/apry8igioaarecxbc5wx2be8sdzvcdtt/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "63609",
    "slug": "tricky-planner",
    "title": "Tricky Planner",
    "description": "Tricky Planner is a challenging arcade puzzle game that tests your logic, timing, and strategy skills. Guide colorful fish through tricky underwater mazes, avoid hungry sharks, and collect all targets before time runs out. Featuring vibrant graphics, addictive gameplay, and brain-teasing levels, this free online puzzle challenge is perfect for fans of strategic thinking games, underwater adventures, and skill-based arcade fun. Play now and prove you&rsquo;re the ultimate tricky planner!",
    "instructions": "Desktop Click with the mouse to plan moves interact with objects and navigate menus Mobile Touch Devices Tap to select move and interact with the game environment",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Best",
      "Best Games",
      "Casual",
      "HTML5",
      "NapTech Games",
      "Online",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/i4zl0gf27v3w7fp25cposy3e50qg6oou/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i4zl0gf27v3w7fp25cposy3e50qg6oou/",
    "sourceUrl": "https://html5.gamemonetize.com/i4zl0gf27v3w7fp25cposy3e50qg6oou/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69225",
    "slug": "spot-the-difference-diffsy-1",
    "title": "Spot The Difference Diffsy_1",
    "description": "Train your brain and test your observation skills with Diffsy &ndash; Spot the Difference, a fun and relaxing visual puzzle game for all ages! Look closely at two nearly identical pictures and find the 10 hidden differences in each level. Some are easy to spot, but others will challenge even the sharpest eyes! Zoom in, take your time, or race against the clock&mdash;it&rsquo;s your choice.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Board",
      "Difference",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/yhvn7wwizdxn9jfaa5t3jnalezrxknsk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yhvn7wwizdxn9jfaa5t3jnalezrxknsk/",
    "sourceUrl": "https://html5.gamemonetize.com/yhvn7wwizdxn9jfaa5t3jnalezrxknsk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69466",
    "slug": "tung-tung-sahur-snow-arena",
    "title": "Tung Tung Sahur Snow Arena",
    "description": "Powerful snowballs are being fired at you from two towers on the left and right &mdash; be careful! By the way, you can push your friend and knock them into the icy water. The player who falls the most loses the game. To win this cold battle with your friend, you must manage to stay on the ice. The first player to fall into the water 10 times loses. Be very careful &mdash; staying on the ice is extremely difficult!",
    "instructions": "Use the WASD and Arrow keys to move Watch out for the snowballs coming from the left and right and push each other into the water The first player to fall into the water 10 times loses the game Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arena",
      "Battle",
      "Brainrot Italian",
      "Tralalero Tralala",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/kg8cugwnyq2diywtw761mv7jjdu6q6ty/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kg8cugwnyq2diywtw761mv7jjdu6q6ty/",
    "sourceUrl": "https://html5.gamemonetize.com/kg8cugwnyq2diywtw761mv7jjdu6q6ty/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69310",
    "slug": "zombie-survival-2",
    "title": "Zombie Survival 2",
    "description": "Play the nervous zombie adventure in Zombie Survival. Explore a dangerous world occupied by zombies. Collect various weapons to attack zombies. Move smartly and set traps to defend yourself from massive zombie waves. Explore abandoned cities, dark alleys, and creepy forests - each level is a new adventure! Challenge big zombie bosses and prove your survival skills under pressure! Collect many useful items to fix your broken tools.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "attack",
      "Shoot",
      "survival",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/83siph0wqz04p8mp137w5uch7vk5t0nu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/83siph0wqz04p8mp137w5uch7vk5t0nu/",
    "sourceUrl": "https://html5.gamemonetize.com/83siph0wqz04p8mp137w5uch7vk5t0nu/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69371",
    "slug": "minecraft-battle-party",
    "title": "Minecraft Battle Party",
    "description": "Ready for a hot feast of square battles? In Minecraft Battle Party, youll enter a pixel-styled battle arena where nervous fighting meets iconic Minecraft-style visuals. In this world, every game is a duel to the death. You will play different roles and use different weapons. For example, as a gunner, constantly move your character so that enemies are shot within your scanning range. Watch out for other peoples attacks.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Fight",
      "Funny",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/3sqyn27o6l24az2w2tmlxc8amc3mt5a4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3sqyn27o6l24az2w2tmlxc8amc3mt5a4/",
    "sourceUrl": "https://html5.gamemonetize.com/3sqyn27o6l24az2w2tmlxc8amc3mt5a4/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "69418",
    "slug": "princess-run-3d",
    "title": "Princess Run 3D",
    "description": "Want a magical and exciting running adventure? Step into Princess Run 3D, a fun 3D platform arcade game full of exciting challenges. Play as a fearless princess racing through colorful 3D worlds. Collect beautiful clothes, shoes, hair, etc. Increase your charisma to get a maid of honor. Theyre going to help you fend off enemies in front of you or dirty mud, rain, etc. Be careful to avoid ugly clothes, costumes, bad weather, etc",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "3D Games",
      "Princess",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/gwe3ok9bdz6cx8n0t26rs26qr6rxb0kx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gwe3ok9bdz6cx8n0t26rs26qr6rxb0kx/",
    "sourceUrl": "https://html5.gamemonetize.com/gwe3ok9bdz6cx8n0t26rs26qr6rxb0kx/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69163",
    "slug": "alex-whiskers",
    "title": "Alex Whiskers",
    "description": "Join Alex Whiskers, the adventurous town cat, on a fast-paced hunt for tasty fish! Dash through busy streets, bounce high on springs, dodge speeding cars, and stay clear of the big bad bulldogs who&rsquo;d love to stop you in your tracks. Quick paws and sharp reflexes are your best friends in this fun, action-packed 3D adventure.",
    "instructions": "Controls Move Arrow Keys or WASD Look Around Mouse left right Jump Spacebar Controller Support Fully compatible for movement camera and jumping",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Cat",
      "Funny",
      "Jumping",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/m97tod5mmb9hq2m1jhdbjlxvjwisbtqe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m97tod5mmb9hq2m1jhdbjlxvjwisbtqe/",
    "sourceUrl": "https://html5.gamemonetize.com/m97tod5mmb9hq2m1jhdbjlxvjwisbtqe/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69499",
    "slug": "safari-match",
    "title": "Safari Match",
    "description": "Play Safari Match, a fun and addictive match-3 puzzle game set in the heart of the wild safari! Match colorful animal blocks, solve exciting puzzles, and unlock powerful boosters to win. Easy to play yet challenging to master, with hundreds of fun levels and stunning graphics. Perfect for kids and adults who love brain games, block puzzles, and animal-themed adventures. Play anywhere&mdash;mobile, tablet, or desktop&mdash;and become the ultimate match-3 champion!",
    "instructions": "Desktop Mouse Click Select amp Match Blocks Mobile Tap Select amp Match Blocks",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Match 3",
      "Matching",
      "NapTech Games",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/047gqvec2g1nektwuly9xns02mefpknw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/047gqvec2g1nektwuly9xns02mefpknw/",
    "sourceUrl": "https://html5.gamemonetize.com/047gqvec2g1nektwuly9xns02mefpknw/",
    "width": 1280,
    "height": 2560,
    "lastUpdated": ""
  },
  {
    "id": "69526",
    "slug": "burst-it-right",
    "title": "Burst It Right",
    "description": "Get ready for a colorful popping challenge in Burst It Right! Your task is to guide drifting balloons into position and pop them using matching-colored pins. Accuracy is key &mdash; only a correct color match will burst the balloon, while mismatches count as failures. With limited chances and increasing speed, your timing and strategy will be put to the test. Can you keep up the popping streak and master the art of precision bursting?",
    "instructions": "Push pin to right color direction",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ballon",
      "Best",
      "Casual",
      "Color"
    ],
    "thumbnail": "https://img.gamemonetize.com/r05pfchgkm1mj37vg3bpmm9yw0dj51s3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r05pfchgkm1mj37vg3bpmm9yw0dj51s3/",
    "sourceUrl": "https://html5.gamemonetize.com/r05pfchgkm1mj37vg3bpmm9yw0dj51s3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69529",
    "slug": "smash-sprout",
    "title": "Smash Sprout",
    "description": "Get your hammer ready and dive into the whacky world of Smash Sprout! Moles are popping up left and right, and it&rsquo;s your job to thump them back into their holes with perfect timing. Each well-aimed hit boosts your score, but miss too many, and it&rsquo;s game over! With fast-paced action, limited chances, and an ever-growing mole invasion, only the quickest reflexes will rise to the top. Can you smash your way to victory?",
    "instructions": "Smash the coming Sprout using Hammer just click on it",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/yil0x9n0lz9w2q7wihlt53hidzdtj5co/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yil0x9n0lz9w2q7wihlt53hidzdtj5co/",
    "sourceUrl": "https://html5.gamemonetize.com/yil0x9n0lz9w2q7wihlt53hidzdtj5co/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69515",
    "slug": "scary-maze-7",
    "title": "Scary Maze 7",
    "description": "Do you enjoy the rush of a good scare? Online games that test your courage have a special pull. The scary maze genre stands out, pushing players to their limits. Scary Maze 7 is the newest version of this well-known and often dreaded experience. It offers a fresh take on the classic internet maze game.",
    "instructions": "Mouse for the computer finger for a mobile device",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Maze"
    ],
    "thumbnail": "https://img.gamemonetize.com/aw9men7759mj6eepont3zmzglp1g755o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/aw9men7759mj6eepont3zmzglp1g755o/",
    "sourceUrl": "https://html5.gamemonetize.com/aw9men7759mj6eepont3zmzglp1g755o/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69272",
    "slug": "3d-educational-car-adventure",
    "title": "3D Educational Car Adventure",
    "description": "Play while learning with 3D cars that teach traffic signs, math, and general knowledge. Perfect for kids! . Explore a fun and interactive world where children drive colorful 3D cars while learning important life skills! This engaging educational game introduces kids to traffic signs, basic math operations, and fascinating general knowledge facts through playful missions and challenges. Designed to stimulate curiosity and critical thinking, each level encourages safe driving habits, problem-solving, and learning through exploration. With vibrant visuals, kid-friendly controls, and rewarding progress, this game is the perfect blend",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Car",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/951xnp5mc16o3d73yffshwzw6vfgzjq6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/951xnp5mc16o3d73yffshwzw6vfgzjq6/",
    "sourceUrl": "https://html5.gamemonetize.com/951xnp5mc16o3d73yffshwzw6vfgzjq6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69376",
    "slug": "jungle-fury-mutant-rhino-mayhem",
    "title": "Jungle Fury Mutant Rhino Mayhem",
    "description": "Enter a jungle plagued by mutant rhino warriors! As a brave tribal hero, rescue captured villagers, battle fierce enemies, and defeat powerful rhino bosses. Use bows, axes, and legendary weapons from the Blacksmith Shop to fight through deadly swamps, chaotic caverns, and fortified ramparts. Can you stop the Apex Mutant Rhino Warlord and restore peace to the land? Key Features: 20 intense levels with thrilling boss fights Unique enemies, from Rhino Brutes to Vampire Bats Powerful weapons like the Thunder Hammer &amp; Lightning Sword Blacksmith Shop for upgrades and new gear Health herbs &amp; gold mushrooms to aid your quest Epic medieval setting",
    "instructions": "Move attack and jump to defeat enemies Rescue villagers to complete levels Upgrade weapons wisely",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Monster",
      "Platform",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/6xmc3rr9d1g36oxh8zgmuwmmpp2qrt4f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6xmc3rr9d1g36oxh8zgmuwmmpp2qrt4f/",
    "sourceUrl": "https://html5.gamemonetize.com/6xmc3rr9d1g36oxh8zgmuwmmpp2qrt4f/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69281",
    "slug": "bubble-shoot-merge-box-2048",
    "title": "Bubble Shoot Merge Box 2048",
    "description": "Bubble Shoot Merge Box 2048 is a fast-paced puzzle shooter that combines classic bubble shooting mechanics with the addictive 2048 number merging gameplay. Aim, shoot, and merge identical numbered boxes to reach higher scores and unlock new levels. Designed for casual and competitive players alike, this hyper-casual arcade game challenges your logic, precision, and reflexes. With smooth gameplay, colorful graphics, and progressive difficulty, its perfect for mobile and desktop users looking for fun, brain-training action. Ideal for fans of merge games, number puzzles, and bubble shooters. Optimize your strategy and climb the leaderboard",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2048",
      "Bubble",
      "Bubble Shooter",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/itojgi1jp1w75wsxdje8tv1ndlm8a0mb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/itojgi1jp1w75wsxdje8tv1ndlm8a0mb/",
    "sourceUrl": "https://html5.gamemonetize.com/itojgi1jp1w75wsxdje8tv1ndlm8a0mb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69137",
    "slug": "school-stories-teacher-sim",
    "title": "School Stories: Teacher Sim",
    "description": "Dive into School Stories: Teacher Sim, an addictive high school game where you become a teacher managing students and school life. Customize your teacher avatar, grade papers, and maintain discipline by catching clever cheaters using hidden phones or notes. Explore vibrant school areas like art rooms, basketball courts, and swimming pools while engaging in mini games that capture the full school experience. Perfect for fans of teacher and school simulators, this game challenges your management skills as you pass levels and unlock new activities. Whether youre enforcing rules or taking part in school life adventures, School Stories: Teacher",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "School",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/xnf3bxeet7w4y8rdmifw7hugjnyzt0ds/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xnf3bxeet7w4y8rdmifw7hugjnyzt0ds/",
    "sourceUrl": "https://html5.gamemonetize.com/xnf3bxeet7w4y8rdmifw7hugjnyzt0ds/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69429",
    "slug": "wednesday-addams-beauty-salon",
    "title": "Wednesday Addams Beauty Salon",
    "description": "Get spooky and stylish in Wednesday Addams Beauty Salon, where gothic meets glam in a 3-level makeover game. Treat Wednesday to a facial, apply stunning dark-themed makeup, and finish off with iconic dress-up fashion in her unique style. From skincare to eyeliner, you control every detail of her transformation. Whether you&rsquo;re a fan of the Addams aesthetic or just love alternative beauty, this salon experience offers a complete glow-up from head to toe.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/23awz8prbs7t7jp4so5e3wlx26bvqloy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/23awz8prbs7t7jp4so5e3wlx26bvqloy/",
    "sourceUrl": "https://html5.gamemonetize.com/23awz8prbs7t7jp4so5e3wlx26bvqloy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69352",
    "slug": "pixel-legyfare-wars",
    "title": "Pixel Legyfare Wars",
    "description": "Pixel Legyfare Wars is a fast-paced, turn-based strategy game combining retro pixel graphics with modern warfare. Command your blocky armies on grid-based battlefields, using unique units and smart tactics to outmaneuver opponents. Web Dev <a href='https://www.crazygamesx.com/'>https://www.crazygamesx.com/</a>",
    "instructions": "Mouse loog WASD walk",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Gun",
      "legyfare",
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "unity",
      "War",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ldkc6qskqhuz4baigzg3kris6ng7r6ao/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ldkc6qskqhuz4baigzg3kris6ng7r6ao/",
    "sourceUrl": "https://html5.gamemonetize.com/ldkc6qskqhuz4baigzg3kris6ng7r6ao/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69113",
    "slug": "ageof2048",
    "title": "AgeOf2048",
    "description": "Very fun composition game, sliding the screen of the same building will synthesize new buildings. When you reach a certain building level, new building styles will be unlocked. Come and play.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2048",
      "Best Games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/kucts59lumpx0mu3j41fr4aj3junu0zc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kucts59lumpx0mu3j41fr4aj3junu0zc/",
    "sourceUrl": "https://html5.gamemonetize.com/kucts59lumpx0mu3j41fr4aj3junu0zc/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69427",
    "slug": "celebrity-wednesday-addams-style",
    "title": "Celebrity Wednesday Addams Style",
    "description": "Indulge in the iconic and bewitching Celebrity Wednesday Addams Style! Embrace the darkly chic aesthetics, explore mesmerizing outfits, and channel your inner gothic elegance. Discover how celebrities rock the macabre charm of Wednesday Addams with a modern twist. Unleash your inner darkness and redefine elegance with a touch of the mysterious.",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/zjbwtois48x4qmybpvm6ocxrgdys1kij/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zjbwtois48x4qmybpvm6ocxrgdys1kij/",
    "sourceUrl": "https://html5.gamemonetize.com/zjbwtois48x4qmybpvm6ocxrgdys1kij/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69442",
    "slug": "brainrot-tung-sahur-battle",
    "title": "Brainrot Tung Sahur Battle",
    "description": "Are you ready for a battle between Brainrot characters Trallero and Tung Tung? You must dodge the cannonballs fired by the Bananamonkeys launchers. Whoever avoids the cannonballs wins the game. Its simple &mdash; each cannonball you dodge adds extra time. Avoid the cannonballs and defeat your friend. The best jumper wins! Be very careful &mdash; cannonballs are everywhere!",
    "instructions": "Use the WASD and Arrow keys to move Avoid the cannonballs until the time runs out to win the game Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/ggv617jjlp7vgkrvmzi84qultev2411h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ggv617jjlp7vgkrvmzi84qultev2411h/",
    "sourceUrl": "https://html5.gamemonetize.com/ggv617jjlp7vgkrvmzi84qultev2411h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69440",
    "slug": "stickman-army-pusher",
    "title": "Stickman Army Pusher",
    "description": "Stickman Army Pusher is a fun and addictive game where you play as a blue stickman commander. Your goal is to strategically place blue stickmen to push the red stickmen off the edge. Use your army wisely to outnumber and push the opponents away, winning each level by making all red stickmen fall. Enjoy smooth gameplay and simple controls, perfect for quick and exciting battles.",
    "instructions": "Tap or mouse click to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "3D",
      "Hypercasual",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/sxmnfs0flc0f4xlddomb05idgbh9p975/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sxmnfs0flc0f4xlddomb05idgbh9p975/",
    "sourceUrl": "https://html5.gamemonetize.com/sxmnfs0flc0f4xlddomb05idgbh9p975/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69453",
    "slug": "thung-thung-sahur-merge-forever",
    "title": "Thung Thung Sahur Merge Forever",
    "description": "Thung Thung Sahur Merge Forever is a merge game without afraid of game over, merge all italian brainrot with no hesitate, enjoy your time",
    "instructions": "mouse only",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Brainrot",
      "Italian Brainrot",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/4y3q1ol1po9vgk6w0fwbwfx4nt5iwsrj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4y3q1ol1po9vgk6w0fwbwfx4nt5iwsrj/",
    "sourceUrl": "https://html5.gamemonetize.com/4y3q1ol1po9vgk6w0fwbwfx4nt5iwsrj/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69077",
    "slug": "kitty-merge-tycoon",
    "title": "Kitty Merge Tycoon",
    "description": "Step into a cozy world where merging fluffy kittens leads to pure joy. In Kitty Merge Tycoon, your goal is to combine identical kitties to unlock new, even cuter companions. Watch as your collection grows into a purring empire of whiskers and wonder. Tap to spawn more fluffballs, discover rare breeds, and rise through the ranks to become the ultimate feline tycoon. The charm never ends!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Cat",
      "Clicker",
      "Collecting",
      "Cute",
      "games for your website",
      "Hello Kitty",
      "Math",
      "sorting",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/9mojqu02upm0qrpmlio7ngcgy4nweqtn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9mojqu02upm0qrpmlio7ngcgy4nweqtn/",
    "sourceUrl": "https://html5.gamemonetize.com/9mojqu02upm0qrpmlio7ngcgy4nweqtn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69378",
    "slug": "lost-adventure",
    "title": "Lost Adventure",
    "description": "Survivors of a mid-air crash find themselves in a mysterious land. The pilot, amidst crafting, mining, and solving puzzles, works tirelessly to save passengers stranded on separate islands in the wild grass. Can they conquer the challenges, reunite, and escape the enigmatic realm before the unknown dangers lurking in the wilderness engulf them all? Embark on a thrilling adventure after a plane crash strands you in a mysterious, wild land. As the pilot, you must gather resources from wreckage, craft tools, and navigate through the wild grass to rescue scattered passengers on small islands.",
    "instructions": "Desktop Controls W uarr Up Arrow Move forward S darr Down Arrow Move backward A larr Left Arrow Move left D rarr Right Arrow Move right Mobile Controls On-Screen Joystick Move in all directions by dragging the joystick",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Aircraft",
      "airplane",
      "Android",
      "Animal",
      "Casual",
      "water",
      "Wolf",
      "World",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/y2kyrbazobem9n4gbbptaqrl83qlt2pr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/y2kyrbazobem9n4gbbptaqrl83qlt2pr/",
    "sourceUrl": "https://html5.gamemonetize.com/y2kyrbazobem9n4gbbptaqrl83qlt2pr/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69402",
    "slug": "stickmansniper",
    "title": "StickmanSniper",
    "description": "Highly trained, these games celebrate the marksmen with the most deadly of aim. In these sniper games the goal is to avoid detection and use your specialized training to infiltrate, observe and eliminate enemy troops at long distances before they even spot your location.",
    "instructions": "Use the mouse or touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Arcade",
      "First Person Shooter",
      "html5 games for your site",
      "kiz10",
      "Shooter",
      "Sniper",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/pnu56ck5blbnesweiw2z1ule6o530x9e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pnu56ck5blbnesweiw2z1ule6o530x9e/",
    "sourceUrl": "https://html5.gamemonetize.com/pnu56ck5blbnesweiw2z1ule6o530x9e/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69359",
    "slug": "pga5",
    "title": "PGA5",
    "description": "Pixel Gun Apocalypse 5 is a fast-paced multiplayer FPS that plunges players into blocky arenas. Featuring classic modes like Team Deathmatch, Free-for-all, and a thrilling Zombie survival mode, it offers diverse combat experiences. Web Dev <a href='https://www.kizi10.org/'>https://www.kizi10.org/</a> Players can unlock new weapons, earn experience by eliminating opponents, and even pilot a helicopter for an added layer of chaotic fun.",
    "instructions": "Mouse to look and shoot WASD walk",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "Shooting",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/x4zc4iyxb80853jvt476j3upe8uin05c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x4zc4iyxb80853jvt476j3upe8uin05c/",
    "sourceUrl": "https://html5.gamemonetize.com/x4zc4iyxb80853jvt476j3upe8uin05c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68998",
    "slug": "jungle-girl-coloring-pages",
    "title": "Jungle Girl: Coloring Pages",
    "description": "Jungle Girl: Coloring Pages is a fun and creative game made for kids who love to color and explore. With a wide selection of Jungle Girl-themed drawings, children can choose their favorite pictures and fill them with bright, beautiful colors. The game is easy to use, with simple controls that let kids tap to color, erase mistakes, and even save their artwork.",
    "instructions": "Pick a drawing you like and press Play to start Choose colors from the palette and begin coloring",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Color",
      "Coloring",
      "Dora"
    ],
    "thumbnail": "https://img.gamemonetize.com/s8duie7xvruui7yuxijc4s74crrf8dy9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s8duie7xvruui7yuxijc4s74crrf8dy9/",
    "sourceUrl": "https://html5.gamemonetize.com/s8duie7xvruui7yuxijc4s74crrf8dy9/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69174",
    "slug": "stellar-guardian",
    "title": "STELLAR GUARDIAN",
    "description": "Stellar Guardian &ndash; Cosmic Defense Force is a fast-paced space shooter where you command powerful ships, unlock upgrades, and defend the galaxy across challenging missions and game modes. to fix the lag you need to keep the PC on a full screen, while on other devices it runs smoothly",
    "instructions": "Controls Desktop larr rarr or A D ndash Move left and right Spacebar or Click ndash Shoot E ndash Activate shield F ndash Slow motion C ndash Special attack link https stellarguardian88 onrender com Shift ndash Precision mode Mo",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "2D",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/unnmh9hjtru4a1sfxm7sjqcxiv69e1s4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/unnmh9hjtru4a1sfxm7sjqcxiv69e1s4/",
    "sourceUrl": "https://html5.gamemonetize.com/unnmh9hjtru4a1sfxm7sjqcxiv69e1s4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69379",
    "slug": "fun-farm-for-kids",
    "title": "Fun Farm For Kids",
    "description": "Fun Farm For Kids is an exciting and educational game designed especially for toddlers and preschoolers (ages 1.5 to 5). Your little ones will explore a colorful farm full of adorable animals, cheerful sounds, and creative activities! Key Features: Animal Sounds &ndash; Tap on each animal to hear its real sound: cow, dog, duck, cat, horse, pig, sheep, and more! Drawing &amp; Coloring &ndash; Let your child unleash their creativity with easy-to-use drawing and coloring tools. Learn Colors &ndash; Fun mini-games that teach kids to recognize and name basic colors. Realistic Sounds &amp; Music &ndash; High-quality sound effects and background music for an",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Family",
      "Farm",
      "Kid",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/zskepvf53bt5bcmcj8sah3xap3vxqk2f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zskepvf53bt5bcmcj8sah3xap3vxqk2f/",
    "sourceUrl": "https://html5.gamemonetize.com/zskepvf53bt5bcmcj8sah3xap3vxqk2f/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69369",
    "slug": "ball-cup-boom",
    "title": "Ball Cup Boom",
    "description": "Ball Cup Boom is a physics-based puzzle game where you must carefully pick up the ball using your mouse and guide it into the cup. Every level brings new obstacles and challenges to test your aim, timing, and hand-eye coordination. It&rsquo;s simple to play, yet tricky to master. Enjoy satisfying win moments and keep improving your accuracy in this fun and casual HTML5 puzzle game made with GDevelop!",
    "instructions": "Mouse Left Button ndash Hold to pick the ball Drag ndash Move the ball Release ndash Drop it into the cup",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ball",
      "Logic",
      "Mouse",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ppvzjp3c03w9kpdieq1plwhhosgbkcj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ppvzjp3c03w9kpdieq1plwhhosgbkcj/",
    "sourceUrl": "https://html5.gamemonetize.com/4ppvzjp3c03w9kpdieq1plwhhosgbkcj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69206",
    "slug": "bid-wars-1-auction-simulator",
    "title": "Bid Wars 1  Auction Simulator",
    "description": "Ever dreamed of becoming a smart and fearless auction tycoon? Bid Wars 1: Auction Simulator is an addictive auction and simulation game that puts you in exciting bidding wars to uncover hidden treasures! In this game, you join intense auctions for storage units, antiques, and mysterious items. Spot valuable gems, bid wisely, and sell them for huge profits!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "idle",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/qotzmhhui1arsut4sg9zuhy7ualnvag4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qotzmhhui1arsut4sg9zuhy7ualnvag4/",
    "sourceUrl": "https://html5.gamemonetize.com/qotzmhhui1arsut4sg9zuhy7ualnvag4/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68270",
    "slug": "girl-games-unblocked-mini-fun",
    "title": "Girl Games Unblocked: Mini Fun",
    "description": "Welcome to Girl Games Unblocked: Mini Fun, a collection of minigames online. Whether you are a casual player looking for relaxation or a skillful gamer who wants to elevate your gaming skills, we will satisfy your needs with our vast number of relaxing games. Find your favorite minigame among our best girl game selection. Fashion design, nail salon, doll dressup games, food cooking... You can always find something that fits your type!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Relaxation",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/61m89nktd7lc1ivzb3sqtlupu7gv8pum/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/61m89nktd7lc1ivzb3sqtlupu7gv8pum/",
    "sourceUrl": "https://html5.gamemonetize.com/61m89nktd7lc1ivzb3sqtlupu7gv8pum/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "69285",
    "slug": "line-puzzle-3d",
    "title": "Line Puzzle 3D",
    "description": "Line Puzzle 3D is a creative drawing game where you guide a pencil to trace 3D shapes with precision. Test your spatial awareness and hand-eye coordination by following complex outlines in a fully interactive 3D environment. With satisfying visuals and brain-teasing levels, this puzzle game offers engaging gameplay for fans of drawing games, brain training, and 3D puzzles. Challenge your focus and accuracy as you complete each level with perfect lines.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Draw",
      "Drawing",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/x75tkhbj2d74sygii596jw5c1g8bji6m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x75tkhbj2d74sygii596jw5c1g8bji6m/",
    "sourceUrl": "https://html5.gamemonetize.com/x75tkhbj2d74sygii596jw5c1g8bji6m/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69321",
    "slug": "line-runner-1",
    "title": "Line Runner 1",
    "description": "This game is a hyper casual game where we avoid obstacles on a rope. When you die, an ad is shown. The one who makes the most points wins and the game is very fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2D",
      "Adult",
      "Android",
      "Best"
    ],
    "thumbnail": "https://img.gamemonetize.com/5tt2ld6eb48noyqkcm5fmq6zaku2uur8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5tt2ld6eb48noyqkcm5fmq6zaku2uur8/",
    "sourceUrl": "https://html5.gamemonetize.com/5tt2ld6eb48noyqkcm5fmq6zaku2uur8/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67349",
    "slug": "colorblockjam",
    "title": "ColorBlockJam",
    "description": "Move the colored blocks out of the exits of the same color. The game has multiple levels, and various items will randomly appear in each level to enhance the fun of the gameplay. Give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Best Games",
      "Block",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/xrbjwx8xz6tpwmjusn5v8yl2p3rxom0g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xrbjwx8xz6tpwmjusn5v8yl2p3rxom0g/",
    "sourceUrl": "https://html5.gamemonetize.com/xrbjwx8xz6tpwmjusn5v8yl2p3rxom0g/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68052",
    "slug": "pixel-paintball-wars",
    "title": "Pixel Paintball Wars",
    "description": "Pixel Paintball Wars is a fast-paced multiplayer shooter that blends retro pixel graphics with the chaotic fun of paintball. Players battle across vibrant, blocky arenas, using a variety of paintball guns and power-ups to eliminate opponents.",
    "instructions": "Mouse wasd walk",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Mentolatux",
      "paint",
      "paintball",
      "Shooting",
      "unity",
      "War",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/hb1ltv4dne082zkwrc2pgbjmeynjmji8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hb1ltv4dne082zkwrc2pgbjmeynjmji8/",
    "sourceUrl": "https://html5.gamemonetize.com/hb1ltv4dne082zkwrc2pgbjmeynjmji8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69370",
    "slug": "park-them-all",
    "title": "Park Them All",
    "description": "In this fun and addictive game, your main task is to sort out the parking spots so that all the cars can find their place and settle down comfortably. Its like being the air traffic controller of a bustling car parking lot! Whether you call it Park Away, Seat Cars Away, or Master of Parking, the goal remains the same &ndash; clear the car jam by arranging the parking spots smartly.",
    "instructions": "tap to park",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "carparking",
      "Parking",
      "sort",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/t51ybtaf3bckodi7ljrl5t27l2o1nyyh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t51ybtaf3bckodi7ljrl5t27l2o1nyyh/",
    "sourceUrl": "https://html5.gamemonetize.com/t51ybtaf3bckodi7ljrl5t27l2o1nyyh/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69217",
    "slug": "rage-swarm",
    "title": "Rage Swarm",
    "description": "Take powerful weapons and make your way through a huge number of enemies in order to get to the boss and eliminate him. Dont forget to pick up useful improvements during the mission to make it easier to complete the tasks at hand.",
    "instructions": "Use the mouse or touch to move",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Bullet",
      "free html5 games for your website",
      "HTML5",
      "kiz10",
      "Monster",
      "Shoot 'Em Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/zn9q0fe95iuih8k70wauc1jwmbsuwpnn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zn9q0fe95iuih8k70wauc1jwmbsuwpnn/",
    "sourceUrl": "https://html5.gamemonetize.com/zn9q0fe95iuih8k70wauc1jwmbsuwpnn/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68309",
    "slug": "lazzy-birds",
    "title": "Lazzy Birds",
    "description": "Lazzy Birds is a fun and physics-based puzzle game where you launch the birds using a slingshot to destroy enemies. Your mission is to defeat all enemies on each level using special birds and limited shorts. Birds: 1 Blue: A simple bird. 2 Black: A bomber bird. 3 Green: A speed bird. 4 Red: A heavy bird.",
    "instructions": "Controls Click and hold the bird to pull back the slingshot Drag to Aim Release to Launch Click during flight activate special ability",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "angrybirds",
      "Arcade",
      "Best Games",
      "Bird",
      "building",
      "Classic",
      "Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/98he3ddjltg9jrt5ba53tnegnbunm2aj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/98he3ddjltg9jrt5ba53tnegnbunm2aj/",
    "sourceUrl": "https://html5.gamemonetize.com/98he3ddjltg9jrt5ba53tnegnbunm2aj/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "67709",
    "slug": "wednesday-dark-academia",
    "title": "Wednesday Dark Academia",
    "description": "Immerse yourself in a world of style and makeup, creating the perfect look for Wednesday. With a variety of unique and stylish options, you can give her a bold school look or a glamorous ballroom appearance. Choose from a range of dark lip colors, eyeshadows, and mascaras to create a one-of-a-kind look thats all your own. From styling her hair to selecting the perfect accessories, you can dress her up for a fun day at school or a special party.",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/mxtmzh7m62fxe2al4c6fiu7y7oo6hdz5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mxtmzh7m62fxe2al4c6fiu7y7oo6hdz5/",
    "sourceUrl": "https://html5.gamemonetize.com/mxtmzh7m62fxe2al4c6fiu7y7oo6hdz5/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "69270",
    "slug": "iron-legion",
    "title": "Iron Legion",
    "description": "Iron Legion Dive into epic tank battles of the modern era! Iron Legion is an exciting online action game where you become the commander of a formidable combat vehicle. Game features: * More than 10 models of legendary classic tanks * Unique maps with detailed terrain * Vehicle development and upgrade system with realistic damage mechanics * Team battles for up to 20 players in real time Gameplay: * Choose your path - from light reconnaissance vehicles to heavy assault tanks * Complete exciting combat missions and tasks",
    "instructions": "Desktop controls movement - WASD arrow keys on the keyboard camera rotation - mouse shooting - left mouse button aim - right mouse button",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "3D",
      "Action",
      "Battle",
      "Driving",
      "military",
      "Multiplayer",
      "Online",
      "PvP",
      "Shooter",
      "Tank",
      "Tanks",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/gkeofcoqengjzxlw0b09f2qrng35egbi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gkeofcoqengjzxlw0b09f2qrng35egbi/",
    "sourceUrl": "https://html5.gamemonetize.com/gkeofcoqengjzxlw0b09f2qrng35egbi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69202",
    "slug": "poker2048",
    "title": "Poker2048",
    "description": "Poker2048 blends the strategic depth of poker with the addictive gameplay of sliding-tile puzzles. On a 4&times;4 grid, you&rsquo;ll merge cards to form classic poker hands. Pair, Three of a Kind, Straight, Flush, Full House and beyond. Powerful hands award more points, so plan your moves carefully to maximize your score. Draw new cards from the deck when needed, but watch your opportunities: the game ends when no moves remain or the deck is empty. With simple controls, vibrant visuals, and endless replayability, Poker2048 is perfect for puzzle lovers and card sharks alike. Challenge yourself to beat your best score!",
    "instructions": "Arrow keys or swipe",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2048",
      "Card",
      "Casino",
      "Mobile",
      "Poker",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/8642bhwj1tqak84ucz7gy8a6ehfcydyh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8642bhwj1tqak84ucz7gy8a6ehfcydyh/",
    "sourceUrl": "https://html5.gamemonetize.com/8642bhwj1tqak84ucz7gy8a6ehfcydyh/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69221",
    "slug": "seedfall-defend-the-last-tree",
    "title": "Seedfall: Defend the Last Tree",
    "description": "Seedfall is a 2D endless side-scroller where nature is your last weapon. Defend the final magical tree using coins to summon natural defenses, cast enchanted upgrades, and survive relentless waves of corrupted creatures. In the heart of a forgotten forest, humanity made a mistake. During an expedition in search of knowledge, a group of explorers uncovered an ancient bacteria hidden deep beneath the earth&rsquo;s roots. What first appeared to be a scientific breakthrough soon turned into something far more powerful and far more dangerous.",
    "instructions": "Move A D or larr rarr Left Right Keys Interact Spend Coins S or darr Down Key PRESS THE P KEY TO RETURN TO THE MENU",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Casual",
      "Pixel",
      "Platform",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/equtkk696ugo1aefnb3abau4ccy2llxd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/equtkk696ugo1aefnb3abau4ccy2llxd/",
    "sourceUrl": "https://html5.gamemonetize.com/equtkk696ugo1aefnb3abau4ccy2llxd/",
    "width": 1024,
    "height": 576,
    "lastUpdated": ""
  },
  {
    "id": "69214",
    "slug": "super-clicked",
    "title": "Super Clicked",
    "description": "Click Rush: Upgrade, Earn, and Compete! Tap to earn points and gold, upgrade your power, and climb the global leaderboard! Compete with players and countries &mdash; no registration needed, just pure fun!",
    "instructions": "Mouse or Touch ndash Tap or click to earn points buy upgrades and interact with the game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Click",
      "Clicker",
      "idle",
      "Mouse"
    ],
    "thumbnail": "https://img.gamemonetize.com/38gl1uek062g36qgnlaimwr0hl0b6tbd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/38gl1uek062g36qgnlaimwr0hl0b6tbd/",
    "sourceUrl": "https://html5.gamemonetize.com/38gl1uek062g36qgnlaimwr0hl0b6tbd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68166",
    "slug": "single-line-drawing-puzzle",
    "title": "Single Line: Drawing Puzzle",
    "description": "Icon image Single Line: Drawing Puzzle About this game Challenge your mind and unleash your creativity with Single Line: Drawing Puzzle! This exciting game is perfect for anyone who loves brain teasers and enjoys solving clever puzzles. Your mission is simple yet addictive: draw one continuous line to complete intricate designs without lifting your finger or retracing your steps. Are you ready to take on this one-line challenge?",
    "instructions": "- Draw in One Go Use a single continuous line to complete the given shape - Avoid Overlaps Plan your path carefully and don rsquo t retrace any steps - Complete Shapes Solve each shape to unlock the next more challenging level",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Drawing",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/achrkouru4jq8yj33krvszvgxuz02w6i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/achrkouru4jq8yj33krvszvgxuz02w6i/",
    "sourceUrl": "https://html5.gamemonetize.com/achrkouru4jq8yj33krvszvgxuz02w6i/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69261",
    "slug": "pixel-zombie-survival-2025",
    "title": "Pixel Zombie Survival 2025",
    "description": "Pixel Zombie Survival 2025 is an action-packed survival shooter where you battle waves of undead in a pixelated world. Collect weapons, upgrade skills, and fight solo or with friends to survive the zombie apocalypse of the future! use WASD to walk, mouse to shoot, tab for menu. Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Mentolatux",
      "Multiplayer",
      "Pixel",
      "WebGL",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/j9ogt0jx0a8t6m5pq7tdnudrlzjjc2cl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j9ogt0jx0a8t6m5pq7tdnudrlzjjc2cl/",
    "sourceUrl": "https://html5.gamemonetize.com/j9ogt0jx0a8t6m5pq7tdnudrlzjjc2cl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68568",
    "slug": "dualight-a-reflected-game",
    "title": "DuaLight   A Reflected Game",
    "description": "DuaLight is a challenging 2D pixel art hyper-casual platformer. The true path lies in the reflection. Navigate levels where the real world tricks your eyes, and only those who watch the reflection below can move forward. Minimalist and short. In DuaLight &ndash; A Reflected Game, nothing is as it seems&hellip; or rather, everything only appears in the reflection. You control a character in a world where invisible platforms can&rsquo;t be seen in the real world, but only in the reflection below the screen. You&rsquo;ll encounter spikes and invisible platforms until you look at the reflection and realize the path was there all along.",
    "instructions": "Use the W A S D keys or the arrow keys to move Press W the up arrow or the spacebar to jump Press P to return to menu",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Casual",
      "Logic",
      "Pixel",
      "Platform",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/3u2rsoiw6scttfr8es5u6fsp7w49z29j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3u2rsoiw6scttfr8es5u6fsp7w49z29j/",
    "sourceUrl": "https://html5.gamemonetize.com/3u2rsoiw6scttfr8es5u6fsp7w49z29j/",
    "width": 1024,
    "height": 576,
    "lastUpdated": ""
  },
  {
    "id": "69232",
    "slug": "curvy-punch-2",
    "title": "Curvy Punch 2",
    "description": "Ready to join the funniest and craziest punch battle ever? Play a creative 3D fight action game in Curvy Punch. You can throw hilarious curve punches to knock out your enemies! Your fists don&rsquo;t just punch straight; you can bend them in wild curves! Control your fists to maneuver around obstacles and punch your opponents hard. Make every punch precise and funny! You can also backflip to avoid enemy attacks! Colorful 3D cartoon style with cool hit effects!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Fight",
      "Funny",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/us0l69i6kfvo5wa3a2skvifjmcmhj8t6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/us0l69i6kfvo5wa3a2skvifjmcmhj8t6/",
    "sourceUrl": "https://html5.gamemonetize.com/us0l69i6kfvo5wa3a2skvifjmcmhj8t6/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68973",
    "slug": "draw-deadly-descent",
    "title": "Draw Deadly Descent",
    "description": "Draw Deadly Descent - a game that combines two elements (parts). This is a puzzle part, where you first need to draw a road or a bridge. And the second part, where you already control this car, like in the game Hill Climb Racing, that is, you control a car with physics. The game has 42 levels. If you encounter a difficult level, you can skip it by watching an ad! There are also 7 variations of car coloring available in the game.",
    "instructions": "Mouse click or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best",
      "Car",
      "Cars",
      "Casual",
      "Crazy",
      "Draw",
      "Drawing",
      "HTML5",
      "Mobile",
      "New",
      "Physics",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/zerem82y7t9exktu4sj6ilbt9b8mr0bp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zerem82y7t9exktu4sj6ilbt9b8mr0bp/",
    "sourceUrl": "https://html5.gamemonetize.com/zerem82y7t9exktu4sj6ilbt9b8mr0bp/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68977",
    "slug": "squirrels-draw-your-level",
    "title": "Squirrels   Draw your level!",
    "description": "Draw levels and compete to see who will get to the acorn first! Forget about boring platformers - let your imagination run wild and draw your own level! Choose one of 5 skins for squirrels! Each player has their own color version, so there are 10 unique options available in total!",
    "instructions": "Controls on PC Blue player - larr rarr uarr Red player - WAD",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Animal",
      "Best",
      "Best Games",
      "Cool",
      "Draw",
      "Drawing",
      "free games for your site",
      "Mobile",
      "New",
      "two player games"
    ],
    "thumbnail": "https://img.gamemonetize.com/1pziw102l4exnjsp6oy8i83s1xfdwf36/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1pziw102l4exnjsp6oy8i83s1xfdwf36/",
    "sourceUrl": "https://html5.gamemonetize.com/1pziw102l4exnjsp6oy8i83s1xfdwf36/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69209",
    "slug": "code-runner-binary-confusion",
    "title": "Code Runner: Binary Confusion",
    "description": "A fast-paced binary runner where logic and reflexes collide. Match the rule, dodge the wrong digit &mdash; survive the code! .A psychological runner puzzle where every second counts and one rule could change everything.",
    "instructions": "1 Swipe left right or use arrow keys to switch lanes 2 Watch the active rule top of screen 3 Follow the rule carefully mdash each mistake costs a life",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "endless",
      "Logic",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/g4lc9i51ukejmxvenq5gl1mypstz6bya/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g4lc9i51ukejmxvenq5gl1mypstz6bya/",
    "sourceUrl": "https://html5.gamemonetize.com/g4lc9i51ukejmxvenq5gl1mypstz6bya/",
    "width": 400,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69068",
    "slug": "tung-tung-tung-tung-sahur",
    "title": "Tung Tung Tung Tung Sahur",
    "description": "Enter a dark, eerie forest haunted by the mysterious Tung Sahur. Your goal is to collect all the lost souls scattered across the woods to escape&hellip; but beware! Tung Sahur appears suddenly to hunt you down. The only way to survive is to hide inside the wooden huts until its safe. Can you gather all the souls before he catches you?",
    "instructions": "On PC Move WASD or Arrow Keys Look Around Move the mouse Run Hold Shift while moving Interact Press E to pick up items Press ESC to unlock the cursor On Mobile Move Use the Joystick Look Around Drag your finger on the screen Run Tap and hold th",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Action",
      "Game",
      "Ghost",
      "Granny",
      "Horror",
      "jump",
      "Sahur",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/iivhncl1ihn5xpk7h1xnqwovwkutrgxl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iivhncl1ihn5xpk7h1xnqwovwkutrgxl/",
    "sourceUrl": "https://html5.gamemonetize.com/iivhncl1ihn5xpk7h1xnqwovwkutrgxl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68694",
    "slug": "super-doctor-bros-mano",
    "title": "Super Doctor Bros Mano",
    "description": "Super Doctor Bros Mano is a 2D adventure game where the player controls Bros, who has become a doctor in a world filled with obstacles and viruses. In this game, Doctor Bros must navigate through levels full of challenges and complex terrains while avoiding viruses and enemies that block his path.",
    "instructions": "For Pc Jump Attack Space",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "Mario"
    ],
    "thumbnail": "https://img.gamemonetize.com/2lp98evkhkarmw3m37mkxxus2ucz6cz1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2lp98evkhkarmw3m37mkxxus2ucz6cz1/",
    "sourceUrl": "https://html5.gamemonetize.com/2lp98evkhkarmw3m37mkxxus2ucz6cz1/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69161",
    "slug": "color-yarn-sort",
    "title": "Color Yarn Sort",
    "description": "Color Yarn Sort is a fun and relaxing puzzle game where you need to sort colorful spools of yarn into their matching buckets. The challenge? You have limited space to place the buckets, and you must think carefully about which bucket to move forward. Each yarn color must be placed in its corresponding bucket, but you can only move the buckets into the available spaces&mdash;there&rsquo;s no room for error!",
    "instructions": "The goal is to match the yarns with their respective colored buckets You can only move one bucket at a time and each bucket takes up a space If you place a bucket incorrectly you rsquo ll lose a space Once all the spaces are filled you rsquo ll lose",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/w6c1riuqxlu05k18ci5mazjcrl74jz6w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w6c1riuqxlu05k18ci5mazjcrl74jz6w/",
    "sourceUrl": "https://html5.gamemonetize.com/w6c1riuqxlu05k18ci5mazjcrl74jz6w/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68999",
    "slug": "kiki-world",
    "title": "Kiki World",
    "description": "Decorate and Makeover your home sweet home with Kiki World: Kawaii Doll Decor! Introducing Kiki World: Kawaii Doll Decor, a home decor game designed exclusively for your aesthetic interior design passions. Dive into the world of decor, where clicking, dragging, and dropping chic furniture transforms empty spaces into captivating living areas. Your dream home is here. Take away the trash, throw away old and dirty things! Lets have a home makeover with Kiki World: Kawaii Doll Decor!",
    "instructions": "Perfect for those who love to fantasize about room transformations and have a keen eye for home aesthetics Start designing your ideal living space now and bring your decor dreams to life with Kiki World Kawaii Doll Decor",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "city",
      "Decorate",
      "Decoration"
    ],
    "thumbnail": "https://img.gamemonetize.com/5lip2anm36bs3599zdriq4wpvc6km63w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5lip2anm36bs3599zdriq4wpvc6km63w/",
    "sourceUrl": "https://html5.gamemonetize.com/5lip2anm36bs3599zdriq4wpvc6km63w/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68352",
    "slug": "newborn-baby-care",
    "title": "Newborn Baby Care",
    "description": "Welcome to Newborn Baby Care, a casual baby care simulation game, where you need to take care of a newborn baby. Experience what a babysitters work is like and learn baby care skills. Whether you are a casual gamer who is looking for a relaxing pastime or a skillful player who wants to challenge yourself, come to Newborn Baby Care!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby Games",
      "Educational",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/5uo9tw11ousxm7kf9f7b36c0y2bfnebh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5uo9tw11ousxm7kf9f7b36c0y2bfnebh/",
    "sourceUrl": "https://html5.gamemonetize.com/5uo9tw11ousxm7kf9f7b36c0y2bfnebh/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "67058",
    "slug": "prisoner-bob",
    "title": "Prisoner Bob",
    "description": "Step into the shadows of a high-security prison, where every move could be your last. In this intense single-player strategy game, you&rsquo;ll navigate a 3&times;3 grid full of patrolling guards, vicious dogs, hidden weapons, and medkits. Your ultimate goal: collect 3 hidden map pieces and escape the prison!",
    "instructions": "Arrows or WASD",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Arcade",
      "Battle",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/s2qup50jjnar8mob68c2m99b4bmjcrob/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s2qup50jjnar8mob68c2m99b4bmjcrob/",
    "sourceUrl": "https://html5.gamemonetize.com/s2qup50jjnar8mob68c2m99b4bmjcrob/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65410",
    "slug": "3d-jigsaw-puzzle",
    "title": "3D Jigsaw Puzzle",
    "description": "3D Jigsaw Puzzle is the implementation of the classic jigsaw puzzle with beautiful and realistic 3D graphic.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Board",
      "Casual",
      "Educational",
      "Family",
      "Jigsaw",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/kiq7ud4joyxb6jyqkll2lp186jl228bd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kiq7ud4joyxb6jyqkll2lp186jl228bd/",
    "sourceUrl": "https://html5.gamemonetize.com/kiq7ud4joyxb6jyqkll2lp186jl228bd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "54068",
    "slug": "word-puzzle-travel",
    "title": "Word Puzzle Travel",
    "description": "Word Puzzle Travel offers an exciting journey through language and exploration. In this captivating game, players embark on a virtual voyage filled with word puzzles inspired by destinations around the globe. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a> From famous landmarks to cultural icons, each level presents unique challenges that test players vocabulary and problem-solving skills.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boys",
      "Educational",
      "Kids",
      "Mentolatux",
      "Puzzle",
      "Unity3D",
      "WebGL",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/0pxg5hkorucuy5kxz9cdd35sq7nbr190/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0pxg5hkorucuy5kxz9cdd35sq7nbr190/",
    "sourceUrl": "https://html5.gamemonetize.com/0pxg5hkorucuy5kxz9cdd35sq7nbr190/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69066",
    "slug": "italian-brainrot-guess-who",
    "title": "Italian Brainrot Guess Who",
    "description": "Welcome to the Italian Brainrot Guess Who quiz game with the characters from Strange Animals! Choose your difficulty and test your knowledge of the Brainrot characters. Tap the correct answer from multiple choices and collect points as you go through the world of Italian Brainrot!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Brainrot Italian",
      "Fun",
      "Funny",
      "Guessing",
      "Italian Brainrot",
      "Kids",
      "Quiz",
      "Skill",
      "Tralalero Tralala",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/trx33059msohwdlt2aefdwrhxth64478/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/trx33059msohwdlt2aefdwrhxth64478/",
    "sourceUrl": "https://html5.gamemonetize.com/trx33059msohwdlt2aefdwrhxth64478/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69231",
    "slug": "geometry-waves",
    "title": "Geometry Waves",
    "description": "Geometry Waves is a fast-paced reflex game where precision is everything. Hold the mouse to make your arrow rise, release to glide down&mdash;navigate through a neon-lit maze of moving traps and deceptive geometry. Each of the 30 handcrafted levels introduces a new obstacle mechanic: vanishing ninjas that flicker in and out of sight, hidden barriers that only appear when youre close, and more unpredictable challenges designed to test your timing and focus.",
    "instructions": "mouse only",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "attack",
      "Avoid",
      "Casual",
      "Geometry",
      "Space",
      "Turn",
      "twist"
    ],
    "thumbnail": "https://img.gamemonetize.com/v1zud8fjalvqmwndggvm5ukwl4lswqzp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v1zud8fjalvqmwndggvm5ukwl4lswqzp/",
    "sourceUrl": "https://html5.gamemonetize.com/v1zud8fjalvqmwndggvm5ukwl4lswqzp/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69205",
    "slug": "jurassic-dinosaur-mech-battle",
    "title": "Jurassic Dinosaur Mech Battle",
    "description": "Want a hot action battle game? In Jurassic Dinosaur Mech Battle, you will be transformed into a super mech warrior. Unleash your skills to attack different kinds of dinosaurs. You can also fly up to the sky and unleash cool killing techniques! Kill the target number of enemies to complete the challenge. Get coins to upgrade your attack power or health - dominate every fight! Smooth action strikes and visual effects give you the thrill of an immersive mecha battle!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Battle",
      "transport",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/xitcc0ouccbqrd0ynvzwc9pk2und1y81/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xitcc0ouccbqrd0ynvzwc9pk2und1y81/",
    "sourceUrl": "https://html5.gamemonetize.com/xitcc0ouccbqrd0ynvzwc9pk2und1y81/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "69184",
    "slug": "fix-da-brainrot",
    "title": "Fix Da Brainrot",
    "description": "Fix Da Brainrot is a quirky jigsaw puzzle game with pieces that look like torn paper. Pick your challenge &mdash;16 pieces for a quick and easy fix or 32 pieces for a real brain teaser. Drag, drop, and fit the torn pieces together, and watch the picture slowly come alive as you fix the brainrot and conquer the puzzle!",
    "instructions": "Use a mouse or touchpad to drag and drop to fit the torn pieces to their right position",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "html5 games",
      "Italian Brainrot",
      "Jigsaw",
      "Mobile",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/5r766tdtqlienvk0z6umtdt2k8dk79my/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5r766tdtqlienvk0z6umtdt2k8dk79my/",
    "sourceUrl": "https://html5.gamemonetize.com/5r766tdtqlienvk0z6umtdt2k8dk79my/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "69204",
    "slug": "whack-a-bug",
    "title": "Whack A Bug",
    "description": "Get ready for fast-paced arcade fun with Whack-a-Bug!, the addictive free online HTML game that puts a fresh spin on classic whacking games. Test your reflexes and strategic thinking as you aim for the high score in this vibrant, bug-filled adventure!",
    "instructions": "Just use mouse or touch controls",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Highscore",
      "Level",
      "Levels"
    ],
    "thumbnail": "https://img.gamemonetize.com/o05zh2t5bblhx56mm79hgd4n61okahd0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o05zh2t5bblhx56mm79hgd4n61okahd0/",
    "sourceUrl": "https://html5.gamemonetize.com/o05zh2t5bblhx56mm79hgd4n61okahd0/",
    "width": 500,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "69012",
    "slug": "color-dodge",
    "title": "Color Dodge",
    "description": "Color Dodge is a fast-paced, addictive color-matching arcade game where reflexes and precision are your only hope! Control a glowing circle from a top-down view and survive as colorful walls charge toward you from all directions. Heres the twist &mdash; you must collide only with the wall segment that matches your color, or you explode in a juicy blast! Whether youre chasing high scores or just vibing with neon chaos, Color Dodge deliv",
    "instructions": "PC Keyboard Move WASD or Arrow Keys Mobile Touch Touch amp Drag anywhere to move like a joystick",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Avoid",
      "Color",
      "Obstacle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tpgv84b0o15q4o2rwmhzygnji6tgt2dl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tpgv84b0o15q4o2rwmhzygnji6tgt2dl/",
    "sourceUrl": "https://html5.gamemonetize.com/tpgv84b0o15q4o2rwmhzygnji6tgt2dl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69053",
    "slug": "openworld-racing",
    "title": "Openworld Racing",
    "description": "Openworld Racing is a simple and fun 3D driving game where you can explore a large open world at your own pace. Drive through streets, enjoy smooth handling, and switch between three different cars. &bull; Open World Exploration &ndash; Drive anywhere with no limits. &bull; Day &amp; Night Cycle &ndash; Experience changing lighting as time passes. &bull; Mobile &amp; PC Controls &ndash; Easy-to-use touch icons on mobile, WASD controls on PC (more controls shown in-game). &bull; Switch Cars Anytime &ndash; Try out all 3 cars and feel the difference. &bull; Camera Modes &ndash; Change perspective for the best driving view. Whether you want to drift, cruise, or just explore&mdash;Openworld Racing is all about fun and freedom.",
    "instructions": "Mobile Tap arrow icons to move brake icon to stop headlight icon to toggle front lights and camera icon to change perspective PC Use WASD to drive More controls are shown in the top-left corner of the game",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Cars",
      "drift",
      "offroad",
      "Racing",
      "Road",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/8bun03rapg7jsazspo0oc80cnxj3cjjs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8bun03rapg7jsazspo0oc80cnxj3cjjs/",
    "sourceUrl": "https://html5.gamemonetize.com/8bun03rapg7jsazspo0oc80cnxj3cjjs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69133",
    "slug": "can-you-catch",
    "title": "Can You Catch",
    "description": "Do you trust your reflexes? lets try it. In this simple game, you need to quickly collect the gold coins falling from above. Be careful, if you cannot collect them, you will lose. Try to score the most.",
    "instructions": "It is played with the a and d keys or the right and left arrow keys on the keyboard",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "catch",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/of1wzi1gjtfitmnbrnvthopy5w7oi6ue/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/of1wzi1gjtfitmnbrnvthopy5w7oi6ue/",
    "sourceUrl": "https://html5.gamemonetize.com/of1wzi1gjtfitmnbrnvthopy5w7oi6ue/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "69104",
    "slug": "scooter-touchgrind-tricks-3d",
    "title": "Scooter Touchgrind Tricks 3D",
    "description": "Scooter Touchgrind Tricks 3D is a fun driving game where you control a scooter through exciting levels full of obstacles. Your goal is simple&mdash;reach the finish line without crashing! Along the way, you&rsquo;ll need to dodge obstacles and keep your balance as the tracks get harder. You can collect coins to unlock cooler scooters and try out different styles. With smooth controls and tons of levels to beat, this game keeps you coming back for more. Whether youre into racing or just love doing tricks, its all about skill, speed, and having fun on two wheels.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Avoid",
      "Driving",
      "Racing",
      "Simulation",
      "Stunts",
      "vehicle",
      "wheel",
      "wheels"
    ],
    "thumbnail": "https://img.gamemonetize.com/jkgxa35eeoodbqfj9hlfya96yq75weoi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jkgxa35eeoodbqfj9hlfya96yq75weoi/",
    "sourceUrl": "https://html5.gamemonetize.com/jkgxa35eeoodbqfj9hlfya96yq75weoi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68528",
    "slug": "anime-fashion-world-met-gala-magic",
    "title": "Anime Fashion World Met Gala Magic",
    "description": "Get ready for the most dazzling fashion night of the year in Anime Fashion World: Met Gala Magic! Style your favorite anime queens&mdash;Nezuko Kamado, Usagi Tsukino, Zero Two, and Nami&mdash;as they prep for the Met Gala runway. From dramatic dresses and sparkly makeup to bold hair and accessories, you&rsquo;ll guide each character through their own glam makeover. Every step is all about expression, creativity, and bringing out each character&rsquo;s unique style. There&rsquo;s no competition or timer&mdash;just pure fun. Mix and match outfits, test wild looks, or go elegant. Each transformation ends with a fashion-forward red carpet moment.",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Anime",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/v78gts29vn3bsky26p0hjzd6leg33fj1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v78gts29vn3bsky26p0hjzd6leg33fj1/",
    "sourceUrl": "https://html5.gamemonetize.com/v78gts29vn3bsky26p0hjzd6leg33fj1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68680",
    "slug": "kids-supermarket",
    "title": "Kids Supermarket",
    "description": "Welcome to Kids Supermarket, a casual supermarket simulation game for kids. Have you ever gone shopping alone? Feel confused about finding goods among a large number of products? Join Kids Supermarket to elevate your observation and categorization skills. Our diverse and clearly aligned products will make you feel like shopping in a real-life supermarket. Pick up your shopping basket and start your journey in the supermarket.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby Games",
      "Cute",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/xp1dunwo5v2pj01voqgnd6qwypbw33ek/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xp1dunwo5v2pj01voqgnd6qwypbw33ek/",
    "sourceUrl": "https://html5.gamemonetize.com/xp1dunwo5v2pj01voqgnd6qwypbw33ek/",
    "width": 1600,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68250",
    "slug": "baby-sprunki-incredibox-coloring",
    "title": "Baby Sprunki incredibox Coloring",
    "description": "Welcome to Mod Baby Sprunki coloring book game where you can start your creativity with our fun and interactive coloring and drawing game! Perfect for all ages, this game offers a wide range of templates and blank canvases where you can color, draw, and design your own masterpieces. Choose from a vibrant palette of colors, use different brush sizes, and add unique effects to bring your imagination to life. Whether youre a budding artist or just looking to relax, this game provides endless opportunities to express yourself and share your artwork with friends. Let your artistic journey begin!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Coloring",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/ykscm0jd5lq8muvzkkgukcn6alif8t8p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ykscm0jd5lq8muvzkkgukcn6alif8t8p/",
    "sourceUrl": "https://html5.gamemonetize.com/ykscm0jd5lq8muvzkkgukcn6alif8t8p/",
    "width": 960,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "69120",
    "slug": "casual-poker-online",
    "title": "Casual Poker Online",
    "description": "&ldquo;Poker Online&rdquo; is a fun and easy way to enjoy classic Texas Holdem online. No real-money betting &mdash; just pure fun and strategy! Play against real players, feel the thrill, build strong hands, and become the best at the virtual table. With a user-friendly interface and quick matchmaking, it&rsquo;s everything you need for the perfect poker night. Features: Classic Texas Holdem rules Real-time matches with live opponents Colorful and intuitive interface",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Card",
      "Poker"
    ],
    "thumbnail": "https://img.gamemonetize.com/bcs4hy6efm4uqx1qacogniq5xvn9jzhe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bcs4hy6efm4uqx1qacogniq5xvn9jzhe/",
    "sourceUrl": "https://html5.gamemonetize.com/bcs4hy6efm4uqx1qacogniq5xvn9jzhe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67048",
    "slug": "ageofbattle",
    "title": "AgeOfBattle",
    "description": "Send troops to break through the enemys castle. Killing soldiers can earn you gold coins, and gold coins can unlock higher-level soldiers. The higher the soldiers rank is, the more powerful he is. Come and have a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Battle",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/7672k6il1my9fyegitb3zo1h1vr0aeg4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7672k6il1my9fyegitb3zo1h1vr0aeg4/",
    "sourceUrl": "https://html5.gamemonetize.com/7672k6il1my9fyegitb3zo1h1vr0aeg4/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69123",
    "slug": "tarcat",
    "title": "Tarcat",
    "description": "Paw Smash - Cat power in a single tap! Enter the world of feline destruction with Tarcat, a hilarious casual game where you control a cats paw! Your goal? Smash all targets with quick reflexes and pinpoint accuracy! With just one tap, hit targets, avoid traps, and dominate each level with the style of a true feline destroyer.",
    "instructions": "TOUCH THE SCREEN MOUSE",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Cat",
      "Fun",
      "Funny",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/ap5q4zpk7u6jxh8yyofvmczo413jlfcd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ap5q4zpk7u6jxh8yyofvmczo413jlfcd/",
    "sourceUrl": "https://html5.gamemonetize.com/ap5q4zpk7u6jxh8yyofvmczo413jlfcd/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "69162",
    "slug": "one-level-stickman-jailbreak",
    "title": "One Level Stickman Jailbreak",
    "description": "Tommy got into trouble! Our hero is behind bars. But he&rsquo;s not going to stay in jail for a long time and he decides to escape. Tommy steals a key and gets out of the jail cell. In order to go free Tommy will have to solve logical puzzles and you can help him in this!",
    "instructions": "Use the keyboard or mobile buttons to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Escape",
      "HTML",
      "html5 games for your site",
      "Jumping",
      "kiz10",
      "Levels",
      "Maze",
      "Platform",
      "Prison",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ydmtrmpnnggfcblhk9blfhqkld9a6hga/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ydmtrmpnnggfcblhk9blfhqkld9a6hga/",
    "sourceUrl": "https://html5.gamemonetize.com/ydmtrmpnnggfcblhk9blfhqkld9a6hga/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68276",
    "slug": "my-cute-restaurant",
    "title": "My Cute Restaurant",
    "description": "Are you ready to spend a day as a chief in the restaurant? Welcome to My Cute Restaurant, a casual cooking game, exclusively for girl gamers. If you are interested in cooking or DIY games, never miss this chance to have fun! Cook delicious dishes, serve your animal customers, and clean the table after the customer leaves.",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Animal",
      "Cooking",
      "Restaurant"
    ],
    "thumbnail": "https://img.gamemonetize.com/dy7146w27hzms4kts0qgnkrywdvf5xd9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dy7146w27hzms4kts0qgnkrywdvf5xd9/",
    "sourceUrl": "https://html5.gamemonetize.com/dy7146w27hzms4kts0qgnkrywdvf5xd9/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68868",
    "slug": "triple-treat-toss",
    "title": "Triple Treat Toss",
    "description": "In Triple Treat Toss, your sweet skills are put to the test! Aim carefully and throw candies toward clusters where at least two more of the same type are waiting. When your thrown candy forms a perfect trio, they vanish in a delightful blast &mdash; earning you points and clearing the way for more fun. But precision matters: only groups of exactly three matching candies will score. Can you master the art of candy tossing and rack up the highest score? Key Features: Addictive candy-tossing gameplay Aim-and-throw mechanics requiring precision and strategy Satisfying match-3 explosions Simple controls, endless fun",
    "instructions": "Click to shoot where the item should go",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best",
      "Candy",
      "Casual",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/hzpd46ld62qhr4l5rdplkkvj58q30iwc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hzpd46ld62qhr4l5rdplkkvj58q30iwc/",
    "sourceUrl": "https://html5.gamemonetize.com/hzpd46ld62qhr4l5rdplkkvj58q30iwc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68952",
    "slug": "bubble-tea-mixing-game",
    "title": "Bubble Tea Mixing Game",
    "description": "Bubble Tea &ndash; Color Game is all about mixing and matching and blending and fusing a huge assortment of flavors and colors to create cold drink concoctions that will have you licking your lips. Receive orders, choose the right ingredients, pour them all into a cup, and serve to your thirsty customers. Take care not to spill your drinks in the excitement! Pick and choose from a wide variety of cups and ingredients. Customize your drinks with the cutest toppers, from bashful bunnies to pandas and more. All it takes is a few rounds of Bubble Tea &ndash; Color Game to get you hooked. It&rsquo;s the perfect time-killer for lunch breaks, long commutes, and a",
    "instructions": "Mix and create the correct bubble tea",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Bubble",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/cox71pgfzhhjtupdzu79zk96l0c9obbj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cox71pgfzhhjtupdzu79zk96l0c9obbj/",
    "sourceUrl": "https://html5.gamemonetize.com/cox71pgfzhhjtupdzu79zk96l0c9obbj/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69147",
    "slug": "mind-gambit",
    "title": "Mind Gambit",
    "description": "Mind Gambit is a relaxing puzzle game inspired by the classic Peg Solitaire. Plan your moves carefully to jump and remove pegs until only one remains. There&rsquo;s no timer, just pure strategy and thoughtful gameplay. With unlimited levels, the challenge never ends.",
    "instructions": "Use your mouse or touchpad to play mdash click on a peg then click on a valid spot to jump over another peg and remove it The objective is to leave only one peg on the board There rsquo s no timer so take your time and plan your moves carefully",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Board",
      "Brain",
      "Logical",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/e3qw2s87fwplpc13omy1m2jqq06thon7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e3qw2s87fwplpc13omy1m2jqq06thon7/",
    "sourceUrl": "https://html5.gamemonetize.com/e3qw2s87fwplpc13omy1m2jqq06thon7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67136",
    "slug": "cuttinggrass",
    "title": "CuttingGrass",
    "description": "Control the lawnmower to clear all the grass from the lawn. The game has multiple levels. Use your brain and clear all the levels.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best Games",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/z4rsmrzlu3nazb39ct9csp8zmmh0ao5a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z4rsmrzlu3nazb39ct9csp8zmmh0ao5a/",
    "sourceUrl": "https://html5.gamemonetize.com/z4rsmrzlu3nazb39ct9csp8zmmh0ao5a/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67977",
    "slug": "ibiza-foam-party",
    "title": "Ibiza Foam Party",
    "description": "Get ready to dive into the craziest virtual party experience with Ibiza Foam Party! Immerse yourself in the electrifying atmosphere of Ibiza, the party capital of the world. Splash around in a sea of bubbles, dance to pumping beats, and compete against friends in wild and energetic beauty challenges. Ready to get the fun started? Then join Gina and Selena in this colorful, summer-themed makeover game for girls, and help our BFFs deal with their dazzling party looks. From scrubbing and skincare to makeup and fabulous fashion, you&rsquo;re the ultimate stylist ensuring these besties shine bright under the Ibiza sun. Have a blast!",
    "instructions": "Use your mouse to play on a dektop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Makeover",
      "Pool",
      "Summer"
    ],
    "thumbnail": "https://img.gamemonetize.com/nmhfepwj0c50oqnnjwcqa0rihx4hp2td/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nmhfepwj0c50oqnnjwcqa0rihx4hp2td/",
    "sourceUrl": "https://html5.gamemonetize.com/nmhfepwj0c50oqnnjwcqa0rihx4hp2td/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "67629",
    "slug": "lava-cre",
    "title": "Lava Cre",
    "description": "Move through the platforms until you reach the helicopter, while being assisted by a character, but dont think hell help you, he wants to have fun with you, face the challenges without falling into the lava",
    "instructions": "Desktop W Up Arrow Key Move Up D Down Arrow Key Move Down A Leff Arrow Key Move Left D Right Arrow Key Move Right Space Jump Mobile Tap Left Move Left Tap Right Move Right Tap Up Move Up Tap Down Move Down Tap Jump Jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D Games",
      "Adventure",
      "Crazy",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/1s9oxoyrpos44yp4o27fnyua0l3bd130/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1s9oxoyrpos44yp4o27fnyua0l3bd130/",
    "sourceUrl": "https://html5.gamemonetize.com/1s9oxoyrpos44yp4o27fnyua0l3bd130/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67902",
    "slug": "wordix",
    "title": "Wordix",
    "description": "Wordix is an engaging logic game where your task is to guess the word within a limited number of attempts. It&rsquo;s the Russian version of the popular game Wordle, but with one important difference: the words are chosen from a pre-prepared list, and you can play as much as you want without waiting for a new word each day. The game develops your thinking skills, expands your vocabulary, and provides an entertaining way to spend time. It&rsquo;s suitable for both children and adults. Simple rules make the game accessible to everyone, and color-coded hints help you find the correct answer faster.",
    "instructions": "Input Type letters or tap keys on the virtual keyboard Submit Press Enter to submit your guess Delete Use Backspace to erase a letter Hints Green correct letter and position Yellow correct letter wrong position Gray letter not in the word",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brain",
      "Casual",
      "Educational",
      "Family",
      "Logic",
      "Logical",
      "Puzzle",
      "unity",
      "WebGL",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/h4f6eu9g4o4yndgpss4tkcqd9wzwkt3w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h4f6eu9g4o4yndgpss4tkcqd9wzwkt3w/",
    "sourceUrl": "https://html5.gamemonetize.com/h4f6eu9g4o4yndgpss4tkcqd9wzwkt3w/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68801",
    "slug": "kick-pong-table-soccer",
    "title": "Kick Pong   Table Soccer",
    "description": "Foosball Pong: Arcade Soccer &amp; 2-Player Battles! The ultimate mix of foosball + Pong is here! Swipe, score, and defend in fast 2D matches vs AI or a friend (same-device multiplayer). Easy to learn, hard to master! Why Players Love It: 2-Player Mode &ndash; Battle friends on one device! (Perfect for duels!). Hybrid Gameplay &ndash; Foosball meets Pong in 5-minute arcade chaos! Realistic Physics &ndash; Every shot feels satisfying! Unlock Custom Kits &ndash; Personalize your team! Cup Tournaments &ndash; Win trophies vs AI! Challenge Your Friends! Download now and see who&rsquo;s the foosball champion!",
    "instructions": "Swipe in mobile Arrow keyboard in PC",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "2 Player",
      "Arcade",
      "Cartoon",
      "Football",
      "Fun",
      "Funny",
      "Soccer",
      "Sport",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/q0cdps5gwd7bvt6hfrr8i1yxmznwsnfa/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q0cdps5gwd7bvt6hfrr8i1yxmznwsnfa/",
    "sourceUrl": "https://html5.gamemonetize.com/q0cdps5gwd7bvt6hfrr8i1yxmznwsnfa/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68956",
    "slug": "the-stone-miner",
    "title": "The Stone Miner",
    "description": "Become the ultimate mining tycoon in The Stone Miner! Drive your powerful mining machine through various fantasy terrains. Crush, collect and smash stones like never before! Steer your mine cart through rocks of different colors and materials and enjoy the exhilarating experience of stone mining. Sell collected stones for gold, and unlock new areas full of rare materials and surprises! Upgrade your vehicle to mine faster and deeper, turning your gear into a true beast!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Funny",
      "Machine",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/razhpktrvmxpqy6kq6e0wan5dajve06o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/razhpktrvmxpqy6kq6e0wan5dajve06o/",
    "sourceUrl": "https://html5.gamemonetize.com/razhpktrvmxpqy6kq6e0wan5dajve06o/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69125",
    "slug": "skip-love",
    "title": "Skip Love",
    "description": "Ready for a funny, brain-teasing love adventure? Play an addictive brain teaser puzzle game in Skip Love. A funny little stickman hero trying to win the heart of his beloved while dodging all sorts of dangers! Each level has unique puzzles that make you think and laugh! Think and use your brain to overcome each challenge, helping the man overcome his sexy wife and lover. For example, help him disguise himself as a clown, disrupt, create chaos, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Brain",
      "Funny",
      "Love"
    ],
    "thumbnail": "https://img.gamemonetize.com/rl17s6vss8dzyk7gx7mbg1u72uynhob6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rl17s6vss8dzyk7gx7mbg1u72uynhob6/",
    "sourceUrl": "https://html5.gamemonetize.com/rl17s6vss8dzyk7gx7mbg1u72uynhob6/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68942",
    "slug": "shape-connect",
    "title": "Shape Connect",
    "description": "Shape Connect is a cute and fun game where kids help two teddy bears meet each other! There&rsquo;s a broken road between them, and you need to fill the gaps with the right shapes from the bottom of the screen. Place the shapes correctly to complete the path so the teddy bears can cross and be together. It&rsquo;s a perfect game to learn about shapes and problem-solving.",
    "instructions": "How to Play Desktop Mouse Click Drag Pick and place shapes into the road Mobile Touch Drag Pick and place shapes into the road",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Baby Games",
      "Brain",
      "Educational",
      "HTML5",
      "Kids",
      "Matching",
      "NapTech Games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/q3quxmosai2jei0a64ru2qptrk9fojfv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/q3quxmosai2jei0a64ru2qptrk9fojfv/",
    "sourceUrl": "https://html5.gamemonetize.com/q3quxmosai2jei0a64ru2qptrk9fojfv/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "65042",
    "slug": "flower-magnet",
    "title": "Flower Magnet",
    "description": "Flower Magnet is a relaxing and enchanting puzzle game where you guide a magical magnet to collect beautiful blossoms. Swipe and slide through dreamy gardens, attracting flowers of different colors while avoiding obstacles and tricky paths. Use strategy and timing to gather every bloom and complete each level with grace. With soothing music, elegant visuals, and increasingly clever puzzles, Flower Magnet is perfect for players seeking calm yet challenging gameplay. Unlock new garden themes, magnet styles, and special floral effects as you progress. Let nature guide your moves&mdash;step into a blooming world of logic and beauty with Flower Magnet!",
    "instructions": "Use Mouse to play game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Magic",
      "Puzzle",
      "quest"
    ],
    "thumbnail": "https://img.gamemonetize.com/ykfekv61oynw4mf9xyzpsi26g3ashls6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ykfekv61oynw4mf9xyzpsi26g3ashls6/",
    "sourceUrl": "https://html5.gamemonetize.com/ykfekv61oynw4mf9xyzpsi26g3ashls6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68204",
    "slug": "paper-doll-diary-dress-up-diy",
    "title": "Paper Doll Diary: Dress Up DIY",
    "description": "Icon image Paper Doll Diary: Dress Up DIY About this game Welcome to Paper Doll Diary: Doll DressUp, where the timeless charm of DIY paper dolls meets the exhilarating world of fashion dress up! Step into a realm of creativity and style where you become the master stylist of your enchanting paper doll dress up. With an expansive wardrobe featuring over 1000 fashion items, including the latest in trendy attire, distinctive accessories, diverse hairstyles, and soothing ASMR makeup touches, your creative potential is limitless.",
    "instructions": "Create the ultimate sanctuary for your DIY paper doll excel in style challenges and customize every aspect of her world in this extraordinary dress up game Paper Doll Diary Doll DressUp transcends the typical princess game inviting you into a univers",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/g954n45w3qik98x0ezqpmp8i15258a0d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g954n45w3qik98x0ezqpmp8i15258a0d/",
    "sourceUrl": "https://html5.gamemonetize.com/g954n45w3qik98x0ezqpmp8i15258a0d/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68776",
    "slug": "nyfw-street-style",
    "title": "NYFW Street Style",
    "description": "Welcome to NYFW Street Style. Rainbow girls are excited to try some really amazing street-style fashion outfits and accessories! So, play it and get inspired for your own wardrobe! Check out all those fabulous items and choose your favorites to dress the beautiful model up with style! She should look amazing in the end, so make sure you pick up the perfect outfit for her!",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/pk41kqfnev0xppk2eknami0nw27ikow2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pk41kqfnev0xppk2eknami0nw27ikow2/",
    "sourceUrl": "https://html5.gamemonetize.com/pk41kqfnev0xppk2eknami0nw27ikow2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68871",
    "slug": "roblox-dream-duo-dress-up",
    "title": "Roblox Dream Duo Dress Up",
    "description": "Roblox Couple Creator lets you unleash your creativity as you style the perfect Roblox-inspired couple! Choose from a wide selection of trendy clothing, cool shoes, and fun hairstyles to design unique looks for both boy and girl characters. Once you&rsquo;ve crafted the perfect outfit combination, you can save your stylish creations as images to share with friends or keep as your own collection.",
    "instructions": "Use Mouse to click",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Boy",
      "Dress Up",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/27ml9syka3uoik32jnsr1bwnwkly0zxx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/27ml9syka3uoik32jnsr1bwnwkly0zxx/",
    "sourceUrl": "https://html5.gamemonetize.com/27ml9syka3uoik32jnsr1bwnwkly0zxx/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68964",
    "slug": "labubu-coloring-adventure",
    "title": "Labubu Coloring Adventure",
    "description": "Labubu Coloring Adventure is a splashy journey into a world full of color, fun, and furry mischief!. Grab your digital crayons and bring Labubu and friends to life with every stroke!. From goofy grins to magical backgrounds, every page is a new surprise! Explore, color, giggle, and create your own cartoon adventure with Labubu!. It&rsquo;s not just coloring: it&rsquo;s a giggle-filled adventure waiting at every tap!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Coloring",
      "Educational",
      "Fun",
      "Hypercasual",
      "Kids",
      "Labubu",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/a8mfgt4ad1wnwc8v69y36pjvo4v9r6gn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a8mfgt4ad1wnwc8v69y36pjvo4v9r6gn/",
    "sourceUrl": "https://html5.gamemonetize.com/a8mfgt4ad1wnwc8v69y36pjvo4v9r6gn/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67107",
    "slug": "carvscops",
    "title": "CarVsCops",
    "description": "Control the vehicle to avoid being pursued by the police car. Skillfully control the cars turns to make the police car chasing behind collide. You can get gold coin rewards along the way and unlock other vehicles. Come and challenge it now.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Best Games",
      "Cars",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/7w1n01zl3dtic53jv1sxoeenqzca36ik/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7w1n01zl3dtic53jv1sxoeenqzca36ik/",
    "sourceUrl": "https://html5.gamemonetize.com/7w1n01zl3dtic53jv1sxoeenqzca36ik/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69096",
    "slug": "flap-hero",
    "title": "Flap Hero",
    "description": "Flap Hero is a fast-paced arcade game inspired by the classic Flappy Bird. Fly through challenging red pipes with precise timing and quick reflexes. Its easy to play but hard to master!",
    "instructions": "Controls Tap Mobile Touchscreen Spacebar Keyboard Stay in the air dodge obstacles and become the ultimate Flap Hero",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best",
      "Casual",
      "Classic",
      "Click",
      "endless",
      "fly",
      "onetouch"
    ],
    "thumbnail": "https://img.gamemonetize.com/yqabq4g5ci6bkf35yt7860k2dgn9wcsc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yqabq4g5ci6bkf35yt7860k2dgn9wcsc/",
    "sourceUrl": "https://html5.gamemonetize.com/yqabq4g5ci6bkf35yt7860k2dgn9wcsc/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "69010",
    "slug": "mineblocks",
    "title": "Mineblocks",
    "description": "Mine Blocks is a 2D Minecraft caves game where you have to dash the blocks and complete the levels You can mine and craft in randomly generated worlds, collect diamonds, build armor, fight monsters, design redstone, explore the nether, defeat the ender dragon, and do hundreds of other things!",
    "instructions": "Use the keyboard or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Best Games",
      "Block",
      "dash",
      "html games for your website",
      "Kiz 10",
      "Levels",
      "Minecraft",
      "Miner"
    ],
    "thumbnail": "https://img.gamemonetize.com/wr4s1bkz7u57su3t7he5rs9otce1o6ft/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wr4s1bkz7u57su3t7he5rs9otce1o6ft/",
    "sourceUrl": "https://html5.gamemonetize.com/wr4s1bkz7u57su3t7he5rs9otce1o6ft/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68121",
    "slug": "brainrot-evolution",
    "title": "Brainrot Evolution",
    "description": "Welcome to Brainrot Evolution! UPDATES EVERY SATURDAY! Eat to gain levels! Gain levels to unlock new Brainrot Evolutions! Collect Wins &amp; Pets! PREMIUM PLAYERS GET +10% Wins &amp; +10% EXP!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brainrot"
    ],
    "thumbnail": "https://img.gamemonetize.com/c34zurvgw1w01fkf4n07idbggc6vvkbq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c34zurvgw1w01fkf4n07idbggc6vvkbq/",
    "sourceUrl": "https://html5.gamemonetize.com/c34zurvgw1w01fkf4n07idbggc6vvkbq/",
    "width": 896,
    "height": 414,
    "lastUpdated": ""
  },
  {
    "id": "68685",
    "slug": "merge-ant-insect-fusion",
    "title": "Merge Ant Insect Fusion",
    "description": "Enter the merged world of insect combat. In Merge Ant: Insect Fusion, you&rsquo;re the commander of a tiny but mighty ant army. Merge different ants, evolve fearsome insects, and build an unstoppable animal force to conquer your enemies. Drag and drop two of the same insects to merge them into a stronger unit. Easy to learn, but deeply strategic.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Army",
      "Card",
      "Enemies"
    ],
    "thumbnail": "https://img.gamemonetize.com/f8m9kw1kdw638xz9ishyenne8f2izl6z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f8m9kw1kdw638xz9ishyenne8f2izl6z/",
    "sourceUrl": "https://html5.gamemonetize.com/f8m9kw1kdw638xz9ishyenne8f2izl6z/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68686",
    "slug": "food-truck-chef-cooking",
    "title": "Food Truck Chef Cooking",
    "description": "Welcome to Food Truck Chef Cooking, a casual food cooking simulation game online. Want to experience a day of a food truck chef? Are you curious about what the screws work is like on an airplane? Join our best chef simulator game and resolve all your doubts. Step into the kitchen of a running truck and answer all your customers requests. Challenge your mind and boost your thinking in this cooking management game.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Card",
      "Cooking",
      "Food",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/8p3so8q9f3iycgpynknbtx1gyv9nxpzm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8p3so8q9f3iycgpynknbtx1gyv9nxpzm/",
    "sourceUrl": "https://html5.gamemonetize.com/8p3so8q9f3iycgpynknbtx1gyv9nxpzm/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68765",
    "slug": "crown-cannon",
    "title": "Crown Cannon",
    "description": "Crown &amp; Cannon is a fast-paced 2D strategy game where players expand territory, deploy various weapons, and battle dynamic AI on destructible terrain. It features upgradeable units, strategic combat, and is optimized for Web platforms and cross platform.",
    "instructions": "PC arrow keys space Android touch controls",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Sandbox",
      "Strategy",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/p8vp0dxq81p2nz04byvs4g0oh24fvjme/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p8vp0dxq81p2nz04byvs4g0oh24fvjme/",
    "sourceUrl": "https://html5.gamemonetize.com/p8vp0dxq81p2nz04byvs4g0oh24fvjme/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "69008",
    "slug": "backrooms-assault-2",
    "title": "Backrooms Assault 2",
    "description": "Backrooms Assault 2 is a first person shooter game where your mission is to shoot your way through the backrooms and find a way to the exit in order to progress and unlock new more powerful weapons to survive the increasing number of enemies.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon TAB - Pause",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "CSGO",
      "First Person Shooter",
      "Gun",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/s9et24t9023vk2kk72m1eygr7yrk59d0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s9et24t9023vk2kk72m1eygr7yrk59d0/",
    "sourceUrl": "https://html5.gamemonetize.com/s9et24t9023vk2kk72m1eygr7yrk59d0/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68317",
    "slug": "meteor-escape",
    "title": "Meteor Escape",
    "description": "Meteors are raining from the sky, and so is money! Can you dodge destruction and get rich at the same time? Move fast, survive longer, and collect those coins like your life depends on it &mdash; because it does!",
    "instructions": "PC Move Left ndash A or larr Move Right ndash D or rarr Mobile Tap the left or right buttons on the screen to move",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action"
    ],
    "thumbnail": "https://img.gamemonetize.com/zmkyms3zzbg4t12h36f1qn57bkkpirfm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zmkyms3zzbg4t12h36f1qn57bkkpirfm/",
    "sourceUrl": "https://html5.gamemonetize.com/zmkyms3zzbg4t12h36f1qn57bkkpirfm/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67074",
    "slug": "buildtower",
    "title": "BuildTower",
    "description": "Seize the opportunity to build a taller tower. The game has multiple levels, and the height of the tower to be built in each level is different. There is an optimal building symbol on each floor of the tower. Seize the opportunity and build the tower at the best position. Give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/63hu1ckpffmin83h2mu9bxah3do0hjcl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/63hu1ckpffmin83h2mu9bxah3do0hjcl/",
    "sourceUrl": "https://html5.gamemonetize.com/63hu1ckpffmin83h2mu9bxah3do0hjcl/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "52013",
    "slug": "downhill-snowboard",
    "title": "Downhill Snowboard",
    "description": "Downhill Snowboard it is a very challenging game. The objective of the game is to go down the slope and accumulate the highest score you can, collect coins to unlock new characters and snowboards.",
    "instructions": "Use the mouse or touch to interact A D or Arrows",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "Casual",
      "endless",
      "Hypercasual",
      "Skill",
      "Snow",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/xxlz1gjpdxfhl98zmshxkqg3a90gccvz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xxlz1gjpdxfhl98zmshxkqg3a90gccvz/",
    "sourceUrl": "https://html5.gamemonetize.com/xxlz1gjpdxfhl98zmshxkqg3a90gccvz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "69006",
    "slug": "city-constructor",
    "title": "City Constructor",
    "description": "Become a heavy machinery operator! In this game, you control excavators, cranes, trucks, and more to solve physics-based puzzles, transport cargo, and complete construction tasks. Realistic mechanics, varied levels, and increasing difficulty make the game both challenging and fun. Use precision and logic to master construction sites, bridges, and mountain terrains. Perfect for all ages &mdash; from vehicle lovers to simulation fans.",
    "instructions": "Desktop A - Move Left D - Move Right W - Move Up S - Move Down Arrow Keys - Control the Arm Spacebar - Grab Release Action TAB - Switch Vehicle ESC - Pause Mobile Use the on-screen controls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2D",
      "Balance",
      "Bridge",
      "build",
      "Car",
      "construction",
      "demolition",
      "destroy",
      "destruction",
      "Logic",
      "Machine",
      "Obstacle",
      "Physics",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/6psthwbt96i8afnwmsovc95508t2pt27/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6psthwbt96i8afnwmsovc95508t2pt27/",
    "sourceUrl": "https://html5.gamemonetize.com/6psthwbt96i8afnwmsovc95508t2pt27/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68950",
    "slug": "cube-to-hole-puzzle",
    "title": "Cube to Hole Puzzle",
    "description": "Welcome to Cube to Hole Puzzle! Get ready for an exciting and brain-teasing experience! In Cube to Hole Puzzle, your objective is simple: fill the colored cubes into their matching colored holes.",
    "instructions": "Do you have the skills to solve every puzzle With increasing difficulty and new challenges at every level Cube to Hole Puzzle will keep you entertained for hours",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Puzzle",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/r0gtbnuiwo9d7owan4fgrmd54ywcti00/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r0gtbnuiwo9d7owan4fgrmd54ywcti00/",
    "sourceUrl": "https://html5.gamemonetize.com/r0gtbnuiwo9d7owan4fgrmd54ywcti00/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "69000",
    "slug": "turbo-drive-mode-blitz",
    "title": "Turbo Drive Mode Blitz",
    "description": "Ready to feel the speed rush? Turbo Drive: Mode Blitz is a nervous racing simulation game that brings together speed, awesome car designs, and driving challenges. Here, you&rsquo;ll control your custom-designed supercar and race in the open city. Accept a mission to send a student to school. Get rewarded for completing the task.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "city",
      "Driving"
    ],
    "thumbnail": "https://img.gamemonetize.com/960f0t0d0xo4pdmdar46bui34lxe3ndk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/960f0t0d0xo4pdmdar46bui34lxe3ndk/",
    "sourceUrl": "https://html5.gamemonetize.com/960f0t0d0xo4pdmdar46bui34lxe3ndk/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68899",
    "slug": "fragile-balance",
    "title": "Fragile Balance",
    "description": "Can you maintain the fragile balance? In Fragile Balance, you must carefully drop brick blocks onto a platform, trying not to tip the scale. One wrong move &mdash; and it all comes crashing down! Test your precision, patience, and steady hand in this minimalist yet addictive game. Fragile Balance is a physics-based arcade game where the player drops brick blocks onto a narrow platform. The goal is to build the highest and most stable tower possible without causing it to collapse. Every drop is a test of accuracy and balance.",
    "instructions": "Fragile Balance mdash test your skills and precision by dropping brick blocks onto a platform Don rsquo t let the tower fall Press the left mouse button or any part of your smartphone to drop the block onto the platform",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Block",
      "build",
      "Casual",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/9gt85xy3om372b2lwusxycx2msh4k90r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9gt85xy3om372b2lwusxycx2msh4k90r/",
    "sourceUrl": "https://html5.gamemonetize.com/9gt85xy3om372b2lwusxycx2msh4k90r/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68640",
    "slug": "alfa-romeo-coloring",
    "title": "Alfa Romeo Coloring",
    "description": "Alfa Romeo Coloring puts you behind the wheel of imagination. Grab your digital crayons and paint these cool cars in wild, wacky colors. Red? Blue? Rainbow wheels? Anything goes! Who says race cars have to be red? In Alfa Romeo Coloring, kids can design their dream rides in bright, bold, and goofy colors. It is like a car show in a crayon box!",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Boys",
      "Car",
      "Coloring",
      "Fun",
      "Girls",
      "HTML5",
      "Hypercasual",
      "Mobile",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/g8uzj3vlv6pmk61p2o8e2bgow84d4j9n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g8uzj3vlv6pmk61p2o8e2bgow84d4j9n/",
    "sourceUrl": "https://html5.gamemonetize.com/g8uzj3vlv6pmk61p2o8e2bgow84d4j9n/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68589",
    "slug": "little-hero-knight",
    "title": "Little Hero Knight",
    "description": "In Little Hero Knight, youll play the role of a brave little hero. Travel through a world full of monsters and keep fighting with your weapon. Build your defense towers and engage in a battle of wits and courage!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "arrow",
      "Defense",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/ieq59ij69onmbvdfjlh16mkupxsfg3ct/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ieq59ij69onmbvdfjlh16mkupxsfg3ct/",
    "sourceUrl": "https://html5.gamemonetize.com/ieq59ij69onmbvdfjlh16mkupxsfg3ct/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "68874",
    "slug": "hazard-heights",
    "title": "Hazard Heights",
    "description": "Hazard Heights is a fast-paced vertical action game where precision and timing are your only allies. Guide your player upward through increasingly dangerous territory, dodging enemy objects that zip horizontally across the screen. In the early stages, narrow passages offer some shelter, but soon the environment opens up, forcing you to navigate freely in an exposed, chaotic space &mdash; making every move count. Survive long enough and you&rsquo;ll reach your ultimate reward: your getaway car, waiting at the summit, ready to drive you away from the peril. The longer you ascend without collision, the higher your score climbs.",
    "instructions": "Use mouse-up to move ahead",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Alien",
      "Car",
      "Race",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/j3696t3w3nl7d05dvrsvxzaulvnd587j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j3696t3w3nl7d05dvrsvxzaulvnd587j/",
    "sourceUrl": "https://html5.gamemonetize.com/j3696t3w3nl7d05dvrsvxzaulvnd587j/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68701",
    "slug": "mr-shinchan-crayon-solving",
    "title": "Mr Shinchan Crayon Solving",
    "description": "From the popular game Crayon shin-chan Little Helper , you can enjoy a variety of challenges while playing! There are many things you can do such as cleaning up or washing clothes, even shopping and care for pets and fishing goldfish Even if you dont know the method or order, just play with shin-chan and can be very happy! Through the playing house games, you can play a lot of little helper missions! all content that can be enjoyed regardless of age!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Anime",
      "Baby Games",
      "Baby Hazel",
      "Cartoon",
      "Coloring"
    ],
    "thumbnail": "https://img.gamemonetize.com/wkokj30hsjf5iwczg486ovsv1w8tc6xc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wkokj30hsjf5iwczg486ovsv1w8tc6xc/",
    "sourceUrl": "https://html5.gamemonetize.com/wkokj30hsjf5iwczg486ovsv1w8tc6xc/",
    "width": 960,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "68965",
    "slug": "jet-escape",
    "title": "Jet Escape",
    "description": "The objective of the game is to climb as far as you can without colliding with any obstacles. You control a character who must jump and dodge in a vertical world filled with danger. The further you go, the harder it gets, with faster movement and trickier traps. Along the way, you can unlock various fun and colorful characters, each bringing a unique style to your run. With simple controls and endless challenge, every climb is a chance to beat your best score.",
    "instructions": "Use the mouse or touch to interact Use A ndash D move player",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Best",
      "cannon",
      "games for your website",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/3leqjwbt1icvillxjrts2w65i2giiwb7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3leqjwbt1icvillxjrts2w65i2giiwb7/",
    "sourceUrl": "https://html5.gamemonetize.com/3leqjwbt1icvillxjrts2w65i2giiwb7/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66149",
    "slug": "shapehavoc3d",
    "title": "ShapeHavoc3D",
    "description": "Move the tablet forward. Randomly shaped obstacles will appear ahead. Before the tablet reaches the obstacle, click on the tablet to transform it into the shape of the obstacle. It greatly tests your hand speed and is extremely thrilling. Come and give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Best Games",
      "Game",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/rwgone04vfprtymtwcjtfir1heto510d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rwgone04vfprtymtwcjtfir1heto510d/",
    "sourceUrl": "https://html5.gamemonetize.com/rwgone04vfprtymtwcjtfir1heto510d/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68957",
    "slug": "one-line-drawling",
    "title": "One Line Drawling",
    "description": "Welcome to One Line Drawing, a game that brings together a variety of line drawing gameplays. You can relax through relaxing line drawing gameplay, or challenge yourself through puzzle-type line drawing gameplay.",
    "instructions": "Through the easy one line drawing gameplay you can relax your stress and experience a relaxing and enjoyable game time",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Drawing"
    ],
    "thumbnail": "https://img.gamemonetize.com/8kdv7gev1fq44rhf9so20ez4anotg4fs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8kdv7gev1fq44rhf9so20ez4anotg4fs/",
    "sourceUrl": "https://html5.gamemonetize.com/8kdv7gev1fq44rhf9so20ez4anotg4fs/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68891",
    "slug": "temple-targets",
    "title": "Temple Targets",
    "description": "Temple Targets is a mind-bending goal-hitting puzzle game that challenges your planning skills and precision. Your mission: guide your player-object through ancient temple chambers filled with mystical reflectors, calculating the perfect path to hit the hidden targets. Each reflector alters your trajectory by 90 degrees, so careful planning is key to mastering every level.",
    "instructions": "Plan and shoot Click to change oritentation direction of objects",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Puzzle",
      "Shoot 'Em Up",
      "temple"
    ],
    "thumbnail": "https://img.gamemonetize.com/78paq8dhn2k08zreaxdr6hdcmh1epgwe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/78paq8dhn2k08zreaxdr6hdcmh1epgwe/",
    "sourceUrl": "https://html5.gamemonetize.com/78paq8dhn2k08zreaxdr6hdcmh1epgwe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68566",
    "slug": "betweenmarine",
    "title": "Betweenmarine",
    "description": "Guide your submarine through the obstacles for as long as you can to gain points and best your high score. Web Dev <a href='https://www.gameonanyscreen.com/'>https://www.gameonanyscreen.com/</a>",
    "instructions": "Simply use your finger to guide the submarine with your touchscreen or use W A S and D slash the arrow keys",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/d393rqdfe4h6h9zk25nzv2459pnqeelq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d393rqdfe4h6h9zk25nzv2459pnqeelq/",
    "sourceUrl": "https://html5.gamemonetize.com/d393rqdfe4h6h9zk25nzv2459pnqeelq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68671",
    "slug": "lovely-cat-pet-life",
    "title": "Lovely Cat Pet Life",
    "description": "Call for all pet lovers! If you are a DIY enthusiast or enjoy playing with cute animals, join Lovely Cat: Pet Life, a casual DIY cat game online. Dive into this adorable, fun-filled, and creative game that combines the elements of cats, pets, fashion, and DIY all in one perfect package! Play dress-up game: Try out charming suits on your pet. Decorate an ideal look for your kitten. Enjoy minigames unblocked: Join mini animal parkour games with your little cat.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Cat",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/zkcddm2uqwzbr4z31wn3dsrblxzenaev/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zkcddm2uqwzbr4z31wn3dsrblxzenaev/",
    "sourceUrl": "https://html5.gamemonetize.com/zkcddm2uqwzbr4z31wn3dsrblxzenaev/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "66148",
    "slug": "cubeblast",
    "title": "CubeBlast",
    "description": "Two or more adjacent blocks of the same color can be clicked to eliminate them. The more adjacent blocks there are, the more special blocks will be generated when clicked. Clicking on the special blocks will produce powerful force. Eliminate the blocks needed in the level to win. Come and give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Best Games",
      "Candy",
      "Hypercasual",
      "Match 3"
    ],
    "thumbnail": "https://img.gamemonetize.com/1z71ur1g7az36nqxvpv69hbellzmx9lg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1z71ur1g7az36nqxvpv69hbellzmx9lg/",
    "sourceUrl": "https://html5.gamemonetize.com/1z71ur1g7az36nqxvpv69hbellzmx9lg/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64777",
    "slug": "word-maze",
    "title": "Word Maze",
    "description": "Word Maze is a brain-boosting puzzle game where words and mazes collide! Sharpen your vocabulary and problem-solving skills as you navigate twisting paths of letters to form words and unlock each level. How to play: Swipe through the letter maze to connect and create valid words. Solve the puzzle by finding all hidden words. Use hints if you get stuck, and keep your mind sharp as levels get harder! With a clean interface, relaxing music, and thousands of challenging levels, Word Maze offers endless fun for word lovers of all ages. Whether you&rsquo;re a casual puzzler or a word search pro, you&rsquo;ll love the blend of logic and language.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/k4fe068va7dwcxuk73twcbthf9mbnkz5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k4fe068va7dwcxuk73twcbthf9mbnkz5/",
    "sourceUrl": "https://html5.gamemonetize.com/k4fe068va7dwcxuk73twcbthf9mbnkz5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68468",
    "slug": "defeat-the-witch",
    "title": "Defeat The Witch",
    "description": "You are a Castlevania soldier, and it is up to you to kill the witches in the castle and occupy the castle. Try to see how many levels you can reach. Just click to operate.",
    "instructions": "Click or Touch",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Adventure",
      "Mobile",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/9lcuehhwrgc8h9oqr36mbcffhtsufrbz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9lcuehhwrgc8h9oqr36mbcffhtsufrbz/",
    "sourceUrl": "https://html5.gamemonetize.com/9lcuehhwrgc8h9oqr36mbcffhtsufrbz/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68233",
    "slug": "zombsmis",
    "title": "ZombsmiS",
    "description": "You are responsible for life and peace in a simulation village after a zombie apocalypse, you need to monitor your groups vital signs and prevent the wall from falling, sometimes your villagers can make decisions themselves. Just Simulate! How long can you hold out?",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Simulator",
      "survival",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/86wql13clu8uezt2fx9fnl0ugslh85d1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/86wql13clu8uezt2fx9fnl0ugslh85d1/",
    "sourceUrl": "https://html5.gamemonetize.com/86wql13clu8uezt2fx9fnl0ugslh85d1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68886",
    "slug": "coin-collector",
    "title": "Coin Collector",
    "description": "Welcome to Coin Collector! Move your character to catch shiny falling coins while dodging dangerous bombs. Quick reflexes and sharp eyes will earn you a high score. Can you collect the fortune without getting blown up? Lives, score counter, and sound effects Bright cartoon graphics and smooth movement Works on mobile and desktop Random coin/bomb patterns for replayability Addictive and quick-paced gameplay",
    "instructions": "Drag or tap sides to move left right Catch falling coins to earn points Avoid falling bombs ndash hitting one loses a life Game over when lives reach zero Background animation for immersive gameplay Simple and fun for all ages",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Arcade",
      "Bomb",
      "Boy",
      "Collecting",
      "endless",
      "Fun",
      "Girl",
      "Gold",
      "Relaxation",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/fzfkma6ilfsojvec4a3u6sowy5qt3tqw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fzfkma6ilfsojvec4a3u6sowy5qt3tqw/",
    "sourceUrl": "https://html5.gamemonetize.com/fzfkma6ilfsojvec4a3u6sowy5qt3tqw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68861",
    "slug": "aim-master",
    "title": "Aim Master",
    "description": "Aim. Shoot. Score! Test your precision in this satisfying stickman shooting challenge. Drag your aim to line up the perfect shot, then fire! Score exactly 10 to pass the level &mdash; miss, and you&rsquo;re out of bullets! With smooth camera shakes, satisfying effects, and tricky moving targets, only the sharpest shooters will survive. Think youre accurate enough? Play now and prove it!",
    "instructions": "Mouse Click Tap ndash Shoot a bullet Aim Reticle ndash Automatically moves based on level Retry Button ndash Restart current level after failing",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/psizgzz3jnafzlmnpctk8bxcfc1jfmk0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/psizgzz3jnafzlmnpctk8bxcfc1jfmk0/",
    "sourceUrl": "https://html5.gamemonetize.com/psizgzz3jnafzlmnpctk8bxcfc1jfmk0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68912",
    "slug": "the-gungame",
    "title": "The Gungame",
    "description": "Become the gun master in the classic physics-based shooting game. Before you play with real guns check out The GunGame instead! Choose a weapon, move into the firing zone and blast all moving targets before they can reach you. Try to complete increasingly challenging tasks, unlock new features and purchase more guns and weapons.",
    "instructions": "Use the mouse or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Army",
      "Bullet",
      "Defense",
      "Gun",
      "html5 games for your site",
      "kiz10",
      "Levels",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/r8cbz6fzaaeki3m0logah9z9d48zft4t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r8cbz6fzaaeki3m0logah9z9d48zft4t/",
    "sourceUrl": "https://html5.gamemonetize.com/r8cbz6fzaaeki3m0logah9z9d48zft4t/",
    "width": 1100,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68867",
    "slug": "kids-amusement-park",
    "title": "Kids Amusement Park",
    "description": "Welcome to Kids Aumsement Park, a collection of online casual minigames for kids. Are you a frequent visitor to amusement parks? Do you enjoy fun and relaxing games of various kinds? This casual game will satisfy all your needs for fun and casual games. In Kids Amusement Park, you can access a vast collection of minigames. If you are a competitive sports lover, join the basketball game. If you enjoy playing with animals, join animal catching.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Games",
      "Relaxation",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/5uw2ufeqkv78rtyz0j26m8flh91xpeuw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5uw2ufeqkv78rtyz0j26m8flh91xpeuw/",
    "sourceUrl": "https://html5.gamemonetize.com/5uw2ufeqkv78rtyz0j26m8flh91xpeuw/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68353",
    "slug": "eye-art-magic-eye-makeup",
    "title": "Eye Art: Magic Eye Makeup",
    "description": "Are you crazy about fashion design? Have you ever dreamed of becoming a makeover artist? Do you love dress-up games or makeup games? If your answer is YES, then Eye Art: Magic Eye Makeup is designed just for you. Here, you are free to apply eye makeup to the model. More than this, you can also match beautiful clothes and accessories for her.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby Games",
      "Dress Up",
      "Kid"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ldqa4w2si786h9nv4ozr5gt6l7oxbt8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ldqa4w2si786h9nv4ozr5gt6l7oxbt8/",
    "sourceUrl": "https://html5.gamemonetize.com/2ldqa4w2si786h9nv4ozr5gt6l7oxbt8/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68534",
    "slug": "sprunki-run",
    "title": "Sprunki Run",
    "description": "Begin an endless run filled with laughter, challenges and surprises. In Sprunki Run, youll take control of the adorable Sprunki team and run on a vibrant platform. You need to choose the proper numbered doors. Keep growing your team. Avoid the rolling spikes, jump over obstacles and reach the finish line!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Obstacle",
      "running",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/woy18av1rsbz0xpvt67k4oxzjs6c3ncs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/woy18av1rsbz0xpvt67k4oxzjs6c3ncs/",
    "sourceUrl": "https://html5.gamemonetize.com/woy18av1rsbz0xpvt67k4oxzjs6c3ncs/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68620",
    "slug": "brainrot-merge",
    "title": "Brainrot Merge",
    "description": "Get ready for a weirdly satisfying evolution puzzle! In Brainrot Merge, drop creatures like Tun-Tun-Tun Sahur, Chimpanzini-Bananini, and Spioniro-Golubiro. Watch them bounce, roll, and merge into even stranger beings! A mix of physics and pure absurdity &mdash; perfect for when your brain needs a break.",
    "instructions": "- Drag left or right to choose where to drop the creature - When identical creatures touch mdash they merge - Merged creatures evolve into new forms - The higher the level the more points you earn",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Matching",
      "Sahur",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/j00jvss4g2nby7optz97bp2xtj1wy6nu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j00jvss4g2nby7optz97bp2xtj1wy6nu/",
    "sourceUrl": "https://html5.gamemonetize.com/j00jvss4g2nby7optz97bp2xtj1wy6nu/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68787",
    "slug": "italian-brainrot-merge",
    "title": "Italian Brainrot Merge",
    "description": "Dive into chaos with Italian Brainrot Merge! From Tung Tung Sahur to Tralalero Tralala, from Cappuccino Ballerina to Brr Brr Patapim, collect and merge the most absurd Italian brainrot characters. Combine two of the same, watch them evolve, and fill your board with the strangest, funniest icons you&rsquo;ve ever seen. The more you merge, the crazier it gets. Unlock them all, rack up points, and enjoy the most unhinged puzzle experience!",
    "instructions": "Drag with your mouse or tap and drag to drop a character Merge two of the same type to reveal a brand new one Discover all the wild ones Tung Tung Sahur Bombardiro Crocodilo Trippi Troppi and more Keep merging to grow your score and avoid running o",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Fun",
      "Funny",
      "Italian Brainrot",
      "Puzzle",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/eoucplyzhq0f2j0ls9iszsist8c7gxac/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/eoucplyzhq0f2j0ls9iszsist8c7gxac/",
    "sourceUrl": "https://html5.gamemonetize.com/eoucplyzhq0f2j0ls9iszsist8c7gxac/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68895",
    "slug": "nugget-valley",
    "title": "Nugget Valley",
    "description": "Nugget Valley is an exciting gold mining adventure where you take on the role of a determined prospector in search of fortune. Your mission: mine rich deposits, collect shiny gold nuggets, and carry them safely back to your base while navigating treacherous terrain and obstacles. The deeper you dig and the more you haul, the greater your rewards &mdash; but only the most skilled miners can master the valley&rsquo;s challenges!",
    "instructions": "Click in the direction to pick any object",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Gold",
      "Mine",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/c9zpeqi8mzp4nj5ifcphpfsrr64vr7q3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c9zpeqi8mzp4nj5ifcphpfsrr64vr7q3/",
    "sourceUrl": "https://html5.gamemonetize.com/c9zpeqi8mzp4nj5ifcphpfsrr64vr7q3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68898",
    "slug": "tec-tak-toe-pro",
    "title": "Tec Tak Toe Pro",
    "description": "Tec Tak Toe Pro &ndash; The Ultimate Tic Tac Toe Challenge! Step into the world of Tec Tak Toe Pro, where classic strategy meets modern excitement! Battle against a smart AI opponent in a vibrant, animated game board using stunning green, red, and violet colors. Play as X and outsmart the computer! Watch Rewarded Ads to unlock powerful perks &mdash; like removing your opponent&rsquo;s move! Victory Animations make each win feel legendary, while defeat animations add extra drama. Features: AI opponent for solo challenges Animated win/loss effects Colorful and modern design Rewarded ads for game-changing advantages Fully responsive",
    "instructions": "Tap Click on a Cell Place your symbol X or O in the selected cell Rewarded Ad Button Watch an ad to remove the opponent rsquo s last move and get another chance to play in that spot This gives you a strategic advantage Reset Button Start a new gam",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "2048",
      "amazing"
    ],
    "thumbnail": "https://img.gamemonetize.com/8rmp9fpj8vfuqnuc8xw30evhokiwu4cc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8rmp9fpj8vfuqnuc8xw30evhokiwu4cc/",
    "sourceUrl": "https://html5.gamemonetize.com/8rmp9fpj8vfuqnuc8xw30evhokiwu4cc/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68006",
    "slug": "pick-and-patch",
    "title": "Pick and Patch",
    "description": "Pick and Patch is a fun matching puzzle game where pieces of a picture are missing, and it&rsquo;s your job to fix it! Each level shows a character or object with blank spots. You have to pick the correct pieces from the options and place them in the right place. Its simple, fun, and great for improving attention and visual memory.",
    "instructions": "Desktop Mouse Click Drag Pick and place the correct patch into the blank spot Mobile Tap Drag Pick and place the correct patch into the blank spot",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "HTML",
      "HTML5",
      "Hypercasual",
      "Kids",
      "Matching",
      "NapTech Games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/0hvpeh7isix8tk9003wger45add5he5q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0hvpeh7isix8tk9003wger45add5he5q/",
    "sourceUrl": "https://html5.gamemonetize.com/0hvpeh7isix8tk9003wger45add5he5q/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68914",
    "slug": "tralalero-tralala-jeep-adventure",
    "title": "Tralalero Tralala Jeep Adventure",
    "description": "Tralalero Tralala Jeep Adventure is a bumpy ride of giggles and thrills. Hop into your silly jeep and zoom through twisty tracks full of wobbly fun. Collect shiny coins like a treasure-hungry raccoon on a candy spree. Dodge loony obstacles, bounce like jelly, and honk your way to the finish.",
    "instructions": "W A S D to drive",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Boys",
      "Brainrot Italian",
      "Car",
      "Collecting",
      "Driving",
      "Hypercasual",
      "Italian Brainrot",
      "jeep",
      "Kids",
      "Mobile",
      "Tralalero Tralala"
    ],
    "thumbnail": "https://img.gamemonetize.com/an6ivuc0bf2mlmeccxpgmoy62cdn196v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/an6ivuc0bf2mlmeccxpgmoy62cdn196v/",
    "sourceUrl": "https://html5.gamemonetize.com/an6ivuc0bf2mlmeccxpgmoy62cdn196v/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68880",
    "slug": "match-fighter",
    "title": "Match Fighter",
    "description": "Match Fighter is a vibrant match-3 fighting game where classic martial arts meet puzzle action! Play as a skilled warrior and take on a series of powerful opponents. Match tiles to strike and unleash special moves in intense one-on-one duels. Every combo you make fuels your fighting spirit. Outsmart your enemies, climb the ranks, and prove yourself as the ultimate martial arts champion! Can you match your way to victory?",
    "instructions": "How to Play 1 Match 3 or more tiles of the same type to perform attacks 2 Build combos to deal more damage and charge your super move 3 Take turns with your opponent mdash plan your moves carefully 4 Defeat your enemy by reducing their health to",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player Games",
      "2D",
      "Battle",
      "Fight",
      "Fighting",
      "Match 3",
      "Match-3",
      "Match3"
    ],
    "thumbnail": "https://img.gamemonetize.com/9msfg45e79xq4jmoconwm2a2ra7xe2de/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9msfg45e79xq4jmoconwm2a2ra7xe2de/",
    "sourceUrl": "https://html5.gamemonetize.com/9msfg45e79xq4jmoconwm2a2ra7xe2de/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68252",
    "slug": "dazzling-divas-makeup",
    "title": "Dazzling Divas Makeup",
    "description": "Inspired by My Little Pony, this colorful dress-up game lets you unleash your creativity and create magical makeup looks for three fabulous girls: Lila, Mimi, and Roxy. Style each diva with makeup influences from iconic ponies like Fluttershy, Pinkie Pie, and Rainbow Dash, then complete their look with trendy tops and accessories. With endless outfit combos and a dash of sparkling magic, this game offers the ultimate glam experience for fashion lovers. Get ready to transform these divas into dazzling stars!",
    "instructions": "Use your mouse to play the game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "beauty",
      "Fashion",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/g3tate7kzysd4zq2vl4ci37nswhbhvs0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g3tate7kzysd4zq2vl4ci37nswhbhvs0/",
    "sourceUrl": "https://html5.gamemonetize.com/g3tate7kzysd4zq2vl4ci37nswhbhvs0/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68864",
    "slug": "number-master-run-and-merge",
    "title": "Number Master Run And Merge",
    "description": "Number Master: Run And Merge is an awesome number racing game that lets you run, merge, and upgrade on a parkour platform to become a true number master! Control your number character as you run through dynamic tracks. Keep collecting more numbers and expanding. Merge with matching numbers to grow stronger. The bigger your number, the more unstoppable you become! Pick the smartest paths, hit speed zones, and keep your speed maxed out!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Number",
      "Racing",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/tblpkzk6l9k17s7rd43dc36zgz7ht88m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tblpkzk6l9k17s7rd43dc36zgz7ht88m/",
    "sourceUrl": "https://html5.gamemonetize.com/tblpkzk6l9k17s7rd43dc36zgz7ht88m/",
    "width": 1136,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "68863",
    "slug": "dress-up-game-princess-doll-2",
    "title": "Dress Up Game Princess Doll 2",
    "description": "Are you an anime dress-up lover? Do you prefer playing princess doll dress-up games online? Are you a girl who is interested in fashion design? Welcome to Dress Up Game: Princess Doll, a casual girl game online. Dive into a world of fashion and realize all your dreams about fashion and dressing up. H5games4u provides a gaming platform where you are free to enter any of our games on your browser anytime, anywhere.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Design",
      "Dress Up",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/5vt2xenmk9j49nba4kj6ymf4txnsmxlg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5vt2xenmk9j49nba4kj6ymf4txnsmxlg/",
    "sourceUrl": "https://html5.gamemonetize.com/5vt2xenmk9j49nba4kj6ymf4txnsmxlg/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68866",
    "slug": "snowboard-game-party",
    "title": "Snowboard Game Party",
    "description": "Begin snow racing thrill in Snowboard Game Party. Its a high-energy multiplayer ski sport challenge. In this adrenaline-filled winter sports game, you&rsquo;ll join other players on dynamic ski tracks full of surprises. Flexibly control your hero and race against other opponents. While keeping your speed! Avoid snowballs, fences, sudden slopes, etc. Win races to earn points, unlock gear, and customize your style!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Multiplayer",
      "running",
      "Snow",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/e60tb5zjmg6wfnkaddqv8bji60h8gx50/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e60tb5zjmg6wfnkaddqv8bji60h8gx50/",
    "sourceUrl": "https://html5.gamemonetize.com/e60tb5zjmg6wfnkaddqv8bji60h8gx50/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68872",
    "slug": "rapid-apex-rush",
    "title": "Rapid Apex Rush",
    "description": "Rapid Apex Rush puts you in the driver&rsquo;s seat of an adrenaline-fueled formula-racing challenge! Master tight corners, plan your turns with precision, and harness powerful speed boosts to stay ahead of the pack. As you navigate high-speed circuits, youll need sharp reflexes to dodge rival vehicles and hazards while plotting the fastest racing line.",
    "instructions": "Use arrow keys to turn and use instructions in game",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Best Games",
      "Cars",
      "Multiplayer",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/jp22mjv7m4b283qu7mhzsy599omxbi13/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jp22mjv7m4b283qu7mhzsy599omxbi13/",
    "sourceUrl": "https://html5.gamemonetize.com/jp22mjv7m4b283qu7mhzsy599omxbi13/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68444",
    "slug": "repo-androids-for-two",
    "title": "Repo androids for two",
    "description": "Repo androids for two - a team platformer for two players on one device. The peculiarity of these androids is that they can fold and turn into mini-androids. In addition, the game has physics, which makes passing levels an insanely fun activity!",
    "instructions": "Controls on PC Red WAD - movement S - Turn into a mini-android Blue larr rarr uarr - movement darr - Turn into a mini-android On mobile using the on-screen buttons The goal is to reach the star Help each other",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Android",
      "Arcade",
      "Best",
      "Best Games",
      "Cool",
      "Crazy",
      "free games for your site",
      "Mobile",
      "Physics",
      "Platform",
      "two player games"
    ],
    "thumbnail": "https://img.gamemonetize.com/63y8xp0cin5ls6ujx19662u0tuwvaz5v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/63y8xp0cin5ls6ujx19662u0tuwvaz5v/",
    "sourceUrl": "https://html5.gamemonetize.com/63y8xp0cin5ls6ujx19662u0tuwvaz5v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68311",
    "slug": "tung-sahur-italien-brainrot",
    "title": "Tung Sahur Italien Brainrot",
    "description": "Dive into the world of Italian Brainrot Evolution : A Fun &amp; Casual 2048 Puzzle Game! CAN YOU UNLOCK ALL OF THEM? Tung Tung Tung Sahur Tralalero Tralala Bombardiro Crocodilo Ballerina Cappuccina Brr Brr Patapim Lirili Larila Trippi Troppi Cappuccino Assassino Chimpanzini Bananini Boneca Ambalabu Frigo Camelo Giraffa Celeste Burbaloni Lulliloli Trulimero Trulicina Tric Trac Barabum U Din Din Din Din Dun and many more Italian Brainrot, Indonesian Brainrot Animals to unlock!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bomb",
      "Boys",
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Coloring",
      "Puzzle",
      "Sahur",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/0khp6yxfvfzeyxc65krkzfio6l9ujwpw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0khp6yxfvfzeyxc65krkzfio6l9ujwpw/",
    "sourceUrl": "https://html5.gamemonetize.com/0khp6yxfvfzeyxc65krkzfio6l9ujwpw/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "54054",
    "slug": "word-blocks",
    "title": "Word Blocks",
    "description": "In the vast landscape of communication, words are the building blocks of expression, the atoms that construct the molecules of meaning. They are not merely sounds or symbols but vessels of thought, carrying the weight of ideas, emotions, and intentions. Each word is a tiny universe unto itself, with its own history, connotations, and nuances. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "Boys",
      "Mentolatux",
      "Puzzle",
      "Unity3D",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/hppar6ddbbis1rd0hadzb73c0i6yjat0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hppar6ddbbis1rd0hadzb73c0i6yjat0/",
    "sourceUrl": "https://html5.gamemonetize.com/hppar6ddbbis1rd0hadzb73c0i6yjat0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68777",
    "slug": "celebrity-barbiecore-aesthetic-look",
    "title": "Celebrity BarbieCore Aesthetic Look",
    "description": "Welcome to Celebrity BarbieCore Aesthetic Look. Step into the glamorous world of celebrity fashion with this game! Six famous stars are inspired by BarbieCore&rsquo;s iconic style and are eager to try her trends. From dazzling red carpet gowns to chic streetwear, they&rsquo;ll explore the diverse range of BarbieCore aesthetics. Experiment with stunning hairstyles, flawless makeup, and luxurious accessories. Become their personal stylist and guide them to embody the essence of BarbieCore&rsquo;s fashion-forward allure. Unleash your creativity and make them shine like true style icons!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Barbie",
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/xp0vfhnwdhhniu52fyb1vu3lezbl85vm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xp0vfhnwdhhniu52fyb1vu3lezbl85vm/",
    "sourceUrl": "https://html5.gamemonetize.com/xp0vfhnwdhhniu52fyb1vu3lezbl85vm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68820",
    "slug": "tic-tac-toe-html",
    "title": "tic tac toe html",
    "description": "Enjoy a classic game of Tic Tac Toe, now available in HTML! Challenge your friends or play against the computer in this simple yet addictive game. With an easy-to-use interface, its perfect for all ages. Test your strategy and see if you can win before your opponent! Web Dev <a href='https://freecrazygames.io/'>https://freecrazygames.io/</a>",
    "instructions": "Mouse click",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "Brain"
    ],
    "thumbnail": "https://img.gamemonetize.com/upf7jow3akcirma7ysj1ku0j2m0vn4fi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/upf7jow3akcirma7ysj1ku0j2m0vn4fi/",
    "sourceUrl": "https://html5.gamemonetize.com/upf7jow3akcirma7ysj1ku0j2m0vn4fi/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67070",
    "slug": "ballfall",
    "title": "BallFall",
    "description": "Control the small ball to fall from the top to the bottom. The game has multiple levels, and each level randomly generates multiple platforms. You need to control the small ball to fall through the gaps of the tablet to avoid hitting traps. Come and give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "Ball",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/dzq93k974fw1sl2hwrkis1r5jc47ohou/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dzq93k974fw1sl2hwrkis1r5jc47ohou/",
    "sourceUrl": "https://html5.gamemonetize.com/dzq93k974fw1sl2hwrkis1r5jc47ohou/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68875",
    "slug": "fin-flinger",
    "title": "Fin Flinger",
    "description": "Fin Flinger is a fun and fast-paced slingshot game where you take aim and launch fish to hit target fishes hiding in clever small-home-style arrangements. Test your precision as you fling your finned friends across the playfield to topple structures and hit every target fish to clear each level!",
    "instructions": "Aim and Propel",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Air",
      "Best Games",
      "Casual",
      "Fish"
    ],
    "thumbnail": "https://img.gamemonetize.com/j4j0ucs81t2ds1mps9mi72i6649g50s2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j4j0ucs81t2ds1mps9mi72i6649g50s2/",
    "sourceUrl": "https://html5.gamemonetize.com/j4j0ucs81t2ds1mps9mi72i6649g50s2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68876",
    "slug": "snake-nokia-classic",
    "title": "Snake Nokia Classic",
    "description": "Relive the legendary mobile gaming era with Snake Nokia Classic, a faithful tribute to the iconic game that defined generations. Guide your pixelated snake through a glowing green grid, eat the food to grow longer, and avoid crashing into yourself. Simple, fast, and addictively challenging&mdash;just like the original.",
    "instructions": "WASD arrow keys to move",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Classic",
      "Collecting",
      "Simulation",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/xjd7qcm24nhpiletzxw22rpr5ieq3z9q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xjd7qcm24nhpiletzxw22rpr5ieq3z9q/",
    "sourceUrl": "https://html5.gamemonetize.com/xjd7qcm24nhpiletzxw22rpr5ieq3z9q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68715",
    "slug": "hungry-shark-evolution-2",
    "title": "Hungry Shark Evolution 2",
    "description": "Hungry Shark is back in this epic arcade game where you control a monstrous sea beast! Dive into an ocean adventure that&rsquo;s bigger, wilder, and more thrilling than ever. Feed your shark&rsquo;s appetite by devouring everything in sight: from bite-size fish to unsuspecting beachgoers, and become the fiercest predator in the sea!",
    "instructions": "Use the keyboard or touch buttons to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "angry",
      "Blood",
      "eating",
      "html games for your website",
      "Hypercasual",
      "kiz10",
      "Monster",
      "Shark"
    ],
    "thumbnail": "https://img.gamemonetize.com/gnkny154qy6pptg91mychnfnhloxwlep/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gnkny154qy6pptg91mychnfnhloxwlep/",
    "sourceUrl": "https://html5.gamemonetize.com/gnkny154qy6pptg91mychnfnhloxwlep/",
    "width": 1024,
    "height": 576,
    "lastUpdated": ""
  },
  {
    "id": "68709",
    "slug": "relax-land-mini-challenge-game",
    "title": "Relax Land: Mini Challenge Game",
    "description": "This hilarious game is packed with wacky mini-games, strange sounds, and unpredictable challenges that will leave you thinking, Did that really just happen?! Game Features: - Hilarious Mini-Games: A mix of silly challenges to keep you entertained for hours. - Funny Sound Effects &amp; Crazy Animations: Enjoy wild sounds and animations that add to the fun! - Meme-Inspired Challenges: Play through the latest meme-based challenges for maximum laughs. - Endless Variety: No two games are alike&mdash;each challenge is completely random! - Perfect for Stress Relief: Unwind with endless fun and let go of your stress!",
    "instructions": "Inspired by trending AI memes each mini-game brings a new level of randomness and comedy Tap swipe and react to quirky challenges that rsquo ll keep you laughing non-stop",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Funny",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/rtuess9r7kgw39vzbkvsllzspp1vap7f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rtuess9r7kgw39vzbkvsllzspp1vap7f/",
    "sourceUrl": "https://html5.gamemonetize.com/rtuess9r7kgw39vzbkvsllzspp1vap7f/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68711",
    "slug": "my-arcade-center",
    "title": "My Arcade Center",
    "description": "In My Arcade Center, play a fun arcade simulation. You build, manage, and grow your very own retro game empire. From humble beginnings to becoming an idle tycoon. You&rsquo;re in control of it all! Buy a few machines and gradually expand your arcade center. Upgrade your games, attract more visitors, and keep the arcade buzzing with activity. Hire staff and enjoy the perfect mix of idle gameplay and management simulation - continuous production of Ultraman to give customers perfect service.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "build",
      "Machine",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/lrai63tp6xcbvdda6c6s1lne4d0ubz3u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lrai63tp6xcbvdda6c6s1lne4d0ubz3u/",
    "sourceUrl": "https://html5.gamemonetize.com/lrai63tp6xcbvdda6c6s1lne4d0ubz3u/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68718",
    "slug": "tung-sahur-bots-chase-room",
    "title": "Tung Sahur Bots Chase Room",
    "description": "Horror brainrot bots are on the hunt! Watch out, stay alive! Welcome to Tung Sahur Bots Chase Room &ndash; the ultimate brainrot meme horror escape game! Get ready for heart-pounding chases as you find yourself trapped in backroom full of unpredictable Tung Tung Tung Tung Sahur, Tralalero Tralala Bots and other viral meme creatures. Can you keep up with the chaos, dodge the brainrot traps, and make it out alive? Only the fastest runners will escape this nightmare.",
    "instructions": "With Tung Tung Tung Tung Sahur Bombardiro Crocodilo and a whole bunch of internet rsquo s wildest memes on your tail survival is the only goal Can you outsmart them and escape the maze",
    "category": "3D",
    "genres": [
      "3D"
    ],
    "tags": [
      "Escape",
      "Horror",
      "run",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/7hfhiqikwaghn6987qszyx377wo53rq3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7hfhiqikwaghn6987qszyx377wo53rq3/",
    "sourceUrl": "https://html5.gamemonetize.com/7hfhiqikwaghn6987qszyx377wo53rq3/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68537",
    "slug": "marble-spiral",
    "title": "Marble Spiral",
    "description": "Target the same color ball and smash the same color ball. Your goal is to match 3 or more marbles of the same color to destroy them and earn points. Prevent the marbles from reaching the end or youll lose a life.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/91bpo9c0m4i3jhc89iaes8sbr2wdf7h8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/91bpo9c0m4i3jhc89iaes8sbr2wdf7h8/",
    "sourceUrl": "https://html5.gamemonetize.com/91bpo9c0m4i3jhc89iaes8sbr2wdf7h8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68704",
    "slug": "drive-io",
    "title": "Drive.IO",
    "description": "Drive.IO is a smart traffic control game where you take charge of managing cars at busy city intersections! Your goal is to let vehicles pass at the right time to avoid crashes. Be quick, precise, and alert &mdash; one mistake can lead to a traffic disaster! Control multiple cars at once, test your reflexes, and enjoy a colorful low-poly city full of life. How long can you keep the roads safe",
    "instructions": "Use the computer mouse to stop the car",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Car",
      "city",
      "Parking",
      "Train"
    ],
    "thumbnail": "https://img.gamemonetize.com/ujr8h44aiw5km3mp3g8srxlfuwcmn1pw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ujr8h44aiw5km3mp3g8srxlfuwcmn1pw/",
    "sourceUrl": "https://html5.gamemonetize.com/ujr8h44aiw5km3mp3g8srxlfuwcmn1pw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68656",
    "slug": "skibidi-toilet-evolution-mod",
    "title": "Skibidi Toilet  Evolution Mod",
    "description": "In Monster Battle toilet games like Skibidi Toilet Evolution Mod you can take on the role of a strategic Battle Master, defeating toilet warriors by synthesizing fight monster! Toilet games emphasize thinking, make key decisions that affect victory or defeat!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "roblox",
      "Robot",
      "Skibidi",
      "Skibidi Toilet"
    ],
    "thumbnail": "https://img.gamemonetize.com/y9oqwld92l90nfnhoigqkcpdrf5nadtx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/y9oqwld92l90nfnhoigqkcpdrf5nadtx/",
    "sourceUrl": "https://html5.gamemonetize.com/y9oqwld92l90nfnhoigqkcpdrf5nadtx/",
    "width": 600,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "68394",
    "slug": "cat-suika",
    "title": "Cat Suika",
    "description": "Cat Suika is a relaxing and adorable merge puzzle game with a feline twist! Drop fluffy cats from the top and try to match two of the same breed to merge them into a new one. Each merge unlocks a new cat breed, from Persian and Siamese to Tuxedo and Calico. Inspired by the Suika game style, this version is all about cats &mdash; no fruits here! With soft colors, cozy sound effects, and charming animations, Cat Suika is perfect for players who enjoy casual puzzle games with a cute theme. Your goal is to unlock every single cat breed and chase the highest score! But beware &mdash; once the board is full, it&rsquo;s game over.",
    "instructions": "Use your mouse or touch screen to drop a cat onto the board When two cats of the same breed touch they merge into a new higher-level breed Keep merging cats to unlock all 11 adorable types Pay attention to where each cat lands as good placement is key",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Animal",
      "Cat",
      "Cute",
      "HTML5",
      "Matching",
      "Mobile",
      "Puzzle",
      "watermelon"
    ],
    "thumbnail": "https://img.gamemonetize.com/vyyh0e28gi85jp4rk3umxdyugsuu9p84/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vyyh0e28gi85jp4rk3umxdyugsuu9p84/",
    "sourceUrl": "https://html5.gamemonetize.com/vyyh0e28gi85jp4rk3umxdyugsuu9p84/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66625",
    "slug": "block-merge-city",
    "title": "Block Merge City",
    "description": "Block Merge City is a relaxing isometric puzzle game where you place and combine buildings to evolve them into bigger structures. Strategically plan your moves, score high, and avoid running out of space!",
    "instructions": "Click on an empty cell on the board to place the next block from the queue Match 3 or more identical blocks to merge them into a higher-level building Earn points and use hammers to remove unwanted blocks The game ends when no more placements are possi",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "building",
      "city",
      "Match 3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ikv6tvl28r0jhq0r003pcv0lhh6ckpr1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ikv6tvl28r0jhq0r003pcv0lhh6ckpr1/",
    "sourceUrl": "https://html5.gamemonetize.com/ikv6tvl28r0jhq0r003pcv0lhh6ckpr1/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68518",
    "slug": "egg-shooter-2",
    "title": "Egg Shooter 2",
    "description": "Egg Shooter is a fast-paced bubble shooter game with a fun eggy twist! Aim, shoot, and match three or more colorful eggs to crack them and clear the board. Use power-ups and combos to blast through tricky levels. With endless waves and increasing difficulty, only the sharpest shooters will survive! Easy to play, hard to master&mdash;perfect for quick sessions or long play. Can you become the ultimate egg blaster? Let&rsquo;s find out!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Bubble Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/9xlrmz5bnipd2hvqkktdjbohpw31byma/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9xlrmz5bnipd2hvqkktdjbohpw31byma/",
    "sourceUrl": "https://html5.gamemonetize.com/9xlrmz5bnipd2hvqkktdjbohpw31byma/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68678",
    "slug": "police-chase-2",
    "title": "Police Chase 2",
    "description": "Ready to join the nervous police car chase ever? Police Chase is an exciting racing driving game where you will play as a heroic police officer. Drive a high-speed police car and launch a frantic pursuit in the city streets! Operate your police car and maneuver your way through traffic! Lock on to the fugitives target and maintain accelerated accuracy to arrest the target. Keep upgrading your vehicles to unlock more cars.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "city",
      "Driving",
      "Police"
    ],
    "thumbnail": "https://img.gamemonetize.com/3vfcposqhcqxry8lugoqadmdpteoae3v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3vfcposqhcqxry8lugoqadmdpteoae3v/",
    "sourceUrl": "https://html5.gamemonetize.com/3vfcposqhcqxry8lugoqadmdpteoae3v/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68626",
    "slug": "mad-car-arena",
    "title": "Mad Car Arena",
    "description": "Buckle up for a wild solo ride! In Mad Car Arena, youll take control of a stunt-ready truck and race through vibrant tracks filled with jumps, obstacles, and tight turns. Test your reflexes, master the controls, and push your limits in this high-speed arena of chaos. How far can you go before crashing",
    "instructions": "use the mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "3D Games",
      "BMX",
      "crash",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/p6yezrjfbpztilf4uh9n1er6aunkhazq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p6yezrjfbpztilf4uh9n1er6aunkhazq/",
    "sourceUrl": "https://html5.gamemonetize.com/p6yezrjfbpztilf4uh9n1er6aunkhazq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68653",
    "slug": "skibidi-toilet-move-face",
    "title": "Skibidi Toilet Move Face",
    "description": "Welcome to Skibidi Toilet Move Face casual games, where youll embark on a journey in epic battlefield with brave warrior. These Casual Merge Games bring exquisite model and scene, immersing battle master in the strategic challenges between monsters and warriors. In Monster Battle toilet games, take on the role of a strategic Battle Master, defeating toilet warriors by synthesizing fight monster! Toilet games emphasize thinking, make key decisions that affect victory or defeat! In this Monster Battle casual game, battle master players use resources to build a army and engage in Monster Battle.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Battle",
      "Skibidi",
      "Skibidi Toilet"
    ],
    "thumbnail": "https://img.gamemonetize.com/x79mfdbq5pbodt57fy76bkowm2je8yb9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x79mfdbq5pbodt57fy76bkowm2je8yb9/",
    "sourceUrl": "https://html5.gamemonetize.com/x79mfdbq5pbodt57fy76bkowm2je8yb9/",
    "width": 600,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "68642",
    "slug": "dalgona-master",
    "title": "Dalgona Master",
    "description": "This engaging sweet game challenge invites you to carve delicate shapes out of honeycomb candy, immersing you in the delicate skill required to perfect each piece without breaking it. Game Features: - An array of Dalgona and honeycomb treats, each demanding a unique approach to cutting. - Master the candy challenge across multiple levels. - A diverse set of cookie-carving tools to achieve the perfect cut. - Enjoy beautifully designed dalgona candy that makes each session visually appetizing. - A perfect game for those who love precision, challenges, and, of course, sweets.",
    "instructions": "Your task is simple yet challenging carefully carve out various honeycomb shapes like hearts animals umbrellas etc from the crunchy Dalgona candy without cracking the entire piece Each level ups the ante with increasingly complex designs testing you",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Candy",
      "cut"
    ],
    "thumbnail": "https://img.gamemonetize.com/unmmql4hfo0hqaca1mstpffycp6o75b8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/unmmql4hfo0hqaca1mstpffycp6o75b8/",
    "sourceUrl": "https://html5.gamemonetize.com/unmmql4hfo0hqaca1mstpffycp6o75b8/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68611",
    "slug": "tralalero-tralala-five-difference",
    "title": "Tralalero Tralala Five Difference",
    "description": "Spot the Difference with a Twist of Tralalero. Get ready to giggle and squint with Tralalero Tralala Five Difference, a hilarious and colorful game of observation where no two pictures are quite the same. Kids will love this silly challenge full of quirky characters and surprising scenes!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Difference",
      "Fun",
      "Hypercasual",
      "Italian Brainrot",
      "Kids",
      "Logic",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/vg5wyas99x4yxky3e2ogjl4jx7o0r89v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vg5wyas99x4yxky3e2ogjl4jx7o0r89v/",
    "sourceUrl": "https://html5.gamemonetize.com/vg5wyas99x4yxky3e2ogjl4jx7o0r89v/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "68546",
    "slug": "duck-duck",
    "title": "Duck Duck",
    "description": "As a small and plucky duck, you set out on an exciting adventure through treacherous landscapes. Your ultimate goal is to collect a crucial key that will unlock the path forward, all while avoiding deadly sharp spikes that threaten to end your journey at every turn. With the key in hand and the path clear, youll finally be able to reach the door to the next challenging level, where new obstacles and surprises await. Will you be able to overcome the dangers and claim victory?",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/x7zbtxe85r6eg442x2b69vpce8w6g8qk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x7zbtxe85r6eg442x2b69vpce8w6g8qk/",
    "sourceUrl": "https://html5.gamemonetize.com/x7zbtxe85r6eg442x2b69vpce8w6g8qk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68560",
    "slug": "quiz-guess-the-country",
    "title": "Quiz Guess the Country",
    "description": "The colorful geography quiz game that turns learning maps into a fun and addictive challenge for all ages! Whether you&rsquo;re brushing up on world knowledge or racing against the clock, this vibrant shape-recognition trivia adventure will have you hooked in seconds! Choose your difficulty and test your memory and visual smarts by guessing countries based on their outlines. Tap the correct answer from multiple choices and rack up points as you speed through the world!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Casual",
      "Educational",
      "Fun",
      "Guessing",
      "Kids",
      "Mobile",
      "Quiz",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/j6wbon6dmm4ej1lfrz6mt3hcurx2l1sx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j6wbon6dmm4ej1lfrz6mt3hcurx2l1sx/",
    "sourceUrl": "https://html5.gamemonetize.com/j6wbon6dmm4ej1lfrz6mt3hcurx2l1sx/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68600",
    "slug": "critter-mahjong-solitaire",
    "title": "Critter Mahjong Solitaire",
    "description": "Critter Mahjong Solitaire is a fun and relaxing game where you match cute animal tiles. Join a group of happy jungle animals as you pair them up and complete each level before time runs out. If you get stuck, you can use hints to help. Finishing a level unlocks new challenges and keeps the fun going!",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "html5 games",
      "Mahjong",
      "Matching",
      "Mobile",
      "Puzzle",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/xilmr8uwpy6paduqr4cv7n7piir8wwtj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xilmr8uwpy6paduqr4cv7n7piir8wwtj/",
    "sourceUrl": "https://html5.gamemonetize.com/xilmr8uwpy6paduqr4cv7n7piir8wwtj/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "68579",
    "slug": "cat-girl-dress-up",
    "title": "Cat Girl Dress Up",
    "description": "Cat girl is a fictional character with human and feline characteristics. Customize this girl using your imagination and show it on social websites. Many fans appreciate catgirls because theyre cute and they suggest softness, cuddliness, aloofness, and hidden claws. The game was designed for mobile devices, but can be played even on a computer.",
    "instructions": "Mouse or finger depends on your device",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Cute",
      "Dress Up",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/09k2841ekemeepxozjpysibiw2txxtl8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/09k2841ekemeepxozjpysibiw2txxtl8/",
    "sourceUrl": "https://html5.gamemonetize.com/09k2841ekemeepxozjpysibiw2txxtl8/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68658",
    "slug": "math-mania",
    "title": "Math Mania",
    "description": "Math Mania is a fast-paced educational game where quick thinking is the key! Solve rapid-fire math equations by tapping if the answer is correct or if it&rsquo;s wrong&mdash;before the timer runs out. With each level, the speed increases and your brain will be pushed to the limit! Great for kids and adults alike, this game boosts math reflexes and rewards accuracy. Challenge your high score and become a mental math master! Mode: Single-player timed reflex game Levels: Endless, increasing speed Difficulty: Increases after every few correct answers Game Mechanics: Equations like &ldquo;5 + 3 = 9&rdquo; appear Tap if correct, if false Score System: +1 p.",
    "instructions": "Tap mobile Click desktop",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "Fun",
      "Highscore",
      "Kids",
      "Math",
      "Mind",
      "Mobile",
      "Number",
      "Puzzle",
      "Quiz",
      "Relaxation",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/tsgmnu7zf3a2fwkkncpcx08kgyhlazsw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tsgmnu7zf3a2fwkkncpcx08kgyhlazsw/",
    "sourceUrl": "https://html5.gamemonetize.com/tsgmnu7zf3a2fwkkncpcx08kgyhlazsw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68632",
    "slug": "super-stickman-dragon",
    "title": "Super Stickman Dragon",
    "description": "Find the truest and most powerful warrior with the Dragon ball z characters in the Super Stickman Dragon Warriors game. Earn Stars to unlock more warriors and destroy all the enemies.",
    "instructions": "Use the mouse or touch to control the warrior",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Action",
      "Dragon Ball Z",
      "Fighting",
      "free html5 games for your website",
      "Hypercasual",
      "kiz10",
      "Physics",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/77b5mbmq8ruyo6zqgdx6mu8zlvtab3um/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/77b5mbmq8ruyo6zqgdx6mu8zlvtab3um/",
    "sourceUrl": "https://html5.gamemonetize.com/77b5mbmq8ruyo6zqgdx6mu8zlvtab3um/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68633",
    "slug": "tap-to-color-painting-book",
    "title": "Tap To Color: Painting Book",
    "description": "Unleash your inner artist and paint your stress away with Tap to Color: Painting Book Game! Dive into a vibrant world of color where creating a masterpiece is as simple as a single tap. Forget the mess of crayons and paints; this is the ultimate digital coloring book for all ages. Find your calm and enter a state of flow as you bring beautiful illustrations to life. It&rsquo;s the perfect way to relax after a long day, pass the time on your commute,",
    "instructions": "Look at the palette of colors at the bottom of your screen Tap on a color to select it Simply tap on the areas to fill them with color Youll see the black-and-white sketch magically transform with every tap Continue selecting colors and coloring matc",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Coloring",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ec24zdv0mtkwigvj0ohazwnil7jlwyda/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ec24zdv0mtkwigvj0ohazwnil7jlwyda/",
    "sourceUrl": "https://html5.gamemonetize.com/ec24zdv0mtkwigvj0ohazwnil7jlwyda/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68592",
    "slug": "diy-doll-factory",
    "title": "DIY Doll Factory",
    "description": "Welcome to DIY Doll Factory. Here you will create your dream doll factory. Begin a running journey to collect doll parts and assemble a unique and exclusive doll by hand! Dash across fun platforms to collect more dolls. Choose skins, glasses, headgear, etc., and finally pack them up to complete your doll collection!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Collecting",
      "Fun",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/9jmutekimfw85gfmue42mfe52xvqbxh7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9jmutekimfw85gfmue42mfe52xvqbxh7/",
    "sourceUrl": "https://html5.gamemonetize.com/9jmutekimfw85gfmue42mfe52xvqbxh7/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68612",
    "slug": "name-breakdown-roast-or-boast",
    "title": "Name Breakdown Roast Or Boast",
    "description": "Name Breakdown: Roast or Boast is a playful app where you type any name or word, and each letter gets turned into a funny roast or a sweet compliment &mdash; depending on your mood. Choose Roast Mode for laughs or Boast Mode to hype someone up! You can copy, share, or download your result as an image, then send it to friends or post it on social media. Perfect for jokes, shoutouts, or just having&nbsp;fun&nbsp;with&nbsp;names!",
    "instructions": "Use your mouse or touchpad to enter a name or word then choose Roast or Boast mode to see the breakdown Copy share or download the result to enjoy with friends",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Crazy",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/3t1l1ofawi6w888fgv28uc1u2kdv0qhk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3t1l1ofawi6w888fgv28uc1u2kdv0qhk/",
    "sourceUrl": "https://html5.gamemonetize.com/3t1l1ofawi6w888fgv28uc1u2kdv0qhk/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68413",
    "slug": "lazy-gto-6",
    "title": "Lazy GTO 6",
    "description": "Step into the chaotic, laid-back streets of Lazy GTO 6 &mdash; an open-world sandbox adventure where you can walk, drive, or ride your way through a vibrant city pulsing with life and mischief. Whether youre cruising in a sports car, hopping on a motorcycle, or just wandering on foot, the freedom is all yours. Explore a massive urban playground full of possibilities &mdash; steal vehicles, race through traffic, or cause mayhem by mowing down unsuspecting pedestrians. With no rules holding you back",
    "instructions": "WASD - move F - getin out vehicle C - change camera",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "3D Games",
      "Action",
      "gta"
    ],
    "thumbnail": "https://img.gamemonetize.com/qkqlhh9cdmommm6c3ilugfwfk4k1kal1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qkqlhh9cdmommm6c3ilugfwfk4k1kal1/",
    "sourceUrl": "https://html5.gamemonetize.com/qkqlhh9cdmommm6c3ilugfwfk4k1kal1/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68607",
    "slug": "something-below-the-sea",
    "title": "Something below the Sea",
    "description": "A team of scientists spotted an area of the planet with an immense amount of garbage, seeing that this threatened marine life, they decided to create drones to remove this garbage, but something else is hidden...",
    "instructions": "AWSD or Analogic to Move Button P or Touch button Orange for Shoot",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Android",
      "Bubble Shooter",
      "Island",
      "Mobile",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/l6hbwlruocypoauh9z7e7697rriugqmw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l6hbwlruocypoauh9z7e7697rriugqmw/",
    "sourceUrl": "https://html5.gamemonetize.com/l6hbwlruocypoauh9z7e7697rriugqmw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67610",
    "slug": "gem-clicker-pro",
    "title": "gem clicker pro",
    "description": "Welcome to Gem Clicker Pro, the ultimate idle clicker experience that will keep you hooked for hours! Enter a mesmerizing world of sparkling diamonds and endless clicking fun. What Makes Gem Clicker Pro Special? Stunning Visual Effects: Watch as beautiful particles explode with every click, creating a satisfying visual feedback that makes each tap feel rewarding. Progressive Upgrade System: Start with simple clicks and evolve into a gem-collecting powerhouse with our comprehensive upgrade system. Rewarding Ad System: Every 50 clicks, watch a short advertisement to earn massive bonus rewards - up to 10x your current click power!",
    "instructions": "Basic Controls Primary Action Left Click or Tap on the central diamond to collect gems Each click awards gems based on your current click power Watch for visual effects and particle explosions with each successful click Game Interface Stats Panel Top",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      ".io",
      "Action",
      "Click",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/g57vca72wr68ebe46uz0t2hz5gdg7lem/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g57vca72wr68ebe46uz0t2hz5gdg7lem/",
    "sourceUrl": "https://html5.gamemonetize.com/g57vca72wr68ebe46uz0t2hz5gdg7lem/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65491",
    "slug": "guess-tiles",
    "title": "Guess Tiles",
    "description": "Memory game with fun 3d effects. Find pairs of tiles with the same pictures. Match the pairs twice in a row and unlock the bonus help button! Score the best number of points.",
    "instructions": "Controls by mouse for a computer or by touching the screen for mobile devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Brain",
      "Bricks",
      "Casual",
      "Cool",
      "Logic",
      "Memory",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/v3z04zubxirjp383zpy9855a0l4jgo3w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/v3z04zubxirjp383zpy9855a0l4jgo3w/",
    "sourceUrl": "https://html5.gamemonetize.com/v3z04zubxirjp383zpy9855a0l4jgo3w/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65039",
    "slug": "tic-tac-toe-2025",
    "title": "Tic Tac Toe 2025",
    "description": "Hook: Classic strategy puzzle game that challenges players to think ahead Features: List key gameplay elements and modes Instructions: Clear how-to-play explanation Call to action: Play now and prove your strategic mastery!",
    "instructions": "Desktop Use mouse to click on empty squares to place your symbol Mobile Touch empty squares to place X or O Accessibility Include keyboard controls when possible",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "Board",
      "Brain",
      "Classic",
      "Family",
      "HTML5",
      "Logic",
      "Mobile",
      "Puzzle",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/03wr4pb47nfab3q4kgam6n0b5dx5wp32/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/03wr4pb47nfab3q4kgam6n0b5dx5wp32/",
    "sourceUrl": "https://html5.gamemonetize.com/03wr4pb47nfab3q4kgam6n0b5dx5wp32/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "55163",
    "slug": "the-pain-of-nextbot",
    "title": "The Pain of Nextbot",
    "description": "This dude is my best friend and he wants to catch and hug you too much. I think you couldnt want it because he is very crazy for everything. If you love your life, go away for him.",
    "instructions": "W A S D movement P Pause game",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "Adventure",
      "amazing",
      "Android",
      "Arena",
      "Crazy",
      "Enemy",
      "Escape",
      "First Person Shooter",
      "Ghost",
      "Horror"
    ],
    "thumbnail": "https://img.gamemonetize.com/vbfgmcm6chnd4szksoca6kpwd0lkjb7r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vbfgmcm6chnd4szksoca6kpwd0lkjb7r/",
    "sourceUrl": "https://html5.gamemonetize.com/vbfgmcm6chnd4szksoca6kpwd0lkjb7r/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67928",
    "slug": "rewarp",
    "title": "Rewarp",
    "description": "Master the art of instant movement as you explore a world full of challenges and hidden paths. In Rewarp, your teleportation skill lets you outmaneuver danger, dodge traps, and skip past barriers in the blink of an eye. Speed, precision, and clever thinking are the keys to surviving this fast-paced journey.",
    "instructions": "Use Mouse and Keyboard for desktop Touch Controls for mobile device",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "dash",
      "free html5 games for your website",
      "Jumping",
      "Ladybug",
      "Logic",
      "Platform",
      "touchscreen"
    ],
    "thumbnail": "https://img.gamemonetize.com/46jl6yn8fqi7mlq1b24m30c1atinlh5s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/46jl6yn8fqi7mlq1b24m30c1atinlh5s/",
    "sourceUrl": "https://html5.gamemonetize.com/46jl6yn8fqi7mlq1b24m30c1atinlh5s/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67101",
    "slug": "foxytruck",
    "title": "FoxyTruck",
    "description": "Embark on an exciting journey with Foxy! Our cute character rushes to the aid of his friends who are waiting for help in different climate conditions with his powerful tractor. He saves penguins by breaking ice in the poles, provides water to thirsty foxes by collecting cacti in the deserts, and collects carrots for hungry rabbits by breaking rocks in the forests. A different adventure, different tasks and colorful environments await you in each section. Choose the right module, steer your tractor and successfully complete Foxys tasks!",
    "instructions": "Use the arrow keys on your keyboard to move press Ctrl to stop and Shift to switch modules On mobile swipe to move tap once to stop and double-tap to switch modules",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Best Games",
      "Casual",
      "Driving",
      "garden",
      "Hypercasual",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/w9xjmg8i8igrbbm6dzmwdc9us5qzfe8u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w9xjmg8i8igrbbm6dzmwdc9us5qzfe8u/",
    "sourceUrl": "https://html5.gamemonetize.com/w9xjmg8i8igrbbm6dzmwdc9us5qzfe8u/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68046",
    "slug": "authentic-football-the-brazil-world-cup",
    "title": "Authentic Football:The Brazil World Cup",
    "description": "3D modeling technology is employed to construct a lifelike football field for the Brazil World Cup, encompassing elements such as the green pitch, goalposts, and stands, thereby creating an immersive match atmosphere. The player and football models also boast a high level of intricacy: the players movements are smooth and natural, and the flight path of the football adheres to the laws of physics, enabling players to feel as if they are in an actual Brazil World Cup match.",
    "instructions": "PC press the W key for a long pass press the S key for a short pass press the D key for a shot press the Q key to change players Mobile Joystick",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Football",
      "Highscore",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/9ptv2pbyrhiv9e9jlcj91vj9cwdwd3mw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9ptv2pbyrhiv9e9jlcj91vj9cwdwd3mw/",
    "sourceUrl": "https://html5.gamemonetize.com/9ptv2pbyrhiv9e9jlcj91vj9cwdwd3mw/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66971",
    "slug": "word-maker",
    "title": "Word Maker",
    "description": "Word Maker is a fun word puzzle game where you create real words from scrambled letters. Drag the letters into the correct order to form the word. It starts easy with 3-letter words, but as you level up, the words get longer and trickier! It&rsquo;s a great way to test your spelling skills and sharpen your brain.",
    "instructions": "Desktop Mouse Drag Move letters into the word box Mobile Touch amp Drag Move letters into the word box",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Click",
      "Educational",
      "Fun",
      "HTML5",
      "Kids",
      "NapTech Games",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/72qleuiiglbn0gbma3pljam9pn0qz5lj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/72qleuiiglbn0gbma3pljam9pn0qz5lj/",
    "sourceUrl": "https://html5.gamemonetize.com/72qleuiiglbn0gbma3pljam9pn0qz5lj/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67359",
    "slug": "abysma-dungeon-story",
    "title": "Abysma Dungeon Story",
    "description": "Descend into the depths of a mysterious dark abyss in this 2D platformer. Play as a wizard surrounded by treacherous traps, where careful movement and illumination are key to survival. Navigate through darkness, using light to uncover hidden dangers and illuminate your path. Beware of lurking enemies in the darkness, ready to strike when you least expect it. Will you uncover the secrets hidden in the shadows?",
    "instructions": "A ndash Move Left D ndash Move Right Left Mouse Button ndash Sword Attack Right Mouse Button ndash Light Magic E ndash Fire Magic",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Horror",
      "Magic"
    ],
    "thumbnail": "https://img.gamemonetize.com/fn6s03oqnkcg8rc0uc2re842gng45js3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fn6s03oqnkcg8rc0uc2re842gng45js3/",
    "sourceUrl": "https://html5.gamemonetize.com/fn6s03oqnkcg8rc0uc2re842gng45js3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68065",
    "slug": "flightbird",
    "title": "FlightBird",
    "description": "Get ready for a fast-paced flying challenge! In Flight Bird, your mission is simple: tap or click to keep your bird in the air and dodge the tricky obstacles. Sounds easy? Think again! This endless arcade game will test your reflexes, timing, and focus. Designed with smooth controls and vibrant visuals, Flight Bird offers a classic gameplay experience thats easy to pick up but hard to master. How far can you fly without crashing? Perfect for quick gaming sessions, Flight Bird is lightweight, addictively fun, and suitable for all ages. Compete with friends, unlock new birds, and aim for the highest score!",
    "instructions": "Click or tap to fly",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Arcade",
      "Bird",
      "Casual",
      "Flight"
    ],
    "thumbnail": "https://img.gamemonetize.com/7kwdq7ag250yldj0ypy04ankasq6xmdo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7kwdq7ag250yldj0ypy04ankasq6xmdo/",
    "sourceUrl": "https://html5.gamemonetize.com/7kwdq7ag250yldj0ypy04ankasq6xmdo/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68319",
    "slug": "pro-pong-game",
    "title": "Pro Pong Game",
    "description": "Pro Pong Game is a fast-paced arcade classic with a modern twist. Control your paddle, deflect the ball, and outplay your opponent in intense one-on-one matches. Precision and reflexes are the key to victory!",
    "instructions": "Player 1 W S Keys or Drag Left Paddle Player 2 uarr darr Keys or Drag Right Paddle Pause ESC Key Mobile Touch and Drag any Paddle",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "Arcade",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/45v5yuzz9v0iqa8wf0c9x6veyypmg46z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/45v5yuzz9v0iqa8wf0c9x6veyypmg46z/",
    "sourceUrl": "https://html5.gamemonetize.com/45v5yuzz9v0iqa8wf0c9x6veyypmg46z/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68543",
    "slug": "traffc-cross",
    "title": "Traffc Cross",
    "description": "Traffic Cross Jam is a simple puzzle game to play on. Here in this game, we have interesting puzzles every day with 8 different Traffic Jam Puzzles. Your goal is to slide the police car through the exit by moving other cars. Move the car strategize your plan and clear the puzzles. Play more puzzles only on y8.com",
    "instructions": "Tap on screen",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      ".io Games",
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/n5w86rvbn0dleu813h3mfuov030sfih9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n5w86rvbn0dleu813h3mfuov030sfih9/",
    "sourceUrl": "https://html5.gamemonetize.com/n5w86rvbn0dleu813h3mfuov030sfih9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68189",
    "slug": "mine-clicker-cookie",
    "title": "Mine Clicker: Cookie!",
    "description": "Welcome to Mine Clicker: Cookie! An addictive clicker where Minecraft meets cookie mania. Click the delicious cookie to produce as many as possible and build your cookie empire. Earn cookies to buy upgrades and hire familiar Minecraft creatures like sheep, pigs, and creepers. Each creature boosts your passive cookie income. The more creatures you hire, the faster your cookies grow! Unlock all helper mobs and prove you&rsquo;re the ultimate cookie master in this blocky world!",
    "instructions": "Tap the Cookie Your main action is to tap the big cookie on the screen Each tap earns you cookies the game rsquo s currency Buy Upgrades Use the cookies you earn to purchase upgrades from the upgrades panel These upgrades are Minecraft creatures tha",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Block",
      "Casual",
      "Click",
      "Clicker",
      "idle",
      "Mine",
      "Minecraft",
      "Miner"
    ],
    "thumbnail": "https://img.gamemonetize.com/e81k98fg5btsc76pi28858xp2x3wvovo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e81k98fg5btsc76pi28858xp2x3wvovo/",
    "sourceUrl": "https://html5.gamemonetize.com/e81k98fg5btsc76pi28858xp2x3wvovo/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "55197",
    "slug": "obstacube",
    "title": "Obstacube",
    "description": "Obstacube is an exhilarating endless runner that challenges your reflexes and strategy as you navigate through an ever-changing world of obstacles. Your primary goal is to survive for as long as possible while dodging a variety of hazards that increase in difficulty the further you progress. Collect coins strategically placed along your path to buy skins or trails in the shop!",
    "instructions": "A D to Move For PC only Swerve controls For both PC and Mobile",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Action",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/945qahpnpg3byb5h074n2zj2vlwxy8bn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/945qahpnpg3byb5h074n2zj2vlwxy8bn/",
    "sourceUrl": "https://html5.gamemonetize.com/945qahpnpg3byb5h074n2zj2vlwxy8bn/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67825",
    "slug": "super-sprunki-adventure-game",
    "title": "super sprunki adventure game",
    "description": "super sprunki adventure game - Jungle Adventure - Classic Run Game gives you the chance to step back in time to your childhood. Bobby World has been nothing but empties since the Princess got kidnapped into the jungle. But then, the adventure begins! Your task is to help Bobby run through the mysterious jungle, jump over the obstacles, and super evil monsters save the beautiful Princess at the final destination of the adventure. This Game is free, and you can play Bob offline! [Features]: + More than 240 levels. + Challenging boss fights + Beautiful high-resolution graphics, drawn in a modern style mixed with a bit of classic. + Smooth us",
    "instructions": "Mouse click or tap to play",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "Mario",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/yh0n2bobl4i5wdm0z43l7rhow2nk62qy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yh0n2bobl4i5wdm0z43l7rhow2nk62qy/",
    "sourceUrl": "https://html5.gamemonetize.com/yh0n2bobl4i5wdm0z43l7rhow2nk62qy/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68310",
    "slug": "purrrification",
    "title": "Purrrification",
    "description": "An innocent-looking platformer. Jump, collect, progress. But something feels off. Levels shift, sounds distort, the screen... reacts. This is more than just a game. How far are you willing to go? 7 levels with increasing difficulty Numerous hidden easter eggs to discover Intentional glitches that can alter the gameplay A progressively distorted game experience Environments, sounds, and UI that change over time Metanarrative elements and unexpected behaviors Nothing is what it seems &mdash; even the menu can deceive",
    "instructions": "Mouse click or tap to play WASD to Move Jump and go down when on platforms x or space to select P to pause the game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Horror",
      "jump",
      "Pixel",
      "Platform",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/xcj55qktot7ucsj0lepq6hjd6egh1b1m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xcj55qktot7ucsj0lepq6hjd6egh1b1m/",
    "sourceUrl": "https://html5.gamemonetize.com/xcj55qktot7ucsj0lepq6hjd6egh1b1m/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "68101",
    "slug": "pager-war",
    "title": "Pager War",
    "description": "This is a casual strategy war game. Use energy to summon soldiers to resist enemy attacks. The level mode and endless challenge mode in the game are waiting for you to experience!",
    "instructions": "Mouse click or tap to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      ".io Games",
      "Army",
      "Stickman",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/x46ibzgwdr5v7nhyda6cywujpv2i4wy6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x46ibzgwdr5v7nhyda6cywujpv2i4wy6/",
    "sourceUrl": "https://html5.gamemonetize.com/x46ibzgwdr5v7nhyda6cywujpv2i4wy6/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68515",
    "slug": "blade-forge-3d",
    "title": "Blade Forge 3D",
    "description": "Step into the fiery forge of Blade Forge 3D, the ultimate 3D simulation casual game. You become the legendary blacksmith. Craft epic weapons from scratch. After matching opponents, choose your own mold and craft your own sword. Temper the sword by forging the blade between the flames. Once completed, the sword will be used to test itself against your opponent. Serious polishing to boost your damage value.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Craft",
      "Funny",
      "Simulation",
      "weapons"
    ],
    "thumbnail": "https://img.gamemonetize.com/nd116fs5meohfjuebitk7mnjss60nsod/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nd116fs5meohfjuebitk7mnjss60nsod/",
    "sourceUrl": "https://html5.gamemonetize.com/nd116fs5meohfjuebitk7mnjss60nsod/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66910",
    "slug": "bffs-k-pop-fangirls",
    "title": "BFFs K Pop Fangirls",
    "description": "Are you a die-hard K-pop fan? Then get ready to show off your style in BFFs K-pop Fangirls Dress Up Game! This exciting game lets you follow the day-to-day life of two real K-pop fangirls. During the day they keep up with their professional lives, but when the clock strikes 6 PM, they gear up in fashionable combat outfits and chase their favorite K-pop idols throughout the city. Get it started, and have a blast mixing and matching different clothing items, hairstyles, and accessories to create the perfect looks for our best friends. Show off your fashion skills and creativity by dressing up your favorite girls and sharing your creations with",
    "instructions": "Use your mouse to play the game on a desktop or tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl"
    ],
    "thumbnail": "https://img.gamemonetize.com/8oc1rjmuwkx2ol1th8pjrfwmtgg3ckgu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8oc1rjmuwkx2ol1th8pjrfwmtgg3ckgu/",
    "sourceUrl": "https://html5.gamemonetize.com/8oc1rjmuwkx2ol1th8pjrfwmtgg3ckgu/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68548",
    "slug": "saws-key",
    "title": "Saws Key",
    "description": "In the game Saws Key, your ultimate goal is to collect the key, which will unlock the door to progress to the next level. However, once the key is collected, youll need to gather food, a newfound requirement for unlocking each subsequent level. As you progress through the levels, the challenges will increase in difficulty, ensuring a thrilling experience. Ultimately, unlocking each level requires both timely key collection and food gathering.",
    "instructions": "Tap on Screen For Mobile Use Keyboard For PC",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/kveqspfrcdspsnzwy1wt8tc3lf63w3xh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kveqspfrcdspsnzwy1wt8tc3lf63w3xh/",
    "sourceUrl": "https://html5.gamemonetize.com/kveqspfrcdspsnzwy1wt8tc3lf63w3xh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68575",
    "slug": "zoo-line",
    "title": "Zoo Line",
    "description": "Race against the clock as you connect adorable animals in Zoo Line! Swipe in any direction up, down, sideways, or diagonally to chain together matching creatures and score big. The longer your combo, the more time and points you earn. Zoo Line adds a wild twist to classic matching games, making each second count in your quest for the top score. Can you beat the timer with a roaring combo?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Bejeweled",
      "Cute",
      "free html5 games for your website",
      "Fun",
      "jungle",
      "Match 3",
      "Puzzle",
      "swipe",
      "touchscreen"
    ],
    "thumbnail": "https://img.gamemonetize.com/8c2ackwuxywgybcyem33mxbxizc7s707/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8c2ackwuxywgybcyem33mxbxizc7s707/",
    "sourceUrl": "https://html5.gamemonetize.com/8c2ackwuxywgybcyem33mxbxizc7s707/",
    "width": 496,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68535",
    "slug": "black-ball",
    "title": "Black Ball",
    "description": "Blackball is a cue sport similar to pool, played on a rectangular table with six pockets. The game involves two types of balls: solid-colored balls (1-7) and striped balls (9-15), plus the black 8-ball. Players take turns trying to pocket their designated group of balls, either solids or stripes, using a cue stick. The objective is to pocket all the balls in their group and then legally pot the 8-ball to win. The game requires precision, strategy, and control of the cue ball for successful play.",
    "instructions": "Tap on screen",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "8 Ball Pool"
    ],
    "thumbnail": "https://img.gamemonetize.com/hwj2oufpdy6xknvjpj99974odbysfq1r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hwj2oufpdy6xknvjpj99974odbysfq1r/",
    "sourceUrl": "https://html5.gamemonetize.com/hwj2oufpdy6xknvjpj99974odbysfq1r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68521",
    "slug": "barbee-summer-vacation",
    "title": "Barbee Summer Vacation",
    "description": "Summer&rsquo;s here, and it&rsquo;s time for Barbie and her besties to enjoy their dream vacation! In Barbie Summer Vacation, you&rsquo;ll help each character get ready with stylish warm-weather outfits, fun accessories, and fresh summer vibes. Whether it&rsquo;s flowy dresses, sunglasses, or floral tops, it&rsquo;s all about picking looks that scream sunshine. There&rsquo;s no rush. Mix and match outfits, try on different styles, and create the perfect beachy-cute vacation wardrobe. Each friend has her own unique vibe&mdash;so explore, experiment, and have fun dressing them all up. It&rsquo;s the perfect fashion game for chill play sessions, creativity, and styling fun!",
    "instructions": "Left Mouse Button Click and Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Barbie",
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls",
      "Summer"
    ],
    "thumbnail": "https://img.gamemonetize.com/gzv7z7bi7gkwehrqupn4up9s8vkbh514/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gzv7z7bi7gkwehrqupn4up9s8vkbh514/",
    "sourceUrl": "https://html5.gamemonetize.com/gzv7z7bi7gkwehrqupn4up9s8vkbh514/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68247",
    "slug": "jump-hero",
    "title": "Jump hero",
    "description": "Jump Hero is a fast-paced reaction game where timing is everything! Take control of a fearless ninja hero as he leaps between platforms in a futuristic dojo. The objective is to jump as far as possible without falling the farther you go, the higher your score. Modes: - Endless Run Mode (score-based) - Speed Increases with Progress Characters: - Main Character: Shadow Ninja with customizable jump animation Levels: - Procedural level design &ndash; every run is unique - Dynamic background transitions based on distance",
    "instructions": "bull Tap Mobile or Click Desktop to make the hero jump bull Time your jump precisely to land on the next platform bull The game gets faster as you progress mdash stay focused",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Adventure",
      "endless"
    ],
    "thumbnail": "https://img.gamemonetize.com/4lltljq2sk4xbtyd73qus8o8igvskno6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4lltljq2sk4xbtyd73qus8o8igvskno6/",
    "sourceUrl": "https://html5.gamemonetize.com/4lltljq2sk4xbtyd73qus8o8igvskno6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68483",
    "slug": "dual-car",
    "title": "Dual Car",
    "description": "DUAL CAR &ndash; Double the Drive, Double the Challenge! Control two cars at the same time! Test your focus and reflexes as you dodge obstacles and collect points on a fast-paced, challenging road. Simple, fun, and addictive &ndash; how long can you last",
    "instructions": "Use the A and B buttons to bypass obstacles",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Alien",
      "BMX Games",
      "Cars",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/4mq6lv5yb2gnzibdud5oauc7n54mlb1o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4mq6lv5yb2gnzibdud5oauc7n54mlb1o/",
    "sourceUrl": "https://html5.gamemonetize.com/4mq6lv5yb2gnzibdud5oauc7n54mlb1o/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67119",
    "slug": "blue-koala-jigsaw-puzzles",
    "title": "Blue Koala Jigsaw Puzzles",
    "description": "Get ready to dive into a world of cute and colorful puzzles with Blue Koala Puzzle - Jigsaw Game! This fun and relaxing game is perfect for kids and adults who love jigsaw puzzles and adorable characters. Join Stitch, the mischievous blue koala-like alien from your favorite animated adventures, as he guides you through dozens of beautiful puzzle images!",
    "instructions": "Click and drag pieces to move them",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cute",
      "Jigsaw"
    ],
    "thumbnail": "https://img.gamemonetize.com/yct47umxg4piy5w0z61on7bjtwf74ar6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yct47umxg4piy5w0z61on7bjtwf74ar6/",
    "sourceUrl": "https://html5.gamemonetize.com/yct47umxg4piy5w0z61on7bjtwf74ar6/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68533",
    "slug": "obby-rescue",
    "title": "Obby Rescue",
    "description": "Obby Rescue is a casual and very funny puzzle game in which the main objective of the game is to protect your adorable little dog from the attack of a swarm of killer bees! The goal of the game is to use the objects that will serve as a barrier against the attack, taking into account at all times your environment and the laws of physics.",
    "instructions": "Use the mouse or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "html5 games for your site",
      "Hypercasual",
      "Kids",
      "Levels",
      "Rescue",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/15xmgy0og4ojairdvytqcm0je1zv5xzz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/15xmgy0og4ojairdvytqcm0je1zv5xzz/",
    "sourceUrl": "https://html5.gamemonetize.com/15xmgy0og4ojairdvytqcm0je1zv5xzz/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "65110",
    "slug": "bullet-army-run",
    "title": "Bullet Army Run",
    "description": "Welcome to the most exciting army-run challenge! In Bullet Army Run, youll be a commander and lead your Bullet Army on the parkour platforms. This is a casual puzzle game that tests your strategy and reflexes. Collect more bullets and grow your team. Lead the team to avoid obstacles like cutters, hammers, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Army",
      "Relaxation",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/05v9me4wnyc3flvn250njm13yjh1cacj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/05v9me4wnyc3flvn250njm13yjh1cacj/",
    "sourceUrl": "https://html5.gamemonetize.com/05v9me4wnyc3flvn250njm13yjh1cacj/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68205",
    "slug": "hair-salon-beauty-salon",
    "title": "Hair Salon: Beauty Salon",
    "description": "Get ready to unleash your inner hairstylist with the adorable and entertaining game Hair Salon: Beauty Salon! This charming simulation game allows you to run your very own hair salon, where you can give your cute and quirky customers the hair style of their dreams. From washing, styling hair and providing luxurious jewelry &amp; makeup accessories, theres never a dull moment in this delightful game.",
    "instructions": "With a wide range of hairstyles and makeup accessories to choose from you can let your creativity run wild and give your clients a look thats uniquely their own",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Hair"
    ],
    "thumbnail": "https://img.gamemonetize.com/6nvze9kpcehevivum9ipbrmgfrkxscza/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6nvze9kpcehevivum9ipbrmgfrkxscza/",
    "sourceUrl": "https://html5.gamemonetize.com/6nvze9kpcehevivum9ipbrmgfrkxscza/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68354",
    "slug": "kid-cakes-maker-cooking-bakery",
    "title": "Kid Cakes Maker Cooking Bakery",
    "description": "Welcome to Kid Cakes Maker Cooking Bakery, a casual cooking simulation game for kids who love food and DIY games. Bake a delicious and beautiful cake with cute animals! Learn to use different cooking tools and master recipes for the best rainbow cake! You need to shop for ingredients and cooking tools in the store. Mix ingredients in the bowl and put the mixture in the moulds to take shape. Heat the cake in the oven.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Baby",
      "Cake"
    ],
    "thumbnail": "https://img.gamemonetize.com/rbfar138z4hjggqmvzqpm33oryjiy5rs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rbfar138z4hjggqmvzqpm33oryjiy5rs/",
    "sourceUrl": "https://html5.gamemonetize.com/rbfar138z4hjggqmvzqpm33oryjiy5rs/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68514",
    "slug": "my-dress-up-darling",
    "title": "My Dress Up Darling",
    "description": "Are you a fashion enthusiast with a passion for all things beautiful? Want to try out new and trendy clothes and makeup? Get ready to enjoy endless creative styles and suits with My Dress Up Darling, the cutest dress-up game online. Designed especially for girl players who love fashion, this casual dress-up game offers a world where you can unleash your inner stylist and create charming looks. We provide plenty of styles, patterns, accessories, and outfits for you.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Design",
      "Dress Up",
      "Fashion",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/xtvh1b36cft17u4vkih8n2h9f1yo9rj5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xtvh1b36cft17u4vkih8n2h9f1yo9rj5/",
    "sourceUrl": "https://html5.gamemonetize.com/xtvh1b36cft17u4vkih8n2h9f1yo9rj5/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68291",
    "slug": "poppy-strike-5",
    "title": "Poppy Strike 5",
    "description": "Poppy Strike 5 is a first person shooter game with elements of horror where your mission is to use big arsenal of weapons to shoot huggy wuggy and kisiy misiy and find a way to escape liminal spaces of haunted toy factory.",
    "instructions": "WASD - Move LMB - Shoot RMB - Aim Flashlight R - Reload F - Use G - Grenade H - Melee C - Crouch M - Mute Space - Jump Shift - Run 1-9 - Select Weapon",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "3D Games",
      "CSGO",
      "First Person Shooter",
      "Horror",
      "huggy",
      "Poppy Playtime",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Unity3D"
    ],
    "thumbnail": "https://img.gamemonetize.com/9p1uqz68xfgc02tb292d3s5mhpbigqjd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9p1uqz68xfgc02tb292d3s5mhpbigqjd/",
    "sourceUrl": "https://html5.gamemonetize.com/9p1uqz68xfgc02tb292d3s5mhpbigqjd/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "62055",
    "slug": "manoeuvre-fps",
    "title": "Manoeuvre FPS",
    "description": "Step into the action with Mini Weapon Simulator, a compact yet thrilling shooting experience designed for quick-fire fun! Progress through bite-sized levels, each crafted to test your aim, timing, and weapon-handling skills. From pistols to powerful rifles, unlock and experiment with a growing arsenal as you advance through each stage. Perfect for fans of shooting games who enjoy focused, level-based challenges without the fluff&mdash;just pure trigger-pulling satisfaction in every round. Start your sharpshooting journey and explore more action-packed browser games at zyrexgames.com &ndash; where every shot hits the mark!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "fps",
      "Gun",
      "Shoot",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/va1g5v5j9gyg8extzkc3id9mkwznfq0g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/va1g5v5j9gyg8extzkc3id9mkwznfq0g/",
    "sourceUrl": "https://html5.gamemonetize.com/va1g5v5j9gyg8extzkc3id9mkwznfq0g/",
    "width": 900,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68516",
    "slug": "tung-tung-sahur-reassembled",
    "title": "Tung Tung Sahur Reassembled",
    "description": "Step into the delightful chaos of Tung Tung Sahur: Reassembled, a hilarious sliding tile puzzle game where you&rsquo;ll help reassemble the most bizarre and brainrot-worthy characters ever! Your mission? Slide the scrambled tiles to restore wacky portraits of our beloved wooden hero Tung Tung, the elegant yet cursed Ballerina Cappucina, and the determined sneaker-wearing Shark Jogger. Each image is broken into pieces&mdash;can your brain keep up?",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brainrot",
      "Italian Brainrot",
      "Slicing",
      "sliding",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/71vi8ce3ncqkn3bx7kaodzdc2siats69/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/71vi8ce3ncqkn3bx7kaodzdc2siats69/",
    "sourceUrl": "https://html5.gamemonetize.com/71vi8ce3ncqkn3bx7kaodzdc2siats69/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68532",
    "slug": "celebrity-valentino-pink-collections",
    "title": "Celebrity Valentino Pink Collections",
    "description": "Welcome to Celebrity Valentino Pink Collections. Celebrity girls are more famous for their fashion trends. Now they planned to add a new collection to this series. Yes! It&rsquo;s the Valentino Pink collection. They already filled the collection in their wardrobe. Browse and pick a suitable costume for each girl. Join and help the girls in their fashion preparation. Have fun!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Celebrity",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/u88pejsgh4edbe4dmafc12wwf702a7jy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u88pejsgh4edbe4dmafc12wwf702a7jy/",
    "sourceUrl": "https://html5.gamemonetize.com/u88pejsgh4edbe4dmafc12wwf702a7jy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68440",
    "slug": "squid-game-craft-runner",
    "title": "Squid Game: Craft Runner",
    "description": "Join the fun in Squid Game Subway Craft! Craft your way through obstacles and race along the railway tracks in a Minecraft-style world. Face exciting challenges, meet cool characters, and show your skills as you survive the ultimate test in this action-packed game inspired by Squid Game! Let me know if this works for you!se!",
    "instructions": "Right Right Arrow or D Left Left Arrow or Q Up Up Arrow or Z Down Down Arrow or S",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Minecraft",
      "squidgame",
      "Subway Surfers"
    ],
    "thumbnail": "https://img.gamemonetize.com/uue9ttbprz2ayg3q7qu0xm9ct4gpx93p/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uue9ttbprz2ayg3q7qu0xm9ct4gpx93p/",
    "sourceUrl": "https://html5.gamemonetize.com/uue9ttbprz2ayg3q7qu0xm9ct4gpx93p/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68488",
    "slug": "labubu-doll-mukbang-asmr-unblocked",
    "title": "Labubu Doll Mukbang Asmr Unblocked",
    "description": "Welcome to Labubu Doll Mukbang Asmr Unblocked, a charming, casual ASMR game that combines the joy of food, cooking, and ASMR sounds! Experience as a talented baker and join the lovely Labubu on a mouthwatering adventure. In the game, you will take orders from your diners, each with unique requests for bread. From croissants to loaves of baguettes, you need to pack each bread for your customers on time.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Cooking",
      "Food",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/e3cp1lq4u1j80ygqemm1997e7di01b4w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e3cp1lq4u1j80ygqemm1997e7di01b4w/",
    "sourceUrl": "https://html5.gamemonetize.com/e3cp1lq4u1j80ygqemm1997e7di01b4w/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66977",
    "slug": "traffic-trap",
    "title": "Traffic Trap",
    "description": "Get ready to dive into Traffic Trap, an addictive HTML5 puzzle game perfect for browser play. Control traffic flow on a busy street grid by managing the routes of trucks using directional signs and traffic lights. Each truck follows a marked direction, and one wrong move could lead to a crash! React fast, think smart, and prevent chaos as you unlock new levels with increasing complexity. Use power-ups like hints and bombs to ease tough situations. Ideal for players of all ages, Traffic Trap is optimized for mobile and desktop and is a great choice for monetization through rewarded ads or in-game purchases.",
    "instructions": "Desktop Click on trucks to change direction Mobile Tap trucks to change direction",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Brain",
      "Casual",
      "Clicker",
      "HTML5",
      "NapTech Games",
      "Skill",
      "Traffic",
      "Truck",
      "trucks"
    ],
    "thumbnail": "https://img.gamemonetize.com/jaj71oz3teb57c2egenil47f6jla6fjh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jaj71oz3teb57c2egenil47f6jla6fjh/",
    "sourceUrl": "https://html5.gamemonetize.com/jaj71oz3teb57c2egenil47f6jla6fjh/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "66981",
    "slug": "carrot-climber",
    "title": "Carrot Climber",
    "description": "Carrot Climber is a cute and fun game where a hungry rabbit climbs walls to collect carrots! Each level has hooks placed on the wall, and you need to help the rabbit jump from one hook to another. Aim carefully&mdash;if you miss, the rabbit will fall! Collect carrots and coins along the way to unlock the next level. It&rsquo;s a sweet mix of challenge and fun for all ages.",
    "instructions": "Desktop Mouse Click Drag to Aim Release to Jump Mobile Touch Drag to Aim Release Finger to Jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "HTML5",
      "html5 games",
      "Hypercasual",
      "Jumping",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/qbaxklf6h2lmtermzm69mlnypubr60bj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qbaxklf6h2lmtermzm69mlnypubr60bj/",
    "sourceUrl": "https://html5.gamemonetize.com/qbaxklf6h2lmtermzm69mlnypubr60bj/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "33844",
    "slug": "aim",
    "title": "Aim",
    "description": "AIM is a term that began to be used during the development of 3d shooters and competitive matches. It was the name of the statistics of hits on target and reaction speed. In this project, you need to use a rebound to set multiple goals at a level. The game features: Advanced object flight physics Good graphics Addictive gameplay Are you ready to upgrade your reaction speed and accuracy? Then start playing! Good luck!",
    "instructions": "When you start the game and select a level you will be greeted by objects on the map there can be from one to ten of them You need to set them in one shot You can fire a shot from anywhere on the level the main thing is to hit all the objects on the",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Ball",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/un37res0ywy0rsoiqcuighkqf453z9o2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/un37res0ywy0rsoiqcuighkqf453z9o2/",
    "sourceUrl": "https://html5.gamemonetize.com/un37res0ywy0rsoiqcuighkqf453z9o2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67932",
    "slug": "malatang-master-stack-run-3d",
    "title": "Malatang Master Stack Run 3D",
    "description": "Ready to feel the hottest and most fun parkour game ever? In Malatang Master Stack Run 3D, you become a street food chef. Keep running through colorful 3D platform tracks and collecting tasty ingredients to build the tallest skewer stack ever. Slide to collect noodles, Chicken thighs, chili, and more as you dash forward.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D Games",
      "Food",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/n00gudvb6qqh99h7ua4pg1k8egt1pgsh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n00gudvb6qqh99h7ua4pg1k8egt1pgsh/",
    "sourceUrl": "https://html5.gamemonetize.com/n00gudvb6qqh99h7ua4pg1k8egt1pgsh/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68211",
    "slug": "anime-doll-diy-cosplay-girl",
    "title": "Anime Doll   DIY Cosplay Girl",
    "description": "Anime Doll - DIY Cosplay Girl is a fashion and lovely dress-up game that presents unprecedented shocking visual effects, providing girls with an amazing dress-up experience! With its stunning graphics and easy-to-use interface, this game is perfect for anyone who loves fashion and adventure.",
    "instructions": "Players simply need to select their preferred clothing items hairstyles and accessories from the games extensive wardrobe selection and apply them to their princess character using the touch and drag controls",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Anime",
      "Cute",
      "Dress Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/32245xntgac16ymjo0g5vz3h693bfzav/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/32245xntgac16ymjo0g5vz3h693bfzav/",
    "sourceUrl": "https://html5.gamemonetize.com/32245xntgac16ymjo0g5vz3h693bfzav/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68355",
    "slug": "lol-dolls-nail-salon",
    "title": "LOL Dolls Nail Salon",
    "description": "Welcome to LOL Dolls Nail Salon, a casual fashion design game for girl players. If you are a doll lover or like doing nail designs, then this game is the perfect place for you. In the game, you are totally on your own to design the fashion nail for your dolls. Dive into the magic fashion nail salon and dazzle the crowd with your charming nail design! You need to start with skin and nail care.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby Games",
      "Makeover",
      "Nails"
    ],
    "thumbnail": "https://img.gamemonetize.com/9v35tumn5wmfomsbq9itutz9r295qw7n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9v35tumn5wmfomsbq9itutz9r295qw7n/",
    "sourceUrl": "https://html5.gamemonetize.com/9v35tumn5wmfomsbq9itutz9r295qw7n/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68447",
    "slug": "pokemon-memory-time",
    "title": "Pokemon Memory Time",
    "description": "A Fun Memory Game With Pokemon Magic. Pokemon Memory Time is not just a memory game &mdash; it is a brain-boosting adventure filled with your favorite pocket monsters! Flip colorful cards, uncover hidden Pokemon, and test how well your memory really works. Each round is a playful puzzle that sharpens your mind and warms your heart. Flip Fast and Remember Right!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Fun",
      "Hypercasual",
      "Kids",
      "Logic",
      "Memory",
      "Pokemon",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/mbf3d5yx40vklpnmbg7c86rggzjkx0x1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mbf3d5yx40vklpnmbg7c86rggzjkx0x1/",
    "sourceUrl": "https://html5.gamemonetize.com/mbf3d5yx40vklpnmbg7c86rggzjkx0x1/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68443",
    "slug": "sandbox-squid-game-create-a-challenge",
    "title": "Sandbox Squid Game   Create a Challenge",
    "description": "Sandbox Squid Game - Create a Challenge &mdash; a game inspired by Squid Game. The game genre is a sandbox. Therefore, you can freely build whatever you want. The main task is to build a test that players will pass. You can help them, hinder them, or even kill them. When players pass the test, you get money. The game has: more than 5 maps, 4 blocks for construction, more than 5 players, 4 skins for the guard.",
    "instructions": "larr rarr or AD - Right Left uarr or W - Jump Q - Change block S - Place block F - Shoot with machine gun After you build the test dont forget to click on the green button in the upper left corner",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best",
      "Block",
      "build",
      "building",
      "Cool",
      "Mobile",
      "New",
      "Platform",
      "Sandbox",
      "Shooter",
      "squid",
      "squidgame"
    ],
    "thumbnail": "https://img.gamemonetize.com/b1lcyzqmred1mndjjapnni7n1249vfkd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b1lcyzqmred1mndjjapnni7n1249vfkd/",
    "sourceUrl": "https://html5.gamemonetize.com/b1lcyzqmred1mndjjapnni7n1249vfkd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68137",
    "slug": "steal-labubu-sprunki",
    "title": "Steal Labubu   Sprunki!",
    "description": "Steal Labubu - Sprunki! &ndash; a platformer with physics. You play as Sprunki Pinky. Your task is to carry the found Labubu toy to the green zone. There are 24 levels in the game.",
    "instructions": "Take the toy and bring it to the green field WAD or larr rarr uarr - Movement X or S or darr - Take Throw the toy The game has a double jump",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Best",
      "Best Games",
      "Casual",
      "Girl",
      "Mobile",
      "Physics",
      "Puzzle",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/x7ugjuvrfahgdl7x7db4vbnseimdgt6o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/x7ugjuvrfahgdl7x7db4vbnseimdgt6o/",
    "sourceUrl": "https://html5.gamemonetize.com/x7ugjuvrfahgdl7x7db4vbnseimdgt6o/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68427",
    "slug": "night-racing",
    "title": "Night Racing",
    "description": "Get ready for thrilling nighttime races in an adrenaline-filled city! In this game, youll become a true street racer. Jump into the seat of a powerful sports car and hit the streets of the nocturnal city where exciting challenges await you. Complete various missions and perform tricks to showcase your driving skills, evading the police and leaving them far behind. As the game progresses, youll have the opportunity to purchase new, more powerful and faster cars. Become the king of street racing!",
    "instructions": "W - accelerate S - brake reverse A - steer left D - steer right Space - handbrake F - nitro available from the 3rd car M - enlarge map L K - control lights I - start stop the engine C - switch camera Mouse - camera rotation ESC TAB - menu",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D Games",
      "Car",
      "Cars",
      "drift",
      "drifting",
      "Driving",
      "endless",
      "gta",
      "Physics",
      "Race",
      "Racing",
      "Traffic",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/vpyg4xx30zcxx3sv2p8ke2ws7bvwg08v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vpyg4xx30zcxx3sv2p8ke2ws7bvwg08v/",
    "sourceUrl": "https://html5.gamemonetize.com/vpyg4xx30zcxx3sv2p8ke2ws7bvwg08v/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67622",
    "slug": "pixel-slide-puzzle",
    "title": "Pixel Slide Puzzle",
    "description": "This is a pixel slide puzzle where you build scenes similar to the classic 15-puzzle &mdash; but with one major twist: every piece can go in any position. Inside, youll find nearly 70 unique levels, each representing a handcrafted pixel illustration. Use the hint feature to preview the completed scene and figure out the correct layout. Perfect for fans of pixel art and relaxing puzzles!",
    "instructions": "Drag and drop pieces to complete the image You can place any piece in any slot Use the hint button to see what the finished level should look like",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Classic",
      "Jigsaw",
      "Pixel",
      "Puzzle",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/l55x3uuoz772nzvt79jjcyczeqrng33g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l55x3uuoz772nzvt79jjcyczeqrng33g/",
    "sourceUrl": "https://html5.gamemonetize.com/l55x3uuoz772nzvt79jjcyczeqrng33g/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68412",
    "slug": "asmr-games-pretty-princess",
    "title": "ASMR Games Pretty Princess",
    "description": "Welcome to ASMR Games Pretty Princess, a casual ASMR makeup game for girls. If you are a fan of makeup or dress-up, or love playing princess games, then this is the perfect place for you. Meet various girls and a specific story in the game. Use your wisdom to help the girl get rid of her appearance anxiety. Do skin cleaning, apply cosmetics, add accessories, select beautiful suits...",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Girls",
      "Makeover"
    ],
    "thumbnail": "https://img.gamemonetize.com/jmnc4ecl2olocvb6z55ycusaudfxtl4s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jmnc4ecl2olocvb6z55ycusaudfxtl4s/",
    "sourceUrl": "https://html5.gamemonetize.com/jmnc4ecl2olocvb6z55ycusaudfxtl4s/",
    "width": 1600,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68051",
    "slug": "pfw-the-big-shoulder-couture",
    "title": "PFW The Big Shoulder Couture",
    "description": "Welcome to PFW-The Big Shoulder Couture. Celebrity girls are getting ready for another action. Yes! it&rsquo;s Paris Fashion Week! They are excited to try big Shoulder Couture outfits. Browse their wardrobe and pick suitable outfits and accessories. Don&rsquo;t forget to give unique hairstyles. Join them as fashion expert and help the girls to show their stunning fashion looks!",
    "instructions": "Left Mouse Button Click",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/7bp469vo6m0k6lfwy8qyw7fqvgq48o3s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7bp469vo6m0k6lfwy8qyw7fqvgq48o3s/",
    "sourceUrl": "https://html5.gamemonetize.com/7bp469vo6m0k6lfwy8qyw7fqvgq48o3s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68235",
    "slug": "idol-livestream-doll-dress-up",
    "title": "Idol Livestream: Doll Dress Up",
    "description": "In Idol Livestream: Doll Dress Up, you&rsquo;re dressing up your doll and getting her ready to go live. Pick from different styles&mdash;she can look like a fairy, wear chill street clothes, or go for a beach outfit. When you&rsquo;re done, she jumps on the stream and starts showing off her look. You can mess with her hair, add makeup, and try out accessories. There&rsquo;s also a battle mode where you go up against other players to see who styled it best.",
    "instructions": "Dress Up Tap or click to pick outfits and mix styles Go Live Send your doll on stage and watch her perform Battle Enter fashion contests and vote on looks No rush no limits mdash just show off your creativity and style sense",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/50em30dyyqudrrhf3c6j9krfw554v32t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/50em30dyyqudrrhf3c6j9krfw554v32t/",
    "sourceUrl": "https://html5.gamemonetize.com/50em30dyyqudrrhf3c6j9krfw554v32t/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67419",
    "slug": "stellar-cathcer",
    "title": "Stellar Cathcer",
    "description": "Catch the Falling Stars A fast-paced game where you catch falling stars and survive as long as possible. Avoid misses, collect power-ups, and progress through harder levels. Features: Catch stars for points Golden Stars = double points Time Slower slows items Hearts recover misses Bolts boost your speed Shop to unlock skins 5 levels: Easy to Endless Play with keyboard or touch",
    "instructions": "Keyboard Move Left A or larr Move Right D or rarr Touch Mobile Tap left right side of the screen to move",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Arcade",
      "endless",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/qpi82jfnvqn11vzdr4uwf719ehgjfh0h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qpi82jfnvqn11vzdr4uwf719ehgjfh0h/",
    "sourceUrl": "https://html5.gamemonetize.com/qpi82jfnvqn11vzdr4uwf719ehgjfh0h/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "65284",
    "slug": "skulls-and-bombs",
    "title": "Skulls And Bombs",
    "description": "Welcome to Skulls And Bombs &mdash; a pirate arcade game where speed means treasure and one mistake leads to an explosion! Click on various items to earn points, but beware of skulls and bombs &mdash; one wrong click and you&rsquo;re sunk! The game gets faster over time, and so do your chances of getting rich&hellip; or not? Test your reflexes and become the fastest pirate on the seas! The golden rule: never click on skulls or bombs. These dangerous objects are thrown in along with the others and can easily trick you. One wrong tap ends the game instantly. So you&rsquo;ll need more than just quick fingers &mdash; you&rsquo;ll need sharp focus. This makes the game not only fast-paced",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Clicker",
      "Mobile",
      "Pirate"
    ],
    "thumbnail": "https://img.gamemonetize.com/2hltbaf2wlgvs5ayr9z631t5812gj7yb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2hltbaf2wlgvs5ayr9z631t5812gj7yb/",
    "sourceUrl": "https://html5.gamemonetize.com/2hltbaf2wlgvs5ayr9z631t5812gj7yb/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "64795",
    "slug": "match-memory-online",
    "title": "Match Memory Online",
    "description": "Looking for an online version of classic Card Matching games? Play a refreshed version of this beloved game here! Win to earn coins and use coins for powerups. Powerups will help you for online matching duels, where you must go against an opponent to match as many cards as possible in one board. As you progress online youll get trophies to advance to new and better leagues, awarding more coins and harder opponents. If youre more of a casual player, you can still play a regular level mode, where you have to find pairs of cards in a bigger and bigger board with a set of lives to do it.You lose a life not finding a pair. Are you ready?Play now",
    "instructions": "Tap a card to reveal Tap 2 cards of same image to get a match Use powerups to win easier",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fun",
      "Interactive",
      "Matching",
      "Online",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/rkh98drqdmpwuk47ee30jh2wq1a2gzwy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rkh98drqdmpwuk47ee30jh2wq1a2gzwy/",
    "sourceUrl": "https://html5.gamemonetize.com/rkh98drqdmpwuk47ee30jh2wq1a2gzwy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67122",
    "slug": "snakegamepro",
    "title": "SnakeGamePro",
    "description": "elive the retro arcade thrill with a modern twist! Classic Snake Pro brings back the iconic arcade experience with sleek visuals, smooth controls, and addictive gameplay. Navigate your snake to munch on glowing food, grow longer, and avoid collisions with walls&mdash;or yourself! Features: Modern Retro Design &ndash; Vibrant colors, smooth animations, and a clean grid layout. Intuitive Controls &ndash; Play with keyboard (arrow keys) or touchscreen (swipe gestures). Speed Boost &ndash; Game gets faster as you score, testing your reflexes! High Score System &ndash; Compete against yourself and unlock new records. Pause &amp; Resume &ndash; Take a break anytime and ju",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Best Games",
      "Classic",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/oyx4jws0ew4ruixgfd1foyohf5yojeg9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oyx4jws0ew4ruixgfd1foyohf5yojeg9/",
    "sourceUrl": "https://html5.gamemonetize.com/oyx4jws0ew4ruixgfd1foyohf5yojeg9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68103",
    "slug": "snakes-eating-blocks",
    "title": "Snakes Eating Blocks",
    "description": "Snake Game is a fun and addictive HTML5 arcade game where you control a green snake using the arrow keys. Eat the red food to grow longer, avoid running into yourself, and try to beat your high score! Designed with responsive controls, smooth animations, and mobile swipe support, this game is perfect for quick and challenging gameplay anytime, anywhere.",
    "instructions": "Use Arrow Keys to move up down right left",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "eating",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/9eu1kt65229y2gvj3f0t8kdi7ror9vda/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9eu1kt65229y2gvj3f0t8kdi7ror9vda/",
    "sourceUrl": "https://html5.gamemonetize.com/9eu1kt65229y2gvj3f0t8kdi7ror9vda/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68156",
    "slug": "death-worm-2",
    "title": "Death Worm 2",
    "description": "The Death Worm has surfaced. In Death Worm, you control a colossal underground monster, bursting through the earth to wreak havoc in a thrilling mix of arcade, action, and casual destruction. There are different modes for you to choose from. For example, enter level mode. Swimming underground at high speeds, locking onto prey and breaking through the ground to complete the fatal attack. Eliminate humans, helicopters, cars, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "attack",
      "Funny",
      "Monster"
    ],
    "thumbnail": "https://img.gamemonetize.com/rnhbauw0kl19s241pd2ucscp0ncltbc0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rnhbauw0kl19s241pd2ucscp0ncltbc0/",
    "sourceUrl": "https://html5.gamemonetize.com/rnhbauw0kl19s241pd2ucscp0ncltbc0/",
    "width": 1136,
    "height": 640,
    "lastUpdated": ""
  },
  {
    "id": "67691",
    "slug": "ticktock-challenge",
    "title": "TickTock Challenge",
    "description": "Looking for the craziest brain teaser ever? Welcome to TickTock Challenge! This is a superb collection of minigames! From fun bubble shooter action to relaxing 2048 puzzles, from clever match and merge challenges to salon-themed brain teasers. This game has it all! Every level brings a new surprise, pushing you to think faster and smarter under the pressure of the ticking clock! Each round is quick, crazy, and incredibly fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Bubble Shooter",
      "Relaxation",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/9tjztpxmnpc4mt08k34qxao8bxpq6o1f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9tjztpxmnpc4mt08k34qxao8bxpq6o1f/",
    "sourceUrl": "https://html5.gamemonetize.com/9tjztpxmnpc4mt08k34qxao8bxpq6o1f/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68199",
    "slug": "asmr-girl-livestream-mukbang",
    "title": "ASMR Girl: Livestream Mukbang",
    "description": "Step into the world of ASMR Girl: Livestream Mukbang, where you take on the role of an adorable mukbang streamer! Get ready to indulge in delicious food, satisfy your cravings, and share the experience with your viewers in a cozy, interactive livestream. The more you eat and engage, the more you earn!",
    "instructions": "Shop Cook and Enjoy Delicious Foods Live Stream Your Mukbang Adventures Earn Money Upgrade Your Girl and Buy More Food",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cooking",
      "Creation",
      "eating"
    ],
    "thumbnail": "https://img.gamemonetize.com/r58na20mmbekdy2e5n6kldppav73zfez/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r58na20mmbekdy2e5n6kldppav73zfez/",
    "sourceUrl": "https://html5.gamemonetize.com/r58na20mmbekdy2e5n6kldppav73zfez/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68153",
    "slug": "mahjong-master-challenge",
    "title": "Mahjong Master Challenge",
    "description": "Ready to flip tiles, race the clock and sharpen your mind? MahjongMasterChallenge packs many handcrafted mahjong layouts into one fun puzzle journey. Your goal: clear the board by matching identical or coherent tiles. For example, chow: Combine two pairs into a sequence to clear. Kong: Combine two pairs into four of a kind to clear. Use your logic skills to eliminate and keep upgrading.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Mahjong",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/a1dzpnig45phtng53xh4fe7npfnpmp62/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a1dzpnig45phtng53xh4fe7npfnpmp62/",
    "sourceUrl": "https://html5.gamemonetize.com/a1dzpnig45phtng53xh4fe7npfnpmp62/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67440",
    "slug": "ellies-recipe-dubai-chocolate-bar",
    "title": "Ellies Recipe: Dubai Chocolate Bar",
    "description": "Whip up luxury in Ellie&rsquo;s Recipe: Dubai Chocolate Bar! Help Ellie create rich, decadent chocolate treats in this fun, interactive cooking game. Gather ingredients, prepare molds, make gourmet fillings, and craft elegant chocolate bars with Dubai flair. Unlock stylish outfits for Ellie and enjoy hands-on cooking fun with real kitchen actions. From mixing to decorating, every step is sweet! Play now and become a luxury dessert pro with Ellie!",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Barbie",
      "Cooking",
      "Dress Up",
      "Fashion",
      "Hidden"
    ],
    "thumbnail": "https://img.gamemonetize.com/b7088jad68v036rp283153k0bceos9sm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b7088jad68v036rp283153k0bceos9sm/",
    "sourceUrl": "https://html5.gamemonetize.com/b7088jad68v036rp283153k0bceos9sm/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68369",
    "slug": "sprunky-rich-rich-rich",
    "title": "Sprunky Rich Rich Rich",
    "description": "The Sprunky brothers fall into rivalry and start a competition. Both Sprunky brothers are very ambitious and want to win against each other. In this two-player game, the one who collects and deposits the most money into the piggy bank wins. Collect all the money before your brother and win the game. Be careful &mdash; dangerous objects are coming from everywhere. Dont hit them or youll lose the game!",
    "instructions": "Use WASD keys and Arrow Keys to move bull The first player to collect 50 coins wins the game bull Be careful while collecting money Sharp blades come from the sides and above",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Arcade",
      "Arena",
      "Platform",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/rjqx9s7cgzy7rtwescn049jwps2u2twv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rjqx9s7cgzy7rtwescn049jwps2u2twv/",
    "sourceUrl": "https://html5.gamemonetize.com/rjqx9s7cgzy7rtwescn049jwps2u2twv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68414",
    "slug": "my-baby-unicorn-pony-care-2",
    "title": "My Baby Unicorn Pony Care 2",
    "description": "Welcome to My Baby Unicorn - Pony Care, a casual baby pet care game for girl players. You will witness the birth of the baby unicorn, take care of him, and play with him! If you are a pet lover, do not miss this pet care simulation game. Have endless fun seeing the little unicorn growing up! Click on the different icons to feed the baby with food, soothe him to sleep, and try perfect dress-up. Earn extra stars and energies after you finish each care task.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Baby Games",
      "Funny",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/s3k4jtwrbdkvoodn6vg9d9qz88g1bo7l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s3k4jtwrbdkvoodn6vg9d9qz88g1bo7l/",
    "sourceUrl": "https://html5.gamemonetize.com/s3k4jtwrbdkvoodn6vg9d9qz88g1bo7l/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68418",
    "slug": "super-meat-boy-online",
    "title": "Super Meat Boy Online",
    "description": "Super Meat Boy Online is a tough as nails platformer where you play as an animated cube of meat whos trying to save his girlfriend (who happens to be made of bandages) from an evil fetus in a jar wearing a tux. Our meaty hero will leap from walls, over seas of buzz saws, through crumbling caves and pools of old needles.",
    "instructions": "Use the mouse or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "Bounce",
      "HTML5",
      "throwing"
    ],
    "thumbnail": "https://img.gamemonetize.com/bh15mylv5b1wint8drwoheax5uiath48/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bh15mylv5b1wint8drwoheax5uiath48/",
    "sourceUrl": "https://html5.gamemonetize.com/bh15mylv5b1wint8drwoheax5uiath48/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "68397",
    "slug": "crazy-bouncer",
    "title": "Crazy Bouncer",
    "description": "Bounce your way to victory! Take control of a bouncy ball in this fun and challenging platformer. Jump, roll, and dodge through tricky obstacles, deadly traps, and moving platforms as you aim to reach the green flag at the end of each level. Master the timing of your jumps by charging and releasing to gain extra height. Precision and patience are the key&mdash;can you make it through all levels without falling? With colorful graphics, satisfying controls, and physics-based gameplay, this game is perfect for fans of casual and skill-based games. Reach the green flag, avoid the red zones, and prove your bouncing skills!",
    "instructions": "Controls Arrow Keys or A D ndash Move Left Right Spacebar ndash Hold to charge jump release to jump Touch Controls Mobile Tap left side to move Tap and hold right side to charge jump release to jump Timing and precision are key Hold your jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "amazing",
      "Ball",
      "Casual",
      "Escape",
      "Fun",
      "HTML5",
      "jump",
      "Jumping",
      "Levels",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/p4kyxlkopbircdny0cic78w3xibqx27d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p4kyxlkopbircdny0cic78w3xibqx27d/",
    "sourceUrl": "https://html5.gamemonetize.com/p4kyxlkopbircdny0cic78w3xibqx27d/",
    "width": 1152,
    "height": 630,
    "lastUpdated": ""
  },
  {
    "id": "68336",
    "slug": "animal-cards-memory",
    "title": "Animal cards memory",
    "description": "Animal Cards Memory is a game that helps you train your memory. No matter how old you are, these types of games are useful at any age. The game consists of 7 levels that become more difficult as you go ahead. Animal memory card games are more than just a source of entertainment; they are a dynamic educational resource that adapts to modern lifestyles. By combining accessibility, variety, and interactive learning, these games not only engage children but also lay the groundwork for essential cognitive and social skills that will benefit them in the long run.",
    "instructions": "Mouse for the computer devices and finger for touch devices",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Memory"
    ],
    "thumbnail": "https://img.gamemonetize.com/bdg66pq2lj0i5snrsty8ibrmupvrryab/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bdg66pq2lj0i5snrsty8ibrmupvrryab/",
    "sourceUrl": "https://html5.gamemonetize.com/bdg66pq2lj0i5snrsty8ibrmupvrryab/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67354",
    "slug": "gem-dojo",
    "title": "Gem Dojo",
    "description": "Gem Dojo Match gems. Master skills. Become the ultimate puzzle ninja. Welcome to Gem Dojo, where stealth meets strategy in a vibrant match-3 puzzle adventure set in the world of ninjas! Train in the ancient art of gem-matching to unleash powerful combos, defeat rival ninjas, and rise through the ranks of the secret dojo. Swap and match colorful gems to charge up your ninja abilities, unlock hidden techniques, and outsmart increasingly tricky puzzle challenges. Only the sharpest minds and fastest fingers can become true masters of the Gem Dojo.",
    "instructions": "Match-3 and win bonuses",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Jewel",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/bl1vizce4zbqhhu7h53sccf23u453wcp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bl1vizce4zbqhhu7h53sccf23u453wcp/",
    "sourceUrl": "https://html5.gamemonetize.com/bl1vizce4zbqhhu7h53sccf23u453wcp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67052",
    "slug": "squishmallow-coloring-book",
    "title": "Squishmallow Coloring Book",
    "description": "Get ready to color your favorite Squishmallow! Weve got over 16 adorable Squishmallow pictures just waiting for your creative touch.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Animal",
      "Coloring"
    ],
    "thumbnail": "https://img.gamemonetize.com/sarcsswymvlql4tsaufwxocwubd10zol/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sarcsswymvlql4tsaufwxocwubd10zol/",
    "sourceUrl": "https://html5.gamemonetize.com/sarcsswymvlql4tsaufwxocwubd10zol/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68362",
    "slug": "screw-sort-puzzle-pin-jam-3d",
    "title": "Screw Sort Puzzle Pin Jam 3D",
    "description": "Want a fun 3D puzzle that&rsquo;s strangely relaxing? In ScrewSortPuzzle:PinJam3D, you&rsquo;ll remove every screw, sort colorful pins, and match them to the right slots without causing a jam! You will have to keep matching the screws of the right color and put them in the box of the corresponding color. Rotate the board to spot the screws you can safely loosen first. You can experience remove screw mode.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Matching",
      "Relaxation",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/7hih363nnbpbp77p9818x6i79tfp6yjr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7hih363nnbpbp77p9818x6i79tfp6yjr/",
    "sourceUrl": "https://html5.gamemonetize.com/7hih363nnbpbp77p9818x6i79tfp6yjr/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68361",
    "slug": "animal-racing-2",
    "title": "Animal Racing 2",
    "description": "Face the wildest race of your life in Animal Racing. It&rsquo;s a full-blown arcade adventure filled with running, transforming, and brain-tickling puzzles! Youll be running on platforms with your opponents. Outsmart your opponents in epic simulator-style racing challenges. Quick response to transform into different animals on different platforms. For example, transforming a shark to cross the sea, an eagle to fly over a gap, an orangutan to run up a flight of steps.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Animal",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/0nhrb2tzz0oglo3bj9oqs4zjxebt32yj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0nhrb2tzz0oglo3bj9oqs4zjxebt32yj/",
    "sourceUrl": "https://html5.gamemonetize.com/0nhrb2tzz0oglo3bj9oqs4zjxebt32yj/",
    "width": 1560,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68358",
    "slug": "fun-mini-games-for-princess",
    "title": "Fun Mini Games For Princess",
    "description": "Welcome to Fun Mini Games For Princess, a collection of mini casual games for kids. Dive into the gaming world and enjoy the fun of playing at your fingertips! Whether you are a casual gamer who looks for relaxation or a skillful player with a purpose, you will find your favorite game and enjoy endless fun in our mini games. Our mini games cover a large range of categories.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fun",
      "Girls",
      "Princess",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ttf1h89mqgcrg2soigeh3c9dp3wa7d3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ttf1h89mqgcrg2soigeh3c9dp3wa7d3/",
    "sourceUrl": "https://html5.gamemonetize.com/2ttf1h89mqgcrg2soigeh3c9dp3wa7d3/",
    "width": 945,
    "height": 1680,
    "lastUpdated": ""
  },
  {
    "id": "68356",
    "slug": "moe-kittens-cat-avatar-maker",
    "title": "Moe Kittens Cat Avatar Maker",
    "description": "Have you got the idea of raising a pet? Do you like playing with lovely cats? Welcome to Moe Kittens: Cat Avatar Maker, a cat avatar simulator game online. You can create your own kitten in every detail, from colors, shapes, tails, to patterns. Various colors and patterns for you to choose from. Never stop creating new fashion! Easy control allows players of all skill levels to enjoy.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Love",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/ddmjdac5v0whn4vsg1us6jmv3zg10ier/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ddmjdac5v0whn4vsg1us6jmv3zg10ier/",
    "sourceUrl": "https://html5.gamemonetize.com/ddmjdac5v0whn4vsg1us6jmv3zg10ier/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "68334",
    "slug": "skibidi-toilet-melon-sandbox",
    "title": "Skibidi Toilet Melon Sandbox",
    "description": "Welcome to Skibidi Toilet Melon Sandbox, where youll embark on a journey in epic battlefield with brave warrior. These Casual Merge Games bring exquisite model and scene, immersing battle master in the strategic challenges between monsters and warriors. In Monster Battle toilet games, take on the role of a strategic Battle Master, defeating toilet warriors by synthesizing fight monster! Toilet games emphasize thinking, make key decisions that affect victory or defeat!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Poppy Playtime",
      "Sandbox",
      "Skibidi",
      "Skibidi Toilet"
    ],
    "thumbnail": "https://img.gamemonetize.com/u1xads6x3swgts3gnmgdevln4ppa92qg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u1xads6x3swgts3gnmgdevln4ppa92qg/",
    "sourceUrl": "https://html5.gamemonetize.com/u1xads6x3swgts3gnmgdevln4ppa92qg/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68316",
    "slug": "candy-monster-raffi",
    "title": "Candy Monster Raffi",
    "description": "Help the candy monster Raffi eat all the candies! He absolutely loves them &ndash; all he wants is to eat candy. But be careful while collecting them! If you jump in the wrong direction, you might hit dangerous spikes. This cute little monster is hungry &ndash; run and feed Raffi with as many candies as you can!",
    "instructions": "Click on the candy just in time to eat the candies watch out for obstacles collect coins buy other costumes The game is available to play on both mobile devices and desktop computers",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Baby",
      "Baby Games",
      "Candy",
      "Cute",
      "Monster"
    ],
    "thumbnail": "https://img.gamemonetize.com/83norf6r3the27ijyignzve2eskynpfo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/83norf6r3the27ijyignzve2eskynpfo/",
    "sourceUrl": "https://html5.gamemonetize.com/83norf6r3the27ijyignzve2eskynpfo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "33854",
    "slug": "stupid-arrow",
    "title": "Stupid Arrow",
    "description": "Blunt Arrow is a one&ndash;of-a-kind action game that can train your reflexes to perfection. Try to walk to the end of the rapidly narrowing circle. The arrow cannot penetrate several objects, you will have to make a lot of accurate shots, and then reach the end. The game offers: Unique gameplay Good graphics Development of reaction and precision Hurry up and start playing, beat your friends high score and collect the rewards!",
    "instructions": "You start the game in the center of the circle your task is to get out of the circle by shooting accurately at the platforms the circle is constantly narrowing Can you get out of it",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Casual",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/mbqhd9nuimy0h206tvz1i6w83qhevw1r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mbqhd9nuimy0h206tvz1i6w83qhevw1r/",
    "sourceUrl": "https://html5.gamemonetize.com/mbqhd9nuimy0h206tvz1i6w83qhevw1r/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68168",
    "slug": "fruit-merge-juicy-drop-game",
    "title": "Fruit Merge: Juicy Drop Game",
    "description": "Dive deep into the vibrant and enthralling world of fruit-matching with our exciting game, Fruit Merge: Juicy Drop Game! When the same fruits collide, they merge into a larger fruit. Your mission is to smartly pair the same types of fruits to make the biggest possible fruits without letting them overflow from the container. However, as the fruits grow in size, space becomes a premium - managing it effectively is your key challenge. Can you strategize and solve this fruity puzzle?",
    "instructions": "Challenge yourself and create a giant fruit Start by merging two smaller fruits to eventually form a gigantic one It rsquo s a feat only 1 of players have achieved Are you ready to join that elite group",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fruits",
      "Puzzle",
      "watermelon"
    ],
    "thumbnail": "https://img.gamemonetize.com/rgz7sjhynwsheffgv4ijzz1nj2oa1nur/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rgz7sjhynwsheffgv4ijzz1nj2oa1nur/",
    "sourceUrl": "https://html5.gamemonetize.com/rgz7sjhynwsheffgv4ijzz1nj2oa1nur/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66286",
    "slug": "hoppyrushy",
    "title": "HoppyRushy",
    "description": "The character moves back and forth on the platform, controlling the characters upward jump to the safe platform. Coins are awarded during the game, and coins can unlock other characters. Lets see how many platforms you can skip.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Best Games",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/j7jweje9x9572zn26ozqlg7ddkd2fsjt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j7jweje9x9572zn26ozqlg7ddkd2fsjt/",
    "sourceUrl": "https://html5.gamemonetize.com/j7jweje9x9572zn26ozqlg7ddkd2fsjt/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68246",
    "slug": "labubu-zombie-miner",
    "title": "Labubu Zombie Miner",
    "description": "Labubu got lost in the mine while searching for gold and valuable minerals. The mines owner, a zombie miner, is chasing Labubu. Labubu must escape safely. Help him escape and reach the parchment at the end of the mine. The parchment is very important &mdash; it contains the way out of the mine. Reach the parchment safely!",
    "instructions": "Press W the key to jump Playable on both mobile and PC Double jump available",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "Arcade",
      "Mine",
      "Miner",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/t85v3af7y1yzwrpikrqr1zobpb3udk69/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t85v3af7y1yzwrpikrqr1zobpb3udk69/",
    "sourceUrl": "https://html5.gamemonetize.com/t85v3af7y1yzwrpikrqr1zobpb3udk69/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68324",
    "slug": "martial-artist",
    "title": "Martial Artist",
    "description": "This time, you are a martial artist, and you will experience the combination of killing and strategy. See how far you can last! Simple click controls and pixel graphics make this game perfect for casual players!",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "RPG",
      "Superhero",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/rhcgv1e11i4b969i0me6m3hgxn99295d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rhcgv1e11i4b969i0me6m3hgxn99295d/",
    "sourceUrl": "https://html5.gamemonetize.com/rhcgv1e11i4b969i0me6m3hgxn99295d/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67992",
    "slug": "bubble-pop-frenzy",
    "title": "Bubble Pop Frenzy",
    "description": "Bubble Pop Frenzy is a fast-paced arcade game where you pop bubbles to score points while avoiding dangerous bomble traps. The game speeds up the longer you play, testing your reflexes and focus. With retro-inspired visuals, smooth controls, and a catchy synthwave soundtrack, its easy to pick up and hard to put down. Try to beat your high score and survive the frenzy!",
    "instructions": "Click or tap on bubbles to pop them Avoid clicking on the bomble That rsquo s all you need to know mdash fast reactions are key",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Clicker",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/g7uysbgy2gxhui81qftkqyewt7rmdv0h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g7uysbgy2gxhui81qftkqyewt7rmdv0h/",
    "sourceUrl": "https://html5.gamemonetize.com/g7uysbgy2gxhui81qftkqyewt7rmdv0h/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67118",
    "slug": "mickey-run-adventure-game",
    "title": "Mickey Run Adventure Game",
    "description": "Welcome to the great kingdom craft! prepare yourself brave mickey, get ready to run, jump, dash and rush through the kingdom. In this craft game, you will be a runner who has to run and collect coins in an endless runner game mine. You need to be very careful as there will be many mouse in your way. You will need to use your craft Mickey and reflexes to avoid them and keep running. There will also be power-ups that you can collect to help you in the craft game.",
    "instructions": "Up Arrow - Jump Left Arrow - Move Left Right Arrow - Move Right Down Arrow - Slide",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Minecraft",
      "running",
      "subway"
    ],
    "thumbnail": "https://img.gamemonetize.com/cji6t48llsv4hcym69m6xvt4sbdxg741/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cji6t48llsv4hcym69m6xvt4sbdxg741/",
    "sourceUrl": "https://html5.gamemonetize.com/cji6t48llsv4hcym69m6xvt4sbdxg741/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68253",
    "slug": "roblox-in-barbie-style",
    "title": "Roblox In Barbie Style",
    "description": "Barbie meets the world of Roblox in this fun fashion game that lets you mix high-style outfits with blocky avatars. In Roblox in Barbie Style, your job is to style your Roblox character in pinks, sparkles, heels, and iconic Barbie-inspired outfits that pop.",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girls",
      "roblox"
    ],
    "thumbnail": "https://img.gamemonetize.com/xvuu8k046og4ofvsppbyvq0u995tsh62/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xvuu8k046og4ofvsppbyvq0u995tsh62/",
    "sourceUrl": "https://html5.gamemonetize.com/xvuu8k046og4ofvsppbyvq0u995tsh62/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68282",
    "slug": "run-guys-knockout-royale",
    "title": "Run Guys: Knockout Royale",
    "description": "Enjoy chaos, laughter, and action in Run Guys: Knockout Royale. A running and multiplayer royale game. In seesaw mode, run over one seesaw after another, keep balance and rush to the finish line. Racing at breakneck speeds through spinning wooden columns, trap floors and trap obstacles. Each level will knock out the slowest players. In mountain climbing, be the first to reach the summit and jump onto the crown.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Funny",
      "jump",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/bivqu9s6efq0gk7rknnqlad3qw0ncizt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bivqu9s6efq0gk7rknnqlad3qw0ncizt/",
    "sourceUrl": "https://html5.gamemonetize.com/bivqu9s6efq0gk7rknnqlad3qw0ncizt/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68272",
    "slug": "construction-simulator",
    "title": "Construction Simulator",
    "description": "Ready to build big and drive even bigger. Construction Simulator brings you into the most realistic world of construction driving simulation. Designed for boys who love mechanics, speed and challenges.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "build",
      "Driving",
      "Simulation",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/1ci7q4hq9q105lp1y1vxcar3rmccjuvt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1ci7q4hq9q105lp1y1vxcar3rmccjuvt/",
    "sourceUrl": "https://html5.gamemonetize.com/1ci7q4hq9q105lp1y1vxcar3rmccjuvt/",
    "width": 1630,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68254",
    "slug": "ballerina-cappuccina-first-date",
    "title": "Ballerina Cappuccina First Date",
    "description": "Tonight&rsquo;s a big night&mdash;Cappuccina and Tung Tung Sahur are heading out on their very first date, and they want to look perfect. In Ballerina Cappuccina First Date, you&rsquo;re the stylist behind their special evening. From choosing outfits to adding finishing touches, it&rsquo;s up to you to make sure both of them shine.",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dating",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/cqws3qg4cs5lpckma16j68fi3mou5dwe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cqws3qg4cs5lpckma16j68fi3mou5dwe/",
    "sourceUrl": "https://html5.gamemonetize.com/cqws3qg4cs5lpckma16j68fi3mou5dwe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "60618",
    "slug": "hexapuzzlenew",
    "title": "HexaPuzzleNew",
    "description": "Drag the blocks and place them in the container above to assemble them. Its very fun and has multiple exquisite levels. Come and experience it now.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/ywbb5779vnbfvxiz7oaj55ax0o2twj5y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ywbb5779vnbfvxiz7oaj55ax0o2twj5y/",
    "sourceUrl": "https://html5.gamemonetize.com/ywbb5779vnbfvxiz7oaj55ax0o2twj5y/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67679",
    "slug": "geometry-jump-dash",
    "title": "Geometry Jump Dash",
    "description": "Jump, dash, and fly through a pulse-pounding obstacle course where one wrong move means disaster! This fast-paced, high-energy arcade game challenges players of all skill levels with precision platforming, rhythmic obstacles, and adrenaline-fueled gameplay.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Dancing",
      "dash",
      "Geometry",
      "jump",
      "Jumping",
      "Rhythm"
    ],
    "thumbnail": "https://img.gamemonetize.com/8b8k4g56cc57x0ju186x94jq8emgqn4b/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8b8k4g56cc57x0ju186x94jq8emgqn4b/",
    "sourceUrl": "https://html5.gamemonetize.com/8b8k4g56cc57x0ju186x94jq8emgqn4b/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68217",
    "slug": "anime-couple-avatar-maker",
    "title": "Anime Couple: Avatar Maker",
    "description": "Anime Couple: Avatar Maker, the ultimate anime avatar character creation experience! Dive into the world of anime with our cutting-edge app that lets you design anime avatar faces, dress up girl avatars, and create the coolest anime couple characters youve ever seen.",
    "instructions": "Whether youre into cute and sweet anime couples or edgy and mysterious ones Anime Couple Avatar Maker has you covered With our comprehensive selection of features and customization options youll never run out of possibilities",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Anime",
      "Dress Up"
    ],
    "thumbnail": "https://img.gamemonetize.com/4d0lpu1afdv2u95rzunih13rii3z13mh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4d0lpu1afdv2u95rzunih13rii3z13mh/",
    "sourceUrl": "https://html5.gamemonetize.com/4d0lpu1afdv2u95rzunih13rii3z13mh/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68251",
    "slug": "tung-tungball-and-labububall",
    "title": "Tung TungBall and Labububall",
    "description": "You must survive in the world of balls. Two friends, Tungball and Labububall, need your help. They must collect all the coins, escape from the forest, find the key, and unlock the castle gate. Both friends must reach the castle safely. Reach the castle safely and earn the right to move on to the next level. Be careful &mdash; if the shelled monsters catch you, you&rsquo;ll lose.",
    "instructions": "Move to WASD Arrow Keys Double Jump available Mobile Touch Control Collect all the coins and the golden key then reach the gate",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "Arcade",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/t8cff8dsfvu1mrtphdb8jl7nkj9yjbxp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t8cff8dsfvu1mrtphdb8jl7nkj9yjbxp/",
    "sourceUrl": "https://html5.gamemonetize.com/t8cff8dsfvu1mrtphdb8jl7nkj9yjbxp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68259",
    "slug": "pixel-draw",
    "title": "Pixel Draw",
    "description": "Unleash your creativity by crafting unique pixel art from scratch. In Pixel Draw, there are no templates &mdash; only your imagination and a grid waiting to be filled. Whether youre sketching a hero, a symbol, or something abstract, this is your chance to become a true pixel artist. Save your masterpiece and share it with friends to showcase your talent.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Block",
      "Board",
      "Color",
      "Coloring",
      "Creation",
      "Draw",
      "Drawing",
      "free html5 games for your website",
      "Number",
      "Pixel",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/9w69vw0kvi9q6bz9zd5rrsp3den3l3fs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9w69vw0kvi9q6bz9zd5rrsp3den3l3fs/",
    "sourceUrl": "https://html5.gamemonetize.com/9w69vw0kvi9q6bz9zd5rrsp3den3l3fs/",
    "width": 320,
    "height": 180,
    "lastUpdated": ""
  },
  {
    "id": "68271",
    "slug": "amazing-paper-doll-diary",
    "title": "Amazing Paper Doll Diary",
    "description": "Welcome to Amazing Paper Doll Diary, a collection of casual mini-games, exclusively for girl players. If you are searching for relaxation online, do not hesitate to join our amazing game selection! Whether you prefer fashion design, doll dress-up, or animal games, you can enjoy a relaxing and refreshing gaming experience with our mini-games. Play the paper doll game in an easy and reactive way.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/w2x1562hsvjf8nco9ko301zjpjxglv6l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w2x1562hsvjf8nco9ko301zjpjxglv6l/",
    "sourceUrl": "https://html5.gamemonetize.com/w2x1562hsvjf8nco9ko301zjpjxglv6l/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68278",
    "slug": "snake-2025",
    "title": "Snake 2025",
    "description": "Snake 2025 is a modern remake of the classic snake game with sleek graphics and smooth controls. Navigate the snake to collect orbs, grow longer, and compete for high scores. Featuring updated mechanics, retro-inspired visuals, and fast-paced arcade action. A perfect mix of nostalgia and challenge!",
    "instructions": "Arrow Keys or WASD to move Avoid hitting yourself or the walls",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Arcade",
      "Snake"
    ],
    "thumbnail": "https://img.gamemonetize.com/lyjm245mz7i1tcryloatgl8nq739g08c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lyjm245mz7i1tcryloatgl8nq739g08c/",
    "sourceUrl": "https://html5.gamemonetize.com/lyjm245mz7i1tcryloatgl8nq739g08c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68281",
    "slug": "volleyball-fun-coloring",
    "title": "Volleyball Fun Coloring",
    "description": "Dive into the colorful world of Volleyball Fun Coloring: a cheerful and free online coloring game where kids can spike their creativity and serve up bright beach vibes one crayon at a time!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Boys",
      "Coloring",
      "Educational",
      "Fun",
      "Girls",
      "Hypercasual",
      "School",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/rgcxnhuoej7i3iqsntrctbsajvc1vfvb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rgcxnhuoej7i3iqsntrctbsajvc1vfvb/",
    "sourceUrl": "https://html5.gamemonetize.com/rgcxnhuoej7i3iqsntrctbsajvc1vfvb/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "68214",
    "slug": "the-ink-shop-tattoo-art-asmr",
    "title": "The Ink Shop Tattoo Art ASMR",
    "description": "Step into the evocative world of tattoo artistry with The Ink Shop - Tattoo Art ASMR. Designed to offer a unique blend of creativity and relaxation, the application puts you in the role of a skilled tattoo artist, responsible for turning clients visions into stunning inked realities. This immersive game not only allows you to explore artistic expressions but also provides the soothing ambiance of ASMR through every phase of the tattooing process.",
    "instructions": "At the heart of the app you will encounter customers each with a unique backstory and tattoo ideas Your task is to guide them through the tattoo journey - from preparing the skin with shaves and antiseptics to the meticulous inking With hundreds of des",
    "category": "3D",
    "genres": [
      "3D"
    ],
    "tags": [
      "Coloring",
      "Drawing"
    ],
    "thumbnail": "https://img.gamemonetize.com/e7wae4uvniaucl2txzi4h0di7t680amw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e7wae4uvniaucl2txzi4h0di7t680amw/",
    "sourceUrl": "https://html5.gamemonetize.com/e7wae4uvniaucl2txzi4h0di7t680amw/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68218",
    "slug": "super-robot-chogokin",
    "title": "Super Robot Chogokin",
    "description": "Play a relaxing destruction game in Super Robot Chogok. You control a giant robot. Smash, crash, and destroy everything in your path. This game is perfect for any boy who dreams of robot domination! The gameplay is super simple and satisfying. Guide your robot through the city, crash into cars, buildings, etc. Unleash powerful moves to destroy and avoid damage!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "destroy",
      "Robot",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/ilrgmbbz9iahzagncq6oamsbmgktufph/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ilrgmbbz9iahzagncq6oamsbmgktufph/",
    "sourceUrl": "https://html5.gamemonetize.com/ilrgmbbz9iahzagncq6oamsbmgktufph/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68219",
    "slug": "zoo-anomaly-simulation",
    "title": "Zoo Anomaly Simulation",
    "description": "Experience a zoo mutation crisis like no other. In Zoo Anomaly Simulation, a peaceful zoo has turned into a nightmare filled with mutated animals, and you&rsquo;re the only one who can stop the chaos! Enter a first-person shooting experience like no other. Explore the eerie zoo environment, grab your weapons, and fight back against giraffes, zebras, elephants, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Animal",
      "Fun",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/u2oar7g2hbolp2qkm5okuqa6nnfcmuty/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u2oar7g2hbolp2qkm5okuqa6nnfcmuty/",
    "sourceUrl": "https://html5.gamemonetize.com/u2oar7g2hbolp2qkm5okuqa6nnfcmuty/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66980",
    "slug": "swing-hero",
    "title": "Swing Hero",
    "description": "Swing Hero is an action-packed adventure game where a monkey swings down a cliff using a rope! As the monkey slides down, obstacles like rocks and snakes block the way. You need to swing left and right to avoid hitting them. It&rsquo;s a thrilling and fun game that tests your timing and reflexes. How far can your monkey swing?",
    "instructions": "Desktop Mouse Drag Swing Rope Mobile Click and hold Swing Rope",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Casual",
      "Clicker",
      "HTML",
      "HTML5",
      "Hypercasual",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/czcr4z403xj0fdtaqc8ilxvlvzvj3v1r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/czcr4z403xj0fdtaqc8ilxvlvzvj3v1r/",
    "sourceUrl": "https://html5.gamemonetize.com/czcr4z403xj0fdtaqc8ilxvlvzvj3v1r/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68242",
    "slug": "where-is-my-water",
    "title": "Where is my Water",
    "description": "Help Swampy by guiding water to his broken shower. Each level is a challenging physics-based puzzle with amazing life-like mechanics. Cut through dirt to guide fresh water, dirty water, toxic water, steam, and ooze through increasingly challenging scenarios! Every drop counts!",
    "instructions": "Use the mouse or touch to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Cute",
      "free html5 games for your website",
      "HTML5",
      "Hypercasual",
      "Kids",
      "Maze",
      "Physics",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/1g5cp5vlxs5vbbvfj5965fd119k19fqv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1g5cp5vlxs5vbbvfj5965fd119k19fqv/",
    "sourceUrl": "https://html5.gamemonetize.com/1g5cp5vlxs5vbbvfj5965fd119k19fqv/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67930",
    "slug": "cinema-empire-idle-tycoon",
    "title": "Cinema Empire Idle Tycoon",
    "description": "Welcome to Cinema Empire Idle Tycoon! Do you dream of owning your own movie theater empire? Nows your chance! In this super fun idle simulation management game, youll start with a small screening room! Build your own cinema empire! As a theater owner, you need to manage every aspect of the theater. Unlock the theaters facilities, ticket booths, movie halls, dining areas, and more. Hiring employees to help you get more bang for your buck.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fun",
      "idle",
      "Movie"
    ],
    "thumbnail": "https://img.gamemonetize.com/7en169urbumxr5ii05udu97ucun00t0n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7en169urbumxr5ii05udu97ucun00t0n/",
    "sourceUrl": "https://html5.gamemonetize.com/7en169urbumxr5ii05udu97ucun00t0n/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "34592",
    "slug": "fish-master",
    "title": "Fish master",
    "description": "Master of Fishing - a new project for fans to sit with a fishing rod, and just relax. The game will give you extremely positive emotions, here you will be able to catch the fish you want, but you have to try. The game offers: - Meditative gameplay - Nice drawn graphics - Realistic fishing Are you ready to cast your rod and pull in your biggest catch? Then go for it!",
    "instructions": "Your character is in a boat and all you have to do is fish Cast your line and fish gradually upgrade your equipment and pull in more and more fish good luck",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io",
      ".io Games",
      "1 Player",
      "Fish",
      "Fishing"
    ],
    "thumbnail": "https://img.gamemonetize.com/1xhcqbonnmw8i8zn6kovy66mk3u1b15i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1xhcqbonnmw8i8zn6kovy66mk3u1b15i/",
    "sourceUrl": "https://html5.gamemonetize.com/1xhcqbonnmw8i8zn6kovy66mk3u1b15i/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67371",
    "slug": "great-zigzag-game-3d",
    "title": "Great ZigZag Game 3D",
    "description": "Hello! Change the direction of the ball by clicking on the screen and try not to fall! You earn points with each click! Try to get the highest score! Be careful, if you accidentally fall, you lose! Be the one who gets the highest score among your friends! Are you ready to have fun with this zigzag game played with simple logic? If you are ready, why are you waiting! Start playing this zigzag game suitable for all ages right away! Be careful, the game will get faster and harder! But we have no doubt that you will get the highest score thanks to your skills!",
    "instructions": "When you click on the screen the direction of the ball changes",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Casual",
      "Click",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/irxqhf16k9lw6miolq132b9a5effvfc9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/irxqhf16k9lw6miolq132b9a5effvfc9/",
    "sourceUrl": "https://html5.gamemonetize.com/irxqhf16k9lw6miolq132b9a5effvfc9/",
    "width": 480,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68134",
    "slug": "geometry-rash",
    "title": "Geometry Rash",
    "description": "Geometry Rash is a high-speed action platformer where every move counts. Jump your way through 8 challenging levels filled with spikes and traps. As you progress, you&rsquo;ll unlock new gameplay forms, fly with the ship or boost with the rocket. Mastering each style is key to surviving later levels. Along the way, collect coins to unlock fresh character looks in the shop. With tight controls and tough level design, this game will test your reflexes and rhythm!",
    "instructions": "Tap or click to jump You begin with the cube form As you beat levels you rsquo ll unlock the ship and rocket forms each with different movement In rocket form hold to fly upward and release to fall Time your moves to dodge traps and collect coins",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Avoid",
      "dash",
      "Geometry",
      "Obstacle",
      "Platform",
      "running",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/izlut8sr8h9k4lz0p0cg3t07wlj0adok/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/izlut8sr8h9k4lz0p0cg3t07wlj0adok/",
    "sourceUrl": "https://html5.gamemonetize.com/izlut8sr8h9k4lz0p0cg3t07wlj0adok/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68173",
    "slug": "bitcoin-io",
    "title": "Bitcoin.io",
    "description": "&lt;Chomp your way to the top in Bitcoin.io &ndash; the crypto-themed multiplayer madness! Munch coins and energy to grow bigger, dodge rivals, and dominate the leaderboard in this fast-paced online arena. It is free, frantic, and super fun. Are you ready to become the biggest Bitcoin in the blockchain?",
    "instructions": "Mouse to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io",
      ".io Games",
      "Arena",
      "Avoid",
      "Boys",
      "Collecting",
      "Hypercasual",
      "Kids",
      "Multiplayer"
    ],
    "thumbnail": "https://img.gamemonetize.com/m6zjbir993y0jreqoja76d0gub0u8une/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m6zjbir993y0jreqoja76d0gub0u8une/",
    "sourceUrl": "https://html5.gamemonetize.com/m6zjbir993y0jreqoja76d0gub0u8une/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68203",
    "slug": "dinosaur-shifting-run",
    "title": "Dinosaur Shifting Run",
    "description": "Imagine sprinting across a scorching desert as a human adventurer, then transforming into a mighty dinosaur to smash through obstacles in a lush jungle! Unlike other runner games, Dinosaur Shifting Run offers unique challenges in every level, keeping the gameplay fresh and exciting.",
    "instructions": "- Transform the character to suit the environment - Make sure you choose the right one to become the winner - The higher level it is the more difficult game-play it is",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "dino",
      "Dinosaur",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ok4q1z95gioil2getwab0s9atkxovc4x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ok4q1z95gioil2getwab0s9atkxovc4x/",
    "sourceUrl": "https://html5.gamemonetize.com/ok4q1z95gioil2getwab0s9atkxovc4x/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68207",
    "slug": "unblocked-forest-fireboy-and-watergirl",
    "title": "Unblocked Forest Fireboy And Watergirl",
    "description": "Want a mind-bending and action forest adventure in Unblocked Forest Fireboy And Watergirl? Play alone or with friends and join adventures! This classic multiplayer puzzle game brings the iconic Fireboy and Watergirl duo back into a mysterious Forest temple. Silent cooperation is the only way to get through! Each collects gems and gold coins of the corresponding color. Push the boxes, press the switches, and cooperate with each other to pass the level successfully.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Fire",
      "Multiplayer",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/1xvemgqh10s5oag3rrvukaeny2fd7ekk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1xvemgqh10s5oag3rrvukaeny2fd7ekk/",
    "sourceUrl": "https://html5.gamemonetize.com/1xvemgqh10s5oag3rrvukaeny2fd7ekk/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67934",
    "slug": "the-long-drive",
    "title": "The Long Drive",
    "description": "Love driving games? Love car simulation but keen on racing? Then you definitely cant miss The Long Drive! This is a real and crazy driving simulation game for boys who love adventure! In this open world, you drive a car and start your challenge. In Free Mode, you can complete various challenges and earn rewards.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Car",
      "Driving",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/bsd3wzjpyo42ju9u2a3rngru0q28r1jy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bsd3wzjpyo42ju9u2a3rngru0q28r1jy/",
    "sourceUrl": "https://html5.gamemonetize.com/bsd3wzjpyo42ju9u2a3rngru0q28r1jy/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67415",
    "slug": "online-cats-multiplayer-park",
    "title": "Online Cats Multiplayer Park",
    "description": "Come to run, jump, guess, and race as a cute but competitive kitty in Online Cats - Multiplayer Park. It&rsquo;s a real-time multiplayer chaos arena. Here are seven modes you can choose from. In Grab A Shabby Ball, for example, you will have to compete with your opponents and try to touch the ball to get points.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Arcade",
      "Cat",
      "jump",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/2zzd4eaozs2hipxphec84xoac3sagofk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2zzd4eaozs2hipxphec84xoac3sagofk/",
    "sourceUrl": "https://html5.gamemonetize.com/2zzd4eaozs2hipxphec84xoac3sagofk/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68081",
    "slug": "fruit-memory-extravaganza",
    "title": "Fruit Memory Extravaganza",
    "description": "Fruit Memory Extravaganza is a vibrant and juicy card-based memory game that challenges your brain and sharpens your recall skills! Flip cards one by one to find matching fruit pairs &mdash; from bananas to berries &mdash; all within a limited time. With 6 increasingly tricky levels, each round gets faster and more challenging, testing how quickly and accurately you can match the fruity duos. Can you conquer the fruit frenzy before the clock runs out? Key Features: Flip-and-match fruit cards in a race against time Boosts memory and concentration skills Time-limited challenges across all levels Colorful fruit-themed visuals",
    "instructions": "Match the cards click to flip",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Card",
      "Matching",
      "Memory"
    ],
    "thumbnail": "https://img.gamemonetize.com/idlyjbyn8fsu8zus5o3qkvovxogm9dtj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/idlyjbyn8fsu8zus5o3qkvovxogm9dtj/",
    "sourceUrl": "https://html5.gamemonetize.com/idlyjbyn8fsu8zus5o3qkvovxogm9dtj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "33853",
    "slug": "fide-the-hole",
    "title": "Fide The Hole",
    "description": "Continuation of the successful game Physical Maze, updated graphics and sounds have been added in the new part. The number of levels has also almost doubled! Now you need to complete the levels, avoiding obstacles. The levels have become more difficult, and the physical model will delight sophisticated players with its sophistication. Start playing, get rewards and unlock new levels! Develop spatial thinking!",
    "instructions": "To play you will need a mouse or the screen of your smartphone Start completing the first level and discover a new physics model The game is made with an emphasis on developing your spatial thinking Therefore its not just entertainment its also a gr",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ball",
      "Logic",
      "Logical"
    ],
    "thumbnail": "https://img.gamemonetize.com/fjidc6224f2ob7jptc7fp88bvrjwmell/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fjidc6224f2ob7jptc7fp88bvrjwmell/",
    "sourceUrl": "https://html5.gamemonetize.com/fjidc6224f2ob7jptc7fp88bvrjwmell/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68111",
    "slug": "road-crosser",
    "title": "ROAD CROSSER",
    "description": "This is a 3D casual game. You can control the character to eat coins while avoiding cars. Coins can be used to buy new and cuter skins.",
    "instructions": "Keyborard",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "3D",
      "Bird",
      "Cars"
    ],
    "thumbnail": "https://img.gamemonetize.com/a2039w4pyybxc19zxs2qiiy4gpnpwyv4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a2039w4pyybxc19zxs2qiiy4gpnpwyv4/",
    "sourceUrl": "https://html5.gamemonetize.com/a2039w4pyybxc19zxs2qiiy4gpnpwyv4/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "68138",
    "slug": "physical-ball",
    "title": "Physical Ball",
    "description": "Physics Balls is Suit for all age and completely FREE to play! Now become the master of the Physic Balls! Features: Perfect physic ball bouncy engine Fully automatic progress save Endless game mode Tablet support",
    "instructions": "Aim at breaking all bricks by one shoot Swipe your finger and throw balls Make them roll among the bricks Hit items to make extra balls or double size ball Prevent the bricks to reach the check-line",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2048",
      "2D",
      "amazing",
      "Ball",
      "Best Games",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/2er4hiizbdlsbszayxfnc0jyymxnawxe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2er4hiizbdlsbszayxfnc0jyymxnawxe/",
    "sourceUrl": "https://html5.gamemonetize.com/2er4hiizbdlsbszayxfnc0jyymxnawxe/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "68186",
    "slug": "mahjong-fruit-3d",
    "title": "Mahjong Fruit 3D",
    "description": "Before you on the screen will be seen a three-dimensional image of cubes on the faces of which you will see various images of fruits. You will need to carefully examine everything, find the same fruits completely and clicking on them to highlight the cubes on which they are applied. Having done this, you will see how these objects will disappear from the game field. For this, you will accrue points and you will make the next move. Your task in the game Mahjong Fruit 3D in the minimum time and the number of moves completely clean the field of cubes.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Best",
      "Brain",
      "Fruit",
      "Fun",
      "Logic",
      "Mahjong",
      "Mobile",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/abcd3b9hjuolfjqliv646ckgph1c961c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/abcd3b9hjuolfjqliv646ckgph1c961c/",
    "sourceUrl": "https://html5.gamemonetize.com/abcd3b9hjuolfjqliv646ckgph1c961c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68196",
    "slug": "quick-shot",
    "title": "Quick Shot",
    "description": "Quick Shot is a fast-paced online shooting game where precision is everything. Your goal is simple: hit each target exactly in the center to score the highest points. But be careful &mdash; you can only miss five times before the game ends. With quick reflexes and sharp aim, you&rsquo;ll need to stay focused as the targets appear faster and more unpredictably. How long can you keep your streak alive? Test your skills and aim for perfection in Quick Shot!",
    "instructions": "Tap on the game screen to play this game",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Arcade",
      "Kids",
      "Shoot",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/p30bd06tsk4xsta5lqqeyw0139voa5bx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p30bd06tsk4xsta5lqqeyw0139voa5bx/",
    "sourceUrl": "https://html5.gamemonetize.com/p30bd06tsk4xsta5lqqeyw0139voa5bx/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68187",
    "slug": "tap-cute-animals",
    "title": "Tap Cute Animals",
    "description": "Get ready to unwind in a cheerful clicker adventure where every tap brings rewards. In Tap Cute Animals, you&rsquo;ll collect coins, unlock adorable creatures, and dress them up in all sorts of quirky hats. Combine animals and outfits to craft delightful styles, explore charming new worlds, and upgrade your clicking power to progress faster. Its a fun and cozy way to spend your time!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Animal",
      "Clicker",
      "Cute",
      "free html5 games for your website",
      "Fun",
      "Hot",
      "Hypercasual",
      "idle",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/ycmhmx85vqq1lzfehe72kt8bz2erk1ds/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ycmhmx85vqq1lzfehe72kt8bz2erk1ds/",
    "sourceUrl": "https://html5.gamemonetize.com/ycmhmx85vqq1lzfehe72kt8bz2erk1ds/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "68195",
    "slug": "tung-tung-tung-sahur-vs-bombardino-crocodilo",
    "title": "Tung Tung Tung Sahur VS Bombardino Crocodilo",
    "description": "The two greatest enemies meet on a long road. Although one is strong, the others powerful stick blows are breaking through the air. Will you be able to carry the true hero to victory?",
    "instructions": "W or Up Arrow or Spacebar or Slide up for jump D or Right Arrow or Slide right for right A or Left Arrow or Slide reft for left Left Mouse Button or Fire Button for throw bat",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "Brainrot Italian",
      "Italian Brainrot",
      "running",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/c3a4z7osw0f0ywsr1xo49dhed1knukin/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c3a4z7osw0f0ywsr1xo49dhed1knukin/",
    "sourceUrl": "https://html5.gamemonetize.com/c3a4z7osw0f0ywsr1xo49dhed1knukin/",
    "width": 540,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "68209",
    "slug": "cod-duty-call-fps",
    "title": "COD Duty Call FPS",
    "description": "Step into the war-torn battlefield in COD Duty Call FPS, a fast-paced first-person shooter that throws players into the heart of modern warfare. Set in a near-future conflict, you assume the role of an elite special forces operative deployed across volatile regions, urban warzones, and covert enemy facilities in a campaign filled with explosive action and immersive storytelling. COD Duty Call FPS delivers an adrenaline-fueled experience where your reflexes, tactics, and precision will determine survival. The game features a gripping single-player campaign that follows a high-stakes mission to prevent global catastrophe. As a member of Shado",
    "instructions": "WASD - move Space - jump mouse - aim and shoot shift - run",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Action",
      "Adventure",
      "apocalypse",
      "Army",
      "assassin",
      "Best Games",
      "First Person Shooter",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/rc0aptuuleju6xnlpeds38lisqpz1hzu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rc0aptuuleju6xnlpeds38lisqpz1hzu/",
    "sourceUrl": "https://html5.gamemonetize.com/rc0aptuuleju6xnlpeds38lisqpz1hzu/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67939",
    "slug": "otr-off-road-driving",
    "title": "Otr Off Road Driving",
    "description": "Love car games and a true off-road driving adventure? In OTR Off-road Driving, you will have a real vehicle simulation experience. Enter off-road mode, choose different levels to start your challenge. Challenge your driving skills in the mountains. Work your way up the steep hill to your destination. Enter the Flyover Bridge Mode, control your car to the bullseye and win. Pay attention to finish the task within the time.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "hills",
      "offroad"
    ],
    "thumbnail": "https://img.gamemonetize.com/vpzq3xlp2ff0238wccv4nx91334kkpd6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vpzq3xlp2ff0238wccv4nx91334kkpd6/",
    "sourceUrl": "https://html5.gamemonetize.com/vpzq3xlp2ff0238wccv4nx91334kkpd6/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67412",
    "slug": "tank-attack-2",
    "title": "Tank Attack 2",
    "description": "Ready, warrior. Tank Attack will bring you to the most explosive battlefield ever. Control your tank and straight into chaos! Your goal is to attack, destroy and survive. Use your cannon to shoot at the enemys tanks and take advantage of the terrain to avoid their attacks. Simple controls, epic action, perfect for every boy who loves driving games!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "destroy",
      "survival",
      "Tanks"
    ],
    "thumbnail": "https://img.gamemonetize.com/4zbu48bx93xhmvjyqpuo0o9rj0zpgxf1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4zbu48bx93xhmvjyqpuo0o9rj0zpgxf1/",
    "sourceUrl": "https://html5.gamemonetize.com/4zbu48bx93xhmvjyqpuo0o9rj0zpgxf1/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "68131",
    "slug": "dead-seek",
    "title": "Dead Seek",
    "description": "Dive into an explosive action-packed arcade where every shot is a fight for survival! Face relentless zombie hordes using a wide arsenal of weapons and upgrade them for maximum firepower. Discover new tactics and explore dangerous zones crawling with the infected. With vibrant graphics, thrilling gameplay, and non-stop action, theres never a dull moment. Are you ready to take on the challenge and survive the walking dead?",
    "instructions": "Shooting zombies is automatic Desktop Use WASD keys to move Mobile Use the on-screen controls",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Action",
      "Defense",
      "demolition",
      "endless",
      "Enemies",
      "Game",
      "Gun",
      "Horror",
      "Hunting",
      "Shooter",
      "Undead",
      "weapons",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/zt2tti9k25tgwbwmnacqoxz6l921m956/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zt2tti9k25tgwbwmnacqoxz6l921m956/",
    "sourceUrl": "https://html5.gamemonetize.com/zt2tti9k25tgwbwmnacqoxz6l921m956/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68164",
    "slug": "shape-shifting-race-game",
    "title": "Shape Shifting: Race Game",
    "description": "Shape Shifting will take you across of all environment: land, air, sea To conquer them, you have to adapt quickly through all these environments Game Features - Transformable characters - Beautiful graphic design and relaxing soundtrack - Many exciting levels - Satisfying and addictive game-play",
    "instructions": "- Transform the character to suit the environment - Make sure you choose the right one to become the winner - The higher level it is the more difficult game-play it is",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/oa6vl05onazdmyfx6vji5p6dzp0otupv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oa6vl05onazdmyfx6vji5p6dzp0otupv/",
    "sourceUrl": "https://html5.gamemonetize.com/oa6vl05onazdmyfx6vji5p6dzp0otupv/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68145",
    "slug": "formula-go",
    "title": "Formula Go",
    "description": "Get behind the wheel of a high-speed Formula 1 car and challenge clever AI competitors on detailed tracks modeled after famous real-world circuits. Formula Go offers thrilling racing with responsive controls, intense competition, and a focus on driving skill. Fine-tune your vehicle, navigate sharp bends, and push your limits to secure a top spot on the podium.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "Cars",
      "Driving",
      "free html5 games for your website",
      "Kart",
      "Racing",
      "Road",
      "Sport",
      "Supercars"
    ],
    "thumbnail": "https://img.gamemonetize.com/ss7hiku3sutu1jiftnohynx0d4nddhhm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ss7hiku3sutu1jiftnohynx0d4nddhhm/",
    "sourceUrl": "https://html5.gamemonetize.com/ss7hiku3sutu1jiftnohynx0d4nddhhm/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "33856",
    "slug": "ball-jumping",
    "title": "Ball Jumping",
    "description": "Bouncing ball is a great entertainment for fans of old games. This project is a kind of reincarnation of the old mobile ball games. The game is waiting for you: Classic platform gameplay Beautiful graphics Responsive and clear direction Come in and start playing! Complete the levels, collect rewards and train your reaction! Its all in the game.",
    "instructions": "You start at the bottom of the level your task is to go up When the ball pushes off the wall it changes direction Use this to successfully complete the levels Good luck",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ball",
      "Best Games",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/vvdwe8a4lvj7hphobgmn2fsvnwo2t4ut/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vvdwe8a4lvj7hphobgmn2fsvnwo2t4ut/",
    "sourceUrl": "https://html5.gamemonetize.com/vvdwe8a4lvj7hphobgmn2fsvnwo2t4ut/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68090",
    "slug": "punching-excavator-breakdown",
    "title": "Punching Excavator: Breakdown!",
    "description": "Control a realistic excavator with detailed physics of movement and manipulation. Complete tasks of varying difficulty, from simple one-story constructions to complex multi-story buildings. Get rewards for each successfully completed level and invest your earnings in improving your equipment or cosmetic improvements to your character.",
    "instructions": "Motion Control W Forward movement S Backward movement A Move left D Move to the right Use the mouse wheel to rotate the sphere smoothly Mobile version Joystick to move Slider to change the rotation angle",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "builder",
      "building",
      "demolition"
    ],
    "thumbnail": "https://img.gamemonetize.com/i2185ta9sze8lwhmr43eq0ulwyt13fvq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i2185ta9sze8lwhmr43eq0ulwyt13fvq/",
    "sourceUrl": "https://html5.gamemonetize.com/i2185ta9sze8lwhmr43eq0ulwyt13fvq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67773",
    "slug": "idle-game-prison-life",
    "title": "Idle Game Prison Life",
    "description": "Ever dreamed of running your prison? Now&rsquo;s your chance! In this casual idle simulator, you&rsquo;ll create a high-security prison empire. Upgrade and expand until you are on your way to becoming a tycoon! Create the perfect prison layout with cells, kitchens, gyms, and surveillance! Recruit guards, medics, and more to keep things under control.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "idle",
      "Prison",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/fb5p9tfhex856zb56obrhgr4vxq9q4vn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fb5p9tfhex856zb56obrhgr4vxq9q4vn/",
    "sourceUrl": "https://html5.gamemonetize.com/fb5p9tfhex856zb56obrhgr4vxq9q4vn/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68050",
    "slug": "cake-sorting-deluxe",
    "title": "Cake Sorting Deluxe",
    "description": "Cake Sorting Deluxe is a fun and relaxing puzzle game that challenges your sorting skills! Shift cakes across shelves to make matches of three or more. Clear the board, uncover hidden and shadowed cakes, and solve tricky puzzles as you go. With cute visuals, smooth gameplay, and lots of sweet challenges, Cake Sorting Deluxe is a treat for anyone who loves a good puzzle. Ready to mix, match, and clear the shelves?",
    "instructions": "Use a mouse or touchpad to shift the cakes across the shelves Uncover hidden and shadowed cakes to complete each level and move on to the next sweet puzzle",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Cake",
      "Match 3",
      "Matching",
      "Puzzle",
      "sorting"
    ],
    "thumbnail": "https://img.gamemonetize.com/66ju6j48hp5fcnxs2r30qg771tai27wk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/66ju6j48hp5fcnxs2r30qg771tai27wk/",
    "sourceUrl": "https://html5.gamemonetize.com/66ju6j48hp5fcnxs2r30qg771tai27wk/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "68078",
    "slug": "pac-ring-adventure-pro",
    "title": "Pac Ring Adventure PRO",
    "description": "Pac Ring Adventure Pro is a thrilling twist on the classic Pacman experience! Navigate a fast-paced circular maze as Pacman chomps through glowing dots while dodging relentless enemies that patrol the ring. With tight turns, shifting speeds, and strategic movement, every second counts in this action-packed arcade adventure. Stay sharp, collect power-ups, and see how long you can survive the ring of danger! Key Features: Unique circular maze design for a fresh Pacman challenge Dodge and outmaneuver clever enemies on the ring Collect dots and power-ups to boost your score Fast, fluid gameplay with increasing difficulty",
    "instructions": "Click tap to change direction of pacman",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "PacMan",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/hq82mze3k8g0r687wj0iu9jxz7zz6uh1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hq82mze3k8g0r687wj0iu9jxz7zz6uh1/",
    "sourceUrl": "https://html5.gamemonetize.com/hq82mze3k8g0r687wj0iu9jxz7zz6uh1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67929",
    "slug": "toca-avatar-my-house",
    "title": "Toca Avatar My House",
    "description": "Welcome to Toca Avatar My House, a casual simulation game where you arrange your own house in the gaming world. If you are a Toca Boca enthusiast, try this life simulator game. You will find more pleasure living in a lovely house designed and decorated by yourself! Click on any of the items and drag to move them to any place you want. Put things in order, categorize cooking utensils, fill the cats bowl with food...",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cooking",
      "Design",
      "Food"
    ],
    "thumbnail": "https://img.gamemonetize.com/gpizzrb1zip4gk8v3pysd6244nxg0wi0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gpizzrb1zip4gk8v3pysd6244nxg0wi0/",
    "sourceUrl": "https://html5.gamemonetize.com/gpizzrb1zip4gk8v3pysd6244nxg0wi0/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "65113",
    "slug": "childcare-master-online",
    "title": "Childcare Master Online",
    "description": "Get ready to become a parenting superstar in Childcare Master Online! This wonderful casual simulation game is all about playing the role of a top parenting expert. As soon as you start the game, youll find yourself in a lively daycare center with adorable kids. Whats your mission? Give them love and care! First, you need to create a warm environment.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Kids",
      "Love",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/o4tigdwwi6p1sldb0f1qwafnozepvbej/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/o4tigdwwi6p1sldb0f1qwafnozepvbej/",
    "sourceUrl": "https://html5.gamemonetize.com/o4tigdwwi6p1sldb0f1qwafnozepvbej/",
    "width": 768,
    "height": 1600,
    "lastUpdated": ""
  },
  {
    "id": "68038",
    "slug": "off-road-motocross",
    "title": "Off road motocross",
    "description": "Off-road motocross is an exciting world of speed and adrenaline. Take a ride on dangerous tracks, overcome obstacles and upgrade your vehicles to become the king of the road. Drive a powerful motorcycle, perform stunts and improve your skills in an exciting racing game. Feel the speed and freedom while playing this addictive game.",
    "instructions": "In the game you control a motorcycle maintaining balance and control over it by pressing the buttons W and S or the up and down arrows To speed up the motorcycle use A and D or the left and right arrows to overcome various obstacles and get to the",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Moto",
      "Motocross",
      "Motorcycle",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/vcecgonbw7uvc92nrt8xgwx9meouuqtz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vcecgonbw7uvc92nrt8xgwx9meouuqtz/",
    "sourceUrl": "https://html5.gamemonetize.com/vcecgonbw7uvc92nrt8xgwx9meouuqtz/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68115",
    "slug": "draw-bridge-puzzle-brain-game",
    "title": "Draw Bridge Puzzle: Brain Game",
    "description": "Draw Bridge Puzzle - Draw Game is an exciting and challenging brain game that will put your problem-solving skills to the test. In this bridge-building adventure, your task is to draw paths for the car to safely navigate through obstacles and reach its destination. Get ready to embark on a thrilling journey of bridge construction and puzzle-solving as you draw roads to rescue the stranded car!",
    "instructions": "- Touch the screen to start drawing - Hold and drag across to make the shapes you want - Once you finish release your finger and the car will run",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Car",
      "Drawing",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/73gtxpfmu8jwdvdfs76vitskhoijp8hl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/73gtxpfmu8jwdvdfs76vitskhoijp8hl/",
    "sourceUrl": "https://html5.gamemonetize.com/73gtxpfmu8jwdvdfs76vitskhoijp8hl/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "68049",
    "slug": "bffs-kidcore-outfits",
    "title": "Bffs Kidcore Outfits",
    "description": "Welcome to Bffs Kidcore Outfits. Kidcore is an aesthetic that centers around bright colors, icons from the 90s, and kiddy themes. These young girls are very excited to try this fashion. Join as a fashion expert and browse the wardrobe for cute outfits. Pick a suitable one for each girl and give a unique hairstyle to them. Play these new dress-up games for girls at cutedressup.com",
    "instructions": "Left mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Cute",
      "Dress Up",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/3cnn1qrre8wolyjh2yxd2a60vqzafqtl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3cnn1qrre8wolyjh2yxd2a60vqzafqtl/",
    "sourceUrl": "https://html5.gamemonetize.com/3cnn1qrre8wolyjh2yxd2a60vqzafqtl/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "33852",
    "slug": "level-rotator",
    "title": "Level Rotator",
    "description": "The game is about a single ball that is located at the beginning of the pipe. Help him reach the end. Here you control not the ball, but all the levels at once! Try to reach the end by avoiding various obstacles along the way. In the game you will find: Memorable levels Intuitive operation Good graphics Just relax and turn on the game. Meditate and complete simple levels! Have a good game!",
    "instructions": "Relax and get into the game Start passing the first level you need to control the level you can do this using the mouse or keyboard Complete the levels and get rewards Go ahead",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Ball",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/2ruoa47wae2lqe8yfax8p1wcm72zz2s3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2ruoa47wae2lqe8yfax8p1wcm72zz2s3/",
    "sourceUrl": "https://html5.gamemonetize.com/2ruoa47wae2lqe8yfax8p1wcm72zz2s3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67239",
    "slug": "sweet-and-fruity-makeup",
    "title": "Sweet And Fruity Makeup",
    "description": "Indulge your senses in our makeup games sweet and fruity world! Immerse yourself in a vibrant palette of colors inspired by juicy fruits that will leave you looking fresh and fabulous. From luscious watermelon pinks to zesty lemon yellows and tangy orange hues, this game allows you to experiment with a selection of deliciously scented cosmetics. Create stunning looks using fruity lip glosses, shimmering eyeshadows, and blushes that mimic the radiant glow of ripe berries. Let your imagination run wild as you mix and match fruity fragrances, adding a delightful touch of freshness to your final touch.",
    "instructions": "Use your mouse to play this game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girl",
      "Makeover",
      "Summer"
    ],
    "thumbnail": "https://img.gamemonetize.com/octgjgtidmcug9tp4d34yt3zv90tkgbh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/octgjgtidmcug9tp4d34yt3zv90tkgbh/",
    "sourceUrl": "https://html5.gamemonetize.com/octgjgtidmcug9tp4d34yt3zv90tkgbh/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "68074",
    "slug": "falcon-dogfight",
    "title": "Falcon Dogfight",
    "description": "A balance between realism and exhilaration: Based on the dynamic design of real fighter jets, but simplifying complex operations, allowing players to quickly immerse themselves in the excitement of high-speed dogfighting and beyond visual range killing. Unlock top tier fighter jets such as F-22 Raptor, Su-27, and Su-33. BVR Showdown: Radar Lock, Automatic Tail Bite, Winning from Dozens of Kilometers Away.",
    "instructions": "Desktop w s pitch a d yaw q e roll hit radar is reset yaw pitch roll Mobile use joystick fireweapon hit weapon icon",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Aircraft",
      "airplane",
      "Battle",
      "Clash",
      "First Person Shooter",
      "Sim",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/cl3xlvuunrx3n0wzmg7djrolfz6qv9io/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cl3xlvuunrx3n0wzmg7djrolfz6qv9io/",
    "sourceUrl": "https://html5.gamemonetize.com/cl3xlvuunrx3n0wzmg7djrolfz6qv9io/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "68128",
    "slug": "bus-jam-escape",
    "title": "Bus Jam Escape",
    "description": "Bus Jam Escape is a fun and colorful puzzle game where your goal is to sort passengers into buses of the same color. Simply tap and send passengers to the appropriate bus, but watch the difficulty increase as new colors and obstacles appear.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Best",
      "bus",
      "Driving",
      "Fun",
      "Kids",
      "Management",
      "Mobile",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/jwxerakx91932kexqr0392ukojb424xa/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jwxerakx91932kexqr0392ukojb424xa/",
    "sourceUrl": "https://html5.gamemonetize.com/jwxerakx91932kexqr0392ukojb424xa/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68077",
    "slug": "crazy-color-balls-2",
    "title": "Crazy Color Balls 2",
    "description": "Crazy Color Balls 2 is an amazing and exciting next-level game very similar to what is Crazy Color Balls. Rush your way through and around obstacles of all shapes and sizes in this colorful game! Control the color ball and try to avoid hitting any objects that are not the same color as the ball. The speed of the game starts slow and picks up fast as the game progresses. In this version of game, the levels grow easier to much tougher and are much more fun to clear. Have lotta fun!",
    "instructions": "Avoid ball hitting other colors",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Ball",
      "Best Games",
      "touch"
    ],
    "thumbnail": "https://img.gamemonetize.com/dyrcryyvekoktw5nkx0z56y46bg8ahdt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dyrcryyvekoktw5nkx0z56y46bg8ahdt/",
    "sourceUrl": "https://html5.gamemonetize.com/dyrcryyvekoktw5nkx0z56y46bg8ahdt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "68047",
    "slug": "pentaword",
    "title": "Pentaword",
    "description": "Guess the hidden five-letter word in just six tries! Use logic, spelling, and word skills in this brain teaser. Can you crack the Pentaword?",
    "instructions": "Your goal is to guess the hidden 5-letter word in 6 tries or less After each guess the tiles will change color to show how close your guess was Green ndash Correct letter in the correct spot Yellow ndash Correct letter in the wrong spot Gray amp n",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "html5 games",
      "Mobile",
      "Puzzle",
      "School",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/dnxuvbu0k01nv95tf72yguxc1x0kldog/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dnxuvbu0k01nv95tf72yguxc1x0kldog/",
    "sourceUrl": "https://html5.gamemonetize.com/dnxuvbu0k01nv95tf72yguxc1x0kldog/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67770",
    "slug": "logic-islands",
    "title": "Logic Islands",
    "description": "A logic puzzle game inspired by Nurikabe and Islands of Insight. Create islands with exact numbers while keeping walls connected. Navigate through 6 unique worlds with different rulesets - from Classic Nurikabe to advanced mechanics like Yin-Yang connectivity. Each world introduces new challenges with ice blocks, one-way arrows, and special orb mechanics across 240 hand-picked puzzles.",
    "instructions": "On PC Click to toggle cells between island wall Double-click or Ctrl click to fill connected areas Mouse wheel or Space to switch draw modes Z to undo R to restart On mobile Tap to toggle Double-tap to fill areas",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Board",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/xsocq2kafpyvurms2y1w7o3g3urm948t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xsocq2kafpyvurms2y1w7o3g3urm948t/",
    "sourceUrl": "https://html5.gamemonetize.com/xsocq2kafpyvurms2y1w7o3g3urm948t/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67967",
    "slug": "mr-autofire",
    "title": "Mr Autofire",
    "description": "Get ready to blast away endless alien hordes in this non-stop retro action shooter! The fabric of reality is in shreds and monsters are pouring in! Become Mr. Autofire and bring your biggest gun and your A game, because you&rsquo;re the&hellip; Defender of Everything! Rampage through levels, unlock new worlds and shoot the alien in the face. Discover new, more powerful weapons and gear. Get faster, nastier and more dodgier with different perks! It&rsquo;s a you vs. everyone else situation, and it would be nasty to be everyone else. What are you waiting for? BITE THE BULLET AND RUMBLE!",
    "instructions": "Use the keyboard Mouse or Touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Arcade",
      "endless",
      "Fire",
      "Highscore",
      "Hypercasual",
      "Jumping",
      "running",
      "Shoot 'Em Up",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/ghsqbsab3s37q5x2gk5k54w6shwl4i5f/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ghsqbsab3s37q5x2gk5k54w6shwl4i5f/",
    "sourceUrl": "https://html5.gamemonetize.com/ghsqbsab3s37q5x2gk5k54w6shwl4i5f/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67971",
    "slug": "stop-zombies",
    "title": "Stop Zombies",
    "description": "Armed with a blaster that fires colored projectiles, you must hold your ground against a relentless horde in Stop Zombies. Each undead creature can only be taken down with a bullet matching its color, so quick thinking and sharp reflexes are your best defense. As the swarm grows stronger, your survival depends on staying alert and firing smart to prevent the apocalypse from reaching you.",
    "instructions": "Use Keyboard for desktop and Touch Controls for mobile device",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "apocalypse",
      "attack",
      "free html5 games for your website",
      "Fun",
      "Pixel",
      "Shoot",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/8sttq4hfxsvoveqhy43cp39updyjcs48/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8sttq4hfxsvoveqhy43cp39updyjcs48/",
    "sourceUrl": "https://html5.gamemonetize.com/8sttq4hfxsvoveqhy43cp39updyjcs48/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67938",
    "slug": "tile-stamper",
    "title": "Tile Stamper",
    "description": "Looking for a fun and casual game that&rsquo;s satisfying and addictive? Tile Stamper is a super uptempo tile floor laying management game! Let you create the most perfect floor with happy clicking! Control your character to place each tile with precision and fill the floor perfectly. Continuously upgrade your vehicles to increase efficiency.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Click",
      "Simulation",
      "vehicle"
    ],
    "thumbnail": "https://img.gamemonetize.com/6afbjlwlbhxw5d3diva2y8qcq12paknn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6afbjlwlbhxw5d3diva2y8qcq12paknn/",
    "sourceUrl": "https://html5.gamemonetize.com/6afbjlwlbhxw5d3diva2y8qcq12paknn/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "66361",
    "slug": "orbitdefense",
    "title": "OrbitDefense",
    "description": "Protect the planet from collision. When your finger presses down on the screen, the ball spins and destroys the object crashing into the planet.Come and play and see how many points you get.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/2phx77hb3rbyjwskesu03phcv7d8d8k4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2phx77hb3rbyjwskesu03phcv7d8d8k4/",
    "sourceUrl": "https://html5.gamemonetize.com/2phx77hb3rbyjwskesu03phcv7d8d8k4/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67689",
    "slug": "tricky-arrow-2",
    "title": "Tricky Arrow 2",
    "description": "In this precision-shooting game, your skills will be put to the test as you aim to hit a spinning circle target with perfect accuracy. However, the challenge doesnt end there, as you must also avoid other arrows flying towards you, making each moment a thrilling puzzle to solve. With simple yet addictive gameplay, this game is perfect for players of all ages who enjoy a good reflex-testing challenge. Your aim and quick reflexes will be put to the limit as you navigate through the twists and turns of this game.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Action",
      "Arcade",
      "arrow",
      "Bow",
      "New",
      "Shoot",
      "Shooting",
      "Skill",
      "touch",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/mlj93g4er4ynh1smd4fm0c0ecbuygg68/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/mlj93g4er4ynh1smd4fm0c0ecbuygg68/",
    "sourceUrl": "https://html5.gamemonetize.com/mlj93g4er4ynh1smd4fm0c0ecbuygg68/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67898",
    "slug": "bob-the-builder-coloring",
    "title": "Bob the Builder Coloring",
    "description": "Bob the Builder Coloring: Creative Fun for Little Artists. Fun online coloring game designed just for kids who love creativity, colors and cartoons! Join Bob and his trusty crew in this colorful adventure where imagination is the only limit. Pick your favorite scenes, grab your virtual crayons, and start painting! Whether you want to follow the original colors or mix things up with wild rainbow designs, this game lets you be the artist. It is perfect for little builders who want to relax, have fun, and bring their favorite characters to life&mdash;one brushstroke at a time. No mess, no rules, just loads",
    "instructions": "Mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Boys",
      "builder",
      "Coloring",
      "Educational",
      "Fun",
      "Girls",
      "Hypercasual",
      "School"
    ],
    "thumbnail": "https://img.gamemonetize.com/if45nr0axy9o1wlasn2cwo0u04r1i59z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/if45nr0axy9o1wlasn2cwo0u04r1i59z/",
    "sourceUrl": "https://html5.gamemonetize.com/if45nr0axy9o1wlasn2cwo0u04r1i59z/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67969",
    "slug": "tung-tung-sahur-supermarket",
    "title": "Tung Tung Sahur Supermarket",
    "description": "Tung Tung Sahur has started running a supermarket. He got a job as a cashier in a busy store. Italian brainrot characters come to shop, but don&rsquo;t let them make a mess! Clean the floor immediately to keep the store spotless. You also need to manage the cash register&mdash;don&rsquo;t keep customers waiting too long. Make sure to scan every item&rsquo;s barcode to track how many products leave the store. If the shelves start to empty, use the money you&rsquo;ve earned to restock from the storage room.",
    "instructions": "Use the WASD keys to move To clean the floor grab a broom from the storage room After sweeping rinse the broom in the water bucket Scan the barcodes of purchased items and place them in the shopping basket Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Brainrot Italian",
      "Simulation",
      "Simulator",
      "Super",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/wtv21hm84crp7qcztjsvkl5tuxa1uwzk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wtv21hm84crp7qcztjsvkl5tuxa1uwzk/",
    "sourceUrl": "https://html5.gamemonetize.com/wtv21hm84crp7qcztjsvkl5tuxa1uwzk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67978",
    "slug": "data-breach",
    "title": "Data Breach",
    "description": "Youre a Computer Virus, are you strong enough to avoid every scanner the antivirus throws at you? Lets find out in Data Breach!!",
    "instructions": "Space Bar or Left Click to jump",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Action",
      "amazing",
      "Jumping"
    ],
    "thumbnail": "https://img.gamemonetize.com/r85hwpgbjc07uasm61ypwqqd6fgq40fr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r85hwpgbjc07uasm61ypwqqd6fgq40fr/",
    "sourceUrl": "https://html5.gamemonetize.com/r85hwpgbjc07uasm61ypwqqd6fgq40fr/",
    "width": 75,
    "height": 75,
    "lastUpdated": ""
  },
  {
    "id": "67873",
    "slug": "monster-rush-cat",
    "title": "Monster Rush cat",
    "description": "Monster Rush Cat is a fast-paced arcade game where you launch a cute monster-cat to catch spinning candies in the sky. Time your jumps perfectly, collect coins, and avoid falling to your doom! As you progress, the challenge increases with moving targets and tricky timing. Unlock new monster skins and aim for the highest score in this colorful, one-tap skill game!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Candy",
      "Casual",
      "Cat",
      "fly",
      "onetouch"
    ],
    "thumbnail": "https://img.gamemonetize.com/747rmx6lgnjk5zl63keg5fz24wz5ge4v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/747rmx6lgnjk5zl63keg5fz24wz5ge4v/",
    "sourceUrl": "https://html5.gamemonetize.com/747rmx6lgnjk5zl63keg5fz24wz5ge4v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67962",
    "slug": "bottleflip",
    "title": "BottleFlip",
    "description": "Test your timing and reflexes in this fun fruit-flipping challenge! Be careful not to let the fruits store obstacles. See how many points you can achieve!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Click",
      "Funny",
      "Mobile",
      "onetouch",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/i0otyw47jtfd4u20u8cwxtuzq8vxjlia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i0otyw47jtfd4u20u8cwxtuzq8vxjlia/",
    "sourceUrl": "https://html5.gamemonetize.com/i0otyw47jtfd4u20u8cwxtuzq8vxjlia/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "66979",
    "slug": "chicken-dash",
    "title": "Chicken Dash",
    "description": "Chicken Dash is a fun and fast platform game where you help a little chicken run and jump its way to the finish line. Each level is full of tricky obstacles, and you need to time your jumps perfectly to avoid them. Along the way, collect shiny coins to boost your score. It&rsquo;s a simple and exciting adventure that&rsquo;s perfect for all ages!",
    "instructions": "Desktop Up Arrow Jump Right Arrow Move Forward Click and Drag Move the Chicken Mobile Tap Right Side Move Tap and swipe up Jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Chicken",
      "HTML",
      "Hypercasual",
      "Jumping",
      "NapTech Games",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/kzgs6w7m9a6oipotviw3o2mclc0b0zxk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kzgs6w7m9a6oipotviw3o2mclc0b0zxk/",
    "sourceUrl": "https://html5.gamemonetize.com/kzgs6w7m9a6oipotviw3o2mclc0b0zxk/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "66145",
    "slug": "blockbreaker",
    "title": "BlockBreaker",
    "description": "The most fun block-playing game. Shoot the small balls to hit the bricks. After hitting other balls, the number of balls shot each time will increase. After hitting the bricks, energy will be collected. When the energy is full, you can directly eliminate a row of bricks. Come and give it a try",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Best Games",
      "Bricks",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/xeb0zdlwn0qpzwl2e9wbwqajdy15ho23/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xeb0zdlwn0qpzwl2e9wbwqajdy15ho23/",
    "sourceUrl": "https://html5.gamemonetize.com/xeb0zdlwn0qpzwl2e9wbwqajdy15ho23/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67850",
    "slug": "drive-mad-2",
    "title": "Drive Mad 2",
    "description": "Want to begin a wildly exciting driving challenge? Welcome to Drive Mad 2, the craziest 3D driving simulation adventure youve ever seen. Youll be racing your sports car around many strange and dangerous tracks! There are all kinds of traps and mechanisms here. For example, sledgehammers, bottles, windmills, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Car",
      "Fun",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/gisd00oq9kft4npyvub4v2ibqrp3x98j/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gisd00oq9kft4npyvub4v2ibqrp3x98j/",
    "sourceUrl": "https://html5.gamemonetize.com/gisd00oq9kft4npyvub4v2ibqrp3x98j/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67942",
    "slug": "spirit-boy",
    "title": "Spirit Boy",
    "description": "In this clever puzzle adventure, you guide a boy through tricky levels filled with deadly traps and clever challenges. Spirit Boy transforms into a ghostly soul when faced with danger, letting him float past spikes and reach hidden areas. But to finish the level, he must return to his human form and find the exit door all while guarding his three precious lives.",
    "instructions": "Use Mouse and Keyboard for desktop Touch Controls for mobile device",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "Arcade",
      "Boy",
      "dash",
      "free html5 games for your website",
      "jet",
      "Jumping",
      "Logic",
      "Pixel",
      "Platform",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/1q6swhq95j9i4olu3luuea72ocg1ornl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1q6swhq95j9i4olu3luuea72ocg1ornl/",
    "sourceUrl": "https://html5.gamemonetize.com/1q6swhq95j9i4olu3luuea72ocg1ornl/",
    "width": 512,
    "height": 288,
    "lastUpdated": ""
  },
  {
    "id": "66975",
    "slug": "tennis-dash",
    "title": "Tennis Dash",
    "description": "Tennis Dash is a fast and fun game where a cute cat plays tennis like a pro! The tennis ball comes from different directions, and your job is to move the cat left and right to hit it. Be quick&mdash;if you miss the ball three times, the game is over! It&rsquo;s easy to play but really hard to master. Try to beat your own high score and keep the rally going!",
    "instructions": "Desktop Click and Drag Left or Right Move the Cat bear Mobile Tap and drag Left or Right Move the Cat bear",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Casual",
      "Fun",
      "HTML",
      "html5 games",
      "Hypercasual",
      "NapTech Games",
      "Sports",
      "Tennis"
    ],
    "thumbnail": "https://img.gamemonetize.com/h8381esputdzb7w30swugmh9aufj4lrz/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h8381esputdzb7w30swugmh9aufj4lrz/",
    "sourceUrl": "https://html5.gamemonetize.com/h8381esputdzb7w30swugmh9aufj4lrz/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67949",
    "slug": "black-and-pink",
    "title": "Black And Pink",
    "description": "Avoid the balls while trying to connect all the sides to fill it in black or pink according to what the level desires. Each time a level is cleared, the ball count is doubled and the game becomes harder and harder.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Mouse"
    ],
    "thumbnail": "https://img.gamemonetize.com/30dx8hml6r4cfbx0bj341mfnaqnkkrrm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/30dx8hml6r4cfbx0bj341mfnaqnkkrrm/",
    "sourceUrl": "https://html5.gamemonetize.com/30dx8hml6r4cfbx0bj341mfnaqnkkrrm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67879",
    "slug": "italian-brainrot-puzzle",
    "title": "Italian Brainrot Puzzle",
    "description": "In the game Italian Brainrot Puzzle you have 16 puzzles with pictures of Italian Brainrot characters. Assemble them by shifting to position the pieces.To change drag parts up to another position. Complete a level, go to the next. In each level you have limited time for which you need to complete it. Enjoy this game!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Brainrot",
      "Brainrot Italian",
      "Fun",
      "Funny",
      "Italian Brainrot",
      "Kids",
      "Mobile",
      "Skill",
      "sliding",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/6jn2zmjsqtxy1e6dwju2346nhggg3h3h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6jn2zmjsqtxy1e6dwju2346nhggg3h3h/",
    "sourceUrl": "https://html5.gamemonetize.com/6jn2zmjsqtxy1e6dwju2346nhggg3h3h/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67956",
    "slug": "mysterious-familiars-enchanted-bestiary",
    "title": "Mysterious Familiars Enchanted Bestiary",
    "description": "Welcome to the magical world of Mysterious Familiars! Discover the Witchcraft Encyclopedia full of mysterious and cute creatures. Your task is to fill the magic vessel by simply tapping on the screen. Each click fills the potion bowl. As soon as the vessel is filled, a new image of one of the familiars or its next stage of maturation will open. Explore magical locations, from the Moonlight Glade to the Slug Trail, and watch incredible creatures appear from small drops of magic potion. Do you want to speed up the process? Trade clicks for upgrades and increase your click power. Collect the entire encyclopedia and become a true expert on magical creatures! Start the adventure right now - the familiars are waiting for you!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Animal",
      "Click",
      "Fantasy",
      "Monster"
    ],
    "thumbnail": "https://img.gamemonetize.com/2fv0ll1x7y0tpbax9wv27skdijx8nxs1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2fv0ll1x7y0tpbax9wv27skdijx8nxs1/",
    "sourceUrl": "https://html5.gamemonetize.com/2fv0ll1x7y0tpbax9wv27skdijx8nxs1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67417",
    "slug": "hidden-hero",
    "title": "Hidden Hero",
    "description": "Help Lily Escape the Cat Chaos! Join Lily on a fast-paced adventure as she dashes, jumps, and ducks to dodge an endless wave of mischievous cats! These fluffy troublemakers are everywhere&mdash;falling from the sky, popping out of trash cans, and even riding skateboards! Use quick reflexes and power-ups to survive as long as you can. Cute, chaotic, and full of surprises, Cat Dodge: Lilys Run is the purr-fect mix of fun and challenge. Can you keep Lily safe and climb the leaderboard?",
    "instructions": "Mouse or finger click or tap to play tap to hide behind something",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Girl",
      "Girls",
      "Hot"
    ],
    "thumbnail": "https://img.gamemonetize.com/znl8a6fr8ulznkphcy67dyzzrssd4ie0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/znl8a6fr8ulznkphcy67dyzzrssd4ie0/",
    "sourceUrl": "https://html5.gamemonetize.com/znl8a6fr8ulznkphcy67dyzzrssd4ie0/",
    "width": 1080,
    "height": 2400,
    "lastUpdated": ""
  },
  {
    "id": "64918",
    "slug": "cosmic-strike-2-0",
    "title": "Cosmic Strike 2.0",
    "description": "A game where you can explore space and battle spaceships. Come on, head into space and fight against extremely tough bosses. What happened, are you scared? There are 3 long levels in the game and each level has a boss with its own different gameplay. As you destroy enemies and bosses, you earn money and can buy new ships. Each ships different damage and firing style make the game different. And last boss is not broken it has a weak spot.",
    "instructions": "W to acceleration S to slow Left Click to Fire Move with mouse f a ship crashs you you die also",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Action",
      "amazing",
      "Android",
      "Arcade",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/fukc1o594u4o3turx87lvd2tqk1shhmm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fukc1o594u4o3turx87lvd2tqk1shhmm/",
    "sourceUrl": "https://html5.gamemonetize.com/fukc1o594u4o3turx87lvd2tqk1shhmm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67933",
    "slug": "stickman-rescue-draw-2-save",
    "title": "Stickman Rescue Draw 2 Save",
    "description": "Your brain is the only shield for the stickman! Enjoy a super casual puzzler in the Stickman Rescue - Draw 2 Save. Use your finger to draw lines and save the stickman from danger! In each level, the stickman is in trouble, such as falling rocks, flying arrows, deep pits, etc. It&rsquo;s up to you to draw a safe shield, a bridge, or a clever device to keep him safe and complete your rescue mission!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Draw",
      "Funny",
      "Stickman"
    ],
    "thumbnail": "https://img.gamemonetize.com/fxzsxwyiw3kdj5hf1dnsx6ogy52od6of/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fxzsxwyiw3kdj5hf1dnsx6ogy52od6of/",
    "sourceUrl": "https://html5.gamemonetize.com/fxzsxwyiw3kdj5hf1dnsx6ogy52od6of/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67858",
    "slug": "duck-shift",
    "title": "Duck Shift",
    "description": "Try to pass all the duck tests on each level avoiding danger in the Duck Shift game. Use your wits to take the key from the door and find the right way to it. But be prepared to deftly jump over deadly spikes otherwise your path will start from the beginning of the level.",
    "instructions": "Use Keyboard for desktop and Touch Controls for mobile device",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Bird",
      "Chicken",
      "dash",
      "Funny",
      "html games for your website",
      "Hypercasual",
      "Jumping",
      "Ladybug",
      "Logical",
      "Pixel",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/uxvavnjak8m7bf8leqdpxzdz2rdg1r9r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uxvavnjak8m7bf8leqdpxzdz2rdg1r9r/",
    "sourceUrl": "https://html5.gamemonetize.com/uxvavnjak8m7bf8leqdpxzdz2rdg1r9r/",
    "width": 640,
    "height": 380,
    "lastUpdated": ""
  },
  {
    "id": "66976",
    "slug": "tumble-boat",
    "title": "Tumble Boat",
    "description": "Tumble Boat is a fun and tricky puzzle game where your goal is to land a boat safely on the ground. The boat starts on top of a stack of blocks, and you have to remove the blocks one by one without tipping the tower. Be careful&mdash;if the boat falls, the game is over! Each level brings a new challenge that will test your thinking and timing.",
    "instructions": "Desktop Mouse Click and drag Remove a Block Mobile Tap and drag Remove a Block",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Boat",
      "Casual",
      "Fun",
      "HTML",
      "HTML5",
      "NapTech Games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/7hb99cxugmjrazfqlythunduyx1ciek9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7hb99cxugmjrazfqlythunduyx1ciek9/",
    "sourceUrl": "https://html5.gamemonetize.com/7hb99cxugmjrazfqlythunduyx1ciek9/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66020",
    "slug": "screw-pin-jam-puzzle",
    "title": "Screw Pin Jam Puzzle",
    "description": "Screw Pin Jam Puzzle is an incredibly creative and strategic puzzle game designed to enhance players spatial imagination and strategic planning abilities. In this game, players face a board composed of complex and intricately placed screws and pins. Each screw and pin could be key to solving the puzzle, requiring careful consideration with every move. Game features include: Diverse level designs: Ranging from simple to complex, each level has a unique layout and difficulty, requiring players to constantly adjust their solution strategies. Intuitive interface: Clear graphics and smooth animation make it easy for players to pick up, while",
    "instructions": "Mouse Controls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Best Games",
      "Game",
      "Games",
      "games for your website",
      "Mobile",
      "onetouch",
      "onlinegames io",
      "Puzzle",
      "puzzleblock",
      "touch",
      "touchscreen"
    ],
    "thumbnail": "https://img.gamemonetize.com/xse3bphv6n0hep6k0a8u9m0oztb3ap5o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xse3bphv6n0hep6k0a8u9m0oztb3ap5o/",
    "sourceUrl": "https://html5.gamemonetize.com/xse3bphv6n0hep6k0a8u9m0oztb3ap5o/",
    "width": 600,
    "height": 930,
    "lastUpdated": ""
  },
  {
    "id": "67522",
    "slug": "super-mano-run-blast-and-slash",
    "title": "Super Mano  Run Blast and Slash",
    "description": "Join Super Mano in a high-octane, Mario-inspired adventure where action meets strategy! Armed with guns, swords, and explosive bombs, Mano must battle waves of quirky enemies, overcome tricky traps, and defeat the forces of evil threatening his colorful pixel world. This side-scrolling platformer combines nostalgic retro charm with thrilling combat mechanics. Whether you&rsquo;re jumping on platforms or blasting through bosses, Super Mano delivers non-stop arcade-style fun for gamers of all ages!",
    "instructions": "Move Left larr Arrow Move Right rarr Arrow Move Up e g ladder or elevator uarr Arrow Move Down e g crouch drop darr Arrow Jump Spacebar Shoot Gun F Throw Bomb G Fly Jetpack Glide T Melee Attack Sword Punch C",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "HTML5",
      "html5 games",
      "jump",
      "Mario",
      "Shooting",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/z135u2wpcnbuxz820lfv631trrkcrhz1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z135u2wpcnbuxz820lfv631trrkcrhz1/",
    "sourceUrl": "https://html5.gamemonetize.com/z135u2wpcnbuxz820lfv631trrkcrhz1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67819",
    "slug": "labubu-skate-parkour",
    "title": "Labubu Skate Parkour",
    "description": "Labubu must survive the sky course! Help Labubu reach the finish line safely. Be careful you could fall from the sky or crash into obstacles and lose. Collect all the gold coins and make it to the finish line in one piece!",
    "instructions": "Use the WASD keys to move Double jump available Playable on both mobile and PC Collect all the gold coins and reach the finish line",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "Arcade",
      "Girl",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/uu6p5o8rkua2n9tzy6k631krejvbl27c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/uu6p5o8rkua2n9tzy6k631krejvbl27c/",
    "sourceUrl": "https://html5.gamemonetize.com/uu6p5o8rkua2n9tzy6k631krejvbl27c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67911",
    "slug": "geometry-flap",
    "title": "Geometry Flap",
    "description": "Enter a world of bold outlines, sharp corners, and pure reflex. In Geometry Flap, you control a shapeshifting arrow darting through a black-and-white maze of geometric chaos. Tap to flap, weave through deadly gates, and dodge precision traps in this high-speed gauntlet of skill. Features: One mistake = instant crash. Simple to play, brutally hard to master. Unlock dozens of slick arrow skins. Will you survive the rhythm of geometry? Challenge your reflex. Flap to glory.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "arrow",
      "arrows",
      "dash",
      "Geometry",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/sqtd73obyk4vtf5adgekw8frm3lqqkas/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sqtd73obyk4vtf5adgekw8frm3lqqkas/",
    "sourceUrl": "https://html5.gamemonetize.com/sqtd73obyk4vtf5adgekw8frm3lqqkas/",
    "width": 460,
    "height": 700,
    "lastUpdated": ""
  },
  {
    "id": "67927",
    "slug": "rolling-going-balls",
    "title": "Rolling Going Balls",
    "description": "Its time to push your reflexes to the limit. Rolling Going Balls is an addictive 3D platform rolling game where you take charge of a fast-moving ball. Rolling and running through tricky tracks full of twists and traps! Smooth rolling controls to guide your ball with precision! Collect as many balls as you can along the way to boost your level! Watch out! Avoid dangerous obstacles like spikes, pendulums, etc.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Ball",
      "Fun",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/ozbxx1p7gw04eauwlp3vqf2ejimwkfqc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ozbxx1p7gw04eauwlp3vqf2ejimwkfqc/",
    "sourceUrl": "https://html5.gamemonetize.com/ozbxx1p7gw04eauwlp3vqf2ejimwkfqc/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67931",
    "slug": "nailong-rush-run",
    "title": "Nailong Rush Run",
    "description": "Nailong Rush Run is a fun 3D parkour game that brings you into a wonderful world. You will play as a cute dinosaur running on an endless platform. You need to keep collecting more nailongs and expanding your team! Increase your number through positive number gates. Lead your team to avoid various obstacles like roadblocks, vehicles, etc. Reach the finish line and start fighting with the enemy dinosaurs.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Enemies",
      "Obstacle",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/0c9zroecwrm1jpd7uljeidlknpawu8al/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0c9zroecwrm1jpd7uljeidlknpawu8al/",
    "sourceUrl": "https://html5.gamemonetize.com/0c9zroecwrm1jpd7uljeidlknpawu8al/",
    "width": 1560,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67829",
    "slug": "blockfall-blitz-master-the-falling-blocks",
    "title": "Blockfall Blitz: Master the Falling Blocks!",
    "description": "Blockfall Blitz is a fast-paced, addictive puzzle game inspired by classic falling block titles. Strategically place descending tetrominoes to complete and clear horizontal lines. Race against the clock as the blocks fall faster with every line you clear. Plan ahead using the Next Piece preview and outsmart the grid by utilizing the new Hold Piece feature! How many lines can you clear and how high can you score before the blocks reach the top?",
    "instructions": "Move Piece Keyboard Left Arrow larr Right Arrow rarr Touch Swipe Left Swipe Right on the game board Rotate Piece Keyboard Up Arrow uarr Touch Tap on the game board Soft Drop Move Down Faster Keyboard Down Arrow darr Touch",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Classic",
      "Tetris"
    ],
    "thumbnail": "https://img.gamemonetize.com/sxgf1m7n1nviv8ts5np5a8rq7mxfosmt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/sxgf1m7n1nviv8ts5np5a8rq7mxfosmt/",
    "sourceUrl": "https://html5.gamemonetize.com/sxgf1m7n1nviv8ts5np5a8rq7mxfosmt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67859",
    "slug": "italian-animals-with-voice-acting",
    "title": "Italian animals with voice acting",
    "description": "All Italian animals and their original sounds are here! In the game, you can open all the characters from the meme about Italian animals and listen to their voice acting with an interesting fusion mechanic. Ballerina Cappuccino and Bombardino Crocodilo are already waiting for you!",
    "instructions": "1 Click on the animals to get coins 2 Buy Italian animals for coins 3 Combine the same character to get the next level Italian animal 4 Reach the last character",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "amazing",
      "Animal",
      "Best",
      "Best Games",
      "Brainrot",
      "Brainrot Italian",
      "Casual",
      "Click",
      "Clicker",
      "Game",
      "Games",
      "Italian Brainrot"
    ],
    "thumbnail": "https://img.gamemonetize.com/fnfaupatt3c7nitj7melsrsok1tyab2c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fnfaupatt3c7nitj7melsrsok1tyab2c/",
    "sourceUrl": "https://html5.gamemonetize.com/fnfaupatt3c7nitj7melsrsok1tyab2c/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67897",
    "slug": "birdy-trip",
    "title": "Birdy Trip",
    "description": "You are not alone in the sky! It&rsquo;s time to migrate to sunny lands. Grab your cute friends on the way and be careful, many dangers could smash you during your journey. Features: &bull; One-Touch control &bull; Enjoy an original atmosphere &amp; colorful graphics &bull; Discover &amp; catch more than 8 birds &bull; Complete dozens of missions &bull; Beware of eagles!",
    "instructions": "Use the Mouse or Touch to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Bird",
      "Casual",
      "Cute",
      "fly",
      "Highscore",
      "HTML5",
      "Hypercasual",
      "Jumping",
      "kiz10",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/7vbrf8hq727ee3rcqhgd0v2zpi8bdigr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7vbrf8hq727ee3rcqhgd0v2zpi8bdigr/",
    "sourceUrl": "https://html5.gamemonetize.com/7vbrf8hq727ee3rcqhgd0v2zpi8bdigr/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "66362",
    "slug": "ballrun",
    "title": "BallRun",
    "description": "Choose the correct route to make the turn. The game will randomly generate routes, each route corresponds to a color, by controlling the character to choose the same color with the character of the route to turn, enter the new route after the characters color will randomly change. Each time you choose the correct route you will get one point, so try and see how many points you can get.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/g45rraohjxxovqll1t8w3wdes33c3phi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g45rraohjxxovqll1t8w3wdes33c3phi/",
    "sourceUrl": "https://html5.gamemonetize.com/g45rraohjxxovqll1t8w3wdes33c3phi/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67473",
    "slug": "treat-tumble",
    "title": "Treat Tumble",
    "description": "Match. Munch. Mayhem! Dive into a deliciously addictive world of candy-coated chaos in Treat Tumble &mdash; the ultimate match-3 puzzle adventure! Swap and match colorful treats like gummy bears, chocolate bites, and jelly cubes to clear levels and unlock sweet surprises. With 100+ vibrant levels, explosive power-ups, and daily rewards, Treat Tumble is your perfect sugar rush &mdash; no calories included! Game Features: Match-3 Magic &ndash; Match 3 or more treats to blast through obstacles and earn tasty combos! Whimsical Worlds &ndash; Explore candy kingdoms, soda swamps, and cookie cliffs.",
    "instructions": "Match-3 and get heavy bonuses",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Candy",
      "Casual",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/h0zdzch2cdm9kvw6lxxjo62ojqb4i303/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h0zdzch2cdm9kvw6lxxjo62ojqb4i303/",
    "sourceUrl": "https://html5.gamemonetize.com/h0zdzch2cdm9kvw6lxxjo62ojqb4i303/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67785",
    "slug": "hard-path",
    "title": "Hard Path",
    "description": "Brace yourself for a wild and unpredictable journey as you help a clumsy hero stumble through complex 2D labyrinths packed with traps, tricks, and unexpected turns. Hard Path delivers a blend of comedy and challenge, turning every step into a potential disaster or triumph. Navigate tight corners, dodge bizarre hazards, and try to keep the Warrior on track in this chaotic maze-filled adventure.",
    "instructions": "Use Keyboard for desktop and Touch Controls for mobile device",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "free html5 games for your website",
      "Logic",
      "Pixel",
      "Puzzle",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/1g0wg1dtp56bzl92dceq7xno8zzr5cq5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1g0wg1dtp56bzl92dceq7xno8zzr5cq5/",
    "sourceUrl": "https://html5.gamemonetize.com/1g0wg1dtp56bzl92dceq7xno8zzr5cq5/",
    "width": 256,
    "height": 256,
    "lastUpdated": ""
  },
  {
    "id": "67863",
    "slug": "trump-wheelie-challenge",
    "title": "Trump Wheelie Challenge",
    "description": "Trump Wheelie Challenge is a super fun 2D game where you drive a jeep on one wheel! Balance carefully, collect money, jump over bouncing balls, and try to reach the finish line without flipping over. Complete each level by mastering the wheelie and surviving the chaos! Play the Trump Wheelie Challenge game now.",
    "instructions": "Right Arrow or mouse",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Balance",
      "Boys",
      "Car",
      "Celebrity",
      "Driving",
      "Fun",
      "Hypercasual",
      "Skill",
      "wheel"
    ],
    "thumbnail": "https://img.gamemonetize.com/9pc3ac8adszy2k1d1gtqhmy1xci9yh6d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9pc3ac8adszy2k1d1gtqhmy1xci9yh6d/",
    "sourceUrl": "https://html5.gamemonetize.com/9pc3ac8adszy2k1d1gtqhmy1xci9yh6d/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67874",
    "slug": "super-ball-juggling-remix",
    "title": "Super Ball Juggling Remix",
    "description": "Super Ball Juggling Remix is a fast-paced arcade game where you juggle a soccer ball without letting it drop &mdash; but with a twist! Travel across iconic locations like Paris, New York, Rome, Pisa, and Sydney, showcasing your freestyle skills in stunning backdrops. Simple to play, hard to master, and packed with global style &mdash; how long can you keep the ball in the air?",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Ball",
      "mapi games",
      "Soccer"
    ],
    "thumbnail": "https://img.gamemonetize.com/ocuawximv8s4omrwf7t8linvh4lsl9u5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ocuawximv8s4omrwf7t8linvh4lsl9u5/",
    "sourceUrl": "https://html5.gamemonetize.com/ocuawximv8s4omrwf7t8linvh4lsl9u5/",
    "width": 600,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "67708",
    "slug": "peaceful-gardening",
    "title": "Peaceful Gardening",
    "description": "A relaxing game where you plant flowers and watch nature come alive. Add butterflies, toggle rain, and create a peaceful digital garden.",
    "instructions": "Mouse Tap",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "garden"
    ],
    "thumbnail": "https://img.gamemonetize.com/jpmcw83phpvq1odqve83ba4f74oblgdq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jpmcw83phpvq1odqve83ba4f74oblgdq/",
    "sourceUrl": "https://html5.gamemonetize.com/jpmcw83phpvq1odqve83ba4f74oblgdq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67566",
    "slug": "break-it",
    "title": "break it",
    "description": "Unleash your fury in BREAK IT, a fast-paced action game where an angry fuzzy creature breaks through walls with sheer foot power! Take control of a mischievous Labubu-style hero on a vertical descent through layers of obstacles, spikes, and breakable bricks. Your mission: smash everything in your path &mdash; but be careful not to hit the deadly spikes or unbreakable blocks!",
    "instructions": "Hold Left Mouse Button Smash downward Release Stop smashing to avoid obstacles",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "3D Games",
      "Clicker",
      "Jumping",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/86eeo825uki6d1fbu0slexqxwhqlf9so/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/86eeo825uki6d1fbu0slexqxwhqlf9so/",
    "sourceUrl": "https://html5.gamemonetize.com/86eeo825uki6d1fbu0slexqxwhqlf9so/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67163",
    "slug": "bank-boom-tung-tung-sahur",
    "title": "Bank Boom Tung Tung Sahur",
    "description": "Are you ready for a bank heist? You have 20 seconds to crack the safe! Compete with your friend &mdash; the first to open the vault wins. Smash the safe open and beat your friend to it. Hit your friend with a club to slow them down and win the race. The club is a powerful weapon. The fate of the game is in your hands. Strike fast and unlock the bank vault!",
    "instructions": "bull Move using WASD or the Arrow Keys bull Press S or the Down Arrow to swing the club bull Playable on both mobile and PC bull Stand on the vault for 20 seconds to open it and win the game",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Battle",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/48kgynv9m53l0aukny9c1ql383thrcjq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/48kgynv9m53l0aukny9c1ql383thrcjq/",
    "sourceUrl": "https://html5.gamemonetize.com/48kgynv9m53l0aukny9c1ql383thrcjq/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67815",
    "slug": "drive-zone",
    "title": "Drive Zone",
    "description": "Dive into a world of speed and thrill! This game takes you on a ride through city streets, rally tracks, and wild off-road terrains. Feel the power of the engines, master every turn, and unleash your inner racer. Its not just about speed &mdash; its about freedom, challenge, and the rush of the unknown. Are you ready to become a legend on every surface?",
    "instructions": "Desktop W - Accelerator S - Brake Reverse A - Left D - Right C - Camera Switch Esc - Pause Mobile Use on-screen controls",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "3D",
      "Car",
      "Driving",
      "endless",
      "Game",
      "jeep",
      "Mobile",
      "offroad",
      "Race",
      "Racing",
      "realistic",
      "Road",
      "Simulator",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/preebt8pchos3u8ul57dozj2gulh46ms/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/preebt8pchos3u8ul57dozj2gulh46ms/",
    "sourceUrl": "https://html5.gamemonetize.com/preebt8pchos3u8ul57dozj2gulh46ms/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67831",
    "slug": "tap-to-fish",
    "title": "Tap to Fish",
    "description": "Cast your line, reel in the rewards, and grow your fishing empire! In Tap to Fish, you begin with simple gear and work your way up by catching and selling fish for gold. Every catch earns you coins to upgrade your fishing rod boosting its capacity and reaching deeper waters. With its smooth gameplay and vibrant visuals, this hypercasual adventure is easy to pick up and hard to put down.",
    "instructions": "Use Mouse for desktop and Touch Controls for mobile device",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "Casual",
      "Fish",
      "Fishing",
      "free html5 games for your website",
      "Fun",
      "Simulator",
      "water"
    ],
    "thumbnail": "https://img.gamemonetize.com/7ztwli9nry48v7id6vd7ajsjzvlhfkts/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7ztwli9nry48v7id6vd7ajsjzvlhfkts/",
    "sourceUrl": "https://html5.gamemonetize.com/7ztwli9nry48v7id6vd7ajsjzvlhfkts/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67765",
    "slug": "geometry-dash-unblocked",
    "title": "Geometry Dash Unblocked",
    "description": "GeometryDashUnblocked is a fun sidescrolling action arcade rush. Control the geometric cubes through a large number of spikes. Seize the moment and tap to jump so that the cube avoids collisions and survives longer. Challenge the farthest distance to get a high score! Unlock more funny skins to participate in the challenge and give you a different experience!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Avoid",
      "jump",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/m84en44qjczb1b5846pzll223s40kar7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m84en44qjczb1b5846pzll223s40kar7/",
    "sourceUrl": "https://html5.gamemonetize.com/m84en44qjczb1b5846pzll223s40kar7/",
    "width": 1920,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67820",
    "slug": "labubu-gokart",
    "title": "Labubu Gokart",
    "description": "Labubu started the engine and slammed the pedal to the metal! You have to help him. Guide Labubu out of the garage and all the way to the finish line. Try to collect all the fuel cans along the way. Be careful &mdash; there are plenty of obstacles waiting on the road. And it&rsquo;s not just obstacles&hellip; bombs are falling from the sky too! Watch out for everything and make sure Labubu reaches the finish line in one piece.",
    "instructions": "Use the WASD keys to move Double jump available Playable on both mobile and PC",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Arcade",
      "Car",
      "Cars",
      "Girl",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/2rxiyrec62uz14ma0nlou2nutmuz9arr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2rxiyrec62uz14ma0nlou2nutmuz9arr/",
    "sourceUrl": "https://html5.gamemonetize.com/2rxiyrec62uz14ma0nlou2nutmuz9arr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67421",
    "slug": "kids-toy-set-mobile",
    "title": "Kids Toy Set Mobile",
    "description": "Welcome to Kid Toy Set Mobile, a collection of casual mini-games especially for girls. You can find various relaxing games here, including doll dress-up, doctor simulator, makeover game, matching game, pop it game, and so on. Your goal is to get fully relaxed and remove all pressure from a busy day. Select one level that interests you and begin to play!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Matching",
      "Relaxation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/u67d4e4owbutlhkuf29wsejty8a1mxnl/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u67d4e4owbutlhkuf29wsejty8a1mxnl/",
    "sourceUrl": "https://html5.gamemonetize.com/u67d4e4owbutlhkuf29wsejty8a1mxnl/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67474",
    "slug": "undead-appetite",
    "title": "Undead Appetite",
    "description": "Undead Appetite Run. Dodge. Survive the hunger of the dead. In Undead Appetite, the world has fallen &mdash; and now theyre coming. Flesh-hungry zombies, spinning saws, and flying bullets stand between you and survival in this high-intensity action game where every second counts. Navigate through chaotic battlegrounds filled with traps and undead horrors. Stay on the move, dodge the danger, and outlast the apocalypse. With only your reflexes and instincts, you must survive the insatiable appetite of the undead.",
    "instructions": "Use Z and X to jump and fire",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Battle",
      "Battlegrounds"
    ],
    "thumbnail": "https://img.gamemonetize.com/n3yzi3k74g19rcksacjpz6phkpejn787/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n3yzi3k74g19rcksacjpz6phkpejn787/",
    "sourceUrl": "https://html5.gamemonetize.com/n3yzi3k74g19rcksacjpz6phkpejn787/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67555",
    "slug": "block-breaker-miner-quest",
    "title": "Block Breaker: Miner Quest",
    "description": "Tap, Dash, Survive! Dive into the depths in Miner Dash: Endless Escape! Smash through blocks, dodge falling rocks, and gather as many gold coins as you can. Unlock epic new skins and test your reflexes in this fast-paced, endless adventure. Are you fast enough to beat your own record? Features: Addictive endless gameplay Simple tap-to-move controls Challenging obstacles and traps Unlockable miner skins Leaderboard support (if applicable)",
    "instructions": "Tap Left Right to move the miner Auto-mine blocks in your path Avoid falling rocks ndash they end your run Collect coins to unlock new characters",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Arcade",
      "Best Games",
      "Block",
      "Brain",
      "Miner",
      "Platform",
      "quest",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/kquj0hb1ll5vfxjkkmfrnunez1kaxqbp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kquj0hb1ll5vfxjkkmfrnunez1kaxqbp/",
    "sourceUrl": "https://html5.gamemonetize.com/kquj0hb1ll5vfxjkkmfrnunez1kaxqbp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67226",
    "slug": "same-and-different-donut",
    "title": "Same and Different Donut",
    "description": "Get ready to have some fun with the game Same &amp; Different Donut! Take a close look at these delicious, colorful donuts. Can you spot which ones look exactly the same? Now, see if you can find the one that&rsquo;s different from the rest. You&rsquo;ll get to answer a few fun questions along the way. After that, it&rsquo;s time to get creative and design your very own donut&mdash;choose your favorite colors and toppings! And of course, don&rsquo;t forget to pretend to take a big bite and &ldquo;eat&rdquo; your creation. Enjoy the game and have lots of fun!",
    "instructions": "mouse click or touch screen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Best Games",
      "Cake",
      "Candy",
      "Cartoon",
      "Cute",
      "Food",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/djtplzxs360e3bgydoj28vk6lhbphbzn/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/djtplzxs360e3bgydoj28vk6lhbphbzn/",
    "sourceUrl": "https://html5.gamemonetize.com/djtplzxs360e3bgydoj28vk6lhbphbzn/",
    "width": 800,
    "height": 500,
    "lastUpdated": ""
  },
  {
    "id": "67580",
    "slug": "car-simulation-drive-master",
    "title": "Car Simulation Drive Master",
    "description": "Welcome to Car Park Simulator! Are you ready to put your driving skills to the ultimate test? Tackle 72 challenging levels packed with tight spaces, tricky obstacles, and realistic parking scenarios. Master precision, timing, and control as you navigate your way to parking perfection!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      ".io Games",
      "Car",
      "Driving",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/qtvk2nsvqk2pztsum8wxpfef4j7rwmvt/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qtvk2nsvqk2pztsum8wxpfef4j7rwmvt/",
    "sourceUrl": "https://html5.gamemonetize.com/qtvk2nsvqk2pztsum8wxpfef4j7rwmvt/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67608",
    "slug": "the-war2727",
    "title": "The War2727",
    "description": "This is a turn-based casual game with a samurai theme based on my previous game.If you like this kind of game, I will continue to update the content!",
    "instructions": "Click or touch",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Pixel",
      "Turn Based",
      "War",
      "Warrior"
    ],
    "thumbnail": "https://img.gamemonetize.com/8wvu25b2jr38psxzjletnqulperzasdq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8wvu25b2jr38psxzjletnqulperzasdq/",
    "sourceUrl": "https://html5.gamemonetize.com/8wvu25b2jr38psxzjletnqulperzasdq/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "10363",
    "slug": "bloxorz",
    "title": "Bloxorz",
    "description": "Bloxorz is a block sliding puzzle game. You will need roll the block around the board until it falls into the square hole in 33 challenging levels.",
    "instructions": "WASD or Arrow keys to roll the block - Space bar to switch between the blocks",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Logic",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/nhyyth7h1gztti5jba25n5o6v3002j5q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/nhyyth7h1gztti5jba25n5o6v3002j5q/",
    "sourceUrl": "https://html5.gamemonetize.com/nhyyth7h1gztti5jba25n5o6v3002j5q/",
    "width": 700,
    "height": 382,
    "lastUpdated": ""
  },
  {
    "id": "67685",
    "slug": "house-cleaning-asmr",
    "title": "House Cleaning ASMR",
    "description": "The house is in an extremely messy condition! Come help out with the cleaning work. House Cleaning ASMR is a casual simulation game where you can experience various kinds of cleaning work. For example, cleaning fans, wiping the dust off the wall, and doing handbag care. All the cleaning tasks are well-designed and highly interactive.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cleaning",
      "Simulation",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/fz5vwlmp7lx2706kg9pxh3bmwv6lrj21/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fz5vwlmp7lx2706kg9pxh3bmwv6lrj21/",
    "sourceUrl": "https://html5.gamemonetize.com/fz5vwlmp7lx2706kg9pxh3bmwv6lrj21/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "67650",
    "slug": "hexa-puzzle-master",
    "title": "Hexa Puzzle Master",
    "description": "Hexa Puzzle Master is a fun and addictive web puzzle game where players fit hexagonal blocks into a grid. With simple drag-and-drop controls, players must think strategically to complete levels without gaps. Featuring multiple difficulty levels and a sleek design, the game offers a relaxing yet challenging experience for puzzle lovers of all ages!",
    "instructions": "Drag amp Drop ndash Click and drag hexagonal blocks to place them on the board Fill the Grid ndash Arrange the pieces to fit perfectly without leaving gaps No Rotation Needed ndash Blocks are pre-set in orientation so focus on placement No Tim",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "hexa",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/f1igeukaqff5gd4d0vv30hrqo7qndkg9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f1igeukaqff5gd4d0vv30hrqo7qndkg9/",
    "sourceUrl": "https://html5.gamemonetize.com/f1igeukaqff5gd4d0vv30hrqo7qndkg9/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64759",
    "slug": "samurai-cow-man",
    "title": "Samurai Cow Man",
    "description": "Samurai Cow Man is a wild, action-packed adventure like no udder! Step into the hooves of a fearless cow with the heart of a samurai and the sword skills to match. Battle enemies, slash through obstacles, and defend your honor across epic landscapes. How to play: Slash, dodge, and dash using smooth touch controls. Fight off waves of enemies with powerful katana combos. Unlock new armor, weapons, and wild samurai abilities. Whether youre charging through bamboo forests or facing legendary bosses, every level is packed with humor, action, and unexpected surprises.",
    "instructions": "Use arrow key on keyboard",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure"
    ],
    "thumbnail": "https://img.gamemonetize.com/1pqo4ca8vfhn920o20e4hhbj9sic7bcv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1pqo4ca8vfhn920o20e4hhbj9sic7bcv/",
    "sourceUrl": "https://html5.gamemonetize.com/1pqo4ca8vfhn920o20e4hhbj9sic7bcv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66424",
    "slug": "circlecrash",
    "title": "CircleCrash",
    "description": "The control car is driving on the ring road.There will be other vehicles during the driving process, avoid collision with other vehicles.Coins are earned while driving, which can be used to unlock new vehicles.Come and experience it!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "Cars",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/93ctf5zwk2pv9q0aocp46jw5pj67nifq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/93ctf5zwk2pv9q0aocp46jw5pj67nifq/",
    "sourceUrl": "https://html5.gamemonetize.com/93ctf5zwk2pv9q0aocp46jw5pj67nifq/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66946",
    "slug": "monster-truck-dirt-rally",
    "title": "Monster Truck Dirt Rally",
    "description": "Monster Truck Dirt Rally delivers high-octane, off-road racing action with powerful monster trucks tearing through rugged dirt tracks. Crush obstacles, perform insane stunts, and compete in adrenaline-fueled rally events. With realistic physics, dynamic environments, and customizable trucks. Web Dev <a href='https://www.y8gamesx.com/'>https://www.y8gamesx.com/</a>",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Driving",
      "Mentolatux",
      "monstertruck",
      "Racing",
      "trucks",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/f4qhkn0fwvobdg89t99i1iig61gfmou4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f4qhkn0fwvobdg89t99i1iig61gfmou4/",
    "sourceUrl": "https://html5.gamemonetize.com/f4qhkn0fwvobdg89t99i1iig61gfmou4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67427",
    "slug": "word-search-universe",
    "title": "Word Search Universe",
    "description": "Word Search Universe is a fun and relaxing puzzle game where you search for hidden words in a grid. The game has 20 chapters, and each one comes with easy, medium, and hard levels to match your skill. In every level, you need to find 6 hidden words. If you get stuck, you can use a hint to help you out. Its a great way to have fun, improve your vocabulary, and keep your brain sharp!",
    "instructions": "Tap and drag to highlight the hidden words in the grid Use the hint button if you need help finding a word",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Board",
      "Educational",
      "Hidden",
      "html5 games",
      "Mobile",
      "Puzzle",
      "Word"
    ],
    "thumbnail": "https://img.gamemonetize.com/jo61yo9k4l15h31izc2j22mwnftauufv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jo61yo9k4l15h31izc2j22mwnftauufv/",
    "sourceUrl": "https://html5.gamemonetize.com/jo61yo9k4l15h31izc2j22mwnftauufv/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67577",
    "slug": "fruit-merge-juicy-drop-fun",
    "title": "Fruit Merge Juicy Drop Fun",
    "description": "Fruit Merge Drop Frenzy &ndash; Juicy Merge, Match &amp; Compete! Embark on a fruity adventure with Fruit Drop Fun! Dive into a vibrant world of colorful fruits, satisfying merges, and endless fun in the most addictive fruit merge game around. From luscious watermelons to juicy pineapples, Fruit Merge combine matching fruits to unlock higher-level combos and blast your way through exciting fruit puzzles. Whether you&rsquo;re a casual gamer or a puzzle pro, Fruit Drop Frenzy offers a perfect mix of strategy, relaxation, and challenge in this Juicy Merge Game!",
    "instructions": "Drop and merge fruits to create higher-level fruits and enjoy juicy combo fun",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fruit",
      "Fruits",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/6k4wwg3g81x92db1hb6zchtqmyco7cou/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6k4wwg3g81x92db1hb6zchtqmyco7cou/",
    "sourceUrl": "https://html5.gamemonetize.com/6k4wwg3g81x92db1hb6zchtqmyco7cou/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67601",
    "slug": "the-hidden-booty",
    "title": "The Hidden Booty",
    "description": "The Hidden Booty Tap smart. Track clues. Find the treasure! Set sail on a puzzling pirate adventure in The Hidden Booty, a clever treasure-hunt game where intuition meets strategy. Your goal? Discover the hidden treasure buried beneath one of many mysterious cards &mdash; before your moves run out! Tap on cards to reveal directional clues pointing toward the treasure. Each clue brings you closer, but choose wisely &mdash; every tap counts! With a limited number of moves, every decision is critical. Can you outwit the map and uncover the legendary Hidden Booty?",
    "instructions": "Click guess and move based on shown arrows",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Gold",
      "Hidden",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/s9xveyg9xmo6chodejdocffsawn4pr0v/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/s9xveyg9xmo6chodejdocffsawn4pr0v/",
    "sourceUrl": "https://html5.gamemonetize.com/s9xveyg9xmo6chodejdocffsawn4pr0v/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67768",
    "slug": "cat-up",
    "title": "Cat Up",
    "description": "At first glance, this is a simple platformer with one button, but not everything is so simple. You have to control a small and very active pixel cat, who needs to overcome all 15 levels and collect all the coins to open all the doors.",
    "instructions": "Use Mouse for desktop and Touch Controls for mobile device",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Best Games",
      "Cat",
      "Cute",
      "dash",
      "free html5 games for your website",
      "Jumping",
      "Mobile",
      "Pixel",
      "Retro"
    ],
    "thumbnail": "https://img.gamemonetize.com/0spnonwawljy80gxvfs2h914alhgoj1g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0spnonwawljy80gxvfs2h914alhgoj1g/",
    "sourceUrl": "https://html5.gamemonetize.com/0spnonwawljy80gxvfs2h914alhgoj1g/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "61571",
    "slug": "gummy-blocks-puzzle",
    "title": "Gummy Blocks Puzzle",
    "description": "Gummy Blocks Puzzle is a block puzzle game where you drop pieces to form and eliminate complete lines on the screen, both vertically and horizontally. Just drag and position the blocks on the board to create lines. Its simple to play and immensely enjoyable! Embrace the challenge of arranging the pieces and observe the lines vanish as you advance. Ideal for a quick session to hone your puzzle abilities or for longer gaming periods.",
    "instructions": "Enjoy this cheerful rainbow-themed Gummy Blocks Puzzle game Slide the delicious gummy blocks into the empty spaces and eliminate rows and columns on the grid Challenge yourself to see how far you can progress while enhancing skills in planning mental",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Block",
      "Casual",
      "Logic",
      "Puzzle",
      "puzzleblock",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/thwax7r1ze82e6diewhloytqmw0astkj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/thwax7r1ze82e6diewhloytqmw0astkj/",
    "sourceUrl": "https://html5.gamemonetize.com/thwax7r1ze82e6diewhloytqmw0astkj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67688",
    "slug": "light-it-rush",
    "title": "Light It Rush",
    "description": "Swing, jump, flip and slide your stickman flip master body from one neon color shape to another to make them glow and light-it up. It&rsquo;s a dark world out there for a teeny little stickman flip master like you, and it&rsquo;s about time you light-it up and make the colors glow.",
    "instructions": "Mouse click or tap to play",
    "category": "Stickman",
    "genres": [
      "Stickman"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Casual",
      "Jumping",
      "running",
      "Stickman",
      "Super"
    ],
    "thumbnail": "https://img.gamemonetize.com/gskztfg8o3i7aeh66zmn8flgkttfftdw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/gskztfg8o3i7aeh66zmn8flgkttfftdw/",
    "sourceUrl": "https://html5.gamemonetize.com/gskztfg8o3i7aeh66zmn8flgkttfftdw/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67695",
    "slug": "super-motocross",
    "title": "Super Motocross",
    "description": "Ride your dirt bike through challenging levels full of ramps, jumps, and obstacles. Balance, accelerate, and reach the finish line without crashing! A fun and fast-paced HTML5 motocross game for all ages.",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "Arcade",
      "mapi games",
      "Motocross",
      "Motorcycle"
    ],
    "thumbnail": "https://img.gamemonetize.com/d8vjyjtwgj1c7opsa1e99ifmvnfvgvn8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d8vjyjtwgj1c7opsa1e99ifmvnfvgvn8/",
    "sourceUrl": "https://html5.gamemonetize.com/d8vjyjtwgj1c7opsa1e99ifmvnfvgvn8/",
    "width": 1280,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67004",
    "slug": "hide-and-seek-friends",
    "title": "Hide And Seek Friends!",
    "description": "The good old classic hide &amp; seek. Play either as a seeker or as a hider and build your shelters from cars or office desks, hide in the water, in the hay pile, in the cornfield, in the boss office and most importantly, push others in the seekers vision field. Try to be kind though. Hide N Seek! : Dive into the ultimate online Hide &amp; Seek experience! Battle in real-time multiplayer matches across immersive, interactive worlds. Play as the cunning hider or relentless seeker. Outsmart rivals, master stealth or track with precision. Non-stop action, strategy, and global fun await!",
    "instructions": "Welcome to the world of Hide amp Seek 3D",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      ".io Games",
      "Action",
      "Arcade",
      "Online",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/c55i7d1tly2sovcobi9j3i13cpz0iekw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/c55i7d1tly2sovcobi9j3i13cpz0iekw/",
    "sourceUrl": "https://html5.gamemonetize.com/c55i7d1tly2sovcobi9j3i13cpz0iekw/",
    "width": 600,
    "height": 960,
    "lastUpdated": ""
  },
  {
    "id": "67686",
    "slug": "diy-ice-cream-roll-cone",
    "title": "DIY Ice Cream Roll Cone",
    "description": "Summer is on its way! Dont you want to try a cool ice cream? What about delicious summer desserts? Welcome to DIY Ice Cream Roll Cone, a casual food DIY game for kids. Cool down with this ice cream dessert cooking simulation designed against the hot summer! If you are a girl who loves eating ice cream or a casual DIY gamer, join us and enjoy endless fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Food",
      "Ice",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/lp9qbdo722u21gngmsf02j1w1s1mfjfm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lp9qbdo722u21gngmsf02j1w1s1mfjfm/",
    "sourceUrl": "https://html5.gamemonetize.com/lp9qbdo722u21gngmsf02j1w1s1mfjfm/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "67146",
    "slug": "vehiclefactory",
    "title": "VehicleFactory",
    "description": "VehicleFactory is a creative physics-based builder game where your engineering skills are put to the test! Construct your own vehicle by attaching components like wheels, special wheels, and ventilators. Once your design is ready, hit the Start button and watch your custom creation navigate a dynamic physics map. Will your build make it to the destination? Web Dev <a href='https://www.crazygamesx.com/'>https://www.crazygamesx.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Action",
      "Brain",
      "Car",
      "Mentolatux",
      "Physics",
      "Puzzle",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/32n43ar75l12h5uru5qjr2djpqddupk2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/32n43ar75l12h5uru5qjr2djpqddupk2/",
    "sourceUrl": "https://html5.gamemonetize.com/32n43ar75l12h5uru5qjr2djpqddupk2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66418",
    "slug": "circleleap",
    "title": "CircleLeap",
    "description": "Control the arrow to sprint to the next circle. Seize the moment, so that the arrow sprint to avoid the vortex.Come and experience it and see how many points you can earn.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade"
    ],
    "thumbnail": "https://img.gamemonetize.com/3irb0wmjx8kc93fohm9j22rxpeim8j2d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3irb0wmjx8kc93fohm9j22rxpeim8j2d/",
    "sourceUrl": "https://html5.gamemonetize.com/3irb0wmjx8kc93fohm9j22rxpeim8j2d/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67604",
    "slug": "wicked-whirl",
    "title": "Wicked Whirl",
    "description": "Wicked Whirl Enter the swirling chaos of Halloween in Wicked Whirl, the spookiest match-3 puzzle game of the season! Match haunted items like glowing pumpkins, creepy eyeballs, magic potions, and mischievous skulls to cast spells, break curses, and uncover hidden surprises. With every swipe, youll venture deeper into eerie forests, haunted mansions, and cursed graveyards. Can you survive the whirl of wicked challenges and unlock all the spooky secrets before midnight strikes?",
    "instructions": "Match-3 amp Win",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Halloween",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/tas23fch7g2lnzm58hw29479erg81bbw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tas23fch7g2lnzm58hw29479erg81bbw/",
    "sourceUrl": "https://html5.gamemonetize.com/tas23fch7g2lnzm58hw29479erg81bbw/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67617",
    "slug": "sprunki-dead-rails",
    "title": "Sprunki Dead Rails",
    "description": "Sprunki Dead Rails - protect the train! Cooperative survival against zombies with block building. To make the game easier, you can buy a turret that will help destroy zombies. Play on one of 6 maps. The maps themselves are huge! Play with a friend, or in single player mode. The game has 15 Sprunki skins for both players, as well as 12 different blocks. The game has 4 types of weapons: pistol, PP, AK-47, RPG.",
    "instructions": "On a mobile device controls are provided using on-screen buttons On PC - Blue player main bull Movement arrow keys larr rarr uarr darr bull Shoot J bull Build K - Red player bull Movement WASD bull Shoot F bull Build",
    "category": "Boys",
    "genres": [
      "Boys"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2D",
      "Best Games",
      "Defense",
      "Mobile",
      "Shooter",
      "Sprunki",
      "Tower Defense",
      "two player games",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/iixpxl3s6ss7gqrvced5eaysnigvw0os/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iixpxl3s6ss7gqrvced5eaysnigvw0os/",
    "sourceUrl": "https://html5.gamemonetize.com/iixpxl3s6ss7gqrvced5eaysnigvw0os/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67625",
    "slug": "slime-smile",
    "title": "Slime Smile",
    "description": "Today is the story of Slime! Get a better clearance experience by matching attributes. If you like it, we will continue to update more content in the future!",
    "instructions": "Mouse click or touch",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Action",
      "Adventure",
      "Click",
      "Mobile",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/k5gebrkgqyvki7du6k1d8hk2bozpdlo8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/k5gebrkgqyvki7du6k1d8hk2bozpdlo8/",
    "sourceUrl": "https://html5.gamemonetize.com/k5gebrkgqyvki7du6k1d8hk2bozpdlo8/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67677",
    "slug": "pixel-path",
    "title": "Pixel Path",
    "description": "Help a brave pixel hero survive mind-bending levels filled with deadly traps, teleporters, and gravity-defying puzzles! Tap to flip the world upside-down, leap over spinning saws, and collect glittering gems to unlock thrilling new worlds. One wrong move&mdash;and it&rsquo;s game over!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Casual",
      "Hypercasual",
      "Pixel",
      "Puzzle",
      "Strategy",
      "trap"
    ],
    "thumbnail": "https://img.gamemonetize.com/fcwz88fz1d52nffy0nemiduus7o8hahs/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fcwz88fz1d52nffy0nemiduus7o8hahs/",
    "sourceUrl": "https://html5.gamemonetize.com/fcwz88fz1d52nffy0nemiduus7o8hahs/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67197",
    "slug": "sauce-silk-spy",
    "title": "Sauce Silk Spy",
    "description": "Sauce Silk Spy: The Doomsday War of Shiba Inu Agent On the wasteland devoured by zombie viruses, a skilled Shiba Inu will shoulder the ultimate mission of saving humanity. When traditional doomsday themes encounter cute pet agents, a passionate and absurd breakout battle is about to begin!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "3D",
      "3D Games",
      "Battle",
      "Gun"
    ],
    "thumbnail": "https://img.gamemonetize.com/e294zypmnxmyfqliqwsdr8gac0o0v8a4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e294zypmnxmyfqliqwsdr8gac0o0v8a4/",
    "sourceUrl": "https://html5.gamemonetize.com/e294zypmnxmyfqliqwsdr8gac0o0v8a4/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67621",
    "slug": "sprunki-ketchup-mod",
    "title": "Sprunki Ketchup Mod",
    "description": "Sprunki Ketchup Mod - A game with physics of throws and ragdoll elements. Throw ketchup so as to get into the Sprunki and turn it into a ketchup version! Try your hand at 30 levels! The difficulty will increase, and the maps will increase. Think with your head: calculate the perfect trajectory of the throw and use the bounces to win!",
    "instructions": "Your mission throw ketchup at Simon Use the ketchup as a projectile stretch it like a slingshot and throw it accurately",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "angrybirds",
      "Casual",
      "Mobile",
      "Physics",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/7tvjo8x6w1flu3fvadry5mz8qbhotkxo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7tvjo8x6w1flu3fvadry5mz8qbhotkxo/",
    "sourceUrl": "https://html5.gamemonetize.com/7tvjo8x6w1flu3fvadry5mz8qbhotkxo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66422",
    "slug": "blockpuzzlemagic",
    "title": "BlockPuzzleMagic",
    "description": "Assemble and eliminate the blocks. Various shaped blocks will randomly appear at the bottom. Drag the blocks into the upper box. They will be eliminated when a row or column is filled. Come and give it a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Puzzle",
      "puzzleblock"
    ],
    "thumbnail": "https://img.gamemonetize.com/z6gxwxdgunqmjmhva7j5kszeya71ls9u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z6gxwxdgunqmjmhva7j5kszeya71ls9u/",
    "sourceUrl": "https://html5.gamemonetize.com/z6gxwxdgunqmjmhva7j5kszeya71ls9u/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67112",
    "slug": "truck-driving-simulator-offroad",
    "title": "Truck Driving Simulator offroad",
    "description": "Experience the thrill of offroad trucking! Navigate rugged terrain, deliver cargo through challenging paths, and master powerful trucks in realistic environments. Conquer hills, mud, and rivers in this ultimate truck driving simulator adventure. Ready to drive? Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Driving",
      "Mentolatux",
      "offroad",
      "Simulator",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/a6i1ot5d0scwphehyrsl0vned0ezjk8q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/a6i1ot5d0scwphehyrsl0vned0ezjk8q/",
    "sourceUrl": "https://html5.gamemonetize.com/a6i1ot5d0scwphehyrsl0vned0ezjk8q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67439",
    "slug": "zombies-vs-sunflowers",
    "title": "Zombies vs. Sunflowers",
    "description": "In this action-packed tower defense game, your garden is under siege by relentless zombies! Strategically place unique plants&mdash;each with special abilities&mdash;to stop the shambling invaders. Unlock &amp; Upgrade &ndash; Strengthen your plants to unleash powerful attacks and create an unbeatable defense. Face Fearsome Foes &ndash; Battle waves of zombies, each with their own strengths and weaknesses. Earn Sun &amp; Survive &ndash; Collect resources to grow your arsenal and hold the line! Can you outsmart the undead and protect your home? The battle for survival begins now!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "angryplants",
      "apocalypse",
      "Army",
      "Battle",
      "Casual",
      "Defense",
      "Fruit",
      "Fruits",
      "Hypercasual",
      "Plant",
      "plants",
      "Tower Defense",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/6kw2gj2vjs2uztzkl5xyrxrpreo5t6lo/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6kw2gj2vjs2uztzkl5xyrxrpreo5t6lo/",
    "sourceUrl": "https://html5.gamemonetize.com/6kw2gj2vjs2uztzkl5xyrxrpreo5t6lo/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67603",
    "slug": "sweet-beasts",
    "title": "Sweet Beasts",
    "description": "Match candy. Feed monsters. Unleash the sugar chaos! Step into the wild and whimsical world of Sweet Beasts, a candy-packed match-3 puzzle adventure where adorable monsters have an insatiable sweet tooth! Match colorful candies, trigger explosive combos, and feed your hungry beast buddies as you journey through gooey gumdrop forests, marshmallow mountains, and jelly lagoons. Each level brings new challenges and mischievous monster mayhem! Unlock new creatures, discover their candy-craving powers, and take on sticky obstacles in hundreds of deliciously tricky levels.",
    "instructions": "Match-3 and win",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Match-3",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/h9oc4gnpqgqndct23kpvys6qlgzlo7v4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h9oc4gnpqgqndct23kpvys6qlgzlo7v4/",
    "sourceUrl": "https://html5.gamemonetize.com/h9oc4gnpqgqndct23kpvys6qlgzlo7v4/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67602",
    "slug": "thronehold",
    "title": "ThroneHold",
    "description": "The throne is lost. The castle is cursed. Take it back. In Thronehold, you step into the boots of a lone warrior trapped in a crumbling castle filled with danger, darkness, and long-forgotten secrets. This intense platformer combines fast-paced action, precision jumps, and clever traps set across a labyrinthine stronghold once ruled by kings &mdash; now haunted by creatures of shadow. Leap over deadly spikes, scale ancient towers, unlock hidden paths, and fight your way through cursed knights, spectral beasts, and twisted machines guarding the throne room. Only the strongest can reclaim the Thronehold.",
    "instructions": "Avoid obstacles and keep moving Click to jump",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "King",
      "Obstacle",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/rv7i4vp7fn46vjdgjs8el77c83twubly/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rv7i4vp7fn46vjdgjs8el77c83twubly/",
    "sourceUrl": "https://html5.gamemonetize.com/rv7i4vp7fn46vjdgjs8el77c83twubly/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67635",
    "slug": "thung-thung-sahur-playgrounds-escape",
    "title": "Thung Thung Sahur Playgrounds Escape",
    "description": "Thung Thung Sahur Playgrounds Escape is a survival horror. You must find a way to complete the quest with certain time before Thung Thung catch you!",
    "instructions": "wasd to move",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Horror",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/8tcibyn2omj8rnb6w52fca37crhmexjh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8tcibyn2omj8rnb6w52fca37crhmexjh/",
    "sourceUrl": "https://html5.gamemonetize.com/8tcibyn2omj8rnb6w52fca37crhmexjh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67614",
    "slug": "survival-shooter-game",
    "title": "Survival Shooter Game",
    "description": "Survival Shooter is a fast-paced top-down action game where you must fight off endless waves of enemies. Armed with powerful weapons and quick reflexes, you&rsquo;ll battle through intense arenas, collect power-ups, and unlock upgrades to survive as long as possible. The enemies get stronger, faster, and more aggressive&mdash;only the skilled will last. With stylized visuals, responsive twin-stick controls, and challenging gameplay, Survival Shooter delivers an adrenaline-pumping experience that keeps you coming back for more. How long can you survive the onslaught? Climb the leaderboard and prove your worth in the ultimate survival test.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2D",
      "attack",
      "Shooter",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/j7cwr3eola0ddykquvywldrqi5umfm8l/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j7cwr3eola0ddykquvywldrqi5umfm8l/",
    "sourceUrl": "https://html5.gamemonetize.com/j7cwr3eola0ddykquvywldrqi5umfm8l/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67639",
    "slug": "slime-rain",
    "title": "Slime Rain",
    "description": "Dodge the falling objects and collect as many coins as you can! Fast-paced, reflex-based arcade game that&rsquo;s easy to play but hard to master. How long can you survive?",
    "instructions": "Keyboard or slide or touch",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2D",
      "Arcade",
      "Avoid",
      "Collection",
      "endless"
    ],
    "thumbnail": "https://img.gamemonetize.com/d0h77hx3taikfukdn3jqgjvh2hz333y3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d0h77hx3taikfukdn3jqgjvh2hz333y3/",
    "sourceUrl": "https://html5.gamemonetize.com/d0h77hx3taikfukdn3jqgjvh2hz333y3/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "67588",
    "slug": "parking-polly-cars",
    "title": "Parking Polly Cars",
    "description": "Get ready to master the ultimate car parking puzzle! In Parking Poly Cars, your mission is to escape traffic jams by moving the right cars in the right order. Enjoy addictive traffic jam puzzle gameplay that tests your logic and strategy. Slide the cars, unblock the path, and clear the parking lot in this fun and challenging car puzzle game! Perfect for fans of brain games, parking simulators, and traffic jam games. With increasing difficulty and smart levels, this car parking game will keep your brain sharp. Whether youre a casual player or a puzzle pro, enjoy hours of antistress fun!",
    "instructions": "Mouse Click and drag cars to move them Touch Tap and swipe cars on mobile to slide them",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "3D Games",
      "Cars",
      "Casual",
      "Hypercasual",
      "Mobile",
      "Parking",
      "Puzzle",
      "unity games"
    ],
    "thumbnail": "https://img.gamemonetize.com/kcrzitqb6wihdtc7dgarvuhzpbupldn3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kcrzitqb6wihdtc7dgarvuhzpbupldn3/",
    "sourceUrl": "https://html5.gamemonetize.com/kcrzitqb6wihdtc7dgarvuhzpbupldn3/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "67570",
    "slug": "drag-n-boom",
    "title": "Drag N Boom",
    "description": "DragnBoom is a fun old-school arcade game combining speed and precision! &bull; Dive into an imaginary medieval universe full of heroes, echoing the greatest arcade and platform games of all time.",
    "instructions": "Use the mouse or touch to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Adventure",
      "Arcade",
      "Cartoon Network",
      "dash",
      "Dragon",
      "Mario",
      "running",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/avdfpa7rynma1wxofv7mfg6iyh8trf07/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/avdfpa7rynma1wxofv7mfg6iyh8trf07/",
    "sourceUrl": "https://html5.gamemonetize.com/avdfpa7rynma1wxofv7mfg6iyh8trf07/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "66610",
    "slug": "linkschallengpuzzle",
    "title": "LinksChallengPuzzle",
    "description": "Join the matching squares together.The game has several types of blocks, each of which has a connection line, and blocks with the same connection line can be connected. The game is space-themed, the screen is very beautiful, come and experience it.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/w9ivj4zh3jsdgv228mo6arl3scwflrpc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w9ivj4zh3jsdgv228mo6arl3scwflrpc/",
    "sourceUrl": "https://html5.gamemonetize.com/w9ivj4zh3jsdgv228mo6arl3scwflrpc/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67605",
    "slug": "heroic-barrage",
    "title": "Heroic Barrage",
    "description": "Unleash bullets. Dodge chaos. Defend the realm. In Heroic Barrage, you are the last line of defense&mdash;a fearless warrior armed with endless firepower, facing wave after wave of relentless enemies. Set in a fast-paced side-scrolling battlefield just above ground level, this arcade-style adventure challenges your reflexes, accuracy, and courage. Enemies swarm from every direction and altitude. Your job? Shoot non-stop, survive the onslaught, and dominate the skies with precision and style. With intuitive joystick controls, you&rsquo;ll move, aim, and blast through ever-increasing waves of flying foes.",
    "instructions": "Dodge enemies and shoot",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Enemies",
      "fly",
      "run",
      "Superhero"
    ],
    "thumbnail": "https://img.gamemonetize.com/xh68e468i0y8trlyucd55tbhdh526foh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xh68e468i0y8trlyucd55tbhdh526foh/",
    "sourceUrl": "https://html5.gamemonetize.com/xh68e468i0y8trlyucd55tbhdh526foh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67609",
    "slug": "escape-from-snakes",
    "title": "Escape From Snakes",
    "description": "Escape From Snakes is a fast-paced arcade survival game where danger slithers from every direction! Dodge an endless wave of snakes and try to survive as long as possible. Simple to play but hard to master &mdash; perfect for both casual and competitive players. Can you outlast the swarm?",
    "instructions": "Keyboard or touch or mouse",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "Mobile",
      "Snake",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/l078xbrwau481peyccnpdwkcdsg5g0ke/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l078xbrwau481peyccnpdwkcdsg5g0ke/",
    "sourceUrl": "https://html5.gamemonetize.com/l078xbrwau481peyccnpdwkcdsg5g0ke/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "67585",
    "slug": "bouncing-balls",
    "title": "Bouncing Balls",
    "description": "If you are finding the champion of time killer, dont miss this Html 5 game Bouncing Balls. It feels like a very simple brick breaker game, but more addictive! It is a simple and minimal game to play because there is no need to pick them up. Just use your finger to tap to aim and shoot the ball and bounce and destroy those bricks. Collect gold circles to get additional balls and get the endless ball chain! Your task is to crush as many bricks as possible before they fall to the ground. Come on! Enjoy the new brand game Bouncing Balls.",
    "instructions": "Swipe your finger to throw the balls and break the bricks Every brick has numbers hit the bricks as many times as the numbers on it to disappear that brick Try to break as many bricks as possible before they move down to the bottom",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Ball",
      "Brain",
      "Number",
      "Puzzle",
      "Skills",
      "Strategy"
    ],
    "thumbnail": "https://img.gamemonetize.com/t6jirs5vm2z0c3xa60ld40xh8u34v13a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t6jirs5vm2z0c3xa60ld40xh8u34v13a/",
    "sourceUrl": "https://html5.gamemonetize.com/t6jirs5vm2z0c3xa60ld40xh8u34v13a/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67516",
    "slug": "labubu-and-friends-2player",
    "title": "Labubu and Friends   2Player",
    "description": "Labubu and his friend need to escape the island during summer! Be very careful as you adventure together and collect all the golden clams along the way. Of course, collect those golden clams first &mdash; then reach the giant gift box! Both adorable Labubu friends must make it to the gift box, because inside are their favorite things. But watch out &mdash; the path is full of dangers and obstacles!",
    "instructions": "Use WASD and Arrow keys to move Collect all the Golden Clams and reach the Gift Box Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2D",
      "Action",
      "Adventure",
      "Arcade",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/lv9gv1e4b0nnycb2h3v6chrzmsiwp1zr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lv9gv1e4b0nnycb2h3v6chrzmsiwp1zr/",
    "sourceUrl": "https://html5.gamemonetize.com/lv9gv1e4b0nnycb2h3v6chrzmsiwp1zr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67113",
    "slug": "real-cargo-truck-driver-2025",
    "title": "Real Cargo Truck Driver 2025",
    "description": "Real Cargo Truck Driver 2025 is an immersive truck simulation game where players transport heavy cargo across challenging roads. Experience realistic driving physics, dynamic weather, and detailed environments as you manage deliveries, upgrade your trucks, and explore expansive open-world routes. Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a>",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "cargo",
      "Driving",
      "Mentolatux",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/l1d2e2zfagy73bk0trm842vg06hfmagh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/l1d2e2zfagy73bk0trm842vg06hfmagh/",
    "sourceUrl": "https://html5.gamemonetize.com/l1d2e2zfagy73bk0trm842vg06hfmagh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "59327",
    "slug": "human-vehicle-run",
    "title": "Human Vehicle Run",
    "description": "Want a fun parkour adventure in Human Vehicle Run? In this unique game, you will collect many stickmen. Then lead a growing crowd of people, transforming them into a car or even powerful vehicles. The more people you have, the more powerful your vehicle becomes until it becomes a helicopter.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/env6yjhbdjtey6d11eualsj2qk4edx0d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/env6yjhbdjtey6d11eualsj2qk4edx0d/",
    "sourceUrl": "https://html5.gamemonetize.com/env6yjhbdjtey6d11eualsj2qk4edx0d/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "67353",
    "slug": "emergency-operator",
    "title": "Emergency Operator",
    "description": "In Emergency Operator, you take charge of urgent 911 calls. Understand the callers situation and decide whether to send the fire crew, police, medical team &mdash; or if no help is needed at all. Make the right calls to save lives, avoid false alarms, and keep the city safe. Prove your skills with accurate decisions and get promoted to higher ranks. Every decision counts!",
    "instructions": "Tap or click to answer the call Choose the correct response to dispatch the right help mdash or none if its not needed",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "html5 games",
      "Management",
      "Mobile",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/8lap59jr8i0kq84gm6tz0guf63c77d6i/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8lap59jr8i0kq84gm6tz0guf63c77d6i/",
    "sourceUrl": "https://html5.gamemonetize.com/8lap59jr8i0kq84gm6tz0guf63c77d6i/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "67517",
    "slug": "thung-thung-sahur-burning-desire",
    "title": "Thung Thung Sahur Burning Desire",
    "description": "In the chilling silence of a snowy island, a new terror rises &mdash; Tung Tung Sahur, a cursed wooden figure, now possessed by a fiery rage. Once a mere local legend, he&rsquo;s back, swinging his heavy club and ready to burn everything in his path! You play as a brave Minecraft-style Chicken Jockey zombie, armed with nothing but a torch and riding your loyal chicken steed. Your mission? Stop Tung Tung Sahur before his burning desire turns the frozen world to ashes. Key Features: Fight the Wooden Menace &ndash; Face off against a relentless wooden enemy that hates fire&hellip; but hates you more. Ride into Battle &ndash; Mount your chicken and dodge",
    "instructions": "WASD to move Space grab",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Brainrot sahuuur",
      "Horror",
      "Sahur",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/g93oa4tu7zldz23b57ymc1mto88i2qa7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g93oa4tu7zldz23b57ymc1mto88i2qa7/",
    "sourceUrl": "https://html5.gamemonetize.com/g93oa4tu7zldz23b57ymc1mto88i2qa7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64766",
    "slug": "girls-pajama-party",
    "title": "Girls Pajama Party",
    "description": "Hey girls! Get ready to host the most amazing pajama party ever with Girls Pajama Party, a super fun casual simulation game thats also educational! The game starts with making your invitations. Youll design cute cards using a variety of accessories to invite your besties to the party. Now, its time to dress up!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "amazing",
      "Educational",
      "Fun"
    ],
    "thumbnail": "https://img.gamemonetize.com/kjjfnkvvc17kylsnhoa23q248ihugrro/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kjjfnkvvc17kylsnhoa23q248ihugrro/",
    "sourceUrl": "https://html5.gamemonetize.com/kjjfnkvvc17kylsnhoa23q248ihugrro/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67523",
    "slug": "harvester-cut-grass",
    "title": "Harvester Cut Grass",
    "description": "Hey farmer, it&rsquo;s time to drive your harvester! Get behind the wheel and collect all the wheat. Harvest season has arrived. The wheat is ripe and ready to be gathered. Start your tractor and plow the field. Time is running out &mdash; you must finish harvesting the entire field before time runs out!",
    "instructions": "bull Use the Arrow keys to move left right up and down bull Playable on both mobile and PC bull Mobile touch controls available",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Farm",
      "Games",
      "HTML5",
      "tractor"
    ],
    "thumbnail": "https://img.gamemonetize.com/cqtzwbhonl1obzxshoppcaq0mek8g2qj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cqtzwbhonl1obzxshoppcaq0mek8g2qj/",
    "sourceUrl": "https://html5.gamemonetize.com/cqtzwbhonl1obzxshoppcaq0mek8g2qj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67512",
    "slug": "giant-killer",
    "title": "Giant Killer",
    "description": "Upgrade your heroes, battle fearsome enemies, and hone your strategic skills in this endlessly replayable fantasy adventure. Master your dodge, defense, and attack to conquer each level and become the ultimate hero!",
    "instructions": "Click or touch",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "attack",
      "Fantasy",
      "Turn Based"
    ],
    "thumbnail": "https://img.gamemonetize.com/5923r5x0fasynzvmt4m12j2ctknjrtvv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5923r5x0fasynzvmt4m12j2ctknjrtvv/",
    "sourceUrl": "https://html5.gamemonetize.com/5923r5x0fasynzvmt4m12j2ctknjrtvv/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67424",
    "slug": "redrunner",
    "title": "RedRunner",
    "description": "Embark on an exciting 2D side-scrolling adventure! Run, jump, and roll your way through challenging levels filled with traps, enemies, and secrets. Use precise timing and quick reflexes to survive and reach the finish line. With smooth controls and fast-paced action, this platformer will put your skills to the test.",
    "instructions": "Controls W mdash Jump A D mdash Move Left Right S mdash Roll or Dodge Master these moves to overcome obstacles and reach the goal",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "2D",
      "Adventure",
      "Platform"
    ],
    "thumbnail": "https://img.gamemonetize.com/ja7cy5j8u20ajm7jkzammyjwo0jo8fe3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ja7cy5j8u20ajm7jkzammyjwo0jo8fe3/",
    "sourceUrl": "https://html5.gamemonetize.com/ja7cy5j8u20ajm7jkzammyjwo0jo8fe3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67327",
    "slug": "mini-supercars-racing-crashing",
    "title": "Mini SuperCars Racing Crashing",
    "description": "Mini SuperCars Racing Crashing is pure chaotic fun! Race tiny but mighty supercars on wild tracks filled with jumps, obstacles, and explosions. Smash into rivals, drift around tight corners, and cause epic crashes as you fight for victory. Fast, furious, and full of mayhem&mdash;this is mini racing madness! Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Cars",
      "crash",
      "demolition",
      "Driving",
      "Mentolatux",
      "Racing",
      "Supercars",
      "unity",
      "vehicle",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/4htdhun5663v914ifk7o2kdfwtc3nfs8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4htdhun5663v914ifk7o2kdfwtc3nfs8/",
    "sourceUrl": "https://html5.gamemonetize.com/4htdhun5663v914ifk7o2kdfwtc3nfs8/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66451",
    "slug": "crazymath",
    "title": "CrazyMath",
    "description": "Quickly figure out the right answer. The game will quickly appear a simple calculation problem, you need to calculate the correct answer, each correct answer your character will fire a bullet to kill the bug in front of you, kill a bug to get a point, come to experience to see how many points you can get.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Arcade",
      "Math",
      "Shoot"
    ],
    "thumbnail": "https://img.gamemonetize.com/85hu8a9g2ve9wi36y5k9byzdrd30tcux/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/85hu8a9g2ve9wi36y5k9byzdrd30tcux/",
    "sourceUrl": "https://html5.gamemonetize.com/85hu8a9g2ve9wi36y5k9byzdrd30tcux/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64642",
    "slug": "box-hop-duel",
    "title": "Box Hop Duel",
    "description": "Box Hop Duel is an addictive and fast-paced mobile game that puts your timing and reflexes to the ultimate test! Control two boxes, and master the art of the perfect jump. In this unique and thrilling challenge, the bigger box must leap over the smaller one at just the right moment to avoid collisions and keep the momentum going. The more precise your jumps, the higher your score climbs! With simple one-tap controls and increasingly difficult levels, Box Hop Duel offers endless fun for players of all ages. Challenge yourself. Can you time your jumps perfectly and set a new high score? Features: Simple one-touch controls Dynamic gameplay",
    "instructions": "Click to jump over",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Arcade",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/6bp1kecxbmpyz3mrmn0xng9jpo110yda/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6bp1kecxbmpyz3mrmn0xng9jpo110yda/",
    "sourceUrl": "https://html5.gamemonetize.com/6bp1kecxbmpyz3mrmn0xng9jpo110yda/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "65285",
    "slug": "pick-the-number",
    "title": "Pick The Number",
    "description": "Pick The Number is an educational and addictive puzzle game designed to boost your brainpower! Sharpen your number recognition, improve your memory, and test your reaction speed in a fun, colorful environment. Your mission is simple: pick the correct number based on the prompt before time runs out! Perfect for kids and adults alike, this game combines quick thinking with educational value.",
    "instructions": "Desktop Click the left button of the mouse to choose correct number in order Mobile Click correct number in order",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Brain",
      "Educational",
      "HTML5",
      "html5 games",
      "Kid",
      "Kids",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/so25mwq4jbenzxwlxfro8yvnecnvltix/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/so25mwq4jbenzxwlxfro8yvnecnvltix/",
    "sourceUrl": "https://html5.gamemonetize.com/so25mwq4jbenzxwlxfro8yvnecnvltix/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67572",
    "slug": "hidden-pairs-mahjong",
    "title": "Hidden Pairs Mahjong",
    "description": "Match and clear all the tile in this Hidden Pairs Mahjong solitaire game. Use your observation skills to find and select identical open tiles to remove them from the board. With beautifully designed classic Mahjong symbols, smooth animations, and a calming background, each level offers a fresh puzzle challenge.Earn bonus time, increase your score, and progress through endless levels of tile-matching fun!",
    "instructions": "Tap matching tiles to clear the board Try to beat the clock with bonus time If you are stuck use hint button",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Mahjong",
      "Matching",
      "Mind",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/castncb969mo3h8kovir9oraxbpypnb3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/castncb969mo3h8kovir9oraxbpypnb3/",
    "sourceUrl": "https://html5.gamemonetize.com/castncb969mo3h8kovir9oraxbpypnb3/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "66884",
    "slug": "chicken-jockey-shooting-tung-tung-sahur",
    "title": "Chicken Jockey Shooting Tung Tung Sahur",
    "description": "Step into the wild, wacky, and pixelated world of Chicken Jockey Shooting Tung Tung Sahur &mdash; a fast-paced action shooter where the unlikeliest of heroes takes on the criminal underworld of a Minecraft-style Las Vegas. You are the Chicken Jockey, a legendary baby zombie mounted on a fearless chicken, armed with grit, determination, and a trusty blaster. When the glitzy desert town is overrun by ruthless bandits in Tung Tung Sahur, it&rsquo;s up to you to bring order back to the blocky chaos!",
    "instructions": "mouse only",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "8 Ball Pool",
      "Action",
      "Air",
      "airplane",
      "apocalypse",
      "Arena",
      "mineblock",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/5jekjsbk5wqleu5n4k5sqxibpycywcth/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5jekjsbk5wqleu5n4k5sqxibpycywcth/",
    "sourceUrl": "https://html5.gamemonetize.com/5jekjsbk5wqleu5n4k5sqxibpycywcth/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67414",
    "slug": "ultimate-robot-fighting",
    "title": "Ultimate Robot Fighting",
    "description": "Enter the ultimate showdown in Ultimate Robot Fighting. Youll be controlling your robot in battle. Keep shooting enemies and try to survive. Play as a fearless mechanical warrior and fight enemies. Collect various guns to increase your bullet count. The game is designed for boys and is simple yet challenging!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Fighting",
      "Robot",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/xo851pwg3e5nh7act1wsy486mjyb8w6u/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xo851pwg3e5nh7act1wsy486mjyb8w6u/",
    "sourceUrl": "https://html5.gamemonetize.com/xo851pwg3e5nh7act1wsy486mjyb8w6u/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67411",
    "slug": "construction-simulator-lite",
    "title": "Construction Simulator Lite",
    "description": "Welcome to Construction Simulator Lite, the casual construction simulator game designed for every boy who dreams of operating heavy machinery! Take control of powerful excavators, cars, cranes, and more! Precise operation of the robotic arm. Completes a series of construction tasks such as digging, handling, and filling the foundation.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Car",
      "Simulator",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/iifqhn3k4bln57rcd9w1saylv5y6bine/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iifqhn3k4bln57rcd9w1saylv5y6bine/",
    "sourceUrl": "https://html5.gamemonetize.com/iifqhn3k4bln57rcd9w1saylv5y6bine/",
    "width": 1630,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67301",
    "slug": "classic-car-parking-2025",
    "title": "Classic Car Parking 2025",
    "description": "Classic Car Parking 2025 challenges your precision and driving skills with realistic parking missions! Take control of vintage cars and navigate tight spaces, narrow lanes, and tricky obstacles. Master each level by parking perfectly without crashes. Its not just a game&mdash;its a true test of patience and control! Web Dev <a href='https://www.kizi10.org/'>https://www.kizi10.org/</a>",
    "instructions": "WASD to drive the car",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Car",
      "carparking",
      "Classic",
      "Driving",
      "Mentolatux",
      "Parking",
      "Skill",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/h2756112zb490g5tjjpoq6av147lo7i7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h2756112zb490g5tjjpoq6av147lo7i7/",
    "sourceUrl": "https://html5.gamemonetize.com/h2756112zb490g5tjjpoq6av147lo7i7/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67238",
    "slug": "tung-sahur-io",
    "title": "Tung Sahur IO",
    "description": "Join up to 100 players in this hilarious viral meme-inspired multiplayer mayhem! Start as an innocent school kid, but watch out, the legendary Tung Sahur infection is spreading fast! Experience tiktoks most beloved bombardino crocodilo and tung tung tung sahur memes come to life in an epic infection game that will have you laughing and screaming at the same time along with your friends. Play as a school kid trying to survive the chaos, or get infected and join the Tung Sahur army to hunt down your former classmates.",
    "instructions": "WASD Arrow keys Move your character LEFT MOUSE Action jump as a kid or attack as a Tung Sahur MOUSE Move camera Mobile DRAG with your LEFT FINGER to move around DRAG with your right finger to look around TAP the GREEN BUTTON to Action jum",
    "category": "Multiplayer",
    "genres": [
      "Multiplayer"
    ],
    "tags": [
      "airplane",
      "Avoid",
      "Battle",
      "Collecting",
      "Escape",
      "fly",
      "Helicopter",
      "jump",
      "run"
    ],
    "thumbnail": "https://img.gamemonetize.com/oddet3vf59i0den8dikuc3us81aby79z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oddet3vf59i0den8dikuc3us81aby79z/",
    "sourceUrl": "https://html5.gamemonetize.com/oddet3vf59i0den8dikuc3us81aby79z/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64712",
    "slug": "fashion-week-2025",
    "title": "Fashion Week 2025",
    "description": "Get ready to rule the runway in Fashion Week 2025! Style 5 stunning models in high-fashion looks for the most glamorous fashion event of the year! From Chanel-inspired elegance to punk rock rebellion, create jaw-dropping outfits across five unique themes. Mix and match couture dresses, bold accessories, and trendy hairstyles to make every model shine! Are you ready to become the ultimate fashion stylist? Play now and slay the runway!",
    "instructions": "Use your mouse to play this game on a desktop tap to play on mobile devices",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "1 Player",
      "Dress Up",
      "Fashion",
      "Girl"
    ],
    "thumbnail": "https://img.gamemonetize.com/i1sdictu7ji0osgsqu4mxen28dogf4yk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/i1sdictu7ji0osgsqu4mxen28dogf4yk/",
    "sourceUrl": "https://html5.gamemonetize.com/i1sdictu7ji0osgsqu4mxen28dogf4yk/",
    "width": 1024,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "66466",
    "slug": "dashvalley",
    "title": "DashValley",
    "description": "Control your pets adventure through obstacles. Avoid touching the spikes above obstacles, there are a lot of cute little animals in the game to unlock, you need to get a certain number of points. Come and experience it.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Adventure",
      "Bricks"
    ],
    "thumbnail": "https://img.gamemonetize.com/8hfx4lj743bimt4oz7u443l7l7ig851d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8hfx4lj743bimt4oz7u443l7l7ig851d/",
    "sourceUrl": "https://html5.gamemonetize.com/8hfx4lj743bimt4oz7u443l7l7ig851d/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67382",
    "slug": "thung-thung-sahur-night-escape",
    "title": "Thung Thung Sahur Night Escape",
    "description": "Thung Thung Sahur Night Escape is an immersive first-person horrorstealth game set in a spooky, abandoned village where your only mission is to rescue the imprisoned Brainrot creatures before the terrifying Tung Tung Sahur catches you.",
    "instructions": "WASD move E interact",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "amazing",
      "Horror",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/620nm6ephwpsh0izvkzh6k8d304t2vpp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/620nm6ephwpsh0izvkzh6k8d304t2vpp/",
    "sourceUrl": "https://html5.gamemonetize.com/620nm6ephwpsh0izvkzh6k8d304t2vpp/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67391",
    "slug": "tralalero-tralala-hidden-stars",
    "title": "Tralalero Tralala Hidden Stars",
    "description": "Discover the Magic in Tralalero Tralala Hidden Stars. Sparkly Adventures Await. Tralalero Tralala Hidden Stars is a super fun and completely free online game made especially for curious kids who love surprises. Your mission is simple: explore each vibrant scene and find every single hidden star. Some are easy to spot, but others are sneakily tucked away! Once you find them all, you unlock the next level and continue the adventure. It is a fun way to train your eyes and your brain while having loads of fun.",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "Boys",
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Fun",
      "Girls",
      "Hidden",
      "Italian Brainrot",
      "Kids",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/kk6se97y755w2qkbzi997r349cx8kf91/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kk6se97y755w2qkbzi997r349cx8kf91/",
    "sourceUrl": "https://html5.gamemonetize.com/kk6se97y755w2qkbzi997r349cx8kf91/",
    "width": 960,
    "height": 540,
    "lastUpdated": ""
  },
  {
    "id": "67422",
    "slug": "voice-of-the-soul",
    "title": "Voice Of The Soul",
    "description": "Voice of the Soul is a simple and calming app that gives you thoughtful, motivational messages to start your day or clear your mind. It&rsquo;s perfect for moments when you need a little clarity, focus, or a gentle push to keep going.",
    "instructions": "Use a mouse or touchpad to play this game",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "html5 games",
      "Mobile"
    ],
    "thumbnail": "https://img.gamemonetize.com/w07a9a1t3kt7xoh747zcgawbhr8i7y0s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w07a9a1t3kt7xoh747zcgawbhr8i7y0s/",
    "sourceUrl": "https://html5.gamemonetize.com/w07a9a1t3kt7xoh747zcgawbhr8i7y0s/",
    "width": 600,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "63978",
    "slug": "shape-whiz",
    "title": "Shape Whiz",
    "description": "Get ready for a sweet learning adventure with Shape Whiz &ndash; the donut-themed educational game that helps kids learn shapes in a fun and interactive way! Perfect for young minds, this game teaches basic geometric shapes like circles, squares, triangles, and more through colorful visuals and delightful animations. As players match the correct shapes with their outlines, they&rsquo;re rewarded with cheerful sounds and tasty donut designs that keep learning exciting. With its vibrant graphics, engaging gameplay, and kid-friendly interface, Shape Whiz turns early education into a joyful treat!",
    "instructions": "On desktop simply use your left mouse button to click on the correct matching outline for each shape On mobile simply click on the correct matching outline for each shape",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Clicker",
      "Educational",
      "Hypercasual",
      "Kids",
      "NapTech Games",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/0ty9l8uw24x6y46wxln69fzdxcxszlw5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0ty9l8uw24x6y46wxln69fzdxcxszlw5/",
    "sourceUrl": "https://html5.gamemonetize.com/0ty9l8uw24x6y46wxln69fzdxcxszlw5/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "64388",
    "slug": "balloon-blitz",
    "title": "Balloon Blitz",
    "description": "Get ready for an action-packed popping frenzy in Balloon Blitz! Tap into fast reflexes and sharp aim as you launch darts to burst vibrant red and blue balloons in this colorful arcade challenge. Strategically hit the right targets, score combo points, and climb the leaderboard in this simple yet addictive game for all ages! With cheerful visuals, smooth controls, and escalating difficulty, Balloon Blitz offers endless fun for casual players and competitive gamers alike. How many balloons can you blitz before time runs out?",
    "instructions": "Desktop Click the left button of the mouse to release matching dart to pop the balloons Mobile Click the dart to release and pop the balloons",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Arcade",
      "NapTech Games",
      "Puzzle",
      "Skill",
      "Skills"
    ],
    "thumbnail": "https://img.gamemonetize.com/0oj4ohrdfog5hba9jp7i47j0fn8ov9v2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0oj4ohrdfog5hba9jp7i47j0fn8ov9v2/",
    "sourceUrl": "https://html5.gamemonetize.com/0oj4ohrdfog5hba9jp7i47j0fn8ov9v2/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67231",
    "slug": "join-blob-clash",
    "title": "Join Blob Clash",
    "description": "Come and experience this awesome 3D action breakout parkour game! Join Blob Clash is an awesome arcade game that combines math, counting, running, and fighting. Youll control a legion of cute Blobs, running wild, collecting partners, knocking over enemies, and smashing big bosses along the way!",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Enemies",
      "Fight",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/h0zibwgfggl2rt7o3928x7jtjm9hxzq2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h0zibwgfggl2rt7o3928x7jtjm9hxzq2/",
    "sourceUrl": "https://html5.gamemonetize.com/h0zibwgfggl2rt7o3928x7jtjm9hxzq2/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67283",
    "slug": "space-survival-rainbow-friends-monster",
    "title": "Space Survival Rainbow Friends Monster",
    "description": "Begin a fun battle like never before in Space Survival - Rainbow Friends Monster! You&rsquo;re in a mysterious space station overrun by terrifying rainbow monsters. Your task is to escape and rescue your friends. Use your gun to begin the battle. Avoid enemy attacks and unleash shooting combos against waves of enemies.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Enemies",
      "Shooting",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/rdij6lpwivwkq1cfebpbyt6kc00fh6hi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rdij6lpwivwkq1cfebpbyt6kc00fh6hi/",
    "sourceUrl": "https://html5.gamemonetize.com/rdij6lpwivwkq1cfebpbyt6kc00fh6hi/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67324",
    "slug": "vehicle-stunts-sky-sim",
    "title": "Vehicle Stunts Sky Sim",
    "description": "Vehicle Stunts Sky Sim takes action to new heights&mdash;literally! Drive powerful cars, bikes, and trucks on insane sky-high tracks. Perform gravity-defying stunts, leap over gaps, and race through loops in mid-air. With thrilling challenges and breathtaking views, are you brave enough to conquer the skies? Web Dev <a href='https://www.bestcrazygames.com/'>https://www.bestcrazygames.com/</a>",
    "instructions": "WASD to drive vehicle on stunts map",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "1 Player",
      "Car",
      "Driving",
      "Mentolatux",
      "Simulator",
      "Stunts",
      "Supercars",
      "unity",
      "vehicle",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ousj5se644v7dap2ct2hbr9332glci0h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ousj5se644v7dap2ct2hbr9332glci0h/",
    "sourceUrl": "https://html5.gamemonetize.com/ousj5se644v7dap2ct2hbr9332glci0h/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67341",
    "slug": "truck-transport-simulator",
    "title": "Truck Transport Simulator",
    "description": "Ready to test your driving skills like a pro? Step into Truck Transport Simulator, the ultimate driving simulator game built for boys. Control a truck and complete exciting transport missions across various landscapes: transport boxes, barrels, etc., and park in designated locations. Watch out for uneven rocky roads and drive slowly to make sure your cargo doesnt fall off! Or you will fail.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Boys",
      "transport",
      "Truck"
    ],
    "thumbnail": "https://img.gamemonetize.com/0yowl6lwz72aululkpwscu00who4si65/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0yowl6lwz72aululkpwscu00who4si65/",
    "sourceUrl": "https://html5.gamemonetize.com/0yowl6lwz72aululkpwscu00who4si65/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "63252",
    "slug": "doodle-football",
    "title": "Doodle Football",
    "description": "Doodle Football is an imaginative and captivating 2D casual game that combines creativity, strategy, and fun. Your goal is simple: guide the football into the goal while overcoming exciting challenges across a variety of themes like the lush greenery of fields, the scorching sands of the desert, and the frosty landscapes of ice.",
    "instructions": "left mouse button to draw Touch and hold to draw on touchscreen",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Casual",
      "Drawing",
      "Sports"
    ],
    "thumbnail": "https://img.gamemonetize.com/otkghh55wx2a5zrrjvqemefeeozufjy3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/otkghh55wx2a5zrrjvqemefeeozufjy3/",
    "sourceUrl": "https://html5.gamemonetize.com/otkghh55wx2a5zrrjvqemefeeozufjy3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67299",
    "slug": "sokomatch",
    "title": "SokoMatch",
    "description": "SokoMatch 3D is a strategic puzzle game that combines block-pushing mechanics with match-3 gameplay. Push colorful animal blocks around the board to create groups of three or more matching animals, which will then disappear. Your goal is to clear all blocks from each level using the fewest moves possible. Navigate through increasingly challenging levels featuring special mechanics like ice blocks that freeze animals in place, and one-way arrow tiles that restrict your movement direction. Plan your moves carefully - some puzzles require strategic thinking to avoid getting stuck with unmatchable blocks.",
    "instructions": "Desktop Arrow Keys or WASD - Move player R - Restart current level Q E - Rotate camera view Space - Continue to next level Start game Mouse - Click UI buttons Mobile Touch Swipe - Move player swipe in direction you want to move Tap buttons - Use on-",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brain",
      "Casual",
      "Hypercasual",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/r4in7whqj17v1j0om49i6os2p2dng6z7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r4in7whqj17v1j0om49i6os2p2dng6z7/",
    "sourceUrl": "https://html5.gamemonetize.com/r4in7whqj17v1j0om49i6os2p2dng6z7/",
    "width": 1200,
    "height": 1000,
    "lastUpdated": ""
  },
  {
    "id": "66467",
    "slug": "bighead",
    "title": "BigHead",
    "description": "Control the character to jump on the platforms on both sides. Different obstacles will appear during the jump. Seize the right moment to jump and avoid hitting the obstacles. Its super exciting. Come and experience it now.",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Action",
      "Adventure",
      "jump"
    ],
    "thumbnail": "https://img.gamemonetize.com/m4gogzmvxhqk5tih1b17uz79h7veouij/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/m4gogzmvxhqk5tih1b17uz79h7veouij/",
    "sourceUrl": "https://html5.gamemonetize.com/m4gogzmvxhqk5tih1b17uz79h7veouij/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67321",
    "slug": "sprunki-troll-platformer",
    "title": "Sprunki Troll Platformer",
    "description": "Sprunki Troll Platformer is a platformer that challenges you! Can you pass the troll levels? Complete levels that are full of hidden traps, set up to make it as difficult as possible! Remember their locations, avoid them, or use them to your advantage! There are 25 levels available in the game.",
    "instructions": "On PC the game is controlled using the WAD keys on the keyboard or the arrows larr rarr uarr On mobile devices the game is controlled using the on-screen buttons The goal of the game is to avoid traps and reach the green check mark",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Arcade",
      "Avoid",
      "Best Games",
      "free html5 games for your website",
      "HTML5",
      "Mobile",
      "Platform",
      "Puzzle",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/vgrwukuu6jh21r2rcgj4ubroxwjp5l3o/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vgrwukuu6jh21r2rcgj4ubroxwjp5l3o/",
    "sourceUrl": "https://html5.gamemonetize.com/vgrwukuu6jh21r2rcgj4ubroxwjp5l3o/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67350",
    "slug": "mythinsects-tower-defense",
    "title": "Mythinsects Tower Defense",
    "description": "Enter the Bugged Out Battlefield in Mythinsects Tower Defense Tiny Heroes, Epic Battles. Get ready for a tower defense adventure where the tiniest creatures wage the mightiest wars! Mythinsects Tower Defense is a delightful and strategic game where you will defend your world from waves of mythical insect invaders. With colorful graphics, quirky bug characters, and tons of upgrade options, it is a game that both kids and adults will love.",
    "instructions": "Mouse to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Boys",
      "Collecting",
      "Fight",
      "Hypercasual",
      "Kids",
      "Skills",
      "Tower Defense"
    ],
    "thumbnail": "https://img.gamemonetize.com/p81xm64z2zd7cyl65hi5uhp1nv6xnt2a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p81xm64z2zd7cyl65hi5uhp1nv6xnt2a/",
    "sourceUrl": "https://html5.gamemonetize.com/p81xm64z2zd7cyl65hi5uhp1nv6xnt2a/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67132",
    "slug": "tank-master",
    "title": "Tank Master",
    "description": "The battle has started. Take your opponent with the cannons and destroy as many tanks as you can before they kill you. Battle against cunning enemies, collect power-ups, and complete more than 100 levels of amazing action. Collect coins and upgrade your war machine with new cannons, bullets and armor to be the leadear.",
    "instructions": "Use the mouse or touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      ".io Games",
      "1 Player",
      "2D",
      "Action",
      "Army",
      "endless",
      "Shoot 'Em Up",
      "Shooter",
      "Tank"
    ],
    "thumbnail": "https://img.gamemonetize.com/r50sosv94qp15bkjhze2givwy8z5bsuu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r50sosv94qp15bkjhze2givwy8z5bsuu/",
    "sourceUrl": "https://html5.gamemonetize.com/r50sosv94qp15bkjhze2givwy8z5bsuu/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67252",
    "slug": "orc-hero",
    "title": "Orc Hero",
    "description": "Embark on a thrilling pixel-art turn-based adventure! Fight fierce enemies, level up your heroes, and master strategic battles. Upgrade your dodge, defense, and attack to survive against stronger foes. Can you defeat the endless waves and become the ultimate hero?",
    "instructions": "Click or Touch",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Adventure",
      "Clicker",
      "Fantasy",
      "Pixel"
    ],
    "thumbnail": "https://img.gamemonetize.com/lqv5exvjamjgzqbhojbdqpdbe72tptet/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lqv5exvjamjgzqbhojbdqpdbe72tptet/",
    "sourceUrl": "https://html5.gamemonetize.com/lqv5exvjamjgzqbhojbdqpdbe72tptet/",
    "width": 854,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67250",
    "slug": "ramp-bus-stunt-simulator",
    "title": "Ramp Bus Stunt Simulator",
    "description": "Experience high-flying thrills in Ramp Bus Stunt Simulator! Perform jaw-dropping stunts, conquer challenging ramps, and drive massive buses across extreme tracks. Test your skills, unlock unique vehicles, and defy gravity in this action-packed, adrenaline-fueled stunt driving simulator! Web Dev <a href='https://www.crazygamesonline.com/'>https://www.crazygamesonline.com/</a>",
    "instructions": "WASD to drive the bus",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "bus",
      "Driving",
      "Mentolatux",
      "Stunts",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/kt0h2atqrt5kejjevpi97ph6ckg0tw9g/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kt0h2atqrt5kejjevpi97ph6ckg0tw9g/",
    "sourceUrl": "https://html5.gamemonetize.com/kt0h2atqrt5kejjevpi97ph6ckg0tw9g/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66629",
    "slug": "letsrun",
    "title": "LetsRun",
    "description": "Parkour on the streets in winter. There will be random obstacles and coins on the street, control the character to avoid obstacles, pick up gold, gold can unlock other cute characters, come and experience it.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Adventure",
      "Aircraft",
      "Best Games",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/9nb220nkmszhkr1glvukhs88vmtey0zg/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/9nb220nkmszhkr1glvukhs88vmtey0zg/",
    "sourceUrl": "https://html5.gamemonetize.com/9nb220nkmszhkr1glvukhs88vmtey0zg/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65193",
    "slug": "cook-baked-dishes-and-desserts",
    "title": "Cook Baked Dishes and Desserts",
    "description": "Hey there, food lovers! Dive into the mouthwatering world of Cook Baked Dishes and Desserts, an amazing casual cooking simulator game thatll excite your taste buds! Once you enter the game, youre greeted by a bustling virtual kitchen filled with all sorts of cooking tools and ingredients. The fun begins with choosing whether you want to whip up a savory baked dish or a sweet, indulgent dessert.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cook",
      "Food",
      "Fun",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/6tt0xz78y09l8w0dcm0pothd1vpexr7k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6tt0xz78y09l8w0dcm0pothd1vpexr7k/",
    "sourceUrl": "https://html5.gamemonetize.com/6tt0xz78y09l8w0dcm0pothd1vpexr7k/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "64774",
    "slug": "sketer-bear-jump",
    "title": "Sketer Bear Jump",
    "description": "Sketer Bear Jump is a fun-filled, sky-high adventure where a bouncy bear takes on the ultimate jumping challenge! Join Sketer, the adorable and energetic bear, as he leaps from platform to platform, dodges tricky obstacles, and climbs higher than ever before. How to play: Tap or tilt to control Sketer&rsquo;s jumps. Avoid spikes, traps, and falling platforms. Collect honey jars and power-ups to boost your score and jump higher! With colorful graphics, smooth animations, and addictive vertical gameplay, Sketer Bear Jump is perfect for players of all ages. The higher you go, the harder it gets&mdash;but the thrill never stops!",
    "instructions": "mouse click for play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "angryplants",
      "Animal",
      "Click",
      "Cute",
      "endless",
      "free games for your site",
      "html5 games"
    ],
    "thumbnail": "https://img.gamemonetize.com/pv2g4qa46woash2vlwhoi6aalqa9ayjk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pv2g4qa46woash2vlwhoi6aalqa9ayjk/",
    "sourceUrl": "https://html5.gamemonetize.com/pv2g4qa46woash2vlwhoi6aalqa9ayjk/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64664",
    "slug": "stone-sheet-shears",
    "title": "Stone Sheet Shears",
    "description": "Unleash your strategy and reflexes in Stone Sheet Shears, a fast-paced, modern twist on the classic game of Rock, Paper, Scissors! Dive into a colorful and engaging world where you&rsquo;ll face off against opponents in exciting, high-stakes rounds of Stone (Crushes), Sheet (Wraps), and Shears (Slices). Test your decision-making in real-time battles, sharpen your instincts, and outthink your challengers to climb the leaderboard. With vibrant graphics, smooth animations, and multiple modes to explore, Stone Sheet Shears delivers both nostalgia and excitement in every match.",
    "instructions": "Use mice or tap",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Casual",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/qgcgsh667058s3w49a8dcsjqw2p8euf2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qgcgsh667058s3w49a8dcsjqw2p8euf2/",
    "sourceUrl": "https://html5.gamemonetize.com/qgcgsh667058s3w49a8dcsjqw2p8euf2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67141",
    "slug": "pastry-pop-blast-bubble-shooter",
    "title": "Pastry Pop Blast   Bubble Shooter",
    "description": "In the game Bubble Shooter Halloween, your goal is to pop all the bubbles before they reach the ground. Aim and shoot to match bubbles of the same color &mdash; when you hit a matching cluster, they&rsquo;ll explode and you&rsquo;ll earn points.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Bubble Shooter",
      "Fun",
      "Kids"
    ],
    "thumbnail": "https://img.gamemonetize.com/w9euon0rmteaatp9nh7do14cfkyws0mr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w9euon0rmteaatp9nh7do14cfkyws0mr/",
    "sourceUrl": "https://html5.gamemonetize.com/w9euon0rmteaatp9nh7do14cfkyws0mr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67282",
    "slug": "street-car-racing",
    "title": "Street Car Racing",
    "description": "In Street Car Racing, drive cool racing cars and race. This is a street racing simulation game for boys. You can feel the extreme drifting, realistic engine roar, and super-fast street racing! In race mode, race against your opponents and collect nitrogen bottles to speed up! Show your driving skills and watch out for the corners!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "Race",
      "Skills",
      "Street Fighting"
    ],
    "thumbnail": "https://img.gamemonetize.com/6mpmshr3a56tp1x01u87xfj3i330ucdy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6mpmshr3a56tp1x01u87xfj3i330ucdy/",
    "sourceUrl": "https://html5.gamemonetize.com/6mpmshr3a56tp1x01u87xfj3i330ucdy/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "67234",
    "slug": "crazy-goods-sort-3d",
    "title": "Crazy Goods Sort 3D",
    "description": "Ready to start a 3D puzzle thats both magical and brain-teasing? Welcome to Crazy Goods Sort 3D, where chaos meets logic, and your job is to restore order. Here, youll be confronted with a pile of boxes that have been tossed around. Sort the same kinds of items into the correct bins so that they match perfectly.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D Games",
      "Logic",
      "Magic",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/8oyorvtaq3sv2g6j2m67crgl4rpe6vdy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8oyorvtaq3sv2g6j2m67crgl4rpe6vdy/",
    "sourceUrl": "https://html5.gamemonetize.com/8oyorvtaq3sv2g6j2m67crgl4rpe6vdy/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "64676",
    "slug": "lollipop-escape-mania",
    "title": "Lollipop Escape Mania",
    "description": "Lollipop Escape Mania is a delightful platformer adventure where sugary clouds are filled with delicious candies waiting to be collected! Jump from one fluffy cloud to another, gather every sweet treat, and navigate through exciting levels without falling. The more candies you collect, the sweeter your victory! With vibrant visuals, smooth controls, and thrilling challenges, Lollipop Escape Mania offers endless fun for players of all ages. Can you master the jumps and collect every last candy? Play now and embark on the ultimate sugary escape!",
    "instructions": "Use arrow keys or click on given buttons",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Candy",
      "Casual",
      "Food"
    ],
    "thumbnail": "https://img.gamemonetize.com/vrb15qx6uz8ja5vr2xl59jnxugho255m/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vrb15qx6uz8ja5vr2xl59jnxugho255m/",
    "sourceUrl": "https://html5.gamemonetize.com/vrb15qx6uz8ja5vr2xl59jnxugho255m/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65119",
    "slug": "gluttonous-bean",
    "title": "Gluttonous Bean",
    "description": "In the game of Greedy Beans, you need to eat all the beans as quickly as possible. Try to eat as many beans as you can each time and avoid being struck by lightning. You will pass the level once you have eaten all the beans. Come on!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Casual",
      "Crazy"
    ],
    "thumbnail": "https://img.gamemonetize.com/00ewrb46e1dpjncmyb4oaiubabholdt6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/00ewrb46e1dpjncmyb4oaiubabholdt6/",
    "sourceUrl": "https://html5.gamemonetize.com/00ewrb46e1dpjncmyb4oaiubabholdt6/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66623",
    "slug": "flipthegun",
    "title": "FlipTheGun",
    "description": "Roll upward with the gun recoil. Touching the screen causes the gun to fire, using the recoil to roll the gun upwardYou get sprints and ammo during the roll.Coins are also earned during the roll, which can unlock better guns. Come and experience it.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/z22yvqrpc17cmoy7pisqv0ac1pdldhit/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/z22yvqrpc17cmoy7pisqv0ac1pdldhit/",
    "sourceUrl": "https://html5.gamemonetize.com/z22yvqrpc17cmoy7pisqv0ac1pdldhit/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67116",
    "slug": "cute-kitty-memory-challenge",
    "title": "Cute Kitty Memory Challenge",
    "description": "Cute Kitty Memory Challenge is a paw-sitively adorable memory game that will tickle your brain and warm your heart! Designed especially for kids, this fun filled game stars a cast of fuzzy little kittens hiding behind cards, just waiting to be matched. Flip the cards, remember their spots, and try to pair up all the cuddly kitties before time runs out. Each level brings new patterns, tricky layouts, and even cuter cats. It is the perfect way to sharpen your memory while having a meowgical time! Whether you are a junior genius or just love cats, this is the purr-fect challenge for curious minds and kitty lovers alike!",
    "instructions": "Mouse to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Educational",
      "Fun",
      "Girls",
      "Hello Kitty",
      "Kids",
      "Logic",
      "Memory",
      "School",
      "Skill"
    ],
    "thumbnail": "https://img.gamemonetize.com/kol2tqztbrkxd3abvfm798rij0e3wkxr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kol2tqztbrkxd3abvfm798rij0e3wkxr/",
    "sourceUrl": "https://html5.gamemonetize.com/kol2tqztbrkxd3abvfm798rij0e3wkxr/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67138",
    "slug": "arcade-pong-deluxe",
    "title": "Arcade Pong Deluxe",
    "description": "Arcade Pong Deluxe: Classic arcade action reborn! Challenge smart AI, enjoy full-screen play, responsive controls, and customizable sound. Dive into retro fun!",
    "instructions": "Mouse click or tap to play",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Air",
      "Arcade",
      "Classic",
      "Defense",
      "Sport"
    ],
    "thumbnail": "https://img.gamemonetize.com/f15sddte014o8cumjvx9oy0n3puiapn7/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/f15sddte014o8cumjvx9oy0n3puiapn7/",
    "sourceUrl": "https://html5.gamemonetize.com/f15sddte014o8cumjvx9oy0n3puiapn7/",
    "width": 800,
    "height": 450,
    "lastUpdated": ""
  },
  {
    "id": "67149",
    "slug": "police-driving-vehicles-simulator",
    "title": "Police Driving Vehicles Simulator",
    "description": "Police Driving Vehicles Simulator puts you in the driver&rsquo;s seat of powerful law enforcement vehicles! Patrol the city, chase down criminals, and complete high-stakes missions across detailed urban and off-road environments. From fast-response cruisers to rugged SWAT trucks, master the controls of different police vehicles and show off your driving skills in this realistic simulator. Web Dev <a href='https://www.unblockedgamesforkids.com/'>https://www.unblockedgamesforkids.com/</a>",
    "instructions": "WASD to drive the police car",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Car",
      "carparking",
      "Driving",
      "Mentolatux",
      "Parking",
      "Police",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/dlzzk0ad8o64dwc19xt9052d8l8ltssy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/dlzzk0ad8o64dwc19xt9052d8l8ltssy/",
    "sourceUrl": "https://html5.gamemonetize.com/dlzzk0ad8o64dwc19xt9052d8l8ltssy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67154",
    "slug": "hunter-tung-tung-sahur",
    "title": "Hunter Tung Tung Sahur",
    "description": "The Tung Tung Sahur monsters are coming! Grab your weapon and shoot them all quickly. They&rsquo;ve taken over the world &mdash; they&rsquo;re everywhere! Load your gun with all the bullets and open fire. Wipe out all the Tung Tung Sahurs and reach the plane in the hangar. That plane is your only chance to escape the area. Reach it safely!",
    "instructions": "Use the WASD keys to move Shoot and defeat all incoming enemies Reach your airplane safely Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Action",
      "Arcade",
      "attack",
      "Gun",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/2x4uo0nhkmx8q888i1ni2glm3th7kln2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2x4uo0nhkmx8q888i1ni2glm3th7kln2/",
    "sourceUrl": "https://html5.gamemonetize.com/2x4uo0nhkmx8q888i1ni2glm3th7kln2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67211",
    "slug": "ninja-shadow-kunai",
    "title": "Ninja Shadow Kunai",
    "description": "Enter the world of shadows in Ninja Shadow Kunai &mdash; a fast-paced 2D knife-throwing ninja game inspired by legends like Naruto and classic shinobi warriors! Master the art of kunai throwing as you take control of a silent ninja assassin. Tap and aim with precision to strike down enemies, break obstacles, and survive endless waves of challenges. Test your reflexes and ninja instincts in this action-packed HTML5 arcade game! Whether youre a fan of Naruto, anime ninja games, or fast-tap reaction games, Ninja Shadow Kunai delivers thrilling gameplay with epic shadow vibes and kunai-throwing fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Casual",
      "Ninja",
      "Shoot",
      "Shooting"
    ],
    "thumbnail": "https://img.gamemonetize.com/rt9dgc33ezpdvzsqsijnzgylr32rtkxe/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rt9dgc33ezpdvzsqsijnzgylr32rtkxe/",
    "sourceUrl": "https://html5.gamemonetize.com/rt9dgc33ezpdvzsqsijnzgylr32rtkxe/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67135",
    "slug": "stickman-warfare",
    "title": "Stickman Warfare",
    "description": "In a dystopian future, the world is in brink of war. It is time when humanity need the peace keeper. Fight hordes of terrorists, enhance your war gears, and regain peace back on earth again!",
    "instructions": "Use the mouse and keyboard or touch to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "Action",
      "Army",
      "Battle",
      "Battlegrounds",
      "Defense",
      "Shooter",
      "Stickman",
      "Tower Defense",
      "War"
    ],
    "thumbnail": "https://img.gamemonetize.com/g29vickxti7tbf2f5srhvijd3w3azse4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/g29vickxti7tbf2f5srhvijd3w3azse4/",
    "sourceUrl": "https://html5.gamemonetize.com/g29vickxti7tbf2f5srhvijd3w3azse4/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67193",
    "slug": "3d-super-rolling-ball-race",
    "title": "3D Super Rolling Ball Race",
    "description": "Like speed? Love excitement? Then you cant afford to miss this awesome 3D Super Rolling Ball Race! It&rsquo;s a wild, high-speed 3D platform game that will test your reflexes, timing, and racing spirit! The operation is simple but full of challenges, super suitable for those who like running and arcade-style. Control a rolling ball, navigate through tricky platforms, and avoid falling off!",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Ball",
      "Multiplayer",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/smjkmhbbzklco9rfh4uhy4o10cjbwbkr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/smjkmhbbzklco9rfh4uhy4o10cjbwbkr/",
    "sourceUrl": "https://html5.gamemonetize.com/smjkmhbbzklco9rfh4uhy4o10cjbwbkr/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67120",
    "slug": "offroad-jeep-hills-driving",
    "title": "Offroad Jeep Hills Driving",
    "description": "Offroad Jeep Hills Driving offers an adventurous ride through rugged hills and dense fog. Drive a powerful jeep across challenging terrain, weaving between palm trees with realistic physics and immersive environments. Conquer nature&rsquo;s obstacles in this true offroad driving experience.",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Driving",
      "hills",
      "jeep",
      "Mentolatux",
      "offroad",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/zwg8qrlmqd5hnbd39kgftqa3lm6htdgp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/zwg8qrlmqd5hnbd39kgftqa3lm6htdgp/",
    "sourceUrl": "https://html5.gamemonetize.com/zwg8qrlmqd5hnbd39kgftqa3lm6htdgp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64985",
    "slug": "galaxy-brick-breaker",
    "title": "Galaxy Brick Breaker",
    "description": "Galaxy Brick Breaker launches you into an interstellar arcade experience where classic brick-breaking meets cosmic action! Blast through waves of glowing bricks with powerful space paddles and energy balls in a galaxy full of challenges. Navigate asteroid fields, unlock power-ups, and face off against alien brick formations across vibrant star systems. With dazzling neon visuals, smooth controls, and addictive gameplay, every level is a journey through the stars. Upgrade your paddle, unleash laser shots, and become the ultimate breaker of the galaxy. Get ready to bounce, blast, and break your way through space in Galaxy Brick Breaker!",
    "instructions": "Use Mouse to play the game",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Best",
      "Best Games",
      "Board",
      "Bricks",
      "Candy",
      "destroy",
      "Shoot",
      "Space",
      "Spaceship",
      "swipe"
    ],
    "thumbnail": "https://img.gamemonetize.com/py3zv9ry8am8vezvg2od9cfk9uzoe94n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/py3zv9ry8am8vezvg2od9cfk9uzoe94n/",
    "sourceUrl": "https://html5.gamemonetize.com/py3zv9ry8am8vezvg2od9cfk9uzoe94n/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66823",
    "slug": "chicken-jockey-hidden-lava-chicken-2",
    "title": "Chicken Jockey hidden lava chicken 2",
    "description": "Beneath the barn... lies the burn! In this explosive sequel, the mischievous Chicken Jockey returns with a scorching new twist &mdash; now riding the elusive Hidden Lava Chicken, a beast born from magma and mystery. With molten feathers and a trail of fire, this underground menace clucks through chaos, turning every race into a heated showdown. Can you outrun the blaze, dodge the traps, and uncover the secrets buried deep in the volcanic coops? One wrong step, and it&rsquo;s fried rider for dinner!",
    "instructions": "Mouse click or tap to play",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "Minecraft",
      "Miner",
      "Miraculous Ladybug",
      "Mobile",
      "Movie"
    ],
    "thumbnail": "https://img.gamemonetize.com/cdmzz3e8mezazt9oa25yw9o1vliud9k9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cdmzz3e8mezazt9oa25yw9o1vliud9k9/",
    "sourceUrl": "https://html5.gamemonetize.com/cdmzz3e8mezazt9oa25yw9o1vliud9k9/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65618",
    "slug": "hair-salon-and-dress-up-girl",
    "title": "Hair Salon And Dress Up Girl",
    "description": "Hair Salon and Dress Up Girl is a casual simulation girl game where you can fully explore your creativity and design skills. From hair washing, hair drying, and hair ironing, to hair dyeing, you complete each step with the guide in the game to give your model proper makeup. In this hair salon, you are the master, and you are the one to decide on which color or style is to be applied. Dont be afraid if you know nothing about fashion.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Fun",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/lfu2ypjhb04it98yv0wev1kqymu1lfb6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lfu2ypjhb04it98yv0wev1kqymu1lfb6/",
    "sourceUrl": "https://html5.gamemonetize.com/lfu2ypjhb04it98yv0wev1kqymu1lfb6/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "66620",
    "slug": "superbounce",
    "title": "SuperBounce",
    "description": "Control the ball to move forward to the next platform. Seize the moment, touch the screen to make the ball fall and touch the platform to bounce, safely enter the next platform, come and experience it, see how many points you can score.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "Arcade",
      "Ball"
    ],
    "thumbnail": "https://img.gamemonetize.com/oouca43ln3kkoow0xb5neoqxxez7tj3t/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oouca43ln3kkoow0xb5neoqxxez7tj3t/",
    "sourceUrl": "https://html5.gamemonetize.com/oouca43ln3kkoow0xb5neoqxxez7tj3t/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67183",
    "slug": "la-casa-de-tung-tung-sahur",
    "title": "La Casa de Tung Tung Sahur",
    "description": "The Tung Tung Sahur Brothers are trying to rob a bank and need your help! Help them collect all the money in the bank. There are two silver keys you need to find&mdash;collect them all to reach the big vault. Open the vault and empty the bank! Play together with your friend and help the Tung Tung Sahur Brothers succeed.",
    "instructions": "Use the WASD and Arrow keys to move Collect all the coins find the red and blue keys and open the bank vault Playable on both mobile and PC",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "2 Player Games",
      "2D",
      "Action",
      "attack",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/2i1bs67w2y0ltciqn0d364wh7rzm411k/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2i1bs67w2y0ltciqn0d364wh7rzm411k/",
    "sourceUrl": "https://html5.gamemonetize.com/2i1bs67w2y0ltciqn0d364wh7rzm411k/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67167",
    "slug": "relaxing-sudoku-and-futushiki",
    "title": "Relaxing Sudoku and Futushiki",
    "description": "Relaxing Sudoku and Futoshiki is a calming casual web game that merges the logic of Sudoku and Futoshiki into a serene sakura garden theme. Players solve puzzles in a tranquil setting filled with soft pastels, fluttering petals, and soothing music, with adjustable difficulty and hint systems to ensure a stress-free, frustration-free experience. The game balances mindful challenges with peaceful visuals and soundscapes, offering a gentle escape for puzzle enthusiasts seeking relaxation and mental clarity.",
    "instructions": "Point and click or tap on mobile devices and tablets",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Puzzle",
      "Relaxation",
      "Sudoku"
    ],
    "thumbnail": "https://img.gamemonetize.com/890426czywjcy4aacv7f23ebj9ryxy6z/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/890426czywjcy4aacv7f23ebj9ryxy6z/",
    "sourceUrl": "https://html5.gamemonetize.com/890426czywjcy4aacv7f23ebj9ryxy6z/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "65767",
    "slug": "domino-online-multiplayer",
    "title": "Domino Online Multiplayer",
    "description": "Do you like strategy, excitement and duel battles? You will find different modes, flexible settings and strong opponents. Variety of modes: With a computer &ndash; hone your skills against AI of varying difficulty Online Duels - fight with live players in real time Play with a friend &ndash; send a link and play together, even from a distance On one screen &ndash; convenient for pair battles at home Flexible settings: 9 difficulty levels Time control Cancel the move Hints Rating and statistics Customization The history of moves Emotions and chat",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "2 Player",
      "Board",
      "Boy",
      "Brain",
      "Classic",
      "Logic",
      "Memory",
      "Multiplayer",
      "Puzzle",
      "PvP"
    ],
    "thumbnail": "https://img.gamemonetize.com/cesnlh8sq40hoqm7t79vz7xnb1mzvnbx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/cesnlh8sq40hoqm7t79vz7xnb1mzvnbx/",
    "sourceUrl": "https://html5.gamemonetize.com/cesnlh8sq40hoqm7t79vz7xnb1mzvnbx/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67129",
    "slug": "moto-attack",
    "title": "Moto Attack",
    "description": "Face the wonderful Moto Attack Showdown! In this explosive action game, you&rsquo;re not just racing. You&rsquo;re also shooting and fighting your way through waves of enemies in your powerful car! Perfect for every action-loving boy, Moto Attack is the high-octane combo of racing, driving, and shooting that you&rsquo;ve been waiting for.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Enemies",
      "Fighting",
      "Moto",
      "Race"
    ],
    "thumbnail": "https://img.gamemonetize.com/3qo6bwp6aea8pj4ntuulxtyqsszn30ns/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3qo6bwp6aea8pj4ntuulxtyqsszn30ns/",
    "sourceUrl": "https://html5.gamemonetize.com/3qo6bwp6aea8pj4ntuulxtyqsszn30ns/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67137",
    "slug": "brrbrr-patapim",
    "title": "BrrBrr Patapim",
    "description": "BrrBrr Patapim is an epic 3D first-person shooter where you face off against the bizarre and powerful enemy&mdash;BrrBrr Patapim! Explore the map, collect powerful weapons, and toss grenades as you fight to survive the madness. With fast-paced action, meme-fueled energy, and nonstop fun, this is a wild and over-the-top shooting experience you wont forget!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "3D",
      "Animal",
      "Anime",
      "Cartoon",
      "Shooter"
    ],
    "thumbnail": "https://img.gamemonetize.com/1656arhg2u1z6evbbz5bcdqy39eyxk1d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/1656arhg2u1z6evbbz5bcdqy39eyxk1d/",
    "sourceUrl": "https://html5.gamemonetize.com/1656arhg2u1z6evbbz5bcdqy39eyxk1d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67114",
    "slug": "tung-tung-sahur",
    "title": "Tung Tung  Sahur",
    "description": "The Italian Brainrot crew has been kidnapped by jealous zombies! Launch Tung Tung like in Angry Birds and blast through each level to save them all during Sahur time. Smash zombies, dodge traps, and free your friends in this fast-paced slingshot adventure!",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Brainrot",
      "Brainrot Italian",
      "Brainrot sahuuur",
      "Italian Brainrot",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/vwbavd1dr61w3y7h0ha3f5hsphef00vu/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vwbavd1dr61w3y7h0ha3f5hsphef00vu/",
    "sourceUrl": "https://html5.gamemonetize.com/vwbavd1dr61w3y7h0ha3f5hsphef00vu/",
    "width": 1024,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67123",
    "slug": "realistic-monster-truck-offroad-simulator",
    "title": "Realistic Monster Truck Offroad Simulator",
    "description": "Realistic Monster Truck Offroad Simulator delivers an intense offroad experience with high-quality monster truck textures, lifelike trees, and dense grass. Tackle tough terrain and natural obstacles in a beautifully detailed environment designed for ultimate realism and thrilling offroad challenges. Web Dev <a href='https://www.crazygamesunblocked.site/'>https://www.crazygamesunblocked.site/</a>",
    "instructions": "WASD to drive the truck",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Mentolatux",
      "Monster",
      "monstertruck",
      "offroad",
      "realistic",
      "Simulator",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/oyql8cwsas24prq2plynllt9trjs0tga/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/oyql8cwsas24prq2plynllt9trjs0tga/",
    "sourceUrl": "https://html5.gamemonetize.com/oyql8cwsas24prq2plynllt9trjs0tga/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67055",
    "slug": "stunt-sprint",
    "title": "Stunt Sprint",
    "description": "Stunt Sprint Blast off, fly far, and crash through everything! In Stunt Sprint, launch your ride off epic ramps, smash obstacles, and soar through dynamic 3D worlds. The farther you fly, the higher you score! Customize your car with stylish decals, unlock crazy vehicles, and upgrade speed, power, and control to master every sprint. Simple to play, addictively fun! Features: One-tap stunt gameplay Custom decals &amp; car skins Vehicle upgrades &amp; unlocks Explosive physics &amp; destruction Beautiful 3D stunt environments",
    "instructions": "Hold to launch your car",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Car",
      "car tuning",
      "Cars",
      "crash",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/6wehfwvhqz38sko3kanj7a5btwrrtk6n/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6wehfwvhqz38sko3kanj7a5btwrrtk6n/",
    "sourceUrl": "https://html5.gamemonetize.com/6wehfwvhqz38sko3kanj7a5btwrrtk6n/",
    "width": 690,
    "height": 900,
    "lastUpdated": ""
  },
  {
    "id": "60742",
    "slug": "sort-new-year",
    "title": "Sort New Year!",
    "description": "Collect three identical items so that they connect! Slow, interesting and easy gameplay will allow you to relax , and a pleasant atmosphere will add a grain of magic! The game has a lot of items and an infinite number of levels! Which one can you reach?",
    "instructions": "1 At first it will be easy to connect the items but over time there will be more and more of them 2 Press and hold your finger or mouse to control the matryoshka Release your finger or mouse button to move the matryoshka doll to the shelf 3 Compete",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "2048",
      "2D",
      "Android",
      "Best"
    ],
    "thumbnail": "https://img.gamemonetize.com/7159t7yly2mi03sz0gfm1cujzf9k05u0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/7159t7yly2mi03sz0gfm1cujzf9k05u0/",
    "sourceUrl": "https://html5.gamemonetize.com/7159t7yly2mi03sz0gfm1cujzf9k05u0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "58874",
    "slug": "magical-cat-castle",
    "title": "Magical Cat Castle",
    "description": "This is a decorating simulation game for girls. Have you ever wondered what happens in a castle full of cats? Maybe one day you can build a castle for cats yourself. If you are curious about this, our game can satisfy your curiosity.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Castle",
      "Cat",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/awdo6pl3bl880gha2thc7rw2o7h29ja2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/awdo6pl3bl880gha2thc7rw2o7h29ja2/",
    "sourceUrl": "https://html5.gamemonetize.com/awdo6pl3bl880gha2thc7rw2o7h29ja2/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "16115",
    "slug": "city-plumber",
    "title": "City Plumber",
    "description": "You like manual work and you’re not afraid to dirty your hands while on the job? Then come change lead into gold and earn a lot of cash through ludicrously high bills in this new plumber game. The piping of New York is on the verge of destruction and everybody is soon going to call for a good plumber. Don’t bum around and go equipped with your toolbox to take part to this gigantic work site.",
    "instructions": "You like manual work and you re not afraid to dirty your hands while on the job Then come change lead into gold and earn a lot of cash through ludicrously high bills in this new plumber game The piping of New York is on the verge of destruction and ever",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "city",
      "Classic",
      "Fish",
      "Fishing",
      "Fun",
      "Funny",
      "Kid",
      "Kids",
      "Math",
      "Pixel",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/3o0sfpaj8jbnxdotbci4vdmu9e73sl1w/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3o0sfpaj8jbnxdotbci4vdmu9e73sl1w/",
    "sourceUrl": "https://html5.gamemonetize.com/3o0sfpaj8jbnxdotbci4vdmu9e73sl1w/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66359",
    "slug": "chicken-jockey-hidden-lava-chicken",
    "title": "Chicken Jockey hidden lava chicken",
    "description": "Chicken Jockey: Hidden Lava Chicken is a fiery visual challenge where sharp eyes and quick clicks are your only weapons. Dive into a chaotic Minecraft-inspired world filled with mobs, motion, and molten surprises as you search for 10 hidden Lava Chickens in every stage!",
    "instructions": "mouse only",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Air",
      "airplane",
      "Alien",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/jr7f76hwsqbmkhp952da212wb0p8oa9q/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jr7f76hwsqbmkhp952da212wb0p8oa9q/",
    "sourceUrl": "https://html5.gamemonetize.com/jr7f76hwsqbmkhp952da212wb0p8oa9q/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66229",
    "slug": "meme-survivors-backrooms",
    "title": "Meme Survivors: Backrooms",
    "description": "How long can YOU survive in the Backrooms? Meme Survivors: Backrooms is a casual game with a vibrant visual style and light roguelite elements. It throws you into the mysterious and endless corridors of the Backrooms, filled with characters and enemies inspired by the most iconic internet memes.",
    "instructions": "Play however you like Use keyboard WASD or arrows mouse touchscreen or even a gamepad mdash controls work everywhere All you need to do is move mdash attacks happen automatically Just dodge enemies collect upgrades and survive as long as you",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Android",
      "Arcade",
      "Boys",
      "Casual",
      "Funny",
      "Girls",
      "Pixel",
      "Shooting",
      "unity games",
      "unity games for your site",
      "unity games for your website"
    ],
    "thumbnail": "https://img.gamemonetize.com/lsgjtn2qs72zyeomar2xwtnixmjddq1d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lsgjtn2qs72zyeomar2xwtnixmjddq1d/",
    "sourceUrl": "https://html5.gamemonetize.com/lsgjtn2qs72zyeomar2xwtnixmjddq1d/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66889",
    "slug": "prankster-cat-simulator-fun",
    "title": "Prankster Cat Simulator Fun",
    "description": "Experience the thrilling life of a Prankster Cat in Life of a Prankster Cat: Simulator Fun! Become the most mischievous feline around, pulling off pranks and tricks that will leave your human family members laughing. With intuitive controls and exciting levels, this game brings all the fun of being a cat into a realistic, interactive environment. Whether you&rsquo;re knocking over vases or setting traps, there&rsquo;s always something hilarious to do!",
    "instructions": "Touch Pad or Mouse click Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "2 Player",
      "Casual",
      "Cat",
      "Hypercasual",
      "Simulation",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/r90row1hn891fy1ikxkqhqn5j6gylvmi/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r90row1hn891fy1ikxkqhqn5j6gylvmi/",
    "sourceUrl": "https://html5.gamemonetize.com/r90row1hn891fy1ikxkqhqn5j6gylvmi/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67106",
    "slug": "brain-test-iq-challenge-2",
    "title": "Brain Test IQ Challenge 2",
    "description": "Ready for the wonderful challenge of your brain power? Brain Test IQ Challenge 2 is here! This is a brainstorming puzzle game that combines drawing, jumping, multiplayer battle, maze escape and other ways to play. Activate your brain in a second! In draw master, underlining guides the character into the correct restroom.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Drawing",
      "Jumping"
    ],
    "thumbnail": "https://img.gamemonetize.com/vyh3jfuu64ey5cdaxskfsoc5a28z6yc0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/vyh3jfuu64ey5cdaxskfsoc5a28z6yc0/",
    "sourceUrl": "https://html5.gamemonetize.com/vyh3jfuu64ey5cdaxskfsoc5a28z6yc0/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "67105",
    "slug": "dream-mania-happy-match",
    "title": "Dream Mania Happy Match",
    "description": "Ready to begin a fantastic match-3 puzzle adventure? Dream Mania - Happy Match is a fun puzzle game that you wont be able to stop playing. Its easy to play, yet the challenging level design. Its a casual game you dont want to miss! Match 3 or more identical items to clear the board and hit your level goals.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fantasy",
      "Fun",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/510g06dcndhuy8sj6whcvlobcfwintlq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/510g06dcndhuy8sj6whcvlobcfwintlq/",
    "sourceUrl": "https://html5.gamemonetize.com/510g06dcndhuy8sj6whcvlobcfwintlq/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "67102",
    "slug": "sailor-chic-vs-pirate-charm",
    "title": "Sailor Chic vs Pirate Charm",
    "description": "Welcome to the trendy sea adventure! Two charming heroines are waiting for you in this game.: the humble little mermaid Amelie and the brave pirate princess Jacqueline. Amelie is the epitome of maritime glamour. Her style is white dresses, gold jewelry and wind in her hair. Jacqueline is the real pirate queen. She wears leather jackets, spectacular corsets and accessories with pirate symbols. Each heroine has her own story and her own path: refined sea romance against wild pirate charm. Play, combine styles and unlock new features. Who will win in this fashionable battle - a sophisticated beauty or a daring sea robber? The choice is yours!",
    "instructions": "Depending on the gaming device either a click of a computer mouse or a simple touch on touchscreens is used to control it",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Pirate",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/hq54zop5rfprmzpl976kt0ldqr2ikkao/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hq54zop5rfprmzpl976kt0ldqr2ikkao/",
    "sourceUrl": "https://html5.gamemonetize.com/hq54zop5rfprmzpl976kt0ldqr2ikkao/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64474",
    "slug": "mad-car-drive-future-racing",
    "title": "Mad Car Drive Future Racing",
    "description": "Mad Race Future Cars is an adrenaline-pumping racing game set in a futuristic world. Players control high-tech vehicles, navigating through challenging tracks filled with obstacles, ramps, and sharp turns. Featuring fast-paced action, stunning visuals, and customizable cars, it offers a thrilling, competitive experience for racing enthusiasts. Web Dev <a href='https://unblockedgames76x.com/'>https://unblockedgames76x.com/</a>",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Car",
      "Driving",
      "Mentolatux",
      "Racing",
      "Supercars",
      "unity",
      "vehicle",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/by7xqtmizsrctwklvb5kkxc797ho45v0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/by7xqtmizsrctwklvb5kkxc797ho45v0/",
    "sourceUrl": "https://html5.gamemonetize.com/by7xqtmizsrctwklvb5kkxc797ho45v0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66627",
    "slug": "stephigh",
    "title": "StepHigh",
    "description": "The control character keeps jumping up. The platform will drop regularly, jump to the platform above before the platform falls, and you will get gold during the jump, gold can unlock new characters, come and see how many platforms you can jump.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/4rzdnu6k4t5q492brkzlo4j7zq2tgg9y/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4rzdnu6k4t5q492brkzlo4j7zq2tgg9y/",
    "sourceUrl": "https://html5.gamemonetize.com/4rzdnu6k4t5q492brkzlo4j7zq2tgg9y/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66836",
    "slug": "animal-explorer-puzzle-game",
    "title": "Animal Explorer Puzzle game",
    "description": "Welcome to the enchanting world of Animal Explorer&mdash;a captivating game designed for young adventurers and budding puzzle masters! In this delightful journey, kids embark on a thrilling quest to piece together vibrant jigsaw puzzles featuring their favorite animals. Immerse yourself in the magical landscapes of the animal kingdom as you assemble adorable puzzles with cuddly kittens, playful puppies, majestic elephants, and more! Each puzzle is a doorway to a new and exciting realm, encouraging kids to explore the diversity of wildlife.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Animal",
      "Baby Games",
      "Best Games",
      "Boy",
      "Boys",
      "Girls",
      "Jigsaw",
      "Kid",
      "Kids",
      "Puzzle",
      "puzzleblock",
      "Science"
    ],
    "thumbnail": "https://img.gamemonetize.com/bbnhvcejl2u7ge2cpk74rm0wydymp0fj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bbnhvcejl2u7ge2cpk74rm0wydymp0fj/",
    "sourceUrl": "https://html5.gamemonetize.com/bbnhvcejl2u7ge2cpk74rm0wydymp0fj/",
    "width": 1366,
    "height": 768,
    "lastUpdated": ""
  },
  {
    "id": "66887",
    "slug": "chicken-jockey-red-light-green-light",
    "title": "Chicken Jockey: Red Light Green Light",
    "description": "Chicken Jockey: Red Light Green Light is a thrilling and hilarious mobile game that fuses Minecraft-inspired visuals with a Squid Game-style survival challenge. In this unique twist, you control the iconic Chicken Jockey &mdash; a tiny zombie riding a brave little chicken &mdash; as he competes in the high-stakes playground game: &ldquo;Red Light, Green Light.&rdquo; This is not just about running. It&rsquo;s about perfect timing, razor-sharp reflexes, and a little bit of chaos.",
    "instructions": "mouse only",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Maze",
      "mineblock",
      "Minecraft",
      "Miner",
      "Minion",
      "Monster",
      "mountain"
    ],
    "thumbnail": "https://img.gamemonetize.com/n7qq4gnwye3r244ylkwl5p8l02egyfjv/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n7qq4gnwye3r244ylkwl5p8l02egyfjv/",
    "sourceUrl": "https://html5.gamemonetize.com/n7qq4gnwye3r244ylkwl5p8l02egyfjv/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65565",
    "slug": "mallow-pop",
    "title": "Mallow Pop",
    "description": "Pop your way through a candy-filled world in Mallow Pop! Aim, shoot, and match marshmallows of the same color to clear the board and score big. Designed for high player retention and ideal ad monetization, this bubble shooter game combines smooth gameplay with vibrant visuals that keep players engaged.",
    "instructions": "Desktop click on the left button of the mouse anywhere on the screen to launch the marshmallow onto the rotating donut at just the right color Mobile click anywhere on the screen to launch the marshmallow onto the rotating donut at just the right color",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "Clicker",
      "HTML",
      "html5 games",
      "Hypercasual",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/lsk26gcm9ysv9xavfsv0pauyapp8w65x/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lsk26gcm9ysv9xavfsv0pauyapp8w65x/",
    "sourceUrl": "https://html5.gamemonetize.com/lsk26gcm9ysv9xavfsv0pauyapp8w65x/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67087",
    "slug": "tung-sahur-coloring",
    "title": "Tung Sahur Coloring",
    "description": "Tung Sahur Coloring is a colorful joyride just waiting to happen! This super fun coloring game for kids turns every blank page into a chance to sparkle with creativity. Grab your virtual crayons and get ready to dive into the world of Tung Sahur, where imagination runs wild and colors know no rules. From cheerful characters to wacky shapes, each page is your personal canvas. Fill it with the wildest colors you can think of&mdash;green suns, purple trees, rainbow hats&mdash;anything goes here!",
    "instructions": "Mouse to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Coloring",
      "Educational",
      "Girl",
      "Hypercasual",
      "Kids",
      "School",
      "Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/h9e5os8iqg8sirxxbsz1izdz2qe8aiph/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h9e5os8iqg8sirxxbsz1izdz2qe8aiph/",
    "sourceUrl": "https://html5.gamemonetize.com/h9e5os8iqg8sirxxbsz1izdz2qe8aiph/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "67108",
    "slug": "water-pour-jam",
    "title": "Water Pour Jam",
    "description": "Ready to push your brain to the limit? Welcome to Water Pour Jam, the fun sort puzzle game that will test your brain and matching skills. Here you will be confronted with colorful cups. Use your logic and observation to pour liquids of the same color into the same bottle so that the colors match perfectly! Get the juice right.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "Color",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/622ycl50ah4ys2topd20e1f7jaw3zh4d/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/622ycl50ah4ys2topd20e1f7jaw3zh4d/",
    "sourceUrl": "https://html5.gamemonetize.com/622ycl50ah4ys2topd20e1f7jaw3zh4d/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "66632",
    "slug": "boomrocket",
    "title": "BoomRocket",
    "description": "Control the plane upward sprint. Seize the moment, touch the screen, and the plane sprints a certain distance in the direction of the nose, avoiding the obstacle. Shield items can be obtained in the game, and shields can prevent all damage. Come and play.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "Best Games",
      "Plane"
    ],
    "thumbnail": "https://img.gamemonetize.com/0pji14ijmlrhpfiu1bol6c5b05x04t7a/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0pji14ijmlrhpfiu1bol6c5b05x04t7a/",
    "sourceUrl": "https://html5.gamemonetize.com/0pji14ijmlrhpfiu1bol6c5b05x04t7a/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67071",
    "slug": "little-dentist-for-kid",
    "title": "Little Dentist For Kid",
    "description": "Welcome to Little Dentist, the fun and educational game where kids become real dentists! Help your adorable patients by cleaning teeth, fighting cavities, removing plaque, and even adding colorful braces. With friendly characters, silly tools, and cheerful music, children will learn the importance of dental hygiene while having tons of fun.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Doctor",
      "Family",
      "Kid",
      "Kids",
      "mapi games"
    ],
    "thumbnail": "https://img.gamemonetize.com/ynortnp159708cfngdw020e21mz7y8gk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ynortnp159708cfngdw020e21mz7y8gk/",
    "sourceUrl": "https://html5.gamemonetize.com/ynortnp159708cfngdw020e21mz7y8gk/",
    "width": 768,
    "height": 1024,
    "lastUpdated": ""
  },
  {
    "id": "67041",
    "slug": "sprunki-final-adventure",
    "title": "Sprunki Final Adventure",
    "description": "Enjoy the Sprunki World with this final adventure game. Immerse yourself in the beats and music simulation, create the band and songs, and discover the dark secrets of your favorite characters. Enjoy the good and evil world, edit your tracks and experiment with different game modes and characters types to complete this awesome adventure.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Adventure",
      "amazing",
      "Arcade",
      "Brainrot Italian",
      "Casual",
      "html5 games for your site",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/pi59ob2e68whmfav5unp04fvph7m2dtq/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/pi59ob2e68whmfav5unp04fvph7m2dtq/",
    "sourceUrl": "https://html5.gamemonetize.com/pi59ob2e68whmfav5unp04fvph7m2dtq/",
    "width": 800,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "67075",
    "slug": "squishy-slime-maker",
    "title": "Squishy Slime Maker",
    "description": "Welcome to Squishy Slime Maker, a casual slime simulator game. If you are full of magical ideas or distinctive imagination, this is the right place for you. Mix the magic ingredients, choose your favorite colors, and have fun touching cute and slimy squishy! Unleash your inner artist to design the beautiful and lovely slimy squishy you want.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Coloring",
      "Magic",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/3o8zzkf9cyvgrqnxrp7mb6iydxca9c8r/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/3o8zzkf9cyvgrqnxrp7mb6iydxca9c8r/",
    "sourceUrl": "https://html5.gamemonetize.com/3o8zzkf9cyvgrqnxrp7mb6iydxca9c8r/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "64775",
    "slug": "impossible-cargo-truck-driver-2025",
    "title": "Impossible Cargo Truck Driver 2025",
    "description": "Impossible Cargo Truck Driver 2025 is a thrilling driving simulator that challenges you to transport heavy cargo across extreme, treacherous terrains. Test your skills on narrow mountain roads, sky-high bridges, and obstacle-filled paths. Web Dev <a href='https://www.kizigamesx.com/'>https://www.kizigamesx.com/</a> +",
    "instructions": "WASD to drive the truck",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "cargo",
      "Driving",
      "Mentolatux",
      "transport",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/u5vex6uy1w2tnblog2e9ft1jdc1cjvol/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/u5vex6uy1w2tnblog2e9ft1jdc1cjvol/",
    "sourceUrl": "https://html5.gamemonetize.com/u5vex6uy1w2tnblog2e9ft1jdc1cjvol/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64993",
    "slug": "fire-ring",
    "title": "Fire Ring",
    "description": "Fire Ring is a fast-paced, fiery challenge that will test your timing and reflexes! Guide your blazing orb through rotating rings, shifting gaps, and fiery obstacles in a game where one wrong move means game over. Tap to jump through openings, avoid the flames, and climb your way to the highest score. With vibrant visuals, smooth animations, and addictive one-touch gameplay, Fire Ring is perfect for quick play sessions or endless challenges. Unlock new fiery effects, beat your best score, and conquer the heat. Can you survive the burn and master the ring? Let the flame begin!",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Arcade",
      "Ball",
      "Best",
      "Best Games",
      "Click",
      "Escape",
      "Fire",
      "firefighters",
      "Point And Click",
      "Puzzle",
      "Shooting",
      "Space"
    ],
    "thumbnail": "https://img.gamemonetize.com/lqw68u7gzk1pn7dpst8a08ta9rhai7k1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lqw68u7gzk1pn7dpst8a08ta9rhai7k1/",
    "sourceUrl": "https://html5.gamemonetize.com/lqw68u7gzk1pn7dpst8a08ta9rhai7k1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64696",
    "slug": "my-memory-boost",
    "title": "My Memory Boost",
    "description": "My Memory Boost is a fun and brain-training card-matching game designed to test and improve your memory skills! Flip the cards, remember their positions, and match pairs of the same numbers before time runs out. The faster you match, the higher your score! With multiple difficulty levels, engaging challenges, and a sleek design, My Memory Boost is perfect for players of all ages looking to sharpen their minds. Can you remember all the right pairs and achieve the highest score? Play now and give your brain the ultimate boost!",
    "instructions": "Tap on card and match",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Math",
      "Memory"
    ],
    "thumbnail": "https://img.gamemonetize.com/ui49kbpjgcgh4ihlnydj81sk45iv7j1e/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ui49kbpjgcgh4ihlnydj81sk45iv7j1e/",
    "sourceUrl": "https://html5.gamemonetize.com/ui49kbpjgcgh4ihlnydj81sk45iv7j1e/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65935",
    "slug": "uno-party-card",
    "title": "Uno Party Card",
    "description": "Want a fun card battle with friends? Uno-Party Card brings the classic UNO card game to your screen. Allow you to challenge opponents from around the world anytime, anywhere. Its a multiplayer card game, where everyone has to use the cards in their hand as well as find the best strategy in an unpredictable situation.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Card",
      "Classic",
      "Multiplayer"
    ],
    "thumbnail": "https://img.gamemonetize.com/tee4g02928vevs4fyc6qi7g55kh657m8/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tee4g02928vevs4fyc6qi7g55kh657m8/",
    "sourceUrl": "https://html5.gamemonetize.com/tee4g02928vevs4fyc6qi7g55kh657m8/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "66901",
    "slug": "tung-tung-tung-sahur-who-is",
    "title": "Tung Tung Tung Sahur Who Is?",
    "description": "Tung Tung Tung Sahur Who Is? is a surreal, meme-fueled quiz game that tests not your knowledge &mdash; but your ability to navigate nonsense logic and meme chaos. Built with no sound, this text-based experience uses expressive visuals, glitched fonts, and absurd humor to deliver the ultimate brainrot challenge.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Brainrot",
      "Italian Brainrot",
      "Tung",
      "Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/jmbtu0nkxitxjsq9ihsp641h9di5dku0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/jmbtu0nkxitxjsq9ihsp641h9di5dku0/",
    "sourceUrl": "https://html5.gamemonetize.com/jmbtu0nkxitxjsq9ihsp641h9di5dku0/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67015",
    "slug": "shell-swap-pro",
    "title": "Shell Swap Pro",
    "description": "Shell Swap Match. Swap. Splash into fun! Dive into a relaxing underwater adventure in Shell Swap, the ultimate sea-themed match-3 puzzle game! Swap colorful sea shells, pearls, and starfish to create powerful combos and clear the board. With soothing ocean vibes and satisfying gameplay, every level is a splash of fun! Whether youre a casual puzzler or a matching master, Shell Swap is your perfect escape beneath the waves.",
    "instructions": "Match-3 and clear the required items",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "Fishing",
      "Match-3"
    ],
    "thumbnail": "https://img.gamemonetize.com/kzrf9dx7zolud55vm1irqmqfwed1831c/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kzrf9dx7zolud55vm1irqmqfwed1831c/",
    "sourceUrl": "https://html5.gamemonetize.com/kzrf9dx7zolud55vm1irqmqfwed1831c/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "67020",
    "slug": "collect-and-break",
    "title": "Collect And Break",
    "description": "Dive into a adventure in Collect And Break which is running game! In this fun arcade game keep collecting coin and food(get energy to break the walls) . You need to be flexible , making sure to collect as coin and food as possible during the run.",
    "instructions": "Mouse click or tap to play Use Mouse left click Drag to move player left right",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Mouse",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/bmzifa3ps1halac7g1qu9bxyqn17nxm5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bmzifa3ps1halac7g1qu9bxyqn17nxm5/",
    "sourceUrl": "https://html5.gamemonetize.com/bmzifa3ps1halac7g1qu9bxyqn17nxm5/",
    "width": 450,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65689",
    "slug": "idle-bathroom-empire-tycoon",
    "title": "Idle Bathroom Empire Tycoon",
    "description": "Ready to become the ultimate bathroom tycoon? In this exciting mix of simulation, management, and idle tycoon gameplay, you&rsquo;ll start with a small restroom. Grow it into a luxurious five-star hygiene haven! Upgrade facilities, optimize services, and expand your empire to make your bathroom the most popular spot in town. Manage your front desk with care, and faster cashiering will give you more cash flow.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Fun",
      "idle",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/iwebmom4m4nlng0sf9mi7owi55p39cl9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/iwebmom4m4nlng0sf9mi7owi55p39cl9/",
    "sourceUrl": "https://html5.gamemonetize.com/iwebmom4m4nlng0sf9mi7owi55p39cl9/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "65968",
    "slug": "my-purrfect-cat-hotel",
    "title": "My Purrfect Cat Hotel",
    "description": "Welcome to My Purrfect Cat Hotel, a super cute cat hotel simulation management game. Enjoy cute and vivid cartoon cat animations. This is the vacation spot for all meow stars, and your mission is to create the most cozy cat hotel. Serving a variety of adorable cats and catering to their needs. Make your hotel the most popular animal tycoon hotel.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Cat",
      "Cute",
      "Fun",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/p1kzm09seq85pi8vz57nog7fr7sit4b1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p1kzm09seq85pi8vz57nog7fr7sit4b1/",
    "sourceUrl": "https://html5.gamemonetize.com/p1kzm09seq85pi8vz57nog7fr7sit4b1/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "66642",
    "slug": "classify",
    "title": "Classify",
    "description": "Sort the candy as instructed. In the game, the candy will enter the classifier, and the candy category will appear on both sides of the classifier, and the candy will be classified according to the category through the classifier switch. Come on and see how many points you can get.",
    "instructions": "Mouse click or tap to play",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "Arcade",
      "Ball",
      "Best Games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/ep91f5duzfn2n5ogsquz79e7hpoek8ws/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ep91f5duzfn2n5ogsquz79e7hpoek8ws/",
    "sourceUrl": "https://html5.gamemonetize.com/ep91f5duzfn2n5ogsquz79e7hpoek8ws/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66833",
    "slug": "glorious-kingdom",
    "title": "Glorious Kingdom",
    "description": "A tactical simulation game where you defeat attacking enemies. You can hire soldiers with the gold you obtain by defeating enemies. Your score is calculated based on the gold you have and the number of turns you have when you clear the 5th stage. Saving is done at the start of each stage.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Casual",
      "Classic",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/e002m1cqnqvt0ahe8u3635lpj231dkaa/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/e002m1cqnqvt0ahe8u3635lpj231dkaa/",
    "sourceUrl": "https://html5.gamemonetize.com/e002m1cqnqvt0ahe8u3635lpj231dkaa/",
    "width": 640,
    "height": 480,
    "lastUpdated": ""
  },
  {
    "id": "66641",
    "slug": "long-trailer-truck-transport-sim",
    "title": "Long Trailer Truck Transport Sim",
    "description": "Long Trailer Truck Transport Sim puts you behind the wheel of powerful long-haul trucks, challenging you to deliver oversized cargo across vast highways and rugged landscapes. Navigate tight corners, manage realistic physics, and overcome dynamic weather conditions. Web Dev <a href='https://www.y8gamesx.com/'>https://www.y8gamesx.com/</a>",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Driving",
      "Mentolatux",
      "Sim",
      "Simulator",
      "transport",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/4ljuamwizz9hqo932u4zv7zrbpqlklyr/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4ljuamwizz9hqo932u4zv7zrbpqlklyr/",
    "sourceUrl": "https://html5.gamemonetize.com/4ljuamwizz9hqo932u4zv7zrbpqlklyr/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65595",
    "slug": "pair-up-shapes",
    "title": "Pair Up Shapes",
    "description": "ntroduce your kids to shapes in a playful way with Shapes! This educational game is perfect for young children to learn basic geometric shapes by matching and identifying them on screen. It&rsquo;s designed with vibrant colors, friendly animations, and simple tap controls to keep kids engaged while learning. A great tool for early childhood development and pre-school fun!",
    "instructions": "Controls Tap on the matching shape using touch Mobile or left button of the mouse to drag element PC",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Baby Games",
      "Educational",
      "Fun",
      "HTML",
      "HTML5",
      "html5 games",
      "Kids",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/y1r8bvweef8hd1vgjakfot9kc1vl66lj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/y1r8bvweef8hd1vgjakfot9kc1vl66lj/",
    "sourceUrl": "https://html5.gamemonetize.com/y1r8bvweef8hd1vgjakfot9kc1vl66lj/",
    "width": 1920,
    "height": 1080,
    "lastUpdated": ""
  },
  {
    "id": "67010",
    "slug": "italian-brainrot-tung-tung-sahur-anomaly",
    "title": "Italian Brainrot Tung Tung Sahur Anomaly",
    "description": "Italian Brainrot Tung Tung Sahur Anomaly offers a whimsical twist on the classic spot the difference challenge. Dive into peculiar Italian-themed artworks featuring quirky characters and search for five hidden differences in each illustration. The game delivers unpredictable chaos and meme-inspired humor that continuously engages and surprises players throughout their journey.",
    "instructions": "mouse only",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brainrot",
      "Chicken",
      "Italian Brainrot",
      "Minecraft",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/ip30a04rfm7785u7pjhcgz5nnwtths9s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ip30a04rfm7785u7pjhcgz5nnwtths9s/",
    "sourceUrl": "https://html5.gamemonetize.com/ip30a04rfm7785u7pjhcgz5nnwtths9s/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66290",
    "slug": "quiz-find-the-italian-brainrot-letters",
    "title": "Quiz Find the Italian brainrot Letters",
    "description": "Quiz Italian Brainrot: Hidden Letter is a hilarious and easy-to-play word game where chaos meets challenge! Dive into a collection of absurd and iconic Italian brainrot memes &mdash; but theres a twist. Each image hides letters, sneakily blended into the madness. Your goal? Spot every hidden letter and piece them together to form the correct word.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Brain",
      "digital circus",
      "Quiz"
    ],
    "thumbnail": "https://img.gamemonetize.com/j7a7jmc8ndhmva7a65i9olwz65m8r07s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/j7a7jmc8ndhmva7a65i9olwz65m8r07s/",
    "sourceUrl": "https://html5.gamemonetize.com/j7a7jmc8ndhmva7a65i9olwz65m8r07s/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66022",
    "slug": "cook-it-3d",
    "title": "Cook it 3D",
    "description": "Dive into the colorful and exciting world of match-3! Collect juicy ingredients on a plate to cook unique recipes and surprise everyone with delicious masterpieces. Uncover new ingredients, discover even more delicious recipes and become a master of culinary adventures! Ready for a fun and delicious challenge? Then start right now!",
    "instructions": "Combine 3 required ingredients on the plate with your mouse or finger to get points Do not add more than 3 products to the plate",
    "category": "Cooking",
    "genres": [
      "Cooking"
    ],
    "tags": [
      "3D",
      "Cooking",
      "Food",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/w4h80fkwq0ipv6u699rm3mwr6wcfjpqx/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/w4h80fkwq0ipv6u699rm3mwr6wcfjpqx/",
    "sourceUrl": "https://html5.gamemonetize.com/w4h80fkwq0ipv6u699rm3mwr6wcfjpqx/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65124",
    "slug": "bitcoin-crypto-tycoon",
    "title": "Bitcoin Crypto Tycoon",
    "description": "Bitcoin Crypto Tycoon is an exciting coin-collecting game where digital riches rain from above! Move your platform strategically to catch as many falling crypto-coins as possible and build your fortune. The more coins you collect, the closer you get to becoming the ultimate crypto tycoon! With fast-paced gameplay, dynamic challenges, and addictive action, Bitcoin Crypto Tycoon tests your reflexes and precision. Can you catch them all and claim the top spot on the leaderboard? Play now and start stacking your virtual wealth!",
    "instructions": "Click n click you win when multiply factor changes",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Best Games",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/ynkb6r6vdbuc5j2u6mx622uxorvuwccy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ynkb6r6vdbuc5j2u6mx622uxorvuwccy/",
    "sourceUrl": "https://html5.gamemonetize.com/ynkb6r6vdbuc5j2u6mx622uxorvuwccy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65234",
    "slug": "icicle-run",
    "title": "Icicle Run",
    "description": "Slide. Shift. Survive. In Icicle Run, you&rsquo;re a slick little penguin dashing through a frozen gauntlet of danger! Tap to instantly flip between the icy floor and the snowy ceiling &mdash; and dodge deadly icicles, frozen spikes, and all kinds of chilly traps. Timing is everything. One wrong shift and it&rsquo;s game over. Simple to play, tough to master, and endlessly addictive!",
    "instructions": "Click to switch direction and never collide",
    "category": "Clicker",
    "genres": [
      "Clicker"
    ],
    "tags": [
      "Casual",
      "Click",
      "Penguin",
      "sky"
    ],
    "thumbnail": "https://img.gamemonetize.com/qzx6zsjerkd3t8c55jwzx5hy7gcl9kjm/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/qzx6zsjerkd3t8c55jwzx5hy7gcl9kjm/",
    "sourceUrl": "https://html5.gamemonetize.com/qzx6zsjerkd3t8c55jwzx5hy7gcl9kjm/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65889",
    "slug": "doges-battle-royale",
    "title": "Doges Battle Royale",
    "description": "Want to join the most hilarious and action-packed survival shooting game ever? In Doges Battle Royale, you take control of the legendary Doge. Battle on a battlefield full of guns, weapons, and crazy opponents. Defeat enemies and pick up their items. Strategize your moves, and shoot with precision to outlast your enemies in this intense Battle Royale challenge.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Battle",
      "Fun",
      "Shoot",
      "survival"
    ],
    "thumbnail": "https://img.gamemonetize.com/xoizh6if2cufeb2hyt7wswprisj25o4h/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/xoizh6if2cufeb2hyt7wswprisj25o4h/",
    "sourceUrl": "https://html5.gamemonetize.com/xoizh6if2cufeb2hyt7wswprisj25o4h/",
    "width": 1560,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66940",
    "slug": "military-vehicle-driving-simulation",
    "title": "Military Vehicle Driving Simulation",
    "description": "Military Vehicle Driving Simulation immerses you in high-stakes missions behind the wheel of armored trucks, tanks, and tactical vehicles. Navigate harsh terrains, combat zones, and strategic routes with precision and skill. Web Dev <a href='https://www.unblockedgamespot.com/'>https://www.unblockedgamespot.com/</a>",
    "instructions": "Use WASD to drive the vehicle",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Action",
      "Cars",
      "Driving",
      "Mentolatux",
      "military",
      "Supercars",
      "Truck",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/ko9f4fjkf5yghqs0xg6luz1w58pffaa1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ko9f4fjkf5yghqs0xg6luz1w58pffaa1/",
    "sourceUrl": "https://html5.gamemonetize.com/ko9f4fjkf5yghqs0xg6luz1w58pffaa1/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65263",
    "slug": "pirate-treasure-island",
    "title": "Pirate Treasure Island",
    "description": "Pirate Treasure Island sets sail on an epic adventure across the high seas! Join a daring pirate crew in search of hidden riches buried deep within mysterious islands. Solve tricky puzzles, dodge traps, and battle rival pirates as you navigate lush jungles, cursed caves, and ancient ruins. Collect gold, unlock secret maps, and upgrade your ship to explore uncharted waters. With colorful graphics, thrilling gameplay, and exciting surprises at every turn, this treasure hunt never gets old. Are you ready to uncover the secrets of the island and claim the legendary loot? The voyage begins now in Pirate Treasure Island!",
    "instructions": "Use Touch Screen Or keyboard arrow key of mouse to play game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Pirate",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/tyzkj3xbbe3a440rsjg54nwv86bxkjmj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/tyzkj3xbbe3a440rsjg54nwv86bxkjmj/",
    "sourceUrl": "https://html5.gamemonetize.com/tyzkj3xbbe3a440rsjg54nwv86bxkjmj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65971",
    "slug": "mini-games-calm-and-puzzle",
    "title": "Mini Games Calm And Puzzle",
    "description": "Love relaxing yet tricky games? Then you definitely cant miss Mini Games: Calm And Puzzle. A fantastic collection of fun and creative minigames. This is the perfect balance of casual relaxation and exciting puzzle challenges. The game offers 8 types of minigames. Some are super relaxing and easy to enjoy, while others are challenging and will test your brainpower.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Draw",
      "Funny",
      "Relaxation"
    ],
    "thumbnail": "https://img.gamemonetize.com/0214qop28koqriu3rkkkziyr5053gxyj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0214qop28koqriu3rkkkziyr5053gxyj/",
    "sourceUrl": "https://html5.gamemonetize.com/0214qop28koqriu3rkkkziyr5053gxyj/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "66370",
    "slug": "summer-beach-girlz",
    "title": "Summer Beach Girlz",
    "description": "Missing summer? Join us and come dress up for a day and head over to the beach in some of the cutest swimwear out there now. You will for sure feel like you are on a beautiful beach vacation. Benefits of Playing Summer Beach Girlz: Boosts creativity, strategy, and quick thinking.No downloads or installations required&mdash;just play online.Ideal for players of all ages looking for engaging entertainment.Accessible from any device with an internet connection.",
    "instructions": "Mouse click or tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Dress Up",
      "Fashion",
      "Girl",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/kk9bk8adnv6xyly0prmfgulalgl23539/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/kk9bk8adnv6xyly0prmfgulalgl23539/",
    "sourceUrl": "https://html5.gamemonetize.com/kk9bk8adnv6xyly0prmfgulalgl23539/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66872",
    "slug": "lost-puppy-rescue-and-care",
    "title": "Lost Puppy Rescue and Care",
    "description": "Welcome to Lost Puppy Rescue and Care. A small pup is lost in the rain, cold and alone. He&rsquo;s not sure who to trust&mdash;but with your care, that starts to change. Gently clean him up, feed him, and help him feel safe again. This calm, story-like game is all about kindness, connection, and giving one little dog a second chance.",
    "instructions": "Left Mouse Button Click or Tap to play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Animal",
      "Cleaning",
      "Cute",
      "Grooming"
    ],
    "thumbnail": "https://img.gamemonetize.com/bfprmqp63f9l8l7p956xkva5ta6v1buy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/bfprmqp63f9l8l7p956xkva5ta6v1buy/",
    "sourceUrl": "https://html5.gamemonetize.com/bfprmqp63f9l8l7p956xkva5ta6v1buy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65564",
    "slug": "pop-the-balloons",
    "title": "Pop The Balloons",
    "description": "Pop The Balloon is a vibrant, fast-paced arcade game where you tap on rising balloons before they escape the screen. With smooth controls and colorful visuals, this hyper-casual game offers endless fun for players of all ages. Test your reflexes, earn high scores, and enjoy the satisfying pop sounds with every tap! Designed for quick play sessions and perfect for casual gamers. Can you keep up with the pace? Pop as many balloons as you can and climb the leaderboard!",
    "instructions": "PC Use the left button of the mouse to drag the matching pin and pop the balloons Mobile Drag the matching pin and pop the balloons",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Casual",
      "HTML",
      "html5 games",
      "Hypercasual",
      "NapTech Games",
      "Point And Click"
    ],
    "thumbnail": "https://img.gamemonetize.com/ijimpc6meigf9kbug9fxq4079e15yon6/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ijimpc6meigf9kbug9fxq4079e15yon6/",
    "sourceUrl": "https://html5.gamemonetize.com/ijimpc6meigf9kbug9fxq4079e15yon6/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66948",
    "slug": "tomb-escaper",
    "title": "Tomb Escaper",
    "description": "Tomb Escaper is a thrilling puzzle-adventure game where you must escape from a mysterious ancient tomb filled with deadly traps and clever puzzles. Use your logic and agility to overcome obstacles, avoid hazards, and find your way out before it&rsquo;s too late. With increasing difficulty and atmospheric design, each level challenges your brain and reflexes in new ways. Will you escape or be trapped forever?",
    "instructions": "Keyboard Controls",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Adventure",
      "Brain",
      "Escape",
      "Puzzle",
      "tomb"
    ],
    "thumbnail": "https://img.gamemonetize.com/ds2heii3l2c33s49adyu4p7bw38ws8mh/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ds2heii3l2c33s49adyu4p7bw38ws8mh/",
    "sourceUrl": "https://html5.gamemonetize.com/ds2heii3l2c33s49adyu4p7bw38ws8mh/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66953",
    "slug": "birddown",
    "title": "BirdDown",
    "description": "The little bird is on the top platform. Control the bird to fall down onto the platform below. There are many traps on the platform below. Avoid falling into the traps. Come and have a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Adventure",
      "Best Games",
      "Bird",
      "Hypercasual"
    ],
    "thumbnail": "https://img.gamemonetize.com/ojacwhe9hk5306l64ufb8khjwn8jq51s/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ojacwhe9hk5306l64ufb8khjwn8jq51s/",
    "sourceUrl": "https://html5.gamemonetize.com/ojacwhe9hk5306l64ufb8khjwn8jq51s/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66900",
    "slug": "chicken-jockey-deadflip",
    "title": "Chicken Jockey Deadflip",
    "description": "Chicken Jockey Deadflip is a chaotic, high-flying, circus-themed platformer where precision flips, wild stunts, and pixelated mayhem collide! Set in a dazzling arena under the big top, this game puts you in control of the most unlikely duo in Minecraft lore&mdash;a baby zombie riding a fearless chicken. But this time, they&rsquo;re not chasing players&mdash;they&rsquo;re performing death-defying acrobatics to the roar of the crowd.",
    "instructions": "mouse only",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Fish",
      "Fishing",
      "Flight",
      "free html5 games for your website",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/2v30ysa752e9s07flwtrp1yo3v8jpf78/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/2v30ysa752e9s07flwtrp1yo3v8jpf78/",
    "sourceUrl": "https://html5.gamemonetize.com/2v30ysa752e9s07flwtrp1yo3v8jpf78/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65800",
    "slug": "shoguns-reckoning",
    "title": "Shoguns Reckoning",
    "description": "Honor is earned. Survival is demanded. Step into the sandals of a lone samurai, navigating a deadly path in Shoguns Reckoning. Slide left or right to dodge fire traps, spinning saws, and enemy ambushes &mdash; all while collecting sacred fruits and powerful bonuses to restore your strength and honor. Quick reflexes and sharp focus are your only allies in this fast-paced survival run. One wrong move, and your journey ends in dishonor. Features: Intense left-right shifting gameplay with deadly precision Avoid fire pits, saw blades, and ruthless enemies Collect fruits and bonuses to boost your score and stay alive",
    "instructions": "Click to move to other side",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "Clans",
      "Clicker"
    ],
    "thumbnail": "https://img.gamemonetize.com/6nxxtkme0mqj98yxn07qgptlpquxfrhp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/6nxxtkme0mqj98yxn07qgptlpquxfrhp/",
    "sourceUrl": "https://html5.gamemonetize.com/6nxxtkme0mqj98yxn07qgptlpquxfrhp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65802",
    "slug": "lava-chase",
    "title": "Lava Chase",
    "description": "Lava Chase Run fast. Shoot sharp. Outrace the inferno. In Lava Chase, youre in a race for your life &mdash; with a massive, molten fireball rolling right behind you! Blast your way through waves of enemies while dodging obstacles and collecting power-ups. But don&rsquo;t look back &mdash; the lava never stops. Armed and on the run, your reflexes and aim are the only things keeping you from getting scorched. How long can you survive the heat?",
    "instructions": "Click to Fly",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Click",
      "Dragon",
      "Physics"
    ],
    "thumbnail": "https://img.gamemonetize.com/lgcz3vp3nc10wskbziz531wocsr1npq5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/lgcz3vp3nc10wskbziz531wocsr1npq5/",
    "sourceUrl": "https://html5.gamemonetize.com/lgcz3vp3nc10wskbziz531wocsr1npq5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66909",
    "slug": "airport-simulator-plane-tycoon",
    "title": "Airport Simulator Plane Tycoon",
    "description": "Want a fun airport management experience in the Airport Simulator: Plane Tycoon? Youre in charge of your bustling airport! Always dreamed of building and running your international airport? Nows your chance in this exciting and highly addictive management game! You will build your airport kingdom from scratch. Plan runways, schedule flights, upgrade facilities, hire employees, and keep the entire airport running smoothly to handle the passenger flow!",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "airplane",
      "building",
      "Simulation"
    ],
    "thumbnail": "https://img.gamemonetize.com/n9m3edi2dwli9hcvgjol21vln1pza8u0/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/n9m3edi2dwli9hcvgjol21vln1pza8u0/",
    "sourceUrl": "https://html5.gamemonetize.com/n9m3edi2dwli9hcvgjol21vln1pza8u0/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "66888",
    "slug": "chicken-jockey-tung-tung-sahur-fight",
    "title": "Chicken Jockey Tung Tung Sahur Fight",
    "description": "Chicken Jockey: Tung Tung Sahur Fight is an outrageous beat &rsquo;em up game that throws you into the heart of chaotic, side-scrolling street battles &mdash; starring none other than the legendary Chicken Jockey, a baby zombie riding a fearless chicken. Inspired by classic arcade brawlers like Final Fight and Streets of Rage, this game adds a uniquely absurd twist by pitting your undead poultry-powered hero against a horde of brainrotted internet icons and local meme legends.",
    "instructions": "Arrow keys move Z X C attack",
    "category": "Adventure",
    "genres": [
      "Adventure"
    ],
    "tags": [
      "1 Player",
      "2048",
      "mineblock",
      "Minecraft"
    ],
    "thumbnail": "https://img.gamemonetize.com/yqqs9m2b0siqkws56glxhf4erf6097ec/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yqqs9m2b0siqkws56glxhf4erf6097ec/",
    "sourceUrl": "https://html5.gamemonetize.com/yqqs9m2b0siqkws56glxhf4erf6097ec/",
    "width": 960,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66871",
    "slug": "barbee-met-gala-transformation",
    "title": "Barbee Met Gala Transformation",
    "description": "Barbee and her friends have a big night ahead&mdash;the Met Gala! It&rsquo;s your job to help each of them get dressed up and feel amazing. Whether someone&rsquo;s into bold colors or classic glam, you get to style their look from head to toe and make sure they&rsquo;re ready to walk the red carpet.",
    "instructions": "Left Mouse Button Click or Tap to Play",
    "category": "Girls",
    "genres": [
      "Girls"
    ],
    "tags": [
      "Barbie",
      "Cute",
      "Fashion",
      "Girls"
    ],
    "thumbnail": "https://img.gamemonetize.com/t6sixhl4z74ngcl9q1g6v6w8keh4upxy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/t6sixhl4z74ngcl9q1g6v6w8keh4upxy/",
    "sourceUrl": "https://html5.gamemonetize.com/t6sixhl4z74ngcl9q1g6v6w8keh4upxy/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66869",
    "slug": "minerrush",
    "title": "MinerRush",
    "description": "Control the drilling machine to sprint downward. Obstacles and gold mines will randomly appear below. Avoid touching the obstacles. Gold mines can unlock other drilling machines.",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Arcade",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/5dvi3tnj4m1a7o3vf1zr2jd0zhnq4eeb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5dvi3tnj4m1a7o3vf1zr2jd0zhnq4eeb/",
    "sourceUrl": "https://html5.gamemonetize.com/5dvi3tnj4m1a7o3vf1zr2jd0zhnq4eeb/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66002",
    "slug": "high-heel-design",
    "title": "High Heel Design",
    "description": "Imagine you are a fashion shoemaker who produces the best high heels ever. In High Heel Design, you are in charge of fashion shoe design. Yes, what you produce is not sneakers, sandals, or boots, but high heels only! Unleash your creativity and combine elements to realize your own stunning high heels in this shoe-designing game.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Design",
      "Fashion",
      "Stunts"
    ],
    "thumbnail": "https://img.gamemonetize.com/r5edz2u459yqeshu0cf9nlafrjqrf2w1/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/r5edz2u459yqeshu0cf9nlafrjqrf2w1/",
    "sourceUrl": "https://html5.gamemonetize.com/r5edz2u459yqeshu0cf9nlafrjqrf2w1/",
    "width": 750,
    "height": 1334,
    "lastUpdated": ""
  },
  {
    "id": "64453",
    "slug": "cargo-truck-simulator-2025",
    "title": "Cargo Truck simulator 2025",
    "description": "Cargo Truck Simulator 2025 puts you in the driver&rsquo;s seat of a powerful truck. Your mission: drive through challenging roads, pick up a stranded car, and deliver it safely to the destination. Navigate realistic terrain, avoid obstacles, and complete each level with precision. Can you handle the haul? Web Dev <a href='https://www.unblockedgamesunblocked.com'>https://www.unblockedgamesunblocked.com</a>",
    "instructions": "WASD to drive",
    "category": "Action",
    "genres": [
      "Action"
    ],
    "tags": [
      "Driving",
      "Mentolatux",
      "Simulator",
      "Truck",
      "trucks",
      "unity",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/b3wf02pl29r9phmtmpya454sr6dw1hyp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/b3wf02pl29r9phmtmpya454sr6dw1hyp/",
    "sourceUrl": "https://html5.gamemonetize.com/b3wf02pl29r9phmtmpya454sr6dw1hyp/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66881",
    "slug": "flappy-sprunki-adventure",
    "title": "Flappy Sprunki Adventure",
    "description": "Flappy Sprunki Adventure is a super fun flappy game for kids and grown ups. Your goal is to keep Sprunki flying in the air for as long as you can. Watch out though: if you grab a sandwich, Sprunki gets bigger and heavier. That makes flying harder! Eat a salad instead to shrink back down and fly easier. Stay up, flap fast, and have a great time!",
    "instructions": "Mouse to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Avoid",
      "Collecting",
      "fly",
      "Hypercasual",
      "Jumping",
      "Kids",
      "Physics",
      "Skill",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/0cvqp03mlr3qa5md7fpt4u7bt8lg8kfp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0cvqp03mlr3qa5md7fpt4u7bt8lg8kfp/",
    "sourceUrl": "https://html5.gamemonetize.com/0cvqp03mlr3qa5md7fpt4u7bt8lg8kfp/",
    "width": 480,
    "height": 854,
    "lastUpdated": ""
  },
  {
    "id": "64408",
    "slug": "nest-quest",
    "title": "Nest Quest",
    "description": "Embark on a relaxing brain adventure in Nest Quest! Slide blocks to help a lost bird reach its nest. Each level challenges your logic and puzzle-solving skills with smart, minimalistic design and increasingly tricky layouts. With over 40 handcrafted levels, smooth controls, and calm visuals, this game is perfect for both casual and serious players. Whether youre on mobile or desktop, Nest Quest offers a peaceful, satisfying puzzle experience for all ages. Can you guide every bird home?",
    "instructions": "Mobile Tap and drag blocks to slide them in the desired direction Desktop Click on the nest to use your mouse to slide characters on the nest",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Best Games",
      "Casual",
      "HTML",
      "HTML5",
      "html5 games",
      "Hypercasual",
      "jump",
      "Jumping",
      "NapTech Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/ceelmuamb2p59wacua1dumfb7u1e80bk/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/ceelmuamb2p59wacua1dumfb7u1e80bk/",
    "sourceUrl": "https://html5.gamemonetize.com/ceelmuamb2p59wacua1dumfb7u1e80bk/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "66841",
    "slug": "italian-brainrot-spot-the-differences",
    "title": "Italian Brainrot Spot the Differences",
    "description": "In this game you have to locate the differences between the two pictures in the limited amount of time given to play each time! To play, use your mouse as control. Make sure that you don&rsquo;t make a mistake more than three times because that will make you fail. One minute is the total time you will play through the 20 levels in this game! In each level you have seven differences. Good luck!",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Best",
      "Brainrot Italian",
      "Difference",
      "Fun",
      "Funny",
      "Italian Brainrot",
      "Kids",
      "Skill",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/d4nnrrc7ax6uzukkrzqnt3zocwrnn3t2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/d4nnrrc7ax6uzukkrzqnt3zocwrnn3t2/",
    "sourceUrl": "https://html5.gamemonetize.com/d4nnrrc7ax6uzukkrzqnt3zocwrnn3t2/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "66902",
    "slug": "residents-evil-tariff-war",
    "title": "Residents Evil Tariff War",
    "description": "In the shadow of a global tariff war, the world teeters on the edge of collapse. The President has been abducted by a hostile nation and taken to a top-secret bio-lab for unspeakable experiments. You are a former special ops agent sent deep into enemy territory on a high-stakes rescue mission. Navigate a maze of infected corridors, solve deadly puzzles, and face off against horrific bio-engineered monsters in this third-person shooter survival adventure. Every bullet counts. Every decision matters. Uncover the truth behind the war&hellip; and save the leader of the free world&mdash;before its too late.",
    "instructions": "Mouse click or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "Horror",
      "Maze",
      "Puzzle",
      "Shooting",
      "War",
      "weapons",
      "Zombie"
    ],
    "thumbnail": "https://img.gamemonetize.com/fflrrt8bl8iqdlrz9drpklg3o8phfasd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/fflrrt8bl8iqdlrz9drpklg3o8phfasd/",
    "sourceUrl": "https://html5.gamemonetize.com/fflrrt8bl8iqdlrz9drpklg3o8phfasd/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "65846",
    "slug": "italian-brainrot-3d-puzzle",
    "title": "Italian Brainrot 3D Puzzle",
    "description": "Italian Brainrot 3D Puzzle is a modern take on the classic jigsaw puzzle, featuring stunning and realistic 3D graphics that bring each piece to life.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "3D",
      "3D Games",
      "Animal",
      "Brain",
      "Crazy",
      "Puzzle",
      "Sahur",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/h4j30ed88mnbzb5diu2k53vj96vbfcd5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h4j30ed88mnbzb5diu2k53vj96vbfcd5/",
    "sourceUrl": "https://html5.gamemonetize.com/h4j30ed88mnbzb5diu2k53vj96vbfcd5/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66860",
    "slug": "merge-fellas-italian-brainrot",
    "title": "Merge Fellas Italian Brainrot",
    "description": "Enjoy the Italian Brainrot meme world in this Merge game. Immerse yourself in the Italian Brainrot world and merge identical characters to accumulate points and reach the highest score. A simple and easy mechanic, drop characters together to form higher-value ones, providing rewards with each successful merge. Solve the puzzle and merge all the pets! Easy to understand; Nice and addictive gameplay; Highscore meme game; Awesome HD Graphics;",
    "instructions": "Use the mouse or touch to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "amazing",
      "Arcade",
      "Casual",
      "Fun",
      "Funny",
      "Hypercasual",
      "Italian Brainrot",
      "Matching"
    ],
    "thumbnail": "https://img.gamemonetize.com/yrdoj2kllllbttzfo8d4542fnmgufugy/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/yrdoj2kllllbttzfo8d4542fnmgufugy/",
    "sourceUrl": "https://html5.gamemonetize.com/yrdoj2kllllbttzfo8d4542fnmgufugy/",
    "width": 480,
    "height": 800,
    "lastUpdated": ""
  },
  {
    "id": "66069",
    "slug": "sprunki-policeman-for-kids",
    "title": "Sprunki Policeman For Kids",
    "description": "Welcome to Sprunki Policeman, a collection of casual games for kids with Sprunki as the theme. You will control your police officer Sprunki to complete different tasks in each level. For example, in the airport scene, your Sprunki will act as a security guard to check passengers luggage and avoid dangerous items.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Kids",
      "Police",
      "Shoot",
      "Sprunki"
    ],
    "thumbnail": "https://img.gamemonetize.com/21rjkb6uu8e7mczvgtmeinc8ilep87ns/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/21rjkb6uu8e7mczvgtmeinc8ilep87ns/",
    "sourceUrl": "https://html5.gamemonetize.com/21rjkb6uu8e7mczvgtmeinc8ilep87ns/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "65977",
    "slug": "princess-rescue-fruit-connect",
    "title": "Princess Rescue Fruit Connect",
    "description": "Begin a fruity puzzle adventure. Princess Rescue Fruit Connect is a delightful match puzzle game where your mission is to rescue a beautiful princess by matching fruits and solving tricky levels. Connect two identical fruits to eliminate them. But notice clearing the board before time runs out. All while progressing to rescue the princess.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Fruits",
      "Matching",
      "Princess"
    ],
    "thumbnail": "https://img.gamemonetize.com/51bp8za9k6izurmve1j1cs4hihp47yw9/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/51bp8za9k6izurmve1j1cs4hihp47yw9/",
    "sourceUrl": "https://html5.gamemonetize.com/51bp8za9k6izurmve1j1cs4hihp47yw9/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  },
  {
    "id": "65114",
    "slug": "perfect-job-run",
    "title": "Perfect Job Run",
    "description": "Run your way to the perfect job. In the Perfect Job Run, youll run the platform of the workplace. Facing various challenges, selecting the right career path and becoming a winner in the workplace. There will be different career tests along the way. Quickly select tools to accomplish tasks.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "Funny",
      "running"
    ],
    "thumbnail": "https://img.gamemonetize.com/69c142687xjxm82akl1bv7xsj8avx8vp/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/69c142687xjxm82akl1bv7xsj8avx8vp/",
    "sourceUrl": "https://html5.gamemonetize.com/69c142687xjxm82akl1bv7xsj8avx8vp/",
    "width": 1334,
    "height": 750,
    "lastUpdated": ""
  },
  {
    "id": "65267",
    "slug": "underwater-aim",
    "title": "Underwater Aim",
    "description": "Underwater Aim dives deep into the classic 8-ball pool experience&mdash;now with a refreshing underwater twist! Challenge your skills in beautifully designed ocean-themed tables where every shot feels smooth and satisfying. Line up your cue, calculate the angles, and sink all your balls before your opponent in this immersive pool game. From shimmering jellyfish lights to coral-lined pockets, each level is bursting with aquatic charm. Play solo, challenge friends, or compete in underwater tournaments. Unlock cues, explore sea-themed arenas, and become the ultimate pool shark of the deep. Cue up and make a splash in Underwater Aim!",
    "instructions": "Use mouse or touch scren for play game",
    "category": "Sports",
    "genres": [
      "Sports"
    ],
    "tags": [
      "1 Player",
      "2 Player",
      "8 Ball Pool",
      "Pool"
    ],
    "thumbnail": "https://img.gamemonetize.com/hksjgjkch7vvkjnpwboj6noif3qm8osd/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hksjgjkch7vvkjnpwboj6noif3qm8osd/",
    "sourceUrl": "https://html5.gamemonetize.com/hksjgjkch7vvkjnpwboj6noif3qm8osd/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "53107",
    "slug": "titan-wall-breaker",
    "title": "Titan Wall Breaker",
    "description": "In Titan Wall Breaker, wield colossal power to demolish towering fortresses guarding ancient relics. As a mighty titan, harness strategic prowess to navigate labyrinthine defenses, deploying devastating abilities to breach impregnable walls. With each level presenting new challenges and cunning adversaries, test your mettle in a battle of wits and strength. Web Dev <a href='https://www.crazygamesunblockedx.com/'>https://www.crazygamesunblockedx.com/</a>",
    "instructions": "Mouse click or tap to play",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Android",
      "Arcade",
      "HTML5",
      "iPad",
      "iPhone",
      "Mobile",
      "Unity3D",
      "WebGL"
    ],
    "thumbnail": "https://img.gamemonetize.com/8uhe7sn1ed8udv7fcir9434l7uoe3pey/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/8uhe7sn1ed8udv7fcir9434l7uoe3pey/",
    "sourceUrl": "https://html5.gamemonetize.com/8uhe7sn1ed8udv7fcir9434l7uoe3pey/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "64914",
    "slug": "solitaire-girls-2",
    "title": "Solitaire Girls 2",
    "description": "Solitaire Girls 2 is a unique card solitaire game that perfectly combines classic card gameplay with anime girl collection elements. Players can enjoy traditional solitaire fun while collecting beautiful anime character cards.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "1 Player",
      "Card"
    ],
    "thumbnail": "https://img.gamemonetize.com/czjonvx8c1kpniq5zdq2d16gvythd3vb/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/czjonvx8c1kpniq5zdq2d16gvythd3vb/",
    "sourceUrl": "https://html5.gamemonetize.com/czjonvx8c1kpniq5zdq2d16gvythd3vb/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66643",
    "slug": "starship",
    "title": "StarShip",
    "description": "Control the ship safely through space.The ship will have various obstacles in the course of space flight, and the flexible control of the ship to avoid obstacles. At the same time, you can touch gold coins to get gold rewards, and gold coins can buy other cool ships, come and try it.",
    "instructions": "Mouse click or tap to play",
    "category": "Racing",
    "genres": [
      "Racing"
    ],
    "tags": [
      "1 Player",
      "3D",
      "Adventure",
      "airplane",
      "Best Games",
      "Racing"
    ],
    "thumbnail": "https://img.gamemonetize.com/be7c6zql57gu5xoz5gfom1cmnwnf12vc/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/be7c6zql57gu5xoz5gfom1cmnwnf12vc/",
    "sourceUrl": "https://html5.gamemonetize.com/be7c6zql57gu5xoz5gfom1cmnwnf12vc/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66834",
    "slug": "hugli-wugli-vs-tung-tung-sahur",
    "title": "Hugli Wugli vs Tung Tung Sahur",
    "description": "The Hugli Wugli brothers are in danger! They&rsquo;re trapped in the dungeon and want to escape, but Tung Tung Sahur is trying to catch them. Avoid Tung Tung Sahur and escape the dungeon. To get out, you must find the red and blue keys. Collect the keys and help the Hugli Wugli brothers reach the dungeon door safely!",
    "instructions": "Use the WASD and Arrow keys to move Collect all the coins find the red and blue keys and head to the door Playable on both mobile and PC",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "2 Player",
      "2 Player Games",
      "2D",
      "Adventure",
      "huggy",
      "Tung Tung",
      "Tung Tung Tung",
      "Tung Tung Tung Sahur"
    ],
    "thumbnail": "https://img.gamemonetize.com/p5bhtgvycsyp72kvjav36mdr3enkd8oj/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p5bhtgvycsyp72kvjav36mdr3enkd8oj/",
    "sourceUrl": "https://html5.gamemonetize.com/p5bhtgvycsyp72kvjav36mdr3enkd8oj/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66870",
    "slug": "helptheduck",
    "title": "HelpTheDuck",
    "description": "Help the ducklings take a bath. The little duck randomly appears on the platform above. Clicking the screen will bring up water. Control the water to flush the little duck into the bath pool at the bottom. Come and have a try.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "Adventure",
      "Animal",
      "Best Games",
      "Casual"
    ],
    "thumbnail": "https://img.gamemonetize.com/opo9hcrhwai5hryfapgeyllrd044nkki/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/opo9hcrhwai5hryfapgeyllrd044nkki/",
    "sourceUrl": "https://html5.gamemonetize.com/opo9hcrhwai5hryfapgeyllrd044nkki/",
    "width": 350,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66548",
    "slug": "invaders-destruction",
    "title": "Invaders Destruction",
    "description": "Invaders Destruction &ndash; Classic Arcade Space Shooter &ndash; Defend Earth in Retro Style! Captain, the Earth needs you! Alien invaders have surrounded our planet, threatening to destroy everything we hold dear. The skies are full of enemy ships, their weapons aimed at our cities, our homes, and our loved ones. This is not just another war&mdash;this is the final stand for humanity! In Invaders Destruction, its your mission to stop the alien invasion and save the world. Will you rise to the challenge?",
    "instructions": "Keyboard Z X C and S if mega rocket is unlocked or tap to play",
    "category": "Shooting",
    "genres": [
      "Shooting"
    ],
    "tags": [
      "1 Player",
      "2D",
      "Action",
      "Aircraft",
      "airplane",
      "Arcade",
      "attack",
      "Retro",
      "Shoot",
      "Shoot 'Em Up",
      "Shooter",
      "Shooting",
      "Space",
      "Spaceship"
    ],
    "thumbnail": "https://img.gamemonetize.com/hj96k2buy81zylbjzuyoas898s5xibe4/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/hj96k2buy81zylbjzuyoas898s5xibe4/",
    "sourceUrl": "https://html5.gamemonetize.com/hj96k2buy81zylbjzuyoas898s5xibe4/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "66808",
    "slug": "mahjong-tralalero-tralala",
    "title": "Mahjong tralalero tralala",
    "description": "Mahjong Tralalero Tralala &ndash; Match, Relax &amp; Enjoy the Fun! Dive into a joyful Mahjong experience like no other! Match colorful tiles featuring , animals, and silly surprises &ndash; all while grooving to the catchy Tralalero Tralala soundtrack. With playful visuals, simple gameplay, and cheerful vibes, this game is perfect for kids and casual players alike. Can you clear all the tiles before the music ends?",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Action",
      "Brain",
      "Hypercasual",
      "jump",
      "Mahjong",
      "Mario",
      "Obstacle",
      "Platform",
      "run",
      "Sprunki",
      "Strategy",
      "trap"
    ],
    "thumbnail": "https://img.gamemonetize.com/p0gm9pnydevus85s12wjcthhq5gmm3x2/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/p0gm9pnydevus85s12wjcthhq5gmm3x2/",
    "sourceUrl": "https://html5.gamemonetize.com/p0gm9pnydevus85s12wjcthhq5gmm3x2/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66798",
    "slug": "hide-and-luig",
    "title": "Hide and Luig",
    "description": "A whimsical point-and-click hide-and-seek adventure where your only goal is to find the ever-elusive Luig&mdash;who insists on hiding inside the weirdest objects imaginable. Explore playful scenes, click around, and uncover Luig&rsquo;s latest hideout in this charmingly absurd journey of curiosity and surprise.",
    "instructions": "Mouse click or tap to play",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "Escape",
      "Hidden",
      "Point And Click",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/h31mj5h9t2r0imhvrmwf3xelw5nw2vjf/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/h31mj5h9t2r0imhvrmwf3xelw5nw2vjf/",
    "sourceUrl": "https://html5.gamemonetize.com/h31mj5h9t2r0imhvrmwf3xelw5nw2vjf/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66413",
    "slug": "girls-fashion-nail-salon",
    "title": "Girls Fashion Nail Salon",
    "description": "Welcome to Girls Fashion Nail Salon, a casual dress-up game for girls. If you are a girl who loves makeup or has a specific interest in fashion, then this nail salon simulator is just designed for you. Get ready to dive into the world of fashion and create your own masterpiece.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Dress Up",
      "Makeover",
      "Nails",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/0bjxllp6iiy7ygc1qgwwt5lnsnr741ia/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/0bjxllp6iiy7ygc1qgwwt5lnsnr741ia/",
    "sourceUrl": "https://html5.gamemonetize.com/0bjxllp6iiy7ygc1qgwwt5lnsnr741ia/",
    "width": 720,
    "height": 1280,
    "lastUpdated": ""
  },
  {
    "id": "65969",
    "slug": "i-am-security",
    "title": "I Am Security",
    "description": "Have you ever wanted to be a hardened security officer and be on the front lines of maintaining order? In I Am Security, an ultra-realistic role-playing simulator, you play the role of a professional security guard. You decide whether or not to allow them to enter. Some guests may try to sneak in with prohibited items and find these hidden items. Performs tasks in a variety of scenarios to identify suspicious persons.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "airplane",
      "Cute",
      "Simulator"
    ],
    "thumbnail": "https://img.gamemonetize.com/4fhv9bnnvkkv8xi4k1a5hl5res510tw5/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/4fhv9bnnvkkv8xi4k1a5hl5res510tw5/",
    "sourceUrl": "https://html5.gamemonetize.com/4fhv9bnnvkkv8xi4k1a5hl5res510tw5/",
    "width": 1280,
    "height": 720,
    "lastUpdated": ""
  },
  {
    "id": "64553",
    "slug": "sweet-monster-pull-out-pin",
    "title": "Sweet Monster   Pull Out Pin",
    "description": "Sweet Monster - Pull Out Pin is a fun, challenging, and brain-training puzzle game where your mission is to help a lovable monster escape tricky traps and collect delicious treats! Use your logic to pull the right pins in the right order and guide the sweet monster to safety. Each level is packed with clever traps, dangerous enemies, lava pools, and hidden surprises. You must think before you pull, or the monster might fall into danger! Pull the pins, avoid obstacles, defeat enemies, and make your way to candy heaven. With vibrant graphics, smooth controls, and engaging gameplay, Sweet Monster - Pull Out Pin offers a fun experience for play",
    "instructions": "Use mouse to play game",
    "category": "Puzzle",
    "genres": [
      "Puzzle"
    ],
    "tags": [
      "1 Player",
      "free games for your site",
      "free html5 games for your website",
      "html5 games",
      "Puzzle"
    ],
    "thumbnail": "https://img.gamemonetize.com/rlszt26i0v6qdc022pwndlxyjvzrjij3/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/rlszt26i0v6qdc022pwndlxyjvzrjij3/",
    "sourceUrl": "https://html5.gamemonetize.com/rlszt26i0v6qdc022pwndlxyjvzrjij3/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "65293",
    "slug": "dark-sprint",
    "title": "Dark Sprint",
    "description": "Dark Sprint is a fast-paced, adrenaline-pumping runner set in a shadowy, mysterious world. Dash through eerie landscapes filled with traps, crumbling paths, and lurking dangers as you guide your character through the darkness. With precise timing and quick reflexes, avoid deadly obstacles and unlock new areas cloaked in secrets. Collect glowing orbs, power-ups, and hidden relics to boost your speed and score. The deeper you run, the darker and more thrilling it becomes. With stylish visuals, intense gameplay, and haunting soundscapes, Dark Sprint offers an unforgettable running experience. Can you outrun the darkness and survive the night?",
    "instructions": "use mouse or touch screen on mobile to play game",
    "category": "Arcade",
    "genres": [
      "Arcade"
    ],
    "tags": [
      "Adventure",
      "Arcade",
      "Best",
      "Best Games"
    ],
    "thumbnail": "https://img.gamemonetize.com/5gv5nhrtgk7s57iddr7kxnxneuxugiya/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/5gv5nhrtgk7s57iddr7kxnxneuxugiya/",
    "sourceUrl": "https://html5.gamemonetize.com/5gv5nhrtgk7s57iddr7kxnxneuxugiya/",
    "width": 800,
    "height": 600,
    "lastUpdated": ""
  },
  {
    "id": "66001",
    "slug": "magic-piano-music",
    "title": "Magic Piano Music",
    "description": "Ready to become a piano master? In Magic Piano Music, tap the magic tiles to follow the beats and play your favorite music. Follow the rhythm of the music and click with precision, dont miss any notes. The game will end after three misses. Theres tons of music here like classic piano music, pop music and more! Every song will take you on an immersive arcade rhythm adventure.",
    "instructions": "Mouse click or tap to play",
    "category": "Hypercasual",
    "genres": [
      "Hypercasual"
    ],
    "tags": [
      "Classic",
      "Magic",
      "Music"
    ],
    "thumbnail": "https://img.gamemonetize.com/wp9o3vgbgwsitkvnnit9emgdmxecn3jw/512x384.jpg",
    "publisher": "GameMonetize",
    "sourceName": "GM-Games",
    "sourceKey": "gm",
    "embedUrl": "https://html5.gamemonetize.com/wp9o3vgbgwsitkvnnit9emgdmxecn3jw/",
    "sourceUrl": "https://html5.gamemonetize.com/wp9o3vgbgwsitkvnnit9emgdmxecn3jw/",
    "width": 1080,
    "height": 1920,
    "lastUpdated": ""
  }
];

export default games;
